
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire8104"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire8104"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("6ZWSX", function(module, exports) {

$parcel$export(module.exports, "Buffer", () => $51861dfc7ca9d588$export$a143d493d941bafc, (v) => $51861dfc7ca9d588$export$a143d493d941bafc = v);
$parcel$export(module.exports, "SlowBuffer", () => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a, (v) => $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = v);
$parcel$export(module.exports, "INSPECT_MAX_BYTES", () => $51861dfc7ca9d588$export$f99ded8fe4b79145, (v) => $51861dfc7ca9d588$export$f99ded8fe4b79145 = v);
$parcel$export(module.exports, "kMaxLength", () => $51861dfc7ca9d588$export$599f31c3813fae4d, (v) => $51861dfc7ca9d588$export$599f31c3813fae4d = v);
/*!
 * The buffer module from node.js, for the browser.
 *
 * @author   Feross Aboukhadijeh <https://feross.org>
 * @license  MIT
 */ /* eslint-disable no-proto */ var $51861dfc7ca9d588$export$a143d493d941bafc;
var $51861dfc7ca9d588$export$e4cf37d7f6fb9e0a;
var $51861dfc7ca9d588$export$f99ded8fe4b79145;
var $51861dfc7ca9d588$export$599f31c3813fae4d;
"use strict";

var $kuxul = parcelRequire("kuxul");

var $9NvM5 = parcelRequire("9NvM5");
const $51861dfc7ca9d588$var$customInspectSymbol = typeof Symbol === "function" && typeof Symbol["for"] === "function" // eslint-disable-line dot-notation
 ? Symbol["for"]("nodejs.util.inspect.custom") // eslint-disable-line dot-notation
 : null;
$51861dfc7ca9d588$export$a143d493d941bafc = $51861dfc7ca9d588$var$Buffer;
$51861dfc7ca9d588$export$e4cf37d7f6fb9e0a = $51861dfc7ca9d588$var$SlowBuffer;
$51861dfc7ca9d588$export$f99ded8fe4b79145 = 50;
const $51861dfc7ca9d588$var$K_MAX_LENGTH = 0x7fffffff;
$51861dfc7ca9d588$export$599f31c3813fae4d = $51861dfc7ca9d588$var$K_MAX_LENGTH;
/**
 * If `Buffer.TYPED_ARRAY_SUPPORT`:
 *   === true    Use Uint8Array implementation (fastest)
 *   === false   Print warning and recommend using `buffer` v4.x which has an Object
 *               implementation (most compatible, even IE6)
 *
 * Browsers that support typed arrays are IE 10+, Firefox 4+, Chrome 7+, Safari 5.1+,
 * Opera 11.6+, iOS 4.2+.
 *
 * We report that the browser does not support typed arrays if the are not subclassable
 * using __proto__. Firefox 4-29 lacks support for adding new properties to `Uint8Array`
 * (See: https://bugzilla.mozilla.org/show_bug.cgi?id=695438). IE 10 lacks support
 * for __proto__ and has a buggy typed array implementation.
 */ $51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT = $51861dfc7ca9d588$var$typedArraySupport();
if (!$51861dfc7ca9d588$var$Buffer.TYPED_ARRAY_SUPPORT && typeof console !== "undefined" && typeof console.error === "function") console.error("This browser lacks typed array (Uint8Array) support which is required by `buffer` v5.x. Use `buffer` v4.x if you require old browser support.");
function $51861dfc7ca9d588$var$typedArraySupport() {
    // Can typed array instances can be augmented?
    try {
        const arr = new Uint8Array(1);
        const proto = {
            foo: function() {
                return 42;
            }
        };
        Object.setPrototypeOf(proto, Uint8Array.prototype);
        Object.setPrototypeOf(arr, proto);
        return arr.foo() === 42;
    } catch (e) {
        return false;
    }
}
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "parent", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.buffer;
    }
});
Object.defineProperty($51861dfc7ca9d588$var$Buffer.prototype, "offset", {
    enumerable: true,
    get: function() {
        if (!$51861dfc7ca9d588$var$Buffer.isBuffer(this)) return undefined;
        return this.byteOffset;
    }
});
function $51861dfc7ca9d588$var$createBuffer(length) {
    if (length > $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError('The value "' + length + '" is invalid for option "size"');
    // Return an augmented `Uint8Array` instance
    const buf = new Uint8Array(length);
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
/**
 * The Buffer constructor returns instances of `Uint8Array` that have their
 * prototype changed to `Buffer.prototype`. Furthermore, `Buffer` is a subclass of
 * `Uint8Array`, so the returned instances will have all the node `Buffer` methods
 * and the `Uint8Array` methods. Square bracket notation works as expected -- it
 * returns a single octet.
 *
 * The `Uint8Array` prototype remains unmodified.
 */ function $51861dfc7ca9d588$var$Buffer(arg, encodingOrOffset, length) {
    // Common case.
    if (typeof arg === "number") {
        if (typeof encodingOrOffset === "string") throw new TypeError('The "string" argument must be of type string. Received type number');
        return $51861dfc7ca9d588$var$allocUnsafe(arg);
    }
    return $51861dfc7ca9d588$var$from(arg, encodingOrOffset, length);
}
$51861dfc7ca9d588$var$Buffer.poolSize = 8192 // not used by this implementation
;
function $51861dfc7ca9d588$var$from(value, encodingOrOffset, length) {
    if (typeof value === "string") return $51861dfc7ca9d588$var$fromString(value, encodingOrOffset);
    if (ArrayBuffer.isView(value)) return $51861dfc7ca9d588$var$fromArrayView(value);
    if (value == null) throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
    if ($51861dfc7ca9d588$var$isInstance(value, ArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, ArrayBuffer)) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof SharedArrayBuffer !== "undefined" && ($51861dfc7ca9d588$var$isInstance(value, SharedArrayBuffer) || value && $51861dfc7ca9d588$var$isInstance(value.buffer, SharedArrayBuffer))) return $51861dfc7ca9d588$var$fromArrayBuffer(value, encodingOrOffset, length);
    if (typeof value === "number") throw new TypeError('The "value" argument must not be of type number. Received type number');
    const valueOf = value.valueOf && value.valueOf();
    if (valueOf != null && valueOf !== value) return $51861dfc7ca9d588$var$Buffer.from(valueOf, encodingOrOffset, length);
    const b = $51861dfc7ca9d588$var$fromObject(value);
    if (b) return b;
    if (typeof Symbol !== "undefined" && Symbol.toPrimitive != null && typeof value[Symbol.toPrimitive] === "function") return $51861dfc7ca9d588$var$Buffer.from(value[Symbol.toPrimitive]("string"), encodingOrOffset, length);
    throw new TypeError("The first argument must be one of type string, Buffer, ArrayBuffer, Array, or Array-like Object. Received type " + typeof value);
}
/**
 * Functionally equivalent to Buffer(arg, encoding) but throws a TypeError
 * if value is a number.
 * Buffer.from(str[, encoding])
 * Buffer.from(array)
 * Buffer.from(buffer)
 * Buffer.from(arrayBuffer[, byteOffset[, length]])
 **/ $51861dfc7ca9d588$var$Buffer.from = function(value, encodingOrOffset, length) {
    return $51861dfc7ca9d588$var$from(value, encodingOrOffset, length);
};
// Note: Change prototype *after* Buffer.from is defined to workaround Chrome bug:
// https://github.com/feross/buffer/pull/148
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer.prototype, Uint8Array.prototype);
Object.setPrototypeOf($51861dfc7ca9d588$var$Buffer, Uint8Array);
function $51861dfc7ca9d588$var$assertSize(size) {
    if (typeof size !== "number") throw new TypeError('"size" argument must be of type number');
    else if (size < 0) throw new RangeError('The value "' + size + '" is invalid for option "size"');
}
function $51861dfc7ca9d588$var$alloc(size, fill, encoding) {
    $51861dfc7ca9d588$var$assertSize(size);
    if (size <= 0) return $51861dfc7ca9d588$var$createBuffer(size);
    if (fill !== undefined) // Only pay attention to encoding if it's a string. This
    // prevents accidentally sending in a number that would
    // be interpreted as a start offset.
    return typeof encoding === "string" ? $51861dfc7ca9d588$var$createBuffer(size).fill(fill, encoding) : $51861dfc7ca9d588$var$createBuffer(size).fill(fill);
    return $51861dfc7ca9d588$var$createBuffer(size);
}
/**
 * Creates a new filled Buffer instance.
 * alloc(size[, fill[, encoding]])
 **/ $51861dfc7ca9d588$var$Buffer.alloc = function(size, fill, encoding) {
    return $51861dfc7ca9d588$var$alloc(size, fill, encoding);
};
function $51861dfc7ca9d588$var$allocUnsafe(size) {
    $51861dfc7ca9d588$var$assertSize(size);
    return $51861dfc7ca9d588$var$createBuffer(size < 0 ? 0 : $51861dfc7ca9d588$var$checked(size) | 0);
}
/**
 * Equivalent to Buffer(num), by default creates a non-zero-filled Buffer instance.
 * */ $51861dfc7ca9d588$var$Buffer.allocUnsafe = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
/**
 * Equivalent to SlowBuffer(num), by default creates a non-zero-filled Buffer instance.
 */ $51861dfc7ca9d588$var$Buffer.allocUnsafeSlow = function(size) {
    return $51861dfc7ca9d588$var$allocUnsafe(size);
};
function $51861dfc7ca9d588$var$fromString(string, encoding) {
    if (typeof encoding !== "string" || encoding === "") encoding = "utf8";
    if (!$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
    const length = $51861dfc7ca9d588$var$byteLength(string, encoding) | 0;
    let buf = $51861dfc7ca9d588$var$createBuffer(length);
    const actual = buf.write(string, encoding);
    if (actual !== length) // Writing a hex string, for example, that contains invalid characters will
    // cause everything after the first invalid character to be ignored. (e.g.
    // 'abxxcd' will be treated as 'ab')
    buf = buf.slice(0, actual);
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayLike(array) {
    const length = array.length < 0 ? 0 : $51861dfc7ca9d588$var$checked(array.length) | 0;
    const buf = $51861dfc7ca9d588$var$createBuffer(length);
    for(let i = 0; i < length; i += 1)buf[i] = array[i] & 255;
    return buf;
}
function $51861dfc7ca9d588$var$fromArrayView(arrayView) {
    if ($51861dfc7ca9d588$var$isInstance(arrayView, Uint8Array)) {
        const copy = new Uint8Array(arrayView);
        return $51861dfc7ca9d588$var$fromArrayBuffer(copy.buffer, copy.byteOffset, copy.byteLength);
    }
    return $51861dfc7ca9d588$var$fromArrayLike(arrayView);
}
function $51861dfc7ca9d588$var$fromArrayBuffer(array, byteOffset, length) {
    if (byteOffset < 0 || array.byteLength < byteOffset) throw new RangeError('"offset" is outside of buffer bounds');
    if (array.byteLength < byteOffset + (length || 0)) throw new RangeError('"length" is outside of buffer bounds');
    let buf;
    if (byteOffset === undefined && length === undefined) buf = new Uint8Array(array);
    else if (length === undefined) buf = new Uint8Array(array, byteOffset);
    else buf = new Uint8Array(array, byteOffset, length);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(buf, $51861dfc7ca9d588$var$Buffer.prototype);
    return buf;
}
function $51861dfc7ca9d588$var$fromObject(obj) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(obj)) {
        const len = $51861dfc7ca9d588$var$checked(obj.length) | 0;
        const buf = $51861dfc7ca9d588$var$createBuffer(len);
        if (buf.length === 0) return buf;
        obj.copy(buf, 0, 0, len);
        return buf;
    }
    if (obj.length !== undefined) {
        if (typeof obj.length !== "number" || $51861dfc7ca9d588$var$numberIsNaN(obj.length)) return $51861dfc7ca9d588$var$createBuffer(0);
        return $51861dfc7ca9d588$var$fromArrayLike(obj);
    }
    if (obj.type === "Buffer" && Array.isArray(obj.data)) return $51861dfc7ca9d588$var$fromArrayLike(obj.data);
}
function $51861dfc7ca9d588$var$checked(length) {
    // Note: cannot use `length < K_MAX_LENGTH` here because that fails when
    // length is NaN (which is otherwise coerced to zero.)
    if (length >= $51861dfc7ca9d588$var$K_MAX_LENGTH) throw new RangeError("Attempt to allocate Buffer larger than maximum size: 0x" + $51861dfc7ca9d588$var$K_MAX_LENGTH.toString(16) + " bytes");
    return length | 0;
}
function $51861dfc7ca9d588$var$SlowBuffer(length) {
    if (+length != length) length = 0;
    return $51861dfc7ca9d588$var$Buffer.alloc(+length);
}
$51861dfc7ca9d588$var$Buffer.isBuffer = function isBuffer(b) {
    return b != null && b._isBuffer === true && b !== $51861dfc7ca9d588$var$Buffer.prototype // so Buffer.isBuffer(Buffer.prototype) will be false
    ;
};
$51861dfc7ca9d588$var$Buffer.compare = function compare(a, b) {
    if ($51861dfc7ca9d588$var$isInstance(a, Uint8Array)) a = $51861dfc7ca9d588$var$Buffer.from(a, a.offset, a.byteLength);
    if ($51861dfc7ca9d588$var$isInstance(b, Uint8Array)) b = $51861dfc7ca9d588$var$Buffer.from(b, b.offset, b.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(a) || !$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError('The "buf1", "buf2" arguments must be one of type Buffer or Uint8Array');
    if (a === b) return 0;
    let x = a.length;
    let y = b.length;
    for(let i = 0, len = Math.min(x, y); i < len; ++i)if (a[i] !== b[i]) {
        x = a[i];
        y = b[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
$51861dfc7ca9d588$var$Buffer.isEncoding = function isEncoding(encoding) {
    switch(String(encoding).toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "latin1":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return true;
        default:
            return false;
    }
};
$51861dfc7ca9d588$var$Buffer.concat = function concat(list, length) {
    if (!Array.isArray(list)) throw new TypeError('"list" argument must be an Array of Buffers');
    if (list.length === 0) return $51861dfc7ca9d588$var$Buffer.alloc(0);
    let i;
    if (length === undefined) {
        length = 0;
        for(i = 0; i < list.length; ++i)length += list[i].length;
    }
    const buffer = $51861dfc7ca9d588$var$Buffer.allocUnsafe(length);
    let pos = 0;
    for(i = 0; i < list.length; ++i){
        let buf = list[i];
        if ($51861dfc7ca9d588$var$isInstance(buf, Uint8Array)) {
            if (pos + buf.length > buffer.length) {
                if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) buf = $51861dfc7ca9d588$var$Buffer.from(buf);
                buf.copy(buffer, pos);
            } else Uint8Array.prototype.set.call(buffer, buf, pos);
        } else if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"list" argument must be an Array of Buffers');
        else buf.copy(buffer, pos);
        pos += buf.length;
    }
    return buffer;
};
function $51861dfc7ca9d588$var$byteLength(string, encoding) {
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(string)) return string.length;
    if (ArrayBuffer.isView(string) || $51861dfc7ca9d588$var$isInstance(string, ArrayBuffer)) return string.byteLength;
    if (typeof string !== "string") throw new TypeError('The "string" argument must be one of type string, Buffer, or ArrayBuffer. Received type ' + typeof string);
    const len = string.length;
    const mustMatch = arguments.length > 2 && arguments[2] === true;
    if (!mustMatch && len === 0) return 0;
    // Use a for loop to avoid recursion
    let loweredCase = false;
    for(;;)switch(encoding){
        case "ascii":
        case "latin1":
        case "binary":
            return len;
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8ToBytes(string).length;
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return len * 2;
        case "hex":
            return len >>> 1;
        case "base64":
            return $51861dfc7ca9d588$var$base64ToBytes(string).length;
        default:
            if (loweredCase) return mustMatch ? -1 : $51861dfc7ca9d588$var$utf8ToBytes(string).length // assume utf8
            ;
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
}
$51861dfc7ca9d588$var$Buffer.byteLength = $51861dfc7ca9d588$var$byteLength;
function $51861dfc7ca9d588$var$slowToString(encoding, start, end) {
    let loweredCase = false;
    // No need to verify that "this.length <= MAX_UINT32" since it's a read-only
    // property of a typed array.
    // This behaves neither like String nor Uint8Array in that we set start/end
    // to their upper/lower bounds if the value passed is out of range.
    // undefined is handled specially as per ECMA-262 6th Edition,
    // Section 13.3.3.7 Runtime Semantics: KeyedBindingInitialization.
    if (start === undefined || start < 0) start = 0;
    // Return early if start > this.length. Done here to prevent potential uint32
    // coercion fail below.
    if (start > this.length) return "";
    if (end === undefined || end > this.length) end = this.length;
    if (end <= 0) return "";
    // Force coercion to uint32. This will also coerce falsey/NaN values to 0.
    end >>>= 0;
    start >>>= 0;
    if (end <= start) return "";
    if (!encoding) encoding = "utf8";
    while(true)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexSlice(this, start, end);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Slice(this, start, end);
        case "ascii":
            return $51861dfc7ca9d588$var$asciiSlice(this, start, end);
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$latin1Slice(this, start, end);
        case "base64":
            return $51861dfc7ca9d588$var$base64Slice(this, start, end);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$utf16leSlice(this, start, end);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = (encoding + "").toLowerCase();
            loweredCase = true;
    }
}
// This property is used by `Buffer.isBuffer` (and the `is-buffer` npm package)
// to detect a Buffer instance. It's not possible to use `instanceof Buffer`
// reliably in a browserify context because there could be multiple different
// copies of the 'buffer' package in use. This method works even for Buffer
// instances that were created from another copy of the `buffer` package.
// See: https://github.com/feross/buffer/issues/154
$51861dfc7ca9d588$var$Buffer.prototype._isBuffer = true;
function $51861dfc7ca9d588$var$swap(b, n, m) {
    const i = b[n];
    b[n] = b[m];
    b[m] = i;
}
$51861dfc7ca9d588$var$Buffer.prototype.swap16 = function swap16() {
    const len = this.length;
    if (len % 2 !== 0) throw new RangeError("Buffer size must be a multiple of 16-bits");
    for(let i = 0; i < len; i += 2)$51861dfc7ca9d588$var$swap(this, i, i + 1);
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap32 = function swap32() {
    const len = this.length;
    if (len % 4 !== 0) throw new RangeError("Buffer size must be a multiple of 32-bits");
    for(let i = 0; i < len; i += 4){
        $51861dfc7ca9d588$var$swap(this, i, i + 3);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 2);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.swap64 = function swap64() {
    const len = this.length;
    if (len % 8 !== 0) throw new RangeError("Buffer size must be a multiple of 64-bits");
    for(let i = 0; i < len; i += 8){
        $51861dfc7ca9d588$var$swap(this, i, i + 7);
        $51861dfc7ca9d588$var$swap(this, i + 1, i + 6);
        $51861dfc7ca9d588$var$swap(this, i + 2, i + 5);
        $51861dfc7ca9d588$var$swap(this, i + 3, i + 4);
    }
    return this;
};
$51861dfc7ca9d588$var$Buffer.prototype.toString = function toString() {
    const length = this.length;
    if (length === 0) return "";
    if (arguments.length === 0) return $51861dfc7ca9d588$var$utf8Slice(this, 0, length);
    return $51861dfc7ca9d588$var$slowToString.apply(this, arguments);
};
$51861dfc7ca9d588$var$Buffer.prototype.toLocaleString = $51861dfc7ca9d588$var$Buffer.prototype.toString;
$51861dfc7ca9d588$var$Buffer.prototype.equals = function equals(b) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(b)) throw new TypeError("Argument must be a Buffer");
    if (this === b) return true;
    return $51861dfc7ca9d588$var$Buffer.compare(this, b) === 0;
};
$51861dfc7ca9d588$var$Buffer.prototype.inspect = function inspect() {
    let str = "";
    const max = $51861dfc7ca9d588$export$f99ded8fe4b79145;
    str = this.toString("hex", 0, max).replace(/(.{2})/g, "$1 ").trim();
    if (this.length > max) str += " ... ";
    return "<Buffer " + str + ">";
};
if ($51861dfc7ca9d588$var$customInspectSymbol) $51861dfc7ca9d588$var$Buffer.prototype[$51861dfc7ca9d588$var$customInspectSymbol] = $51861dfc7ca9d588$var$Buffer.prototype.inspect;
$51861dfc7ca9d588$var$Buffer.prototype.compare = function compare(target, start, end, thisStart, thisEnd) {
    if ($51861dfc7ca9d588$var$isInstance(target, Uint8Array)) target = $51861dfc7ca9d588$var$Buffer.from(target, target.offset, target.byteLength);
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError('The "target" argument must be one of type Buffer or Uint8Array. Received type ' + typeof target);
    if (start === undefined) start = 0;
    if (end === undefined) end = target ? target.length : 0;
    if (thisStart === undefined) thisStart = 0;
    if (thisEnd === undefined) thisEnd = this.length;
    if (start < 0 || end > target.length || thisStart < 0 || thisEnd > this.length) throw new RangeError("out of range index");
    if (thisStart >= thisEnd && start >= end) return 0;
    if (thisStart >= thisEnd) return -1;
    if (start >= end) return 1;
    start >>>= 0;
    end >>>= 0;
    thisStart >>>= 0;
    thisEnd >>>= 0;
    if (this === target) return 0;
    let x = thisEnd - thisStart;
    let y = end - start;
    const len = Math.min(x, y);
    const thisCopy = this.slice(thisStart, thisEnd);
    const targetCopy = target.slice(start, end);
    for(let i = 0; i < len; ++i)if (thisCopy[i] !== targetCopy[i]) {
        x = thisCopy[i];
        y = targetCopy[i];
        break;
    }
    if (x < y) return -1;
    if (y < x) return 1;
    return 0;
};
// Finds either the first index of `val` in `buffer` at offset >= `byteOffset`,
// OR the last index of `val` in `buffer` at offset <= `byteOffset`.
//
// Arguments:
// - buffer - a Buffer to search
// - val - a string, Buffer, or number
// - byteOffset - an index into `buffer`; will be clamped to an int32
// - encoding - an optional encoding, relevant is val is a string
// - dir - true for indexOf, false for lastIndexOf
function $51861dfc7ca9d588$var$bidirectionalIndexOf(buffer, val, byteOffset, encoding, dir) {
    // Empty buffer means no match
    if (buffer.length === 0) return -1;
    // Normalize byteOffset
    if (typeof byteOffset === "string") {
        encoding = byteOffset;
        byteOffset = 0;
    } else if (byteOffset > 0x7fffffff) byteOffset = 0x7fffffff;
    else if (byteOffset < -2147483648) byteOffset = -2147483648;
    byteOffset = +byteOffset // Coerce to Number.
    ;
    if ($51861dfc7ca9d588$var$numberIsNaN(byteOffset)) // byteOffset: it it's undefined, null, NaN, "foo", etc, search whole buffer
    byteOffset = dir ? 0 : buffer.length - 1;
    // Normalize byteOffset: negative offsets start from the end of the buffer
    if (byteOffset < 0) byteOffset = buffer.length + byteOffset;
    if (byteOffset >= buffer.length) {
        if (dir) return -1;
        else byteOffset = buffer.length - 1;
    } else if (byteOffset < 0) {
        if (dir) byteOffset = 0;
        else return -1;
    }
    // Normalize val
    if (typeof val === "string") val = $51861dfc7ca9d588$var$Buffer.from(val, encoding);
    // Finally, search either indexOf (if dir is true) or lastIndexOf
    if ($51861dfc7ca9d588$var$Buffer.isBuffer(val)) {
        // Special case: looking for empty string/buffer always fails
        if (val.length === 0) return -1;
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, val, byteOffset, encoding, dir);
    } else if (typeof val === "number") {
        val = val & 0xFF // Search for a byte value [0-255]
        ;
        if (typeof Uint8Array.prototype.indexOf === "function") {
            if (dir) return Uint8Array.prototype.indexOf.call(buffer, val, byteOffset);
            else return Uint8Array.prototype.lastIndexOf.call(buffer, val, byteOffset);
        }
        return $51861dfc7ca9d588$var$arrayIndexOf(buffer, [
            val
        ], byteOffset, encoding, dir);
    }
    throw new TypeError("val must be string, number or Buffer");
}
function $51861dfc7ca9d588$var$arrayIndexOf(arr, val, byteOffset, encoding, dir) {
    let indexSize = 1;
    let arrLength = arr.length;
    let valLength = val.length;
    if (encoding !== undefined) {
        encoding = String(encoding).toLowerCase();
        if (encoding === "ucs2" || encoding === "ucs-2" || encoding === "utf16le" || encoding === "utf-16le") {
            if (arr.length < 2 || val.length < 2) return -1;
            indexSize = 2;
            arrLength /= 2;
            valLength /= 2;
            byteOffset /= 2;
        }
    }
    function read(buf, i) {
        if (indexSize === 1) return buf[i];
        else return buf.readUInt16BE(i * indexSize);
    }
    let i;
    if (dir) {
        let foundIndex = -1;
        for(i = byteOffset; i < arrLength; i++)if (read(arr, i) === read(val, foundIndex === -1 ? 0 : i - foundIndex)) {
            if (foundIndex === -1) foundIndex = i;
            if (i - foundIndex + 1 === valLength) return foundIndex * indexSize;
        } else {
            if (foundIndex !== -1) i -= i - foundIndex;
            foundIndex = -1;
        }
    } else {
        if (byteOffset + valLength > arrLength) byteOffset = arrLength - valLength;
        for(i = byteOffset; i >= 0; i--){
            let found = true;
            for(let j = 0; j < valLength; j++)if (read(arr, i + j) !== read(val, j)) {
                found = false;
                break;
            }
            if (found) return i;
        }
    }
    return -1;
}
$51861dfc7ca9d588$var$Buffer.prototype.includes = function includes(val, byteOffset, encoding) {
    return this.indexOf(val, byteOffset, encoding) !== -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.indexOf = function indexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, true);
};
$51861dfc7ca9d588$var$Buffer.prototype.lastIndexOf = function lastIndexOf(val, byteOffset, encoding) {
    return $51861dfc7ca9d588$var$bidirectionalIndexOf(this, val, byteOffset, encoding, false);
};
function $51861dfc7ca9d588$var$hexWrite(buf, string, offset, length) {
    offset = Number(offset) || 0;
    const remaining = buf.length - offset;
    if (!length) length = remaining;
    else {
        length = Number(length);
        if (length > remaining) length = remaining;
    }
    const strLen = string.length;
    if (length > strLen / 2) length = strLen / 2;
    let i;
    for(i = 0; i < length; ++i){
        const parsed = parseInt(string.substr(i * 2, 2), 16);
        if ($51861dfc7ca9d588$var$numberIsNaN(parsed)) return i;
        buf[offset + i] = parsed;
    }
    return i;
}
function $51861dfc7ca9d588$var$utf8Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf8ToBytes(string, buf.length - offset), buf, offset, length);
}
function $51861dfc7ca9d588$var$asciiWrite(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$asciiToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$base64Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$base64ToBytes(string), buf, offset, length);
}
function $51861dfc7ca9d588$var$ucs2Write(buf, string, offset, length) {
    return $51861dfc7ca9d588$var$blitBuffer($51861dfc7ca9d588$var$utf16leToBytes(string, buf.length - offset), buf, offset, length);
}
$51861dfc7ca9d588$var$Buffer.prototype.write = function write(string, offset, length, encoding) {
    // Buffer#write(string)
    if (offset === undefined) {
        encoding = "utf8";
        length = this.length;
        offset = 0;
    // Buffer#write(string, encoding)
    } else if (length === undefined && typeof offset === "string") {
        encoding = offset;
        length = this.length;
        offset = 0;
    // Buffer#write(string, offset[, length][, encoding])
    } else if (isFinite(offset)) {
        offset = offset >>> 0;
        if (isFinite(length)) {
            length = length >>> 0;
            if (encoding === undefined) encoding = "utf8";
        } else {
            encoding = length;
            length = undefined;
        }
    } else throw new Error("Buffer.write(string, encoding, offset[, length]) is no longer supported");
    const remaining = this.length - offset;
    if (length === undefined || length > remaining) length = remaining;
    if (string.length > 0 && (length < 0 || offset < 0) || offset > this.length) throw new RangeError("Attempt to write outside buffer bounds");
    if (!encoding) encoding = "utf8";
    let loweredCase = false;
    for(;;)switch(encoding){
        case "hex":
            return $51861dfc7ca9d588$var$hexWrite(this, string, offset, length);
        case "utf8":
        case "utf-8":
            return $51861dfc7ca9d588$var$utf8Write(this, string, offset, length);
        case "ascii":
        case "latin1":
        case "binary":
            return $51861dfc7ca9d588$var$asciiWrite(this, string, offset, length);
        case "base64":
            // Warning: maxLength not taken into account in base64Write
            return $51861dfc7ca9d588$var$base64Write(this, string, offset, length);
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return $51861dfc7ca9d588$var$ucs2Write(this, string, offset, length);
        default:
            if (loweredCase) throw new TypeError("Unknown encoding: " + encoding);
            encoding = ("" + encoding).toLowerCase();
            loweredCase = true;
    }
};
$51861dfc7ca9d588$var$Buffer.prototype.toJSON = function toJSON() {
    return {
        type: "Buffer",
        data: Array.prototype.slice.call(this._arr || this, 0)
    };
};
function $51861dfc7ca9d588$var$base64Slice(buf, start, end) {
    if (start === 0 && end === buf.length) return $kuxul.fromByteArray(buf);
    else return $kuxul.fromByteArray(buf.slice(start, end));
}
function $51861dfc7ca9d588$var$utf8Slice(buf, start, end) {
    end = Math.min(buf.length, end);
    const res = [];
    let i = start;
    while(i < end){
        const firstByte = buf[i];
        let codePoint = null;
        let bytesPerSequence = firstByte > 0xEF ? 4 : firstByte > 0xDF ? 3 : firstByte > 0xBF ? 2 : 1;
        if (i + bytesPerSequence <= end) {
            let secondByte, thirdByte, fourthByte, tempCodePoint;
            switch(bytesPerSequence){
                case 1:
                    if (firstByte < 0x80) codePoint = firstByte;
                    break;
                case 2:
                    secondByte = buf[i + 1];
                    if ((secondByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0x1F) << 0x6 | secondByte & 0x3F;
                        if (tempCodePoint > 0x7F) codePoint = tempCodePoint;
                    }
                    break;
                case 3:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0xC | (secondByte & 0x3F) << 0x6 | thirdByte & 0x3F;
                        if (tempCodePoint > 0x7FF && (tempCodePoint < 0xD800 || tempCodePoint > 0xDFFF)) codePoint = tempCodePoint;
                    }
                    break;
                case 4:
                    secondByte = buf[i + 1];
                    thirdByte = buf[i + 2];
                    fourthByte = buf[i + 3];
                    if ((secondByte & 0xC0) === 0x80 && (thirdByte & 0xC0) === 0x80 && (fourthByte & 0xC0) === 0x80) {
                        tempCodePoint = (firstByte & 0xF) << 0x12 | (secondByte & 0x3F) << 0xC | (thirdByte & 0x3F) << 0x6 | fourthByte & 0x3F;
                        if (tempCodePoint > 0xFFFF && tempCodePoint < 0x110000) codePoint = tempCodePoint;
                    }
            }
        }
        if (codePoint === null) {
            // we did not generate a valid codePoint so insert a
            // replacement char (U+FFFD) and advance only 1 byte
            codePoint = 0xFFFD;
            bytesPerSequence = 1;
        } else if (codePoint > 0xFFFF) {
            // encode to utf16 (surrogate pair dance)
            codePoint -= 0x10000;
            res.push(codePoint >>> 10 & 0x3FF | 0xD800);
            codePoint = 0xDC00 | codePoint & 0x3FF;
        }
        res.push(codePoint);
        i += bytesPerSequence;
    }
    return $51861dfc7ca9d588$var$decodeCodePointsArray(res);
}
// Based on http://stackoverflow.com/a/22747272/680742, the browser with
// the lowest limit is Chrome, with 0x10000 args.
// We go 1 magnitude less, for safety
const $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH = 0x1000;
function $51861dfc7ca9d588$var$decodeCodePointsArray(codePoints) {
    const len = codePoints.length;
    if (len <= $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH) return String.fromCharCode.apply(String, codePoints) // avoid extra slice()
    ;
    // Decode in chunks to avoid "call stack size exceeded".
    let res = "";
    let i = 0;
    while(i < len)res += String.fromCharCode.apply(String, codePoints.slice(i, i += $51861dfc7ca9d588$var$MAX_ARGUMENTS_LENGTH));
    return res;
}
function $51861dfc7ca9d588$var$asciiSlice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i] & 0x7F);
    return ret;
}
function $51861dfc7ca9d588$var$latin1Slice(buf, start, end) {
    let ret = "";
    end = Math.min(buf.length, end);
    for(let i = start; i < end; ++i)ret += String.fromCharCode(buf[i]);
    return ret;
}
function $51861dfc7ca9d588$var$hexSlice(buf, start, end) {
    const len = buf.length;
    if (!start || start < 0) start = 0;
    if (!end || end < 0 || end > len) end = len;
    let out = "";
    for(let i = start; i < end; ++i)out += $51861dfc7ca9d588$var$hexSliceLookupTable[buf[i]];
    return out;
}
function $51861dfc7ca9d588$var$utf16leSlice(buf, start, end) {
    const bytes = buf.slice(start, end);
    let res = "";
    // If bytes.length is odd, the last 8 bits must be ignored (same as node.js)
    for(let i = 0; i < bytes.length - 1; i += 2)res += String.fromCharCode(bytes[i] + bytes[i + 1] * 256);
    return res;
}
$51861dfc7ca9d588$var$Buffer.prototype.slice = function slice(start, end) {
    const len = this.length;
    start = ~~start;
    end = end === undefined ? len : ~~end;
    if (start < 0) {
        start += len;
        if (start < 0) start = 0;
    } else if (start > len) start = len;
    if (end < 0) {
        end += len;
        if (end < 0) end = 0;
    } else if (end > len) end = len;
    if (end < start) end = start;
    const newBuf = this.subarray(start, end);
    // Return an augmented `Uint8Array` instance
    Object.setPrototypeOf(newBuf, $51861dfc7ca9d588$var$Buffer.prototype);
    return newBuf;
};
/*
 * Need to make sure that buffer isn't trying to write out of bounds.
 */ function $51861dfc7ca9d588$var$checkOffset(offset, ext, length) {
    if (offset % 1 !== 0 || offset < 0) throw new RangeError("offset is not uint");
    if (offset + ext > length) throw new RangeError("Trying to access beyond buffer length");
}
$51861dfc7ca9d588$var$Buffer.prototype.readUintLE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntLE = function readUIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUintBE = $51861dfc7ca9d588$var$Buffer.prototype.readUIntBE = function readUIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset + --byteLength];
    let mul = 1;
    while(byteLength > 0 && (mul *= 0x100))val += this[offset + --byteLength] * mul;
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint8 = $51861dfc7ca9d588$var$Buffer.prototype.readUInt8 = function readUInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    return this[offset];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16LE = function readUInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] | this[offset + 1] << 8;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt16BE = function readUInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    return this[offset] << 8 | this[offset + 1];
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32LE = function readUInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return (this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16) + this[offset + 3] * 0x1000000;
};
$51861dfc7ca9d588$var$Buffer.prototype.readUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.readUInt32BE = function readUInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] * 0x1000000 + (this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3]);
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const lo = first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24;
    const hi = this[++offset] + this[++offset] * 256 + this[++offset] * 2 ** 16 + last * 2 ** 24;
    return BigInt(lo) + (BigInt(hi) << BigInt(32));
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigUInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const hi = first * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    const lo = this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last;
    return (BigInt(hi) << BigInt(32)) + BigInt(lo);
});
$51861dfc7ca9d588$var$Buffer.prototype.readIntLE = function readIntLE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let val = this[offset];
    let mul = 1;
    let i = 0;
    while(++i < byteLength && (mul *= 0x100))val += this[offset + i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readIntBE = function readIntBE(offset, byteLength, noAssert) {
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, byteLength, this.length);
    let i = byteLength;
    let mul = 1;
    let val = this[offset + --i];
    while(i > 0 && (mul *= 0x100))val += this[offset + --i] * mul;
    mul *= 0x80;
    if (val >= mul) val -= Math.pow(2, 8 * byteLength);
    return val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt8 = function readInt8(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 1, this.length);
    if (!(this[offset] & 0x80)) return this[offset];
    return (0xff - this[offset] + 1) * -1;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16LE = function readInt16LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset] | this[offset + 1] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt16BE = function readInt16BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 2, this.length);
    const val = this[offset + 1] | this[offset] << 8;
    return val & 0x8000 ? val | 0xFFFF0000 : val;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32LE = function readInt32LE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] | this[offset + 1] << 8 | this[offset + 2] << 16 | this[offset + 3] << 24;
};
$51861dfc7ca9d588$var$Buffer.prototype.readInt32BE = function readInt32BE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return this[offset] << 24 | this[offset + 1] << 16 | this[offset + 2] << 8 | this[offset + 3];
};
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64LE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = this[offset + 4] + this[offset + 5] * 256 + this[offset + 6] * 2 ** 16 + (last << 24 // Overflow
    );
    return (BigInt(val) << BigInt(32)) + BigInt(first + this[++offset] * 256 + this[++offset] * 2 ** 16 + this[++offset] * 2 ** 24);
});
$51861dfc7ca9d588$var$Buffer.prototype.readBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function readBigInt64BE(offset) {
    offset = offset >>> 0;
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    const first = this[offset];
    const last = this[offset + 7];
    if (first === undefined || last === undefined) $51861dfc7ca9d588$var$boundsError(offset, this.length - 8);
    const val = (first << 24) + // Overflow
    this[++offset] * 2 ** 16 + this[++offset] * 256 + this[++offset];
    return (BigInt(val) << BigInt(32)) + BigInt(this[++offset] * 2 ** 24 + this[++offset] * 2 ** 16 + this[++offset] * 256 + last);
});
$51861dfc7ca9d588$var$Buffer.prototype.readFloatLE = function readFloatLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, true, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readFloatBE = function readFloatBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 4, this.length);
    return $9NvM5.read(this, offset, false, 23, 4);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleLE = function readDoubleLE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, true, 52, 8);
};
$51861dfc7ca9d588$var$Buffer.prototype.readDoubleBE = function readDoubleBE(offset, noAssert) {
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkOffset(offset, 8, this.length);
    return $9NvM5.read(this, offset, false, 52, 8);
};
function $51861dfc7ca9d588$var$checkInt(buf, value, offset, ext, max, min) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(buf)) throw new TypeError('"buffer" argument must be a Buffer instance');
    if (value > max || value < min) throw new RangeError('"value" argument is out of bounds');
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
}
$51861dfc7ca9d588$var$Buffer.prototype.writeUintLE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntLE = function writeUIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let mul = 1;
    let i = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUintBE = $51861dfc7ca9d588$var$Buffer.prototype.writeUIntBE = function writeUIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    byteLength = byteLength >>> 0;
    if (!noAssert) {
        const maxBytes = Math.pow(2, 8 * byteLength) - 1;
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, maxBytes, 0);
    }
    let i = byteLength - 1;
    let mul = 1;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100))this[offset + i] = value / mul & 0xFF;
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint8 = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt8 = function writeUInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0xff, 0);
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16LE = function writeUInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint16BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt16BE = function writeUInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0xffff, 0);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32LE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32LE = function writeUInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset + 3] = value >>> 24;
    this[offset + 2] = value >>> 16;
    this[offset + 1] = value >>> 8;
    this[offset] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeUint32BE = $51861dfc7ca9d588$var$Buffer.prototype.writeUInt32BE = function writeUInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0xffffffff, 0);
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
function $51861dfc7ca9d588$var$wrtBigUInt64LE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    lo = lo >> 8;
    buf[offset++] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    hi = hi >> 8;
    buf[offset++] = hi;
    return offset;
}
function $51861dfc7ca9d588$var$wrtBigUInt64BE(buf, value, offset, min, max) {
    $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, 7);
    let lo = Number(value & BigInt(0xffffffff));
    buf[offset + 7] = lo;
    lo = lo >> 8;
    buf[offset + 6] = lo;
    lo = lo >> 8;
    buf[offset + 5] = lo;
    lo = lo >> 8;
    buf[offset + 4] = lo;
    let hi = Number(value >> BigInt(32) & BigInt(0xffffffff));
    buf[offset + 3] = hi;
    hi = hi >> 8;
    buf[offset + 2] = hi;
    hi = hi >> 8;
    buf[offset + 1] = hi;
    hi = hi >> 8;
    buf[offset] = hi;
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigUInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigUInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, BigInt(0), BigInt("0xffffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeIntLE = function writeIntLE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = 0;
    let mul = 1;
    let sub = 0;
    this[offset] = value & 0xFF;
    while(++i < byteLength && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i - 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeIntBE = function writeIntBE(value, offset, byteLength, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) {
        const limit = Math.pow(2, 8 * byteLength - 1);
        $51861dfc7ca9d588$var$checkInt(this, value, offset, byteLength, limit - 1, -limit);
    }
    let i = byteLength - 1;
    let mul = 1;
    let sub = 0;
    this[offset + i] = value & 0xFF;
    while(--i >= 0 && (mul *= 0x100)){
        if (value < 0 && sub === 0 && this[offset + i + 1] !== 0) sub = 1;
        this[offset + i] = (value / mul >> 0) - sub & 0xFF;
    }
    return offset + byteLength;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt8 = function writeInt8(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 1, 0x7f, -128);
    if (value < 0) value = 0xff + value + 1;
    this[offset] = value & 0xff;
    return offset + 1;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16LE = function writeInt16LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt16BE = function writeInt16BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 2, 0x7fff, -32768);
    this[offset] = value >>> 8;
    this[offset + 1] = value & 0xff;
    return offset + 2;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32LE = function writeInt32LE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    this[offset] = value & 0xff;
    this[offset + 1] = value >>> 8;
    this[offset + 2] = value >>> 16;
    this[offset + 3] = value >>> 24;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeInt32BE = function writeInt32BE(value, offset, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkInt(this, value, offset, 4, 0x7fffffff, -2147483648);
    if (value < 0) value = 0xffffffff + value + 1;
    this[offset] = value >>> 24;
    this[offset + 1] = value >>> 16;
    this[offset + 2] = value >>> 8;
    this[offset + 3] = value & 0xff;
    return offset + 4;
};
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64LE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64LE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64LE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
$51861dfc7ca9d588$var$Buffer.prototype.writeBigInt64BE = $51861dfc7ca9d588$var$defineBigIntMethod(function writeBigInt64BE(value, offset = 0) {
    return $51861dfc7ca9d588$var$wrtBigUInt64BE(this, value, offset, -BigInt("0x8000000000000000"), BigInt("0x7fffffffffffffff"));
});
function $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, ext, max, min) {
    if (offset + ext > buf.length) throw new RangeError("Index out of range");
    if (offset < 0) throw new RangeError("Index out of range");
}
function $51861dfc7ca9d588$var$writeFloat(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 4, 3.4028234663852886e+38, -340282346638528860000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 23, 4);
    return offset + 4;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatLE = function writeFloatLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeFloatBE = function writeFloatBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeFloat(this, value, offset, false, noAssert);
};
function $51861dfc7ca9d588$var$writeDouble(buf, value, offset, littleEndian, noAssert) {
    value = +value;
    offset = offset >>> 0;
    if (!noAssert) $51861dfc7ca9d588$var$checkIEEE754(buf, value, offset, 8, 1.7976931348623157E+308, -179769313486231570000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000000);
    $9NvM5.write(buf, value, offset, littleEndian, 52, 8);
    return offset + 8;
}
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleLE = function writeDoubleLE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, true, noAssert);
};
$51861dfc7ca9d588$var$Buffer.prototype.writeDoubleBE = function writeDoubleBE(value, offset, noAssert) {
    return $51861dfc7ca9d588$var$writeDouble(this, value, offset, false, noAssert);
};
// copy(targetBuffer, targetStart=0, sourceStart=0, sourceEnd=buffer.length)
$51861dfc7ca9d588$var$Buffer.prototype.copy = function copy(target, targetStart, start, end) {
    if (!$51861dfc7ca9d588$var$Buffer.isBuffer(target)) throw new TypeError("argument should be a Buffer");
    if (!start) start = 0;
    if (!end && end !== 0) end = this.length;
    if (targetStart >= target.length) targetStart = target.length;
    if (!targetStart) targetStart = 0;
    if (end > 0 && end < start) end = start;
    // Copy 0 bytes; we're done
    if (end === start) return 0;
    if (target.length === 0 || this.length === 0) return 0;
    // Fatal error conditions
    if (targetStart < 0) throw new RangeError("targetStart out of bounds");
    if (start < 0 || start >= this.length) throw new RangeError("Index out of range");
    if (end < 0) throw new RangeError("sourceEnd out of bounds");
    // Are we oob?
    if (end > this.length) end = this.length;
    if (target.length - targetStart < end - start) end = target.length - targetStart + start;
    const len = end - start;
    if (this === target && typeof Uint8Array.prototype.copyWithin === "function") // Use built-in when available, missing from IE11
    this.copyWithin(targetStart, start, end);
    else Uint8Array.prototype.set.call(target, this.subarray(start, end), targetStart);
    return len;
};
// Usage:
//    buffer.fill(number[, offset[, end]])
//    buffer.fill(buffer[, offset[, end]])
//    buffer.fill(string[, offset[, end]][, encoding])
$51861dfc7ca9d588$var$Buffer.prototype.fill = function fill(val, start, end, encoding) {
    // Handle string cases:
    if (typeof val === "string") {
        if (typeof start === "string") {
            encoding = start;
            start = 0;
            end = this.length;
        } else if (typeof end === "string") {
            encoding = end;
            end = this.length;
        }
        if (encoding !== undefined && typeof encoding !== "string") throw new TypeError("encoding must be a string");
        if (typeof encoding === "string" && !$51861dfc7ca9d588$var$Buffer.isEncoding(encoding)) throw new TypeError("Unknown encoding: " + encoding);
        if (val.length === 1) {
            const code = val.charCodeAt(0);
            if (encoding === "utf8" && code < 128 || encoding === "latin1") // Fast path: If `val` fits into a single byte, use that numeric value.
            val = code;
        }
    } else if (typeof val === "number") val = val & 255;
    else if (typeof val === "boolean") val = Number(val);
    // Invalid ranges are not set to a default, so can range check early.
    if (start < 0 || this.length < start || this.length < end) throw new RangeError("Out of range index");
    if (end <= start) return this;
    start = start >>> 0;
    end = end === undefined ? this.length : end >>> 0;
    if (!val) val = 0;
    let i;
    if (typeof val === "number") for(i = start; i < end; ++i)this[i] = val;
    else {
        const bytes = $51861dfc7ca9d588$var$Buffer.isBuffer(val) ? val : $51861dfc7ca9d588$var$Buffer.from(val, encoding);
        const len = bytes.length;
        if (len === 0) throw new TypeError('The value "' + val + '" is invalid for argument "value"');
        for(i = 0; i < end - start; ++i)this[i + start] = bytes[i % len];
    }
    return this;
};
// CUSTOM ERRORS
// =============
// Simplified versions from Node, changed for Buffer-only usage
const $51861dfc7ca9d588$var$errors = {};
function $51861dfc7ca9d588$var$E(sym, getMessage, Base) {
    $51861dfc7ca9d588$var$errors[sym] = class NodeError extends Base {
        constructor(){
            super();
            Object.defineProperty(this, "message", {
                value: getMessage.apply(this, arguments),
                writable: true,
                configurable: true
            });
            // Add the error code to the name to include it in the stack trace.
            this.name = `${this.name} [${sym}]`;
            // Access the stack to generate the error message including the error code
            // from the name.
            this.stack // eslint-disable-line no-unused-expressions
            ;
            // Reset the name to the actual name.
            delete this.name;
        }
        get code() {
            return sym;
        }
        set code(value) {
            Object.defineProperty(this, "code", {
                configurable: true,
                enumerable: true,
                value: value,
                writable: true
            });
        }
        toString() {
            return `${this.name} [${sym}]: ${this.message}`;
        }
    };
}
$51861dfc7ca9d588$var$E("ERR_BUFFER_OUT_OF_BOUNDS", function(name) {
    if (name) return `${name} is outside of buffer bounds`;
    return "Attempt to access memory outside buffer bounds";
}, RangeError);
$51861dfc7ca9d588$var$E("ERR_INVALID_ARG_TYPE", function(name, actual) {
    return `The "${name}" argument must be of type number. Received type ${typeof actual}`;
}, TypeError);
$51861dfc7ca9d588$var$E("ERR_OUT_OF_RANGE", function(str, range, input) {
    let msg = `The value of "${str}" is out of range.`;
    let received = input;
    if (Number.isInteger(input) && Math.abs(input) > 2 ** 32) received = $51861dfc7ca9d588$var$addNumericalSeparator(String(input));
    else if (typeof input === "bigint") {
        received = String(input);
        if (input > BigInt(2) ** BigInt(32) || input < -(BigInt(2) ** BigInt(32))) received = $51861dfc7ca9d588$var$addNumericalSeparator(received);
        received += "n";
    }
    msg += ` It must be ${range}. Received ${received}`;
    return msg;
}, RangeError);
function $51861dfc7ca9d588$var$addNumericalSeparator(val) {
    let res = "";
    let i = val.length;
    const start = val[0] === "-" ? 1 : 0;
    for(; i >= start + 4; i -= 3)res = `_${val.slice(i - 3, i)}${res}`;
    return `${val.slice(0, i)}${res}`;
}
// CHECK FUNCTIONS
// ===============
function $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength) {
    $51861dfc7ca9d588$var$validateNumber(offset, "offset");
    if (buf[offset] === undefined || buf[offset + byteLength] === undefined) $51861dfc7ca9d588$var$boundsError(offset, buf.length - (byteLength + 1));
}
function $51861dfc7ca9d588$var$checkIntBI(value, min, max, buf, offset, byteLength) {
    if (value > max || value < min) {
        const n = typeof min === "bigint" ? "n" : "";
        let range;
        if (byteLength > 3) {
            if (min === 0 || min === BigInt(0)) range = `>= 0${n} and < 2${n} ** ${(byteLength + 1) * 8}${n}`;
            else range = `>= -(2${n} ** ${(byteLength + 1) * 8 - 1}${n}) and < 2 ** ` + `${(byteLength + 1) * 8 - 1}${n}`;
        } else range = `>= ${min}${n} and <= ${max}${n}`;
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE("value", range, value);
    }
    $51861dfc7ca9d588$var$checkBounds(buf, offset, byteLength);
}
function $51861dfc7ca9d588$var$validateNumber(value, name) {
    if (typeof value !== "number") throw new $51861dfc7ca9d588$var$errors.ERR_INVALID_ARG_TYPE(name, "number", value);
}
function $51861dfc7ca9d588$var$boundsError(value, length, type) {
    if (Math.floor(value) !== value) {
        $51861dfc7ca9d588$var$validateNumber(value, type);
        throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", "an integer", value);
    }
    if (length < 0) throw new $51861dfc7ca9d588$var$errors.ERR_BUFFER_OUT_OF_BOUNDS();
    throw new $51861dfc7ca9d588$var$errors.ERR_OUT_OF_RANGE(type || "offset", `>= ${type ? 1 : 0} and <= ${length}`, value);
}
// HELPER FUNCTIONS
// ================
const $51861dfc7ca9d588$var$INVALID_BASE64_RE = /[^+/0-9A-Za-z-_]/g;
function $51861dfc7ca9d588$var$base64clean(str) {
    // Node takes equal signs as end of the Base64 encoding
    str = str.split("=")[0];
    // Node strips out invalid characters like \n and \t from the string, base64-js does not
    str = str.trim().replace($51861dfc7ca9d588$var$INVALID_BASE64_RE, "");
    // Node converts strings with length < 2 to ''
    if (str.length < 2) return "";
    // Node allows for non-padded base64 strings (missing trailing ===), base64-js does not
    while(str.length % 4 !== 0)str = str + "=";
    return str;
}
function $51861dfc7ca9d588$var$utf8ToBytes(string, units) {
    units = units || Infinity;
    let codePoint;
    const length = string.length;
    let leadSurrogate = null;
    const bytes = [];
    for(let i = 0; i < length; ++i){
        codePoint = string.charCodeAt(i);
        // is surrogate component
        if (codePoint > 0xD7FF && codePoint < 0xE000) {
            // last char was a lead
            if (!leadSurrogate) {
                // no lead yet
                if (codePoint > 0xDBFF) {
                    // unexpected trail
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                } else if (i + 1 === length) {
                    // unpaired lead
                    if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                    continue;
                }
                // valid lead
                leadSurrogate = codePoint;
                continue;
            }
            // 2 leads in a row
            if (codePoint < 0xDC00) {
                if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
                leadSurrogate = codePoint;
                continue;
            }
            // valid surrogate pair
            codePoint = (leadSurrogate - 0xD800 << 10 | codePoint - 0xDC00) + 0x10000;
        } else if (leadSurrogate) // valid bmp char, but last char was a lead
        {
            if ((units -= 3) > -1) bytes.push(0xEF, 0xBF, 0xBD);
        }
        leadSurrogate = null;
        // encode utf8
        if (codePoint < 0x80) {
            if ((units -= 1) < 0) break;
            bytes.push(codePoint);
        } else if (codePoint < 0x800) {
            if ((units -= 2) < 0) break;
            bytes.push(codePoint >> 0x6 | 0xC0, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x10000) {
            if ((units -= 3) < 0) break;
            bytes.push(codePoint >> 0xC | 0xE0, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else if (codePoint < 0x110000) {
            if ((units -= 4) < 0) break;
            bytes.push(codePoint >> 0x12 | 0xF0, codePoint >> 0xC & 0x3F | 0x80, codePoint >> 0x6 & 0x3F | 0x80, codePoint & 0x3F | 0x80);
        } else throw new Error("Invalid code point");
    }
    return bytes;
}
function $51861dfc7ca9d588$var$asciiToBytes(str) {
    const byteArray = [];
    for(let i = 0; i < str.length; ++i)// Node's code seems to be doing this and not & 0x7F..
    byteArray.push(str.charCodeAt(i) & 0xFF);
    return byteArray;
}
function $51861dfc7ca9d588$var$utf16leToBytes(str, units) {
    let c, hi, lo;
    const byteArray = [];
    for(let i = 0; i < str.length; ++i){
        if ((units -= 2) < 0) break;
        c = str.charCodeAt(i);
        hi = c >> 8;
        lo = c % 256;
        byteArray.push(lo);
        byteArray.push(hi);
    }
    return byteArray;
}
function $51861dfc7ca9d588$var$base64ToBytes(str) {
    return $kuxul.toByteArray($51861dfc7ca9d588$var$base64clean(str));
}
function $51861dfc7ca9d588$var$blitBuffer(src, dst, offset, length) {
    let i;
    for(i = 0; i < length; ++i){
        if (i + offset >= dst.length || i >= src.length) break;
        dst[i + offset] = src[i];
    }
    return i;
}
// ArrayBuffer or Uint8Array objects from other contexts (i.e. iframes) do not pass
// the `instanceof` check but they should be treated as of that type.
// See: https://github.com/feross/buffer/issues/166
function $51861dfc7ca9d588$var$isInstance(obj, type) {
    return obj instanceof type || obj != null && obj.constructor != null && obj.constructor.name != null && obj.constructor.name === type.name;
}
function $51861dfc7ca9d588$var$numberIsNaN(obj) {
    // For IE11 support
    return obj !== obj // eslint-disable-line no-self-compare
    ;
}
// Create lookup table for `toString('hex')`
// See: https://github.com/feross/buffer/issues/219
const $51861dfc7ca9d588$var$hexSliceLookupTable = function() {
    const alphabet = "0123456789abcdef";
    const table = new Array(256);
    for(let i = 0; i < 16; ++i){
        const i16 = i * 16;
        for(let j = 0; j < 16; ++j)table[i16 + j] = alphabet[i] + alphabet[j];
    }
    return table;
}();
// Return not function with Error if BigInt not supported
function $51861dfc7ca9d588$var$defineBigIntMethod(fn) {
    return typeof BigInt === "undefined" ? $51861dfc7ca9d588$var$BufferBigIntNotDefined : fn;
}
function $51861dfc7ca9d588$var$BufferBigIntNotDefined() {
    throw new Error("BigInt not supported");
}

});
parcelRegister("kuxul", function(module, exports) {

$parcel$export(module.exports, "toByteArray", () => $eeb0961446aae8e3$export$d622b2ad8d90c771, (v) => $eeb0961446aae8e3$export$d622b2ad8d90c771 = v);
$parcel$export(module.exports, "fromByteArray", () => $eeb0961446aae8e3$export$6100ba28696e12de, (v) => $eeb0961446aae8e3$export$6100ba28696e12de = v);
var $eeb0961446aae8e3$export$a48f0734ac7c2329;
var $eeb0961446aae8e3$export$d622b2ad8d90c771;
var $eeb0961446aae8e3$export$6100ba28696e12de;
"use strict";
$eeb0961446aae8e3$export$a48f0734ac7c2329 = $eeb0961446aae8e3$var$byteLength;
$eeb0961446aae8e3$export$d622b2ad8d90c771 = $eeb0961446aae8e3$var$toByteArray;
$eeb0961446aae8e3$export$6100ba28696e12de = $eeb0961446aae8e3$var$fromByteArray;
var $eeb0961446aae8e3$var$lookup = [];
var $eeb0961446aae8e3$var$revLookup = [];
var $eeb0961446aae8e3$var$Arr = typeof Uint8Array !== "undefined" ? Uint8Array : Array;
var $eeb0961446aae8e3$var$code = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/";
for(var $eeb0961446aae8e3$var$i = 0, $eeb0961446aae8e3$var$len = $eeb0961446aae8e3$var$code.length; $eeb0961446aae8e3$var$i < $eeb0961446aae8e3$var$len; ++$eeb0961446aae8e3$var$i){
    $eeb0961446aae8e3$var$lookup[$eeb0961446aae8e3$var$i] = $eeb0961446aae8e3$var$code[$eeb0961446aae8e3$var$i];
    $eeb0961446aae8e3$var$revLookup[$eeb0961446aae8e3$var$code.charCodeAt($eeb0961446aae8e3$var$i)] = $eeb0961446aae8e3$var$i;
}
// Support decoding URL-safe base64 strings, as Node.js does.
// See: https://en.wikipedia.org/wiki/Base64#URL_applications
$eeb0961446aae8e3$var$revLookup["-".charCodeAt(0)] = 62;
$eeb0961446aae8e3$var$revLookup["_".charCodeAt(0)] = 63;
function $eeb0961446aae8e3$var$getLens(b64) {
    var len = b64.length;
    if (len % 4 > 0) throw new Error("Invalid string. Length must be a multiple of 4");
    // Trim off extra bytes after placeholder bytes are found
    // See: https://github.com/beatgammit/base64-js/issues/42
    var validLen = b64.indexOf("=");
    if (validLen === -1) validLen = len;
    var placeHoldersLen = validLen === len ? 0 : 4 - validLen % 4;
    return [
        validLen,
        placeHoldersLen
    ];
}
// base64 is 4/3 + up to two characters of the original data
function $eeb0961446aae8e3$var$byteLength(b64) {
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen) {
    return (validLen + placeHoldersLen) * 3 / 4 - placeHoldersLen;
}
function $eeb0961446aae8e3$var$toByteArray(b64) {
    var tmp;
    var lens = $eeb0961446aae8e3$var$getLens(b64);
    var validLen = lens[0];
    var placeHoldersLen = lens[1];
    var arr = new $eeb0961446aae8e3$var$Arr($eeb0961446aae8e3$var$_byteLength(b64, validLen, placeHoldersLen));
    var curByte = 0;
    // if there are placeholders, only get up to the last complete 4 chars
    var len = placeHoldersLen > 0 ? validLen - 4 : validLen;
    var i;
    for(i = 0; i < len; i += 4){
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 18 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 12 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] << 6 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 3)];
        arr[curByte++] = tmp >> 16 & 0xFF;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 2) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 2 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] >> 4;
        arr[curByte++] = tmp & 0xFF;
    }
    if (placeHoldersLen === 1) {
        tmp = $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i)] << 10 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 1)] << 4 | $eeb0961446aae8e3$var$revLookup[b64.charCodeAt(i + 2)] >> 2;
        arr[curByte++] = tmp >> 8 & 0xFF;
        arr[curByte++] = tmp & 0xFF;
    }
    return arr;
}
function $eeb0961446aae8e3$var$tripletToBase64(num) {
    return $eeb0961446aae8e3$var$lookup[num >> 18 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 12 & 0x3F] + $eeb0961446aae8e3$var$lookup[num >> 6 & 0x3F] + $eeb0961446aae8e3$var$lookup[num & 0x3F];
}
function $eeb0961446aae8e3$var$encodeChunk(uint8, start, end) {
    var tmp;
    var output = [];
    for(var i = start; i < end; i += 3){
        tmp = (uint8[i] << 16 & 0xFF0000) + (uint8[i + 1] << 8 & 0xFF00) + (uint8[i + 2] & 0xFF);
        output.push($eeb0961446aae8e3$var$tripletToBase64(tmp));
    }
    return output.join("");
}
function $eeb0961446aae8e3$var$fromByteArray(uint8) {
    var tmp;
    var len = uint8.length;
    var extraBytes = len % 3 // if we have 1 byte left, pad 2 bytes
    ;
    var parts = [];
    var maxChunkLength = 16383 // must be multiple of 3
    ;
    // go through the array every three bytes, we'll deal with trailing stuff later
    for(var i = 0, len2 = len - extraBytes; i < len2; i += maxChunkLength)parts.push($eeb0961446aae8e3$var$encodeChunk(uint8, i, i + maxChunkLength > len2 ? len2 : i + maxChunkLength));
    // pad the end with zeros, but make sure to not forget the extra bytes
    if (extraBytes === 1) {
        tmp = uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 2] + $eeb0961446aae8e3$var$lookup[tmp << 4 & 0x3F] + "==");
    } else if (extraBytes === 2) {
        tmp = (uint8[len - 2] << 8) + uint8[len - 1];
        parts.push($eeb0961446aae8e3$var$lookup[tmp >> 10] + $eeb0961446aae8e3$var$lookup[tmp >> 4 & 0x3F] + $eeb0961446aae8e3$var$lookup[tmp << 2 & 0x3F] + "=");
    }
    return parts.join("");
}

});

parcelRegister("9NvM5", function(module, exports) {

$parcel$export(module.exports, "read", () => $7221566bd4d49f44$export$aafa59e2e03f2942, (v) => $7221566bd4d49f44$export$aafa59e2e03f2942 = v);
$parcel$export(module.exports, "write", () => $7221566bd4d49f44$export$68d8715fc104d294, (v) => $7221566bd4d49f44$export$68d8715fc104d294 = v);
/*! ieee754. BSD-3-Clause License. Feross Aboukhadijeh <https://feross.org/opensource> */ var $7221566bd4d49f44$export$aafa59e2e03f2942;
var $7221566bd4d49f44$export$68d8715fc104d294;
$7221566bd4d49f44$export$aafa59e2e03f2942 = function(buffer, offset, isLE, mLen, nBytes) {
    var e, m;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var nBits = -7;
    var i = isLE ? nBytes - 1 : 0;
    var d = isLE ? -1 : 1;
    var s = buffer[offset + i];
    i += d;
    e = s & (1 << -nBits) - 1;
    s >>= -nBits;
    nBits += eLen;
    for(; nBits > 0; e = e * 256 + buffer[offset + i], i += d, nBits -= 8);
    m = e & (1 << -nBits) - 1;
    e >>= -nBits;
    nBits += mLen;
    for(; nBits > 0; m = m * 256 + buffer[offset + i], i += d, nBits -= 8);
    if (e === 0) e = 1 - eBias;
    else if (e === eMax) return m ? NaN : (s ? -1 : 1) * Infinity;
    else {
        m = m + Math.pow(2, mLen);
        e = e - eBias;
    }
    return (s ? -1 : 1) * m * Math.pow(2, e - mLen);
};
$7221566bd4d49f44$export$68d8715fc104d294 = function(buffer, value, offset, isLE, mLen, nBytes) {
    var e, m, c;
    var eLen = nBytes * 8 - mLen - 1;
    var eMax = (1 << eLen) - 1;
    var eBias = eMax >> 1;
    var rt = mLen === 23 ? Math.pow(2, -24) - Math.pow(2, -77) : 0;
    var i = isLE ? 0 : nBytes - 1;
    var d = isLE ? 1 : -1;
    var s = value < 0 || value === 0 && 1 / value < 0 ? 1 : 0;
    value = Math.abs(value);
    if (isNaN(value) || value === Infinity) {
        m = isNaN(value) ? 1 : 0;
        e = eMax;
    } else {
        e = Math.floor(Math.log(value) / Math.LN2);
        if (value * (c = Math.pow(2, -e)) < 1) {
            e--;
            c *= 2;
        }
        if (e + eBias >= 1) value += rt / c;
        else value += rt * Math.pow(2, 1 - eBias);
        if (value * c >= 2) {
            e++;
            c /= 2;
        }
        if (e + eBias >= eMax) {
            m = 0;
            e = eMax;
        } else if (e + eBias >= 1) {
            m = (value * c - 1) * Math.pow(2, mLen);
            e = e + eBias;
        } else {
            m = value * Math.pow(2, eBias - 1) * Math.pow(2, mLen);
            e = 0;
        }
    }
    for(; mLen >= 8; buffer[offset + i] = m & 0xff, i += d, m /= 256, mLen -= 8);
    e = e << mLen | m;
    eLen += mLen;
    for(; eLen > 0; buffer[offset + i] = e & 0xff, i += d, e /= 256, eLen -= 8);
    buffer[offset + i - d] |= s * 128;
};

});


parcelRegister("3wrUl", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.initEccLib = module.exports.Transaction = module.exports.opcodes = module.exports.Psbt = module.exports.Block = module.exports.script = module.exports.payments = module.exports.networks = module.exports.crypto = module.exports.address = void 0;

var $d1wHE = parcelRequire("d1wHE");
module.exports.address = $d1wHE;

var $lgTFk = parcelRequire("lgTFk");
module.exports.crypto = $lgTFk;

var $fjh6Q = parcelRequire("fjh6Q");
module.exports.networks = $fjh6Q;

var $j87lX = parcelRequire("j87lX");
module.exports.payments = $j87lX;

var $8wAtk = parcelRequire("8wAtk");
module.exports.script = $8wAtk;

var $huuL7 = parcelRequire("huuL7");
Object.defineProperty(module.exports, "Block", {
    enumerable: true,
    get: function() {
        return $huuL7.Block;
    }
});

var $hXYde = parcelRequire("hXYde");
Object.defineProperty(module.exports, "Psbt", {
    enumerable: true,
    get: function() {
        return $hXYde.Psbt;
    }
});

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, "opcodes", {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $gMJcK = parcelRequire("gMJcK");
Object.defineProperty(module.exports, "Transaction", {
    enumerable: true,
    get: function() {
        return $gMJcK.Transaction;
    }
});

var $f6boC = parcelRequire("f6boC");
Object.defineProperty(module.exports, "initEccLib", {
    enumerable: true,
    get: function() {
        return $f6boC.initEccLib;
    }
});

});
parcelRegister("d1wHE", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $97b4bc83495059dc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.toOutputScript = module.exports.fromOutputScript = module.exports.toBech32 = module.exports.toBase58Check = module.exports.fromBech32 = module.exports.fromBase58Check = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $db6J2 = parcelRequire("db6J2");

var $wjgZX = parcelRequire("wjgZX");
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE = 40;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION = 16;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION = 2;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF = 0x50;
const $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING = "WARNING: Sending to a future segwit version address can lead to loss of funds. End users MUST be warned carefully in the GUI and asked if they wish to proceed with caution. Wallets should verify the segwit version from the output of fromBech32, then decide when it is safe to use which version of segwit.";
function $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network) {
    const data = output.slice(2);
    if (data.length < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE || data.length > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) throw new TypeError("Invalid program length for segwit address");
    const version = output[0] - $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF;
    if (version < $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION || version > $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION) throw new TypeError("Invalid version for segwit address");
    if (output[1] !== data.length) throw new TypeError("Invalid script for segwit address");
    console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
    return $97b4bc83495059dc$var$toBech32(data, version, network.bech32);
}
/**
 * decode address with base58 specification,  return address version and address hash if valid
 */ function $97b4bc83495059dc$var$fromBase58Check(address) {
    const payload = $97b4bc83495059dc$require$Buffer.from($wjgZX.decode(address));
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + " is too short");
    if (payload.length > 21) throw new TypeError(address + " is too long");
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
module.exports.fromBase58Check = $97b4bc83495059dc$var$fromBase58Check;
/**
 * decode address with bech32 specification,  return address version、address prefix and address data if valid
 */ function $97b4bc83495059dc$var$fromBech32(address) {
    let result;
    let version;
    try {
        result = $db6J2.bech32.decode(address);
    } catch (e) {}
    if (result) {
        version = result.words[0];
        if (version !== 0) throw new TypeError(address + " uses wrong encoding");
    } else {
        result = $db6J2.bech32m.decode(address);
        version = result.words[0];
        if (version === 0) throw new TypeError(address + " uses wrong encoding");
    }
    const data = $db6J2.bech32.fromWords(result.words.slice(1));
    return {
        version: version,
        prefix: result.prefix,
        data: $97b4bc83495059dc$require$Buffer.from(data)
    };
}
module.exports.fromBech32 = $97b4bc83495059dc$var$fromBech32;
/**
 * encode address hash to base58 address with version
 */ function $97b4bc83495059dc$var$toBase58Check(hash, version) {
    (0, $18Mz5.typeforce)((0, $18Mz5.tuple)($18Mz5.Hash160bit, $18Mz5.UInt8), arguments);
    const payload = $97b4bc83495059dc$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $wjgZX.encode(payload);
}
module.exports.toBase58Check = $97b4bc83495059dc$var$toBase58Check;
/**
 * encode address hash to bech32 address with version and prefix
 */ function $97b4bc83495059dc$var$toBech32(data, version, prefix) {
    const words = $db6J2.bech32.toWords(data);
    words.unshift(version);
    return version === 0 ? $db6J2.bech32.encode(prefix, words) : $db6J2.bech32m.encode(prefix, words);
}
module.exports.toBech32 = $97b4bc83495059dc$var$toBech32;
/**
 * decode address from output script with network, return address if matched
 */ function $97b4bc83495059dc$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $fjh6Q.bitcoin;
    try {
        return $j87lX.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $j87lX.p2tr({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $97b4bc83495059dc$var$_toFutureSegwitAddress(output, network);
    } catch (e) {}
    throw new Error($8wAtk.toASM(output) + " has no matching Address");
}
module.exports.fromOutputScript = $97b4bc83495059dc$var$fromOutputScript;
/**
 * encodes address to output script with network, return output script if address matched
 */ function $97b4bc83495059dc$var$toOutputScript(address, network) {
    network = network || $fjh6Q.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $97b4bc83495059dc$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $j87lX.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $j87lX.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $97b4bc83495059dc$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $j87lX.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $j87lX.p2wsh({
                    hash: decodeBech32.data
                }).output;
            } else if (decodeBech32.version === 1) {
                if (decodeBech32.data.length === 32) return $j87lX.p2tr({
                    pubkey: decodeBech32.data
                }).output;
            } else if (decodeBech32.version >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_VERSION && decodeBech32.version <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_VERSION && decodeBech32.data.length >= $97b4bc83495059dc$var$FUTURE_SEGWIT_MIN_SIZE && decodeBech32.data.length <= $97b4bc83495059dc$var$FUTURE_SEGWIT_MAX_SIZE) {
                console.warn($97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_WARNING);
                return $8wAtk.compile([
                    decodeBech32.version + $97b4bc83495059dc$var$FUTURE_SEGWIT_VERSION_DIFF,
                    decodeBech32.data
                ]);
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
module.exports.toOutputScript = $97b4bc83495059dc$var$toOutputScript;

});
parcelRegister("fjh6Q", function(module, exports) {
"use strict";
// https://en.bitcoin.it/wiki/List_of_address_prefixes
// Dogecoin BIP32 is a proposed standard: https://bitcointalk.org/index.php?topic=409731
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.testnet = module.exports.regtest = module.exports.bitcoin = void 0;
/**
 * Represents the Bitcoin network configuration.
 */ module.exports.bitcoin = {
    /**
   * The message prefix used for signing Bitcoin messages.
   */ messagePrefix: "\x18Bitcoin Signed Message:\n",
    /**
   * The Bech32 prefix used for Bitcoin addresses.
   */ bech32: "bc",
    /**
   * The BIP32 key prefixes for Bitcoin.
   */ bip32: {
        /**
     * The public key prefix for BIP32 extended public keys.
     */ public: 0x0488b21e,
        /**
     * The private key prefix for BIP32 extended private keys.
     */ private: 0x0488ade4
    },
    /**
   * The prefix for Bitcoin public key hashes.
   */ pubKeyHash: 0x00,
    /**
   * The prefix for Bitcoin script hashes.
   */ scriptHash: 0x05,
    /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */ wif: 0x80
};
/**
 * Represents the regtest network configuration.
 */ module.exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
/**
 * Represents the testnet network configuration.
 */ module.exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};

});

parcelRegister("j87lX", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2tr = module.exports.p2wsh = module.exports.p2wpkh = module.exports.p2sh = module.exports.p2pkh = module.exports.p2pk = module.exports.p2ms = module.exports.embed = void 0;

var $bnRoL = parcelRequire("bnRoL");
Object.defineProperty(module.exports, "embed", {
    enumerable: true,
    get: function() {
        return $bnRoL.p2data;
    }
});

var $c9fEL = parcelRequire("c9fEL");
Object.defineProperty(module.exports, "p2ms", {
    enumerable: true,
    get: function() {
        return $c9fEL.p2ms;
    }
});

var $eSuia = parcelRequire("eSuia");
Object.defineProperty(module.exports, "p2pk", {
    enumerable: true,
    get: function() {
        return $eSuia.p2pk;
    }
});

var $jpa81 = parcelRequire("jpa81");
Object.defineProperty(module.exports, "p2pkh", {
    enumerable: true,
    get: function() {
        return $jpa81.p2pkh;
    }
});

var $4yk7Y = parcelRequire("4yk7Y");
Object.defineProperty(module.exports, "p2sh", {
    enumerable: true,
    get: function() {
        return $4yk7Y.p2sh;
    }
});

var $8P2rG = parcelRequire("8P2rG");
Object.defineProperty(module.exports, "p2wpkh", {
    enumerable: true,
    get: function() {
        return $8P2rG.p2wpkh;
    }
});

var $576Qs = parcelRequire("576Qs");
Object.defineProperty(module.exports, "p2wsh", {
    enumerable: true,
    get: function() {
        return $576Qs.p2wsh;
    }
});

var $bl5DO = parcelRequire("bl5DO");
Object.defineProperty(module.exports, "p2tr", {
    enumerable: true,
    get: function() {
        return $bl5DO.p2tr;
    }
}); // TODO
 // witness commitment

});
parcelRegister("bnRoL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2data = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $849b437e3769f84b$var$OPS = $8wAtk.OPS;
// output: OP_RETURN ...
/**
 * Embeds data in a Bitcoin payment.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The modified payment object.
 * @throws {TypeError} If there is not enough data or if the output is invalid.
 */ function $849b437e3769f84b$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        data: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "embed",
        network: network
    };
    $4v19v.prop(o, "output", ()=>{
        if (!a.data) return;
        return $8wAtk.compile([
            $849b437e3769f84b$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $4v19v.prop(o, "data", ()=>{
        if (!a.output) return;
        return $8wAtk.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $8wAtk.decompile(a.output);
            if (chunks[0] !== $849b437e3769f84b$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($18Mz5.typeforce.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !(0, $18Mz5.stacksEqual)(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2data = $849b437e3769f84b$var$p2data;

});
parcelRegister("8wAtk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $634d9a7855d2b99b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signature = module.exports.number = module.exports.isCanonicalScriptSignature = module.exports.isDefinedHashType = module.exports.isCanonicalPubKey = module.exports.toStack = module.exports.fromASM = module.exports.toASM = module.exports.decompile = module.exports.compile = module.exports.countNonPushOnlyOPs = module.exports.isPushOnly = module.exports.OPS = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $l0in9 = parcelRequire("l0in9");
Object.defineProperty(module.exports, "OPS", {
    enumerable: true,
    get: function() {
        return $l0in9.OPS;
    }
});

var $dX1I0 = parcelRequire("dX1I0");

var $1mhXk = parcelRequire("1mhXk");

var $loONM = parcelRequire("loONM");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $634d9a7855d2b99b$var$typeforce } = $18Mz5;
const $634d9a7855d2b99b$var$OP_INT_BASE = $l0in9.OPS.OP_RESERVED; // OP_1 - 1
function $634d9a7855d2b99b$var$isOPInt(value) {
    return $18Mz5.Number(value) && (value === $l0in9.OPS.OP_0 || value >= $l0in9.OPS.OP_1 && value <= $l0in9.OPS.OP_16 || value === $l0in9.OPS.OP_1NEGATE);
}
function $634d9a7855d2b99b$var$isPushOnlyChunk(value) {
    return $18Mz5.Buffer(value) || $634d9a7855d2b99b$var$isOPInt(value);
}
function $634d9a7855d2b99b$var$isPushOnly(value) {
    return $18Mz5.Array(value) && value.every($634d9a7855d2b99b$var$isPushOnlyChunk);
}
module.exports.isPushOnly = $634d9a7855d2b99b$var$isPushOnly;
function $634d9a7855d2b99b$var$countNonPushOnlyOPs(value) {
    return value.length - value.filter($634d9a7855d2b99b$var$isPushOnlyChunk).length;
}
module.exports.countNonPushOnlyOPs = $634d9a7855d2b99b$var$countNonPushOnlyOPs;
function $634d9a7855d2b99b$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $l0in9.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $634d9a7855d2b99b$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $l0in9.OPS.OP_1NEGATE;
}
function $634d9a7855d2b99b$var$chunksIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
function $634d9a7855d2b99b$var$chunksIsArray(buf) {
    return $18Mz5.Array(buf);
}
function $634d9a7855d2b99b$var$singleChunkIsBuffer(buf) {
    return $634d9a7855d2b99b$require$Buffer.isBuffer(buf);
}
/**
 * Compiles an array of chunks into a Buffer.
 *
 * @param chunks - The array of chunks to compile.
 * @returns The compiled Buffer.
 * @throws Error if the compilation fails.
 */ function $634d9a7855d2b99b$var$compile(chunks) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) return chunks;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $634d9a7855d2b99b$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $dX1I0.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $634d9a7855d2b99b$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $dX1I0.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
module.exports.compile = $634d9a7855d2b99b$var$compile;
function $634d9a7855d2b99b$var$decompile(buffer) {
    // TODO: remove me
    if ($634d9a7855d2b99b$var$chunksIsArray(buffer)) return buffer;
    $634d9a7855d2b99b$var$typeforce($18Mz5.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $l0in9.OPS.OP_0 && opcode <= $l0in9.OPS.OP_PUSHDATA4) {
            const d = $dX1I0.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $634d9a7855d2b99b$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
module.exports.decompile = $634d9a7855d2b99b$var$decompile;
/**
 * Converts the given chunks into an ASM (Assembly) string representation.
 * If the chunks parameter is a Buffer, it will be decompiled into a Stack before conversion.
 * @param chunks - The chunks to convert into ASM.
 * @returns The ASM string representation of the chunks.
 */ function $634d9a7855d2b99b$var$toASM(chunks) {
    if ($634d9a7855d2b99b$var$chunksIsBuffer(chunks)) chunks = $634d9a7855d2b99b$var$decompile(chunks);
    if (!chunks) throw new Error("Could not convert invalid chunks to ASM");
    return chunks.map((chunk)=>{
        // data?
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(chunk)) {
            const op = $634d9a7855d2b99b$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $l0in9.REVERSE_OPS[chunk];
    }).join(" ");
}
module.exports.toASM = $634d9a7855d2b99b$var$toASM;
/**
 * Converts an ASM string to a Buffer.
 * @param asm The ASM string to convert.
 * @returns The converted Buffer.
 */ function $634d9a7855d2b99b$var$fromASM(asm) {
    $634d9a7855d2b99b$var$typeforce($18Mz5.String, asm);
    return $634d9a7855d2b99b$var$compile(asm.split(" ").map((chunkStr)=>{
        // opcode?
        if ($l0in9.OPS[chunkStr] !== undefined) return $l0in9.OPS[chunkStr];
        $634d9a7855d2b99b$var$typeforce($18Mz5.Hex, chunkStr);
        // data!
        return $634d9a7855d2b99b$require$Buffer.from(chunkStr, "hex");
    }));
}
module.exports.fromASM = $634d9a7855d2b99b$var$fromASM;
/**
 * Converts the given chunks into a stack of buffers.
 *
 * @param chunks - The chunks to convert.
 * @returns The stack of buffers.
 */ function $634d9a7855d2b99b$var$toStack(chunks) {
    chunks = $634d9a7855d2b99b$var$decompile(chunks);
    $634d9a7855d2b99b$var$typeforce($634d9a7855d2b99b$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($634d9a7855d2b99b$var$singleChunkIsBuffer(op)) return op;
        if (op === $l0in9.OPS.OP_0) return $634d9a7855d2b99b$require$Buffer.allocUnsafe(0);
        return $1mhXk.encode(op - $634d9a7855d2b99b$var$OP_INT_BASE);
    });
}
module.exports.toStack = $634d9a7855d2b99b$var$toStack;
function $634d9a7855d2b99b$var$isCanonicalPubKey(buffer) {
    return $18Mz5.isPoint(buffer);
}
module.exports.isCanonicalPubKey = $634d9a7855d2b99b$var$isCanonicalPubKey;
function $634d9a7855d2b99b$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
module.exports.isDefinedHashType = $634d9a7855d2b99b$var$isDefinedHashType;
function $634d9a7855d2b99b$var$isCanonicalScriptSignature(buffer) {
    if (!$634d9a7855d2b99b$require$Buffer.isBuffer(buffer)) return false;
    if (!$634d9a7855d2b99b$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $gDdvx.check(buffer.slice(0, -1));
}
module.exports.isCanonicalScriptSignature = $634d9a7855d2b99b$var$isCanonicalScriptSignature;
module.exports.number = $1mhXk;
module.exports.signature = $loONM;

});
parcelRegister("gDdvx", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c1bac437d9c5804f$require$Buffer = $6ZWSX.Buffer;
"use strict";
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = module.exports.check = void 0;
function $c1bac437d9c5804f$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    const lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    const lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
module.exports.check = $c1bac437d9c5804f$var$check;
function $c1bac437d9c5804f$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    const lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    const lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
module.exports.decode = $c1bac437d9c5804f$var$decode;
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
 */ function $c1bac437d9c5804f$var$encode(r, s) {
    const lenR = r.length;
    const lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    const signature = $c1bac437d9c5804f$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
module.exports.encode = $c1bac437d9c5804f$var$encode;

});

parcelRegister("l0in9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.REVERSE_OPS = module.exports.OPS = void 0;
const $f4a7d973a6629c90$var$OPS = {
    OP_FALSE: 0,
    OP_0: 0,
    OP_PUSHDATA1: 76,
    OP_PUSHDATA2: 77,
    OP_PUSHDATA4: 78,
    OP_1NEGATE: 79,
    OP_RESERVED: 80,
    OP_TRUE: 81,
    OP_1: 81,
    OP_2: 82,
    OP_3: 83,
    OP_4: 84,
    OP_5: 85,
    OP_6: 86,
    OP_7: 87,
    OP_8: 88,
    OP_9: 89,
    OP_10: 90,
    OP_11: 91,
    OP_12: 92,
    OP_13: 93,
    OP_14: 94,
    OP_15: 95,
    OP_16: 96,
    OP_NOP: 97,
    OP_VER: 98,
    OP_IF: 99,
    OP_NOTIF: 100,
    OP_VERIF: 101,
    OP_VERNOTIF: 102,
    OP_ELSE: 103,
    OP_ENDIF: 104,
    OP_VERIFY: 105,
    OP_RETURN: 106,
    OP_TOALTSTACK: 107,
    OP_FROMALTSTACK: 108,
    OP_2DROP: 109,
    OP_2DUP: 110,
    OP_3DUP: 111,
    OP_2OVER: 112,
    OP_2ROT: 113,
    OP_2SWAP: 114,
    OP_IFDUP: 115,
    OP_DEPTH: 116,
    OP_DROP: 117,
    OP_DUP: 118,
    OP_NIP: 119,
    OP_OVER: 120,
    OP_PICK: 121,
    OP_ROLL: 122,
    OP_ROT: 123,
    OP_SWAP: 124,
    OP_TUCK: 125,
    OP_CAT: 126,
    OP_SUBSTR: 127,
    OP_LEFT: 128,
    OP_RIGHT: 129,
    OP_SIZE: 130,
    OP_INVERT: 131,
    OP_AND: 132,
    OP_OR: 133,
    OP_XOR: 134,
    OP_EQUAL: 135,
    OP_EQUALVERIFY: 136,
    OP_RESERVED1: 137,
    OP_RESERVED2: 138,
    OP_1ADD: 139,
    OP_1SUB: 140,
    OP_2MUL: 141,
    OP_2DIV: 142,
    OP_NEGATE: 143,
    OP_ABS: 144,
    OP_NOT: 145,
    OP_0NOTEQUAL: 146,
    OP_ADD: 147,
    OP_SUB: 148,
    OP_MUL: 149,
    OP_DIV: 150,
    OP_MOD: 151,
    OP_LSHIFT: 152,
    OP_RSHIFT: 153,
    OP_BOOLAND: 154,
    OP_BOOLOR: 155,
    OP_NUMEQUAL: 156,
    OP_NUMEQUALVERIFY: 157,
    OP_NUMNOTEQUAL: 158,
    OP_LESSTHAN: 159,
    OP_GREATERTHAN: 160,
    OP_LESSTHANOREQUAL: 161,
    OP_GREATERTHANOREQUAL: 162,
    OP_MIN: 163,
    OP_MAX: 164,
    OP_WITHIN: 165,
    OP_RIPEMD160: 166,
    OP_SHA1: 167,
    OP_SHA256: 168,
    OP_HASH160: 169,
    OP_HASH256: 170,
    OP_CODESEPARATOR: 171,
    OP_CHECKSIG: 172,
    OP_CHECKSIGVERIFY: 173,
    OP_CHECKMULTISIG: 174,
    OP_CHECKMULTISIGVERIFY: 175,
    OP_NOP1: 176,
    OP_NOP2: 177,
    OP_CHECKLOCKTIMEVERIFY: 177,
    OP_NOP3: 178,
    OP_CHECKSEQUENCEVERIFY: 178,
    OP_NOP4: 179,
    OP_NOP5: 180,
    OP_NOP6: 181,
    OP_NOP7: 182,
    OP_NOP8: 183,
    OP_NOP9: 184,
    OP_NOP10: 185,
    OP_CHECKSIGADD: 186,
    OP_PUBKEYHASH: 253,
    OP_PUBKEY: 254,
    OP_INVALIDOPCODE: 255
};
module.exports.OPS = $f4a7d973a6629c90$var$OPS;
const $f4a7d973a6629c90$var$REVERSE_OPS = {};
module.exports.REVERSE_OPS = $f4a7d973a6629c90$var$REVERSE_OPS;
for (const op of Object.keys($f4a7d973a6629c90$var$OPS)){
    const code = $f4a7d973a6629c90$var$OPS[op];
    $f4a7d973a6629c90$var$REVERSE_OPS[code] = op;
}

});

parcelRegister("dX1I0", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.decode = module.exports.encode = module.exports.encodingLength = void 0;

var $l0in9 = parcelRequire("l0in9");
/**
 * Calculates the encoding length of a number used for push data in Bitcoin transactions.
 * @param i The number to calculate the encoding length for.
 * @returns The encoding length of the number.
 */ function $a2821c5ffe705947$var$encodingLength(i) {
    return i < $l0in9.OPS.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
module.exports.encodingLength = $a2821c5ffe705947$var$encodingLength;
/**
 * Encodes a number into a buffer using a variable-length encoding scheme.
 * The encoded buffer is written starting at the specified offset.
 * Returns the size of the encoded buffer.
 *
 * @param buffer - The buffer to write the encoded data into.
 * @param num - The number to encode.
 * @param offset - The offset at which to start writing the encoded buffer.
 * @returns The size of the encoded buffer.
 */ function $a2821c5ffe705947$var$encode(buffer, num, offset) {
    const size = $a2821c5ffe705947$var$encodingLength(num);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(num, offset);
    else if (size === 2) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA1, offset);
        buffer.writeUInt8(num, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(num, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($l0in9.OPS.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(num, offset + 1);
    }
    return size;
}
module.exports.encode = $a2821c5ffe705947$var$encode;
/**
 * Decodes a buffer and returns information about the opcode, number, and size.
 * @param buffer - The buffer to decode.
 * @param offset - The offset within the buffer to start decoding.
 * @returns An object containing the opcode, number, and size, or null if decoding fails.
 */ function $a2821c5ffe705947$var$decode(buffer, offset) {
    const opcode = buffer.readUInt8(offset);
    let num;
    let size;
    // ~6 bit
    if (opcode < $l0in9.OPS.OP_PUSHDATA1) {
        num = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        num = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $l0in9.OPS.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        num = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $l0in9.OPS.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        num = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: num,
        size: size
    };
}
module.exports.decode = $a2821c5ffe705947$var$decode;

});

parcelRegister("1mhXk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $0fd5c63598aa1719$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = void 0;
/**
 * Decodes a script number from a buffer.
 *
 * @param buffer - The buffer containing the script number.
 * @param maxLength - The maximum length of the script number. Defaults to 4.
 * @param minimal - Whether the script number should be minimal. Defaults to true.
 * @returns The decoded script number.
 * @throws {TypeError} If the script number overflows the maximum length.
 * @throws {Error} If the script number is not minimally encoded when minimal is true.
 */ function $0fd5c63598aa1719$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
module.exports.decode = $0fd5c63598aa1719$var$decode;
function $0fd5c63598aa1719$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
/**
 * Encodes a number into a Buffer using a specific format.
 *
 * @param _number - The number to encode.
 * @returns The encoded number as a Buffer.
 */ function $0fd5c63598aa1719$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $0fd5c63598aa1719$var$scriptNumSize(value);
    const buffer = $0fd5c63598aa1719$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
module.exports.encode = $0fd5c63598aa1719$var$encode;

});

parcelRegister("loONM", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f9433f0a843bc51f$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.encode = module.exports.decode = void 0;

var $gDdvx = parcelRequire("gDdvx");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $f9433f0a843bc51f$var$typeforce } = $18Mz5;
const $f9433f0a843bc51f$var$ZERO = $f9433f0a843bc51f$require$Buffer.alloc(1, 0);
/**
 * Converts a buffer to a DER-encoded buffer.
 * @param x - The buffer to be converted.
 * @returns The DER-encoded buffer.
 */ function $f9433f0a843bc51f$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $f9433f0a843bc51f$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $f9433f0a843bc51f$require$Buffer.concat([
        $f9433f0a843bc51f$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
/**
 * Converts a DER-encoded signature to a buffer.
 * If the first byte of the input buffer is 0x00, it is skipped.
 * The resulting buffer is 32 bytes long, filled with zeros if necessary.
 * @param x - The DER-encoded signature.
 * @returns The converted buffer.
 */ function $f9433f0a843bc51f$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $f9433f0a843bc51f$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
/**
 * Decodes a buffer into a ScriptSignature object.
 * @param buffer - The buffer to decode.
 * @returns The decoded ScriptSignature object.
 * @throws Error if the hashType is invalid.
 */ function $f9433f0a843bc51f$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    if (!(0, $8wAtk.isDefinedHashType)(hashType)) throw new Error("Invalid hashType " + hashType);
    const decoded = $gDdvx.decode(buffer.slice(0, -1));
    const r = $f9433f0a843bc51f$var$fromDER(decoded.r);
    const s = $f9433f0a843bc51f$var$fromDER(decoded.s);
    const signature = $f9433f0a843bc51f$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
module.exports.decode = $f9433f0a843bc51f$var$decode;
/**
 * Encodes a signature and hash type into a buffer.
 * @param signature - The signature to encode.
 * @param hashType - The hash type to encode.
 * @returns The encoded buffer.
 * @throws Error if the hashType is invalid.
 */ function $f9433f0a843bc51f$var$encode(signature, hashType) {
    $f9433f0a843bc51f$var$typeforce({
        signature: $18Mz5.BufferN(64),
        hashType: $18Mz5.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    if (!(0, $8wAtk.isDefinedHashType)(hashType)) throw new Error("Invalid hashType " + hashType);
    const hashTypeBuffer = $f9433f0a843bc51f$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $f9433f0a843bc51f$var$toDER(signature.slice(0, 32));
    const s = $f9433f0a843bc51f$var$toDER(signature.slice(32, 64));
    return $f9433f0a843bc51f$require$Buffer.concat([
        $gDdvx.encode(r, s),
        hashTypeBuffer
    ]);
}
module.exports.encode = $f9433f0a843bc51f$var$encode;

});
parcelRegister("18Mz5", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.oneOf = module.exports.Null = module.exports.BufferN = module.exports.Function = module.exports.UInt32 = module.exports.UInt8 = module.exports.tuple = module.exports.maybe = module.exports.Hex = module.exports.Buffer = module.exports.String = module.exports.Boolean = module.exports.Array = module.exports.Number = module.exports.Hash256bit = module.exports.Hash160bit = module.exports.Buffer256bit = module.exports.isTaptree = module.exports.isTapleaf = module.exports.TAPLEAF_VERSION_MASK = module.exports.Satoshi = module.exports.isPoint = module.exports.stacksEqual = module.exports.typeforce = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

module.exports.typeforce = (parcelRequire("lYlyf"));
const $0d4c35ca8ad6fd29$var$ZERO32 = $6ZWSX.Buffer.alloc(32, 0);
const $0d4c35ca8ad6fd29$var$EC_P = $6ZWSX.Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
/**
 * Checks if two arrays of Buffers are equal.
 * @param a - The first array of Buffers.
 * @param b - The second array of Buffers.
 * @returns True if the arrays are equal, false otherwise.
 */ function $0d4c35ca8ad6fd29$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
module.exports.stacksEqual = $0d4c35ca8ad6fd29$var$stacksEqual;
/**
 * Checks if the given value is a valid elliptic curve point.
 * @param p - The value to check.
 * @returns True if the value is a valid elliptic curve point, false otherwise.
 */ function $0d4c35ca8ad6fd29$var$isPoint(p) {
    if (!$6ZWSX.Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (x.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) return true;
    const y = p.slice(33);
    if (y.compare($0d4c35ca8ad6fd29$var$ZERO32) === 0) return false;
    if (y.compare($0d4c35ca8ad6fd29$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
module.exports.isPoint = $0d4c35ca8ad6fd29$var$isPoint;
const $0d4c35ca8ad6fd29$var$SATOSHI_MAX = 21 * 1e14;
function $0d4c35ca8ad6fd29$var$Satoshi(value) {
    return module.exports.typeforce.UInt53(value) && value <= $0d4c35ca8ad6fd29$var$SATOSHI_MAX;
}
module.exports.Satoshi = $0d4c35ca8ad6fd29$var$Satoshi;
module.exports.TAPLEAF_VERSION_MASK = 0xfe;
function $0d4c35ca8ad6fd29$var$isTapleaf(o) {
    if (!o || !("output" in o)) return false;
    if (!$6ZWSX.Buffer.isBuffer(o.output)) return false;
    if (o.version !== undefined) return (o.version & module.exports.TAPLEAF_VERSION_MASK) === o.version;
    return true;
}
module.exports.isTapleaf = $0d4c35ca8ad6fd29$var$isTapleaf;
function $0d4c35ca8ad6fd29$var$isTaptree(scriptTree) {
    if (!(0, module.exports.Array)(scriptTree)) return $0d4c35ca8ad6fd29$var$isTapleaf(scriptTree);
    if (scriptTree.length !== 2) return false;
    return scriptTree.every((t)=>$0d4c35ca8ad6fd29$var$isTaptree(t));
}
module.exports.isTaptree = $0d4c35ca8ad6fd29$var$isTaptree;
module.exports.Buffer256bit = module.exports.typeforce.BufferN(32);
module.exports.Hash160bit = module.exports.typeforce.BufferN(20);
module.exports.Hash256bit = module.exports.typeforce.BufferN(32);
module.exports.Number = module.exports.typeforce.Number;
module.exports.Array = module.exports.typeforce.Array;
module.exports.Boolean = module.exports.typeforce.Boolean;
module.exports.String = module.exports.typeforce.String;
module.exports.Buffer = module.exports.typeforce.Buffer;
module.exports.Hex = module.exports.typeforce.Hex;
module.exports.maybe = module.exports.typeforce.maybe;
module.exports.tuple = module.exports.typeforce.tuple;
module.exports.UInt8 = module.exports.typeforce.UInt8;
module.exports.UInt32 = module.exports.typeforce.UInt32;
module.exports.Function = module.exports.typeforce.Function;
module.exports.BufferN = module.exports.typeforce.BufferN;
module.exports.Null = module.exports.typeforce.Null;
module.exports.oneOf = module.exports.typeforce.oneOf;

});
parcelRegister("lYlyf", function(module, exports) {

var $akIbT = parcelRequire("akIbT");

var $heKts = parcelRequire("heKts");
// short-hand
var $ffefeb359bffb323$var$tfJSON = $akIbT.tfJSON;
var $ffefeb359bffb323$var$TfTypeError = $akIbT.TfTypeError;
var $ffefeb359bffb323$var$TfPropertyTypeError = $akIbT.TfPropertyTypeError;
var $ffefeb359bffb323$var$tfSubError = $akIbT.tfSubError;
var $ffefeb359bffb323$var$getValueTypeName = $akIbT.getValueTypeName;
var $ffefeb359bffb323$var$TYPES = {
    arrayOf: function arrayOf(type, options) {
        type = $ffefeb359bffb323$var$compile(type);
        options = options || {};
        function _arrayOf(array, strict) {
            if (!$heKts.Array(array)) return false;
            if ($heKts.Nil(array)) return false;
            if (options.minLength !== undefined && array.length < options.minLength) return false;
            if (options.maxLength !== undefined && array.length > options.maxLength) return false;
            if (options.length !== undefined && array.length !== options.length) return false;
            return array.every(function(value, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _arrayOf.toJSON = function() {
            var str = "[" + $ffefeb359bffb323$var$tfJSON(type) + "]";
            if (options.length !== undefined) str += "{" + options.length + "}";
            else if (options.minLength !== undefined || options.maxLength !== undefined) str += "{" + (options.minLength === undefined ? 0 : options.minLength) + "," + (options.maxLength === undefined ? Infinity : options.maxLength) + "}";
            return str;
        };
        return _arrayOf;
    },
    maybe: function maybe(type) {
        type = $ffefeb359bffb323$var$compile(type);
        function _maybe(value, strict) {
            return $heKts.Nil(value) || type(value, strict, maybe);
        }
        _maybe.toJSON = function() {
            return "?" + $ffefeb359bffb323$var$tfJSON(type);
        };
        return _maybe;
    },
    map: function map(propertyType, propertyKeyType) {
        propertyType = $ffefeb359bffb323$var$compile(propertyType);
        if (propertyKeyType) propertyKeyType = $ffefeb359bffb323$var$compile(propertyKeyType);
        function _map(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            for(var propertyName in value){
                try {
                    if (propertyKeyType) $ffefeb359bffb323$var$typeforce(propertyKeyType, propertyName, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName, "key");
                }
                try {
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
                }
            }
            return true;
        }
        if (propertyKeyType) _map.toJSON = function() {
            return "{" + $ffefeb359bffb323$var$tfJSON(propertyKeyType) + ": " + $ffefeb359bffb323$var$tfJSON(propertyType) + "}";
        };
        else _map.toJSON = function() {
            return "{" + $ffefeb359bffb323$var$tfJSON(propertyType) + "}";
        };
        return _map;
    },
    object: function object(uncompiled) {
        var type = {};
        for(var typePropertyName in uncompiled)type[typePropertyName] = $ffefeb359bffb323$var$compile(uncompiled[typePropertyName]);
        function _object(value, strict) {
            if (!$heKts.Object(value)) return false;
            if ($heKts.Nil(value)) return false;
            var propertyName;
            try {
                for(propertyName in type){
                    var propertyType = type[propertyName];
                    var propertyValue = value[propertyName];
                    $ffefeb359bffb323$var$typeforce(propertyType, propertyValue, strict);
                }
            } catch (e) {
                throw $ffefeb359bffb323$var$tfSubError(e, propertyName);
            }
            if (strict) for(propertyName in value){
                if (type[propertyName]) continue;
                throw new $ffefeb359bffb323$var$TfPropertyTypeError(undefined, propertyName);
            }
            return true;
        }
        _object.toJSON = function() {
            return $ffefeb359bffb323$var$tfJSON(type);
        };
        return _object;
    },
    anyOf: function anyOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _anyOf(value, strict) {
            return types.some(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _anyOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join("|");
        };
        return _anyOf;
    },
    allOf: function allOf() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _allOf(value, strict) {
            return types.every(function(type) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, value, strict);
                } catch (e) {
                    return false;
                }
            });
        }
        _allOf.toJSON = function() {
            return types.map($ffefeb359bffb323$var$tfJSON).join(" & ");
        };
        return _allOf;
    },
    quacksLike: function quacksLike(type) {
        function _quacksLike(value) {
            return type === $ffefeb359bffb323$var$getValueTypeName(value);
        }
        _quacksLike.toJSON = function() {
            return type;
        };
        return _quacksLike;
    },
    tuple: function tuple() {
        var types = [].slice.call(arguments).map($ffefeb359bffb323$var$compile);
        function _tuple(values, strict) {
            if ($heKts.Nil(values)) return false;
            if ($heKts.Nil(values.length)) return false;
            if (strict && values.length !== types.length) return false;
            return types.every(function(type, i) {
                try {
                    return $ffefeb359bffb323$var$typeforce(type, values[i], strict);
                } catch (e) {
                    throw $ffefeb359bffb323$var$tfSubError(e, i);
                }
            });
        }
        _tuple.toJSON = function() {
            return "(" + types.map($ffefeb359bffb323$var$tfJSON).join(", ") + ")";
        };
        return _tuple;
    },
    value: function value(expected) {
        function _value(actual) {
            return actual === expected;
        }
        _value.toJSON = function() {
            return expected;
        };
        return _value;
    }
};
// TODO: deprecate
$ffefeb359bffb323$var$TYPES.oneOf = $ffefeb359bffb323$var$TYPES.anyOf;
function $ffefeb359bffb323$var$compile(type) {
    if ($heKts.String(type)) {
        if (type[0] === "?") return $ffefeb359bffb323$var$TYPES.maybe(type.slice(1));
        return $heKts[type] || $ffefeb359bffb323$var$TYPES.quacksLike(type);
    } else if (type && $heKts.Object(type)) {
        if ($heKts.Array(type)) {
            if (type.length !== 1) throw new TypeError("Expected compile() parameter of type Array of length 1");
            return $ffefeb359bffb323$var$TYPES.arrayOf(type[0]);
        }
        return $ffefeb359bffb323$var$TYPES.object(type);
    } else if ($heKts.Function(type)) return type;
    return $ffefeb359bffb323$var$TYPES.value(type);
}
function $ffefeb359bffb323$var$typeforce(type, value, strict, surrogate) {
    if ($heKts.Function(type)) {
        if (type(value, strict)) return true;
        throw new $ffefeb359bffb323$var$TfTypeError(surrogate || type, value);
    }
    // JIT
    return $ffefeb359bffb323$var$typeforce($ffefeb359bffb323$var$compile(type), value, strict);
}
// assign types to typeforce function
for(var $ffefeb359bffb323$var$typeName in $heKts)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $heKts[$ffefeb359bffb323$var$typeName];
for($ffefeb359bffb323$var$typeName in $ffefeb359bffb323$var$TYPES)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $ffefeb359bffb323$var$TYPES[$ffefeb359bffb323$var$typeName];

var $8tZX5 = parcelRequire("8tZX5");
for($ffefeb359bffb323$var$typeName in $8tZX5)$ffefeb359bffb323$var$typeforce[$ffefeb359bffb323$var$typeName] = $8tZX5[$ffefeb359bffb323$var$typeName];
$ffefeb359bffb323$var$typeforce.compile = $ffefeb359bffb323$var$compile;
$ffefeb359bffb323$var$typeforce.TfTypeError = $ffefeb359bffb323$var$TfTypeError;
$ffefeb359bffb323$var$typeforce.TfPropertyTypeError = $ffefeb359bffb323$var$TfPropertyTypeError;
module.exports = $ffefeb359bffb323$var$typeforce;

});
parcelRegister("akIbT", function(module, exports) {

var $heKts = parcelRequire("heKts");
function $785e0cfecbfb7b1d$var$getTypeName(fn) {
    return fn.name || fn.toString().match(/function (.*?)\s*\(/)[1];
}
function $785e0cfecbfb7b1d$var$getValueTypeName(value) {
    return $heKts.Nil(value) ? "" : $785e0cfecbfb7b1d$var$getTypeName(value.constructor);
}
function $785e0cfecbfb7b1d$var$getValue(value) {
    if ($heKts.Function(value)) return "";
    if ($heKts.String(value)) return JSON.stringify(value);
    if (value && $heKts.Object(value)) return "";
    return value;
}
function $785e0cfecbfb7b1d$var$captureStackTrace(e, t) {
    if (Error.captureStackTrace) Error.captureStackTrace(e, t);
}
function $785e0cfecbfb7b1d$var$tfJSON(type) {
    if ($heKts.Function(type)) return type.toJSON ? type.toJSON() : $785e0cfecbfb7b1d$var$getTypeName(type);
    if ($heKts.Array(type)) return "Array";
    if (type && $heKts.Object(type)) return "Object";
    return type !== undefined ? type : "";
}
function $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName) {
    var valueJson = $785e0cfecbfb7b1d$var$getValue(value);
    return "Expected " + $785e0cfecbfb7b1d$var$tfJSON(type) + ", got" + (valueTypeName !== "" ? " " + valueTypeName : "") + (valueJson !== "" ? " " + valueJson : "");
}
function $785e0cfecbfb7b1d$var$TfTypeError(type, value, valueTypeName) {
    valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
    this.message = $785e0cfecbfb7b1d$var$tfErrorString(type, value, valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, name, value, valueTypeName) {
    var description = '" of type ';
    if (label === "key") description = '" with key type ';
    return $785e0cfecbfb7b1d$var$tfErrorString('property "' + $785e0cfecbfb7b1d$var$tfJSON(name) + description + $785e0cfecbfb7b1d$var$tfJSON(type), value, valueTypeName);
}
function $785e0cfecbfb7b1d$var$TfPropertyTypeError(type, property, label, value, valueTypeName) {
    if (type) {
        valueTypeName = valueTypeName || $785e0cfecbfb7b1d$var$getValueTypeName(value);
        this.message = $785e0cfecbfb7b1d$var$tfPropertyErrorString(type, label, property, value, valueTypeName);
    } else this.message = 'Unexpected property "' + property + '"';
    $785e0cfecbfb7b1d$var$captureStackTrace(this, $785e0cfecbfb7b1d$var$TfTypeError);
    this.__label = label;
    this.__property = property;
    this.__type = type;
    this.__value = value;
    this.__valueTypeName = valueTypeName;
}
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype = Object.create(Error.prototype);
$785e0cfecbfb7b1d$var$TfPropertyTypeError.prototype.constructor = $785e0cfecbfb7b1d$var$TfTypeError;
function $785e0cfecbfb7b1d$var$tfCustomError(expected, actual) {
    return new $785e0cfecbfb7b1d$var$TfTypeError(expected, {}, actual);
}
function $785e0cfecbfb7b1d$var$tfSubError(e, property, label) {
    // sub child?
    if (e instanceof $785e0cfecbfb7b1d$var$TfPropertyTypeError) {
        property = property + "." + e.__property;
        e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, e.__label, e.__value, e.__valueTypeName);
    // child?
    } else if (e instanceof $785e0cfecbfb7b1d$var$TfTypeError) e = new $785e0cfecbfb7b1d$var$TfPropertyTypeError(e.__type, property, label, e.__value, e.__valueTypeName);
    $785e0cfecbfb7b1d$var$captureStackTrace(e);
    return e;
}
module.exports = {
    TfTypeError: $785e0cfecbfb7b1d$var$TfTypeError,
    TfPropertyTypeError: $785e0cfecbfb7b1d$var$TfPropertyTypeError,
    tfCustomError: $785e0cfecbfb7b1d$var$tfCustomError,
    tfSubError: $785e0cfecbfb7b1d$var$tfSubError,
    tfJSON: $785e0cfecbfb7b1d$var$tfJSON,
    getValueTypeName: $785e0cfecbfb7b1d$var$getValueTypeName
};

});
parcelRegister("heKts", function(module, exports) {
var $c8c7cb41b203218a$var$types = {
    Array: function(value) {
        return value !== null && value !== undefined && value.constructor === Array;
    },
    Boolean: function(value) {
        return typeof value === "boolean";
    },
    Function: function(value) {
        return typeof value === "function";
    },
    Nil: function(value) {
        return value === undefined || value === null;
    },
    Number: function(value) {
        return typeof value === "number";
    },
    Object: function(value) {
        return typeof value === "object";
    },
    String: function(value) {
        return typeof value === "string";
    },
    "": function() {
        return true;
    }
};
// TODO: deprecate
$c8c7cb41b203218a$var$types.Null = $c8c7cb41b203218a$var$types.Nil;
for(var $c8c7cb41b203218a$var$typeName in $c8c7cb41b203218a$var$types)$c8c7cb41b203218a$var$types[$c8c7cb41b203218a$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $c8c7cb41b203218a$var$typeName);
module.exports = $c8c7cb41b203218a$var$types;

});


parcelRegister("8tZX5", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $62d11690565d87ea$require$Buffer = $6ZWSX.Buffer;

var $heKts = parcelRequire("heKts");

var $akIbT = parcelRequire("akIbT");
function $62d11690565d87ea$var$_Buffer(value) {
    return $62d11690565d87ea$require$Buffer.isBuffer(value);
}
function $62d11690565d87ea$var$Hex(value) {
    return typeof value === "string" && /^([0-9a-f]{2})+$/i.test(value);
}
function $62d11690565d87ea$var$_LengthN(type, length) {
    var name = type.toJSON();
    function Length(value) {
        if (!type(value)) return false;
        if (value.length === length) return true;
        throw $akIbT.tfCustomError(name + "(Length: " + length + ")", name + "(Length: " + value.length + ")");
    }
    Length.toJSON = function() {
        return name;
    };
    return Length;
}
var $62d11690565d87ea$var$_ArrayN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.Array);
var $62d11690565d87ea$var$_BufferN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$_Buffer);
var $62d11690565d87ea$var$_HexN = $62d11690565d87ea$var$_LengthN.bind(null, $62d11690565d87ea$var$Hex);
var $62d11690565d87ea$var$_StringN = $62d11690565d87ea$var$_LengthN.bind(null, $heKts.String);
function $62d11690565d87ea$var$Range(a, b, f) {
    f = f || $heKts.Number;
    function _range(value, strict) {
        return f(value, strict) && value > a && value < b;
    }
    _range.toJSON = function() {
        return `${f.toJSON()} between [${a}, ${b}]`;
    };
    return _range;
}
var $62d11690565d87ea$var$INT53_MAX = Math.pow(2, 53) - 1;
function $62d11690565d87ea$var$Finite(value) {
    return typeof value === "number" && isFinite(value);
}
function $62d11690565d87ea$var$Int8(value) {
    return value << 24 >> 24 === value;
}
function $62d11690565d87ea$var$Int16(value) {
    return value << 16 >> 16 === value;
}
function $62d11690565d87ea$var$Int32(value) {
    return (value | 0) === value;
}
function $62d11690565d87ea$var$Int53(value) {
    return typeof value === "number" && value >= -$62d11690565d87ea$var$INT53_MAX && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
function $62d11690565d87ea$var$UInt8(value) {
    return (value & 0xff) === value;
}
function $62d11690565d87ea$var$UInt16(value) {
    return (value & 0xffff) === value;
}
function $62d11690565d87ea$var$UInt32(value) {
    return value >>> 0 === value;
}
function $62d11690565d87ea$var$UInt53(value) {
    return typeof value === "number" && value >= 0 && value <= $62d11690565d87ea$var$INT53_MAX && Math.floor(value) === value;
}
var $62d11690565d87ea$var$types = {
    ArrayN: $62d11690565d87ea$var$_ArrayN,
    Buffer: $62d11690565d87ea$var$_Buffer,
    BufferN: $62d11690565d87ea$var$_BufferN,
    Finite: $62d11690565d87ea$var$Finite,
    Hex: $62d11690565d87ea$var$Hex,
    HexN: $62d11690565d87ea$var$_HexN,
    Int8: $62d11690565d87ea$var$Int8,
    Int16: $62d11690565d87ea$var$Int16,
    Int32: $62d11690565d87ea$var$Int32,
    Int53: $62d11690565d87ea$var$Int53,
    Range: $62d11690565d87ea$var$Range,
    StringN: $62d11690565d87ea$var$_StringN,
    UInt8: $62d11690565d87ea$var$UInt8,
    UInt16: $62d11690565d87ea$var$UInt16,
    UInt32: $62d11690565d87ea$var$UInt32,
    UInt53: $62d11690565d87ea$var$UInt53
};
for(var $62d11690565d87ea$var$typeName in $62d11690565d87ea$var$types)$62d11690565d87ea$var$types[$62d11690565d87ea$var$typeName].toJSON = (function(t) {
    return t;
}).bind(null, $62d11690565d87ea$var$typeName);
module.exports = $62d11690565d87ea$var$types;

});





parcelRegister("4v19v", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.value = module.exports.prop = void 0;
function $346af381949c93ee$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
module.exports.prop = $346af381949c93ee$var$prop;
function $346af381949c93ee$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
module.exports.value = $346af381949c93ee$var$value;

});


parcelRegister("c9fEL", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2ms = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $8d82785ca490385e$var$OPS = $8wAtk.OPS;
const $8d82785ca490385e$var$OP_INT_BASE = $8d82785ca490385e$var$OPS.OP_RESERVED; // OP_1 - 1
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
/**
 * Represents a function that creates a Pay-to-Multisig (P2MS) payment object.
 * @param a - The payment object.
 * @param opts - Optional payment options.
 * @returns The created payment object.
 * @throws {TypeError} If the provided data is not valid.
 */ function $8d82785ca490385e$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $8wAtk.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $8d82785ca490385e$var$OPS.OP_0) !== undefined;
    }
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        m: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        n: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkeys: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.isPoint)),
        signatures: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf(isAcceptableSignature)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $8wAtk.decompile(output);
        o.m = chunks[0] - $8d82785ca490385e$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $8d82785ca490385e$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $4v19v.prop(o, "output", ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $8wAtk.compile([].concat($8d82785ca490385e$var$OP_INT_BASE + a.m, a.pubkeys, $8d82785ca490385e$var$OP_INT_BASE + o.n, $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG));
    });
    $4v19v.prop(o, "m", ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $4v19v.prop(o, "n", ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $4v19v.prop(o, "pubkeys", ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $4v19v.prop(o, "signatures", ()=>{
        if (!a.input) return;
        return $8wAtk.decompile(a.input).slice(1);
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.signatures) return;
        return $8wAtk.compile([
            $8d82785ca490385e$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    $4v19v.prop(o, "name", ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$18Mz5.typeforce.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$18Mz5.typeforce.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $8d82785ca490385e$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every((x)=>(0, $18Mz5.isPoint)(x))) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !(0, $18Mz5.stacksEqual)(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $8d82785ca490385e$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !(0, $18Mz5.stacksEqual)(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2ms = $8d82785ca490385e$var$p2ms;

});

parcelRegister("eSuia", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2pk = void 0;

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");
const $ad4d9b2ec8e5b9d4$var$OPS = $8wAtk.OPS;
// input: {signature}
// output: {pubKey} OP_CHECKSIG
/**
 * Creates a pay-to-public-key (P2PK) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PK payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $ad4d9b2ec8e5b9d4$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2pk",
        network: network
    };
    $4v19v.prop(o, "output", ()=>{
        if (!a.pubkey) return;
        return $8wAtk.compile([
            a.pubkey,
            $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature
        ]);
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $ad4d9b2ec8e5b9d4$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!(0, $18Mz5.isPoint)(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pk = $ad4d9b2ec8e5b9d4$var$p2pk;

});

parcelRegister("jpa81", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e20835639c8773b0$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2pkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $wjgZX = parcelRequire("wjgZX");
const $e20835639c8773b0$var$OPS = $8wAtk.OPS;
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
/**
 * Creates a Pay-to-Public-Key-Hash (P2PKH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2PKH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $e20835639c8773b0$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(25)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer)
    }, a);
    const _address = $4v19v.value(()=>{
        const payload = $e20835639c8773b0$require$Buffer.from($wjgZX.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2pkh",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $e20835639c8773b0$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $wjgZX.encode(payload);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $e20835639c8773b0$var$OPS.OP_DUP,
            $e20835639c8773b0$var$OPS.OP_HASH160,
            o.hash,
            $e20835639c8773b0$var$OPS.OP_EQUALVERIFY,
            $e20835639c8773b0$var$OPS.OP_CHECKSIG
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $8wAtk.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $e20835639c8773b0$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $e20835639c8773b0$var$OPS.OP_DUP || a.output[1] !== $e20835639c8773b0$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $e20835639c8773b0$var$OPS.OP_EQUALVERIFY || a.output[24] !== $e20835639c8773b0$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!(0, $18Mz5.isPoint)(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $lgTFk.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2pkh = $e20835639c8773b0$var$p2pkh;

});
parcelRegister("lgTFk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f7c6459ce559cfe9$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.taggedHash = module.exports.TAGGED_HASH_PREFIXES = module.exports.TAGS = module.exports.hash256 = module.exports.hash160 = module.exports.sha256 = module.exports.sha1 = module.exports.ripemd160 = void 0;

var $j5xzM = parcelRequire("j5xzM");

var $dGR9X = parcelRequire("dGR9X");

var $6XnWx = parcelRequire("6XnWx");
function $f7c6459ce559cfe9$var$ripemd160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)(Uint8Array.from(buffer)));
}
module.exports.ripemd160 = $f7c6459ce559cfe9$var$ripemd160;
function $f7c6459ce559cfe9$var$sha1(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $dGR9X.sha1)(Uint8Array.from(buffer)));
}
module.exports.sha1 = $f7c6459ce559cfe9$var$sha1;
function $f7c6459ce559cfe9$var$sha256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)(Uint8Array.from(buffer)));
}
module.exports.sha256 = $f7c6459ce559cfe9$var$sha256;
function $f7c6459ce559cfe9$var$hash160(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $j5xzM.ripemd160)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash160 = $f7c6459ce559cfe9$var$hash160;
function $f7c6459ce559cfe9$var$hash256(buffer) {
    return $f7c6459ce559cfe9$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)(Uint8Array.from(buffer))));
}
module.exports.hash256 = $f7c6459ce559cfe9$var$hash256;
module.exports.TAGS = [
    "BIP0340/challenge",
    "BIP0340/aux",
    "BIP0340/nonce",
    "TapLeaf",
    "TapBranch",
    "TapSighash",
    "TapTweak",
    "KeyAgg list",
    "KeyAgg coefficient"
];
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ /**
 * Defines the tagged hash prefixes used in the crypto module.
 */ module.exports.TAGGED_HASH_PREFIXES = {
    "BIP0340/challenge": $f7c6459ce559cfe9$require$Buffer.from([
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124,
        123,
        181,
        45,
        122,
        159,
        239,
        88,
        50,
        62,
        177,
        191,
        122,
        64,
        125,
        179,
        130,
        210,
        243,
        242,
        216,
        27,
        177,
        34,
        79,
        73,
        254,
        81,
        143,
        109,
        72,
        211,
        124
    ]),
    "BIP0340/aux": $f7c6459ce559cfe9$require$Buffer.from([
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144,
        241,
        239,
        78,
        94,
        192,
        99,
        202,
        218,
        109,
        148,
        202,
        250,
        157,
        152,
        126,
        160,
        105,
        38,
        88,
        57,
        236,
        193,
        31,
        151,
        45,
        119,
        165,
        46,
        216,
        193,
        204,
        144
    ]),
    "BIP0340/nonce": $f7c6459ce559cfe9$require$Buffer.from([
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47,
        7,
        73,
        119,
        52,
        167,
        155,
        203,
        53,
        91,
        155,
        140,
        125,
        3,
        79,
        18,
        28,
        244,
        52,
        215,
        62,
        247,
        45,
        218,
        25,
        135,
        0,
        97,
        251,
        82,
        191,
        235,
        47
    ]),
    TapLeaf: $f7c6459ce559cfe9$require$Buffer.from([
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238,
        174,
        234,
        143,
        220,
        66,
        8,
        152,
        49,
        5,
        115,
        75,
        88,
        8,
        29,
        30,
        38,
        56,
        211,
        95,
        28,
        181,
        64,
        8,
        212,
        211,
        87,
        202,
        3,
        190,
        120,
        233,
        238
    ]),
    TapBranch: $f7c6459ce559cfe9$require$Buffer.from([
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21,
        25,
        65,
        161,
        242,
        229,
        110,
        185,
        95,
        162,
        169,
        241,
        148,
        190,
        92,
        1,
        247,
        33,
        111,
        51,
        237,
        130,
        176,
        145,
        70,
        52,
        144,
        208,
        91,
        245,
        22,
        160,
        21
    ]),
    TapSighash: $f7c6459ce559cfe9$require$Buffer.from([
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49,
        244,
        10,
        72,
        223,
        75,
        42,
        112,
        200,
        180,
        146,
        75,
        242,
        101,
        70,
        97,
        237,
        61,
        149,
        253,
        102,
        163,
        19,
        235,
        135,
        35,
        117,
        151,
        198,
        40,
        228,
        160,
        49
    ]),
    TapTweak: $f7c6459ce559cfe9$require$Buffer.from([
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233,
        232,
        15,
        225,
        99,
        156,
        156,
        160,
        80,
        227,
        175,
        27,
        57,
        193,
        67,
        198,
        62,
        66,
        156,
        188,
        235,
        21,
        217,
        64,
        251,
        181,
        197,
        161,
        244,
        175,
        87,
        197,
        233
    ]),
    "KeyAgg list": $f7c6459ce559cfe9$require$Buffer.from([
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240,
        72,
        28,
        151,
        28,
        60,
        11,
        70,
        215,
        240,
        178,
        117,
        174,
        89,
        141,
        78,
        44,
        126,
        215,
        49,
        156,
        89,
        74,
        92,
        110,
        199,
        158,
        160,
        212,
        153,
        2,
        148,
        240
    ]),
    "KeyAgg coefficient": $f7c6459ce559cfe9$require$Buffer.from([
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129,
        191,
        201,
        4,
        3,
        77,
        28,
        136,
        232,
        200,
        14,
        34,
        229,
        61,
        36,
        86,
        109,
        100,
        130,
        78,
        214,
        66,
        114,
        129,
        192,
        145,
        0,
        249,
        77,
        205,
        82,
        201,
        129
    ])
};
function $f7c6459ce559cfe9$var$taggedHash(prefix, data) {
    return $f7c6459ce559cfe9$var$sha256($f7c6459ce559cfe9$require$Buffer.concat([
        module.exports.TAGGED_HASH_PREFIXES[prefix],
        data
    ]));
}
module.exports.taggedHash = $f7c6459ce559cfe9$var$taggedHash;

});
parcelRegister("j5xzM", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ripemd160 = module.exports.RIPEMD160 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// https://homes.esat.kuleuven.be/~bosselae/ripemd160.html
// https://homes.esat.kuleuven.be/~bosselae/ripemd160/pdf/AB-9601/AB-9601.pdf
const $de58877bbb165fd5$var$Rho = /* @__PURE__ */ new Uint8Array([
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8
]);
const $de58877bbb165fd5$var$Id = /* @__PURE__ */ new Uint8Array(new Array(16).fill(0).map((_, i)=>i));
const $de58877bbb165fd5$var$Pi = /* @__PURE__ */ $de58877bbb165fd5$var$Id.map((i)=>(9 * i + 5) % 16);
let $de58877bbb165fd5$var$idxL = [
    $de58877bbb165fd5$var$Id
];
let $de58877bbb165fd5$var$idxR = [
    $de58877bbb165fd5$var$Pi
];
for(let i = 0; i < 4; i++)for (let j of [
    $de58877bbb165fd5$var$idxL,
    $de58877bbb165fd5$var$idxR
])j.push(j[i].map((k)=>$de58877bbb165fd5$var$Rho[k]));
const $de58877bbb165fd5$var$shifts = /* @__PURE__ */ [
    [
        11,
        14,
        15,
        12,
        5,
        8,
        7,
        9,
        11,
        13,
        14,
        15,
        6,
        7,
        9,
        8
    ],
    [
        12,
        13,
        11,
        15,
        6,
        9,
        9,
        7,
        12,
        15,
        11,
        13,
        7,
        8,
        7,
        7
    ],
    [
        13,
        15,
        14,
        11,
        7,
        7,
        6,
        8,
        13,
        14,
        13,
        12,
        5,
        5,
        6,
        9
    ],
    [
        14,
        11,
        12,
        14,
        8,
        6,
        5,
        5,
        15,
        12,
        15,
        14,
        9,
        9,
        8,
        6
    ],
    [
        15,
        12,
        13,
        13,
        9,
        5,
        8,
        6,
        14,
        11,
        12,
        11,
        8,
        6,
        5,
        5
    ]
].map((i)=>new Uint8Array(i));
const $de58877bbb165fd5$var$shiftsL = /* @__PURE__ */ $de58877bbb165fd5$var$idxL.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$shiftsR = /* @__PURE__ */ $de58877bbb165fd5$var$idxR.map((idx, i)=>idx.map((j)=>$de58877bbb165fd5$var$shifts[i][j]));
const $de58877bbb165fd5$var$Kl = /* @__PURE__ */ new Uint32Array([
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
]);
const $de58877bbb165fd5$var$Kr = /* @__PURE__ */ new Uint32Array([
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
]);
// It's called f() in spec.
function $de58877bbb165fd5$var$f(group, x, y, z) {
    if (group === 0) return x ^ y ^ z;
    else if (group === 1) return x & y | ~x & z;
    else if (group === 2) return (x | ~y) ^ z;
    else if (group === 3) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
// Temporary buffer, not used to store anything between runs
const $de58877bbb165fd5$var$R_BUF = /* @__PURE__ */ new Uint32Array(16);
class $de58877bbb165fd5$var$RIPEMD160 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, true);
        this.h0 = 1732584193;
        this.h1 = -271733879;
        this.h2 = -1732584194;
        this.h3 = 271733878;
        this.h4 = -1009589776;
    }
    get() {
        const { h0: h0, h1: h1, h2: h2, h3: h3, h4: h4 } = this;
        return [
            h0,
            h1,
            h2,
            h3,
            h4
        ];
    }
    set(h0, h1, h2, h3, h4) {
        this.h0 = h0 | 0;
        this.h1 = h1 | 0;
        this.h2 = h2 | 0;
        this.h3 = h3 | 0;
        this.h4 = h4 | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$de58877bbb165fd5$var$R_BUF[i] = view.getUint32(offset, true);
        // prettier-ignore
        let al = this.h0 | 0, ar = al, bl = this.h1 | 0, br = bl, cl = this.h2 | 0, cr = cl, dl = this.h3 | 0, dr = dl, el = this.h4 | 0, er = el;
        // Instead of iterating 0 to 80, we split it into 5 groups
        // And use the groups in constants, functions, etc. Much simpler
        for(let group = 0; group < 5; group++){
            const rGroup = 4 - group;
            const hbl = $de58877bbb165fd5$var$Kl[group], hbr = $de58877bbb165fd5$var$Kr[group]; // prettier-ignore
            const rl = $de58877bbb165fd5$var$idxL[group], rr = $de58877bbb165fd5$var$idxR[group]; // prettier-ignore
            const sl = $de58877bbb165fd5$var$shiftsL[group], sr = $de58877bbb165fd5$var$shiftsR[group]; // prettier-ignore
            for(let i = 0; i < 16; i++){
                const tl = (0, $3Bcdj.rotl)(al + $de58877bbb165fd5$var$f(group, bl, cl, dl) + $de58877bbb165fd5$var$R_BUF[rl[i]] + hbl, sl[i]) + el | 0;
                al = el, el = dl, dl = (0, $3Bcdj.rotl)(cl, 10) | 0, cl = bl, bl = tl; // prettier-ignore
            }
            // 2 loops are 10% faster
            for(let i = 0; i < 16; i++){
                const tr = (0, $3Bcdj.rotl)(ar + $de58877bbb165fd5$var$f(rGroup, br, cr, dr) + $de58877bbb165fd5$var$R_BUF[rr[i]] + hbr, sr[i]) + er | 0;
                ar = er, er = dr, dr = (0, $3Bcdj.rotl)(cr, 10) | 0, cr = br, br = tr; // prettier-ignore
            }
        }
        // Add the compressed chunk to the current hash value
        this.set(this.h1 + cl + dr | 0, this.h2 + dl + er | 0, this.h3 + el + ar | 0, this.h4 + al + br | 0, this.h0 + bl + cr | 0);
    }
    roundClean() {
        $de58877bbb165fd5$var$R_BUF.fill(0);
    }
    destroy() {
        this.destroyed = true;
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0);
    }
}
module.exports.RIPEMD160 = $de58877bbb165fd5$var$RIPEMD160;
/**
 * RIPEMD-160 - a hash function from 1990s.
 * @param message - msg that would be hashed
 */ module.exports.ripemd160 = (0, $3Bcdj.wrapConstructor)(()=>new $de58877bbb165fd5$var$RIPEMD160());

});
parcelRegister("iYRTw", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.HashMD = module.exports.Maj = module.exports.Chi = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
/**
 * Polyfill for Safari 14
 */ function $dd17a2ee919821c7$var$setBigUint64(view, byteOffset, value, isLE) {
    if (typeof view.setBigUint64 === "function") return view.setBigUint64(byteOffset, value, isLE);
    const _32n = BigInt(32);
    const _u32_max = BigInt(0xffffffff);
    const wh = Number(value >> _32n & _u32_max);
    const wl = Number(value & _u32_max);
    const h = isLE ? 4 : 0;
    const l = isLE ? 0 : 4;
    view.setUint32(byteOffset + h, wh, isLE);
    view.setUint32(byteOffset + l, wl, isLE);
}
/**
 * Choice: a ? b : c
 */ const $dd17a2ee919821c7$var$Chi = (a, b, c)=>a & b ^ ~a & c;
module.exports.Chi = $dd17a2ee919821c7$var$Chi;
/**
 * Majority function, true if any two inputs is true
 */ const $dd17a2ee919821c7$var$Maj = (a, b, c)=>a & b ^ a & c ^ b & c;
module.exports.Maj = $dd17a2ee919821c7$var$Maj;
/**
 * Merkle-Damgard hash construction base class.
 * Could be used to create MD5, RIPEMD, SHA1, SHA2.
 */ class $dd17a2ee919821c7$var$HashMD extends $3Bcdj.Hash {
    constructor(blockLen, outputLen, padOffset, isLE){
        super();
        this.blockLen = blockLen;
        this.outputLen = outputLen;
        this.padOffset = padOffset;
        this.isLE = isLE;
        this.finished = false;
        this.length = 0;
        this.pos = 0;
        this.destroyed = false;
        this.buffer = new Uint8Array(blockLen);
        this.view = (0, $3Bcdj.createView)(this.buffer);
    }
    update(data) {
        (0, $dNiq9.exists)(this);
        const { view: view, buffer: buffer, blockLen: blockLen } = this;
        data = (0, $3Bcdj.toBytes)(data);
        const len = data.length;
        for(let pos = 0; pos < len;){
            const take = Math.min(blockLen - this.pos, len - pos);
            // Fast path: we have at least one block in input, cast it to view and process
            if (take === blockLen) {
                const dataView = (0, $3Bcdj.createView)(data);
                for(; blockLen <= len - pos; pos += blockLen)this.process(dataView, pos);
                continue;
            }
            buffer.set(data.subarray(pos, pos + take), this.pos);
            this.pos += take;
            pos += take;
            if (this.pos === blockLen) {
                this.process(view, 0);
                this.pos = 0;
            }
        }
        this.length += data.length;
        this.roundClean();
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.output)(out, this);
        this.finished = true;
        // Padding
        // We can avoid allocation of buffer for padding completely if it
        // was previously not allocated here. But it won't change performance.
        const { buffer: buffer, view: view, blockLen: blockLen, isLE: isLE } = this;
        let { pos: pos } = this;
        // append the bit '1' to the message
        buffer[pos++] = 128;
        this.buffer.subarray(pos).fill(0);
        // we have less than padOffset left in buffer, so we cannot put length in
        // current block, need process it and pad again
        if (this.padOffset > blockLen - pos) {
            this.process(view, 0);
            pos = 0;
        }
        // Pad until full block byte with zeros
        for(let i = pos; i < blockLen; i++)buffer[i] = 0;
        // Note: sha512 requires length to be 128bit integer, but length in JS will overflow before that
        // You need to write around 2 exabytes (u64_max / 8 / (1024**6)) for this to happen.
        // So we just write lowest 64 bits of that value.
        $dd17a2ee919821c7$var$setBigUint64(view, blockLen - 8, BigInt(this.length * 8), isLE);
        this.process(view, 0);
        const oview = (0, $3Bcdj.createView)(out);
        const len = this.outputLen;
        // NOTE: we do division by 4 later, which should be fused in single op with modulo by JIT
        if (len % 4) throw new Error("_sha2: outputLen should be aligned to 32bit");
        const outLen = len / 4;
        const state = this.get();
        if (outLen > state.length) throw new Error("_sha2: outputLen bigger than state");
        for(let i = 0; i < outLen; i++)oview.setUint32(4 * i, state[i], isLE);
    }
    digest() {
        const { buffer: buffer, outputLen: outputLen } = this;
        this.digestInto(buffer);
        const res = buffer.slice(0, outputLen);
        this.destroy();
        return res;
    }
    _cloneInto(to) {
        to || (to = new this.constructor());
        to.set(...this.get());
        const { blockLen: blockLen, buffer: buffer, length: length, finished: finished, destroyed: destroyed, pos: pos } = this;
        to.length = length;
        to.pos = pos;
        to.finished = finished;
        to.destroyed = destroyed;
        if (length % blockLen) to.buffer.set(buffer);
        return to;
    }
}
module.exports.HashMD = $dd17a2ee919821c7$var$HashMD;

});
parcelRegister("dNiq9", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isBytes = $a0ae23f5901291b4$var$isBytes;
module.exports.number = $a0ae23f5901291b4$var$number;
module.exports.bool = $a0ae23f5901291b4$var$bool;
module.exports.bytes = $a0ae23f5901291b4$var$bytes;
module.exports.hash = $a0ae23f5901291b4$var$hash;
module.exports.exists = $a0ae23f5901291b4$var$exists;
module.exports.output = $a0ae23f5901291b4$var$output;
function $a0ae23f5901291b4$var$number(n) {
    if (!Number.isSafeInteger(n) || n < 0) throw new Error(`positive integer expected, not ${n}`);
}
function $a0ae23f5901291b4$var$bool(b) {
    if (typeof b !== "boolean") throw new Error(`boolean expected, not ${b}`);
}
// copied from utils
function $a0ae23f5901291b4$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $a0ae23f5901291b4$var$bytes(b, ...lengths) {
    if (!$a0ae23f5901291b4$var$isBytes(b)) throw new Error("Uint8Array expected");
    if (lengths.length > 0 && !lengths.includes(b.length)) throw new Error(`Uint8Array expected of length ${lengths}, not of length=${b.length}`);
}
function $a0ae23f5901291b4$var$hash(h) {
    if (typeof h !== "function" || typeof h.create !== "function") throw new Error("Hash should be wrapped by utils.wrapConstructor");
    $a0ae23f5901291b4$var$number(h.outputLen);
    $a0ae23f5901291b4$var$number(h.blockLen);
}
function $a0ae23f5901291b4$var$exists(instance, checkFinished = true) {
    if (instance.destroyed) throw new Error("Hash instance has been destroyed");
    if (checkFinished && instance.finished) throw new Error("Hash#digest() has already been called");
}
function $a0ae23f5901291b4$var$output(out, instance) {
    $a0ae23f5901291b4$var$bytes(out);
    const min = instance.outputLen;
    if (out.length < min) throw new Error(`digestInto() expects output buffer of length at least ${min}`);
}
const $a0ae23f5901291b4$var$assert = {
    number: $a0ae23f5901291b4$var$number,
    bool: $a0ae23f5901291b4$var$bool,
    bytes: $a0ae23f5901291b4$var$bytes,
    hash: $a0ae23f5901291b4$var$hash,
    exists: $a0ae23f5901291b4$var$exists,
    output: $a0ae23f5901291b4$var$output
};
module.exports.default = $a0ae23f5901291b4$var$assert;

});

parcelRegister("3Bcdj", function(module, exports) {
"use strict";
/*! noble-hashes - MIT License (c) 2022 Paul Miller (paulmillr.com) */ Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Hash = module.exports.nextTick = module.exports.byteSwapIfBE = module.exports.byteSwap = module.exports.isLE = module.exports.rotl = module.exports.rotr = module.exports.createView = module.exports.u32 = module.exports.u8 = void 0;
module.exports.isBytes = $29ee4d3171d9809b$var$isBytes;
module.exports.byteSwap32 = $29ee4d3171d9809b$var$byteSwap32;
module.exports.bytesToHex = $29ee4d3171d9809b$var$bytesToHex;
module.exports.hexToBytes = $29ee4d3171d9809b$var$hexToBytes;
module.exports.asyncLoop = $29ee4d3171d9809b$var$asyncLoop;
module.exports.utf8ToBytes = $29ee4d3171d9809b$var$utf8ToBytes;
module.exports.toBytes = $29ee4d3171d9809b$var$toBytes;
module.exports.concatBytes = $29ee4d3171d9809b$var$concatBytes;
module.exports.checkOpts = $29ee4d3171d9809b$var$checkOpts;
module.exports.wrapConstructor = $29ee4d3171d9809b$var$wrapConstructor;
module.exports.wrapConstructorWithOpts = $29ee4d3171d9809b$var$wrapConstructorWithOpts;
module.exports.wrapXOFConstructorWithOpts = $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts;
module.exports.randomBytes = $29ee4d3171d9809b$var$randomBytes;

var $dUxV2 = parcelRequire("dUxV2");

var $dNiq9 = parcelRequire("dNiq9");
// export { isBytes } from './_assert.js';
// We can't reuse isBytes from _assert, because somehow this causes huge perf issues
function $29ee4d3171d9809b$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
// Cast array to different type
const $29ee4d3171d9809b$var$u8 = (arr)=>new Uint8Array(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.u8 = $29ee4d3171d9809b$var$u8;
const $29ee4d3171d9809b$var$u32 = (arr)=>new Uint32Array(arr.buffer, arr.byteOffset, Math.floor(arr.byteLength / 4));
module.exports.u32 = $29ee4d3171d9809b$var$u32;
// Cast array to view
const $29ee4d3171d9809b$var$createView = (arr)=>new DataView(arr.buffer, arr.byteOffset, arr.byteLength);
module.exports.createView = $29ee4d3171d9809b$var$createView;
// The rotate right (circular right shift) operation for uint32
const $29ee4d3171d9809b$var$rotr = (word, shift)=>word << 32 - shift | word >>> shift;
module.exports.rotr = $29ee4d3171d9809b$var$rotr;
// The rotate left (circular left shift) operation for uint32
const $29ee4d3171d9809b$var$rotl = (word, shift)=>word << shift | word >>> 32 - shift >>> 0;
module.exports.rotl = $29ee4d3171d9809b$var$rotl;
module.exports.isLE = new Uint8Array(new Uint32Array([
    0x11223344
]).buffer)[0] === 0x44;
// The byte swap operation for uint32
const $29ee4d3171d9809b$var$byteSwap = (word)=>word << 24 & 0xff000000 | word << 8 & 0xff0000 | word >>> 8 & 0xff00 | word >>> 24 & 0xff;
module.exports.byteSwap = $29ee4d3171d9809b$var$byteSwap;
// Conditionally byte swap if on a big-endian platform
module.exports.byteSwapIfBE = module.exports.isLE ? (n)=>n : (n)=>(0, module.exports.byteSwap)(n);
// In place byte swap for Uint32Array
function $29ee4d3171d9809b$var$byteSwap32(arr) {
    for(let i = 0; i < arr.length; i++)arr[i] = (0, module.exports.byteSwap)(arr[i]);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $29ee4d3171d9809b$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $29ee4d3171d9809b$var$bytesToHex(bytes) {
    (0, $dNiq9.bytes)(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $29ee4d3171d9809b$var$hexes[bytes[i]];
    return hex;
}
// We use optimized technique to convert hex string to byte array
const $29ee4d3171d9809b$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $29ee4d3171d9809b$var$asciiToBase16(char) {
    if (char >= $29ee4d3171d9809b$var$asciis._0 && char <= $29ee4d3171d9809b$var$asciis._9) return char - $29ee4d3171d9809b$var$asciis._0;
    if (char >= $29ee4d3171d9809b$var$asciis._A && char <= $29ee4d3171d9809b$var$asciis._F) return char - ($29ee4d3171d9809b$var$asciis._A - 10);
    if (char >= $29ee4d3171d9809b$var$asciis._a && char <= $29ee4d3171d9809b$var$asciis._f) return char - ($29ee4d3171d9809b$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $29ee4d3171d9809b$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $29ee4d3171d9809b$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
// There is no setImmediate in browser and setTimeout is slow.
// call of async fn will return Promise, which will be fullfiled only on
// next scheduler queue processing step and this is exactly what we need.
const $29ee4d3171d9809b$var$nextTick = async ()=>{};
module.exports.nextTick = $29ee4d3171d9809b$var$nextTick;
// Returns control to thread each 'tick' ms to avoid blocking
async function $29ee4d3171d9809b$var$asyncLoop(iters, tick, cb) {
    let ts = Date.now();
    for(let i = 0; i < iters; i++){
        cb(i);
        // Date.now() is not monotonic, so in case if clock goes backwards we return return control too
        const diff = Date.now() - ts;
        if (diff >= 0 && diff < tick) continue;
        await (0, module.exports.nextTick)();
        ts += diff;
    }
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $29ee4d3171d9809b$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
/**
 * Normalizes (non-hex) string or Uint8Array to Uint8Array.
 * Warning: when Uint8Array is passed, it would NOT get copied.
 * Keep in mind for future mutable operations.
 */ function $29ee4d3171d9809b$var$toBytes(data) {
    if (typeof data === "string") data = $29ee4d3171d9809b$var$utf8ToBytes(data);
    (0, $dNiq9.bytes)(data);
    return data;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $29ee4d3171d9809b$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        (0, $dNiq9.bytes)(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// For runtime check if class implements interface
class $29ee4d3171d9809b$var$Hash {
    // Safe version that clones internal state
    clone() {
        return this._cloneInto();
    }
}
module.exports.Hash = $29ee4d3171d9809b$var$Hash;
const $29ee4d3171d9809b$var$toStr = {}.toString;
function $29ee4d3171d9809b$var$checkOpts(defaults, opts) {
    if (opts !== undefined && $29ee4d3171d9809b$var$toStr.call(opts) !== "[object Object]") throw new Error("Options should be object or undefined");
    const merged = Object.assign(defaults, opts);
    return merged;
}
function $29ee4d3171d9809b$var$wrapConstructor(hashCons) {
    const hashC = (msg)=>hashCons().update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons();
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = ()=>hashCons();
    return hashC;
}
function $29ee4d3171d9809b$var$wrapConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
function $29ee4d3171d9809b$var$wrapXOFConstructorWithOpts(hashCons) {
    const hashC = (msg, opts)=>hashCons(opts).update($29ee4d3171d9809b$var$toBytes(msg)).digest();
    const tmp = hashCons({});
    hashC.outputLen = tmp.outputLen;
    hashC.blockLen = tmp.blockLen;
    hashC.create = (opts)=>hashCons(opts);
    return hashC;
}
/**
 * Secure PRNG. Uses `crypto.getRandomValues`, which defers to OS.
 */ function $29ee4d3171d9809b$var$randomBytes(bytesLength = 32) {
    if ($dUxV2.crypto && typeof $dUxV2.crypto.getRandomValues === "function") return $dUxV2.crypto.getRandomValues(new Uint8Array(bytesLength));
    // Legacy Node.js compatibility
    if ($dUxV2.crypto && typeof $dUxV2.crypto.randomBytes === "function") return $dUxV2.crypto.randomBytes(bytesLength);
    throw new Error("crypto.getRandomValues must be defined");
}

});
parcelRegister("dUxV2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.crypto = void 0;
module.exports.crypto = typeof globalThis === "object" && "crypto" in globalThis ? globalThis.crypto : undefined;

});




parcelRegister("dGR9X", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha1 = module.exports.SHA1 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA1 (RFC 3174). It was cryptographically broken: prefer newer algorithms.
// Initial state
const $9f786f0150d7e2f4$var$SHA1_IV = /* @__PURE__ */ new Uint32Array([
    0x67452301,
    0xefcdab89,
    0x98badcfe,
    0x10325476,
    0xc3d2e1f0
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $9f786f0150d7e2f4$var$SHA1_W = /* @__PURE__ */ new Uint32Array(80);
class $9f786f0150d7e2f4$var$SHA1 extends $iYRTw.HashMD {
    constructor(){
        super(64, 20, 8, false);
        this.A = $9f786f0150d7e2f4$var$SHA1_IV[0] | 0;
        this.B = $9f786f0150d7e2f4$var$SHA1_IV[1] | 0;
        this.C = $9f786f0150d7e2f4$var$SHA1_IV[2] | 0;
        this.D = $9f786f0150d7e2f4$var$SHA1_IV[3] | 0;
        this.E = $9f786f0150d7e2f4$var$SHA1_IV[4] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E } = this;
        return [
            A,
            B,
            C,
            D,
            E
        ];
    }
    set(A, B, C, D, E) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
    }
    process(view, offset) {
        for(let i = 0; i < 16; i++, offset += 4)$9f786f0150d7e2f4$var$SHA1_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 80; i++)$9f786f0150d7e2f4$var$SHA1_W[i] = (0, $3Bcdj.rotl)($9f786f0150d7e2f4$var$SHA1_W[i - 3] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 8] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 14] ^ $9f786f0150d7e2f4$var$SHA1_W[i - 16], 1);
        // Compression function main loop, 80 rounds
        let { A: A, B: B, C: C, D: D, E: E } = this;
        for(let i = 0; i < 80; i++){
            let F, K;
            if (i < 20) {
                F = (0, $iYRTw.Chi)(B, C, D);
                K = 0x5a827999;
            } else if (i < 40) {
                F = B ^ C ^ D;
                K = 0x6ed9eba1;
            } else if (i < 60) {
                F = (0, $iYRTw.Maj)(B, C, D);
                K = 0x8f1bbcdc;
            } else {
                F = B ^ C ^ D;
                K = 0xca62c1d6;
            }
            const T = (0, $3Bcdj.rotl)(A, 5) + F + E + K + $9f786f0150d7e2f4$var$SHA1_W[i] | 0;
            E = D;
            D = C;
            C = (0, $3Bcdj.rotl)(B, 30);
            B = A;
            A = T;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        this.set(A, B, C, D, E);
    }
    roundClean() {
        $9f786f0150d7e2f4$var$SHA1_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.SHA1 = $9f786f0150d7e2f4$var$SHA1;
/**
 * SHA1 (RFC 3174) hash function.
 * It was cryptographically broken: prefer newer algorithms.
 * @param message - data that would be hashed
 */ module.exports.sha1 = (0, $3Bcdj.wrapConstructor)(()=>new $9f786f0150d7e2f4$var$SHA1());

});

parcelRegister("6XnWx", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.sha224 = module.exports.sha256 = module.exports.SHA256 = void 0;

var $iYRTw = parcelRequire("iYRTw");

var $3Bcdj = parcelRequire("3Bcdj");
// SHA2-256 need to try 2^128 hashes to execute birthday attack.
// BTC network is doing 2^67 hashes/sec as per early 2023.
// Round constants:
// first 32 bits of the fractional parts of the cube roots of the first 64 primes 2..311)
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_K = /* @__PURE__ */ new Uint32Array([
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
]);
// Initial state:
// first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19
// prettier-ignore
const $510ad3657d73a9d2$var$SHA256_IV = /* @__PURE__ */ new Uint32Array([
    0x6a09e667,
    0xbb67ae85,
    0x3c6ef372,
    0xa54ff53a,
    0x510e527f,
    0x9b05688c,
    0x1f83d9ab,
    0x5be0cd19
]);
// Temporary buffer, not used to store anything between runs
// Named this way because it matches specification.
const $510ad3657d73a9d2$var$SHA256_W = /* @__PURE__ */ new Uint32Array(64);
class $510ad3657d73a9d2$var$SHA256 extends $iYRTw.HashMD {
    constructor(){
        super(64, 32, 8, false);
        // We cannot use array here since array allows indexing by variable
        // which means optimizer/compiler cannot use registers.
        this.A = $510ad3657d73a9d2$var$SHA256_IV[0] | 0;
        this.B = $510ad3657d73a9d2$var$SHA256_IV[1] | 0;
        this.C = $510ad3657d73a9d2$var$SHA256_IV[2] | 0;
        this.D = $510ad3657d73a9d2$var$SHA256_IV[3] | 0;
        this.E = $510ad3657d73a9d2$var$SHA256_IV[4] | 0;
        this.F = $510ad3657d73a9d2$var$SHA256_IV[5] | 0;
        this.G = $510ad3657d73a9d2$var$SHA256_IV[6] | 0;
        this.H = $510ad3657d73a9d2$var$SHA256_IV[7] | 0;
    }
    get() {
        const { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        return [
            A,
            B,
            C,
            D,
            E,
            F,
            G,
            H
        ];
    }
    // prettier-ignore
    set(A, B, C, D, E, F, G, H) {
        this.A = A | 0;
        this.B = B | 0;
        this.C = C | 0;
        this.D = D | 0;
        this.E = E | 0;
        this.F = F | 0;
        this.G = G | 0;
        this.H = H | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 48 words w[16..63] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4)$510ad3657d73a9d2$var$SHA256_W[i] = view.getUint32(offset, false);
        for(let i = 16; i < 64; i++){
            const W15 = $510ad3657d73a9d2$var$SHA256_W[i - 15];
            const W2 = $510ad3657d73a9d2$var$SHA256_W[i - 2];
            const s0 = (0, $3Bcdj.rotr)(W15, 7) ^ (0, $3Bcdj.rotr)(W15, 18) ^ W15 >>> 3;
            const s1 = (0, $3Bcdj.rotr)(W2, 17) ^ (0, $3Bcdj.rotr)(W2, 19) ^ W2 >>> 10;
            $510ad3657d73a9d2$var$SHA256_W[i] = s1 + $510ad3657d73a9d2$var$SHA256_W[i - 7] + s0 + $510ad3657d73a9d2$var$SHA256_W[i - 16] | 0;
        }
        // Compression function main loop, 64 rounds
        let { A: A, B: B, C: C, D: D, E: E, F: F, G: G, H: H } = this;
        for(let i = 0; i < 64; i++){
            const sigma1 = (0, $3Bcdj.rotr)(E, 6) ^ (0, $3Bcdj.rotr)(E, 11) ^ (0, $3Bcdj.rotr)(E, 25);
            const T1 = H + sigma1 + (0, $iYRTw.Chi)(E, F, G) + $510ad3657d73a9d2$var$SHA256_K[i] + $510ad3657d73a9d2$var$SHA256_W[i] | 0;
            const sigma0 = (0, $3Bcdj.rotr)(A, 2) ^ (0, $3Bcdj.rotr)(A, 13) ^ (0, $3Bcdj.rotr)(A, 22);
            const T2 = sigma0 + (0, $iYRTw.Maj)(A, B, C) | 0;
            H = G;
            G = F;
            F = E;
            E = D + T1 | 0;
            D = C;
            C = B;
            B = A;
            A = T1 + T2 | 0;
        }
        // Add the compressed chunk to the current hash value
        A = A + this.A | 0;
        B = B + this.B | 0;
        C = C + this.C | 0;
        D = D + this.D | 0;
        E = E + this.E | 0;
        F = F + this.F | 0;
        G = G + this.G | 0;
        H = H + this.H | 0;
        this.set(A, B, C, D, E, F, G, H);
    }
    roundClean() {
        $510ad3657d73a9d2$var$SHA256_W.fill(0);
    }
    destroy() {
        this.set(0, 0, 0, 0, 0, 0, 0, 0);
        this.buffer.fill(0);
    }
}
module.exports.SHA256 = $510ad3657d73a9d2$var$SHA256;
// Constants from https://nvlpubs.nist.gov/nistpubs/FIPS/NIST.FIPS.180-4.pdf
class $510ad3657d73a9d2$var$SHA224 extends $510ad3657d73a9d2$var$SHA256 {
    constructor(){
        super();
        this.A = -1056596264;
        this.B = 914150663;
        this.C = 812702999;
        this.D = -150054599;
        this.E = -4191439;
        this.F = 1750603025;
        this.G = 1694076839;
        this.H = -1090891868;
        this.outputLen = 28;
    }
}
/**
 * SHA2-256 hash function
 * @param message - data that would be hashed
 */ module.exports.sha256 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA256());
/**
 * SHA2-224 hash function
 */ module.exports.sha224 = (0, $3Bcdj.wrapConstructor)(()=>new $510ad3657d73a9d2$var$SHA224());

});


parcelRegister("wjgZX", function(module, exports) {
"use strict";

var $6XnWx = parcelRequire("6XnWx");
var $0611f085f6ca7f20$require$sha256 = $6XnWx.sha256;

var $jow4V = parcelRequire("jow4V");
// SHA256(SHA256(buffer))
function $0611f085f6ca7f20$var$sha256x2(buffer) {
    return $0611f085f6ca7f20$require$sha256($0611f085f6ca7f20$require$sha256(buffer));
}
module.exports = $jow4V($0611f085f6ca7f20$var$sha256x2);

});
parcelRegister("jow4V", function(module, exports) {
"use strict";

var $kmJDL = parcelRequire("kmJDL");
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var payloadU8 = Uint8Array.from(payload);
        var checksum = checksumFn(payloadU8);
        var length = payloadU8.length + 4;
        var both = new Uint8Array(length);
        both.set(payloadU8, 0);
        both.set(checksum.subarray(0, 4), payloadU8.length);
        return $kmJDL.encode(both, length);
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $kmJDL.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $kmJDL.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("kmJDL", function(module, exports) {

var $bPPBe = parcelRequire("bPPBe");
const $ed3943ede7740d05$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $bPPBe($ed3943ede7740d05$var$ALPHABET);

});
parcelRegister("bPPBe", function(module, exports) {
"use strict";
// base-x encoding / decoding
// Copyright (c) 2018 base-x contributors
// Copyright (c) 2014-2018 The Bitcoin Core developers (base58.cpp)
// Distributed under the MIT software license, see the accompanying
// file LICENSE or http://www.opensource.org/licenses/mit-license.php.
function $89dc7bbdd4e9133e$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (source instanceof Uint8Array) ;
        else if (ArrayBuffer.isView(source)) source = new Uint8Array(source.buffer, source.byteOffset, source.byteLength);
        else if (Array.isArray(source)) source = Uint8Array.from(source);
        if (!(source instanceof Uint8Array)) throw new TypeError("Expected Uint8Array");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return new Uint8Array();
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(source[psz]){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = new Uint8Array(zeroes + (size - it4));
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $89dc7bbdd4e9133e$var$base;

});





parcelRegister("4yk7Y", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3509f34e0538f818$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2sh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $wjgZX = parcelRequire("wjgZX");
const $3509f34e0538f818$var$OPS = $8wAtk.OPS;
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
/**
 * Creates a Pay-to-Script-Hash (P2SH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2SH payment object.
 * @throws {TypeError} If the required data is not provided or if the data is invalid.
 */ function $3509f34e0538f818$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(23)),
        redeem: $18Mz5.typeforce.maybe({
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    const _address = $4v19v.value(()=>{
        const payload = $3509f34e0538f818$require$Buffer.from($wjgZX.decode(a.address));
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.input);
    });
    const _redeem = $4v19v.value(()=>{
        const chunks = _chunks();
        const lastChunk = chunks[chunks.length - 1];
        return {
            network: network,
            output: lastChunk === $3509f34e0538f818$var$OPS.OP_FALSE ? $3509f34e0538f818$require$Buffer.from([]) : lastChunk,
            input: $8wAtk.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $3509f34e0538f818$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $wjgZX.encode(payload);
    });
    $4v19v.prop(o, "hash", ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $lgTFk.hash160(o.redeem.output);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3509f34e0538f818$var$OPS.OP_HASH160,
            o.hash,
            $3509f34e0538f818$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $4v19v.prop(o, "redeem", ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $4v19v.prop(o, "input", ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $8wAtk.compile([].concat($8wAtk.decompile(a.redeem.input), a.redeem.output));
    });
    $4v19v.prop(o, "witness", ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $4v19v.prop(o, "name", ()=>{
        const nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        let hash = $3509f34e0538f818$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $3509f34e0538f818$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $3509f34e0538f818$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $8wAtk.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                if (redeem.output.byteLength > 520) throw new TypeError("Redeem.output unspendable if larger than 520 bytes");
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                const hash2 = $lgTFk.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    const richunks = $8wAtk.decompile(redeem.input);
                    if (!$8wAtk.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$3509f34e0538f818$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !(0, $18Mz5.stacksEqual)(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2sh = $3509f34e0538f818$var$p2sh;

});

parcelRegister("8P2rG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $66c4fbcaba3cf164$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2wpkh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $66c4fbcaba3cf164$var$OPS = $8wAtk.OPS;
const $66c4fbcaba3cf164$var$EMPTY_BUFFER = $66c4fbcaba3cf164$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
/**
 * Creates a pay-to-witness-public-key-hash (p2wpkh) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The p2wpkh payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $66c4fbcaba3cf164$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(20)),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(22)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.isPoint),
        signature: $18Mz5.typeforce.maybe($8wAtk.isCanonicalScriptSignature),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $66c4fbcaba3cf164$require$Buffer.from(data)
        };
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2wpkh",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $lgTFk.hash160(a.pubkey || o.pubkey);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $66c4fbcaba3cf164$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $4v19v.prop(o, "signature", ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $4v19v.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $66c4fbcaba3cf164$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, "witness", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $66c4fbcaba3cf164$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $66c4fbcaba3cf164$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $lgTFk.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!(0, $18Mz5.isPoint)(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$8wAtk.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!(0, $18Mz5.isPoint)(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $lgTFk.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wpkh = $66c4fbcaba3cf164$var$p2wpkh;

});
parcelRegister("db6J2", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.bech32m = module.exports.bech32 = void 0;
const $998184fe7eff6e26$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
const $998184fe7eff6e26$var$ALPHABET_MAP = {};
for(let z = 0; z < $998184fe7eff6e26$var$ALPHABET.length; z++){
    const x = $998184fe7eff6e26$var$ALPHABET.charAt(z);
    $998184fe7eff6e26$var$ALPHABET_MAP[x] = z;
}
function $998184fe7eff6e26$var$polymodStep(pre) {
    const b = pre >> 25;
    return (pre & 0x1ffffff) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $998184fe7eff6e26$var$prefixChk(prefix) {
    let chk = 1;
    for(let i = 0; i < prefix.length; ++i){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $998184fe7eff6e26$var$polymodStep(chk);
    for(let i = 0; i < prefix.length; ++i){
        const v = prefix.charCodeAt(i);
        chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $998184fe7eff6e26$var$convert(data, inBits, outBits, pad) {
    let value = 0;
    let bits = 0;
    const maxV = (1 << outBits) - 1;
    const result = [];
    for(let i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $998184fe7eff6e26$var$toWords(bytes) {
    return $998184fe7eff6e26$var$convert(bytes, 8, 5, true);
}
function $998184fe7eff6e26$var$fromWordsUnsafe(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $998184fe7eff6e26$var$fromWords(words) {
    const res = $998184fe7eff6e26$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $998184fe7eff6e26$var$getLibraryFromEncoding(encoding) {
    let ENCODING_CONST;
    if (encoding === "bech32") ENCODING_CONST = 1;
    else ENCODING_CONST = 0x2bc830a3;
    function encode(prefix, words, LIMIT) {
        LIMIT = LIMIT || 90;
        if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
        prefix = prefix.toLowerCase();
        // determine chk mod
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === "string") throw new Error(chk);
        let result = prefix + "1";
        for(let i = 0; i < words.length; ++i){
            const x = words[i];
            if (x >> 5 !== 0) throw new Error("Non 5-bit word");
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ x;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(x);
        }
        for(let i = 0; i < 6; ++i)chk = $998184fe7eff6e26$var$polymodStep(chk);
        chk ^= ENCODING_CONST;
        for(let i = 0; i < 6; ++i){
            const v = chk >> (5 - i) * 5 & 0x1f;
            result += $998184fe7eff6e26$var$ALPHABET.charAt(v);
        }
        return result;
    }
    function __decode(str, LIMIT) {
        LIMIT = LIMIT || 90;
        if (str.length < 8) return str + " too short";
        if (str.length > LIMIT) return "Exceeds length limit";
        // don't allow mixed case
        const lowered = str.toLowerCase();
        const uppered = str.toUpperCase();
        if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
        str = lowered;
        const split = str.lastIndexOf("1");
        if (split === -1) return "No separator character for " + str;
        if (split === 0) return "Missing prefix for " + str;
        const prefix = str.slice(0, split);
        const wordChars = str.slice(split + 1);
        if (wordChars.length < 6) return "Data too short";
        let chk = $998184fe7eff6e26$var$prefixChk(prefix);
        if (typeof chk === "string") return chk;
        const words = [];
        for(let i = 0; i < wordChars.length; ++i){
            const c = wordChars.charAt(i);
            const v = $998184fe7eff6e26$var$ALPHABET_MAP[c];
            if (v === undefined) return "Unknown character " + c;
            chk = $998184fe7eff6e26$var$polymodStep(chk) ^ v;
            // not in the checksum?
            if (i + 6 >= wordChars.length) continue;
            words.push(v);
        }
        if (chk !== ENCODING_CONST) return "Invalid checksum for " + str;
        return {
            prefix: prefix,
            words: words
        };
    }
    function decodeUnsafe(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
    }
    function decode(str, LIMIT) {
        const res = __decode(str, LIMIT);
        if (typeof res === "object") return res;
        throw new Error(res);
    }
    return {
        decodeUnsafe: decodeUnsafe,
        decode: decode,
        encode: encode,
        toWords: $998184fe7eff6e26$var$toWords,
        fromWordsUnsafe: $998184fe7eff6e26$var$fromWordsUnsafe,
        fromWords: $998184fe7eff6e26$var$fromWords
    };
}
module.exports.bech32 = $998184fe7eff6e26$var$getLibraryFromEncoding("bech32");
module.exports.bech32m = $998184fe7eff6e26$var$getLibraryFromEncoding("bech32m");

});


parcelRegister("576Qs", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $3b92ea7f46896519$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2wsh = void 0;

var $lgTFk = parcelRequire("lgTFk");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");
const $3b92ea7f46896519$var$OPS = $8wAtk.OPS;
const $3b92ea7f46896519$var$EMPTY_BUFFER = $3b92ea7f46896519$require$Buffer.alloc(0);
function $3b92ea7f46896519$var$chunkHasUncompressedPubkey(chunk) {
    if ($3b92ea7f46896519$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && (0, $18Mz5.isPoint)(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
/**
 * Creates a Pay-to-Witness-Script-Hash (P2WSH) payment object.
 *
 * @param a - The payment object containing the necessary data.
 * @param opts - Optional payment options.
 * @returns The P2WSH payment object.
 * @throws {TypeError} If the required data is missing or invalid.
 */ function $3b92ea7f46896519$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        redeem: $18Mz5.typeforce.maybe({
            input: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
    }, a);
    const _address = $4v19v.value(()=>{
        const result = $db6J2.bech32.decode(a.address);
        const version = result.words.shift();
        const data = $db6J2.bech32.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $3b92ea7f46896519$require$Buffer.from(data)
        };
    });
    const _rchunks = $4v19v.value(()=>{
        return $8wAtk.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $fjh6Q.bitcoin;
    const o = {
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $db6J2.bech32.toWords(o.hash);
        words.unshift(0x00);
        return $db6J2.bech32.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $lgTFk.sha256(o.redeem.output);
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $8wAtk.compile([
            $3b92ea7f46896519$var$OPS.OP_0,
            o.hash
        ]);
    });
    $4v19v.prop(o, "redeem", ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $3b92ea7f46896519$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $4v19v.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $3b92ea7f46896519$var$EMPTY_BUFFER;
    });
    $4v19v.prop(o, "witness", ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $8wAtk.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $3b92ea7f46896519$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $4v19v.prop(o, "name", ()=>{
        const nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined && o.redeem.name !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        let hash = $3b92ea7f46896519$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $3b92ea7f46896519$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty/valid?
            if (a.redeem.output) {
                const decompile = $8wAtk.decompile(a.redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output is invalid");
                if (a.redeem.output.byteLength > 3600) throw new TypeError("Redeem.output unspendable if larger than 3600 bytes");
                if ($8wAtk.countNonPushOnlyOPs(decompile) > 201) throw new TypeError("Redeem.output unspendable with more than 201 non-push ops");
                // match hash against other sources
                const hash2 = $lgTFk.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (a.redeem.input && !$8wAtk.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !(0, $18Mz5.stacksEqual)(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || a.redeem.output && ($8wAtk.decompile(a.redeem.output) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($3b92ea7f46896519$var$chunkHasUncompressedPubkey) || ($8wAtk.decompile(wScript) || []).some($3b92ea7f46896519$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
module.exports.p2wsh = $3b92ea7f46896519$var$p2wsh;

});

parcelRegister("bl5DO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.p2tr = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $fjh6Q = parcelRequire("fjh6Q");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");

var $f6boC = parcelRequire("f6boC");

var $lzIk8 = parcelRequire("lzIk8");

var $4v19v = parcelRequire("4v19v");

var $db6J2 = parcelRequire("db6J2");

var $d1wHE = parcelRequire("d1wHE");
const $8416081c4ea2e910$var$OPS = $8wAtk.OPS;
const $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION = 0x01;
const $8416081c4ea2e910$var$ANNEX_PREFIX = 0x50;
/**
 * Creates a Pay-to-Taproot (P2TR) payment object.
 *
 * @param a - The payment object containing the necessary data for P2TR.
 * @param opts - Optional payment options.
 * @returns The P2TR payment object.
 * @throws {TypeError} If the provided data is invalid or insufficient.
 */ function $8416081c4ea2e910$var$p2tr(a, opts) {
    if (!a.address && !a.output && !a.pubkey && !a.internalPubkey && !(a.witness && a.witness.length > 1)) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    (0, $18Mz5.typeforce)({
        address: $18Mz5.typeforce.maybe($18Mz5.typeforce.String),
        input: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(0)),
        network: $18Mz5.typeforce.maybe($18Mz5.typeforce.Object),
        output: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(34)),
        internalPubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        hash: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        pubkey: $18Mz5.typeforce.maybe($18Mz5.typeforce.BufferN(32)),
        signature: $18Mz5.typeforce.maybe($18Mz5.typeforce.anyOf($18Mz5.typeforce.BufferN(64), $18Mz5.typeforce.BufferN(65))),
        witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer)),
        scriptTree: $18Mz5.typeforce.maybe($18Mz5.isTaptree),
        redeem: $18Mz5.typeforce.maybe({
            output: $18Mz5.typeforce.maybe($18Mz5.typeforce.Buffer),
            redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number),
            witness: $18Mz5.typeforce.maybe($18Mz5.typeforce.arrayOf($18Mz5.typeforce.Buffer))
        }),
        redeemVersion: $18Mz5.typeforce.maybe($18Mz5.typeforce.Number)
    }, a);
    const _address = $4v19v.value(()=>{
        return (0, $d1wHE.fromBech32)(a.address);
    });
    // remove annex if present, ignored by taproot
    const _witness = $4v19v.value(()=>{
        if (!a.witness || !a.witness.length) return;
        if (a.witness.length >= 2 && a.witness[a.witness.length - 1][0] === $8416081c4ea2e910$var$ANNEX_PREFIX) return a.witness.slice(0, -1);
        return a.witness.slice();
    });
    const _hashTree = $4v19v.value(()=>{
        if (a.scriptTree) return (0, $lzIk8.toHashTree)(a.scriptTree);
        if (a.hash) return {
            hash: a.hash
        };
        return;
    });
    const network = a.network || $fjh6Q.bitcoin;
    const o = {
        name: "p2tr",
        network: network
    };
    $4v19v.prop(o, "address", ()=>{
        if (!o.pubkey) return;
        const words = $db6J2.bech32m.toWords(o.pubkey);
        words.unshift($8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION);
        return $db6J2.bech32m.encode(network.bech32, words);
    });
    $4v19v.prop(o, "hash", ()=>{
        const hashTree = _hashTree();
        if (hashTree) return hashTree.hash;
        const w = _witness();
        if (w && w.length > 1) {
            const controlBlock = w[w.length - 1];
            const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
            const script = w[w.length - 2];
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: script,
                version: leafVersion
            });
            return (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
        }
        return null;
    });
    $4v19v.prop(o, "output", ()=>{
        if (!o.pubkey) return;
        return $8wAtk.compile([
            $8416081c4ea2e910$var$OPS.OP_1,
            o.pubkey
        ]);
    });
    $4v19v.prop(o, "redeemVersion", ()=>{
        if (a.redeemVersion) return a.redeemVersion;
        if (a.redeem && a.redeem.redeemVersion !== undefined && a.redeem.redeemVersion !== null) return a.redeem.redeemVersion;
        return $lzIk8.LEAF_VERSION_TAPSCRIPT;
    });
    $4v19v.prop(o, "redeem", ()=>{
        const witness = _witness(); // witness without annex
        if (!witness || witness.length < 2) return;
        return {
            output: witness[witness.length - 2],
            witness: witness.slice(0, -2),
            redeemVersion: witness[witness.length - 1][0] & $18Mz5.TAPLEAF_VERSION_MASK
        };
    });
    $4v19v.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(o.internalPubkey, o.hash);
            if (tweakedKey) return tweakedKey.x;
        }
    });
    $4v19v.prop(o, "internalPubkey", ()=>{
        if (a.internalPubkey) return a.internalPubkey;
        const witness = _witness();
        if (witness && witness.length > 1) return witness[witness.length - 1].slice(1, 33);
    });
    $4v19v.prop(o, "signature", ()=>{
        if (a.signature) return a.signature;
        const witness = _witness(); // witness without annex
        if (!witness || witness.length !== 1) return;
        return witness[0];
    });
    $4v19v.prop(o, "witness", ()=>{
        if (a.witness) return a.witness;
        const hashTree = _hashTree();
        if (hashTree && a.redeem && a.redeem.output && a.internalPubkey) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            const path = (0, $lzIk8.findScriptPath)(hashTree, leafHash);
            if (!path) return;
            const outputKey = (0, $lzIk8.tweakKey)(a.internalPubkey, hashTree.hash);
            if (!outputKey) return;
            const controlBock = $6ZWSX.Buffer.concat([
                $6ZWSX.Buffer.from([
                    o.redeemVersion | outputKey.parity
                ]),
                a.internalPubkey
            ].concat(path));
            return [
                a.redeem.output,
                controlBock
            ];
        }
        if (a.signature) return [
            a.signature
        ];
    });
    // extended validation
    if (opts.validate) {
        let pubkey = $6ZWSX.Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== $8416081c4ea2e910$var$TAPROOT_WITNESS_VERSION) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            pubkey = _address().data;
        }
        if (a.pubkey) {
            if (pubkey.length > 0 && !pubkey.equals(a.pubkey)) throw new TypeError("Pubkey mismatch");
            else pubkey = a.pubkey;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $8416081c4ea2e910$var$OPS.OP_1 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            if (pubkey.length > 0 && !pubkey.equals(a.output.slice(2))) throw new TypeError("Pubkey mismatch");
            else pubkey = a.output.slice(2);
        }
        if (a.internalPubkey) {
            const tweakedKey = (0, $lzIk8.tweakKey)(a.internalPubkey, o.hash);
            if (pubkey.length > 0 && !pubkey.equals(tweakedKey.x)) throw new TypeError("Pubkey mismatch");
            else pubkey = tweakedKey.x;
        }
        if (pubkey && pubkey.length) {
            if (!(0, $f6boC.getEccLib)().isXOnlyPoint(pubkey)) throw new TypeError("Invalid pubkey for p2tr");
        }
        const hashTree = _hashTree();
        if (a.hash && hashTree) {
            if (!a.hash.equals(hashTree.hash)) throw new TypeError("Hash mismatch");
        }
        if (a.redeem && a.redeem.output && hashTree) {
            const leafHash = (0, $lzIk8.tapleafHash)({
                output: a.redeem.output,
                version: o.redeemVersion
            });
            if (!(0, $lzIk8.findScriptPath)(hashTree, leafHash)) throw new TypeError("Redeem script not in tree");
        }
        const witness = _witness();
        // compare the provided redeem data with the one computed from witness
        if (a.redeem && o.redeem) {
            if (a.redeem.redeemVersion) {
                if (a.redeem.redeemVersion !== o.redeem.redeemVersion) throw new TypeError("Redeem.redeemVersion and witness mismatch");
            }
            if (a.redeem.output) {
                if ($8wAtk.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // output redeem is constructed from the witness
                if (o.redeem.output && !a.redeem.output.equals(o.redeem.output)) throw new TypeError("Redeem.output and witness mismatch");
            }
            if (a.redeem.witness) {
                if (o.redeem.witness && !(0, $18Mz5.stacksEqual)(a.redeem.witness, o.redeem.witness)) throw new TypeError("Redeem.witness and witness mismatch");
            }
        }
        if (witness && witness.length) {
            if (witness.length === 1) {
                // key spending
                if (a.signature && !a.signature.equals(witness[0])) throw new TypeError("Signature mismatch");
            } else {
                // script path spending
                const controlBlock = witness[witness.length - 1];
                if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
                if ((controlBlock.length - 33) % 32 !== 0) throw new TypeError(`The control-block length of ${controlBlock.length} is incorrect!`);
                const m = (controlBlock.length - 33) / 32;
                if (m > 128) throw new TypeError(`The script path is too long. Got ${m}, expected max 128.`);
                const internalPubkey = controlBlock.slice(1, 33);
                if (a.internalPubkey && !a.internalPubkey.equals(internalPubkey)) throw new TypeError("Internal pubkey mismatch");
                if (!(0, $f6boC.getEccLib)().isXOnlyPoint(internalPubkey)) throw new TypeError("Invalid internalPubkey for p2tr witness");
                const leafVersion = controlBlock[0] & $18Mz5.TAPLEAF_VERSION_MASK;
                const script = witness[witness.length - 2];
                const leafHash = (0, $lzIk8.tapleafHash)({
                    output: script,
                    version: leafVersion
                });
                const hash = (0, $lzIk8.rootHashFromPath)(controlBlock, leafHash);
                const outputKey = (0, $lzIk8.tweakKey)(internalPubkey, hash);
                if (!outputKey) // todo: needs test data
                throw new TypeError("Invalid outputKey for p2tr witness");
                if (pubkey.length && !pubkey.equals(outputKey.x)) throw new TypeError("Pubkey mismatch for p2tr witness");
                if (outputKey.parity !== (controlBlock[0] & 1)) throw new Error("Incorrect parity");
            }
        }
    }
    return Object.assign(o, a);
}
module.exports.p2tr = $8416081c4ea2e910$var$p2tr;

});
parcelRegister("f6boC", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $afe04196d4a8990c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.getEccLib = module.exports.initEccLib = void 0;
const $afe04196d4a8990c$var$_ECCLIB_CACHE = {};
/**
 * Initializes the ECC library with the provided instance.
 * If `eccLib` is `undefined`, the library will be cleared.
 * If `eccLib` is a new instance, it will be verified before setting it as the active library.
 *
 * @param eccLib The instance of the ECC library to initialize.
 */ function $afe04196d4a8990c$var$initEccLib(eccLib) {
    if (!eccLib) // allow clearing the library
    $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    else if (eccLib !== $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) {
        // new instance, verify it
        $afe04196d4a8990c$var$verifyEcc(eccLib);
        $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib = eccLib;
    }
}
module.exports.initEccLib = $afe04196d4a8990c$var$initEccLib;
/**
 * Retrieves the ECC Library instance.
 * Throws an error if the ECC Library is not provided.
 * You must call initEccLib() with a valid TinySecp256k1Interface instance before calling this function.
 * @returns The ECC Library instance.
 * @throws Error if the ECC Library is not provided.
 */ function $afe04196d4a8990c$var$getEccLib() {
    if (!$afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib) throw new Error("No ECC Library provided. You must call initEccLib() with a valid TinySecp256k1Interface instance");
    return $afe04196d4a8990c$var$_ECCLIB_CACHE.eccLib;
}
module.exports.getEccLib = $afe04196d4a8990c$var$getEccLib;
const $afe04196d4a8990c$var$h = (hex)=>$afe04196d4a8990c$require$Buffer.from(hex, "hex");
/**
 * Verifies the ECC functionality.
 *
 * @param ecc - The TinySecp256k1Interface object.
 */ function $afe04196d4a8990c$var$verifyEcc(ecc) {
    $afe04196d4a8990c$var$assert(typeof ecc.isXOnlyPoint === "function");
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffeeffffc2e")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9")));
    $afe04196d4a8990c$var$assert(ecc.isXOnlyPoint($afe04196d4a8990c$var$h("0000000000000000000000000000000000000000000000000000000000000001")));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h("0000000000000000000000000000000000000000000000000000000000000000")));
    $afe04196d4a8990c$var$assert(!ecc.isXOnlyPoint($afe04196d4a8990c$var$h("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f")));
    $afe04196d4a8990c$var$assert(typeof ecc.xOnlyPointAddTweak === "function");
    $afe04196d4a8990c$var$tweakAddVectors.forEach((t)=>{
        const r = ecc.xOnlyPointAddTweak($afe04196d4a8990c$var$h(t.pubkey), $afe04196d4a8990c$var$h(t.tweak));
        if (t.result === null) $afe04196d4a8990c$var$assert(r === null);
        else {
            $afe04196d4a8990c$var$assert(r !== null);
            $afe04196d4a8990c$var$assert(r.parity === t.parity);
            $afe04196d4a8990c$var$assert($afe04196d4a8990c$require$Buffer.from(r.xOnlyPubkey).equals($afe04196d4a8990c$var$h(t.result)));
        }
    });
}
function $afe04196d4a8990c$var$assert(bool) {
    if (!bool) throw new Error("ecc library invalid");
}
const $afe04196d4a8990c$var$tweakAddVectors = [
    {
        pubkey: "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        tweak: "fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364140",
        parity: -1,
        result: null
    },
    {
        pubkey: "1617d38ed8d8657da4d4761e8057bc396ea9e4b9d29776d4be096016dbd2509b",
        tweak: "a8397a935f0dfceba6ba9618f6451ef4d80637abf4e6af2669fbc9de6a8fd2ac",
        parity: 1,
        result: "e478f99dab91052ab39a33ea35fd5e6e4933f4d28023cd597c9a1f6760346adf"
    },
    {
        pubkey: "2c0b7cf95324a07d05398b240174dc0c2be444d96b159aa6c7f7b1e668680991",
        tweak: "823c3cd2142744b075a87eade7e1b8678ba308d566226a0056ca2b7a76f86b47",
        parity: 0,
        result: "9534f8dc8c6deda2dc007655981c78b49c5d96c778fbf363462a11ec9dfd948c"
    }
];

});

parcelRegister("lzIk8", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.tweakKey = module.exports.tapTweakHash = module.exports.tapleafHash = module.exports.findScriptPath = module.exports.toHashTree = module.exports.rootHashFromPath = module.exports.MAX_TAPTREE_DEPTH = module.exports.LEAF_VERSION_TAPSCRIPT = void 0;

var $6ZWSX = parcelRequire("6ZWSX");

var $f6boC = parcelRequire("f6boC");

var $lgTFk = parcelRequire("lgTFk");

var $lMPrw = parcelRequire("lMPrw");

var $18Mz5 = parcelRequire("18Mz5");
module.exports.LEAF_VERSION_TAPSCRIPT = 0xc0;
module.exports.MAX_TAPTREE_DEPTH = 128;
const $fb4f3fa2c6b14256$var$isHashBranch = (ht)=>"left" in ht && "right" in ht;
/**
 * Calculates the root hash from a given control block and leaf hash.
 * @param controlBlock - The control block buffer.
 * @param leafHash - The leaf hash buffer.
 * @returns The root hash buffer.
 * @throws {TypeError} If the control block length is less than 33.
 */ function $fb4f3fa2c6b14256$var$rootHashFromPath(controlBlock, leafHash) {
    if (controlBlock.length < 33) throw new TypeError(`The control-block length is too small. Got ${controlBlock.length}, expected min 33.`);
    const m = (controlBlock.length - 33) / 32;
    let kj = leafHash;
    for(let j = 0; j < m; j++){
        const ej = controlBlock.slice(33 + 32 * j, 65 + 32 * j);
        if (kj.compare(ej) < 0) kj = $fb4f3fa2c6b14256$var$tapBranchHash(kj, ej);
        else kj = $fb4f3fa2c6b14256$var$tapBranchHash(ej, kj);
    }
    return kj;
}
module.exports.rootHashFromPath = $fb4f3fa2c6b14256$var$rootHashFromPath;
/**
 * Build a hash tree of merkle nodes from the scripts binary tree.
 * @param scriptTree - the tree of scripts to pairwise hash.
 */ function $fb4f3fa2c6b14256$var$toHashTree(scriptTree) {
    if ((0, $18Mz5.isTapleaf)(scriptTree)) return {
        hash: $fb4f3fa2c6b14256$var$tapleafHash(scriptTree)
    };
    const hashes = [
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[0]),
        $fb4f3fa2c6b14256$var$toHashTree(scriptTree[1])
    ];
    hashes.sort((a, b)=>a.hash.compare(b.hash));
    const [left, right] = hashes;
    return {
        hash: $fb4f3fa2c6b14256$var$tapBranchHash(left.hash, right.hash),
        left: left,
        right: right
    };
}
module.exports.toHashTree = $fb4f3fa2c6b14256$var$toHashTree;
/**
 * Given a HashTree, finds the path from a particular hash to the root.
 * @param node - the root of the tree
 * @param hash - the hash to search for
 * @returns - array of sibling hashes, from leaf (inclusive) to root
 * (exclusive) needed to prove inclusion of the specified hash. undefined if no
 * path is found
 */ function $fb4f3fa2c6b14256$var$findScriptPath(node, hash) {
    if ($fb4f3fa2c6b14256$var$isHashBranch(node)) {
        const leftPath = $fb4f3fa2c6b14256$var$findScriptPath(node.left, hash);
        if (leftPath !== undefined) return [
            ...leftPath,
            node.right.hash
        ];
        const rightPath = $fb4f3fa2c6b14256$var$findScriptPath(node.right, hash);
        if (rightPath !== undefined) return [
            ...rightPath,
            node.left.hash
        ];
    } else if (node.hash.equals(hash)) return [];
    return undefined;
}
module.exports.findScriptPath = $fb4f3fa2c6b14256$var$findScriptPath;
function $fb4f3fa2c6b14256$var$tapleafHash(leaf) {
    const version = leaf.version || module.exports.LEAF_VERSION_TAPSCRIPT;
    return $lgTFk.taggedHash("TapLeaf", $6ZWSX.Buffer.concat([
        $6ZWSX.Buffer.from([
            version
        ]),
        $fb4f3fa2c6b14256$var$serializeScript(leaf.output)
    ]));
}
module.exports.tapleafHash = $fb4f3fa2c6b14256$var$tapleafHash;
function $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h) {
    return $lgTFk.taggedHash("TapTweak", $6ZWSX.Buffer.concat(h ? [
        pubKey,
        h
    ] : [
        pubKey
    ]));
}
module.exports.tapTweakHash = $fb4f3fa2c6b14256$var$tapTweakHash;
function $fb4f3fa2c6b14256$var$tweakKey(pubKey, h) {
    if (!$6ZWSX.Buffer.isBuffer(pubKey)) return null;
    if (pubKey.length !== 32) return null;
    if (h && h.length !== 32) return null;
    const tweakHash = $fb4f3fa2c6b14256$var$tapTweakHash(pubKey, h);
    const res = (0, $f6boC.getEccLib)().xOnlyPointAddTweak(pubKey, tweakHash);
    if (!res || res.xOnlyPubkey === null) return null;
    return {
        parity: res.parity,
        x: $6ZWSX.Buffer.from(res.xOnlyPubkey)
    };
}
module.exports.tweakKey = $fb4f3fa2c6b14256$var$tweakKey;
function $fb4f3fa2c6b14256$var$tapBranchHash(a, b) {
    return $lgTFk.taggedHash("TapBranch", $6ZWSX.Buffer.concat([
        a,
        b
    ]));
}
function $fb4f3fa2c6b14256$var$serializeScript(s) {
    const varintLen = $lMPrw.varuint.encodingLength(s.length);
    const buffer = $6ZWSX.Buffer.allocUnsafe(varintLen); // better
    $lMPrw.varuint.encode(s.length, buffer);
    return $6ZWSX.Buffer.concat([
        buffer,
        s
    ]);
}

});
parcelRegister("lMPrw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $fdc5fc2bbe395f08$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.cloneBuffer = module.exports.reverseBuffer = module.exports.writeUInt64LE = module.exports.readUInt64LE = module.exports.varuint = void 0;

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $fdc5fc2bbe395f08$var$typeforce } = $18Mz5;

var $JAEWR = parcelRequire("JAEWR");
module.exports.varuint = $JAEWR;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $fdc5fc2bbe395f08$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $fdc5fc2bbe395f08$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $fdc5fc2bbe395f08$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $fdc5fc2bbe395f08$var$readUInt64LE;
/**
 * Writes a 64-bit unsigned integer in little-endian format to the specified buffer at the given offset.
 *
 * @param buffer - The buffer to write the value to.
 * @param value - The 64-bit unsigned integer value to write.
 * @param offset - The offset in the buffer where the value should be written.
 * @returns The new offset after writing the value.
 */ function $fdc5fc2bbe395f08$var$writeUInt64LE(buffer, value, offset) {
    $fdc5fc2bbe395f08$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $fdc5fc2bbe395f08$var$writeUInt64LE;
/**
 * Reverses the order of bytes in a buffer.
 * @param buffer - The buffer to reverse.
 * @returns A new buffer with the bytes reversed.
 */ function $fdc5fc2bbe395f08$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $fdc5fc2bbe395f08$var$reverseBuffer;
function $fdc5fc2bbe395f08$var$cloneBuffer(buffer) {
    const clone = $fdc5fc2bbe395f08$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
module.exports.cloneBuffer = $fdc5fc2bbe395f08$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $fdc5fc2bbe395f08$var$BufferWriter {
    static withCapacity(size) {
        return new $fdc5fc2bbe395f08$var$BufferWriter($fdc5fc2bbe395f08$require$Buffer.alloc(size));
    }
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $fdc5fc2bbe395f08$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
    end() {
        if (this.buffer.length === this.offset) return this.buffer;
        throw new Error(`buffer size ${this.buffer.length}, offset ${this.offset}`);
    }
}
module.exports.BufferWriter = $fdc5fc2bbe395f08$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $fdc5fc2bbe395f08$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $fdc5fc2bbe395f08$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $fdc5fc2bbe395f08$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $fdc5fc2bbe395f08$var$BufferReader;

});
parcelRegister("JAEWR", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $0890a3e38d1fefe2$require$Buffer = $1U9GM.Buffer;
// Number.MAX_SAFE_INTEGER
var $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER = 9007199254740991;
function $0890a3e38d1fefe2$var$checkUInt53(n) {
    if (n < 0 || n > $0890a3e38d1fefe2$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $0890a3e38d1fefe2$var$encode(number, buffer, offset) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    if (!buffer) buffer = $0890a3e38d1fefe2$require$Buffer.allocUnsafe($0890a3e38d1fefe2$var$encodingLength(number));
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (number < 0xfd) {
        buffer.writeUInt8(number, offset);
        $0890a3e38d1fefe2$var$encode.bytes = 1;
    // 16 bit
    } else if (number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 3;
    // 32 bit
    } else if (number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(number, offset + 1);
        $0890a3e38d1fefe2$var$encode.bytes = 5;
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(number >>> 0, offset + 1);
        buffer.writeUInt32LE(number / 0x100000000 | 0, offset + 5);
        $0890a3e38d1fefe2$var$encode.bytes = 9;
    }
    return buffer;
}
function $0890a3e38d1fefe2$var$decode(buffer, offset) {
    if (!$0890a3e38d1fefe2$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    var first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 1;
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        $0890a3e38d1fefe2$var$decode.bytes = 3;
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        $0890a3e38d1fefe2$var$decode.bytes = 5;
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        $0890a3e38d1fefe2$var$decode.bytes = 9;
        var lo = buffer.readUInt32LE(offset + 1);
        var hi = buffer.readUInt32LE(offset + 5);
        var number = hi * 0x0100000000 + lo;
        $0890a3e38d1fefe2$var$checkUInt53(number);
        return number;
    }
}
function $0890a3e38d1fefe2$var$encodingLength(number) {
    $0890a3e38d1fefe2$var$checkUInt53(number);
    return number < 0xfd ? 1 : number <= 0xffff ? 3 : number <= 0xffffffff ? 5 : 9;
}
module.exports = {
    encode: $0890a3e38d1fefe2$var$encode,
    decode: $0890a3e38d1fefe2$var$decode,
    encodingLength: $0890a3e38d1fefe2$var$encodingLength
};

});
parcelRegister("1U9GM", function(module, exports) {
/*! safe-buffer. MIT License. Feross Aboukhadijeh <https://feross.org/opensource> */ /* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $1632896ed805433d$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $1632896ed805433d$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($1632896ed805433d$var$Buffer.from && $1632896ed805433d$var$Buffer.alloc && $1632896ed805433d$var$Buffer.allocUnsafe && $1632896ed805433d$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $1632896ed805433d$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $1632896ed805433d$var$SafeBuffer;
}
function $1632896ed805433d$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
}
$1632896ed805433d$var$SafeBuffer.prototype = Object.create($1632896ed805433d$var$Buffer.prototype);
// Copy static methods from Buffer
$1632896ed805433d$var$copyProps($1632896ed805433d$var$Buffer, $1632896ed805433d$var$SafeBuffer);
$1632896ed805433d$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $1632896ed805433d$var$Buffer(arg, encodingOrOffset, length);
};
$1632896ed805433d$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $1632896ed805433d$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$1632896ed805433d$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $1632896ed805433d$var$Buffer(size);
};
$1632896ed805433d$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});







parcelRegister("huuL7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $cbbd191810e07df9$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Block = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $gmJA7 = parcelRequire("gmJA7");

var $gMJcK = parcelRequire("gMJcK");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $cbbd191810e07df9$var$typeforce } = $18Mz5;
const $cbbd191810e07df9$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
const $cbbd191810e07df9$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
class $cbbd191810e07df9$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const block = new $cbbd191810e07df9$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $gMJcK.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $cbbd191810e07df9$var$Block.fromBuffer($cbbd191810e07df9$require$Buffer.from(hex, "hex"));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $cbbd191810e07df9$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $cbbd191810e07df9$var$typeforce([
            {
                getHash: $18Mz5.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (forWitness && !$cbbd191810e07df9$var$txesHaveWitnessCommit(transactions)) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = (0, $gmJA7.fastMerkleRoot)(hashes, $lgTFk.hash256);
        return forWitness ? $lgTFk.hash256($cbbd191810e07df9$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$cbbd191810e07df9$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($cbbd191810e07df9$require$Buffer.from("6a24aa21a9ed", "hex"))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $cbbd191810e07df9$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $cbbd191810e07df9$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $cbbd191810e07df9$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $lMPrw.varuint.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $lgTFk.hash256(this.toBuffer(true));
    }
    getId() {
        return (0, $lMPrw.reverseBuffer)(this.getHash()).toString("hex");
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $cbbd191810e07df9$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $lMPrw.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $lMPrw.varuint.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $lMPrw.varuint.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString("hex");
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = (0, $lMPrw.reverseBuffer)(this.getHash());
        const target = $cbbd191810e07df9$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        const actualMerkleRoot = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $cbbd191810e07df9$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $cbbd191810e07df9$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $cbbd191810e07df9$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
module.exports.Block = $cbbd191810e07df9$var$Block;
function $cbbd191810e07df9$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $cbbd191810e07df9$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === "object" && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === "object" && input.witness instanceof Array && input.witness.length > 0));
}

});
parcelRegister("gmJA7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bea20efcdc27ef99$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.fastMerkleRoot = void 0;
/**
 * Calculates the Merkle root of an array of buffers using a specified digest function.
 *
 * @param values - The array of buffers.
 * @param digestFn - The digest function used to calculate the hash of the concatenated buffers.
 * @returns The Merkle root as a buffer.
 * @throws {TypeError} If the values parameter is not an array or the digestFn parameter is not a function.
 */ function $bea20efcdc27ef99$var$fastMerkleRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    let length = values.length;
    const results = values.concat();
    while(length > 1){
        let j = 0;
        for(let i = 0; i < length; i += 2, ++j){
            const left = results[i];
            const right = i + 1 === length ? left : results[i + 1];
            const data = $bea20efcdc27ef99$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
}
module.exports.fastMerkleRoot = $bea20efcdc27ef99$var$fastMerkleRoot;

});

parcelRegister("gMJcK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c38431c0153a39cb$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Transaction = void 0;

var $lMPrw = parcelRequire("lMPrw");

var $lgTFk = parcelRequire("lgTFk");

var $8wAtk = parcelRequire("8wAtk");

var $8wAtk = parcelRequire("8wAtk");

var $18Mz5 = parcelRequire("18Mz5");
const { typeforce: $c38431c0153a39cb$var$typeforce } = $18Mz5;
function $c38431c0153a39cb$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $lMPrw.varuint.encodingLength(length) + length;
}
function $c38431c0153a39cb$var$vectorSize(someVector) {
    const length = someVector.length;
    return $lMPrw.varuint.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $c38431c0153a39cb$var$varSliceSize(witness);
    }, 0);
}
const $c38431c0153a39cb$var$EMPTY_BUFFER = $c38431c0153a39cb$require$Buffer.allocUnsafe(0);
const $c38431c0153a39cb$var$EMPTY_WITNESS = [];
const $c38431c0153a39cb$var$ZERO = $c38431c0153a39cb$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
const $c38431c0153a39cb$var$ONE = $c38431c0153a39cb$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
const $c38431c0153a39cb$var$VALUE_UINT64_MAX = $c38431c0153a39cb$require$Buffer.from("ffffffffffffffff", "hex");
const $c38431c0153a39cb$var$BLANK_OUTPUT = {
    script: $c38431c0153a39cb$var$EMPTY_BUFFER,
    valueBuffer: $c38431c0153a39cb$var$VALUE_UINT64_MAX
};
function $c38431c0153a39cb$var$isOutput(out) {
    return out.value !== undefined;
}
/**
 * Represents a Bitcoin transaction.
 */ class $c38431c0153a39cb$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $lMPrw.BufferReader(buffer);
        const tx = new $c38431c0153a39cb$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
        return tx;
    }
    static fromHex(hex) {
        return $c38431c0153a39cb$var$Transaction.fromBuffer($c38431c0153a39cb$require$Buffer.from(hex, "hex"), false);
    }
    static isCoinbaseHash(buffer) {
        $c38431c0153a39cb$var$typeforce($18Mz5.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $c38431c0153a39cb$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Hash256bit, $18Mz5.UInt32, $18Mz5.maybe($18Mz5.UInt32), $18Mz5.maybe($18Mz5.Buffer)), arguments);
        if ($18Mz5.Null(sequence)) sequence = $c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $c38431c0153a39cb$var$EMPTY_BUFFER,
            sequence: sequence,
            witness: $c38431c0153a39cb$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Buffer, $18Mz5.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $lMPrw.varuint.encodingLength(this.ins.length) + $lMPrw.varuint.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $c38431c0153a39cb$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $c38431c0153a39cb$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $c38431c0153a39cb$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, /* types.UInt8 */ $18Mz5.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $c38431c0153a39cb$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $8wAtk.compile($8wAtk.decompile(prevOutScript).filter((x)=>{
            return x !== $8wAtk.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $c38431c0153a39cb$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $c38431c0153a39cb$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $c38431c0153a39cb$var$EMPTY_BUFFER;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $lgTFk.hash256(buffer);
    }
    hashForWitnessV1(inIndex, prevOutScripts, values, hashType, leafHash, annex) {
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#common-signature-message
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Buffer), $c38431c0153a39cb$var$typeforce.arrayOf($18Mz5.Satoshi), $18Mz5.UInt32), arguments);
        if (values.length !== this.ins.length || prevOutScripts.length !== this.ins.length) throw new Error("Must supply prevout script and value for all inputs");
        const outputType = hashType === $c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT ? $c38431c0153a39cb$var$Transaction.SIGHASH_ALL : hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK;
        const inputType = hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK;
        const isAnyoneCanPay = inputType === $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY;
        const isNone = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_NONE;
        const isSingle = outputType === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE;
        let hashPrevouts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashAmounts = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashScriptPubKeys = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashSequences = $c38431c0153a39cb$var$EMPTY_BUFFER;
        let hashOutputs = $c38431c0153a39cb$var$EMPTY_BUFFER;
        if (!isAnyoneCanPay) {
            let bufferWriter = $lMPrw.BufferWriter.withCapacity(36 * this.ins.length);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(8 * this.ins.length);
            values.forEach((value)=>bufferWriter.writeUInt64(value));
            hashAmounts = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(prevOutScripts.map($c38431c0153a39cb$var$varSliceSize).reduce((a, b)=>a + b));
            prevOutScripts.forEach((prevOutScript)=>bufferWriter.writeVarSlice(prevOutScript));
            hashScriptPubKeys = $lgTFk.sha256(bufferWriter.end());
            bufferWriter = $lMPrw.BufferWriter.withCapacity(4 * this.ins.length);
            this.ins.forEach((txIn)=>bufferWriter.writeUInt32(txIn.sequence));
            hashSequences = $lgTFk.sha256(bufferWriter.end());
        }
        if (!(isNone || isSingle)) {
            const txOutsSize = this.outs.map((output)=>8 + $c38431c0153a39cb$var$varSliceSize(output.script)).reduce((a, b)=>a + b);
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(txOutsSize);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        } else if (isSingle && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            const bufferWriter = $lMPrw.BufferWriter.withCapacity(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.sha256(bufferWriter.end());
        }
        const spendType = (leafHash ? 2 : 0) + (annex ? 1 : 0);
        // Length calculation from:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-14
        // With extension from:
        // https://github.com/bitcoin/bips/blob/master/bip-0342.mediawiki#signature-validation
        const sigMsgSize = 174 - (isAnyoneCanPay ? 49 : 0) - (isNone ? 32 : 0) + (annex ? 32 : 0) + (leafHash ? 37 : 0);
        const sigMsgWriter = $lMPrw.BufferWriter.withCapacity(sigMsgSize);
        sigMsgWriter.writeUInt8(hashType);
        // Transaction
        sigMsgWriter.writeInt32(this.version);
        sigMsgWriter.writeUInt32(this.locktime);
        sigMsgWriter.writeSlice(hashPrevouts);
        sigMsgWriter.writeSlice(hashAmounts);
        sigMsgWriter.writeSlice(hashScriptPubKeys);
        sigMsgWriter.writeSlice(hashSequences);
        if (!(isNone || isSingle)) sigMsgWriter.writeSlice(hashOutputs);
        // Input
        sigMsgWriter.writeUInt8(spendType);
        if (isAnyoneCanPay) {
            const input = this.ins[inIndex];
            sigMsgWriter.writeSlice(input.hash);
            sigMsgWriter.writeUInt32(input.index);
            sigMsgWriter.writeUInt64(values[inIndex]);
            sigMsgWriter.writeVarSlice(prevOutScripts[inIndex]);
            sigMsgWriter.writeUInt32(input.sequence);
        } else sigMsgWriter.writeUInt32(inIndex);
        if (annex) {
            const bufferWriter = $lMPrw.BufferWriter.withCapacity($c38431c0153a39cb$var$varSliceSize(annex));
            bufferWriter.writeVarSlice(annex);
            sigMsgWriter.writeSlice($lgTFk.sha256(bufferWriter.end()));
        }
        // Output
        if (isSingle) sigMsgWriter.writeSlice(hashOutputs);
        // BIP342 extension
        if (leafHash) {
            sigMsgWriter.writeSlice(leafHash);
            sigMsgWriter.writeUInt8(0);
            sigMsgWriter.writeUInt32(0xffffffff);
        }
        // Extra zero byte because:
        // https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_note-19
        return $lgTFk.taggedHash("TapSighash", $c38431c0153a39cb$require$Buffer.concat([
            $c38431c0153a39cb$require$Buffer.from([
                0x00
            ]),
            sigMsgWriter.end()
        ]));
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.UInt32, $18Mz5.Buffer, $18Mz5.Satoshi, $18Mz5.UInt32), arguments);
        let tbuffer = $c38431c0153a39cb$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $c38431c0153a39cb$var$ZERO;
        let hashPrevouts = $c38431c0153a39cb$var$ZERO;
        let hashSequence = $c38431c0153a39cb$var$ZERO;
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $lgTFk.hash256(tbuffer);
        }
        if (!(hashType & $c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $lgTFk.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $c38431c0153a39cb$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $c38431c0153a39cb$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $lgTFk.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(8 + $c38431c0153a39cb$var$varSliceSize(output.script));
            bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $lgTFk.hash256(tbuffer);
        }
        tbuffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(156 + $c38431c0153a39cb$var$varSliceSize(prevOutScript));
        bufferWriter = new $lMPrw.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $lgTFk.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $c38431c0153a39cb$require$Buffer.alloc(32, 0);
        return $lgTFk.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return (0, $lMPrw.reverseBuffer)(this.getHash(false)).toString("hex");
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString("hex");
    }
    setInputScript(index, scriptSig) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, $18Mz5.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $c38431c0153a39cb$var$typeforce($18Mz5.tuple($18Mz5.Number, [
            $18Mz5.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $c38431c0153a39cb$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $lMPrw.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($c38431c0153a39cb$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
module.exports.Transaction = $c38431c0153a39cb$var$Transaction;
$c38431c0153a39cb$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$c38431c0153a39cb$var$Transaction.SIGHASH_DEFAULT = 0x00;
$c38431c0153a39cb$var$Transaction.SIGHASH_ALL = 0x01;
$c38431c0153a39cb$var$Transaction.SIGHASH_NONE = 0x02;
$c38431c0153a39cb$var$Transaction.SIGHASH_SINGLE = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$c38431c0153a39cb$var$Transaction.SIGHASH_OUTPUT_MASK = 0x03;
$c38431c0153a39cb$var$Transaction.SIGHASH_INPUT_MASK = 0x80;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$c38431c0153a39cb$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;

});


parcelRegister("hXYde", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $d146a75032ca9c85$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.Psbt = void 0;

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");

var $d1wHE = parcelRequire("d1wHE");

var $lMPrw = parcelRequire("lMPrw");

var $fjh6Q = parcelRequire("fjh6Q");

var $j87lX = parcelRequire("j87lX");

var $lzIk8 = parcelRequire("lzIk8");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $7rkx8 = parcelRequire("7rkx8");

var $9txdn = parcelRequire("9txdn");
/**
 * These are the default arguments for a Psbt instance.
 */ const $d146a75032ca9c85$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $fjh6Q.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 *
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 *
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 *
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 *
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 *
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $d146a75032ca9c85$var$Psbt {
    static fromBase64(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $d146a75032ca9c85$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $d146a75032ca9c85$var$transactionFromBuffer);
        const psbt = new $d146a75032ca9c85$var$Psbt(opts, psbtBase);
        $d146a75032ca9c85$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    constructor(opts = {}, data = new $jbkDe.Psbt(new $d146a75032ca9c85$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $d146a75032ca9c85$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Psbt's predecessor (TransactionBuilder - now removed) behavior
            // was to not confirm input values  before signing.
            // Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: (0, $lMPrw.cloneBuffer)(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = (0, $d1wHE.fromOutputScript)(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: (0, $lMPrw.cloneBuffer)(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $d146a75032ca9c85$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $d146a75032ca9c85$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $d146a75032ca9c85$var$check32Bit(version);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $d146a75032ca9c85$var$check32Bit(locktime);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $d146a75032ca9c85$var$check32Bit(sequence);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        (0, $7rkx8.checkTaprootInputFields)(inputData, inputData, "addInput");
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "addInput");
        if (inputData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $d146a75032ca9c85$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $d146a75032ca9c85$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
        const { address: address } = outputData;
        if (typeof address === "string") {
            const { network: network } = this.opts;
            const script = (0, $d1wHE.toOutputScript)(address, network);
            outputData = Object.assign({}, outputData, {
                script: script
            });
        }
        (0, $7rkx8.checkTaprootOutputFields)(outputData, outputData, "addOutput");
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error("Not finalized");
        const c = this.__CACHE;
        if (!disableFeeCheck) $d146a75032ca9c85$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $d146a75032ca9c85$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $d146a75032ca9c85$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $d146a75032ca9c85$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        $d146a75032ca9c85$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, undefined, finalScriptsFunc);
        return this._finalizeInput(inputIndex, input, finalScriptsFunc);
    }
    finalizeTaprootInput(inputIndex, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc);
        throw new Error(`Cannot finalize input #${inputIndex}. Not Taproot.`);
    }
    _finalizeInput(inputIndex, input, finalScriptsFunc = $d146a75032ca9c85$var$getFinalScripts) {
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $d146a75032ca9c85$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    _finalizeTaprootInput(inputIndex, input, tapLeafHashToFinalize, finalScriptsFunc = $7rkx8.tapScriptFinalizer) {
        if (!input.witnessUtxo) throw new Error(`Cannot finalize input #${inputIndex}. Missing withness utxo.`);
        // Check key spend first. Increased privacy and reduced block space.
        if (input.tapKeySig) {
            const payment = $j87lX.p2tr({
                output: input.witnessUtxo.script,
                signature: input.tapKeySig
            });
            const finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        } else {
            const { finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, tapLeafHashToFinalize);
            this.data.updateInput(inputIndex, {
                finalScriptWitness: finalScriptWitness
            });
        }
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $d146a75032ca9c85$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $d146a75032ca9c85$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === "raw" ? "" : result.type + "-";
        const mainType = $d146a75032ca9c85$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        return $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        return $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = (0, $geRUU.checkForOutput)(this.data.outputs, outputIndex);
        const derivationIsMine = $d146a75032ca9c85$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs(validator) {
        (0, $geRUU.checkForInput)(this.data.inputs, 0); // making sure we have at least one
        const results = $d146a75032ca9c85$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx, validator));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        if ((0, $7rkx8.isTaprootInput)(input)) return this.validateSignaturesOfTaprootInput(inputIndex, validator, pubkey);
        return this._validateSignaturesOfInput(inputIndex, validator, pubkey);
    }
    _validateSignaturesOfInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
        if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $8wAtk.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $d146a75032ca9c85$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $d146a75032ca9c85$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
            results.push(validator(pSig.pubkey, hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    validateSignaturesOfTaprootInput(inputIndex, validator, pubkey) {
        const input = this.data.inputs[inputIndex];
        const tapKeySig = (input || {}).tapKeySig;
        const tapScriptSig = (input || {}).tapScriptSig;
        if (!input && !tapKeySig && !(tapScriptSig && !tapScriptSig.length)) throw new Error("No signatures to validate");
        if (typeof validator !== "function") throw new Error("Need validator function to validate signatures");
        pubkey = pubkey && (0, $7rkx8.toXOnly)(pubkey);
        const allHashses = pubkey ? $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, pubkey, this.__CACHE) : $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, this.data.inputs, this.__CACHE);
        if (!allHashses.length) throw new Error("No signatures for this pubkey");
        const tapKeyHash = allHashses.find((h)=>!h.leafHash);
        let validationResultCount = 0;
        if (tapKeySig && tapKeyHash) {
            const isValidTapkeySig = validator(tapKeyHash.pubkey, tapKeyHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapKeySig));
            if (!isValidTapkeySig) return false;
            validationResultCount++;
        }
        if (tapScriptSig) for (const tapSig of tapScriptSig){
            const tapSigHash = allHashses.find((h)=>tapSig.pubkey.equals(h.pubkey));
            if (tapSigHash) {
                const isValidTapScriptSig = validator(tapSig.pubkey, tapSigHash.hash, $d146a75032ca9c85$var$trimTaprootSig(tapSig.signature));
                if (!isValidTapScriptSig) return false;
                validationResultCount++;
            }
        }
        return validationResultCount > 0;
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const results = [];
            const promises = [];
            for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const signers = $d146a75032ca9c85$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $d146a75032ca9c85$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, undefined, sighashTypes);
        return this._signInput(inputIndex, keyPair, sighashTypes);
    }
    signTaprootInput(inputIndex, keyPair, tapLeafHashToSign, sighashTypes) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
        if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, sighashTypes);
        throw new Error(`Input #${inputIndex} is not of type Taproot.`);
    }
    _signInput(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $8wAtk.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    _signTaprootInput(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes);
        const tapKeySig = hashesForSig.filter((h)=>!h.leafHash).map((h)=>(0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType))[0];
        const tapScriptSig = hashesForSig.filter((h)=>!!h.leafHash).map((h)=>({
                pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                signature: (0, $7rkx8.serializeTaprootSignature)(keyPair.signSchnorr(h.hash), input.sighashType),
                leafHash: h.leafHash
            }));
        if (tapKeySig) this.data.updateInput(inputIndex, {
            tapKeySig: tapKeySig
        });
        if (tapScriptSig.length) this.data.updateInput(inputIndex, {
            tapScriptSig: tapScriptSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, undefined, sighashTypes);
            return this._signInputAsync(inputIndex, keyPair, sighashTypes);
        });
    }
    signTaprootInputAsync(inputIndex, keyPair, tapLeafHash, sighashTypes) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const input = (0, $geRUU.checkForInput)(this.data.inputs, inputIndex);
            if ((0, $7rkx8.isTaprootInput)(input)) return this._signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
            throw new Error(`Input #${inputIndex} is not of type Taproot.`);
        });
    }
    _signInputAsync(inputIndex, keyPair, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_ALL
    ]) {
        const { hash: hash, sighashType: sighashType } = $d146a75032ca9c85$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
            const partialSig = [
                {
                    pubkey: keyPair.publicKey,
                    signature: $8wAtk.signature.encode(signature, sighashType)
                }
            ];
            this.data.updateInput(inputIndex, {
                partialSig: partialSig
            });
        });
    }
    async _signTaprootInputAsync(inputIndex, input, keyPair, tapLeafHash, sighashTypes = [
        $gMJcK.Transaction.SIGHASH_DEFAULT
    ]) {
        const hashesForSig = this.checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHash, sighashTypes);
        const signaturePromises = [];
        const tapKeyHash = hashesForSig.filter((h)=>!h.leafHash)[0];
        if (tapKeyHash) {
            const tapKeySigPromise = Promise.resolve(keyPair.signSchnorr(tapKeyHash.hash)).then((sig)=>{
                return {
                    tapKeySig: (0, $7rkx8.serializeTaprootSignature)(sig, input.sighashType)
                };
            });
            signaturePromises.push(tapKeySigPromise);
        }
        const tapScriptHashes = hashesForSig.filter((h)=>!!h.leafHash);
        if (tapScriptHashes.length) {
            const tapScriptSigPromises = tapScriptHashes.map((tsh)=>{
                return Promise.resolve(keyPair.signSchnorr(tsh.hash)).then((signature)=>{
                    const tapScriptSig = [
                        {
                            pubkey: (0, $7rkx8.toXOnly)(keyPair.publicKey),
                            signature: (0, $7rkx8.serializeTaprootSignature)(signature, input.sighashType),
                            leafHash: tsh.leafHash
                        }
                    ];
                    return {
                        tapScriptSig: tapScriptSig
                    };
                });
            });
            signaturePromises.push(...tapScriptSigPromises);
        }
        return Promise.all(signaturePromises).then((results)=>{
            results.forEach((v)=>this.data.updateInput(inputIndex, v));
        });
    }
    checkTaprootHashesForSig(inputIndex, input, keyPair, tapLeafHashToSign, allowedSighashTypes) {
        if (typeof keyPair.signSchnorr !== "function") throw new Error(`Need Schnorr Signer to sign taproot input #${inputIndex}.`);
        const hashesForSig = $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, this.data.inputs, keyPair.publicKey, this.__CACHE, tapLeafHashToSign, allowedSighashTypes);
        if (!hashesForSig || !hashesForSig.length) throw new Error(`Can not sign for input #${inputIndex} with the key ${keyPair.publicKey.toString("hex")}`);
        return hashesForSig;
    }
    toBuffer() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $d146a75032ca9c85$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $d146a75032ca9c85$var$checkInvalidP2WSH(updateData.witnessScript);
        (0, $7rkx8.checkTaprootInputFields)(this.data.inputs[inputIndex], updateData, "updateInput");
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $d146a75032ca9c85$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const outputData = this.data.outputs[outputIndex];
        (0, $7rkx8.checkTaprootOutputFields)(outputData, updateData, "updateOutput");
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
module.exports.Psbt = $d146a75032ca9c85$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $d146a75032ca9c85$var$transactionFromBuffer = (buffer)=>new $d146a75032ca9c85$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $d146a75032ca9c85$var$PsbtTransaction {
    constructor(buffer = $d146a75032ca9c85$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $gMJcK.Transaction.fromBuffer(buffer);
        $d146a75032ca9c85$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
        const hash = typeof input.hash === "string" ? (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash, "hex")) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$d146a75032ca9c85$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $d146a75032ca9c85$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $d146a75032ca9c85$var$hasSigs(1, input.partialSig);
        case "multisig":
            const p2ms = $j87lX.p2ms({
                output: script
            });
            return $d146a75032ca9c85$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $d146a75032ca9c85$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $d146a75032ca9c85$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $d146a75032ca9c85$var$compressPubkey(pkey);
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $d146a75032ca9c85$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $d146a75032ca9c85$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $d146a75032ca9c85$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $d146a75032ca9c85$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $d146a75032ca9c85$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        const throws = (0, $7rkx8.isTaprootInput)(input) ? (0, $7rkx8.checkTaprootInputForSigs)(input, action) : (0, $9txdn.checkInputForSig)(input, action);
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $d146a75032ca9c85$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $8wAtk.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, action) {
    if (!(0, $9txdn.pubkeyInScript)(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString("hex")}`);
}
function $d146a75032ca9c85$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $d146a75032ca9c85$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $d146a75032ca9c85$var$checkTxInputCache(cache, input);
    });
}
function $d146a75032ca9c85$var$checkTxInputCache(cache, input) {
    const key = (0, $lMPrw.reverseBuffer)($d146a75032ca9c85$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $d146a75032ca9c85$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $d146a75032ca9c85$var$checkRedeemScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2sh, "Redeem script");
const $d146a75032ca9c85$var$checkWitnessScript = $d146a75032ca9c85$var$scriptCheckerFactory($j87lX.p2wsh, "Witness script");
function $d146a75032ca9c85$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($d146a75032ca9c85$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $d146a75032ca9c85$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $d146a75032ca9c85$var$classifyScript(script);
    if (!$d146a75032ca9c85$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $d146a75032ca9c85$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $j87lX.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $j87lX.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(p2wsh.witness);
        else finalScriptWitness = (0, $9txdn.witnessStackToScriptWitness)(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $d146a75032ca9c85$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $d146a75032ca9c85$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $d146a75032ca9c85$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_ALL;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes);
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    const { meaningfulScript: meaningfulScript, type: type } = $d146a75032ca9c85$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript);
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ((0, $9txdn.isP2WPKH)(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $j87lX.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString("hex")}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as Psbt's predecessor (TransactionBuilder - now removed) when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $d146a75032ca9c85$var$getAllTaprootHashesForSig(inputIndex, input, inputs, cache) {
    const allPublicKeys = [];
    if (input.tapInternalKey) {
        const key = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache);
        if (key) allPublicKeys.push(key);
    }
    if (input.tapScriptSig) {
        const tapScriptPubkeys = input.tapScriptSig.map((tss)=>tss.pubkey);
        allPublicKeys.push(...tapScriptPubkeys);
    }
    const allHashes = allPublicKeys.map((pubicKey)=>$d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubicKey, cache));
    return allHashes.flat();
}
function $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return (0, $9txdn.isP2TR)(script) ? script.subarray(2, 34) : null;
}
function $d146a75032ca9c85$var$trimTaprootSig(signature) {
    return signature.length === 64 ? signature : signature.subarray(0, 64);
}
function $d146a75032ca9c85$var$getTaprootHashesForSig(inputIndex, input, inputs, pubkey, cache, tapLeafHashToSign, allowedSighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $gMJcK.Transaction.SIGHASH_DEFAULT;
    $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, allowedSighashTypes);
    const prevOuts = inputs.map((i, index)=>$d146a75032ca9c85$var$getScriptAndAmountFromUtxo(index, i, cache));
    const signingScripts = prevOuts.map((o)=>o.script);
    const values = prevOuts.map((o)=>o.value);
    const hashes = [];
    if (input.tapInternalKey && !tapLeafHashToSign) {
        const outputKey = $d146a75032ca9c85$var$getPrevoutTaprootKey(inputIndex, input, cache) || $d146a75032ca9c85$require$Buffer.from([]);
        if ((0, $7rkx8.toXOnly)(pubkey).equals(outputKey)) {
            const tapKeyHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType);
            hashes.push({
                pubkey: pubkey,
                hash: tapKeyHash
            });
        }
    }
    const tapLeafHashes = (input.tapLeafScript || []).filter((tapLeaf)=>(0, $9txdn.pubkeyInScript)(pubkey, tapLeaf.script)).map((tapLeaf)=>{
        const hash = (0, $lzIk8.tapleafHash)({
            output: tapLeaf.script,
            version: tapLeaf.leafVersion
        });
        return Object.assign({
            hash: hash
        }, tapLeaf);
    }).filter((tapLeaf)=>!tapLeafHashToSign || tapLeafHashToSign.equals(tapLeaf.hash)).map((tapLeaf)=>{
        const tapScriptHash = unsignedTx.hashForWitnessV1(inputIndex, signingScripts, values, sighashType, tapLeaf.hash);
        return {
            pubkey: pubkey,
            hash: tapScriptHash,
            leafHash: tapLeaf.hash
        };
    });
    return hashes.concat(tapLeafHashes);
}
function $d146a75032ca9c85$var$checkSighashTypeAllowed(sighashType, sighashTypes) {
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $d146a75032ca9c85$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
}
function $d146a75032ca9c85$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case "multisig":
            const sigs = $d146a75032ca9c85$var$getSortedSigs(script, partialSig);
            payment = $j87lX.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $j87lX.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $j87lX.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $j87lX.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $d146a75032ca9c85$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || (0, $9txdn.isP2WPKH)(res.script)) res.isSegwit = true;
    return res;
}
function $d146a75032ca9c85$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = (0, $geRUU.checkForInput)(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $d146a75032ca9c85$var$getSortedSigs(script, partialSig) {
    const p2ms = $j87lX.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $d146a75032ca9c85$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $d146a75032ca9c85$var$sighashTypeToString(sighashType) {
    let text = sighashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $gMJcK.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $gMJcK.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $d146a75032ca9c85$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $d146a75032ca9c85$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache) {
    const { script: script } = $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache);
    return script;
}
function $d146a75032ca9c85$var$getScriptAndAmountFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return {
        script: input.witnessUtxo.script,
        value: input.witnessUtxo.value
    };
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $d146a75032ca9c85$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const o = nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index];
        return {
            script: o.script,
            value: o.value
        };
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $d146a75032ca9c85$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $d146a75032ca9c85$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $d146a75032ca9c85$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript);
    return (0, $9txdn.pubkeyInScript)(pubkey, meaningfulScript);
}
function $d146a75032ca9c85$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $8wAtk.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$d146a75032ca9c85$require$Buffer.isBuffer(lastItem) || $d146a75032ca9c85$var$isPubkeyLike(lastItem) || $d146a75032ca9c85$var$isSigLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $d146a75032ca9c85$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($d146a75032ca9c85$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $8wAtk.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $d146a75032ca9c85$var$compressPubkey(pubkey) {
    if (pubkey.length === 65) {
        const parity = pubkey[64] & 1;
        const newKey = pubkey.slice(0, 33);
        newKey[0] = 2 | parity;
        return newKey;
    }
    return pubkey.slice();
}
function $d146a75032ca9c85$var$isPubkeyLike(buf) {
    return buf.length === 33 && $8wAtk.isCanonicalPubKey(buf);
}
function $d146a75032ca9c85$var$isSigLike(buf) {
    return $8wAtk.isCanonicalScriptSignature(buf);
}
function $d146a75032ca9c85$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = (0, $9txdn.isP2SHScript)(script);
    const isP2SHP2WSH = isP2SH && redeemScript && (0, $9txdn.isP2WSHScript)(redeemScript);
    const isP2WSH = (0, $9txdn.isP2WSHScript)(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
        $d146a75032ca9c85$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $d146a75032ca9c85$var$checkWitnessScript(index, script, witnessScript, ioType);
        $d146a75032ca9c85$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $d146a75032ca9c85$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $d146a75032ca9c85$var$checkInvalidP2WSH(script) {
    if ((0, $9txdn.isP2WPKH)(script) || (0, $9txdn.isP2SHScript)(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $d146a75032ca9c85$var$classifyScript(script) {
    if ((0, $9txdn.isP2WPKH)(script)) return "witnesspubkeyhash";
    if ((0, $9txdn.isP2PKH)(script)) return "pubkeyhash";
    if ((0, $9txdn.isP2MS)(script)) return "multisig";
    if ((0, $9txdn.isP2PK)(script)) return "pubkey";
    return "nonstandard";
}
function $d146a75032ca9c85$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}

});
parcelRegister("jbkDe", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $df6f0c6de5015d92$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $kO5Vi = parcelRequire("kO5Vi");

var $8Damr = parcelRequire("8Damr");

var $qpq9i = parcelRequire("qpq9i");

var $geRUU = parcelRequire("geRUU");
class $df6f0c6de5015d92$var$Psbt {
    constructor(tx){
        this.inputs = [];
        this.outputs = [];
        this.globalMap = {
            unsignedTx: tx
        };
    }
    static fromBase64(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromHex(data, txFromBuffer) {
        const buffer = $df6f0c6de5015d92$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, txFromBuffer);
    }
    static fromBuffer(buffer, txFromBuffer) {
        const results = $8Damr.psbtFromBuffer(buffer, txFromBuffer);
        const psbt = new this(results.globalMap.unsignedTx);
        Object.assign(psbt, results);
        return psbt;
    }
    toBase64() {
        const buffer = this.toBuffer();
        return buffer.toString("base64");
    }
    toHex() {
        const buffer = this.toBuffer();
        return buffer.toString("hex");
    }
    toBuffer() {
        return $8Damr.psbtToBuffer(this);
    }
    updateGlobal(updateData) {
        $geRUU.updateGlobal(updateData, this.globalMap);
        return this;
    }
    updateInput(inputIndex, updateData) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.updateInput(updateData, input);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.updateOutput(updateData, output);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        $geRUU.checkHasKey(keyVal, this.globalMap.unknownKeyVals, $geRUU.getEnumLength($qpq9i.GlobalTypes));
        if (!this.globalMap.unknownKeyVals) this.globalMap.unknownKeyVals = [];
        this.globalMap.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.checkHasKey(keyVal, input.unknownKeyVals, $geRUU.getEnumLength($qpq9i.InputTypes));
        if (!input.unknownKeyVals) input.unknownKeyVals = [];
        input.unknownKeyVals.push(keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        const output = $geRUU.checkForOutput(this.outputs, outputIndex);
        $geRUU.checkHasKey(keyVal, output.unknownKeyVals, $geRUU.getEnumLength($qpq9i.OutputTypes));
        if (!output.unknownKeyVals) output.unknownKeyVals = [];
        output.unknownKeyVals.push(keyVal);
        return this;
    }
    addInput(inputData) {
        this.globalMap.unsignedTx.addInput(inputData);
        this.inputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = inputData.unknownKeyVals || [];
        const inputIndex = this.inputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToInput(inputIndex, keyVal));
        $geRUU.addInputAttributes(this.inputs, inputData);
        return this;
    }
    addOutput(outputData) {
        this.globalMap.unsignedTx.addOutput(outputData);
        this.outputs.push({
            unknownKeyVals: []
        });
        const addKeyVals = outputData.unknownKeyVals || [];
        const outputIndex = this.outputs.length - 1;
        if (!Array.isArray(addKeyVals)) throw new Error("unknownKeyVals must be an Array");
        addKeyVals.forEach((keyVal)=>this.addUnknownKeyValToOutput(outputIndex, keyVal));
        $geRUU.addOutputAttributes(this.outputs, outputData);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        const input = $geRUU.checkForInput(this.inputs, inputIndex);
        $geRUU.inputCheckUncleanFinalized(inputIndex, input);
        for (const key of Object.keys(input))if (![
            "witnessUtxo",
            "nonWitnessUtxo",
            "finalScriptSig",
            "finalScriptWitness",
            "unknownKeyVals"
        ].includes(key)) // @ts-ignore
        delete input[key];
        return this;
    }
    combine(...those) {
        // Combine this with those.
        // Return self for chaining.
        const result = $kO5Vi.combine([
            this
        ].concat(those));
        Object.assign(this, result);
        return this;
    }
    getTransaction() {
        return this.globalMap.unsignedTx.toBuffer();
    }
}
module.exports.Psbt = $df6f0c6de5015d92$var$Psbt;

});
parcelRegister("kO5Vi", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $8Damr = parcelRequire("8Damr");
function $f25d125ea4ac600e$var$combine(psbts) {
    const self = psbts[0];
    const selfKeyVals = $8Damr.psbtToKeyVals(self);
    const others = psbts.slice(1);
    if (others.length === 0) throw new Error("Combine: Nothing to combine");
    const selfTx = $f25d125ea4ac600e$var$getTx(self);
    if (selfTx === undefined) throw new Error("Combine: Self missing transaction");
    const selfGlobalSet = $f25d125ea4ac600e$var$getKeySet(selfKeyVals.globalKeyVals);
    const selfInputSets = selfKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    const selfOutputSets = selfKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
    for (const other of others){
        const otherTx = $f25d125ea4ac600e$var$getTx(other);
        if (otherTx === undefined || !otherTx.toBuffer().equals(selfTx.toBuffer())) throw new Error("Combine: One of the Psbts does not have the same transaction.");
        const otherKeyVals = $8Damr.psbtToKeyVals(other);
        const otherGlobalSet = $f25d125ea4ac600e$var$getKeySet(otherKeyVals.globalKeyVals);
        otherGlobalSet.forEach($f25d125ea4ac600e$var$keyPusher(selfGlobalSet, selfKeyVals.globalKeyVals, otherKeyVals.globalKeyVals));
        const otherInputSets = otherKeyVals.inputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherInputSets.forEach((inputSet, idx)=>inputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfInputSets[idx], selfKeyVals.inputKeyVals[idx], otherKeyVals.inputKeyVals[idx])));
        const otherOutputSets = otherKeyVals.outputKeyVals.map($f25d125ea4ac600e$var$getKeySet);
        otherOutputSets.forEach((outputSet, idx)=>outputSet.forEach($f25d125ea4ac600e$var$keyPusher(selfOutputSets[idx], selfKeyVals.outputKeyVals[idx], otherKeyVals.outputKeyVals[idx])));
    }
    return $8Damr.psbtFromKeyVals(selfTx, {
        globalMapKeyVals: selfKeyVals.globalKeyVals,
        inputKeyVals: selfKeyVals.inputKeyVals,
        outputKeyVals: selfKeyVals.outputKeyVals
    });
}
module.exports.combine = $f25d125ea4ac600e$var$combine;
function $f25d125ea4ac600e$var$keyPusher(selfSet, selfKeyVals, otherKeyVals) {
    return (key)=>{
        if (selfSet.has(key)) return;
        const newKv = otherKeyVals.filter((kv)=>kv.key.toString("hex") === key)[0];
        selfKeyVals.push(newKv);
        selfSet.add(key);
    };
}
function $f25d125ea4ac600e$var$getTx(psbt) {
    return psbt.globalMap.unsignedTx;
}
function $f25d125ea4ac600e$var$getKeySet(keyVals) {
    const set = new Set();
    keyVals.forEach((keyVal)=>{
        const hex = keyVal.key.toString("hex");
        if (set.has(hex)) throw new Error("Combine: KeyValue Map keys should be unique");
        set.add(hex);
    });
    return set;
}

});
parcelRegister("8Damr", function(module, exports) {
"use strict";
function $648a00b25642ba5f$var$__export(m) {
    for(var p in m)if (!module.exports.hasOwnProperty(p)) module.exports[p] = m[p];
}
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

$648a00b25642ba5f$var$__export((parcelRequire("8zyJG")));

$648a00b25642ba5f$var$__export((parcelRequire("iWOny")));

});
parcelRegister("8zyJG", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $63dc896e08abdb53$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");

var $qpq9i = parcelRequire("qpq9i");
function $63dc896e08abdb53$var$psbtFromBuffer(buffer, txGetter) {
    let offset = 0;
    function varSlice() {
        const keyLen = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.encodingLength(keyLen);
        const key = buffer.slice(offset, offset + keyLen);
        offset += keyLen;
        return key;
    }
    function readUInt32BE() {
        const num = buffer.readUInt32BE(offset);
        offset += 4;
        return num;
    }
    function readUInt8() {
        const num = buffer.readUInt8(offset);
        offset += 1;
        return num;
    }
    function getKeyValue() {
        const key = varSlice();
        const value = varSlice();
        return {
            key: key,
            value: value
        };
    }
    function checkEndOfKeyValPairs() {
        if (offset >= buffer.length) throw new Error("Format Error: Unexpected End of PSBT");
        const isEnd = buffer.readUInt8(offset) === 0;
        if (isEnd) offset++;
        return isEnd;
    }
    if (readUInt32BE() !== 0x70736274) throw new Error("Format Error: Invalid Magic Number");
    if (readUInt8() !== 0xff) throw new Error("Format Error: Magic Number must be followed by 0xff separator");
    const globalMapKeyVals = [];
    const globalKeyIndex = {};
    while(!checkEndOfKeyValPairs()){
        const keyVal = getKeyValue();
        const hexKey = keyVal.key.toString("hex");
        if (globalKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for global keymap: key " + hexKey);
        globalKeyIndex[hexKey] = 1;
        globalMapKeyVals.push(keyVal);
    }
    const unsignedTxMaps = globalMapKeyVals.filter((keyVal)=>keyVal.key[0] === $qpq9i.GlobalTypes.UNSIGNED_TX);
    if (unsignedTxMaps.length !== 1) throw new Error("Format Error: Only one UNSIGNED_TX allowed");
    const unsignedTx = txGetter(unsignedTxMaps[0].value);
    // Get input and output counts to loop the respective fields
    const { inputCount: inputCount, outputCount: outputCount } = unsignedTx.getInputOutputCounts();
    const inputKeyVals = [];
    const outputKeyVals = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const inputKeyIndex = {};
        const input = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (inputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each input: input index " + index + " key " + hexKey);
            inputKeyIndex[hexKey] = 1;
            input.push(keyVal);
        }
        inputKeyVals.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const outputKeyIndex = {};
        const output = [];
        while(!checkEndOfKeyValPairs()){
            const keyVal = getKeyValue();
            const hexKey = keyVal.key.toString("hex");
            if (outputKeyIndex[hexKey]) throw new Error("Format Error: Keys must be unique for each output: output index " + index + " key " + hexKey);
            outputKeyIndex[hexKey] = 1;
            output.push(keyVal);
        }
        outputKeyVals.push(output);
    }
    return $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, {
        globalMapKeyVals: globalMapKeyVals,
        inputKeyVals: inputKeyVals,
        outputKeyVals: outputKeyVals
    });
}
module.exports.psbtFromBuffer = $63dc896e08abdb53$var$psbtFromBuffer;
function $63dc896e08abdb53$var$checkKeyBuffer(type, keyBuf, keyNum) {
    if (!keyBuf.equals($63dc896e08abdb53$require$Buffer.from([
        keyNum
    ]))) throw new Error(`Format Error: Invalid ${type} key: ${keyBuf.toString("hex")}`);
}
module.exports.checkKeyBuffer = $63dc896e08abdb53$var$checkKeyBuffer;
function $63dc896e08abdb53$var$psbtFromKeyVals(unsignedTx, { globalMapKeyVals: globalMapKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals }) {
    // That was easy :-)
    const globalMap = {
        unsignedTx: unsignedTx
    };
    let txCount = 0;
    for (const keyVal of globalMapKeyVals)// If a globalMap item needs pubkey, uncomment
    // const pubkey = convert.globals.checkPubkey(keyVal);
    switch(keyVal.key[0]){
        case $qpq9i.GlobalTypes.UNSIGNED_TX:
            $63dc896e08abdb53$var$checkKeyBuffer("global", keyVal.key, $qpq9i.GlobalTypes.UNSIGNED_TX);
            if (txCount > 0) throw new Error("Format Error: GlobalMap has multiple UNSIGNED_TX");
            txCount++;
            break;
        case $qpq9i.GlobalTypes.GLOBAL_XPUB:
            if (globalMap.globalXpub === undefined) globalMap.globalXpub = [];
            globalMap.globalXpub.push($7H7c4.globals.globalXpub.decode(keyVal));
            break;
        default:
            // This will allow inclusion during serialization.
            if (!globalMap.unknownKeyVals) globalMap.unknownKeyVals = [];
            globalMap.unknownKeyVals.push(keyVal);
    }
    // Get input and output counts to loop the respective fields
    const inputCount = inputKeyVals.length;
    const outputCount = outputKeyVals.length;
    const inputs = [];
    const outputs = [];
    // Get input fields
    for (const index of $3cFg7.range(inputCount)){
        const input = {};
        for (const keyVal of inputKeyVals[index]){
            $7H7c4.inputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.InputTypes.NON_WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.NON_WITNESS_UTXO);
                    if (input.nonWitnessUtxo !== undefined) throw new Error("Format Error: Input has multiple NON_WITNESS_UTXO");
                    input.nonWitnessUtxo = $7H7c4.inputs.nonWitnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_UTXO:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.WITNESS_UTXO);
                    if (input.witnessUtxo !== undefined) throw new Error("Format Error: Input has multiple WITNESS_UTXO");
                    input.witnessUtxo = $7H7c4.inputs.witnessUtxo.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.PARTIAL_SIG:
                    if (input.partialSig === undefined) input.partialSig = [];
                    input.partialSig.push($7H7c4.inputs.partialSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.SIGHASH_TYPE:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.SIGHASH_TYPE);
                    if (input.sighashType !== undefined) throw new Error("Format Error: Input has multiple SIGHASH_TYPE");
                    input.sighashType = $7H7c4.inputs.sighashType.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.REDEEM_SCRIPT);
                    if (input.redeemScript !== undefined) throw new Error("Format Error: Input has multiple REDEEM_SCRIPT");
                    input.redeemScript = $7H7c4.inputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.WITNESS_SCRIPT);
                    if (input.witnessScript !== undefined) throw new Error("Format Error: Input has multiple WITNESS_SCRIPT");
                    input.witnessScript = $7H7c4.inputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.BIP32_DERIVATION:
                    if (input.bip32Derivation === undefined) input.bip32Derivation = [];
                    input.bip32Derivation.push($7H7c4.inputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTSIG:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTSIG);
                    input.finalScriptSig = $7H7c4.inputs.finalScriptSig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.FINAL_SCRIPTWITNESS:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.FINAL_SCRIPTWITNESS);
                    input.finalScriptWitness = $7H7c4.inputs.finalScriptWitness.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.POR_COMMITMENT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.POR_COMMITMENT);
                    input.porCommitment = $7H7c4.inputs.porCommitment.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_KEY_SIG:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_KEY_SIG);
                    input.tapKeySig = $7H7c4.inputs.tapKeySig.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_SCRIPT_SIG:
                    if (input.tapScriptSig === undefined) input.tapScriptSig = [];
                    input.tapScriptSig.push($7H7c4.inputs.tapScriptSig.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_LEAF_SCRIPT:
                    if (input.tapLeafScript === undefined) input.tapLeafScript = [];
                    input.tapLeafScript.push($7H7c4.inputs.tapLeafScript.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_BIP32_DERIVATION:
                    if (input.tapBip32Derivation === undefined) input.tapBip32Derivation = [];
                    input.tapBip32Derivation.push($7H7c4.inputs.tapBip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.InputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_INTERNAL_KEY);
                    input.tapInternalKey = $7H7c4.inputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.InputTypes.TAP_MERKLE_ROOT:
                    $63dc896e08abdb53$var$checkKeyBuffer("input", keyVal.key, $qpq9i.InputTypes.TAP_MERKLE_ROOT);
                    input.tapMerkleRoot = $7H7c4.inputs.tapMerkleRoot.decode(keyVal);
                    break;
                default:
                    // This will allow inclusion during serialization.
                    if (!input.unknownKeyVals) input.unknownKeyVals = [];
                    input.unknownKeyVals.push(keyVal);
            }
        }
        inputs.push(input);
    }
    for (const index of $3cFg7.range(outputCount)){
        const output = {};
        for (const keyVal of outputKeyVals[index]){
            $7H7c4.outputs.checkPubkey(keyVal);
            switch(keyVal.key[0]){
                case $qpq9i.OutputTypes.REDEEM_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.REDEEM_SCRIPT);
                    if (output.redeemScript !== undefined) throw new Error("Format Error: Output has multiple REDEEM_SCRIPT");
                    output.redeemScript = $7H7c4.outputs.redeemScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.WITNESS_SCRIPT:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.WITNESS_SCRIPT);
                    if (output.witnessScript !== undefined) throw new Error("Format Error: Output has multiple WITNESS_SCRIPT");
                    output.witnessScript = $7H7c4.outputs.witnessScript.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.BIP32_DERIVATION:
                    if (output.bip32Derivation === undefined) output.bip32Derivation = [];
                    output.bip32Derivation.push($7H7c4.outputs.bip32Derivation.decode(keyVal));
                    break;
                case $qpq9i.OutputTypes.TAP_INTERNAL_KEY:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.TAP_INTERNAL_KEY);
                    output.tapInternalKey = $7H7c4.outputs.tapInternalKey.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_TREE:
                    $63dc896e08abdb53$var$checkKeyBuffer("output", keyVal.key, $qpq9i.OutputTypes.TAP_TREE);
                    output.tapTree = $7H7c4.outputs.tapTree.decode(keyVal);
                    break;
                case $qpq9i.OutputTypes.TAP_BIP32_DERIVATION:
                    if (output.tapBip32Derivation === undefined) output.tapBip32Derivation = [];
                    output.tapBip32Derivation.push($7H7c4.outputs.tapBip32Derivation.decode(keyVal));
                    break;
                default:
                    if (!output.unknownKeyVals) output.unknownKeyVals = [];
                    output.unknownKeyVals.push(keyVal);
            }
        }
        outputs.push(output);
    }
    return {
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    };
}
module.exports.psbtFromKeyVals = $63dc896e08abdb53$var$psbtFromKeyVals;

});
parcelRegister("7H7c4", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $2M3mP = parcelRequire("2M3mP");

var $9CSLb = parcelRequire("9CSLb");

var $bHI13 = parcelRequire("bHI13");

var $gsMQz = parcelRequire("gsMQz");

var $fmNoO = parcelRequire("fmNoO");

var $9vZgw = parcelRequire("9vZgw");

var $ckVfp = parcelRequire("ckVfp");

var $eOKUK = parcelRequire("eOKUK");

var $bn4w6 = parcelRequire("bn4w6");

var $gJHsk = parcelRequire("gJHsk");

var $gOgEP = parcelRequire("gOgEP");

var $fvNw3 = parcelRequire("fvNw3");

var $eweRk = parcelRequire("eweRk");

var $jO9dJ = parcelRequire("jO9dJ");

var $7YFpq = parcelRequire("7YFpq");

var $iVrTH = parcelRequire("iVrTH");

var $62Nv9 = parcelRequire("62Nv9");

var $3RTes = parcelRequire("3RTes");

var $1Ya0J = parcelRequire("1Ya0J");

var $kSfZv = parcelRequire("kSfZv");
const $59a221109c575e6a$var$globals = {
    unsignedTx: $9CSLb,
    globalXpub: $2M3mP,
    // pass an Array of key bytes that require pubkey beside the key
    checkPubkey: $iVrTH.makeChecker([])
};
module.exports.globals = $59a221109c575e6a$var$globals;
const $59a221109c575e6a$var$inputs = {
    nonWitnessUtxo: $fmNoO,
    partialSig: $9vZgw,
    sighashType: $eOKUK,
    finalScriptSig: $bHI13,
    finalScriptWitness: $gsMQz,
    porCommitment: $ckVfp,
    witnessUtxo: $eweRk,
    bip32Derivation: $7YFpq.makeConverter($qpq9i.InputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.InputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.InputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.InputTypes.PARTIAL_SIG,
        $qpq9i.InputTypes.BIP32_DERIVATION
    ]),
    tapKeySig: $bn4w6,
    tapScriptSig: $fvNw3,
    tapLeafScript: $gJHsk,
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.InputTypes.TAP_BIP32_DERIVATION),
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.InputTypes.TAP_INTERNAL_KEY),
    tapMerkleRoot: $gOgEP
};
module.exports.inputs = $59a221109c575e6a$var$inputs;
const $59a221109c575e6a$var$outputs = {
    bip32Derivation: $7YFpq.makeConverter($qpq9i.OutputTypes.BIP32_DERIVATION),
    redeemScript: $62Nv9.makeConverter($qpq9i.OutputTypes.REDEEM_SCRIPT),
    witnessScript: $kSfZv.makeConverter($qpq9i.OutputTypes.WITNESS_SCRIPT),
    checkPubkey: $iVrTH.makeChecker([
        $qpq9i.OutputTypes.BIP32_DERIVATION
    ]),
    tapBip32Derivation: $3RTes.makeConverter($qpq9i.OutputTypes.TAP_BIP32_DERIVATION),
    tapTree: $jO9dJ,
    tapInternalKey: $1Ya0J.makeConverter($qpq9i.OutputTypes.TAP_INTERNAL_KEY)
};
module.exports.outputs = $59a221109c575e6a$var$outputs;

});
parcelRegister("qpq9i", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
var $04f625daf5ade9df$var$GlobalTypes;
(function(GlobalTypes) {
    GlobalTypes[GlobalTypes["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    GlobalTypes[GlobalTypes["GLOBAL_XPUB"] = 1] = "GLOBAL_XPUB";
})($04f625daf5ade9df$var$GlobalTypes = module.exports.GlobalTypes || (module.exports.GlobalTypes = {}));
module.exports.GLOBAL_TYPE_NAMES = [
    "unsignedTx",
    "globalXpub"
];
var $04f625daf5ade9df$var$InputTypes;
(function(InputTypes) {
    InputTypes[InputTypes["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    InputTypes[InputTypes["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    InputTypes[InputTypes["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    InputTypes[InputTypes["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    InputTypes[InputTypes["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    InputTypes[InputTypes["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    InputTypes[InputTypes["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    InputTypes[InputTypes["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    InputTypes[InputTypes["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    InputTypes[InputTypes["POR_COMMITMENT"] = 9] = "POR_COMMITMENT";
    InputTypes[InputTypes["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    InputTypes[InputTypes["TAP_SCRIPT_SIG"] = 20] = "TAP_SCRIPT_SIG";
    InputTypes[InputTypes["TAP_LEAF_SCRIPT"] = 21] = "TAP_LEAF_SCRIPT";
    InputTypes[InputTypes["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
    InputTypes[InputTypes["TAP_INTERNAL_KEY"] = 23] = "TAP_INTERNAL_KEY";
    InputTypes[InputTypes["TAP_MERKLE_ROOT"] = 24] = "TAP_MERKLE_ROOT";
})($04f625daf5ade9df$var$InputTypes = module.exports.InputTypes || (module.exports.InputTypes = {}));
module.exports.INPUT_TYPE_NAMES = [
    "nonWitnessUtxo",
    "witnessUtxo",
    "partialSig",
    "sighashType",
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "finalScriptSig",
    "finalScriptWitness",
    "porCommitment",
    "tapKeySig",
    "tapScriptSig",
    "tapLeafScript",
    "tapBip32Derivation",
    "tapInternalKey",
    "tapMerkleRoot"
];
var $04f625daf5ade9df$var$OutputTypes;
(function(OutputTypes) {
    OutputTypes[OutputTypes["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    OutputTypes[OutputTypes["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    OutputTypes[OutputTypes["BIP32_DERIVATION"] = 2] = "BIP32_DERIVATION";
    OutputTypes[OutputTypes["TAP_INTERNAL_KEY"] = 5] = "TAP_INTERNAL_KEY";
    OutputTypes[OutputTypes["TAP_TREE"] = 6] = "TAP_TREE";
    OutputTypes[OutputTypes["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($04f625daf5ade9df$var$OutputTypes = module.exports.OutputTypes || (module.exports.OutputTypes = {}));
module.exports.OUTPUT_TYPE_NAMES = [
    "redeemScript",
    "witnessScript",
    "bip32Derivation",
    "tapInternalKey",
    "tapTree",
    "tapBip32Derivation"
];

});

parcelRegister("2M3mP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2052ad254c60a4b2$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
const $2052ad254c60a4b2$var$range = (n)=>[
        ...Array(n).keys()
    ];
function $2052ad254c60a4b2$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.GlobalTypes.GLOBAL_XPUB) throw new Error("Decode Error: could not decode globalXpub with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 79 || ![
        2,
        3
    ].includes(keyVal.key[46])) throw new Error("Decode Error: globalXpub has invalid extended pubkey in key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Global GLOBAL_XPUB value length should be multiple of 4");
    const extendedPubkey = keyVal.key.slice(1);
    const data = {
        masterFingerprint: keyVal.value.slice(0, 4),
        extendedPubkey: extendedPubkey,
        path: "m"
    };
    for (const i of $2052ad254c60a4b2$var$range(keyVal.value.length / 4 - 1)){
        const val = keyVal.value.readUInt32LE(i * 4 + 4);
        const isHard = !!(val & 0x80000000);
        const idx = val & 0x7fffffff;
        data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
    }
    return data;
}
module.exports.decode = $2052ad254c60a4b2$var$decode;
function $2052ad254c60a4b2$var$encode(data) {
    const head = $2052ad254c60a4b2$require$Buffer.from([
        $qpq9i.GlobalTypes.GLOBAL_XPUB
    ]);
    const key = $2052ad254c60a4b2$require$Buffer.concat([
        head,
        data.extendedPubkey
    ]);
    const splitPath = data.path.split("/");
    const value = $2052ad254c60a4b2$require$Buffer.allocUnsafe(splitPath.length * 4);
    data.masterFingerprint.copy(value, 0);
    let offset = 4;
    splitPath.slice(1).forEach((level)=>{
        const isHard = level.slice(-1) === "'";
        let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
        if (isHard) num += 0x80000000;
        value.writeUInt32LE(num, offset);
        offset += 4;
    });
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $2052ad254c60a4b2$var$encode;
module.exports.expected = "{ masterFingerprint: Buffer; extendedPubkey: Buffer; path: string; }";
function $2052ad254c60a4b2$var$check(data) {
    const epk = data.extendedPubkey;
    const mfp = data.masterFingerprint;
    const p = data.path;
    return $2052ad254c60a4b2$require$Buffer.isBuffer(epk) && epk.length === 78 && [
        2,
        3
    ].indexOf(epk[45]) > -1 && $2052ad254c60a4b2$require$Buffer.isBuffer(mfp) && mfp.length === 4 && typeof p === "string" && !!p.match(/^m(\/\d+'?)*$/);
}
module.exports.check = $2052ad254c60a4b2$var$check;
function $2052ad254c60a4b2$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.extendedPubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.extendedPubkey.equals(item.extendedPubkey)).length === 0;
}
module.exports.canAddToArray = $2052ad254c60a4b2$var$canAddToArray;

});

parcelRegister("9CSLb", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $702223ddf4530a73$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $702223ddf4530a73$var$encode(data) {
    return {
        key: $702223ddf4530a73$require$Buffer.from([
            $qpq9i.GlobalTypes.UNSIGNED_TX
        ]),
        value: data.toBuffer()
    };
}
module.exports.encode = $702223ddf4530a73$var$encode;

});

parcelRegister("bHI13", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8855da8654d9bb8f$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8855da8654d9bb8f$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTSIG) throw new Error("Decode Error: could not decode finalScriptSig with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $8855da8654d9bb8f$var$decode;
function $8855da8654d9bb8f$var$encode(data) {
    const key = $8855da8654d9bb8f$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTSIG
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $8855da8654d9bb8f$var$encode;
module.exports.expected = "Buffer";
function $8855da8654d9bb8f$var$check(data) {
    return $8855da8654d9bb8f$require$Buffer.isBuffer(data);
}
module.exports.check = $8855da8654d9bb8f$var$check;
function $8855da8654d9bb8f$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptSig === undefined;
}
module.exports.canAdd = $8855da8654d9bb8f$var$canAdd;

});

parcelRegister("gsMQz", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bfc526d659a6650b$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $bfc526d659a6650b$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.FINAL_SCRIPTWITNESS) throw new Error("Decode Error: could not decode finalScriptWitness with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $bfc526d659a6650b$var$decode;
function $bfc526d659a6650b$var$encode(data) {
    const key = $bfc526d659a6650b$require$Buffer.from([
        $qpq9i.InputTypes.FINAL_SCRIPTWITNESS
    ]);
    return {
        key: key,
        value: data
    };
}
module.exports.encode = $bfc526d659a6650b$var$encode;
module.exports.expected = "Buffer";
function $bfc526d659a6650b$var$check(data) {
    return $bfc526d659a6650b$require$Buffer.isBuffer(data);
}
module.exports.check = $bfc526d659a6650b$var$check;
function $bfc526d659a6650b$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.finalScriptWitness === undefined;
}
module.exports.canAdd = $bfc526d659a6650b$var$canAdd;

});

parcelRegister("fmNoO", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b2ff3ac145fbf7ad$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b2ff3ac145fbf7ad$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.NON_WITNESS_UTXO) throw new Error("Decode Error: could not decode nonWitnessUtxo with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value;
}
module.exports.decode = $b2ff3ac145fbf7ad$var$decode;
function $b2ff3ac145fbf7ad$var$encode(data) {
    return {
        key: $b2ff3ac145fbf7ad$require$Buffer.from([
            $qpq9i.InputTypes.NON_WITNESS_UTXO
        ]),
        value: data
    };
}
module.exports.encode = $b2ff3ac145fbf7ad$var$encode;
module.exports.expected = "Buffer";
function $b2ff3ac145fbf7ad$var$check(data) {
    return $b2ff3ac145fbf7ad$require$Buffer.isBuffer(data);
}
module.exports.check = $b2ff3ac145fbf7ad$var$check;
function $b2ff3ac145fbf7ad$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.nonWitnessUtxo === undefined;
}
module.exports.canAdd = $b2ff3ac145fbf7ad$var$canAdd;

});

parcelRegister("9vZgw", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6ed6885f6d3c4155$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $6ed6885f6d3c4155$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.PARTIAL_SIG) throw new Error("Decode Error: could not decode partialSig with key 0x" + keyVal.key.toString("hex"));
    if (!(keyVal.key.length === 34 || keyVal.key.length === 66) || ![
        2,
        3,
        4
    ].includes(keyVal.key[1])) throw new Error("Decode Error: partialSig has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1);
    return {
        pubkey: pubkey,
        signature: keyVal.value
    };
}
module.exports.decode = $6ed6885f6d3c4155$var$decode;
function $6ed6885f6d3c4155$var$encode(pSig) {
    const head = $6ed6885f6d3c4155$require$Buffer.from([
        $qpq9i.InputTypes.PARTIAL_SIG
    ]);
    return {
        key: $6ed6885f6d3c4155$require$Buffer.concat([
            head,
            pSig.pubkey
        ]),
        value: pSig.signature
    };
}
module.exports.encode = $6ed6885f6d3c4155$var$encode;
module.exports.expected = "{ pubkey: Buffer; signature: Buffer; }";
function $6ed6885f6d3c4155$var$check(data) {
    return $6ed6885f6d3c4155$require$Buffer.isBuffer(data.pubkey) && $6ed6885f6d3c4155$require$Buffer.isBuffer(data.signature) && [
        33,
        65
    ].includes(data.pubkey.length) && [
        2,
        3,
        4
    ].includes(data.pubkey[0]) && $6ed6885f6d3c4155$var$isDerSigWithSighash(data.signature);
}
module.exports.check = $6ed6885f6d3c4155$var$check;
function $6ed6885f6d3c4155$var$isDerSigWithSighash(buf) {
    if (!$6ed6885f6d3c4155$require$Buffer.isBuffer(buf) || buf.length < 9) return false;
    if (buf[0] !== 0x30) return false;
    if (buf.length !== buf[1] + 3) return false;
    if (buf[2] !== 0x02) return false;
    const rLen = buf[3];
    if (rLen > 33 || rLen < 1) return false;
    if (buf[3 + rLen + 1] !== 0x02) return false;
    const sLen = buf[3 + rLen + 2];
    if (sLen > 33 || sLen < 1) return false;
    if (buf.length !== 3 + rLen + 2 + sLen + 2) return false;
    return true;
}
function $6ed6885f6d3c4155$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
}
module.exports.canAddToArray = $6ed6885f6d3c4155$var$canAddToArray;

});

parcelRegister("ckVfp", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8fb3c27476d0f9f4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $8fb3c27476d0f9f4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.POR_COMMITMENT) throw new Error("Decode Error: could not decode porCommitment with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.toString("utf8");
}
module.exports.decode = $8fb3c27476d0f9f4$var$decode;
function $8fb3c27476d0f9f4$var$encode(data) {
    const key = $8fb3c27476d0f9f4$require$Buffer.from([
        $qpq9i.InputTypes.POR_COMMITMENT
    ]);
    return {
        key: key,
        value: $8fb3c27476d0f9f4$require$Buffer.from(data, "utf8")
    };
}
module.exports.encode = $8fb3c27476d0f9f4$var$encode;
module.exports.expected = "string";
function $8fb3c27476d0f9f4$var$check(data) {
    return typeof data === "string";
}
module.exports.check = $8fb3c27476d0f9f4$var$check;
function $8fb3c27476d0f9f4$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.porCommitment === undefined;
}
module.exports.canAdd = $8fb3c27476d0f9f4$var$canAdd;

});

parcelRegister("eOKUK", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $ac9a206413f62f80$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $ac9a206413f62f80$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.SIGHASH_TYPE) throw new Error("Decode Error: could not decode sighashType with key 0x" + keyVal.key.toString("hex"));
    return keyVal.value.readUInt32LE(0);
}
module.exports.decode = $ac9a206413f62f80$var$decode;
function $ac9a206413f62f80$var$encode(data) {
    const key = $ac9a206413f62f80$require$Buffer.from([
        $qpq9i.InputTypes.SIGHASH_TYPE
    ]);
    const value = $ac9a206413f62f80$require$Buffer.allocUnsafe(4);
    value.writeUInt32LE(data, 0);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $ac9a206413f62f80$var$encode;
module.exports.expected = "number";
function $ac9a206413f62f80$var$check(data) {
    return typeof data === "number";
}
module.exports.check = $ac9a206413f62f80$var$check;
function $ac9a206413f62f80$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.sighashType === undefined;
}
module.exports.canAdd = $ac9a206413f62f80$var$canAdd;

});

parcelRegister("bn4w6", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $847558a6a72418a0$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $847558a6a72418a0$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_KEY_SIG || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapKeySig with key 0x" + keyVal.key.toString("hex"));
    if (!$847558a6a72418a0$var$check(keyVal.value)) throw new Error("Decode Error: tapKeySig not a valid 64-65-byte BIP340 signature");
    return keyVal.value;
}
module.exports.decode = $847558a6a72418a0$var$decode;
function $847558a6a72418a0$var$encode(value) {
    const key = $847558a6a72418a0$require$Buffer.from([
        $qpq9i.InputTypes.TAP_KEY_SIG
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $847558a6a72418a0$var$encode;
module.exports.expected = "Buffer";
function $847558a6a72418a0$var$check(data) {
    return $847558a6a72418a0$require$Buffer.isBuffer(data) && (data.length === 64 || data.length === 65);
}
module.exports.check = $847558a6a72418a0$var$check;
function $847558a6a72418a0$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapKeySig === undefined;
}
module.exports.canAdd = $847558a6a72418a0$var$canAdd;

});

parcelRegister("gJHsk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c2f28ec33344129a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c2f28ec33344129a$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_LEAF_SCRIPT) throw new Error("Decode Error: could not decode tapLeafScript with key 0x" + keyVal.key.toString("hex"));
    if ((keyVal.key.length - 2) % 32 !== 0) throw new Error("Decode Error: tapLeafScript has invalid control block in key 0x" + keyVal.key.toString("hex"));
    const leafVersion = keyVal.value[keyVal.value.length - 1];
    if ((keyVal.key[1] & 0xfe) !== leafVersion) throw new Error("Decode Error: tapLeafScript bad leaf version in key 0x" + keyVal.key.toString("hex"));
    const script = keyVal.value.slice(0, -1);
    const controlBlock = keyVal.key.slice(1);
    return {
        controlBlock: controlBlock,
        script: script,
        leafVersion: leafVersion
    };
}
module.exports.decode = $c2f28ec33344129a$var$decode;
function $c2f28ec33344129a$var$encode(tScript) {
    const head = $c2f28ec33344129a$require$Buffer.from([
        $qpq9i.InputTypes.TAP_LEAF_SCRIPT
    ]);
    const verBuf = $c2f28ec33344129a$require$Buffer.from([
        tScript.leafVersion
    ]);
    return {
        key: $c2f28ec33344129a$require$Buffer.concat([
            head,
            tScript.controlBlock
        ]),
        value: $c2f28ec33344129a$require$Buffer.concat([
            tScript.script,
            verBuf
        ])
    };
}
module.exports.encode = $c2f28ec33344129a$var$encode;
module.exports.expected = "{ controlBlock: Buffer; leafVersion: number, script: Buffer; }";
function $c2f28ec33344129a$var$check(data) {
    return $c2f28ec33344129a$require$Buffer.isBuffer(data.controlBlock) && (data.controlBlock.length - 1) % 32 === 0 && (data.controlBlock[0] & 0xfe) === data.leafVersion && $c2f28ec33344129a$require$Buffer.isBuffer(data.script);
}
module.exports.check = $c2f28ec33344129a$var$check;
function $c2f28ec33344129a$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.controlBlock.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.controlBlock.equals(item.controlBlock)).length === 0;
}
module.exports.canAddToArray = $c2f28ec33344129a$var$canAddToArray;

});

parcelRegister("gOgEP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $c3ce3caf0cf5c395$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $c3ce3caf0cf5c395$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_MERKLE_ROOT || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapMerkleRoot with key 0x" + keyVal.key.toString("hex"));
    if (!$c3ce3caf0cf5c395$var$check(keyVal.value)) throw new Error("Decode Error: tapMerkleRoot not a 32-byte hash");
    return keyVal.value;
}
module.exports.decode = $c3ce3caf0cf5c395$var$decode;
function $c3ce3caf0cf5c395$var$encode(value) {
    const key = $c3ce3caf0cf5c395$require$Buffer.from([
        $qpq9i.InputTypes.TAP_MERKLE_ROOT
    ]);
    return {
        key: key,
        value: value
    };
}
module.exports.encode = $c3ce3caf0cf5c395$var$encode;
module.exports.expected = "Buffer";
function $c3ce3caf0cf5c395$var$check(data) {
    return $c3ce3caf0cf5c395$require$Buffer.isBuffer(data) && data.length === 32;
}
module.exports.check = $c3ce3caf0cf5c395$var$check;
function $c3ce3caf0cf5c395$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapMerkleRoot === undefined;
}
module.exports.canAdd = $c3ce3caf0cf5c395$var$canAdd;

});

parcelRegister("fvNw3", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b4b0291bb9cf8fc4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");
function $b4b0291bb9cf8fc4$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.TAP_SCRIPT_SIG) throw new Error("Decode Error: could not decode tapScriptSig with key 0x" + keyVal.key.toString("hex"));
    if (keyVal.key.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid key 0x" + keyVal.key.toString("hex"));
    if (keyVal.value.length !== 64 && keyVal.value.length !== 65) throw new Error("Decode Error: tapScriptSig has invalid signature in key 0x" + keyVal.key.toString("hex"));
    const pubkey = keyVal.key.slice(1, 33);
    const leafHash = keyVal.key.slice(33);
    return {
        pubkey: pubkey,
        leafHash: leafHash,
        signature: keyVal.value
    };
}
module.exports.decode = $b4b0291bb9cf8fc4$var$decode;
function $b4b0291bb9cf8fc4$var$encode(tSig) {
    const head = $b4b0291bb9cf8fc4$require$Buffer.from([
        $qpq9i.InputTypes.TAP_SCRIPT_SIG
    ]);
    return {
        key: $b4b0291bb9cf8fc4$require$Buffer.concat([
            head,
            tSig.pubkey,
            tSig.leafHash
        ]),
        value: tSig.signature
    };
}
module.exports.encode = $b4b0291bb9cf8fc4$var$encode;
module.exports.expected = "{ pubkey: Buffer; leafHash: Buffer; signature: Buffer; }";
function $b4b0291bb9cf8fc4$var$check(data) {
    return $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.pubkey) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.leafHash) && $b4b0291bb9cf8fc4$require$Buffer.isBuffer(data.signature) && data.pubkey.length === 32 && data.leafHash.length === 32 && (data.signature.length === 64 || data.signature.length === 65);
}
module.exports.check = $b4b0291bb9cf8fc4$var$check;
function $b4b0291bb9cf8fc4$var$canAddToArray(array, item, dupeSet) {
    const dupeString = item.pubkey.toString("hex") + item.leafHash.toString("hex");
    if (dupeSet.has(dupeString)) return false;
    dupeSet.add(dupeString);
    return array.filter((v)=>v.pubkey.equals(item.pubkey) && v.leafHash.equals(item.leafHash)).length === 0;
}
module.exports.canAddToArray = $b4b0291bb9cf8fc4$var$canAddToArray;

});

parcelRegister("eweRk", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a91f948fd34f9dcc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $3cFg7 = parcelRequire("3cFg7");

var $gjBY1 = parcelRequire("gjBY1");
function $a91f948fd34f9dcc$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.InputTypes.WITNESS_UTXO) throw new Error("Decode Error: could not decode witnessUtxo with key 0x" + keyVal.key.toString("hex"));
    const value = $3cFg7.readUInt64LE(keyVal.value, 0);
    let _offset = 8;
    const scriptLen = $gjBY1.decode(keyVal.value, _offset);
    _offset += $gjBY1.encodingLength(scriptLen);
    const script = keyVal.value.slice(_offset);
    if (script.length !== scriptLen) throw new Error("Decode Error: WITNESS_UTXO script is not proper length");
    return {
        script: script,
        value: value
    };
}
module.exports.decode = $a91f948fd34f9dcc$var$decode;
function $a91f948fd34f9dcc$var$encode(data) {
    const { script: script, value: value } = data;
    const varintLen = $gjBY1.encodingLength(script.length);
    const result = $a91f948fd34f9dcc$require$Buffer.allocUnsafe(8 + varintLen + script.length);
    $3cFg7.writeUInt64LE(result, value, 0);
    $gjBY1.encode(script.length, result, 8);
    script.copy(result, 8 + varintLen);
    return {
        key: $a91f948fd34f9dcc$require$Buffer.from([
            $qpq9i.InputTypes.WITNESS_UTXO
        ]),
        value: result
    };
}
module.exports.encode = $a91f948fd34f9dcc$var$encode;
module.exports.expected = "{ script: Buffer; value: number; }";
function $a91f948fd34f9dcc$var$check(data) {
    return $a91f948fd34f9dcc$require$Buffer.isBuffer(data.script) && typeof data.value === "number";
}
module.exports.check = $a91f948fd34f9dcc$var$check;
function $a91f948fd34f9dcc$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.witnessUtxo === undefined;
}
module.exports.canAdd = $a91f948fd34f9dcc$var$canAdd;

});
parcelRegister("3cFg7", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $25527f468d6fb9e3$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");
module.exports.range = (n)=>[
        ...Array(n).keys()
    ];
function $25527f468d6fb9e3$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
module.exports.reverseBuffer = $25527f468d6fb9e3$var$reverseBuffer;
function $25527f468d6fb9e3$var$keyValsToBuffer(keyVals) {
    const buffers = keyVals.map($25527f468d6fb9e3$var$keyValToBuffer);
    buffers.push($25527f468d6fb9e3$require$Buffer.from([
        0
    ]));
    return $25527f468d6fb9e3$require$Buffer.concat(buffers);
}
module.exports.keyValsToBuffer = $25527f468d6fb9e3$var$keyValsToBuffer;
function $25527f468d6fb9e3$var$keyValToBuffer(keyVal) {
    const keyLen = keyVal.key.length;
    const valLen = keyVal.value.length;
    const keyVarIntLen = $gjBY1.encodingLength(keyLen);
    const valVarIntLen = $gjBY1.encodingLength(valLen);
    const buffer = $25527f468d6fb9e3$require$Buffer.allocUnsafe(keyVarIntLen + keyLen + valVarIntLen + valLen);
    $gjBY1.encode(keyLen, buffer, 0);
    keyVal.key.copy(buffer, keyVarIntLen);
    $gjBY1.encode(valLen, buffer, keyVarIntLen + keyLen);
    keyVal.value.copy(buffer, keyVarIntLen + keyLen + valVarIntLen);
    return buffer;
}
module.exports.keyValToBuffer = $25527f468d6fb9e3$var$keyValToBuffer;
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $25527f468d6fb9e3$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $25527f468d6fb9e3$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $25527f468d6fb9e3$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
module.exports.readUInt64LE = $25527f468d6fb9e3$var$readUInt64LE;
function $25527f468d6fb9e3$var$writeUInt64LE(buffer, value, offset) {
    $25527f468d6fb9e3$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
module.exports.writeUInt64LE = $25527f468d6fb9e3$var$writeUInt64LE;

});
parcelRegister("gjBY1", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $be0bdf280ebbccbc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
// Number.MAX_SAFE_INTEGER
const $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER = 9007199254740991;
function $be0bdf280ebbccbc$var$checkUInt53(n) {
    if (n < 0 || n > $be0bdf280ebbccbc$var$MAX_SAFE_INTEGER || n % 1 !== 0) throw new RangeError("value out of range");
}
function $be0bdf280ebbccbc$var$encode(_number, buffer, offset) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    if (!buffer) buffer = $be0bdf280ebbccbc$require$Buffer.allocUnsafe($be0bdf280ebbccbc$var$encodingLength(_number));
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    // 8 bit
    if (_number < 0xfd) {
        buffer.writeUInt8(_number, offset);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 1
        });
    // 16 bit
    } else if (_number <= 0xffff) {
        buffer.writeUInt8(0xfd, offset);
        buffer.writeUInt16LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 3
        });
    // 32 bit
    } else if (_number <= 0xffffffff) {
        buffer.writeUInt8(0xfe, offset);
        buffer.writeUInt32LE(_number, offset + 1);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 5
        });
    // 64 bit
    } else {
        buffer.writeUInt8(0xff, offset);
        buffer.writeUInt32LE(_number >>> 0, offset + 1);
        buffer.writeUInt32LE(_number / 0x100000000 | 0, offset + 5);
        Object.assign($be0bdf280ebbccbc$var$encode, {
            bytes: 9
        });
    }
    return buffer;
}
module.exports.encode = $be0bdf280ebbccbc$var$encode;
function $be0bdf280ebbccbc$var$decode(buffer, offset) {
    if (!$be0bdf280ebbccbc$require$Buffer.isBuffer(buffer)) throw new TypeError("buffer must be a Buffer instance");
    if (!offset) offset = 0;
    const first = buffer.readUInt8(offset);
    // 8 bit
    if (first < 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 1
        });
        return first;
    // 16 bit
    } else if (first === 0xfd) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 3
        });
        return buffer.readUInt16LE(offset + 1);
    // 32 bit
    } else if (first === 0xfe) {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 5
        });
        return buffer.readUInt32LE(offset + 1);
    // 64 bit
    } else {
        Object.assign($be0bdf280ebbccbc$var$decode, {
            bytes: 9
        });
        const lo = buffer.readUInt32LE(offset + 1);
        const hi = buffer.readUInt32LE(offset + 5);
        const _number = hi * 0x0100000000 + lo;
        $be0bdf280ebbccbc$var$checkUInt53(_number);
        return _number;
    }
}
module.exports.decode = $be0bdf280ebbccbc$var$decode;
function $be0bdf280ebbccbc$var$encodingLength(_number) {
    $be0bdf280ebbccbc$var$checkUInt53(_number);
    return _number < 0xfd ? 1 : _number <= 0xffff ? 3 : _number <= 0xffffffff ? 5 : 9;
}
module.exports.encodingLength = $be0bdf280ebbccbc$var$encodingLength;

});



parcelRegister("jO9dJ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $e6b9d6da4db2882d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $qpq9i = parcelRequire("qpq9i");

var $gjBY1 = parcelRequire("gjBY1");
function $e6b9d6da4db2882d$var$decode(keyVal) {
    if (keyVal.key[0] !== $qpq9i.OutputTypes.TAP_TREE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapTree with key 0x" + keyVal.key.toString("hex"));
    let _offset = 0;
    const data = [];
    while(_offset < keyVal.value.length){
        const depth = keyVal.value[_offset++];
        const leafVersion = keyVal.value[_offset++];
        const scriptLen = $gjBY1.decode(keyVal.value, _offset);
        _offset += $gjBY1.encodingLength(scriptLen);
        data.push({
            depth: depth,
            leafVersion: leafVersion,
            script: keyVal.value.slice(_offset, _offset + scriptLen)
        });
        _offset += scriptLen;
    }
    return {
        leaves: data
    };
}
module.exports.decode = $e6b9d6da4db2882d$var$decode;
function $e6b9d6da4db2882d$var$encode(tree) {
    const key = $e6b9d6da4db2882d$require$Buffer.from([
        $qpq9i.OutputTypes.TAP_TREE
    ]);
    const bufs = [].concat(...tree.leaves.map((tapLeaf)=>[
            $e6b9d6da4db2882d$require$Buffer.of(tapLeaf.depth, tapLeaf.leafVersion),
            $gjBY1.encode(tapLeaf.script.length),
            tapLeaf.script
        ]));
    return {
        key: key,
        value: $e6b9d6da4db2882d$require$Buffer.concat(bufs)
    };
}
module.exports.encode = $e6b9d6da4db2882d$var$encode;
module.exports.expected = "{ leaves: [{ depth: number; leafVersion: number, script: Buffer; }] }";
function $e6b9d6da4db2882d$var$check(data) {
    return Array.isArray(data.leaves) && data.leaves.every((tapLeaf)=>tapLeaf.depth >= 0 && tapLeaf.depth <= 128 && (tapLeaf.leafVersion & 0xfe) === tapLeaf.leafVersion && $e6b9d6da4db2882d$require$Buffer.isBuffer(tapLeaf.script));
}
module.exports.check = $e6b9d6da4db2882d$var$check;
function $e6b9d6da4db2882d$var$canAdd(currentData, newData) {
    return !!currentData && !!newData && currentData.tapTree === undefined;
}
module.exports.canAdd = $e6b9d6da4db2882d$var$canAdd;

});

parcelRegister("7YFpq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $5cee41fc3b21e94a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
const $5cee41fc3b21e94a$var$range = (n)=>[
        ...Array(n).keys()
    ];
const $5cee41fc3b21e94a$var$isValidDERKey = (pubkey)=>pubkey.length === 33 && [
        2,
        3
    ].includes(pubkey[0]) || pubkey.length === 65 && 4 === pubkey[0];
function $5cee41fc3b21e94a$var$makeConverter(TYPE_BYTE, isValidPubkey = $5cee41fc3b21e94a$var$isValidDERKey) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode bip32Derivation with key 0x" + keyVal.key.toString("hex"));
        const pubkey = keyVal.key.slice(1);
        if (!isValidPubkey(pubkey)) throw new Error("Decode Error: bip32Derivation has invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length / 4 % 1 !== 0) throw new Error("Decode Error: Input BIP32_DERIVATION value length should be multiple of 4");
        const data = {
            masterFingerprint: keyVal.value.slice(0, 4),
            pubkey: pubkey,
            path: "m"
        };
        for (const i of $5cee41fc3b21e94a$var$range(keyVal.value.length / 4 - 1)){
            const val = keyVal.value.readUInt32LE(i * 4 + 4);
            const isHard = !!(val & 0x80000000);
            const idx = val & 0x7fffffff;
            data.path += "/" + idx.toString(10) + (isHard ? "'" : "");
        }
        return data;
    }
    function encode(data) {
        const head = $5cee41fc3b21e94a$require$Buffer.from([
            TYPE_BYTE
        ]);
        const key = $5cee41fc3b21e94a$require$Buffer.concat([
            head,
            data.pubkey
        ]);
        const splitPath = data.path.split("/");
        const value = $5cee41fc3b21e94a$require$Buffer.allocUnsafe(splitPath.length * 4);
        data.masterFingerprint.copy(value, 0);
        let offset = 4;
        splitPath.slice(1).forEach((level)=>{
            const isHard = level.slice(-1) === "'";
            let num = 0x7fffffff & parseInt(isHard ? level.slice(0, -1) : level, 10);
            if (isHard) num += 0x80000000;
            value.writeUInt32LE(num, offset);
            offset += 4;
        });
        return {
            key: key,
            value: value
        };
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; }";
    function check(data) {
        return $5cee41fc3b21e94a$require$Buffer.isBuffer(data.pubkey) && $5cee41fc3b21e94a$require$Buffer.isBuffer(data.masterFingerprint) && typeof data.path === "string" && isValidPubkey(data.pubkey) && data.masterFingerprint.length === 4;
    }
    function canAddToArray(array, item, dupeSet) {
        const dupeString = item.pubkey.toString("hex");
        if (dupeSet.has(dupeString)) return false;
        dupeSet.add(dupeString);
        return array.filter((v)=>v.pubkey.equals(item.pubkey)).length === 0;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: canAddToArray
    };
}
module.exports.makeConverter = $5cee41fc3b21e94a$var$makeConverter;

});

parcelRegister("iVrTH", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $dc7330b71df5261e$var$makeChecker(pubkeyTypes) {
    return checkPubkey;
    function checkPubkey(keyVal) {
        let pubkey;
        if (pubkeyTypes.includes(keyVal.key[0])) {
            pubkey = keyVal.key.slice(1);
            if (!(pubkey.length === 33 || pubkey.length === 65) || ![
                2,
                3,
                4
            ].includes(pubkey[0])) throw new Error("Format Error: invalid pubkey in key 0x" + keyVal.key.toString("hex"));
        }
        return pubkey;
    }
}
module.exports.makeChecker = $dc7330b71df5261e$var$makeChecker;

});

parcelRegister("62Nv9", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $466953f25b3e332a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $466953f25b3e332a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode redeemScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $466953f25b3e332a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $466953f25b3e332a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.redeemScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $466953f25b3e332a$var$makeConverter;

});

parcelRegister("3RTes", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $2d112a507e908169$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $gjBY1 = parcelRequire("gjBY1");

var $7YFpq = parcelRequire("7YFpq");
const $2d112a507e908169$var$isValidBIP340Key = (pubkey)=>pubkey.length === 32;
function $2d112a507e908169$var$makeConverter(TYPE_BYTE) {
    const parent = $7YFpq.makeConverter(TYPE_BYTE, $2d112a507e908169$var$isValidBIP340Key);
    function decode(keyVal) {
        const nHashes = $gjBY1.decode(keyVal.value);
        const nHashesLen = $gjBY1.encodingLength(nHashes);
        const base = parent.decode({
            key: keyVal.key,
            value: keyVal.value.slice(nHashesLen + nHashes * 32)
        });
        const leafHashes = new Array(nHashes);
        for(let i = 0, _offset = nHashesLen; i < nHashes; i++, _offset += 32)leafHashes[i] = keyVal.value.slice(_offset, _offset + 32);
        return Object.assign({}, base, {
            leafHashes: leafHashes
        });
    }
    function encode(data) {
        const base = parent.encode(data);
        const nHashesLen = $gjBY1.encodingLength(data.leafHashes.length);
        const nHashesBuf = $2d112a507e908169$require$Buffer.allocUnsafe(nHashesLen);
        $gjBY1.encode(data.leafHashes.length, nHashesBuf);
        const value = $2d112a507e908169$require$Buffer.concat([
            nHashesBuf,
            ...data.leafHashes,
            base.value
        ]);
        return Object.assign({}, base, {
            value: value
        });
    }
    const expected = "{ masterFingerprint: Buffer; pubkey: Buffer; path: string; leafHashes: Buffer[]; }";
    function check(data) {
        return Array.isArray(data.leafHashes) && data.leafHashes.every((leafHash)=>$2d112a507e908169$require$Buffer.isBuffer(leafHash) && leafHash.length === 32) && parent.check(data);
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAddToArray: parent.canAddToArray
    };
}
module.exports.makeConverter = $2d112a507e908169$var$makeConverter;

});

parcelRegister("1Ya0J", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $16f329006747ada3$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $16f329006747ada3$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE || keyVal.key.length !== 1) throw new Error("Decode Error: could not decode tapInternalKey with key 0x" + keyVal.key.toString("hex"));
        if (keyVal.value.length !== 32) throw new Error("Decode Error: tapInternalKey not a 32-byte x-only pubkey");
        return keyVal.value;
    }
    function encode(value) {
        const key = $16f329006747ada3$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: value
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $16f329006747ada3$require$Buffer.isBuffer(data) && data.length === 32;
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.tapInternalKey === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $16f329006747ada3$var$makeConverter;

});

parcelRegister("kSfZv", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $f3254142a84d7e3a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
function $f3254142a84d7e3a$var$makeConverter(TYPE_BYTE) {
    function decode(keyVal) {
        if (keyVal.key[0] !== TYPE_BYTE) throw new Error("Decode Error: could not decode witnessScript with key 0x" + keyVal.key.toString("hex"));
        return keyVal.value;
    }
    function encode(data) {
        const key = $f3254142a84d7e3a$require$Buffer.from([
            TYPE_BYTE
        ]);
        return {
            key: key,
            value: data
        };
    }
    const expected = "Buffer";
    function check(data) {
        return $f3254142a84d7e3a$require$Buffer.isBuffer(data);
    }
    function canAdd(currentData, newData) {
        return !!currentData && !!newData && currentData.witnessScript === undefined;
    }
    return {
        decode: decode,
        encode: encode,
        check: check,
        expected: expected,
        canAdd: canAdd
    };
}
module.exports.makeConverter = $f3254142a84d7e3a$var$makeConverter;

});



parcelRegister("iWOny", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $dcb4b8fdd10c0711$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");

var $3cFg7 = parcelRequire("3cFg7");
function $dcb4b8fdd10c0711$var$psbtToBuffer({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    const { globalKeyVals: globalKeyVals, inputKeyVals: inputKeyVals, outputKeyVals: outputKeyVals } = $dcb4b8fdd10c0711$var$psbtToKeyVals({
        globalMap: globalMap,
        inputs: inputs,
        outputs: outputs
    });
    const globalBuffer = $3cFg7.keyValsToBuffer(globalKeyVals);
    const keyValsOrEmptyToBuffer = (keyVals)=>keyVals.length === 0 ? [
            $dcb4b8fdd10c0711$require$Buffer.from([
                0
            ])
        ] : keyVals.map($3cFg7.keyValsToBuffer);
    const inputBuffers = keyValsOrEmptyToBuffer(inputKeyVals);
    const outputBuffers = keyValsOrEmptyToBuffer(outputKeyVals);
    const header = $dcb4b8fdd10c0711$require$Buffer.allocUnsafe(5);
    header.writeUIntBE(0x70736274ff, 0, 5);
    return $dcb4b8fdd10c0711$require$Buffer.concat([
        header,
        globalBuffer
    ].concat(inputBuffers, outputBuffers));
}
module.exports.psbtToBuffer = $dcb4b8fdd10c0711$var$psbtToBuffer;
const $dcb4b8fdd10c0711$var$sortKeyVals = (a, b)=>{
    return a.key.compare(b.key);
};
function $dcb4b8fdd10c0711$var$keyValsFromMap(keyValMap, converterFactory) {
    const keyHexSet = new Set();
    const keyVals = Object.entries(keyValMap).reduce((result, [key, value])=>{
        if (key === "unknownKeyVals") return result;
        // We are checking for undefined anyways. So ignore TS error
        // @ts-ignore
        const converter = converterFactory[key];
        if (converter === undefined) return result;
        const encodedKeyVals = (Array.isArray(value) ? value : [
            value
        ]).map(converter.encode);
        const keyHexes = encodedKeyVals.map((kv)=>kv.key.toString("hex"));
        keyHexes.forEach((hex)=>{
            if (keyHexSet.has(hex)) throw new Error("Serialize Error: Duplicate key: " + hex);
            keyHexSet.add(hex);
        });
        return result.concat(encodedKeyVals);
    }, []);
    // Get other keyVals that have not yet been gotten
    const otherKeyVals = keyValMap.unknownKeyVals ? keyValMap.unknownKeyVals.filter((keyVal)=>{
        return !keyHexSet.has(keyVal.key.toString("hex"));
    }) : [];
    return keyVals.concat(otherKeyVals).sort($dcb4b8fdd10c0711$var$sortKeyVals);
}
function $dcb4b8fdd10c0711$var$psbtToKeyVals({ globalMap: globalMap, inputs: inputs, outputs: outputs }) {
    // First parse the global keyVals
    // Get any extra keyvals to pass along
    return {
        globalKeyVals: $dcb4b8fdd10c0711$var$keyValsFromMap(globalMap, $7H7c4.globals),
        inputKeyVals: inputs.map((i)=>$dcb4b8fdd10c0711$var$keyValsFromMap(i, $7H7c4.inputs)),
        outputKeyVals: outputs.map((o)=>$dcb4b8fdd10c0711$var$keyValsFromMap(o, $7H7c4.outputs))
    };
}
module.exports.psbtToKeyVals = $dcb4b8fdd10c0711$var$psbtToKeyVals;

});



parcelRegister("geRUU", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $bd27c6f06c7d7c23$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});

var $7H7c4 = parcelRequire("7H7c4");
function $bd27c6f06c7d7c23$var$checkForInput(inputs, inputIndex) {
    const input = inputs[inputIndex];
    if (input === undefined) throw new Error(`No input #${inputIndex}`);
    return input;
}
module.exports.checkForInput = $bd27c6f06c7d7c23$var$checkForInput;
function $bd27c6f06c7d7c23$var$checkForOutput(outputs, outputIndex) {
    const output = outputs[outputIndex];
    if (output === undefined) throw new Error(`No output #${outputIndex}`);
    return output;
}
module.exports.checkForOutput = $bd27c6f06c7d7c23$var$checkForOutput;
function $bd27c6f06c7d7c23$var$checkHasKey(checkKeyVal, keyVals, enumLength) {
    if (checkKeyVal.key[0] < enumLength) throw new Error(`Use the method for your specific key instead of addUnknownKeyVal*`);
    if (keyVals && keyVals.filter((kv)=>kv.key.equals(checkKeyVal.key)).length !== 0) throw new Error(`Duplicate Key: ${checkKeyVal.key.toString("hex")}`);
}
module.exports.checkHasKey = $bd27c6f06c7d7c23$var$checkHasKey;
function $bd27c6f06c7d7c23$var$getEnumLength(myenum) {
    let count = 0;
    Object.keys(myenum).forEach((val)=>{
        if (Number(isNaN(Number(val)))) count++;
    });
    return count;
}
module.exports.getEnumLength = $bd27c6f06c7d7c23$var$getEnumLength;
function $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized(inputIndex, input) {
    let result = false;
    if (input.nonWitnessUtxo || input.witnessUtxo) {
        const needScriptSig = !!input.redeemScript;
        const needWitnessScript = !!input.witnessScript;
        const scriptSigOK = !needScriptSig || !!input.finalScriptSig;
        const witnessScriptOK = !needWitnessScript || !!input.finalScriptWitness;
        const hasOneFinal = !!input.finalScriptSig || !!input.finalScriptWitness;
        result = scriptSigOK && witnessScriptOK && hasOneFinal;
    }
    if (result === false) throw new Error(`Input #${inputIndex} has too much or too little data to clean`);
}
module.exports.inputCheckUncleanFinalized = $bd27c6f06c7d7c23$var$inputCheckUncleanFinalized;
function $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data) {
    throw new Error(`Data for ${typeName} key ${name} is incorrect: Expected ` + `${expected} and got ${JSON.stringify(data)}`);
}
function $bd27c6f06c7d7c23$var$updateMaker(typeName) {
    return (updateData, mainData)=>{
        for (const name of Object.keys(updateData)){
            // @ts-ignore
            const data = updateData[name];
            // @ts-ignore
            const { canAdd: canAdd, canAddToArray: canAddToArray, check: check, expected: expected } = // @ts-ignore
            $7H7c4[typeName + "s"][name] || {};
            const isArray = !!canAddToArray;
            // If unknown data. ignore and do not add
            if (check) {
                if (isArray) {
                    if (!Array.isArray(data) || // @ts-ignore
                    mainData[name] && !Array.isArray(mainData[name])) throw new Error(`Key type ${name} must be an array`);
                    if (!data.every(check)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    // @ts-ignore
                    const arr = mainData[name] || [];
                    const dupeCheckSet = new Set();
                    if (!data.every((v)=>canAddToArray(arr, v, dupeCheckSet))) throw new Error("Can not add duplicate data to array");
                    // @ts-ignore
                    mainData[name] = arr.concat(data);
                } else {
                    if (!check(data)) $bd27c6f06c7d7c23$var$throwForUpdateMaker(typeName, name, expected, data);
                    if (!canAdd(mainData, data)) throw new Error(`Can not add duplicate data to ${typeName}`);
                    // @ts-ignore
                    mainData[name] = data;
                }
            }
        }
    };
}
module.exports.updateGlobal = $bd27c6f06c7d7c23$var$updateMaker("global");
module.exports.updateInput = $bd27c6f06c7d7c23$var$updateMaker("input");
module.exports.updateOutput = $bd27c6f06c7d7c23$var$updateMaker("output");
function $bd27c6f06c7d7c23$var$addInputAttributes(inputs, data) {
    const index = inputs.length - 1;
    const input = $bd27c6f06c7d7c23$var$checkForInput(inputs, index);
    module.exports.updateInput(data, input);
}
module.exports.addInputAttributes = $bd27c6f06c7d7c23$var$addInputAttributes;
function $bd27c6f06c7d7c23$var$addOutputAttributes(outputs, data) {
    const index = outputs.length - 1;
    const output = $bd27c6f06c7d7c23$var$checkForOutput(outputs, index);
    module.exports.updateOutput(data, output);
}
module.exports.addOutputAttributes = $bd27c6f06c7d7c23$var$addOutputAttributes;
function $bd27c6f06c7d7c23$var$defaultVersionSetter(version, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Version: Invalid Transaction");
    txBuf.writeUInt32LE(version, 0);
    return txBuf;
}
module.exports.defaultVersionSetter = $bd27c6f06c7d7c23$var$defaultVersionSetter;
function $bd27c6f06c7d7c23$var$defaultLocktimeSetter(locktime, txBuf) {
    if (!$bd27c6f06c7d7c23$require$Buffer.isBuffer(txBuf) || txBuf.length < 4) throw new Error("Set Locktime: Invalid Transaction");
    txBuf.writeUInt32LE(locktime, txBuf.length - 4);
    return txBuf;
}
module.exports.defaultLocktimeSetter = $bd27c6f06c7d7c23$var$defaultLocktimeSetter;

});


parcelRegister("7rkx8", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $56aafb8d6d11875d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.checkTaprootInputForSigs = module.exports.tapTreeFromList = module.exports.tapTreeToList = module.exports.tweakInternalPubKey = module.exports.checkTaprootOutputFields = module.exports.checkTaprootInputFields = module.exports.isTaprootOutput = module.exports.isTaprootInput = module.exports.serializeTaprootSignature = module.exports.tapScriptFinalizer = module.exports.toXOnly = void 0;

var $18Mz5 = parcelRequire("18Mz5");

var $gMJcK = parcelRequire("gMJcK");

var $9txdn = parcelRequire("9txdn");

var $lzIk8 = parcelRequire("lzIk8");

var $j87lX = parcelRequire("j87lX");

var $9txdn = parcelRequire("9txdn");
const $56aafb8d6d11875d$var$toXOnly = (pubKey)=>pubKey.length === 32 ? pubKey : pubKey.slice(1, 33);
module.exports.toXOnly = $56aafb8d6d11875d$var$toXOnly;
/**
 * Default tapscript finalizer. It searches for the `tapLeafHashToFinalize` if provided.
 * Otherwise it will search for the tapleaf that has at least one signature and has the shortest path.
 * @param inputIndex the position of the PSBT input.
 * @param input the PSBT input.
 * @param tapLeafHashToFinalize optional, if provided the finalizer will search for a tapleaf that has this hash
 *                              and will try to build the finalScriptWitness.
 * @returns the finalScriptWitness or throws an exception if no tapleaf found.
 */ function $56aafb8d6d11875d$var$tapScriptFinalizer(inputIndex, input, tapLeafHashToFinalize) {
    const tapLeaf = $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, tapLeafHashToFinalize);
    try {
        const sigs = $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf);
        const witness = sigs.concat(tapLeaf.script).concat(tapLeaf.controlBlock);
        return {
            finalScriptWitness: (0, $9txdn.witnessStackToScriptWitness)(witness)
        };
    } catch (err) {
        throw new Error(`Can not finalize taproot input #${inputIndex}: ${err}`);
    }
}
module.exports.tapScriptFinalizer = $56aafb8d6d11875d$var$tapScriptFinalizer;
function $56aafb8d6d11875d$var$serializeTaprootSignature(sig, sighashType) {
    const sighashTypeByte = sighashType ? $56aafb8d6d11875d$require$Buffer.from([
        sighashType
    ]) : $56aafb8d6d11875d$require$Buffer.from([]);
    return $56aafb8d6d11875d$require$Buffer.concat([
        sig,
        sighashTypeByte
    ]);
}
module.exports.serializeTaprootSignature = $56aafb8d6d11875d$var$serializeTaprootSignature;
function $56aafb8d6d11875d$var$isTaprootInput(input) {
    return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || input.witnessUtxo && (0, $9txdn.isP2TR)(input.witnessUtxo.script));
}
module.exports.isTaprootInput = $56aafb8d6d11875d$var$isTaprootInput;
function $56aafb8d6d11875d$var$isTaprootOutput(output, script) {
    return output && !!(output.tapInternalKey || output.tapTree || output.tapBip32Derivation && output.tapBip32Derivation.length || script && (0, $9txdn.isP2TR)(script));
}
module.exports.isTaprootOutput = $56aafb8d6d11875d$var$isTaprootOutput;
function $56aafb8d6d11875d$var$checkTaprootInputFields(inputData, newInputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action);
    $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action);
}
module.exports.checkTaprootInputFields = $56aafb8d6d11875d$var$checkTaprootInputFields;
function $56aafb8d6d11875d$var$checkTaprootOutputFields(outputData, newOutputData, action) {
    $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(outputData, newOutputData, action);
    $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData);
}
module.exports.checkTaprootOutputFields = $56aafb8d6d11875d$var$checkTaprootOutputFields;
function $56aafb8d6d11875d$var$checkTaprootScriptPubkey(outputData, newOutputData) {
    if (!newOutputData.tapTree && !newOutputData.tapInternalKey) return;
    const tapInternalKey = newOutputData.tapInternalKey || outputData.tapInternalKey;
    const tapTree = newOutputData.tapTree || outputData.tapTree;
    if (tapInternalKey) {
        const { script: scriptPubkey } = outputData;
        const script = $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree);
        if (scriptPubkey && !scriptPubkey.equals(script)) throw new Error("Error adding output. Script or address missmatch.");
    }
}
function $56aafb8d6d11875d$var$getTaprootScripPubkey(tapInternalKey, tapTree) {
    const scriptTree = tapTree && $56aafb8d6d11875d$var$tapTreeFromList(tapTree.leaves);
    const { output: output } = (0, $j87lX.p2tr)({
        internalPubkey: tapInternalKey,
        scriptTree: scriptTree
    });
    return output;
}
function $56aafb8d6d11875d$var$tweakInternalPubKey(inputIndex, input) {
    const tapInternalKey = input.tapInternalKey;
    const outputKey = tapInternalKey && (0, $lzIk8.tweakKey)(tapInternalKey, input.tapMerkleRoot);
    if (!outputKey) throw new Error(`Cannot tweak tap internal key for input #${inputIndex}. Public key: ${tapInternalKey && tapInternalKey.toString("hex")}`);
    return outputKey.x;
}
module.exports.tweakInternalPubKey = $56aafb8d6d11875d$var$tweakInternalPubKey;
/**
 * Convert a binary tree to a BIP371 type list. Each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @param tree the binary tap tree
 * @returns a list of BIP 371 tapleaves
 */ function $56aafb8d6d11875d$var$tapTreeToList(tree) {
    if (!(0, $18Mz5.isTaptree)(tree)) throw new Error("Cannot convert taptree to tapleaf list. Expecting a tapree structure.");
    return $56aafb8d6d11875d$var$_tapTreeToList(tree);
}
module.exports.tapTreeToList = $56aafb8d6d11875d$var$tapTreeToList;
/**
 * Convert a BIP371 TapLeaf list to a TapTree (binary).
 * @param leaves a list of tapleaves where each element of the list is (according to BIP371):
 * One or more tuples representing the depth, leaf version, and script for a leaf in the Taproot tree,
 * allowing the entire tree to be reconstructed. The tuples must be in depth first search order so that
 * the tree is correctly reconstructed.
 * @returns the corresponding taptree, or throws an exception if the tree cannot be reconstructed
 */ function $56aafb8d6d11875d$var$tapTreeFromList(leaves = []) {
    if (leaves.length === 1 && leaves[0].depth === 0) return {
        output: leaves[0].script,
        version: leaves[0].leafVersion
    };
    return $56aafb8d6d11875d$var$instertLeavesInTree(leaves);
}
module.exports.tapTreeFromList = $56aafb8d6d11875d$var$tapTreeFromList;
function $56aafb8d6d11875d$var$checkTaprootInputForSigs(input, action) {
    const sigs = $56aafb8d6d11875d$var$extractTaprootSigs(input);
    return sigs.some((sig)=>(0, $9txdn.signatureBlocksAction)(sig, $56aafb8d6d11875d$var$decodeSchnorrSignature, action));
}
module.exports.checkTaprootInputForSigs = $56aafb8d6d11875d$var$checkTaprootInputForSigs;
function $56aafb8d6d11875d$var$decodeSchnorrSignature(signature) {
    return {
        signature: signature.slice(0, 64),
        hashType: signature.slice(64)[0] || $gMJcK.Transaction.SIGHASH_DEFAULT
    };
}
function $56aafb8d6d11875d$var$extractTaprootSigs(input) {
    const sigs = [];
    if (input.tapKeySig) sigs.push(input.tapKeySig);
    if (input.tapScriptSig) sigs.push(...input.tapScriptSig.map((s)=>s.signature));
    if (!sigs.length) {
        const finalTapKeySig = $56aafb8d6d11875d$var$getTapKeySigFromWithness(input.finalScriptWitness);
        if (finalTapKeySig) sigs.push(finalTapKeySig);
    }
    return sigs;
}
function $56aafb8d6d11875d$var$getTapKeySigFromWithness(finalScriptWitness) {
    if (!finalScriptWitness) return;
    const witness = finalScriptWitness.slice(2);
    // todo: add schnorr signature validation
    if (witness.length === 64 || witness.length === 65) return witness;
}
function $56aafb8d6d11875d$var$_tapTreeToList(tree, leaves = [], depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (!tree) return [];
    if ((0, $18Mz5.isTapleaf)(tree)) {
        leaves.push({
            depth: depth,
            leafVersion: tree.version || $lzIk8.LEAF_VERSION_TAPSCRIPT,
            script: tree.output
        });
        return leaves;
    }
    if (tree[0]) $56aafb8d6d11875d$var$_tapTreeToList(tree[0], leaves, depth + 1);
    if (tree[1]) $56aafb8d6d11875d$var$_tapTreeToList(tree[1], leaves, depth + 1);
    return leaves;
}
function $56aafb8d6d11875d$var$instertLeavesInTree(leaves) {
    let tree;
    for (const leaf of leaves){
        tree = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree);
        if (!tree) throw new Error(`No room left to insert tapleaf in tree`);
    }
    return tree;
}
function $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree, depth = 0) {
    if (depth > $lzIk8.MAX_TAPTREE_DEPTH) throw new Error("Max taptree depth exceeded.");
    if (leaf.depth === depth) {
        if (!tree) return {
            output: leaf.script,
            version: leaf.leafVersion
        };
        return;
    }
    if ((0, $18Mz5.isTapleaf)(tree)) return;
    const leftSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[0], depth + 1);
    if (leftSide) return [
        leftSide,
        tree && tree[1]
    ];
    const rightSide = $56aafb8d6d11875d$var$instertLeafInTree(leaf, tree && tree[1], depth + 1);
    if (rightSide) return [
        tree && tree[0],
        rightSide
    ];
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootInputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootInput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootInput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootInput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData); // todo: bad? use !===
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
function $56aafb8d6d11875d$var$checkMixedTaprootAndNonTaprootOutputFields(inputData, newInputData, action) {
    const isBadTaprootUpdate = $56aafb8d6d11875d$var$isTaprootOutput(inputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    const isBadNonTaprootUpdate = $56aafb8d6d11875d$var$hasNonTaprootFields(inputData) && $56aafb8d6d11875d$var$isTaprootOutput(newInputData);
    const hasMixedFields = inputData === newInputData && $56aafb8d6d11875d$var$isTaprootOutput(newInputData) && $56aafb8d6d11875d$var$hasNonTaprootFields(newInputData);
    if (isBadTaprootUpdate || isBadNonTaprootUpdate || hasMixedFields) throw new Error(`Invalid arguments for Psbt.${action}. ` + `Cannot use both taproot and non-taproot fields.`);
}
/**
 * Checks if the tap leaf is part of the tap tree for the given input data.
 * Throws an error if the tap leaf is not part of the tap tree.
 * @param inputData - The original PsbtInput data.
 * @param newInputData - The new PsbtInput data.
 * @param action - The action being performed.
 * @throws {Error} - If the tap leaf is not part of the tap tree.
 */ function $56aafb8d6d11875d$var$checkIfTapLeafInTree(inputData, newInputData, action) {
    if (newInputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        const oldLeafsInTree = (inputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, newInputData.tapMerkleRoot));
        if (!newLeafsInTree || !oldLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    } else if (inputData.tapMerkleRoot) {
        const newLeafsInTree = (newInputData.tapLeafScript || []).every((l)=>$56aafb8d6d11875d$var$isTapLeafInTree(l, inputData.tapMerkleRoot));
        if (!newLeafsInTree) throw new Error(`Invalid arguments for Psbt.${action}. Tapleaf not part of taptree.`);
    }
}
/**
 * Checks if a TapLeafScript is present in a Merkle tree.
 * @param tapLeaf The TapLeafScript to check.
 * @param merkleRoot The Merkle root of the tree. If not provided, the function assumes the TapLeafScript is present.
 * @returns A boolean indicating whether the TapLeafScript is present in the tree.
 */ function $56aafb8d6d11875d$var$isTapLeafInTree(tapLeaf, merkleRoot) {
    if (!merkleRoot) return true;
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    const rootHash = (0, $lzIk8.rootHashFromPath)(tapLeaf.controlBlock, leafHash);
    return rootHash.equals(merkleRoot);
}
/**
 * Sorts the signatures in the input's tapScriptSig array based on their position in the tapLeaf script.
 *
 * @param input - The PsbtInput object.
 * @param tapLeaf - The TapLeafScript object.
 * @returns An array of sorted signatures as Buffers.
 */ function $56aafb8d6d11875d$var$sortSignatures(input, tapLeaf) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: tapLeaf.script,
        version: tapLeaf.leafVersion
    });
    return (input.tapScriptSig || []).filter((tss)=>tss.leafHash.equals(leafHash)).map((tss)=>$56aafb8d6d11875d$var$addPubkeyPositionInScript(tapLeaf.script, tss)).sort((t1, t2)=>t2.positionInScript - t1.positionInScript).map((t)=>t.signature);
}
/**
 * Adds the position of a public key in a script to a TapScriptSig object.
 * @param script The script in which to find the position of the public key.
 * @param tss The TapScriptSig object to add the position to.
 * @returns A TapScriptSigWitPosition object with the added position.
 */ function $56aafb8d6d11875d$var$addPubkeyPositionInScript(script, tss) {
    return Object.assign({
        positionInScript: (0, $9txdn.pubkeyPositionInScript)(tss.pubkey, script)
    }, tss);
}
/**
 * Find tapleaf by hash, or get the signed tapleaf with the shortest path.
 */ function $56aafb8d6d11875d$var$findTapLeafToFinalize(input, inputIndex, leafHashToFinalize) {
    if (!input.tapScriptSig || !input.tapScriptSig.length) throw new Error(`Can not finalize taproot input #${inputIndex}. No tapleaf script signature provided.`);
    const tapLeaf = (input.tapLeafScript || []).sort((a, b)=>a.controlBlock.length - b.controlBlock.length).find((leaf)=>$56aafb8d6d11875d$var$canFinalizeLeaf(leaf, input.tapScriptSig, leafHashToFinalize));
    if (!tapLeaf) throw new Error(`Can not finalize taproot input #${inputIndex}. Signature for tapleaf script not found.`);
    return tapLeaf;
}
/**
 * Determines whether a TapLeafScript can be finalized.
 *
 * @param leaf - The TapLeafScript to check.
 * @param tapScriptSig - The array of TapScriptSig objects.
 * @param hash - The optional hash to compare with the leaf hash.
 * @returns A boolean indicating whether the TapLeafScript can be finalized.
 */ function $56aafb8d6d11875d$var$canFinalizeLeaf(leaf, tapScriptSig, hash) {
    const leafHash = (0, $lzIk8.tapleafHash)({
        output: leaf.script,
        version: leaf.leafVersion
    });
    const whiteListedHash = !hash || hash.equals(leafHash);
    return whiteListedHash && tapScriptSig.find((tss)=>tss.leafHash.equals(leafHash)) !== undefined;
}
/**
 * Checks if the given PsbtInput or PsbtOutput has non-taproot fields.
 * Non-taproot fields include redeemScript, witnessScript, and bip32Derivation.
 * @param io The PsbtInput or PsbtOutput to check.
 * @returns A boolean indicating whether the given input or output has non-taproot fields.
 */ function $56aafb8d6d11875d$var$hasNonTaprootFields(io) {
    return io && !!(io.redeemScript || io.witnessScript || io.bip32Derivation && io.bip32Derivation.length);
}

});
parcelRegister("9txdn", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $6e60963a04e48e3d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.signatureBlocksAction = module.exports.checkInputForSig = module.exports.pubkeyInScript = module.exports.pubkeyPositionInScript = module.exports.witnessStackToScriptWitness = module.exports.isP2TR = module.exports.isP2SHScript = module.exports.isP2WSHScript = module.exports.isP2WPKH = module.exports.isP2PKH = module.exports.isP2PK = module.exports.isP2MS = void 0;

var $gjBY1 = parcelRequire("gjBY1");

var $8wAtk = parcelRequire("8wAtk");

var $gMJcK = parcelRequire("gMJcK");

var $lgTFk = parcelRequire("lgTFk");

var $j87lX = parcelRequire("j87lX");
function $6e60963a04e48e3d$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
module.exports.isP2MS = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2ms);
module.exports.isP2PK = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pk);
module.exports.isP2PKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2pkh);
module.exports.isP2WPKH = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wpkh);
module.exports.isP2WSHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2wsh);
module.exports.isP2SHScript = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2sh);
module.exports.isP2TR = $6e60963a04e48e3d$var$isPaymentFactory($j87lX.p2tr);
/**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The script witness as a Buffer.
 */ /**
 * Converts a witness stack to a script witness.
 * @param witness The witness stack to convert.
 * @returns The converted script witness.
 */ function $6e60963a04e48e3d$var$witnessStackToScriptWitness(witness) {
    let buffer = $6e60963a04e48e3d$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $6e60963a04e48e3d$require$Buffer.concat([
            buffer,
            $6e60963a04e48e3d$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
module.exports.witnessStackToScriptWitness = $6e60963a04e48e3d$var$witnessStackToScriptWitness;
/**
 * Finds the position of a public key in a script.
 * @param pubkey The public key to search for.
 * @param script The script to search in.
 * @returns The index of the public key in the script, or -1 if not found.
 * @throws {Error} If there is an unknown script error.
 */ function $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) {
    const pubkeyHash = (0, $lgTFk.hash160)(pubkey);
    const pubkeyXOnly = pubkey.slice(1, 33); // slice before calling?
    const decompiled = $8wAtk.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.findIndex((element)=>{
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash) || element.equals(pubkeyXOnly);
    });
}
module.exports.pubkeyPositionInScript = $6e60963a04e48e3d$var$pubkeyPositionInScript;
/**
 * Checks if a public key is present in a script.
 * @param pubkey The public key to check.
 * @param script The script to search in.
 * @returns A boolean indicating whether the public key is present in the script.
 */ function $6e60963a04e48e3d$var$pubkeyInScript(pubkey, script) {
    return $6e60963a04e48e3d$var$pubkeyPositionInScript(pubkey, script) !== -1;
}
module.exports.pubkeyInScript = $6e60963a04e48e3d$var$pubkeyInScript;
/**
 * Checks if an input contains a signature for a specific action.
 * @param input - The input to check.
 * @param action - The action to check for.
 * @returns A boolean indicating whether the input contains a signature for the specified action.
 */ function $6e60963a04e48e3d$var$checkInputForSig(input, action) {
    const pSigs = $6e60963a04e48e3d$var$extractPartialSigs(input);
    return pSigs.some((pSig)=>$6e60963a04e48e3d$var$signatureBlocksAction(pSig, $8wAtk.signature.decode, action));
}
module.exports.checkInputForSig = $6e60963a04e48e3d$var$checkInputForSig;
/**
 * Determines if a given action is allowed for a signature block.
 * @param signature - The signature block.
 * @param signatureDecodeFn - The function used to decode the signature.
 * @param action - The action to be checked.
 * @returns True if the action is allowed, false otherwise.
 */ function $6e60963a04e48e3d$var$signatureBlocksAction(signature, signatureDecodeFn, action) {
    const { hashType: hashType } = signatureDecodeFn(signature);
    const whitelist = [];
    const isAnyoneCanPay = hashType & $gMJcK.Transaction.SIGHASH_ANYONECANPAY;
    if (isAnyoneCanPay) whitelist.push("addInput");
    const hashMod = hashType & 0x1f;
    switch(hashMod){
        case $gMJcK.Transaction.SIGHASH_ALL:
            break;
        case $gMJcK.Transaction.SIGHASH_SINGLE:
        case $gMJcK.Transaction.SIGHASH_NONE:
            whitelist.push("addOutput");
            whitelist.push("setInputSequence");
            break;
    }
    if (whitelist.indexOf(action) === -1) return true;
    return false;
}
module.exports.signatureBlocksAction = $6e60963a04e48e3d$var$signatureBlocksAction;
/**
 * Extracts the signatures from a PsbtInput object.
 * If the input has partial signatures, it returns an array of the signatures.
 * If the input does not have partial signatures, it checks if it has a finalScriptSig or finalScriptWitness.
 * If it does, it extracts the signatures from the final scripts and returns them.
 * If none of the above conditions are met, it returns an empty array.
 *
 * @param input - The PsbtInput object from which to extract the signatures.
 * @returns An array of signatures extracted from the PsbtInput object.
 */ function $6e60963a04e48e3d$var$extractPartialSigs(input) {
    let pSigs = [];
    if ((input.partialSig || []).length === 0) {
        if (!input.finalScriptSig && !input.finalScriptWitness) return [];
        pSigs = $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input);
    } else pSigs = input.partialSig;
    return pSigs.map((p)=>p.signature);
}
/**
 * Retrieves the partial signatures (Psigs) from the input's final scripts.
 * Psigs are extracted from both the final scriptSig and final scriptWitness of the input.
 * Only canonical script signatures are considered.
 *
 * @param input - The PsbtInput object representing the input.
 * @returns An array of PartialSig objects containing the extracted Psigs.
 */ function $6e60963a04e48e3d$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $8wAtk.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $8wAtk.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $6e60963a04e48e3d$require$Buffer.isBuffer(item) && $8wAtk.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}

});




parcelRegister("7etJZ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
"use strict";
var $5440e9199a418654$var$R = typeof Reflect === "object" ? Reflect : null;
var $5440e9199a418654$var$ReflectApply = $5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.apply === "function" ? $5440e9199a418654$var$R.apply : function ReflectApply(target, receiver, args) {
    return Function.prototype.apply.call(target, receiver, args);
};
var $5440e9199a418654$var$ReflectOwnKeys;
if ($5440e9199a418654$var$R && typeof $5440e9199a418654$var$R.ownKeys === "function") $5440e9199a418654$var$ReflectOwnKeys = $5440e9199a418654$var$R.ownKeys;
else if (Object.getOwnPropertySymbols) $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target).concat(Object.getOwnPropertySymbols(target));
};
else $5440e9199a418654$var$ReflectOwnKeys = function ReflectOwnKeys(target) {
    return Object.getOwnPropertyNames(target);
};
function $5440e9199a418654$var$ProcessEmitWarning(warning) {
    if (console && console.warn) console.warn(warning);
}
var $5440e9199a418654$var$NumberIsNaN = Number.isNaN || function NumberIsNaN(value) {
    return value !== value;
};
function $5440e9199a418654$var$EventEmitter() {
    $5440e9199a418654$var$EventEmitter.init.call(this);
}
module.exports = $5440e9199a418654$var$EventEmitter;
module.exports.once = $5440e9199a418654$var$once;
// Backwards-compat with node 0.10.x
$5440e9199a418654$var$EventEmitter.EventEmitter = $5440e9199a418654$var$EventEmitter;
$5440e9199a418654$var$EventEmitter.prototype._events = undefined;
$5440e9199a418654$var$EventEmitter.prototype._eventsCount = 0;
$5440e9199a418654$var$EventEmitter.prototype._maxListeners = undefined;
// By default EventEmitters will print a warning if more than 10 listeners are
// added to it. This is a useful default which helps finding memory leaks.
var $5440e9199a418654$var$defaultMaxListeners = 10;
function $5440e9199a418654$var$checkListener(listener) {
    if (typeof listener !== "function") throw new TypeError('The "listener" argument must be of type Function. Received type ' + typeof listener);
}
Object.defineProperty($5440e9199a418654$var$EventEmitter, "defaultMaxListeners", {
    enumerable: true,
    get: function() {
        return $5440e9199a418654$var$defaultMaxListeners;
    },
    set: function(arg) {
        if (typeof arg !== "number" || arg < 0 || $5440e9199a418654$var$NumberIsNaN(arg)) throw new RangeError('The value of "defaultMaxListeners" is out of range. It must be a non-negative number. Received ' + arg + ".");
        $5440e9199a418654$var$defaultMaxListeners = arg;
    }
});
$5440e9199a418654$var$EventEmitter.init = function() {
    if (this._events === undefined || this._events === Object.getPrototypeOf(this)._events) {
        this._events = Object.create(null);
        this._eventsCount = 0;
    }
    this._maxListeners = this._maxListeners || undefined;
};
// Obviously not all Emitters should be limited to 10. This function allows
// that to be increased. Set to zero for unlimited.
$5440e9199a418654$var$EventEmitter.prototype.setMaxListeners = function setMaxListeners(n) {
    if (typeof n !== "number" || n < 0 || $5440e9199a418654$var$NumberIsNaN(n)) throw new RangeError('The value of "n" is out of range. It must be a non-negative number. Received ' + n + ".");
    this._maxListeners = n;
    return this;
};
function $5440e9199a418654$var$_getMaxListeners(that) {
    if (that._maxListeners === undefined) return $5440e9199a418654$var$EventEmitter.defaultMaxListeners;
    return that._maxListeners;
}
$5440e9199a418654$var$EventEmitter.prototype.getMaxListeners = function getMaxListeners() {
    return $5440e9199a418654$var$_getMaxListeners(this);
};
$5440e9199a418654$var$EventEmitter.prototype.emit = function emit(type) {
    var args = [];
    for(var i = 1; i < arguments.length; i++)args.push(arguments[i]);
    var doError = type === "error";
    var events = this._events;
    if (events !== undefined) doError = doError && events.error === undefined;
    else if (!doError) return false;
    // If there is no 'error' event listener then throw.
    if (doError) {
        var er;
        if (args.length > 0) er = args[0];
        if (er instanceof Error) // Note: The comments on the `throw` lines are intentional, they show
        // up in Node's output if this results in an unhandled exception.
        throw er; // Unhandled 'error' event
        // At least give some kind of context to the user
        var err = new Error("Unhandled error." + (er ? " (" + er.message + ")" : ""));
        err.context = er;
        throw err; // Unhandled 'error' event
    }
    var handler = events[type];
    if (handler === undefined) return false;
    if (typeof handler === "function") $5440e9199a418654$var$ReflectApply(handler, this, args);
    else {
        var len = handler.length;
        var listeners = $5440e9199a418654$var$arrayClone(handler, len);
        for(var i = 0; i < len; ++i)$5440e9199a418654$var$ReflectApply(listeners[i], this, args);
    }
    return true;
};
function $5440e9199a418654$var$_addListener(target, type, listener, prepend) {
    var m;
    var events;
    var existing;
    $5440e9199a418654$var$checkListener(listener);
    events = target._events;
    if (events === undefined) {
        events = target._events = Object.create(null);
        target._eventsCount = 0;
    } else {
        // To avoid recursion in the case that type === "newListener"! Before
        // adding it to the listeners, first emit "newListener".
        if (events.newListener !== undefined) {
            target.emit("newListener", type, listener.listener ? listener.listener : listener);
            // Re-assign `events` because a newListener handler could have caused the
            // this._events to be assigned to a new object
            events = target._events;
        }
        existing = events[type];
    }
    if (existing === undefined) {
        // Optimize the case of one listener. Don't need the extra array object.
        existing = events[type] = listener;
        ++target._eventsCount;
    } else {
        if (typeof existing === "function") // Adding the second element, need to change to array.
        existing = events[type] = prepend ? [
            listener,
            existing
        ] : [
            existing,
            listener
        ];
        else if (prepend) existing.unshift(listener);
        else existing.push(listener);
        // Check for listener leak
        m = $5440e9199a418654$var$_getMaxListeners(target);
        if (m > 0 && existing.length > m && !existing.warned) {
            existing.warned = true;
            // No error code for this since it is a Warning
            // eslint-disable-next-line no-restricted-syntax
            var w = new Error("Possible EventEmitter memory leak detected. " + existing.length + " " + String(type) + " listeners " + "added. Use emitter.setMaxListeners() to " + "increase limit");
            w.name = "MaxListenersExceededWarning";
            w.emitter = target;
            w.type = type;
            w.count = existing.length;
            $5440e9199a418654$var$ProcessEmitWarning(w);
        }
    }
    return target;
}
$5440e9199a418654$var$EventEmitter.prototype.addListener = function addListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, false);
};
$5440e9199a418654$var$EventEmitter.prototype.on = $5440e9199a418654$var$EventEmitter.prototype.addListener;
$5440e9199a418654$var$EventEmitter.prototype.prependListener = function prependListener(type, listener) {
    return $5440e9199a418654$var$_addListener(this, type, listener, true);
};
function $5440e9199a418654$var$onceWrapper() {
    if (!this.fired) {
        this.target.removeListener(this.type, this.wrapFn);
        this.fired = true;
        if (arguments.length === 0) return this.listener.call(this.target);
        return this.listener.apply(this.target, arguments);
    }
}
function $5440e9199a418654$var$_onceWrap(target, type, listener) {
    var state = {
        fired: false,
        wrapFn: undefined,
        target: target,
        type: type,
        listener: listener
    };
    var wrapped = $5440e9199a418654$var$onceWrapper.bind(state);
    wrapped.listener = listener;
    state.wrapFn = wrapped;
    return wrapped;
}
$5440e9199a418654$var$EventEmitter.prototype.once = function once(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.on(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.prependOnceListener = function prependOnceListener(type, listener) {
    $5440e9199a418654$var$checkListener(listener);
    this.prependListener(type, $5440e9199a418654$var$_onceWrap(this, type, listener));
    return this;
};
// Emits a 'removeListener' event if and only if the listener was removed.
$5440e9199a418654$var$EventEmitter.prototype.removeListener = function removeListener(type, listener) {
    var list, events, position, i, originalListener;
    $5440e9199a418654$var$checkListener(listener);
    events = this._events;
    if (events === undefined) return this;
    list = events[type];
    if (list === undefined) return this;
    if (list === listener || list.listener === listener) {
        if (--this._eventsCount === 0) this._events = Object.create(null);
        else {
            delete events[type];
            if (events.removeListener) this.emit("removeListener", type, list.listener || listener);
        }
    } else if (typeof list !== "function") {
        position = -1;
        for(i = list.length - 1; i >= 0; i--)if (list[i] === listener || list[i].listener === listener) {
            originalListener = list[i].listener;
            position = i;
            break;
        }
        if (position < 0) return this;
        if (position === 0) list.shift();
        else $5440e9199a418654$var$spliceOne(list, position);
        if (list.length === 1) events[type] = list[0];
        if (events.removeListener !== undefined) this.emit("removeListener", type, originalListener || listener);
    }
    return this;
};
$5440e9199a418654$var$EventEmitter.prototype.off = $5440e9199a418654$var$EventEmitter.prototype.removeListener;
$5440e9199a418654$var$EventEmitter.prototype.removeAllListeners = function removeAllListeners(type) {
    var listeners, events, i;
    events = this._events;
    if (events === undefined) return this;
    // not listening for removeListener, no need to emit
    if (events.removeListener === undefined) {
        if (arguments.length === 0) {
            this._events = Object.create(null);
            this._eventsCount = 0;
        } else if (events[type] !== undefined) {
            if (--this._eventsCount === 0) this._events = Object.create(null);
            else delete events[type];
        }
        return this;
    }
    // emit removeListener for all listeners on all events
    if (arguments.length === 0) {
        var keys = Object.keys(events);
        var key;
        for(i = 0; i < keys.length; ++i){
            key = keys[i];
            if (key === "removeListener") continue;
            this.removeAllListeners(key);
        }
        this.removeAllListeners("removeListener");
        this._events = Object.create(null);
        this._eventsCount = 0;
        return this;
    }
    listeners = events[type];
    if (typeof listeners === "function") this.removeListener(type, listeners);
    else if (listeners !== undefined) // LIFO order
    for(i = listeners.length - 1; i >= 0; i--)this.removeListener(type, listeners[i]);
    return this;
};
function $5440e9199a418654$var$_listeners(target, type, unwrap) {
    var events = target._events;
    if (events === undefined) return [];
    var evlistener = events[type];
    if (evlistener === undefined) return [];
    if (typeof evlistener === "function") return unwrap ? [
        evlistener.listener || evlistener
    ] : [
        evlistener
    ];
    return unwrap ? $5440e9199a418654$var$unwrapListeners(evlistener) : $5440e9199a418654$var$arrayClone(evlistener, evlistener.length);
}
$5440e9199a418654$var$EventEmitter.prototype.listeners = function listeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, true);
};
$5440e9199a418654$var$EventEmitter.prototype.rawListeners = function rawListeners(type) {
    return $5440e9199a418654$var$_listeners(this, type, false);
};
$5440e9199a418654$var$EventEmitter.listenerCount = function(emitter, type) {
    if (typeof emitter.listenerCount === "function") return emitter.listenerCount(type);
    else return $5440e9199a418654$var$listenerCount.call(emitter, type);
};
$5440e9199a418654$var$EventEmitter.prototype.listenerCount = $5440e9199a418654$var$listenerCount;
function $5440e9199a418654$var$listenerCount(type) {
    var events = this._events;
    if (events !== undefined) {
        var evlistener = events[type];
        if (typeof evlistener === "function") return 1;
        else if (evlistener !== undefined) return evlistener.length;
    }
    return 0;
}
$5440e9199a418654$var$EventEmitter.prototype.eventNames = function eventNames() {
    return this._eventsCount > 0 ? $5440e9199a418654$var$ReflectOwnKeys(this._events) : [];
};
function $5440e9199a418654$var$arrayClone(arr, n) {
    var copy = new Array(n);
    for(var i = 0; i < n; ++i)copy[i] = arr[i];
    return copy;
}
function $5440e9199a418654$var$spliceOne(list, index) {
    for(; index + 1 < list.length; index++)list[index] = list[index + 1];
    list.pop();
}
function $5440e9199a418654$var$unwrapListeners(arr) {
    var ret = new Array(arr.length);
    for(var i = 0; i < ret.length; ++i)ret[i] = arr[i].listener || arr[i];
    return ret;
}
function $5440e9199a418654$var$once(emitter, name) {
    return new Promise(function(resolve, reject) {
        function errorListener(err) {
            emitter.removeListener(name, resolver);
            reject(err);
        }
        function resolver() {
            if (typeof emitter.removeListener === "function") emitter.removeListener("error", errorListener);
            resolve([].slice.call(arguments));
        }
        $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, resolver, {
            once: true
        });
        if (name !== "error") $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, errorListener, {
            once: true
        });
    });
}
function $5440e9199a418654$var$addErrorHandlerIfEventEmitter(emitter, handler, flags) {
    if (typeof emitter.on === "function") $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, "error", handler, flags);
}
function $5440e9199a418654$var$eventTargetAgnosticAddListener(emitter, name, listener, flags) {
    if (typeof emitter.on === "function") {
        if (flags.once) emitter.once(name, listener);
        else emitter.on(name, listener);
    } else if (typeof emitter.addEventListener === "function") // EventTarget does not have `error` event semantics like Node
    // EventEmitters, we do not listen for `error` events here.
    emitter.addEventListener(name, function wrapListener(arg) {
        // IE does not have builtin `{ once: true }` support so we
        // have to do it manually.
        if (flags.once) emitter.removeEventListener(name, wrapListener);
        listener(arg);
    });
    else throw new TypeError('The "emitter" argument must be of type EventEmitter. Received type ' + typeof emitter);
}

});

parcelRegister("kGRcS", function(module, exports) {

var $fJ45P = parcelRequire("fJ45P");
var $f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH = $fJ45P.MAX_SAFE_COMPONENT_LENGTH;
var $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH = $fJ45P.MAX_SAFE_BUILD_LENGTH;
var $f101009ed9c0563c$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;

var $i9RZm = parcelRequire("i9RZm");
exports = module.exports = {};
// The actual regexps go on exports.re
const re = exports.re = [];
const safeRe = exports.safeRe = [];
const src = exports.src = [];
const t = exports.t = {};
let R = 0;
const LETTERDASHNUMBER = "[a-zA-Z0-9-]";
// Replace some greedy regex tokens to prevent regex dos issues. These regex are
// used internally via the safeRe object since all inputs in this library get
// normalized first to trim and collapse all extra whitespace. The original
// regexes are exported for userland consumption and lower level usage. A
// future breaking change could export the safer regex only with a note that
// all input should have extra whitespace removed.
const safeRegexReplacements = [
    [
        "\\s",
        1
    ],
    [
        "\\d",
        $f101009ed9c0563c$require$MAX_LENGTH
    ],
    [
        LETTERDASHNUMBER,
        $f101009ed9c0563c$require$MAX_SAFE_BUILD_LENGTH
    ]
];
const makeSafeRegex = (value)=>{
    for (const [token, max] of safeRegexReplacements)value = value.split(`${token}*`).join(`${token}{0,${max}}`).split(`${token}+`).join(`${token}{1,${max}}`);
    return value;
};
const createToken = (name, value, isGlobal)=>{
    const safe = makeSafeRegex(value);
    const index = R++;
    $i9RZm(name, index, value);
    t[name] = index;
    src[index] = value;
    re[index] = new RegExp(value, isGlobal ? "g" : undefined);
    safeRe[index] = new RegExp(safe, isGlobal ? "g" : undefined);
};
// The following Regular Expressions can be used for tokenizing,
// validating, and parsing SemVer version strings.
// ## Numeric Identifier
// A single `0`, or a non-zero digit followed by zero or more digits.
createToken("NUMERICIDENTIFIER", "0|[1-9]\\d*");
createToken("NUMERICIDENTIFIERLOOSE", "\\d+");
// ## Non-numeric Identifier
// Zero or more digits, followed by a letter or hyphen, and then zero or
// more letters, digits, or hyphens.
createToken("NONNUMERICIDENTIFIER", `\\d*[a-zA-Z-]${LETTERDASHNUMBER}*`);
// ## Main Version
// Three dot-separated numeric identifiers.
createToken("MAINVERSION", `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})\\.` + `(${src[t.NUMERICIDENTIFIER]})`);
createToken("MAINVERSIONLOOSE", `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})\\.` + `(${src[t.NUMERICIDENTIFIERLOOSE]})`);
// ## Pre-release Version Identifier
// A numeric identifier, or a non-numeric identifier.
createToken("PRERELEASEIDENTIFIER", `(?:${src[t.NUMERICIDENTIFIER]}|${src[t.NONNUMERICIDENTIFIER]})`);
createToken("PRERELEASEIDENTIFIERLOOSE", `(?:${src[t.NUMERICIDENTIFIERLOOSE]}|${src[t.NONNUMERICIDENTIFIER]})`);
// ## Pre-release Version
// Hyphen, followed by one or more dot-separated pre-release version
// identifiers.
createToken("PRERELEASE", `(?:-(${src[t.PRERELEASEIDENTIFIER]}(?:\\.${src[t.PRERELEASEIDENTIFIER]})*))`);
createToken("PRERELEASELOOSE", `(?:-?(${src[t.PRERELEASEIDENTIFIERLOOSE]}(?:\\.${src[t.PRERELEASEIDENTIFIERLOOSE]})*))`);
// ## Build Metadata Identifier
// Any combination of digits, letters, or hyphens.
createToken("BUILDIDENTIFIER", `${LETTERDASHNUMBER}+`);
// ## Build Metadata
// Plus sign, followed by one or more period-separated build metadata
// identifiers.
createToken("BUILD", `(?:\\+(${src[t.BUILDIDENTIFIER]}(?:\\.${src[t.BUILDIDENTIFIER]})*))`);
// ## Full Version String
// A main version, followed optionally by a pre-release version and
// build metadata.
// Note that the only major, minor, patch, and pre-release sections of
// the version string are capturing groups.  The build metadata is not a
// capturing group, because it should not ever be used in version
// comparison.
createToken("FULLPLAIN", `v?${src[t.MAINVERSION]}${src[t.PRERELEASE]}?${src[t.BUILD]}?`);
createToken("FULL", `^${src[t.FULLPLAIN]}$`);
// like full, but allows v1.2.3 and =1.2.3, which people do sometimes.
// also, 1.0.0alpha1 (prerelease without the hyphen) which is pretty
// common in the npm registry.
createToken("LOOSEPLAIN", `[v=\\s]*${src[t.MAINVERSIONLOOSE]}${src[t.PRERELEASELOOSE]}?${src[t.BUILD]}?`);
createToken("LOOSE", `^${src[t.LOOSEPLAIN]}$`);
createToken("GTLT", "((?:<|>)?=?)");
// Something like "2.*" or "1.2.x".
// Note that "x.x" is a valid xRange identifer, meaning "any version"
// Only the first item is strictly required.
createToken("XRANGEIDENTIFIERLOOSE", `${src[t.NUMERICIDENTIFIERLOOSE]}|x|X|\\*`);
createToken("XRANGEIDENTIFIER", `${src[t.NUMERICIDENTIFIER]}|x|X|\\*`);
createToken("XRANGEPLAIN", `[v=\\s]*(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:\\.(${src[t.XRANGEIDENTIFIER]})` + `(?:${src[t.PRERELEASE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGEPLAINLOOSE", `[v=\\s]*(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:\\.(${src[t.XRANGEIDENTIFIERLOOSE]})` + `(?:${src[t.PRERELEASELOOSE]})?${src[t.BUILD]}?` + `)?)?`);
createToken("XRANGE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAIN]}$`);
createToken("XRANGELOOSE", `^${src[t.GTLT]}\\s*${src[t.XRANGEPLAINLOOSE]}$`);
// Coercion.
// Extract anything that could conceivably be a part of a valid semver
createToken("COERCEPLAIN", `${"(^|[^\\d])(\\d{1,"}${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}})` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?` + `(?:\\.(\\d{1,${$f101009ed9c0563c$require$MAX_SAFE_COMPONENT_LENGTH}}))?`);
createToken("COERCE", `${src[t.COERCEPLAIN]}(?:$|[^\\d])`);
createToken("COERCEFULL", src[t.COERCEPLAIN] + `(?:${src[t.PRERELEASE]})?` + `(?:${src[t.BUILD]})?` + `(?:$|[^\\d])`);
createToken("COERCERTL", src[t.COERCE], true);
createToken("COERCERTLFULL", src[t.COERCEFULL], true);
// Tilde ranges.
// Meaning is "reasonably at or greater than"
createToken("LONETILDE", "(?:~>?)");
createToken("TILDETRIM", `(\\s*)${src[t.LONETILDE]}\\s+`, true);
exports.tildeTrimReplace = "$1~";
createToken("TILDE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAIN]}$`);
createToken("TILDELOOSE", `^${src[t.LONETILDE]}${src[t.XRANGEPLAINLOOSE]}$`);
// Caret ranges.
// Meaning is "at least and backwards compatible with"
createToken("LONECARET", "(?:\\^)");
createToken("CARETTRIM", `(\\s*)${src[t.LONECARET]}\\s+`, true);
exports.caretTrimReplace = "$1^";
createToken("CARET", `^${src[t.LONECARET]}${src[t.XRANGEPLAIN]}$`);
createToken("CARETLOOSE", `^${src[t.LONECARET]}${src[t.XRANGEPLAINLOOSE]}$`);
// A simple gt/lt/eq thing, or just "" to indicate "any version"
createToken("COMPARATORLOOSE", `^${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]})$|^$`);
createToken("COMPARATOR", `^${src[t.GTLT]}\\s*(${src[t.FULLPLAIN]})$|^$`);
// An expression to strip any whitespace between the gtlt and the thing
// it modifies, so that `> 1.2.3` ==> `>1.2.3`
createToken("COMPARATORTRIM", `(\\s*)${src[t.GTLT]}\\s*(${src[t.LOOSEPLAIN]}|${src[t.XRANGEPLAIN]})`, true);
exports.comparatorTrimReplace = "$1$2$3";
// Something like `1.2.3 - 1.2.4`
// Note that these all use the loose form, because they'll be
// checked against either the strict or loose comparator form
// later.
createToken("HYPHENRANGE", `^\\s*(${src[t.XRANGEPLAIN]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAIN]})` + `\\s*$`);
createToken("HYPHENRANGELOOSE", `^\\s*(${src[t.XRANGEPLAINLOOSE]})` + `\\s+-\\s+` + `(${src[t.XRANGEPLAINLOOSE]})` + `\\s*$`);
// Star ranges basically just allow anything at all.
createToken("STAR", "(<|>)?=?\\s*\\*");
// >=0.0.0 is like a star
createToken("GTE0", "^\\s*>=\\s*0\\.0\\.0\\s*$");
createToken("GTE0PRE", "^\\s*>=\\s*0\\.0\\.0-0\\s*$");

});
parcelRegister("fJ45P", function(module, exports) {
// Note: this is the semver.org version of the spec that it implements
// Not necessarily the package version of this code.
const $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION = "2.0.0";
const $b72e3bc5fa8d2c21$var$MAX_LENGTH = 256;
const $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER = Number.MAX_SAFE_INTEGER || /* istanbul ignore next */ 9007199254740991;
// Max safe segment length for coercion.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH = 16;
// Max safe length for a build identifier. The max length minus 6 characters for
// the shortest version with a build 0.0.0+BUILD.
const $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH = $b72e3bc5fa8d2c21$var$MAX_LENGTH - 6;
const $b72e3bc5fa8d2c21$var$RELEASE_TYPES = [
    "major",
    "premajor",
    "minor",
    "preminor",
    "patch",
    "prepatch",
    "prerelease"
];
module.exports = {
    MAX_LENGTH: $b72e3bc5fa8d2c21$var$MAX_LENGTH,
    MAX_SAFE_COMPONENT_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_COMPONENT_LENGTH,
    MAX_SAFE_BUILD_LENGTH: $b72e3bc5fa8d2c21$var$MAX_SAFE_BUILD_LENGTH,
    MAX_SAFE_INTEGER: $b72e3bc5fa8d2c21$var$MAX_SAFE_INTEGER,
    RELEASE_TYPES: $b72e3bc5fa8d2c21$var$RELEASE_TYPES,
    SEMVER_SPEC_VERSION: $b72e3bc5fa8d2c21$var$SEMVER_SPEC_VERSION,
    FLAG_INCLUDE_PRERELEASE: 1,
    FLAG_LOOSE: 2
};

});

parcelRegister("i9RZm", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
const $d382f2433df5837c$var$debug = (typeof $hPtJY === "object" && $hPtJY.env && undefined, ()=>{});
module.exports = $d382f2433df5837c$var$debug;

});
parcelRegister("hPtJY", function(module, exports) {
// shim for using process in browser
var $cfae44f0dfdf62c0$var$process = module.exports = {};
// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.
var $cfae44f0dfdf62c0$var$cachedSetTimeout;
var $cfae44f0dfdf62c0$var$cachedClearTimeout;
function $cfae44f0dfdf62c0$var$defaultSetTimout() {
    throw new Error("setTimeout has not been defined");
}
function $cfae44f0dfdf62c0$var$defaultClearTimeout() {
    throw new Error("clearTimeout has not been defined");
}
(function() {
    try {
        if (typeof setTimeout === "function") $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        else $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = $cfae44f0dfdf62c0$var$defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === "function") $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        else $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    } catch (e) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = $cfae44f0dfdf62c0$var$defaultClearTimeout;
    }
})();
function $cfae44f0dfdf62c0$var$runTimeout(fun) {
    if ($cfae44f0dfdf62c0$var$cachedSetTimeout === setTimeout) //normal enviroments in sane situations
    return setTimeout(fun, 0);
    // if setTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedSetTimeout === $cfae44f0dfdf62c0$var$defaultSetTimout || !$cfae44f0dfdf62c0$var$cachedSetTimeout) && setTimeout) {
        $cfae44f0dfdf62c0$var$cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedSetTimeout(fun, 0);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(null, fun, 0);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return $cfae44f0dfdf62c0$var$cachedSetTimeout.call(this, fun, 0);
        }
    }
}
function $cfae44f0dfdf62c0$var$runClearTimeout(marker) {
    if ($cfae44f0dfdf62c0$var$cachedClearTimeout === clearTimeout) //normal enviroments in sane situations
    return clearTimeout(marker);
    // if clearTimeout wasn't available but was latter defined
    if (($cfae44f0dfdf62c0$var$cachedClearTimeout === $cfae44f0dfdf62c0$var$defaultClearTimeout || !$cfae44f0dfdf62c0$var$cachedClearTimeout) && clearTimeout) {
        $cfae44f0dfdf62c0$var$cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return $cfae44f0dfdf62c0$var$cachedClearTimeout(marker);
    } catch (e) {
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(null, marker);
        } catch (e) {
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return $cfae44f0dfdf62c0$var$cachedClearTimeout.call(this, marker);
        }
    }
}
var $cfae44f0dfdf62c0$var$queue = [];
var $cfae44f0dfdf62c0$var$draining = false;
var $cfae44f0dfdf62c0$var$currentQueue;
var $cfae44f0dfdf62c0$var$queueIndex = -1;
function $cfae44f0dfdf62c0$var$cleanUpNextTick() {
    if (!$cfae44f0dfdf62c0$var$draining || !$cfae44f0dfdf62c0$var$currentQueue) return;
    $cfae44f0dfdf62c0$var$draining = false;
    if ($cfae44f0dfdf62c0$var$currentQueue.length) $cfae44f0dfdf62c0$var$queue = $cfae44f0dfdf62c0$var$currentQueue.concat($cfae44f0dfdf62c0$var$queue);
    else $cfae44f0dfdf62c0$var$queueIndex = -1;
    if ($cfae44f0dfdf62c0$var$queue.length) $cfae44f0dfdf62c0$var$drainQueue();
}
function $cfae44f0dfdf62c0$var$drainQueue() {
    if ($cfae44f0dfdf62c0$var$draining) return;
    var timeout = $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$cleanUpNextTick);
    $cfae44f0dfdf62c0$var$draining = true;
    var len = $cfae44f0dfdf62c0$var$queue.length;
    while(len){
        $cfae44f0dfdf62c0$var$currentQueue = $cfae44f0dfdf62c0$var$queue;
        $cfae44f0dfdf62c0$var$queue = [];
        while(++$cfae44f0dfdf62c0$var$queueIndex < len)if ($cfae44f0dfdf62c0$var$currentQueue) $cfae44f0dfdf62c0$var$currentQueue[$cfae44f0dfdf62c0$var$queueIndex].run();
        $cfae44f0dfdf62c0$var$queueIndex = -1;
        len = $cfae44f0dfdf62c0$var$queue.length;
    }
    $cfae44f0dfdf62c0$var$currentQueue = null;
    $cfae44f0dfdf62c0$var$draining = false;
    $cfae44f0dfdf62c0$var$runClearTimeout(timeout);
}
$cfae44f0dfdf62c0$var$process.nextTick = function(fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) for(var i = 1; i < arguments.length; i++)args[i - 1] = arguments[i];
    $cfae44f0dfdf62c0$var$queue.push(new $cfae44f0dfdf62c0$var$Item(fun, args));
    if ($cfae44f0dfdf62c0$var$queue.length === 1 && !$cfae44f0dfdf62c0$var$draining) $cfae44f0dfdf62c0$var$runTimeout($cfae44f0dfdf62c0$var$drainQueue);
};
// v8 likes predictible objects
function $cfae44f0dfdf62c0$var$Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
$cfae44f0dfdf62c0$var$Item.prototype.run = function() {
    this.fun.apply(null, this.array);
};
$cfae44f0dfdf62c0$var$process.title = "browser";
$cfae44f0dfdf62c0$var$process.browser = true;
$cfae44f0dfdf62c0$var$process.env = {};
$cfae44f0dfdf62c0$var$process.argv = [];
$cfae44f0dfdf62c0$var$process.version = ""; // empty string to avoid regexp issues
$cfae44f0dfdf62c0$var$process.versions = {};
function $cfae44f0dfdf62c0$var$noop() {}
$cfae44f0dfdf62c0$var$process.on = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.addListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.once = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.off = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.removeAllListeners = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.emit = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.prependOnceListener = $cfae44f0dfdf62c0$var$noop;
$cfae44f0dfdf62c0$var$process.listeners = function(name) {
    return [];
};
$cfae44f0dfdf62c0$var$process.binding = function(name) {
    throw new Error("process.binding is not supported");
};
$cfae44f0dfdf62c0$var$process.cwd = function() {
    return "/";
};
$cfae44f0dfdf62c0$var$process.chdir = function(dir) {
    throw new Error("process.chdir is not supported");
};
$cfae44f0dfdf62c0$var$process.umask = function() {
    return 0;
};

});



parcelRegister("pyUmM", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $04cd69f16d83c082$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.AppClient = module.exports.PartialSignature = void 0;

var $1suGZ = parcelRequire("1suGZ");

var $bBRJ3 = parcelRequire("bBRJ3");

var $bUD38 = parcelRequire("bUD38");

var $goh0i = parcelRequire("goh0i");

var $fUsjC = parcelRequire("fUsjC");

var $8GOLq = parcelRequire("8GOLq");
const $04cd69f16d83c082$var$CLA_BTC = 0xe1;
const $04cd69f16d83c082$var$CLA_FRAMEWORK = 0xf8;
const $04cd69f16d83c082$var$CURRENT_PROTOCOL_VERSION = 1; // supported from version 2.1.0 of the app
var $04cd69f16d83c082$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($04cd69f16d83c082$var$BitcoinIns || ($04cd69f16d83c082$var$BitcoinIns = {}));
var $04cd69f16d83c082$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($04cd69f16d83c082$var$FrameworkIns || ($04cd69f16d83c082$var$FrameworkIns = {}));
/**
 * This class represents a partial signature produced by the app during signing.
 * It always contains the `signature` and the corresponding `pubkey` whose private key
 * was used for signing; in the case of taproot script paths, it also contains the
 * tapleaf hash.
 */ class $04cd69f16d83c082$var$PartialSignature {
    constructor(pubkey, signature, tapleafHash){
        this.pubkey = pubkey;
        this.signature = signature;
        this.tapleafHash = tapleafHash;
    }
}
module.exports.PartialSignature = $04cd69f16d83c082$var$PartialSignature;
/**
 * Creates an instance of `PartialSignature` from the returned raw augmented pubkey and signature.
 * @param pubkeyAugm the public key, concatenated with the tapleaf hash in the case of taproot script path spend.
 * @param signature the signature
 * @returns an instance of `PartialSignature`.
 */ function $04cd69f16d83c082$var$makePartialSignature(pubkeyAugm, signature) {
    if (pubkeyAugm.length == 64) // tapscript spend: concatenation of 32-bytes x-only pubkey and 32-bytes tapleaf_hash
    return new $04cd69f16d83c082$var$PartialSignature(pubkeyAugm.slice(0, 32), signature, pubkeyAugm.slice(32, 64));
    else if (pubkeyAugm.length == 32 || pubkeyAugm.length == 33) // legacy, segwit or taproot keypath spend: pubkeyAugm is just the pubkey
    return new $04cd69f16d83c082$var$PartialSignature(pubkeyAugm, signature);
    else throw new Error(`Invalid length for pubkeyAugm: ${pubkeyAugm.length} bytes.`);
}
/**
 * Checks whether a descriptor template contains an `a:` fragment.
 */ function $04cd69f16d83c082$var$containsA(descriptorTemplate) {
    const matches = descriptorTemplate.match(/[asctdvjnlu]+:/g) || [];
    return matches.some((match)=>match.includes("a"));
}
/**
 * This class encapsulates the APDU protocol documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md
 */ class $04cd69f16d83c082$var$AppClient {
    constructor(transport){
        this.transport = transport;
    }
    async makeRequest(ins, data, cci) {
        let response = await this.transport.send($04cd69f16d83c082$var$CLA_BTC, ins, 0, $04cd69f16d83c082$var$CURRENT_PROTOCOL_VERSION, data, [
            0x9000,
            0xe000
        ]);
        while(response.readUInt16BE(response.length - 2) === 0xe000){
            if (!cci) throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
            const hwRequest = response.slice(0, -2);
            const commandResponse = cci.execute(hwRequest);
            response = await this.transport.send($04cd69f16d83c082$var$CLA_FRAMEWORK, $04cd69f16d83c082$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                0x9000,
                0xe000
            ]);
        }
        return response.slice(0, -2); // drop the status word (can only be 0x9000 at this point)
    }
    /**
     * Returns an object containing the currently running app's name, version and the device status flags.
     *
     * @returns an object with app name, version and device status flags.
     */ async getAppAndVersion() {
        const r = await this.transport.send(0xb0, 0x01, 0x00, 0x00);
        let i = 0;
        const format = r[i++];
        if (format !== 1) throw new Error("Unexpected response");
        const nameLength = r[i++];
        const name = r.slice(i, i += nameLength).toString("ascii");
        const versionLength = r[i++];
        const version = r.slice(i, i += versionLength).toString("ascii");
        const flagLength = r[i++];
        const flags = r.slice(i, i += flagLength);
        return {
            name: name,
            version: version,
            flags: flags
        };
    }
    /**
     * Requests the BIP-32 extended pubkey to the hardware wallet.
     * If `display` is `false`, only standard paths will be accepted; an error is returned if an unusual path is
     * requested.
     * If `display` is `true`, the requested path is shown on screen for user verification; unusual paths can be
     * requested, and a warning is shown to the user in that case.
     *
     * @param path the requested BIP-32 path as a string
     * @param display `false` to silently retrieve a pubkey for a standard path, `true` to display the path on screen
     * @returns the base58-encoded serialized extended pubkey (xpub)
     */ async getExtendedPubkey(path, display = false) {
        const pathElements = (0, $1suGZ.pathStringToArray)(path);
        if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_PUBKEY, $04cd69f16d83c082$require$Buffer.concat([
            $04cd69f16d83c082$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            (0, $1suGZ.pathElementsToBuffer)(pathElements)
        ]));
        return response.toString("ascii");
    }
    /**
     * Registers a `WalletPolicy`, after interactive verification from the user.
     * On success, after user's approval, this function returns the id (which is the same that can be computed with
     * `walletPolicy.getid()`), followed by the 32-byte hmac. The client should store the hmac to use it for future
     * requests to `getWalletAddress` or `signPsbt` using this `WalletPolicy`.
     *
     * @param walletPolicy the `WalletPolicy` to register
     * @returns a pair of two 32-byte arrays: the id of the Wallet Policy, followed by the policy hmac
     */ async registerWallet(walletPolicy) {
        await this.validatePolicy(walletPolicy);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const serializedWalletPolicy = walletPolicy.serialize();
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.REGISTER_WALLET, $04cd69f16d83c082$require$Buffer.concat([
            (0, $8GOLq.createVarint)(serializedWalletPolicy.length),
            serializedWalletPolicy
        ]), clientInterpreter);
        if (response.length != 64) throw Error(`Invalid response length. Expected 64 bytes, got ${response.length}`);
        return [
            response.subarray(0, 32),
            response.subarray(32)
        ];
    }
    /**
     * Returns the address of `walletPolicy` for the given `change` and `addressIndex`.
     *
     * @param walletPolicy the `WalletPolicy` to use
     * @param walletHMAC the 32-byte hmac returned during wallet registration for a registered policy; otherwise
     * `null` for a standard policy
     * @param change `0` for a normal receive address, `1` for a change address
     * @param addressIndex the address index to retrieve
     * @param display `True` to show the address on screen, `False` to retrieve it silently
     * @returns the address, as an ascii string.
     */ async getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
        if (change !== 0 && change !== 1) throw new Error("Change can only be 0 or 1");
        if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error("Invalid address index");
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        await this.validatePolicy(walletPolicy);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        const addressIndexBuffer = $04cd69f16d83c082$require$Buffer.alloc(4);
        addressIndexBuffer.writeUInt32BE(addressIndex, 0);
        const response = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_WALLET_ADDRESS, $04cd69f16d83c082$require$Buffer.concat([
            $04cd69f16d83c082$require$Buffer.from(display ? [
                1
            ] : [
                0
            ]),
            walletPolicy.getId(),
            walletHMAC || $04cd69f16d83c082$require$Buffer.alloc(32, 0),
            $04cd69f16d83c082$require$Buffer.from([
                change
            ]),
            addressIndexBuffer
        ]), clientInterpreter);
        return response.toString("ascii");
    }
    /**
     * Signs a psbt using a (standard or registered) `WalletPolicy`. This is an interactive command, as user validation
     * is necessary using the device's secure screen.
     * On success, a map of input indexes and signatures is returned.
     * @param psbt a base64-encoded string, or a psbt in a binary Buffer. Using the `PsbtV2` type is deprecated.
     * @param walletPolicy the `WalletPolicy` to use for signing
     * @param walletHMAC the 32-byte hmac obtained during wallet policy registration, or `null` for a standard policy
     * @param progressCallback optionally, a callback that will be called every time a signature is produced during
     * the signing process. The callback does not receive any argument, but can be used to track progress.
     * @returns an array of of tuples with 2 elements containing:
     *    - the index of the input being signed;
     *    - an instance of PartialSignature
     */ async signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
        await this.validatePolicy(walletPolicy);
        if (typeof psbt === "string") psbt = $04cd69f16d83c082$require$Buffer.from(psbt, "base64");
        if ($04cd69f16d83c082$require$Buffer.isBuffer(psbt)) {
            const psbtObj = new $fUsjC.PsbtV2();
            psbtObj.deserialize(psbt);
            psbt = psbtObj;
        }
        const merkelizedPsbt = new $bUD38.MerkelizedPsbt(psbt);
        if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter(progressCallback);
        // prepare ClientCommandInterpreter
        clientInterpreter.addKnownWalletPolicy(walletPolicy);
        clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
        for (const map of merkelizedPsbt.inputMerkleMaps)clientInterpreter.addKnownMapping(map);
        for (const map of merkelizedPsbt.outputMerkleMaps)clientInterpreter.addKnownMapping(map);
        clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
        const inputMapsRoot = new $goh0i.Merkle(merkelizedPsbt.inputMapCommitments.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
        const outputMapsRoot = new $goh0i.Merkle(merkelizedPsbt.outputMapCommitments.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.SIGN_PSBT, $04cd69f16d83c082$require$Buffer.concat([
            merkelizedPsbt.getGlobalKeysValuesRoot(),
            (0, $8GOLq.createVarint)(merkelizedPsbt.getGlobalInputCount()),
            inputMapsRoot,
            (0, $8GOLq.createVarint)(merkelizedPsbt.getGlobalOutputCount()),
            outputMapsRoot,
            walletPolicy.getId(),
            walletHMAC || $04cd69f16d83c082$require$Buffer.alloc(32, 0)
        ]), clientInterpreter);
        const yielded = clientInterpreter.getYielded();
        const ret = [];
        for (const inputAndSig of yielded){
            // inputAndSig contains:
            // <inputIndex : varint> <pubkeyLen : 1 byte> <pubkey : pubkeyLen bytes (32 or 33)> <signature : variable length>
            const [inputIndex, inputIndexLen] = (0, $8GOLq.parseVarint)(inputAndSig, 0);
            const pubkeyAugmLen = inputAndSig[inputIndexLen];
            const pubkeyAugm = inputAndSig.subarray(inputIndexLen + 1, inputIndexLen + 1 + pubkeyAugmLen);
            const signature = inputAndSig.subarray(inputIndexLen + 1 + pubkeyAugmLen);
            const partialSig = $04cd69f16d83c082$var$makePartialSignature(pubkeyAugm, signature);
            ret.push([
                Number(inputIndex),
                partialSig
            ]);
        }
        return ret;
    }
    /**
     * Returns the fingerprint of the master public key, as per BIP-32 standard.
     * @returns the master key fingerprint as a string of 8 hexadecimal digits.
     */ async getMasterFingerprint() {
        const fpr = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.GET_MASTER_FINGERPRINT, $04cd69f16d83c082$require$Buffer.from([]));
        return fpr.toString("hex");
    }
    /**
     * Signs a message using the legacy Bitcoin Message Signing standard. The signed message is
     * the double-sha256 hash of the concatenation of:
     * - "\x18Bitcoin Signed Message:\n";
     * - the length of `message`, encoded as a Bitcoin-style variable length integer;
     * - `message`.
     *
     * @param message the serialized message to sign
     * @param path the BIP-32 path of the key used to sign the message
     * @returns base64-encoded signature of the message.
     */ async signMessage(message, path) {
        const pathElements = (0, $1suGZ.pathStringToArray)(path);
        const clientInterpreter = new $bBRJ3.ClientCommandInterpreter();
        // prepare ClientCommandInterpreter
        const nChunks = Math.ceil(message.length / 64);
        const chunks = [];
        for(let i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
        clientInterpreter.addKnownList(chunks);
        const chunksRoot = new $goh0i.Merkle(chunks.map((m)=>(0, $goh0i.hashLeaf)(m))).getRoot();
        const result = await this.makeRequest($04cd69f16d83c082$var$BitcoinIns.SIGN_MESSAGE, $04cd69f16d83c082$require$Buffer.concat([
            (0, $1suGZ.pathElementsToBuffer)(pathElements),
            (0, $8GOLq.createVarint)(message.length),
            chunksRoot
        ]), clientInterpreter);
        return result.toString("base64");
    }
    /* Performs any additional checks on the policy before using it.*/ async validatePolicy(walletPolicy) {
        if ($04cd69f16d83c082$var$containsA(walletPolicy.descriptorTemplate)) {
            const appAndVer = await this.getAppAndVersion();
            if ([
                "2.1.0",
                "2.1.1"
            ].includes(appAndVer.version)) // Versions 2.1.0 and 2.1.1 produced incorrect scripts for policies containing
            // the `a:` fragment.
            throw new Error("Please update your Ledger Bitcoin app.");
        }
    }
}
module.exports.AppClient = $04cd69f16d83c082$var$AppClient;
module.exports.default = $04cd69f16d83c082$var$AppClient;

});
parcelRegister("1suGZ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $110036d6b13dde20$require$Buffer = $6ZWSX.Buffer;
"use strict";
var $110036d6b13dde20$var$__importDefault = module.exports && module.exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hardenedPathOf = module.exports.getXpubComponents = module.exports.pubkeyFromXpub = module.exports.pathStringToArray = module.exports.pathArrayToString = module.exports.bip32asBuffer = module.exports.pathElementsToBuffer = void 0;

const $110036d6b13dde20$var$bip32_path_1 = $110036d6b13dde20$var$__importDefault((parcelRequire("4c5Uh"))); // TODO: get rid of this dependency

const $110036d6b13dde20$var$bs58check_1 = $110036d6b13dde20$var$__importDefault((parcelRequire("lpa1P")));
function $110036d6b13dde20$var$pathElementsToBuffer(paths) {
    const buffer = $110036d6b13dde20$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach((element, index)=>{
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
module.exports.pathElementsToBuffer = $110036d6b13dde20$var$pathElementsToBuffer;
function $110036d6b13dde20$var$bip32asBuffer(path) {
    const pathElements = !path ? [] : $110036d6b13dde20$var$pathStringToArray(path);
    return $110036d6b13dde20$var$pathElementsToBuffer(pathElements);
}
module.exports.bip32asBuffer = $110036d6b13dde20$var$bip32asBuffer;
function $110036d6b13dde20$var$pathArrayToString(pathElements) {
    // bippath doesn't handle an empty path.
    if (pathElements.length == 0) return "m";
    return $110036d6b13dde20$var$bip32_path_1.default.fromPathArray(pathElements).toString();
}
module.exports.pathArrayToString = $110036d6b13dde20$var$pathArrayToString;
function $110036d6b13dde20$var$pathStringToArray(path) {
    // bippath doesn't handle an empty path.
    if (path == "m" || path == "") return [];
    return $110036d6b13dde20$var$bip32_path_1.default.fromString(path).toPathArray();
}
module.exports.pathStringToArray = $110036d6b13dde20$var$pathStringToArray;
function $110036d6b13dde20$var$pubkeyFromXpub(xpub) {
    const xpubBuf = $110036d6b13dde20$var$bs58check_1.default.decode(xpub);
    return xpubBuf.slice(xpubBuf.length - 33);
}
module.exports.pubkeyFromXpub = $110036d6b13dde20$var$pubkeyFromXpub;
function $110036d6b13dde20$var$getXpubComponents(xpub) {
    const xpubBuf = $110036d6b13dde20$var$bs58check_1.default.decode(xpub);
    return {
        chaincode: xpubBuf.slice(13, 45),
        pubkey: xpubBuf.slice(xpubBuf.length - 33),
        version: xpubBuf.readUInt32BE(0)
    };
}
module.exports.getXpubComponents = $110036d6b13dde20$var$getXpubComponents;
function $110036d6b13dde20$var$hardenedPathOf(pathElements) {
    for(let i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}
module.exports.hardenedPathOf = $110036d6b13dde20$var$hardenedPathOf;

});
parcelRegister("4c5Uh", function(module, exports) {
/*
 * Bitcoin BIP32 path helpers
 * (C) 2016 Alex Beregszaszi
 */ const $30dcdd5c9ca402d9$var$HARDENED = 0x80000000;
var $30dcdd5c9ca402d9$var$BIPPath = function(path) {
    if (!Array.isArray(path)) throw new Error("Input must be an Array");
    if (path.length === 0) throw new Error("Path must contain at least one level");
    for(var i = 0; i < path.length; i++){
        if (typeof path[i] !== "number") throw new Error("Path element is not a number");
    }
    this.path = path;
};
$30dcdd5c9ca402d9$var$BIPPath.validatePathArray = function(path) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromPathArray(path);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.validateString = function(text, reqRoot) {
    try {
        $30dcdd5c9ca402d9$var$BIPPath.fromString(text, reqRoot);
        return true;
    } catch (e) {
        return false;
    }
};
$30dcdd5c9ca402d9$var$BIPPath.fromPathArray = function(path) {
    return new $30dcdd5c9ca402d9$var$BIPPath(path);
};
$30dcdd5c9ca402d9$var$BIPPath.fromString = function(text, reqRoot) {
    // skip the root
    if (/^m\//i.test(text)) text = text.slice(2);
    else if (reqRoot) throw new Error("Root element is required");
    var path = text.split("/");
    var ret = new Array(path.length);
    for(var i = 0; i < path.length; i++){
        var tmp = /(\d+)([hH\']?)/.exec(path[i]);
        if (tmp === null) throw new Error("Invalid input");
        ret[i] = parseInt(tmp[1], 10);
        if (ret[i] >= $30dcdd5c9ca402d9$var$HARDENED) throw new Error("Invalid child index");
        if (tmp[2] === "h" || tmp[2] === "H" || tmp[2] === "'") ret[i] += $30dcdd5c9ca402d9$var$HARDENED;
        else if (tmp[2].length != 0) throw new Error("Invalid modifier");
    }
    return new $30dcdd5c9ca402d9$var$BIPPath(ret);
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toPathArray = function() {
    return this.path;
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.toString = function(noRoot, oldStyle) {
    var ret = new Array(this.path.length);
    for(var i = 0; i < this.path.length; i++){
        var tmp = this.path[i];
        if (tmp & $30dcdd5c9ca402d9$var$HARDENED) ret[i] = (tmp & ~$30dcdd5c9ca402d9$var$HARDENED) + (oldStyle ? "h" : "'");
        else ret[i] = tmp;
    }
    return (noRoot ? "" : "m/") + ret.join("/");
};
$30dcdd5c9ca402d9$var$BIPPath.prototype.inspect = function() {
    return "BIPPath <" + this.toString() + ">";
};
module.exports = $30dcdd5c9ca402d9$var$BIPPath;

});

parcelRegister("lpa1P", function(module, exports) {
"use strict";

var $1R2J7 = parcelRequire("1R2J7");

var $bJNmB = parcelRequire("bJNmB");
// SHA256(SHA256(buffer))
function $f953b6354166cf05$var$sha256x2(buffer) {
    var tmp = $1R2J7("sha256").update(buffer).digest();
    return $1R2J7("sha256").update(tmp).digest();
}
module.exports = $bJNmB($f953b6354166cf05$var$sha256x2);

});
parcelRegister("1R2J7", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $loYLU = parcelRequire("loYLU");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $26nOC = parcelRequire("26nOC");
function $159cdb2c74f453a8$var$Hash(hash) {
    $26nOC.call(this, "digest");
    this._hash = hash;
}
$dlqwk($159cdb2c74f453a8$var$Hash, $26nOC);
$159cdb2c74f453a8$var$Hash.prototype._update = function(data) {
    this._hash.update(data);
};
$159cdb2c74f453a8$var$Hash.prototype._final = function() {
    return this._hash.digest();
};
module.exports = function createHash(alg) {
    alg = alg.toLowerCase();
    if (alg === "md5") return new $loYLU();
    if (alg === "rmd160" || alg === "ripemd160") return new $a8qBR();
    return new $159cdb2c74f453a8$var$Hash($5Z1sR(alg));
};

});
parcelRegister("dlqwk", function(module, exports) {
if (typeof Object.create === "function") // implementation from standard node.js 'util' module
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        ctor.prototype = Object.create(superCtor.prototype, {
            constructor: {
                value: ctor,
                enumerable: false,
                writable: true,
                configurable: true
            }
        });
    }
};
else // old school shim for old browsers
module.exports = function inherits(ctor, superCtor) {
    if (superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
};

});

parcelRegister("loYLU", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");

var $1U9GM = parcelRequire("1U9GM");
var $f94afad95abc0930$require$Buffer = $1U9GM.Buffer;
var $f94afad95abc0930$var$ARRAY16 = new Array(16);
function $f94afad95abc0930$var$MD5() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
}
$dlqwk($f94afad95abc0930$var$MD5, $eLdEM);
$f94afad95abc0930$var$MD5.prototype._update = function() {
    var M = $f94afad95abc0930$var$ARRAY16;
    for(var i = 0; i < 16; ++i)M[i] = this._block.readInt32LE(i * 4);
    var a = this._a;
    var b = this._b;
    var c = this._c;
    var d = this._d;
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[0], 0xd76aa478, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[1], 0xe8c7b756, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[2], 0x242070db, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[3], 0xc1bdceee, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[4], 0xf57c0faf, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[5], 0x4787c62a, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[6], 0xa8304613, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[7], 0xfd469501, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[8], 0x698098d8, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[9], 0x8b44f7af, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[10], 0xffff5bb1, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[11], 0x895cd7be, 22);
    a = $f94afad95abc0930$var$fnF(a, b, c, d, M[12], 0x6b901122, 7);
    d = $f94afad95abc0930$var$fnF(d, a, b, c, M[13], 0xfd987193, 12);
    c = $f94afad95abc0930$var$fnF(c, d, a, b, M[14], 0xa679438e, 17);
    b = $f94afad95abc0930$var$fnF(b, c, d, a, M[15], 0x49b40821, 22);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[1], 0xf61e2562, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[6], 0xc040b340, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[11], 0x265e5a51, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[0], 0xe9b6c7aa, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[5], 0xd62f105d, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[10], 0x02441453, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[15], 0xd8a1e681, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[4], 0xe7d3fbc8, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[9], 0x21e1cde6, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[14], 0xc33707d6, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[3], 0xf4d50d87, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[8], 0x455a14ed, 20);
    a = $f94afad95abc0930$var$fnG(a, b, c, d, M[13], 0xa9e3e905, 5);
    d = $f94afad95abc0930$var$fnG(d, a, b, c, M[2], 0xfcefa3f8, 9);
    c = $f94afad95abc0930$var$fnG(c, d, a, b, M[7], 0x676f02d9, 14);
    b = $f94afad95abc0930$var$fnG(b, c, d, a, M[12], 0x8d2a4c8a, 20);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[5], 0xfffa3942, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[8], 0x8771f681, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[11], 0x6d9d6122, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[14], 0xfde5380c, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[1], 0xa4beea44, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[4], 0x4bdecfa9, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[7], 0xf6bb4b60, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[10], 0xbebfbc70, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[13], 0x289b7ec6, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[0], 0xeaa127fa, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[3], 0xd4ef3085, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[6], 0x04881d05, 23);
    a = $f94afad95abc0930$var$fnH(a, b, c, d, M[9], 0xd9d4d039, 4);
    d = $f94afad95abc0930$var$fnH(d, a, b, c, M[12], 0xe6db99e5, 11);
    c = $f94afad95abc0930$var$fnH(c, d, a, b, M[15], 0x1fa27cf8, 16);
    b = $f94afad95abc0930$var$fnH(b, c, d, a, M[2], 0xc4ac5665, 23);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[0], 0xf4292244, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[7], 0x432aff97, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[14], 0xab9423a7, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[5], 0xfc93a039, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[12], 0x655b59c3, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[3], 0x8f0ccc92, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[10], 0xffeff47d, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[1], 0x85845dd1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[8], 0x6fa87e4f, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[15], 0xfe2ce6e0, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[6], 0xa3014314, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[13], 0x4e0811a1, 21);
    a = $f94afad95abc0930$var$fnI(a, b, c, d, M[4], 0xf7537e82, 6);
    d = $f94afad95abc0930$var$fnI(d, a, b, c, M[11], 0xbd3af235, 10);
    c = $f94afad95abc0930$var$fnI(c, d, a, b, M[2], 0x2ad7d2bb, 15);
    b = $f94afad95abc0930$var$fnI(b, c, d, a, M[9], 0xeb86d391, 21);
    this._a = this._a + a | 0;
    this._b = this._b + b | 0;
    this._c = this._c + c | 0;
    this._d = this._d + d | 0;
};
$f94afad95abc0930$var$MD5.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $f94afad95abc0930$require$Buffer.allocUnsafe(16);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    return buffer;
};
function $f94afad95abc0930$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $f94afad95abc0930$var$fnF(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnG(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnH(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + b | 0;
}
function $f94afad95abc0930$var$fnI(a, b, c, d, m, k, s) {
    return $f94afad95abc0930$var$rotl(a + (c ^ (b | ~d)) + m + k | 0, s) + b | 0;
}
module.exports = $f94afad95abc0930$var$MD5;

});
parcelRegister("eLdEM", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $abf00c68ae11d39d$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $abf00c68ae11d39d$require$Transform = $ioRHp.Transform;

var $dlqwk = parcelRequire("dlqwk");
function $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(val, prefix) {
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(val) && typeof val !== "string") throw new TypeError(prefix + " must be a string or a buffer");
}
function $abf00c68ae11d39d$var$HashBase(blockSize) {
    $abf00c68ae11d39d$require$Transform.call(this);
    this._block = $abf00c68ae11d39d$require$Buffer.allocUnsafe(blockSize);
    this._blockSize = blockSize;
    this._blockOffset = 0;
    this._length = [
        0,
        0,
        0,
        0
    ];
    this._finalized = false;
}
$dlqwk($abf00c68ae11d39d$var$HashBase, $abf00c68ae11d39d$require$Transform);
$abf00c68ae11d39d$var$HashBase.prototype._transform = function(chunk, encoding, callback) {
    var error = null;
    try {
        this.update(chunk, encoding);
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype._flush = function(callback) {
    var error = null;
    try {
        this.push(this.digest());
    } catch (err) {
        error = err;
    }
    callback(error);
};
$abf00c68ae11d39d$var$HashBase.prototype.update = function(data, encoding) {
    $abf00c68ae11d39d$var$throwIfNotStringOrBuffer(data, "Data");
    if (this._finalized) throw new Error("Digest already called");
    if (!$abf00c68ae11d39d$require$Buffer.isBuffer(data)) data = $abf00c68ae11d39d$require$Buffer.from(data, encoding);
    // consume data
    var block = this._block;
    var offset = 0;
    while(this._blockOffset + data.length - offset >= this._blockSize){
        for(var i = this._blockOffset; i < this._blockSize;)block[i++] = data[offset++];
        this._update();
        this._blockOffset = 0;
    }
    while(offset < data.length)block[this._blockOffset++] = data[offset++];
    // update length
    for(var j = 0, carry = data.length * 8; carry > 0; ++j){
        this._length[j] += carry;
        carry = this._length[j] / 0x0100000000 | 0;
        if (carry > 0) this._length[j] -= 0x0100000000 * carry;
    }
    return this;
};
$abf00c68ae11d39d$var$HashBase.prototype._update = function() {
    throw new Error("_update is not implemented");
};
$abf00c68ae11d39d$var$HashBase.prototype.digest = function(encoding) {
    if (this._finalized) throw new Error("Digest already called");
    this._finalized = true;
    var digest = this._digest();
    if (encoding !== undefined) digest = digest.toString(encoding);
    // reset state
    this._block.fill(0);
    this._blockOffset = 0;
    for(var i = 0; i < 4; ++i)this._length[i] = 0;
    return digest;
};
$abf00c68ae11d39d$var$HashBase.prototype._digest = function() {
    throw new Error("_digest is not implemented");
};
module.exports = $abf00c68ae11d39d$var$HashBase;

});
parcelRegister("ioRHp", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
module.exports = $d6541f691ffb0af6$var$Stream;

var $7etJZ = parcelRequire("7etJZ");
var $d6541f691ffb0af6$require$EE = $7etJZ.EventEmitter;

var $dlqwk = parcelRequire("dlqwk");
$dlqwk($d6541f691ffb0af6$var$Stream, $d6541f691ffb0af6$require$EE);

$d6541f691ffb0af6$var$Stream.Readable = (parcelRequire("aBufs"));

$d6541f691ffb0af6$var$Stream.Writable = (parcelRequire("6XbcT"));

$d6541f691ffb0af6$var$Stream.Duplex = (parcelRequire("fFuzr"));

$d6541f691ffb0af6$var$Stream.Transform = (parcelRequire("k3Gr9"));

$d6541f691ffb0af6$var$Stream.PassThrough = (parcelRequire("6G2fH"));

$d6541f691ffb0af6$var$Stream.finished = (parcelRequire("hzqCm"));

$d6541f691ffb0af6$var$Stream.pipeline = (parcelRequire("coyuH"));
// Backwards-compat with node 0.4.x
$d6541f691ffb0af6$var$Stream.Stream = $d6541f691ffb0af6$var$Stream;
// old-style streams.  Note that the pipe method (the only relevant
// part of this class) is overridden in the Readable class.
function $d6541f691ffb0af6$var$Stream() {
    $d6541f691ffb0af6$require$EE.call(this);
}
$d6541f691ffb0af6$var$Stream.prototype.pipe = function(dest, options) {
    var source = this;
    function ondata(chunk) {
        if (dest.writable) {
            if (false === dest.write(chunk) && source.pause) source.pause();
        }
    }
    source.on("data", ondata);
    function ondrain() {
        if (source.readable && source.resume) source.resume();
    }
    dest.on("drain", ondrain);
    // If the 'end' option is not supplied, dest.end() will be called when
    // source gets the 'end' or 'close' events.  Only dest.end() once.
    if (!dest._isStdio && (!options || options.end !== false)) {
        source.on("end", onend);
        source.on("close", onclose);
    }
    var didOnEnd = false;
    function onend() {
        if (didOnEnd) return;
        didOnEnd = true;
        dest.end();
    }
    function onclose() {
        if (didOnEnd) return;
        didOnEnd = true;
        if (typeof dest.destroy === "function") dest.destroy();
    }
    // don't leave dangling pipes when there are errors.
    function onerror(er) {
        cleanup();
        if ($d6541f691ffb0af6$require$EE.listenerCount(this, "error") === 0) throw er; // Unhandled stream error in pipe.
    }
    source.on("error", onerror);
    dest.on("error", onerror);
    // remove all the event listeners that were added.
    function cleanup() {
        source.removeListener("data", ondata);
        dest.removeListener("drain", ondrain);
        source.removeListener("end", onend);
        source.removeListener("close", onclose);
        source.removeListener("error", onerror);
        dest.removeListener("error", onerror);
        source.removeListener("end", cleanup);
        source.removeListener("close", cleanup);
        dest.removeListener("close", cleanup);
    }
    source.on("end", cleanup);
    source.on("close", cleanup);
    dest.on("close", cleanup);
    dest.emit("pipe", source);
    // Allow for unix-like usage: A.pipe(B).pipe(C)
    return dest;
};

});
parcelRegister("aBufs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $7b84d2ca8f0d8afd$var$Readable;
/*<replacement>*/ var $7b84d2ca8f0d8afd$var$Duplex;
/*</replacement>*/ $7b84d2ca8f0d8afd$var$Readable.ReadableState = $7b84d2ca8f0d8afd$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $7b84d2ca8f0d8afd$require$EE = $7etJZ.EventEmitter;
var $7b84d2ca8f0d8afd$var$EElistenerCount = function EElistenerCount(emitter, type) {
    return emitter.listeners(type).length;
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $7b84d2ca8f0d8afd$require$Buffer = $6ZWSX.Buffer;
var $7b84d2ca8f0d8afd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk) {
    return $7b84d2ca8f0d8afd$require$Buffer.from(chunk);
}
function $7b84d2ca8f0d8afd$var$_isUint8Array(obj) {
    return $7b84d2ca8f0d8afd$require$Buffer.isBuffer(obj) || obj instanceof $7b84d2ca8f0d8afd$var$OurUint8Array;
}

var $kjyEk = parcelRequire("kjyEk");
var $7b84d2ca8f0d8afd$var$debug;
if ($kjyEk && $kjyEk.debuglog) $7b84d2ca8f0d8afd$var$debug = $kjyEk.debuglog("stream");
else $7b84d2ca8f0d8afd$var$debug = function debug() {};

var $6aKSQ = parcelRequire("6aKSQ");

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $7b84d2ca8f0d8afd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $7b84d2ca8f0d8afd$require$_require$codes = $967Aq.codes;
var $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE = $7b84d2ca8f0d8afd$require$_require$codes.ERR_INVALID_ARG_TYPE, $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_PUSH_AFTER_EOF, $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED = $7b84d2ca8f0d8afd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT = $7b84d2ca8f0d8afd$require$_require$codes.ERR_STREAM_UNSHIFT_AFTER_END_EVENT;
// Lazy loaded to improve the startup performance.
var $7b84d2ca8f0d8afd$var$StringDecoder;
var $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator;
var $7b84d2ca8f0d8afd$var$from;

(parcelRequire("dlqwk"))($7b84d2ca8f0d8afd$var$Readable, $jJj7p);
var $7b84d2ca8f0d8afd$var$errorOrDestroy = $fnDgj.errorOrDestroy;
var $7b84d2ca8f0d8afd$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $7b84d2ca8f0d8afd$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if (Array.isArray(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $7b84d2ca8f0d8afd$var$ReadableState(options, stream, isDuplex) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $7b84d2ca8f0d8afd$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    this.highWaterMark = $7b84d2ca8f0d8afd$var$getHighWaterMark(this, options, "readableHighWaterMark", isDuplex);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $6aKSQ();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    this.paused = true;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'end' (and potentially 'finish')
    this.autoDestroy = !!options.autoDestroy;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
        this.decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $7b84d2ca8f0d8afd$var$Readable(options) {
    $7b84d2ca8f0d8afd$var$Duplex = $7b84d2ca8f0d8afd$var$Duplex || (parcelRequire("fFuzr"));
    if (!(this instanceof $7b84d2ca8f0d8afd$var$Readable)) return new $7b84d2ca8f0d8afd$var$Readable(options);
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the ReadableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $7b84d2ca8f0d8afd$var$Duplex;
    this._readableState = new $7b84d2ca8f0d8afd$var$ReadableState(options, this, isDuplex);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jJj7p.call(this);
}
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$7b84d2ca8f0d8afd$var$Readable.prototype.destroy = $fnDgj.destroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._undestroy = $fnDgj.undestroy;
$7b84d2ca8f0d8afd$var$Readable.prototype._destroy = function(err, cb) {
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$7b84d2ca8f0d8afd$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $7b84d2ca8f0d8afd$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$7b84d2ca8f0d8afd$var$Readable.prototype.unshift = function(chunk) {
    return $7b84d2ca8f0d8afd$var$readableAddChunk(this, chunk, null, true, false);
};
function $7b84d2ca8f0d8afd$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    $7b84d2ca8f0d8afd$var$debug("readableAddChunk", chunk);
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $7b84d2ca8f0d8afd$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk);
        if (er) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $7b84d2ca8f0d8afd$require$Buffer.prototype) chunk = $7b84d2ca8f0d8afd$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_UNSHIFT_AFTER_END_EVENT());
                else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) $7b84d2ca8f0d8afd$var$errorOrDestroy(stream, new $7b84d2ca8f0d8afd$var$ERR_STREAM_PUSH_AFTER_EOF());
            else if (state.destroyed) return false;
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
                    else $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
                } else $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) {
            state.reading = false;
            $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
        }
    }
    // We can push more data if we are below the highWaterMark.
    // Also, if we have no data yet, we can stand some more bytes.
    // This is to work around cases where hwm=0, such as the repl.
    return !state.ended && (state.length < state.highWaterMark || state.length === 0);
}
function $7b84d2ca8f0d8afd$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        state.awaitDrain = 0;
        stream.emit("data", chunk);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $7b84d2ca8f0d8afd$var$emitReadable(stream);
    }
    $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state);
}
function $7b84d2ca8f0d8afd$var$chunkInvalid(state, chunk) {
    var er;
    if (!$7b84d2ca8f0d8afd$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new $7b84d2ca8f0d8afd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer",
        "Uint8Array"
    ], chunk);
    return er;
}
$7b84d2ca8f0d8afd$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$7b84d2ca8f0d8afd$var$Readable.prototype.setEncoding = function(enc) {
    if (!$7b84d2ca8f0d8afd$var$StringDecoder) $7b84d2ca8f0d8afd$var$StringDecoder = (parcelRequire("eNRCS")).StringDecoder;
    var decoder = new $7b84d2ca8f0d8afd$var$StringDecoder(enc);
    this._readableState.decoder = decoder;
    // If setEncoding(null), decoder.encoding equals utf8
    this._readableState.encoding = this._readableState.decoder.encoding;
    // Iterate over current buffer to convert already stored Buffers:
    var p = this._readableState.buffer.head;
    var content = "";
    while(p !== null){
        content += decoder.write(p.data);
        p = p.next;
    }
    this._readableState.buffer.clear();
    if (content !== "") this._readableState.buffer.push(content);
    this._readableState.length = content.length;
    return this;
};
// Don't raise the hwm > 1GB
var $7b84d2ca8f0d8afd$var$MAX_HWM = 0x40000000;
function $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n) {
    if (n >= $7b84d2ca8f0d8afd$var$MAX_HWM) // TODO(ronag): Throw ERR_VALUE_OUT_OF_RANGE.
    n = $7b84d2ca8f0d8afd$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $7b84d2ca8f0d8afd$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$7b84d2ca8f0d8afd$var$Readable.prototype.read = function(n) {
    $7b84d2ca8f0d8afd$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && ((state.highWaterMark !== 0 ? state.length >= state.highWaterMark : state.length > 0) || state.ended)) {
        $7b84d2ca8f0d8afd$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
        else $7b84d2ca8f0d8afd$var$emitReadable(this);
        return null;
    }
    n = $7b84d2ca8f0d8afd$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $7b84d2ca8f0d8afd$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $7b84d2ca8f0d8afd$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $7b84d2ca8f0d8afd$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $7b84d2ca8f0d8afd$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $7b84d2ca8f0d8afd$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $7b84d2ca8f0d8afd$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $7b84d2ca8f0d8afd$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = state.length <= state.highWaterMark;
        n = 0;
    } else {
        state.length -= n;
        state.awaitDrain = 0;
    }
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $7b84d2ca8f0d8afd$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $7b84d2ca8f0d8afd$var$onEofChunk(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("onEofChunk");
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    if (state.sync) // if we are sync, wait until next tick to emit the data.
    // Otherwise we risk emitting data in the flow()
    // the readable code triggers during a read() call
    $7b84d2ca8f0d8afd$var$emitReadable(stream);
    else {
        // emit 'readable' now to make sure it gets picked up.
        state.needReadable = false;
        if (!state.emittedReadable) {
            state.emittedReadable = true;
            $7b84d2ca8f0d8afd$var$emitReadable_(stream);
        }
    }
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $7b84d2ca8f0d8afd$var$emitReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable", state.needReadable, state.emittedReadable);
    state.needReadable = false;
    if (!state.emittedReadable) {
        $7b84d2ca8f0d8afd$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$emitReadable_, stream);
    }
}
function $7b84d2ca8f0d8afd$var$emitReadable_(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("emitReadable_", state.destroyed, state.length, state.ended);
    if (!state.destroyed && (state.length || state.ended)) {
        stream.emit("readable");
        state.emittedReadable = false;
    }
    // The stream needs another readable event if
    // 1. It is not flowing, as the flow mechanism will take
    //    care of it.
    // 2. It is not ended.
    // 3. It is below the highWaterMark, so we can schedule
    //    another readable later.
    state.needReadable = !state.flowing && !state.ended && state.length <= state.highWaterMark;
    $7b84d2ca8f0d8afd$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $7b84d2ca8f0d8afd$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$maybeReadMore_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$maybeReadMore_(stream, state) {
    // Attempt to read more data if we should.
    //
    // The conditions for reading more data are (one of):
    // - Not enough data buffered (state.length < state.highWaterMark). The loop
    //   is responsible for filling the buffer with enough data if such data
    //   is available. If highWaterMark is 0 and we are not in the flowing mode
    //   we should _not_ attempt to buffer any extra data. We'll get more data
    //   when the stream consumer calls read() instead.
    // - No data in the buffer, and the stream is in flowing mode. In this mode
    //   the loop below is responsible for ensuring read() is called. Failing to
    //   call read here would abort the flow and there's no other mechanism for
    //   continuing the flow if the stream consumer has just subscribed to the
    //   'data' event.
    //
    // In addition to the above conditions to keep reading data, the following
    // conditions prevent the data from being read:
    // - The stream has ended (state.ended).
    // - There is already a pending 'read' operation (state.reading). This is a
    //   case where the the stream has called the implementation defined _read()
    //   method, but they are processing the call asynchronously and have _not_
    //   called push() with new data. In this case we skip performing more
    //   read()s. The execution ends in this method again after the _read() ends
    //   up calling push() with more data.
    while(!state.reading && !state.ended && (state.length < state.highWaterMark || state.flowing && state.length === 0)){
        var len = state.length;
        $7b84d2ca8f0d8afd$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$7b84d2ca8f0d8afd$var$Readable.prototype._read = function(n) {
    $7b84d2ca8f0d8afd$var$errorOrDestroy(this, new $7b84d2ca8f0d8afd$var$ERR_METHOD_NOT_IMPLEMENTED("_read()"));
};
$7b84d2ca8f0d8afd$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $7b84d2ca8f0d8afd$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $hPtJY.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $7b84d2ca8f0d8afd$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $7b84d2ca8f0d8afd$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $7b84d2ca8f0d8afd$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $7b84d2ca8f0d8afd$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    src.on("data", ondata);
    function ondata(chunk) {
        $7b84d2ca8f0d8afd$var$debug("ondata");
        var ret = dest.write(chunk);
        $7b84d2ca8f0d8afd$var$debug("dest.write", ret);
        if (ret === false) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $7b84d2ca8f0d8afd$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $7b84d2ca8f0d8afd$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($7b84d2ca8f0d8afd$var$EElistenerCount(dest, "error") === 0) $7b84d2ca8f0d8afd$var$errorOrDestroy(dest, er);
    }
    // Make sure our error handler is attached before userland ones.
    $7b84d2ca8f0d8afd$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $7b84d2ca8f0d8afd$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $7b84d2ca8f0d8afd$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $7b84d2ca8f0d8afd$var$pipeOnDrain(src) {
    return function pipeOnDrainFunctionResult() {
        var state = src._readableState;
        $7b84d2ca8f0d8afd$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $7b84d2ca8f0d8afd$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $7b84d2ca8f0d8afd$var$flow(src);
        }
    };
}
$7b84d2ca8f0d8afd$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $7b84d2ca8f0d8afd$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$7b84d2ca8f0d8afd$var$Readable.prototype.on = function(ev, fn) {
    var res = $jJj7p.prototype.on.call(this, ev, fn);
    var state = this._readableState;
    if (ev === "data") {
        // update readableListening so that resume() may be a no-op
        // a few lines down. This is needed to support once('readable').
        state.readableListening = this.listenerCount("readable") > 0;
        // Try start flowing on next tick if stream isn't explicitly paused
        if (state.flowing !== false) this.resume();
    } else if (ev === "readable") {
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.flowing = false;
            state.emittedReadable = false;
            $7b84d2ca8f0d8afd$var$debug("on readable", state.length, state.reading);
            if (state.length) $7b84d2ca8f0d8afd$var$emitReadable(this);
            else if (!state.reading) $hPtJY.nextTick($7b84d2ca8f0d8afd$var$nReadingNextTick, this);
        }
    }
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.addListener = $7b84d2ca8f0d8afd$var$Readable.prototype.on;
$7b84d2ca8f0d8afd$var$Readable.prototype.removeListener = function(ev, fn) {
    var res = $jJj7p.prototype.removeListener.call(this, ev, fn);
    if (ev === "readable") // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
$7b84d2ca8f0d8afd$var$Readable.prototype.removeAllListeners = function(ev) {
    var res = $jJj7p.prototype.removeAllListeners.apply(this, arguments);
    if (ev === "readable" || ev === undefined) // We need to check if there is someone still listening to
    // readable and reset the state. However this needs to happen
    // after readable has been emitted but before I/O (nextTick) to
    // support once('readable', fn) cycles. This means that calling
    // resume within the same tick will have no
    // effect.
    $hPtJY.nextTick($7b84d2ca8f0d8afd$var$updateReadableListening, this);
    return res;
};
function $7b84d2ca8f0d8afd$var$updateReadableListening(self1) {
    var state = self1._readableState;
    state.readableListening = self1.listenerCount("readable") > 0;
    if (state.resumeScheduled && !state.paused) // flowing needs to be set to true now, otherwise
    // the upcoming resume will not flow.
    state.flowing = true;
    else if (self1.listenerCount("data") > 0) self1.resume();
}
function $7b84d2ca8f0d8afd$var$nReadingNextTick(self1) {
    $7b84d2ca8f0d8afd$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$7b84d2ca8f0d8afd$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $7b84d2ca8f0d8afd$var$debug("resume");
        // we flow only if there is no one listening
        // for readable, but we still have to call
        // resume()
        state.flowing = !state.readableListening;
        $7b84d2ca8f0d8afd$var$resume(this, state);
    }
    state.paused = false;
    return this;
};
function $7b84d2ca8f0d8afd$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$resume_, stream, state);
    }
}
function $7b84d2ca8f0d8afd$var$resume_(stream, state) {
    $7b84d2ca8f0d8afd$var$debug("resume", state.reading);
    if (!state.reading) stream.read(0);
    state.resumeScheduled = false;
    stream.emit("resume");
    $7b84d2ca8f0d8afd$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$7b84d2ca8f0d8afd$var$Readable.prototype.pause = function() {
    $7b84d2ca8f0d8afd$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (this._readableState.flowing !== false) {
        $7b84d2ca8f0d8afd$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    this._readableState.paused = true;
    return this;
};
function $7b84d2ca8f0d8afd$var$flow(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$7b84d2ca8f0d8afd$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $7b84d2ca8f0d8afd$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $7b84d2ca8f0d8afd$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function methodWrap(method) {
        return function methodWrapReturnFunction() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $7b84d2ca8f0d8afd$var$kProxyEvents.length; n++)stream.on($7b84d2ca8f0d8afd$var$kProxyEvents[n], this.emit.bind(this, $7b84d2ca8f0d8afd$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $7b84d2ca8f0d8afd$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.prototype[Symbol.asyncIterator] = function() {
    if ($7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator === undefined) $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator = (parcelRequire("3etzH"));
    return $7b84d2ca8f0d8afd$var$createReadableStreamAsyncIterator(this);
};
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.highWaterMark;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState && this._readableState.buffer;
    }
});
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableFlowing", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.flowing;
    },
    set: function set(state) {
        if (this._readableState) this._readableState.flowing = state;
    }
});
// exposed for testing purposes only.
$7b84d2ca8f0d8afd$var$Readable._fromList = $7b84d2ca8f0d8afd$var$fromList;
Object.defineProperty($7b84d2ca8f0d8afd$var$Readable.prototype, "readableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._readableState.length;
    }
});
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $7b84d2ca8f0d8afd$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.first();
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = state.buffer.consume(n, state.decoder);
    return ret;
}
function $7b84d2ca8f0d8afd$var$endReadable(stream) {
    var state = stream._readableState;
    $7b84d2ca8f0d8afd$var$debug("endReadable", state.endEmitted);
    if (!state.endEmitted) {
        state.ended = true;
        $hPtJY.nextTick($7b84d2ca8f0d8afd$var$endReadableNT, state, stream);
    }
}
function $7b84d2ca8f0d8afd$var$endReadableNT(state, stream) {
    $7b84d2ca8f0d8afd$var$debug("endReadableNT", state.endEmitted, state.length);
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
        if (state.autoDestroy) {
            // In case of duplex streams we need a way to detect
            // if the writable side is ready for autoDestroy as well
            var wState = stream._writableState;
            if (!wState || wState.autoDestroy && wState.finished) stream.destroy();
        }
    }
}

if (typeof Symbol === "function") $7b84d2ca8f0d8afd$var$Readable.from = function(iterable, opts) {
    if ($7b84d2ca8f0d8afd$var$from === undefined) $7b84d2ca8f0d8afd$var$from = (parcelRequire("gN4Jr"));
    return $7b84d2ca8f0d8afd$var$from($7b84d2ca8f0d8afd$var$Readable, iterable, opts);
};
function $7b84d2ca8f0d8afd$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("jJj7p", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("kjyEk", function(module, exports) {
"use strict";

});

parcelRegister("6aKSQ", function(module, exports) {
"use strict";
function $47e80b5d1f4ca857$var$ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        enumerableOnly && (symbols = symbols.filter(function(sym) {
            return Object.getOwnPropertyDescriptor(object, sym).enumerable;
        })), keys.push.apply(keys, symbols);
    }
    return keys;
}
function $47e80b5d1f4ca857$var$_objectSpread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = null != arguments[i] ? arguments[i] : {};
        i % 2 ? $47e80b5d1f4ca857$var$ownKeys(Object(source), !0).forEach(function(key) {
            $47e80b5d1f4ca857$var$_defineProperty(target, key, source[key]);
        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : $47e80b5d1f4ca857$var$ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function $47e80b5d1f4ca857$var$_defineProperty(obj, key, value) {
    key = $47e80b5d1f4ca857$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $47e80b5d1f4ca857$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}
function $47e80b5d1f4ca857$var$_defineProperties(target, props) {
    for(var i = 0; i < props.length; i++){
        var descriptor = props[i];
        descriptor.enumerable = descriptor.enumerable || false;
        descriptor.configurable = true;
        if ("value" in descriptor) descriptor.writable = true;
        Object.defineProperty(target, $47e80b5d1f4ca857$var$_toPropertyKey(descriptor.key), descriptor);
    }
}
function $47e80b5d1f4ca857$var$_createClass(Constructor, protoProps, staticProps) {
    if (protoProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor.prototype, protoProps);
    if (staticProps) $47e80b5d1f4ca857$var$_defineProperties(Constructor, staticProps);
    Object.defineProperty(Constructor, "prototype", {
        writable: false
    });
    return Constructor;
}
function $47e80b5d1f4ca857$var$_toPropertyKey(arg) {
    var key = $47e80b5d1f4ca857$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $47e80b5d1f4ca857$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $6ZWSX = parcelRequire("6ZWSX");
var $47e80b5d1f4ca857$var$Buffer = $6ZWSX.Buffer;

var $kjyEk = parcelRequire("kjyEk");
var $47e80b5d1f4ca857$var$inspect = $kjyEk.inspect;
var $47e80b5d1f4ca857$var$custom = $47e80b5d1f4ca857$var$inspect && $47e80b5d1f4ca857$var$inspect.custom || "inspect";
function $47e80b5d1f4ca857$var$copyBuffer(src, target, offset) {
    $47e80b5d1f4ca857$var$Buffer.prototype.copy.call(src, target, offset);
}
module.exports = /*#__PURE__*/ function() {
    function BufferList() {
        $47e80b5d1f4ca857$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    $47e80b5d1f4ca857$var$_createClass(BufferList, [
        {
            key: "push",
            value: function push(v) {
                var entry = {
                    data: v,
                    next: null
                };
                if (this.length > 0) this.tail.next = entry;
                else this.head = entry;
                this.tail = entry;
                ++this.length;
            }
        },
        {
            key: "unshift",
            value: function unshift(v) {
                var entry = {
                    data: v,
                    next: this.head
                };
                if (this.length === 0) this.tail = entry;
                this.head = entry;
                ++this.length;
            }
        },
        {
            key: "shift",
            value: function shift() {
                if (this.length === 0) return;
                var ret = this.head.data;
                if (this.length === 1) this.head = this.tail = null;
                else this.head = this.head.next;
                --this.length;
                return ret;
            }
        },
        {
            key: "clear",
            value: function clear() {
                this.head = this.tail = null;
                this.length = 0;
            }
        },
        {
            key: "join",
            value: function join(s) {
                if (this.length === 0) return "";
                var p = this.head;
                var ret = "" + p.data;
                while(p = p.next)ret += s + p.data;
                return ret;
            }
        },
        {
            key: "concat",
            value: function concat(n) {
                if (this.length === 0) return $47e80b5d1f4ca857$var$Buffer.alloc(0);
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n >>> 0);
                var p = this.head;
                var i = 0;
                while(p){
                    $47e80b5d1f4ca857$var$copyBuffer(p.data, ret, i);
                    i += p.data.length;
                    p = p.next;
                }
                return ret;
            }
        },
        {
            key: "consume",
            value: function consume(n, hasStrings) {
                var ret;
                if (n < this.head.data.length) {
                    // `slice` is the same for buffers and strings.
                    ret = this.head.data.slice(0, n);
                    this.head.data = this.head.data.slice(n);
                } else if (n === this.head.data.length) // First chunk is a perfect match.
                ret = this.shift();
                else // Result spans more than one buffer.
                ret = hasStrings ? this._getString(n) : this._getBuffer(n);
                return ret;
            }
        },
        {
            key: "first",
            value: function first() {
                return this.head.data;
            }
        },
        {
            key: "_getString",
            value: function _getString(n) {
                var p = this.head;
                var c = 1;
                var ret = p.data;
                n -= ret.length;
                while(p = p.next){
                    var str = p.data;
                    var nb = n > str.length ? str.length : n;
                    if (nb === str.length) ret += str;
                    else ret += str.slice(0, n);
                    n -= nb;
                    if (n === 0) {
                        if (nb === str.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = str.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: "_getBuffer",
            value: function _getBuffer(n) {
                var ret = $47e80b5d1f4ca857$var$Buffer.allocUnsafe(n);
                var p = this.head;
                var c = 1;
                p.data.copy(ret);
                n -= p.data.length;
                while(p = p.next){
                    var buf = p.data;
                    var nb = n > buf.length ? buf.length : n;
                    buf.copy(ret, ret.length - n, 0, nb);
                    n -= nb;
                    if (n === 0) {
                        if (nb === buf.length) {
                            ++c;
                            if (p.next) this.head = p.next;
                            else this.head = this.tail = null;
                        } else {
                            this.head = p;
                            p.data = buf.slice(nb);
                        }
                        break;
                    }
                    ++c;
                }
                this.length -= c;
                return ret;
            }
        },
        {
            key: $47e80b5d1f4ca857$var$custom,
            value: function value(_, options) {
                return $47e80b5d1f4ca857$var$inspect(this, $47e80b5d1f4ca857$var$_objectSpread($47e80b5d1f4ca857$var$_objectSpread({}, options), {}, {
                    // Only inspect one level.
                    depth: 0,
                    // It should not recurse.
                    customInspect: false
                }));
            }
        }
    ]);
    return BufferList;
}();

});

parcelRegister("fnDgj", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// undocumented cb() API, needed for core, not for public API
function $b32775a19d7a76d1$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $hPtJY.nextTick($b32775a19d7a76d1$var$emitErrorAndCloseNT, _this, err);
            } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
        } else if (cb) {
            $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
            cb(err);
        } else $hPtJY.nextTick($b32775a19d7a76d1$var$emitCloseNT, _this);
    });
    return this;
}
function $b32775a19d7a76d1$var$emitErrorAndCloseNT(self, err) {
    $b32775a19d7a76d1$var$emitErrorNT(self, err);
    $b32775a19d7a76d1$var$emitCloseNT(self);
}
function $b32775a19d7a76d1$var$emitCloseNT(self) {
    if (self._writableState && !self._writableState.emitClose) return;
    if (self._readableState && !self._readableState.emitClose) return;
    self.emit("close");
}
function $b32775a19d7a76d1$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b32775a19d7a76d1$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
function $b32775a19d7a76d1$var$errorOrDestroy(stream, err) {
    // We have tests that rely on errors being emitted
    // in the same tick, so changing this is semver major.
    // For now when you opt-in to autoDestroy we allow
    // the error to be emitted nextTick. In a future
    // semver major update we should change the default to this.
    var rState = stream._readableState;
    var wState = stream._writableState;
    if (rState && rState.autoDestroy || wState && wState.autoDestroy) stream.destroy(err);
    else stream.emit("error", err);
}
module.exports = {
    destroy: $b32775a19d7a76d1$var$destroy,
    undestroy: $b32775a19d7a76d1$var$undestroy,
    errorOrDestroy: $b32775a19d7a76d1$var$errorOrDestroy
};

});

parcelRegister("5yyyA", function(module, exports) {
"use strict";

var $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE = (parcelRequire("967Aq")).codes.ERR_INVALID_OPT_VALUE;
function $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey) {
    return options.highWaterMark != null ? options.highWaterMark : isDuplex ? options[duplexKey] : null;
}
function $40baeeffbb52bbd0$var$getHighWaterMark(state, options, duplexKey, isDuplex) {
    var hwm = $40baeeffbb52bbd0$var$highWaterMarkFrom(options, isDuplex, duplexKey);
    if (hwm != null) {
        if (!(isFinite(hwm) && Math.floor(hwm) === hwm) || hwm < 0) {
            var name = isDuplex ? duplexKey : "highWaterMark";
            throw new $40baeeffbb52bbd0$var$ERR_INVALID_OPT_VALUE(name, hwm);
        }
        return Math.floor(hwm);
    }
    // Default value
    return state.objectMode ? 16 : 16384;
}
module.exports = {
    getHighWaterMark: $40baeeffbb52bbd0$var$getHighWaterMark
};

});
parcelRegister("967Aq", function(module, exports) {

$parcel$export(module.exports, "codes", () => $69fa8f23fe6fc7e7$export$e45cb6485273080e, (v) => $69fa8f23fe6fc7e7$export$e45cb6485273080e = v);
var $69fa8f23fe6fc7e7$export$e45cb6485273080e;
"use strict";
function $69fa8f23fe6fc7e7$var$_inheritsLoose(subClass, superClass) {
    subClass.prototype = Object.create(superClass.prototype);
    subClass.prototype.constructor = subClass;
    subClass.__proto__ = superClass;
}
var $69fa8f23fe6fc7e7$var$codes = {};
function $69fa8f23fe6fc7e7$var$createErrorType(code, message, Base) {
    if (!Base) Base = Error;
    function getMessage(arg1, arg2, arg3) {
        if (typeof message === "string") return message;
        else return message(arg1, arg2, arg3);
    }
    var NodeError = /*#__PURE__*/ function(_Base) {
        $69fa8f23fe6fc7e7$var$_inheritsLoose(NodeError, _Base);
        function NodeError(arg1, arg2, arg3) {
            return _Base.call(this, getMessage(arg1, arg2, arg3)) || this;
        }
        return NodeError;
    }(Base);
    NodeError.prototype.name = Base.name;
    NodeError.prototype.code = code;
    $69fa8f23fe6fc7e7$var$codes[code] = NodeError;
} // https://github.com/nodejs/node/blob/v10.8.0/lib/internal/errors.js
function $69fa8f23fe6fc7e7$var$oneOf(expected, thing) {
    if (Array.isArray(expected)) {
        var len = expected.length;
        expected = expected.map(function(i) {
            return String(i);
        });
        if (len > 2) return "one of ".concat(thing, " ").concat(expected.slice(0, len - 1).join(", "), ", or ") + expected[len - 1];
        else if (len === 2) return "one of ".concat(thing, " ").concat(expected[0], " or ").concat(expected[1]);
        else return "of ".concat(thing, " ").concat(expected[0]);
    } else return "of ".concat(thing, " ").concat(String(expected));
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/startsWith
function $69fa8f23fe6fc7e7$var$startsWith(str, search, pos) {
    return str.substr(!pos || pos < 0 ? 0 : +pos, search.length) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/endsWith
function $69fa8f23fe6fc7e7$var$endsWith(str, search, this_len) {
    if (this_len === undefined || this_len > str.length) this_len = str.length;
    return str.substring(this_len - search.length, this_len) === search;
} // https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/includes
function $69fa8f23fe6fc7e7$var$includes(str, search, start) {
    if (typeof start !== "number") start = 0;
    if (start + search.length > str.length) return false;
    else return str.indexOf(search, start) !== -1;
}
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_OPT_VALUE", function(name, value) {
    return 'The value "' + value + '" is invalid for option "' + name + '"';
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_INVALID_ARG_TYPE", function(name, expected, actual) {
    // determiner: 'must be' or 'must not be'
    var determiner;
    if (typeof expected === "string" && $69fa8f23fe6fc7e7$var$startsWith(expected, "not ")) {
        determiner = "must not be";
        expected = expected.replace(/^not /, "");
    } else determiner = "must be";
    var msg;
    if ($69fa8f23fe6fc7e7$var$endsWith(name, " argument")) // For cases like 'first argument'
    msg = "The ".concat(name, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    else {
        var type = $69fa8f23fe6fc7e7$var$includes(name, ".") ? "property" : "argument";
        msg = 'The "'.concat(name, '" ').concat(type, " ").concat(determiner, " ").concat($69fa8f23fe6fc7e7$var$oneOf(expected, "type"));
    }
    msg += ". Received type ".concat(typeof actual);
    return msg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PUSH_AFTER_EOF", "stream.push() after EOF");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_METHOD_NOT_IMPLEMENTED", function(name) {
    return "The " + name + " method is not implemented";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_PREMATURE_CLOSE", "Premature close");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_DESTROYED", function(name) {
    return "Cannot call " + name + " after a stream was destroyed";
});
$69fa8f23fe6fc7e7$var$createErrorType("ERR_MULTIPLE_CALLBACK", "Callback called multiple times");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_CANNOT_PIPE", "Cannot pipe, not readable");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_WRITE_AFTER_END", "write after end");
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_NULL_VALUES", "May not write null values to stream", TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_UNKNOWN_ENCODING", function(arg) {
    return "Unknown encoding: " + arg;
}, TypeError);
$69fa8f23fe6fc7e7$var$createErrorType("ERR_STREAM_UNSHIFT_AFTER_END_EVENT", "stream.unshift() after end event");
$69fa8f23fe6fc7e7$export$e45cb6485273080e = $69fa8f23fe6fc7e7$var$codes;

});


parcelRegister("fFuzr", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
/*<replacement>*/ var $b682660ac74fe757$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $b682660ac74fe757$var$Duplex;

var $aBufs = parcelRequire("aBufs");

var $6XbcT = parcelRequire("6XbcT");

(parcelRequire("dlqwk"))($b682660ac74fe757$var$Duplex, $aBufs);
// Allow the keys array to be GC'ed.
var $b682660ac74fe757$var$keys = $b682660ac74fe757$var$objectKeys($6XbcT.prototype);
for(var $b682660ac74fe757$var$v = 0; $b682660ac74fe757$var$v < $b682660ac74fe757$var$keys.length; $b682660ac74fe757$var$v++){
    var $b682660ac74fe757$var$method = $b682660ac74fe757$var$keys[$b682660ac74fe757$var$v];
    if (!$b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method]) $b682660ac74fe757$var$Duplex.prototype[$b682660ac74fe757$var$method] = $6XbcT.prototype[$b682660ac74fe757$var$method];
}
function $b682660ac74fe757$var$Duplex(options) {
    if (!(this instanceof $b682660ac74fe757$var$Duplex)) return new $b682660ac74fe757$var$Duplex(options);
    $aBufs.call(this, options);
    $6XbcT.call(this, options);
    this.allowHalfOpen = true;
    if (options) {
        if (options.readable === false) this.readable = false;
        if (options.writable === false) this.writable = false;
        if (options.allowHalfOpen === false) {
            this.allowHalfOpen = false;
            this.once("end", $b682660ac74fe757$var$onend);
        }
    }
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
// the no-half-open enforcer
function $b682660ac74fe757$var$onend() {
    // If the writable side ended, then we're ok.
    if (this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $hPtJY.nextTick($b682660ac74fe757$var$onEndNT, this);
}
function $b682660ac74fe757$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($b682660ac74fe757$var$Duplex.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});

});
parcelRegister("6XbcT", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.

var $hPtJY = parcelRequire("hPtJY");
"use strict";
module.exports = $5100f23d2ab8fadd$var$Writable;
/* <replacement> */ function $5100f23d2ab8fadd$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $5100f23d2ab8fadd$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $5100f23d2ab8fadd$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $5100f23d2ab8fadd$var$Duplex;
/*</replacement>*/ $5100f23d2ab8fadd$var$Writable.WritableState = $5100f23d2ab8fadd$var$WritableState;

/*<replacement>*/ var $5100f23d2ab8fadd$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jJj7p = parcelRequire("jJj7p");

var $6ZWSX = parcelRequire("6ZWSX");
var $5100f23d2ab8fadd$require$Buffer = $6ZWSX.Buffer;
var $5100f23d2ab8fadd$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk) {
    return $5100f23d2ab8fadd$require$Buffer.from(chunk);
}
function $5100f23d2ab8fadd$var$_isUint8Array(obj) {
    return $5100f23d2ab8fadd$require$Buffer.isBuffer(obj) || obj instanceof $5100f23d2ab8fadd$var$OurUint8Array;
}

var $fnDgj = parcelRequire("fnDgj");

var $5yyyA = parcelRequire("5yyyA");
var $5100f23d2ab8fadd$var$getHighWaterMark = $5yyyA.getHighWaterMark;

var $967Aq = parcelRequire("967Aq");
var $5100f23d2ab8fadd$require$_require$codes = $967Aq.codes;
var $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE = $5100f23d2ab8fadd$require$_require$codes.ERR_INVALID_ARG_TYPE, $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED = $5100f23d2ab8fadd$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK = $5100f23d2ab8fadd$require$_require$codes.ERR_MULTIPLE_CALLBACK, $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_CANNOT_PIPE, $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_DESTROYED, $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_NULL_VALUES, $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END = $5100f23d2ab8fadd$require$_require$codes.ERR_STREAM_WRITE_AFTER_END, $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING = $5100f23d2ab8fadd$require$_require$codes.ERR_UNKNOWN_ENCODING;
var $5100f23d2ab8fadd$var$errorOrDestroy = $fnDgj.errorOrDestroy;

(parcelRequire("dlqwk"))($5100f23d2ab8fadd$var$Writable, $jJj7p);
function $5100f23d2ab8fadd$var$nop() {}

function $5100f23d2ab8fadd$var$WritableState(options, stream, isDuplex) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream,
    // e.g. options.readableObjectMode vs. options.writableObjectMode, etc.
    if (typeof isDuplex !== "boolean") isDuplex = stream instanceof $5100f23d2ab8fadd$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    this.highWaterMark = $5100f23d2ab8fadd$var$getHighWaterMark(this, options, "writableHighWaterMark", isDuplex);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $5100f23d2ab8fadd$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // Should close be emitted on destroy. Defaults to true.
    this.emitClose = options.emitClose !== false;
    // Should .destroy() be called after 'finish' (and potentially 'end')
    this.autoDestroy = !!options.autoDestroy;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(this);
}
$5100f23d2ab8fadd$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($5100f23d2ab8fadd$var$WritableState.prototype, "buffer", {
            get: $5100f23d2ab8fadd$var$internalUtil.deprecate(function writableStateBufferGetter() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $5100f23d2ab8fadd$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $5100f23d2ab8fadd$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($5100f23d2ab8fadd$var$Writable, Symbol.hasInstance, {
        value: function value(object) {
            if ($5100f23d2ab8fadd$var$realHasInstance.call(this, object)) return true;
            if (this !== $5100f23d2ab8fadd$var$Writable) return false;
            return object && object._writableState instanceof $5100f23d2ab8fadd$var$WritableState;
        }
    });
} else $5100f23d2ab8fadd$var$realHasInstance = function realHasInstance(object) {
    return object instanceof this;
};

function $5100f23d2ab8fadd$var$Writable(options) {
    $5100f23d2ab8fadd$var$Duplex = $5100f23d2ab8fadd$var$Duplex || (parcelRequire("fFuzr"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    // Checking for a Stream.Duplex instance is faster here instead of inside
    // the WritableState constructor, at least with V8 6.5
    var isDuplex = this instanceof $5100f23d2ab8fadd$var$Duplex;
    if (!isDuplex && !$5100f23d2ab8fadd$var$realHasInstance.call($5100f23d2ab8fadd$var$Writable, this)) return new $5100f23d2ab8fadd$var$Writable(options);
    this._writableState = new $5100f23d2ab8fadd$var$WritableState(options, this, isDuplex);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jJj7p.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$5100f23d2ab8fadd$var$Writable.prototype.pipe = function() {
    $5100f23d2ab8fadd$var$errorOrDestroy(this, new $5100f23d2ab8fadd$var$ERR_STREAM_CANNOT_PIPE());
};
function $5100f23d2ab8fadd$var$writeAfterEnd(stream, cb) {
    var er = new $5100f23d2ab8fadd$var$ERR_STREAM_WRITE_AFTER_END();
    // TODO: defer error events consistently everywhere, not just the cb
    $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    $hPtJY.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $5100f23d2ab8fadd$var$validChunk(stream, state, chunk, cb) {
    var er;
    if (chunk === null) er = new $5100f23d2ab8fadd$var$ERR_STREAM_NULL_VALUES();
    else if (typeof chunk !== "string" && !state.objectMode) er = new $5100f23d2ab8fadd$var$ERR_INVALID_ARG_TYPE("chunk", [
        "string",
        "Buffer"
    ], chunk);
    if (er) {
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        $hPtJY.nextTick(cb, er);
        return false;
    }
    return true;
}
$5100f23d2ab8fadd$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $5100f23d2ab8fadd$var$_isUint8Array(chunk);
    if (isBuf && !$5100f23d2ab8fadd$require$Buffer.isBuffer(chunk)) chunk = $5100f23d2ab8fadd$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $5100f23d2ab8fadd$var$nop;
    if (state.ending) $5100f23d2ab8fadd$var$writeAfterEnd(this, cb);
    else if (isBuf || $5100f23d2ab8fadd$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $5100f23d2ab8fadd$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$5100f23d2ab8fadd$var$Writable.prototype.cork = function() {
    this._writableState.corked++;
};
$5100f23d2ab8fadd$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(this, state);
    }
};
$5100f23d2ab8fadd$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new $5100f23d2ab8fadd$var$ERR_UNKNOWN_ENCODING(encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableBuffer", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState && this._writableState.getBuffer();
    }
});
function $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $5100f23d2ab8fadd$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $5100f23d2ab8fadd$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $5100f23d2ab8fadd$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $5100f23d2ab8fadd$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (state.destroyed) state.onwrite(new $5100f23d2ab8fadd$var$ERR_STREAM_DESTROYED("write"));
    else if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $hPtJY.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $hPtJY.nextTick($5100f23d2ab8fadd$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        $5100f23d2ab8fadd$var$errorOrDestroy(stream, er);
        // this can emit finish, but finish must
        // always follow error
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    }
}
function $5100f23d2ab8fadd$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $5100f23d2ab8fadd$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    if (typeof cb !== "function") throw new $5100f23d2ab8fadd$var$ERR_MULTIPLE_CALLBACK();
    $5100f23d2ab8fadd$var$onwriteStateUpdate(state);
    if (er) $5100f23d2ab8fadd$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $5100f23d2ab8fadd$var$needFinish(state) || stream.destroyed;
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $5100f23d2ab8fadd$var$clearBuffer(stream, state);
        if (sync) $hPtJY.nextTick($5100f23d2ab8fadd$var$afterWrite, stream, state, finished, cb);
        else $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb);
    }
}
function $5100f23d2ab8fadd$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $5100f23d2ab8fadd$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $5100f23d2ab8fadd$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $5100f23d2ab8fadd$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $5100f23d2ab8fadd$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $5100f23d2ab8fadd$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $5100f23d2ab8fadd$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$5100f23d2ab8fadd$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new $5100f23d2ab8fadd$var$ERR_METHOD_NOT_IMPLEMENTED("_write()"));
};
$5100f23d2ab8fadd$var$Writable.prototype._writev = null;
$5100f23d2ab8fadd$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $5100f23d2ab8fadd$var$endWritable(this, state, cb);
    return this;
};
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "writableLength", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        return this._writableState.length;
    }
});
function $5100f23d2ab8fadd$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $5100f23d2ab8fadd$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) $5100f23d2ab8fadd$var$errorOrDestroy(stream, err);
        state.prefinished = true;
        stream.emit("prefinish");
        $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    });
}
function $5100f23d2ab8fadd$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function" && !state.destroyed) {
            state.pendingcb++;
            state.finalCalled = true;
            $hPtJY.nextTick($5100f23d2ab8fadd$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $5100f23d2ab8fadd$var$finishMaybe(stream, state) {
    var need = $5100f23d2ab8fadd$var$needFinish(state);
    if (need) {
        $5100f23d2ab8fadd$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
            if (state.autoDestroy) {
                // In case of duplex streams we need a way to detect
                // if the readable side is ready for autoDestroy as well
                var rState = stream._readableState;
                if (!rState || rState.autoDestroy && rState.endEmitted) stream.destroy();
            }
        }
    }
    return need;
}
function $5100f23d2ab8fadd$var$endWritable(stream, state, cb) {
    state.ending = true;
    $5100f23d2ab8fadd$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $hPtJY.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $5100f23d2ab8fadd$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($5100f23d2ab8fadd$var$Writable.prototype, "destroyed", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function get() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function set(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$5100f23d2ab8fadd$var$Writable.prototype.destroy = $fnDgj.destroy;
$5100f23d2ab8fadd$var$Writable.prototype._undestroy = $fnDgj.undestroy;
$5100f23d2ab8fadd$var$Writable.prototype._destroy = function(err, cb) {
    cb(err);
};

});
parcelRegister("39vsn", function(module, exports) {
/**
 * Module exports.
 */ module.exports = $24ba9cfc39d77116$var$deprecate;
/**
 * Mark that a method should not be used.
 * Returns a modified function which warns once by default.
 *
 * If `localStorage.noDeprecation = true` is set, then it is a no-op.
 *
 * If `localStorage.throwDeprecation = true` is set, then deprecated functions
 * will throw an Error when invoked.
 *
 * If `localStorage.traceDeprecation = true` is set, then deprecated functions
 * will invoke `console.trace()` instead of `console.error()`.
 *
 * @param {Function} fn - the function to deprecate
 * @param {String} msg - the string to print to the console when `fn` is invoked
 * @returns {Function} a new "deprecated" version of `fn`
 * @api public
 */ function $24ba9cfc39d77116$var$deprecate(fn, msg) {
    if ($24ba9cfc39d77116$var$config("noDeprecation")) return fn;
    var warned = false;
    function deprecated() {
        if (!warned) {
            if ($24ba9cfc39d77116$var$config("throwDeprecation")) throw new Error(msg);
            else if ($24ba9cfc39d77116$var$config("traceDeprecation")) console.trace(msg);
            else console.warn(msg);
            warned = true;
        }
        return fn.apply(this, arguments);
    }
    return deprecated;
}
/**
 * Checks `localStorage` for boolean values for the given `name`.
 *
 * @param {String} name
 * @returns {Boolean}
 * @api private
 */ function $24ba9cfc39d77116$var$config(name) {
    // accessing global.localStorage can trigger a DOMException in sandboxed iframes
    try {
        if (!$parcel$global.localStorage) return false;
    } catch (_) {
        return false;
    }
    var val = $parcel$global.localStorage[name];
    if (null == val) return false;
    return String(val).toLowerCase() === "true";
}

});



parcelRegister("eNRCS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $ac6f3d51130904be$export$63a7aa211a91ed69, (v) => $ac6f3d51130904be$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $ac6f3d51130904be$export$63a7aa211a91ed69;
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $ac6f3d51130904be$require$Buffer = $1U9GM.Buffer;
/*</replacement>*/ var $ac6f3d51130904be$var$isEncoding = $ac6f3d51130904be$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $ac6f3d51130904be$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $ac6f3d51130904be$var$normalizeEncoding(enc) {
    var nenc = $ac6f3d51130904be$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($ac6f3d51130904be$require$Buffer.isEncoding === $ac6f3d51130904be$var$isEncoding || !$ac6f3d51130904be$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$ac6f3d51130904be$export$63a7aa211a91ed69 = $ac6f3d51130904be$var$StringDecoder;
function $ac6f3d51130904be$var$StringDecoder(encoding) {
    this.encoding = $ac6f3d51130904be$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $ac6f3d51130904be$var$utf16Text;
            this.end = $ac6f3d51130904be$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $ac6f3d51130904be$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $ac6f3d51130904be$var$base64Text;
            this.end = $ac6f3d51130904be$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $ac6f3d51130904be$var$simpleWrite;
            this.end = $ac6f3d51130904be$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $ac6f3d51130904be$require$Buffer.allocUnsafe(nb);
}
$ac6f3d51130904be$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$ac6f3d51130904be$var$StringDecoder.prototype.end = $ac6f3d51130904be$var$utf8End;
// Returns only complete characters in a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.text = $ac6f3d51130904be$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$ac6f3d51130904be$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $ac6f3d51130904be$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $ac6f3d51130904be$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $ac6f3d51130904be$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $ac6f3d51130904be$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $ac6f3d51130904be$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $ac6f3d51130904be$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $ac6f3d51130904be$var$utf8Text(buf, i) {
    var total = $ac6f3d51130904be$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $ac6f3d51130904be$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $ac6f3d51130904be$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $ac6f3d51130904be$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $ac6f3d51130904be$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $ac6f3d51130904be$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $ac6f3d51130904be$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $ac6f3d51130904be$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});

parcelRegister("3etzH", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
var $25a99ede456543b7$var$_Object$setPrototypeO;
function $25a99ede456543b7$var$_defineProperty(obj, key, value) {
    key = $25a99ede456543b7$var$_toPropertyKey(key);
    if (key in obj) Object.defineProperty(obj, key, {
        value: value,
        enumerable: true,
        configurable: true,
        writable: true
    });
    else obj[key] = value;
    return obj;
}
function $25a99ede456543b7$var$_toPropertyKey(arg) {
    var key = $25a99ede456543b7$var$_toPrimitive(arg, "string");
    return typeof key === "symbol" ? key : String(key);
}
function $25a99ede456543b7$var$_toPrimitive(input, hint) {
    if (typeof input !== "object" || input === null) return input;
    var prim = input[Symbol.toPrimitive];
    if (prim !== undefined) {
        var res = prim.call(input, hint || "default");
        if (typeof res !== "object") return res;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return (hint === "string" ? String : Number)(input);
}

var $hzqCm = parcelRequire("hzqCm");
var $25a99ede456543b7$var$kLastResolve = Symbol("lastResolve");
var $25a99ede456543b7$var$kLastReject = Symbol("lastReject");
var $25a99ede456543b7$var$kError = Symbol("error");
var $25a99ede456543b7$var$kEnded = Symbol("ended");
var $25a99ede456543b7$var$kLastPromise = Symbol("lastPromise");
var $25a99ede456543b7$var$kHandlePromise = Symbol("handlePromise");
var $25a99ede456543b7$var$kStream = Symbol("stream");
function $25a99ede456543b7$var$createIterResult(value, done) {
    return {
        value: value,
        done: done
    };
}
function $25a99ede456543b7$var$readAndResolve(iter) {
    var resolve = iter[$25a99ede456543b7$var$kLastResolve];
    if (resolve !== null) {
        var data = iter[$25a99ede456543b7$var$kStream].read();
        // we defer if data is null
        // we can be expecting either 'end' or
        // 'error'
        if (data !== null) {
            iter[$25a99ede456543b7$var$kLastPromise] = null;
            iter[$25a99ede456543b7$var$kLastResolve] = null;
            iter[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(data, false));
        }
    }
}
function $25a99ede456543b7$var$onReadable(iter) {
    // we wait for the next tick, because it might
    // emit an error with process.nextTick
    $hPtJY.nextTick($25a99ede456543b7$var$readAndResolve, iter);
}
function $25a99ede456543b7$var$wrapForNext(lastPromise, iter) {
    return function(resolve, reject) {
        lastPromise.then(function() {
            if (iter[$25a99ede456543b7$var$kEnded]) {
                resolve($25a99ede456543b7$var$createIterResult(undefined, true));
                return;
            }
            iter[$25a99ede456543b7$var$kHandlePromise](resolve, reject);
        }, reject);
    };
}
var $25a99ede456543b7$var$AsyncIteratorPrototype = Object.getPrototypeOf(function() {});
var $25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype = Object.setPrototypeOf(($25a99ede456543b7$var$_Object$setPrototypeO = {
    get stream () {
        return this[$25a99ede456543b7$var$kStream];
    },
    next: function next() {
        var _this = this;
        // if we have detected an error in the meanwhile
        // reject straight away
        var error = this[$25a99ede456543b7$var$kError];
        if (error !== null) return Promise.reject(error);
        if (this[$25a99ede456543b7$var$kEnded]) return Promise.resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        if (this[$25a99ede456543b7$var$kStream].destroyed) // We need to defer via nextTick because if .destroy(err) is
        // called, the error will be emitted via nextTick, and
        // we cannot guarantee that there is no error lingering around
        // waiting to be emitted.
        return new Promise(function(resolve, reject) {
            $hPtJY.nextTick(function() {
                if (_this[$25a99ede456543b7$var$kError]) reject(_this[$25a99ede456543b7$var$kError]);
                else resolve($25a99ede456543b7$var$createIterResult(undefined, true));
            });
        });
        // if we have multiple next() calls
        // we will wait for the previous Promise to finish
        // this logic is optimized to support for await loops,
        // where next() is only called once at a time
        var lastPromise = this[$25a99ede456543b7$var$kLastPromise];
        var promise;
        if (lastPromise) promise = new Promise($25a99ede456543b7$var$wrapForNext(lastPromise, this));
        else {
            // fast path needed to support multiple this.push()
            // without triggering the next() queue
            var data = this[$25a99ede456543b7$var$kStream].read();
            if (data !== null) return Promise.resolve($25a99ede456543b7$var$createIterResult(data, false));
            promise = new Promise(this[$25a99ede456543b7$var$kHandlePromise]);
        }
        this[$25a99ede456543b7$var$kLastPromise] = promise;
        return promise;
    }
}, $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, Symbol.asyncIterator, function() {
    return this;
}), $25a99ede456543b7$var$_defineProperty($25a99ede456543b7$var$_Object$setPrototypeO, "return", function _return() {
    var _this2 = this;
    // destroy(err, cb) is a private API
    // we can guarantee we have that here, because we control the
    // Readable class this is attached to
    return new Promise(function(resolve, reject) {
        _this2[$25a99ede456543b7$var$kStream].destroy(null, function(err) {
            if (err) {
                reject(err);
                return;
            }
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        });
    });
}), $25a99ede456543b7$var$_Object$setPrototypeO), $25a99ede456543b7$var$AsyncIteratorPrototype);
var $25a99ede456543b7$var$createReadableStreamAsyncIterator = function createReadableStreamAsyncIterator(stream) {
    var _Object$create;
    var iterator = Object.create($25a99ede456543b7$var$ReadableStreamAsyncIteratorPrototype, (_Object$create = {}, $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kStream, {
        value: stream,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastResolve, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kLastReject, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kError, {
        value: null,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kEnded, {
        value: stream._readableState.endEmitted,
        writable: true
    }), $25a99ede456543b7$var$_defineProperty(_Object$create, $25a99ede456543b7$var$kHandlePromise, {
        value: function value(resolve, reject) {
            var data = iterator[$25a99ede456543b7$var$kStream].read();
            if (data) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                resolve($25a99ede456543b7$var$createIterResult(data, false));
            } else {
                iterator[$25a99ede456543b7$var$kLastResolve] = resolve;
                iterator[$25a99ede456543b7$var$kLastReject] = reject;
            }
        },
        writable: true
    }), _Object$create));
    iterator[$25a99ede456543b7$var$kLastPromise] = null;
    $hzqCm(stream, function(err) {
        if (err && err.code !== "ERR_STREAM_PREMATURE_CLOSE") {
            var reject = iterator[$25a99ede456543b7$var$kLastReject];
            // reject if we are waiting for data in the Promise
            // returned by next() and store the error
            if (reject !== null) {
                iterator[$25a99ede456543b7$var$kLastPromise] = null;
                iterator[$25a99ede456543b7$var$kLastResolve] = null;
                iterator[$25a99ede456543b7$var$kLastReject] = null;
                reject(err);
            }
            iterator[$25a99ede456543b7$var$kError] = err;
            return;
        }
        var resolve = iterator[$25a99ede456543b7$var$kLastResolve];
        if (resolve !== null) {
            iterator[$25a99ede456543b7$var$kLastPromise] = null;
            iterator[$25a99ede456543b7$var$kLastResolve] = null;
            iterator[$25a99ede456543b7$var$kLastReject] = null;
            resolve($25a99ede456543b7$var$createIterResult(undefined, true));
        }
        iterator[$25a99ede456543b7$var$kEnded] = true;
    });
    stream.on("readable", $25a99ede456543b7$var$onReadable.bind(null, iterator));
    return iterator;
};
module.exports = $25a99ede456543b7$var$createReadableStreamAsyncIterator;

});
parcelRegister("hzqCm", function(module, exports) {
// Ported from https://github.com/mafintosh/end-of-stream with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";

var $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE = (parcelRequire("967Aq")).codes.ERR_STREAM_PREMATURE_CLOSE;
function $ccaa5a4968d6bb28$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        for(var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++)args[_key] = arguments[_key];
        callback.apply(this, args);
    };
}
function $ccaa5a4968d6bb28$var$noop() {}
function $ccaa5a4968d6bb28$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}
function $ccaa5a4968d6bb28$var$eos(stream, opts, callback) {
    if (typeof opts === "function") return $ccaa5a4968d6bb28$var$eos(stream, null, opts);
    if (!opts) opts = {};
    callback = $ccaa5a4968d6bb28$var$once(callback || $ccaa5a4968d6bb28$var$noop);
    var readable = opts.readable || opts.readable !== false && stream.readable;
    var writable = opts.writable || opts.writable !== false && stream.writable;
    var onlegacyfinish = function onlegacyfinish() {
        if (!stream.writable) onfinish();
    };
    var writableEnded = stream._writableState && stream._writableState.finished;
    var onfinish = function onfinish() {
        writable = false;
        writableEnded = true;
        if (!readable) callback.call(stream);
    };
    var readableEnded = stream._readableState && stream._readableState.endEmitted;
    var onend = function onend() {
        readable = false;
        readableEnded = true;
        if (!writable) callback.call(stream);
    };
    var onerror = function onerror(err) {
        callback.call(stream, err);
    };
    var onclose = function onclose() {
        var err;
        if (readable && !readableEnded) {
            if (!stream._readableState || !stream._readableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
        if (writable && !writableEnded) {
            if (!stream._writableState || !stream._writableState.ended) err = new $ccaa5a4968d6bb28$var$ERR_STREAM_PREMATURE_CLOSE();
            return callback.call(stream, err);
        }
    };
    var onrequest = function onrequest() {
        stream.req.on("finish", onfinish);
    };
    if ($ccaa5a4968d6bb28$var$isRequest(stream)) {
        stream.on("complete", onfinish);
        stream.on("abort", onclose);
        if (stream.req) onrequest();
        else stream.on("request", onrequest);
    } else if (writable && !stream._writableState) {
        // legacy streams
        stream.on("end", onlegacyfinish);
        stream.on("close", onlegacyfinish);
    }
    stream.on("end", onend);
    stream.on("finish", onfinish);
    if (opts.error !== false) stream.on("error", onerror);
    stream.on("close", onclose);
    return function() {
        stream.removeListener("complete", onfinish);
        stream.removeListener("abort", onclose);
        stream.removeListener("request", onrequest);
        if (stream.req) stream.req.removeListener("finish", onfinish);
        stream.removeListener("end", onlegacyfinish);
        stream.removeListener("close", onlegacyfinish);
        stream.removeListener("finish", onfinish);
        stream.removeListener("end", onend);
        stream.removeListener("error", onerror);
        stream.removeListener("close", onclose);
    };
}
module.exports = $ccaa5a4968d6bb28$var$eos;

});


parcelRegister("gN4Jr", function(module, exports) {
module.exports = function() {
    throw new Error("Readable.from is not available in the browser");
};

});


parcelRegister("k3Gr9", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $e9a50192eb9e2af9$var$Transform;

var $967Aq = parcelRequire("967Aq");
var $e9a50192eb9e2af9$require$_require$codes = $967Aq.codes;
var $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED = $e9a50192eb9e2af9$require$_require$codes.ERR_METHOD_NOT_IMPLEMENTED, $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK = $e9a50192eb9e2af9$require$_require$codes.ERR_MULTIPLE_CALLBACK, $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_ALREADY_TRANSFORMING, $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0 = $e9a50192eb9e2af9$require$_require$codes.ERR_TRANSFORM_WITH_LENGTH_0;

var $fFuzr = parcelRequire("fFuzr");

(parcelRequire("dlqwk"))($e9a50192eb9e2af9$var$Transform, $fFuzr);
function $e9a50192eb9e2af9$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (cb === null) return this.emit("error", new $e9a50192eb9e2af9$var$ERR_MULTIPLE_CALLBACK());
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) // single equals check for both `null` and `undefined`
    this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $e9a50192eb9e2af9$var$Transform(options) {
    if (!(this instanceof $e9a50192eb9e2af9$var$Transform)) return new $e9a50192eb9e2af9$var$Transform(options);
    $fFuzr.call(this, options);
    this._transformState = {
        afterTransform: $e9a50192eb9e2af9$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $e9a50192eb9e2af9$var$prefinish);
}
function $e9a50192eb9e2af9$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function" && !this._readableState.destroyed) this._flush(function(er, data) {
        $e9a50192eb9e2af9$var$done(_this, er, data);
    });
    else $e9a50192eb9e2af9$var$done(this, null, null);
}
$e9a50192eb9e2af9$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $fFuzr.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$e9a50192eb9e2af9$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    cb(new $e9a50192eb9e2af9$var$ERR_METHOD_NOT_IMPLEMENTED("_transform()"));
};
$e9a50192eb9e2af9$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$e9a50192eb9e2af9$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$e9a50192eb9e2af9$var$Transform.prototype._destroy = function(err, cb) {
    $fFuzr.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
    });
};
function $e9a50192eb9e2af9$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) // single equals check for both `null` and `undefined`
    stream.push(data);
    // TODO(BridgeAR): Write a test for these two error cases
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_WITH_LENGTH_0();
    if (stream._transformState.transforming) throw new $e9a50192eb9e2af9$var$ERR_TRANSFORM_ALREADY_TRANSFORMING();
    return stream.push(null);
}

});

parcelRegister("6G2fH", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $4dc8698e5416b71e$var$PassThrough;

var $k3Gr9 = parcelRequire("k3Gr9");

(parcelRequire("dlqwk"))($4dc8698e5416b71e$var$PassThrough, $k3Gr9);
function $4dc8698e5416b71e$var$PassThrough(options) {
    if (!(this instanceof $4dc8698e5416b71e$var$PassThrough)) return new $4dc8698e5416b71e$var$PassThrough(options);
    $k3Gr9.call(this, options);
}
$4dc8698e5416b71e$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});

parcelRegister("coyuH", function(module, exports) {
// Ported from https://github.com/mafintosh/pump with
// permission from the author, Mathias Buus (@mafintosh).
"use strict";
var $90627bba44315748$var$eos;
function $90627bba44315748$var$once(callback) {
    var called = false;
    return function() {
        if (called) return;
        called = true;
        callback.apply(void 0, arguments);
    };
}

var $967Aq = parcelRequire("967Aq");
var $90627bba44315748$require$_require$codes = $967Aq.codes;
var $90627bba44315748$var$ERR_MISSING_ARGS = $90627bba44315748$require$_require$codes.ERR_MISSING_ARGS, $90627bba44315748$var$ERR_STREAM_DESTROYED = $90627bba44315748$require$_require$codes.ERR_STREAM_DESTROYED;
function $90627bba44315748$var$noop(err) {
    // Rethrow the error if it exists to avoid swallowing it
    if (err) throw err;
}
function $90627bba44315748$var$isRequest(stream) {
    return stream.setHeader && typeof stream.abort === "function";
}

function $90627bba44315748$var$destroyer(stream, reading, writing, callback) {
    callback = $90627bba44315748$var$once(callback);
    var closed = false;
    stream.on("close", function() {
        closed = true;
    });
    if ($90627bba44315748$var$eos === undefined) $90627bba44315748$var$eos = (parcelRequire("hzqCm"));
    $90627bba44315748$var$eos(stream, {
        readable: reading,
        writable: writing
    }, function(err) {
        if (err) return callback(err);
        closed = true;
        callback();
    });
    var destroyed = false;
    return function(err) {
        if (closed) return;
        if (destroyed) return;
        destroyed = true;
        // request.destroy just do .end - .abort is what we want
        if ($90627bba44315748$var$isRequest(stream)) return stream.abort();
        if (typeof stream.destroy === "function") return stream.destroy();
        callback(err || new $90627bba44315748$var$ERR_STREAM_DESTROYED("pipe"));
    };
}
function $90627bba44315748$var$call(fn) {
    fn();
}
function $90627bba44315748$var$pipe(from, to) {
    return from.pipe(to);
}
function $90627bba44315748$var$popCallback(streams) {
    if (!streams.length) return $90627bba44315748$var$noop;
    if (typeof streams[streams.length - 1] !== "function") return $90627bba44315748$var$noop;
    return streams.pop();
}
function $90627bba44315748$var$pipeline() {
    for(var _len = arguments.length, streams = new Array(_len), _key = 0; _key < _len; _key++)streams[_key] = arguments[_key];
    var callback = $90627bba44315748$var$popCallback(streams);
    if (Array.isArray(streams[0])) streams = streams[0];
    if (streams.length < 2) throw new $90627bba44315748$var$ERR_MISSING_ARGS("streams");
    var error;
    var destroys = streams.map(function(stream, i) {
        var reading = i < streams.length - 1;
        var writing = i > 0;
        return $90627bba44315748$var$destroyer(stream, reading, writing, function(err) {
            if (!error) error = err;
            if (err) destroys.forEach($90627bba44315748$var$call);
            if (reading) return;
            destroys.forEach($90627bba44315748$var$call);
            callback(error);
        });
    });
    return streams.reduce($90627bba44315748$var$pipe);
}
module.exports = $90627bba44315748$var$pipeline;

});




parcelRegister("a8qBR", function(module, exports) {
"use strict";

var $6ZWSX = parcelRequire("6ZWSX");
var $760f4ae3157f7f0b$require$Buffer = $6ZWSX.Buffer;

var $dlqwk = parcelRequire("dlqwk");

var $eLdEM = parcelRequire("eLdEM");
var $760f4ae3157f7f0b$var$ARRAY16 = new Array(16);
var $760f4ae3157f7f0b$var$zl = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $760f4ae3157f7f0b$var$zr = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $760f4ae3157f7f0b$var$sl = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $760f4ae3157f7f0b$var$sr = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];
var $760f4ae3157f7f0b$var$hl = [
    0x00000000,
    0x5a827999,
    0x6ed9eba1,
    0x8f1bbcdc,
    0xa953fd4e
];
var $760f4ae3157f7f0b$var$hr = [
    0x50a28be6,
    0x5c4dd124,
    0x6d703ef3,
    0x7a6d76e9,
    0x00000000
];
function $760f4ae3157f7f0b$var$RIPEMD160() {
    $eLdEM.call(this, 64);
    // state
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
}
$dlqwk($760f4ae3157f7f0b$var$RIPEMD160, $eLdEM);
$760f4ae3157f7f0b$var$RIPEMD160.prototype._update = function() {
    var words = $760f4ae3157f7f0b$var$ARRAY16;
    for(var j = 0; j < 16; ++j)words[j] = this._block.readInt32LE(j * 4);
    var al = this._a | 0;
    var bl = this._b | 0;
    var cl = this._c | 0;
    var dl = this._d | 0;
    var el = this._e | 0;
    var ar = this._a | 0;
    var br = this._b | 0;
    var cr = this._c | 0;
    var dr = this._d | 0;
    var er = this._e | 0;
    // computation
    for(var i = 0; i < 80; i += 1){
        var tl;
        var tr;
        if (i < 16) {
            tl = $760f4ae3157f7f0b$var$fn1(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[0], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn5(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[0], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 32) {
            tl = $760f4ae3157f7f0b$var$fn2(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[1], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn4(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[1], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 48) {
            tl = $760f4ae3157f7f0b$var$fn3(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[2], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn3(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[2], $760f4ae3157f7f0b$var$sr[i]);
        } else if (i < 64) {
            tl = $760f4ae3157f7f0b$var$fn4(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[3], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn2(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[3], $760f4ae3157f7f0b$var$sr[i]);
        } else {
            tl = $760f4ae3157f7f0b$var$fn5(al, bl, cl, dl, el, words[$760f4ae3157f7f0b$var$zl[i]], $760f4ae3157f7f0b$var$hl[4], $760f4ae3157f7f0b$var$sl[i]);
            tr = $760f4ae3157f7f0b$var$fn1(ar, br, cr, dr, er, words[$760f4ae3157f7f0b$var$zr[i]], $760f4ae3157f7f0b$var$hr[4], $760f4ae3157f7f0b$var$sr[i]);
        }
        al = el;
        el = dl;
        dl = $760f4ae3157f7f0b$var$rotl(cl, 10);
        cl = bl;
        bl = tl;
        ar = er;
        er = dr;
        dr = $760f4ae3157f7f0b$var$rotl(cr, 10);
        cr = br;
        br = tr;
    }
    // update state
    var t = this._b + cl + dr | 0;
    this._b = this._c + dl + er | 0;
    this._c = this._d + el + ar | 0;
    this._d = this._e + al + br | 0;
    this._e = this._a + bl + cr | 0;
    this._a = t;
};
$760f4ae3157f7f0b$var$RIPEMD160.prototype._digest = function() {
    // create padding and handle blocks
    this._block[this._blockOffset++] = 0x80;
    if (this._blockOffset > 56) {
        this._block.fill(0, this._blockOffset, 64);
        this._update();
        this._blockOffset = 0;
    }
    this._block.fill(0, this._blockOffset, 56);
    this._block.writeUInt32LE(this._length[0], 56);
    this._block.writeUInt32LE(this._length[1], 60);
    this._update();
    // produce result
    var buffer = $760f4ae3157f7f0b$require$Buffer.alloc ? $760f4ae3157f7f0b$require$Buffer.alloc(20) : new $760f4ae3157f7f0b$require$Buffer(20);
    buffer.writeInt32LE(this._a, 0);
    buffer.writeInt32LE(this._b, 4);
    buffer.writeInt32LE(this._c, 8);
    buffer.writeInt32LE(this._d, 12);
    buffer.writeInt32LE(this._e, 16);
    return buffer;
};
function $760f4ae3157f7f0b$var$rotl(x, n) {
    return x << n | x >>> 32 - n;
}
function $760f4ae3157f7f0b$var$fn1(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ c ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn2(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & c | ~b & d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn3(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + ((b | ~c) ^ d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn4(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b & d | c & ~d) + m + k | 0, s) + e | 0;
}
function $760f4ae3157f7f0b$var$fn5(a, b, c, d, e, m, k, s) {
    return $760f4ae3157f7f0b$var$rotl(a + (b ^ (c | ~d)) + m + k | 0, s) + e | 0;
}
module.exports = $760f4ae3157f7f0b$var$RIPEMD160;

});

parcelRegister("5Z1sR", function(module, exports) {
var $45b3c90d57600982$var$exports = module.exports = function SHA(algorithm) {
    algorithm = algorithm.toLowerCase();
    var Algorithm = $45b3c90d57600982$var$exports[algorithm];
    if (!Algorithm) throw new Error(algorithm + " is not supported (we accept pull requests)");
    return new Algorithm();
};

$45b3c90d57600982$var$exports.sha = (parcelRequire("dECyV"));

$45b3c90d57600982$var$exports.sha1 = (parcelRequire("dVcFO"));

$45b3c90d57600982$var$exports.sha224 = (parcelRequire("3wNjm"));

$45b3c90d57600982$var$exports.sha256 = (parcelRequire("3BFQx"));

$45b3c90d57600982$var$exports.sha384 = (parcelRequire("5qHaZ"));

$45b3c90d57600982$var$exports.sha512 = (parcelRequire("bZI17"));

});
parcelRegister("dECyV", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-0, as defined
 * in FIPS PUB 180-1
 * This source code is derived from sha1.js of the same repository.
 * The difference between SHA-0 and SHA-1 is just a bitwise rotate left
 * operation was added.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $9f0cec708e1f2103$require$Buffer = $1U9GM.Buffer;
var $9f0cec708e1f2103$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $9f0cec708e1f2103$var$W = new Array(80);
function $9f0cec708e1f2103$var$Sha() {
    this.init();
    this._w = $9f0cec708e1f2103$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($9f0cec708e1f2103$var$Sha, $O5ywn);
$9f0cec708e1f2103$var$Sha.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $9f0cec708e1f2103$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $9f0cec708e1f2103$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $9f0cec708e1f2103$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$9f0cec708e1f2103$var$Sha.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16];
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $9f0cec708e1f2103$var$rotl5(a) + $9f0cec708e1f2103$var$ft(s, b, c, d) + e + W[j] + $9f0cec708e1f2103$var$K[s] | 0;
        e = d;
        d = c;
        c = $9f0cec708e1f2103$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$9f0cec708e1f2103$var$Sha.prototype._hash = function() {
    var H = $9f0cec708e1f2103$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $9f0cec708e1f2103$var$Sha;

});
parcelRegister("O5ywn", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $0968fae43eb53960$require$Buffer = $1U9GM.Buffer;
// prototype class for hash functions
function $0968fae43eb53960$var$Hash(blockSize, finalSize) {
    this._block = $0968fae43eb53960$require$Buffer.alloc(blockSize);
    this._finalSize = finalSize;
    this._blockSize = blockSize;
    this._len = 0;
}
$0968fae43eb53960$var$Hash.prototype.update = function(data, enc) {
    if (typeof data === "string") {
        enc = enc || "utf8";
        data = $0968fae43eb53960$require$Buffer.from(data, enc);
    }
    var block = this._block;
    var blockSize = this._blockSize;
    var length = data.length;
    var accum = this._len;
    for(var offset = 0; offset < length;){
        var assigned = accum % blockSize;
        var remainder = Math.min(length - offset, blockSize - assigned);
        for(var i = 0; i < remainder; i++)block[assigned + i] = data[offset + i];
        accum += remainder;
        offset += remainder;
        if (accum % blockSize === 0) this._update(block);
    }
    this._len += length;
    return this;
};
$0968fae43eb53960$var$Hash.prototype.digest = function(enc) {
    var rem = this._len % this._blockSize;
    this._block[rem] = 0x80;
    // zero (rem + 1) trailing bits, where (rem + 1) is the smallest
    // non-negative solution to the equation (length + 1 + (rem + 1)) === finalSize mod blockSize
    this._block.fill(0, rem + 1);
    if (rem >= this._finalSize) {
        this._update(this._block);
        this._block.fill(0);
    }
    var bits = this._len * 8;
    // uint32
    if (bits <= 0xffffffff) this._block.writeUInt32BE(bits, this._blockSize - 4);
    else {
        var lowBits = (bits & 0xffffffff) >>> 0;
        var highBits = (bits - lowBits) / 0x100000000;
        this._block.writeUInt32BE(highBits, this._blockSize - 8);
        this._block.writeUInt32BE(lowBits, this._blockSize - 4);
    }
    this._update(this._block);
    var hash = this._hash();
    return enc ? hash.toString(enc) : hash;
};
$0968fae43eb53960$var$Hash.prototype._update = function() {
    throw new Error("_update must be implemented by subclass");
};
module.exports = $0968fae43eb53960$var$Hash;

});


parcelRegister("dVcFO", function(module, exports) {
/*
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-1, as defined
 * in FIPS PUB 180-1
 * Version 2.1a Copyright Paul Johnston 2000 - 2002.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 * Distributed under the BSD License
 * See http://pajhome.org.uk/crypt/md5 for details.
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $a22a6de6a357c37a$require$Buffer = $1U9GM.Buffer;
var $a22a6de6a357c37a$var$K = [
    0x5a827999,
    0x6ed9eba1,
    -1894007588,
    -899497514
];
var $a22a6de6a357c37a$var$W = new Array(80);
function $a22a6de6a357c37a$var$Sha1() {
    this.init();
    this._w = $a22a6de6a357c37a$var$W;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($a22a6de6a357c37a$var$Sha1, $O5ywn);
$a22a6de6a357c37a$var$Sha1.prototype.init = function() {
    this._a = 0x67452301;
    this._b = 0xefcdab89;
    this._c = 0x98badcfe;
    this._d = 0x10325476;
    this._e = 0xc3d2e1f0;
    return this;
};
function $a22a6de6a357c37a$var$rotl1(num) {
    return num << 1 | num >>> 31;
}
function $a22a6de6a357c37a$var$rotl5(num) {
    return num << 5 | num >>> 27;
}
function $a22a6de6a357c37a$var$rotl30(num) {
    return num << 30 | num >>> 2;
}
function $a22a6de6a357c37a$var$ft(s, b, c, d) {
    if (s === 0) return b & c | ~b & d;
    if (s === 2) return b & c | b & d | c & d;
    return b ^ c ^ d;
}
$a22a6de6a357c37a$var$Sha1.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 80; ++i)W[i] = $a22a6de6a357c37a$var$rotl1(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16]);
    for(var j = 0; j < 80; ++j){
        var s = ~~(j / 20);
        var t = $a22a6de6a357c37a$var$rotl5(a) + $a22a6de6a357c37a$var$ft(s, b, c, d) + e + W[j] + $a22a6de6a357c37a$var$K[s] | 0;
        e = d;
        d = c;
        c = $a22a6de6a357c37a$var$rotl30(b);
        b = a;
        a = t;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
};
$a22a6de6a357c37a$var$Sha1.prototype._hash = function() {
    var H = $a22a6de6a357c37a$require$Buffer.allocUnsafe(20);
    H.writeInt32BE(this._a | 0, 0);
    H.writeInt32BE(this._b | 0, 4);
    H.writeInt32BE(this._c | 0, 8);
    H.writeInt32BE(this._d | 0, 12);
    H.writeInt32BE(this._e | 0, 16);
    return H;
};
module.exports = $a22a6de6a357c37a$var$Sha1;

});

parcelRegister("3wNjm", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $3BFQx = parcelRequire("3BFQx");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $291a9c6c5654a48d$require$Buffer = $1U9GM.Buffer;
var $291a9c6c5654a48d$var$W = new Array(64);
function $291a9c6c5654a48d$var$Sha224() {
    this.init();
    this._w = $291a9c6c5654a48d$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($291a9c6c5654a48d$var$Sha224, $3BFQx);
$291a9c6c5654a48d$var$Sha224.prototype.init = function() {
    this._a = 0xc1059ed8;
    this._b = 0x367cd507;
    this._c = 0x3070dd17;
    this._d = 0xf70e5939;
    this._e = 0xffc00b31;
    this._f = 0x68581511;
    this._g = 0x64f98fa7;
    this._h = 0xbefa4fa4;
    return this;
};
$291a9c6c5654a48d$var$Sha224.prototype._hash = function() {
    var H = $291a9c6c5654a48d$require$Buffer.allocUnsafe(28);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    return H;
};
module.exports = $291a9c6c5654a48d$var$Sha224;

});
parcelRegister("3BFQx", function(module, exports) {
/**
 * A JavaScript implementation of the Secure Hash Algorithm, SHA-256, as defined
 * in FIPS 180-2
 * Version 2.2-beta Copyright Angel Marin, Paul Johnston 2000 - 2009.
 * Other contributors: Greg Holt, Andrew Kepert, Ydnar, Lostinet
 *
 */ 
var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $2a05499bef58a0cf$require$Buffer = $1U9GM.Buffer;
var $2a05499bef58a0cf$var$K = [
    0x428A2F98,
    0x71374491,
    0xB5C0FBCF,
    0xE9B5DBA5,
    0x3956C25B,
    0x59F111F1,
    0x923F82A4,
    0xAB1C5ED5,
    0xD807AA98,
    0x12835B01,
    0x243185BE,
    0x550C7DC3,
    0x72BE5D74,
    0x80DEB1FE,
    0x9BDC06A7,
    0xC19BF174,
    0xE49B69C1,
    0xEFBE4786,
    0x0FC19DC6,
    0x240CA1CC,
    0x2DE92C6F,
    0x4A7484AA,
    0x5CB0A9DC,
    0x76F988DA,
    0x983E5152,
    0xA831C66D,
    0xB00327C8,
    0xBF597FC7,
    0xC6E00BF3,
    0xD5A79147,
    0x06CA6351,
    0x14292967,
    0x27B70A85,
    0x2E1B2138,
    0x4D2C6DFC,
    0x53380D13,
    0x650A7354,
    0x766A0ABB,
    0x81C2C92E,
    0x92722C85,
    0xA2BFE8A1,
    0xA81A664B,
    0xC24B8B70,
    0xC76C51A3,
    0xD192E819,
    0xD6990624,
    0xF40E3585,
    0x106AA070,
    0x19A4C116,
    0x1E376C08,
    0x2748774C,
    0x34B0BCB5,
    0x391C0CB3,
    0x4ED8AA4A,
    0x5B9CCA4F,
    0x682E6FF3,
    0x748F82EE,
    0x78A5636F,
    0x84C87814,
    0x8CC70208,
    0x90BEFFFA,
    0xA4506CEB,
    0xBEF9A3F7,
    0xC67178F2
];
var $2a05499bef58a0cf$var$W = new Array(64);
function $2a05499bef58a0cf$var$Sha256() {
    this.init();
    this._w = $2a05499bef58a0cf$var$W // new Array(64)
    ;
    $O5ywn.call(this, 64, 56);
}
$dlqwk($2a05499bef58a0cf$var$Sha256, $O5ywn);
$2a05499bef58a0cf$var$Sha256.prototype.init = function() {
    this._a = 0x6a09e667;
    this._b = 0xbb67ae85;
    this._c = 0x3c6ef372;
    this._d = 0xa54ff53a;
    this._e = 0x510e527f;
    this._f = 0x9b05688c;
    this._g = 0x1f83d9ab;
    this._h = 0x5be0cd19;
    return this;
};
function $2a05499bef58a0cf$var$ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $2a05499bef58a0cf$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $2a05499bef58a0cf$var$sigma0(x) {
    return (x >>> 2 | x << 30) ^ (x >>> 13 | x << 19) ^ (x >>> 22 | x << 10);
}
function $2a05499bef58a0cf$var$sigma1(x) {
    return (x >>> 6 | x << 26) ^ (x >>> 11 | x << 21) ^ (x >>> 25 | x << 7);
}
function $2a05499bef58a0cf$var$gamma0(x) {
    return (x >>> 7 | x << 25) ^ (x >>> 18 | x << 14) ^ x >>> 3;
}
function $2a05499bef58a0cf$var$gamma1(x) {
    return (x >>> 17 | x << 15) ^ (x >>> 19 | x << 13) ^ x >>> 10;
}
$2a05499bef58a0cf$var$Sha256.prototype._update = function(M) {
    var W = this._w;
    var a = this._a | 0;
    var b = this._b | 0;
    var c = this._c | 0;
    var d = this._d | 0;
    var e = this._e | 0;
    var f = this._f | 0;
    var g = this._g | 0;
    var h = this._h | 0;
    for(var i = 0; i < 16; ++i)W[i] = M.readInt32BE(i * 4);
    for(; i < 64; ++i)W[i] = $2a05499bef58a0cf$var$gamma1(W[i - 2]) + W[i - 7] + $2a05499bef58a0cf$var$gamma0(W[i - 15]) + W[i - 16] | 0;
    for(var j = 0; j < 64; ++j){
        var T1 = h + $2a05499bef58a0cf$var$sigma1(e) + $2a05499bef58a0cf$var$ch(e, f, g) + $2a05499bef58a0cf$var$K[j] + W[j] | 0;
        var T2 = $2a05499bef58a0cf$var$sigma0(a) + $2a05499bef58a0cf$var$maj(a, b, c) | 0;
        h = g;
        g = f;
        f = e;
        e = d + T1 | 0;
        d = c;
        c = b;
        b = a;
        a = T1 + T2 | 0;
    }
    this._a = a + this._a | 0;
    this._b = b + this._b | 0;
    this._c = c + this._c | 0;
    this._d = d + this._d | 0;
    this._e = e + this._e | 0;
    this._f = f + this._f | 0;
    this._g = g + this._g | 0;
    this._h = h + this._h | 0;
};
$2a05499bef58a0cf$var$Sha256.prototype._hash = function() {
    var H = $2a05499bef58a0cf$require$Buffer.allocUnsafe(32);
    H.writeInt32BE(this._a, 0);
    H.writeInt32BE(this._b, 4);
    H.writeInt32BE(this._c, 8);
    H.writeInt32BE(this._d, 12);
    H.writeInt32BE(this._e, 16);
    H.writeInt32BE(this._f, 20);
    H.writeInt32BE(this._g, 24);
    H.writeInt32BE(this._h, 28);
    return H;
};
module.exports = $2a05499bef58a0cf$var$Sha256;

});


parcelRegister("5qHaZ", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $bZI17 = parcelRequire("bZI17");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $01052ce47f94a5df$require$Buffer = $1U9GM.Buffer;
var $01052ce47f94a5df$var$W = new Array(160);
function $01052ce47f94a5df$var$Sha384() {
    this.init();
    this._w = $01052ce47f94a5df$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($01052ce47f94a5df$var$Sha384, $bZI17);
$01052ce47f94a5df$var$Sha384.prototype.init = function() {
    this._ah = 0xcbbb9d5d;
    this._bh = 0x629a292a;
    this._ch = 0x9159015a;
    this._dh = 0x152fecd8;
    this._eh = 0x67332667;
    this._fh = 0x8eb44a87;
    this._gh = 0xdb0c2e0d;
    this._hh = 0x47b5481d;
    this._al = 0xc1059ed8;
    this._bl = 0x367cd507;
    this._cl = 0x3070dd17;
    this._dl = 0xf70e5939;
    this._el = 0xffc00b31;
    this._fl = 0x68581511;
    this._gl = 0x64f98fa7;
    this._hl = 0xbefa4fa4;
    return this;
};
$01052ce47f94a5df$var$Sha384.prototype._hash = function() {
    var H = $01052ce47f94a5df$require$Buffer.allocUnsafe(48);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    return H;
};
module.exports = $01052ce47f94a5df$var$Sha384;

});
parcelRegister("bZI17", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $O5ywn = parcelRequire("O5ywn");

var $1U9GM = parcelRequire("1U9GM");
var $8bb7891960962038$require$Buffer = $1U9GM.Buffer;
var $8bb7891960962038$var$K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
var $8bb7891960962038$var$W = new Array(160);
function $8bb7891960962038$var$Sha512() {
    this.init();
    this._w = $8bb7891960962038$var$W;
    $O5ywn.call(this, 128, 112);
}
$dlqwk($8bb7891960962038$var$Sha512, $O5ywn);
$8bb7891960962038$var$Sha512.prototype.init = function() {
    this._ah = 0x6a09e667;
    this._bh = 0xbb67ae85;
    this._ch = 0x3c6ef372;
    this._dh = 0xa54ff53a;
    this._eh = 0x510e527f;
    this._fh = 0x9b05688c;
    this._gh = 0x1f83d9ab;
    this._hh = 0x5be0cd19;
    this._al = 0xf3bcc908;
    this._bl = 0x84caa73b;
    this._cl = 0xfe94f82b;
    this._dl = 0x5f1d36f1;
    this._el = 0xade682d1;
    this._fl = 0x2b3e6c1f;
    this._gl = 0xfb41bd6b;
    this._hl = 0x137e2179;
    return this;
};
function $8bb7891960962038$var$Ch(x, y, z) {
    return z ^ x & (y ^ z);
}
function $8bb7891960962038$var$maj(x, y, z) {
    return x & y | z & (x | y);
}
function $8bb7891960962038$var$sigma0(x, xl) {
    return (x >>> 28 | xl << 4) ^ (xl >>> 2 | x << 30) ^ (xl >>> 7 | x << 25);
}
function $8bb7891960962038$var$sigma1(x, xl) {
    return (x >>> 14 | xl << 18) ^ (x >>> 18 | xl << 14) ^ (xl >>> 9 | x << 23);
}
function $8bb7891960962038$var$Gamma0(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ x >>> 7;
}
function $8bb7891960962038$var$Gamma0l(x, xl) {
    return (x >>> 1 | xl << 31) ^ (x >>> 8 | xl << 24) ^ (x >>> 7 | xl << 25);
}
function $8bb7891960962038$var$Gamma1(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ x >>> 6;
}
function $8bb7891960962038$var$Gamma1l(x, xl) {
    return (x >>> 19 | xl << 13) ^ (xl >>> 29 | x << 3) ^ (x >>> 6 | xl << 26);
}
function $8bb7891960962038$var$getCarry(a, b) {
    return a >>> 0 < b >>> 0 ? 1 : 0;
}
$8bb7891960962038$var$Sha512.prototype._update = function(M) {
    var W = this._w;
    var ah = this._ah | 0;
    var bh = this._bh | 0;
    var ch = this._ch | 0;
    var dh = this._dh | 0;
    var eh = this._eh | 0;
    var fh = this._fh | 0;
    var gh = this._gh | 0;
    var hh = this._hh | 0;
    var al = this._al | 0;
    var bl = this._bl | 0;
    var cl = this._cl | 0;
    var dl = this._dl | 0;
    var el = this._el | 0;
    var fl = this._fl | 0;
    var gl = this._gl | 0;
    var hl = this._hl | 0;
    for(var i = 0; i < 32; i += 2){
        W[i] = M.readInt32BE(i * 4);
        W[i + 1] = M.readInt32BE(i * 4 + 4);
    }
    for(; i < 160; i += 2){
        var xh = W[i - 30];
        var xl = W[i - 30 + 1];
        var gamma0 = $8bb7891960962038$var$Gamma0(xh, xl);
        var gamma0l = $8bb7891960962038$var$Gamma0l(xl, xh);
        xh = W[i - 4];
        xl = W[i - 4 + 1];
        var gamma1 = $8bb7891960962038$var$Gamma1(xh, xl);
        var gamma1l = $8bb7891960962038$var$Gamma1l(xl, xh);
        // W[i] = gamma0 + W[i - 7] + gamma1 + W[i - 16]
        var Wi7h = W[i - 14];
        var Wi7l = W[i - 14 + 1];
        var Wi16h = W[i - 32];
        var Wi16l = W[i - 32 + 1];
        var Wil = gamma0l + Wi7l | 0;
        var Wih = gamma0 + Wi7h + $8bb7891960962038$var$getCarry(Wil, gamma0l) | 0;
        Wil = Wil + gamma1l | 0;
        Wih = Wih + gamma1 + $8bb7891960962038$var$getCarry(Wil, gamma1l) | 0;
        Wil = Wil + Wi16l | 0;
        Wih = Wih + Wi16h + $8bb7891960962038$var$getCarry(Wil, Wi16l) | 0;
        W[i] = Wih;
        W[i + 1] = Wil;
    }
    for(var j = 0; j < 160; j += 2){
        Wih = W[j];
        Wil = W[j + 1];
        var majh = $8bb7891960962038$var$maj(ah, bh, ch);
        var majl = $8bb7891960962038$var$maj(al, bl, cl);
        var sigma0h = $8bb7891960962038$var$sigma0(ah, al);
        var sigma0l = $8bb7891960962038$var$sigma0(al, ah);
        var sigma1h = $8bb7891960962038$var$sigma1(eh, el);
        var sigma1l = $8bb7891960962038$var$sigma1(el, eh);
        // t1 = h + sigma1 + ch + K[j] + W[j]
        var Kih = $8bb7891960962038$var$K[j];
        var Kil = $8bb7891960962038$var$K[j + 1];
        var chh = $8bb7891960962038$var$Ch(eh, fh, gh);
        var chl = $8bb7891960962038$var$Ch(el, fl, gl);
        var t1l = hl + sigma1l | 0;
        var t1h = hh + sigma1h + $8bb7891960962038$var$getCarry(t1l, hl) | 0;
        t1l = t1l + chl | 0;
        t1h = t1h + chh + $8bb7891960962038$var$getCarry(t1l, chl) | 0;
        t1l = t1l + Kil | 0;
        t1h = t1h + Kih + $8bb7891960962038$var$getCarry(t1l, Kil) | 0;
        t1l = t1l + Wil | 0;
        t1h = t1h + Wih + $8bb7891960962038$var$getCarry(t1l, Wil) | 0;
        // t2 = sigma0 + maj
        var t2l = sigma0l + majl | 0;
        var t2h = sigma0h + majh + $8bb7891960962038$var$getCarry(t2l, sigma0l) | 0;
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        el = dl + t1l | 0;
        eh = dh + t1h + $8bb7891960962038$var$getCarry(el, dl) | 0;
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        al = t1l + t2l | 0;
        ah = t1h + t2h + $8bb7891960962038$var$getCarry(al, t1l) | 0;
    }
    this._al = this._al + al | 0;
    this._bl = this._bl + bl | 0;
    this._cl = this._cl + cl | 0;
    this._dl = this._dl + dl | 0;
    this._el = this._el + el | 0;
    this._fl = this._fl + fl | 0;
    this._gl = this._gl + gl | 0;
    this._hl = this._hl + hl | 0;
    this._ah = this._ah + ah + $8bb7891960962038$var$getCarry(this._al, al) | 0;
    this._bh = this._bh + bh + $8bb7891960962038$var$getCarry(this._bl, bl) | 0;
    this._ch = this._ch + ch + $8bb7891960962038$var$getCarry(this._cl, cl) | 0;
    this._dh = this._dh + dh + $8bb7891960962038$var$getCarry(this._dl, dl) | 0;
    this._eh = this._eh + eh + $8bb7891960962038$var$getCarry(this._el, el) | 0;
    this._fh = this._fh + fh + $8bb7891960962038$var$getCarry(this._fl, fl) | 0;
    this._gh = this._gh + gh + $8bb7891960962038$var$getCarry(this._gl, gl) | 0;
    this._hh = this._hh + hh + $8bb7891960962038$var$getCarry(this._hl, hl) | 0;
};
$8bb7891960962038$var$Sha512.prototype._hash = function() {
    var H = $8bb7891960962038$require$Buffer.allocUnsafe(64);
    function writeInt64BE(h, l, offset) {
        H.writeInt32BE(h, offset);
        H.writeInt32BE(l, offset + 4);
    }
    writeInt64BE(this._ah, this._al, 0);
    writeInt64BE(this._bh, this._bl, 8);
    writeInt64BE(this._ch, this._cl, 16);
    writeInt64BE(this._dh, this._dl, 24);
    writeInt64BE(this._eh, this._el, 32);
    writeInt64BE(this._fh, this._fl, 40);
    writeInt64BE(this._gh, this._gl, 48);
    writeInt64BE(this._hh, this._hl, 56);
    return H;
};
module.exports = $8bb7891960962038$var$Sha512;

});



parcelRegister("26nOC", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $187e9d8dfda3dbba$require$Buffer = $1U9GM.Buffer;

var $ioRHp = parcelRequire("ioRHp");
var $187e9d8dfda3dbba$require$Transform = $ioRHp.Transform;

var $eNRCS = parcelRequire("eNRCS");
var $187e9d8dfda3dbba$require$StringDecoder = $eNRCS.StringDecoder;

var $dlqwk = parcelRequire("dlqwk");
function $187e9d8dfda3dbba$var$CipherBase(hashMode) {
    $187e9d8dfda3dbba$require$Transform.call(this);
    this.hashMode = typeof hashMode === "string";
    if (this.hashMode) this[hashMode] = this._finalOrDigest;
    else this.final = this._finalOrDigest;
    if (this._final) {
        this.__final = this._final;
        this._final = null;
    }
    this._decoder = null;
    this._encoding = null;
}
$dlqwk($187e9d8dfda3dbba$var$CipherBase, $187e9d8dfda3dbba$require$Transform);
$187e9d8dfda3dbba$var$CipherBase.prototype.update = function(data, inputEnc, outputEnc) {
    if (typeof data === "string") data = $187e9d8dfda3dbba$require$Buffer.from(data, inputEnc);
    var outData = this._update(data);
    if (this.hashMode) return this;
    if (outputEnc) outData = this._toString(outData, outputEnc);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAutoPadding = function() {};
$187e9d8dfda3dbba$var$CipherBase.prototype.getAuthTag = function() {
    throw new Error("trying to get auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAuthTag = function() {
    throw new Error("trying to set auth tag in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype.setAAD = function() {
    throw new Error("trying to set aad in unsupported state");
};
$187e9d8dfda3dbba$var$CipherBase.prototype._transform = function(data, _, next) {
    var err;
    try {
        if (this.hashMode) this._update(data);
        else this.push(this._update(data));
    } catch (e) {
        err = e;
    } finally{
        next(err);
    }
};
$187e9d8dfda3dbba$var$CipherBase.prototype._flush = function(done) {
    var err;
    try {
        this.push(this.__final());
    } catch (e) {
        err = e;
    }
    done(err);
};
$187e9d8dfda3dbba$var$CipherBase.prototype._finalOrDigest = function(outputEnc) {
    var outData = this.__final() || $187e9d8dfda3dbba$require$Buffer.alloc(0);
    if (outputEnc) outData = this._toString(outData, outputEnc, true);
    return outData;
};
$187e9d8dfda3dbba$var$CipherBase.prototype._toString = function(value, enc, fin) {
    if (!this._decoder) {
        this._decoder = new $187e9d8dfda3dbba$require$StringDecoder(enc);
        this._encoding = enc;
    }
    if (this._encoding !== enc) throw new Error("can't switch encodings");
    var out = this._decoder.write(value);
    if (fin) out += this._decoder.end();
    return out;
};
module.exports = $187e9d8dfda3dbba$var$CipherBase;

});


parcelRegister("bJNmB", function(module, exports) {
"use strict";

var $bYkMz = parcelRequire("bYkMz");

var $1U9GM = parcelRequire("1U9GM");
var $88ba304516094693$require$Buffer = $1U9GM.Buffer;
module.exports = function(checksumFn) {
    // Encode a buffer as a base58-check encoded string
    function encode(payload) {
        var checksum = checksumFn(payload);
        return $bYkMz.encode($88ba304516094693$require$Buffer.concat([
            payload,
            checksum
        ], payload.length + 4));
    }
    function decodeRaw(buffer) {
        var payload = buffer.slice(0, -4);
        var checksum = buffer.slice(-4);
        var newChecksum = checksumFn(payload);
        if (checksum[0] ^ newChecksum[0] | checksum[1] ^ newChecksum[1] | checksum[2] ^ newChecksum[2] | checksum[3] ^ newChecksum[3]) return;
        return payload;
    }
    // Decode a base58-check encoded string to a buffer, no result if checksum is wrong
    function decodeUnsafe(string) {
        var buffer = $bYkMz.decodeUnsafe(string);
        if (!buffer) return;
        return decodeRaw(buffer);
    }
    function decode(string) {
        var buffer = $bYkMz.decode(string);
        var payload = decodeRaw(buffer, checksumFn);
        if (!payload) throw new Error("Invalid checksum");
        return payload;
    }
    return {
        encode: encode,
        decode: decode,
        decodeUnsafe: decodeUnsafe
    };
};

});
parcelRegister("bYkMz", function(module, exports) {

var $0DhcF = parcelRequire("0DhcF");
var $8b756b3b8ee97947$var$ALPHABET = "123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz";
module.exports = $0DhcF($8b756b3b8ee97947$var$ALPHABET);

});
parcelRegister("0DhcF", function(module, exports) {
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $001e77b0dfd1bf3d$require$_Buffer = $1U9GM.Buffer;
function $001e77b0dfd1bf3d$var$base(ALPHABET) {
    if (ALPHABET.length >= 255) throw new TypeError("Alphabet too long");
    var BASE_MAP = new Uint8Array(256);
    for(var j = 0; j < BASE_MAP.length; j++)BASE_MAP[j] = 255;
    for(var i = 0; i < ALPHABET.length; i++){
        var x = ALPHABET.charAt(i);
        var xc = x.charCodeAt(0);
        if (BASE_MAP[xc] !== 255) throw new TypeError(x + " is ambiguous");
        BASE_MAP[xc] = i;
    }
    var BASE = ALPHABET.length;
    var LEADER = ALPHABET.charAt(0);
    var FACTOR = Math.log(BASE) / Math.log(256) // log(BASE) / log(256), rounded up
    ;
    var iFACTOR = Math.log(256) / Math.log(BASE) // log(256) / log(BASE), rounded up
    ;
    function encode(source) {
        if (Array.isArray(source) || source instanceof Uint8Array) source = $001e77b0dfd1bf3d$require$_Buffer.from(source);
        if (!$001e77b0dfd1bf3d$require$_Buffer.isBuffer(source)) throw new TypeError("Expected Buffer");
        if (source.length === 0) return "";
        // Skip & count leading zeroes.
        var zeroes = 0;
        var length = 0;
        var pbegin = 0;
        var pend = source.length;
        while(pbegin !== pend && source[pbegin] === 0){
            pbegin++;
            zeroes++;
        }
        // Allocate enough space in big-endian base58 representation.
        var size = (pend - pbegin) * iFACTOR + 1 >>> 0;
        var b58 = new Uint8Array(size);
        // Process the bytes.
        while(pbegin !== pend){
            var carry = source[pbegin];
            // Apply "b58 = b58 * 256 + ch".
            var i = 0;
            for(var it1 = size - 1; (carry !== 0 || i < length) && it1 !== -1; it1--, i++){
                carry += 256 * b58[it1] >>> 0;
                b58[it1] = carry % BASE >>> 0;
                carry = carry / BASE >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            pbegin++;
        }
        // Skip leading zeroes in base58 result.
        var it2 = size - length;
        while(it2 !== size && b58[it2] === 0)it2++;
        // Translate the result into a string.
        var str = LEADER.repeat(zeroes);
        for(; it2 < size; ++it2)str += ALPHABET.charAt(b58[it2]);
        return str;
    }
    function decodeUnsafe(source) {
        if (typeof source !== "string") throw new TypeError("Expected String");
        if (source.length === 0) return $001e77b0dfd1bf3d$require$_Buffer.alloc(0);
        var psz = 0;
        // Skip and count leading '1's.
        var zeroes = 0;
        var length = 0;
        while(source[psz] === LEADER){
            zeroes++;
            psz++;
        }
        // Allocate enough space in big-endian base256 representation.
        var size = (source.length - psz) * FACTOR + 1 >>> 0 // log(58) / log(256), rounded up.
        ;
        var b256 = new Uint8Array(size);
        // Process the characters.
        while(psz < source.length){
            // Decode character
            var carry = BASE_MAP[source.charCodeAt(psz)];
            // Invalid character
            if (carry === 255) return;
            var i = 0;
            for(var it3 = size - 1; (carry !== 0 || i < length) && it3 !== -1; it3--, i++){
                carry += BASE * b256[it3] >>> 0;
                b256[it3] = carry % 256 >>> 0;
                carry = carry / 256 >>> 0;
            }
            if (carry !== 0) throw new Error("Non-zero carry");
            length = i;
            psz++;
        }
        // Skip leading zeroes in b256.
        var it4 = size - length;
        while(it4 !== size && b256[it4] === 0)it4++;
        var vch = $001e77b0dfd1bf3d$require$_Buffer.allocUnsafe(zeroes + (size - it4));
        vch.fill(0x00, 0, zeroes);
        var j = zeroes;
        while(it4 !== size)vch[j++] = b256[it4++];
        return vch;
    }
    function decode(string) {
        var buffer = decodeUnsafe(string);
        if (buffer) return buffer;
        throw new Error("Non-base" + BASE + " character");
    }
    return {
        encode: encode,
        decodeUnsafe: decodeUnsafe,
        decode: decode
    };
}
module.exports = $001e77b0dfd1bf3d$var$base;

});





parcelRegister("bBRJ3", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $873cd33230d94083$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.ClientCommandInterpreter = module.exports.GetMoreElementsCommand = module.exports.GetMerkleLeafIndexCommand = module.exports.GetMerkleLeafProofCommand = module.exports.GetPreimageCommand = module.exports.YieldCommand = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $8rRzQ = parcelRequire("8rRzQ");

var $goh0i = parcelRequire("goh0i");

var $8GOLq = parcelRequire("8GOLq");
var $873cd33230d94083$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($873cd33230d94083$var$ClientCommandCode || ($873cd33230d94083$var$ClientCommandCode = {}));
class $873cd33230d94083$var$ClientCommand {
}
class $873cd33230d94083$var$YieldCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(results, progressCallback){
        super();
        this.progressCallback = progressCallback;
        this.code = $873cd33230d94083$var$ClientCommandCode.YIELD;
        this.results = results;
    }
    execute(request) {
        this.results.push($873cd33230d94083$require$Buffer.from(request.subarray(1)));
        if (this.progressCallback) this.progressCallback();
        return $873cd33230d94083$require$Buffer.from("");
    }
}
module.exports.YieldCommand = $873cd33230d94083$var$YieldCommand;
class $873cd33230d94083$var$GetPreimageCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_preimages, queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_PREIMAGE;
        this.known_preimages = known_preimages;
        this.queue = queue;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        // we expect no more data to read
        if (req.length != 33) throw new Error("Invalid request, unexpected trailing data");
        if (req[0] != 0) throw new Error("Unsupported request, the first byte should be 0");
        // read the hash
        const hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)hash[i] = req[1 + i];
        const req_hash_hex = hash.toString("hex");
        const known_preimage = this.known_preimages.get(req_hash_hex);
        if (known_preimage != undefined) {
            const preimage_len_varint = (0, $8GOLq.createVarint)(known_preimage.length);
            // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
            // the rest will be stored in the queue for GET_MORE_ELEMENTS
            const max_payload_size = 255 - preimage_len_varint.length - 1;
            const payload_size = Math.min(max_payload_size, known_preimage.length);
            if (payload_size < known_preimage.length) for(let i = payload_size; i < known_preimage.length; i++)this.queue.push($873cd33230d94083$require$Buffer.from([
                known_preimage[i]
            ]));
            return $873cd33230d94083$require$Buffer.concat([
                preimage_len_varint,
                $873cd33230d94083$require$Buffer.from([
                    payload_size
                ]),
                $873cd33230d94083$require$Buffer.from(known_preimage.subarray(0, payload_size))
            ]);
        }
        throw Error(`Requested unknown preimage for: ${req_hash_hex}`);
    }
}
module.exports.GetPreimageCommand = $873cd33230d94083$var$GetPreimageCommand;
class $873cd33230d94083$var$GetMerkleLeafProofCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_trees, queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
        this.known_trees = known_trees;
        this.queue = queue;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        if (req.length < 34) throw new Error("Invalid request, expected at least 34 bytes");
        const reqBuf = new $8rRzQ.BufferReader(req);
        const hash = reqBuf.readSlice(32);
        const hash_hex = hash.toString("hex");
        let tree_size;
        let leaf_index;
        try {
            tree_size = (0, $8GOLq.sanitizeBigintToNumber)(reqBuf.readVarInt());
            leaf_index = (0, $8GOLq.sanitizeBigintToNumber)(reqBuf.readVarInt());
        } catch (e) {
            throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
        }
        const mt = this.known_trees.get(hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf proof for unknown tree: ${hash_hex}`);
        if (leaf_index >= tree_size || mt.size() != tree_size) throw Error("Invalid index or tree size.");
        if (this.queue.length != 0) throw Error("This command should not execute when the queue is not empty.");
        const proof = mt.getProof(leaf_index);
        const n_response_elements = Math.min(Math.floor(6.90625), proof.length);
        const n_leftover_elements = proof.length - n_response_elements;
        // Add to the queue any proof elements that do not fit the response
        if (n_leftover_elements > 0) this.queue.push(...proof.slice(-n_leftover_elements));
        return $873cd33230d94083$require$Buffer.concat([
            mt.getLeafHash(leaf_index),
            $873cd33230d94083$require$Buffer.from([
                proof.length
            ]),
            $873cd33230d94083$require$Buffer.from([
                n_response_elements
            ]),
            ...proof.slice(0, n_response_elements)
        ]);
    }
}
module.exports.GetMerkleLeafProofCommand = $873cd33230d94083$var$GetMerkleLeafProofCommand;
class $873cd33230d94083$var$GetMerkleLeafIndexCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(known_trees){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
        this.known_trees = known_trees;
    }
    execute(request) {
        const req = $873cd33230d94083$require$Buffer.from(request.subarray(1));
        if (req.length != 64) throw new Error("Invalid request, unexpected trailing data");
        // read the root hash
        const root_hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
        const root_hash_hex = root_hash.toString("hex");
        // read the leaf hash
        const leef_hash = $873cd33230d94083$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)leef_hash[i] = req.readUInt8(32 + i);
        const leef_hash_hex = leef_hash.toString("hex");
        const mt = this.known_trees.get(root_hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf index for unknown root: ${root_hash_hex}`);
        let leaf_index = 0;
        let found = 0;
        for(let i = 0; i < mt.size(); i++)if (mt.getLeafHash(i).toString("hex") == leef_hash_hex) {
            found = 1;
            leaf_index = i;
            break;
        }
        return $873cd33230d94083$require$Buffer.concat([
            $873cd33230d94083$require$Buffer.from([
                found
            ]),
            (0, $8GOLq.createVarint)(leaf_index)
        ]);
    }
}
module.exports.GetMerkleLeafIndexCommand = $873cd33230d94083$var$GetMerkleLeafIndexCommand;
class $873cd33230d94083$var$GetMoreElementsCommand extends $873cd33230d94083$var$ClientCommand {
    constructor(queue){
        super();
        this.code = $873cd33230d94083$var$ClientCommandCode.GET_MORE_ELEMENTS;
        this.queue = queue;
    }
    execute(request) {
        if (request.length != 1) throw new Error("Invalid request, unexpected trailing data");
        if (this.queue.length === 0) throw new Error("No elements to get");
        // all elements should have the same length
        const element_len = this.queue[0].length;
        if (this.queue.some((el)=>el.length != element_len)) throw new Error("The queue contains elements with different byte length, which is not expected");
        const max_elements = Math.floor(253 / element_len);
        const n_returned_elements = Math.min(max_elements, this.queue.length);
        const returned_elements = this.queue.splice(0, n_returned_elements);
        return $873cd33230d94083$require$Buffer.concat([
            $873cd33230d94083$require$Buffer.from([
                n_returned_elements
            ]),
            $873cd33230d94083$require$Buffer.from([
                element_len
            ]),
            ...returned_elements
        ]);
    }
}
module.exports.GetMoreElementsCommand = $873cd33230d94083$var$GetMoreElementsCommand;
/**
 * This class will dispatch a client command coming from the hardware device to
 * the appropriate client command implementation. Those client commands
 * typically requests data from a merkle tree or merkelized maps.
 *
 * A ClientCommandInterpreter is prepared by adding the merkle trees and
 * merkelized maps it should be able to serve to the hardware device. This class
 * doesn't know anything about the semantics of the data it holds, it just
 * serves merkle data. It doesn't even know in what context it is being
 * executed, ie SignPsbt, getWalletAddress, etc.
 *
 * If the command yelds results to the client, as signPsbt does, the yielded
 * data will be accessible after the command completed by calling getYielded(),
 * which will return the yields in the same order as they came in.
 */ class $873cd33230d94083$var$ClientCommandInterpreter {
    constructor(progressCallback){
        this.roots = new Map();
        this.preimages = new Map();
        this.yielded = [];
        this.queue = [];
        this.commands = new Map();
        const commands = [
            new $873cd33230d94083$var$YieldCommand(this.yielded, progressCallback),
            new $873cd33230d94083$var$GetPreimageCommand(this.preimages, this.queue),
            new $873cd33230d94083$var$GetMerkleLeafIndexCommand(this.roots),
            new $873cd33230d94083$var$GetMerkleLeafProofCommand(this.roots, this.queue),
            new $873cd33230d94083$var$GetMoreElementsCommand(this.queue)
        ];
        for (const cmd of commands){
            if (this.commands.has(cmd.code)) throw new Error(`Multiple commands with code ${cmd.code}`);
            this.commands.set(cmd.code, cmd);
        }
    }
    getYielded() {
        return this.yielded;
    }
    addKnownPreimage(preimage) {
        this.preimages.set($3wrUl.crypto.sha256(preimage).toString("hex"), preimage);
    }
    addKnownList(elements) {
        for (const el of elements){
            const preimage = $873cd33230d94083$require$Buffer.concat([
                $873cd33230d94083$require$Buffer.from([
                    0
                ]),
                el
            ]);
            this.addKnownPreimage(preimage);
        }
        const mt = new $goh0i.Merkle(elements.map((el)=>(0, $goh0i.hashLeaf)(el)));
        this.roots.set(mt.getRoot().toString("hex"), mt);
    }
    addKnownMapping(mm) {
        this.addKnownList(mm.keys);
        this.addKnownList(mm.values);
    }
    addKnownWalletPolicy(wp) {
        this.addKnownPreimage(wp.serialize());
        this.addKnownList(wp.keys.map((k)=>$873cd33230d94083$require$Buffer.from(k, "ascii")));
        this.addKnownPreimage($873cd33230d94083$require$Buffer.from(wp.descriptorTemplate));
    }
    execute(request) {
        if (request.length == 0) throw new Error("Unexpected empty command");
        const cmdCode = request[0];
        const cmd = this.commands.get(cmdCode);
        if (!cmd) throw new Error(`Unexpected command code ${cmdCode}`);
        return cmd.execute(request);
    }
}
module.exports.ClientCommandInterpreter = $873cd33230d94083$var$ClientCommandInterpreter;

});
parcelRegister("8rRzQ", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $626a67a10dc4b88a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.BufferReader = module.exports.BufferWriter = module.exports.unsafeFrom64bitLE = module.exports.unsafeTo64bitLE = void 0;

var $8GOLq = parcelRequire("8GOLq");
function $626a67a10dc4b88a$var$unsafeTo64bitLE(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const byteArray = $626a67a10dc4b88a$require$Buffer.alloc(8, 0);
    for(let index = 0; index < byteArray.length; index++){
        const byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
module.exports.unsafeTo64bitLE = $626a67a10dc4b88a$var$unsafeTo64bitLE;
function $626a67a10dc4b88a$var$unsafeFrom64bitLE(byteArray) {
    let value = 0;
    if (byteArray.length != 8) throw new Error("Expected Bufffer of lenght 8");
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(let i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
module.exports.unsafeFrom64bitLE = $626a67a10dc4b88a$var$unsafeFrom64bitLE;
class $626a67a10dc4b88a$var$BufferWriter {
    constructor(){
        this.bufs = [];
    }
    write(alloc, fn) {
        const b = $626a67a10dc4b88a$require$Buffer.alloc(alloc);
        fn(b);
        this.bufs.push(b);
    }
    writeUInt8(i) {
        this.write(1, (b)=>b.writeUInt8(i, 0));
    }
    writeInt32(i) {
        this.write(4, (b)=>b.writeInt32LE(i, 0));
    }
    writeUInt32(i) {
        this.write(4, (b)=>b.writeUInt32LE(i, 0));
    }
    writeUInt64(i) {
        const bytes = $626a67a10dc4b88a$var$unsafeTo64bitLE(i);
        this.writeSlice(bytes);
    }
    writeVarInt(i) {
        this.bufs.push((0, $8GOLq.createVarint)(i));
    }
    writeSlice(slice) {
        this.bufs.push($626a67a10dc4b88a$require$Buffer.from(slice));
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    buffer() {
        return $626a67a10dc4b88a$require$Buffer.concat(this.bufs);
    }
}
module.exports.BufferWriter = $626a67a10dc4b88a$var$BufferWriter;
class $626a67a10dc4b88a$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
    }
    available() {
        return this.buffer.length - this.offset;
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const buf = this.readSlice(8);
        return $626a67a10dc4b88a$var$unsafeFrom64bitLE(buf);
    }
    readVarInt() {
        const [vi, vi_size] = (0, $8GOLq.parseVarint)(this.buffer, this.offset);
        this.offset += vi_size;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        const n = (0, $8GOLq.sanitizeBigintToNumber)(this.readVarInt());
        return this.readSlice(n);
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
module.exports.BufferReader = $626a67a10dc4b88a$var$BufferReader;

});
parcelRegister("8GOLq", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $65399fa1584d746d$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.createVarint = module.exports.parseVarint = module.exports.sanitizeBigintToNumber = void 0;
function $65399fa1584d746d$var$bigintToSmallEndian(value, length, buffer, offset) {
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error("Buffer too small");
        buffer[i + offset] = Number(value % BigInt(256));
        value = value >> BigInt(8);
    }
}
function $65399fa1584d746d$var$smallEndianToBigint(buffer, offset, length) {
    let result = BigInt(0);
    for(let i = 0; i < length; i++){
        if (buffer[i + offset] == undefined) throw Error("Buffer too small");
        result += BigInt(buffer[i + offset]) << BigInt(i * 8);
    }
    return result;
}
/**
 * Converts a `bigint` to a `number` if it non-negative and at most MAX_SAFE_INTEGER; throws `RangeError` otherwise.
 * Used when converting a Bitcoin-style varint to a `number`, since varints could be larger than what the `Number`
 * class can represent without loss of precision.
 *
 * @param n the number to convert
 * @returns `n` as a `number`
 */ function $65399fa1584d746d$var$sanitizeBigintToNumber(n) {
    if (n < 0) throw RangeError("Negative bigint is not a valid varint");
    if (n > Number.MAX_SAFE_INTEGER) throw RangeError("Too large for a Number");
    return Number(n);
}
module.exports.sanitizeBigintToNumber = $65399fa1584d746d$var$sanitizeBigintToNumber;
function $65399fa1584d746d$var$getVarintSize(value) {
    if (typeof value == "number") value = $65399fa1584d746d$var$sanitizeBigintToNumber(value);
    if (value < BigInt(0)) throw new RangeError("Negative numbers are not supported");
    if (value >= BigInt(1) << BigInt(64)) throw new RangeError("Too large for a Bitcoin-style varint");
    if (value < BigInt(0xfd)) return 1;
    else if (value <= BigInt(0xffff)) return 3;
    else if (value <= BigInt(0xffffffff)) return 5;
    else return 9;
}
/**
 * Parses a Bitcoin-style variable length integer from a buffer, starting at the given `offset`. Returns a pair
 * containing the parsed `BigInt`, and its length in bytes from the buffer.
 *
 * @param data the `Buffer` from which the variable-length integer is read
 * @param offset a non-negative offset to read from
 * @returns a pair where the first element is the parsed BigInt, and the second element is the length in bytes parsed
 * from the buffer.
 *
 * @throws `RangeError` if offset is negative.
 * @throws `Error` if the buffer's end is reached withut parsing being completed.
 */ function $65399fa1584d746d$var$parseVarint(data, offset) {
    if (offset < 0) throw RangeError("Negative offset is invalid");
    if (data[offset] == undefined) throw Error("Buffer too small");
    if (data[offset] < 0xfd) return [
        BigInt(data[offset]),
        1
    ];
    else {
        let size;
        if (data[offset] === 0xfd) size = 2;
        else if (data[offset] === 0xfe) size = 4;
        else size = 8;
        return [
            $65399fa1584d746d$var$smallEndianToBigint(data, offset + 1, size),
            size + 1
        ];
    }
}
module.exports.parseVarint = $65399fa1584d746d$var$parseVarint;
function $65399fa1584d746d$var$createVarint(value) {
    if (typeof value == "number") value = $65399fa1584d746d$var$sanitizeBigintToNumber(value);
    const size = $65399fa1584d746d$var$getVarintSize(value);
    value = BigInt(value);
    const buffer = $65399fa1584d746d$require$Buffer.alloc(size);
    if (size == 1) buffer[0] = Number(value);
    else {
        if (size == 3) buffer[0] = 0xfd;
        else if (size === 5) buffer[0] = 0xfe;
        else buffer[0] = 0xff;
        $65399fa1584d746d$var$bigintToSmallEndian(value, size - 1, buffer, 1);
    }
    return buffer;
}
module.exports.createVarint = $65399fa1584d746d$var$createVarint;

});


parcelRegister("goh0i", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $beec13d4254150cc$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.hashLeaf = module.exports.Merkle = void 0;

var $3wrUl = parcelRequire("3wrUl");
/**
 * This class implements the merkle tree used by Ledger Bitcoin app v2+,
 * which is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md
 */ class $beec13d4254150cc$var$Merkle {
    constructor(leaves, hasher = $3wrUl.crypto.sha256){
        this.leaves = leaves;
        this.h = hasher;
        const nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    getRoot() {
        return this.rootNode.hash;
    }
    size() {
        return this.leaves.length;
    }
    getLeaves() {
        return this.leaves;
    }
    getLeafHash(index) {
        return this.leafNodes[index].hash;
    }
    getProof(index) {
        if (index >= this.leaves.length) throw Error("Index out of bounds");
        return $beec13d4254150cc$var$proveNode(this.leafNodes[index]);
    }
    calculateRoot(leaves) {
        const n = leaves.length;
        if (n == 0) return {
            root: new $beec13d4254150cc$var$Node(undefined, undefined, $beec13d4254150cc$require$Buffer.alloc(32, 0)),
            leaves: []
        };
        if (n == 1) {
            const newNode = new $beec13d4254150cc$var$Node(undefined, undefined, leaves[0]);
            return {
                root: newNode,
                leaves: [
                    newNode
                ]
            };
        }
        const leftCount = $beec13d4254150cc$var$highestPowerOf2LessThan(n);
        const leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
        const rightBranch = this.calculateRoot(leaves.slice(leftCount));
        const leftChild = leftBranch.root;
        const rightChild = rightBranch.root;
        const hash = this.hashNode(leftChild.hash, rightChild.hash);
        const node = new $beec13d4254150cc$var$Node(leftChild, rightChild, hash);
        leftChild.parent = node;
        rightChild.parent = node;
        return {
            root: node,
            leaves: leftBranch.leaves.concat(rightBranch.leaves)
        };
    }
    hashNode(left, right) {
        return this.h($beec13d4254150cc$require$Buffer.concat([
            $beec13d4254150cc$require$Buffer.from([
                1
            ]),
            left,
            right
        ]));
    }
}
module.exports.Merkle = $beec13d4254150cc$var$Merkle;
function $beec13d4254150cc$var$hashLeaf(buf, hashFunction = $3wrUl.crypto.sha256) {
    return $beec13d4254150cc$var$hashConcat($beec13d4254150cc$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
module.exports.hashLeaf = $beec13d4254150cc$var$hashLeaf;
function $beec13d4254150cc$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($beec13d4254150cc$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
class $beec13d4254150cc$var$Node {
    constructor(left, right, hash){
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    isLeaf() {
        return this.leftChild == undefined;
    }
}
function $beec13d4254150cc$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error("Expected right child to exist");
        return [
            node.parent.rightChild.hash,
            ...$beec13d4254150cc$var$proveNode(node.parent)
        ];
    } else {
        if (!node.parent.leftChild) throw new Error("Expected left child to exist");
        return [
            node.parent.leftChild.hash,
            ...$beec13d4254150cc$var$proveNode(node.parent)
        ];
    }
}
function $beec13d4254150cc$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error("Expected n >= 2");
    if ($beec13d4254150cc$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $beec13d4254150cc$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}

});


parcelRegister("bUD38", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $8ac337153aed10db$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkelizedPsbt = void 0;

var $flljP = parcelRequire("flljP");

var $fUsjC = parcelRequire("fUsjC");
/**
 * This class merkelizes a PSBTv2, by merkelizing the different
 * maps of the psbt. This is used during the transaction signing process,
 * where the hardware app can request specific parts of the psbt from the
 * client code and be sure that the response data actually belong to the psbt.
 * The reason for this is the limited amount of memory available to the app,
 * so it can't always store the full psbt in memory.
 *
 * The signing process is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#sign_psbt
 */ class $8ac337153aed10db$var$MerkelizedPsbt extends $fUsjC.PsbtV2 {
    constructor(psbt){
        super();
        this.inputMerkleMaps = [];
        this.outputMerkleMaps = [];
        psbt.copy(this);
        this.globalMerkleMap = $8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.globalMap);
        for(let i = 0; i < this.getGlobalInputCount(); i++)this.inputMerkleMaps.push($8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.inputMaps[i]));
        this.inputMapCommitments = [
            ...this.inputMerkleMaps.values()
        ].map((v)=>v.commitment());
        for(let i = 0; i < this.getGlobalOutputCount(); i++)this.outputMerkleMaps.push($8ac337153aed10db$var$MerkelizedPsbt.createMerkleMap(this.outputMaps[i]));
        this.outputMapCommitments = [
            ...this.outputMerkleMaps.values()
        ].map((v)=>v.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
        return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
        return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(map) {
        const sortedKeysStrings = [
            ...map.keys()
        ].sort();
        const values = sortedKeysStrings.map((k)=>{
            const v = map.get(k);
            if (!v) throw new Error("No value for key " + k);
            return v;
        });
        const sortedKeys = sortedKeysStrings.map((k)=>$8ac337153aed10db$require$Buffer.from(k, "hex"));
        return new $flljP.MerkleMap(sortedKeys, values);
    }
}
module.exports.MerkelizedPsbt = $8ac337153aed10db$var$MerkelizedPsbt;

});
parcelRegister("flljP", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b2b95aa8c594b0f4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.MerkleMap = void 0;

var $goh0i = parcelRequire("goh0i");

var $8GOLq = parcelRequire("8GOLq");
/**
 * This implements "Merkelized Maps", documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/merkle.md#merkleized-maps
 *
 * A merkelized map consist of two merkle trees, one for the keys of
 * a map and one for the values of the same map, thus the two merkle
 * trees have the same shape. The commitment is the number elements
 * in the map followed by the keys' merkle root followed by the
 * values' merkle root.
 */ class $b2b95aa8c594b0f4$var$MerkleMap {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */ constructor(keys, values){
        if (keys.length != values.length) throw new Error("keys and values should have the same length");
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(let i = 0; i < keys.length - 1; i++){
            if (keys[i].toString("hex") >= keys[i + 1].toString("hex")) throw new Error("keys must be in strictly increasing order");
        }
        this.keys = keys;
        this.keysTree = new $goh0i.Merkle(keys.map((k)=>(0, $goh0i.hashLeaf)(k)));
        this.values = values;
        this.valuesTree = new $goh0i.Merkle(values.map((v)=>(0, $goh0i.hashLeaf)(v)));
    }
    commitment() {
        // returns a buffer between 65 and 73 (included) bytes long
        return $b2b95aa8c594b0f4$require$Buffer.concat([
            (0, $8GOLq.createVarint)(this.keys.length),
            this.keysTree.getRoot(),
            this.valuesTree.getRoot()
        ]);
    }
}
module.exports.MerkleMap = $b2b95aa8c594b0f4$var$MerkleMap;

});

parcelRegister("fUsjC", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b9520cdb7ab7b6f5$require$Buffer = $6ZWSX.Buffer;
"use strict";
/* eslint-disable @typescript-eslint/no-non-null-assertion */ var $b9520cdb7ab7b6f5$var$__createBinding = module.exports && module.exports.__createBinding || (Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
});
var $b9520cdb7ab7b6f5$var$__setModuleDefault = module.exports && module.exports.__setModuleDefault || (Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
});
var $b9520cdb7ab7b6f5$var$__importStar = module.exports && module.exports.__importStar || function(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $b9520cdb7ab7b6f5$var$__createBinding(result, mod, k);
    }
    $b9520cdb7ab7b6f5$var$__setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.PsbtV2 = module.exports.NoSuchEntry = module.exports.psbtOut = module.exports.psbtIn = module.exports.psbtGlobal = void 0;

const $b9520cdb7ab7b6f5$var$bjs = $b9520cdb7ab7b6f5$var$__importStar((parcelRequire("3wrUl")));

var $8rRzQ = parcelRequire("8rRzQ");

var $8GOLq = parcelRequire("8GOLq");
var $b9520cdb7ab7b6f5$var$psbtGlobal;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["UNSIGNED_TX"] = 0] = "UNSIGNED_TX";
    psbtGlobal[psbtGlobal["XPUB"] = 1] = "XPUB";
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($b9520cdb7ab7b6f5$var$psbtGlobal = module.exports.psbtGlobal || (module.exports.psbtGlobal = {}));
var $b9520cdb7ab7b6f5$var$psbtIn;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["WITNESS_SCRIPT"] = 5] = "WITNESS_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($b9520cdb7ab7b6f5$var$psbtIn = module.exports.psbtIn || (module.exports.psbtIn = {}));
var $b9520cdb7ab7b6f5$var$psbtOut;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["WITNESS_SCRIPT"] = 1] = "WITNESS_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($b9520cdb7ab7b6f5$var$psbtOut = module.exports.psbtOut || (module.exports.psbtOut = {}));
const $b9520cdb7ab7b6f5$var$PSBT_MAGIC_BYTES = $b9520cdb7ab7b6f5$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
class $b9520cdb7ab7b6f5$var$NoSuchEntry extends Error {
}
module.exports.NoSuchEntry = $b9520cdb7ab7b6f5$var$NoSuchEntry;
/**
 * Implements Partially Signed Bitcoin Transaction version 2, BIP370, as
 * documented at https://github.com/bitcoin/bips/blob/master/bip-0370.mediawiki
 * and https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki
 *
 * A psbt is a data structure that can carry all relevant information about a
 * transaction through all stages of the signing process. From constructing an
 * unsigned transaction to extracting the final serialized transaction ready for
 * broadcast.
 *
 * This implementation is limited to what's needed in ledgerjs to carry out its
 * duties, which means that support for features like multisig or taproot script
 * path spending are not implemented. Specifically, it supports p2pkh,
 * p2wpkhWrappedInP2sh, p2wpkh and p2tr key path spending.
 *
 * This class is made purposefully dumb, so it's easy to add support for
 * complemantary fields as needed in the future.
 */ class $b9520cdb7ab7b6f5$var$PsbtV2 {
    constructor(){
        this.globalMap = new Map();
        this.inputMaps = [];
        this.outputMaps = [];
    }
    setGlobalTxVersion(version) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_VERSION, $b9520cdb7ab7b6f5$var$uint32LE(version));
    }
    getGlobalTxVersion() {
        return this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(locktime) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.FALLBACK_LOCKTIME, $b9520cdb7ab7b6f5$var$uint32LE(locktime));
    }
    getGlobalFallbackLocktime() {
        var _a;
        return (_a = this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.FALLBACK_LOCKTIME)) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0);
    }
    setGlobalInputCount(inputCount) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.INPUT_COUNT, $b9520cdb7ab7b6f5$var$varint(inputCount));
    }
    getGlobalInputCount() {
        return $b9520cdb7ab7b6f5$var$fromVarint(this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.INPUT_COUNT));
    }
    setGlobalOutputCount(outputCount) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.OUTPUT_COUNT, $b9520cdb7ab7b6f5$var$varint(outputCount));
    }
    getGlobalOutputCount() {
        return $b9520cdb7ab7b6f5$var$fromVarint(this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(byte) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.TX_MODIFIABLE, byte);
    }
    getGlobalTxModifiable() {
        return this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(psbtVersion) {
        this.setGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION, $b9520cdb7ab7b6f5$var$uint32LE(psbtVersion));
    }
    getGlobalPsbtVersion() {
        return this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(inputIndex, transaction) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.NON_WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b(), transaction);
    }
    getInputNonWitnessUtxo(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.NON_WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b());
    }
    setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeSlice($b9520cdb7ab7b6f5$var$uint64LE(amount));
        buf.writeVarSlice(scriptPubKey);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b(), buf.buffer());
    }
    getInputWitnessUtxo(inputIndex) {
        const utxo = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_UTXO, $b9520cdb7ab7b6f5$var$b());
        if (!utxo) return undefined;
        const buf = new $8rRzQ.BufferReader(utxo);
        return {
            amount: (0, $8rRzQ.unsafeFrom64bitLE)(buf.readSlice(8)),
            scriptPubKey: buf.readVarSlice()
        };
    }
    setInputPartialSig(inputIndex, pubkey, signature) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PARTIAL_SIG, pubkey, signature);
    }
    getInputPartialSig(inputIndex, pubkey) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PARTIAL_SIG, pubkey);
    }
    setInputSighashType(inputIndex, sigHashtype) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SIGHASH_TYPE, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(sigHashtype));
    }
    getInputSighashType(inputIndex) {
        const result = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SIGHASH_TYPE, $b9520cdb7ab7b6f5$var$b());
        if (!result) return undefined;
        return result.readUInt32LE(0);
    }
    setInputRedeemScript(inputIndex, redeemScript) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b(), redeemScript);
    }
    getInputRedeemScript(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setInputWitnessScript(inputIndex, witnessScript) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_SCRIPT, $b9520cdb7ab7b6f5$var$b(), witnessScript);
    }
    getInputWitnessScript(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.WITNESS_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
        if (pubkey.length != 33) throw new Error("Invalid pubkey length: " + pubkey.length);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getInputBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.BIP32_DERIVATION, pubkey);
        if (!buf) return undefined;
        return this.decodeBip32Derivation(buf);
    }
    setInputFinalScriptsig(inputIndex, scriptSig) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTSIG, $b9520cdb7ab7b6f5$var$b(), scriptSig);
    }
    getInputFinalScriptsig(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTSIG, $b9520cdb7ab7b6f5$var$b());
    }
    setInputFinalScriptwitness(inputIndex, scriptWitness) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTWITNESS, $b9520cdb7ab7b6f5$var$b(), scriptWitness);
    }
    getInputFinalScriptwitness(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.FINAL_SCRIPTWITNESS, $b9520cdb7ab7b6f5$var$b());
    }
    setInputPreviousTxId(inputIndex, txid) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PREVIOUS_TXID, $b9520cdb7ab7b6f5$var$b(), txid);
    }
    getInputPreviousTxid(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.PREVIOUS_TXID, $b9520cdb7ab7b6f5$var$b());
    }
    setInputOutputIndex(inputIndex, outputIndex) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.OUTPUT_INDEX, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(outputIndex));
    }
    getInputOutputIndex(inputIndex) {
        return this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.OUTPUT_INDEX, $b9520cdb7ab7b6f5$var$b()).readUInt32LE(0);
    }
    setInputSequence(inputIndex, sequence) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SEQUENCE, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint32LE(sequence));
    }
    getInputSequence(inputIndex) {
        var _a, _b;
        return (_b = (_a = this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.SEQUENCE, $b9520cdb7ab7b6f5$var$b())) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0)) !== null && _b !== void 0 ? _b : 0xffffffff;
    }
    setInputTapKeySig(inputIndex, sig) {
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_KEY_SIG, $b9520cdb7ab7b6f5$var$b(), sig);
    }
    getInputTapKeySig(inputIndex) {
        return this.getInputOptional(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_KEY_SIG, $b9520cdb7ab7b6f5$var$b());
    }
    setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
        if (pubkey.length != 32) throw new Error("Invalid pubkey length: " + pubkey.length);
        const buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
        this.setInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getInputTapBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInput(inputIndex, $b9520cdb7ab7b6f5$var$psbtIn.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getInputKeyDatas(inputIndex, keyType) {
        return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
    }
    setOutputRedeemScript(outputIndex, redeemScript) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b(), redeemScript);
    }
    getOutputRedeemScript(outputIndex) {
        return this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.REDEEM_SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getOutputBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.BIP_32_DERIVATION, pubkey);
        return this.decodeBip32Derivation(buf);
    }
    setOutputAmount(outputIndex, amount) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.AMOUNT, $b9520cdb7ab7b6f5$var$b(), $b9520cdb7ab7b6f5$var$uint64LE(amount));
    }
    getOutputAmount(outputIndex) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.AMOUNT, $b9520cdb7ab7b6f5$var$b());
        return (0, $8rRzQ.unsafeFrom64bitLE)(buf);
    }
    setOutputScript(outputIndex, scriptPubKey) {
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.SCRIPT, $b9520cdb7ab7b6f5$var$b(), scriptPubKey);
    }
    getOutputScript(outputIndex) {
        return this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.SCRIPT, $b9520cdb7ab7b6f5$var$b());
    }
    setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
        const buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
        this.setOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getOutputTapBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $b9520cdb7ab7b6f5$var$psbtOut.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    deleteInputEntries(inputIndex, keyTypes) {
        const map = this.inputMaps[inputIndex];
        map.forEach((_v, k, m)=>{
            if (this.isKeyType(k, keyTypes)) m.delete(k);
        });
    }
    copy(to) {
        this.copyMap(this.globalMap, to.globalMap);
        this.copyMaps(this.inputMaps, to.inputMaps);
        this.copyMaps(this.outputMaps, to.outputMaps);
    }
    copyMaps(from, to) {
        from.forEach((m, index)=>{
            const to_index = new Map();
            this.copyMap(m, to_index);
            to[index] = to_index;
        });
    }
    copyMap(from, to) {
        from.forEach((v, k)=>to.set(k, $b9520cdb7ab7b6f5$require$Buffer.from(v)));
    }
    serialize() {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeSlice($b9520cdb7ab7b6f5$require$Buffer.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xff
        ]));
        $b9520cdb7ab7b6f5$var$serializeMap(buf, this.globalMap);
        this.inputMaps.forEach((map)=>{
            $b9520cdb7ab7b6f5$var$serializeMap(buf, map);
        });
        this.outputMaps.forEach((map)=>{
            $b9520cdb7ab7b6f5$var$serializeMap(buf, map);
        });
        return buf.buffer();
    }
    deserialize(psbt) {
        const buf = new $8rRzQ.BufferReader(psbt);
        if (!buf.readSlice(5).equals($b9520cdb7ab7b6f5$var$PSBT_MAGIC_BYTES)) throw new Error("Invalid magic bytes");
        while(this.readKeyPair(this.globalMap, buf));
        let psbtVersion;
        try {
            psbtVersion = this.getGlobalPsbtVersion();
        } catch (_a) {
            psbtVersion = 0;
        }
        if (psbtVersion !== 0 && psbtVersion !== 2) throw new Error("Only PSBTs of version 0 or 2 are supported");
        let nInputs;
        let nOutputs;
        if (psbtVersion == 0) {
            // if PSBTv0, we parse the PSBT_GLOBAL_UNSIGNED_TX field
            const txRaw = this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX);
            const tx = $b9520cdb7ab7b6f5$var$bjs.Transaction.fromBuffer(txRaw);
            nInputs = tx.ins.length;
            nOutputs = tx.outs.length;
        } else {
            // if PSBTv2, we already have the counts
            nInputs = this.getGlobalInputCount();
            nOutputs = this.getGlobalOutputCount();
        }
        for(let i = 0; i < nInputs; i++){
            this.inputMaps[i] = new Map();
            while(this.readKeyPair(this.inputMaps[i], buf));
        }
        for(let i = 0; i < nOutputs; i++){
            this.outputMaps[i] = new Map();
            while(this.readKeyPair(this.outputMaps[i], buf));
        }
        this.normalizeToV2();
    }
    normalizeToV2() {
        var _a;
        // if the psbt is a PsbtV0, convert it to PsbtV2 instead.
        // throw an error for any version other than 0 or 2,
        const psbtVersion = (_a = this.getGlobalOptional($b9520cdb7ab7b6f5$var$psbtGlobal.VERSION)) === null || _a === void 0 ? void 0 : _a.readInt32LE(0);
        if (psbtVersion === 2) return;
        else if (psbtVersion !== undefined) throw new Error("Invalid or unsupported value for PSBT_GLOBAL_VERSION");
        // Convert PsbtV0 to PsbtV2 by parsing the PSBT_GLOBAL_UNSIGNED_TX field
        // and filling in the corresponding fields.
        const txRaw = this.getGlobal($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX);
        const tx = $b9520cdb7ab7b6f5$var$bjs.Transaction.fromBuffer(txRaw);
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(tx.version);
        this.setGlobalFallbackLocktime(tx.locktime);
        this.setGlobalInputCount(tx.ins.length);
        this.setGlobalOutputCount(tx.outs.length);
        for(let i = 0; i < tx.ins.length; i++){
            this.setInputPreviousTxId(i, tx.ins[i].hash);
            this.setInputOutputIndex(i, tx.ins[i].index);
            this.setInputSequence(i, tx.ins[i].sequence);
        }
        for(let i = 0; i < tx.outs.length; i++){
            this.setOutputAmount(i, tx.outs[i].value);
            this.setOutputScript(i, tx.outs[i].script);
        }
        // PSBT_GLOBAL_UNSIGNED_TX must be removed in a valid PSBTv2
        this.globalMap.delete($b9520cdb7ab7b6f5$var$psbtGlobal.UNSIGNED_TX.toString(16).padStart(2, "0"));
    }
    /**
     * Imports a BitcoinJS (bitcoinjs-lib) Psbt object.
     * https://github.com/bitcoinjs/bitcoinjs-lib/blob/master/ts_src/psbt.ts
     *
     * Prepares the fields required for signing a Psbt on a Ledger
     * device. It should be used exclusively before calling
     * `appClient.signPsbt()` and not as a general Psbt conversion method.
     *
     * Note: This method supports all the policies that the Ledger is able to
     * sign, with the exception of taproot: tr(@0).
     */ fromBitcoinJS(psbtBJS) {
        function isTaprootInput(input) {
            let isP2TR;
            try {
                $b9520cdb7ab7b6f5$var$bjs.payments.p2tr({
                    output: input.witnessUtxo.script
                });
                isP2TR = true;
            } catch (err) {
                isP2TR = false;
            }
            return input && !!(input.tapInternalKey || input.tapMerkleRoot || input.tapLeafScript && input.tapLeafScript.length || input.tapBip32Derivation && input.tapBip32Derivation.length || isP2TR);
        }
        this.setGlobalPsbtVersion(2);
        this.setGlobalTxVersion(psbtBJS.version);
        this.setGlobalInputCount(psbtBJS.data.inputs.length);
        this.setGlobalOutputCount(psbtBJS.txOutputs.length);
        if (psbtBJS.locktime !== undefined) this.setGlobalFallbackLocktime(psbtBJS.locktime);
        psbtBJS.data.inputs.forEach((input, index)=>{
            if (isTaprootInput(input)) throw new Error(`Taproot inputs not supported`);
            this.setInputPreviousTxId(index, psbtBJS.txInputs[index].hash);
            if (psbtBJS.txInputs[index].sequence !== undefined) this.setInputSequence(index, psbtBJS.txInputs[index].sequence);
            this.setInputOutputIndex(index, psbtBJS.txInputs[index].index);
            if (input.sighashType !== undefined) this.setInputSighashType(index, input.sighashType);
            if (input.nonWitnessUtxo) this.setInputNonWitnessUtxo(index, input.nonWitnessUtxo);
            if (input.witnessUtxo) this.setInputWitnessUtxo(index, input.witnessUtxo.value, input.witnessUtxo.script);
            if (input.witnessScript) this.setInputWitnessScript(index, input.witnessScript);
            if (input.redeemScript) this.setInputRedeemScript(index, input.redeemScript);
            psbtBJS.data.inputs[index].bip32Derivation.forEach((derivation)=>{
                if (!/^m\//i.test(derivation.path)) throw new Error(`Invalid input bip32 derivation`);
                const pathArray = derivation.path.replace(/m\//i, "").split("/").map((level)=>level.match(/['h]/i) ? parseInt(level) + 0x80000000 : Number(level));
                this.setInputBip32Derivation(index, derivation.pubkey, derivation.masterFingerprint, pathArray);
            });
        });
        psbtBJS.txOutputs.forEach((output, index)=>{
            this.setOutputAmount(index, output.value);
            this.setOutputScript(index, output.script);
        });
        return this;
    }
    readKeyPair(map, buf) {
        const keyLen = (0, $8GOLq.sanitizeBigintToNumber)(buf.readVarInt());
        if (keyLen == 0) return false;
        const keyType = buf.readUInt8();
        const keyData = buf.readSlice(keyLen - 1);
        const value = buf.readVarSlice();
        $b9520cdb7ab7b6f5$var$set(map, keyType, keyData, value);
        return true;
    }
    getKeyDatas(map, keyType) {
        const result = [];
        map.forEach((_v, k)=>{
            if (this.isKeyType(k, [
                keyType
            ])) result.push($b9520cdb7ab7b6f5$require$Buffer.from(k.substring(2), "hex"));
        });
        return result;
    }
    isKeyType(hexKey, keyTypes) {
        const keyType = $b9520cdb7ab7b6f5$require$Buffer.from(hexKey.substring(0, 2), "hex").readUInt8(0);
        return keyTypes.some((k)=>k == keyType);
    }
    setGlobal(keyType, value) {
        const key = new $b9520cdb7ab7b6f5$var$Key(keyType, $b9520cdb7ab7b6f5$require$Buffer.from([]));
        this.globalMap.set(key.toString(), value);
    }
    getGlobal(keyType) {
        return $b9520cdb7ab7b6f5$var$get(this.globalMap, keyType, $b9520cdb7ab7b6f5$var$b(), false);
    }
    getGlobalOptional(keyType) {
        return $b9520cdb7ab7b6f5$var$get(this.globalMap, keyType, $b9520cdb7ab7b6f5$var$b(), true);
    }
    setInput(index, keyType, keyData, value) {
        $b9520cdb7ab7b6f5$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
    }
    getInput(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.inputMaps[index], keyType, keyData, false);
    }
    getInputOptional(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.inputMaps[index], keyType, keyData, true);
    }
    setOutput(index, keyType, keyData, value) {
        $b9520cdb7ab7b6f5$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
    }
    getOutput(index, keyType, keyData) {
        return $b9520cdb7ab7b6f5$var$get(this.outputMaps[index], keyType, keyData, false);
    }
    getMap(index, maps) {
        if (maps[index]) return maps[index];
        return maps[index] = new Map();
    }
    encodeBip32Derivation(masterFingerprint, path) {
        const buf = new $8rRzQ.BufferWriter();
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeBip32Derivation(buffer) {
        const buf = new $8rRzQ.BufferReader(buffer);
        return this.readBip32Derivation(buf);
    }
    writeBip32Derivation(buf, masterFingerprint, path) {
        buf.writeSlice(masterFingerprint);
        path.forEach((element)=>{
            buf.writeUInt32(element);
        });
    }
    readBip32Derivation(buf) {
        const masterFingerprint = buf.readSlice(4);
        const path = [];
        while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
        return {
            masterFingerprint: masterFingerprint,
            path: path
        };
    }
    encodeTapBip32Derivation(hashes, masterFingerprint, path) {
        const buf = new $8rRzQ.BufferWriter();
        buf.writeVarInt(hashes.length);
        hashes.forEach((h)=>{
            buf.writeSlice(h);
        });
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeTapBip32Derivation(buffer) {
        const buf = new $8rRzQ.BufferReader(buffer);
        const hashCount = (0, $8GOLq.sanitizeBigintToNumber)(buf.readVarInt());
        const hashes = [];
        for(let i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
        const deriv = this.readBip32Derivation(buf);
        return Object.assign({
            hashes: hashes
        }, deriv);
    }
}
module.exports.PsbtV2 = $b9520cdb7ab7b6f5$var$PsbtV2;
function $b9520cdb7ab7b6f5$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw Error("No such map");
    const key = new $b9520cdb7ab7b6f5$var$Key(keyType, keyData);
    const value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $b9520cdb7ab7b6f5$var$NoSuchEntry(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $b9520cdb7ab7b6f5$require$Buffer.from(value);
}
class $b9520cdb7ab7b6f5$var$Key {
    constructor(keyType, keyData){
        this.keyType = keyType;
        this.keyData = keyData;
    }
    toString() {
        const buf = new $8rRzQ.BufferWriter();
        this.toBuffer(buf);
        return buf.buffer().toString("hex");
    }
    serialize(buf) {
        buf.writeVarInt(1 + this.keyData.length);
        this.toBuffer(buf);
    }
    toBuffer(buf) {
        buf.writeUInt8(this.keyType);
        buf.writeSlice(this.keyData);
    }
}
class $b9520cdb7ab7b6f5$var$KeyPair {
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    serialize(buf) {
        this.key.serialize(buf);
        buf.writeVarSlice(this.value);
    }
}
function $b9520cdb7ab7b6f5$var$createKey(buf) {
    return new $b9520cdb7ab7b6f5$var$Key(buf.readUInt8(0), buf.slice(1));
}
function $b9520cdb7ab7b6f5$var$serializeMap(buf, map) {
    // serialize in lexicographical order of keys
    for (let [key, value] of [
        ...map
    ].sort(([k1], [k2])=>k1.localeCompare(k2))){
        const keyPair = new $b9520cdb7ab7b6f5$var$KeyPair($b9520cdb7ab7b6f5$var$createKey($b9520cdb7ab7b6f5$require$Buffer.from(key, "hex")), value);
        keyPair.serialize(buf);
    }
    buf.writeUInt8(0);
}
function $b9520cdb7ab7b6f5$var$b() {
    return $b9520cdb7ab7b6f5$require$Buffer.from([]);
}
function $b9520cdb7ab7b6f5$var$set(map, keyType, keyData, value) {
    const key = new $b9520cdb7ab7b6f5$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $b9520cdb7ab7b6f5$var$uint32LE(n) {
    const buf = $b9520cdb7ab7b6f5$require$Buffer.alloc(4);
    buf.writeUInt32LE(n, 0);
    return buf;
}
function $b9520cdb7ab7b6f5$var$uint64LE(n) {
    return (0, $8rRzQ.unsafeTo64bitLE)(n);
}
function $b9520cdb7ab7b6f5$var$varint(n) {
    const buf = new $8rRzQ.BufferWriter();
    buf.writeVarInt(n);
    return buf.buffer();
}
function $b9520cdb7ab7b6f5$var$fromVarint(buf) {
    return (0, $8GOLq.sanitizeBigintToNumber)(new $8rRzQ.BufferReader(buf).readVarInt());
}

});



parcelRegister("1iL1D", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $77ZZs = parcelRequire("77ZZs");

var $26nOC = parcelRequire("26nOC");

var $1U9GM = parcelRequire("1U9GM");
var $0f2bf322914b61b2$require$Buffer = $1U9GM.Buffer;

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
var $0f2bf322914b61b2$var$ZEROS = $0f2bf322914b61b2$require$Buffer.alloc(128);
function $0f2bf322914b61b2$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $0f2bf322914b61b2$require$Buffer.from(key);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    this._alg = alg;
    this._key = key;
    if (key.length > blocksize) {
        var hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
        key = hash.update(key).digest();
    } else if (key.length < blocksize) key = $0f2bf322914b61b2$require$Buffer.concat([
        key,
        $0f2bf322914b61b2$var$ZEROS
    ], blocksize);
    var ipad = this._ipad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    var opad = this._opad = $0f2bf322914b61b2$require$Buffer.allocUnsafe(blocksize);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = alg === "rmd160" ? new $a8qBR() : $5Z1sR(alg);
    this._hash.update(ipad);
}
$dlqwk($0f2bf322914b61b2$var$Hmac, $26nOC);
$0f2bf322914b61b2$var$Hmac.prototype._update = function(data) {
    this._hash.update(data);
};
$0f2bf322914b61b2$var$Hmac.prototype._final = function() {
    var h = this._hash.digest();
    var hash = this._alg === "rmd160" ? new $a8qBR() : $5Z1sR(this._alg);
    return hash.update(this._opad).update(h).digest();
};
module.exports = function createHmac(alg, key) {
    alg = alg.toLowerCase();
    if (alg === "rmd160" || alg === "ripemd160") return new $0f2bf322914b61b2$var$Hmac("rmd160", key);
    if (alg === "md5") return new $77ZZs($8nM4g, key);
    return new $0f2bf322914b61b2$var$Hmac(alg, key);
};

});
parcelRegister("77ZZs", function(module, exports) {
"use strict";

var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $530945d1f5e7b9b5$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");
var $530945d1f5e7b9b5$var$ZEROS = $530945d1f5e7b9b5$require$Buffer.alloc(128);
var $530945d1f5e7b9b5$var$blocksize = 64;
function $530945d1f5e7b9b5$var$Hmac(alg, key) {
    $26nOC.call(this, "digest");
    if (typeof key === "string") key = $530945d1f5e7b9b5$require$Buffer.from(key);
    this._alg = alg;
    this._key = key;
    if (key.length > $530945d1f5e7b9b5$var$blocksize) key = alg(key);
    else if (key.length < $530945d1f5e7b9b5$var$blocksize) key = $530945d1f5e7b9b5$require$Buffer.concat([
        key,
        $530945d1f5e7b9b5$var$ZEROS
    ], $530945d1f5e7b9b5$var$blocksize);
    var ipad = this._ipad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    var opad = this._opad = $530945d1f5e7b9b5$require$Buffer.allocUnsafe($530945d1f5e7b9b5$var$blocksize);
    for(var i = 0; i < $530945d1f5e7b9b5$var$blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    this._hash = [
        ipad
    ];
}
$dlqwk($530945d1f5e7b9b5$var$Hmac, $26nOC);
$530945d1f5e7b9b5$var$Hmac.prototype._update = function(data) {
    this._hash.push(data);
};
$530945d1f5e7b9b5$var$Hmac.prototype._final = function() {
    var h = this._alg($530945d1f5e7b9b5$require$Buffer.concat(this._hash));
    return this._alg($530945d1f5e7b9b5$require$Buffer.concat([
        this._opad,
        h
    ]));
};
module.exports = $530945d1f5e7b9b5$var$Hmac;

});

parcelRegister("8nM4g", function(module, exports) {

var $loYLU = parcelRequire("loYLU");
module.exports = function(buffer) {
    return new $loYLU().update(buffer).digest();
};

});


parcelRegister("6noBd", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("fuV4H", function(module, exports) {
module.exports = JSON.parse('{"name":"elliptic","version":"6.6.1","description":"EC cryptography","main":"lib/elliptic.js","files":["lib"],"scripts":{"lint":"eslint lib test","lint:fix":"npm run lint -- --fix","unit":"istanbul test _mocha --reporter=spec test/index.js","test":"npm run lint && npm run unit","version":"grunt dist && git add dist/"},"repository":{"type":"git","url":"git@github.com:indutny/elliptic"},"keywords":["EC","Elliptic","curve","Cryptography"],"author":"Fedor Indutny <fedor@indutny.com>","license":"MIT","bugs":{"url":"https://github.com/indutny/elliptic/issues"},"homepage":"https://github.com/indutny/elliptic","devDependencies":{"brfs":"^2.0.2","coveralls":"^3.1.0","eslint":"^7.6.0","grunt":"^1.2.1","grunt-browserify":"^5.3.0","grunt-cli":"^1.3.2","grunt-contrib-connect":"^3.0.0","grunt-contrib-copy":"^1.0.0","grunt-contrib-uglify":"^5.0.0","grunt-mocha-istanbul":"^5.0.2","grunt-saucelabs":"^9.0.1","istanbul":"^0.4.5","mocha":"^8.0.1"},"dependencies":{"bn.js":"^4.11.9","brorand":"^1.1.0","hash.js":"^1.0.0","hmac-drbg":"^1.0.1","inherits":"^2.0.4","minimalistic-assert":"^1.0.1","minimalistic-crypto-utils":"^1.0.1"}}');

});

parcelRegister("gEVtY", function(module, exports) {
"use strict";
var $c20cf89948514165$var$utils = module.exports;

var $jX0xT = parcelRequire("jX0xT");

var $koC21 = parcelRequire("koC21");

var $lC4vN = parcelRequire("lC4vN");
$c20cf89948514165$var$utils.assert = $koC21;
$c20cf89948514165$var$utils.toArray = $lC4vN.toArray;
$c20cf89948514165$var$utils.zero2 = $lC4vN.zero2;
$c20cf89948514165$var$utils.toHex = $lC4vN.toHex;
$c20cf89948514165$var$utils.encode = $lC4vN.encode;
// Represent num in a w-NAF form
function $c20cf89948514165$var$getNAF(num, w, bits) {
    var naf = new Array(Math.max(num.bitLength(), bits) + 1);
    var i;
    for(i = 0; i < naf.length; i += 1)naf[i] = 0;
    var ws = 1 << w + 1;
    var k = num.clone();
    for(i = 0; i < naf.length; i++){
        var z;
        var mod = k.andln(ws - 1);
        if (k.isOdd()) {
            if (mod > (ws >> 1) - 1) z = (ws >> 1) - mod;
            else z = mod;
            k.isubn(z);
        } else z = 0;
        naf[i] = z;
        k.iushrn(1);
    }
    return naf;
}
$c20cf89948514165$var$utils.getNAF = $c20cf89948514165$var$getNAF;
// Represent k1, k2 in a Joint Sparse Form
function $c20cf89948514165$var$getJSF(k1, k2) {
    var jsf = [
        [],
        []
    ];
    k1 = k1.clone();
    k2 = k2.clone();
    var d1 = 0;
    var d2 = 0;
    var m8;
    while(k1.cmpn(-d1) > 0 || k2.cmpn(-d2) > 0){
        // First phase
        var m14 = k1.andln(3) + d1 & 3;
        var m24 = k2.andln(3) + d2 & 3;
        if (m14 === 3) m14 = -1;
        if (m24 === 3) m24 = -1;
        var u1;
        if ((m14 & 1) === 0) u1 = 0;
        else {
            m8 = k1.andln(7) + d1 & 7;
            if ((m8 === 3 || m8 === 5) && m24 === 2) u1 = -m14;
            else u1 = m14;
        }
        jsf[0].push(u1);
        var u2;
        if ((m24 & 1) === 0) u2 = 0;
        else {
            m8 = k2.andln(7) + d2 & 7;
            if ((m8 === 3 || m8 === 5) && m14 === 2) u2 = -m24;
            else u2 = m24;
        }
        jsf[1].push(u2);
        // Second phase
        if (2 * d1 === u1 + 1) d1 = 1 - d1;
        if (2 * d2 === u2 + 1) d2 = 1 - d2;
        k1.iushrn(1);
        k2.iushrn(1);
    }
    return jsf;
}
$c20cf89948514165$var$utils.getJSF = $c20cf89948514165$var$getJSF;
function $c20cf89948514165$var$cachedProperty(obj, name, computer) {
    var key = "_" + name;
    obj.prototype[name] = function cachedProperty() {
        return this[key] !== undefined ? this[key] : this[key] = computer.call(this);
    };
}
$c20cf89948514165$var$utils.cachedProperty = $c20cf89948514165$var$cachedProperty;
function $c20cf89948514165$var$parseBytes(bytes) {
    return typeof bytes === "string" ? $c20cf89948514165$var$utils.toArray(bytes, "hex") : bytes;
}
$c20cf89948514165$var$utils.parseBytes = $c20cf89948514165$var$parseBytes;
function $c20cf89948514165$var$intFromLE(bytes) {
    return new $jX0xT(bytes, "hex", "le");
}
$c20cf89948514165$var$utils.intFromLE = $c20cf89948514165$var$intFromLE;

});
parcelRegister("jX0xT", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("koC21", function(module, exports) {
module.exports = $ed938ccf59a32f03$var$assert;
function $ed938ccf59a32f03$var$assert(val, msg) {
    if (!val) throw new Error(msg || "Assertion failed");
}
$ed938ccf59a32f03$var$assert.equal = function assertEqual(l, r, msg) {
    if (l != r) throw new Error(msg || "Assertion failed: " + l + " != " + r);
};

});

parcelRegister("lC4vN", function(module, exports) {
"use strict";
var $fbc0a58a3f4350d8$var$utils = module.exports;
function $fbc0a58a3f4350d8$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg !== "string") {
        for(var i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
        return res;
    }
    if (enc === "hex") {
        msg = msg.replace(/[^a-z0-9]+/ig, "");
        if (msg.length % 2 !== 0) msg = "0" + msg;
        for(var i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
    } else for(var i = 0; i < msg.length; i++){
        var c = msg.charCodeAt(i);
        var hi = c >> 8;
        var lo = c & 0xff;
        if (hi) res.push(hi, lo);
        else res.push(lo);
    }
    return res;
}
$fbc0a58a3f4350d8$var$utils.toArray = $fbc0a58a3f4350d8$var$toArray;
function $fbc0a58a3f4350d8$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$fbc0a58a3f4350d8$var$utils.zero2 = $fbc0a58a3f4350d8$var$zero2;
function $fbc0a58a3f4350d8$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $fbc0a58a3f4350d8$var$zero2(msg[i].toString(16));
    return res;
}
$fbc0a58a3f4350d8$var$utils.toHex = $fbc0a58a3f4350d8$var$toHex;
$fbc0a58a3f4350d8$var$utils.encode = function encode(arr, enc) {
    if (enc === "hex") return $fbc0a58a3f4350d8$var$toHex(arr);
    else return arr;
};

});


parcelRegister("7JHF0", function(module, exports) {
var $5a1e9a6ed4e8de8a$var$r;
module.exports = function rand(len) {
    if (!$5a1e9a6ed4e8de8a$var$r) $5a1e9a6ed4e8de8a$var$r = new $5a1e9a6ed4e8de8a$var$Rand(null);
    return $5a1e9a6ed4e8de8a$var$r.generate(len);
};
function $5a1e9a6ed4e8de8a$var$Rand(rand) {
    this.rand = rand;
}
module.exports.Rand = $5a1e9a6ed4e8de8a$var$Rand;
$5a1e9a6ed4e8de8a$var$Rand.prototype.generate = function generate(len) {
    return this._rand(len);
};
// Emulate crypto API using randy
$5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
    if (this.rand.getBytes) return this.rand.getBytes(n);
    var res = new Uint8Array(n);
    for(var i = 0; i < res.length; i++)res[i] = this.rand.getByte();
    return res;
};

if (typeof self === "object") {
    if (self.crypto && self.crypto.getRandomValues) // Modern browsers
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.crypto.getRandomValues(arr);
        return arr;
    };
    else if (self.msCrypto && self.msCrypto.getRandomValues) // IE
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        var arr = new Uint8Array(n);
        self.msCrypto.getRandomValues(arr);
        return arr;
    };
    else if (typeof window === "object") // Old junk
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function() {
        throw new Error("Not implemented yet");
    };
} else // Node.js or Web worker with no crypto support
try {
    var $5a1e9a6ed4e8de8a$var$crypto = (parcelRequire("kjyEk"));
    if (typeof $5a1e9a6ed4e8de8a$var$crypto.randomBytes !== "function") throw new Error("Not supported");
    $5a1e9a6ed4e8de8a$var$Rand.prototype._rand = function _rand(n) {
        return $5a1e9a6ed4e8de8a$var$crypto.randomBytes(n);
    };
} catch (e) {}

});

parcelRegister("cP1GP", function(module, exports) {
"use strict";
var $955b8f041d2341cf$var$curve = module.exports;

$955b8f041d2341cf$var$curve.base = (parcelRequire("hSu7V"));

$955b8f041d2341cf$var$curve.short = (parcelRequire("eYNyQ"));

$955b8f041d2341cf$var$curve.mont = (parcelRequire("av2Yx"));

$955b8f041d2341cf$var$curve.edwards = (parcelRequire("dqmX9"));

});
parcelRegister("hSu7V", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d03ed95a59c9b218$var$getNAF = $gEVtY.getNAF;
var $d03ed95a59c9b218$var$getJSF = $gEVtY.getJSF;
var $d03ed95a59c9b218$var$assert = $gEVtY.assert;
function $d03ed95a59c9b218$var$BaseCurve(type, conf) {
    this.type = type;
    this.p = new $jX0xT(conf.p, 16);
    // Use Montgomery, when there is no fast reduction for the prime
    this.red = conf.prime ? $jX0xT.red(conf.prime) : $jX0xT.mont(this.p);
    // Useful for many curves
    this.zero = new $jX0xT(0).toRed(this.red);
    this.one = new $jX0xT(1).toRed(this.red);
    this.two = new $jX0xT(2).toRed(this.red);
    // Curve configuration, optional
    this.n = conf.n && new $jX0xT(conf.n, 16);
    this.g = conf.g && this.pointFromJSON(conf.g, conf.gRed);
    // Temporary arrays
    this._wnafT1 = new Array(4);
    this._wnafT2 = new Array(4);
    this._wnafT3 = new Array(4);
    this._wnafT4 = new Array(4);
    this._bitLength = this.n ? this.n.bitLength() : 0;
    // Generalized Greg Maxwell's trick
    var adjustCount = this.n && this.p.div(this.n);
    if (!adjustCount || adjustCount.cmpn(100) > 0) this.redN = null;
    else {
        this._maxwellTrick = true;
        this.redN = this.n.toRed(this.red);
    }
}
module.exports = $d03ed95a59c9b218$var$BaseCurve;
$d03ed95a59c9b218$var$BaseCurve.prototype.point = function point() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype.validate = function validate() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BaseCurve.prototype._fixedNafMul = function _fixedNafMul(p, k) {
    $d03ed95a59c9b218$var$assert(p.precomputed);
    var doubles = p._getDoubles();
    var naf = $d03ed95a59c9b218$var$getNAF(k, 1, this._bitLength);
    var I = (1 << doubles.step + 1) - (doubles.step % 2 === 0 ? 2 : 1);
    I /= 3;
    // Translate into more windowed form
    var repr = [];
    var j;
    var nafW;
    for(j = 0; j < naf.length; j += doubles.step){
        nafW = 0;
        for(var l = j + doubles.step - 1; l >= j; l--)nafW = (nafW << 1) + naf[l];
        repr.push(nafW);
    }
    var a = this.jpoint(null, null, null);
    var b = this.jpoint(null, null, null);
    for(var i = I; i > 0; i--){
        for(j = 0; j < repr.length; j++){
            nafW = repr[j];
            if (nafW === i) b = b.mixedAdd(doubles.points[j]);
            else if (nafW === -i) b = b.mixedAdd(doubles.points[j].neg());
        }
        a = a.add(b);
    }
    return a.toP();
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMul = function _wnafMul(p, k) {
    var w = 4;
    // Precompute window
    var nafPoints = p._getNAFPoints(w);
    w = nafPoints.wnd;
    var wnd = nafPoints.points;
    // Get NAF form
    var naf = $d03ed95a59c9b218$var$getNAF(k, w, this._bitLength);
    // Add `this`*(N+1) for every w-NAF index
    var acc = this.jpoint(null, null, null);
    for(var i = naf.length - 1; i >= 0; i--){
        // Count zeroes
        for(var l = 0; i >= 0 && naf[i] === 0; i--)l++;
        if (i >= 0) l++;
        acc = acc.dblp(l);
        if (i < 0) break;
        var z = naf[i];
        $d03ed95a59c9b218$var$assert(z !== 0);
        if (p.type === "affine") {
            // J +- P
            if (z > 0) acc = acc.mixedAdd(wnd[z - 1 >> 1]);
            else acc = acc.mixedAdd(wnd[-z - 1 >> 1].neg());
        } else // J +- J
        if (z > 0) acc = acc.add(wnd[z - 1 >> 1]);
        else acc = acc.add(wnd[-z - 1 >> 1].neg());
    }
    return p.type === "affine" ? acc.toP() : acc;
};
$d03ed95a59c9b218$var$BaseCurve.prototype._wnafMulAdd = function _wnafMulAdd(defW, points, coeffs, len, jacobianResult) {
    var wndWidth = this._wnafT1;
    var wnd = this._wnafT2;
    var naf = this._wnafT3;
    // Fill all arrays
    var max = 0;
    var i;
    var j;
    var p;
    for(i = 0; i < len; i++){
        p = points[i];
        var nafPoints = p._getNAFPoints(defW);
        wndWidth[i] = nafPoints.wnd;
        wnd[i] = nafPoints.points;
    }
    // Comb small window NAFs
    for(i = len - 1; i >= 1; i -= 2){
        var a = i - 1;
        var b = i;
        if (wndWidth[a] !== 1 || wndWidth[b] !== 1) {
            naf[a] = $d03ed95a59c9b218$var$getNAF(coeffs[a], wndWidth[a], this._bitLength);
            naf[b] = $d03ed95a59c9b218$var$getNAF(coeffs[b], wndWidth[b], this._bitLength);
            max = Math.max(naf[a].length, max);
            max = Math.max(naf[b].length, max);
            continue;
        }
        var comb = [
            points[a],
            /* 1 */ null,
            /* 3 */ null,
            /* 5 */ points[b]
        ];
        // Try to avoid Projective points, if possible
        if (points[a].y.cmp(points[b].y) === 0) {
            comb[1] = points[a].add(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        } else if (points[a].y.cmp(points[b].y.redNeg()) === 0) {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].add(points[b].neg());
        } else {
            comb[1] = points[a].toJ().mixedAdd(points[b]);
            comb[2] = points[a].toJ().mixedAdd(points[b].neg());
        }
        var index = [
            -3,
            /* -1 -1 */ -1,
            /* -1 0 */ -5,
            /* -1 1 */ -7,
            /* 0 -1 */ 0,
            /* 0 0 */ 7,
            /* 0 1 */ 5,
            /* 1 -1 */ 1,
            /* 1 0 */ 3
        ];
        var jsf = $d03ed95a59c9b218$var$getJSF(coeffs[a], coeffs[b]);
        max = Math.max(jsf[0].length, max);
        naf[a] = new Array(max);
        naf[b] = new Array(max);
        for(j = 0; j < max; j++){
            var ja = jsf[0][j] | 0;
            var jb = jsf[1][j] | 0;
            naf[a][j] = index[(ja + 1) * 3 + (jb + 1)];
            naf[b][j] = 0;
            wnd[a] = comb;
        }
    }
    var acc = this.jpoint(null, null, null);
    var tmp = this._wnafT4;
    for(i = max; i >= 0; i--){
        var k = 0;
        while(i >= 0){
            var zero = true;
            for(j = 0; j < len; j++){
                tmp[j] = naf[j][i] | 0;
                if (tmp[j] !== 0) zero = false;
            }
            if (!zero) break;
            k++;
            i--;
        }
        if (i >= 0) k++;
        acc = acc.dblp(k);
        if (i < 0) break;
        for(j = 0; j < len; j++){
            var z = tmp[j];
            p;
            if (z === 0) continue;
            else if (z > 0) p = wnd[j][z - 1 >> 1];
            else if (z < 0) p = wnd[j][-z - 1 >> 1].neg();
            if (p.type === "affine") acc = acc.mixedAdd(p);
            else acc = acc.add(p);
        }
    }
    // Zeroify references
    for(i = 0; i < len; i++)wnd[i] = null;
    if (jacobianResult) return acc;
    else return acc.toP();
};
function $d03ed95a59c9b218$var$BasePoint(curve, type) {
    this.curve = curve;
    this.type = type;
    this.precomputed = null;
}
$d03ed95a59c9b218$var$BaseCurve.BasePoint = $d03ed95a59c9b218$var$BasePoint;
$d03ed95a59c9b218$var$BasePoint.prototype.eq = function eq() {
    throw new Error("Not implemented");
};
$d03ed95a59c9b218$var$BasePoint.prototype.validate = function validate() {
    return this.curve.validate(this);
};
$d03ed95a59c9b218$var$BaseCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    bytes = $gEVtY.toArray(bytes, enc);
    var len = this.p.byteLength();
    // uncompressed, hybrid-odd, hybrid-even
    if ((bytes[0] === 0x04 || bytes[0] === 0x06 || bytes[0] === 0x07) && bytes.length - 1 === 2 * len) {
        if (bytes[0] === 0x06) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 0);
        else if (bytes[0] === 0x07) $d03ed95a59c9b218$var$assert(bytes[bytes.length - 1] % 2 === 1);
        var res = this.point(bytes.slice(1, 1 + len), bytes.slice(1 + len, 1 + 2 * len));
        return res;
    } else if ((bytes[0] === 0x02 || bytes[0] === 0x03) && bytes.length - 1 === len) return this.pointFromX(bytes.slice(1, 1 + len), bytes[0] === 0x03);
    throw new Error("Unknown point format");
};
$d03ed95a59c9b218$var$BasePoint.prototype.encodeCompressed = function encodeCompressed(enc) {
    return this.encode(enc, true);
};
$d03ed95a59c9b218$var$BasePoint.prototype._encode = function _encode(compact) {
    var len = this.curve.p.byteLength();
    var x = this.getX().toArray("be", len);
    if (compact) return [
        this.getY().isEven() ? 0x02 : 0x03
    ].concat(x);
    return [
        0x04
    ].concat(x, this.getY().toArray("be", len));
};
$d03ed95a59c9b218$var$BasePoint.prototype.encode = function encode(enc, compact) {
    return $gEVtY.encode(this._encode(compact), enc);
};
$d03ed95a59c9b218$var$BasePoint.prototype.precompute = function precompute(power) {
    if (this.precomputed) return this;
    var precomputed = {
        doubles: null,
        naf: null,
        beta: null
    };
    precomputed.naf = this._getNAFPoints(8);
    precomputed.doubles = this._getDoubles(4, power);
    precomputed.beta = this._getBeta();
    this.precomputed = precomputed;
    return this;
};
$d03ed95a59c9b218$var$BasePoint.prototype._hasDoubles = function _hasDoubles(k) {
    if (!this.precomputed) return false;
    var doubles = this.precomputed.doubles;
    if (!doubles) return false;
    return doubles.points.length >= Math.ceil((k.bitLength() + 1) / doubles.step);
};
$d03ed95a59c9b218$var$BasePoint.prototype._getDoubles = function _getDoubles(step, power) {
    if (this.precomputed && this.precomputed.doubles) return this.precomputed.doubles;
    var doubles = [
        this
    ];
    var acc = this;
    for(var i = 0; i < power; i += step){
        for(var j = 0; j < step; j++)acc = acc.dbl();
        doubles.push(acc);
    }
    return {
        step: step,
        points: doubles
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getNAFPoints = function _getNAFPoints(wnd) {
    if (this.precomputed && this.precomputed.naf) return this.precomputed.naf;
    var res = [
        this
    ];
    var max = (1 << wnd) - 1;
    var dbl = max === 1 ? null : this.dbl();
    for(var i = 1; i < max; i++)res[i] = res[i - 1].add(dbl);
    return {
        wnd: wnd,
        points: res
    };
};
$d03ed95a59c9b218$var$BasePoint.prototype._getBeta = function _getBeta() {
    return null;
};
$d03ed95a59c9b218$var$BasePoint.prototype.dblp = function dblp(k) {
    var r = this;
    for(var i = 0; i < k; i++)r = r.dbl();
    return r;
};

});

parcelRegister("eYNyQ", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $ae7d1d0c45b43ec6$var$assert = $gEVtY.assert;
function $ae7d1d0c45b43ec6$var$ShortCurve(conf) {
    $hSu7V.call(this, "short", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.tinv = this.two.redInvm();
    this.zeroA = this.a.fromRed().cmpn(0) === 0;
    this.threeA = this.a.fromRed().sub(this.p).cmpn(-3) === 0;
    // If the curve is endomorphic, precalculate beta and lambda
    this.endo = this._getEndomorphism(conf);
    this._endoWnafT1 = new Array(4);
    this._endoWnafT2 = new Array(4);
}
$dlqwk($ae7d1d0c45b43ec6$var$ShortCurve, $hSu7V);
module.exports = $ae7d1d0c45b43ec6$var$ShortCurve;
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndomorphism = function _getEndomorphism(conf) {
    // No efficient endomorphism
    if (!this.zeroA || !this.g || !this.n || this.p.modn(3) !== 1) return;
    // Compute beta and lambda, that lambda * P = (beta * Px; Py)
    var beta;
    var lambda;
    if (conf.beta) beta = new $jX0xT(conf.beta, 16).toRed(this.red);
    else {
        var betas = this._getEndoRoots(this.p);
        // Choose the smallest beta
        beta = betas[0].cmp(betas[1]) < 0 ? betas[0] : betas[1];
        beta = beta.toRed(this.red);
    }
    if (conf.lambda) lambda = new $jX0xT(conf.lambda, 16);
    else {
        // Choose the lambda that is matching selected beta
        var lambdas = this._getEndoRoots(this.n);
        if (this.g.mul(lambdas[0]).x.cmp(this.g.x.redMul(beta)) === 0) lambda = lambdas[0];
        else {
            lambda = lambdas[1];
            $ae7d1d0c45b43ec6$var$assert(this.g.mul(lambda).x.cmp(this.g.x.redMul(beta)) === 0);
        }
    }
    // Get basis vectors, used for balanced length-two representation
    var basis;
    if (conf.basis) basis = conf.basis.map(function(vec) {
        return {
            a: new $jX0xT(vec.a, 16),
            b: new $jX0xT(vec.b, 16)
        };
    });
    else basis = this._getEndoBasis(lambda);
    return {
        beta: beta,
        lambda: lambda,
        basis: basis
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoRoots = function _getEndoRoots(num) {
    // Find roots of for x^2 + x + 1 in F
    // Root = (-1 +- Sqrt(-3)) / 2
    //
    var red = num === this.p ? this.red : $jX0xT.mont(num);
    var tinv = new $jX0xT(2).toRed(red).redInvm();
    var ntinv = tinv.redNeg();
    var s = new $jX0xT(3).toRed(red).redNeg().redSqrt().redMul(tinv);
    var l1 = ntinv.redAdd(s).fromRed();
    var l2 = ntinv.redSub(s).fromRed();
    return [
        l1,
        l2
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._getEndoBasis = function _getEndoBasis(lambda) {
    // aprxSqrt >= sqrt(this.n)
    var aprxSqrt = this.n.ushrn(Math.floor(this.n.bitLength() / 2));
    // 3.74
    // Run EGCD, until r(L + 1) < aprxSqrt
    var u = lambda;
    var v = this.n.clone();
    var x1 = new $jX0xT(1);
    var y1 = new $jX0xT(0);
    var x2 = new $jX0xT(0);
    var y2 = new $jX0xT(1);
    // NOTE: all vectors are roots of: a + b * lambda = 0 (mod n)
    var a0;
    var b0;
    // First vector
    var a1;
    var b1;
    // Second vector
    var a2;
    var b2;
    var prevR;
    var i = 0;
    var r;
    var x;
    while(u.cmpn(0) !== 0){
        var q = v.div(u);
        r = v.sub(q.mul(u));
        x = x2.sub(q.mul(x1));
        var y = y2.sub(q.mul(y1));
        if (!a1 && r.cmp(aprxSqrt) < 0) {
            a0 = prevR.neg();
            b0 = x1;
            a1 = r.neg();
            b1 = x;
        } else if (a1 && ++i === 2) break;
        prevR = r;
        v = u;
        u = r;
        x2 = x1;
        x1 = x;
        y2 = y1;
        y1 = y;
    }
    a2 = r.neg();
    b2 = x;
    var len1 = a1.sqr().add(b1.sqr());
    var len2 = a2.sqr().add(b2.sqr());
    if (len2.cmp(len1) >= 0) {
        a2 = a0;
        b2 = b0;
    }
    // Normalize signs
    if (a1.negative) {
        a1 = a1.neg();
        b1 = b1.neg();
    }
    if (a2.negative) {
        a2 = a2.neg();
        b2 = b2.neg();
    }
    return [
        {
            a: a1,
            b: b1
        },
        {
            a: a2,
            b: b2
        }
    ];
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoSplit = function _endoSplit(k) {
    var basis = this.endo.basis;
    var v1 = basis[0];
    var v2 = basis[1];
    var c1 = v2.b.mul(k).divRound(this.n);
    var c2 = v1.b.neg().mul(k).divRound(this.n);
    var p1 = c1.mul(v1.a);
    var p2 = c2.mul(v2.a);
    var q1 = c1.mul(v1.b);
    var q2 = c2.mul(v2.b);
    // Calculate answer
    var k1 = k.sub(p1).sub(p2);
    var k2 = q1.add(q2).neg();
    return {
        k1: k1,
        k2: k2
    };
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var y2 = x.redSqr().redMul(x).redIAdd(x.redMul(this.a)).redIAdd(this.b);
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    // XXX Is there any way to tell if the number is odd without converting it
    // to non-red form?
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.validate = function validate(point) {
    if (point.inf) return true;
    var x = point.x;
    var y = point.y;
    var ax = this.a.redMul(x);
    var rhs = x.redSqr().redMul(x).redIAdd(ax).redIAdd(this.b);
    return y.redSqr().redISub(rhs).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype._endoWnafMulAdd = function _endoWnafMulAdd(points, coeffs, jacobianResult) {
    var npoints = this._endoWnafT1;
    var ncoeffs = this._endoWnafT2;
    for(var i = 0; i < points.length; i++){
        var split = this._endoSplit(coeffs[i]);
        var p = points[i];
        var beta = p._getBeta();
        if (split.k1.negative) {
            split.k1.ineg();
            p = p.neg(true);
        }
        if (split.k2.negative) {
            split.k2.ineg();
            beta = beta.neg(true);
        }
        npoints[i * 2] = p;
        npoints[i * 2 + 1] = beta;
        ncoeffs[i * 2] = split.k1;
        ncoeffs[i * 2 + 1] = split.k2;
    }
    var res = this._wnafMulAdd(1, npoints, ncoeffs, i * 2, jacobianResult);
    // Clean-up references to points and coefficients
    for(var j = 0; j < i * 2; j++){
        npoints[j] = null;
        ncoeffs[j] = null;
    }
    return res;
};
function $ae7d1d0c45b43ec6$var$Point(curve, x, y, isRed) {
    $hSu7V.BasePoint.call(this, curve, "affine");
    if (x === null && y === null) {
        this.x = null;
        this.y = null;
        this.inf = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        // Force redgomery representation when loading from JSON
        if (isRed) {
            this.x.forceRed(this.curve.red);
            this.y.forceRed(this.curve.red);
        }
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        this.inf = false;
    }
}
$dlqwk($ae7d1d0c45b43ec6$var$Point, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.point = function point(x, y, isRed) {
    return new $ae7d1d0c45b43ec6$var$Point(this, x, y, isRed);
};
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.pointFromJSON = function pointFromJSON(obj, red) {
    return $ae7d1d0c45b43ec6$var$Point.fromJSON(this, obj, red);
};
$ae7d1d0c45b43ec6$var$Point.prototype._getBeta = function _getBeta() {
    if (!this.curve.endo) return;
    var pre = this.precomputed;
    if (pre && pre.beta) return pre.beta;
    var beta = this.curve.point(this.x.redMul(this.curve.endo.beta), this.y);
    if (pre) {
        var curve = this.curve;
        var endoMul = function(p) {
            return curve.point(p.x.redMul(curve.endo.beta), p.y);
        };
        pre.beta = beta;
        beta.precomputed = {
            beta: null,
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(endoMul)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(endoMul)
            }
        };
    }
    return beta;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJSON = function toJSON() {
    if (!this.precomputed) return [
        this.x,
        this.y
    ];
    return [
        this.x,
        this.y,
        this.precomputed && {
            doubles: this.precomputed.doubles && {
                step: this.precomputed.doubles.step,
                points: this.precomputed.doubles.points.slice(1)
            },
            naf: this.precomputed.naf && {
                wnd: this.precomputed.naf.wnd,
                points: this.precomputed.naf.points.slice(1)
            }
        }
    ];
};
$ae7d1d0c45b43ec6$var$Point.fromJSON = function fromJSON(curve, obj, red) {
    if (typeof obj === "string") obj = JSON.parse(obj);
    var res = curve.point(obj[0], obj[1], red);
    if (!obj[2]) return res;
    function obj2point(obj) {
        return curve.point(obj[0], obj[1], red);
    }
    var pre = obj[2];
    res.precomputed = {
        beta: null,
        doubles: pre.doubles && {
            step: pre.doubles.step,
            points: [
                res
            ].concat(pre.doubles.points.map(obj2point))
        },
        naf: pre.naf && {
            wnd: pre.naf.wnd,
            points: [
                res
            ].concat(pre.naf.points.map(obj2point))
        }
    };
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$Point.prototype.isInfinity = function isInfinity() {
    return this.inf;
};
$ae7d1d0c45b43ec6$var$Point.prototype.add = function add(p) {
    // O + P = P
    if (this.inf) return p;
    // P + O = P
    if (p.inf) return this;
    // P + P = 2P
    if (this.eq(p)) return this.dbl();
    // P + (-P) = O
    if (this.neg().eq(p)) return this.curve.point(null, null);
    // P + Q = O
    if (this.x.cmp(p.x) === 0) return this.curve.point(null, null);
    var c = this.y.redSub(p.y);
    if (c.cmpn(0) !== 0) c = c.redMul(this.x.redSub(p.x).redInvm());
    var nx = c.redSqr().redISub(this.x).redISub(p.x);
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.dbl = function dbl() {
    if (this.inf) return this;
    // 2P = O
    var ys1 = this.y.redAdd(this.y);
    if (ys1.cmpn(0) === 0) return this.curve.point(null, null);
    var a = this.curve.a;
    var x2 = this.x.redSqr();
    var dyinv = ys1.redInvm();
    var c = x2.redAdd(x2).redIAdd(x2).redIAdd(a).redMul(dyinv);
    var nx = c.redSqr().redISub(this.x.redAdd(this.x));
    var ny = c.redMul(this.x.redSub(nx)).redISub(this.y);
    return this.curve.point(nx, ny);
};
$ae7d1d0c45b43ec6$var$Point.prototype.getX = function getX() {
    return this.x.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.getY = function getY() {
    return this.y.fromRed();
};
$ae7d1d0c45b43ec6$var$Point.prototype.mul = function mul(k) {
    k = new $jX0xT(k, 16);
    if (this.isInfinity()) return this;
    else if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else if (this.curve.endo) return this.curve._endoWnafMulAdd([
        this
    ], [
        k
    ]);
    else return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$Point.prototype.mulAdd = function mulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2);
};
$ae7d1d0c45b43ec6$var$Point.prototype.jmulAdd = function jmulAdd(k1, p2, k2) {
    var points = [
        this,
        p2
    ];
    var coeffs = [
        k1,
        k2
    ];
    if (this.curve.endo) return this.curve._endoWnafMulAdd(points, coeffs, true);
    else return this.curve._wnafMulAdd(1, points, coeffs, 2, true);
};
$ae7d1d0c45b43ec6$var$Point.prototype.eq = function eq(p) {
    return this === p || this.inf === p.inf && (this.inf || this.x.cmp(p.x) === 0 && this.y.cmp(p.y) === 0);
};
$ae7d1d0c45b43ec6$var$Point.prototype.neg = function neg(_precompute) {
    if (this.inf) return this;
    var res = this.curve.point(this.x, this.y.redNeg());
    if (_precompute && this.precomputed) {
        var pre = this.precomputed;
        var negate = function(p) {
            return p.neg();
        };
        res.precomputed = {
            naf: pre.naf && {
                wnd: pre.naf.wnd,
                points: pre.naf.points.map(negate)
            },
            doubles: pre.doubles && {
                step: pre.doubles.step,
                points: pre.doubles.points.map(negate)
            }
        };
    }
    return res;
};
$ae7d1d0c45b43ec6$var$Point.prototype.toJ = function toJ() {
    if (this.inf) return this.curve.jpoint(null, null, null);
    var res = this.curve.jpoint(this.x, this.y, this.curve.one);
    return res;
};
function $ae7d1d0c45b43ec6$var$JPoint(curve, x, y, z) {
    $hSu7V.BasePoint.call(this, curve, "jacobian");
    if (x === null && y === null && z === null) {
        this.x = this.curve.one;
        this.y = this.curve.one;
        this.z = new $jX0xT(0);
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = new $jX0xT(z, 16);
    }
    if (!this.x.red) this.x = this.x.toRed(this.curve.red);
    if (!this.y.red) this.y = this.y.toRed(this.curve.red);
    if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    this.zOne = this.z === this.curve.one;
}
$dlqwk($ae7d1d0c45b43ec6$var$JPoint, $hSu7V.BasePoint);
$ae7d1d0c45b43ec6$var$ShortCurve.prototype.jpoint = function jpoint(x, y, z) {
    return new $ae7d1d0c45b43ec6$var$JPoint(this, x, y, z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.toP = function toP() {
    if (this.isInfinity()) return this.curve.point(null, null);
    var zinv = this.z.redInvm();
    var zinv2 = zinv.redSqr();
    var ax = this.x.redMul(zinv2);
    var ay = this.y.redMul(zinv2).redMul(zinv);
    return this.curve.point(ax, ay);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.neg = function neg() {
    return this.curve.jpoint(this.x, this.y.redNeg(), this.z);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.add = function add(p) {
    // O + P = P
    if (this.isInfinity()) return p;
    // P + O = P
    if (p.isInfinity()) return this;
    // 12M + 4S + 7A
    var pz2 = p.z.redSqr();
    var z2 = this.z.redSqr();
    var u1 = this.x.redMul(pz2);
    var u2 = p.x.redMul(z2);
    var s1 = this.y.redMul(pz2.redMul(p.z));
    var s2 = p.y.redMul(z2.redMul(this.z));
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(p.z).redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mixedAdd = function mixedAdd(p) {
    // O + P = P
    if (this.isInfinity()) return p.toJ();
    // P + O = P
    if (p.isInfinity()) return this;
    // 8M + 3S + 7A
    var z2 = this.z.redSqr();
    var u1 = this.x;
    var u2 = p.x.redMul(z2);
    var s1 = this.y;
    var s2 = p.y.redMul(z2).redMul(this.z);
    var h = u1.redSub(u2);
    var r = s1.redSub(s2);
    if (h.cmpn(0) === 0) {
        if (r.cmpn(0) !== 0) return this.curve.jpoint(null, null, null);
        else return this.dbl();
    }
    var h2 = h.redSqr();
    var h3 = h2.redMul(h);
    var v = u1.redMul(h2);
    var nx = r.redSqr().redIAdd(h3).redISub(v).redISub(v);
    var ny = r.redMul(v.redISub(nx)).redISub(s1.redMul(h3));
    var nz = this.z.redMul(h);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dblp = function dblp(pow) {
    if (pow === 0) return this;
    if (this.isInfinity()) return this;
    if (!pow) return this.dbl();
    var i;
    if (this.curve.zeroA || this.curve.threeA) {
        var r = this;
        for(i = 0; i < pow; i++)r = r.dbl();
        return r;
    }
    // 1M + 2S + 1A + N * (4S + 5M + 8A)
    // N = 1 => 6M + 6S + 9A
    var a = this.curve.a;
    var tinv = this.curve.tinv;
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    // Reuse results
    var jyd = jy.redAdd(jy);
    for(i = 0; i < pow; i++){
        var jx2 = jx.redSqr();
        var jyd2 = jyd.redSqr();
        var jyd4 = jyd2.redSqr();
        var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
        var t1 = jx.redMul(jyd2);
        var nx = c.redSqr().redISub(t1.redAdd(t1));
        var t2 = t1.redISub(nx);
        var dny = c.redMul(t2);
        dny = dny.redIAdd(dny).redISub(jyd4);
        var nz = jyd.redMul(jz);
        if (i + 1 < pow) jz4 = jz4.redMul(jyd4);
        jx = nx;
        jz = nz;
        jyd = dny;
    }
    return this.curve.jpoint(jx, jyd.redMul(tinv), jz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    if (this.curve.zeroA) return this._zeroDbl();
    else if (this.curve.threeA) return this._threeDbl();
    else return this._dbl();
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._zeroDbl = function _zeroDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 14A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a; a = 0
        var m = xx.redAdd(xx).redIAdd(xx);
        // T = M ^ 2 - 2*S
        var t = m.redSqr().redISub(s).redISub(s);
        // 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2*Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html
        //     #doubling-dbl-2009-l
        // 2M + 5S + 13A
        // A = X1^2
        var a = this.x.redSqr();
        // B = Y1^2
        var b = this.y.redSqr();
        // C = B^2
        var c = b.redSqr();
        // D = 2 * ((X1 + B)^2 - A - C)
        var d = this.x.redAdd(b).redSqr().redISub(a).redISub(c);
        d = d.redIAdd(d);
        // E = 3 * A
        var e = a.redAdd(a).redIAdd(a);
        // F = E^2
        var f = e.redSqr();
        // 8 * C
        var c8 = c.redIAdd(c);
        c8 = c8.redIAdd(c8);
        c8 = c8.redIAdd(c8);
        // X3 = F - 2 * D
        nx = f.redISub(d).redISub(d);
        // Y3 = E * (D - X3) - 8 * C
        ny = e.redMul(d.redISub(nx)).redISub(c8);
        // Z3 = 2 * Y1 * Z1
        nz = this.y.redMul(this.z);
        nz = nz.redIAdd(nz);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._threeDbl = function _threeDbl() {
    var nx;
    var ny;
    var nz;
    // Z = 1
    if (this.zOne) {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html
        //     #doubling-mdbl-2007-bl
        // 1M + 5S + 15A
        // XX = X1^2
        var xx = this.x.redSqr();
        // YY = Y1^2
        var yy = this.y.redSqr();
        // YYYY = YY^2
        var yyyy = yy.redSqr();
        // S = 2 * ((X1 + YY)^2 - XX - YYYY)
        var s = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
        s = s.redIAdd(s);
        // M = 3 * XX + a
        var m = xx.redAdd(xx).redIAdd(xx).redIAdd(this.curve.a);
        // T = M^2 - 2 * S
        var t = m.redSqr().redISub(s).redISub(s);
        // X3 = T
        nx = t;
        // Y3 = M * (S - T) - 8 * YYYY
        var yyyy8 = yyyy.redIAdd(yyyy);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        yyyy8 = yyyy8.redIAdd(yyyy8);
        ny = m.redMul(s.redISub(t)).redISub(yyyy8);
        // Z3 = 2 * Y1
        nz = this.y.redAdd(this.y);
    } else {
        // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-3.html#doubling-dbl-2001-b
        // 3M + 5S
        // delta = Z1^2
        var delta = this.z.redSqr();
        // gamma = Y1^2
        var gamma = this.y.redSqr();
        // beta = X1 * gamma
        var beta = this.x.redMul(gamma);
        // alpha = 3 * (X1 - delta) * (X1 + delta)
        var alpha = this.x.redSub(delta).redMul(this.x.redAdd(delta));
        alpha = alpha.redAdd(alpha).redIAdd(alpha);
        // X3 = alpha^2 - 8 * beta
        var beta4 = beta.redIAdd(beta);
        beta4 = beta4.redIAdd(beta4);
        var beta8 = beta4.redAdd(beta4);
        nx = alpha.redSqr().redISub(beta8);
        // Z3 = (Y1 + Z1)^2 - gamma - delta
        nz = this.y.redAdd(this.z).redSqr().redISub(gamma).redISub(delta);
        // Y3 = alpha * (4 * beta - X3) - 8 * gamma^2
        var ggamma8 = gamma.redSqr();
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ggamma8 = ggamma8.redIAdd(ggamma8);
        ny = alpha.redMul(beta4.redISub(nx)).redISub(ggamma8);
    }
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype._dbl = function _dbl() {
    var a = this.curve.a;
    // 4M + 6S + 10A
    var jx = this.x;
    var jy = this.y;
    var jz = this.z;
    var jz4 = jz.redSqr().redSqr();
    var jx2 = jx.redSqr();
    var jy2 = jy.redSqr();
    var c = jx2.redAdd(jx2).redIAdd(jx2).redIAdd(a.redMul(jz4));
    var jxd4 = jx.redAdd(jx);
    jxd4 = jxd4.redIAdd(jxd4);
    var t1 = jxd4.redMul(jy2);
    var nx = c.redSqr().redISub(t1.redAdd(t1));
    var t2 = t1.redISub(nx);
    var jyd8 = jy2.redSqr();
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    jyd8 = jyd8.redIAdd(jyd8);
    var ny = c.redMul(t2).redISub(jyd8);
    var nz = jy.redAdd(jy).redMul(jz);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.trpl = function trpl() {
    if (!this.curve.zeroA) return this.dbl().add(this);
    // hyperelliptic.org/EFD/g1p/auto-shortw-jacobian-0.html#tripling-tpl-2007-bl
    // 5M + 10S + ...
    // XX = X1^2
    var xx = this.x.redSqr();
    // YY = Y1^2
    var yy = this.y.redSqr();
    // ZZ = Z1^2
    var zz = this.z.redSqr();
    // YYYY = YY^2
    var yyyy = yy.redSqr();
    // M = 3 * XX + a * ZZ2; a = 0
    var m = xx.redAdd(xx).redIAdd(xx);
    // MM = M^2
    var mm = m.redSqr();
    // E = 6 * ((X1 + YY)^2 - XX - YYYY) - MM
    var e = this.x.redAdd(yy).redSqr().redISub(xx).redISub(yyyy);
    e = e.redIAdd(e);
    e = e.redAdd(e).redIAdd(e);
    e = e.redISub(mm);
    // EE = E^2
    var ee = e.redSqr();
    // T = 16*YYYY
    var t = yyyy.redIAdd(yyyy);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    t = t.redIAdd(t);
    // U = (M + E)^2 - MM - EE - T
    var u = m.redIAdd(e).redSqr().redISub(mm).redISub(ee).redISub(t);
    // X3 = 4 * (X1 * EE - 4 * YY * U)
    var yyu4 = yy.redMul(u);
    yyu4 = yyu4.redIAdd(yyu4);
    yyu4 = yyu4.redIAdd(yyu4);
    var nx = this.x.redMul(ee).redISub(yyu4);
    nx = nx.redIAdd(nx);
    nx = nx.redIAdd(nx);
    // Y3 = 8 * Y1 * (U * (T - U) - E * EE)
    var ny = this.y.redMul(u.redMul(t.redISub(u)).redISub(e.redMul(ee)));
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    ny = ny.redIAdd(ny);
    // Z3 = (Z1 + E)^2 - ZZ - EE
    var nz = this.z.redAdd(e).redSqr().redISub(zz).redISub(ee);
    return this.curve.jpoint(nx, ny, nz);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.mul = function mul(k, kbase) {
    k = new $jX0xT(k, kbase);
    return this.curve._wnafMul(this, k);
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eq = function eq(p) {
    if (p.type === "affine") return this.eq(p.toJ());
    if (this === p) return true;
    // x1 * z2^2 == x2 * z1^2
    var z2 = this.z.redSqr();
    var pz2 = p.z.redSqr();
    if (this.x.redMul(pz2).redISub(p.x.redMul(z2)).cmpn(0) !== 0) return false;
    // y1 * z2^3 == y2 * z1^3
    var z3 = z2.redMul(this.z);
    var pz3 = pz2.redMul(p.z);
    return this.y.redMul(pz3).redISub(p.y.redMul(z3)).cmpn(0) === 0;
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.eqXToP = function eqXToP(x) {
    var zs = this.z.redSqr();
    var rx = x.toRed(this.curve.red).redMul(zs);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(zs);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC JPoint Infinity>";
    return "<EC JPoint x: " + this.x.toString(16, 2) + " y: " + this.y.toString(16, 2) + " z: " + this.z.toString(16, 2) + ">";
};
$ae7d1d0c45b43ec6$var$JPoint.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};

});

parcelRegister("av2Yx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");

var $gEVtY = parcelRequire("gEVtY");
function $7a4f1b7c0dc1f992$var$MontCurve(conf) {
    $hSu7V.call(this, "mont", conf);
    this.a = new $jX0xT(conf.a, 16).toRed(this.red);
    this.b = new $jX0xT(conf.b, 16).toRed(this.red);
    this.i4 = new $jX0xT(4).toRed(this.red).redInvm();
    this.two = new $jX0xT(2).toRed(this.red);
    this.a24 = this.i4.redMul(this.a.redAdd(this.two));
}
$dlqwk($7a4f1b7c0dc1f992$var$MontCurve, $hSu7V);
module.exports = $7a4f1b7c0dc1f992$var$MontCurve;
$7a4f1b7c0dc1f992$var$MontCurve.prototype.validate = function validate(point) {
    var x = point.normalize().x;
    var x2 = x.redSqr();
    var rhs = x2.redMul(x).redAdd(x2.redMul(this.a)).redAdd(x);
    var y = rhs.redSqrt();
    return y.redSqr().cmp(rhs) === 0;
};
function $7a4f1b7c0dc1f992$var$Point(curve, x, z) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && z === null) {
        this.x = this.curve.one;
        this.z = this.curve.zero;
    } else {
        this.x = new $jX0xT(x, 16);
        this.z = new $jX0xT(z, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
    }
}
$dlqwk($7a4f1b7c0dc1f992$var$Point, $hSu7V.BasePoint);
$7a4f1b7c0dc1f992$var$MontCurve.prototype.decodePoint = function decodePoint(bytes, enc) {
    return this.point($gEVtY.toArray(bytes, enc), 1);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.point = function point(x, z) {
    return new $7a4f1b7c0dc1f992$var$Point(this, x, z);
};
$7a4f1b7c0dc1f992$var$MontCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $7a4f1b7c0dc1f992$var$Point.fromJSON(this, obj);
};
$7a4f1b7c0dc1f992$var$Point.prototype.precompute = function precompute() {
// No-op
};
$7a4f1b7c0dc1f992$var$Point.prototype._encode = function _encode() {
    return this.getX().toArray("be", this.curve.p.byteLength());
};
$7a4f1b7c0dc1f992$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $7a4f1b7c0dc1f992$var$Point(curve, obj[0], obj[1] || curve.one);
};
$7a4f1b7c0dc1f992$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$7a4f1b7c0dc1f992$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.z.cmpn(0) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.dbl = function dbl() {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#doubling-dbl-1987-m-3
    // 2M + 2S + 4A
    // A = X1 + Z1
    var a = this.x.redAdd(this.z);
    // AA = A^2
    var aa = a.redSqr();
    // B = X1 - Z1
    var b = this.x.redSub(this.z);
    // BB = B^2
    var bb = b.redSqr();
    // C = AA - BB
    var c = aa.redSub(bb);
    // X3 = AA * BB
    var nx = aa.redMul(bb);
    // Z3 = C * (BB + A24 * C)
    var nz = c.redMul(bb.redAdd(this.curve.a24.redMul(c)));
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.add = function add() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.diffAdd = function diffAdd(p, diff) {
    // http://hyperelliptic.org/EFD/g1p/auto-montgom-xz.html#diffadd-dadd-1987-m-3
    // 4M + 2S + 6A
    // A = X2 + Z2
    var a = this.x.redAdd(this.z);
    // B = X2 - Z2
    var b = this.x.redSub(this.z);
    // C = X3 + Z3
    var c = p.x.redAdd(p.z);
    // D = X3 - Z3
    var d = p.x.redSub(p.z);
    // DA = D * A
    var da = d.redMul(a);
    // CB = C * B
    var cb = c.redMul(b);
    // X5 = Z1 * (DA + CB)^2
    var nx = diff.z.redMul(da.redAdd(cb).redSqr());
    // Z5 = X1 * (DA - CB)^2
    var nz = diff.x.redMul(da.redISub(cb).redSqr());
    return this.curve.point(nx, nz);
};
$7a4f1b7c0dc1f992$var$Point.prototype.mul = function mul(k) {
    var t = k.clone();
    var a = this; // (N / 2) * Q + Q
    var b = this.curve.point(null, null); // (N / 2) * Q
    var c = this; // Q
    for(var bits = []; t.cmpn(0) !== 0; t.iushrn(1))bits.push(t.andln(1));
    for(var i = bits.length - 1; i >= 0; i--)if (bits[i] === 0) {
        // N * Q + Q = ((N / 2) * Q + Q)) + (N / 2) * Q
        a = a.diffAdd(b, c);
        // N * Q = 2 * ((N / 2) * Q + Q))
        b = b.dbl();
    } else {
        // N * Q = ((N / 2) * Q + Q) + ((N / 2) * Q)
        b = a.diffAdd(b, c);
        // N * Q + Q = 2 * ((N / 2) * Q + Q)
        a = a.dbl();
    }
    return b;
};
$7a4f1b7c0dc1f992$var$Point.prototype.mulAdd = function mulAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.jumlAdd = function jumlAdd() {
    throw new Error("Not supported on Montgomery curve");
};
$7a4f1b7c0dc1f992$var$Point.prototype.eq = function eq(other) {
    return this.getX().cmp(other.getX()) === 0;
};
$7a4f1b7c0dc1f992$var$Point.prototype.normalize = function normalize() {
    this.x = this.x.redMul(this.z.redInvm());
    this.z = this.curve.one;
    return this;
};
$7a4f1b7c0dc1f992$var$Point.prototype.getX = function getX() {
    // Normalize coordinates
    this.normalize();
    return this.x.fromRed();
};

});

parcelRegister("dqmX9", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");

var $jX0xT = parcelRequire("jX0xT");

var $dlqwk = parcelRequire("dlqwk");

var $hSu7V = parcelRequire("hSu7V");
var $9c5f8216d530af0e$var$assert = $gEVtY.assert;
function $9c5f8216d530af0e$var$EdwardsCurve(conf) {
    // NOTE: Important as we are creating point in Base.call()
    this.twisted = (conf.a | 0) !== 1;
    this.mOneA = this.twisted && (conf.a | 0) === -1;
    this.extended = this.mOneA;
    $hSu7V.call(this, "edwards", conf);
    this.a = new $jX0xT(conf.a, 16).umod(this.red.m);
    this.a = this.a.toRed(this.red);
    this.c = new $jX0xT(conf.c, 16).toRed(this.red);
    this.c2 = this.c.redSqr();
    this.d = new $jX0xT(conf.d, 16).toRed(this.red);
    this.dd = this.d.redAdd(this.d);
    $9c5f8216d530af0e$var$assert(!this.twisted || this.c.fromRed().cmpn(1) === 0);
    this.oneC = (conf.c | 0) === 1;
}
$dlqwk($9c5f8216d530af0e$var$EdwardsCurve, $hSu7V);
module.exports = $9c5f8216d530af0e$var$EdwardsCurve;
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulA = function _mulA(num) {
    if (this.mOneA) return num.redNeg();
    else return this.a.redMul(num);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype._mulC = function _mulC(num) {
    if (this.oneC) return num;
    else return this.c.redMul(num);
};
// Just for compatibility with Short curve
$9c5f8216d530af0e$var$EdwardsCurve.prototype.jpoint = function jpoint(x, y, z, t) {
    return this.point(x, y, z, t);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromX = function pointFromX(x, odd) {
    x = new $jX0xT(x, 16);
    if (!x.red) x = x.toRed(this.red);
    var x2 = x.redSqr();
    var rhs = this.c2.redSub(this.a.redMul(x2));
    var lhs = this.one.redSub(this.c2.redMul(this.d).redMul(x2));
    var y2 = rhs.redMul(lhs.redInvm());
    var y = y2.redSqrt();
    if (y.redSqr().redSub(y2).cmp(this.zero) !== 0) throw new Error("invalid point");
    var isOdd = y.fromRed().isOdd();
    if (odd && !isOdd || !odd && isOdd) y = y.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromY = function pointFromY(y, odd) {
    y = new $jX0xT(y, 16);
    if (!y.red) y = y.toRed(this.red);
    // x^2 = (y^2 - c^2) / (c^2 d y^2 - a)
    var y2 = y.redSqr();
    var lhs = y2.redSub(this.c2);
    var rhs = y2.redMul(this.d).redMul(this.c2).redSub(this.a);
    var x2 = lhs.redMul(rhs.redInvm());
    if (x2.cmp(this.zero) === 0) {
        if (odd) throw new Error("invalid point");
        else return this.point(this.zero, y);
    }
    var x = x2.redSqrt();
    if (x.redSqr().redSub(x2).cmp(this.zero) !== 0) throw new Error("invalid point");
    if (x.fromRed().isOdd() !== odd) x = x.redNeg();
    return this.point(x, y);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.validate = function validate(point) {
    if (point.isInfinity()) return true;
    // Curve: A * X^2 + Y^2 = C^2 * (1 + D * X^2 * Y^2)
    point.normalize();
    var x2 = point.x.redSqr();
    var y2 = point.y.redSqr();
    var lhs = x2.redMul(this.a).redAdd(y2);
    var rhs = this.c2.redMul(this.one.redAdd(this.d.redMul(x2).redMul(y2)));
    return lhs.cmp(rhs) === 0;
};
function $9c5f8216d530af0e$var$Point(curve, x, y, z, t) {
    $hSu7V.BasePoint.call(this, curve, "projective");
    if (x === null && y === null && z === null) {
        this.x = this.curve.zero;
        this.y = this.curve.one;
        this.z = this.curve.one;
        this.t = this.curve.zero;
        this.zOne = true;
    } else {
        this.x = new $jX0xT(x, 16);
        this.y = new $jX0xT(y, 16);
        this.z = z ? new $jX0xT(z, 16) : this.curve.one;
        this.t = t && new $jX0xT(t, 16);
        if (!this.x.red) this.x = this.x.toRed(this.curve.red);
        if (!this.y.red) this.y = this.y.toRed(this.curve.red);
        if (!this.z.red) this.z = this.z.toRed(this.curve.red);
        if (this.t && !this.t.red) this.t = this.t.toRed(this.curve.red);
        this.zOne = this.z === this.curve.one;
        // Use extended coordinates
        if (this.curve.extended && !this.t) {
            this.t = this.x.redMul(this.y);
            if (!this.zOne) this.t = this.t.redMul(this.z.redInvm());
        }
    }
}
$dlqwk($9c5f8216d530af0e$var$Point, $hSu7V.BasePoint);
$9c5f8216d530af0e$var$EdwardsCurve.prototype.pointFromJSON = function pointFromJSON(obj) {
    return $9c5f8216d530af0e$var$Point.fromJSON(this, obj);
};
$9c5f8216d530af0e$var$EdwardsCurve.prototype.point = function point(x, y, z, t) {
    return new $9c5f8216d530af0e$var$Point(this, x, y, z, t);
};
$9c5f8216d530af0e$var$Point.fromJSON = function fromJSON(curve, obj) {
    return new $9c5f8216d530af0e$var$Point(curve, obj[0], obj[1], obj[2]);
};
$9c5f8216d530af0e$var$Point.prototype.inspect = function inspect() {
    if (this.isInfinity()) return "<EC Point Infinity>";
    return "<EC Point x: " + this.x.fromRed().toString(16, 2) + " y: " + this.y.fromRed().toString(16, 2) + " z: " + this.z.fromRed().toString(16, 2) + ">";
};
$9c5f8216d530af0e$var$Point.prototype.isInfinity = function isInfinity() {
    // XXX This code assumes that zero is always zero in red
    return this.x.cmpn(0) === 0 && (this.y.cmp(this.z) === 0 || this.zOne && this.y.cmp(this.curve.c) === 0);
};
$9c5f8216d530af0e$var$Point.prototype._extDbl = function _extDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #doubling-dbl-2008-hwcd
    // 4M + 4S
    // A = X1^2
    var a = this.x.redSqr();
    // B = Y1^2
    var b = this.y.redSqr();
    // C = 2 * Z1^2
    var c = this.z.redSqr();
    c = c.redIAdd(c);
    // D = a * A
    var d = this.curve._mulA(a);
    // E = (X1 + Y1)^2 - A - B
    var e = this.x.redAdd(this.y).redSqr().redISub(a).redISub(b);
    // G = D + B
    var g = d.redAdd(b);
    // F = G - C
    var f = g.redSub(c);
    // H = D - B
    var h = d.redSub(b);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projDbl = function _projDbl() {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #doubling-dbl-2008-bbjlp
    //     #doubling-dbl-2007-bl
    // and others
    // Generally 3M + 4S or 2M + 4S
    // B = (X1 + Y1)^2
    var b = this.x.redAdd(this.y).redSqr();
    // C = X1^2
    var c = this.x.redSqr();
    // D = Y1^2
    var d = this.y.redSqr();
    var nx;
    var ny;
    var nz;
    var e;
    var h;
    var j;
    if (this.curve.twisted) {
        // E = a * C
        e = this.curve._mulA(c);
        // F = E + D
        var f = e.redAdd(d);
        if (this.zOne) {
            // X3 = (B - C - D) * (F - 2)
            nx = b.redSub(c).redSub(d).redMul(f.redSub(this.curve.two));
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F^2 - 2 * F
            nz = f.redSqr().redSub(f).redSub(f);
        } else {
            // H = Z1^2
            h = this.z.redSqr();
            // J = F - 2 * H
            j = f.redSub(h).redISub(h);
            // X3 = (B-C-D)*J
            nx = b.redSub(c).redISub(d).redMul(j);
            // Y3 = F * (E - D)
            ny = f.redMul(e.redSub(d));
            // Z3 = F * J
            nz = f.redMul(j);
        }
    } else {
        // E = C + D
        e = c.redAdd(d);
        // H = (c * Z1)^2
        h = this.curve._mulC(this.z).redSqr();
        // J = E - 2 * H
        j = e.redSub(h).redSub(h);
        // X3 = c * (B - E) * J
        nx = this.curve._mulC(b.redISub(e)).redMul(j);
        // Y3 = c * E * (C - D)
        ny = this.curve._mulC(e).redMul(c.redISub(d));
        // Z3 = E * J
        nz = e.redMul(j);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.dbl = function dbl() {
    if (this.isInfinity()) return this;
    // Double in extended coordinates
    if (this.curve.extended) return this._extDbl();
    else return this._projDbl();
};
$9c5f8216d530af0e$var$Point.prototype._extAdd = function _extAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-extended-1.html
    //     #addition-add-2008-hwcd-3
    // 8M
    // A = (Y1 - X1) * (Y2 - X2)
    var a = this.y.redSub(this.x).redMul(p.y.redSub(p.x));
    // B = (Y1 + X1) * (Y2 + X2)
    var b = this.y.redAdd(this.x).redMul(p.y.redAdd(p.x));
    // C = T1 * k * T2
    var c = this.t.redMul(this.curve.dd).redMul(p.t);
    // D = Z1 * 2 * Z2
    var d = this.z.redMul(p.z.redAdd(p.z));
    // E = B - A
    var e = b.redSub(a);
    // F = D - C
    var f = d.redSub(c);
    // G = D + C
    var g = d.redAdd(c);
    // H = B + A
    var h = b.redAdd(a);
    // X3 = E * F
    var nx = e.redMul(f);
    // Y3 = G * H
    var ny = g.redMul(h);
    // T3 = E * H
    var nt = e.redMul(h);
    // Z3 = F * G
    var nz = f.redMul(g);
    return this.curve.point(nx, ny, nz, nt);
};
$9c5f8216d530af0e$var$Point.prototype._projAdd = function _projAdd(p) {
    // hyperelliptic.org/EFD/g1p/auto-twisted-projective.html
    //     #addition-add-2008-bbjlp
    //     #addition-add-2007-bl
    // 10M + 1S
    // A = Z1 * Z2
    var a = this.z.redMul(p.z);
    // B = A^2
    var b = a.redSqr();
    // C = X1 * X2
    var c = this.x.redMul(p.x);
    // D = Y1 * Y2
    var d = this.y.redMul(p.y);
    // E = d * C * D
    var e = this.curve.d.redMul(c).redMul(d);
    // F = B - E
    var f = b.redSub(e);
    // G = B + E
    var g = b.redAdd(e);
    // X3 = A * F * ((X1 + Y1) * (X2 + Y2) - C - D)
    var tmp = this.x.redAdd(this.y).redMul(p.x.redAdd(p.y)).redISub(c).redISub(d);
    var nx = a.redMul(f).redMul(tmp);
    var ny;
    var nz;
    if (this.curve.twisted) {
        // Y3 = A * G * (D - a * C)
        ny = a.redMul(g).redMul(d.redSub(this.curve._mulA(c)));
        // Z3 = F * G
        nz = f.redMul(g);
    } else {
        // Y3 = A * G * (D - C)
        ny = a.redMul(g).redMul(d.redSub(c));
        // Z3 = c * F * G
        nz = this.curve._mulC(f).redMul(g);
    }
    return this.curve.point(nx, ny, nz);
};
$9c5f8216d530af0e$var$Point.prototype.add = function add(p) {
    if (this.isInfinity()) return p;
    if (p.isInfinity()) return this;
    if (this.curve.extended) return this._extAdd(p);
    else return this._projAdd(p);
};
$9c5f8216d530af0e$var$Point.prototype.mul = function mul(k) {
    if (this._hasDoubles(k)) return this.curve._fixedNafMul(this, k);
    else return this.curve._wnafMul(this, k);
};
$9c5f8216d530af0e$var$Point.prototype.mulAdd = function mulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, false);
};
$9c5f8216d530af0e$var$Point.prototype.jmulAdd = function jmulAdd(k1, p, k2) {
    return this.curve._wnafMulAdd(1, [
        this,
        p
    ], [
        k1,
        k2
    ], 2, true);
};
$9c5f8216d530af0e$var$Point.prototype.normalize = function normalize() {
    if (this.zOne) return this;
    // Normalize coordinates
    var zi = this.z.redInvm();
    this.x = this.x.redMul(zi);
    this.y = this.y.redMul(zi);
    if (this.t) this.t = this.t.redMul(zi);
    this.z = this.curve.one;
    this.zOne = true;
    return this;
};
$9c5f8216d530af0e$var$Point.prototype.neg = function neg() {
    return this.curve.point(this.x.redNeg(), this.y, this.z, this.t && this.t.redNeg());
};
$9c5f8216d530af0e$var$Point.prototype.getX = function getX() {
    this.normalize();
    return this.x.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.getY = function getY() {
    this.normalize();
    return this.y.fromRed();
};
$9c5f8216d530af0e$var$Point.prototype.eq = function eq(other) {
    return this === other || this.getX().cmp(other.getX()) === 0 && this.getY().cmp(other.getY()) === 0;
};
$9c5f8216d530af0e$var$Point.prototype.eqXToP = function eqXToP(x) {
    var rx = x.toRed(this.curve.red).redMul(this.z);
    if (this.x.cmp(rx) === 0) return true;
    var xc = x.clone();
    var t = this.curve.redN.redMul(this.z);
    for(;;){
        xc.iadd(this.curve.n);
        if (xc.cmp(this.curve.p) >= 0) return false;
        rx.redIAdd(t);
        if (this.x.cmp(rx) === 0) return true;
    }
};
// Compatibility with BaseCurve
$9c5f8216d530af0e$var$Point.prototype.toP = $9c5f8216d530af0e$var$Point.prototype.normalize;
$9c5f8216d530af0e$var$Point.prototype.mixedAdd = $9c5f8216d530af0e$var$Point.prototype.add;

});


parcelRegister("fbTbW", function(module, exports) {
"use strict";
var $b0f2b206068f1378$var$curves = module.exports;

var $kiSKt = parcelRequire("kiSKt");

var $cP1GP = parcelRequire("cP1GP");

var $gEVtY = parcelRequire("gEVtY");
var $b0f2b206068f1378$var$assert = $gEVtY.assert;
function $b0f2b206068f1378$var$PresetCurve(options) {
    if (options.type === "short") this.curve = new $cP1GP.short(options);
    else if (options.type === "edwards") this.curve = new $cP1GP.edwards(options);
    else this.curve = new $cP1GP.mont(options);
    this.g = this.curve.g;
    this.n = this.curve.n;
    this.hash = options.hash;
    $b0f2b206068f1378$var$assert(this.g.validate(), "Invalid curve");
    $b0f2b206068f1378$var$assert(this.g.mul(this.n).isInfinity(), "Invalid curve, G*N != O");
}
$b0f2b206068f1378$var$curves.PresetCurve = $b0f2b206068f1378$var$PresetCurve;
function $b0f2b206068f1378$var$defineCurve(name, options) {
    Object.defineProperty($b0f2b206068f1378$var$curves, name, {
        configurable: true,
        enumerable: true,
        get: function() {
            var curve = new $b0f2b206068f1378$var$PresetCurve(options);
            Object.defineProperty($b0f2b206068f1378$var$curves, name, {
                configurable: true,
                enumerable: true,
                value: curve
            });
            return curve;
        }
    });
}
$b0f2b206068f1378$var$defineCurve("p192", {
    type: "short",
    prime: "p192",
    p: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff fffffffc",
    b: "64210519 e59c80e7 0fa7e9ab 72243049 feb8deec c146b9b1",
    n: "ffffffff ffffffff ffffffff 99def836 146bc9b1 b4d22831",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "188da80e b03090f6 7cbf20eb 43a18800 f4ff0afd 82ff1012",
        "07192b95 ffc8da78 631011ed 6b24cdd5 73f977a1 1e794811"
    ]
});
$b0f2b206068f1378$var$defineCurve("p224", {
    type: "short",
    prime: "p224",
    p: "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001",
    a: "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff fffffffe",
    b: "b4050a85 0c04b3ab f5413256 5044b0b7 d7bfd8ba 270b3943 2355ffb4",
    n: "ffffffff ffffffff ffffffff ffff16a2 e0b8f03e 13dd2945 5c5c2a3d",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "b70e0cbd 6bb4bf7f 321390b9 4a03c1d3 56c21122 343280d6 115c1d21",
        "bd376388 b5f723fb 4c22dfe6 cd4375a0 5a074764 44d58199 85007e34"
    ]
});
$b0f2b206068f1378$var$defineCurve("p256", {
    type: "short",
    prime: null,
    p: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff ffffffff",
    a: "ffffffff 00000001 00000000 00000000 00000000 ffffffff ffffffff fffffffc",
    b: "5ac635d8 aa3a93e7 b3ebbd55 769886bc 651d06b0 cc53b0f6 3bce3c3e 27d2604b",
    n: "ffffffff 00000000 ffffffff ffffffff bce6faad a7179e84 f3b9cac2 fc632551",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "6b17d1f2 e12c4247 f8bce6e5 63a440f2 77037d81 2deb33a0 f4a13945 d898c296",
        "4fe342e2 fe1a7f9b 8ee7eb4a 7c0f9e16 2bce3357 6b315ece cbb64068 37bf51f5"
    ]
});
$b0f2b206068f1378$var$defineCurve("p384", {
    type: "short",
    prime: null,
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 ffffffff",
    a: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe ffffffff 00000000 00000000 fffffffc",
    b: "b3312fa7 e23ee7e4 988e056b e3f82d19 181d9c6e fe814112 0314088f 5013875a c656398d 8a2ed19d 2a85c8ed d3ec2aef",
    n: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff c7634d81 f4372ddf 581a0db2 48b0a77a ecec196a ccc52973",
    hash: $kiSKt.sha384,
    gRed: false,
    g: [
        "aa87ca22 be8b0537 8eb1c71e f320ad74 6e1d3b62 8ba79b98 59f741e0 82542a38 5502f25d bf55296c 3a545e38 72760ab7",
        "3617de4a 96262c6f 5d9e98bf 9292dc29 f8f41dbd 289a147c e9da3113 b5f0b8c0 0a60b1ce 1d7e819d 7a431d7c 90ea0e5f"
    ]
});
$b0f2b206068f1378$var$defineCurve("p521", {
    type: "short",
    prime: null,
    p: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff",
    a: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffc",
    b: "00000051 953eb961 8e1c9a1f 929a21a0 b68540ee a2da725b 99b315f3 b8b48991 8ef109e1 56193951 ec7e937b 1652c0bd 3bb1bf07 3573df88 3d2c34f1 ef451fd4 6b503f00",
    n: "000001ff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffa 51868783 bf2f966b 7fcc0148 f709a5d0 3bb5c9b8 899c47ae bb6fb71e 91386409",
    hash: $kiSKt.sha512,
    gRed: false,
    g: [
        "000000c6 858e06b7 0404e9cd 9e3ecb66 2395b442 9c648139 053fb521 f828af60 6b4d3dba a14b5e77 efe75928 fe1dc127 a2ffa8de 3348b3c1 856a429b f97e7e31 c2e5bd66",
        "00000118 39296a78 9a3bc004 5c8a5fb4 2c7d1bd9 98f54449 579b4468 17afbd17 273e662c 97ee7299 5ef42640 c550b901 3fad0761 353c7086 a272c240 88be9476 9fd16650"
    ]
});
$b0f2b206068f1378$var$defineCurve("curve25519", {
    type: "mont",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "76d06",
    b: "1",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "9"
    ]
});
$b0f2b206068f1378$var$defineCurve("ed25519", {
    type: "edwards",
    prime: "p25519",
    p: "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed",
    a: "-1",
    c: "1",
    // -121665 * (121666^(-1)) (mod P)
    d: "52036cee2b6ffe73 8cc740797779e898 00700a4d4141d8ab 75eb4dca135978a3",
    n: "1000000000000000 0000000000000000 14def9dea2f79cd6 5812631a5cf5d3ed",
    hash: $kiSKt.sha256,
    gRed: false,
    g: [
        "216936d3cd6e53fec0a4e231fdd6dc5c692cc7609525a7b2c9562d608f25d51a",
        // 4/5
        "6666666666666666666666666666666666666666666666666666666666666658"
    ]
});
var $b0f2b206068f1378$var$pre;

try {
    $b0f2b206068f1378$var$pre = (parcelRequire("lNVWe"));
} catch (e) {
    $b0f2b206068f1378$var$pre = undefined;
}
$b0f2b206068f1378$var$defineCurve("secp256k1", {
    type: "short",
    prime: "k256",
    p: "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f",
    a: "0",
    b: "7",
    n: "ffffffff ffffffff ffffffff fffffffe baaedce6 af48a03b bfd25e8c d0364141",
    h: "1",
    hash: $kiSKt.sha256,
    // Precomputed endomorphism
    beta: "7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee",
    lambda: "5363ad4cc05c30e0a5261c028812645a122e22ea20816678df02967c1b23bd72",
    basis: [
        {
            a: "3086d221a7d46bcde86c90e49284eb15",
            b: "-e4437ed6010e88286f547fa90abfe4c3"
        },
        {
            a: "114ca50f7a8e2f3f657c1108d9d44cfd8",
            b: "3086d221a7d46bcde86c90e49284eb15"
        }
    ],
    gRed: false,
    g: [
        "79be667ef9dcbbac55a06295ce870b07029bfcdb2dce28d959f2815b16f81798",
        "483ada7726a3c4655da4fbfc0e1108a8fd17b448a68554199c47d08ffb10d4b8",
        $b0f2b206068f1378$var$pre
    ]
});

});
parcelRegister("kiSKt", function(module, exports) {
var $ec7ff5071b027891$var$hash = module.exports;

$ec7ff5071b027891$var$hash.utils = (parcelRequire("btcbI"));

$ec7ff5071b027891$var$hash.common = (parcelRequire("aAb7n"));

$ec7ff5071b027891$var$hash.sha = (parcelRequire("2wnQk"));

$ec7ff5071b027891$var$hash.ripemd = (parcelRequire("05eZB"));

$ec7ff5071b027891$var$hash.hmac = (parcelRequire("ap2lu"));
// Proxy hash functions to the main object
$ec7ff5071b027891$var$hash.sha1 = $ec7ff5071b027891$var$hash.sha.sha1;
$ec7ff5071b027891$var$hash.sha256 = $ec7ff5071b027891$var$hash.sha.sha256;
$ec7ff5071b027891$var$hash.sha224 = $ec7ff5071b027891$var$hash.sha.sha224;
$ec7ff5071b027891$var$hash.sha384 = $ec7ff5071b027891$var$hash.sha.sha384;
$ec7ff5071b027891$var$hash.sha512 = $ec7ff5071b027891$var$hash.sha.sha512;
$ec7ff5071b027891$var$hash.ripemd160 = $ec7ff5071b027891$var$hash.ripemd.ripemd160;

});
parcelRegister("btcbI", function(module, exports) {

$parcel$export(module.exports, "inherits", () => $859bdb699f0f4e15$export$69f1b2dcda23c5f8, (v) => $859bdb699f0f4e15$export$69f1b2dcda23c5f8 = v);
$parcel$export(module.exports, "toArray", () => $859bdb699f0f4e15$export$45b10814cc054894, (v) => $859bdb699f0f4e15$export$45b10814cc054894 = v);
$parcel$export(module.exports, "toHex", () => $859bdb699f0f4e15$export$7ea66e3774a60b67, (v) => $859bdb699f0f4e15$export$7ea66e3774a60b67 = v);
$parcel$export(module.exports, "htonl", () => $859bdb699f0f4e15$export$34a52f00f601f6f1, (v) => $859bdb699f0f4e15$export$34a52f00f601f6f1 = v);
$parcel$export(module.exports, "toHex32", () => $859bdb699f0f4e15$export$812b0cbd5e8a72ab, (v) => $859bdb699f0f4e15$export$812b0cbd5e8a72ab = v);
$parcel$export(module.exports, "zero2", () => $859bdb699f0f4e15$export$f24f9e11d63bb314, (v) => $859bdb699f0f4e15$export$f24f9e11d63bb314 = v);
$parcel$export(module.exports, "zero8", () => $859bdb699f0f4e15$export$b71357c7e07ca1f1, (v) => $859bdb699f0f4e15$export$b71357c7e07ca1f1 = v);
$parcel$export(module.exports, "join32", () => $859bdb699f0f4e15$export$2e58a4b541fdcbe8, (v) => $859bdb699f0f4e15$export$2e58a4b541fdcbe8 = v);
$parcel$export(module.exports, "split32", () => $859bdb699f0f4e15$export$183b950bde9faab8, (v) => $859bdb699f0f4e15$export$183b950bde9faab8 = v);
$parcel$export(module.exports, "rotr32", () => $859bdb699f0f4e15$export$4785c77169fea59e, (v) => $859bdb699f0f4e15$export$4785c77169fea59e = v);
$parcel$export(module.exports, "rotl32", () => $859bdb699f0f4e15$export$242a185dfcffac5b, (v) => $859bdb699f0f4e15$export$242a185dfcffac5b = v);
$parcel$export(module.exports, "sum32", () => $859bdb699f0f4e15$export$58c04ae0ae31877d, (v) => $859bdb699f0f4e15$export$58c04ae0ae31877d = v);
$parcel$export(module.exports, "sum32_3", () => $859bdb699f0f4e15$export$d058ca695f8c6f11, (v) => $859bdb699f0f4e15$export$d058ca695f8c6f11 = v);
$parcel$export(module.exports, "sum32_4", () => $859bdb699f0f4e15$export$a1efd7fc3e986367, (v) => $859bdb699f0f4e15$export$a1efd7fc3e986367 = v);
$parcel$export(module.exports, "sum32_5", () => $859bdb699f0f4e15$export$bbfea4a2b5abaab4, (v) => $859bdb699f0f4e15$export$bbfea4a2b5abaab4 = v);
$parcel$export(module.exports, "sum64", () => $859bdb699f0f4e15$export$97ad4afc7de86152, (v) => $859bdb699f0f4e15$export$97ad4afc7de86152 = v);
$parcel$export(module.exports, "sum64_hi", () => $859bdb699f0f4e15$export$ce4673d9a79f6a4b, (v) => $859bdb699f0f4e15$export$ce4673d9a79f6a4b = v);
$parcel$export(module.exports, "sum64_lo", () => $859bdb699f0f4e15$export$786cc99fc6eedc0b, (v) => $859bdb699f0f4e15$export$786cc99fc6eedc0b = v);
$parcel$export(module.exports, "sum64_4_hi", () => $859bdb699f0f4e15$export$45c59b9a1848dd0, (v) => $859bdb699f0f4e15$export$45c59b9a1848dd0 = v);
$parcel$export(module.exports, "sum64_4_lo", () => $859bdb699f0f4e15$export$50d8f613e76d3034, (v) => $859bdb699f0f4e15$export$50d8f613e76d3034 = v);
$parcel$export(module.exports, "sum64_5_hi", () => $859bdb699f0f4e15$export$b8e83683c60ee162, (v) => $859bdb699f0f4e15$export$b8e83683c60ee162 = v);
$parcel$export(module.exports, "sum64_5_lo", () => $859bdb699f0f4e15$export$aeeb51790d1bcc4a, (v) => $859bdb699f0f4e15$export$aeeb51790d1bcc4a = v);
$parcel$export(module.exports, "rotr64_hi", () => $859bdb699f0f4e15$export$bb7c616f719ad9c, (v) => $859bdb699f0f4e15$export$bb7c616f719ad9c = v);
$parcel$export(module.exports, "rotr64_lo", () => $859bdb699f0f4e15$export$4d63290824f9d7df, (v) => $859bdb699f0f4e15$export$4d63290824f9d7df = v);
$parcel$export(module.exports, "shr64_hi", () => $859bdb699f0f4e15$export$2f64ceb90ef28ea1, (v) => $859bdb699f0f4e15$export$2f64ceb90ef28ea1 = v);
$parcel$export(module.exports, "shr64_lo", () => $859bdb699f0f4e15$export$8d2089d465f6d10d, (v) => $859bdb699f0f4e15$export$8d2089d465f6d10d = v);
var $859bdb699f0f4e15$export$69f1b2dcda23c5f8;
var $859bdb699f0f4e15$export$45b10814cc054894;
var $859bdb699f0f4e15$export$7ea66e3774a60b67;
var $859bdb699f0f4e15$export$34a52f00f601f6f1;
var $859bdb699f0f4e15$export$812b0cbd5e8a72ab;
var $859bdb699f0f4e15$export$f24f9e11d63bb314;
var $859bdb699f0f4e15$export$b71357c7e07ca1f1;
var $859bdb699f0f4e15$export$2e58a4b541fdcbe8;
var $859bdb699f0f4e15$export$183b950bde9faab8;
var $859bdb699f0f4e15$export$4785c77169fea59e;
var $859bdb699f0f4e15$export$242a185dfcffac5b;
var $859bdb699f0f4e15$export$58c04ae0ae31877d;
var $859bdb699f0f4e15$export$d058ca695f8c6f11;
var $859bdb699f0f4e15$export$a1efd7fc3e986367;
var $859bdb699f0f4e15$export$bbfea4a2b5abaab4;
var $859bdb699f0f4e15$export$97ad4afc7de86152;
var $859bdb699f0f4e15$export$ce4673d9a79f6a4b;
var $859bdb699f0f4e15$export$786cc99fc6eedc0b;
var $859bdb699f0f4e15$export$45c59b9a1848dd0;
var $859bdb699f0f4e15$export$50d8f613e76d3034;
var $859bdb699f0f4e15$export$b8e83683c60ee162;
var $859bdb699f0f4e15$export$aeeb51790d1bcc4a;
var $859bdb699f0f4e15$export$bb7c616f719ad9c;
var $859bdb699f0f4e15$export$4d63290824f9d7df;
var $859bdb699f0f4e15$export$2f64ceb90ef28ea1;
var $859bdb699f0f4e15$export$8d2089d465f6d10d;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
$859bdb699f0f4e15$export$69f1b2dcda23c5f8 = $dlqwk;
function $859bdb699f0f4e15$var$isSurrogatePair(msg, i) {
    if ((msg.charCodeAt(i) & 0xFC00) !== 0xD800) return false;
    if (i < 0 || i + 1 >= msg.length) return false;
    return (msg.charCodeAt(i + 1) & 0xFC00) === 0xDC00;
}
function $859bdb699f0f4e15$var$toArray(msg, enc) {
    if (Array.isArray(msg)) return msg.slice();
    if (!msg) return [];
    var res = [];
    if (typeof msg === "string") {
        if (!enc) {
            // Inspired by stringToUtf8ByteArray() in closure-library by Google
            // https://github.com/google/closure-library/blob/8598d87242af59aac233270742c8984e2b2bdbe0/closure/goog/crypt/crypt.js#L117-L143
            // Apache License 2.0
            // https://github.com/google/closure-library/blob/master/LICENSE
            var p = 0;
            for(var i = 0; i < msg.length; i++){
                var c = msg.charCodeAt(i);
                if (c < 128) res[p++] = c;
                else if (c < 2048) {
                    res[p++] = c >> 6 | 192;
                    res[p++] = c & 63 | 128;
                } else if ($859bdb699f0f4e15$var$isSurrogatePair(msg, i)) {
                    c = 0x10000 + ((c & 0x03FF) << 10) + (msg.charCodeAt(++i) & 0x03FF);
                    res[p++] = c >> 18 | 240;
                    res[p++] = c >> 12 & 63 | 128;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                } else {
                    res[p++] = c >> 12 | 224;
                    res[p++] = c >> 6 & 63 | 128;
                    res[p++] = c & 63 | 128;
                }
            }
        } else if (enc === "hex") {
            msg = msg.replace(/[^a-z0-9]+/ig, "");
            if (msg.length % 2 !== 0) msg = "0" + msg;
            for(i = 0; i < msg.length; i += 2)res.push(parseInt(msg[i] + msg[i + 1], 16));
        }
    } else for(i = 0; i < msg.length; i++)res[i] = msg[i] | 0;
    return res;
}
$859bdb699f0f4e15$export$45b10814cc054894 = $859bdb699f0f4e15$var$toArray;
function $859bdb699f0f4e15$var$toHex(msg) {
    var res = "";
    for(var i = 0; i < msg.length; i++)res += $859bdb699f0f4e15$var$zero2(msg[i].toString(16));
    return res;
}
$859bdb699f0f4e15$export$7ea66e3774a60b67 = $859bdb699f0f4e15$var$toHex;
function $859bdb699f0f4e15$var$htonl(w) {
    var res = w >>> 24 | w >>> 8 & 0xff00 | w << 8 & 0xff0000 | (w & 0xff) << 24;
    return res >>> 0;
}
$859bdb699f0f4e15$export$34a52f00f601f6f1 = $859bdb699f0f4e15$var$htonl;
function $859bdb699f0f4e15$var$toHex32(msg, endian) {
    var res = "";
    for(var i = 0; i < msg.length; i++){
        var w = msg[i];
        if (endian === "little") w = $859bdb699f0f4e15$var$htonl(w);
        res += $859bdb699f0f4e15$var$zero8(w.toString(16));
    }
    return res;
}
$859bdb699f0f4e15$export$812b0cbd5e8a72ab = $859bdb699f0f4e15$var$toHex32;
function $859bdb699f0f4e15$var$zero2(word) {
    if (word.length === 1) return "0" + word;
    else return word;
}
$859bdb699f0f4e15$export$f24f9e11d63bb314 = $859bdb699f0f4e15$var$zero2;
function $859bdb699f0f4e15$var$zero8(word) {
    if (word.length === 7) return "0" + word;
    else if (word.length === 6) return "00" + word;
    else if (word.length === 5) return "000" + word;
    else if (word.length === 4) return "0000" + word;
    else if (word.length === 3) return "00000" + word;
    else if (word.length === 2) return "000000" + word;
    else if (word.length === 1) return "0000000" + word;
    else return word;
}
$859bdb699f0f4e15$export$b71357c7e07ca1f1 = $859bdb699f0f4e15$var$zero8;
function $859bdb699f0f4e15$var$join32(msg, start, end, endian) {
    var len = end - start;
    $koC21(len % 4 === 0);
    var res = new Array(len / 4);
    for(var i = 0, k = start; i < res.length; i++, k += 4){
        var w;
        if (endian === "big") w = msg[k] << 24 | msg[k + 1] << 16 | msg[k + 2] << 8 | msg[k + 3];
        else w = msg[k + 3] << 24 | msg[k + 2] << 16 | msg[k + 1] << 8 | msg[k];
        res[i] = w >>> 0;
    }
    return res;
}
$859bdb699f0f4e15$export$2e58a4b541fdcbe8 = $859bdb699f0f4e15$var$join32;
function $859bdb699f0f4e15$var$split32(msg, endian) {
    var res = new Array(msg.length * 4);
    for(var i = 0, k = 0; i < msg.length; i++, k += 4){
        var m = msg[i];
        if (endian === "big") {
            res[k] = m >>> 24;
            res[k + 1] = m >>> 16 & 0xff;
            res[k + 2] = m >>> 8 & 0xff;
            res[k + 3] = m & 0xff;
        } else {
            res[k + 3] = m >>> 24;
            res[k + 2] = m >>> 16 & 0xff;
            res[k + 1] = m >>> 8 & 0xff;
            res[k] = m & 0xff;
        }
    }
    return res;
}
$859bdb699f0f4e15$export$183b950bde9faab8 = $859bdb699f0f4e15$var$split32;
function $859bdb699f0f4e15$var$rotr32(w, b) {
    return w >>> b | w << 32 - b;
}
$859bdb699f0f4e15$export$4785c77169fea59e = $859bdb699f0f4e15$var$rotr32;
function $859bdb699f0f4e15$var$rotl32(w, b) {
    return w << b | w >>> 32 - b;
}
$859bdb699f0f4e15$export$242a185dfcffac5b = $859bdb699f0f4e15$var$rotl32;
function $859bdb699f0f4e15$var$sum32(a, b) {
    return a + b >>> 0;
}
$859bdb699f0f4e15$export$58c04ae0ae31877d = $859bdb699f0f4e15$var$sum32;
function $859bdb699f0f4e15$var$sum32_3(a, b, c) {
    return a + b + c >>> 0;
}
$859bdb699f0f4e15$export$d058ca695f8c6f11 = $859bdb699f0f4e15$var$sum32_3;
function $859bdb699f0f4e15$var$sum32_4(a, b, c, d) {
    return a + b + c + d >>> 0;
}
$859bdb699f0f4e15$export$a1efd7fc3e986367 = $859bdb699f0f4e15$var$sum32_4;
function $859bdb699f0f4e15$var$sum32_5(a, b, c, d, e) {
    return a + b + c + d + e >>> 0;
}
$859bdb699f0f4e15$export$bbfea4a2b5abaab4 = $859bdb699f0f4e15$var$sum32_5;
function $859bdb699f0f4e15$var$sum64(buf, pos, ah, al) {
    var bh = buf[pos];
    var bl = buf[pos + 1];
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    buf[pos] = hi >>> 0;
    buf[pos + 1] = lo;
}
$859bdb699f0f4e15$export$97ad4afc7de86152 = $859bdb699f0f4e15$var$sum64;
function $859bdb699f0f4e15$var$sum64_hi(ah, al, bh, bl) {
    var lo = al + bl >>> 0;
    var hi = (lo < al ? 1 : 0) + ah + bh;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$ce4673d9a79f6a4b = $859bdb699f0f4e15$var$sum64_hi;
function $859bdb699f0f4e15$var$sum64_lo(ah, al, bh, bl) {
    var lo = al + bl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$786cc99fc6eedc0b = $859bdb699f0f4e15$var$sum64_lo;
function $859bdb699f0f4e15$var$sum64_4_hi(ah, al, bh, bl, ch, cl, dh, dl) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    var hi = ah + bh + ch + dh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$45c59b9a1848dd0 = $859bdb699f0f4e15$var$sum64_4_hi;
function $859bdb699f0f4e15$var$sum64_4_lo(ah, al, bh, bl, ch, cl, dh, dl) {
    var lo = al + bl + cl + dl;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$50d8f613e76d3034 = $859bdb699f0f4e15$var$sum64_4_lo;
function $859bdb699f0f4e15$var$sum64_5_hi(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var carry = 0;
    var lo = al;
    lo = lo + bl >>> 0;
    carry += lo < al ? 1 : 0;
    lo = lo + cl >>> 0;
    carry += lo < cl ? 1 : 0;
    lo = lo + dl >>> 0;
    carry += lo < dl ? 1 : 0;
    lo = lo + el >>> 0;
    carry += lo < el ? 1 : 0;
    var hi = ah + bh + ch + dh + eh + carry;
    return hi >>> 0;
}
$859bdb699f0f4e15$export$b8e83683c60ee162 = $859bdb699f0f4e15$var$sum64_5_hi;
function $859bdb699f0f4e15$var$sum64_5_lo(ah, al, bh, bl, ch, cl, dh, dl, eh, el) {
    var lo = al + bl + cl + dl + el;
    return lo >>> 0;
}
$859bdb699f0f4e15$export$aeeb51790d1bcc4a = $859bdb699f0f4e15$var$sum64_5_lo;
function $859bdb699f0f4e15$var$rotr64_hi(ah, al, num) {
    var r = al << 32 - num | ah >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$bb7c616f719ad9c = $859bdb699f0f4e15$var$rotr64_hi;
function $859bdb699f0f4e15$var$rotr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$4d63290824f9d7df = $859bdb699f0f4e15$var$rotr64_lo;
function $859bdb699f0f4e15$var$shr64_hi(ah, al, num) {
    return ah >>> num;
}
$859bdb699f0f4e15$export$2f64ceb90ef28ea1 = $859bdb699f0f4e15$var$shr64_hi;
function $859bdb699f0f4e15$var$shr64_lo(ah, al, num) {
    var r = ah << 32 - num | al >>> num;
    return r >>> 0;
}
$859bdb699f0f4e15$export$8d2089d465f6d10d = $859bdb699f0f4e15$var$shr64_lo;

});

parcelRegister("aAb7n", function(module, exports) {

$parcel$export(module.exports, "BlockHash", () => $7b45e3fb23ceb2f4$export$8687658379b577e6, (v) => $7b45e3fb23ceb2f4$export$8687658379b577e6 = v);
var $7b45e3fb23ceb2f4$export$8687658379b577e6;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $7b45e3fb23ceb2f4$var$BlockHash() {
    this.pending = null;
    this.pendingTotal = 0;
    this.blockSize = this.constructor.blockSize;
    this.outSize = this.constructor.outSize;
    this.hmacStrength = this.constructor.hmacStrength;
    this.padLength = this.constructor.padLength / 8;
    this.endian = "big";
    this._delta8 = this.blockSize / 8;
    this._delta32 = this.blockSize / 32;
}
$7b45e3fb23ceb2f4$export$8687658379b577e6 = $7b45e3fb23ceb2f4$var$BlockHash;
$7b45e3fb23ceb2f4$var$BlockHash.prototype.update = function update(msg, enc) {
    // Convert message to array, pad it, and join into 32bit blocks
    msg = $btcbI.toArray(msg, enc);
    if (!this.pending) this.pending = msg;
    else this.pending = this.pending.concat(msg);
    this.pendingTotal += msg.length;
    // Enough data, try updating
    if (this.pending.length >= this._delta8) {
        msg = this.pending;
        // Process pending data in blocks
        var r = msg.length % this._delta8;
        this.pending = msg.slice(msg.length - r, msg.length);
        if (this.pending.length === 0) this.pending = null;
        msg = $btcbI.join32(msg, 0, msg.length - r, this.endian);
        for(var i = 0; i < msg.length; i += this._delta32)this._update(msg, i, i + this._delta32);
    }
    return this;
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype.digest = function digest(enc) {
    this.update(this._pad());
    $koC21(this.pending === null);
    return this._digest(enc);
};
$7b45e3fb23ceb2f4$var$BlockHash.prototype._pad = function pad() {
    var len = this.pendingTotal;
    var bytes = this._delta8;
    var k = bytes - (len + this.padLength) % bytes;
    var res = new Array(k + this.padLength);
    res[0] = 0x80;
    for(var i = 1; i < k; i++)res[i] = 0;
    // Append length
    len <<= 3;
    if (this.endian === "big") {
        for(var t = 8; t < this.padLength; t++)res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len & 0xff;
    } else {
        res[i++] = len & 0xff;
        res[i++] = len >>> 8 & 0xff;
        res[i++] = len >>> 16 & 0xff;
        res[i++] = len >>> 24 & 0xff;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        res[i++] = 0;
        for(t = 8; t < this.padLength; t++)res[i++] = 0;
    }
    return res;
};

});

parcelRegister("2wnQk", function(module, exports) {

$parcel$export(module.exports, "sha1", () => $1d6110a725745f5a$export$5091bdda49ba90f5, (v) => $1d6110a725745f5a$export$5091bdda49ba90f5 = v);
$parcel$export(module.exports, "sha224", () => $1d6110a725745f5a$export$97b70509d4e397ea, (v) => $1d6110a725745f5a$export$97b70509d4e397ea = v);
$parcel$export(module.exports, "sha256", () => $1d6110a725745f5a$export$bced8d2aada2d1c9, (v) => $1d6110a725745f5a$export$bced8d2aada2d1c9 = v);
$parcel$export(module.exports, "sha384", () => $1d6110a725745f5a$export$612d47d55dedde45, (v) => $1d6110a725745f5a$export$612d47d55dedde45 = v);
$parcel$export(module.exports, "sha512", () => $1d6110a725745f5a$export$a888d2532e6dc7bb, (v) => $1d6110a725745f5a$export$a888d2532e6dc7bb = v);
var $1d6110a725745f5a$export$5091bdda49ba90f5;
var $1d6110a725745f5a$export$97b70509d4e397ea;
var $1d6110a725745f5a$export$bced8d2aada2d1c9;
var $1d6110a725745f5a$export$612d47d55dedde45;
var $1d6110a725745f5a$export$a888d2532e6dc7bb;
"use strict";

$1d6110a725745f5a$export$5091bdda49ba90f5 = (parcelRequire("IUW6G"));

$1d6110a725745f5a$export$97b70509d4e397ea = (parcelRequire("gBE2w"));

$1d6110a725745f5a$export$bced8d2aada2d1c9 = (parcelRequire("a9EzX"));

$1d6110a725745f5a$export$612d47d55dedde45 = (parcelRequire("7j4cV"));

$1d6110a725745f5a$export$a888d2532e6dc7bb = (parcelRequire("lMBCM"));

});
parcelRegister("IUW6G", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");
var $0870468534428d45$var$rotl32 = $btcbI.rotl32;
var $0870468534428d45$var$sum32 = $btcbI.sum32;
var $0870468534428d45$var$sum32_5 = $btcbI.sum32_5;
var $0870468534428d45$var$ft_1 = $dV8oa.ft_1;
var $0870468534428d45$var$BlockHash = $aAb7n.BlockHash;
var $0870468534428d45$var$sha1_K = [
    0x5A827999,
    0x6ED9EBA1,
    0x8F1BBCDC,
    0xCA62C1D6
];
function $0870468534428d45$var$SHA1() {
    if (!(this instanceof $0870468534428d45$var$SHA1)) return new $0870468534428d45$var$SHA1();
    $0870468534428d45$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.W = new Array(80);
}
$btcbI.inherits($0870468534428d45$var$SHA1, $0870468534428d45$var$BlockHash);
module.exports = $0870468534428d45$var$SHA1;
$0870468534428d45$var$SHA1.blockSize = 512;
$0870468534428d45$var$SHA1.outSize = 160;
$0870468534428d45$var$SHA1.hmacStrength = 80;
$0870468534428d45$var$SHA1.padLength = 64;
$0870468534428d45$var$SHA1.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $0870468534428d45$var$rotl32(W[i - 3] ^ W[i - 8] ^ W[i - 14] ^ W[i - 16], 1);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    for(i = 0; i < W.length; i++){
        var s = ~~(i / 20);
        var t = $0870468534428d45$var$sum32_5($0870468534428d45$var$rotl32(a, 5), $0870468534428d45$var$ft_1(s, b, c, d), e, W[i], $0870468534428d45$var$sha1_K[s]);
        e = d;
        d = c;
        c = $0870468534428d45$var$rotl32(b, 30);
        b = a;
        a = t;
    }
    this.h[0] = $0870468534428d45$var$sum32(this.h[0], a);
    this.h[1] = $0870468534428d45$var$sum32(this.h[1], b);
    this.h[2] = $0870468534428d45$var$sum32(this.h[2], c);
    this.h[3] = $0870468534428d45$var$sum32(this.h[3], d);
    this.h[4] = $0870468534428d45$var$sum32(this.h[4], e);
};
$0870468534428d45$var$SHA1.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});
parcelRegister("dV8oa", function(module, exports) {

$parcel$export(module.exports, "ft_1", () => $a2271b1744b4602b$export$5a92649d7ddb9f63, (v) => $a2271b1744b4602b$export$5a92649d7ddb9f63 = v);
$parcel$export(module.exports, "ch32", () => $a2271b1744b4602b$export$c6d0d020c3a6269, (v) => $a2271b1744b4602b$export$c6d0d020c3a6269 = v);
$parcel$export(module.exports, "maj32", () => $a2271b1744b4602b$export$eb90c27fca05f956, (v) => $a2271b1744b4602b$export$eb90c27fca05f956 = v);
$parcel$export(module.exports, "s0_256", () => $a2271b1744b4602b$export$14a4a98e063b1999, (v) => $a2271b1744b4602b$export$14a4a98e063b1999 = v);
$parcel$export(module.exports, "s1_256", () => $a2271b1744b4602b$export$d20cecfa1564c686, (v) => $a2271b1744b4602b$export$d20cecfa1564c686 = v);
$parcel$export(module.exports, "g0_256", () => $a2271b1744b4602b$export$44fd472a12fc6db, (v) => $a2271b1744b4602b$export$44fd472a12fc6db = v);
$parcel$export(module.exports, "g1_256", () => $a2271b1744b4602b$export$1ed238bb6ea1dd47, (v) => $a2271b1744b4602b$export$1ed238bb6ea1dd47 = v);
var $a2271b1744b4602b$export$5a92649d7ddb9f63;
var $a2271b1744b4602b$export$c6d0d020c3a6269;
var $a2271b1744b4602b$export$eb90c27fca05f956;
var $a2271b1744b4602b$export$cc992891a14496a1;
var $a2271b1744b4602b$export$14a4a98e063b1999;
var $a2271b1744b4602b$export$d20cecfa1564c686;
var $a2271b1744b4602b$export$44fd472a12fc6db;
var $a2271b1744b4602b$export$1ed238bb6ea1dd47;
"use strict";

var $btcbI = parcelRequire("btcbI");
var $a2271b1744b4602b$var$rotr32 = $btcbI.rotr32;
function $a2271b1744b4602b$var$ft_1(s, x, y, z) {
    if (s === 0) return $a2271b1744b4602b$var$ch32(x, y, z);
    if (s === 1 || s === 3) return $a2271b1744b4602b$var$p32(x, y, z);
    if (s === 2) return $a2271b1744b4602b$var$maj32(x, y, z);
}
$a2271b1744b4602b$export$5a92649d7ddb9f63 = $a2271b1744b4602b$var$ft_1;
function $a2271b1744b4602b$var$ch32(x, y, z) {
    return x & y ^ ~x & z;
}
$a2271b1744b4602b$export$c6d0d020c3a6269 = $a2271b1744b4602b$var$ch32;
function $a2271b1744b4602b$var$maj32(x, y, z) {
    return x & y ^ x & z ^ y & z;
}
$a2271b1744b4602b$export$eb90c27fca05f956 = $a2271b1744b4602b$var$maj32;
function $a2271b1744b4602b$var$p32(x, y, z) {
    return x ^ y ^ z;
}
$a2271b1744b4602b$export$cc992891a14496a1 = $a2271b1744b4602b$var$p32;
function $a2271b1744b4602b$var$s0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 2) ^ $a2271b1744b4602b$var$rotr32(x, 13) ^ $a2271b1744b4602b$var$rotr32(x, 22);
}
$a2271b1744b4602b$export$14a4a98e063b1999 = $a2271b1744b4602b$var$s0_256;
function $a2271b1744b4602b$var$s1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 6) ^ $a2271b1744b4602b$var$rotr32(x, 11) ^ $a2271b1744b4602b$var$rotr32(x, 25);
}
$a2271b1744b4602b$export$d20cecfa1564c686 = $a2271b1744b4602b$var$s1_256;
function $a2271b1744b4602b$var$g0_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 7) ^ $a2271b1744b4602b$var$rotr32(x, 18) ^ x >>> 3;
}
$a2271b1744b4602b$export$44fd472a12fc6db = $a2271b1744b4602b$var$g0_256;
function $a2271b1744b4602b$var$g1_256(x) {
    return $a2271b1744b4602b$var$rotr32(x, 17) ^ $a2271b1744b4602b$var$rotr32(x, 19) ^ x >>> 10;
}
$a2271b1744b4602b$export$1ed238bb6ea1dd47 = $a2271b1744b4602b$var$g1_256;

});


parcelRegister("gBE2w", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $a9EzX = parcelRequire("a9EzX");
function $c16f2915997a3b04$var$SHA224() {
    if (!(this instanceof $c16f2915997a3b04$var$SHA224)) return new $c16f2915997a3b04$var$SHA224();
    $a9EzX.call(this);
    this.h = [
        0xc1059ed8,
        0x367cd507,
        0x3070dd17,
        0xf70e5939,
        0xffc00b31,
        0x68581511,
        0x64f98fa7,
        0xbefa4fa4
    ];
}
$btcbI.inherits($c16f2915997a3b04$var$SHA224, $a9EzX);
module.exports = $c16f2915997a3b04$var$SHA224;
$c16f2915997a3b04$var$SHA224.blockSize = 512;
$c16f2915997a3b04$var$SHA224.outSize = 224;
$c16f2915997a3b04$var$SHA224.hmacStrength = 192;
$c16f2915997a3b04$var$SHA224.padLength = 64;
$c16f2915997a3b04$var$SHA224.prototype._digest = function digest(enc) {
    // Just truncate output
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 7), "big");
    else return $btcbI.split32(this.h.slice(0, 7), "big");
};

});
parcelRegister("a9EzX", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $dV8oa = parcelRequire("dV8oa");

var $koC21 = parcelRequire("koC21");
var $764a38c4cb12cffe$var$sum32 = $btcbI.sum32;
var $764a38c4cb12cffe$var$sum32_4 = $btcbI.sum32_4;
var $764a38c4cb12cffe$var$sum32_5 = $btcbI.sum32_5;
var $764a38c4cb12cffe$var$ch32 = $dV8oa.ch32;
var $764a38c4cb12cffe$var$maj32 = $dV8oa.maj32;
var $764a38c4cb12cffe$var$s0_256 = $dV8oa.s0_256;
var $764a38c4cb12cffe$var$s1_256 = $dV8oa.s1_256;
var $764a38c4cb12cffe$var$g0_256 = $dV8oa.g0_256;
var $764a38c4cb12cffe$var$g1_256 = $dV8oa.g1_256;
var $764a38c4cb12cffe$var$BlockHash = $aAb7n.BlockHash;
var $764a38c4cb12cffe$var$sha256_K = [
    0x428a2f98,
    0x71374491,
    0xb5c0fbcf,
    0xe9b5dba5,
    0x3956c25b,
    0x59f111f1,
    0x923f82a4,
    0xab1c5ed5,
    0xd807aa98,
    0x12835b01,
    0x243185be,
    0x550c7dc3,
    0x72be5d74,
    0x80deb1fe,
    0x9bdc06a7,
    0xc19bf174,
    0xe49b69c1,
    0xefbe4786,
    0x0fc19dc6,
    0x240ca1cc,
    0x2de92c6f,
    0x4a7484aa,
    0x5cb0a9dc,
    0x76f988da,
    0x983e5152,
    0xa831c66d,
    0xb00327c8,
    0xbf597fc7,
    0xc6e00bf3,
    0xd5a79147,
    0x06ca6351,
    0x14292967,
    0x27b70a85,
    0x2e1b2138,
    0x4d2c6dfc,
    0x53380d13,
    0x650a7354,
    0x766a0abb,
    0x81c2c92e,
    0x92722c85,
    0xa2bfe8a1,
    0xa81a664b,
    0xc24b8b70,
    0xc76c51a3,
    0xd192e819,
    0xd6990624,
    0xf40e3585,
    0x106aa070,
    0x19a4c116,
    0x1e376c08,
    0x2748774c,
    0x34b0bcb5,
    0x391c0cb3,
    0x4ed8aa4a,
    0x5b9cca4f,
    0x682e6ff3,
    0x748f82ee,
    0x78a5636f,
    0x84c87814,
    0x8cc70208,
    0x90befffa,
    0xa4506ceb,
    0xbef9a3f7,
    0xc67178f2
];
function $764a38c4cb12cffe$var$SHA256() {
    if (!(this instanceof $764a38c4cb12cffe$var$SHA256)) return new $764a38c4cb12cffe$var$SHA256();
    $764a38c4cb12cffe$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xbb67ae85,
        0x3c6ef372,
        0xa54ff53a,
        0x510e527f,
        0x9b05688c,
        0x1f83d9ab,
        0x5be0cd19
    ];
    this.k = $764a38c4cb12cffe$var$sha256_K;
    this.W = new Array(64);
}
$btcbI.inherits($764a38c4cb12cffe$var$SHA256, $764a38c4cb12cffe$var$BlockHash);
module.exports = $764a38c4cb12cffe$var$SHA256;
$764a38c4cb12cffe$var$SHA256.blockSize = 512;
$764a38c4cb12cffe$var$SHA256.outSize = 256;
$764a38c4cb12cffe$var$SHA256.hmacStrength = 192;
$764a38c4cb12cffe$var$SHA256.padLength = 64;
$764a38c4cb12cffe$var$SHA256.prototype._update = function _update(msg, start) {
    var W = this.W;
    for(var i = 0; i < 16; i++)W[i] = msg[start + i];
    for(; i < W.length; i++)W[i] = $764a38c4cb12cffe$var$sum32_4($764a38c4cb12cffe$var$g1_256(W[i - 2]), W[i - 7], $764a38c4cb12cffe$var$g0_256(W[i - 15]), W[i - 16]);
    var a = this.h[0];
    var b = this.h[1];
    var c = this.h[2];
    var d = this.h[3];
    var e = this.h[4];
    var f = this.h[5];
    var g = this.h[6];
    var h = this.h[7];
    $koC21(this.k.length === W.length);
    for(i = 0; i < W.length; i++){
        var T1 = $764a38c4cb12cffe$var$sum32_5(h, $764a38c4cb12cffe$var$s1_256(e), $764a38c4cb12cffe$var$ch32(e, f, g), this.k[i], W[i]);
        var T2 = $764a38c4cb12cffe$var$sum32($764a38c4cb12cffe$var$s0_256(a), $764a38c4cb12cffe$var$maj32(a, b, c));
        h = g;
        g = f;
        f = e;
        e = $764a38c4cb12cffe$var$sum32(d, T1);
        d = c;
        c = b;
        b = a;
        a = $764a38c4cb12cffe$var$sum32(T1, T2);
    }
    this.h[0] = $764a38c4cb12cffe$var$sum32(this.h[0], a);
    this.h[1] = $764a38c4cb12cffe$var$sum32(this.h[1], b);
    this.h[2] = $764a38c4cb12cffe$var$sum32(this.h[2], c);
    this.h[3] = $764a38c4cb12cffe$var$sum32(this.h[3], d);
    this.h[4] = $764a38c4cb12cffe$var$sum32(this.h[4], e);
    this.h[5] = $764a38c4cb12cffe$var$sum32(this.h[5], f);
    this.h[6] = $764a38c4cb12cffe$var$sum32(this.h[6], g);
    this.h[7] = $764a38c4cb12cffe$var$sum32(this.h[7], h);
};
$764a38c4cb12cffe$var$SHA256.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};

});


parcelRegister("7j4cV", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $lMBCM = parcelRequire("lMBCM");
function $551d923eb49b8fc5$var$SHA384() {
    if (!(this instanceof $551d923eb49b8fc5$var$SHA384)) return new $551d923eb49b8fc5$var$SHA384();
    $lMBCM.call(this);
    this.h = [
        0xcbbb9d5d,
        0xc1059ed8,
        0x629a292a,
        0x367cd507,
        0x9159015a,
        0x3070dd17,
        0x152fecd8,
        0xf70e5939,
        0x67332667,
        0xffc00b31,
        0x8eb44a87,
        0x68581511,
        0xdb0c2e0d,
        0x64f98fa7,
        0x47b5481d,
        0xbefa4fa4
    ];
}
$btcbI.inherits($551d923eb49b8fc5$var$SHA384, $lMBCM);
module.exports = $551d923eb49b8fc5$var$SHA384;
$551d923eb49b8fc5$var$SHA384.blockSize = 1024;
$551d923eb49b8fc5$var$SHA384.outSize = 384;
$551d923eb49b8fc5$var$SHA384.hmacStrength = 192;
$551d923eb49b8fc5$var$SHA384.padLength = 128;
$551d923eb49b8fc5$var$SHA384.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h.slice(0, 12), "big");
    else return $btcbI.split32(this.h.slice(0, 12), "big");
};

});
parcelRegister("lMBCM", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");

var $koC21 = parcelRequire("koC21");
var $fdbb441c0566fb85$var$rotr64_hi = $btcbI.rotr64_hi;
var $fdbb441c0566fb85$var$rotr64_lo = $btcbI.rotr64_lo;
var $fdbb441c0566fb85$var$shr64_hi = $btcbI.shr64_hi;
var $fdbb441c0566fb85$var$shr64_lo = $btcbI.shr64_lo;
var $fdbb441c0566fb85$var$sum64 = $btcbI.sum64;
var $fdbb441c0566fb85$var$sum64_hi = $btcbI.sum64_hi;
var $fdbb441c0566fb85$var$sum64_lo = $btcbI.sum64_lo;
var $fdbb441c0566fb85$var$sum64_4_hi = $btcbI.sum64_4_hi;
var $fdbb441c0566fb85$var$sum64_4_lo = $btcbI.sum64_4_lo;
var $fdbb441c0566fb85$var$sum64_5_hi = $btcbI.sum64_5_hi;
var $fdbb441c0566fb85$var$sum64_5_lo = $btcbI.sum64_5_lo;
var $fdbb441c0566fb85$var$BlockHash = $aAb7n.BlockHash;
var $fdbb441c0566fb85$var$sha512_K = [
    0x428a2f98,
    0xd728ae22,
    0x71374491,
    0x23ef65cd,
    0xb5c0fbcf,
    0xec4d3b2f,
    0xe9b5dba5,
    0x8189dbbc,
    0x3956c25b,
    0xf348b538,
    0x59f111f1,
    0xb605d019,
    0x923f82a4,
    0xaf194f9b,
    0xab1c5ed5,
    0xda6d8118,
    0xd807aa98,
    0xa3030242,
    0x12835b01,
    0x45706fbe,
    0x243185be,
    0x4ee4b28c,
    0x550c7dc3,
    0xd5ffb4e2,
    0x72be5d74,
    0xf27b896f,
    0x80deb1fe,
    0x3b1696b1,
    0x9bdc06a7,
    0x25c71235,
    0xc19bf174,
    0xcf692694,
    0xe49b69c1,
    0x9ef14ad2,
    0xefbe4786,
    0x384f25e3,
    0x0fc19dc6,
    0x8b8cd5b5,
    0x240ca1cc,
    0x77ac9c65,
    0x2de92c6f,
    0x592b0275,
    0x4a7484aa,
    0x6ea6e483,
    0x5cb0a9dc,
    0xbd41fbd4,
    0x76f988da,
    0x831153b5,
    0x983e5152,
    0xee66dfab,
    0xa831c66d,
    0x2db43210,
    0xb00327c8,
    0x98fb213f,
    0xbf597fc7,
    0xbeef0ee4,
    0xc6e00bf3,
    0x3da88fc2,
    0xd5a79147,
    0x930aa725,
    0x06ca6351,
    0xe003826f,
    0x14292967,
    0x0a0e6e70,
    0x27b70a85,
    0x46d22ffc,
    0x2e1b2138,
    0x5c26c926,
    0x4d2c6dfc,
    0x5ac42aed,
    0x53380d13,
    0x9d95b3df,
    0x650a7354,
    0x8baf63de,
    0x766a0abb,
    0x3c77b2a8,
    0x81c2c92e,
    0x47edaee6,
    0x92722c85,
    0x1482353b,
    0xa2bfe8a1,
    0x4cf10364,
    0xa81a664b,
    0xbc423001,
    0xc24b8b70,
    0xd0f89791,
    0xc76c51a3,
    0x0654be30,
    0xd192e819,
    0xd6ef5218,
    0xd6990624,
    0x5565a910,
    0xf40e3585,
    0x5771202a,
    0x106aa070,
    0x32bbd1b8,
    0x19a4c116,
    0xb8d2d0c8,
    0x1e376c08,
    0x5141ab53,
    0x2748774c,
    0xdf8eeb99,
    0x34b0bcb5,
    0xe19b48a8,
    0x391c0cb3,
    0xc5c95a63,
    0x4ed8aa4a,
    0xe3418acb,
    0x5b9cca4f,
    0x7763e373,
    0x682e6ff3,
    0xd6b2b8a3,
    0x748f82ee,
    0x5defb2fc,
    0x78a5636f,
    0x43172f60,
    0x84c87814,
    0xa1f0ab72,
    0x8cc70208,
    0x1a6439ec,
    0x90befffa,
    0x23631e28,
    0xa4506ceb,
    0xde82bde9,
    0xbef9a3f7,
    0xb2c67915,
    0xc67178f2,
    0xe372532b,
    0xca273ece,
    0xea26619c,
    0xd186b8c7,
    0x21c0c207,
    0xeada7dd6,
    0xcde0eb1e,
    0xf57d4f7f,
    0xee6ed178,
    0x06f067aa,
    0x72176fba,
    0x0a637dc5,
    0xa2c898a6,
    0x113f9804,
    0xbef90dae,
    0x1b710b35,
    0x131c471b,
    0x28db77f5,
    0x23047d84,
    0x32caab7b,
    0x40c72493,
    0x3c9ebe0a,
    0x15c9bebc,
    0x431d67c4,
    0x9c100d4c,
    0x4cc5d4be,
    0xcb3e42b6,
    0x597f299c,
    0xfc657e2a,
    0x5fcb6fab,
    0x3ad6faec,
    0x6c44198c,
    0x4a475817
];
function $fdbb441c0566fb85$var$SHA512() {
    if (!(this instanceof $fdbb441c0566fb85$var$SHA512)) return new $fdbb441c0566fb85$var$SHA512();
    $fdbb441c0566fb85$var$BlockHash.call(this);
    this.h = [
        0x6a09e667,
        0xf3bcc908,
        0xbb67ae85,
        0x84caa73b,
        0x3c6ef372,
        0xfe94f82b,
        0xa54ff53a,
        0x5f1d36f1,
        0x510e527f,
        0xade682d1,
        0x9b05688c,
        0x2b3e6c1f,
        0x1f83d9ab,
        0xfb41bd6b,
        0x5be0cd19,
        0x137e2179
    ];
    this.k = $fdbb441c0566fb85$var$sha512_K;
    this.W = new Array(160);
}
$btcbI.inherits($fdbb441c0566fb85$var$SHA512, $fdbb441c0566fb85$var$BlockHash);
module.exports = $fdbb441c0566fb85$var$SHA512;
$fdbb441c0566fb85$var$SHA512.blockSize = 1024;
$fdbb441c0566fb85$var$SHA512.outSize = 512;
$fdbb441c0566fb85$var$SHA512.hmacStrength = 192;
$fdbb441c0566fb85$var$SHA512.padLength = 128;
$fdbb441c0566fb85$var$SHA512.prototype._prepareBlock = function _prepareBlock(msg, start) {
    var W = this.W;
    // 32 x 32bit words
    for(var i = 0; i < 32; i++)W[i] = msg[start + i];
    for(; i < W.length; i += 2){
        var c0_hi = $fdbb441c0566fb85$var$g1_512_hi(W[i - 4], W[i - 3]); // i - 2
        var c0_lo = $fdbb441c0566fb85$var$g1_512_lo(W[i - 4], W[i - 3]);
        var c1_hi = W[i - 14]; // i - 7
        var c1_lo = W[i - 13];
        var c2_hi = $fdbb441c0566fb85$var$g0_512_hi(W[i - 30], W[i - 29]); // i - 15
        var c2_lo = $fdbb441c0566fb85$var$g0_512_lo(W[i - 30], W[i - 29]);
        var c3_hi = W[i - 32]; // i - 16
        var c3_lo = W[i - 31];
        W[i] = $fdbb441c0566fb85$var$sum64_4_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
        W[i + 1] = $fdbb441c0566fb85$var$sum64_4_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo);
    }
};
$fdbb441c0566fb85$var$SHA512.prototype._update = function _update(msg, start) {
    this._prepareBlock(msg, start);
    var W = this.W;
    var ah = this.h[0];
    var al = this.h[1];
    var bh = this.h[2];
    var bl = this.h[3];
    var ch = this.h[4];
    var cl = this.h[5];
    var dh = this.h[6];
    var dl = this.h[7];
    var eh = this.h[8];
    var el = this.h[9];
    var fh = this.h[10];
    var fl = this.h[11];
    var gh = this.h[12];
    var gl = this.h[13];
    var hh = this.h[14];
    var hl = this.h[15];
    $koC21(this.k.length === W.length);
    for(var i = 0; i < W.length; i += 2){
        var c0_hi = hh;
        var c0_lo = hl;
        var c1_hi = $fdbb441c0566fb85$var$s1_512_hi(eh, el);
        var c1_lo = $fdbb441c0566fb85$var$s1_512_lo(eh, el);
        var c2_hi = $fdbb441c0566fb85$var$ch64_hi(eh, el, fh, fl, gh, gl);
        var c2_lo = $fdbb441c0566fb85$var$ch64_lo(eh, el, fh, fl, gh, gl);
        var c3_hi = this.k[i];
        var c3_lo = this.k[i + 1];
        var c4_hi = W[i];
        var c4_lo = W[i + 1];
        var T1_hi = $fdbb441c0566fb85$var$sum64_5_hi(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        var T1_lo = $fdbb441c0566fb85$var$sum64_5_lo(c0_hi, c0_lo, c1_hi, c1_lo, c2_hi, c2_lo, c3_hi, c3_lo, c4_hi, c4_lo);
        c0_hi = $fdbb441c0566fb85$var$s0_512_hi(ah, al);
        c0_lo = $fdbb441c0566fb85$var$s0_512_lo(ah, al);
        c1_hi = $fdbb441c0566fb85$var$maj64_hi(ah, al, bh, bl, ch, cl);
        c1_lo = $fdbb441c0566fb85$var$maj64_lo(ah, al, bh, bl, ch, cl);
        var T2_hi = $fdbb441c0566fb85$var$sum64_hi(c0_hi, c0_lo, c1_hi, c1_lo);
        var T2_lo = $fdbb441c0566fb85$var$sum64_lo(c0_hi, c0_lo, c1_hi, c1_lo);
        hh = gh;
        hl = gl;
        gh = fh;
        gl = fl;
        fh = eh;
        fl = el;
        eh = $fdbb441c0566fb85$var$sum64_hi(dh, dl, T1_hi, T1_lo);
        el = $fdbb441c0566fb85$var$sum64_lo(dl, dl, T1_hi, T1_lo);
        dh = ch;
        dl = cl;
        ch = bh;
        cl = bl;
        bh = ah;
        bl = al;
        ah = $fdbb441c0566fb85$var$sum64_hi(T1_hi, T1_lo, T2_hi, T2_lo);
        al = $fdbb441c0566fb85$var$sum64_lo(T1_hi, T1_lo, T2_hi, T2_lo);
    }
    $fdbb441c0566fb85$var$sum64(this.h, 0, ah, al);
    $fdbb441c0566fb85$var$sum64(this.h, 2, bh, bl);
    $fdbb441c0566fb85$var$sum64(this.h, 4, ch, cl);
    $fdbb441c0566fb85$var$sum64(this.h, 6, dh, dl);
    $fdbb441c0566fb85$var$sum64(this.h, 8, eh, el);
    $fdbb441c0566fb85$var$sum64(this.h, 10, fh, fl);
    $fdbb441c0566fb85$var$sum64(this.h, 12, gh, gl);
    $fdbb441c0566fb85$var$sum64(this.h, 14, hh, hl);
};
$fdbb441c0566fb85$var$SHA512.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "big");
    else return $btcbI.split32(this.h, "big");
};
function $fdbb441c0566fb85$var$ch64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ ~xh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$ch64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ ~xl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_hi(xh, xl, yh, yl, zh) {
    var r = xh & yh ^ xh & zh ^ yh & zh;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$maj64_lo(xh, xl, yh, yl, zh, zl) {
    var r = xl & yl ^ xl & zl ^ yl & zl;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 28);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 2); // 34
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 7); // 39
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 28);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 2); // 34
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 7); // 39
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 14);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 18);
    var c2_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 9); // 41
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$s1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 14);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 18);
    var c2_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 9); // 41
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 1);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 8);
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 7);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g0_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 1);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 8);
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 7);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_hi(xh, xl) {
    var c0_hi = $fdbb441c0566fb85$var$rotr64_hi(xh, xl, 19);
    var c1_hi = $fdbb441c0566fb85$var$rotr64_hi(xl, xh, 29); // 61
    var c2_hi = $fdbb441c0566fb85$var$shr64_hi(xh, xl, 6);
    var r = c0_hi ^ c1_hi ^ c2_hi;
    if (r < 0) r += 0x100000000;
    return r;
}
function $fdbb441c0566fb85$var$g1_512_lo(xh, xl) {
    var c0_lo = $fdbb441c0566fb85$var$rotr64_lo(xh, xl, 19);
    var c1_lo = $fdbb441c0566fb85$var$rotr64_lo(xl, xh, 29); // 61
    var c2_lo = $fdbb441c0566fb85$var$shr64_lo(xh, xl, 6);
    var r = c0_lo ^ c1_lo ^ c2_lo;
    if (r < 0) r += 0x100000000;
    return r;
}

});



parcelRegister("05eZB", function(module, exports) {

$parcel$export(module.exports, "ripemd160", () => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e, (v) => $00fc18f316764a3b$export$d1cea0ee4e3f0d3e = v);
var $00fc18f316764a3b$export$d1cea0ee4e3f0d3e;
"use strict";

var $btcbI = parcelRequire("btcbI");

var $aAb7n = parcelRequire("aAb7n");
var $00fc18f316764a3b$var$rotl32 = $btcbI.rotl32;
var $00fc18f316764a3b$var$sum32 = $btcbI.sum32;
var $00fc18f316764a3b$var$sum32_3 = $btcbI.sum32_3;
var $00fc18f316764a3b$var$sum32_4 = $btcbI.sum32_4;
var $00fc18f316764a3b$var$BlockHash = $aAb7n.BlockHash;
function $00fc18f316764a3b$var$RIPEMD160() {
    if (!(this instanceof $00fc18f316764a3b$var$RIPEMD160)) return new $00fc18f316764a3b$var$RIPEMD160();
    $00fc18f316764a3b$var$BlockHash.call(this);
    this.h = [
        0x67452301,
        0xefcdab89,
        0x98badcfe,
        0x10325476,
        0xc3d2e1f0
    ];
    this.endian = "little";
}
$btcbI.inherits($00fc18f316764a3b$var$RIPEMD160, $00fc18f316764a3b$var$BlockHash);
$00fc18f316764a3b$export$d1cea0ee4e3f0d3e = $00fc18f316764a3b$var$RIPEMD160;
$00fc18f316764a3b$var$RIPEMD160.blockSize = 512;
$00fc18f316764a3b$var$RIPEMD160.outSize = 160;
$00fc18f316764a3b$var$RIPEMD160.hmacStrength = 192;
$00fc18f316764a3b$var$RIPEMD160.padLength = 64;
$00fc18f316764a3b$var$RIPEMD160.prototype._update = function update(msg, start) {
    var A = this.h[0];
    var B = this.h[1];
    var C = this.h[2];
    var D = this.h[3];
    var E = this.h[4];
    var Ah = A;
    var Bh = B;
    var Ch = C;
    var Dh = D;
    var Eh = E;
    for(var j = 0; j < 80; j++){
        var T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(A, $00fc18f316764a3b$var$f(j, B, C, D), msg[$00fc18f316764a3b$var$r[j] + start], $00fc18f316764a3b$var$K(j)), $00fc18f316764a3b$var$s[j]), E);
        A = E;
        E = D;
        D = $00fc18f316764a3b$var$rotl32(C, 10);
        C = B;
        B = T;
        T = $00fc18f316764a3b$var$sum32($00fc18f316764a3b$var$rotl32($00fc18f316764a3b$var$sum32_4(Ah, $00fc18f316764a3b$var$f(79 - j, Bh, Ch, Dh), msg[$00fc18f316764a3b$var$rh[j] + start], $00fc18f316764a3b$var$Kh(j)), $00fc18f316764a3b$var$sh[j]), Eh);
        Ah = Eh;
        Eh = Dh;
        Dh = $00fc18f316764a3b$var$rotl32(Ch, 10);
        Ch = Bh;
        Bh = T;
    }
    T = $00fc18f316764a3b$var$sum32_3(this.h[1], C, Dh);
    this.h[1] = $00fc18f316764a3b$var$sum32_3(this.h[2], D, Eh);
    this.h[2] = $00fc18f316764a3b$var$sum32_3(this.h[3], E, Ah);
    this.h[3] = $00fc18f316764a3b$var$sum32_3(this.h[4], A, Bh);
    this.h[4] = $00fc18f316764a3b$var$sum32_3(this.h[0], B, Ch);
    this.h[0] = T;
};
$00fc18f316764a3b$var$RIPEMD160.prototype._digest = function digest(enc) {
    if (enc === "hex") return $btcbI.toHex32(this.h, "little");
    else return $btcbI.split32(this.h, "little");
};
function $00fc18f316764a3b$var$f(j, x, y, z) {
    if (j <= 15) return x ^ y ^ z;
    else if (j <= 31) return x & y | ~x & z;
    else if (j <= 47) return (x | ~y) ^ z;
    else if (j <= 63) return x & z | y & ~z;
    else return x ^ (y | ~z);
}
function $00fc18f316764a3b$var$K(j) {
    if (j <= 15) return 0x00000000;
    else if (j <= 31) return 0x5a827999;
    else if (j <= 47) return 0x6ed9eba1;
    else if (j <= 63) return 0x8f1bbcdc;
    else return 0xa953fd4e;
}
function $00fc18f316764a3b$var$Kh(j) {
    if (j <= 15) return 0x50a28be6;
    else if (j <= 31) return 0x5c4dd124;
    else if (j <= 47) return 0x6d703ef3;
    else if (j <= 63) return 0x7a6d76e9;
    else return 0x00000000;
}
var $00fc18f316764a3b$var$r = [
    0,
    1,
    2,
    3,
    4,
    5,
    6,
    7,
    8,
    9,
    10,
    11,
    12,
    13,
    14,
    15,
    7,
    4,
    13,
    1,
    10,
    6,
    15,
    3,
    12,
    0,
    9,
    5,
    2,
    14,
    11,
    8,
    3,
    10,
    14,
    4,
    9,
    15,
    8,
    1,
    2,
    7,
    0,
    6,
    13,
    11,
    5,
    12,
    1,
    9,
    11,
    10,
    0,
    8,
    12,
    4,
    13,
    3,
    7,
    15,
    14,
    5,
    6,
    2,
    4,
    0,
    5,
    9,
    7,
    12,
    2,
    10,
    14,
    1,
    3,
    8,
    11,
    6,
    15,
    13
];
var $00fc18f316764a3b$var$rh = [
    5,
    14,
    7,
    0,
    9,
    2,
    11,
    4,
    13,
    6,
    15,
    8,
    1,
    10,
    3,
    12,
    6,
    11,
    3,
    7,
    0,
    13,
    5,
    10,
    14,
    15,
    8,
    12,
    4,
    9,
    1,
    2,
    15,
    5,
    1,
    3,
    7,
    14,
    6,
    9,
    11,
    8,
    12,
    2,
    10,
    0,
    4,
    13,
    8,
    6,
    4,
    1,
    3,
    11,
    15,
    0,
    5,
    12,
    2,
    13,
    9,
    7,
    10,
    14,
    12,
    15,
    10,
    4,
    1,
    5,
    8,
    7,
    6,
    2,
    13,
    14,
    0,
    3,
    9,
    11
];
var $00fc18f316764a3b$var$s = [
    11,
    14,
    15,
    12,
    5,
    8,
    7,
    9,
    11,
    13,
    14,
    15,
    6,
    7,
    9,
    8,
    7,
    6,
    8,
    13,
    11,
    9,
    7,
    15,
    7,
    12,
    15,
    9,
    11,
    7,
    13,
    12,
    11,
    13,
    6,
    7,
    14,
    9,
    13,
    15,
    14,
    8,
    13,
    6,
    5,
    12,
    7,
    5,
    11,
    12,
    14,
    15,
    14,
    15,
    9,
    8,
    9,
    14,
    5,
    6,
    8,
    6,
    5,
    12,
    9,
    15,
    5,
    11,
    6,
    8,
    13,
    12,
    5,
    12,
    13,
    14,
    11,
    8,
    5,
    6
];
var $00fc18f316764a3b$var$sh = [
    8,
    9,
    9,
    11,
    13,
    15,
    15,
    5,
    7,
    7,
    8,
    11,
    14,
    14,
    12,
    6,
    9,
    13,
    15,
    7,
    12,
    8,
    9,
    11,
    7,
    7,
    12,
    7,
    6,
    15,
    13,
    11,
    9,
    7,
    15,
    11,
    8,
    6,
    6,
    14,
    12,
    13,
    5,
    14,
    13,
    13,
    7,
    5,
    15,
    5,
    8,
    11,
    14,
    14,
    6,
    14,
    6,
    9,
    12,
    9,
    12,
    5,
    15,
    8,
    8,
    5,
    12,
    9,
    12,
    5,
    14,
    6,
    8,
    13,
    6,
    5,
    15,
    13,
    11,
    11
];

});

parcelRegister("ap2lu", function(module, exports) {
"use strict";

var $btcbI = parcelRequire("btcbI");

var $koC21 = parcelRequire("koC21");
function $792e0ef6fa035d02$var$Hmac(hash, key, enc) {
    if (!(this instanceof $792e0ef6fa035d02$var$Hmac)) return new $792e0ef6fa035d02$var$Hmac(hash, key, enc);
    this.Hash = hash;
    this.blockSize = hash.blockSize / 8;
    this.outSize = hash.outSize / 8;
    this.inner = null;
    this.outer = null;
    this._init($btcbI.toArray(key, enc));
}
module.exports = $792e0ef6fa035d02$var$Hmac;
$792e0ef6fa035d02$var$Hmac.prototype._init = function init(key) {
    // Shorten key, if needed
    if (key.length > this.blockSize) key = new this.Hash().update(key).digest();
    $koC21(key.length <= this.blockSize);
    // Add padding to key
    for(var i = key.length; i < this.blockSize; i++)key.push(0);
    for(i = 0; i < key.length; i++)key[i] ^= 0x36;
    this.inner = new this.Hash().update(key);
    // 0x36 ^ 0x5c = 0x6a
    for(i = 0; i < key.length; i++)key[i] ^= 0x6a;
    this.outer = new this.Hash().update(key);
};
$792e0ef6fa035d02$var$Hmac.prototype.update = function update(msg, enc) {
    this.inner.update(msg, enc);
    return this;
};
$792e0ef6fa035d02$var$Hmac.prototype.digest = function digest(enc) {
    this.outer.update(this.inner.digest());
    return this.outer.digest(enc);
};

});


parcelRegister("lNVWe", function(module, exports) {
module.exports = {
    doubles: {
        step: 4,
        points: [
            [
                "e60fce93b59e9ec53011aabc21c23e97b2a31369b87a5ae9c44ee89e2a6dec0a",
                "f7e3507399e595929db99f34f57937101296891e44d23f0be1f32cce69616821"
            ],
            [
                "8282263212c609d9ea2a6e3e172de238d8c39cabd5ac1ca10646e23fd5f51508",
                "11f8a8098557dfe45e8256e830b60ace62d613ac2f7b17bed31b6eaff6e26caf"
            ],
            [
                "175e159f728b865a72f99cc6c6fc846de0b93833fd2222ed73fce5b551e5b739",
                "d3506e0d9e3c79eba4ef97a51ff71f5eacb5955add24345c6efa6ffee9fed695"
            ],
            [
                "363d90d447b00c9c99ceac05b6262ee053441c7e55552ffe526bad8f83ff4640",
                "4e273adfc732221953b445397f3363145b9a89008199ecb62003c7f3bee9de9"
            ],
            [
                "8b4b5f165df3c2be8c6244b5b745638843e4a781a15bcd1b69f79a55dffdf80c",
                "4aad0a6f68d308b4b3fbd7813ab0da04f9e336546162ee56b3eff0c65fd4fd36"
            ],
            [
                "723cbaa6e5db996d6bf771c00bd548c7b700dbffa6c0e77bcb6115925232fcda",
                "96e867b5595cc498a921137488824d6e2660a0653779494801dc069d9eb39f5f"
            ],
            [
                "eebfa4d493bebf98ba5feec812c2d3b50947961237a919839a533eca0e7dd7fa",
                "5d9a8ca3970ef0f269ee7edaf178089d9ae4cdc3a711f712ddfd4fdae1de8999"
            ],
            [
                "100f44da696e71672791d0a09b7bde459f1215a29b3c03bfefd7835b39a48db0",
                "cdd9e13192a00b772ec8f3300c090666b7ff4a18ff5195ac0fbd5cd62bc65a09"
            ],
            [
                "e1031be262c7ed1b1dc9227a4a04c017a77f8d4464f3b3852c8acde6e534fd2d",
                "9d7061928940405e6bb6a4176597535af292dd419e1ced79a44f18f29456a00d"
            ],
            [
                "feea6cae46d55b530ac2839f143bd7ec5cf8b266a41d6af52d5e688d9094696d",
                "e57c6b6c97dce1bab06e4e12bf3ecd5c981c8957cc41442d3155debf18090088"
            ],
            [
                "da67a91d91049cdcb367be4be6ffca3cfeed657d808583de33fa978bc1ec6cb1",
                "9bacaa35481642bc41f463f7ec9780e5dec7adc508f740a17e9ea8e27a68be1d"
            ],
            [
                "53904faa0b334cdda6e000935ef22151ec08d0f7bb11069f57545ccc1a37b7c0",
                "5bc087d0bc80106d88c9eccac20d3c1c13999981e14434699dcb096b022771c8"
            ],
            [
                "8e7bcd0bd35983a7719cca7764ca906779b53a043a9b8bcaeff959f43ad86047",
                "10b7770b2a3da4b3940310420ca9514579e88e2e47fd68b3ea10047e8460372a"
            ],
            [
                "385eed34c1cdff21e6d0818689b81bde71a7f4f18397e6690a841e1599c43862",
                "283bebc3e8ea23f56701de19e9ebf4576b304eec2086dc8cc0458fe5542e5453"
            ],
            [
                "6f9d9b803ecf191637c73a4413dfa180fddf84a5947fbc9c606ed86c3fac3a7",
                "7c80c68e603059ba69b8e2a30e45c4d47ea4dd2f5c281002d86890603a842160"
            ],
            [
                "3322d401243c4e2582a2147c104d6ecbf774d163db0f5e5313b7e0e742d0e6bd",
                "56e70797e9664ef5bfb019bc4ddaf9b72805f63ea2873af624f3a2e96c28b2a0"
            ],
            [
                "85672c7d2de0b7da2bd1770d89665868741b3f9af7643397721d74d28134ab83",
                "7c481b9b5b43b2eb6374049bfa62c2e5e77f17fcc5298f44c8e3094f790313a6"
            ],
            [
                "948bf809b1988a46b06c9f1919413b10f9226c60f668832ffd959af60c82a0a",
                "53a562856dcb6646dc6b74c5d1c3418c6d4dff08c97cd2bed4cb7f88d8c8e589"
            ],
            [
                "6260ce7f461801c34f067ce0f02873a8f1b0e44dfc69752accecd819f38fd8e8",
                "bc2da82b6fa5b571a7f09049776a1ef7ecd292238051c198c1a84e95b2b4ae17"
            ],
            [
                "e5037de0afc1d8d43d8348414bbf4103043ec8f575bfdc432953cc8d2037fa2d",
                "4571534baa94d3b5f9f98d09fb990bddbd5f5b03ec481f10e0e5dc841d755bda"
            ],
            [
                "e06372b0f4a207adf5ea905e8f1771b4e7e8dbd1c6a6c5b725866a0ae4fce725",
                "7a908974bce18cfe12a27bb2ad5a488cd7484a7787104870b27034f94eee31dd"
            ],
            [
                "213c7a715cd5d45358d0bbf9dc0ce02204b10bdde2a3f58540ad6908d0559754",
                "4b6dad0b5ae462507013ad06245ba190bb4850f5f36a7eeddff2c27534b458f2"
            ],
            [
                "4e7c272a7af4b34e8dbb9352a5419a87e2838c70adc62cddf0cc3a3b08fbd53c",
                "17749c766c9d0b18e16fd09f6def681b530b9614bff7dd33e0b3941817dcaae6"
            ],
            [
                "fea74e3dbe778b1b10f238ad61686aa5c76e3db2be43057632427e2840fb27b6",
                "6e0568db9b0b13297cf674deccb6af93126b596b973f7b77701d3db7f23cb96f"
            ],
            [
                "76e64113f677cf0e10a2570d599968d31544e179b760432952c02a4417bdde39",
                "c90ddf8dee4e95cf577066d70681f0d35e2a33d2b56d2032b4b1752d1901ac01"
            ],
            [
                "c738c56b03b2abe1e8281baa743f8f9a8f7cc643df26cbee3ab150242bcbb891",
                "893fb578951ad2537f718f2eacbfbbbb82314eef7880cfe917e735d9699a84c3"
            ],
            [
                "d895626548b65b81e264c7637c972877d1d72e5f3a925014372e9f6588f6c14b",
                "febfaa38f2bc7eae728ec60818c340eb03428d632bb067e179363ed75d7d991f"
            ],
            [
                "b8da94032a957518eb0f6433571e8761ceffc73693e84edd49150a564f676e03",
                "2804dfa44805a1e4d7c99cc9762808b092cc584d95ff3b511488e4e74efdf6e7"
            ],
            [
                "e80fea14441fb33a7d8adab9475d7fab2019effb5156a792f1a11778e3c0df5d",
                "eed1de7f638e00771e89768ca3ca94472d155e80af322ea9fcb4291b6ac9ec78"
            ],
            [
                "a301697bdfcd704313ba48e51d567543f2a182031efd6915ddc07bbcc4e16070",
                "7370f91cfb67e4f5081809fa25d40f9b1735dbf7c0a11a130c0d1a041e177ea1"
            ],
            [
                "90ad85b389d6b936463f9d0512678de208cc330b11307fffab7ac63e3fb04ed4",
                "e507a3620a38261affdcbd9427222b839aefabe1582894d991d4d48cb6ef150"
            ],
            [
                "8f68b9d2f63b5f339239c1ad981f162ee88c5678723ea3351b7b444c9ec4c0da",
                "662a9f2dba063986de1d90c2b6be215dbbea2cfe95510bfdf23cbf79501fff82"
            ],
            [
                "e4f3fb0176af85d65ff99ff9198c36091f48e86503681e3e6686fd5053231e11",
                "1e63633ad0ef4f1c1661a6d0ea02b7286cc7e74ec951d1c9822c38576feb73bc"
            ],
            [
                "8c00fa9b18ebf331eb961537a45a4266c7034f2f0d4e1d0716fb6eae20eae29e",
                "efa47267fea521a1a9dc343a3736c974c2fadafa81e36c54e7d2a4c66702414b"
            ],
            [
                "e7a26ce69dd4829f3e10cec0a9e98ed3143d084f308b92c0997fddfc60cb3e41",
                "2a758e300fa7984b471b006a1aafbb18d0a6b2c0420e83e20e8a9421cf2cfd51"
            ],
            [
                "b6459e0ee3662ec8d23540c223bcbdc571cbcb967d79424f3cf29eb3de6b80ef",
                "67c876d06f3e06de1dadf16e5661db3c4b3ae6d48e35b2ff30bf0b61a71ba45"
            ],
            [
                "d68a80c8280bb840793234aa118f06231d6f1fc67e73c5a5deda0f5b496943e8",
                "db8ba9fff4b586d00c4b1f9177b0e28b5b0e7b8f7845295a294c84266b133120"
            ],
            [
                "324aed7df65c804252dc0270907a30b09612aeb973449cea4095980fc28d3d5d",
                "648a365774b61f2ff130c0c35aec1f4f19213b0c7e332843967224af96ab7c84"
            ],
            [
                "4df9c14919cde61f6d51dfdbe5fee5dceec4143ba8d1ca888e8bd373fd054c96",
                "35ec51092d8728050974c23a1d85d4b5d506cdc288490192ebac06cad10d5d"
            ],
            [
                "9c3919a84a474870faed8a9c1cc66021523489054d7f0308cbfc99c8ac1f98cd",
                "ddb84f0f4a4ddd57584f044bf260e641905326f76c64c8e6be7e5e03d4fc599d"
            ],
            [
                "6057170b1dd12fdf8de05f281d8e06bb91e1493a8b91d4cc5a21382120a959e5",
                "9a1af0b26a6a4807add9a2daf71df262465152bc3ee24c65e899be932385a2a8"
            ],
            [
                "a576df8e23a08411421439a4518da31880cef0fba7d4df12b1a6973eecb94266",
                "40a6bf20e76640b2c92b97afe58cd82c432e10a7f514d9f3ee8be11ae1b28ec8"
            ],
            [
                "7778a78c28dec3e30a05fe9629de8c38bb30d1f5cf9a3a208f763889be58ad71",
                "34626d9ab5a5b22ff7098e12f2ff580087b38411ff24ac563b513fc1fd9f43ac"
            ],
            [
                "928955ee637a84463729fd30e7afd2ed5f96274e5ad7e5cb09eda9c06d903ac",
                "c25621003d3f42a827b78a13093a95eeac3d26efa8a8d83fc5180e935bcd091f"
            ],
            [
                "85d0fef3ec6db109399064f3a0e3b2855645b4a907ad354527aae75163d82751",
                "1f03648413a38c0be29d496e582cf5663e8751e96877331582c237a24eb1f962"
            ],
            [
                "ff2b0dce97eece97c1c9b6041798b85dfdfb6d8882da20308f5404824526087e",
                "493d13fef524ba188af4c4dc54d07936c7b7ed6fb90e2ceb2c951e01f0c29907"
            ],
            [
                "827fbbe4b1e880ea9ed2b2e6301b212b57f1ee148cd6dd28780e5e2cf856e241",
                "c60f9c923c727b0b71bef2c67d1d12687ff7a63186903166d605b68baec293ec"
            ],
            [
                "eaa649f21f51bdbae7be4ae34ce6e5217a58fdce7f47f9aa7f3b58fa2120e2b3",
                "be3279ed5bbbb03ac69a80f89879aa5a01a6b965f13f7e59d47a5305ba5ad93d"
            ],
            [
                "e4a42d43c5cf169d9391df6decf42ee541b6d8f0c9a137401e23632dda34d24f",
                "4d9f92e716d1c73526fc99ccfb8ad34ce886eedfa8d8e4f13a7f7131deba9414"
            ],
            [
                "1ec80fef360cbdd954160fadab352b6b92b53576a88fea4947173b9d4300bf19",
                "aeefe93756b5340d2f3a4958a7abbf5e0146e77f6295a07b671cdc1cc107cefd"
            ],
            [
                "146a778c04670c2f91b00af4680dfa8bce3490717d58ba889ddb5928366642be",
                "b318e0ec3354028add669827f9d4b2870aaa971d2f7e5ed1d0b297483d83efd0"
            ],
            [
                "fa50c0f61d22e5f07e3acebb1aa07b128d0012209a28b9776d76a8793180eef9",
                "6b84c6922397eba9b72cd2872281a68a5e683293a57a213b38cd8d7d3f4f2811"
            ],
            [
                "da1d61d0ca721a11b1a5bf6b7d88e8421a288ab5d5bba5220e53d32b5f067ec2",
                "8157f55a7c99306c79c0766161c91e2966a73899d279b48a655fba0f1ad836f1"
            ],
            [
                "a8e282ff0c9706907215ff98e8fd416615311de0446f1e062a73b0610d064e13",
                "7f97355b8db81c09abfb7f3c5b2515888b679a3e50dd6bd6cef7c73111f4cc0c"
            ],
            [
                "174a53b9c9a285872d39e56e6913cab15d59b1fa512508c022f382de8319497c",
                "ccc9dc37abfc9c1657b4155f2c47f9e6646b3a1d8cb9854383da13ac079afa73"
            ],
            [
                "959396981943785c3d3e57edf5018cdbe039e730e4918b3d884fdff09475b7ba",
                "2e7e552888c331dd8ba0386a4b9cd6849c653f64c8709385e9b8abf87524f2fd"
            ],
            [
                "d2a63a50ae401e56d645a1153b109a8fcca0a43d561fba2dbb51340c9d82b151",
                "e82d86fb6443fcb7565aee58b2948220a70f750af484ca52d4142174dcf89405"
            ],
            [
                "64587e2335471eb890ee7896d7cfdc866bacbdbd3839317b3436f9b45617e073",
                "d99fcdd5bf6902e2ae96dd6447c299a185b90a39133aeab358299e5e9faf6589"
            ],
            [
                "8481bde0e4e4d885b3a546d3e549de042f0aa6cea250e7fd358d6c86dd45e458",
                "38ee7b8cba5404dd84a25bf39cecb2ca900a79c42b262e556d64b1b59779057e"
            ],
            [
                "13464a57a78102aa62b6979ae817f4637ffcfed3c4b1ce30bcd6303f6caf666b",
                "69be159004614580ef7e433453ccb0ca48f300a81d0942e13f495a907f6ecc27"
            ],
            [
                "bc4a9df5b713fe2e9aef430bcc1dc97a0cd9ccede2f28588cada3a0d2d83f366",
                "d3a81ca6e785c06383937adf4b798caa6e8a9fbfa547b16d758d666581f33c1"
            ],
            [
                "8c28a97bf8298bc0d23d8c749452a32e694b65e30a9472a3954ab30fe5324caa",
                "40a30463a3305193378fedf31f7cc0eb7ae784f0451cb9459e71dc73cbef9482"
            ],
            [
                "8ea9666139527a8c1dd94ce4f071fd23c8b350c5a4bb33748c4ba111faccae0",
                "620efabbc8ee2782e24e7c0cfb95c5d735b783be9cf0f8e955af34a30e62b945"
            ],
            [
                "dd3625faef5ba06074669716bbd3788d89bdde815959968092f76cc4eb9a9787",
                "7a188fa3520e30d461da2501045731ca941461982883395937f68d00c644a573"
            ],
            [
                "f710d79d9eb962297e4f6232b40e8f7feb2bc63814614d692c12de752408221e",
                "ea98e67232d3b3295d3b535532115ccac8612c721851617526ae47a9c77bfc82"
            ]
        ]
    },
    naf: {
        wnd: 7,
        points: [
            [
                "f9308a019258c31049344f85f89d5229b531c845836f99b08601f113bce036f9",
                "388f7b0f632de8140fe337e62a37f3566500a99934c2231b6cb9fd7584b8e672"
            ],
            [
                "2f8bde4d1a07209355b4a7250a5c5128e88b84bddc619ab7cba8d569b240efe4",
                "d8ac222636e5e3d6d4dba9dda6c9c426f788271bab0d6840dca87d3aa6ac62d6"
            ],
            [
                "5cbdf0646e5db4eaa398f365f2ea7a0e3d419b7e0330e39ce92bddedcac4f9bc",
                "6aebca40ba255960a3178d6d861a54dba813d0b813fde7b5a5082628087264da"
            ],
            [
                "acd484e2f0c7f65309ad178a9f559abde09796974c57e714c35f110dfc27ccbe",
                "cc338921b0a7d9fd64380971763b61e9add888a4375f8e0f05cc262ac64f9c37"
            ],
            [
                "774ae7f858a9411e5ef4246b70c65aac5649980be5c17891bbec17895da008cb",
                "d984a032eb6b5e190243dd56d7b7b365372db1e2dff9d6a8301d74c9c953c61b"
            ],
            [
                "f28773c2d975288bc7d1d205c3748651b075fbc6610e58cddeeddf8f19405aa8",
                "ab0902e8d880a89758212eb65cdaf473a1a06da521fa91f29b5cb52db03ed81"
            ],
            [
                "d7924d4f7d43ea965a465ae3095ff41131e5946f3c85f79e44adbcf8e27e080e",
                "581e2872a86c72a683842ec228cc6defea40af2bd896d3a5c504dc9ff6a26b58"
            ],
            [
                "defdea4cdb677750a420fee807eacf21eb9898ae79b9768766e4faa04a2d4a34",
                "4211ab0694635168e997b0ead2a93daeced1f4a04a95c0f6cfb199f69e56eb77"
            ],
            [
                "2b4ea0a797a443d293ef5cff444f4979f06acfebd7e86d277475656138385b6c",
                "85e89bc037945d93b343083b5a1c86131a01f60c50269763b570c854e5c09b7a"
            ],
            [
                "352bbf4a4cdd12564f93fa332ce333301d9ad40271f8107181340aef25be59d5",
                "321eb4075348f534d59c18259dda3e1f4a1b3b2e71b1039c67bd3d8bcf81998c"
            ],
            [
                "2fa2104d6b38d11b0230010559879124e42ab8dfeff5ff29dc9cdadd4ecacc3f",
                "2de1068295dd865b64569335bd5dd80181d70ecfc882648423ba76b532b7d67"
            ],
            [
                "9248279b09b4d68dab21a9b066edda83263c3d84e09572e269ca0cd7f5453714",
                "73016f7bf234aade5d1aa71bdea2b1ff3fc0de2a887912ffe54a32ce97cb3402"
            ],
            [
                "daed4f2be3a8bf278e70132fb0beb7522f570e144bf615c07e996d443dee8729",
                "a69dce4a7d6c98e8d4a1aca87ef8d7003f83c230f3afa726ab40e52290be1c55"
            ],
            [
                "c44d12c7065d812e8acf28d7cbb19f9011ecd9e9fdf281b0e6a3b5e87d22e7db",
                "2119a460ce326cdc76c45926c982fdac0e106e861edf61c5a039063f0e0e6482"
            ],
            [
                "6a245bf6dc698504c89a20cfded60853152b695336c28063b61c65cbd269e6b4",
                "e022cf42c2bd4a708b3f5126f16a24ad8b33ba48d0423b6efd5e6348100d8a82"
            ],
            [
                "1697ffa6fd9de627c077e3d2fe541084ce13300b0bec1146f95ae57f0d0bd6a5",
                "b9c398f186806f5d27561506e4557433a2cf15009e498ae7adee9d63d01b2396"
            ],
            [
                "605bdb019981718b986d0f07e834cb0d9deb8360ffb7f61df982345ef27a7479",
                "2972d2de4f8d20681a78d93ec96fe23c26bfae84fb14db43b01e1e9056b8c49"
            ],
            [
                "62d14dab4150bf497402fdc45a215e10dcb01c354959b10cfe31c7e9d87ff33d",
                "80fc06bd8cc5b01098088a1950eed0db01aa132967ab472235f5642483b25eaf"
            ],
            [
                "80c60ad0040f27dade5b4b06c408e56b2c50e9f56b9b8b425e555c2f86308b6f",
                "1c38303f1cc5c30f26e66bad7fe72f70a65eed4cbe7024eb1aa01f56430bd57a"
            ],
            [
                "7a9375ad6167ad54aa74c6348cc54d344cc5dc9487d847049d5eabb0fa03c8fb",
                "d0e3fa9eca8726909559e0d79269046bdc59ea10c70ce2b02d499ec224dc7f7"
            ],
            [
                "d528ecd9b696b54c907a9ed045447a79bb408ec39b68df504bb51f459bc3ffc9",
                "eecf41253136e5f99966f21881fd656ebc4345405c520dbc063465b521409933"
            ],
            [
                "49370a4b5f43412ea25f514e8ecdad05266115e4a7ecb1387231808f8b45963",
                "758f3f41afd6ed428b3081b0512fd62a54c3f3afbb5b6764b653052a12949c9a"
            ],
            [
                "77f230936ee88cbbd73df930d64702ef881d811e0e1498e2f1c13eb1fc345d74",
                "958ef42a7886b6400a08266e9ba1b37896c95330d97077cbbe8eb3c7671c60d6"
            ],
            [
                "f2dac991cc4ce4b9ea44887e5c7c0bce58c80074ab9d4dbaeb28531b7739f530",
                "e0dedc9b3b2f8dad4da1f32dec2531df9eb5fbeb0598e4fd1a117dba703a3c37"
            ],
            [
                "463b3d9f662621fb1b4be8fbbe2520125a216cdfc9dae3debcba4850c690d45b",
                "5ed430d78c296c3543114306dd8622d7c622e27c970a1de31cb377b01af7307e"
            ],
            [
                "f16f804244e46e2a09232d4aff3b59976b98fac14328a2d1a32496b49998f247",
                "cedabd9b82203f7e13d206fcdf4e33d92a6c53c26e5cce26d6579962c4e31df6"
            ],
            [
                "caf754272dc84563b0352b7a14311af55d245315ace27c65369e15f7151d41d1",
                "cb474660ef35f5f2a41b643fa5e460575f4fa9b7962232a5c32f908318a04476"
            ],
            [
                "2600ca4b282cb986f85d0f1709979d8b44a09c07cb86d7c124497bc86f082120",
                "4119b88753c15bd6a693b03fcddbb45d5ac6be74ab5f0ef44b0be9475a7e4b40"
            ],
            [
                "7635ca72d7e8432c338ec53cd12220bc01c48685e24f7dc8c602a7746998e435",
                "91b649609489d613d1d5e590f78e6d74ecfc061d57048bad9e76f302c5b9c61"
            ],
            [
                "754e3239f325570cdbbf4a87deee8a66b7f2b33479d468fbc1a50743bf56cc18",
                "673fb86e5bda30fb3cd0ed304ea49a023ee33d0197a695d0c5d98093c536683"
            ],
            [
                "e3e6bd1071a1e96aff57859c82d570f0330800661d1c952f9fe2694691d9b9e8",
                "59c9e0bba394e76f40c0aa58379a3cb6a5a2283993e90c4167002af4920e37f5"
            ],
            [
                "186b483d056a033826ae73d88f732985c4ccb1f32ba35f4b4cc47fdcf04aa6eb",
                "3b952d32c67cf77e2e17446e204180ab21fb8090895138b4a4a797f86e80888b"
            ],
            [
                "df9d70a6b9876ce544c98561f4be4f725442e6d2b737d9c91a8321724ce0963f",
                "55eb2dafd84d6ccd5f862b785dc39d4ab157222720ef9da217b8c45cf2ba2417"
            ],
            [
                "5edd5cc23c51e87a497ca815d5dce0f8ab52554f849ed8995de64c5f34ce7143",
                "efae9c8dbc14130661e8cec030c89ad0c13c66c0d17a2905cdc706ab7399a868"
            ],
            [
                "290798c2b6476830da12fe02287e9e777aa3fba1c355b17a722d362f84614fba",
                "e38da76dcd440621988d00bcf79af25d5b29c094db2a23146d003afd41943e7a"
            ],
            [
                "af3c423a95d9f5b3054754efa150ac39cd29552fe360257362dfdecef4053b45",
                "f98a3fd831eb2b749a93b0e6f35cfb40c8cd5aa667a15581bc2feded498fd9c6"
            ],
            [
                "766dbb24d134e745cccaa28c99bf274906bb66b26dcf98df8d2fed50d884249a",
                "744b1152eacbe5e38dcc887980da38b897584a65fa06cedd2c924f97cbac5996"
            ],
            [
                "59dbf46f8c94759ba21277c33784f41645f7b44f6c596a58ce92e666191abe3e",
                "c534ad44175fbc300f4ea6ce648309a042ce739a7919798cd85e216c4a307f6e"
            ],
            [
                "f13ada95103c4537305e691e74e9a4a8dd647e711a95e73cb62dc6018cfd87b8",
                "e13817b44ee14de663bf4bc808341f326949e21a6a75c2570778419bdaf5733d"
            ],
            [
                "7754b4fa0e8aced06d4167a2c59cca4cda1869c06ebadfb6488550015a88522c",
                "30e93e864e669d82224b967c3020b8fa8d1e4e350b6cbcc537a48b57841163a2"
            ],
            [
                "948dcadf5990e048aa3874d46abef9d701858f95de8041d2a6828c99e2262519",
                "e491a42537f6e597d5d28a3224b1bc25df9154efbd2ef1d2cbba2cae5347d57e"
            ],
            [
                "7962414450c76c1689c7b48f8202ec37fb224cf5ac0bfa1570328a8a3d7c77ab",
                "100b610ec4ffb4760d5c1fc133ef6f6b12507a051f04ac5760afa5b29db83437"
            ],
            [
                "3514087834964b54b15b160644d915485a16977225b8847bb0dd085137ec47ca",
                "ef0afbb2056205448e1652c48e8127fc6039e77c15c2378b7e7d15a0de293311"
            ],
            [
                "d3cc30ad6b483e4bc79ce2c9dd8bc54993e947eb8df787b442943d3f7b527eaf",
                "8b378a22d827278d89c5e9be8f9508ae3c2ad46290358630afb34db04eede0a4"
            ],
            [
                "1624d84780732860ce1c78fcbfefe08b2b29823db913f6493975ba0ff4847610",
                "68651cf9b6da903e0914448c6cd9d4ca896878f5282be4c8cc06e2a404078575"
            ],
            [
                "733ce80da955a8a26902c95633e62a985192474b5af207da6df7b4fd5fc61cd4",
                "f5435a2bd2badf7d485a4d8b8db9fcce3e1ef8e0201e4578c54673bc1dc5ea1d"
            ],
            [
                "15d9441254945064cf1a1c33bbd3b49f8966c5092171e699ef258dfab81c045c",
                "d56eb30b69463e7234f5137b73b84177434800bacebfc685fc37bbe9efe4070d"
            ],
            [
                "a1d0fcf2ec9de675b612136e5ce70d271c21417c9d2b8aaaac138599d0717940",
                "edd77f50bcb5a3cab2e90737309667f2641462a54070f3d519212d39c197a629"
            ],
            [
                "e22fbe15c0af8ccc5780c0735f84dbe9a790badee8245c06c7ca37331cb36980",
                "a855babad5cd60c88b430a69f53a1a7a38289154964799be43d06d77d31da06"
            ],
            [
                "311091dd9860e8e20ee13473c1155f5f69635e394704eaa74009452246cfa9b3",
                "66db656f87d1f04fffd1f04788c06830871ec5a64feee685bd80f0b1286d8374"
            ],
            [
                "34c1fd04d301be89b31c0442d3e6ac24883928b45a9340781867d4232ec2dbdf",
                "9414685e97b1b5954bd46f730174136d57f1ceeb487443dc5321857ba73abee"
            ],
            [
                "f219ea5d6b54701c1c14de5b557eb42a8d13f3abbcd08affcc2a5e6b049b8d63",
                "4cb95957e83d40b0f73af4544cccf6b1f4b08d3c07b27fb8d8c2962a400766d1"
            ],
            [
                "d7b8740f74a8fbaab1f683db8f45de26543a5490bca627087236912469a0b448",
                "fa77968128d9c92ee1010f337ad4717eff15db5ed3c049b3411e0315eaa4593b"
            ],
            [
                "32d31c222f8f6f0ef86f7c98d3a3335ead5bcd32abdd94289fe4d3091aa824bf",
                "5f3032f5892156e39ccd3d7915b9e1da2e6dac9e6f26e961118d14b8462e1661"
            ],
            [
                "7461f371914ab32671045a155d9831ea8793d77cd59592c4340f86cbc18347b5",
                "8ec0ba238b96bec0cbdddcae0aa442542eee1ff50c986ea6b39847b3cc092ff6"
            ],
            [
                "ee079adb1df1860074356a25aa38206a6d716b2c3e67453d287698bad7b2b2d6",
                "8dc2412aafe3be5c4c5f37e0ecc5f9f6a446989af04c4e25ebaac479ec1c8c1e"
            ],
            [
                "16ec93e447ec83f0467b18302ee620f7e65de331874c9dc72bfd8616ba9da6b5",
                "5e4631150e62fb40d0e8c2a7ca5804a39d58186a50e497139626778e25b0674d"
            ],
            [
                "eaa5f980c245f6f038978290afa70b6bd8855897f98b6aa485b96065d537bd99",
                "f65f5d3e292c2e0819a528391c994624d784869d7e6ea67fb18041024edc07dc"
            ],
            [
                "78c9407544ac132692ee1910a02439958ae04877151342ea96c4b6b35a49f51",
                "f3e0319169eb9b85d5404795539a5e68fa1fbd583c064d2462b675f194a3ddb4"
            ],
            [
                "494f4be219a1a77016dcd838431aea0001cdc8ae7a6fc688726578d9702857a5",
                "42242a969283a5f339ba7f075e36ba2af925ce30d767ed6e55f4b031880d562c"
            ],
            [
                "a598a8030da6d86c6bc7f2f5144ea549d28211ea58faa70ebf4c1e665c1fe9b5",
                "204b5d6f84822c307e4b4a7140737aec23fc63b65b35f86a10026dbd2d864e6b"
            ],
            [
                "c41916365abb2b5d09192f5f2dbeafec208f020f12570a184dbadc3e58595997",
                "4f14351d0087efa49d245b328984989d5caf9450f34bfc0ed16e96b58fa9913"
            ],
            [
                "841d6063a586fa475a724604da03bc5b92a2e0d2e0a36acfe4c73a5514742881",
                "73867f59c0659e81904f9a1c7543698e62562d6744c169ce7a36de01a8d6154"
            ],
            [
                "5e95bb399a6971d376026947f89bde2f282b33810928be4ded112ac4d70e20d5",
                "39f23f366809085beebfc71181313775a99c9aed7d8ba38b161384c746012865"
            ],
            [
                "36e4641a53948fd476c39f8a99fd974e5ec07564b5315d8bf99471bca0ef2f66",
                "d2424b1b1abe4eb8164227b085c9aa9456ea13493fd563e06fd51cf5694c78fc"
            ],
            [
                "336581ea7bfbbb290c191a2f507a41cf5643842170e914faeab27c2c579f726",
                "ead12168595fe1be99252129b6e56b3391f7ab1410cd1e0ef3dcdcabd2fda224"
            ],
            [
                "8ab89816dadfd6b6a1f2634fcf00ec8403781025ed6890c4849742706bd43ede",
                "6fdcef09f2f6d0a044e654aef624136f503d459c3e89845858a47a9129cdd24e"
            ],
            [
                "1e33f1a746c9c5778133344d9299fcaa20b0938e8acff2544bb40284b8c5fb94",
                "60660257dd11b3aa9c8ed618d24edff2306d320f1d03010e33a7d2057f3b3b6"
            ],
            [
                "85b7c1dcb3cec1b7ee7f30ded79dd20a0ed1f4cc18cbcfcfa410361fd8f08f31",
                "3d98a9cdd026dd43f39048f25a8847f4fcafad1895d7a633c6fed3c35e999511"
            ],
            [
                "29df9fbd8d9e46509275f4b125d6d45d7fbe9a3b878a7af872a2800661ac5f51",
                "b4c4fe99c775a606e2d8862179139ffda61dc861c019e55cd2876eb2a27d84b"
            ],
            [
                "a0b1cae06b0a847a3fea6e671aaf8adfdfe58ca2f768105c8082b2e449fce252",
                "ae434102edde0958ec4b19d917a6a28e6b72da1834aff0e650f049503a296cf2"
            ],
            [
                "4e8ceafb9b3e9a136dc7ff67e840295b499dfb3b2133e4ba113f2e4c0e121e5",
                "cf2174118c8b6d7a4b48f6d534ce5c79422c086a63460502b827ce62a326683c"
            ],
            [
                "d24a44e047e19b6f5afb81c7ca2f69080a5076689a010919f42725c2b789a33b",
                "6fb8d5591b466f8fc63db50f1c0f1c69013f996887b8244d2cdec417afea8fa3"
            ],
            [
                "ea01606a7a6c9cdd249fdfcfacb99584001edd28abbab77b5104e98e8e3b35d4",
                "322af4908c7312b0cfbfe369f7a7b3cdb7d4494bc2823700cfd652188a3ea98d"
            ],
            [
                "af8addbf2b661c8a6c6328655eb96651252007d8c5ea31be4ad196de8ce2131f",
                "6749e67c029b85f52a034eafd096836b2520818680e26ac8f3dfbcdb71749700"
            ],
            [
                "e3ae1974566ca06cc516d47e0fb165a674a3dabcfca15e722f0e3450f45889",
                "2aeabe7e4531510116217f07bf4d07300de97e4874f81f533420a72eeb0bd6a4"
            ],
            [
                "591ee355313d99721cf6993ffed1e3e301993ff3ed258802075ea8ced397e246",
                "b0ea558a113c30bea60fc4775460c7901ff0b053d25ca2bdeee98f1a4be5d196"
            ],
            [
                "11396d55fda54c49f19aa97318d8da61fa8584e47b084945077cf03255b52984",
                "998c74a8cd45ac01289d5833a7beb4744ff536b01b257be4c5767bea93ea57a4"
            ],
            [
                "3c5d2a1ba39c5a1790000738c9e0c40b8dcdfd5468754b6405540157e017aa7a",
                "b2284279995a34e2f9d4de7396fc18b80f9b8b9fdd270f6661f79ca4c81bd257"
            ],
            [
                "cc8704b8a60a0defa3a99a7299f2e9c3fbc395afb04ac078425ef8a1793cc030",
                "bdd46039feed17881d1e0862db347f8cf395b74fc4bcdc4e940b74e3ac1f1b13"
            ],
            [
                "c533e4f7ea8555aacd9777ac5cad29b97dd4defccc53ee7ea204119b2889b197",
                "6f0a256bc5efdf429a2fb6242f1a43a2d9b925bb4a4b3a26bb8e0f45eb596096"
            ],
            [
                "c14f8f2ccb27d6f109f6d08d03cc96a69ba8c34eec07bbcf566d48e33da6593",
                "c359d6923bb398f7fd4473e16fe1c28475b740dd098075e6c0e8649113dc3a38"
            ],
            [
                "a6cbc3046bc6a450bac24789fa17115a4c9739ed75f8f21ce441f72e0b90e6ef",
                "21ae7f4680e889bb130619e2c0f95a360ceb573c70603139862afd617fa9b9f"
            ],
            [
                "347d6d9a02c48927ebfb86c1359b1caf130a3c0267d11ce6344b39f99d43cc38",
                "60ea7f61a353524d1c987f6ecec92f086d565ab687870cb12689ff1e31c74448"
            ],
            [
                "da6545d2181db8d983f7dcb375ef5866d47c67b1bf31c8cf855ef7437b72656a",
                "49b96715ab6878a79e78f07ce5680c5d6673051b4935bd897fea824b77dc208a"
            ],
            [
                "c40747cc9d012cb1a13b8148309c6de7ec25d6945d657146b9d5994b8feb1111",
                "5ca560753be2a12fc6de6caf2cb489565db936156b9514e1bb5e83037e0fa2d4"
            ],
            [
                "4e42c8ec82c99798ccf3a610be870e78338c7f713348bd34c8203ef4037f3502",
                "7571d74ee5e0fb92a7a8b33a07783341a5492144cc54bcc40a94473693606437"
            ],
            [
                "3775ab7089bc6af823aba2e1af70b236d251cadb0c86743287522a1b3b0dedea",
                "be52d107bcfa09d8bcb9736a828cfa7fac8db17bf7a76a2c42ad961409018cf7"
            ],
            [
                "cee31cbf7e34ec379d94fb814d3d775ad954595d1314ba8846959e3e82f74e26",
                "8fd64a14c06b589c26b947ae2bcf6bfa0149ef0be14ed4d80f448a01c43b1c6d"
            ],
            [
                "b4f9eaea09b6917619f6ea6a4eb5464efddb58fd45b1ebefcdc1a01d08b47986",
                "39e5c9925b5a54b07433a4f18c61726f8bb131c012ca542eb24a8ac07200682a"
            ],
            [
                "d4263dfc3d2df923a0179a48966d30ce84e2515afc3dccc1b77907792ebcc60e",
                "62dfaf07a0f78feb30e30d6295853ce189e127760ad6cf7fae164e122a208d54"
            ],
            [
                "48457524820fa65a4f8d35eb6930857c0032acc0a4a2de422233eeda897612c4",
                "25a748ab367979d98733c38a1fa1c2e7dc6cc07db2d60a9ae7a76aaa49bd0f77"
            ],
            [
                "dfeeef1881101f2cb11644f3a2afdfc2045e19919152923f367a1767c11cceda",
                "ecfb7056cf1de042f9420bab396793c0c390bde74b4bbdff16a83ae09a9a7517"
            ],
            [
                "6d7ef6b17543f8373c573f44e1f389835d89bcbc6062ced36c82df83b8fae859",
                "cd450ec335438986dfefa10c57fea9bcc521a0959b2d80bbf74b190dca712d10"
            ],
            [
                "e75605d59102a5a2684500d3b991f2e3f3c88b93225547035af25af66e04541f",
                "f5c54754a8f71ee540b9b48728473e314f729ac5308b06938360990e2bfad125"
            ],
            [
                "eb98660f4c4dfaa06a2be453d5020bc99a0c2e60abe388457dd43fefb1ed620c",
                "6cb9a8876d9cb8520609af3add26cd20a0a7cd8a9411131ce85f44100099223e"
            ],
            [
                "13e87b027d8514d35939f2e6892b19922154596941888336dc3563e3b8dba942",
                "fef5a3c68059a6dec5d624114bf1e91aac2b9da568d6abeb2570d55646b8adf1"
            ],
            [
                "ee163026e9fd6fe017c38f06a5be6fc125424b371ce2708e7bf4491691e5764a",
                "1acb250f255dd61c43d94ccc670d0f58f49ae3fa15b96623e5430da0ad6c62b2"
            ],
            [
                "b268f5ef9ad51e4d78de3a750c2dc89b1e626d43505867999932e5db33af3d80",
                "5f310d4b3c99b9ebb19f77d41c1dee018cf0d34fd4191614003e945a1216e423"
            ],
            [
                "ff07f3118a9df035e9fad85eb6c7bfe42b02f01ca99ceea3bf7ffdba93c4750d",
                "438136d603e858a3a5c440c38eccbaddc1d2942114e2eddd4740d098ced1f0d8"
            ],
            [
                "8d8b9855c7c052a34146fd20ffb658bea4b9f69e0d825ebec16e8c3ce2b526a1",
                "cdb559eedc2d79f926baf44fb84ea4d44bcf50fee51d7ceb30e2e7f463036758"
            ],
            [
                "52db0b5384dfbf05bfa9d472d7ae26dfe4b851ceca91b1eba54263180da32b63",
                "c3b997d050ee5d423ebaf66a6db9f57b3180c902875679de924b69d84a7b375"
            ],
            [
                "e62f9490d3d51da6395efd24e80919cc7d0f29c3f3fa48c6fff543becbd43352",
                "6d89ad7ba4876b0b22c2ca280c682862f342c8591f1daf5170e07bfd9ccafa7d"
            ],
            [
                "7f30ea2476b399b4957509c88f77d0191afa2ff5cb7b14fd6d8e7d65aaab1193",
                "ca5ef7d4b231c94c3b15389a5f6311e9daff7bb67b103e9880ef4bff637acaec"
            ],
            [
                "5098ff1e1d9f14fb46a210fada6c903fef0fb7b4a1dd1d9ac60a0361800b7a00",
                "9731141d81fc8f8084d37c6e7542006b3ee1b40d60dfe5362a5b132fd17ddc0"
            ],
            [
                "32b78c7de9ee512a72895be6b9cbefa6e2f3c4ccce445c96b9f2c81e2778ad58",
                "ee1849f513df71e32efc3896ee28260c73bb80547ae2275ba497237794c8753c"
            ],
            [
                "e2cb74fddc8e9fbcd076eef2a7c72b0ce37d50f08269dfc074b581550547a4f7",
                "d3aa2ed71c9dd2247a62df062736eb0baddea9e36122d2be8641abcb005cc4a4"
            ],
            [
                "8438447566d4d7bedadc299496ab357426009a35f235cb141be0d99cd10ae3a8",
                "c4e1020916980a4da5d01ac5e6ad330734ef0d7906631c4f2390426b2edd791f"
            ],
            [
                "4162d488b89402039b584c6fc6c308870587d9c46f660b878ab65c82c711d67e",
                "67163e903236289f776f22c25fb8a3afc1732f2b84b4e95dbda47ae5a0852649"
            ],
            [
                "3fad3fa84caf0f34f0f89bfd2dcf54fc175d767aec3e50684f3ba4a4bf5f683d",
                "cd1bc7cb6cc407bb2f0ca647c718a730cf71872e7d0d2a53fa20efcdfe61826"
            ],
            [
                "674f2600a3007a00568c1a7ce05d0816c1fb84bf1370798f1c69532faeb1a86b",
                "299d21f9413f33b3edf43b257004580b70db57da0b182259e09eecc69e0d38a5"
            ],
            [
                "d32f4da54ade74abb81b815ad1fb3b263d82d6c692714bcff87d29bd5ee9f08f",
                "f9429e738b8e53b968e99016c059707782e14f4535359d582fc416910b3eea87"
            ],
            [
                "30e4e670435385556e593657135845d36fbb6931f72b08cb1ed954f1e3ce3ff6",
                "462f9bce619898638499350113bbc9b10a878d35da70740dc695a559eb88db7b"
            ],
            [
                "be2062003c51cc3004682904330e4dee7f3dcd10b01e580bf1971b04d4cad297",
                "62188bc49d61e5428573d48a74e1c655b1c61090905682a0d5558ed72dccb9bc"
            ],
            [
                "93144423ace3451ed29e0fb9ac2af211cb6e84a601df5993c419859fff5df04a",
                "7c10dfb164c3425f5c71a3f9d7992038f1065224f72bb9d1d902a6d13037b47c"
            ],
            [
                "b015f8044f5fcbdcf21ca26d6c34fb8197829205c7b7d2a7cb66418c157b112c",
                "ab8c1e086d04e813744a655b2df8d5f83b3cdc6faa3088c1d3aea1454e3a1d5f"
            ],
            [
                "d5e9e1da649d97d89e4868117a465a3a4f8a18de57a140d36b3f2af341a21b52",
                "4cb04437f391ed73111a13cc1d4dd0db1693465c2240480d8955e8592f27447a"
            ],
            [
                "d3ae41047dd7ca065dbf8ed77b992439983005cd72e16d6f996a5316d36966bb",
                "bd1aeb21ad22ebb22a10f0303417c6d964f8cdd7df0aca614b10dc14d125ac46"
            ],
            [
                "463e2763d885f958fc66cdd22800f0a487197d0a82e377b49f80af87c897b065",
                "bfefacdb0e5d0fd7df3a311a94de062b26b80c61fbc97508b79992671ef7ca7f"
            ],
            [
                "7985fdfd127c0567c6f53ec1bb63ec3158e597c40bfe747c83cddfc910641917",
                "603c12daf3d9862ef2b25fe1de289aed24ed291e0ec6708703a5bd567f32ed03"
            ],
            [
                "74a1ad6b5f76e39db2dd249410eac7f99e74c59cb83d2d0ed5ff1543da7703e9",
                "cc6157ef18c9c63cd6193d83631bbea0093e0968942e8c33d5737fd790e0db08"
            ],
            [
                "30682a50703375f602d416664ba19b7fc9bab42c72747463a71d0896b22f6da3",
                "553e04f6b018b4fa6c8f39e7f311d3176290d0e0f19ca73f17714d9977a22ff8"
            ],
            [
                "9e2158f0d7c0d5f26c3791efefa79597654e7a2b2464f52b1ee6c1347769ef57",
                "712fcdd1b9053f09003a3481fa7762e9ffd7c8ef35a38509e2fbf2629008373"
            ],
            [
                "176e26989a43c9cfeba4029c202538c28172e566e3c4fce7322857f3be327d66",
                "ed8cc9d04b29eb877d270b4878dc43c19aefd31f4eee09ee7b47834c1fa4b1c3"
            ],
            [
                "75d46efea3771e6e68abb89a13ad747ecf1892393dfc4f1b7004788c50374da8",
                "9852390a99507679fd0b86fd2b39a868d7efc22151346e1a3ca4726586a6bed8"
            ],
            [
                "809a20c67d64900ffb698c4c825f6d5f2310fb0451c869345b7319f645605721",
                "9e994980d9917e22b76b061927fa04143d096ccc54963e6a5ebfa5f3f8e286c1"
            ],
            [
                "1b38903a43f7f114ed4500b4eac7083fdefece1cf29c63528d563446f972c180",
                "4036edc931a60ae889353f77fd53de4a2708b26b6f5da72ad3394119daf408f9"
            ]
        ]
    }
};

});


parcelRegister("220Zx", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $kKonu = parcelRequire("kKonu");

var $gEVtY = parcelRequire("gEVtY");

var $fbTbW = parcelRequire("fbTbW");

var $7JHF0 = parcelRequire("7JHF0");
var $17ac898fe5b06379$var$assert = $gEVtY.assert;

var $lPqzs = parcelRequire("lPqzs");

var $i46nc = parcelRequire("i46nc");
function $17ac898fe5b06379$var$EC(options) {
    if (!(this instanceof $17ac898fe5b06379$var$EC)) return new $17ac898fe5b06379$var$EC(options);
    // Shortcut `elliptic.ec(curve-name)`
    if (typeof options === "string") {
        $17ac898fe5b06379$var$assert(Object.prototype.hasOwnProperty.call($fbTbW, options), "Unknown curve " + options);
        options = $fbTbW[options];
    }
    // Shortcut for `elliptic.ec(elliptic.curves.curveName)`
    if (options instanceof $fbTbW.PresetCurve) options = {
        curve: options
    };
    this.curve = options.curve.curve;
    this.n = this.curve.n;
    this.nh = this.n.ushrn(1);
    this.g = this.curve.g;
    // Point on curve
    this.g = options.curve.g;
    this.g.precompute(options.curve.n.bitLength() + 1);
    // Hash for function for DRBG
    this.hash = options.hash || options.curve.hash;
}
module.exports = $17ac898fe5b06379$var$EC;
$17ac898fe5b06379$var$EC.prototype.keyPair = function keyPair(options) {
    return new $lPqzs(this, options);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPrivate = function keyFromPrivate(priv, enc) {
    return $lPqzs.fromPrivate(this, priv, enc);
};
$17ac898fe5b06379$var$EC.prototype.keyFromPublic = function keyFromPublic(pub, enc) {
    return $lPqzs.fromPublic(this, pub, enc);
};
$17ac898fe5b06379$var$EC.prototype.genKeyPair = function genKeyPair(options) {
    if (!options) options = {};
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        pers: options.pers,
        persEnc: options.persEnc || "utf8",
        entropy: options.entropy || $7JHF0(this.hash.hmacStrength),
        entropyEnc: options.entropy && options.entropyEnc || "utf8",
        nonce: this.n.toArray()
    });
    var bytes = this.n.byteLength();
    var ns2 = this.n.sub(new $jX0xT(2));
    for(;;){
        var priv = new $jX0xT(drbg.generate(bytes));
        if (priv.cmp(ns2) > 0) continue;
        priv.iaddn(1);
        return this.keyFromPrivate(priv);
    }
};
$17ac898fe5b06379$var$EC.prototype._truncateToN = function _truncateToN(msg, truncOnly, bitLength) {
    var byteLength;
    if ($jX0xT.isBN(msg) || typeof msg === "number") {
        msg = new $jX0xT(msg, 16);
        byteLength = msg.byteLength();
    } else if (typeof msg === "object") {
        // BN assumes an array-like input and asserts length
        byteLength = msg.length;
        msg = new $jX0xT(msg, 16);
    } else {
        // BN converts the value to string
        var str = msg.toString();
        // HEX encoding
        byteLength = str.length + 1 >>> 1;
        msg = new $jX0xT(str, 16);
    }
    // Allow overriding
    if (typeof bitLength !== "number") bitLength = byteLength * 8;
    var delta = bitLength - this.n.bitLength();
    if (delta > 0) msg = msg.ushrn(delta);
    if (!truncOnly && msg.cmp(this.n) >= 0) return msg.sub(this.n);
    else return msg;
};
$17ac898fe5b06379$var$EC.prototype.sign = function sign(msg, key, enc, options) {
    if (typeof enc === "object") {
        options = enc;
        enc = null;
    }
    if (!options) options = {};
    if (typeof msg !== "string" && typeof msg !== "number" && !$jX0xT.isBN(msg)) {
        $17ac898fe5b06379$var$assert(typeof msg === "object" && msg && typeof msg.length === "number", "Expected message to be an array-like, a hex string, or a BN instance");
        $17ac898fe5b06379$var$assert(msg.length >>> 0 === msg.length); // non-negative 32-bit integer
        for(var i = 0; i < msg.length; i++)$17ac898fe5b06379$var$assert((msg[i] & 255) === msg[i]);
    }
    key = this.keyFromPrivate(key, enc);
    msg = this._truncateToN(msg, false, options.msgBitLength);
    // Would fail further checks, but let's make the error message clear
    $17ac898fe5b06379$var$assert(!msg.isNeg(), "Can not sign a negative message");
    // Zero-extend key to provide enough entropy
    var bytes = this.n.byteLength();
    var bkey = key.getPrivate().toArray("be", bytes);
    // Zero-extend nonce to have the same byte size as N
    var nonce = msg.toArray("be", bytes);
    // Recheck nonce to be bijective to msg
    $17ac898fe5b06379$var$assert(new $jX0xT(nonce).eq(msg), "Can not sign message");
    // Instantiate Hmac_DRBG
    var drbg = new $kKonu({
        hash: this.hash,
        entropy: bkey,
        nonce: nonce,
        pers: options.pers,
        persEnc: options.persEnc || "utf8"
    });
    // Number of bytes to generate
    var ns1 = this.n.sub(new $jX0xT(1));
    for(var iter = 0;; iter++){
        var k = options.k ? options.k(iter) : new $jX0xT(drbg.generate(this.n.byteLength()));
        k = this._truncateToN(k, true);
        if (k.cmpn(1) <= 0 || k.cmp(ns1) >= 0) continue;
        var kp = this.g.mul(k);
        if (kp.isInfinity()) continue;
        var kpX = kp.getX();
        var r = kpX.umod(this.n);
        if (r.cmpn(0) === 0) continue;
        var s = k.invm(this.n).mul(r.mul(key.getPrivate()).iadd(msg));
        s = s.umod(this.n);
        if (s.cmpn(0) === 0) continue;
        var recoveryParam = (kp.getY().isOdd() ? 1 : 0) | (kpX.cmp(r) !== 0 ? 2 : 0);
        // Use complement of `s`, if it is > `n / 2`
        if (options.canonical && s.cmp(this.nh) > 0) {
            s = this.n.sub(s);
            recoveryParam ^= 1;
        }
        return new $i46nc({
            r: r,
            s: s,
            recoveryParam: recoveryParam
        });
    }
};
$17ac898fe5b06379$var$EC.prototype.verify = function verify(msg, signature, key, enc, options) {
    if (!options) options = {};
    msg = this._truncateToN(msg, false, options.msgBitLength);
    key = this.keyFromPublic(key, enc);
    signature = new $i46nc(signature, "hex");
    // Perform primitive values validation
    var r = signature.r;
    var s = signature.s;
    if (r.cmpn(1) < 0 || r.cmp(this.n) >= 0) return false;
    if (s.cmpn(1) < 0 || s.cmp(this.n) >= 0) return false;
    // Validate signature
    var sinv = s.invm(this.n);
    var u1 = sinv.mul(msg).umod(this.n);
    var u2 = sinv.mul(r).umod(this.n);
    var p;
    if (!this.curve._maxwellTrick) {
        p = this.g.mulAdd(u1, key.getPublic(), u2);
        if (p.isInfinity()) return false;
        return p.getX().umod(this.n).cmp(r) === 0;
    }
    // NOTE: Greg Maxwell's trick, inspired by:
    // https://git.io/vad3K
    p = this.g.jmulAdd(u1, key.getPublic(), u2);
    if (p.isInfinity()) return false;
    // Compare `p.x` of Jacobian point with `r`,
    // this will do `p.x == r * p.z^2` instead of multiplying `p.x` by the
    // inverse of `p.z^2`
    return p.eqXToP(r);
};
$17ac898fe5b06379$var$EC.prototype.recoverPubKey = function(msg, signature, j, enc) {
    $17ac898fe5b06379$var$assert((3 & j) === j, "The recovery param is more than two bits");
    signature = new $i46nc(signature, enc);
    var n = this.n;
    var e = new $jX0xT(msg);
    var r = signature.r;
    var s = signature.s;
    // A set LSB signifies that the y-coordinate is odd
    var isYOdd = j & 1;
    var isSecondKey = j >> 1;
    if (r.cmp(this.curve.p.umod(this.curve.n)) >= 0 && isSecondKey) throw new Error("Unable to find sencond key candinate");
    // 1.1. Let x = r + jn.
    if (isSecondKey) r = this.curve.pointFromX(r.add(this.curve.n), isYOdd);
    else r = this.curve.pointFromX(r, isYOdd);
    var rInv = signature.r.invm(n);
    var s1 = n.sub(e).mul(rInv).umod(n);
    var s2 = s.mul(rInv).umod(n);
    // 1.6.1 Compute Q = r^-1 (sR -  eG)
    //               Q = r^-1 (sR + -eG)
    return this.g.mulAdd(s1, r, s2);
};
$17ac898fe5b06379$var$EC.prototype.getKeyRecoveryParam = function(e, signature, Q, enc) {
    signature = new $i46nc(signature, enc);
    if (signature.recoveryParam !== null) return signature.recoveryParam;
    for(var i = 0; i < 4; i++){
        var Qprime;
        try {
            Qprime = this.recoverPubKey(e, signature, i);
        } catch (e) {
            continue;
        }
        if (Qprime.eq(Q)) return i;
    }
    throw new Error("Unable to find valid recovery factor");
};

});
parcelRegister("kKonu", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $lC4vN = parcelRequire("lC4vN");

var $koC21 = parcelRequire("koC21");
function $f1ab03780ebd0ab4$var$HmacDRBG(options) {
    if (!(this instanceof $f1ab03780ebd0ab4$var$HmacDRBG)) return new $f1ab03780ebd0ab4$var$HmacDRBG(options);
    this.hash = options.hash;
    this.predResist = !!options.predResist;
    this.outLen = this.hash.outSize;
    this.minEntropy = options.minEntropy || this.hash.hmacStrength;
    this._reseed = null;
    this.reseedInterval = null;
    this.K = null;
    this.V = null;
    var entropy = $lC4vN.toArray(options.entropy, options.entropyEnc || "hex");
    var nonce = $lC4vN.toArray(options.nonce, options.nonceEnc || "hex");
    var pers = $lC4vN.toArray(options.pers, options.persEnc || "hex");
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._init(entropy, nonce, pers);
}
module.exports = $f1ab03780ebd0ab4$var$HmacDRBG;
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._init = function init(entropy, nonce, pers) {
    var seed = entropy.concat(nonce).concat(pers);
    this.K = new Array(this.outLen / 8);
    this.V = new Array(this.outLen / 8);
    for(var i = 0; i < this.V.length; i++){
        this.K[i] = 0x00;
        this.V[i] = 0x01;
    }
    this._update(seed);
    this._reseed = 1;
    this.reseedInterval = 0x1000000000000; // 2^48
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._hmac = function hmac() {
    return new $kiSKt.hmac(this.hash, this.K);
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype._update = function update(seed) {
    var kmac = this._hmac().update(this.V).update([
        0x00
    ]);
    if (seed) kmac = kmac.update(seed);
    this.K = kmac.digest();
    this.V = this._hmac().update(this.V).digest();
    if (!seed) return;
    this.K = this._hmac().update(this.V).update([
        0x01
    ]).update(seed).digest();
    this.V = this._hmac().update(this.V).digest();
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.reseed = function reseed(entropy, entropyEnc, add, addEnc) {
    // Optional entropy enc
    if (typeof entropyEnc !== "string") {
        addEnc = add;
        add = entropyEnc;
        entropyEnc = null;
    }
    entropy = $lC4vN.toArray(entropy, entropyEnc);
    add = $lC4vN.toArray(add, addEnc);
    $koC21(entropy.length >= this.minEntropy / 8, "Not enough entropy. Minimum is: " + this.minEntropy + " bits");
    this._update(entropy.concat(add || []));
    this._reseed = 1;
};
$f1ab03780ebd0ab4$var$HmacDRBG.prototype.generate = function generate(len, enc, add, addEnc) {
    if (this._reseed > this.reseedInterval) throw new Error("Reseed is required");
    // Optional encoding
    if (typeof enc !== "string") {
        addEnc = add;
        add = enc;
        enc = null;
    }
    // Optional additional data
    if (add) {
        add = $lC4vN.toArray(add, addEnc || "hex");
        this._update(add);
    }
    var temp = [];
    while(temp.length < len){
        this.V = this._hmac().update(this.V).digest();
        temp = temp.concat(this.V);
    }
    var res = temp.slice(0, len);
    this._update(add);
    this._reseed++;
    return $lC4vN.encode(res, enc);
};

});

parcelRegister("lPqzs", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $fe42f8d68750188b$var$assert = $gEVtY.assert;
function $fe42f8d68750188b$var$KeyPair(ec, options) {
    this.ec = ec;
    this.priv = null;
    this.pub = null;
    // KeyPair(ec, { priv: ..., pub: ... })
    if (options.priv) this._importPrivate(options.priv, options.privEnc);
    if (options.pub) this._importPublic(options.pub, options.pubEnc);
}
module.exports = $fe42f8d68750188b$var$KeyPair;
$fe42f8d68750188b$var$KeyPair.fromPublic = function fromPublic(ec, pub, enc) {
    if (pub instanceof $fe42f8d68750188b$var$KeyPair) return pub;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        pub: pub,
        pubEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.fromPrivate = function fromPrivate(ec, priv, enc) {
    if (priv instanceof $fe42f8d68750188b$var$KeyPair) return priv;
    return new $fe42f8d68750188b$var$KeyPair(ec, {
        priv: priv,
        privEnc: enc
    });
};
$fe42f8d68750188b$var$KeyPair.prototype.validate = function validate() {
    var pub = this.getPublic();
    if (pub.isInfinity()) return {
        result: false,
        reason: "Invalid public key"
    };
    if (!pub.validate()) return {
        result: false,
        reason: "Public key is not a point"
    };
    if (!pub.mul(this.ec.curve.n).isInfinity()) return {
        result: false,
        reason: "Public key * N != O"
    };
    return {
        result: true,
        reason: null
    };
};
$fe42f8d68750188b$var$KeyPair.prototype.getPublic = function getPublic(compact, enc) {
    // compact is optional argument
    if (typeof compact === "string") {
        enc = compact;
        compact = null;
    }
    if (!this.pub) this.pub = this.ec.g.mul(this.priv);
    if (!enc) return this.pub;
    return this.pub.encode(enc, compact);
};
$fe42f8d68750188b$var$KeyPair.prototype.getPrivate = function getPrivate(enc) {
    if (enc === "hex") return this.priv.toString(16, 2);
    else return this.priv;
};
$fe42f8d68750188b$var$KeyPair.prototype._importPrivate = function _importPrivate(key, enc) {
    this.priv = new $jX0xT(key, enc || 16);
    // Ensure that the priv won't be bigger than n, otherwise we may fail
    // in fixed multiplication method
    this.priv = this.priv.umod(this.ec.curve.n);
};
$fe42f8d68750188b$var$KeyPair.prototype._importPublic = function _importPublic(key, enc) {
    if (key.x || key.y) {
        // Montgomery points only have an `x` coordinate.
        // Weierstrass/Edwards points on the other hand have both `x` and
        // `y` coordinates.
        if (this.ec.curve.type === "mont") $fe42f8d68750188b$var$assert(key.x, "Need x coordinate");
        else if (this.ec.curve.type === "short" || this.ec.curve.type === "edwards") $fe42f8d68750188b$var$assert(key.x && key.y, "Need both x and y coordinate");
        this.pub = this.ec.curve.point(key.x, key.y);
        return;
    }
    this.pub = this.ec.curve.decodePoint(key, enc);
};
// ECDH
$fe42f8d68750188b$var$KeyPair.prototype.derive = function derive(pub) {
    if (!pub.validate()) $fe42f8d68750188b$var$assert(pub.validate(), "public point not validated");
    return pub.mul(this.priv).getX();
};
// ECDSA
$fe42f8d68750188b$var$KeyPair.prototype.sign = function sign(msg, enc, options) {
    return this.ec.sign(msg, this, enc, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.verify = function verify(msg, signature, options) {
    return this.ec.verify(msg, signature, this, undefined, options);
};
$fe42f8d68750188b$var$KeyPair.prototype.inspect = function inspect() {
    return "<Key priv: " + (this.priv && this.priv.toString(16, 2)) + " pub: " + (this.pub && this.pub.inspect()) + " >";
};

});

parcelRegister("i46nc", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $d26d8b510bde7292$var$assert = $gEVtY.assert;
function $d26d8b510bde7292$var$Signature(options, enc) {
    if (options instanceof $d26d8b510bde7292$var$Signature) return options;
    if (this._importDER(options, enc)) return;
    $d26d8b510bde7292$var$assert(options.r && options.s, "Signature without r or s");
    this.r = new $jX0xT(options.r, 16);
    this.s = new $jX0xT(options.s, 16);
    if (options.recoveryParam === undefined) this.recoveryParam = null;
    else this.recoveryParam = options.recoveryParam;
}
module.exports = $d26d8b510bde7292$var$Signature;
function $d26d8b510bde7292$var$Position() {
    this.place = 0;
}
function $d26d8b510bde7292$var$getLength(buf, p) {
    var initial = buf[p.place++];
    if (!(initial & 0x80)) return initial;
    var octetLen = initial & 0xf;
    // Indefinite length or overflow
    if (octetLen === 0 || octetLen > 4) return false;
    if (buf[p.place] === 0x00) return false;
    var val = 0;
    for(var i = 0, off = p.place; i < octetLen; i++, off++){
        val <<= 8;
        val |= buf[off];
        val >>>= 0;
    }
    // Leading zeroes
    if (val <= 0x7f) return false;
    p.place = off;
    return val;
}
function $d26d8b510bde7292$var$rmPadding(buf) {
    var i = 0;
    var len = buf.length - 1;
    while(!buf[i] && !(buf[i + 1] & 0x80) && i < len)i++;
    if (i === 0) return buf;
    return buf.slice(i);
}
$d26d8b510bde7292$var$Signature.prototype._importDER = function _importDER(data, enc) {
    data = $gEVtY.toArray(data, enc);
    var p = new $d26d8b510bde7292$var$Position();
    if (data[p.place++] !== 0x30) return false;
    var len = $d26d8b510bde7292$var$getLength(data, p);
    if (len === false) return false;
    if (len + p.place !== data.length) return false;
    if (data[p.place++] !== 0x02) return false;
    var rlen = $d26d8b510bde7292$var$getLength(data, p);
    if (rlen === false) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var r = data.slice(p.place, rlen + p.place);
    p.place += rlen;
    if (data[p.place++] !== 0x02) return false;
    var slen = $d26d8b510bde7292$var$getLength(data, p);
    if (slen === false) return false;
    if (data.length !== slen + p.place) return false;
    if ((data[p.place] & 128) !== 0) return false;
    var s = data.slice(p.place, slen + p.place);
    if (r[0] === 0) {
        if (r[1] & 0x80) r = r.slice(1);
        else // Leading zeroes
        return false;
    }
    if (s[0] === 0) {
        if (s[1] & 0x80) s = s.slice(1);
        else // Leading zeroes
        return false;
    }
    this.r = new $jX0xT(r);
    this.s = new $jX0xT(s);
    this.recoveryParam = null;
    return true;
};
function $d26d8b510bde7292$var$constructLength(arr, len) {
    if (len < 0x80) {
        arr.push(len);
        return;
    }
    var octets = 1 + (Math.log(len) / Math.LN2 >>> 3);
    arr.push(octets | 0x80);
    while(--octets)arr.push(len >>> (octets << 3) & 0xff);
    arr.push(len);
}
$d26d8b510bde7292$var$Signature.prototype.toDER = function toDER(enc) {
    var r = this.r.toArray();
    var s = this.s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    // Pad values
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    r = $d26d8b510bde7292$var$rmPadding(r);
    s = $d26d8b510bde7292$var$rmPadding(s);
    while(!s[0] && !(s[1] & 0x80))s = s.slice(1);
    var arr = [
        0x02
    ];
    $d26d8b510bde7292$var$constructLength(arr, r.length);
    arr = arr.concat(r);
    arr.push(0x02);
    $d26d8b510bde7292$var$constructLength(arr, s.length);
    var backHalf = arr.concat(s);
    var res = [
        0x30
    ];
    $d26d8b510bde7292$var$constructLength(res, backHalf.length);
    res = res.concat(backHalf);
    return $gEVtY.encode(res, enc);
};

});


parcelRegister("esmmS", function(module, exports) {
"use strict";

var $kiSKt = parcelRequire("kiSKt");

var $fbTbW = parcelRequire("fbTbW");

var $gEVtY = parcelRequire("gEVtY");
var $a865080dcef76248$var$assert = $gEVtY.assert;
var $a865080dcef76248$var$parseBytes = $gEVtY.parseBytes;

var $1D85n = parcelRequire("1D85n");

var $7XcGE = parcelRequire("7XcGE");
function $a865080dcef76248$var$EDDSA(curve) {
    $a865080dcef76248$var$assert(curve === "ed25519", "only tested with ed25519 so far");
    if (!(this instanceof $a865080dcef76248$var$EDDSA)) return new $a865080dcef76248$var$EDDSA(curve);
    curve = $fbTbW[curve].curve;
    this.curve = curve;
    this.g = curve.g;
    this.g.precompute(curve.n.bitLength() + 1);
    this.pointClass = curve.point().constructor;
    this.encodingLength = Math.ceil(curve.n.bitLength() / 8);
    this.hash = $kiSKt.sha512;
}
module.exports = $a865080dcef76248$var$EDDSA;
/**
* @param {Array|String} message - message bytes
* @param {Array|String|KeyPair} secret - secret bytes or a keypair
* @returns {Signature} - signature
*/ $a865080dcef76248$var$EDDSA.prototype.sign = function sign(message, secret) {
    message = $a865080dcef76248$var$parseBytes(message);
    var key = this.keyFromSecret(secret);
    var r = this.hashInt(key.messagePrefix(), message);
    var R = this.g.mul(r);
    var Rencoded = this.encodePoint(R);
    var s_ = this.hashInt(Rencoded, key.pubBytes(), message).mul(key.priv());
    var S = r.add(s_).umod(this.curve.n);
    return this.makeSignature({
        R: R,
        S: S,
        Rencoded: Rencoded
    });
};
/**
* @param {Array} message - message bytes
* @param {Array|String|Signature} sig - sig bytes
* @param {Array|String|Point|KeyPair} pub - public key
* @returns {Boolean} - true if public key matches sig of message
*/ $a865080dcef76248$var$EDDSA.prototype.verify = function verify(message, sig, pub) {
    message = $a865080dcef76248$var$parseBytes(message);
    sig = this.makeSignature(sig);
    if (sig.S().gte(sig.eddsa.curve.n) || sig.S().isNeg()) return false;
    var key = this.keyFromPublic(pub);
    var h = this.hashInt(sig.Rencoded(), key.pubBytes(), message);
    var SG = this.g.mul(sig.S());
    var RplusAh = sig.R().add(key.pub().mul(h));
    return RplusAh.eq(SG);
};
$a865080dcef76248$var$EDDSA.prototype.hashInt = function hashInt() {
    var hash = this.hash();
    for(var i = 0; i < arguments.length; i++)hash.update(arguments[i]);
    return $gEVtY.intFromLE(hash.digest()).umod(this.curve.n);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromPublic = function keyFromPublic(pub) {
    return $1D85n.fromPublic(this, pub);
};
$a865080dcef76248$var$EDDSA.prototype.keyFromSecret = function keyFromSecret(secret) {
    return $1D85n.fromSecret(this, secret);
};
$a865080dcef76248$var$EDDSA.prototype.makeSignature = function makeSignature(sig) {
    if (sig instanceof $7XcGE) return sig;
    return new $7XcGE(this, sig);
};
/**
* * https://tools.ietf.org/html/draft-josefsson-eddsa-ed25519-03#section-5.2
*
* EDDSA defines methods for encoding and decoding points and integers. These are
* helper convenience methods, that pass along to utility functions implied
* parameters.
*
*/ $a865080dcef76248$var$EDDSA.prototype.encodePoint = function encodePoint(point) {
    var enc = point.getY().toArray("le", this.encodingLength);
    enc[this.encodingLength - 1] |= point.getX().isOdd() ? 0x80 : 0;
    return enc;
};
$a865080dcef76248$var$EDDSA.prototype.decodePoint = function decodePoint(bytes) {
    bytes = $gEVtY.parseBytes(bytes);
    var lastIx = bytes.length - 1;
    var normed = bytes.slice(0, lastIx).concat(bytes[lastIx] & -129);
    var xIsOdd = (bytes[lastIx] & 0x80) !== 0;
    var y = $gEVtY.intFromLE(normed);
    return this.curve.pointFromY(y, xIsOdd);
};
$a865080dcef76248$var$EDDSA.prototype.encodeInt = function encodeInt(num) {
    return num.toArray("le", this.encodingLength);
};
$a865080dcef76248$var$EDDSA.prototype.decodeInt = function decodeInt(bytes) {
    return $gEVtY.intFromLE(bytes);
};
$a865080dcef76248$var$EDDSA.prototype.isPoint = function isPoint(val) {
    return val instanceof this.pointClass;
};

});
parcelRegister("1D85n", function(module, exports) {
"use strict";

var $gEVtY = parcelRequire("gEVtY");
var $12ffb49ca423a34b$var$assert = $gEVtY.assert;
var $12ffb49ca423a34b$var$parseBytes = $gEVtY.parseBytes;
var $12ffb49ca423a34b$var$cachedProperty = $gEVtY.cachedProperty;
/**
* @param {EDDSA} eddsa - instance
* @param {Object} params - public/private key parameters
*
* @param {Array<Byte>} [params.secret] - secret seed bytes
* @param {Point} [params.pub] - public key point (aka `A` in eddsa terms)
* @param {Array<Byte>} [params.pub] - public key point encoded as bytes
*
*/ function $12ffb49ca423a34b$var$KeyPair(eddsa, params) {
    this.eddsa = eddsa;
    this._secret = $12ffb49ca423a34b$var$parseBytes(params.secret);
    if (eddsa.isPoint(params.pub)) this._pub = params.pub;
    else this._pubBytes = $12ffb49ca423a34b$var$parseBytes(params.pub);
}
$12ffb49ca423a34b$var$KeyPair.fromPublic = function fromPublic(eddsa, pub) {
    if (pub instanceof $12ffb49ca423a34b$var$KeyPair) return pub;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        pub: pub
    });
};
$12ffb49ca423a34b$var$KeyPair.fromSecret = function fromSecret(eddsa, secret) {
    if (secret instanceof $12ffb49ca423a34b$var$KeyPair) return secret;
    return new $12ffb49ca423a34b$var$KeyPair(eddsa, {
        secret: secret
    });
};
$12ffb49ca423a34b$var$KeyPair.prototype.secret = function secret() {
    return this._secret;
};
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pubBytes", function pubBytes() {
    return this.eddsa.encodePoint(this.pub());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "pub", function pub() {
    if (this._pubBytes) return this.eddsa.decodePoint(this._pubBytes);
    return this.eddsa.g.mul(this.priv());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "privBytes", function privBytes() {
    var eddsa = this.eddsa;
    var hash = this.hash();
    var lastIx = eddsa.encodingLength - 1;
    var a = hash.slice(0, eddsa.encodingLength);
    a[0] &= 248;
    a[lastIx] &= 127;
    a[lastIx] |= 64;
    return a;
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "priv", function priv() {
    return this.eddsa.decodeInt(this.privBytes());
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "hash", function hash() {
    return this.eddsa.hash().update(this.secret()).digest();
});
$12ffb49ca423a34b$var$cachedProperty($12ffb49ca423a34b$var$KeyPair, "messagePrefix", function messagePrefix() {
    return this.hash().slice(this.eddsa.encodingLength);
});
$12ffb49ca423a34b$var$KeyPair.prototype.sign = function sign(message) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair can only verify");
    return this.eddsa.sign(message, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.verify = function verify(message, sig) {
    return this.eddsa.verify(message, sig, this);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getSecret = function getSecret(enc) {
    $12ffb49ca423a34b$var$assert(this._secret, "KeyPair is public only");
    return $gEVtY.encode(this.secret(), enc);
};
$12ffb49ca423a34b$var$KeyPair.prototype.getPublic = function getPublic(enc) {
    return $gEVtY.encode(this.pubBytes(), enc);
};
module.exports = $12ffb49ca423a34b$var$KeyPair;

});

parcelRegister("7XcGE", function(module, exports) {
"use strict";

var $jX0xT = parcelRequire("jX0xT");

var $gEVtY = parcelRequire("gEVtY");
var $5ca7e26f93e1a560$var$assert = $gEVtY.assert;
var $5ca7e26f93e1a560$var$cachedProperty = $gEVtY.cachedProperty;
var $5ca7e26f93e1a560$var$parseBytes = $gEVtY.parseBytes;
/**
* @param {EDDSA} eddsa - eddsa instance
* @param {Array<Bytes>|Object} sig -
* @param {Array<Bytes>|Point} [sig.R] - R point as Point or bytes
* @param {Array<Bytes>|bn} [sig.S] - S scalar as bn or bytes
* @param {Array<Bytes>} [sig.Rencoded] - R point encoded
* @param {Array<Bytes>} [sig.Sencoded] - S scalar encoded
*/ function $5ca7e26f93e1a560$var$Signature(eddsa, sig) {
    this.eddsa = eddsa;
    if (typeof sig !== "object") sig = $5ca7e26f93e1a560$var$parseBytes(sig);
    if (Array.isArray(sig)) {
        $5ca7e26f93e1a560$var$assert(sig.length === eddsa.encodingLength * 2, "Signature has invalid size");
        sig = {
            R: sig.slice(0, eddsa.encodingLength),
            S: sig.slice(eddsa.encodingLength)
        };
    }
    $5ca7e26f93e1a560$var$assert(sig.R && sig.S, "Signature without R or S");
    if (eddsa.isPoint(sig.R)) this._R = sig.R;
    if (sig.S instanceof $jX0xT) this._S = sig.S;
    this._Rencoded = Array.isArray(sig.R) ? sig.R : sig.Rencoded;
    this._Sencoded = Array.isArray(sig.S) ? sig.S : sig.Sencoded;
}
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "S", function S() {
    return this.eddsa.decodeInt(this.Sencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "R", function R() {
    return this.eddsa.decodePoint(this.Rencoded());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Rencoded", function Rencoded() {
    return this.eddsa.encodePoint(this.R());
});
$5ca7e26f93e1a560$var$cachedProperty($5ca7e26f93e1a560$var$Signature, "Sencoded", function Sencoded() {
    return this.eddsa.encodeInt(this.S());
});
$5ca7e26f93e1a560$var$Signature.prototype.toBytes = function toBytes() {
    return this.Rencoded().concat(this.Sencoded());
};
$5ca7e26f93e1a560$var$Signature.prototype.toHex = function toHex() {
    return $gEVtY.encode(this.toBytes(), "hex").toUpperCase();
};
module.exports = $5ca7e26f93e1a560$var$Signature;

});


parcelRegister("7dYL4", function(module, exports) {
module.exports = JSON.parse('{"OP_FALSE":0,"OP_0":0,"OP_PUSHDATA1":76,"OP_PUSHDATA2":77,"OP_PUSHDATA4":78,"OP_1NEGATE":79,"OP_RESERVED":80,"OP_TRUE":81,"OP_1":81,"OP_2":82,"OP_3":83,"OP_4":84,"OP_5":85,"OP_6":86,"OP_7":87,"OP_8":88,"OP_9":89,"OP_10":90,"OP_11":91,"OP_12":92,"OP_13":93,"OP_14":94,"OP_15":95,"OP_16":96,"OP_NOP":97,"OP_VER":98,"OP_IF":99,"OP_NOTIF":100,"OP_VERIF":101,"OP_VERNOTIF":102,"OP_ELSE":103,"OP_ENDIF":104,"OP_VERIFY":105,"OP_RETURN":106,"OP_TOALTSTACK":107,"OP_FROMALTSTACK":108,"OP_2DROP":109,"OP_2DUP":110,"OP_3DUP":111,"OP_2OVER":112,"OP_2ROT":113,"OP_2SWAP":114,"OP_IFDUP":115,"OP_DEPTH":116,"OP_DROP":117,"OP_DUP":118,"OP_NIP":119,"OP_OVER":120,"OP_PICK":121,"OP_ROLL":122,"OP_ROT":123,"OP_SWAP":124,"OP_TUCK":125,"OP_CAT":126,"OP_SUBSTR":127,"OP_LEFT":128,"OP_RIGHT":129,"OP_SIZE":130,"OP_INVERT":131,"OP_AND":132,"OP_OR":133,"OP_XOR":134,"OP_EQUAL":135,"OP_EQUALVERIFY":136,"OP_RESERVED1":137,"OP_RESERVED2":138,"OP_1ADD":139,"OP_1SUB":140,"OP_2MUL":141,"OP_2DIV":142,"OP_NEGATE":143,"OP_ABS":144,"OP_NOT":145,"OP_0NOTEQUAL":146,"OP_ADD":147,"OP_SUB":148,"OP_MUL":149,"OP_DIV":150,"OP_MOD":151,"OP_LSHIFT":152,"OP_RSHIFT":153,"OP_BOOLAND":154,"OP_BOOLOR":155,"OP_NUMEQUAL":156,"OP_NUMEQUALVERIFY":157,"OP_NUMNOTEQUAL":158,"OP_LESSTHAN":159,"OP_GREATERTHAN":160,"OP_LESSTHANOREQUAL":161,"OP_GREATERTHANOREQUAL":162,"OP_MIN":163,"OP_MAX":164,"OP_WITHIN":165,"OP_RIPEMD160":166,"OP_SHA1":167,"OP_SHA256":168,"OP_HASH160":169,"OP_HASH256":170,"OP_CODESEPARATOR":171,"OP_CHECKSIG":172,"OP_CHECKSIGVERIFY":173,"OP_CHECKMULTISIG":174,"OP_CHECKMULTISIGVERIFY":175,"OP_NOP1":176,"OP_NOP2":177,"OP_CHECKLOCKTIMEVERIFY":177,"OP_NOP3":178,"OP_CHECKSEQUENCEVERIFY":178,"OP_NOP4":179,"OP_NOP5":180,"OP_NOP6":181,"OP_NOP7":182,"OP_NOP8":183,"OP_NOP9":184,"OP_NOP10":185,"OP_PUBKEYHASH":253,"OP_PUBKEY":254,"OP_INVALIDOPCODE":255}');

});

parcelRegister("hkN9y", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
// limit of Crypto.getRandomValues()
// https://developer.mozilla.org/en-US/docs/Web/API/Crypto/getRandomValues
var $c9ea6eb6e1b0be83$var$MAX_BYTES = 65536;
// Node supports requesting up to this number of bytes
// https://github.com/nodejs/node/blob/master/lib/internal/crypto/random.js#L48
var $c9ea6eb6e1b0be83$var$MAX_UINT32 = 4294967295;
function $c9ea6eb6e1b0be83$var$oldBrowser() {
    throw new Error("Secure random number generation is not supported by this browser.\nUse Chrome, Firefox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");
var $c9ea6eb6e1b0be83$require$Buffer = $1U9GM.Buffer;
var $c9ea6eb6e1b0be83$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
if ($c9ea6eb6e1b0be83$var$crypto && $c9ea6eb6e1b0be83$var$crypto.getRandomValues) module.exports = $c9ea6eb6e1b0be83$var$randomBytes;
else module.exports = $c9ea6eb6e1b0be83$var$oldBrowser;
function $c9ea6eb6e1b0be83$var$randomBytes(size, cb) {
    // phantomjs needs to throw
    if (size > $c9ea6eb6e1b0be83$var$MAX_UINT32) throw new RangeError("requested too many random bytes");
    var bytes = $c9ea6eb6e1b0be83$require$Buffer.allocUnsafe(size);
    if (size > 0) {
        if (size > $c9ea6eb6e1b0be83$var$MAX_BYTES) // can do at once see https://developer.mozilla.org/en-US/docs/Web/API/window.crypto.getRandomValues
        for(var generated = 0; generated < size; generated += $c9ea6eb6e1b0be83$var$MAX_BYTES)// buffer.slice automatically checks if the end is past the end of
        // the buffer so we don't have to here
        $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes.slice(generated, generated + $c9ea6eb6e1b0be83$var$MAX_BYTES));
        else $c9ea6eb6e1b0be83$var$crypto.getRandomValues(bytes);
    }
    if (typeof cb === "function") return $hPtJY.nextTick(function() {
        cb(null, bytes);
    });
    return bytes;
}

});

parcelRegister("6swAi", function(module, exports) {
module.exports = JSON.parse('{"sha224WithRSAEncryption":{"sign":"rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"RSA-SHA224":{"sign":"ecdsa/rsa","hash":"sha224","id":"302d300d06096086480165030402040500041c"},"sha256WithRSAEncryption":{"sign":"rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"RSA-SHA256":{"sign":"ecdsa/rsa","hash":"sha256","id":"3031300d060960864801650304020105000420"},"sha384WithRSAEncryption":{"sign":"rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"RSA-SHA384":{"sign":"ecdsa/rsa","hash":"sha384","id":"3041300d060960864801650304020205000430"},"sha512WithRSAEncryption":{"sign":"rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA512":{"sign":"ecdsa/rsa","hash":"sha512","id":"3051300d060960864801650304020305000440"},"RSA-SHA1":{"sign":"rsa","hash":"sha1","id":"3021300906052b0e03021a05000414"},"ecdsa-with-SHA1":{"sign":"ecdsa","hash":"sha1","id":""},"sha256":{"sign":"ecdsa","hash":"sha256","id":""},"sha224":{"sign":"ecdsa","hash":"sha224","id":""},"sha384":{"sign":"ecdsa","hash":"sha384","id":""},"sha512":{"sign":"ecdsa","hash":"sha512","id":""},"DSA-SHA":{"sign":"dsa","hash":"sha1","id":""},"DSA-SHA1":{"sign":"dsa","hash":"sha1","id":""},"DSA":{"sign":"dsa","hash":"sha1","id":""},"DSA-WITH-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-SHA224":{"sign":"dsa","hash":"sha224","id":""},"DSA-WITH-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-SHA256":{"sign":"dsa","hash":"sha256","id":""},"DSA-WITH-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-SHA384":{"sign":"dsa","hash":"sha384","id":""},"DSA-WITH-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-SHA512":{"sign":"dsa","hash":"sha512","id":""},"DSA-RIPEMD160":{"sign":"dsa","hash":"rmd160","id":""},"ripemd160WithRSA":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"RSA-RIPEMD160":{"sign":"rsa","hash":"rmd160","id":"3021300906052b2403020105000414"},"md5WithRSAEncryption":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"},"RSA-MD5":{"sign":"rsa","hash":"md5","id":"3020300c06082a864886f70d020505000410"}}');

});

parcelRegister("5dQ72", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $3cd697166017b735$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $1VtKc = parcelRequire("1VtKc");

var $kiaDM = parcelRequire("kiaDM");
var $3cd697166017b735$var$ZERO_BUF;
var $3cd697166017b735$var$subtle = $parcel$global.crypto && $parcel$global.crypto.subtle;
var $3cd697166017b735$var$toBrowser = {
    sha: "SHA-1",
    "sha-1": "SHA-1",
    sha1: "SHA-1",
    sha256: "SHA-256",
    "sha-256": "SHA-256",
    sha384: "SHA-384",
    "sha-384": "SHA-384",
    "sha-512": "SHA-512",
    sha512: "SHA-512"
};
var $3cd697166017b735$var$checks = [];
function $3cd697166017b735$var$checkNative(algo) {
    if ($parcel$global.process && !$parcel$global.process.browser) return Promise.resolve(false);
    if (!$3cd697166017b735$var$subtle || !$3cd697166017b735$var$subtle.importKey || !$3cd697166017b735$var$subtle.deriveBits) return Promise.resolve(false);
    if ($3cd697166017b735$var$checks[algo] !== undefined) return $3cd697166017b735$var$checks[algo];
    $3cd697166017b735$var$ZERO_BUF = $3cd697166017b735$var$ZERO_BUF || $3cd697166017b735$require$Buffer.alloc(8);
    var prom = $3cd697166017b735$var$browserPbkdf2($3cd697166017b735$var$ZERO_BUF, $3cd697166017b735$var$ZERO_BUF, 10, 128, algo).then(function() {
        return true;
    }).catch(function() {
        return false;
    });
    $3cd697166017b735$var$checks[algo] = prom;
    return prom;
}
var $3cd697166017b735$var$nextTick;
function $3cd697166017b735$var$getNextTick() {
    if ($3cd697166017b735$var$nextTick) return $3cd697166017b735$var$nextTick;
    if ($parcel$global.process && $parcel$global.process.nextTick) $3cd697166017b735$var$nextTick = $parcel$global.process.nextTick;
    else if ($parcel$global.queueMicrotask) $3cd697166017b735$var$nextTick = $parcel$global.queueMicrotask;
    else if ($parcel$global.setImmediate) $3cd697166017b735$var$nextTick = $parcel$global.setImmediate;
    else $3cd697166017b735$var$nextTick = $parcel$global.setTimeout;
    return $3cd697166017b735$var$nextTick;
}
function $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, length, algo) {
    return $3cd697166017b735$var$subtle.importKey("raw", password, {
        name: "PBKDF2"
    }, false, [
        "deriveBits"
    ]).then(function(key) {
        return $3cd697166017b735$var$subtle.deriveBits({
            name: "PBKDF2",
            salt: salt,
            iterations: iterations,
            hash: {
                name: algo
            }
        }, key, length << 3);
    }).then(function(res) {
        return $3cd697166017b735$require$Buffer.from(res);
    });
}
function $3cd697166017b735$var$resolvePromise(promise, callback) {
    promise.then(function(out) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(null, out);
        });
    }, function(e) {
        $3cd697166017b735$var$getNextTick()(function() {
            callback(e);
        });
    });
}
module.exports = function(password, salt, iterations, keylen, digest, callback) {
    if (typeof digest === "function") {
        callback = digest;
        digest = undefined;
    }
    digest = digest || "sha1";
    var algo = $3cd697166017b735$var$toBrowser[digest.toLowerCase()];
    if (!algo || typeof $parcel$global.Promise !== "function") {
        $3cd697166017b735$var$getNextTick()(function() {
            var out;
            try {
                out = $1VtKc(password, salt, iterations, keylen, digest);
            } catch (e) {
                return callback(e);
            }
            callback(null, out);
        });
        return;
    }
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    if (typeof callback !== "function") throw new Error("No callback provided to pbkdf2");
    $3cd697166017b735$var$resolvePromise($3cd697166017b735$var$checkNative(algo).then(function(resp) {
        if (resp) return $3cd697166017b735$var$browserPbkdf2(password, salt, iterations, keylen, algo);
        return $1VtKc(password, salt, iterations, keylen, digest);
    }), callback);
};

});
parcelRegister("7dtUH", function(module, exports) {
var $5410f37dea3a95ee$var$MAX_ALLOC = Math.pow(2, 30) - 1 // default in iojs
;
module.exports = function(iterations, keylen) {
    if (typeof iterations !== "number") throw new TypeError("Iterations not a number");
    if (iterations < 0) throw new TypeError("Bad iterations");
    if (typeof keylen !== "number") throw new TypeError("Key length not a number");
    if (keylen < 0 || keylen > $5410f37dea3a95ee$var$MAX_ALLOC || keylen !== keylen) throw new TypeError("Bad key length");
};

});

parcelRegister("6YaY3", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
var $5130da986dd86f24$var$defaultEncoding;
/* istanbul ignore next */ if ($parcel$global.process && $parcel$global.process.browser) $5130da986dd86f24$var$defaultEncoding = "utf-8";
else if ($parcel$global.process && $parcel$global.process.version) {
    var $5130da986dd86f24$var$pVersionMajor = parseInt($hPtJY.version.split(".")[0].slice(1), 10);
    $5130da986dd86f24$var$defaultEncoding = $5130da986dd86f24$var$pVersionMajor >= 6 ? "utf-8" : "binary";
} else $5130da986dd86f24$var$defaultEncoding = "utf-8";
module.exports = $5130da986dd86f24$var$defaultEncoding;

});

parcelRegister("1VtKc", function(module, exports) {

var $8nM4g = parcelRequire("8nM4g");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");

var $1U9GM = parcelRequire("1U9GM");
var $16722fe28cdbf3c2$require$Buffer = $1U9GM.Buffer;

var $7dtUH = parcelRequire("7dtUH");

var $6YaY3 = parcelRequire("6YaY3");

var $kiaDM = parcelRequire("kiaDM");
var $16722fe28cdbf3c2$var$ZEROS = $16722fe28cdbf3c2$require$Buffer.alloc(128);
var $16722fe28cdbf3c2$var$sizes = {
    md5: 16,
    sha1: 20,
    sha224: 28,
    sha256: 32,
    sha384: 48,
    sha512: 64,
    rmd160: 20,
    ripemd160: 20
};
function $16722fe28cdbf3c2$var$Hmac(alg, key, saltLen) {
    var hash = $16722fe28cdbf3c2$var$getDigest(alg);
    var blocksize = alg === "sha512" || alg === "sha384" ? 128 : 64;
    if (key.length > blocksize) key = hash(key);
    else if (key.length < blocksize) key = $16722fe28cdbf3c2$require$Buffer.concat([
        key,
        $16722fe28cdbf3c2$var$ZEROS
    ], blocksize);
    var ipad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    var opad = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + $16722fe28cdbf3c2$var$sizes[alg]);
    for(var i = 0; i < blocksize; i++){
        ipad[i] = key[i] ^ 0x36;
        opad[i] = key[i] ^ 0x5C;
    }
    var ipad1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(blocksize + saltLen + 4);
    ipad.copy(ipad1, 0, 0, blocksize);
    this.ipad1 = ipad1;
    this.ipad2 = ipad;
    this.opad = opad;
    this.alg = alg;
    this.blocksize = blocksize;
    this.hash = hash;
    this.size = $16722fe28cdbf3c2$var$sizes[alg];
}
$16722fe28cdbf3c2$var$Hmac.prototype.run = function(data, ipad) {
    data.copy(ipad, this.blocksize);
    var h = this.hash(ipad);
    h.copy(this.opad, this.blocksize);
    return this.hash(this.opad);
};
function $16722fe28cdbf3c2$var$getDigest(alg) {
    function shaFunc(data) {
        return $5Z1sR(alg).update(data).digest();
    }
    function rmd160Func(data) {
        return new $a8qBR().update(data).digest();
    }
    if (alg === "rmd160" || alg === "ripemd160") return rmd160Func;
    if (alg === "md5") return $8nM4g;
    return shaFunc;
}
function $16722fe28cdbf3c2$var$pbkdf2(password, salt, iterations, keylen, digest) {
    $7dtUH(iterations, keylen);
    password = $kiaDM(password, $6YaY3, "Password");
    salt = $kiaDM(salt, $6YaY3, "Salt");
    digest = digest || "sha1";
    var hmac = new $16722fe28cdbf3c2$var$Hmac(digest, password, salt.length);
    var DK = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(keylen);
    var block1 = $16722fe28cdbf3c2$require$Buffer.allocUnsafe(salt.length + 4);
    salt.copy(block1, 0, 0, salt.length);
    var destPos = 0;
    var hLen = $16722fe28cdbf3c2$var$sizes[digest];
    var l = Math.ceil(keylen / hLen);
    for(var i = 1; i <= l; i++){
        block1.writeUInt32BE(i, salt.length);
        var T = hmac.run(block1, hmac.ipad1);
        var U = T;
        for(var j = 1; j < iterations; j++){
            U = hmac.run(U, hmac.ipad2);
            for(var k = 0; k < hLen; k++)T[k] ^= U[k];
        }
        T.copy(DK, destPos);
        destPos += hLen;
    }
    return DK;
}
module.exports = $16722fe28cdbf3c2$var$pbkdf2;

});
parcelRegister("kiaDM", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $ec5dbe1d2de061b3$require$Buffer = $1U9GM.Buffer;
module.exports = function(thing, encoding, name) {
    if ($ec5dbe1d2de061b3$require$Buffer.isBuffer(thing)) return thing;
    else if (typeof thing === "string") return $ec5dbe1d2de061b3$require$Buffer.from(thing, encoding);
    else if (ArrayBuffer.isView(thing)) return $ec5dbe1d2de061b3$require$Buffer.from(thing.buffer);
    else throw new TypeError(name + " must be a string, a Buffer, a typed array or a DataView");
};

});



parcelRegister("dyok1", function(module, exports) {

$parcel$export(module.exports, "readUInt32BE", () => $9de15128f81796e0$export$cfaef8ed399428b0, (v) => $9de15128f81796e0$export$cfaef8ed399428b0 = v);
$parcel$export(module.exports, "writeUInt32BE", () => $9de15128f81796e0$export$a80c7deaea7cbd80, (v) => $9de15128f81796e0$export$a80c7deaea7cbd80 = v);
$parcel$export(module.exports, "ip", () => $9de15128f81796e0$export$ed7577ae6e1cd0ef, (v) => $9de15128f81796e0$export$ed7577ae6e1cd0ef = v);
$parcel$export(module.exports, "rip", () => $9de15128f81796e0$export$5dcbef3aa594f567, (v) => $9de15128f81796e0$export$5dcbef3aa594f567 = v);
$parcel$export(module.exports, "pc1", () => $9de15128f81796e0$export$5bc8001ca71ed9c5, (v) => $9de15128f81796e0$export$5bc8001ca71ed9c5 = v);
$parcel$export(module.exports, "r28shl", () => $9de15128f81796e0$export$3e714e2c5d5d8cb2, (v) => $9de15128f81796e0$export$3e714e2c5d5d8cb2 = v);
$parcel$export(module.exports, "pc2", () => $9de15128f81796e0$export$94c3e544fd062b7f, (v) => $9de15128f81796e0$export$94c3e544fd062b7f = v);
$parcel$export(module.exports, "expand", () => $9de15128f81796e0$export$9f77e0932fb78f72, (v) => $9de15128f81796e0$export$9f77e0932fb78f72 = v);
$parcel$export(module.exports, "substitute", () => $9de15128f81796e0$export$d865ce2836f5927f, (v) => $9de15128f81796e0$export$d865ce2836f5927f = v);
$parcel$export(module.exports, "permute", () => $9de15128f81796e0$export$95e62ad65da8b7d2, (v) => $9de15128f81796e0$export$95e62ad65da8b7d2 = v);
$parcel$export(module.exports, "padSplit", () => $9de15128f81796e0$export$209139ff098c441a, (v) => $9de15128f81796e0$export$209139ff098c441a = v);
var $9de15128f81796e0$export$cfaef8ed399428b0;
var $9de15128f81796e0$export$a80c7deaea7cbd80;
var $9de15128f81796e0$export$ed7577ae6e1cd0ef;
var $9de15128f81796e0$export$5dcbef3aa594f567;
var $9de15128f81796e0$export$5bc8001ca71ed9c5;
var $9de15128f81796e0$export$3e714e2c5d5d8cb2;
var $9de15128f81796e0$export$94c3e544fd062b7f;
var $9de15128f81796e0$export$9f77e0932fb78f72;
var $9de15128f81796e0$export$d865ce2836f5927f;
var $9de15128f81796e0$export$95e62ad65da8b7d2;
var $9de15128f81796e0$export$209139ff098c441a;
"use strict";
$9de15128f81796e0$export$cfaef8ed399428b0 = function readUInt32BE(bytes, off) {
    var res = bytes[0 + off] << 24 | bytes[1 + off] << 16 | bytes[2 + off] << 8 | bytes[3 + off];
    return res >>> 0;
};
$9de15128f81796e0$export$a80c7deaea7cbd80 = function writeUInt32BE(bytes, value, off) {
    bytes[0 + off] = value >>> 24;
    bytes[1 + off] = value >>> 16 & 0xff;
    bytes[2 + off] = value >>> 8 & 0xff;
    bytes[3 + off] = value & 0xff;
};
$9de15128f81796e0$export$ed7577ae6e1cd0ef = function ip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >>> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >>> j + i & 1;
        }
    }
    for(var i = 6; i >= 0; i -= 2){
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inR >>> j + i & 1;
        }
        for(var j = 1; j <= 25; j += 8){
            outR <<= 1;
            outR |= inL >>> j + i & 1;
        }
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5dcbef3aa594f567 = function rip(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    for(var i = 0; i < 4; i++)for(var j = 24; j >= 0; j -= 8){
        outL <<= 1;
        outL |= inR >>> j + i & 1;
        outL <<= 1;
        outL |= inL >>> j + i & 1;
    }
    for(var i = 4; i < 8; i++)for(var j = 24; j >= 0; j -= 8){
        outR <<= 1;
        outR |= inR >>> j + i & 1;
        outR <<= 1;
        outR |= inL >>> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$5bc8001ca71ed9c5 = function pc1(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    // 7, 15, 23, 31, 39, 47, 55, 63
    // 6, 14, 22, 30, 39, 47, 55, 63
    // 5, 13, 21, 29, 39, 47, 55, 63
    // 4, 12, 20, 28
    for(var i = 7; i >= 5; i--){
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outL <<= 1;
            outL |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outL <<= 1;
        outL |= inR >> j + i & 1;
    }
    // 1, 9, 17, 25, 33, 41, 49, 57
    // 2, 10, 18, 26, 34, 42, 50, 58
    // 3, 11, 19, 27, 35, 43, 51, 59
    // 36, 44, 52, 60
    for(var i = 1; i <= 3; i++){
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inR >> j + i & 1;
        }
        for(var j = 0; j <= 24; j += 8){
            outR <<= 1;
            outR |= inL >> j + i & 1;
        }
    }
    for(var j = 0; j <= 24; j += 8){
        outR <<= 1;
        outR |= inL >> j + i & 1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$3e714e2c5d5d8cb2 = function r28shl(num, shift) {
    return num << shift & 0xfffffff | num >>> 28 - shift;
};
var $9de15128f81796e0$var$pc2table = [
    // inL => outL
    14,
    11,
    17,
    4,
    27,
    23,
    25,
    0,
    13,
    22,
    7,
    18,
    5,
    9,
    16,
    24,
    2,
    20,
    12,
    21,
    1,
    8,
    15,
    26,
    // inR => outR
    15,
    4,
    25,
    19,
    9,
    1,
    26,
    16,
    5,
    11,
    23,
    8,
    12,
    7,
    17,
    0,
    22,
    3,
    10,
    14,
    6,
    20,
    27,
    24
];
$9de15128f81796e0$export$94c3e544fd062b7f = function pc2(inL, inR, out, off) {
    var outL = 0;
    var outR = 0;
    var len = $9de15128f81796e0$var$pc2table.length >>> 1;
    for(var i = 0; i < len; i++){
        outL <<= 1;
        outL |= inL >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    for(var i = len; i < $9de15128f81796e0$var$pc2table.length; i++){
        outR <<= 1;
        outR |= inR >>> $9de15128f81796e0$var$pc2table[i] & 0x1;
    }
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
$9de15128f81796e0$export$9f77e0932fb78f72 = function expand(r, out, off) {
    var outL = 0;
    var outR = 0;
    outL = (r & 1) << 5 | r >>> 27;
    for(var i = 23; i >= 15; i -= 4){
        outL <<= 6;
        outL |= r >>> i & 0x3f;
    }
    for(var i = 11; i >= 3; i -= 4){
        outR |= r >>> i & 0x3f;
        outR <<= 6;
    }
    outR |= (r & 0x1f) << 1 | r >>> 31;
    out[off + 0] = outL >>> 0;
    out[off + 1] = outR >>> 0;
};
var $9de15128f81796e0$var$sTable = [
    14,
    0,
    4,
    15,
    13,
    7,
    1,
    4,
    2,
    14,
    15,
    2,
    11,
    13,
    8,
    1,
    3,
    10,
    10,
    6,
    6,
    12,
    12,
    11,
    5,
    9,
    9,
    5,
    0,
    3,
    7,
    8,
    4,
    15,
    1,
    12,
    14,
    8,
    8,
    2,
    13,
    4,
    6,
    9,
    2,
    1,
    11,
    7,
    15,
    5,
    12,
    11,
    9,
    3,
    7,
    14,
    3,
    10,
    10,
    0,
    5,
    6,
    0,
    13,
    15,
    3,
    1,
    13,
    8,
    4,
    14,
    7,
    6,
    15,
    11,
    2,
    3,
    8,
    4,
    14,
    9,
    12,
    7,
    0,
    2,
    1,
    13,
    10,
    12,
    6,
    0,
    9,
    5,
    11,
    10,
    5,
    0,
    13,
    14,
    8,
    7,
    10,
    11,
    1,
    10,
    3,
    4,
    15,
    13,
    4,
    1,
    2,
    5,
    11,
    8,
    6,
    12,
    7,
    6,
    12,
    9,
    0,
    3,
    5,
    2,
    14,
    15,
    9,
    10,
    13,
    0,
    7,
    9,
    0,
    14,
    9,
    6,
    3,
    3,
    4,
    15,
    6,
    5,
    10,
    1,
    2,
    13,
    8,
    12,
    5,
    7,
    14,
    11,
    12,
    4,
    11,
    2,
    15,
    8,
    1,
    13,
    1,
    6,
    10,
    4,
    13,
    9,
    0,
    8,
    6,
    15,
    9,
    3,
    8,
    0,
    7,
    11,
    4,
    1,
    15,
    2,
    14,
    12,
    3,
    5,
    11,
    10,
    5,
    14,
    2,
    7,
    12,
    7,
    13,
    13,
    8,
    14,
    11,
    3,
    5,
    0,
    6,
    6,
    15,
    9,
    0,
    10,
    3,
    1,
    4,
    2,
    7,
    8,
    2,
    5,
    12,
    11,
    1,
    12,
    10,
    4,
    14,
    15,
    9,
    10,
    3,
    6,
    15,
    9,
    0,
    0,
    6,
    12,
    10,
    11,
    1,
    7,
    13,
    13,
    8,
    15,
    9,
    1,
    4,
    3,
    5,
    14,
    11,
    5,
    12,
    2,
    7,
    8,
    2,
    4,
    14,
    2,
    14,
    12,
    11,
    4,
    2,
    1,
    12,
    7,
    4,
    10,
    7,
    11,
    13,
    6,
    1,
    8,
    5,
    5,
    0,
    3,
    15,
    15,
    10,
    13,
    3,
    0,
    9,
    14,
    8,
    9,
    6,
    4,
    11,
    2,
    8,
    1,
    12,
    11,
    7,
    10,
    1,
    13,
    14,
    7,
    2,
    8,
    13,
    15,
    6,
    9,
    15,
    12,
    0,
    5,
    9,
    6,
    10,
    3,
    4,
    0,
    5,
    14,
    3,
    12,
    10,
    1,
    15,
    10,
    4,
    15,
    2,
    9,
    7,
    2,
    12,
    6,
    9,
    8,
    5,
    0,
    6,
    13,
    1,
    3,
    13,
    4,
    14,
    14,
    0,
    7,
    11,
    5,
    3,
    11,
    8,
    9,
    4,
    14,
    3,
    15,
    2,
    5,
    12,
    2,
    9,
    8,
    5,
    12,
    15,
    3,
    10,
    7,
    11,
    0,
    14,
    4,
    1,
    10,
    7,
    1,
    6,
    13,
    0,
    11,
    8,
    6,
    13,
    4,
    13,
    11,
    0,
    2,
    11,
    14,
    7,
    15,
    4,
    0,
    9,
    8,
    1,
    13,
    10,
    3,
    14,
    12,
    3,
    9,
    5,
    7,
    12,
    5,
    2,
    10,
    15,
    6,
    8,
    1,
    6,
    1,
    6,
    4,
    11,
    11,
    13,
    13,
    8,
    12,
    1,
    3,
    4,
    7,
    10,
    14,
    7,
    10,
    9,
    15,
    5,
    6,
    0,
    8,
    15,
    0,
    14,
    5,
    2,
    9,
    3,
    2,
    12,
    13,
    1,
    2,
    15,
    8,
    13,
    4,
    8,
    6,
    10,
    15,
    3,
    11,
    7,
    1,
    4,
    10,
    12,
    9,
    5,
    3,
    6,
    14,
    11,
    5,
    0,
    0,
    14,
    12,
    9,
    7,
    2,
    7,
    2,
    11,
    1,
    4,
    14,
    1,
    7,
    9,
    4,
    12,
    10,
    14,
    8,
    2,
    13,
    0,
    15,
    6,
    12,
    10,
    9,
    13,
    0,
    15,
    3,
    3,
    5,
    5,
    6,
    8,
    11
];
$9de15128f81796e0$export$d865ce2836f5927f = function substitute(inL, inR) {
    var out = 0;
    for(var i = 0; i < 4; i++){
        var b = inL >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    for(var i = 0; i < 4; i++){
        var b = inR >>> 18 - i * 6 & 0x3f;
        var sb = $9de15128f81796e0$var$sTable[256 + i * 0x40 + b];
        out <<= 4;
        out |= sb;
    }
    return out >>> 0;
};
var $9de15128f81796e0$var$permuteTable = [
    16,
    25,
    12,
    11,
    3,
    20,
    4,
    15,
    31,
    17,
    9,
    6,
    27,
    14,
    1,
    22,
    30,
    24,
    8,
    18,
    0,
    5,
    29,
    23,
    13,
    19,
    2,
    26,
    10,
    21,
    28,
    7
];
$9de15128f81796e0$export$95e62ad65da8b7d2 = function permute(num) {
    var out = 0;
    for(var i = 0; i < $9de15128f81796e0$var$permuteTable.length; i++){
        out <<= 1;
        out |= num >>> $9de15128f81796e0$var$permuteTable[i] & 0x1;
    }
    return out >>> 0;
};
$9de15128f81796e0$export$209139ff098c441a = function padSplit(num, size, group) {
    var str = num.toString(2);
    while(str.length < size)str = "0" + str;
    var out = [];
    for(var i = 0; i < size; i += group)out.push(str.slice(i, i + group));
    return out.join(" ");
};

});

parcelRegister("enfpo", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");
function $a76f2a83ec677410$var$Cipher(options) {
    this.options = options;
    this.type = this.options.type;
    this.blockSize = 8;
    this._init();
    this.buffer = new Array(this.blockSize);
    this.bufferOff = 0;
    this.padding = options.padding !== false;
}
module.exports = $a76f2a83ec677410$var$Cipher;
$a76f2a83ec677410$var$Cipher.prototype._init = function _init() {
// Might be overrided
};
$a76f2a83ec677410$var$Cipher.prototype.update = function update(data) {
    if (data.length === 0) return [];
    if (this.type === "decrypt") return this._updateDecrypt(data);
    else return this._updateEncrypt(data);
};
$a76f2a83ec677410$var$Cipher.prototype._buffer = function _buffer(data, off) {
    // Append data to buffer
    var min = Math.min(this.buffer.length - this.bufferOff, data.length - off);
    for(var i = 0; i < min; i++)this.buffer[this.bufferOff + i] = data[off + i];
    this.bufferOff += min;
    // Shift next
    return min;
};
$a76f2a83ec677410$var$Cipher.prototype._flushBuffer = function _flushBuffer(out, off) {
    this._update(this.buffer, 0, out, off);
    this.bufferOff = 0;
    return this.blockSize;
};
$a76f2a83ec677410$var$Cipher.prototype._updateEncrypt = function _updateEncrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = (this.bufferOff + data.length) / this.blockSize | 0;
    var out = new Array(count * this.blockSize);
    if (this.bufferOff !== 0) {
        inputOff += this._buffer(data, inputOff);
        if (this.bufferOff === this.buffer.length) outputOff += this._flushBuffer(out, outputOff);
    }
    // Write blocks
    var max = data.length - (data.length - inputOff) % this.blockSize;
    for(; inputOff < max; inputOff += this.blockSize){
        this._update(data, inputOff, out, outputOff);
        outputOff += this.blockSize;
    }
    // Queue rest
    for(; inputOff < data.length; inputOff++, this.bufferOff++)this.buffer[this.bufferOff] = data[inputOff];
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._updateDecrypt = function _updateDecrypt(data) {
    var inputOff = 0;
    var outputOff = 0;
    var count = Math.ceil((this.bufferOff + data.length) / this.blockSize) - 1;
    var out = new Array(count * this.blockSize);
    // TODO(indutny): optimize it, this is far from optimal
    for(; count > 0; count--){
        inputOff += this._buffer(data, inputOff);
        outputOff += this._flushBuffer(out, outputOff);
    }
    // Buffer rest of the input
    inputOff += this._buffer(data, inputOff);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype.final = function final(buffer) {
    var first;
    if (buffer) first = this.update(buffer);
    var last;
    if (this.type === "encrypt") last = this._finalEncrypt();
    else last = this._finalDecrypt();
    if (first) return first.concat(last);
    else return last;
};
$a76f2a83ec677410$var$Cipher.prototype._pad = function _pad(buffer, off) {
    if (off === 0) return false;
    while(off < buffer.length)buffer[off++] = 0;
    return true;
};
$a76f2a83ec677410$var$Cipher.prototype._finalEncrypt = function _finalEncrypt() {
    if (!this._pad(this.buffer, this.bufferOff)) return [];
    var out = new Array(this.blockSize);
    this._update(this.buffer, 0, out, 0);
    return out;
};
$a76f2a83ec677410$var$Cipher.prototype._unpad = function _unpad(buffer) {
    return buffer;
};
$a76f2a83ec677410$var$Cipher.prototype._finalDecrypt = function _finalDecrypt() {
    $koC21.equal(this.bufferOff, this.blockSize, "Not enough data to decrypt");
    var out = new Array(this.blockSize);
    this._flushBuffer(out, 0);
    return this._unpad(out);
};

});

parcelRegister("dB8Kv", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $dyok1 = parcelRequire("dyok1");

var $enfpo = parcelRequire("enfpo");
function $9e6584766ef755d8$var$DESState() {
    this.tmp = new Array(2);
    this.keys = null;
}
function $9e6584766ef755d8$var$DES(options) {
    $enfpo.call(this, options);
    var state = new $9e6584766ef755d8$var$DESState();
    this._desState = state;
    this.deriveKeys(state, options.key);
}
$dlqwk($9e6584766ef755d8$var$DES, $enfpo);
module.exports = $9e6584766ef755d8$var$DES;
$9e6584766ef755d8$var$DES.create = function create(options) {
    return new $9e6584766ef755d8$var$DES(options);
};
var $9e6584766ef755d8$var$shiftTable = [
    1,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1,
    2,
    2,
    2,
    2,
    2,
    2,
    1
];
$9e6584766ef755d8$var$DES.prototype.deriveKeys = function deriveKeys(state, key) {
    state.keys = new Array(32);
    $koC21.equal(key.length, this.blockSize, "Invalid key length");
    var kL = $dyok1.readUInt32BE(key, 0);
    var kR = $dyok1.readUInt32BE(key, 4);
    $dyok1.pc1(kL, kR, state.tmp, 0);
    kL = state.tmp[0];
    kR = state.tmp[1];
    for(var i = 0; i < state.keys.length; i += 2){
        var shift = $9e6584766ef755d8$var$shiftTable[i >>> 1];
        kL = $dyok1.r28shl(kL, shift);
        kR = $dyok1.r28shl(kR, shift);
        $dyok1.pc2(kL, kR, state.keys, i);
    }
};
$9e6584766ef755d8$var$DES.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._desState;
    var l = $dyok1.readUInt32BE(inp, inOff);
    var r = $dyok1.readUInt32BE(inp, inOff + 4);
    // Initial Permutation
    $dyok1.ip(l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    if (this.type === "encrypt") this._encrypt(state, l, r, state.tmp, 0);
    else this._decrypt(state, l, r, state.tmp, 0);
    l = state.tmp[0];
    r = state.tmp[1];
    $dyok1.writeUInt32BE(out, l, outOff);
    $dyok1.writeUInt32BE(out, r, outOff + 4);
};
$9e6584766ef755d8$var$DES.prototype._pad = function _pad(buffer, off) {
    if (this.padding === false) return false;
    var value = buffer.length - off;
    for(var i = off; i < buffer.length; i++)buffer[i] = value;
    return true;
};
$9e6584766ef755d8$var$DES.prototype._unpad = function _unpad(buffer) {
    if (this.padding === false) return buffer;
    var pad = buffer[buffer.length - 1];
    for(var i = buffer.length - pad; i < buffer.length; i++)$koC21.equal(buffer[i], pad);
    return buffer.slice(0, buffer.length - pad);
};
$9e6584766ef755d8$var$DES.prototype._encrypt = function _encrypt(state, lStart, rStart, out, off) {
    var l = lStart;
    var r = rStart;
    // Apply f() x16 times
    for(var i = 0; i < state.keys.length; i += 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(r, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = r;
        r = (l ^ f) >>> 0;
        l = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(r, l, out, off);
};
$9e6584766ef755d8$var$DES.prototype._decrypt = function _decrypt(state, lStart, rStart, out, off) {
    var l = rStart;
    var r = lStart;
    // Apply f() x16 times
    for(var i = state.keys.length - 2; i >= 0; i -= 2){
        var keyL = state.keys[i];
        var keyR = state.keys[i + 1];
        // f(r, k)
        $dyok1.expand(l, state.tmp, 0);
        keyL ^= state.tmp[0];
        keyR ^= state.tmp[1];
        var s = $dyok1.substitute(keyL, keyR);
        var f = $dyok1.permute(s);
        var t = l;
        l = (r ^ f) >>> 0;
        r = t;
    }
    // Reverse Initial Permutation
    $dyok1.rip(l, r, out, off);
};

});

parcelRegister("eiYbc", function(module, exports) {

$parcel$export(module.exports, "instantiate", () => $a6a16d933acb8abd$export$f9bb8d20ccc7477a, (v) => $a6a16d933acb8abd$export$f9bb8d20ccc7477a = v);
var $a6a16d933acb8abd$export$f9bb8d20ccc7477a;
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");
var $a6a16d933acb8abd$var$proto = {};
function $a6a16d933acb8abd$var$CBCState(iv) {
    $koC21.equal(iv.length, 8, "Invalid IV length");
    this.iv = new Array(8);
    for(var i = 0; i < this.iv.length; i++)this.iv[i] = iv[i];
}
function $a6a16d933acb8abd$var$instantiate(Base) {
    function CBC(options) {
        Base.call(this, options);
        this._cbcInit();
    }
    $dlqwk(CBC, Base);
    var keys = Object.keys($a6a16d933acb8abd$var$proto);
    for(var i = 0; i < keys.length; i++){
        var key = keys[i];
        CBC.prototype[key] = $a6a16d933acb8abd$var$proto[key];
    }
    CBC.create = function create(options) {
        return new CBC(options);
    };
    return CBC;
}
$a6a16d933acb8abd$export$f9bb8d20ccc7477a = $a6a16d933acb8abd$var$instantiate;
$a6a16d933acb8abd$var$proto._cbcInit = function _cbcInit() {
    var state = new $a6a16d933acb8abd$var$CBCState(this.options.iv);
    this._cbcState = state;
};
$a6a16d933acb8abd$var$proto._update = function _update(inp, inOff, out, outOff) {
    var state = this._cbcState;
    var superProto = this.constructor.super_.prototype;
    var iv = state.iv;
    if (this.type === "encrypt") {
        for(var i = 0; i < this.blockSize; i++)iv[i] ^= inp[inOff + i];
        superProto._update.call(this, iv, 0, out, outOff);
        for(var i = 0; i < this.blockSize; i++)iv[i] = out[outOff + i];
    } else {
        superProto._update.call(this, inp, inOff, out, outOff);
        for(var i = 0; i < this.blockSize; i++)out[outOff + i] ^= iv[i];
        for(var i = 0; i < this.blockSize; i++)iv[i] = inp[inOff + i];
    }
};

});

parcelRegister("5ye6K", function(module, exports) {
"use strict";

var $koC21 = parcelRequire("koC21");

var $dlqwk = parcelRequire("dlqwk");

var $enfpo = parcelRequire("enfpo");

var $dB8Kv = parcelRequire("dB8Kv");
function $40ab123e2a8964f5$var$EDEState(type, key) {
    $koC21.equal(key.length, 24, "Invalid key length");
    var k1 = key.slice(0, 8);
    var k2 = key.slice(8, 16);
    var k3 = key.slice(16, 24);
    if (type === "encrypt") this.ciphers = [
        $dB8Kv.create({
            type: "encrypt",
            key: k1
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k3
        })
    ];
    else this.ciphers = [
        $dB8Kv.create({
            type: "decrypt",
            key: k3
        }),
        $dB8Kv.create({
            type: "encrypt",
            key: k2
        }),
        $dB8Kv.create({
            type: "decrypt",
            key: k1
        })
    ];
}
function $40ab123e2a8964f5$var$EDE(options) {
    $enfpo.call(this, options);
    var state = new $40ab123e2a8964f5$var$EDEState(this.type, this.options.key);
    this._edeState = state;
}
$dlqwk($40ab123e2a8964f5$var$EDE, $enfpo);
module.exports = $40ab123e2a8964f5$var$EDE;
$40ab123e2a8964f5$var$EDE.create = function create(options) {
    return new $40ab123e2a8964f5$var$EDE(options);
};
$40ab123e2a8964f5$var$EDE.prototype._update = function _update(inp, inOff, out, outOff) {
    var state = this._edeState;
    state.ciphers[0]._update(inp, inOff, out, outOff);
    state.ciphers[1]._update(out, outOff, out, outOff);
    state.ciphers[2]._update(out, outOff, out, outOff);
};
$40ab123e2a8964f5$var$EDE.prototype._pad = $dB8Kv.prototype._pad;
$40ab123e2a8964f5$var$EDE.prototype._unpad = $dB8Kv.prototype._unpad;

});

parcelRegister("f6p9h", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $afeaec8849bcc81c$export$5b0f6292f11d1d18, (v) => $afeaec8849bcc81c$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $afeaec8849bcc81c$export$e85a0c9a1067c5d3, (v) => $afeaec8849bcc81c$export$e85a0c9a1067c5d3 = v);
var $afeaec8849bcc81c$export$5b0f6292f11d1d18;
var $afeaec8849bcc81c$export$e85a0c9a1067c5d3;
$afeaec8849bcc81c$export$5b0f6292f11d1d18 = function(self, block) {
    return self._cipher.encryptBlock(block);
};
$afeaec8849bcc81c$export$e85a0c9a1067c5d3 = function(self, block) {
    return self._cipher.decryptBlock(block);
};

});

parcelRegister("3QymJ", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18, (v) => $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = v);
$parcel$export(module.exports, "decrypt", () => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3, (v) => $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = v);
var $2cd0e2b9ec00ca64$export$5b0f6292f11d1d18;
var $2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3;

var $dUX5c = parcelRequire("dUX5c");
$2cd0e2b9ec00ca64$export$5b0f6292f11d1d18 = function(self, block) {
    var data = $dUX5c(block, self._prev);
    self._prev = self._cipher.encryptBlock(data);
    return self._prev;
};
$2cd0e2b9ec00ca64$export$e85a0c9a1067c5d3 = function(self, block) {
    var pad = self._prev;
    self._prev = block;
    var out = self._cipher.decryptBlock(block);
    return $dUX5c(out, pad);
};

});
parcelRegister("dUX5c", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $a21e55eeffd2595b$require$Buffer = $6ZWSX.Buffer;
module.exports = function xor(a, b) {
    var length = Math.min(a.length, b.length);
    var buffer = new $a21e55eeffd2595b$require$Buffer(length);
    for(var i = 0; i < length; ++i)buffer[i] = a[i] ^ b[i];
    return buffer;
};

});


parcelRegister("2cuuO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $19a45ba19082fc97$export$5b0f6292f11d1d18, (v) => $19a45ba19082fc97$export$5b0f6292f11d1d18 = v);
var $19a45ba19082fc97$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $19a45ba19082fc97$require$Buffer = $1U9GM.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $19a45ba19082fc97$var$encryptStart(self, data, decrypt) {
    var len = data.length;
    var out = $dUX5c(data, self._cache);
    self._cache = self._cache.slice(len);
    self._prev = $19a45ba19082fc97$require$Buffer.concat([
        self._prev,
        decrypt ? data : out
    ]);
    return out;
}
$19a45ba19082fc97$export$5b0f6292f11d1d18 = function(self, data, decrypt) {
    var out = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
    var len;
    while(data.length){
        if (self._cache.length === 0) {
            self._cache = self._cipher.encryptBlock(self._prev);
            self._prev = $19a45ba19082fc97$require$Buffer.allocUnsafe(0);
        }
        if (self._cache.length <= data.length) {
            len = self._cache.length;
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data.slice(0, len), decrypt)
            ]);
            data = data.slice(len);
        } else {
            out = $19a45ba19082fc97$require$Buffer.concat([
                out,
                $19a45ba19082fc97$var$encryptStart(self, data, decrypt)
            ]);
            break;
        }
    }
    return out;
};

});

parcelRegister("03mhO", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $00a19188a96aa70f$export$5b0f6292f11d1d18, (v) => $00a19188a96aa70f$export$5b0f6292f11d1d18 = v);
var $00a19188a96aa70f$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $00a19188a96aa70f$require$Buffer = $1U9GM.Buffer;
function $00a19188a96aa70f$var$encryptByte(self, byteParam, decrypt) {
    var pad = self._cipher.encryptBlock(self._prev);
    var out = pad[0] ^ byteParam;
    self._prev = $00a19188a96aa70f$require$Buffer.concat([
        self._prev.slice(1),
        $00a19188a96aa70f$require$Buffer.from([
            decrypt ? byteParam : out
        ])
    ]);
    return out;
}
$00a19188a96aa70f$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $00a19188a96aa70f$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $00a19188a96aa70f$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fK9OU", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b762c4f45662bf18$export$5b0f6292f11d1d18, (v) => $b762c4f45662bf18$export$5b0f6292f11d1d18 = v);
var $b762c4f45662bf18$export$5b0f6292f11d1d18;

var $1U9GM = parcelRequire("1U9GM");
var $b762c4f45662bf18$require$Buffer = $1U9GM.Buffer;
function $b762c4f45662bf18$var$encryptByte(self, byteParam, decrypt) {
    var pad;
    var i = -1;
    var len = 8;
    var out = 0;
    var bit, value;
    while(++i < len){
        pad = self._cipher.encryptBlock(self._prev);
        bit = byteParam & 1 << 7 - i ? 0x80 : 0;
        value = pad[0] ^ bit;
        out += (value & 0x80) >> i % 8;
        self._prev = $b762c4f45662bf18$var$shiftIn(self._prev, decrypt ? bit : value);
    }
    return out;
}
function $b762c4f45662bf18$var$shiftIn(buffer, value) {
    var len = buffer.length;
    var i = -1;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(buffer.length);
    buffer = $b762c4f45662bf18$require$Buffer.concat([
        buffer,
        $b762c4f45662bf18$require$Buffer.from([
            value
        ])
    ]);
    while(++i < len)out[i] = buffer[i] << 1 | buffer[i + 1] >> 7;
    return out;
}
$b762c4f45662bf18$export$5b0f6292f11d1d18 = function(self, chunk, decrypt) {
    var len = chunk.length;
    var out = $b762c4f45662bf18$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)out[i] = $b762c4f45662bf18$var$encryptByte(self, chunk[i], decrypt);
    return out;
};

});

parcelRegister("fFe8N", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b675a769a603e0fc$export$5b0f6292f11d1d18, (v) => $b675a769a603e0fc$export$5b0f6292f11d1d18 = v);
var $b675a769a603e0fc$export$5b0f6292f11d1d18;

var $6ZWSX = parcelRequire("6ZWSX");
var $b675a769a603e0fc$require$Buffer = $6ZWSX.Buffer;

var $dUX5c = parcelRequire("dUX5c");
function $b675a769a603e0fc$var$getBlock(self) {
    self._prev = self._cipher.encryptBlock(self._prev);
    return self._prev;
}
$b675a769a603e0fc$export$5b0f6292f11d1d18 = function(self, chunk) {
    while(self._cache.length < chunk.length)self._cache = $b675a769a603e0fc$require$Buffer.concat([
        self._cache,
        $b675a769a603e0fc$var$getBlock(self)
    ]);
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});

parcelRegister("fJbMg", function(module, exports) {

$parcel$export(module.exports, "encrypt", () => $b73431c24e9fa039$export$5b0f6292f11d1d18, (v) => $b73431c24e9fa039$export$5b0f6292f11d1d18 = v);
var $b73431c24e9fa039$export$5b0f6292f11d1d18;

var $dUX5c = parcelRequire("dUX5c");

var $1U9GM = parcelRequire("1U9GM");
var $b73431c24e9fa039$require$Buffer = $1U9GM.Buffer;

var $3VKgl = parcelRequire("3VKgl");
function $b73431c24e9fa039$var$getBlock(self) {
    var out = self._cipher.encryptBlockRaw(self._prev);
    $3VKgl(self._prev);
    return out;
}
var $b73431c24e9fa039$var$blockSize = 16;
$b73431c24e9fa039$export$5b0f6292f11d1d18 = function(self, chunk) {
    var chunkNum = Math.ceil(chunk.length / $b73431c24e9fa039$var$blockSize);
    var start = self._cache.length;
    self._cache = $b73431c24e9fa039$require$Buffer.concat([
        self._cache,
        $b73431c24e9fa039$require$Buffer.allocUnsafe(chunkNum * $b73431c24e9fa039$var$blockSize)
    ]);
    for(var i = 0; i < chunkNum; i++){
        var out = $b73431c24e9fa039$var$getBlock(self);
        var offset = start + i * $b73431c24e9fa039$var$blockSize;
        self._cache.writeUInt32BE(out[0], offset + 0);
        self._cache.writeUInt32BE(out[1], offset + 4);
        self._cache.writeUInt32BE(out[2], offset + 8);
        self._cache.writeUInt32BE(out[3], offset + 12);
    }
    var pad = self._cache.slice(0, chunk.length);
    self._cache = self._cache.slice(chunk.length);
    return $dUX5c(chunk, pad);
};

});
parcelRegister("3VKgl", function(module, exports) {
function $2dca94c326c7eb9a$var$incr32(iv) {
    var len = iv.length;
    var item;
    while(len--){
        item = iv.readUInt8(len);
        if (item === 255) iv.writeUInt8(0, len);
        else {
            item++;
            iv.writeUInt8(item, len);
            break;
        }
    }
}
module.exports = $2dca94c326c7eb9a$var$incr32;

});


parcelRegister("5vmVB", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("7Zvov", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("b6RFW", function(module, exports) {

exports = module.exports = (parcelRequire("d4xg3"));
exports.Stream = exports;
exports.Readable = exports;

exports.Writable = (parcelRequire("3LwY7"));

exports.Duplex = (parcelRequire("DwJuQ"));

exports.Transform = (parcelRequire("b7kl8"));

exports.PassThrough = (parcelRequire("4wWcs"));

});
parcelRegister("d4xg3", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.

var $hPtJY = parcelRequire("hPtJY");
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $9845726cca5dc7eb$var$Readable;

var $767Wy = parcelRequire("767Wy");
/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$Duplex;
/*</replacement>*/ $9845726cca5dc7eb$var$Readable.ReadableState = $9845726cca5dc7eb$var$ReadableState;

var $7etJZ = parcelRequire("7etJZ");
var $9845726cca5dc7eb$require$EE = $7etJZ.EventEmitter;
var $9845726cca5dc7eb$var$EElistenerCount = function(emitter, type) {
    return emitter.listeners(type).length;
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $9845726cca5dc7eb$require$Buffer = $h3oXE.Buffer;
var $9845726cca5dc7eb$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk) {
    return $9845726cca5dc7eb$require$Buffer.from(chunk);
}
function $9845726cca5dc7eb$var$_isUint8Array(obj) {
    return $9845726cca5dc7eb$require$Buffer.isBuffer(obj) || obj instanceof $9845726cca5dc7eb$var$OurUint8Array;
}

/*</replacement>*/ /*<replacement>*/ var $9845726cca5dc7eb$var$util = Object.create((parcelRequire("dH2Jp")));

$9845726cca5dc7eb$var$util.inherits = (parcelRequire("dlqwk"));

var $kjyEk = parcelRequire("kjyEk");
var $9845726cca5dc7eb$var$debug = void 0;
if ($kjyEk && $kjyEk.debuglog) $9845726cca5dc7eb$var$debug = $kjyEk.debuglog("stream");
else $9845726cca5dc7eb$var$debug = function() {};

var $185iR = parcelRequire("185iR");

var $fMCbt = parcelRequire("fMCbt");
var $9845726cca5dc7eb$var$StringDecoder;
$9845726cca5dc7eb$var$util.inherits($9845726cca5dc7eb$var$Readable, $jfAlf);
var $9845726cca5dc7eb$var$kProxyEvents = [
    "error",
    "close",
    "destroy",
    "pause",
    "resume"
];
function $9845726cca5dc7eb$var$prependListener(emitter, event, fn) {
    // Sadly this is not cacheable as some libraries bundle their own
    // event emitter implementation with them.
    if (typeof emitter.prependListener === "function") return emitter.prependListener(event, fn);
    // This is a hack to make sure that our error handler is attached before any
    // userland ones.  NEVER DO THIS. This is here only because this code needs
    // to continue to work with older versions of Node.js that do not include
    // the prependListener() method. The goal is to eventually remove this hack.
    if (!emitter._events || !emitter._events[event]) emitter.on(event, fn);
    else if ($767Wy(emitter._events[event])) emitter._events[event].unshift(fn);
    else emitter._events[event] = [
        fn,
        emitter._events[event]
    ];
}


function $9845726cca5dc7eb$var$ReadableState(options, stream) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $9845726cca5dc7eb$var$Duplex;
    // object stream flag. Used to make read(n) ignore n and to
    // make all the buffer merging and length checks go away
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.readableObjectMode;
    // the point at which it stops calling _read() to fill the buffer
    // Note: 0 is a valid value, means "don't call _read preemptively ever"
    var hwm = options.highWaterMark;
    var readableHwm = options.readableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (readableHwm || readableHwm === 0)) this.highWaterMark = readableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // A linked list is used to store data chunks instead of an array because the
    // linked list can remove elements from the beginning faster than
    // array.shift()
    this.buffer = new $185iR();
    this.length = 0;
    this.pipes = null;
    this.pipesCount = 0;
    this.flowing = null;
    this.ended = false;
    this.endEmitted = false;
    this.reading = false;
    // a flag to be able to tell if the event 'readable'/'data' is emitted
    // immediately, or on a later tick.  We set this to true at first, because
    // any actions that shouldn't happen until "later" should generally also
    // not happen before the first read call.
    this.sync = true;
    // whenever we return null, then we set a flag to say
    // that we're awaiting a 'readable' event emission.
    this.needReadable = false;
    this.emittedReadable = false;
    this.readableListening = false;
    this.resumeScheduled = false;
    // has it been destroyed
    this.destroyed = false;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // the number of writers that are awaiting a drain event in .pipe()s
    this.awaitDrain = 0;
    // if true, a maybeReadMore has been scheduled
    this.readingMore = false;
    this.decoder = null;
    this.encoding = null;
    if (options.encoding) {
        if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
        this.decoder = new $9845726cca5dc7eb$var$StringDecoder(options.encoding);
        this.encoding = options.encoding;
    }
}

function $9845726cca5dc7eb$var$Readable(options) {
    $9845726cca5dc7eb$var$Duplex = $9845726cca5dc7eb$var$Duplex || (parcelRequire("DwJuQ"));
    if (!(this instanceof $9845726cca5dc7eb$var$Readable)) return new $9845726cca5dc7eb$var$Readable(options);
    this._readableState = new $9845726cca5dc7eb$var$ReadableState(options, this);
    // legacy
    this.readable = true;
    if (options) {
        if (typeof options.read === "function") this._read = options.read;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
    }
    $jfAlf.call(this);
}
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined) return false;
        return this._readableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._readableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
    }
});
$9845726cca5dc7eb$var$Readable.prototype.destroy = $fMCbt.destroy;
$9845726cca5dc7eb$var$Readable.prototype._undestroy = $fMCbt.undestroy;
$9845726cca5dc7eb$var$Readable.prototype._destroy = function(err, cb) {
    this.push(null);
    cb(err);
};
// Manually shove something into the read() buffer.
// This returns true if the highWaterMark has not been hit yet,
// similar to how Writable.write() returns true if you should
// write() some more.
$9845726cca5dc7eb$var$Readable.prototype.push = function(chunk, encoding) {
    var state = this._readableState;
    var skipChunkCheck;
    if (!state.objectMode) {
        if (typeof chunk === "string") {
            encoding = encoding || state.defaultEncoding;
            if (encoding !== state.encoding) {
                chunk = $9845726cca5dc7eb$require$Buffer.from(chunk, encoding);
                encoding = "";
            }
            skipChunkCheck = true;
        }
    } else skipChunkCheck = true;
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, encoding, false, skipChunkCheck);
};
// Unshift should *always* be something directly out of read()
$9845726cca5dc7eb$var$Readable.prototype.unshift = function(chunk) {
    return $9845726cca5dc7eb$var$readableAddChunk(this, chunk, null, true, false);
};
function $9845726cca5dc7eb$var$readableAddChunk(stream, chunk, encoding, addToFront, skipChunkCheck) {
    var state = stream._readableState;
    if (chunk === null) {
        state.reading = false;
        $9845726cca5dc7eb$var$onEofChunk(stream, state);
    } else {
        var er;
        if (!skipChunkCheck) er = $9845726cca5dc7eb$var$chunkInvalid(state, chunk);
        if (er) stream.emit("error", er);
        else if (state.objectMode || chunk && chunk.length > 0) {
            if (typeof chunk !== "string" && !state.objectMode && Object.getPrototypeOf(chunk) !== $9845726cca5dc7eb$require$Buffer.prototype) chunk = $9845726cca5dc7eb$var$_uint8ArrayToBuffer(chunk);
            if (addToFront) {
                if (state.endEmitted) stream.emit("error", new Error("stream.unshift() after end event"));
                else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, true);
            } else if (state.ended) stream.emit("error", new Error("stream.push() after EOF"));
            else {
                state.reading = false;
                if (state.decoder && !encoding) {
                    chunk = state.decoder.write(chunk);
                    if (state.objectMode || chunk.length !== 0) $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
                    else $9845726cca5dc7eb$var$maybeReadMore(stream, state);
                } else $9845726cca5dc7eb$var$addChunk(stream, state, chunk, false);
            }
        } else if (!addToFront) state.reading = false;
    }
    return $9845726cca5dc7eb$var$needMoreData(state);
}
function $9845726cca5dc7eb$var$addChunk(stream, state, chunk, addToFront) {
    if (state.flowing && state.length === 0 && !state.sync) {
        stream.emit("data", chunk);
        stream.read(0);
    } else {
        // update the buffer info.
        state.length += state.objectMode ? 1 : chunk.length;
        if (addToFront) state.buffer.unshift(chunk);
        else state.buffer.push(chunk);
        if (state.needReadable) $9845726cca5dc7eb$var$emitReadable(stream);
    }
    $9845726cca5dc7eb$var$maybeReadMore(stream, state);
}
function $9845726cca5dc7eb$var$chunkInvalid(state, chunk) {
    var er;
    if (!$9845726cca5dc7eb$var$_isUint8Array(chunk) && typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    return er;
}
// if it's past the high water mark, we can push in some more.
// Also, if we have no data yet, we can stand some
// more bytes.  This is to work around cases where hwm=0,
// such as the repl.  Also, if the push() triggered a
// readable event, and the user called read(largeNumber) such that
// needReadable was set, then we ought to push more, so that another
// 'readable' event will be triggered.
function $9845726cca5dc7eb$var$needMoreData(state) {
    return !state.ended && (state.needReadable || state.length < state.highWaterMark || state.length === 0);
}
$9845726cca5dc7eb$var$Readable.prototype.isPaused = function() {
    return this._readableState.flowing === false;
};

// backwards compatibility.
$9845726cca5dc7eb$var$Readable.prototype.setEncoding = function(enc) {
    if (!$9845726cca5dc7eb$var$StringDecoder) $9845726cca5dc7eb$var$StringDecoder = (parcelRequire("imDDS")).StringDecoder;
    this._readableState.decoder = new $9845726cca5dc7eb$var$StringDecoder(enc);
    this._readableState.encoding = enc;
    return this;
};
// Don't raise the hwm > 8MB
var $9845726cca5dc7eb$var$MAX_HWM = 0x800000;
function $9845726cca5dc7eb$var$computeNewHighWaterMark(n) {
    if (n >= $9845726cca5dc7eb$var$MAX_HWM) n = $9845726cca5dc7eb$var$MAX_HWM;
    else {
        // Get the next highest power of 2 to prevent increasing hwm excessively in
        // tiny amounts
        n--;
        n |= n >>> 1;
        n |= n >>> 2;
        n |= n >>> 4;
        n |= n >>> 8;
        n |= n >>> 16;
        n++;
    }
    return n;
}
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$howMuchToRead(n, state) {
    if (n <= 0 || state.length === 0 && state.ended) return 0;
    if (state.objectMode) return 1;
    if (n !== n) {
        // Only flow one buffer at a time
        if (state.flowing && state.length) return state.buffer.head.data.length;
        else return state.length;
    }
    // If we're asking for more than the current hwm, then raise the hwm.
    if (n > state.highWaterMark) state.highWaterMark = $9845726cca5dc7eb$var$computeNewHighWaterMark(n);
    if (n <= state.length) return n;
    // Don't have enough
    if (!state.ended) {
        state.needReadable = true;
        return 0;
    }
    return state.length;
}
// you can override either this method, or the async _read(n) below.
$9845726cca5dc7eb$var$Readable.prototype.read = function(n) {
    $9845726cca5dc7eb$var$debug("read", n);
    n = parseInt(n, 10);
    var state = this._readableState;
    var nOrig = n;
    if (n !== 0) state.emittedReadable = false;
    // if we're doing read(0) to trigger a readable event, but we
    // already have a bunch of data in the buffer, then just trigger
    // the 'readable' event and move on.
    if (n === 0 && state.needReadable && (state.length >= state.highWaterMark || state.ended)) {
        $9845726cca5dc7eb$var$debug("read: emitReadable", state.length, state.ended);
        if (state.length === 0 && state.ended) $9845726cca5dc7eb$var$endReadable(this);
        else $9845726cca5dc7eb$var$emitReadable(this);
        return null;
    }
    n = $9845726cca5dc7eb$var$howMuchToRead(n, state);
    // if we've ended, and we're now clear, then finish it up.
    if (n === 0 && state.ended) {
        if (state.length === 0) $9845726cca5dc7eb$var$endReadable(this);
        return null;
    }
    // All the actual chunk generation logic needs to be
    // *below* the call to _read.  The reason is that in certain
    // synthetic stream cases, such as passthrough streams, _read
    // may be a completely synchronous operation which may change
    // the state of the read buffer, providing enough data when
    // before there was *not* enough.
    //
    // So, the steps are:
    // 1. Figure out what the state of things will be after we do
    // a read from the buffer.
    //
    // 2. If that resulting state will trigger a _read, then call _read.
    // Note that this may be asynchronous, or synchronous.  Yes, it is
    // deeply ugly to write APIs this way, but that still doesn't mean
    // that the Readable class should behave improperly, as streams are
    // designed to be sync/async agnostic.
    // Take note if the _read call is sync or async (ie, if the read call
    // has returned yet), so that we know whether or not it's safe to emit
    // 'readable' etc.
    //
    // 3. Actually pull the requested chunks out of the buffer and return.
    // if we need a readable event, then we need to do some reading.
    var doRead = state.needReadable;
    $9845726cca5dc7eb$var$debug("need readable", doRead);
    // if we currently have less than the highWaterMark, then also read some
    if (state.length === 0 || state.length - n < state.highWaterMark) {
        doRead = true;
        $9845726cca5dc7eb$var$debug("length less than watermark", doRead);
    }
    // however, if we've ended, then there's no point, and if we're already
    // reading, then it's unnecessary.
    if (state.ended || state.reading) {
        doRead = false;
        $9845726cca5dc7eb$var$debug("reading or ended", doRead);
    } else if (doRead) {
        $9845726cca5dc7eb$var$debug("do read");
        state.reading = true;
        state.sync = true;
        // if the length is currently zero, then we *need* a readable event.
        if (state.length === 0) state.needReadable = true;
        // call internal read method
        this._read(state.highWaterMark);
        state.sync = false;
        // If _read pushed data synchronously, then `reading` will be false,
        // and we need to re-evaluate how much data we can return to the user.
        if (!state.reading) n = $9845726cca5dc7eb$var$howMuchToRead(nOrig, state);
    }
    var ret;
    if (n > 0) ret = $9845726cca5dc7eb$var$fromList(n, state);
    else ret = null;
    if (ret === null) {
        state.needReadable = true;
        n = 0;
    } else state.length -= n;
    if (state.length === 0) {
        // If we have nothing in the buffer, then we want to know
        // as soon as we *do* get something into the buffer.
        if (!state.ended) state.needReadable = true;
        // If we tried to read() past the EOF, then emit end on the next tick.
        if (nOrig !== n && state.ended) $9845726cca5dc7eb$var$endReadable(this);
    }
    if (ret !== null) this.emit("data", ret);
    return ret;
};
function $9845726cca5dc7eb$var$onEofChunk(stream, state) {
    if (state.ended) return;
    if (state.decoder) {
        var chunk = state.decoder.end();
        if (chunk && chunk.length) {
            state.buffer.push(chunk);
            state.length += state.objectMode ? 1 : chunk.length;
        }
    }
    state.ended = true;
    // emit 'readable' now to make sure it gets picked up.
    $9845726cca5dc7eb$var$emitReadable(stream);
}
// Don't emit readable right away in sync mode, because this can trigger
// another read() call => stack overflow.  This way, it might trigger
// a nextTick recursion warning, but that's not so bad.
function $9845726cca5dc7eb$var$emitReadable(stream) {
    var state = stream._readableState;
    state.needReadable = false;
    if (!state.emittedReadable) {
        $9845726cca5dc7eb$var$debug("emitReadable", state.flowing);
        state.emittedReadable = true;
        if (state.sync) $bUlqC.nextTick($9845726cca5dc7eb$var$emitReadable_, stream);
        else $9845726cca5dc7eb$var$emitReadable_(stream);
    }
}
function $9845726cca5dc7eb$var$emitReadable_(stream) {
    $9845726cca5dc7eb$var$debug("emit readable");
    stream.emit("readable");
    $9845726cca5dc7eb$var$flow(stream);
}
// at this point, the user has presumably seen the 'readable' event,
// and called read() to consume some data.  that may have triggered
// in turn another _read(n) call, in which case reading = true if
// it's in progress.
// However, if we're not ended, or reading, and the length < hwm,
// then go ahead and try to read some more preemptively.
function $9845726cca5dc7eb$var$maybeReadMore(stream, state) {
    if (!state.readingMore) {
        state.readingMore = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$maybeReadMore_, stream, state);
    }
}
function $9845726cca5dc7eb$var$maybeReadMore_(stream, state) {
    var len = state.length;
    while(!state.reading && !state.flowing && !state.ended && state.length < state.highWaterMark){
        $9845726cca5dc7eb$var$debug("maybeReadMore read 0");
        stream.read(0);
        if (len === state.length) break;
        else len = state.length;
    }
    state.readingMore = false;
}
// abstract method.  to be overridden in specific implementation classes.
// call cb(er, data) where data is <= n in length.
// for virtual (non-string, non-buffer) streams, "length" is somewhat
// arbitrary, and perhaps not very meaningful.
$9845726cca5dc7eb$var$Readable.prototype._read = function(n) {
    this.emit("error", new Error("_read() is not implemented"));
};
$9845726cca5dc7eb$var$Readable.prototype.pipe = function(dest, pipeOpts) {
    var src = this;
    var state = this._readableState;
    switch(state.pipesCount){
        case 0:
            state.pipes = dest;
            break;
        case 1:
            state.pipes = [
                state.pipes,
                dest
            ];
            break;
        default:
            state.pipes.push(dest);
            break;
    }
    state.pipesCount += 1;
    $9845726cca5dc7eb$var$debug("pipe count=%d opts=%j", state.pipesCount, pipeOpts);
    var doEnd = (!pipeOpts || pipeOpts.end !== false) && dest !== $hPtJY.stdout && dest !== $hPtJY.stderr;
    var endFn = doEnd ? onend : unpipe;
    if (state.endEmitted) $bUlqC.nextTick(endFn);
    else src.once("end", endFn);
    dest.on("unpipe", onunpipe);
    function onunpipe(readable, unpipeInfo) {
        $9845726cca5dc7eb$var$debug("onunpipe");
        if (readable === src) {
            if (unpipeInfo && unpipeInfo.hasUnpiped === false) {
                unpipeInfo.hasUnpiped = true;
                cleanup();
            }
        }
    }
    function onend() {
        $9845726cca5dc7eb$var$debug("onend");
        dest.end();
    }
    // when the dest drains, it reduces the awaitDrain counter
    // on the source.  This would be more elegant with a .once()
    // handler in flow(), but adding and removing repeatedly is
    // too slow.
    var ondrain = $9845726cca5dc7eb$var$pipeOnDrain(src);
    dest.on("drain", ondrain);
    var cleanedUp = false;
    function cleanup() {
        $9845726cca5dc7eb$var$debug("cleanup");
        // cleanup event handlers once the pipe is broken
        dest.removeListener("close", onclose);
        dest.removeListener("finish", onfinish);
        dest.removeListener("drain", ondrain);
        dest.removeListener("error", onerror);
        dest.removeListener("unpipe", onunpipe);
        src.removeListener("end", onend);
        src.removeListener("end", unpipe);
        src.removeListener("data", ondata);
        cleanedUp = true;
        // if the reader is waiting for a drain event from this
        // specific writer, then it would cause it to never start
        // flowing again.
        // So, if this is awaiting a drain, then we just call it now.
        // If we don't know, then assume that we are waiting for one.
        if (state.awaitDrain && (!dest._writableState || dest._writableState.needDrain)) ondrain();
    }
    // If the user pushes more data while we're writing to dest then we'll end up
    // in ondata again. However, we only want to increase awaitDrain once because
    // dest will only emit one 'drain' event for the multiple writes.
    // => Introduce a guard on increasing awaitDrain.
    var increasedAwaitDrain = false;
    src.on("data", ondata);
    function ondata(chunk) {
        $9845726cca5dc7eb$var$debug("ondata");
        increasedAwaitDrain = false;
        var ret = dest.write(chunk);
        if (false === ret && !increasedAwaitDrain) {
            // If the user unpiped during `dest.write()`, it is possible
            // to get stuck in a permanently paused state if that write
            // also returned false.
            // => Check whether `dest` is still a piping destination.
            if ((state.pipesCount === 1 && state.pipes === dest || state.pipesCount > 1 && $9845726cca5dc7eb$var$indexOf(state.pipes, dest) !== -1) && !cleanedUp) {
                $9845726cca5dc7eb$var$debug("false write response, pause", state.awaitDrain);
                state.awaitDrain++;
                increasedAwaitDrain = true;
            }
            src.pause();
        }
    }
    // if the dest has an error, then stop piping into it.
    // however, don't suppress the throwing behavior for this.
    function onerror(er) {
        $9845726cca5dc7eb$var$debug("onerror", er);
        unpipe();
        dest.removeListener("error", onerror);
        if ($9845726cca5dc7eb$var$EElistenerCount(dest, "error") === 0) dest.emit("error", er);
    }
    // Make sure our error handler is attached before userland ones.
    $9845726cca5dc7eb$var$prependListener(dest, "error", onerror);
    // Both close and finish should trigger unpipe, but only once.
    function onclose() {
        dest.removeListener("finish", onfinish);
        unpipe();
    }
    dest.once("close", onclose);
    function onfinish() {
        $9845726cca5dc7eb$var$debug("onfinish");
        dest.removeListener("close", onclose);
        unpipe();
    }
    dest.once("finish", onfinish);
    function unpipe() {
        $9845726cca5dc7eb$var$debug("unpipe");
        src.unpipe(dest);
    }
    // tell the dest that it's being piped to
    dest.emit("pipe", src);
    // start the flow if it hasn't been started already.
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("pipe resume");
        src.resume();
    }
    return dest;
};
function $9845726cca5dc7eb$var$pipeOnDrain(src) {
    return function() {
        var state = src._readableState;
        $9845726cca5dc7eb$var$debug("pipeOnDrain", state.awaitDrain);
        if (state.awaitDrain) state.awaitDrain--;
        if (state.awaitDrain === 0 && $9845726cca5dc7eb$var$EElistenerCount(src, "data")) {
            state.flowing = true;
            $9845726cca5dc7eb$var$flow(src);
        }
    };
}
$9845726cca5dc7eb$var$Readable.prototype.unpipe = function(dest) {
    var state = this._readableState;
    var unpipeInfo = {
        hasUnpiped: false
    };
    // if we're not piping anywhere, then do nothing.
    if (state.pipesCount === 0) return this;
    // just one destination.  most common case.
    if (state.pipesCount === 1) {
        // passed in one, but it's not the right one.
        if (dest && dest !== state.pipes) return this;
        if (!dest) dest = state.pipes;
        // got a match.
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        if (dest) dest.emit("unpipe", this, unpipeInfo);
        return this;
    }
    // slow case. multiple pipe destinations.
    if (!dest) {
        // remove all.
        var dests = state.pipes;
        var len = state.pipesCount;
        state.pipes = null;
        state.pipesCount = 0;
        state.flowing = false;
        for(var i = 0; i < len; i++)dests[i].emit("unpipe", this, {
            hasUnpiped: false
        });
        return this;
    }
    // try to find the right one.
    var index = $9845726cca5dc7eb$var$indexOf(state.pipes, dest);
    if (index === -1) return this;
    state.pipes.splice(index, 1);
    state.pipesCount -= 1;
    if (state.pipesCount === 1) state.pipes = state.pipes[0];
    dest.emit("unpipe", this, unpipeInfo);
    return this;
};
// set up data events if they are asked for
// Ensure readable listeners eventually get something
$9845726cca5dc7eb$var$Readable.prototype.on = function(ev, fn) {
    var res = $jfAlf.prototype.on.call(this, ev, fn);
    if (ev === "data") // Start flowing on next tick if stream isn't explicitly paused
    {
        if (this._readableState.flowing !== false) this.resume();
    } else if (ev === "readable") {
        var state = this._readableState;
        if (!state.endEmitted && !state.readableListening) {
            state.readableListening = state.needReadable = true;
            state.emittedReadable = false;
            if (!state.reading) $bUlqC.nextTick($9845726cca5dc7eb$var$nReadingNextTick, this);
            else if (state.length) $9845726cca5dc7eb$var$emitReadable(this);
        }
    }
    return res;
};
$9845726cca5dc7eb$var$Readable.prototype.addListener = $9845726cca5dc7eb$var$Readable.prototype.on;
function $9845726cca5dc7eb$var$nReadingNextTick(self1) {
    $9845726cca5dc7eb$var$debug("readable nexttick read 0");
    self1.read(0);
}
// pause() and resume() are remnants of the legacy readable stream API
// If the user uses them, then switch into old mode.
$9845726cca5dc7eb$var$Readable.prototype.resume = function() {
    var state = this._readableState;
    if (!state.flowing) {
        $9845726cca5dc7eb$var$debug("resume");
        state.flowing = true;
        $9845726cca5dc7eb$var$resume(this, state);
    }
    return this;
};
function $9845726cca5dc7eb$var$resume(stream, state) {
    if (!state.resumeScheduled) {
        state.resumeScheduled = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$resume_, stream, state);
    }
}
function $9845726cca5dc7eb$var$resume_(stream, state) {
    if (!state.reading) {
        $9845726cca5dc7eb$var$debug("resume read 0");
        stream.read(0);
    }
    state.resumeScheduled = false;
    state.awaitDrain = 0;
    stream.emit("resume");
    $9845726cca5dc7eb$var$flow(stream);
    if (state.flowing && !state.reading) stream.read(0);
}
$9845726cca5dc7eb$var$Readable.prototype.pause = function() {
    $9845726cca5dc7eb$var$debug("call pause flowing=%j", this._readableState.flowing);
    if (false !== this._readableState.flowing) {
        $9845726cca5dc7eb$var$debug("pause");
        this._readableState.flowing = false;
        this.emit("pause");
    }
    return this;
};
function $9845726cca5dc7eb$var$flow(stream) {
    var state = stream._readableState;
    $9845726cca5dc7eb$var$debug("flow", state.flowing);
    while(state.flowing && stream.read() !== null);
}
// wrap an old-style stream as the async data source.
// This is *not* part of the readable stream interface.
// It is an ugly unfortunate mess of history.
$9845726cca5dc7eb$var$Readable.prototype.wrap = function(stream) {
    var _this = this;
    var state = this._readableState;
    var paused = false;
    stream.on("end", function() {
        $9845726cca5dc7eb$var$debug("wrapped end");
        if (state.decoder && !state.ended) {
            var chunk = state.decoder.end();
            if (chunk && chunk.length) _this.push(chunk);
        }
        _this.push(null);
    });
    stream.on("data", function(chunk) {
        $9845726cca5dc7eb$var$debug("wrapped data");
        if (state.decoder) chunk = state.decoder.write(chunk);
        // don't skip over falsy values in objectMode
        if (state.objectMode && (chunk === null || chunk === undefined)) return;
        else if (!state.objectMode && (!chunk || !chunk.length)) return;
        var ret = _this.push(chunk);
        if (!ret) {
            paused = true;
            stream.pause();
        }
    });
    // proxy all the other methods.
    // important when wrapping filters and duplexes.
    for(var i in stream)if (this[i] === undefined && typeof stream[i] === "function") this[i] = function(method) {
        return function() {
            return stream[method].apply(stream, arguments);
        };
    }(i);
    // proxy certain important events.
    for(var n = 0; n < $9845726cca5dc7eb$var$kProxyEvents.length; n++)stream.on($9845726cca5dc7eb$var$kProxyEvents[n], this.emit.bind(this, $9845726cca5dc7eb$var$kProxyEvents[n]));
    // when we try to consume some more bytes, simply unpause the
    // underlying stream.
    this._read = function(n) {
        $9845726cca5dc7eb$var$debug("wrapped _read", n);
        if (paused) {
            paused = false;
            stream.resume();
        }
    };
    return this;
};
Object.defineProperty($9845726cca5dc7eb$var$Readable.prototype, "readableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._readableState.highWaterMark;
    }
});
// exposed for testing purposes only.
$9845726cca5dc7eb$var$Readable._fromList = $9845726cca5dc7eb$var$fromList;
// Pluck off n bytes from an array of buffers.
// Length is the combined lengths of all the buffers in the list.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromList(n, state) {
    // nothing buffered
    if (state.length === 0) return null;
    var ret;
    if (state.objectMode) ret = state.buffer.shift();
    else if (!n || n >= state.length) {
        // read it all, truncate the list
        if (state.decoder) ret = state.buffer.join("");
        else if (state.buffer.length === 1) ret = state.buffer.head.data;
        else ret = state.buffer.concat(state.length);
        state.buffer.clear();
    } else // read part of list
    ret = $9845726cca5dc7eb$var$fromListPartial(n, state.buffer, state.decoder);
    return ret;
}
// Extracts only enough buffered data to satisfy the amount requested.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$fromListPartial(n, list, hasStrings) {
    var ret;
    if (n < list.head.data.length) {
        // slice is the same for buffers and strings
        ret = list.head.data.slice(0, n);
        list.head.data = list.head.data.slice(n);
    } else if (n === list.head.data.length) // first chunk is a perfect match
    ret = list.shift();
    else // result spans more than one buffer
    ret = hasStrings ? $9845726cca5dc7eb$var$copyFromBufferString(n, list) : $9845726cca5dc7eb$var$copyFromBuffer(n, list);
    return ret;
}
// Copies a specified amount of characters from the list of buffered data
// chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBufferString(n, list) {
    var p = list.head;
    var c = 1;
    var ret = p.data;
    n -= ret.length;
    while(p = p.next){
        var str = p.data;
        var nb = n > str.length ? str.length : n;
        if (nb === str.length) ret += str;
        else ret += str.slice(0, n);
        n -= nb;
        if (n === 0) {
            if (nb === str.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = str.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
// Copies a specified amount of bytes from the list of buffered data chunks.
// This function is designed to be inlinable, so please take care when making
// changes to the function body.
function $9845726cca5dc7eb$var$copyFromBuffer(n, list) {
    var ret = $9845726cca5dc7eb$require$Buffer.allocUnsafe(n);
    var p = list.head;
    var c = 1;
    p.data.copy(ret);
    n -= p.data.length;
    while(p = p.next){
        var buf = p.data;
        var nb = n > buf.length ? buf.length : n;
        buf.copy(ret, ret.length - n, 0, nb);
        n -= nb;
        if (n === 0) {
            if (nb === buf.length) {
                ++c;
                if (p.next) list.head = p.next;
                else list.head = list.tail = null;
            } else {
                list.head = p;
                p.data = buf.slice(nb);
            }
            break;
        }
        ++c;
    }
    list.length -= c;
    return ret;
}
function $9845726cca5dc7eb$var$endReadable(stream) {
    var state = stream._readableState;
    // If we get here before consuming all the bytes, then that is a
    // bug in node.  Should never happen.
    if (state.length > 0) throw new Error('"endReadable()" called on non-empty stream');
    if (!state.endEmitted) {
        state.ended = true;
        $bUlqC.nextTick($9845726cca5dc7eb$var$endReadableNT, state, stream);
    }
}
function $9845726cca5dc7eb$var$endReadableNT(state, stream) {
    // Check that we didn't get one last unshift.
    if (!state.endEmitted && state.length === 0) {
        state.endEmitted = true;
        stream.readable = false;
        stream.emit("end");
    }
}
function $9845726cca5dc7eb$var$indexOf(xs, x) {
    for(var i = 0, l = xs.length; i < l; i++){
        if (xs[i] === x) return i;
    }
    return -1;
}

});
parcelRegister("bUlqC", function(module, exports) {

var $hPtJY = parcelRequire("hPtJY");
"use strict";
if (typeof $hPtJY === "undefined" || !$hPtJY.version || $hPtJY.version.indexOf("v0.") === 0 || $hPtJY.version.indexOf("v1.") === 0 && $hPtJY.version.indexOf("v1.8.") !== 0) module.exports = {
    nextTick: $8ab58be9444f732a$var$nextTick
};
else module.exports = $hPtJY;
function $8ab58be9444f732a$var$nextTick(fn, arg1, arg2, arg3) {
    if (typeof fn !== "function") throw new TypeError('"callback" argument must be a function');
    var len = arguments.length;
    var args, i;
    switch(len){
        case 0:
        case 1:
            return $hPtJY.nextTick(fn);
        case 2:
            return $hPtJY.nextTick(function afterTickOne() {
                fn.call(null, arg1);
            });
        case 3:
            return $hPtJY.nextTick(function afterTickTwo() {
                fn.call(null, arg1, arg2);
            });
        case 4:
            return $hPtJY.nextTick(function afterTickThree() {
                fn.call(null, arg1, arg2, arg3);
            });
        default:
            args = new Array(len - 1);
            i = 0;
            while(i < args.length)args[i++] = arguments[i];
            return $hPtJY.nextTick(function afterTick() {
                fn.apply(null, args);
            });
    }
}

});

parcelRegister("767Wy", function(module, exports) {
var $52af415c3a3d4253$var$toString = {}.toString;
module.exports = Array.isArray || function(arr) {
    return $52af415c3a3d4253$var$toString.call(arr) == "[object Array]";
};

});

parcelRegister("jfAlf", function(module, exports) {

module.exports = (parcelRequire("7etJZ")).EventEmitter;

});

parcelRegister("h3oXE", function(module, exports) {
/* eslint-disable node/no-deprecated-api */ 
var $6ZWSX = parcelRequire("6ZWSX");
var $c6a6143e40fe9703$var$Buffer = $6ZWSX.Buffer;
// alternative to using Object.keys for old browsers
function $c6a6143e40fe9703$var$copyProps(src, dst) {
    for(var key in src)dst[key] = src[key];
}
if ($c6a6143e40fe9703$var$Buffer.from && $c6a6143e40fe9703$var$Buffer.alloc && $c6a6143e40fe9703$var$Buffer.allocUnsafe && $c6a6143e40fe9703$var$Buffer.allocUnsafeSlow) module.exports = $6ZWSX;
else {
    // Copy properties from require('buffer')
    $c6a6143e40fe9703$var$copyProps($6ZWSX, module.exports);
    module.exports.Buffer = $c6a6143e40fe9703$var$SafeBuffer;
}
function $c6a6143e40fe9703$var$SafeBuffer(arg, encodingOrOffset, length) {
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
}
// Copy static methods from Buffer
$c6a6143e40fe9703$var$copyProps($c6a6143e40fe9703$var$Buffer, $c6a6143e40fe9703$var$SafeBuffer);
$c6a6143e40fe9703$var$SafeBuffer.from = function(arg, encodingOrOffset, length) {
    if (typeof arg === "number") throw new TypeError("Argument must not be a number");
    return $c6a6143e40fe9703$var$Buffer(arg, encodingOrOffset, length);
};
$c6a6143e40fe9703$var$SafeBuffer.alloc = function(size, fill, encoding) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    var buf = $c6a6143e40fe9703$var$Buffer(size);
    if (fill !== undefined) {
        if (typeof encoding === "string") buf.fill(fill, encoding);
        else buf.fill(fill);
    } else buf.fill(0);
    return buf;
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafe = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $c6a6143e40fe9703$var$Buffer(size);
};
$c6a6143e40fe9703$var$SafeBuffer.allocUnsafeSlow = function(size) {
    if (typeof size !== "number") throw new TypeError("Argument must be a number");
    return $6ZWSX.SlowBuffer(size);
};

});

parcelRegister("dH2Jp", function(module, exports) {

$parcel$export(module.exports, "isArray", () => $9f8168ed52eee242$export$43bee75e5e14138e, (v) => $9f8168ed52eee242$export$43bee75e5e14138e = v);
$parcel$export(module.exports, "isBoolean", () => $9f8168ed52eee242$export$f9ce7b637dfbe238, (v) => $9f8168ed52eee242$export$f9ce7b637dfbe238 = v);
$parcel$export(module.exports, "isNull", () => $9f8168ed52eee242$export$630801d484da15df, (v) => $9f8168ed52eee242$export$630801d484da15df = v);
$parcel$export(module.exports, "isNullOrUndefined", () => $9f8168ed52eee242$export$bedb7023a7733221, (v) => $9f8168ed52eee242$export$bedb7023a7733221 = v);
$parcel$export(module.exports, "isNumber", () => $9f8168ed52eee242$export$7e4aa119212bc614, (v) => $9f8168ed52eee242$export$7e4aa119212bc614 = v);
$parcel$export(module.exports, "isString", () => $9f8168ed52eee242$export$844ec244b1367d54, (v) => $9f8168ed52eee242$export$844ec244b1367d54 = v);
$parcel$export(module.exports, "isSymbol", () => $9f8168ed52eee242$export$a244864fd9645c7f, (v) => $9f8168ed52eee242$export$a244864fd9645c7f = v);
$parcel$export(module.exports, "isUndefined", () => $9f8168ed52eee242$export$fce6876652108ab, (v) => $9f8168ed52eee242$export$fce6876652108ab = v);
$parcel$export(module.exports, "isRegExp", () => $9f8168ed52eee242$export$49841c62b9eff15, (v) => $9f8168ed52eee242$export$49841c62b9eff15 = v);
$parcel$export(module.exports, "isObject", () => $9f8168ed52eee242$export$a6cdc56e425d0d0a, (v) => $9f8168ed52eee242$export$a6cdc56e425d0d0a = v);
$parcel$export(module.exports, "isDate", () => $9f8168ed52eee242$export$871608497c498473, (v) => $9f8168ed52eee242$export$871608497c498473 = v);
$parcel$export(module.exports, "isError", () => $9f8168ed52eee242$export$e6127cc7fe7395c3, (v) => $9f8168ed52eee242$export$e6127cc7fe7395c3 = v);
$parcel$export(module.exports, "isFunction", () => $9f8168ed52eee242$export$f6e2535fb5126e54, (v) => $9f8168ed52eee242$export$f6e2535fb5126e54 = v);
$parcel$export(module.exports, "isPrimitive", () => $9f8168ed52eee242$export$c3825b437cbdea5c, (v) => $9f8168ed52eee242$export$c3825b437cbdea5c = v);
$parcel$export(module.exports, "isBuffer", () => $9f8168ed52eee242$export$a7884ebc965f8f54, (v) => $9f8168ed52eee242$export$a7884ebc965f8f54 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// NOTE: These type checking functions intentionally don't use `instanceof`
// because it is fragile and can be easily faked with `Object.create()`.
var $9f8168ed52eee242$export$43bee75e5e14138e;
var $9f8168ed52eee242$export$f9ce7b637dfbe238;
var $9f8168ed52eee242$export$630801d484da15df;
var $9f8168ed52eee242$export$bedb7023a7733221;
var $9f8168ed52eee242$export$7e4aa119212bc614;
var $9f8168ed52eee242$export$844ec244b1367d54;
var $9f8168ed52eee242$export$a244864fd9645c7f;
var $9f8168ed52eee242$export$fce6876652108ab;
var $9f8168ed52eee242$export$49841c62b9eff15;
var $9f8168ed52eee242$export$a6cdc56e425d0d0a;
var $9f8168ed52eee242$export$871608497c498473;
var $9f8168ed52eee242$export$e6127cc7fe7395c3;
var $9f8168ed52eee242$export$f6e2535fb5126e54;
var $9f8168ed52eee242$export$c3825b437cbdea5c;
var $9f8168ed52eee242$export$a7884ebc965f8f54;
function $9f8168ed52eee242$var$isArray(arg) {
    if (Array.isArray) return Array.isArray(arg);
    return $9f8168ed52eee242$var$objectToString(arg) === "[object Array]";
}
$9f8168ed52eee242$export$43bee75e5e14138e = $9f8168ed52eee242$var$isArray;
function $9f8168ed52eee242$var$isBoolean(arg) {
    return typeof arg === "boolean";
}
$9f8168ed52eee242$export$f9ce7b637dfbe238 = $9f8168ed52eee242$var$isBoolean;
function $9f8168ed52eee242$var$isNull(arg) {
    return arg === null;
}
$9f8168ed52eee242$export$630801d484da15df = $9f8168ed52eee242$var$isNull;
function $9f8168ed52eee242$var$isNullOrUndefined(arg) {
    return arg == null;
}
$9f8168ed52eee242$export$bedb7023a7733221 = $9f8168ed52eee242$var$isNullOrUndefined;
function $9f8168ed52eee242$var$isNumber(arg) {
    return typeof arg === "number";
}
$9f8168ed52eee242$export$7e4aa119212bc614 = $9f8168ed52eee242$var$isNumber;
function $9f8168ed52eee242$var$isString(arg) {
    return typeof arg === "string";
}
$9f8168ed52eee242$export$844ec244b1367d54 = $9f8168ed52eee242$var$isString;
function $9f8168ed52eee242$var$isSymbol(arg) {
    return typeof arg === "symbol";
}
$9f8168ed52eee242$export$a244864fd9645c7f = $9f8168ed52eee242$var$isSymbol;
function $9f8168ed52eee242$var$isUndefined(arg) {
    return arg === void 0;
}
$9f8168ed52eee242$export$fce6876652108ab = $9f8168ed52eee242$var$isUndefined;
function $9f8168ed52eee242$var$isRegExp(re) {
    return $9f8168ed52eee242$var$objectToString(re) === "[object RegExp]";
}
$9f8168ed52eee242$export$49841c62b9eff15 = $9f8168ed52eee242$var$isRegExp;
function $9f8168ed52eee242$var$isObject(arg) {
    return typeof arg === "object" && arg !== null;
}
$9f8168ed52eee242$export$a6cdc56e425d0d0a = $9f8168ed52eee242$var$isObject;
function $9f8168ed52eee242$var$isDate(d) {
    return $9f8168ed52eee242$var$objectToString(d) === "[object Date]";
}
$9f8168ed52eee242$export$871608497c498473 = $9f8168ed52eee242$var$isDate;
function $9f8168ed52eee242$var$isError(e) {
    return $9f8168ed52eee242$var$objectToString(e) === "[object Error]" || e instanceof Error;
}
$9f8168ed52eee242$export$e6127cc7fe7395c3 = $9f8168ed52eee242$var$isError;
function $9f8168ed52eee242$var$isFunction(arg) {
    return typeof arg === "function";
}
$9f8168ed52eee242$export$f6e2535fb5126e54 = $9f8168ed52eee242$var$isFunction;
function $9f8168ed52eee242$var$isPrimitive(arg) {
    return arg === null || typeof arg === "boolean" || typeof arg === "number" || typeof arg === "string" || typeof arg === "symbol" || // ES6 symbol
    typeof arg === "undefined";
}
$9f8168ed52eee242$export$c3825b437cbdea5c = $9f8168ed52eee242$var$isPrimitive;

$9f8168ed52eee242$export$a7884ebc965f8f54 = (parcelRequire("6ZWSX")).Buffer.isBuffer;
function $9f8168ed52eee242$var$objectToString(o) {
    return Object.prototype.toString.call(o);
}

});

parcelRegister("185iR", function(module, exports) {
"use strict";
function $0d2aa6ea56b3e1e2$var$_classCallCheck(instance, Constructor) {
    if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
}

var $h3oXE = parcelRequire("h3oXE");
var $0d2aa6ea56b3e1e2$require$Buffer = $h3oXE.Buffer;

var $kjyEk = parcelRequire("kjyEk");
function $0d2aa6ea56b3e1e2$var$copyBuffer(src, target, offset) {
    src.copy(target, offset);
}
module.exports = function() {
    function BufferList() {
        $0d2aa6ea56b3e1e2$var$_classCallCheck(this, BufferList);
        this.head = null;
        this.tail = null;
        this.length = 0;
    }
    BufferList.prototype.push = function push(v) {
        var entry = {
            data: v,
            next: null
        };
        if (this.length > 0) this.tail.next = entry;
        else this.head = entry;
        this.tail = entry;
        ++this.length;
    };
    BufferList.prototype.unshift = function unshift(v) {
        var entry = {
            data: v,
            next: this.head
        };
        if (this.length === 0) this.tail = entry;
        this.head = entry;
        ++this.length;
    };
    BufferList.prototype.shift = function shift() {
        if (this.length === 0) return;
        var ret = this.head.data;
        if (this.length === 1) this.head = this.tail = null;
        else this.head = this.head.next;
        --this.length;
        return ret;
    };
    BufferList.prototype.clear = function clear() {
        this.head = this.tail = null;
        this.length = 0;
    };
    BufferList.prototype.join = function join(s) {
        if (this.length === 0) return "";
        var p = this.head;
        var ret = "" + p.data;
        while(p = p.next)ret += s + p.data;
        return ret;
    };
    BufferList.prototype.concat = function concat(n) {
        if (this.length === 0) return $0d2aa6ea56b3e1e2$require$Buffer.alloc(0);
        var ret = $0d2aa6ea56b3e1e2$require$Buffer.allocUnsafe(n >>> 0);
        var p = this.head;
        var i = 0;
        while(p){
            $0d2aa6ea56b3e1e2$var$copyBuffer(p.data, ret, i);
            i += p.data.length;
            p = p.next;
        }
        return ret;
    };
    return BufferList;
}();
if ($kjyEk && $kjyEk.inspect && $kjyEk.inspect.custom) module.exports.prototype[$kjyEk.inspect.custom] = function() {
    var obj = $kjyEk.inspect({
        length: this.length
    });
    return this.constructor.name + " " + obj;
};

});

parcelRegister("fMCbt", function(module, exports) {
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ // undocumented cb() API, needed for core, not for public API
function $b7d8f541ca4a3ff5$var$destroy(err, cb) {
    var _this = this;
    var readableDestroyed = this._readableState && this._readableState.destroyed;
    var writableDestroyed = this._writableState && this._writableState.destroyed;
    if (readableDestroyed || writableDestroyed) {
        if (cb) cb(err);
        else if (err) {
            if (!this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            else if (!this._writableState.errorEmitted) {
                this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, this, err);
            }
        }
        return this;
    }
    // we set destroyed to true before firing error callbacks in order
    // to make it re-entrance safe in case destroy() is called within callbacks
    if (this._readableState) this._readableState.destroyed = true;
    // if this is a duplex stream mark the writable part as destroyed as well
    if (this._writableState) this._writableState.destroyed = true;
    this._destroy(err || null, function(err) {
        if (!cb && err) {
            if (!_this._writableState) $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            else if (!_this._writableState.errorEmitted) {
                _this._writableState.errorEmitted = true;
                $bUlqC.nextTick($b7d8f541ca4a3ff5$var$emitErrorNT, _this, err);
            }
        } else if (cb) cb(err);
    });
    return this;
}
function $b7d8f541ca4a3ff5$var$undestroy() {
    if (this._readableState) {
        this._readableState.destroyed = false;
        this._readableState.reading = false;
        this._readableState.ended = false;
        this._readableState.endEmitted = false;
    }
    if (this._writableState) {
        this._writableState.destroyed = false;
        this._writableState.ended = false;
        this._writableState.ending = false;
        this._writableState.finalCalled = false;
        this._writableState.prefinished = false;
        this._writableState.finished = false;
        this._writableState.errorEmitted = false;
    }
}
function $b7d8f541ca4a3ff5$var$emitErrorNT(self, err) {
    self.emit("error", err);
}
module.exports = {
    destroy: $b7d8f541ca4a3ff5$var$destroy,
    undestroy: $b7d8f541ca4a3ff5$var$undestroy
};

});

parcelRegister("DwJuQ", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a duplex stream is just a stream that is both readable and writable.
// Since JS doesn't have multiple prototypal inheritance, this class
// prototypally inherits from Readable, and then parasitically from
// Writable.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ /*<replacement>*/ var $076d08b0309449dc$var$objectKeys = Object.keys || function(obj) {
    var keys = [];
    for(var key in obj)keys.push(key);
    return keys;
};
/*</replacement>*/ module.exports = $076d08b0309449dc$var$Duplex;

/*<replacement>*/ var $076d08b0309449dc$var$util = Object.create((parcelRequire("dH2Jp")));

$076d08b0309449dc$var$util.inherits = (parcelRequire("dlqwk"));

var $d4xg3 = parcelRequire("d4xg3");

var $3LwY7 = parcelRequire("3LwY7");
$076d08b0309449dc$var$util.inherits($076d08b0309449dc$var$Duplex, $d4xg3);
// avoid scope creep, the keys array can then be collected
var $076d08b0309449dc$var$keys = $076d08b0309449dc$var$objectKeys($3LwY7.prototype);
for(var $076d08b0309449dc$var$v = 0; $076d08b0309449dc$var$v < $076d08b0309449dc$var$keys.length; $076d08b0309449dc$var$v++){
    var $076d08b0309449dc$var$method = $076d08b0309449dc$var$keys[$076d08b0309449dc$var$v];
    if (!$076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method]) $076d08b0309449dc$var$Duplex.prototype[$076d08b0309449dc$var$method] = $3LwY7.prototype[$076d08b0309449dc$var$method];
}
function $076d08b0309449dc$var$Duplex(options) {
    if (!(this instanceof $076d08b0309449dc$var$Duplex)) return new $076d08b0309449dc$var$Duplex(options);
    $d4xg3.call(this, options);
    $3LwY7.call(this, options);
    if (options && options.readable === false) this.readable = false;
    if (options && options.writable === false) this.writable = false;
    this.allowHalfOpen = true;
    if (options && options.allowHalfOpen === false) this.allowHalfOpen = false;
    this.once("end", $076d08b0309449dc$var$onend);
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// the no-half-open enforcer
function $076d08b0309449dc$var$onend() {
    // if we allow half-open state, or if the writable side ended,
    // then we're ok.
    if (this.allowHalfOpen || this._writableState.ended) return;
    // no more data can be written.
    // But allow more writes to happen in this tick.
    $bUlqC.nextTick($076d08b0309449dc$var$onEndNT, this);
}
function $076d08b0309449dc$var$onEndNT(self) {
    self.end();
}
Object.defineProperty($076d08b0309449dc$var$Duplex.prototype, "destroyed", {
    get: function() {
        if (this._readableState === undefined || this._writableState === undefined) return false;
        return this._readableState.destroyed && this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (this._readableState === undefined || this._writableState === undefined) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._readableState.destroyed = value;
        this._writableState.destroyed = value;
    }
});
$076d08b0309449dc$var$Duplex.prototype._destroy = function(err, cb) {
    this.push(null);
    this.end();
    $bUlqC.nextTick(cb, err);
};

});
parcelRegister("3LwY7", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// A bit simpler than readable streams.
// Implement an async ._write(chunk, encoding, cb), and it'll handle all
// the drain event emission and buffering.
"use strict";

var $bUlqC = parcelRequire("bUlqC");
/*</replacement>*/ module.exports = $2bdf55c2c4f390d3$var$Writable;
/* <replacement> */ function $2bdf55c2c4f390d3$var$WriteReq(chunk, encoding, cb) {
    this.chunk = chunk;
    this.encoding = encoding;
    this.callback = cb;
    this.next = null;
}
// It seems a linked list but it is not
// there will be only 2 of these for each stream
function $2bdf55c2c4f390d3$var$CorkedRequest(state) {
    var _this = this;
    this.next = null;
    this.entry = null;
    this.finish = function() {
        $2bdf55c2c4f390d3$var$onCorkedFinish(_this, state);
    };
}
/* </replacement> */ /*<replacement>*/ var $2bdf55c2c4f390d3$var$asyncWrite = (0, $bUlqC.nextTick);
/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$Duplex;
/*</replacement>*/ $2bdf55c2c4f390d3$var$Writable.WritableState = $2bdf55c2c4f390d3$var$WritableState;

/*<replacement>*/ var $2bdf55c2c4f390d3$var$util = Object.create((parcelRequire("dH2Jp")));

$2bdf55c2c4f390d3$var$util.inherits = (parcelRequire("dlqwk"));

/*</replacement>*/ /*<replacement>*/ var $2bdf55c2c4f390d3$var$internalUtil = {
    deprecate: (parcelRequire("39vsn"))
};

var $jfAlf = parcelRequire("jfAlf");

var $h3oXE = parcelRequire("h3oXE");
var $2bdf55c2c4f390d3$require$Buffer = $h3oXE.Buffer;
var $2bdf55c2c4f390d3$var$OurUint8Array = (typeof $parcel$global !== "undefined" ? $parcel$global : typeof window !== "undefined" ? window : typeof self !== "undefined" ? self : {}).Uint8Array || function() {};
function $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk) {
    return $2bdf55c2c4f390d3$require$Buffer.from(chunk);
}
function $2bdf55c2c4f390d3$var$_isUint8Array(obj) {
    return $2bdf55c2c4f390d3$require$Buffer.isBuffer(obj) || obj instanceof $2bdf55c2c4f390d3$var$OurUint8Array;
}

var $fMCbt = parcelRequire("fMCbt");
$2bdf55c2c4f390d3$var$util.inherits($2bdf55c2c4f390d3$var$Writable, $jfAlf);
function $2bdf55c2c4f390d3$var$nop() {}

function $2bdf55c2c4f390d3$var$WritableState(options, stream) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    options = options || {};
    // Duplex streams are both readable and writable, but share
    // the same options object.
    // However, some cases require setting options to different
    // values for the readable and the writable sides of the duplex stream.
    // These options can be provided separately as readableXXX and writableXXX.
    var isDuplex = stream instanceof $2bdf55c2c4f390d3$var$Duplex;
    // object stream flag to indicate whether or not this stream
    // contains buffers or objects.
    this.objectMode = !!options.objectMode;
    if (isDuplex) this.objectMode = this.objectMode || !!options.writableObjectMode;
    // the point at which write() starts returning false
    // Note: 0 is a valid value, means that we always return false if
    // the entire buffer is not flushed immediately on write()
    var hwm = options.highWaterMark;
    var writableHwm = options.writableHighWaterMark;
    var defaultHwm = this.objectMode ? 16 : 16384;
    if (hwm || hwm === 0) this.highWaterMark = hwm;
    else if (isDuplex && (writableHwm || writableHwm === 0)) this.highWaterMark = writableHwm;
    else this.highWaterMark = defaultHwm;
    // cast to ints.
    this.highWaterMark = Math.floor(this.highWaterMark);
    // if _final has been called
    this.finalCalled = false;
    // drain event flag.
    this.needDrain = false;
    // at the start of calling end()
    this.ending = false;
    // when end() has been called, and returned
    this.ended = false;
    // when 'finish' is emitted
    this.finished = false;
    // has it been destroyed
    this.destroyed = false;
    // should we decode strings into buffers before passing to _write?
    // this is here so that some node-core streams can optimize string
    // handling at a lower level.
    var noDecode = options.decodeStrings === false;
    this.decodeStrings = !noDecode;
    // Crypto is kind of old and crusty.  Historically, its default string
    // encoding is 'binary' so we have to make this configurable.
    // Everything else in the universe uses 'utf8', though.
    this.defaultEncoding = options.defaultEncoding || "utf8";
    // not an actual buffer we keep track of, but a measurement
    // of how much we're waiting to get pushed to some underlying
    // socket or file.
    this.length = 0;
    // a flag to see when we're in the middle of a write.
    this.writing = false;
    // when true all writes will be buffered until .uncork() call
    this.corked = 0;
    // a flag to be able to tell if the onwrite cb is called immediately,
    // or on a later tick.  We set this to true at first, because any
    // actions that shouldn't happen until "later" should generally also
    // not happen before the first write call.
    this.sync = true;
    // a flag to know if we're processing previously buffered items, which
    // may call the _write() callback in the same tick, so that we don't
    // end up in an overlapped onwrite situation.
    this.bufferProcessing = false;
    // the callback that's passed to _write(chunk,cb)
    this.onwrite = function(er) {
        $2bdf55c2c4f390d3$var$onwrite(stream, er);
    };
    // the callback that the user supplies to write(chunk,encoding,cb)
    this.writecb = null;
    // the amount that is being written when _write is called.
    this.writelen = 0;
    this.bufferedRequest = null;
    this.lastBufferedRequest = null;
    // number of pending user-supplied write callbacks
    // this must be 0 before 'finish' can be emitted
    this.pendingcb = 0;
    // emit prefinish if the only thing we're waiting for is _write cbs
    // This is relevant for synchronous Transform streams
    this.prefinished = false;
    // True if the error was already emitted and should not be thrown again
    this.errorEmitted = false;
    // count buffered requests
    this.bufferedRequestCount = 0;
    // allocate the first CorkedRequest, there is always
    // one allocated and free to use, and we maintain at most two
    this.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(this);
}
$2bdf55c2c4f390d3$var$WritableState.prototype.getBuffer = function getBuffer() {
    var current = this.bufferedRequest;
    var out = [];
    while(current){
        out.push(current);
        current = current.next;
    }
    return out;
};
(function() {
    try {
        Object.defineProperty($2bdf55c2c4f390d3$var$WritableState.prototype, "buffer", {
            get: $2bdf55c2c4f390d3$var$internalUtil.deprecate(function() {
                return this.getBuffer();
            }, "_writableState.buffer is deprecated. Use _writableState.getBuffer instead.", "DEP0003")
        });
    } catch (_) {}
})();
// Test _writableState for inheritance to account for Duplex streams,
// whose prototype chain only points to Readable.
var $2bdf55c2c4f390d3$var$realHasInstance;
if (typeof Symbol === "function" && Symbol.hasInstance && typeof Function.prototype[Symbol.hasInstance] === "function") {
    $2bdf55c2c4f390d3$var$realHasInstance = Function.prototype[Symbol.hasInstance];
    Object.defineProperty($2bdf55c2c4f390d3$var$Writable, Symbol.hasInstance, {
        value: function(object) {
            if ($2bdf55c2c4f390d3$var$realHasInstance.call(this, object)) return true;
            if (this !== $2bdf55c2c4f390d3$var$Writable) return false;
            return object && object._writableState instanceof $2bdf55c2c4f390d3$var$WritableState;
        }
    });
} else $2bdf55c2c4f390d3$var$realHasInstance = function(object) {
    return object instanceof this;
};

function $2bdf55c2c4f390d3$var$Writable(options) {
    $2bdf55c2c4f390d3$var$Duplex = $2bdf55c2c4f390d3$var$Duplex || (parcelRequire("DwJuQ"));
    // Writable ctor is applied to Duplexes, too.
    // `realHasInstance` is necessary because using plain `instanceof`
    // would return false, as no `_writableState` property is attached.
    // Trying to use the custom `instanceof` for Writable here will also break the
    // Node.js LazyTransform implementation, which has a non-trivial getter for
    // `_writableState` that would lead to infinite recursion.
    if (!$2bdf55c2c4f390d3$var$realHasInstance.call($2bdf55c2c4f390d3$var$Writable, this) && !(this instanceof $2bdf55c2c4f390d3$var$Duplex)) return new $2bdf55c2c4f390d3$var$Writable(options);
    this._writableState = new $2bdf55c2c4f390d3$var$WritableState(options, this);
    // legacy.
    this.writable = true;
    if (options) {
        if (typeof options.write === "function") this._write = options.write;
        if (typeof options.writev === "function") this._writev = options.writev;
        if (typeof options.destroy === "function") this._destroy = options.destroy;
        if (typeof options.final === "function") this._final = options.final;
    }
    $jfAlf.call(this);
}
// Otherwise people can pipe Writable streams, which is just wrong.
$2bdf55c2c4f390d3$var$Writable.prototype.pipe = function() {
    this.emit("error", new Error("Cannot pipe, not readable"));
};
function $2bdf55c2c4f390d3$var$writeAfterEnd(stream, cb) {
    var er = new Error("write after end");
    // TODO: defer error events consistently everywhere, not just the cb
    stream.emit("error", er);
    $bUlqC.nextTick(cb, er);
}
// Checks that a user-supplied chunk is valid, especially for the particular
// mode the stream is in. Currently this means that `null` is never accepted
// and undefined/non-string values are only allowed in object mode.
function $2bdf55c2c4f390d3$var$validChunk(stream, state, chunk, cb) {
    var valid = true;
    var er = false;
    if (chunk === null) er = new TypeError("May not write null values to stream");
    else if (typeof chunk !== "string" && chunk !== undefined && !state.objectMode) er = new TypeError("Invalid non-string/buffer chunk");
    if (er) {
        stream.emit("error", er);
        $bUlqC.nextTick(cb, er);
        valid = false;
    }
    return valid;
}
$2bdf55c2c4f390d3$var$Writable.prototype.write = function(chunk, encoding, cb) {
    var state = this._writableState;
    var ret = false;
    var isBuf = !state.objectMode && $2bdf55c2c4f390d3$var$_isUint8Array(chunk);
    if (isBuf && !$2bdf55c2c4f390d3$require$Buffer.isBuffer(chunk)) chunk = $2bdf55c2c4f390d3$var$_uint8ArrayToBuffer(chunk);
    if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (isBuf) encoding = "buffer";
    else if (!encoding) encoding = state.defaultEncoding;
    if (typeof cb !== "function") cb = $2bdf55c2c4f390d3$var$nop;
    if (state.ended) $2bdf55c2c4f390d3$var$writeAfterEnd(this, cb);
    else if (isBuf || $2bdf55c2c4f390d3$var$validChunk(this, state, chunk, cb)) {
        state.pendingcb++;
        ret = $2bdf55c2c4f390d3$var$writeOrBuffer(this, state, isBuf, chunk, encoding, cb);
    }
    return ret;
};
$2bdf55c2c4f390d3$var$Writable.prototype.cork = function() {
    var state = this._writableState;
    state.corked++;
};
$2bdf55c2c4f390d3$var$Writable.prototype.uncork = function() {
    var state = this._writableState;
    if (state.corked) {
        state.corked--;
        if (!state.writing && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(this, state);
    }
};
$2bdf55c2c4f390d3$var$Writable.prototype.setDefaultEncoding = function setDefaultEncoding(encoding) {
    // node::ParseEncoding() requires lower case.
    if (typeof encoding === "string") encoding = encoding.toLowerCase();
    if (!([
        "hex",
        "utf8",
        "utf-8",
        "ascii",
        "binary",
        "base64",
        "ucs2",
        "ucs-2",
        "utf16le",
        "utf-16le",
        "raw"
    ].indexOf((encoding + "").toLowerCase()) > -1)) throw new TypeError("Unknown encoding: " + encoding);
    this._writableState.defaultEncoding = encoding;
    return this;
};
function $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding) {
    if (!state.objectMode && state.decodeStrings !== false && typeof chunk === "string") chunk = $2bdf55c2c4f390d3$require$Buffer.from(chunk, encoding);
    return chunk;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "writableHighWaterMark", {
    // making it explicit this property is not enumerable
    // because otherwise some prototype manipulation in
    // userland will fail
    enumerable: false,
    get: function() {
        return this._writableState.highWaterMark;
    }
});
// if we're already writing something, then just put this
// in the queue, and wait our turn.  Otherwise, call _write
// If we return false, then we need a drain event, so set that flag.
function $2bdf55c2c4f390d3$var$writeOrBuffer(stream, state, isBuf, chunk, encoding, cb) {
    if (!isBuf) {
        var newChunk = $2bdf55c2c4f390d3$var$decodeChunk(state, chunk, encoding);
        if (chunk !== newChunk) {
            isBuf = true;
            encoding = "buffer";
            chunk = newChunk;
        }
    }
    var len = state.objectMode ? 1 : chunk.length;
    state.length += len;
    var ret = state.length < state.highWaterMark;
    // we must ensure that previous needDrain will not be reset to false.
    if (!ret) state.needDrain = true;
    if (state.writing || state.corked) {
        var last = state.lastBufferedRequest;
        state.lastBufferedRequest = {
            chunk: chunk,
            encoding: encoding,
            isBuf: isBuf,
            callback: cb,
            next: null
        };
        if (last) last.next = state.lastBufferedRequest;
        else state.bufferedRequest = state.lastBufferedRequest;
        state.bufferedRequestCount += 1;
    } else $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
    return ret;
}
function $2bdf55c2c4f390d3$var$doWrite(stream, state, writev, len, chunk, encoding, cb) {
    state.writelen = len;
    state.writecb = cb;
    state.writing = true;
    state.sync = true;
    if (writev) stream._writev(chunk, state.onwrite);
    else stream._write(chunk, encoding, state.onwrite);
    state.sync = false;
}
function $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb) {
    --state.pendingcb;
    if (sync) {
        // defer the callback if we are being called synchronously
        // to avoid piling up things on the stack
        $bUlqC.nextTick(cb, er);
        // this can emit finish, and it will always happen
        // after error
        $bUlqC.nextTick($2bdf55c2c4f390d3$var$finishMaybe, stream, state);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
    } else {
        // the caller expect this to happen before if
        // it is async
        cb(er);
        stream._writableState.errorEmitted = true;
        stream.emit("error", er);
        // this can emit finish, but finish must
        // always follow error
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    }
}
function $2bdf55c2c4f390d3$var$onwriteStateUpdate(state) {
    state.writing = false;
    state.writecb = null;
    state.length -= state.writelen;
    state.writelen = 0;
}
function $2bdf55c2c4f390d3$var$onwrite(stream, er) {
    var state = stream._writableState;
    var sync = state.sync;
    var cb = state.writecb;
    $2bdf55c2c4f390d3$var$onwriteStateUpdate(state);
    if (er) $2bdf55c2c4f390d3$var$onwriteError(stream, state, sync, er, cb);
    else {
        // Check if we're actually ready to finish, but don't emit yet
        var finished = $2bdf55c2c4f390d3$var$needFinish(state);
        if (!finished && !state.corked && !state.bufferProcessing && state.bufferedRequest) $2bdf55c2c4f390d3$var$clearBuffer(stream, state);
        if (sync) /*<replacement>*/ $2bdf55c2c4f390d3$var$asyncWrite($2bdf55c2c4f390d3$var$afterWrite, stream, state, finished, cb);
        else $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb);
    }
}
function $2bdf55c2c4f390d3$var$afterWrite(stream, state, finished, cb) {
    if (!finished) $2bdf55c2c4f390d3$var$onwriteDrain(stream, state);
    state.pendingcb--;
    cb();
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
}
// Must force callback to be called on nextTick, so that we don't
// emit 'drain' before the write() consumer gets the 'false' return
// value, and has a chance to attach a 'drain' listener.
function $2bdf55c2c4f390d3$var$onwriteDrain(stream, state) {
    if (state.length === 0 && state.needDrain) {
        state.needDrain = false;
        stream.emit("drain");
    }
}
// if there's something in the buffer waiting, then process it
function $2bdf55c2c4f390d3$var$clearBuffer(stream, state) {
    state.bufferProcessing = true;
    var entry = state.bufferedRequest;
    if (stream._writev && entry && entry.next) {
        // Fast case, write everything using _writev()
        var l = state.bufferedRequestCount;
        var buffer = new Array(l);
        var holder = state.corkedRequestsFree;
        holder.entry = entry;
        var count = 0;
        var allBuffers = true;
        while(entry){
            buffer[count] = entry;
            if (!entry.isBuf) allBuffers = false;
            entry = entry.next;
            count += 1;
        }
        buffer.allBuffers = allBuffers;
        $2bdf55c2c4f390d3$var$doWrite(stream, state, true, state.length, buffer, "", holder.finish);
        // doWrite is almost always async, defer these to save a bit of time
        // as the hot path ends with doWrite
        state.pendingcb++;
        state.lastBufferedRequest = null;
        if (holder.next) {
            state.corkedRequestsFree = holder.next;
            holder.next = null;
        } else state.corkedRequestsFree = new $2bdf55c2c4f390d3$var$CorkedRequest(state);
        state.bufferedRequestCount = 0;
    } else {
        // Slow case, write chunks one-by-one
        while(entry){
            var chunk = entry.chunk;
            var encoding = entry.encoding;
            var cb = entry.callback;
            var len = state.objectMode ? 1 : chunk.length;
            $2bdf55c2c4f390d3$var$doWrite(stream, state, false, len, chunk, encoding, cb);
            entry = entry.next;
            state.bufferedRequestCount--;
            // if we didn't call the onwrite immediately, then
            // it means that we need to wait until it does.
            // also, that means that the chunk and cb are currently
            // being processed, so move the buffer counter past them.
            if (state.writing) break;
        }
        if (entry === null) state.lastBufferedRequest = null;
    }
    state.bufferedRequest = entry;
    state.bufferProcessing = false;
}
$2bdf55c2c4f390d3$var$Writable.prototype._write = function(chunk, encoding, cb) {
    cb(new Error("_write() is not implemented"));
};
$2bdf55c2c4f390d3$var$Writable.prototype._writev = null;
$2bdf55c2c4f390d3$var$Writable.prototype.end = function(chunk, encoding, cb) {
    var state = this._writableState;
    if (typeof chunk === "function") {
        cb = chunk;
        chunk = null;
        encoding = null;
    } else if (typeof encoding === "function") {
        cb = encoding;
        encoding = null;
    }
    if (chunk !== null && chunk !== undefined) this.write(chunk, encoding);
    // .end() fully uncorks
    if (state.corked) {
        state.corked = 1;
        this.uncork();
    }
    // ignore unnecessary end() calls.
    if (!state.ending) $2bdf55c2c4f390d3$var$endWritable(this, state, cb);
};
function $2bdf55c2c4f390d3$var$needFinish(state) {
    return state.ending && state.length === 0 && state.bufferedRequest === null && !state.finished && !state.writing;
}
function $2bdf55c2c4f390d3$var$callFinal(stream, state) {
    stream._final(function(err) {
        state.pendingcb--;
        if (err) stream.emit("error", err);
        state.prefinished = true;
        stream.emit("prefinish");
        $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    });
}
function $2bdf55c2c4f390d3$var$prefinish(stream, state) {
    if (!state.prefinished && !state.finalCalled) {
        if (typeof stream._final === "function") {
            state.pendingcb++;
            state.finalCalled = true;
            $bUlqC.nextTick($2bdf55c2c4f390d3$var$callFinal, stream, state);
        } else {
            state.prefinished = true;
            stream.emit("prefinish");
        }
    }
}
function $2bdf55c2c4f390d3$var$finishMaybe(stream, state) {
    var need = $2bdf55c2c4f390d3$var$needFinish(state);
    if (need) {
        $2bdf55c2c4f390d3$var$prefinish(stream, state);
        if (state.pendingcb === 0) {
            state.finished = true;
            stream.emit("finish");
        }
    }
    return need;
}
function $2bdf55c2c4f390d3$var$endWritable(stream, state, cb) {
    state.ending = true;
    $2bdf55c2c4f390d3$var$finishMaybe(stream, state);
    if (cb) {
        if (state.finished) $bUlqC.nextTick(cb);
        else stream.once("finish", cb);
    }
    state.ended = true;
    stream.writable = false;
}
function $2bdf55c2c4f390d3$var$onCorkedFinish(corkReq, state, err) {
    var entry = corkReq.entry;
    corkReq.entry = null;
    while(entry){
        var cb = entry.callback;
        state.pendingcb--;
        cb(err);
        entry = entry.next;
    }
    // reuse the free corkReq.
    state.corkedRequestsFree.next = corkReq;
}
Object.defineProperty($2bdf55c2c4f390d3$var$Writable.prototype, "destroyed", {
    get: function() {
        if (this._writableState === undefined) return false;
        return this._writableState.destroyed;
    },
    set: function(value) {
        // we ignore the value if the stream
        // has not been initialized yet
        if (!this._writableState) return;
        // backward compatibility, the user is explicitly
        // managing destroyed
        this._writableState.destroyed = value;
    }
});
$2bdf55c2c4f390d3$var$Writable.prototype.destroy = $fMCbt.destroy;
$2bdf55c2c4f390d3$var$Writable.prototype._undestroy = $fMCbt.undestroy;
$2bdf55c2c4f390d3$var$Writable.prototype._destroy = function(err, cb) {
    this.end();
    cb(err);
};

});


parcelRegister("imDDS", function(module, exports) {

$parcel$export(module.exports, "StringDecoder", () => $d5e9082788fdd47b$export$63a7aa211a91ed69, (v) => $d5e9082788fdd47b$export$63a7aa211a91ed69 = v);
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// StringDecoder provides an interface for efficiently splitting a series of
// buffers into a series of JS strings without breaking apart multi-byte
// characters.
var $d5e9082788fdd47b$export$63a7aa211a91ed69;
"use strict";

var $h3oXE = parcelRequire("h3oXE");
var $d5e9082788fdd47b$require$Buffer = $h3oXE.Buffer;
/*</replacement>*/ var $d5e9082788fdd47b$var$isEncoding = $d5e9082788fdd47b$require$Buffer.isEncoding || function(encoding) {
    encoding = "" + encoding;
    switch(encoding && encoding.toLowerCase()){
        case "hex":
        case "utf8":
        case "utf-8":
        case "ascii":
        case "binary":
        case "base64":
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
        case "raw":
            return true;
        default:
            return false;
    }
};
function $d5e9082788fdd47b$var$_normalizeEncoding(enc) {
    if (!enc) return "utf8";
    var retried;
    while(true)switch(enc){
        case "utf8":
        case "utf-8":
            return "utf8";
        case "ucs2":
        case "ucs-2":
        case "utf16le":
        case "utf-16le":
            return "utf16le";
        case "latin1":
        case "binary":
            return "latin1";
        case "base64":
        case "ascii":
        case "hex":
            return enc;
        default:
            if (retried) return; // undefined
            enc = ("" + enc).toLowerCase();
            retried = true;
    }
}
// Do not cache `Buffer.isEncoding` when checking encoding names as some
// modules monkey-patch it to support additional encodings
function $d5e9082788fdd47b$var$normalizeEncoding(enc) {
    var nenc = $d5e9082788fdd47b$var$_normalizeEncoding(enc);
    if (typeof nenc !== "string" && ($d5e9082788fdd47b$require$Buffer.isEncoding === $d5e9082788fdd47b$var$isEncoding || !$d5e9082788fdd47b$var$isEncoding(enc))) throw new Error("Unknown encoding: " + enc);
    return nenc || enc;
}
$d5e9082788fdd47b$export$63a7aa211a91ed69 = $d5e9082788fdd47b$var$StringDecoder;
function $d5e9082788fdd47b$var$StringDecoder(encoding) {
    this.encoding = $d5e9082788fdd47b$var$normalizeEncoding(encoding);
    var nb;
    switch(this.encoding){
        case "utf16le":
            this.text = $d5e9082788fdd47b$var$utf16Text;
            this.end = $d5e9082788fdd47b$var$utf16End;
            nb = 4;
            break;
        case "utf8":
            this.fillLast = $d5e9082788fdd47b$var$utf8FillLast;
            nb = 4;
            break;
        case "base64":
            this.text = $d5e9082788fdd47b$var$base64Text;
            this.end = $d5e9082788fdd47b$var$base64End;
            nb = 3;
            break;
        default:
            this.write = $d5e9082788fdd47b$var$simpleWrite;
            this.end = $d5e9082788fdd47b$var$simpleEnd;
            return;
    }
    this.lastNeed = 0;
    this.lastTotal = 0;
    this.lastChar = $d5e9082788fdd47b$require$Buffer.allocUnsafe(nb);
}
$d5e9082788fdd47b$var$StringDecoder.prototype.write = function(buf) {
    if (buf.length === 0) return "";
    var r;
    var i;
    if (this.lastNeed) {
        r = this.fillLast(buf);
        if (r === undefined) return "";
        i = this.lastNeed;
        this.lastNeed = 0;
    } else i = 0;
    if (i < buf.length) return r ? r + this.text(buf, i) : this.text(buf, i);
    return r || "";
};
$d5e9082788fdd47b$var$StringDecoder.prototype.end = $d5e9082788fdd47b$var$utf8End;
// Returns only complete characters in a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.text = $d5e9082788fdd47b$var$utf8Text;
// Attempts to complete a partial non-UTF-8 character using bytes from a Buffer
$d5e9082788fdd47b$var$StringDecoder.prototype.fillLast = function(buf) {
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, this.lastTotal - this.lastNeed, 0, buf.length);
    this.lastNeed -= buf.length;
};
// Checks the type of a UTF-8 byte, whether it's ASCII, a leading byte, or a
// continuation byte. If an invalid byte is detected, -2 is returned.
function $d5e9082788fdd47b$var$utf8CheckByte(byte) {
    if (byte <= 0x7F) return 0;
    else if (byte >> 5 === 0x06) return 2;
    else if (byte >> 4 === 0x0E) return 3;
    else if (byte >> 3 === 0x1E) return 4;
    return byte >> 6 === 0x02 ? -1 : -2;
}
// Checks at most 3 bytes at the end of a Buffer in order to detect an
// incomplete multi-byte UTF-8 character. The total number of bytes (2, 3, or 4)
// needed to complete the UTF-8 character (if applicable) are returned.
function $d5e9082788fdd47b$var$utf8CheckIncomplete(self, buf, i) {
    var j = buf.length - 1;
    if (j < i) return 0;
    var nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 1;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) self.lastNeed = nb - 2;
        return nb;
    }
    if (--j < i || nb === -2) return 0;
    nb = $d5e9082788fdd47b$var$utf8CheckByte(buf[j]);
    if (nb >= 0) {
        if (nb > 0) {
            if (nb === 2) nb = 0;
            else self.lastNeed = nb - 3;
        }
        return nb;
    }
    return 0;
}
// Validates as many continuation bytes for a multi-byte UTF-8 character as
// needed or are available. If we see a non-continuation byte where we expect
// one, we "replace" the validated continuation bytes we've seen so far with
// a single UTF-8 replacement character ('\ufffd'), to match v8's UTF-8 decoding
// behavior. The continuation byte check is included three times in the case
// where all of the continuation bytes for a character exist in the same buffer.
// It is also done this way as a slight performance increase instead of using a
// loop.
function $d5e9082788fdd47b$var$utf8CheckExtraBytes(self, buf, p) {
    if ((buf[0] & 0xC0) !== 0x80) {
        self.lastNeed = 0;
        return "\uFFFD";
    }
    if (self.lastNeed > 1 && buf.length > 1) {
        if ((buf[1] & 0xC0) !== 0x80) {
            self.lastNeed = 1;
            return "\uFFFD";
        }
        if (self.lastNeed > 2 && buf.length > 2) {
            if ((buf[2] & 0xC0) !== 0x80) {
                self.lastNeed = 2;
                return "\uFFFD";
            }
        }
    }
}
// Attempts to complete a multi-byte UTF-8 character using bytes from a Buffer.
function $d5e9082788fdd47b$var$utf8FillLast(buf) {
    var p = this.lastTotal - this.lastNeed;
    var r = $d5e9082788fdd47b$var$utf8CheckExtraBytes(this, buf, p);
    if (r !== undefined) return r;
    if (this.lastNeed <= buf.length) {
        buf.copy(this.lastChar, p, 0, this.lastNeed);
        return this.lastChar.toString(this.encoding, 0, this.lastTotal);
    }
    buf.copy(this.lastChar, p, 0, buf.length);
    this.lastNeed -= buf.length;
}
// Returns all complete UTF-8 characters in a Buffer. If the Buffer ended on a
// partial character, the character's bytes are buffered until the required
// number of bytes are available.
function $d5e9082788fdd47b$var$utf8Text(buf, i) {
    var total = $d5e9082788fdd47b$var$utf8CheckIncomplete(this, buf, i);
    if (!this.lastNeed) return buf.toString("utf8", i);
    this.lastTotal = total;
    var end = buf.length - (total - this.lastNeed);
    buf.copy(this.lastChar, 0, end);
    return buf.toString("utf8", i, end);
}
// For UTF-8, a replacement character is added when ending on a partial
// character.
function $d5e9082788fdd47b$var$utf8End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + "\uFFFD";
    return r;
}
// UTF-16LE typically needs two bytes per character, but even if we have an even
// number of bytes available, we need to check if we end on a leading/high
// surrogate. In that case, we need to wait for the next two bytes in order to
// decode the last character properly.
function $d5e9082788fdd47b$var$utf16Text(buf, i) {
    if ((buf.length - i) % 2 === 0) {
        var r = buf.toString("utf16le", i);
        if (r) {
            var c = r.charCodeAt(r.length - 1);
            if (c >= 0xD800 && c <= 0xDBFF) {
                this.lastNeed = 2;
                this.lastTotal = 4;
                this.lastChar[0] = buf[buf.length - 2];
                this.lastChar[1] = buf[buf.length - 1];
                return r.slice(0, -1);
            }
        }
        return r;
    }
    this.lastNeed = 1;
    this.lastTotal = 2;
    this.lastChar[0] = buf[buf.length - 1];
    return buf.toString("utf16le", i, buf.length - 1);
}
// For UTF-16LE we do not explicitly append special replacement characters if we
// end on a partial character, we simply let v8 handle that.
function $d5e9082788fdd47b$var$utf16End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) {
        var end = this.lastTotal - this.lastNeed;
        return r + this.lastChar.toString("utf16le", 0, end);
    }
    return r;
}
function $d5e9082788fdd47b$var$base64Text(buf, i) {
    var n = (buf.length - i) % 3;
    if (n === 0) return buf.toString("base64", i);
    this.lastNeed = 3 - n;
    this.lastTotal = 3;
    if (n === 1) this.lastChar[0] = buf[buf.length - 1];
    else {
        this.lastChar[0] = buf[buf.length - 2];
        this.lastChar[1] = buf[buf.length - 1];
    }
    return buf.toString("base64", i, buf.length - n);
}
function $d5e9082788fdd47b$var$base64End(buf) {
    var r = buf && buf.length ? this.write(buf) : "";
    if (this.lastNeed) return r + this.lastChar.toString("base64", 0, 3 - this.lastNeed);
    return r;
}
// Pass bytes on through for single-byte encodings (e.g. ascii, latin1, hex)
function $d5e9082788fdd47b$var$simpleWrite(buf) {
    return buf.toString(this.encoding);
}
function $d5e9082788fdd47b$var$simpleEnd(buf) {
    return buf && buf.length ? this.write(buf) : "";
}

});


parcelRegister("b7kl8", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a transform stream is a readable/writable stream where you do
// something with the data.  Sometimes it's called a "filter",
// but that's not a great name for it, since that implies a thing where
// some bits pass through, and others are simply ignored.  (That would
// be a valid example of a transform, of course.)
//
// While the output is causally related to the input, it's not a
// necessarily symmetric or synchronous transformation.  For example,
// a zlib stream might take multiple plain-text writes(), and then
// emit a single compressed chunk some time in the future.
//
// Here's how this works:
//
// The Transform stream has all the aspects of the readable and writable
// stream classes.  When you write(chunk), that calls _write(chunk,cb)
// internally, and returns false if there's a lot of pending writes
// buffered up.  When you call read(), that calls _read(n) until
// there's enough pending readable data buffered up.
//
// In a transform stream, the written data is placed in a buffer.  When
// _read(n) is called, it transforms the queued up data, calling the
// buffered _write cb's as it consumes chunks.  If consuming a single
// written chunk would result in multiple output chunks, then the first
// outputted bit calls the readcb, and subsequent chunks just go into
// the read buffer, and will cause it to emit 'readable' if necessary.
//
// This way, back-pressure is actually determined by the reading side,
// since _read has to be called to start processing a new chunk.  However,
// a pathological inflate type of transform can cause excessive buffering
// here.  For example, imagine a stream where every byte of input is
// interpreted as an integer from 0-255, and then results in that many
// bytes of output.  Writing the 4 bytes {ff,ff,ff,ff} would result in
// 1kb of data being output.  In this case, you could write a very small
// amount of input, and end up with a very large amount of output.  In
// such a pathological inflating mechanism, there'd be no way to tell
// the system to stop doing the transform.  A single 4MB write could
// cause the system to run out of memory.
//
// However, even in such a pathological case, only a single written chunk
// would be consumed, and then the rest would wait (un-transformed) until
// the results of the previous transformed chunk were consumed.
"use strict";
module.exports = $8180203f7f0d3074$var$Transform;

var $DwJuQ = parcelRequire("DwJuQ");

/*<replacement>*/ var $8180203f7f0d3074$var$util = Object.create((parcelRequire("dH2Jp")));

$8180203f7f0d3074$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $8180203f7f0d3074$var$util.inherits($8180203f7f0d3074$var$Transform, $DwJuQ);
function $8180203f7f0d3074$var$afterTransform(er, data) {
    var ts = this._transformState;
    ts.transforming = false;
    var cb = ts.writecb;
    if (!cb) return this.emit("error", new Error("write callback called multiple times"));
    ts.writechunk = null;
    ts.writecb = null;
    if (data != null) this.push(data);
    cb(er);
    var rs = this._readableState;
    rs.reading = false;
    if (rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
}
function $8180203f7f0d3074$var$Transform(options) {
    if (!(this instanceof $8180203f7f0d3074$var$Transform)) return new $8180203f7f0d3074$var$Transform(options);
    $DwJuQ.call(this, options);
    this._transformState = {
        afterTransform: $8180203f7f0d3074$var$afterTransform.bind(this),
        needTransform: false,
        transforming: false,
        writecb: null,
        writechunk: null,
        writeencoding: null
    };
    // start out asking for a readable event once data is transformed.
    this._readableState.needReadable = true;
    // we have implemented the _read method, and done the other things
    // that Readable wants before the first _read call, so unset the
    // sync guard flag.
    this._readableState.sync = false;
    if (options) {
        if (typeof options.transform === "function") this._transform = options.transform;
        if (typeof options.flush === "function") this._flush = options.flush;
    }
    // When the writable side finishes, then flush out anything remaining.
    this.on("prefinish", $8180203f7f0d3074$var$prefinish);
}
function $8180203f7f0d3074$var$prefinish() {
    var _this = this;
    if (typeof this._flush === "function") this._flush(function(er, data) {
        $8180203f7f0d3074$var$done(_this, er, data);
    });
    else $8180203f7f0d3074$var$done(this, null, null);
}
$8180203f7f0d3074$var$Transform.prototype.push = function(chunk, encoding) {
    this._transformState.needTransform = false;
    return $DwJuQ.prototype.push.call(this, chunk, encoding);
};
// This is the part where you do stuff!
// override this function in implementation classes.
// 'chunk' is an input chunk.
//
// Call `push(newChunk)` to pass along transformed output
// to the readable side.  You may call 'push' zero or more times.
//
// Call `cb(err)` when you are done with this chunk.  If you pass
// an error, then that'll put the hurt on the whole operation.  If you
// never call cb(), then you'll never get another chunk.
$8180203f7f0d3074$var$Transform.prototype._transform = function(chunk, encoding, cb) {
    throw new Error("_transform() is not implemented");
};
$8180203f7f0d3074$var$Transform.prototype._write = function(chunk, encoding, cb) {
    var ts = this._transformState;
    ts.writecb = cb;
    ts.writechunk = chunk;
    ts.writeencoding = encoding;
    if (!ts.transforming) {
        var rs = this._readableState;
        if (ts.needTransform || rs.needReadable || rs.length < rs.highWaterMark) this._read(rs.highWaterMark);
    }
};
// Doesn't matter what the args are here.
// _transform does all the work.
// That we got here means that the readable side wants more data.
$8180203f7f0d3074$var$Transform.prototype._read = function(n) {
    var ts = this._transformState;
    if (ts.writechunk !== null && ts.writecb && !ts.transforming) {
        ts.transforming = true;
        this._transform(ts.writechunk, ts.writeencoding, ts.afterTransform);
    } else // mark that we need a transform, so that any data that comes in
    // will get processed, now that we've asked for it.
    ts.needTransform = true;
};
$8180203f7f0d3074$var$Transform.prototype._destroy = function(err, cb) {
    var _this2 = this;
    $DwJuQ.prototype._destroy.call(this, err, function(err2) {
        cb(err2);
        _this2.emit("close");
    });
};
function $8180203f7f0d3074$var$done(stream, er, data) {
    if (er) return stream.emit("error", er);
    if (data != null) stream.push(data);
    // if there's nothing in the write buffer, then that means
    // that nothing more will ever be provided
    if (stream._writableState.length) throw new Error("Calling transform done when ws.length != 0");
    if (stream._transformState.transforming) throw new Error("Calling transform done when still transforming");
    return stream.push(null);
}

});

parcelRegister("4wWcs", function(module, exports) {
// Copyright Joyent, Inc. and other Node contributors.
//
// Permission is hereby granted, free of charge, to any person obtaining a
// copy of this software and associated documentation files (the
// "Software"), to deal in the Software without restriction, including
// without limitation the rights to use, copy, modify, merge, publish,
// distribute, sublicense, and/or sell copies of the Software, and to permit
// persons to whom the Software is furnished to do so, subject to the
// following conditions:
//
// The above copyright notice and this permission notice shall be included
// in all copies or substantial portions of the Software.
//
// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
// USE OR OTHER DEALINGS IN THE SOFTWARE.
// a passthrough stream.
// basically just the most minimal sort of Transform stream.
// Every written chunk gets output as-is.
"use strict";
module.exports = $34c74be520d619f2$var$PassThrough;

var $b7kl8 = parcelRequire("b7kl8");

/*<replacement>*/ var $34c74be520d619f2$var$util = Object.create((parcelRequire("dH2Jp")));

$34c74be520d619f2$var$util.inherits = (parcelRequire("dlqwk"));
/*</replacement>*/ $34c74be520d619f2$var$util.inherits($34c74be520d619f2$var$PassThrough, $b7kl8);
function $34c74be520d619f2$var$PassThrough(options) {
    if (!(this instanceof $34c74be520d619f2$var$PassThrough)) return new $34c74be520d619f2$var$PassThrough(options);
    $b7kl8.call(this, options);
}
$34c74be520d619f2$var$PassThrough.prototype._transform = function(chunk, encoding, cb) {
    cb(null, chunk);
};

});


parcelRegister("dEXSZ", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this._strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // '0' - '9'
        if (c >= 48 && c <= 57) return c - 48;
        else if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else assert(false, "Invalid character in " + string);
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this._strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var b = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) b = c - 49 + 0xa;
            else if (c >= 17) b = c - 17 + 0xa;
            else b = c;
            assert(c >= 0 && b < mul, "Invalid character");
            r += b;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this._strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    function move(dest, src) {
        dest.words = src.words;
        dest.length = src.length;
        dest.negative = src.negative;
        dest.red = src.red;
    }
    BN.prototype._move = function _move(dest) {
        move(dest, this);
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype._strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    // Check Symbol.for because not everywhere where Symbol defined
    // See https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Symbol#Browser_compatibility
    if (typeof Symbol !== "undefined" && typeof Symbol.for === "function") try {
        BN.prototype[Symbol.for("nodejs.util.inspect.custom")] = inspect;
    } catch (e) {
        BN.prototype.inspect = inspect;
    }
    else BN.prototype.inspect = inspect;
    function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    }
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modrn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16, 2);
    };
    if (Buffer) BN.prototype.toBuffer = function toBuffer(endian, length) {
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    var allocate = function allocate(ArrayType, size) {
        if (ArrayType.allocUnsafe) return ArrayType.allocUnsafe(size);
        return new ArrayType(size);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        this._strip();
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        var res = allocate(ArrayType, reqLength);
        var postfix = endian === "le" ? "LE" : "BE";
        this["_toArrayLike" + postfix](res, byteLength);
        return res;
    };
    BN.prototype._toArrayLikeLE = function _toArrayLikeLE(res, byteLength) {
        var position = 0;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position++] = word & 0xff;
            if (position < res.length) res[position++] = word >> 8 & 0xff;
            if (position < res.length) res[position++] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position < res.length) res[position++] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position < res.length) {
            res[position++] = carry;
            while(position < res.length)res[position++] = 0;
        }
    };
    BN.prototype._toArrayLikeBE = function _toArrayLikeBE(res, byteLength) {
        var position = res.length - 1;
        var carry = 0;
        for(var i = 0, shift = 0; i < this.length; i++){
            var word = this.words[i] << shift | carry;
            res[position--] = word & 0xff;
            if (position >= 0) res[position--] = word >> 8 & 0xff;
            if (position >= 0) res[position--] = word >> 16 & 0xff;
            if (shift === 6) {
                if (position >= 0) res[position--] = word >> 24 & 0xff;
                carry = 0;
                shift = 0;
            } else {
                carry = word >>> 24;
                shift += 2;
            }
        }
        if (position >= 0) {
            res[position--] = carry;
            while(position >= 0)res[position--] = 0;
        }
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = num.words[off] >>> wbit & 0x01;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this._strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this._strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this._strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this._strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this._strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this._strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out._strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out._strip();
    }
    function jumboMulTo(self, num, out) {
        // Temporary disable, see https://github.com/indutny/bn.js/issues/211
        // var fftm = new FFTM();
        // return fftm.mulp(self, num, out);
        return bigMulTo(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out._strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this._strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this._strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this._strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) <= num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this._strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this._strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this._strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q._strip();
        a._strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modrn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modrn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modrn = function modrn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return isNegNum ? -acc : acc;
    };
    // WARNING: DEPRECATED
    BN.prototype.modn = function modn(num) {
        return this.modrn(num);
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        var isNegNum = num < 0;
        if (isNegNum) num = -num;
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        this._strip();
        return isNegNum ? this.ineg() : this;
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this._strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is a BN v4 instance
        r.strip();
        else // r is a BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        move(a, a.umod(this.m)._forceRed(this));
        return a;
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("9qVGS", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("8fBln", function(module, exports) {

var $10gXo = parcelRequire("10gXo");

var $dlqwk = parcelRequire("dlqwk");
var $601cb1289d0f28d5$var$api = module.exports;
$601cb1289d0f28d5$var$api.define = function define(name, body) {
    return new $601cb1289d0f28d5$var$Entity(name, body);
};
function $601cb1289d0f28d5$var$Entity(name, body) {
    this.name = name;
    this.body = body;
    this.decoders = {};
    this.encoders = {};
}

$601cb1289d0f28d5$var$Entity.prototype._createNamed = function createNamed(base) {
    var named;
    try {
        named = (parcelRequire("aeJDW")).runInThisContext("(function " + this.name + "(entity) {\n" + "  this._initNamed(entity);\n" + "})");
    } catch (e) {
        named = function(entity) {
            this._initNamed(entity);
        };
    }
    $dlqwk(named, base);
    named.prototype._initNamed = function initnamed(entity) {
        base.call(this, entity);
    };
    return new named(this);
};
$601cb1289d0f28d5$var$Entity.prototype._getDecoder = function _getDecoder(enc) {
    enc = enc || "der";
    // Lazily create decoder
    if (!this.decoders.hasOwnProperty(enc)) this.decoders[enc] = this._createNamed($10gXo.decoders[enc]);
    return this.decoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.decode = function decode(data, enc, options) {
    return this._getDecoder(enc).decode(data, options);
};
$601cb1289d0f28d5$var$Entity.prototype._getEncoder = function _getEncoder(enc) {
    enc = enc || "der";
    // Lazily create encoder
    if (!this.encoders.hasOwnProperty(enc)) this.encoders[enc] = this._createNamed($10gXo.encoders[enc]);
    return this.encoders[enc];
};
$601cb1289d0f28d5$var$Entity.prototype.encode = function encode(data, enc, /* internal */ reporter) {
    return this._getEncoder(enc).encode(data, reporter);
};

});
parcelRegister("10gXo", function(module, exports) {
var $0bb2f1d33a97833b$var$asn1 = module.exports;

$0bb2f1d33a97833b$var$asn1.bignum = (parcelRequire("9qVGS"));

$0bb2f1d33a97833b$var$asn1.define = (parcelRequire("8fBln")).define;

$0bb2f1d33a97833b$var$asn1.base = (parcelRequire("5JhaY"));

$0bb2f1d33a97833b$var$asn1.constants = (parcelRequire("3TcQc"));

$0bb2f1d33a97833b$var$asn1.decoders = (parcelRequire("89TTw"));

$0bb2f1d33a97833b$var$asn1.encoders = (parcelRequire("ljw8S"));

});
parcelRegister("5JhaY", function(module, exports) {
var $42be7a86790be210$var$base = module.exports;

$42be7a86790be210$var$base.Reporter = (parcelRequire("k2jVB")).Reporter;

$42be7a86790be210$var$base.DecoderBuffer = (parcelRequire("33sbF")).DecoderBuffer;

$42be7a86790be210$var$base.EncoderBuffer = (parcelRequire("33sbF")).EncoderBuffer;

$42be7a86790be210$var$base.Node = (parcelRequire("h4y6g"));

});
parcelRegister("k2jVB", function(module, exports) {

$parcel$export(module.exports, "Reporter", () => $e96373d85f7a5083$export$957313a2f485e5ed, (v) => $e96373d85f7a5083$export$957313a2f485e5ed = v);
var $e96373d85f7a5083$export$957313a2f485e5ed;

var $dlqwk = parcelRequire("dlqwk");
function $e96373d85f7a5083$var$Reporter(options) {
    this._reporterState = {
        obj: null,
        path: [],
        options: options || {},
        errors: []
    };
}
$e96373d85f7a5083$export$957313a2f485e5ed = $e96373d85f7a5083$var$Reporter;
$e96373d85f7a5083$var$Reporter.prototype.isError = function isError(obj) {
    return obj instanceof $e96373d85f7a5083$var$ReporterError;
};
$e96373d85f7a5083$var$Reporter.prototype.save = function save() {
    var state = this._reporterState;
    return {
        obj: state.obj,
        pathLen: state.path.length
    };
};
$e96373d85f7a5083$var$Reporter.prototype.restore = function restore(data) {
    var state = this._reporterState;
    state.obj = data.obj;
    state.path = state.path.slice(0, data.pathLen);
};
$e96373d85f7a5083$var$Reporter.prototype.enterKey = function enterKey(key) {
    return this._reporterState.path.push(key);
};
$e96373d85f7a5083$var$Reporter.prototype.exitKey = function exitKey(index) {
    var state = this._reporterState;
    state.path = state.path.slice(0, index - 1);
};
$e96373d85f7a5083$var$Reporter.prototype.leaveKey = function leaveKey(index, key, value) {
    var state = this._reporterState;
    this.exitKey(index);
    if (state.obj !== null) state.obj[key] = value;
};
$e96373d85f7a5083$var$Reporter.prototype.path = function path() {
    return this._reporterState.path.join("/");
};
$e96373d85f7a5083$var$Reporter.prototype.enterObject = function enterObject() {
    var state = this._reporterState;
    var prev = state.obj;
    state.obj = {};
    return prev;
};
$e96373d85f7a5083$var$Reporter.prototype.leaveObject = function leaveObject(prev) {
    var state = this._reporterState;
    var now = state.obj;
    state.obj = prev;
    return now;
};
$e96373d85f7a5083$var$Reporter.prototype.error = function error(msg) {
    var err;
    var state = this._reporterState;
    var inherited = msg instanceof $e96373d85f7a5083$var$ReporterError;
    if (inherited) err = msg;
    else err = new $e96373d85f7a5083$var$ReporterError(state.path.map(function(elem) {
        return "[" + JSON.stringify(elem) + "]";
    }).join(""), msg.message || msg, msg.stack);
    if (!state.options.partial) throw err;
    if (!inherited) state.errors.push(err);
    return err;
};
$e96373d85f7a5083$var$Reporter.prototype.wrapResult = function wrapResult(result) {
    var state = this._reporterState;
    if (!state.options.partial) return result;
    return {
        result: this.isError(result) ? null : result,
        errors: state.errors
    };
};
function $e96373d85f7a5083$var$ReporterError(path, msg) {
    this.path = path;
    this.rethrow(msg);
}
$dlqwk($e96373d85f7a5083$var$ReporterError, Error);
$e96373d85f7a5083$var$ReporterError.prototype.rethrow = function rethrow(msg) {
    this.message = msg + " at: " + (this.path || "(shallow)");
    if (Error.captureStackTrace) Error.captureStackTrace(this, $e96373d85f7a5083$var$ReporterError);
    if (!this.stack) try {
        // IE only adds stack when thrown
        throw new Error(this.message);
    } catch (e) {
        this.stack = e.stack;
    }
    return this;
};

});

parcelRegister("33sbF", function(module, exports) {

$parcel$export(module.exports, "DecoderBuffer", () => $2397844df508f52e$export$bf9f79cdc4a49163, (v) => $2397844df508f52e$export$bf9f79cdc4a49163 = v);
$parcel$export(module.exports, "EncoderBuffer", () => $2397844df508f52e$export$8ff24f7760c7a78e, (v) => $2397844df508f52e$export$8ff24f7760c7a78e = v);
var $2397844df508f52e$export$bf9f79cdc4a49163;
var $2397844df508f52e$export$8ff24f7760c7a78e;

var $dlqwk = parcelRequire("dlqwk");

var $5JhaY = parcelRequire("5JhaY");
var $2397844df508f52e$require$Reporter = $5JhaY.Reporter;

var $6ZWSX = parcelRequire("6ZWSX");
var $2397844df508f52e$require$Buffer = $6ZWSX.Buffer;
function $2397844df508f52e$var$DecoderBuffer(base, options) {
    $2397844df508f52e$require$Reporter.call(this, options);
    if (!$2397844df508f52e$require$Buffer.isBuffer(base)) {
        this.error("Input not Buffer");
        return;
    }
    this.base = base;
    this.offset = 0;
    this.length = base.length;
}
$dlqwk($2397844df508f52e$var$DecoderBuffer, $2397844df508f52e$require$Reporter);
$2397844df508f52e$export$bf9f79cdc4a49163 = $2397844df508f52e$var$DecoderBuffer;
$2397844df508f52e$var$DecoderBuffer.prototype.save = function save() {
    return {
        offset: this.offset,
        reporter: $2397844df508f52e$require$Reporter.prototype.save.call(this)
    };
};
$2397844df508f52e$var$DecoderBuffer.prototype.restore = function restore(save) {
    // Return skipped data
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    res.offset = save.offset;
    res.length = this.offset;
    this.offset = save.offset;
    $2397844df508f52e$require$Reporter.prototype.restore.call(this, save.reporter);
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.isEmpty = function isEmpty() {
    return this.offset === this.length;
};
$2397844df508f52e$var$DecoderBuffer.prototype.readUInt8 = function readUInt8(fail) {
    if (this.offset + 1 <= this.length) return this.base.readUInt8(this.offset++, true);
    else return this.error(fail || "DecoderBuffer overrun");
};
$2397844df508f52e$var$DecoderBuffer.prototype.skip = function skip(bytes, fail) {
    if (!(this.offset + bytes <= this.length)) return this.error(fail || "DecoderBuffer overrun");
    var res = new $2397844df508f52e$var$DecoderBuffer(this.base);
    // Share reporter state
    res._reporterState = this._reporterState;
    res.offset = this.offset;
    res.length = this.offset + bytes;
    this.offset += bytes;
    return res;
};
$2397844df508f52e$var$DecoderBuffer.prototype.raw = function raw(save) {
    return this.base.slice(save ? save.offset : this.offset, this.length);
};
function $2397844df508f52e$var$EncoderBuffer(value, reporter) {
    if (Array.isArray(value)) {
        this.length = 0;
        this.value = value.map(function(item) {
            if (!(item instanceof $2397844df508f52e$var$EncoderBuffer)) item = new $2397844df508f52e$var$EncoderBuffer(item, reporter);
            this.length += item.length;
            return item;
        }, this);
    } else if (typeof value === "number") {
        if (!(0 <= value && value <= 0xff)) return reporter.error("non-byte EncoderBuffer value");
        this.value = value;
        this.length = 1;
    } else if (typeof value === "string") {
        this.value = value;
        this.length = $2397844df508f52e$require$Buffer.byteLength(value);
    } else if ($2397844df508f52e$require$Buffer.isBuffer(value)) {
        this.value = value;
        this.length = value.length;
    } else return reporter.error("Unsupported type: " + typeof value);
}
$2397844df508f52e$export$8ff24f7760c7a78e = $2397844df508f52e$var$EncoderBuffer;
$2397844df508f52e$var$EncoderBuffer.prototype.join = function join(out, offset) {
    if (!out) out = new $2397844df508f52e$require$Buffer(this.length);
    if (!offset) offset = 0;
    if (this.length === 0) return out;
    if (Array.isArray(this.value)) this.value.forEach(function(item) {
        item.join(out, offset);
        offset += item.length;
    });
    else {
        if (typeof this.value === "number") out[offset] = this.value;
        else if (typeof this.value === "string") out.write(this.value, offset);
        else if ($2397844df508f52e$require$Buffer.isBuffer(this.value)) this.value.copy(out, offset);
        offset += this.length;
    }
    return out;
};

});

parcelRegister("h4y6g", function(module, exports) {

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$Reporter = $5JhaY.Reporter;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$EncoderBuffer = $5JhaY.EncoderBuffer;

var $5JhaY = parcelRequire("5JhaY");
var $c6dd42f3395d566f$require$DecoderBuffer = $5JhaY.DecoderBuffer;

var $koC21 = parcelRequire("koC21");
// Supported tags
var $c6dd42f3395d566f$var$tags = [
    "seq",
    "seqof",
    "set",
    "setof",
    "objid",
    "bool",
    "gentime",
    "utctime",
    "null_",
    "enum",
    "int",
    "objDesc",
    "bitstr",
    "bmpstr",
    "charstr",
    "genstr",
    "graphstr",
    "ia5str",
    "iso646str",
    "numstr",
    "octstr",
    "printstr",
    "t61str",
    "unistr",
    "utf8str",
    "videostr"
];
// Public methods list
var $c6dd42f3395d566f$var$methods = [
    "key",
    "obj",
    "use",
    "optional",
    "explicit",
    "implicit",
    "def",
    "choice",
    "any",
    "contains"
].concat($c6dd42f3395d566f$var$tags);
// Overrided methods list
var $c6dd42f3395d566f$var$overrided = [
    "_peekTag",
    "_decodeTag",
    "_use",
    "_decodeStr",
    "_decodeObjid",
    "_decodeTime",
    "_decodeNull",
    "_decodeInt",
    "_decodeBool",
    "_decodeList",
    "_encodeComposite",
    "_encodeStr",
    "_encodeObjid",
    "_encodeTime",
    "_encodeNull",
    "_encodeInt",
    "_encodeBool"
];
function $c6dd42f3395d566f$var$Node(enc, parent) {
    var state = {};
    this._baseState = state;
    state.enc = enc;
    state.parent = parent || null;
    state.children = null;
    // State
    state.tag = null;
    state.args = null;
    state.reverseArgs = null;
    state.choice = null;
    state.optional = false;
    state.any = false;
    state.obj = false;
    state.use = null;
    state.useDecoder = null;
    state.key = null;
    state["default"] = null;
    state.explicit = null;
    state.implicit = null;
    state.contains = null;
    // Should create new instance on each method
    if (!state.parent) {
        state.children = [];
        this._wrap();
    }
}
module.exports = $c6dd42f3395d566f$var$Node;
var $c6dd42f3395d566f$var$stateProps = [
    "enc",
    "parent",
    "children",
    "tag",
    "args",
    "reverseArgs",
    "choice",
    "optional",
    "any",
    "obj",
    "use",
    "alteredUse",
    "key",
    "default",
    "explicit",
    "implicit",
    "contains"
];
$c6dd42f3395d566f$var$Node.prototype.clone = function clone() {
    var state = this._baseState;
    var cstate = {};
    $c6dd42f3395d566f$var$stateProps.forEach(function(prop) {
        cstate[prop] = state[prop];
    });
    var res = new this.constructor(cstate.parent);
    res._baseState = cstate;
    return res;
};
$c6dd42f3395d566f$var$Node.prototype._wrap = function wrap() {
    var state = this._baseState;
    $c6dd42f3395d566f$var$methods.forEach(function(method) {
        this[method] = function _wrappedMethod() {
            var clone = new this.constructor(this);
            state.children.push(clone);
            return clone[method].apply(clone, arguments);
        };
    }, this);
};
$c6dd42f3395d566f$var$Node.prototype._init = function init(body) {
    var state = this._baseState;
    $koC21(state.parent === null);
    body.call(this);
    // Filter children
    state.children = state.children.filter(function(child) {
        return child._baseState.parent === this;
    }, this);
    $koC21.equal(state.children.length, 1, "Root node can have only one child");
};
$c6dd42f3395d566f$var$Node.prototype._useArgs = function useArgs(args) {
    var state = this._baseState;
    // Filter children and args
    var children = args.filter(function(arg) {
        return arg instanceof this.constructor;
    }, this);
    args = args.filter(function(arg) {
        return !(arg instanceof this.constructor);
    }, this);
    if (children.length !== 0) {
        $koC21(state.children === null);
        state.children = children;
        // Replace parent to maintain backward link
        children.forEach(function(child) {
            child._baseState.parent = this;
        }, this);
    }
    if (args.length !== 0) {
        $koC21(state.args === null);
        state.args = args;
        state.reverseArgs = args.map(function(arg) {
            if (typeof arg !== "object" || arg.constructor !== Object) return arg;
            var res = {};
            Object.keys(arg).forEach(function(key) {
                if (key == (key | 0)) key |= 0;
                var value = arg[key];
                res[value] = key;
            });
            return res;
        });
    }
};
//
// Overrided methods
//
$c6dd42f3395d566f$var$overrided.forEach(function(method) {
    $c6dd42f3395d566f$var$Node.prototype[method] = function _overrided() {
        var state = this._baseState;
        throw new Error(method + " not implemented for encoding: " + state.enc);
    };
});
//
// Public methods
//
$c6dd42f3395d566f$var$tags.forEach(function(tag) {
    $c6dd42f3395d566f$var$Node.prototype[tag] = function _tagMethod() {
        var state = this._baseState;
        var args = Array.prototype.slice.call(arguments);
        $koC21(state.tag === null);
        state.tag = tag;
        this._useArgs(args);
        return this;
    };
});
$c6dd42f3395d566f$var$Node.prototype.use = function use(item) {
    $koC21(item);
    var state = this._baseState;
    $koC21(state.use === null);
    state.use = item;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.optional = function optional() {
    var state = this._baseState;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.def = function def(val) {
    var state = this._baseState;
    $koC21(state["default"] === null);
    state["default"] = val;
    state.optional = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.explicit = function explicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.explicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.implicit = function implicit(num) {
    var state = this._baseState;
    $koC21(state.explicit === null && state.implicit === null);
    state.implicit = num;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.obj = function obj() {
    var state = this._baseState;
    var args = Array.prototype.slice.call(arguments);
    state.obj = true;
    if (args.length !== 0) this._useArgs(args);
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.key = function key(newKey) {
    var state = this._baseState;
    $koC21(state.key === null);
    state.key = newKey;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.any = function any() {
    var state = this._baseState;
    state.any = true;
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.choice = function choice(obj) {
    var state = this._baseState;
    $koC21(state.choice === null);
    state.choice = obj;
    this._useArgs(Object.keys(obj).map(function(key) {
        return obj[key];
    }));
    return this;
};
$c6dd42f3395d566f$var$Node.prototype.contains = function contains(item) {
    var state = this._baseState;
    $koC21(state.use === null);
    state.contains = item;
    return this;
};
//
// Decoding
//
$c6dd42f3395d566f$var$Node.prototype._decode = function decode(input, options) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return input.wrapResult(state.children[0]._decode(input, options));
    var result = state["default"];
    var present = true;
    var prevKey = null;
    if (state.key !== null) prevKey = input.enterKey(state.key);
    // Check if tag is there
    if (state.optional) {
        var tag = null;
        if (state.explicit !== null) tag = state.explicit;
        else if (state.implicit !== null) tag = state.implicit;
        else if (state.tag !== null) tag = state.tag;
        if (tag === null && !state.any) {
            // Trial and Error
            var save = input.save();
            try {
                if (state.choice === null) this._decodeGeneric(state.tag, input, options);
                else this._decodeChoice(input, options);
                present = true;
            } catch (e) {
                present = false;
            }
            input.restore(save);
        } else {
            present = this._peekTag(input, tag, state.any);
            if (input.isError(present)) return present;
        }
    }
    // Push object on stack
    var prevObj;
    if (state.obj && present) prevObj = input.enterObject();
    if (present) {
        // Unwrap explicit values
        if (state.explicit !== null) {
            var explicit = this._decodeTag(input, state.explicit);
            if (input.isError(explicit)) return explicit;
            input = explicit;
        }
        var start = input.offset;
        // Unwrap implicit and normal values
        if (state.use === null && state.choice === null) {
            if (state.any) var save = input.save();
            var body = this._decodeTag(input, state.implicit !== null ? state.implicit : state.tag, state.any);
            if (input.isError(body)) return body;
            if (state.any) result = input.raw(save);
            else input = body;
        }
        if (options && options.track && state.tag !== null) options.track(input.path(), start, input.length, "tagged");
        if (options && options.track && state.tag !== null) options.track(input.path(), input.offset, input.length, "content");
        // Select proper method for tag
        if (state.any) result;
        else if (state.choice === null) result = this._decodeGeneric(state.tag, input, options);
        else result = this._decodeChoice(input, options);
        if (input.isError(result)) return result;
        // Decode children
        if (!state.any && state.choice === null && state.children !== null) state.children.forEach(function decodeChildren(child) {
            // NOTE: We are ignoring errors here, to let parser continue with other
            // parts of encoded data
            child._decode(input, options);
        });
        // Decode contained/encoded by schema, only in bit or octet strings
        if (state.contains && (state.tag === "octstr" || state.tag === "bitstr")) {
            var data = new $c6dd42f3395d566f$require$DecoderBuffer(result);
            result = this._getUse(state.contains, input._reporterState.obj)._decode(data, options);
        }
    }
    // Pop object
    if (state.obj && present) result = input.leaveObject(prevObj);
    // Set key
    if (state.key !== null && (result !== null || present === true)) input.leaveKey(prevKey, state.key, result);
    else if (prevKey !== null) input.exitKey(prevKey);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._decodeGeneric = function decodeGeneric(tag, input, options) {
    var state = this._baseState;
    if (tag === "seq" || tag === "set") return null;
    if (tag === "seqof" || tag === "setof") return this._decodeList(input, tag, state.args[0], options);
    else if (/str$/.test(tag)) return this._decodeStr(input, tag, options);
    else if (tag === "objid" && state.args) return this._decodeObjid(input, state.args[0], state.args[1], options);
    else if (tag === "objid") return this._decodeObjid(input, null, null, options);
    else if (tag === "gentime" || tag === "utctime") return this._decodeTime(input, tag, options);
    else if (tag === "null_") return this._decodeNull(input, options);
    else if (tag === "bool") return this._decodeBool(input, options);
    else if (tag === "objDesc") return this._decodeStr(input, tag, options);
    else if (tag === "int" || tag === "enum") return this._decodeInt(input, state.args && state.args[0], options);
    if (state.use !== null) return this._getUse(state.use, input._reporterState.obj)._decode(input, options);
    else return input.error("unknown tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._getUse = function _getUse(entity, obj) {
    var state = this._baseState;
    // Create altered use decoder if implicit is set
    state.useDecoder = this._use(entity, obj);
    $koC21(state.useDecoder._baseState.parent === null);
    state.useDecoder = state.useDecoder._baseState.children[0];
    if (state.implicit !== state.useDecoder._baseState.implicit) {
        state.useDecoder = state.useDecoder.clone();
        state.useDecoder._baseState.implicit = state.implicit;
    }
    return state.useDecoder;
};
$c6dd42f3395d566f$var$Node.prototype._decodeChoice = function decodeChoice(input, options) {
    var state = this._baseState;
    var result = null;
    var match = false;
    Object.keys(state.choice).some(function(key) {
        var save = input.save();
        var node = state.choice[key];
        try {
            var value = node._decode(input, options);
            if (input.isError(value)) return false;
            result = {
                type: key,
                value: value
            };
            match = true;
        } catch (e) {
            input.restore(save);
            return false;
        }
        return true;
    }, this);
    if (!match) return input.error("Choice not matched");
    return result;
};
//
// Encoding
//
$c6dd42f3395d566f$var$Node.prototype._createEncoderBuffer = function createEncoderBuffer(data) {
    return new $c6dd42f3395d566f$require$EncoderBuffer(data, this.reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encode = function encode(data, reporter, parent) {
    var state = this._baseState;
    if (state["default"] !== null && state["default"] === data) return;
    var result = this._encodeValue(data, reporter, parent);
    if (result === undefined) return;
    if (this._skipDefault(result, reporter, parent)) return;
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeValue = function encode(data, reporter, parent) {
    var state = this._baseState;
    // Decode root node
    if (state.parent === null) return state.children[0]._encode(data, reporter || new $c6dd42f3395d566f$require$Reporter());
    var result = null;
    // Set reporter to share it with a child class
    this.reporter = reporter;
    // Check if data is there
    if (state.optional && data === undefined) {
        if (state["default"] !== null) data = state["default"];
        else return;
    }
    // Encode children first
    var content = null;
    var primitive = false;
    if (state.any) // Anything that was given is translated to buffer
    result = this._createEncoderBuffer(data);
    else if (state.choice) result = this._encodeChoice(data, reporter);
    else if (state.contains) {
        content = this._getUse(state.contains, parent)._encode(data, reporter);
        primitive = true;
    } else if (state.children) {
        content = state.children.map(function(child) {
            if (child._baseState.tag === "null_") return child._encode(null, reporter, data);
            if (child._baseState.key === null) return reporter.error("Child should have a key");
            var prevKey = reporter.enterKey(child._baseState.key);
            if (typeof data !== "object") return reporter.error("Child expected, but input is not object");
            var res = child._encode(data[child._baseState.key], reporter, data);
            reporter.leaveKey(prevKey);
            return res;
        }, this).filter(function(child) {
            return child;
        });
        content = this._createEncoderBuffer(content);
    } else {
        if (state.tag === "seqof" || state.tag === "setof") {
            // TODO(indutny): this should be thrown on DSL level
            if (!(state.args && state.args.length === 1)) return reporter.error("Too many args for : " + state.tag);
            if (!Array.isArray(data)) return reporter.error("seqof/setof, but data is not Array");
            var child = this.clone();
            child._baseState.implicit = null;
            content = this._createEncoderBuffer(data.map(function(item) {
                var state = this._baseState;
                return this._getUse(state.args[0], data)._encode(item, reporter);
            }, child));
        } else if (state.use !== null) result = this._getUse(state.use, parent)._encode(data, reporter);
        else {
            content = this._encodePrimitive(state.tag, data);
            primitive = true;
        }
    }
    // Encode data itself
    var result;
    if (!state.any && state.choice === null) {
        var tag = state.implicit !== null ? state.implicit : state.tag;
        var cls = state.implicit === null ? "universal" : "context";
        if (tag === null) {
            if (state.use === null) reporter.error("Tag could be omitted only for .use()");
        } else if (state.use === null) result = this._encodeComposite(tag, primitive, cls, content);
    }
    // Wrap in explicit
    if (state.explicit !== null) result = this._encodeComposite(state.explicit, false, "context", result);
    return result;
};
$c6dd42f3395d566f$var$Node.prototype._encodeChoice = function encodeChoice(data, reporter) {
    var state = this._baseState;
    var node = state.choice[data.type];
    if (!node) $koC21(false, data.type + " not found in " + JSON.stringify(Object.keys(state.choice)));
    return node._encode(data.value, reporter);
};
$c6dd42f3395d566f$var$Node.prototype._encodePrimitive = function encodePrimitive(tag, data) {
    var state = this._baseState;
    if (/str$/.test(tag)) return this._encodeStr(data, tag);
    else if (tag === "objid" && state.args) return this._encodeObjid(data, state.reverseArgs[0], state.args[1]);
    else if (tag === "objid") return this._encodeObjid(data, null, null);
    else if (tag === "gentime" || tag === "utctime") return this._encodeTime(data, tag);
    else if (tag === "null_") return this._encodeNull();
    else if (tag === "int" || tag === "enum") return this._encodeInt(data, state.args && state.reverseArgs[0]);
    else if (tag === "bool") return this._encodeBool(data);
    else if (tag === "objDesc") return this._encodeStr(data, tag);
    else throw new Error("Unsupported tag: " + tag);
};
$c6dd42f3395d566f$var$Node.prototype._isNumstr = function isNumstr(str) {
    return /^[0-9 ]*$/.test(str);
};
$c6dd42f3395d566f$var$Node.prototype._isPrintstr = function isPrintstr(str) {
    return /^[A-Za-z0-9 '\(\)\+,\-\.\/:=\?]*$/.test(str);
};

});


parcelRegister("3TcQc", function(module, exports) {
var $2d507811e368678d$var$constants = module.exports;
// Helper
$2d507811e368678d$var$constants._reverse = function reverse(map) {
    var res = {};
    Object.keys(map).forEach(function(key) {
        // Convert key to integer if it is stringified
        if ((key | 0) == key) key = key | 0;
        var value = map[key];
        res[value] = key;
    });
    return res;
};

$2d507811e368678d$var$constants.der = (parcelRequire("1G1m0"));

});
parcelRegister("1G1m0", function(module, exports) {

$parcel$export(module.exports, "tagClass", () => $138ac3909863432c$export$3584c46ed60baee8, (v) => $138ac3909863432c$export$3584c46ed60baee8 = v);
$parcel$export(module.exports, "tagClassByName", () => $138ac3909863432c$export$f18596ef8d632e49, (v) => $138ac3909863432c$export$f18596ef8d632e49 = v);
$parcel$export(module.exports, "tag", () => $138ac3909863432c$export$2b067c6666111485, (v) => $138ac3909863432c$export$2b067c6666111485 = v);
$parcel$export(module.exports, "tagByName", () => $138ac3909863432c$export$f17df38a421ab9e3, (v) => $138ac3909863432c$export$f17df38a421ab9e3 = v);
var $138ac3909863432c$export$3584c46ed60baee8;
var $138ac3909863432c$export$f18596ef8d632e49;
var $138ac3909863432c$export$2b067c6666111485;
var $138ac3909863432c$export$f17df38a421ab9e3;

var $3TcQc = parcelRequire("3TcQc");
$138ac3909863432c$export$3584c46ed60baee8 = {
    0: "universal",
    1: "application",
    2: "context",
    3: "private"
};
$138ac3909863432c$export$f18596ef8d632e49 = $3TcQc._reverse($138ac3909863432c$export$3584c46ed60baee8);
$138ac3909863432c$export$2b067c6666111485 = {
    0x00: "end",
    0x01: "bool",
    0x02: "int",
    0x03: "bitstr",
    0x04: "octstr",
    0x05: "null_",
    0x06: "objid",
    0x07: "objDesc",
    0x08: "external",
    0x09: "real",
    0x0a: "enum",
    0x0b: "embed",
    0x0c: "utf8str",
    0x0d: "relativeOid",
    0x10: "seq",
    0x11: "set",
    0x12: "numstr",
    0x13: "printstr",
    0x14: "t61str",
    0x15: "videostr",
    0x16: "ia5str",
    0x17: "utctime",
    0x18: "gentime",
    0x19: "graphstr",
    0x1a: "iso646str",
    0x1b: "genstr",
    0x1c: "unistr",
    0x1d: "charstr",
    0x1e: "bmpstr"
};
$138ac3909863432c$export$f17df38a421ab9e3 = $3TcQc._reverse($138ac3909863432c$export$2b067c6666111485);

});


parcelRegister("89TTw", function(module, exports) {
var $5f0a857a78ce037a$var$decoders = module.exports;

$5f0a857a78ce037a$var$decoders.der = (parcelRequire("fkoHA"));

$5f0a857a78ce037a$var$decoders.pem = (parcelRequire("9wGrq"));

});
parcelRegister("fkoHA", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $10gXo = parcelRequire("10gXo");
var $b28be291c8d179e1$var$base = $10gXo.base;
var $b28be291c8d179e1$var$bignum = $10gXo.bignum;
// Import DER constants
var $b28be291c8d179e1$var$der = $10gXo.constants.der;
function $b28be291c8d179e1$var$DERDecoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $b28be291c8d179e1$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $b28be291c8d179e1$var$DERDecoder;
$b28be291c8d179e1$var$DERDecoder.prototype.decode = function decode(data, options) {
    if (!(data instanceof $b28be291c8d179e1$var$base.DecoderBuffer)) data = new $b28be291c8d179e1$var$base.DecoderBuffer(data, options);
    return this.tree._decode(data, options);
};
// Tree methods
function $b28be291c8d179e1$var$DERNode(parent) {
    $b28be291c8d179e1$var$base.Node.call(this, "der", parent);
}
$dlqwk($b28be291c8d179e1$var$DERNode, $b28be291c8d179e1$var$base.Node);
$b28be291c8d179e1$var$DERNode.prototype._peekTag = function peekTag(buffer, tag, any) {
    if (buffer.isEmpty()) return false;
    var state = buffer.save();
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to peek tag: "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    buffer.restore(state);
    return decodedTag.tag === tag || decodedTag.tagStr === tag || decodedTag.tagStr + "of" === tag || any;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTag = function decodeTag(buffer, tag, any) {
    var decodedTag = $b28be291c8d179e1$var$derDecodeTag(buffer, 'Failed to decode tag of "' + tag + '"');
    if (buffer.isError(decodedTag)) return decodedTag;
    var len = $b28be291c8d179e1$var$derDecodeLen(buffer, decodedTag.primitive, 'Failed to get length of "' + tag + '"');
    // Failure
    if (buffer.isError(len)) return len;
    if (!any && decodedTag.tag !== tag && decodedTag.tagStr !== tag && decodedTag.tagStr + "of" !== tag) return buffer.error('Failed to match tag: "' + tag + '"');
    if (decodedTag.primitive || len !== null) return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
    // Indefinite length... find END tag
    var state = buffer.save();
    var res = this._skipUntilEnd(buffer, 'Failed to skip indefinite length body: "' + this.tag + '"');
    if (buffer.isError(res)) return res;
    len = buffer.offset - state.offset;
    buffer.restore(state);
    return buffer.skip(len, 'Failed to match body of: "' + tag + '"');
};
$b28be291c8d179e1$var$DERNode.prototype._skipUntilEnd = function skipUntilEnd(buffer, fail) {
    while(true){
        var tag = $b28be291c8d179e1$var$derDecodeTag(buffer, fail);
        if (buffer.isError(tag)) return tag;
        var len = $b28be291c8d179e1$var$derDecodeLen(buffer, tag.primitive, fail);
        if (buffer.isError(len)) return len;
        var res;
        if (tag.primitive || len !== null) res = buffer.skip(len);
        else res = this._skipUntilEnd(buffer, fail);
        // Failure
        if (buffer.isError(res)) return res;
        if (tag.tagStr === "end") break;
    }
};
$b28be291c8d179e1$var$DERNode.prototype._decodeList = function decodeList(buffer, tag, decoder, options) {
    var result = [];
    while(!buffer.isEmpty()){
        var possibleEnd = this._peekTag(buffer, "end");
        if (buffer.isError(possibleEnd)) return possibleEnd;
        var res = decoder.decode(buffer, "der", options);
        if (buffer.isError(res) && possibleEnd) break;
        result.push(res);
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeStr = function decodeStr(buffer, tag) {
    if (tag === "bitstr") {
        var unused = buffer.readUInt8();
        if (buffer.isError(unused)) return unused;
        return {
            unused: unused,
            data: buffer.raw()
        };
    } else if (tag === "bmpstr") {
        var raw = buffer.raw();
        if (raw.length % 2 === 1) return buffer.error("Decoding of string type: bmpstr length mismatch");
        var str = "";
        for(var i = 0; i < raw.length / 2; i++)str += String.fromCharCode(raw.readUInt16BE(i * 2));
        return str;
    } else if (tag === "numstr") {
        var numstr = buffer.raw().toString("ascii");
        if (!this._isNumstr(numstr)) return buffer.error("Decoding of string type: numstr unsupported characters");
        return numstr;
    } else if (tag === "octstr") return buffer.raw();
    else if (tag === "objDesc") return buffer.raw();
    else if (tag === "printstr") {
        var printstr = buffer.raw().toString("ascii");
        if (!this._isPrintstr(printstr)) return buffer.error("Decoding of string type: printstr unsupported characters");
        return printstr;
    } else if (/str$/.test(tag)) return buffer.raw().toString();
    else return buffer.error("Decoding of string type: " + tag + " unsupported");
};
$b28be291c8d179e1$var$DERNode.prototype._decodeObjid = function decodeObjid(buffer, values, relative) {
    var result;
    var identifiers = [];
    var ident = 0;
    while(!buffer.isEmpty()){
        var subident = buffer.readUInt8();
        ident <<= 7;
        ident |= subident & 0x7f;
        if ((subident & 0x80) === 0) {
            identifiers.push(ident);
            ident = 0;
        }
    }
    if (subident & 0x80) identifiers.push(ident);
    var first = identifiers[0] / 40 | 0;
    var second = identifiers[0] % 40;
    if (relative) result = identifiers;
    else result = [
        first,
        second
    ].concat(identifiers.slice(1));
    if (values) {
        var tmp = values[result.join(" ")];
        if (tmp === undefined) tmp = values[result.join(".")];
        if (tmp !== undefined) result = tmp;
    }
    return result;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeTime = function decodeTime(buffer, tag) {
    var str = buffer.raw().toString();
    if (tag === "gentime") {
        var year = str.slice(0, 4) | 0;
        var mon = str.slice(4, 6) | 0;
        var day = str.slice(6, 8) | 0;
        var hour = str.slice(8, 10) | 0;
        var min = str.slice(10, 12) | 0;
        var sec = str.slice(12, 14) | 0;
    } else if (tag === "utctime") {
        var year = str.slice(0, 2) | 0;
        var mon = str.slice(2, 4) | 0;
        var day = str.slice(4, 6) | 0;
        var hour = str.slice(6, 8) | 0;
        var min = str.slice(8, 10) | 0;
        var sec = str.slice(10, 12) | 0;
        if (year < 70) year = 2000 + year;
        else year = 1900 + year;
    } else return buffer.error("Decoding " + tag + " time is not supported yet");
    return Date.UTC(year, mon - 1, day, hour, min, sec, 0);
};
$b28be291c8d179e1$var$DERNode.prototype._decodeNull = function decodeNull(buffer) {
    return null;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeBool = function decodeBool(buffer) {
    var res = buffer.readUInt8();
    if (buffer.isError(res)) return res;
    else return res !== 0;
};
$b28be291c8d179e1$var$DERNode.prototype._decodeInt = function decodeInt(buffer, values) {
    // Bigint, return as it is (assume big endian)
    var raw = buffer.raw();
    var res = new $b28be291c8d179e1$var$bignum(raw);
    if (values) res = values[res.toString(10)] || res;
    return res;
};
$b28be291c8d179e1$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getDecoder("der").tree;
};
// Utility methods
function $b28be291c8d179e1$var$derDecodeTag(buf, fail) {
    var tag = buf.readUInt8(fail);
    if (buf.isError(tag)) return tag;
    var cls = $b28be291c8d179e1$var$der.tagClass[tag >> 6];
    var primitive = (tag & 0x20) === 0;
    // Multi-octet tag - load
    if ((tag & 0x1f) === 0x1f) {
        var oct = tag;
        tag = 0;
        while((oct & 0x80) === 0x80){
            oct = buf.readUInt8(fail);
            if (buf.isError(oct)) return oct;
            tag <<= 7;
            tag |= oct & 0x7f;
        }
    } else tag &= 0x1f;
    var tagStr = $b28be291c8d179e1$var$der.tag[tag];
    return {
        cls: cls,
        primitive: primitive,
        tag: tag,
        tagStr: tagStr
    };
}
function $b28be291c8d179e1$var$derDecodeLen(buf, primitive, fail) {
    var len = buf.readUInt8(fail);
    if (buf.isError(len)) return len;
    // Indefinite form
    if (!primitive && len === 0x80) return null;
    // Definite form
    if ((len & 0x80) === 0) // Short form
    return len;
    // Long form
    var num = len & 0x7f;
    if (num > 4) return buf.error("length octect is too long");
    len = 0;
    for(var i = 0; i < num; i++){
        len <<= 8;
        var j = buf.readUInt8(fail);
        if (buf.isError(j)) return j;
        len |= j;
    }
    return len;
}

});

parcelRegister("9wGrq", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $6ef8062b6cdbe0f4$require$Buffer = $6ZWSX.Buffer;

var $fkoHA = parcelRequire("fkoHA");
function $6ef8062b6cdbe0f4$var$PEMDecoder(entity) {
    $fkoHA.call(this, entity);
    this.enc = "pem";
}
$dlqwk($6ef8062b6cdbe0f4$var$PEMDecoder, $fkoHA);
module.exports = $6ef8062b6cdbe0f4$var$PEMDecoder;
$6ef8062b6cdbe0f4$var$PEMDecoder.prototype.decode = function decode(data, options) {
    var lines = data.toString().split(/[\r\n]+/g);
    var label = options.label.toUpperCase();
    var re = /^-----(BEGIN|END) ([^-]+)-----$/;
    var start = -1;
    var end = -1;
    for(var i = 0; i < lines.length; i++){
        var match = lines[i].match(re);
        if (match === null) continue;
        if (match[2] !== label) continue;
        if (start === -1) {
            if (match[1] !== "BEGIN") break;
            start = i;
        } else {
            if (match[1] !== "END") break;
            end = i;
            break;
        }
    }
    if (start === -1 || end === -1) throw new Error("PEM section not found for: " + label);
    var base64 = lines.slice(start + 1, end).join("");
    // Remove excessive symbols
    base64.replace(/[^a-z0-9\+\/=]+/gi, "");
    var input = new $6ef8062b6cdbe0f4$require$Buffer(base64, "base64");
    return $fkoHA.prototype.decode.call(this, input, options);
};

});


parcelRegister("ljw8S", function(module, exports) {
var $f8444e153c0591ac$var$encoders = module.exports;

$f8444e153c0591ac$var$encoders.der = (parcelRequire("2j6ve"));

$f8444e153c0591ac$var$encoders.pem = (parcelRequire("bPffB"));

});
parcelRegister("2j6ve", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $6ZWSX = parcelRequire("6ZWSX");
var $1ae2666fc718ae87$require$Buffer = $6ZWSX.Buffer;

var $10gXo = parcelRequire("10gXo");
var $1ae2666fc718ae87$var$base = $10gXo.base;
// Import DER constants
var $1ae2666fc718ae87$var$der = $10gXo.constants.der;
function $1ae2666fc718ae87$var$DEREncoder(entity) {
    this.enc = "der";
    this.name = entity.name;
    this.entity = entity;
    // Construct base tree
    this.tree = new $1ae2666fc718ae87$var$DERNode();
    this.tree._init(entity.body);
}
module.exports = $1ae2666fc718ae87$var$DEREncoder;
$1ae2666fc718ae87$var$DEREncoder.prototype.encode = function encode(data, reporter) {
    return this.tree._encode(data, reporter).join();
};
// Tree methods
function $1ae2666fc718ae87$var$DERNode(parent) {
    $1ae2666fc718ae87$var$base.Node.call(this, "der", parent);
}
$dlqwk($1ae2666fc718ae87$var$DERNode, $1ae2666fc718ae87$var$base.Node);
$1ae2666fc718ae87$var$DERNode.prototype._encodeComposite = function encodeComposite(tag, primitive, cls, content) {
    var encodedTag = $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, this.reporter);
    // Short form
    if (content.length < 0x80) {
        var header = new $1ae2666fc718ae87$require$Buffer(2);
        header[0] = encodedTag;
        header[1] = content.length;
        return this._createEncoderBuffer([
            header,
            content
        ]);
    }
    // Long form
    // Count octets required to store length
    var lenOctets = 1;
    for(var i = content.length; i >= 0x100; i >>= 8)lenOctets++;
    var header = new $1ae2666fc718ae87$require$Buffer(2 + lenOctets);
    header[0] = encodedTag;
    header[1] = 0x80 | lenOctets;
    for(var i = 1 + lenOctets, j = content.length; j > 0; i--, j >>= 8)header[i] = j & 0xff;
    return this._createEncoderBuffer([
        header,
        content
    ]);
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeStr = function encodeStr(str, tag) {
    if (tag === "bitstr") return this._createEncoderBuffer([
        str.unused | 0,
        str.data
    ]);
    else if (tag === "bmpstr") {
        var buf = new $1ae2666fc718ae87$require$Buffer(str.length * 2);
        for(var i = 0; i < str.length; i++)buf.writeUInt16BE(str.charCodeAt(i), i * 2);
        return this._createEncoderBuffer(buf);
    } else if (tag === "numstr") {
        if (!this._isNumstr(str)) return this.reporter.error("Encoding of string type: numstr supports only digits and space");
        return this._createEncoderBuffer(str);
    } else if (tag === "printstr") {
        if (!this._isPrintstr(str)) return this.reporter.error("Encoding of string type: printstr supports only latin upper and lower case letters, digits, space, apostrophe, left and rigth parenthesis, plus sign, comma, hyphen, dot, slash, colon, equal sign, question mark");
        return this._createEncoderBuffer(str);
    } else if (/str$/.test(tag)) return this._createEncoderBuffer(str);
    else if (tag === "objDesc") return this._createEncoderBuffer(str);
    else return this.reporter.error("Encoding of string type: " + tag + " unsupported");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeObjid = function encodeObjid(id, values, relative) {
    if (typeof id === "string") {
        if (!values) return this.reporter.error("string objid given, but no values map found");
        if (!values.hasOwnProperty(id)) return this.reporter.error("objid not found in values map");
        id = values[id].split(/[\s\.]+/g);
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    } else if (Array.isArray(id)) {
        id = id.slice();
        for(var i = 0; i < id.length; i++)id[i] |= 0;
    }
    if (!Array.isArray(id)) return this.reporter.error("objid() should be either array or string, got: " + JSON.stringify(id));
    if (!relative) {
        if (id[1] >= 40) return this.reporter.error("Second objid identifier OOB");
        id.splice(0, 2, id[0] * 40 + id[1]);
    }
    // Count number of octets
    var size = 0;
    for(var i = 0; i < id.length; i++){
        var ident = id[i];
        for(size++; ident >= 0x80; ident >>= 7)size++;
    }
    var objid = new $1ae2666fc718ae87$require$Buffer(size);
    var offset = objid.length - 1;
    for(var i = id.length - 1; i >= 0; i--){
        var ident = id[i];
        objid[offset--] = ident & 0x7f;
        while((ident >>= 7) > 0)objid[offset--] = 0x80 | ident & 0x7f;
    }
    return this._createEncoderBuffer(objid);
};
function $1ae2666fc718ae87$var$two(num) {
    if (num < 10) return "0" + num;
    else return num;
}
$1ae2666fc718ae87$var$DERNode.prototype._encodeTime = function encodeTime(time, tag) {
    var str;
    var date = new Date(time);
    if (tag === "gentime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear()),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else if (tag === "utctime") str = [
        $1ae2666fc718ae87$var$two(date.getFullYear() % 100),
        $1ae2666fc718ae87$var$two(date.getUTCMonth() + 1),
        $1ae2666fc718ae87$var$two(date.getUTCDate()),
        $1ae2666fc718ae87$var$two(date.getUTCHours()),
        $1ae2666fc718ae87$var$two(date.getUTCMinutes()),
        $1ae2666fc718ae87$var$two(date.getUTCSeconds()),
        "Z"
    ].join("");
    else this.reporter.error("Encoding " + tag + " time is not supported yet");
    return this._encodeStr(str, "octstr");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeNull = function encodeNull() {
    return this._createEncoderBuffer("");
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeInt = function encodeInt(num, values) {
    if (typeof num === "string") {
        if (!values) return this.reporter.error("String int or enum given, but no values map");
        if (!values.hasOwnProperty(num)) return this.reporter.error("Values map doesn't contain: " + JSON.stringify(num));
        num = values[num];
    }
    // Bignum, assume big endian
    if (typeof num !== "number" && !$1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var numArray = num.toArray();
        if (!num.sign && numArray[0] & 0x80) numArray.unshift(0);
        num = new $1ae2666fc718ae87$require$Buffer(numArray);
    }
    if ($1ae2666fc718ae87$require$Buffer.isBuffer(num)) {
        var size = num.length;
        if (num.length === 0) size++;
        var out = new $1ae2666fc718ae87$require$Buffer(size);
        num.copy(out);
        if (num.length === 0) out[0] = 0;
        return this._createEncoderBuffer(out);
    }
    if (num < 0x80) return this._createEncoderBuffer(num);
    if (num < 0x100) return this._createEncoderBuffer([
        0,
        num
    ]);
    var size = 1;
    for(var i = num; i >= 0x100; i >>= 8)size++;
    var out = new Array(size);
    for(var i = out.length - 1; i >= 0; i--){
        out[i] = num & 0xff;
        num >>= 8;
    }
    if (out[0] & 0x80) out.unshift(0);
    return this._createEncoderBuffer(new $1ae2666fc718ae87$require$Buffer(out));
};
$1ae2666fc718ae87$var$DERNode.prototype._encodeBool = function encodeBool(value) {
    return this._createEncoderBuffer(value ? 0xff : 0);
};
$1ae2666fc718ae87$var$DERNode.prototype._use = function use(entity, obj) {
    if (typeof entity === "function") entity = entity(obj);
    return entity._getEncoder("der").tree;
};
$1ae2666fc718ae87$var$DERNode.prototype._skipDefault = function skipDefault(dataBuffer, reporter, parent) {
    var state = this._baseState;
    var i;
    if (state["default"] === null) return false;
    var data = dataBuffer.join();
    if (state.defaultBuffer === undefined) state.defaultBuffer = this._encodeValue(state["default"], reporter, parent).join();
    if (data.length !== state.defaultBuffer.length) return false;
    for(i = 0; i < data.length; i++)if (data[i] !== state.defaultBuffer[i]) return false;
    return true;
};
// Utility methods
function $1ae2666fc718ae87$var$encodeTag(tag, primitive, cls, reporter) {
    var res;
    if (tag === "seqof") tag = "seq";
    else if (tag === "setof") tag = "set";
    if ($1ae2666fc718ae87$var$der.tagByName.hasOwnProperty(tag)) res = $1ae2666fc718ae87$var$der.tagByName[tag];
    else if (typeof tag === "number" && (tag | 0) === tag) res = tag;
    else return reporter.error("Unknown tag: " + tag);
    if (res >= 0x1f) return reporter.error("Multi-octet tag encoding unsupported");
    if (!primitive) res |= 0x20;
    res |= $1ae2666fc718ae87$var$der.tagClassByName[cls || "universal"] << 6;
    return res;
}

});

parcelRegister("bPffB", function(module, exports) {

var $dlqwk = parcelRequire("dlqwk");

var $2j6ve = parcelRequire("2j6ve");
function $89c04996afa84ca7$var$PEMEncoder(entity) {
    $2j6ve.call(this, entity);
    this.enc = "pem";
}
$dlqwk($89c04996afa84ca7$var$PEMEncoder, $2j6ve);
module.exports = $89c04996afa84ca7$var$PEMEncoder;
$89c04996afa84ca7$var$PEMEncoder.prototype.encode = function encode(data, options) {
    var buf = $2j6ve.prototype.encode.call(this, data);
    var p = buf.toString("base64");
    var out = [
        "-----BEGIN " + options.label + "-----"
    ];
    for(var i = 0; i < p.length; i += 64)out.push(p.slice(i, i + 64));
    out.push("-----END " + options.label + "-----");
    return out.join("\n");
};

});



parcelRegister("aeJDW", function(module, exports) {
var indexOf = function(xs, item) {
    if (xs.indexOf) return xs.indexOf(item);
    else for(var i = 0; i < xs.length; i++){
        if (xs[i] === item) return i;
    }
    return -1;
};
var Object_keys = function(obj) {
    if (Object.keys) return Object.keys(obj);
    else {
        var res = [];
        for(var key in obj)res.push(key);
        return res;
    }
};
var forEach = function(xs, fn) {
    if (xs.forEach) return xs.forEach(fn);
    else for(var i = 0; i < xs.length; i++)fn(xs[i], i, xs);
};
var defineProp = function() {
    try {
        Object.defineProperty({}, "_", {});
        return function(obj, name, value) {
            Object.defineProperty(obj, name, {
                writable: true,
                enumerable: false,
                configurable: true,
                value: value
            });
        };
    } catch (e) {
        return function(obj, name, value) {
            obj[name] = value;
        };
    }
}();
var globals = [
    "Array",
    "Boolean",
    "Date",
    "Error",
    "EvalError",
    "Function",
    "Infinity",
    "JSON",
    "Math",
    "NaN",
    "Number",
    "Object",
    "RangeError",
    "ReferenceError",
    "RegExp",
    "String",
    "SyntaxError",
    "TypeError",
    "URIError",
    "decodeURI",
    "decodeURIComponent",
    "encodeURI",
    "encodeURIComponent",
    "escape",
    "eval",
    "isFinite",
    "isNaN",
    "parseFloat",
    "parseInt",
    "undefined",
    "unescape"
];
function Context() {}
Context.prototype = {};
var Script = exports.Script = function NodeScript(code) {
    if (!(this instanceof Script)) return new Script(code);
    this.code = code;
};
Script.prototype.runInContext = function(context) {
    if (!(context instanceof Context)) throw new TypeError("needs a 'context' argument.");
    var iframe = document.createElement("iframe");
    if (!iframe.style) iframe.style = {};
    iframe.style.display = "none";
    document.body.appendChild(iframe);
    var win = iframe.contentWindow;
    var wEval = win.eval, wExecScript = win.execScript;
    if (!wEval && wExecScript) {
        // win.eval() magically appears when this is called in IE:
        wExecScript.call(win, "null");
        wEval = win.eval;
    }
    forEach(Object_keys(context), function(key) {
        win[key] = context[key];
    });
    forEach(globals, function(key) {
        if (context[key]) win[key] = context[key];
    });
    var winKeys = Object_keys(win);
    var res = wEval.call(win, this.code);
    forEach(Object_keys(win), function(key) {
        // Avoid copying circular objects like `top` and `window` by only
        // updating existing context properties or new properties in the `win`
        // that was only introduced after the eval.
        if (key in context || indexOf(winKeys, key) === -1) context[key] = win[key];
    });
    forEach(globals, function(key) {
        if (!(key in context)) defineProp(context, key, win[key]);
    });
    document.body.removeChild(iframe);
    return res;
};
Script.prototype.runInThisContext = function() {
    return eval(this.code); // maybe...
};
Script.prototype.runInNewContext = function(context) {
    var ctx = Script.createContext(context);
    var res = this.runInContext(ctx);
    if (context) forEach(Object_keys(ctx), function(key) {
        context[key] = ctx[key];
    });
    return res;
};
forEach(Object_keys(Script.prototype), function(name) {
    exports[name] = Script[name] = function(code) {
        var s = Script(code);
        return s[name].apply(s, [].slice.call(arguments, 1));
    };
});
exports.isContext = function(context) {
    return context instanceof Context;
};
exports.createScript = function(code) {
    return exports.Script(code);
};
exports.createContext = Script.createContext = function(context) {
    var copy = new Context();
    if (typeof context === "object") forEach(Object_keys(context), function(key) {
        copy[key] = context[key];
    });
    return copy;
};

});


parcelRegister("bDaUv", function(module, exports) {
// from https://github.com/Rantanen/node-dtls/blob/25a7dc861bda38cfeac93a723500eea4f0ac2e86/Certificate.js
// thanks to @Rantanen
"use strict";

var $10gXo = parcelRequire("10gXo");
var $877bcccea3fc6be5$var$Time = $10gXo.define("Time", function() {
    this.choice({
        utcTime: this.utctime(),
        generalTime: this.gentime()
    });
});
var $877bcccea3fc6be5$var$AttributeTypeValue = $10gXo.define("AttributeTypeValue", function() {
    this.seq().obj(this.key("type").objid(), this.key("value").any());
});
var $877bcccea3fc6be5$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("parameters").optional(), this.key("curve").objid().optional());
});
var $877bcccea3fc6be5$var$SubjectPublicKeyInfo = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
var $877bcccea3fc6be5$var$RelativeDistinguishedName = $10gXo.define("RelativeDistinguishedName", function() {
    this.setof($877bcccea3fc6be5$var$AttributeTypeValue);
});
var $877bcccea3fc6be5$var$RDNSequence = $10gXo.define("RDNSequence", function() {
    this.seqof($877bcccea3fc6be5$var$RelativeDistinguishedName);
});
var $877bcccea3fc6be5$var$Name = $10gXo.define("Name", function() {
    this.choice({
        rdnSequence: this.use($877bcccea3fc6be5$var$RDNSequence)
    });
});
var $877bcccea3fc6be5$var$Validity = $10gXo.define("Validity", function() {
    this.seq().obj(this.key("notBefore").use($877bcccea3fc6be5$var$Time), this.key("notAfter").use($877bcccea3fc6be5$var$Time));
});
var $877bcccea3fc6be5$var$Extension = $10gXo.define("Extension", function() {
    this.seq().obj(this.key("extnID").objid(), this.key("critical").bool().def(false), this.key("extnValue").octstr());
});
var $877bcccea3fc6be5$var$TBSCertificate = $10gXo.define("TBSCertificate", function() {
    this.seq().obj(this.key("version").explicit(0)["int"]().optional(), this.key("serialNumber")["int"](), this.key("signature").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("issuer").use($877bcccea3fc6be5$var$Name), this.key("validity").use($877bcccea3fc6be5$var$Validity), this.key("subject").use($877bcccea3fc6be5$var$Name), this.key("subjectPublicKeyInfo").use($877bcccea3fc6be5$var$SubjectPublicKeyInfo), this.key("issuerUniqueID").implicit(1).bitstr().optional(), this.key("subjectUniqueID").implicit(2).bitstr().optional(), this.key("extensions").explicit(3).seqof($877bcccea3fc6be5$var$Extension).optional());
});
var $877bcccea3fc6be5$var$X509Certificate = $10gXo.define("X509Certificate", function() {
    this.seq().obj(this.key("tbsCertificate").use($877bcccea3fc6be5$var$TBSCertificate), this.key("signatureAlgorithm").use($877bcccea3fc6be5$var$AlgorithmIdentifier), this.key("signatureValue").bitstr());
});
module.exports = $877bcccea3fc6be5$var$X509Certificate;

});

parcelRegister("fd3gh", function(module, exports) {

var $6ZWSX = parcelRequire("6ZWSX");
var $b12a999e54d2bf45$require$Buffer = $6ZWSX.Buffer;

var $1zUcV = parcelRequire("1zUcV");

var $jqmf0 = parcelRequire("jqmf0");
module.exports = function createECDH(curve) {
    return new $b12a999e54d2bf45$var$ECDH(curve);
};
var $b12a999e54d2bf45$var$aliases = {
    secp256k1: {
        name: "secp256k1",
        byteLength: 32
    },
    secp224r1: {
        name: "p224",
        byteLength: 28
    },
    prime256v1: {
        name: "p256",
        byteLength: 32
    },
    prime192v1: {
        name: "p192",
        byteLength: 24
    },
    ed25519: {
        name: "ed25519",
        byteLength: 32
    },
    secp384r1: {
        name: "p384",
        byteLength: 48
    },
    secp521r1: {
        name: "p521",
        byteLength: 66
    }
};
$b12a999e54d2bf45$var$aliases.p224 = $b12a999e54d2bf45$var$aliases.secp224r1;
$b12a999e54d2bf45$var$aliases.p256 = $b12a999e54d2bf45$var$aliases.secp256r1 = $b12a999e54d2bf45$var$aliases.prime256v1;
$b12a999e54d2bf45$var$aliases.p192 = $b12a999e54d2bf45$var$aliases.secp192r1 = $b12a999e54d2bf45$var$aliases.prime192v1;
$b12a999e54d2bf45$var$aliases.p384 = $b12a999e54d2bf45$var$aliases.secp384r1;
$b12a999e54d2bf45$var$aliases.p521 = $b12a999e54d2bf45$var$aliases.secp521r1;
function $b12a999e54d2bf45$var$ECDH(curve) {
    this.curveType = $b12a999e54d2bf45$var$aliases[curve];
    if (!this.curveType) this.curveType = {
        name: curve
    };
    this.curve = new $1zUcV.ec(this.curveType.name) // eslint-disable-line new-cap
    ;
    this.keys = void 0;
}
$b12a999e54d2bf45$var$ECDH.prototype.generateKeys = function(enc, format) {
    this.keys = this.curve.genKeyPair();
    return this.getPublicKey(enc, format);
};
$b12a999e54d2bf45$var$ECDH.prototype.computeSecret = function(other, inenc, enc) {
    inenc = inenc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(other)) other = new $b12a999e54d2bf45$require$Buffer(other, inenc);
    var otherPub = this.curve.keyFromPublic(other).getPublic();
    var out = otherPub.mul(this.keys.getPrivate()).getX();
    return $b12a999e54d2bf45$var$formatReturnValue(out, enc, this.curveType.byteLength);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPublicKey = function(enc, format) {
    var key = this.keys.getPublic(format === "compressed", true);
    if (format === "hybrid") {
        if (key[key.length - 1] % 2) key[0] = 7;
        else key[0] = 6;
    }
    return $b12a999e54d2bf45$var$formatReturnValue(key, enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.getPrivateKey = function(enc) {
    return $b12a999e54d2bf45$var$formatReturnValue(this.keys.getPrivate(), enc);
};
$b12a999e54d2bf45$var$ECDH.prototype.setPublicKey = function(pub, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(pub)) pub = new $b12a999e54d2bf45$require$Buffer(pub, enc);
    this.keys._importPublic(pub);
    return this;
};
$b12a999e54d2bf45$var$ECDH.prototype.setPrivateKey = function(priv, enc) {
    enc = enc || "utf8";
    if (!$b12a999e54d2bf45$require$Buffer.isBuffer(priv)) priv = new $b12a999e54d2bf45$require$Buffer(priv, enc);
    var _priv = new $jqmf0(priv);
    _priv = _priv.toString(16);
    this.keys = this.curve.genKeyPair();
    this.keys._importPrivate(_priv);
    return this;
};
function $b12a999e54d2bf45$var$formatReturnValue(bn, enc, len) {
    if (!Array.isArray(bn)) bn = bn.toArray();
    var buf = new $b12a999e54d2bf45$require$Buffer(bn);
    if (len && buf.length < len) {
        var zeros = new $b12a999e54d2bf45$require$Buffer(len - buf.length);
        zeros.fill(0);
        buf = $b12a999e54d2bf45$require$Buffer.concat([
            zeros,
            buf
        ]);
    }
    if (!enc) return buf;
    else return buf.toString(enc);
}

});
parcelRegister("1zUcV", function(module, exports) {
"use strict";
var $1264a8f63e75be39$var$elliptic = module.exports;

$1264a8f63e75be39$var$elliptic.version = (parcelRequire("fuV4H")).version;

$1264a8f63e75be39$var$elliptic.utils = (parcelRequire("gEVtY"));

$1264a8f63e75be39$var$elliptic.rand = (parcelRequire("7JHF0"));

$1264a8f63e75be39$var$elliptic.curve = (parcelRequire("cP1GP"));

$1264a8f63e75be39$var$elliptic.curves = (parcelRequire("fbTbW"));

// Protocols
$1264a8f63e75be39$var$elliptic.ec = (parcelRequire("220Zx"));

$1264a8f63e75be39$var$elliptic.eddsa = (parcelRequire("esmmS"));

});

parcelRegister("jqmf0", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});


parcelRegister("98aLY", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $hkN9y = parcelRequire("hkN9y");

var $1R2J7 = parcelRequire("1R2J7");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3pDg3 = parcelRequire("3pDg3");

var $3Sg1O = parcelRequire("3Sg1O");

var $1U9GM = parcelRequire("1U9GM");
var $6a5d37a95541eeab$require$Buffer = $1U9GM.Buffer;
module.exports = function publicEncrypt(publicKey, msg, reverse) {
    var padding;
    if (publicKey.padding) padding = publicKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(publicKey);
    var paddedMsg;
    if (padding === 4) paddedMsg = $6a5d37a95541eeab$var$oaep(key, msg);
    else if (padding === 1) paddedMsg = $6a5d37a95541eeab$var$pkcs1(key, msg, reverse);
    else if (padding === 3) {
        paddedMsg = new $6rDPA(msg);
        if (paddedMsg.cmp(key.modulus) >= 0) throw new Error("data too long for modulus");
    } else throw new Error("unknown padding");
    if (reverse) return $3Sg1O(paddedMsg, key);
    else return $3pDg3(paddedMsg, key);
};
function $6a5d37a95541eeab$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var mLen = msg.length;
    var iHash = $1R2J7("sha1").update($6a5d37a95541eeab$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    var hLen2 = 2 * hLen;
    if (mLen > k - hLen2 - 2) throw new Error("message too long");
    var ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - hLen2 - 2);
    var dblen = k - hLen - 1;
    var seed = $hkN9y(hLen);
    var maskedDb = $6nrMP($6a5d37a95541eeab$require$Buffer.concat([
        iHash,
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1, 1),
        msg
    ], dblen), $5BMkJ(seed, dblen));
    var maskedSeed = $6nrMP(seed, $5BMkJ(maskedDb, hLen));
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        maskedSeed,
        maskedDb
    ], k));
}
function $6a5d37a95541eeab$var$pkcs1(key, msg, reverse) {
    var mLen = msg.length;
    var k = key.modulus.byteLength();
    if (mLen > k - 11) throw new Error("message too long");
    var ps;
    if (reverse) ps = $6a5d37a95541eeab$require$Buffer.alloc(k - mLen - 3, 0xff);
    else ps = $6a5d37a95541eeab$var$nonZero(k - mLen - 3);
    return new $6rDPA($6a5d37a95541eeab$require$Buffer.concat([
        $6a5d37a95541eeab$require$Buffer.from([
            0,
            reverse ? 1 : 2
        ]),
        ps,
        $6a5d37a95541eeab$require$Buffer.alloc(1),
        msg
    ], k));
}
function $6a5d37a95541eeab$var$nonZero(len) {
    var out = $6a5d37a95541eeab$require$Buffer.allocUnsafe(len);
    var i = 0;
    var cache = $hkN9y(len * 2);
    var cur = 0;
    var num;
    while(i < len){
        if (cur === cache.length) {
            cache = $hkN9y(len * 2);
            cur = 0;
        }
        num = cache[cur++];
        if (num) out[i++] = num;
    }
    return out;
}

});
parcelRegister("aNeDF", function(module, exports) {
"use strict";

var $fC6a8 = parcelRequire("fC6a8");

var $5v6nH = parcelRequire("5v6nH");

var $3ILSx = parcelRequire("3ILSx");

var $7Zu82 = parcelRequire("7Zu82");

var $lORrZ = parcelRequire("lORrZ");

var $1U9GM = parcelRequire("1U9GM");
var $7db9d5f82e4113aa$require$Buffer = $1U9GM.Buffer;
function $7db9d5f82e4113aa$var$decrypt(data, password) {
    var salt = data.algorithm.decrypt.kde.kdeparams.salt;
    var iters = parseInt(data.algorithm.decrypt.kde.kdeparams.iters.toString(), 10);
    var algo = $5v6nH[data.algorithm.decrypt.cipher.algo.join(".")];
    var iv = data.algorithm.decrypt.cipher.iv;
    var cipherText = data.subjectPrivateKey;
    var keylen = parseInt(algo.split("-")[1], 10) / 8;
    var key = $lORrZ.pbkdf2Sync(password, salt, iters, keylen, "sha1");
    var cipher = $7Zu82.createDecipheriv(algo, key, iv);
    var out = [];
    out.push(cipher.update(cipherText));
    out.push(cipher["final"]());
    return $7db9d5f82e4113aa$require$Buffer.concat(out);
}
function $7db9d5f82e4113aa$var$parseKeys(buffer) {
    var password;
    if (typeof buffer === "object" && !$7db9d5f82e4113aa$require$Buffer.isBuffer(buffer)) {
        password = buffer.passphrase;
        buffer = buffer.key;
    }
    if (typeof buffer === "string") buffer = $7db9d5f82e4113aa$require$Buffer.from(buffer);
    var stripped = $3ILSx(buffer, password);
    var type = stripped.tag;
    var data = stripped.data;
    var subtype, ndata;
    switch(type){
        case "CERTIFICATE":
            ndata = $fC6a8.certificate.decode(data, "der").tbsCertificate.subjectPublicKeyInfo;
        // falls through
        case "PUBLIC KEY":
            if (!ndata) ndata = $fC6a8.PublicKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPublicKey.decode(ndata.subjectPublicKey.data, "der");
                case "1.2.840.10045.2.1":
                    ndata.subjectPrivateKey = ndata.subjectPublicKey;
                    return {
                        type: "ec",
                        data: ndata
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.pub_key = $fC6a8.DSAparam.decode(ndata.subjectPublicKey.data, "der");
                    return {
                        type: "dsa",
                        data: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "ENCRYPTED PRIVATE KEY":
            data = $fC6a8.EncryptedPrivateKey.decode(data, "der");
            data = $7db9d5f82e4113aa$var$decrypt(data, password);
        // falls through
        case "PRIVATE KEY":
            ndata = $fC6a8.PrivateKey.decode(data, "der");
            subtype = ndata.algorithm.algorithm.join(".");
            switch(subtype){
                case "1.2.840.113549.1.1.1":
                    return $fC6a8.RSAPrivateKey.decode(ndata.subjectPrivateKey, "der");
                case "1.2.840.10045.2.1":
                    return {
                        curve: ndata.algorithm.curve,
                        privateKey: $fC6a8.ECPrivateKey.decode(ndata.subjectPrivateKey, "der").privateKey
                    };
                case "1.2.840.10040.4.1":
                    ndata.algorithm.params.priv_key = $fC6a8.DSAparam.decode(ndata.subjectPrivateKey, "der");
                    return {
                        type: "dsa",
                        params: ndata.algorithm.params
                    };
                default:
                    throw new Error("unknown key id " + subtype);
            }
        // throw new Error('unknown key type ' + type)
        case "RSA PUBLIC KEY":
            return $fC6a8.RSAPublicKey.decode(data, "der");
        case "RSA PRIVATE KEY":
            return $fC6a8.RSAPrivateKey.decode(data, "der");
        case "DSA PRIVATE KEY":
            return {
                type: "dsa",
                params: $fC6a8.DSAPrivateKey.decode(data, "der")
            };
        case "EC PRIVATE KEY":
            data = $fC6a8.ECPrivateKey.decode(data, "der");
            return {
                curve: data.parameters.value,
                privateKey: data.privateKey
            };
        default:
            throw new Error("unknown key type " + type);
    }
}
$7db9d5f82e4113aa$var$parseKeys.signature = $fC6a8.signature;
module.exports = $7db9d5f82e4113aa$var$parseKeys;

});
parcelRegister("fC6a8", function(module, exports) {

$parcel$export(module.exports, "certificate", () => $b5df2f5887fb7e8d$export$c98397a6eb8d0678, (v) => $b5df2f5887fb7e8d$export$c98397a6eb8d0678 = v);
$parcel$export(module.exports, "RSAPrivateKey", () => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b, (v) => $b5df2f5887fb7e8d$export$f4aab6816f64fa6b = v);
$parcel$export(module.exports, "RSAPublicKey", () => $b5df2f5887fb7e8d$export$4471f5c65d097c11, (v) => $b5df2f5887fb7e8d$export$4471f5c65d097c11 = v);
$parcel$export(module.exports, "PublicKey", () => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de, (v) => $b5df2f5887fb7e8d$export$ca8b6604d6ce14de = v);
$parcel$export(module.exports, "PrivateKey", () => $b5df2f5887fb7e8d$export$8f54525b330fd87b, (v) => $b5df2f5887fb7e8d$export$8f54525b330fd87b = v);
$parcel$export(module.exports, "EncryptedPrivateKey", () => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7, (v) => $b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = v);
$parcel$export(module.exports, "DSAPrivateKey", () => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce, (v) => $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = v);
$parcel$export(module.exports, "DSAparam", () => $b5df2f5887fb7e8d$export$8ad762e3e6399afe, (v) => $b5df2f5887fb7e8d$export$8ad762e3e6399afe = v);
$parcel$export(module.exports, "ECPrivateKey", () => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0, (v) => $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = v);
$parcel$export(module.exports, "signature", () => $b5df2f5887fb7e8d$export$c9cd164b539ebb63, (v) => $b5df2f5887fb7e8d$export$c9cd164b539ebb63 = v);
// from https://github.com/indutny/self-signed/blob/gh-pages/lib/asn1.js
// Fedor, you are amazing.
var $b5df2f5887fb7e8d$export$c98397a6eb8d0678;
var $b5df2f5887fb7e8d$export$f4aab6816f64fa6b;
var $b5df2f5887fb7e8d$export$4471f5c65d097c11;
var $b5df2f5887fb7e8d$export$ca8b6604d6ce14de;
var $b5df2f5887fb7e8d$export$8f54525b330fd87b;
var $b5df2f5887fb7e8d$export$23cd2842b44ca3e7;
var $b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce;
var $b5df2f5887fb7e8d$export$8ad762e3e6399afe;
var $b5df2f5887fb7e8d$export$32ef6f92e22c6ab0;
var $b5df2f5887fb7e8d$export$c9cd164b539ebb63;
"use strict";

var $10gXo = parcelRequire("10gXo");

$b5df2f5887fb7e8d$export$c98397a6eb8d0678 = (parcelRequire("bDaUv"));
var $b5df2f5887fb7e8d$var$RSAPrivateKey = $10gXo.define("RSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("modulus")["int"](), this.key("publicExponent")["int"](), this.key("privateExponent")["int"](), this.key("prime1")["int"](), this.key("prime2")["int"](), this.key("exponent1")["int"](), this.key("exponent2")["int"](), this.key("coefficient")["int"]());
});
$b5df2f5887fb7e8d$export$f4aab6816f64fa6b = $b5df2f5887fb7e8d$var$RSAPrivateKey;
var $b5df2f5887fb7e8d$var$RSAPublicKey = $10gXo.define("RSAPublicKey", function() {
    this.seq().obj(this.key("modulus")["int"](), this.key("publicExponent")["int"]());
});
$b5df2f5887fb7e8d$export$4471f5c65d097c11 = $b5df2f5887fb7e8d$var$RSAPublicKey;
var $b5df2f5887fb7e8d$var$AlgorithmIdentifier = $10gXo.define("AlgorithmIdentifier", function() {
    this.seq().obj(this.key("algorithm").objid(), this.key("none").null_().optional(), this.key("curve").objid().optional(), this.key("params").seq().obj(this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"]()).optional());
});
var $b5df2f5887fb7e8d$var$PublicKey = $10gXo.define("SubjectPublicKeyInfo", function() {
    this.seq().obj(this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPublicKey").bitstr());
});
$b5df2f5887fb7e8d$export$ca8b6604d6ce14de = $b5df2f5887fb7e8d$var$PublicKey;
var $b5df2f5887fb7e8d$var$PrivateKeyInfo = $10gXo.define("PrivateKeyInfo", function() {
    this.seq().obj(this.key("version")["int"](), this.key("algorithm").use($b5df2f5887fb7e8d$var$AlgorithmIdentifier), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$8f54525b330fd87b = $b5df2f5887fb7e8d$var$PrivateKeyInfo;
var $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo = $10gXo.define("EncryptedPrivateKeyInfo", function() {
    this.seq().obj(this.key("algorithm").seq().obj(this.key("id").objid(), this.key("decrypt").seq().obj(this.key("kde").seq().obj(this.key("id").objid(), this.key("kdeparams").seq().obj(this.key("salt").octstr(), this.key("iters")["int"]())), this.key("cipher").seq().obj(this.key("algo").objid(), this.key("iv").octstr()))), this.key("subjectPrivateKey").octstr());
});
$b5df2f5887fb7e8d$export$23cd2842b44ca3e7 = $b5df2f5887fb7e8d$var$EncryptedPrivateKeyInfo;
var $b5df2f5887fb7e8d$var$DSAPrivateKey = $10gXo.define("DSAPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("p")["int"](), this.key("q")["int"](), this.key("g")["int"](), this.key("pub_key")["int"](), this.key("priv_key")["int"]());
});
$b5df2f5887fb7e8d$export$245c9aaa9f5ce4ce = $b5df2f5887fb7e8d$var$DSAPrivateKey;
$b5df2f5887fb7e8d$export$8ad762e3e6399afe = $10gXo.define("DSAparam", function() {
    this["int"]();
});
var $b5df2f5887fb7e8d$var$ECParameters = $10gXo.define("ECParameters", function() {
    this.choice({
        namedCurve: this.objid()
    });
});
var $b5df2f5887fb7e8d$var$ECPrivateKey = $10gXo.define("ECPrivateKey", function() {
    this.seq().obj(this.key("version")["int"](), this.key("privateKey").octstr(), this.key("parameters").optional().explicit(0).use($b5df2f5887fb7e8d$var$ECParameters), this.key("publicKey").optional().explicit(1).bitstr());
});
$b5df2f5887fb7e8d$export$32ef6f92e22c6ab0 = $b5df2f5887fb7e8d$var$ECPrivateKey;
$b5df2f5887fb7e8d$export$c9cd164b539ebb63 = $10gXo.define("signature", function() {
    this.seq().obj(this.key("r")["int"](), this.key("s")["int"]());
});

});

parcelRegister("5v6nH", function(module, exports) {
module.exports = JSON.parse('{"2.16.840.1.101.3.4.1.1":"aes-128-ecb","2.16.840.1.101.3.4.1.2":"aes-128-cbc","2.16.840.1.101.3.4.1.3":"aes-128-ofb","2.16.840.1.101.3.4.1.4":"aes-128-cfb","2.16.840.1.101.3.4.1.21":"aes-192-ecb","2.16.840.1.101.3.4.1.22":"aes-192-cbc","2.16.840.1.101.3.4.1.23":"aes-192-ofb","2.16.840.1.101.3.4.1.24":"aes-192-cfb","2.16.840.1.101.3.4.1.41":"aes-256-ecb","2.16.840.1.101.3.4.1.42":"aes-256-cbc","2.16.840.1.101.3.4.1.43":"aes-256-ofb","2.16.840.1.101.3.4.1.44":"aes-256-cfb"}');

});

parcelRegister("3ILSx", function(module, exports) {
"use strict";
// adapted from https://github.com/apatil/pemstrip
var $2b5a9edea8bfc145$var$findProc = /Proc-Type: 4,ENCRYPTED[\n\r]+DEK-Info: AES-((?:128)|(?:192)|(?:256))-CBC,([0-9A-H]+)[\n\r]+([0-9A-z\n\r+/=]+)[\n\r]+/m;
var $2b5a9edea8bfc145$var$startRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----/m;
var $2b5a9edea8bfc145$var$fullRegex = /^-----BEGIN ((?:.*? KEY)|CERTIFICATE)-----([0-9A-z\n\r+/=]+)-----END \1-----$/m;

var $bSYjd = parcelRequire("bSYjd");

var $7Zu82 = parcelRequire("7Zu82");

var $1U9GM = parcelRequire("1U9GM");
var $2b5a9edea8bfc145$require$Buffer = $1U9GM.Buffer;
module.exports = function(okey, password) {
    var key = okey.toString();
    var match = key.match($2b5a9edea8bfc145$var$findProc);
    var decrypted;
    if (!match) {
        var match2 = key.match($2b5a9edea8bfc145$var$fullRegex);
        decrypted = $2b5a9edea8bfc145$require$Buffer.from(match2[2].replace(/[\r\n]/g, ""), "base64");
    } else {
        var suite = "aes" + match[1];
        var iv = $2b5a9edea8bfc145$require$Buffer.from(match[2], "hex");
        var cipherText = $2b5a9edea8bfc145$require$Buffer.from(match[3].replace(/[\r\n]/g, ""), "base64");
        var cipherKey = $bSYjd(password, iv.slice(0, 8), parseInt(match[1], 10)).key;
        var out = [];
        var cipher = $7Zu82.createDecipheriv(suite, cipherKey, iv);
        out.push(cipher.update(cipherText));
        out.push(cipher["final"]());
        decrypted = $2b5a9edea8bfc145$require$Buffer.concat(out);
    }
    var tag = key.match($2b5a9edea8bfc145$var$startRegex)[1];
    return {
        tag: tag,
        data: decrypted
    };
};

});
parcelRegister("bSYjd", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $8a7384f85993cf90$require$Buffer = $1U9GM.Buffer;

var $loYLU = parcelRequire("loYLU");
/* eslint-disable camelcase */ function $8a7384f85993cf90$var$EVP_BytesToKey(password, salt, keyBits, ivLen) {
    if (!$8a7384f85993cf90$require$Buffer.isBuffer(password)) password = $8a7384f85993cf90$require$Buffer.from(password, "binary");
    if (salt) {
        if (!$8a7384f85993cf90$require$Buffer.isBuffer(salt)) salt = $8a7384f85993cf90$require$Buffer.from(salt, "binary");
        if (salt.length !== 8) throw new RangeError("salt should be Buffer with 8 byte length");
    }
    var keyLen = keyBits / 8;
    var key = $8a7384f85993cf90$require$Buffer.alloc(keyLen);
    var iv = $8a7384f85993cf90$require$Buffer.alloc(ivLen || 0);
    var tmp = $8a7384f85993cf90$require$Buffer.alloc(0);
    while(keyLen > 0 || ivLen > 0){
        var hash = new $loYLU();
        hash.update(tmp);
        hash.update(password);
        if (salt) hash.update(salt);
        tmp = hash.digest();
        var used = 0;
        if (keyLen > 0) {
            var keyStart = key.length - keyLen;
            used = Math.min(keyLen, tmp.length);
            tmp.copy(key, keyStart, 0, used);
            keyLen -= used;
        }
        if (used < tmp.length && ivLen > 0) {
            var ivStart = iv.length - ivLen;
            var length = Math.min(ivLen, tmp.length - used);
            tmp.copy(iv, ivStart, used, used + length);
            ivLen -= length;
        }
    }
    tmp.fill(0);
    return {
        key: key,
        iv: iv
    };
}
module.exports = $8a7384f85993cf90$var$EVP_BytesToKey;

});

parcelRegister("7Zu82", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $5d1599d560efe1c2$export$2f64596b8cbf08b4, (v) => $5d1599d560efe1c2$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createDecipheriv", () => $5d1599d560efe1c2$export$36b6d6ef312eab39, (v) => $5d1599d560efe1c2$export$36b6d6ef312eab39 = v);
$parcel$export(module.exports, "getCiphers", () => $5d1599d560efe1c2$export$58a258485f1e49f6, (v) => $5d1599d560efe1c2$export$58a258485f1e49f6 = v);
var $5d1599d560efe1c2$export$bdd223f16383713e;
var $5d1599d560efe1c2$export$26e5786e8ac8e530;
var $5d1599d560efe1c2$export$2f64596b8cbf08b4;
var $5d1599d560efe1c2$export$20533d26f07f1ee0;
var $5d1599d560efe1c2$export$12ada9414fbc594c;
var $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a;
var $5d1599d560efe1c2$export$36b6d6ef312eab39;
var $5d1599d560efe1c2$export$f5e7e39d57cd9700;
var $5d1599d560efe1c2$export$dedd8dc3dc62b370;
var $5d1599d560efe1c2$export$58a258485f1e49f6;

var $8Zgnw = parcelRequire("8Zgnw");

var $aSTOs = parcelRequire("aSTOs");

var $2lZ3i = parcelRequire("2lZ3i");
function $5d1599d560efe1c2$var$getCiphers() {
    return Object.keys($2lZ3i);
}
$5d1599d560efe1c2$export$bdd223f16383713e = $5d1599d560efe1c2$export$26e5786e8ac8e530 = $8Zgnw.createCipher;
$5d1599d560efe1c2$export$2f64596b8cbf08b4 = $5d1599d560efe1c2$export$20533d26f07f1ee0 = $8Zgnw.createCipheriv;
$5d1599d560efe1c2$export$12ada9414fbc594c = $5d1599d560efe1c2$export$2ce6d8d0e8b04e1a = $aSTOs.createDecipher;
$5d1599d560efe1c2$export$36b6d6ef312eab39 = $5d1599d560efe1c2$export$f5e7e39d57cd9700 = $aSTOs.createDecipheriv;
$5d1599d560efe1c2$export$dedd8dc3dc62b370 = $5d1599d560efe1c2$export$58a258485f1e49f6 = $5d1599d560efe1c2$var$getCiphers;

});
parcelRegister("8Zgnw", function(module, exports) {

$parcel$export(module.exports, "createCipheriv", () => $68b0b9a01ec378ac$export$2f64596b8cbf08b4, (v) => $68b0b9a01ec378ac$export$2f64596b8cbf08b4 = v);
$parcel$export(module.exports, "createCipher", () => $68b0b9a01ec378ac$export$bdd223f16383713e, (v) => $68b0b9a01ec378ac$export$bdd223f16383713e = v);
var $68b0b9a01ec378ac$export$2f64596b8cbf08b4;
var $68b0b9a01ec378ac$export$bdd223f16383713e;

var $5Su5u = parcelRequire("5Su5u");

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $68b0b9a01ec378ac$require$Buffer = $1U9GM.Buffer;

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $68b0b9a01ec378ac$var$Cipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $68b0b9a01ec378ac$var$Splitter();
    this._cipher = new $j0hdX.AES(key);
    this._prev = $68b0b9a01ec378ac$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($68b0b9a01ec378ac$var$Cipher, $26nOC);
$68b0b9a01ec378ac$var$Cipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get()){
        thing = this._mode.encrypt(this, chunk);
        out.push(thing);
    }
    return $68b0b9a01ec378ac$require$Buffer.concat(out);
};
var $68b0b9a01ec378ac$var$PADDING = $68b0b9a01ec378ac$require$Buffer.alloc(16, 0x10);
$68b0b9a01ec378ac$var$Cipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) {
        chunk = this._mode.encrypt(this, chunk);
        this._cipher.scrub();
        return chunk;
    }
    if (!chunk.equals($68b0b9a01ec378ac$var$PADDING)) {
        this._cipher.scrub();
        throw new Error("data not multiple of block length");
    }
};
$68b0b9a01ec378ac$var$Cipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $68b0b9a01ec378ac$var$Splitter() {
    this.cache = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(0);
}
$68b0b9a01ec378ac$var$Splitter.prototype.add = function(data) {
    this.cache = $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$68b0b9a01ec378ac$var$Splitter.prototype.get = function() {
    if (this.cache.length > 15) {
        var out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$68b0b9a01ec378ac$var$Splitter.prototype.flush = function() {
    var len = 16 - this.cache.length;
    var padBuff = $68b0b9a01ec378ac$require$Buffer.allocUnsafe(len);
    var i = -1;
    while(++i < len)padBuff.writeUInt8(len, i);
    return $68b0b9a01ec378ac$require$Buffer.concat([
        this.cache,
        padBuff
    ]);
};
function $68b0b9a01ec378ac$var$createCipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof password === "string") password = $68b0b9a01ec378ac$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (typeof iv === "string") iv = $68b0b9a01ec378ac$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv);
    return new $68b0b9a01ec378ac$var$Cipher(config.module, password, iv);
}
function $68b0b9a01ec378ac$var$createCipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $68b0b9a01ec378ac$var$createCipheriv(suite, keys.key, keys.iv);
}
$68b0b9a01ec378ac$export$2f64596b8cbf08b4 = $68b0b9a01ec378ac$var$createCipheriv;
$68b0b9a01ec378ac$export$bdd223f16383713e = $68b0b9a01ec378ac$var$createCipher;

});
parcelRegister("5Su5u", function(module, exports) {








var $447955a9e06650da$var$modeModules = {
    ECB: (parcelRequire("f6p9h")),
    CBC: (parcelRequire("3QymJ")),
    CFB: (parcelRequire("2cuuO")),
    CFB8: (parcelRequire("03mhO")),
    CFB1: (parcelRequire("fK9OU")),
    OFB: (parcelRequire("fFe8N")),
    CTR: (parcelRequire("fJbMg")),
    GCM: (parcelRequire("fJbMg"))
};

var $2lZ3i = parcelRequire("2lZ3i");
for(var $447955a9e06650da$var$key in $2lZ3i)$2lZ3i[$447955a9e06650da$var$key].module = $447955a9e06650da$var$modeModules[$2lZ3i[$447955a9e06650da$var$key].mode];
module.exports = $2lZ3i;

});
parcelRegister("2lZ3i", function(module, exports) {
module.exports = JSON.parse('{"aes-128-ecb":{"cipher":"AES","key":128,"iv":0,"mode":"ECB","type":"block"},"aes-192-ecb":{"cipher":"AES","key":192,"iv":0,"mode":"ECB","type":"block"},"aes-256-ecb":{"cipher":"AES","key":256,"iv":0,"mode":"ECB","type":"block"},"aes-128-cbc":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes-192-cbc":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes-256-cbc":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes128":{"cipher":"AES","key":128,"iv":16,"mode":"CBC","type":"block"},"aes192":{"cipher":"AES","key":192,"iv":16,"mode":"CBC","type":"block"},"aes256":{"cipher":"AES","key":256,"iv":16,"mode":"CBC","type":"block"},"aes-128-cfb":{"cipher":"AES","key":128,"iv":16,"mode":"CFB","type":"stream"},"aes-192-cfb":{"cipher":"AES","key":192,"iv":16,"mode":"CFB","type":"stream"},"aes-256-cfb":{"cipher":"AES","key":256,"iv":16,"mode":"CFB","type":"stream"},"aes-128-cfb8":{"cipher":"AES","key":128,"iv":16,"mode":"CFB8","type":"stream"},"aes-192-cfb8":{"cipher":"AES","key":192,"iv":16,"mode":"CFB8","type":"stream"},"aes-256-cfb8":{"cipher":"AES","key":256,"iv":16,"mode":"CFB8","type":"stream"},"aes-128-cfb1":{"cipher":"AES","key":128,"iv":16,"mode":"CFB1","type":"stream"},"aes-192-cfb1":{"cipher":"AES","key":192,"iv":16,"mode":"CFB1","type":"stream"},"aes-256-cfb1":{"cipher":"AES","key":256,"iv":16,"mode":"CFB1","type":"stream"},"aes-128-ofb":{"cipher":"AES","key":128,"iv":16,"mode":"OFB","type":"stream"},"aes-192-ofb":{"cipher":"AES","key":192,"iv":16,"mode":"OFB","type":"stream"},"aes-256-ofb":{"cipher":"AES","key":256,"iv":16,"mode":"OFB","type":"stream"},"aes-128-ctr":{"cipher":"AES","key":128,"iv":16,"mode":"CTR","type":"stream"},"aes-192-ctr":{"cipher":"AES","key":192,"iv":16,"mode":"CTR","type":"stream"},"aes-256-ctr":{"cipher":"AES","key":256,"iv":16,"mode":"CTR","type":"stream"},"aes-128-gcm":{"cipher":"AES","key":128,"iv":12,"mode":"GCM","type":"auth"},"aes-192-gcm":{"cipher":"AES","key":192,"iv":12,"mode":"GCM","type":"auth"},"aes-256-gcm":{"cipher":"AES","key":256,"iv":12,"mode":"GCM","type":"auth"}}');

});


parcelRegister("lyZ5N", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $fb2c299f1eae7447$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");

var $5Z5i8 = parcelRequire("5Z5i8");

var $dUX5c = parcelRequire("dUX5c");

var $3VKgl = parcelRequire("3VKgl");
function $fb2c299f1eae7447$var$xorTest(a, b) {
    var out = 0;
    if (a.length !== b.length) out++;
    var len = Math.min(a.length, b.length);
    for(var i = 0; i < len; ++i)out += a[i] ^ b[i];
    return out;
}
function $fb2c299f1eae7447$var$calcIv(self, iv, ck) {
    if (iv.length === 12) {
        self._finID = $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                1
            ])
        ]);
        return $fb2c299f1eae7447$require$Buffer.concat([
            iv,
            $fb2c299f1eae7447$require$Buffer.from([
                0,
                0,
                0,
                2
            ])
        ]);
    }
    var ghash = new $5Z5i8(ck);
    var len = iv.length;
    var toPad = len % 16;
    ghash.update(iv);
    if (toPad) {
        toPad = 16 - toPad;
        ghash.update($fb2c299f1eae7447$require$Buffer.alloc(toPad, 0));
    }
    ghash.update($fb2c299f1eae7447$require$Buffer.alloc(8, 0));
    var ivBits = len * 8;
    var tail = $fb2c299f1eae7447$require$Buffer.alloc(8);
    tail.writeUIntBE(ivBits, 0, 8);
    ghash.update(tail);
    self._finID = ghash.state;
    var out = $fb2c299f1eae7447$require$Buffer.from(self._finID);
    $3VKgl(out);
    return out;
}
function $fb2c299f1eae7447$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    var h = $fb2c299f1eae7447$require$Buffer.alloc(4, 0);
    this._cipher = new $j0hdX.AES(key);
    var ck = this._cipher.encryptBlock(h);
    this._ghash = new $5Z5i8(ck);
    iv = $fb2c299f1eae7447$var$calcIv(this, iv, ck);
    this._prev = $fb2c299f1eae7447$require$Buffer.from(iv);
    this._cache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._secCache = $fb2c299f1eae7447$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._alen = 0;
    this._len = 0;
    this._mode = mode;
    this._authTag = null;
    this._called = false;
}
$dlqwk($fb2c299f1eae7447$var$StreamCipher, $26nOC);
$fb2c299f1eae7447$var$StreamCipher.prototype._update = function(chunk) {
    if (!this._called && this._alen) {
        var rump = 16 - this._alen % 16;
        if (rump < 16) {
            rump = $fb2c299f1eae7447$require$Buffer.alloc(rump, 0);
            this._ghash.update(rump);
        }
    }
    this._called = true;
    var out = this._mode.encrypt(this, chunk);
    if (this._decrypt) this._ghash.update(chunk);
    else this._ghash.update(out);
    this._len += chunk.length;
    return out;
};
$fb2c299f1eae7447$var$StreamCipher.prototype._final = function() {
    if (this._decrypt && !this._authTag) throw new Error("Unsupported state or unable to authenticate data");
    var tag = $dUX5c(this._ghash.final(this._alen * 8, this._len * 8), this._cipher.encryptBlock(this._finID));
    if (this._decrypt && $fb2c299f1eae7447$var$xorTest(tag, this._authTag)) throw new Error("Unsupported state or unable to authenticate data");
    this._authTag = tag;
    this._cipher.scrub();
};
$fb2c299f1eae7447$var$StreamCipher.prototype.getAuthTag = function getAuthTag() {
    if (this._decrypt || !$fb2c299f1eae7447$require$Buffer.isBuffer(this._authTag)) throw new Error("Attempting to get auth tag in unsupported state");
    return this._authTag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAuthTag = function setAuthTag(tag) {
    if (!this._decrypt) throw new Error("Attempting to set auth tag in unsupported state");
    this._authTag = tag;
};
$fb2c299f1eae7447$var$StreamCipher.prototype.setAAD = function setAAD(buf) {
    if (this._called) throw new Error("Attempting to set AAD in unsupported state");
    this._ghash.update(buf);
    this._alen += buf.length;
};
module.exports = $fb2c299f1eae7447$var$StreamCipher;

});
parcelRegister("j0hdX", function(module, exports) {

$parcel$export(module.exports, "AES", () => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5, (v) => $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = v);
// based on the aes implimentation in triple sec
// https://github.com/keybase/triplesec
// which is in turn based on the one from crypto-js
// https://code.google.com/p/crypto-js/
var $dd5b60bed61b3c64$export$b80fbe1c3a2b92b5;

var $1U9GM = parcelRequire("1U9GM");
var $dd5b60bed61b3c64$require$Buffer = $1U9GM.Buffer;
function $dd5b60bed61b3c64$var$asUInt32Array(buf) {
    if (!$dd5b60bed61b3c64$require$Buffer.isBuffer(buf)) buf = $dd5b60bed61b3c64$require$Buffer.from(buf);
    var len = buf.length / 4 | 0;
    var out = new Array(len);
    for(var i = 0; i < len; i++)out[i] = buf.readUInt32BE(i * 4);
    return out;
}
function $dd5b60bed61b3c64$var$scrubVec(v) {
    for(var i = 0; i < v.length; v++)v[i] = 0;
}
function $dd5b60bed61b3c64$var$cryptBlock(M, keySchedule, SUB_MIX, SBOX, nRounds) {
    var SUB_MIX0 = SUB_MIX[0];
    var SUB_MIX1 = SUB_MIX[1];
    var SUB_MIX2 = SUB_MIX[2];
    var SUB_MIX3 = SUB_MIX[3];
    var s0 = M[0] ^ keySchedule[0];
    var s1 = M[1] ^ keySchedule[1];
    var s2 = M[2] ^ keySchedule[2];
    var s3 = M[3] ^ keySchedule[3];
    var t0, t1, t2, t3;
    var ksRow = 4;
    for(var round = 1; round < nRounds; round++){
        t0 = SUB_MIX0[s0 >>> 24] ^ SUB_MIX1[s1 >>> 16 & 0xff] ^ SUB_MIX2[s2 >>> 8 & 0xff] ^ SUB_MIX3[s3 & 0xff] ^ keySchedule[ksRow++];
        t1 = SUB_MIX0[s1 >>> 24] ^ SUB_MIX1[s2 >>> 16 & 0xff] ^ SUB_MIX2[s3 >>> 8 & 0xff] ^ SUB_MIX3[s0 & 0xff] ^ keySchedule[ksRow++];
        t2 = SUB_MIX0[s2 >>> 24] ^ SUB_MIX1[s3 >>> 16 & 0xff] ^ SUB_MIX2[s0 >>> 8 & 0xff] ^ SUB_MIX3[s1 & 0xff] ^ keySchedule[ksRow++];
        t3 = SUB_MIX0[s3 >>> 24] ^ SUB_MIX1[s0 >>> 16 & 0xff] ^ SUB_MIX2[s1 >>> 8 & 0xff] ^ SUB_MIX3[s2 & 0xff] ^ keySchedule[ksRow++];
        s0 = t0;
        s1 = t1;
        s2 = t2;
        s3 = t3;
    }
    t0 = (SBOX[s0 >>> 24] << 24 | SBOX[s1 >>> 16 & 0xff] << 16 | SBOX[s2 >>> 8 & 0xff] << 8 | SBOX[s3 & 0xff]) ^ keySchedule[ksRow++];
    t1 = (SBOX[s1 >>> 24] << 24 | SBOX[s2 >>> 16 & 0xff] << 16 | SBOX[s3 >>> 8 & 0xff] << 8 | SBOX[s0 & 0xff]) ^ keySchedule[ksRow++];
    t2 = (SBOX[s2 >>> 24] << 24 | SBOX[s3 >>> 16 & 0xff] << 16 | SBOX[s0 >>> 8 & 0xff] << 8 | SBOX[s1 & 0xff]) ^ keySchedule[ksRow++];
    t3 = (SBOX[s3 >>> 24] << 24 | SBOX[s0 >>> 16 & 0xff] << 16 | SBOX[s1 >>> 8 & 0xff] << 8 | SBOX[s2 & 0xff]) ^ keySchedule[ksRow++];
    t0 = t0 >>> 0;
    t1 = t1 >>> 0;
    t2 = t2 >>> 0;
    t3 = t3 >>> 0;
    return [
        t0,
        t1,
        t2,
        t3
    ];
}
// AES constants
var $dd5b60bed61b3c64$var$RCON = [
    0x00,
    0x01,
    0x02,
    0x04,
    0x08,
    0x10,
    0x20,
    0x40,
    0x80,
    0x1b,
    0x36
];
var $dd5b60bed61b3c64$var$G = function() {
    // Compute double table
    var d = new Array(256);
    for(var j = 0; j < 256; j++)if (j < 128) d[j] = j << 1;
    else d[j] = j << 1 ^ 0x11b;
    var SBOX = [];
    var INV_SBOX = [];
    var SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    var INV_SUB_MIX = [
        [],
        [],
        [],
        []
    ];
    // Walk GF(2^8)
    var x = 0;
    var xi = 0;
    for(var i = 0; i < 256; ++i){
        // Compute sbox
        var sx = xi ^ xi << 1 ^ xi << 2 ^ xi << 3 ^ xi << 4;
        sx = sx >>> 8 ^ sx & 0xff ^ 0x63;
        SBOX[x] = sx;
        INV_SBOX[sx] = x;
        // Compute multiplication
        var x2 = d[x];
        var x4 = d[x2];
        var x8 = d[x4];
        // Compute sub bytes, mix columns tables
        var t = d[sx] * 0x101 ^ sx * 0x1010100;
        SUB_MIX[0][x] = t << 24 | t >>> 8;
        SUB_MIX[1][x] = t << 16 | t >>> 16;
        SUB_MIX[2][x] = t << 8 | t >>> 24;
        SUB_MIX[3][x] = t;
        // Compute inv sub bytes, inv mix columns tables
        t = x8 * 0x1010101 ^ x4 * 0x10001 ^ x2 * 0x101 ^ x * 0x1010100;
        INV_SUB_MIX[0][sx] = t << 24 | t >>> 8;
        INV_SUB_MIX[1][sx] = t << 16 | t >>> 16;
        INV_SUB_MIX[2][sx] = t << 8 | t >>> 24;
        INV_SUB_MIX[3][sx] = t;
        if (x === 0) x = xi = 1;
        else {
            x = x2 ^ d[d[d[x8 ^ x2]]];
            xi ^= d[d[xi]];
        }
    }
    return {
        SBOX: SBOX,
        INV_SBOX: INV_SBOX,
        SUB_MIX: SUB_MIX,
        INV_SUB_MIX: INV_SUB_MIX
    };
}();
function $dd5b60bed61b3c64$var$AES(key) {
    this._key = $dd5b60bed61b3c64$var$asUInt32Array(key);
    this._reset();
}
$dd5b60bed61b3c64$var$AES.blockSize = 16;
$dd5b60bed61b3c64$var$AES.keySize = 32;
$dd5b60bed61b3c64$var$AES.prototype.blockSize = $dd5b60bed61b3c64$var$AES.blockSize;
$dd5b60bed61b3c64$var$AES.prototype.keySize = $dd5b60bed61b3c64$var$AES.keySize;
$dd5b60bed61b3c64$var$AES.prototype._reset = function() {
    var keyWords = this._key;
    var keySize = keyWords.length;
    var nRounds = keySize + 6;
    var ksRows = (nRounds + 1) * 4;
    var keySchedule = [];
    for(var k = 0; k < keySize; k++)keySchedule[k] = keyWords[k];
    for(k = keySize; k < ksRows; k++){
        var t = keySchedule[k - 1];
        if (k % keySize === 0) {
            t = t << 8 | t >>> 24;
            t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
            t ^= $dd5b60bed61b3c64$var$RCON[k / keySize | 0] << 24;
        } else if (keySize > 6 && k % keySize === 4) t = $dd5b60bed61b3c64$var$G.SBOX[t >>> 24] << 24 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 16 & 0xff] << 16 | $dd5b60bed61b3c64$var$G.SBOX[t >>> 8 & 0xff] << 8 | $dd5b60bed61b3c64$var$G.SBOX[t & 0xff];
        keySchedule[k] = keySchedule[k - keySize] ^ t;
    }
    var invKeySchedule = [];
    for(var ik = 0; ik < ksRows; ik++){
        var ksR = ksRows - ik;
        var tt = keySchedule[ksR - (ik % 4 ? 0 : 4)];
        if (ik < 4 || ksR <= 4) invKeySchedule[ik] = tt;
        else invKeySchedule[ik] = $dd5b60bed61b3c64$var$G.INV_SUB_MIX[0][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 24]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[1][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 16 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[2][$dd5b60bed61b3c64$var$G.SBOX[tt >>> 8 & 0xff]] ^ $dd5b60bed61b3c64$var$G.INV_SUB_MIX[3][$dd5b60bed61b3c64$var$G.SBOX[tt & 0xff]];
    }
    this._nRounds = nRounds;
    this._keySchedule = keySchedule;
    this._invKeySchedule = invKeySchedule;
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlockRaw = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    return $dd5b60bed61b3c64$var$cryptBlock(M, this._keySchedule, $dd5b60bed61b3c64$var$G.SUB_MIX, $dd5b60bed61b3c64$var$G.SBOX, this._nRounds);
};
$dd5b60bed61b3c64$var$AES.prototype.encryptBlock = function(M) {
    var out = this.encryptBlockRaw(M);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[1], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[3], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.decryptBlock = function(M) {
    M = $dd5b60bed61b3c64$var$asUInt32Array(M);
    // swap
    var m1 = M[1];
    M[1] = M[3];
    M[3] = m1;
    var out = $dd5b60bed61b3c64$var$cryptBlock(M, this._invKeySchedule, $dd5b60bed61b3c64$var$G.INV_SUB_MIX, $dd5b60bed61b3c64$var$G.INV_SBOX, this._nRounds);
    var buf = $dd5b60bed61b3c64$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0], 0);
    buf.writeUInt32BE(out[3], 4);
    buf.writeUInt32BE(out[2], 8);
    buf.writeUInt32BE(out[1], 12);
    return buf;
};
$dd5b60bed61b3c64$var$AES.prototype.scrub = function() {
    $dd5b60bed61b3c64$var$scrubVec(this._keySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._invKeySchedule);
    $dd5b60bed61b3c64$var$scrubVec(this._key);
};
$dd5b60bed61b3c64$export$b80fbe1c3a2b92b5 = $dd5b60bed61b3c64$var$AES;

});

parcelRegister("5Z5i8", function(module, exports) {

var $1U9GM = parcelRequire("1U9GM");
var $45b6c10c8dc18438$require$Buffer = $1U9GM.Buffer;
var $45b6c10c8dc18438$var$ZEROES = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
function $45b6c10c8dc18438$var$toArray(buf) {
    return [
        buf.readUInt32BE(0),
        buf.readUInt32BE(4),
        buf.readUInt32BE(8),
        buf.readUInt32BE(12)
    ];
}
function $45b6c10c8dc18438$var$fromArray(out) {
    var buf = $45b6c10c8dc18438$require$Buffer.allocUnsafe(16);
    buf.writeUInt32BE(out[0] >>> 0, 0);
    buf.writeUInt32BE(out[1] >>> 0, 4);
    buf.writeUInt32BE(out[2] >>> 0, 8);
    buf.writeUInt32BE(out[3] >>> 0, 12);
    return buf;
}
function $45b6c10c8dc18438$var$GHASH(key) {
    this.h = key;
    this.state = $45b6c10c8dc18438$require$Buffer.alloc(16, 0);
    this.cache = $45b6c10c8dc18438$require$Buffer.allocUnsafe(0);
}
// from http://bitwiseshiftleft.github.io/sjcl/doc/symbols/src/core_gcm.js.html
// by Juho Vähä-Herttua
$45b6c10c8dc18438$var$GHASH.prototype.ghash = function(block) {
    var i = -1;
    while(++i < block.length)this.state[i] ^= block[i];
    this._multiply();
};
$45b6c10c8dc18438$var$GHASH.prototype._multiply = function() {
    var Vi = $45b6c10c8dc18438$var$toArray(this.h);
    var Zi = [
        0,
        0,
        0,
        0
    ];
    var j, xi, lsbVi;
    var i = -1;
    while(++i < 128){
        xi = (this.state[~~(i / 8)] & 1 << 7 - i % 8) !== 0;
        if (xi) {
            // Z_i+1 = Z_i ^ V_i
            Zi[0] ^= Vi[0];
            Zi[1] ^= Vi[1];
            Zi[2] ^= Vi[2];
            Zi[3] ^= Vi[3];
        }
        // Store the value of LSB(V_i)
        lsbVi = (Vi[3] & 1) !== 0;
        // V_i+1 = V_i >> 1
        for(j = 3; j > 0; j--)Vi[j] = Vi[j] >>> 1 | (Vi[j - 1] & 1) << 31;
        Vi[0] = Vi[0] >>> 1;
        // If LSB(V_i) is 1, V_i+1 = (V_i >> 1) ^ R
        if (lsbVi) Vi[0] = Vi[0] ^ -520093696;
    }
    this.state = $45b6c10c8dc18438$var$fromArray(Zi);
};
$45b6c10c8dc18438$var$GHASH.prototype.update = function(buf) {
    this.cache = $45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        buf
    ]);
    var chunk;
    while(this.cache.length >= 16){
        chunk = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        this.ghash(chunk);
    }
};
$45b6c10c8dc18438$var$GHASH.prototype.final = function(abl, bl) {
    if (this.cache.length) this.ghash($45b6c10c8dc18438$require$Buffer.concat([
        this.cache,
        $45b6c10c8dc18438$var$ZEROES
    ], 16));
    this.ghash($45b6c10c8dc18438$var$fromArray([
        0,
        abl,
        0,
        bl
    ]));
    return this.state;
};
module.exports = $45b6c10c8dc18438$var$GHASH;

});


parcelRegister("hzsAp", function(module, exports) {

var $j0hdX = parcelRequire("j0hdX");

var $1U9GM = parcelRequire("1U9GM");
var $ccabe1300e92c82b$require$Buffer = $1U9GM.Buffer;

var $26nOC = parcelRequire("26nOC");

var $dlqwk = parcelRequire("dlqwk");
function $ccabe1300e92c82b$var$StreamCipher(mode, key, iv, decrypt) {
    $26nOC.call(this);
    this._cipher = new $j0hdX.AES(key);
    this._prev = $ccabe1300e92c82b$require$Buffer.from(iv);
    this._cache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._secCache = $ccabe1300e92c82b$require$Buffer.allocUnsafe(0);
    this._decrypt = decrypt;
    this._mode = mode;
}
$dlqwk($ccabe1300e92c82b$var$StreamCipher, $26nOC);
$ccabe1300e92c82b$var$StreamCipher.prototype._update = function(chunk) {
    return this._mode.encrypt(this, chunk, this._decrypt);
};
$ccabe1300e92c82b$var$StreamCipher.prototype._final = function() {
    this._cipher.scrub();
};
module.exports = $ccabe1300e92c82b$var$StreamCipher;

});


parcelRegister("aSTOs", function(module, exports) {

$parcel$export(module.exports, "createDecipher", () => $7eca3dd1d6757703$export$12ada9414fbc594c, (v) => $7eca3dd1d6757703$export$12ada9414fbc594c = v);
$parcel$export(module.exports, "createDecipheriv", () => $7eca3dd1d6757703$export$36b6d6ef312eab39, (v) => $7eca3dd1d6757703$export$36b6d6ef312eab39 = v);
var $7eca3dd1d6757703$export$12ada9414fbc594c;
var $7eca3dd1d6757703$export$36b6d6ef312eab39;

var $lyZ5N = parcelRequire("lyZ5N");

var $1U9GM = parcelRequire("1U9GM");
var $7eca3dd1d6757703$require$Buffer = $1U9GM.Buffer;

var $5Su5u = parcelRequire("5Su5u");

var $hzsAp = parcelRequire("hzsAp");

var $26nOC = parcelRequire("26nOC");

var $j0hdX = parcelRequire("j0hdX");

var $bSYjd = parcelRequire("bSYjd");

var $dlqwk = parcelRequire("dlqwk");
function $7eca3dd1d6757703$var$Decipher(mode, key, iv) {
    $26nOC.call(this);
    this._cache = new $7eca3dd1d6757703$var$Splitter();
    this._last = void 0;
    this._cipher = new $j0hdX.AES(key);
    this._prev = $7eca3dd1d6757703$require$Buffer.from(iv);
    this._mode = mode;
    this._autopadding = true;
}
$dlqwk($7eca3dd1d6757703$var$Decipher, $26nOC);
$7eca3dd1d6757703$var$Decipher.prototype._update = function(data) {
    this._cache.add(data);
    var chunk;
    var thing;
    var out = [];
    while(chunk = this._cache.get(this._autopadding)){
        thing = this._mode.decrypt(this, chunk);
        out.push(thing);
    }
    return $7eca3dd1d6757703$require$Buffer.concat(out);
};
$7eca3dd1d6757703$var$Decipher.prototype._final = function() {
    var chunk = this._cache.flush();
    if (this._autopadding) return $7eca3dd1d6757703$var$unpad(this._mode.decrypt(this, chunk));
    else if (chunk) throw new Error("data not multiple of block length");
};
$7eca3dd1d6757703$var$Decipher.prototype.setAutoPadding = function(setTo) {
    this._autopadding = !!setTo;
    return this;
};
function $7eca3dd1d6757703$var$Splitter() {
    this.cache = $7eca3dd1d6757703$require$Buffer.allocUnsafe(0);
}
$7eca3dd1d6757703$var$Splitter.prototype.add = function(data) {
    this.cache = $7eca3dd1d6757703$require$Buffer.concat([
        this.cache,
        data
    ]);
};
$7eca3dd1d6757703$var$Splitter.prototype.get = function(autoPadding) {
    var out;
    if (autoPadding) {
        if (this.cache.length > 16) {
            out = this.cache.slice(0, 16);
            this.cache = this.cache.slice(16);
            return out;
        }
    } else if (this.cache.length >= 16) {
        out = this.cache.slice(0, 16);
        this.cache = this.cache.slice(16);
        return out;
    }
    return null;
};
$7eca3dd1d6757703$var$Splitter.prototype.flush = function() {
    if (this.cache.length) return this.cache;
};
function $7eca3dd1d6757703$var$unpad(last) {
    var padded = last[15];
    if (padded < 1 || padded > 16) throw new Error("unable to decrypt data");
    var i = -1;
    while(++i < padded){
        if (last[i + (16 - padded)] !== padded) throw new Error("unable to decrypt data");
    }
    if (padded === 16) return;
    return last.slice(0, 16 - padded);
}
function $7eca3dd1d6757703$var$createDecipheriv(suite, password, iv) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    if (typeof iv === "string") iv = $7eca3dd1d6757703$require$Buffer.from(iv);
    if (config.mode !== "GCM" && iv.length !== config.iv) throw new TypeError("invalid iv length " + iv.length);
    if (typeof password === "string") password = $7eca3dd1d6757703$require$Buffer.from(password);
    if (password.length !== config.key / 8) throw new TypeError("invalid key length " + password.length);
    if (config.type === "stream") return new $hzsAp(config.module, password, iv, true);
    else if (config.type === "auth") return new $lyZ5N(config.module, password, iv, true);
    return new $7eca3dd1d6757703$var$Decipher(config.module, password, iv);
}
function $7eca3dd1d6757703$var$createDecipher(suite, password) {
    var config = $5Su5u[suite.toLowerCase()];
    if (!config) throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, config.key, config.iv);
    return $7eca3dd1d6757703$var$createDecipheriv(suite, keys.key, keys.iv);
}
$7eca3dd1d6757703$export$12ada9414fbc594c = $7eca3dd1d6757703$var$createDecipher;
$7eca3dd1d6757703$export$36b6d6ef312eab39 = $7eca3dd1d6757703$var$createDecipheriv;

});



parcelRegister("lORrZ", function(module, exports) {

$parcel$export(module.exports, "pbkdf2", () => $fe27baa2ca96071e$export$448fa22aedc9dbca, (v) => $fe27baa2ca96071e$export$448fa22aedc9dbca = v);
$parcel$export(module.exports, "pbkdf2Sync", () => $fe27baa2ca96071e$export$b80c7ba289c8fa56, (v) => $fe27baa2ca96071e$export$b80c7ba289c8fa56 = v);
var $fe27baa2ca96071e$export$448fa22aedc9dbca;
var $fe27baa2ca96071e$export$b80c7ba289c8fa56;

$fe27baa2ca96071e$export$448fa22aedc9dbca = (parcelRequire("5dQ72"));

$fe27baa2ca96071e$export$b80c7ba289c8fa56 = (parcelRequire("1VtKc"));

});


parcelRegister("5BMkJ", function(module, exports) {

var $1R2J7 = parcelRequire("1R2J7");

var $1U9GM = parcelRequire("1U9GM");
var $4155e6705a7c8e0e$require$Buffer = $1U9GM.Buffer;
module.exports = function(seed, len) {
    var t = $4155e6705a7c8e0e$require$Buffer.alloc(0);
    var i = 0;
    var c;
    while(t.length < len){
        c = $4155e6705a7c8e0e$var$i2ops(i++);
        t = $4155e6705a7c8e0e$require$Buffer.concat([
            t,
            $1R2J7("sha1").update(seed).update(c).digest()
        ]);
    }
    return t.slice(0, len);
};
function $4155e6705a7c8e0e$var$i2ops(c) {
    var out = $4155e6705a7c8e0e$require$Buffer.allocUnsafe(4);
    out.writeUInt32BE(c, 0);
    return out;
}

});

parcelRegister("6nrMP", function(module, exports) {
module.exports = function xor(a, b) {
    var len = a.length;
    var i = -1;
    while(++i < len)a[i] ^= b[i];
    return a;
};

});

parcelRegister("6rDPA", function(module, exports) {

(function(module1, exports) {
    "use strict";
    // Utils
    function assert(val, msg) {
        if (!val) throw new Error(msg || "Assertion failed");
    }
    // Could use `inherits` module, but don't want to move from single file
    // architecture yet.
    function inherits(ctor, superCtor) {
        ctor.super_ = superCtor;
        var TempCtor = function() {};
        TempCtor.prototype = superCtor.prototype;
        ctor.prototype = new TempCtor();
        ctor.prototype.constructor = ctor;
    }
    // BN
    function BN(number, base, endian) {
        if (BN.isBN(number)) return number;
        this.negative = 0;
        this.words = null;
        this.length = 0;
        // Reduction context
        this.red = null;
        if (number !== null) {
            if (base === "le" || base === "be") {
                endian = base;
                base = 10;
            }
            this._init(number || 0, base || 10, endian || "be");
        }
    }
    if (typeof module1 === "object") module1.exports = BN;
    else exports.BN = BN;
    BN.BN = BN;
    BN.wordSize = 26;
    var Buffer;
    try {
        if (typeof window !== "undefined" && typeof window.Buffer !== "undefined") Buffer = window.Buffer;
        else Buffer = (parcelRequire("kjyEk")).Buffer;
    } catch (e) {}
    BN.isBN = function isBN(num) {
        if (num instanceof BN) return true;
        return num !== null && typeof num === "object" && num.constructor.wordSize === BN.wordSize && Array.isArray(num.words);
    };
    BN.max = function max(left, right) {
        if (left.cmp(right) > 0) return left;
        return right;
    };
    BN.min = function min(left, right) {
        if (left.cmp(right) < 0) return left;
        return right;
    };
    BN.prototype._init = function init(number, base, endian) {
        if (typeof number === "number") return this._initNumber(number, base, endian);
        if (typeof number === "object") return this._initArray(number, base, endian);
        if (base === "hex") base = 16;
        assert(base === (base | 0) && base >= 2 && base <= 36);
        number = number.toString().replace(/\s+/g, "");
        var start = 0;
        if (number[0] === "-") {
            start++;
            this.negative = 1;
        }
        if (start < number.length) {
            if (base === 16) this._parseHex(number, start, endian);
            else {
                this._parseBase(number, base, start);
                if (endian === "le") this._initArray(this.toArray(), base, endian);
            }
        }
    };
    BN.prototype._initNumber = function _initNumber(number, base, endian) {
        if (number < 0) {
            this.negative = 1;
            number = -number;
        }
        if (number < 0x4000000) {
            this.words = [
                number & 0x3ffffff
            ];
            this.length = 1;
        } else if (number < 0x10000000000000) {
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff
            ];
            this.length = 2;
        } else {
            assert(number < 0x20000000000000); // 2 ^ 53 (unsafe)
            this.words = [
                number & 0x3ffffff,
                number / 0x4000000 & 0x3ffffff,
                1
            ];
            this.length = 3;
        }
        if (endian !== "le") return;
        // Reverse the bytes
        this._initArray(this.toArray(), base, endian);
    };
    BN.prototype._initArray = function _initArray(number, base, endian) {
        // Perhaps a Uint8Array
        assert(typeof number.length === "number");
        if (number.length <= 0) {
            this.words = [
                0
            ];
            this.length = 1;
            return this;
        }
        this.length = Math.ceil(number.length / 3);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        var j, w;
        var off = 0;
        if (endian === "be") for(i = number.length - 1, j = 0; i >= 0; i -= 3){
            w = number[i] | number[i - 1] << 8 | number[i - 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        else if (endian === "le") for(i = 0, j = 0; i < number.length; i += 3){
            w = number[i] | number[i + 1] << 8 | number[i + 2] << 16;
            this.words[j] |= w << off & 0x3ffffff;
            this.words[j + 1] = w >>> 26 - off & 0x3ffffff;
            off += 24;
            if (off >= 26) {
                off -= 26;
                j++;
            }
        }
        return this.strip();
    };
    function parseHex4Bits(string, index) {
        var c = string.charCodeAt(index);
        // 'A' - 'F'
        if (c >= 65 && c <= 70) return c - 55;
        else if (c >= 97 && c <= 102) return c - 87;
        else return c - 48 & 0xf;
    }
    function parseHexByte(string, lowerBound, index) {
        var r = parseHex4Bits(string, index);
        if (index - 1 >= lowerBound) r |= parseHex4Bits(string, index - 1) << 4;
        return r;
    }
    BN.prototype._parseHex = function _parseHex(number, start, endian) {
        // Create possibly bigger array to ensure that it fits the number
        this.length = Math.ceil((number.length - start) / 6);
        this.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)this.words[i] = 0;
        // 24-bits chunks
        var off = 0;
        var j = 0;
        var w;
        if (endian === "be") for(i = number.length - 1; i >= start; i -= 2){
            w = parseHexByte(number, start, i) << off;
            this.words[j] |= w & 0x3ffffff;
            if (off >= 18) {
                off -= 18;
                j += 1;
                this.words[j] |= w >>> 26;
            } else off += 8;
        }
        else {
            var parseLength = number.length - start;
            for(i = parseLength % 2 === 0 ? start + 1 : start; i < number.length; i += 2){
                w = parseHexByte(number, start, i) << off;
                this.words[j] |= w & 0x3ffffff;
                if (off >= 18) {
                    off -= 18;
                    j += 1;
                    this.words[j] |= w >>> 26;
                } else off += 8;
            }
        }
        this.strip();
    };
    function parseBase(str, start, end, mul) {
        var r = 0;
        var len = Math.min(str.length, end);
        for(var i = start; i < len; i++){
            var c = str.charCodeAt(i) - 48;
            r *= mul;
            // 'a'
            if (c >= 49) r += c - 49 + 0xa;
            else if (c >= 17) r += c - 17 + 0xa;
            else r += c;
        }
        return r;
    }
    BN.prototype._parseBase = function _parseBase(number, base, start) {
        // Initialize as zero
        this.words = [
            0
        ];
        this.length = 1;
        // Find length of limb in base
        for(var limbLen = 0, limbPow = 1; limbPow <= 0x3ffffff; limbPow *= base)limbLen++;
        limbLen--;
        limbPow = limbPow / base | 0;
        var total = number.length - start;
        var mod = total % limbLen;
        var end = Math.min(total, total - mod) + start;
        var word = 0;
        for(var i = start; i < end; i += limbLen){
            word = parseBase(number, i, i + limbLen, base);
            this.imuln(limbPow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        if (mod !== 0) {
            var pow = 1;
            word = parseBase(number, i, number.length, base);
            for(i = 0; i < mod; i++)pow *= base;
            this.imuln(pow);
            if (this.words[0] + word < 0x4000000) this.words[0] += word;
            else this._iaddn(word);
        }
        this.strip();
    };
    BN.prototype.copy = function copy(dest) {
        dest.words = new Array(this.length);
        for(var i = 0; i < this.length; i++)dest.words[i] = this.words[i];
        dest.length = this.length;
        dest.negative = this.negative;
        dest.red = this.red;
    };
    BN.prototype.clone = function clone() {
        var r = new BN(null);
        this.copy(r);
        return r;
    };
    BN.prototype._expand = function _expand(size) {
        while(this.length < size)this.words[this.length++] = 0;
        return this;
    };
    // Remove leading `0` from `this`
    BN.prototype.strip = function strip() {
        while(this.length > 1 && this.words[this.length - 1] === 0)this.length--;
        return this._normSign();
    };
    BN.prototype._normSign = function _normSign() {
        // -0 = 0
        if (this.length === 1 && this.words[0] === 0) this.negative = 0;
        return this;
    };
    BN.prototype.inspect = function inspect() {
        return (this.red ? "<BN-R: " : "<BN: ") + this.toString(16) + ">";
    };
    /*

  var zeros = [];
  var groupSizes = [];
  var groupBases = [];

  var s = '';
  var i = -1;
  while (++i < BN.wordSize) {
    zeros[i] = s;
    s += '0';
  }
  groupSizes[0] = 0;
  groupSizes[1] = 0;
  groupBases[0] = 0;
  groupBases[1] = 0;
  var base = 2 - 1;
  while (++base < 36 + 1) {
    var groupSize = 0;
    var groupBase = 1;
    while (groupBase < (1 << BN.wordSize) / base) {
      groupBase *= base;
      groupSize += 1;
    }
    groupSizes[base] = groupSize;
    groupBases[base] = groupBase;
  }

  */ var zeros = [
        "",
        "0",
        "00",
        "000",
        "0000",
        "00000",
        "000000",
        "0000000",
        "00000000",
        "000000000",
        "0000000000",
        "00000000000",
        "000000000000",
        "0000000000000",
        "00000000000000",
        "000000000000000",
        "0000000000000000",
        "00000000000000000",
        "000000000000000000",
        "0000000000000000000",
        "00000000000000000000",
        "000000000000000000000",
        "0000000000000000000000",
        "00000000000000000000000",
        "000000000000000000000000",
        "0000000000000000000000000"
    ];
    var groupSizes = [
        0,
        0,
        25,
        16,
        12,
        11,
        10,
        9,
        8,
        8,
        7,
        7,
        7,
        7,
        6,
        6,
        6,
        6,
        6,
        6,
        6,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5,
        5
    ];
    var groupBases = [
        0,
        0,
        33554432,
        43046721,
        16777216,
        48828125,
        60466176,
        40353607,
        16777216,
        43046721,
        10000000,
        19487171,
        35831808,
        62748517,
        7529536,
        11390625,
        16777216,
        24137569,
        34012224,
        47045881,
        64000000,
        4084101,
        5153632,
        6436343,
        7962624,
        9765625,
        11881376,
        14348907,
        17210368,
        20511149,
        24300000,
        28629151,
        33554432,
        39135393,
        45435424,
        52521875,
        60466176
    ];
    BN.prototype.toString = function toString(base, padding) {
        base = base || 10;
        padding = padding | 0 || 1;
        var out;
        if (base === 16 || base === "hex") {
            out = "";
            var off = 0;
            var carry = 0;
            for(var i = 0; i < this.length; i++){
                var w = this.words[i];
                var word = ((w << off | carry) & 0xffffff).toString(16);
                carry = w >>> 24 - off & 0xffffff;
                if (carry !== 0 || i !== this.length - 1) out = zeros[6 - word.length] + word + out;
                else out = word + out;
                off += 2;
                if (off >= 26) {
                    off -= 26;
                    i--;
                }
            }
            if (carry !== 0) out = carry.toString(16) + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        if (base === (base | 0) && base >= 2 && base <= 36) {
            // var groupSize = Math.floor(BN.wordSize * Math.LN2 / Math.log(base));
            var groupSize = groupSizes[base];
            // var groupBase = Math.pow(base, groupSize);
            var groupBase = groupBases[base];
            out = "";
            var c = this.clone();
            c.negative = 0;
            while(!c.isZero()){
                var r = c.modn(groupBase).toString(base);
                c = c.idivn(groupBase);
                if (!c.isZero()) out = zeros[groupSize - r.length] + r + out;
                else out = r + out;
            }
            if (this.isZero()) out = "0" + out;
            while(out.length % padding !== 0)out = "0" + out;
            if (this.negative !== 0) out = "-" + out;
            return out;
        }
        assert(false, "Base should be between 2 and 36");
    };
    BN.prototype.toNumber = function toNumber() {
        var ret = this.words[0];
        if (this.length === 2) ret += this.words[1] * 0x4000000;
        else if (this.length === 3 && this.words[2] === 0x01) // NOTE: at this stage it is known that the top bit is set
        ret += 0x10000000000000 + this.words[1] * 0x4000000;
        else if (this.length > 2) assert(false, "Number can only safely store up to 53 bits");
        return this.negative !== 0 ? -ret : ret;
    };
    BN.prototype.toJSON = function toJSON() {
        return this.toString(16);
    };
    BN.prototype.toBuffer = function toBuffer(endian, length) {
        assert(typeof Buffer !== "undefined");
        return this.toArrayLike(Buffer, endian, length);
    };
    BN.prototype.toArray = function toArray(endian, length) {
        return this.toArrayLike(Array, endian, length);
    };
    BN.prototype.toArrayLike = function toArrayLike(ArrayType, endian, length) {
        var byteLength = this.byteLength();
        var reqLength = length || Math.max(1, byteLength);
        assert(byteLength <= reqLength, "byte array longer than desired length");
        assert(reqLength > 0, "Requested array length <= 0");
        this.strip();
        var littleEndian = endian === "le";
        var res = new ArrayType(reqLength);
        var b, i;
        var q = this.clone();
        if (!littleEndian) {
            // Assume big-endian
            for(i = 0; i < reqLength - byteLength; i++)res[i] = 0;
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[reqLength - i - 1] = b;
            }
        } else {
            for(i = 0; !q.isZero(); i++){
                b = q.andln(0xff);
                q.iushrn(8);
                res[i] = b;
            }
            for(; i < reqLength; i++)res[i] = 0;
        }
        return res;
    };
    if (Math.clz32) BN.prototype._countBits = function _countBits(w) {
        return 32 - Math.clz32(w);
    };
    else BN.prototype._countBits = function _countBits(w) {
        var t = w;
        var r = 0;
        if (t >= 0x1000) {
            r += 13;
            t >>>= 13;
        }
        if (t >= 0x40) {
            r += 7;
            t >>>= 7;
        }
        if (t >= 0x8) {
            r += 4;
            t >>>= 4;
        }
        if (t >= 0x02) {
            r += 2;
            t >>>= 2;
        }
        return r + t;
    };
    BN.prototype._zeroBits = function _zeroBits(w) {
        // Short-cut
        if (w === 0) return 26;
        var t = w;
        var r = 0;
        if ((t & 0x1fff) === 0) {
            r += 13;
            t >>>= 13;
        }
        if ((t & 0x7f) === 0) {
            r += 7;
            t >>>= 7;
        }
        if ((t & 0xf) === 0) {
            r += 4;
            t >>>= 4;
        }
        if ((t & 0x3) === 0) {
            r += 2;
            t >>>= 2;
        }
        if ((t & 0x1) === 0) r++;
        return r;
    };
    // Return number of used bits in a BN
    BN.prototype.bitLength = function bitLength() {
        var w = this.words[this.length - 1];
        var hi = this._countBits(w);
        return (this.length - 1) * 26 + hi;
    };
    function toBitArray(num) {
        var w = new Array(num.bitLength());
        for(var bit = 0; bit < w.length; bit++){
            var off = bit / 26 | 0;
            var wbit = bit % 26;
            w[bit] = (num.words[off] & 1 << wbit) >>> wbit;
        }
        return w;
    }
    // Number of trailing zero bits
    BN.prototype.zeroBits = function zeroBits() {
        if (this.isZero()) return 0;
        var r = 0;
        for(var i = 0; i < this.length; i++){
            var b = this._zeroBits(this.words[i]);
            r += b;
            if (b !== 26) break;
        }
        return r;
    };
    BN.prototype.byteLength = function byteLength() {
        return Math.ceil(this.bitLength() / 8);
    };
    BN.prototype.toTwos = function toTwos(width) {
        if (this.negative !== 0) return this.abs().inotn(width).iaddn(1);
        return this.clone();
    };
    BN.prototype.fromTwos = function fromTwos(width) {
        if (this.testn(width - 1)) return this.notn(width).iaddn(1).ineg();
        return this.clone();
    };
    BN.prototype.isNeg = function isNeg() {
        return this.negative !== 0;
    };
    // Return negative clone of `this`
    BN.prototype.neg = function neg() {
        return this.clone().ineg();
    };
    BN.prototype.ineg = function ineg() {
        if (!this.isZero()) this.negative ^= 1;
        return this;
    };
    // Or `num` with `this` in-place
    BN.prototype.iuor = function iuor(num) {
        while(this.length < num.length)this.words[this.length++] = 0;
        for(var i = 0; i < num.length; i++)this.words[i] = this.words[i] | num.words[i];
        return this.strip();
    };
    BN.prototype.ior = function ior(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuor(num);
    };
    // Or `num` with `this`
    BN.prototype.or = function or(num) {
        if (this.length > num.length) return this.clone().ior(num);
        return num.clone().ior(this);
    };
    BN.prototype.uor = function uor(num) {
        if (this.length > num.length) return this.clone().iuor(num);
        return num.clone().iuor(this);
    };
    // And `num` with `this` in-place
    BN.prototype.iuand = function iuand(num) {
        // b = min-length(num, this)
        var b;
        if (this.length > num.length) b = num;
        else b = this;
        for(var i = 0; i < b.length; i++)this.words[i] = this.words[i] & num.words[i];
        this.length = b.length;
        return this.strip();
    };
    BN.prototype.iand = function iand(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuand(num);
    };
    // And `num` with `this`
    BN.prototype.and = function and(num) {
        if (this.length > num.length) return this.clone().iand(num);
        return num.clone().iand(this);
    };
    BN.prototype.uand = function uand(num) {
        if (this.length > num.length) return this.clone().iuand(num);
        return num.clone().iuand(this);
    };
    // Xor `num` with `this` in-place
    BN.prototype.iuxor = function iuxor(num) {
        // a.length > b.length
        var a;
        var b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        for(var i = 0; i < b.length; i++)this.words[i] = a.words[i] ^ b.words[i];
        if (this !== a) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = a.length;
        return this.strip();
    };
    BN.prototype.ixor = function ixor(num) {
        assert((this.negative | num.negative) === 0);
        return this.iuxor(num);
    };
    // Xor `num` with `this`
    BN.prototype.xor = function xor(num) {
        if (this.length > num.length) return this.clone().ixor(num);
        return num.clone().ixor(this);
    };
    BN.prototype.uxor = function uxor(num) {
        if (this.length > num.length) return this.clone().iuxor(num);
        return num.clone().iuxor(this);
    };
    // Not ``this`` with ``width`` bitwidth
    BN.prototype.inotn = function inotn(width) {
        assert(typeof width === "number" && width >= 0);
        var bytesNeeded = Math.ceil(width / 26) | 0;
        var bitsLeft = width % 26;
        // Extend the buffer with leading zeroes
        this._expand(bytesNeeded);
        if (bitsLeft > 0) bytesNeeded--;
        // Handle complete words
        for(var i = 0; i < bytesNeeded; i++)this.words[i] = ~this.words[i] & 0x3ffffff;
        // Handle the residue
        if (bitsLeft > 0) this.words[i] = ~this.words[i] & 0x3ffffff >> 26 - bitsLeft;
        // And remove leading zeroes
        return this.strip();
    };
    BN.prototype.notn = function notn(width) {
        return this.clone().inotn(width);
    };
    // Set `bit` of `this`
    BN.prototype.setn = function setn(bit, val) {
        assert(typeof bit === "number" && bit >= 0);
        var off = bit / 26 | 0;
        var wbit = bit % 26;
        this._expand(off + 1);
        if (val) this.words[off] = this.words[off] | 1 << wbit;
        else this.words[off] = this.words[off] & ~(1 << wbit);
        return this.strip();
    };
    // Add `num` to `this` in-place
    BN.prototype.iadd = function iadd(num) {
        var r;
        // negative + positive
        if (this.negative !== 0 && num.negative === 0) {
            this.negative = 0;
            r = this.isub(num);
            this.negative ^= 1;
            return this._normSign();
        // positive + negative
        } else if (this.negative === 0 && num.negative !== 0) {
            num.negative = 0;
            r = this.isub(num);
            num.negative = 1;
            return r._normSign();
        }
        // a.length > b.length
        var a, b;
        if (this.length > num.length) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) + (b.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            this.words[i] = r & 0x3ffffff;
            carry = r >>> 26;
        }
        this.length = a.length;
        if (carry !== 0) {
            this.words[this.length] = carry;
            this.length++;
        // Copy the rest of the words
        } else if (a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        return this;
    };
    // Add `num` to `this`
    BN.prototype.add = function add(num) {
        var res;
        if (num.negative !== 0 && this.negative === 0) {
            num.negative = 0;
            res = this.sub(num);
            num.negative ^= 1;
            return res;
        } else if (num.negative === 0 && this.negative !== 0) {
            this.negative = 0;
            res = num.sub(this);
            this.negative = 1;
            return res;
        }
        if (this.length > num.length) return this.clone().iadd(num);
        return num.clone().iadd(this);
    };
    // Subtract `num` from `this` in-place
    BN.prototype.isub = function isub(num) {
        // this - (-num) = this + num
        if (num.negative !== 0) {
            num.negative = 0;
            var r = this.iadd(num);
            num.negative = 1;
            return r._normSign();
        // -this - num = -(this + num)
        } else if (this.negative !== 0) {
            this.negative = 0;
            this.iadd(num);
            this.negative = 1;
            return this._normSign();
        }
        // At this point both numbers are positive
        var cmp = this.cmp(num);
        // Optimization - zeroify
        if (cmp === 0) {
            this.negative = 0;
            this.length = 1;
            this.words[0] = 0;
            return this;
        }
        // a > b
        var a, b;
        if (cmp > 0) {
            a = this;
            b = num;
        } else {
            a = num;
            b = this;
        }
        var carry = 0;
        for(var i = 0; i < b.length; i++){
            r = (a.words[i] | 0) - (b.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        for(; carry !== 0 && i < a.length; i++){
            r = (a.words[i] | 0) + carry;
            carry = r >> 26;
            this.words[i] = r & 0x3ffffff;
        }
        // Copy rest of the words
        if (carry === 0 && i < a.length && a !== this) for(; i < a.length; i++)this.words[i] = a.words[i];
        this.length = Math.max(this.length, i);
        if (a !== this) this.negative = 1;
        return this.strip();
    };
    // Subtract `num` from `this`
    BN.prototype.sub = function sub(num) {
        return this.clone().isub(num);
    };
    function smallMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        var len = self.length + num.length | 0;
        out.length = len;
        len = len - 1 | 0;
        // Peel one iteration (compiler can't do it, because of code complexity)
        var a = self.words[0] | 0;
        var b = num.words[0] | 0;
        var r = a * b;
        var lo = r & 0x3ffffff;
        var carry = r / 0x4000000 | 0;
        out.words[0] = lo;
        for(var k = 1; k < len; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = carry >>> 26;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j | 0;
                a = self.words[i] | 0;
                b = num.words[j] | 0;
                r = a * b + rword;
                ncarry += r / 0x4000000 | 0;
                rword = r & 0x3ffffff;
            }
            out.words[k] = rword | 0;
            carry = ncarry | 0;
        }
        if (carry !== 0) out.words[k] = carry | 0;
        else out.length--;
        return out.strip();
    }
    // TODO(indutny): it may be reasonable to omit it for users who don't need
    // to work with 256-bit numbers, otherwise it gives 20% improvement for 256-bit
    // multiplication (like elliptic secp256k1).
    var comb10MulTo = function comb10MulTo(self, num, out) {
        var a = self.words;
        var b = num.words;
        var o = out.words;
        var c = 0;
        var lo;
        var mid;
        var hi;
        var a0 = a[0] | 0;
        var al0 = a0 & 0x1fff;
        var ah0 = a0 >>> 13;
        var a1 = a[1] | 0;
        var al1 = a1 & 0x1fff;
        var ah1 = a1 >>> 13;
        var a2 = a[2] | 0;
        var al2 = a2 & 0x1fff;
        var ah2 = a2 >>> 13;
        var a3 = a[3] | 0;
        var al3 = a3 & 0x1fff;
        var ah3 = a3 >>> 13;
        var a4 = a[4] | 0;
        var al4 = a4 & 0x1fff;
        var ah4 = a4 >>> 13;
        var a5 = a[5] | 0;
        var al5 = a5 & 0x1fff;
        var ah5 = a5 >>> 13;
        var a6 = a[6] | 0;
        var al6 = a6 & 0x1fff;
        var ah6 = a6 >>> 13;
        var a7 = a[7] | 0;
        var al7 = a7 & 0x1fff;
        var ah7 = a7 >>> 13;
        var a8 = a[8] | 0;
        var al8 = a8 & 0x1fff;
        var ah8 = a8 >>> 13;
        var a9 = a[9] | 0;
        var al9 = a9 & 0x1fff;
        var ah9 = a9 >>> 13;
        var b0 = b[0] | 0;
        var bl0 = b0 & 0x1fff;
        var bh0 = b0 >>> 13;
        var b1 = b[1] | 0;
        var bl1 = b1 & 0x1fff;
        var bh1 = b1 >>> 13;
        var b2 = b[2] | 0;
        var bl2 = b2 & 0x1fff;
        var bh2 = b2 >>> 13;
        var b3 = b[3] | 0;
        var bl3 = b3 & 0x1fff;
        var bh3 = b3 >>> 13;
        var b4 = b[4] | 0;
        var bl4 = b4 & 0x1fff;
        var bh4 = b4 >>> 13;
        var b5 = b[5] | 0;
        var bl5 = b5 & 0x1fff;
        var bh5 = b5 >>> 13;
        var b6 = b[6] | 0;
        var bl6 = b6 & 0x1fff;
        var bh6 = b6 >>> 13;
        var b7 = b[7] | 0;
        var bl7 = b7 & 0x1fff;
        var bh7 = b7 >>> 13;
        var b8 = b[8] | 0;
        var bl8 = b8 & 0x1fff;
        var bh8 = b8 >>> 13;
        var b9 = b[9] | 0;
        var bl9 = b9 & 0x1fff;
        var bh9 = b9 >>> 13;
        out.negative = self.negative ^ num.negative;
        out.length = 19;
        /* k = 0 */ lo = Math.imul(al0, bl0);
        mid = Math.imul(al0, bh0);
        mid = mid + Math.imul(ah0, bl0) | 0;
        hi = Math.imul(ah0, bh0);
        var w0 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w0 >>> 26) | 0;
        w0 &= 0x3ffffff;
        /* k = 1 */ lo = Math.imul(al1, bl0);
        mid = Math.imul(al1, bh0);
        mid = mid + Math.imul(ah1, bl0) | 0;
        hi = Math.imul(ah1, bh0);
        lo = lo + Math.imul(al0, bl1) | 0;
        mid = mid + Math.imul(al0, bh1) | 0;
        mid = mid + Math.imul(ah0, bl1) | 0;
        hi = hi + Math.imul(ah0, bh1) | 0;
        var w1 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w1 >>> 26) | 0;
        w1 &= 0x3ffffff;
        /* k = 2 */ lo = Math.imul(al2, bl0);
        mid = Math.imul(al2, bh0);
        mid = mid + Math.imul(ah2, bl0) | 0;
        hi = Math.imul(ah2, bh0);
        lo = lo + Math.imul(al1, bl1) | 0;
        mid = mid + Math.imul(al1, bh1) | 0;
        mid = mid + Math.imul(ah1, bl1) | 0;
        hi = hi + Math.imul(ah1, bh1) | 0;
        lo = lo + Math.imul(al0, bl2) | 0;
        mid = mid + Math.imul(al0, bh2) | 0;
        mid = mid + Math.imul(ah0, bl2) | 0;
        hi = hi + Math.imul(ah0, bh2) | 0;
        var w2 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w2 >>> 26) | 0;
        w2 &= 0x3ffffff;
        /* k = 3 */ lo = Math.imul(al3, bl0);
        mid = Math.imul(al3, bh0);
        mid = mid + Math.imul(ah3, bl0) | 0;
        hi = Math.imul(ah3, bh0);
        lo = lo + Math.imul(al2, bl1) | 0;
        mid = mid + Math.imul(al2, bh1) | 0;
        mid = mid + Math.imul(ah2, bl1) | 0;
        hi = hi + Math.imul(ah2, bh1) | 0;
        lo = lo + Math.imul(al1, bl2) | 0;
        mid = mid + Math.imul(al1, bh2) | 0;
        mid = mid + Math.imul(ah1, bl2) | 0;
        hi = hi + Math.imul(ah1, bh2) | 0;
        lo = lo + Math.imul(al0, bl3) | 0;
        mid = mid + Math.imul(al0, bh3) | 0;
        mid = mid + Math.imul(ah0, bl3) | 0;
        hi = hi + Math.imul(ah0, bh3) | 0;
        var w3 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w3 >>> 26) | 0;
        w3 &= 0x3ffffff;
        /* k = 4 */ lo = Math.imul(al4, bl0);
        mid = Math.imul(al4, bh0);
        mid = mid + Math.imul(ah4, bl0) | 0;
        hi = Math.imul(ah4, bh0);
        lo = lo + Math.imul(al3, bl1) | 0;
        mid = mid + Math.imul(al3, bh1) | 0;
        mid = mid + Math.imul(ah3, bl1) | 0;
        hi = hi + Math.imul(ah3, bh1) | 0;
        lo = lo + Math.imul(al2, bl2) | 0;
        mid = mid + Math.imul(al2, bh2) | 0;
        mid = mid + Math.imul(ah2, bl2) | 0;
        hi = hi + Math.imul(ah2, bh2) | 0;
        lo = lo + Math.imul(al1, bl3) | 0;
        mid = mid + Math.imul(al1, bh3) | 0;
        mid = mid + Math.imul(ah1, bl3) | 0;
        hi = hi + Math.imul(ah1, bh3) | 0;
        lo = lo + Math.imul(al0, bl4) | 0;
        mid = mid + Math.imul(al0, bh4) | 0;
        mid = mid + Math.imul(ah0, bl4) | 0;
        hi = hi + Math.imul(ah0, bh4) | 0;
        var w4 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w4 >>> 26) | 0;
        w4 &= 0x3ffffff;
        /* k = 5 */ lo = Math.imul(al5, bl0);
        mid = Math.imul(al5, bh0);
        mid = mid + Math.imul(ah5, bl0) | 0;
        hi = Math.imul(ah5, bh0);
        lo = lo + Math.imul(al4, bl1) | 0;
        mid = mid + Math.imul(al4, bh1) | 0;
        mid = mid + Math.imul(ah4, bl1) | 0;
        hi = hi + Math.imul(ah4, bh1) | 0;
        lo = lo + Math.imul(al3, bl2) | 0;
        mid = mid + Math.imul(al3, bh2) | 0;
        mid = mid + Math.imul(ah3, bl2) | 0;
        hi = hi + Math.imul(ah3, bh2) | 0;
        lo = lo + Math.imul(al2, bl3) | 0;
        mid = mid + Math.imul(al2, bh3) | 0;
        mid = mid + Math.imul(ah2, bl3) | 0;
        hi = hi + Math.imul(ah2, bh3) | 0;
        lo = lo + Math.imul(al1, bl4) | 0;
        mid = mid + Math.imul(al1, bh4) | 0;
        mid = mid + Math.imul(ah1, bl4) | 0;
        hi = hi + Math.imul(ah1, bh4) | 0;
        lo = lo + Math.imul(al0, bl5) | 0;
        mid = mid + Math.imul(al0, bh5) | 0;
        mid = mid + Math.imul(ah0, bl5) | 0;
        hi = hi + Math.imul(ah0, bh5) | 0;
        var w5 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w5 >>> 26) | 0;
        w5 &= 0x3ffffff;
        /* k = 6 */ lo = Math.imul(al6, bl0);
        mid = Math.imul(al6, bh0);
        mid = mid + Math.imul(ah6, bl0) | 0;
        hi = Math.imul(ah6, bh0);
        lo = lo + Math.imul(al5, bl1) | 0;
        mid = mid + Math.imul(al5, bh1) | 0;
        mid = mid + Math.imul(ah5, bl1) | 0;
        hi = hi + Math.imul(ah5, bh1) | 0;
        lo = lo + Math.imul(al4, bl2) | 0;
        mid = mid + Math.imul(al4, bh2) | 0;
        mid = mid + Math.imul(ah4, bl2) | 0;
        hi = hi + Math.imul(ah4, bh2) | 0;
        lo = lo + Math.imul(al3, bl3) | 0;
        mid = mid + Math.imul(al3, bh3) | 0;
        mid = mid + Math.imul(ah3, bl3) | 0;
        hi = hi + Math.imul(ah3, bh3) | 0;
        lo = lo + Math.imul(al2, bl4) | 0;
        mid = mid + Math.imul(al2, bh4) | 0;
        mid = mid + Math.imul(ah2, bl4) | 0;
        hi = hi + Math.imul(ah2, bh4) | 0;
        lo = lo + Math.imul(al1, bl5) | 0;
        mid = mid + Math.imul(al1, bh5) | 0;
        mid = mid + Math.imul(ah1, bl5) | 0;
        hi = hi + Math.imul(ah1, bh5) | 0;
        lo = lo + Math.imul(al0, bl6) | 0;
        mid = mid + Math.imul(al0, bh6) | 0;
        mid = mid + Math.imul(ah0, bl6) | 0;
        hi = hi + Math.imul(ah0, bh6) | 0;
        var w6 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w6 >>> 26) | 0;
        w6 &= 0x3ffffff;
        /* k = 7 */ lo = Math.imul(al7, bl0);
        mid = Math.imul(al7, bh0);
        mid = mid + Math.imul(ah7, bl0) | 0;
        hi = Math.imul(ah7, bh0);
        lo = lo + Math.imul(al6, bl1) | 0;
        mid = mid + Math.imul(al6, bh1) | 0;
        mid = mid + Math.imul(ah6, bl1) | 0;
        hi = hi + Math.imul(ah6, bh1) | 0;
        lo = lo + Math.imul(al5, bl2) | 0;
        mid = mid + Math.imul(al5, bh2) | 0;
        mid = mid + Math.imul(ah5, bl2) | 0;
        hi = hi + Math.imul(ah5, bh2) | 0;
        lo = lo + Math.imul(al4, bl3) | 0;
        mid = mid + Math.imul(al4, bh3) | 0;
        mid = mid + Math.imul(ah4, bl3) | 0;
        hi = hi + Math.imul(ah4, bh3) | 0;
        lo = lo + Math.imul(al3, bl4) | 0;
        mid = mid + Math.imul(al3, bh4) | 0;
        mid = mid + Math.imul(ah3, bl4) | 0;
        hi = hi + Math.imul(ah3, bh4) | 0;
        lo = lo + Math.imul(al2, bl5) | 0;
        mid = mid + Math.imul(al2, bh5) | 0;
        mid = mid + Math.imul(ah2, bl5) | 0;
        hi = hi + Math.imul(ah2, bh5) | 0;
        lo = lo + Math.imul(al1, bl6) | 0;
        mid = mid + Math.imul(al1, bh6) | 0;
        mid = mid + Math.imul(ah1, bl6) | 0;
        hi = hi + Math.imul(ah1, bh6) | 0;
        lo = lo + Math.imul(al0, bl7) | 0;
        mid = mid + Math.imul(al0, bh7) | 0;
        mid = mid + Math.imul(ah0, bl7) | 0;
        hi = hi + Math.imul(ah0, bh7) | 0;
        var w7 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w7 >>> 26) | 0;
        w7 &= 0x3ffffff;
        /* k = 8 */ lo = Math.imul(al8, bl0);
        mid = Math.imul(al8, bh0);
        mid = mid + Math.imul(ah8, bl0) | 0;
        hi = Math.imul(ah8, bh0);
        lo = lo + Math.imul(al7, bl1) | 0;
        mid = mid + Math.imul(al7, bh1) | 0;
        mid = mid + Math.imul(ah7, bl1) | 0;
        hi = hi + Math.imul(ah7, bh1) | 0;
        lo = lo + Math.imul(al6, bl2) | 0;
        mid = mid + Math.imul(al6, bh2) | 0;
        mid = mid + Math.imul(ah6, bl2) | 0;
        hi = hi + Math.imul(ah6, bh2) | 0;
        lo = lo + Math.imul(al5, bl3) | 0;
        mid = mid + Math.imul(al5, bh3) | 0;
        mid = mid + Math.imul(ah5, bl3) | 0;
        hi = hi + Math.imul(ah5, bh3) | 0;
        lo = lo + Math.imul(al4, bl4) | 0;
        mid = mid + Math.imul(al4, bh4) | 0;
        mid = mid + Math.imul(ah4, bl4) | 0;
        hi = hi + Math.imul(ah4, bh4) | 0;
        lo = lo + Math.imul(al3, bl5) | 0;
        mid = mid + Math.imul(al3, bh5) | 0;
        mid = mid + Math.imul(ah3, bl5) | 0;
        hi = hi + Math.imul(ah3, bh5) | 0;
        lo = lo + Math.imul(al2, bl6) | 0;
        mid = mid + Math.imul(al2, bh6) | 0;
        mid = mid + Math.imul(ah2, bl6) | 0;
        hi = hi + Math.imul(ah2, bh6) | 0;
        lo = lo + Math.imul(al1, bl7) | 0;
        mid = mid + Math.imul(al1, bh7) | 0;
        mid = mid + Math.imul(ah1, bl7) | 0;
        hi = hi + Math.imul(ah1, bh7) | 0;
        lo = lo + Math.imul(al0, bl8) | 0;
        mid = mid + Math.imul(al0, bh8) | 0;
        mid = mid + Math.imul(ah0, bl8) | 0;
        hi = hi + Math.imul(ah0, bh8) | 0;
        var w8 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w8 >>> 26) | 0;
        w8 &= 0x3ffffff;
        /* k = 9 */ lo = Math.imul(al9, bl0);
        mid = Math.imul(al9, bh0);
        mid = mid + Math.imul(ah9, bl0) | 0;
        hi = Math.imul(ah9, bh0);
        lo = lo + Math.imul(al8, bl1) | 0;
        mid = mid + Math.imul(al8, bh1) | 0;
        mid = mid + Math.imul(ah8, bl1) | 0;
        hi = hi + Math.imul(ah8, bh1) | 0;
        lo = lo + Math.imul(al7, bl2) | 0;
        mid = mid + Math.imul(al7, bh2) | 0;
        mid = mid + Math.imul(ah7, bl2) | 0;
        hi = hi + Math.imul(ah7, bh2) | 0;
        lo = lo + Math.imul(al6, bl3) | 0;
        mid = mid + Math.imul(al6, bh3) | 0;
        mid = mid + Math.imul(ah6, bl3) | 0;
        hi = hi + Math.imul(ah6, bh3) | 0;
        lo = lo + Math.imul(al5, bl4) | 0;
        mid = mid + Math.imul(al5, bh4) | 0;
        mid = mid + Math.imul(ah5, bl4) | 0;
        hi = hi + Math.imul(ah5, bh4) | 0;
        lo = lo + Math.imul(al4, bl5) | 0;
        mid = mid + Math.imul(al4, bh5) | 0;
        mid = mid + Math.imul(ah4, bl5) | 0;
        hi = hi + Math.imul(ah4, bh5) | 0;
        lo = lo + Math.imul(al3, bl6) | 0;
        mid = mid + Math.imul(al3, bh6) | 0;
        mid = mid + Math.imul(ah3, bl6) | 0;
        hi = hi + Math.imul(ah3, bh6) | 0;
        lo = lo + Math.imul(al2, bl7) | 0;
        mid = mid + Math.imul(al2, bh7) | 0;
        mid = mid + Math.imul(ah2, bl7) | 0;
        hi = hi + Math.imul(ah2, bh7) | 0;
        lo = lo + Math.imul(al1, bl8) | 0;
        mid = mid + Math.imul(al1, bh8) | 0;
        mid = mid + Math.imul(ah1, bl8) | 0;
        hi = hi + Math.imul(ah1, bh8) | 0;
        lo = lo + Math.imul(al0, bl9) | 0;
        mid = mid + Math.imul(al0, bh9) | 0;
        mid = mid + Math.imul(ah0, bl9) | 0;
        hi = hi + Math.imul(ah0, bh9) | 0;
        var w9 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w9 >>> 26) | 0;
        w9 &= 0x3ffffff;
        /* k = 10 */ lo = Math.imul(al9, bl1);
        mid = Math.imul(al9, bh1);
        mid = mid + Math.imul(ah9, bl1) | 0;
        hi = Math.imul(ah9, bh1);
        lo = lo + Math.imul(al8, bl2) | 0;
        mid = mid + Math.imul(al8, bh2) | 0;
        mid = mid + Math.imul(ah8, bl2) | 0;
        hi = hi + Math.imul(ah8, bh2) | 0;
        lo = lo + Math.imul(al7, bl3) | 0;
        mid = mid + Math.imul(al7, bh3) | 0;
        mid = mid + Math.imul(ah7, bl3) | 0;
        hi = hi + Math.imul(ah7, bh3) | 0;
        lo = lo + Math.imul(al6, bl4) | 0;
        mid = mid + Math.imul(al6, bh4) | 0;
        mid = mid + Math.imul(ah6, bl4) | 0;
        hi = hi + Math.imul(ah6, bh4) | 0;
        lo = lo + Math.imul(al5, bl5) | 0;
        mid = mid + Math.imul(al5, bh5) | 0;
        mid = mid + Math.imul(ah5, bl5) | 0;
        hi = hi + Math.imul(ah5, bh5) | 0;
        lo = lo + Math.imul(al4, bl6) | 0;
        mid = mid + Math.imul(al4, bh6) | 0;
        mid = mid + Math.imul(ah4, bl6) | 0;
        hi = hi + Math.imul(ah4, bh6) | 0;
        lo = lo + Math.imul(al3, bl7) | 0;
        mid = mid + Math.imul(al3, bh7) | 0;
        mid = mid + Math.imul(ah3, bl7) | 0;
        hi = hi + Math.imul(ah3, bh7) | 0;
        lo = lo + Math.imul(al2, bl8) | 0;
        mid = mid + Math.imul(al2, bh8) | 0;
        mid = mid + Math.imul(ah2, bl8) | 0;
        hi = hi + Math.imul(ah2, bh8) | 0;
        lo = lo + Math.imul(al1, bl9) | 0;
        mid = mid + Math.imul(al1, bh9) | 0;
        mid = mid + Math.imul(ah1, bl9) | 0;
        hi = hi + Math.imul(ah1, bh9) | 0;
        var w10 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w10 >>> 26) | 0;
        w10 &= 0x3ffffff;
        /* k = 11 */ lo = Math.imul(al9, bl2);
        mid = Math.imul(al9, bh2);
        mid = mid + Math.imul(ah9, bl2) | 0;
        hi = Math.imul(ah9, bh2);
        lo = lo + Math.imul(al8, bl3) | 0;
        mid = mid + Math.imul(al8, bh3) | 0;
        mid = mid + Math.imul(ah8, bl3) | 0;
        hi = hi + Math.imul(ah8, bh3) | 0;
        lo = lo + Math.imul(al7, bl4) | 0;
        mid = mid + Math.imul(al7, bh4) | 0;
        mid = mid + Math.imul(ah7, bl4) | 0;
        hi = hi + Math.imul(ah7, bh4) | 0;
        lo = lo + Math.imul(al6, bl5) | 0;
        mid = mid + Math.imul(al6, bh5) | 0;
        mid = mid + Math.imul(ah6, bl5) | 0;
        hi = hi + Math.imul(ah6, bh5) | 0;
        lo = lo + Math.imul(al5, bl6) | 0;
        mid = mid + Math.imul(al5, bh6) | 0;
        mid = mid + Math.imul(ah5, bl6) | 0;
        hi = hi + Math.imul(ah5, bh6) | 0;
        lo = lo + Math.imul(al4, bl7) | 0;
        mid = mid + Math.imul(al4, bh7) | 0;
        mid = mid + Math.imul(ah4, bl7) | 0;
        hi = hi + Math.imul(ah4, bh7) | 0;
        lo = lo + Math.imul(al3, bl8) | 0;
        mid = mid + Math.imul(al3, bh8) | 0;
        mid = mid + Math.imul(ah3, bl8) | 0;
        hi = hi + Math.imul(ah3, bh8) | 0;
        lo = lo + Math.imul(al2, bl9) | 0;
        mid = mid + Math.imul(al2, bh9) | 0;
        mid = mid + Math.imul(ah2, bl9) | 0;
        hi = hi + Math.imul(ah2, bh9) | 0;
        var w11 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w11 >>> 26) | 0;
        w11 &= 0x3ffffff;
        /* k = 12 */ lo = Math.imul(al9, bl3);
        mid = Math.imul(al9, bh3);
        mid = mid + Math.imul(ah9, bl3) | 0;
        hi = Math.imul(ah9, bh3);
        lo = lo + Math.imul(al8, bl4) | 0;
        mid = mid + Math.imul(al8, bh4) | 0;
        mid = mid + Math.imul(ah8, bl4) | 0;
        hi = hi + Math.imul(ah8, bh4) | 0;
        lo = lo + Math.imul(al7, bl5) | 0;
        mid = mid + Math.imul(al7, bh5) | 0;
        mid = mid + Math.imul(ah7, bl5) | 0;
        hi = hi + Math.imul(ah7, bh5) | 0;
        lo = lo + Math.imul(al6, bl6) | 0;
        mid = mid + Math.imul(al6, bh6) | 0;
        mid = mid + Math.imul(ah6, bl6) | 0;
        hi = hi + Math.imul(ah6, bh6) | 0;
        lo = lo + Math.imul(al5, bl7) | 0;
        mid = mid + Math.imul(al5, bh7) | 0;
        mid = mid + Math.imul(ah5, bl7) | 0;
        hi = hi + Math.imul(ah5, bh7) | 0;
        lo = lo + Math.imul(al4, bl8) | 0;
        mid = mid + Math.imul(al4, bh8) | 0;
        mid = mid + Math.imul(ah4, bl8) | 0;
        hi = hi + Math.imul(ah4, bh8) | 0;
        lo = lo + Math.imul(al3, bl9) | 0;
        mid = mid + Math.imul(al3, bh9) | 0;
        mid = mid + Math.imul(ah3, bl9) | 0;
        hi = hi + Math.imul(ah3, bh9) | 0;
        var w12 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w12 >>> 26) | 0;
        w12 &= 0x3ffffff;
        /* k = 13 */ lo = Math.imul(al9, bl4);
        mid = Math.imul(al9, bh4);
        mid = mid + Math.imul(ah9, bl4) | 0;
        hi = Math.imul(ah9, bh4);
        lo = lo + Math.imul(al8, bl5) | 0;
        mid = mid + Math.imul(al8, bh5) | 0;
        mid = mid + Math.imul(ah8, bl5) | 0;
        hi = hi + Math.imul(ah8, bh5) | 0;
        lo = lo + Math.imul(al7, bl6) | 0;
        mid = mid + Math.imul(al7, bh6) | 0;
        mid = mid + Math.imul(ah7, bl6) | 0;
        hi = hi + Math.imul(ah7, bh6) | 0;
        lo = lo + Math.imul(al6, bl7) | 0;
        mid = mid + Math.imul(al6, bh7) | 0;
        mid = mid + Math.imul(ah6, bl7) | 0;
        hi = hi + Math.imul(ah6, bh7) | 0;
        lo = lo + Math.imul(al5, bl8) | 0;
        mid = mid + Math.imul(al5, bh8) | 0;
        mid = mid + Math.imul(ah5, bl8) | 0;
        hi = hi + Math.imul(ah5, bh8) | 0;
        lo = lo + Math.imul(al4, bl9) | 0;
        mid = mid + Math.imul(al4, bh9) | 0;
        mid = mid + Math.imul(ah4, bl9) | 0;
        hi = hi + Math.imul(ah4, bh9) | 0;
        var w13 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w13 >>> 26) | 0;
        w13 &= 0x3ffffff;
        /* k = 14 */ lo = Math.imul(al9, bl5);
        mid = Math.imul(al9, bh5);
        mid = mid + Math.imul(ah9, bl5) | 0;
        hi = Math.imul(ah9, bh5);
        lo = lo + Math.imul(al8, bl6) | 0;
        mid = mid + Math.imul(al8, bh6) | 0;
        mid = mid + Math.imul(ah8, bl6) | 0;
        hi = hi + Math.imul(ah8, bh6) | 0;
        lo = lo + Math.imul(al7, bl7) | 0;
        mid = mid + Math.imul(al7, bh7) | 0;
        mid = mid + Math.imul(ah7, bl7) | 0;
        hi = hi + Math.imul(ah7, bh7) | 0;
        lo = lo + Math.imul(al6, bl8) | 0;
        mid = mid + Math.imul(al6, bh8) | 0;
        mid = mid + Math.imul(ah6, bl8) | 0;
        hi = hi + Math.imul(ah6, bh8) | 0;
        lo = lo + Math.imul(al5, bl9) | 0;
        mid = mid + Math.imul(al5, bh9) | 0;
        mid = mid + Math.imul(ah5, bl9) | 0;
        hi = hi + Math.imul(ah5, bh9) | 0;
        var w14 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w14 >>> 26) | 0;
        w14 &= 0x3ffffff;
        /* k = 15 */ lo = Math.imul(al9, bl6);
        mid = Math.imul(al9, bh6);
        mid = mid + Math.imul(ah9, bl6) | 0;
        hi = Math.imul(ah9, bh6);
        lo = lo + Math.imul(al8, bl7) | 0;
        mid = mid + Math.imul(al8, bh7) | 0;
        mid = mid + Math.imul(ah8, bl7) | 0;
        hi = hi + Math.imul(ah8, bh7) | 0;
        lo = lo + Math.imul(al7, bl8) | 0;
        mid = mid + Math.imul(al7, bh8) | 0;
        mid = mid + Math.imul(ah7, bl8) | 0;
        hi = hi + Math.imul(ah7, bh8) | 0;
        lo = lo + Math.imul(al6, bl9) | 0;
        mid = mid + Math.imul(al6, bh9) | 0;
        mid = mid + Math.imul(ah6, bl9) | 0;
        hi = hi + Math.imul(ah6, bh9) | 0;
        var w15 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w15 >>> 26) | 0;
        w15 &= 0x3ffffff;
        /* k = 16 */ lo = Math.imul(al9, bl7);
        mid = Math.imul(al9, bh7);
        mid = mid + Math.imul(ah9, bl7) | 0;
        hi = Math.imul(ah9, bh7);
        lo = lo + Math.imul(al8, bl8) | 0;
        mid = mid + Math.imul(al8, bh8) | 0;
        mid = mid + Math.imul(ah8, bl8) | 0;
        hi = hi + Math.imul(ah8, bh8) | 0;
        lo = lo + Math.imul(al7, bl9) | 0;
        mid = mid + Math.imul(al7, bh9) | 0;
        mid = mid + Math.imul(ah7, bl9) | 0;
        hi = hi + Math.imul(ah7, bh9) | 0;
        var w16 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w16 >>> 26) | 0;
        w16 &= 0x3ffffff;
        /* k = 17 */ lo = Math.imul(al9, bl8);
        mid = Math.imul(al9, bh8);
        mid = mid + Math.imul(ah9, bl8) | 0;
        hi = Math.imul(ah9, bh8);
        lo = lo + Math.imul(al8, bl9) | 0;
        mid = mid + Math.imul(al8, bh9) | 0;
        mid = mid + Math.imul(ah8, bl9) | 0;
        hi = hi + Math.imul(ah8, bh9) | 0;
        var w17 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w17 >>> 26) | 0;
        w17 &= 0x3ffffff;
        /* k = 18 */ lo = Math.imul(al9, bl9);
        mid = Math.imul(al9, bh9);
        mid = mid + Math.imul(ah9, bl9) | 0;
        hi = Math.imul(ah9, bh9);
        var w18 = (c + lo | 0) + ((mid & 0x1fff) << 13) | 0;
        c = (hi + (mid >>> 13) | 0) + (w18 >>> 26) | 0;
        w18 &= 0x3ffffff;
        o[0] = w0;
        o[1] = w1;
        o[2] = w2;
        o[3] = w3;
        o[4] = w4;
        o[5] = w5;
        o[6] = w6;
        o[7] = w7;
        o[8] = w8;
        o[9] = w9;
        o[10] = w10;
        o[11] = w11;
        o[12] = w12;
        o[13] = w13;
        o[14] = w14;
        o[15] = w15;
        o[16] = w16;
        o[17] = w17;
        o[18] = w18;
        if (c !== 0) {
            o[19] = c;
            out.length++;
        }
        return out;
    };
    // Polyfill comb
    if (!Math.imul) comb10MulTo = smallMulTo;
    function bigMulTo(self, num, out) {
        out.negative = num.negative ^ self.negative;
        out.length = self.length + num.length;
        var carry = 0;
        var hncarry = 0;
        for(var k = 0; k < out.length - 1; k++){
            // Sum all words with the same `i + j = k` and accumulate `ncarry`,
            // note that ncarry could be >= 0x3ffffff
            var ncarry = hncarry;
            hncarry = 0;
            var rword = carry & 0x3ffffff;
            var maxJ = Math.min(k, num.length - 1);
            for(var j = Math.max(0, k - self.length + 1); j <= maxJ; j++){
                var i = k - j;
                var a = self.words[i] | 0;
                var b = num.words[j] | 0;
                var r = a * b;
                var lo = r & 0x3ffffff;
                ncarry = ncarry + (r / 0x4000000 | 0) | 0;
                lo = lo + rword | 0;
                rword = lo & 0x3ffffff;
                ncarry = ncarry + (lo >>> 26) | 0;
                hncarry += ncarry >>> 26;
                ncarry &= 0x3ffffff;
            }
            out.words[k] = rword;
            carry = ncarry;
            ncarry = hncarry;
        }
        if (carry !== 0) out.words[k] = carry;
        else out.length--;
        return out.strip();
    }
    function jumboMulTo(self, num, out) {
        var fftm = new FFTM();
        return fftm.mulp(self, num, out);
    }
    BN.prototype.mulTo = function mulTo(num, out) {
        var res;
        var len = this.length + num.length;
        if (this.length === 10 && num.length === 10) res = comb10MulTo(this, num, out);
        else if (len < 63) res = smallMulTo(this, num, out);
        else if (len < 1024) res = bigMulTo(this, num, out);
        else res = jumboMulTo(this, num, out);
        return res;
    };
    // Cooley-Tukey algorithm for FFT
    // slightly revisited to rely on looping instead of recursion
    function FFTM(x, y) {
        this.x = x;
        this.y = y;
    }
    FFTM.prototype.makeRBT = function makeRBT(N) {
        var t = new Array(N);
        var l = BN.prototype._countBits(N) - 1;
        for(var i = 0; i < N; i++)t[i] = this.revBin(i, l, N);
        return t;
    };
    // Returns binary-reversed representation of `x`
    FFTM.prototype.revBin = function revBin(x, l, N) {
        if (x === 0 || x === N - 1) return x;
        var rb = 0;
        for(var i = 0; i < l; i++){
            rb |= (x & 1) << l - i - 1;
            x >>= 1;
        }
        return rb;
    };
    // Performs "tweedling" phase, therefore 'emulating'
    // behaviour of the recursive algorithm
    FFTM.prototype.permute = function permute(rbt, rws, iws, rtws, itws, N) {
        for(var i = 0; i < N; i++){
            rtws[i] = rws[rbt[i]];
            itws[i] = iws[rbt[i]];
        }
    };
    FFTM.prototype.transform = function transform(rws, iws, rtws, itws, N, rbt) {
        this.permute(rbt, rws, iws, rtws, itws, N);
        for(var s = 1; s < N; s <<= 1){
            var l = s << 1;
            var rtwdf = Math.cos(2 * Math.PI / l);
            var itwdf = Math.sin(2 * Math.PI / l);
            for(var p = 0; p < N; p += l){
                var rtwdf_ = rtwdf;
                var itwdf_ = itwdf;
                for(var j = 0; j < s; j++){
                    var re = rtws[p + j];
                    var ie = itws[p + j];
                    var ro = rtws[p + j + s];
                    var io = itws[p + j + s];
                    var rx = rtwdf_ * ro - itwdf_ * io;
                    io = rtwdf_ * io + itwdf_ * ro;
                    ro = rx;
                    rtws[p + j] = re + ro;
                    itws[p + j] = ie + io;
                    rtws[p + j + s] = re - ro;
                    itws[p + j + s] = ie - io;
                    /* jshint maxdepth : false */ if (j !== l) {
                        rx = rtwdf * rtwdf_ - itwdf * itwdf_;
                        itwdf_ = rtwdf * itwdf_ + itwdf * rtwdf_;
                        rtwdf_ = rx;
                    }
                }
            }
        }
    };
    FFTM.prototype.guessLen13b = function guessLen13b(n, m) {
        var N = Math.max(m, n) | 1;
        var odd = N & 1;
        var i = 0;
        for(N = N / 2 | 0; N; N = N >>> 1)i++;
        return 1 << i + 1 + odd;
    };
    FFTM.prototype.conjugate = function conjugate(rws, iws, N) {
        if (N <= 1) return;
        for(var i = 0; i < N / 2; i++){
            var t = rws[i];
            rws[i] = rws[N - i - 1];
            rws[N - i - 1] = t;
            t = iws[i];
            iws[i] = -iws[N - i - 1];
            iws[N - i - 1] = -t;
        }
    };
    FFTM.prototype.normalize13b = function normalize13b(ws, N) {
        var carry = 0;
        for(var i = 0; i < N / 2; i++){
            var w = Math.round(ws[2 * i + 1] / N) * 0x2000 + Math.round(ws[2 * i] / N) + carry;
            ws[i] = w & 0x3ffffff;
            if (w < 0x4000000) carry = 0;
            else carry = w / 0x4000000 | 0;
        }
        return ws;
    };
    FFTM.prototype.convert13b = function convert13b(ws, len, rws, N) {
        var carry = 0;
        for(var i = 0; i < len; i++){
            carry = carry + (ws[i] | 0);
            rws[2 * i] = carry & 0x1fff;
            carry = carry >>> 13;
            rws[2 * i + 1] = carry & 0x1fff;
            carry = carry >>> 13;
        }
        // Pad with zeroes
        for(i = 2 * len; i < N; ++i)rws[i] = 0;
        assert(carry === 0);
        assert((carry & -8192) === 0);
    };
    FFTM.prototype.stub = function stub(N) {
        var ph = new Array(N);
        for(var i = 0; i < N; i++)ph[i] = 0;
        return ph;
    };
    FFTM.prototype.mulp = function mulp(x, y, out) {
        var N = 2 * this.guessLen13b(x.length, y.length);
        var rbt = this.makeRBT(N);
        var _ = this.stub(N);
        var rws = new Array(N);
        var rwst = new Array(N);
        var iwst = new Array(N);
        var nrws = new Array(N);
        var nrwst = new Array(N);
        var niwst = new Array(N);
        var rmws = out.words;
        rmws.length = N;
        this.convert13b(x.words, x.length, rws, N);
        this.convert13b(y.words, y.length, nrws, N);
        this.transform(rws, _, rwst, iwst, N, rbt);
        this.transform(nrws, _, nrwst, niwst, N, rbt);
        for(var i = 0; i < N; i++){
            var rx = rwst[i] * nrwst[i] - iwst[i] * niwst[i];
            iwst[i] = rwst[i] * niwst[i] + iwst[i] * nrwst[i];
            rwst[i] = rx;
        }
        this.conjugate(rwst, iwst, N);
        this.transform(rwst, iwst, rmws, _, N, rbt);
        this.conjugate(rmws, _, N);
        this.normalize13b(rmws, N);
        out.negative = x.negative ^ y.negative;
        out.length = x.length + y.length;
        return out.strip();
    };
    // Multiply `this` by `num`
    BN.prototype.mul = function mul(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return this.mulTo(num, out);
    };
    // Multiply employing FFT
    BN.prototype.mulf = function mulf(num) {
        var out = new BN(null);
        out.words = new Array(this.length + num.length);
        return jumboMulTo(this, num, out);
    };
    // In-place Multiplication
    BN.prototype.imul = function imul(num) {
        return this.clone().mulTo(num, this);
    };
    BN.prototype.imuln = function imuln(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        // Carry
        var carry = 0;
        for(var i = 0; i < this.length; i++){
            var w = (this.words[i] | 0) * num;
            var lo = (w & 0x3ffffff) + (carry & 0x3ffffff);
            carry >>= 26;
            carry += w / 0x4000000 | 0;
            // NOTE: lo is 27bit maximum
            carry += lo >>> 26;
            this.words[i] = lo & 0x3ffffff;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.muln = function muln(num) {
        return this.clone().imuln(num);
    };
    // `this` * `this`
    BN.prototype.sqr = function sqr() {
        return this.mul(this);
    };
    // `this` * `this` in-place
    BN.prototype.isqr = function isqr() {
        return this.imul(this.clone());
    };
    // Math.pow(`this`, `num`)
    BN.prototype.pow = function pow(num) {
        var w = toBitArray(num);
        if (w.length === 0) return new BN(1);
        // Skip leading zeroes
        var res = this;
        for(var i = 0; i < w.length; i++, res = res.sqr()){
            if (w[i] !== 0) break;
        }
        if (++i < w.length) for(var q = res.sqr(); i < w.length; i++, q = q.sqr()){
            if (w[i] === 0) continue;
            res = res.mul(q);
        }
        return res;
    };
    // Shift-left in-place
    BN.prototype.iushln = function iushln(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        var carryMask = 0x3ffffff >>> 26 - r << 26 - r;
        var i;
        if (r !== 0) {
            var carry = 0;
            for(i = 0; i < this.length; i++){
                var newCarry = this.words[i] & carryMask;
                var c = (this.words[i] | 0) - newCarry << r;
                this.words[i] = c | carry;
                carry = newCarry >>> 26 - r;
            }
            if (carry) {
                this.words[i] = carry;
                this.length++;
            }
        }
        if (s !== 0) {
            for(i = this.length - 1; i >= 0; i--)this.words[i + s] = this.words[i];
            for(i = 0; i < s; i++)this.words[i] = 0;
            this.length += s;
        }
        return this.strip();
    };
    BN.prototype.ishln = function ishln(bits) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushln(bits);
    };
    // Shift-right in-place
    // NOTE: `hint` is a lowest bit before trailing zeroes
    // NOTE: if `extended` is present - it will be filled with destroyed bits
    BN.prototype.iushrn = function iushrn(bits, hint, extended) {
        assert(typeof bits === "number" && bits >= 0);
        var h;
        if (hint) h = (hint - hint % 26) / 26;
        else h = 0;
        var r = bits % 26;
        var s = Math.min((bits - r) / 26, this.length);
        var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
        var maskedWords = extended;
        h -= s;
        h = Math.max(0, h);
        // Extended mode, copy masked part
        if (maskedWords) {
            for(var i = 0; i < s; i++)maskedWords.words[i] = this.words[i];
            maskedWords.length = s;
        }
        if (s === 0) ;
        else if (this.length > s) {
            this.length -= s;
            for(i = 0; i < this.length; i++)this.words[i] = this.words[i + s];
        } else {
            this.words[0] = 0;
            this.length = 1;
        }
        var carry = 0;
        for(i = this.length - 1; i >= 0 && (carry !== 0 || i >= h); i--){
            var word = this.words[i] | 0;
            this.words[i] = carry << 26 - r | word >>> r;
            carry = word & mask;
        }
        // Push carried bits as a mask
        if (maskedWords && carry !== 0) maskedWords.words[maskedWords.length++] = carry;
        if (this.length === 0) {
            this.words[0] = 0;
            this.length = 1;
        }
        return this.strip();
    };
    BN.prototype.ishrn = function ishrn(bits, hint, extended) {
        // TODO(indutny): implement me
        assert(this.negative === 0);
        return this.iushrn(bits, hint, extended);
    };
    // Shift-left
    BN.prototype.shln = function shln(bits) {
        return this.clone().ishln(bits);
    };
    BN.prototype.ushln = function ushln(bits) {
        return this.clone().iushln(bits);
    };
    // Shift-right
    BN.prototype.shrn = function shrn(bits) {
        return this.clone().ishrn(bits);
    };
    BN.prototype.ushrn = function ushrn(bits) {
        return this.clone().iushrn(bits);
    };
    // Test if n bit is set
    BN.prototype.testn = function testn(bit) {
        assert(typeof bit === "number" && bit >= 0);
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) return false;
        // Check bit and return
        var w = this.words[s];
        return !!(w & q);
    };
    // Return only lowers bits of number (in-place)
    BN.prototype.imaskn = function imaskn(bits) {
        assert(typeof bits === "number" && bits >= 0);
        var r = bits % 26;
        var s = (bits - r) / 26;
        assert(this.negative === 0, "imaskn works only with positive numbers");
        if (this.length <= s) return this;
        if (r !== 0) s++;
        this.length = Math.min(s, this.length);
        if (r !== 0) {
            var mask = 0x3ffffff ^ 0x3ffffff >>> r << r;
            this.words[this.length - 1] &= mask;
        }
        return this.strip();
    };
    // Return only lowers bits of number
    BN.prototype.maskn = function maskn(bits) {
        return this.clone().imaskn(bits);
    };
    // Add plain number `num` to `this`
    BN.prototype.iaddn = function iaddn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.isubn(-num);
        // Possible sign change
        if (this.negative !== 0) {
            if (this.length === 1 && (this.words[0] | 0) < num) {
                this.words[0] = num - (this.words[0] | 0);
                this.negative = 0;
                return this;
            }
            this.negative = 0;
            this.isubn(num);
            this.negative = 1;
            return this;
        }
        // Add without checks
        return this._iaddn(num);
    };
    BN.prototype._iaddn = function _iaddn(num) {
        this.words[0] += num;
        // Carry
        for(var i = 0; i < this.length && this.words[i] >= 0x4000000; i++){
            this.words[i] -= 0x4000000;
            if (i === this.length - 1) this.words[i + 1] = 1;
            else this.words[i + 1]++;
        }
        this.length = Math.max(this.length, i + 1);
        return this;
    };
    // Subtract plain number `num` from `this`
    BN.prototype.isubn = function isubn(num) {
        assert(typeof num === "number");
        assert(num < 0x4000000);
        if (num < 0) return this.iaddn(-num);
        if (this.negative !== 0) {
            this.negative = 0;
            this.iaddn(num);
            this.negative = 1;
            return this;
        }
        this.words[0] -= num;
        if (this.length === 1 && this.words[0] < 0) {
            this.words[0] = -this.words[0];
            this.negative = 1;
        } else // Carry
        for(var i = 0; i < this.length && this.words[i] < 0; i++){
            this.words[i] += 0x4000000;
            this.words[i + 1] -= 1;
        }
        return this.strip();
    };
    BN.prototype.addn = function addn(num) {
        return this.clone().iaddn(num);
    };
    BN.prototype.subn = function subn(num) {
        return this.clone().isubn(num);
    };
    BN.prototype.iabs = function iabs() {
        this.negative = 0;
        return this;
    };
    BN.prototype.abs = function abs() {
        return this.clone().iabs();
    };
    BN.prototype._ishlnsubmul = function _ishlnsubmul(num, mul, shift) {
        var len = num.length + shift;
        var i;
        this._expand(len);
        var w;
        var carry = 0;
        for(i = 0; i < num.length; i++){
            w = (this.words[i + shift] | 0) + carry;
            var right = (num.words[i] | 0) * mul;
            w -= right & 0x3ffffff;
            carry = (w >> 26) - (right / 0x4000000 | 0);
            this.words[i + shift] = w & 0x3ffffff;
        }
        for(; i < this.length - shift; i++){
            w = (this.words[i + shift] | 0) + carry;
            carry = w >> 26;
            this.words[i + shift] = w & 0x3ffffff;
        }
        if (carry === 0) return this.strip();
        // Subtraction overflow
        assert(carry === -1);
        carry = 0;
        for(i = 0; i < this.length; i++){
            w = -(this.words[i] | 0) + carry;
            carry = w >> 26;
            this.words[i] = w & 0x3ffffff;
        }
        this.negative = 1;
        return this.strip();
    };
    BN.prototype._wordDiv = function _wordDiv(num, mode) {
        var shift = this.length - num.length;
        var a = this.clone();
        var b = num;
        // Normalize
        var bhi = b.words[b.length - 1] | 0;
        var bhiBits = this._countBits(bhi);
        shift = 26 - bhiBits;
        if (shift !== 0) {
            b = b.ushln(shift);
            a.iushln(shift);
            bhi = b.words[b.length - 1] | 0;
        }
        // Initialize quotient
        var m = a.length - b.length;
        var q;
        if (mode !== "mod") {
            q = new BN(null);
            q.length = m + 1;
            q.words = new Array(q.length);
            for(var i = 0; i < q.length; i++)q.words[i] = 0;
        }
        var diff = a.clone()._ishlnsubmul(b, 1, m);
        if (diff.negative === 0) {
            a = diff;
            if (q) q.words[m] = 1;
        }
        for(var j = m - 1; j >= 0; j--){
            var qj = (a.words[b.length + j] | 0) * 0x4000000 + (a.words[b.length + j - 1] | 0);
            // NOTE: (qj / bhi) is (0x3ffffff * 0x4000000 + 0x3ffffff) / 0x2000000 max
            // (0x7ffffff)
            qj = Math.min(qj / bhi | 0, 0x3ffffff);
            a._ishlnsubmul(b, qj, j);
            while(a.negative !== 0){
                qj--;
                a.negative = 0;
                a._ishlnsubmul(b, 1, j);
                if (!a.isZero()) a.negative ^= 1;
            }
            if (q) q.words[j] = qj;
        }
        if (q) q.strip();
        a.strip();
        // Denormalize
        if (mode !== "div" && shift !== 0) a.iushrn(shift);
        return {
            div: q || null,
            mod: a
        };
    };
    // NOTE: 1) `mode` can be set to `mod` to request mod only,
    //       to `div` to request div only, or be absent to
    //       request both div & mod
    //       2) `positive` is true if unsigned mod is requested
    BN.prototype.divmod = function divmod(num, mode, positive) {
        assert(!num.isZero());
        if (this.isZero()) return {
            div: new BN(0),
            mod: new BN(0)
        };
        var div, mod, res;
        if (this.negative !== 0 && num.negative === 0) {
            res = this.neg().divmod(num, mode);
            if (mode !== "mod") div = res.div.neg();
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.iadd(num);
            }
            return {
                div: div,
                mod: mod
            };
        }
        if (this.negative === 0 && num.negative !== 0) {
            res = this.divmod(num.neg(), mode);
            if (mode !== "mod") div = res.div.neg();
            return {
                div: div,
                mod: res.mod
            };
        }
        if ((this.negative & num.negative) !== 0) {
            res = this.neg().divmod(num.neg(), mode);
            if (mode !== "div") {
                mod = res.mod.neg();
                if (positive && mod.negative !== 0) mod.isub(num);
            }
            return {
                div: res.div,
                mod: mod
            };
        }
        // Both numbers are positive at this point
        // Strip both numbers to approximate shift value
        if (num.length > this.length || this.cmp(num) < 0) return {
            div: new BN(0),
            mod: this
        };
        // Very short reduction
        if (num.length === 1) {
            if (mode === "div") return {
                div: this.divn(num.words[0]),
                mod: null
            };
            if (mode === "mod") return {
                div: null,
                mod: new BN(this.modn(num.words[0]))
            };
            return {
                div: this.divn(num.words[0]),
                mod: new BN(this.modn(num.words[0]))
            };
        }
        return this._wordDiv(num, mode);
    };
    // Find `this` / `num`
    BN.prototype.div = function div(num) {
        return this.divmod(num, "div", false).div;
    };
    // Find `this` % `num`
    BN.prototype.mod = function mod(num) {
        return this.divmod(num, "mod", false).mod;
    };
    BN.prototype.umod = function umod(num) {
        return this.divmod(num, "mod", true).mod;
    };
    // Find Round(`this` / `num`)
    BN.prototype.divRound = function divRound(num) {
        var dm = this.divmod(num);
        // Fast case - exact division
        if (dm.mod.isZero()) return dm.div;
        var mod = dm.div.negative !== 0 ? dm.mod.isub(num) : dm.mod;
        var half = num.ushrn(1);
        var r2 = num.andln(1);
        var cmp = mod.cmp(half);
        // Round down
        if (cmp < 0 || r2 === 1 && cmp === 0) return dm.div;
        // Round up
        return dm.div.negative !== 0 ? dm.div.isubn(1) : dm.div.iaddn(1);
    };
    BN.prototype.modn = function modn(num) {
        assert(num <= 0x3ffffff);
        var p = 67108864 % num;
        var acc = 0;
        for(var i = this.length - 1; i >= 0; i--)acc = (p * acc + (this.words[i] | 0)) % num;
        return acc;
    };
    // In-place division by number
    BN.prototype.idivn = function idivn(num) {
        assert(num <= 0x3ffffff);
        var carry = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var w = (this.words[i] | 0) + carry * 0x4000000;
            this.words[i] = w / num | 0;
            carry = w % num;
        }
        return this.strip();
    };
    BN.prototype.divn = function divn(num) {
        return this.clone().idivn(num);
    };
    BN.prototype.egcd = function egcd(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var x = this;
        var y = p.clone();
        if (x.negative !== 0) x = x.umod(p);
        else x = x.clone();
        // A * x + B * y = x
        var A = new BN(1);
        var B = new BN(0);
        // C * x + D * y = y
        var C = new BN(0);
        var D = new BN(1);
        var g = 0;
        while(x.isEven() && y.isEven()){
            x.iushrn(1);
            y.iushrn(1);
            ++g;
        }
        var yp = y.clone();
        var xp = x.clone();
        while(!x.isZero()){
            for(var i = 0, im = 1; (x.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                x.iushrn(i);
                while(i-- > 0){
                    if (A.isOdd() || B.isOdd()) {
                        A.iadd(yp);
                        B.isub(xp);
                    }
                    A.iushrn(1);
                    B.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (y.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                y.iushrn(j);
                while(j-- > 0){
                    if (C.isOdd() || D.isOdd()) {
                        C.iadd(yp);
                        D.isub(xp);
                    }
                    C.iushrn(1);
                    D.iushrn(1);
                }
            }
            if (x.cmp(y) >= 0) {
                x.isub(y);
                A.isub(C);
                B.isub(D);
            } else {
                y.isub(x);
                C.isub(A);
                D.isub(B);
            }
        }
        return {
            a: C,
            b: D,
            gcd: y.iushln(g)
        };
    };
    // This is reduced incarnation of the binary EEA
    // above, designated to invert members of the
    // _prime_ fields F(p) at a maximal speed
    BN.prototype._invmp = function _invmp(p) {
        assert(p.negative === 0);
        assert(!p.isZero());
        var a = this;
        var b = p.clone();
        if (a.negative !== 0) a = a.umod(p);
        else a = a.clone();
        var x1 = new BN(1);
        var x2 = new BN(0);
        var delta = b.clone();
        while(a.cmpn(1) > 0 && b.cmpn(1) > 0){
            for(var i = 0, im = 1; (a.words[0] & im) === 0 && i < 26; ++i, im <<= 1);
            if (i > 0) {
                a.iushrn(i);
                while(i-- > 0){
                    if (x1.isOdd()) x1.iadd(delta);
                    x1.iushrn(1);
                }
            }
            for(var j = 0, jm = 1; (b.words[0] & jm) === 0 && j < 26; ++j, jm <<= 1);
            if (j > 0) {
                b.iushrn(j);
                while(j-- > 0){
                    if (x2.isOdd()) x2.iadd(delta);
                    x2.iushrn(1);
                }
            }
            if (a.cmp(b) >= 0) {
                a.isub(b);
                x1.isub(x2);
            } else {
                b.isub(a);
                x2.isub(x1);
            }
        }
        var res;
        if (a.cmpn(1) === 0) res = x1;
        else res = x2;
        if (res.cmpn(0) < 0) res.iadd(p);
        return res;
    };
    BN.prototype.gcd = function gcd(num) {
        if (this.isZero()) return num.abs();
        if (num.isZero()) return this.abs();
        var a = this.clone();
        var b = num.clone();
        a.negative = 0;
        b.negative = 0;
        // Remove common factor of two
        for(var shift = 0; a.isEven() && b.isEven(); shift++){
            a.iushrn(1);
            b.iushrn(1);
        }
        do {
            while(a.isEven())a.iushrn(1);
            while(b.isEven())b.iushrn(1);
            var r = a.cmp(b);
            if (r < 0) {
                // Swap `a` and `b` to make `a` always bigger than `b`
                var t = a;
                a = b;
                b = t;
            } else if (r === 0 || b.cmpn(1) === 0) break;
            a.isub(b);
        }while (true);
        return b.iushln(shift);
    };
    // Invert number in the field F(num)
    BN.prototype.invm = function invm(num) {
        return this.egcd(num).a.umod(num);
    };
    BN.prototype.isEven = function isEven() {
        return (this.words[0] & 1) === 0;
    };
    BN.prototype.isOdd = function isOdd() {
        return (this.words[0] & 1) === 1;
    };
    // And first word and num
    BN.prototype.andln = function andln(num) {
        return this.words[0] & num;
    };
    // Increment at the bit position in-line
    BN.prototype.bincn = function bincn(bit) {
        assert(typeof bit === "number");
        var r = bit % 26;
        var s = (bit - r) / 26;
        var q = 1 << r;
        // Fast case: bit is much higher than all existing words
        if (this.length <= s) {
            this._expand(s + 1);
            this.words[s] |= q;
            return this;
        }
        // Add bit and propagate, if needed
        var carry = q;
        for(var i = s; carry !== 0 && i < this.length; i++){
            var w = this.words[i] | 0;
            w += carry;
            carry = w >>> 26;
            w &= 0x3ffffff;
            this.words[i] = w;
        }
        if (carry !== 0) {
            this.words[i] = carry;
            this.length++;
        }
        return this;
    };
    BN.prototype.isZero = function isZero() {
        return this.length === 1 && this.words[0] === 0;
    };
    BN.prototype.cmpn = function cmpn(num) {
        var negative = num < 0;
        if (this.negative !== 0 && !negative) return -1;
        if (this.negative === 0 && negative) return 1;
        this.strip();
        var res;
        if (this.length > 1) res = 1;
        else {
            if (negative) num = -num;
            assert(num <= 0x3ffffff, "Number is too big");
            var w = this.words[0] | 0;
            res = w === num ? 0 : w < num ? -1 : 1;
        }
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Compare two numbers and return:
    // 1 - if `this` > `num`
    // 0 - if `this` == `num`
    // -1 - if `this` < `num`
    BN.prototype.cmp = function cmp(num) {
        if (this.negative !== 0 && num.negative === 0) return -1;
        if (this.negative === 0 && num.negative !== 0) return 1;
        var res = this.ucmp(num);
        if (this.negative !== 0) return -res | 0;
        return res;
    };
    // Unsigned comparison
    BN.prototype.ucmp = function ucmp(num) {
        // At this point both numbers have the same sign
        if (this.length > num.length) return 1;
        if (this.length < num.length) return -1;
        var res = 0;
        for(var i = this.length - 1; i >= 0; i--){
            var a = this.words[i] | 0;
            var b = num.words[i] | 0;
            if (a === b) continue;
            if (a < b) res = -1;
            else if (a > b) res = 1;
            break;
        }
        return res;
    };
    BN.prototype.gtn = function gtn(num) {
        return this.cmpn(num) === 1;
    };
    BN.prototype.gt = function gt(num) {
        return this.cmp(num) === 1;
    };
    BN.prototype.gten = function gten(num) {
        return this.cmpn(num) >= 0;
    };
    BN.prototype.gte = function gte(num) {
        return this.cmp(num) >= 0;
    };
    BN.prototype.ltn = function ltn(num) {
        return this.cmpn(num) === -1;
    };
    BN.prototype.lt = function lt(num) {
        return this.cmp(num) === -1;
    };
    BN.prototype.lten = function lten(num) {
        return this.cmpn(num) <= 0;
    };
    BN.prototype.lte = function lte(num) {
        return this.cmp(num) <= 0;
    };
    BN.prototype.eqn = function eqn(num) {
        return this.cmpn(num) === 0;
    };
    BN.prototype.eq = function eq(num) {
        return this.cmp(num) === 0;
    };
    //
    // A reduce context, could be using montgomery or something better, depending
    // on the `m` itself.
    //
    BN.red = function red(num) {
        return new Red(num);
    };
    BN.prototype.toRed = function toRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        assert(this.negative === 0, "red works only with positives");
        return ctx.convertTo(this)._forceRed(ctx);
    };
    BN.prototype.fromRed = function fromRed() {
        assert(this.red, "fromRed works only with numbers in reduction context");
        return this.red.convertFrom(this);
    };
    BN.prototype._forceRed = function _forceRed(ctx) {
        this.red = ctx;
        return this;
    };
    BN.prototype.forceRed = function forceRed(ctx) {
        assert(!this.red, "Already a number in reduction context");
        return this._forceRed(ctx);
    };
    BN.prototype.redAdd = function redAdd(num) {
        assert(this.red, "redAdd works only with red numbers");
        return this.red.add(this, num);
    };
    BN.prototype.redIAdd = function redIAdd(num) {
        assert(this.red, "redIAdd works only with red numbers");
        return this.red.iadd(this, num);
    };
    BN.prototype.redSub = function redSub(num) {
        assert(this.red, "redSub works only with red numbers");
        return this.red.sub(this, num);
    };
    BN.prototype.redISub = function redISub(num) {
        assert(this.red, "redISub works only with red numbers");
        return this.red.isub(this, num);
    };
    BN.prototype.redShl = function redShl(num) {
        assert(this.red, "redShl works only with red numbers");
        return this.red.shl(this, num);
    };
    BN.prototype.redMul = function redMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.mul(this, num);
    };
    BN.prototype.redIMul = function redIMul(num) {
        assert(this.red, "redMul works only with red numbers");
        this.red._verify2(this, num);
        return this.red.imul(this, num);
    };
    BN.prototype.redSqr = function redSqr() {
        assert(this.red, "redSqr works only with red numbers");
        this.red._verify1(this);
        return this.red.sqr(this);
    };
    BN.prototype.redISqr = function redISqr() {
        assert(this.red, "redISqr works only with red numbers");
        this.red._verify1(this);
        return this.red.isqr(this);
    };
    // Square root over p
    BN.prototype.redSqrt = function redSqrt() {
        assert(this.red, "redSqrt works only with red numbers");
        this.red._verify1(this);
        return this.red.sqrt(this);
    };
    BN.prototype.redInvm = function redInvm() {
        assert(this.red, "redInvm works only with red numbers");
        this.red._verify1(this);
        return this.red.invm(this);
    };
    // Return negative clone of `this` % `red modulo`
    BN.prototype.redNeg = function redNeg() {
        assert(this.red, "redNeg works only with red numbers");
        this.red._verify1(this);
        return this.red.neg(this);
    };
    BN.prototype.redPow = function redPow(num) {
        assert(this.red && !num.red, "redPow(normalNum)");
        this.red._verify1(this);
        return this.red.pow(this, num);
    };
    // Prime numbers with efficient reduction
    var primes = {
        k256: null,
        p224: null,
        p192: null,
        p25519: null
    };
    // Pseudo-Mersenne prime
    function MPrime(name, p) {
        // P = 2 ^ N - K
        this.name = name;
        this.p = new BN(p, 16);
        this.n = this.p.bitLength();
        this.k = new BN(1).iushln(this.n).isub(this.p);
        this.tmp = this._tmp();
    }
    MPrime.prototype._tmp = function _tmp() {
        var tmp = new BN(null);
        tmp.words = new Array(Math.ceil(this.n / 13));
        return tmp;
    };
    MPrime.prototype.ireduce = function ireduce(num) {
        // Assumes that `num` is less than `P^2`
        // num = HI * (2 ^ N - K) + HI * K + LO = HI * K + LO (mod P)
        var r = num;
        var rlen;
        do {
            this.split(r, this.tmp);
            r = this.imulK(r);
            r = r.iadd(this.tmp);
            rlen = r.bitLength();
        }while (rlen > this.n);
        var cmp = rlen < this.n ? -1 : r.ucmp(this.p);
        if (cmp === 0) {
            r.words[0] = 0;
            r.length = 1;
        } else if (cmp > 0) r.isub(this.p);
        else if (r.strip !== undefined) // r is BN v4 instance
        r.strip();
        else // r is BN v5 instance
        r._strip();
        return r;
    };
    MPrime.prototype.split = function split(input, out) {
        input.iushrn(this.n, 0, out);
    };
    MPrime.prototype.imulK = function imulK(num) {
        return num.imul(this.k);
    };
    function K256() {
        MPrime.call(this, "k256", "ffffffff ffffffff ffffffff ffffffff ffffffff ffffffff fffffffe fffffc2f");
    }
    inherits(K256, MPrime);
    K256.prototype.split = function split(input, output) {
        // 256 = 9 * 26 + 22
        var mask = 0x3fffff;
        var outLen = Math.min(input.length, 9);
        for(var i = 0; i < outLen; i++)output.words[i] = input.words[i];
        output.length = outLen;
        if (input.length <= 9) {
            input.words[0] = 0;
            input.length = 1;
            return;
        }
        // Shift by 9 limbs
        var prev = input.words[9];
        output.words[output.length++] = prev & mask;
        for(i = 10; i < input.length; i++){
            var next = input.words[i] | 0;
            input.words[i - 10] = (next & mask) << 4 | prev >>> 22;
            prev = next;
        }
        prev >>>= 22;
        input.words[i - 10] = prev;
        if (prev === 0 && input.length > 10) input.length -= 10;
        else input.length -= 9;
    };
    K256.prototype.imulK = function imulK(num) {
        // K = 0x1000003d1 = [ 0x40, 0x3d1 ]
        num.words[num.length] = 0;
        num.words[num.length + 1] = 0;
        num.length += 2;
        // bounded at: 0x40 * 0x3ffffff + 0x3d0 = 0x100000390
        var lo = 0;
        for(var i = 0; i < num.length; i++){
            var w = num.words[i] | 0;
            lo += w * 0x3d1;
            num.words[i] = lo & 0x3ffffff;
            lo = w * 0x40 + (lo / 0x4000000 | 0);
        }
        // Fast length reduction
        if (num.words[num.length - 1] === 0) {
            num.length--;
            if (num.words[num.length - 1] === 0) num.length--;
        }
        return num;
    };
    function P224() {
        MPrime.call(this, "p224", "ffffffff ffffffff ffffffff ffffffff 00000000 00000000 00000001");
    }
    inherits(P224, MPrime);
    function P192() {
        MPrime.call(this, "p192", "ffffffff ffffffff ffffffff fffffffe ffffffff ffffffff");
    }
    inherits(P192, MPrime);
    function P25519() {
        // 2 ^ 255 - 19
        MPrime.call(this, "25519", "7fffffffffffffff ffffffffffffffff ffffffffffffffff ffffffffffffffed");
    }
    inherits(P25519, MPrime);
    P25519.prototype.imulK = function imulK(num) {
        // K = 0x13
        var carry = 0;
        for(var i = 0; i < num.length; i++){
            var hi = (num.words[i] | 0) * 0x13 + carry;
            var lo = hi & 0x3ffffff;
            hi >>>= 26;
            num.words[i] = lo;
            carry = hi;
        }
        if (carry !== 0) num.words[num.length++] = carry;
        return num;
    };
    // Exported mostly for testing purposes, use plain name instead
    BN._prime = function prime(name) {
        // Cached version of prime
        if (primes[name]) return primes[name];
        var prime;
        if (name === "k256") prime = new K256();
        else if (name === "p224") prime = new P224();
        else if (name === "p192") prime = new P192();
        else if (name === "p25519") prime = new P25519();
        else throw new Error("Unknown prime " + name);
        primes[name] = prime;
        return prime;
    };
    //
    // Base reduction engine
    //
    function Red(m) {
        if (typeof m === "string") {
            var prime = BN._prime(m);
            this.m = prime.p;
            this.prime = prime;
        } else {
            assert(m.gtn(1), "modulus must be greater than 1");
            this.m = m;
            this.prime = null;
        }
    }
    Red.prototype._verify1 = function _verify1(a) {
        assert(a.negative === 0, "red works only with positives");
        assert(a.red, "red works only with red numbers");
    };
    Red.prototype._verify2 = function _verify2(a, b) {
        assert((a.negative | b.negative) === 0, "red works only with positives");
        assert(a.red && a.red === b.red, "red works only with red numbers");
    };
    Red.prototype.imod = function imod(a) {
        if (this.prime) return this.prime.ireduce(a)._forceRed(this);
        return a.umod(this.m)._forceRed(this);
    };
    Red.prototype.neg = function neg(a) {
        if (a.isZero()) return a.clone();
        return this.m.sub(a)._forceRed(this);
    };
    Red.prototype.add = function add(a, b) {
        this._verify2(a, b);
        var res = a.add(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res._forceRed(this);
    };
    Red.prototype.iadd = function iadd(a, b) {
        this._verify2(a, b);
        var res = a.iadd(b);
        if (res.cmp(this.m) >= 0) res.isub(this.m);
        return res;
    };
    Red.prototype.sub = function sub(a, b) {
        this._verify2(a, b);
        var res = a.sub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res._forceRed(this);
    };
    Red.prototype.isub = function isub(a, b) {
        this._verify2(a, b);
        var res = a.isub(b);
        if (res.cmpn(0) < 0) res.iadd(this.m);
        return res;
    };
    Red.prototype.shl = function shl(a, num) {
        this._verify1(a);
        return this.imod(a.ushln(num));
    };
    Red.prototype.imul = function imul(a, b) {
        this._verify2(a, b);
        return this.imod(a.imul(b));
    };
    Red.prototype.mul = function mul(a, b) {
        this._verify2(a, b);
        return this.imod(a.mul(b));
    };
    Red.prototype.isqr = function isqr(a) {
        return this.imul(a, a.clone());
    };
    Red.prototype.sqr = function sqr(a) {
        return this.mul(a, a);
    };
    Red.prototype.sqrt = function sqrt(a) {
        if (a.isZero()) return a.clone();
        var mod3 = this.m.andln(3);
        assert(mod3 % 2 === 1);
        // Fast case
        if (mod3 === 3) {
            var pow = this.m.add(new BN(1)).iushrn(2);
            return this.pow(a, pow);
        }
        // Tonelli-Shanks algorithm (Totally unoptimized and slow)
        //
        // Find Q and S, that Q * 2 ^ S = (P - 1)
        var q = this.m.subn(1);
        var s = 0;
        while(!q.isZero() && q.andln(1) === 0){
            s++;
            q.iushrn(1);
        }
        assert(!q.isZero());
        var one = new BN(1).toRed(this);
        var nOne = one.redNeg();
        // Find quadratic non-residue
        // NOTE: Max is such because of generalized Riemann hypothesis.
        var lpow = this.m.subn(1).iushrn(1);
        var z = this.m.bitLength();
        z = new BN(2 * z * z).toRed(this);
        while(this.pow(z, lpow).cmp(nOne) !== 0)z.redIAdd(nOne);
        var c = this.pow(z, q);
        var r = this.pow(a, q.addn(1).iushrn(1));
        var t = this.pow(a, q);
        var m = s;
        while(t.cmp(one) !== 0){
            var tmp = t;
            for(var i = 0; tmp.cmp(one) !== 0; i++)tmp = tmp.redSqr();
            assert(i < m);
            var b = this.pow(c, new BN(1).iushln(m - i - 1));
            r = r.redMul(b);
            c = b.redSqr();
            t = t.redMul(c);
            m = i;
        }
        return r;
    };
    Red.prototype.invm = function invm(a) {
        var inv = a._invmp(this.m);
        if (inv.negative !== 0) {
            inv.negative = 0;
            return this.imod(inv).redNeg();
        } else return this.imod(inv);
    };
    Red.prototype.pow = function pow(a, num) {
        if (num.isZero()) return new BN(1).toRed(this);
        if (num.cmpn(1) === 0) return a.clone();
        var windowSize = 4;
        var wnd = new Array(1 << windowSize);
        wnd[0] = new BN(1).toRed(this);
        wnd[1] = a;
        for(var i = 2; i < wnd.length; i++)wnd[i] = this.mul(wnd[i - 1], a);
        var res = wnd[0];
        var current = 0;
        var currentLen = 0;
        var start = num.bitLength() % 26;
        if (start === 0) start = 26;
        for(i = num.length - 1; i >= 0; i--){
            var word = num.words[i];
            for(var j = start - 1; j >= 0; j--){
                var bit = word >> j & 1;
                if (res !== wnd[0]) res = this.sqr(res);
                if (bit === 0 && current === 0) {
                    currentLen = 0;
                    continue;
                }
                current <<= 1;
                current |= bit;
                currentLen++;
                if (currentLen !== windowSize && (i !== 0 || j !== 0)) continue;
                res = this.mul(res, wnd[current]);
                currentLen = 0;
                current = 0;
            }
            start = 26;
        }
        return res;
    };
    Red.prototype.convertTo = function convertTo(num) {
        var r = num.umod(this.m);
        return r === num ? r.clone() : r;
    };
    Red.prototype.convertFrom = function convertFrom(num) {
        var res = num.clone();
        res.red = null;
        return res;
    };
    //
    // Montgomery method engine
    //
    BN.mont = function mont(num) {
        return new Mont(num);
    };
    function Mont(m) {
        Red.call(this, m);
        this.shift = this.m.bitLength();
        if (this.shift % 26 !== 0) this.shift += 26 - this.shift % 26;
        this.r = new BN(1).iushln(this.shift);
        this.r2 = this.imod(this.r.sqr());
        this.rinv = this.r._invmp(this.m);
        this.minv = this.rinv.mul(this.r).isubn(1).div(this.m);
        this.minv = this.minv.umod(this.r);
        this.minv = this.r.sub(this.minv);
    }
    inherits(Mont, Red);
    Mont.prototype.convertTo = function convertTo(num) {
        return this.imod(num.ushln(this.shift));
    };
    Mont.prototype.convertFrom = function convertFrom(num) {
        var r = this.imod(num.mul(this.rinv));
        r.red = null;
        return r;
    };
    Mont.prototype.imul = function imul(a, b) {
        if (a.isZero() || b.isZero()) {
            a.words[0] = 0;
            a.length = 1;
            return a;
        }
        var t = a.imul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.mul = function mul(a, b) {
        if (a.isZero() || b.isZero()) return new BN(0)._forceRed(this);
        var t = a.mul(b);
        var c = t.maskn(this.shift).mul(this.minv).imaskn(this.shift).mul(this.m);
        var u = t.isub(c).iushrn(this.shift);
        var res = u;
        if (u.cmp(this.m) >= 0) res = u.isub(this.m);
        else if (u.cmpn(0) < 0) res = u.iadd(this.m);
        return res._forceRed(this);
    };
    Mont.prototype.invm = function invm(a) {
        // (AR)^-1 * R^2 = (A^-1 * R^-1) * R^2 = A^-1 * R
        var res = this.imod(a._invmp(this.m).mul(this.r2));
        return res._forceRed(this);
    };
})(module, this);

});

parcelRegister("3pDg3", function(module, exports) {

var $6rDPA = parcelRequire("6rDPA");

var $1U9GM = parcelRequire("1U9GM");
var $27c228af35759e80$require$Buffer = $1U9GM.Buffer;
function $27c228af35759e80$var$withPublic(paddedMsg, key) {
    return $27c228af35759e80$require$Buffer.from(paddedMsg.toRed($6rDPA.mont(key.modulus)).redPow(new $6rDPA(key.publicExponent)).fromRed().toArray());
}
module.exports = $27c228af35759e80$var$withPublic;

});

parcelRegister("3Sg1O", function(module, exports) {
"use strict";

var $dEXSZ = parcelRequire("dEXSZ");

var $hkN9y = parcelRequire("hkN9y");

var $1U9GM = parcelRequire("1U9GM");
var $2d22d91c93a13ae5$require$Buffer = $1U9GM.Buffer;
function $2d22d91c93a13ae5$var$getr(priv) {
    var len = priv.modulus.byteLength();
    var r;
    do r = new $dEXSZ($hkN9y(len));
    while (r.cmp(priv.modulus) >= 0 || !r.umod(priv.prime1) || !r.umod(priv.prime2));
    return r;
}
function $2d22d91c93a13ae5$var$blind(priv) {
    var r = $2d22d91c93a13ae5$var$getr(priv);
    var blinder = r.toRed($dEXSZ.mont(priv.modulus)).redPow(new $dEXSZ(priv.publicExponent)).fromRed();
    return {
        blinder: blinder,
        unblinder: r.invm(priv.modulus)
    };
}
function $2d22d91c93a13ae5$var$crt(msg, priv) {
    var blinds = $2d22d91c93a13ae5$var$blind(priv);
    var len = priv.modulus.byteLength();
    var blinded = new $dEXSZ(msg).mul(blinds.blinder).umod(priv.modulus);
    var c1 = blinded.toRed($dEXSZ.mont(priv.prime1));
    var c2 = blinded.toRed($dEXSZ.mont(priv.prime2));
    var qinv = priv.coefficient;
    var p = priv.prime1;
    var q = priv.prime2;
    var m1 = c1.redPow(priv.exponent1).fromRed();
    var m2 = c2.redPow(priv.exponent2).fromRed();
    var h = m1.isub(m2).imul(qinv).umod(p).imul(q);
    return m2.iadd(h).imul(blinds.unblinder).umod(priv.modulus).toArrayLike($2d22d91c93a13ae5$require$Buffer, "be", len);
}
$2d22d91c93a13ae5$var$crt.getr = $2d22d91c93a13ae5$var$getr;
module.exports = $2d22d91c93a13ae5$var$crt;

});


parcelRegister("jU8t7", function(module, exports) {

var $aNeDF = parcelRequire("aNeDF");

var $5BMkJ = parcelRequire("5BMkJ");

var $6nrMP = parcelRequire("6nrMP");

var $6rDPA = parcelRequire("6rDPA");

var $3Sg1O = parcelRequire("3Sg1O");

var $1R2J7 = parcelRequire("1R2J7");

var $3pDg3 = parcelRequire("3pDg3");

var $1U9GM = parcelRequire("1U9GM");
var $e7d9d10092031842$require$Buffer = $1U9GM.Buffer;
module.exports = function privateDecrypt(privateKey, enc, reverse) {
    var padding;
    if (privateKey.padding) padding = privateKey.padding;
    else if (reverse) padding = 1;
    else padding = 4;
    var key = $aNeDF(privateKey);
    var k = key.modulus.byteLength();
    if (enc.length > k || new $6rDPA(enc).cmp(key.modulus) >= 0) throw new Error("decryption error");
    var msg;
    if (reverse) msg = $3pDg3(new $6rDPA(enc), key);
    else msg = $3Sg1O(enc, key);
    var zBuffer = $e7d9d10092031842$require$Buffer.alloc(k - msg.length);
    msg = $e7d9d10092031842$require$Buffer.concat([
        zBuffer,
        msg
    ], k);
    if (padding === 4) return $e7d9d10092031842$var$oaep(key, msg);
    else if (padding === 1) return $e7d9d10092031842$var$pkcs1(key, msg, reverse);
    else if (padding === 3) return msg;
    else throw new Error("unknown padding");
};
function $e7d9d10092031842$var$oaep(key, msg) {
    var k = key.modulus.byteLength();
    var iHash = $1R2J7("sha1").update($e7d9d10092031842$require$Buffer.alloc(0)).digest();
    var hLen = iHash.length;
    if (msg[0] !== 0) throw new Error("decryption error");
    var maskedSeed = msg.slice(1, hLen + 1);
    var maskedDb = msg.slice(hLen + 1);
    var seed = $6nrMP(maskedSeed, $5BMkJ(maskedDb, hLen));
    var db = $6nrMP(maskedDb, $5BMkJ(seed, k - hLen - 1));
    if ($e7d9d10092031842$var$compare(iHash, db.slice(0, hLen))) throw new Error("decryption error");
    var i = hLen;
    while(db[i] === 0)i++;
    if (db[i++] !== 1) throw new Error("decryption error");
    return db.slice(i);
}
function $e7d9d10092031842$var$pkcs1(key, msg, reverse) {
    var p1 = msg.slice(0, 2);
    var i = 2;
    var status = 0;
    while(msg[i++] !== 0)if (i >= msg.length) {
        status++;
        break;
    }
    var ps = msg.slice(2, i - 1);
    if (p1.toString("hex") !== "0002" && !reverse || p1.toString("hex") !== "0001" && reverse) status++;
    if (ps.length < 8) status++;
    if (status) throw new Error("decryption error");
    return msg.slice(i);
}
function $e7d9d10092031842$var$compare(a, b) {
    a = $e7d9d10092031842$require$Buffer.from(a);
    b = $e7d9d10092031842$require$Buffer.from(b);
    var dif = 0;
    var len = a.length;
    if (a.length !== b.length) {
        dif++;
        len = Math.min(a.length, b.length);
    }
    var i = -1;
    while(++i < len)dif += a[i] ^ b[i];
    return dif;
}

});

parcelRegister("fr4Yq", function(module, exports) {
const $b3cd3c4411d4f56b$var$errors = {
    IMPOSSIBLE_CASE: "Impossible case. Please create issue.",
    TWEAK_ADD: "The tweak was out of range or the resulted private key is invalid",
    TWEAK_MUL: "The tweak was out of range or equal to zero",
    CONTEXT_RANDOMIZE_UNKNOW: "Unknow error on context randomization",
    SECKEY_INVALID: "Private Key is invalid",
    PUBKEY_PARSE: "Public Key could not be parsed",
    PUBKEY_SERIALIZE: "Public Key serialization error",
    PUBKEY_COMBINE: "The sum of the public keys is not valid",
    SIG_PARSE: "Signature could not be parsed",
    SIGN: "The nonce generation function failed, or the private key was invalid",
    RECOVER: "Public key could not be recover",
    ECDH: "Scalar was invalid (zero or overflow)"
};
function $b3cd3c4411d4f56b$var$assert(cond, msg) {
    if (!cond) throw new Error(msg);
}
function $b3cd3c4411d4f56b$var$isUint8Array(name, value, length) {
    $b3cd3c4411d4f56b$var$assert(value instanceof Uint8Array, `Expected ${name} to be an Uint8Array`);
    if (length !== undefined) {
        if (Array.isArray(length)) {
            const numbers = length.join(", ");
            const msg = `Expected ${name} to be an Uint8Array with length [${numbers}]`;
            $b3cd3c4411d4f56b$var$assert(length.includes(value.length), msg);
        } else {
            const msg = `Expected ${name} to be an Uint8Array with length ${length}`;
            $b3cd3c4411d4f56b$var$assert(value.length === length, msg);
        }
    }
}
function $b3cd3c4411d4f56b$var$isCompressed(value) {
    $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(value) === "Boolean", "Expected compressed to be a Boolean");
}
function $b3cd3c4411d4f56b$var$getAssertedOutput(output = (len)=>new Uint8Array(len), length) {
    if (typeof output === "function") output = output(length);
    $b3cd3c4411d4f56b$var$isUint8Array("output", output, length);
    return output;
}
function $b3cd3c4411d4f56b$var$toTypeString(value) {
    return Object.prototype.toString.call(value).slice(8, -1);
}
module.exports = (secp256k1)=>{
    return {
        contextRandomize (seed) {
            $b3cd3c4411d4f56b$var$assert(seed === null || seed instanceof Uint8Array, "Expected seed to be an Uint8Array or null");
            if (seed !== null) $b3cd3c4411d4f56b$var$isUint8Array("seed", seed, 32);
            switch(secp256k1.contextRandomize(seed)){
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.CONTEXT_RANDOMIZE_UNKNOW);
            }
        },
        privateKeyVerify (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            return secp256k1.privateKeyVerify(seckey) === 0;
        },
        privateKeyNegate (seckey) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            switch(secp256k1.privateKeyNegate(seckey)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        privateKeyTweakAdd (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakAdd(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        privateKeyTweakMul (seckey, tweak) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            switch(secp256k1.privateKeyTweakMul(seckey, tweak)){
                case 0:
                    return seckey;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        publicKeyVerify (pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            return secp256k1.publicKeyVerify(pubkey) === 0;
        },
        publicKeyCreate (seckey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCreate(output, seckey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SECKEY_INVALID);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyConvert (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyConvert(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyNegate (pubkey, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyNegate(output, pubkey)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyCombine (pubkeys, compressed = true, output) {
            $b3cd3c4411d4f56b$var$assert(Array.isArray(pubkeys), "Expected public keys to be an Array");
            $b3cd3c4411d4f56b$var$assert(pubkeys.length > 0, "Expected public keys array will have more than zero items");
            for (const pubkey of pubkeys)$b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyCombine(output, pubkeys)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_COMBINE);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_SERIALIZE);
            }
        },
        publicKeyTweakAdd (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakAdd(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_ADD);
            }
        },
        publicKeyTweakMul (pubkey, tweak, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("tweak", tweak, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.publicKeyTweakMul(output, pubkey, tweak)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.TWEAK_MUL);
            }
        },
        signatureNormalize (sig) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            switch(secp256k1.signatureNormalize(sig)){
                case 0:
                    return sig;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
            }
        },
        signatureExport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 72);
            const obj = {
                output: output,
                outputlen: 72
            };
            switch(secp256k1.signatureExport(obj, sig)){
                case 0:
                    return output.slice(0, obj.outputlen);
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        signatureImport (sig, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            switch(secp256k1.signatureImport(output, sig)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaSign (msg32, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.data", options.data);
            if (options.noncefn !== undefined) $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.noncefn) === "Function", "Expected options.noncefn to be a Function");
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 64);
            const obj = {
                signature: output,
                recid: null
            };
            switch(secp256k1.ecdsaSign(obj, msg32, seckey, options.data, options.noncefn)){
                case 0:
                    return obj;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIGN);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdsaVerify (sig, msg32, pubkey) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            switch(secp256k1.ecdsaVerify(sig, msg32, pubkey)){
                case 0:
                    return true;
                case 3:
                    return false;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
            }
        },
        ecdsaRecover (sig, recid, msg32, compressed = true, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("signature", sig, 64);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(recid) === "Number" && recid >= 0 && recid <= 3, "Expected recovery id to be a Number within interval [0, 3]");
            $b3cd3c4411d4f56b$var$isUint8Array("message", msg32, 32);
            $b3cd3c4411d4f56b$var$isCompressed(compressed);
            output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, compressed ? 33 : 65);
            switch(secp256k1.ecdsaRecover(output, sig, recid, msg32)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.SIG_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.RECOVER);
                case 3:
                    throw new Error($b3cd3c4411d4f56b$var$errors.IMPOSSIBLE_CASE);
            }
        },
        ecdh (pubkey, seckey, options = {}, output) {
            $b3cd3c4411d4f56b$var$isUint8Array("public key", pubkey, [
                33,
                65
            ]);
            $b3cd3c4411d4f56b$var$isUint8Array("private key", seckey, 32);
            $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options) === "Object", "Expected options to be an Object");
            if (options.data !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.data", options.data);
            if (options.hashfn !== undefined) {
                $b3cd3c4411d4f56b$var$assert($b3cd3c4411d4f56b$var$toTypeString(options.hashfn) === "Function", "Expected options.hashfn to be a Function");
                if (options.xbuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.xbuf", options.xbuf, 32);
                if (options.ybuf !== undefined) $b3cd3c4411d4f56b$var$isUint8Array("options.ybuf", options.ybuf, 32);
                $b3cd3c4411d4f56b$var$isUint8Array("output", output);
            } else output = $b3cd3c4411d4f56b$var$getAssertedOutput(output, 32);
            switch(secp256k1.ecdh(output, pubkey, seckey, options.data, options.hashfn, options.xbuf, options.ybuf)){
                case 0:
                    return output;
                case 1:
                    throw new Error($b3cd3c4411d4f56b$var$errors.PUBKEY_PARSE);
                case 2:
                    throw new Error($b3cd3c4411d4f56b$var$errors.ECDH);
            }
        }
    };
};

});

parcelRegister("ejO33", function(module, exports) {

var $1zUcV = parcelRequire("1zUcV");
var $a6c9a9981cef49fd$require$EC = $1zUcV.ec;
const $a6c9a9981cef49fd$var$ec = new $a6c9a9981cef49fd$require$EC("secp256k1");
const $a6c9a9981cef49fd$var$ecparams = $a6c9a9981cef49fd$var$ec.curve;
// Hack, we can not use bn.js@5, while elliptic uses bn.js@4
// See https://github.com/indutny/elliptic/issues/191#issuecomment-569888758
const $a6c9a9981cef49fd$var$BN = $a6c9a9981cef49fd$var$ecparams.n.constructor;
function $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, xbuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // compute corresponding Y
    let y = x.redSqr().redIMul(x).redIAdd($a6c9a9981cef49fd$var$ecparams.b).redSqrt();
    if (first === 0x03 !== y.isOdd()) y = y.redNeg();
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($a6c9a9981cef49fd$var$ecparams.b)).isZero()) return null;
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, xbuf, ybuf) {
    let x = new $a6c9a9981cef49fd$var$BN(xbuf);
    let y = new $a6c9a9981cef49fd$var$BN(ybuf);
    // overflow
    if (x.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0 || y.cmp($a6c9a9981cef49fd$var$ecparams.p) >= 0) return null;
    x = x.toRed($a6c9a9981cef49fd$var$ecparams.red);
    y = y.toRed($a6c9a9981cef49fd$var$ecparams.red);
    // is odd flag
    if ((first === 0x06 || first === 0x07) && y.isOdd() !== (first === 0x07)) return null;
    // x*x*x + b = y*y
    const x3 = x.redSqr().redIMul(x);
    if (!y.redSqr().redISub(x3.redIAdd($a6c9a9981cef49fd$var$ecparams.b)).isZero()) return null;
    return $a6c9a9981cef49fd$var$ec.keyPair({
        pub: {
            x: x,
            y: y
        }
    });
}
function $a6c9a9981cef49fd$var$loadPublicKey(pubkey) {
    // length should be validated in interface
    const first = pubkey[0];
    switch(first){
        case 0x02:
        case 0x03:
            if (pubkey.length !== 33) return null;
            return $a6c9a9981cef49fd$var$loadCompressedPublicKey(first, pubkey.subarray(1, 33));
        case 0x04:
        case 0x06:
        case 0x07:
            if (pubkey.length !== 65) return null;
            return $a6c9a9981cef49fd$var$loadUncompressedPublicKey(first, pubkey.subarray(1, 33), pubkey.subarray(33, 65));
        default:
            return null;
    }
}
function $a6c9a9981cef49fd$var$savePublicKey(output, point) {
    const pubkey = point.encode(null, output.length === 33);
    // Loop should be faster because we do not need create extra Uint8Array
    // output.set(new Uint8Array(pubkey))
    for(let i = 0; i < output.length; ++i)output[i] = pubkey[i];
}
module.exports = {
    contextRandomize () {
        return 0;
    },
    privateKeyVerify (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        return bn.cmp($a6c9a9981cef49fd$var$ecparams.n) < 0 && !bn.isZero() ? 0 : 1;
    },
    privateKeyNegate (seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        const negate = $a6c9a9981cef49fd$var$ecparams.n.sub(bn).umod($a6c9a9981cef49fd$var$ecparams.n).toArrayLike(Uint8Array, "be", 32);
        seckey.set(negate);
        return 0;
    },
    privateKeyTweakAdd (seckey, tweak) {
        const bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        bn.iadd(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn.isub($a6c9a9981cef49fd$var$ecparams.n);
        if (bn.isZero()) return 1;
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    privateKeyTweakMul (seckey, tweak) {
        let bn = new $a6c9a9981cef49fd$var$BN(tweak);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        bn.imul(new $a6c9a9981cef49fd$var$BN(seckey));
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) bn = bn.umod($a6c9a9981cef49fd$var$ecparams.n);
        const tweaked = bn.toArrayLike(Uint8Array, "be", 32);
        seckey.set(tweaked);
        return 0;
    },
    publicKeyVerify (pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        return pair === null ? 1 : 0;
    },
    publicKeyCreate (output, seckey) {
        const bn = new $a6c9a9981cef49fd$var$BN(seckey);
        if (bn.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || bn.isZero()) return 1;
        const point = $a6c9a9981cef49fd$var$ec.keyFromPrivate(seckey).getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyConvert (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyNegate (output, pubkey) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const point = pair.getPublic();
        point.y = point.y.redNeg();
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyCombine (output, pubkeys) {
        const pairs = new Array(pubkeys.length);
        for(let i = 0; i < pubkeys.length; ++i){
            pairs[i] = $a6c9a9981cef49fd$var$loadPublicKey(pubkeys[i]);
            if (pairs[i] === null) return 1;
        }
        let point = pairs[0].getPublic();
        for(let i = 1; i < pairs.length; ++i)point = point.add(pairs[i].pub);
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakAdd (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 2;
        const point = pair.getPublic().add($a6c9a9981cef49fd$var$ecparams.g.mul(tweak));
        if (point.isInfinity()) return 2;
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    publicKeyTweakMul (output, pubkey, tweak) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        tweak = new $a6c9a9981cef49fd$var$BN(tweak);
        if (tweak.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || tweak.isZero()) return 2;
        const point = pair.getPublic().mul(tweak);
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    signatureNormalize (sig) {
        const r = new $a6c9a9981cef49fd$var$BN(sig.subarray(0, 32));
        const s = new $a6c9a9981cef49fd$var$BN(sig.subarray(32, 64));
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (s.cmp($a6c9a9981cef49fd$var$ec.nh) === 1) sig.set($a6c9a9981cef49fd$var$ecparams.n.sub(s).toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureExport (obj, sig) {
        const sigR = sig.subarray(0, 32);
        const sigS = sig.subarray(32, 64);
        if (new $a6c9a9981cef49fd$var$BN(sigR).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (new $a6c9a9981cef49fd$var$BN(sigS).cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        const { output: output } = obj;
        // Prepare R
        let r = output.subarray(4, 37);
        r[0] = 0x00;
        r.set(sigR, 1);
        let lenR = 33;
        let posR = 0;
        for(; lenR > 1 && r[posR] === 0x00 && !(r[posR + 1] & 0x80); --lenR, ++posR);
        r = r.subarray(posR);
        if (r[0] & 0x80) return 1;
        if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) return 1;
        // Prepare S
        let s = output.subarray(39, 72);
        s[0] = 0x00;
        s.set(sigS, 1);
        let lenS = 33;
        let posS = 0;
        for(; lenS > 1 && s[posS] === 0x00 && !(s[posS + 1] & 0x80); --lenS, ++posS);
        s = s.subarray(posS);
        if (s[0] & 0x80) return 1;
        if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) return 1;
        // Set output length for return
        obj.outputlen = 6 + lenR + lenS;
        // Output in specified format
        // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
        output[0] = 0x30;
        output[1] = obj.outputlen - 2;
        output[2] = 0x02;
        output[3] = r.length;
        output.set(r, 4);
        output[4 + lenR] = 0x02;
        output[5 + lenR] = s.length;
        output.set(s, 6 + lenR);
        return 0;
    },
    // Copied 1-to-1 from https://github.com/bitcoinjs/bip66/blob/master/index.js
    // Adapted for Uint8Array instead Buffer
    signatureImport (output, sig) {
        if (sig.length < 8) return 1;
        if (sig.length > 72) return 1;
        if (sig[0] !== 0x30) return 1;
        if (sig[1] !== sig.length - 2) return 1;
        if (sig[2] !== 0x02) return 1;
        const lenR = sig[3];
        if (lenR === 0) return 1;
        if (5 + lenR >= sig.length) return 1;
        if (sig[4 + lenR] !== 0x02) return 1;
        const lenS = sig[5 + lenR];
        if (lenS === 0) return 1;
        if (6 + lenR + lenS !== sig.length) return 1;
        if (sig[4] & 0x80) return 1;
        if (lenR > 1 && sig[4] === 0x00 && !(sig[5] & 0x80)) return 1;
        if (sig[lenR + 6] & 0x80) return 1;
        if (lenS > 1 && sig[lenR + 6] === 0x00 && !(sig[lenR + 7] & 0x80)) return 1;
        let sigR = sig.subarray(4, 4 + lenR);
        if (sigR.length === 33 && sigR[0] === 0x00) sigR = sigR.subarray(1);
        if (sigR.length > 32) return 1;
        let sigS = sig.subarray(6 + lenR);
        if (sigS.length === 33 && sigS[0] === 0x00) sigS = sigS.slice(1);
        if (sigS.length > 32) throw new Error("S length is too long");
        let r = new $a6c9a9981cef49fd$var$BN(sigR);
        if (r.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) r = new $a6c9a9981cef49fd$var$BN(0);
        let s = new $a6c9a9981cef49fd$var$BN(sig.subarray(6 + lenR));
        if (s.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) s = new $a6c9a9981cef49fd$var$BN(0);
        output.set(r.toArrayLike(Uint8Array, "be", 32), 0);
        output.set(s.toArrayLike(Uint8Array, "be", 32), 32);
        return 0;
    },
    ecdsaSign (obj, message, seckey, data, noncefn) {
        if (noncefn) {
            const _noncefn = noncefn;
            noncefn = (counter)=>{
                const nonce = _noncefn(message, seckey, null, data, counter);
                const isValid = nonce instanceof Uint8Array && nonce.length === 32;
                if (!isValid) throw new Error("This is the way");
                return new $a6c9a9981cef49fd$var$BN(nonce);
            };
        }
        const d = new $a6c9a9981cef49fd$var$BN(seckey);
        if (d.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || d.isZero()) return 1;
        let sig;
        try {
            sig = $a6c9a9981cef49fd$var$ec.sign(message, seckey, {
                canonical: true,
                k: noncefn,
                pers: data
            });
        } catch (err) {
            return 1;
        }
        obj.signature.set(sig.r.toArrayLike(Uint8Array, "be", 32), 0);
        obj.signature.set(sig.s.toArrayLike(Uint8Array, "be", 32), 32);
        obj.recid = sig.recoveryParam;
        return 0;
    },
    ecdsaVerify (sig, msg32, pubkey) {
        const sigObj = {
            r: sig.subarray(0, 32),
            s: sig.subarray(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigs.cmp($a6c9a9981cef49fd$var$ec.nh) === 1 || sigr.isZero() || sigs.isZero()) return 3;
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 2;
        const point = pair.getPublic();
        const isValid = $a6c9a9981cef49fd$var$ec.verify(msg32, sigObj, point);
        return isValid ? 0 : 3;
    },
    ecdsaRecover (output, sig, recid, msg32) {
        const sigObj = {
            r: sig.slice(0, 32),
            s: sig.slice(32, 64)
        };
        const sigr = new $a6c9a9981cef49fd$var$BN(sigObj.r);
        const sigs = new $a6c9a9981cef49fd$var$BN(sigObj.s);
        if (sigr.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || sigs.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0) return 1;
        if (sigr.isZero() || sigs.isZero()) return 2;
        // Can throw `throw new Error('Unable to find sencond key candinate');`
        let point;
        try {
            point = $a6c9a9981cef49fd$var$ec.recoverPubKey(msg32, sigObj, recid);
        } catch (err) {
            return 2;
        }
        $a6c9a9981cef49fd$var$savePublicKey(output, point);
        return 0;
    },
    ecdh (output, pubkey, seckey, data, hashfn, xbuf, ybuf) {
        const pair = $a6c9a9981cef49fd$var$loadPublicKey(pubkey);
        if (pair === null) return 1;
        const scalar = new $a6c9a9981cef49fd$var$BN(seckey);
        if (scalar.cmp($a6c9a9981cef49fd$var$ecparams.n) >= 0 || scalar.isZero()) return 2;
        const point = pair.getPublic().mul(scalar);
        if (hashfn === undefined) {
            const data = point.encode(null, true);
            const sha256 = $a6c9a9981cef49fd$var$ec.hash().update(data).digest();
            for(let i = 0; i < 32; ++i)output[i] = sha256[i];
        } else {
            if (!xbuf) xbuf = new Uint8Array(32);
            const x = point.getX().toArray("be", 32);
            for(let i = 0; i < 32; ++i)xbuf[i] = x[i];
            if (!ybuf) ybuf = new Uint8Array(32);
            const y = point.getY().toArray("be", 32);
            for(let i = 0; i < 32; ++i)ybuf[i] = y[i];
            const hash = hashfn(xbuf, ybuf, data);
            const isValid = hash instanceof Uint8Array && hash.length === output.length;
            if (!isValid) return 2;
            output.set(hash);
        }
        return 0;
    }
};

});

parcelRegister("lkFCe", function(module, exports) {
"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.wNAF = wNAF;
exports.pippenger = pippenger;
exports.validateBasic = validateBasic;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
const _0n = BigInt(0);
const _1n = BigInt(1);
// Since points in different groups cannot be equal (different object constructor),
// we can have single place to store precomputes
const pointPrecomputes = new WeakMap();
const pointWindowSizes = new WeakMap(); // This allows use make points immutable (nothing changes inside)
// Elliptic curve multiplication of Point by scalar. Fragile.
// Scalars should always be less than curve order: this should be checked inside of a curve itself.
// Creates precomputation tables for fast multiplication:
// - private scalar is split by fixed size windows of W bits
// - every window point is collected from window's table & added to accumulator
// - since windows are different, same point inside tables won't be accessed more than once per calc
// - each multiplication is 'Math.ceil(CURVE_ORDER / 𝑊) + 1' point additions (fixed for any scalar)
// - +1 window is neccessary for wNAF
// - wNAF reduces table size: 2x less memory + 2x faster generation, but 10% slower multiplication
// TODO: Research returning 2d JS array of windows, instead of a single window. This would allow
// windows to be in different memory locations
function wNAF(c, bits) {
    const constTimeNegate = (condition, item)=>{
        const neg = item.negate();
        return condition ? neg : item;
    };
    const validateW = (W)=>{
        if (!Number.isSafeInteger(W) || W <= 0 || W > bits) throw new Error(`Wrong window size=${W}, should be [1..${bits}]`);
    };
    const opts = (W)=>{
        validateW(W);
        const windows = Math.ceil(bits / W) + 1; // +1, because
        const windowSize = 2 ** (W - 1); // -1 because we skip zero
        return {
            windows: windows,
            windowSize: windowSize
        };
    };
    return {
        constTimeNegate: constTimeNegate,
        // non-const time multiplication ladder
        unsafeLadder (elm, n) {
            let p = c.ZERO;
            let d = elm;
            while(n > _0n){
                if (n & _1n) p = p.add(d);
                d = d.double();
                n >>= _1n;
            }
            return p;
        },
        /**
         * Creates a wNAF precomputation window. Used for caching.
         * Default window size is set by `utils.precompute()` and is equal to 8.
         * Number of precomputed points depends on the curve size:
         * 2^(𝑊−1) * (Math.ceil(𝑛 / 𝑊) + 1), where:
         * - 𝑊 is the window size
         * - 𝑛 is the bitlength of the curve order.
         * For a 256-bit curve and window size 8, the number of precomputed points is 128 * 33 = 4224.
         * @returns precomputed point tables flattened to a single array
         */ precomputeWindow (elm, W) {
            const { windows, windowSize } = opts(W);
            const points = [];
            let p = elm;
            let base = p;
            for(let window = 0; window < windows; window++){
                base = p;
                points.push(base);
                // =1, because we skip zero
                for(let i = 1; i < windowSize; i++){
                    base = base.add(p);
                    points.push(base);
                }
                p = base.double();
            }
            return points;
        },
        /**
         * Implements ec multiplication using precomputed tables and w-ary non-adjacent form.
         * @param W window size
         * @param precomputes precomputed tables
         * @param n scalar (we don't check here, but should be less than curve order)
         * @returns real and fake (for const-time) points
         */ wNAF (W, precomputes, n) {
            // TODO: maybe check that scalar is less than group order? wNAF behavious is undefined otherwise
            // But need to carefully remove other checks before wNAF. ORDER == bits here
            const { windows, windowSize } = opts(W);
            let p = c.ZERO;
            let f = c.BASE;
            const mask = BigInt(2 ** W - 1); // Create mask with W ones: 0b1111 for W=4 etc.
            const maxNumber = 2 ** W;
            const shiftBy = BigInt(W);
            for(let window = 0; window < windows; window++){
                const offset = window * windowSize;
                // Extract W bits.
                let wbits = Number(n & mask);
                // Shift number by W bits.
                n >>= shiftBy;
                // If the bits are bigger than max size, we'll split those.
                // +224 => 256 - 32
                if (wbits > windowSize) {
                    wbits -= maxNumber;
                    n += _1n;
                }
                // This code was first written with assumption that 'f' and 'p' will never be infinity point:
                // since each addition is multiplied by 2 ** W, it cannot cancel each other. However,
                // there is negate now: it is possible that negated element from low value
                // would be the same as high element, which will create carry into next window.
                // It's not obvious how this can fail, but still worth investigating later.
                // Check if we're onto Zero point.
                // Add random point inside current window to f.
                const offset1 = offset;
                const offset2 = offset + Math.abs(wbits) - 1; // -1 because we skip zero
                const cond1 = window % 2 !== 0;
                const cond2 = wbits < 0;
                if (wbits === 0) // The most important part for const-time getPublicKey
                f = f.add(constTimeNegate(cond1, precomputes[offset1]));
                else p = p.add(constTimeNegate(cond2, precomputes[offset2]));
            }
            // JIT-compiler should not eliminate f here, since it will later be used in normalizeZ()
            // Even if the variable is still unused, there are some checks which will
            // throw an exception, so compiler needs to prove they won't happen, which is hard.
            // At this point there is a way to F be infinity-point even if p is not,
            // which makes it less const-time: around 1 bigint multiply.
            return {
                p: p,
                f: f
            };
        },
        wNAFCached (P, n, transform) {
            const W = pointWindowSizes.get(P) || 1;
            // Calculate precomputes on a first run, reuse them after
            let comp = pointPrecomputes.get(P);
            if (!comp) {
                comp = this.precomputeWindow(P, W);
                if (W !== 1) pointPrecomputes.set(P, transform(comp));
            }
            return this.wNAF(W, comp, n);
        },
        // We calculate precomputes for elliptic curve point multiplication
        // using windowed method. This specifies window size and
        // stores precomputed values. Usually only base point would be precomputed.
        setWindowSize (P, W) {
            validateW(W);
            pointWindowSizes.set(P, W);
            pointPrecomputes.delete(P);
        }
    };
}
/**
 * Pippenger algorithm for multi-scalar multiplication (MSM).
 * MSM is basically (Pa + Qb + Rc + ...).
 * 30x faster vs naive addition on L=4096, 10x faster with precomputes.
 * For N=254bit, L=1, it does: 1024 ADD + 254 DBL. For L=5: 1536 ADD + 254 DBL.
 * Algorithmically constant-time (for same L), even when 1 point + scalar, or when scalar = 0.
 * @param c Curve Point constructor
 * @param field field over CURVE.N - important that it's not over CURVE.P
 * @param points array of L curve points
 * @param scalars array of L scalars (aka private keys / bigints)
 */ function pippenger(c, field, points, scalars) {
    // If we split scalars by some window (let's say 8 bits), every chunk will only
    // take 256 buckets even if there are 4096 scalars, also re-uses double.
    // TODO:
    // - https://eprint.iacr.org/2024/750.pdf
    // - https://tches.iacr.org/index.php/TCHES/article/view/10287
    // 0 is accepted in scalars
    if (!Array.isArray(points) || !Array.isArray(scalars) || scalars.length !== points.length) throw new Error("arrays of points and scalars must have equal length");
    scalars.forEach((s, i)=>{
        if (!field.isValid(s)) throw new Error(`wrong scalar at index ${i}`);
    });
    points.forEach((p, i)=>{
        if (!(p instanceof c)) throw new Error(`wrong point at index ${i}`);
    });
    const wbits = (0, $esaJO.bitLen)(BigInt(points.length));
    const windowSize = wbits > 12 ? wbits - 3 : wbits > 4 ? wbits - 2 : wbits ? 2 : 1; // in bits
    const MASK = (1 << windowSize) - 1;
    const buckets = new Array(MASK + 1).fill(c.ZERO); // +1 for zero array
    const lastBits = Math.floor((field.BITS - 1) / windowSize) * windowSize;
    let sum = c.ZERO;
    for(let i = lastBits; i >= 0; i -= windowSize){
        buckets.fill(c.ZERO);
        for(let j = 0; j < scalars.length; j++){
            const scalar = scalars[j];
            const wbits = Number(scalar >> BigInt(i) & BigInt(MASK));
            buckets[wbits] = buckets[wbits].add(points[j]);
        }
        let resI = c.ZERO; // not using this will do small speed-up, but will lose ct
        // Skip first bucket, because it is zero
        for(let j = buckets.length - 1, sumI = c.ZERO; j > 0; j--){
            sumI = sumI.add(buckets[j]);
            resI = resI.add(sumI);
        }
        sum = sum.add(resI);
        if (i !== 0) for(let j = 0; j < windowSize; j++)sum = sum.double();
    }
    return sum;
}
function validateBasic(curve) {
    (0, $2D9sF.validateField)(curve.Fp);
    (0, $esaJO.validateObject)(curve, {
        n: "bigint",
        h: "bigint",
        Gx: "field",
        Gy: "field"
    }, {
        nBitLength: "isSafeInteger",
        nByteLength: "isSafeInteger"
    });
    // Set defaults
    return Object.freeze({
        ...(0, $2D9sF.nLength)(curve.n, curve.nBitLength),
        ...curve,
        p: curve.Fp.ORDER
    });
}

});
parcelRegister("2D9sF", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.isNegativeLE = void 0;
module.exports.mod = $1ea6901afdde618b$var$mod;
module.exports.pow = $1ea6901afdde618b$var$pow;
module.exports.pow2 = $1ea6901afdde618b$var$pow2;
module.exports.invert = $1ea6901afdde618b$var$invert;
module.exports.tonelliShanks = $1ea6901afdde618b$var$tonelliShanks;
module.exports.FpSqrt = $1ea6901afdde618b$var$FpSqrt;
module.exports.validateField = $1ea6901afdde618b$var$validateField;
module.exports.FpPow = $1ea6901afdde618b$var$FpPow;
module.exports.FpInvertBatch = $1ea6901afdde618b$var$FpInvertBatch;
module.exports.FpDiv = $1ea6901afdde618b$var$FpDiv;
module.exports.FpLegendre = $1ea6901afdde618b$var$FpLegendre;
module.exports.FpIsSquare = $1ea6901afdde618b$var$FpIsSquare;
module.exports.nLength = $1ea6901afdde618b$var$nLength;
module.exports.Field = $1ea6901afdde618b$var$Field;
module.exports.FpSqrtOdd = $1ea6901afdde618b$var$FpSqrtOdd;
module.exports.FpSqrtEven = $1ea6901afdde618b$var$FpSqrtEven;
module.exports.hashToPrivateScalar = $1ea6901afdde618b$var$hashToPrivateScalar;
module.exports.getFieldBytesLength = $1ea6901afdde618b$var$getFieldBytesLength;
module.exports.getMinHashLength = $1ea6901afdde618b$var$getMinHashLength;
module.exports.mapHashToField = $1ea6901afdde618b$var$mapHashToField;

var $esaJO = parcelRequire("esaJO");
// prettier-ignore
const $1ea6901afdde618b$var$_0n = BigInt(0), $1ea6901afdde618b$var$_1n = BigInt(1), $1ea6901afdde618b$var$_2n = BigInt(2), $1ea6901afdde618b$var$_3n = BigInt(3);
// prettier-ignore
const $1ea6901afdde618b$var$_4n = BigInt(4), $1ea6901afdde618b$var$_5n = BigInt(5), $1ea6901afdde618b$var$_8n = BigInt(8);
// prettier-ignore
const $1ea6901afdde618b$var$_9n = BigInt(9), $1ea6901afdde618b$var$_16n = BigInt(16);
// Calculates a modulo b
function $1ea6901afdde618b$var$mod(a, b) {
    const result = a % b;
    return result >= $1ea6901afdde618b$var$_0n ? result : b + result;
}
/**
 * Efficiently raise num to power and do modular division.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 * @example
 * pow(2n, 6n, 11n) // 64n % 11n == 9n
 */ // TODO: use field version && remove
function $1ea6901afdde618b$var$pow(num, power, modulo) {
    if (modulo <= $1ea6901afdde618b$var$_0n || power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power/modulo > 0");
    if (modulo === $1ea6901afdde618b$var$_1n) return $1ea6901afdde618b$var$_0n;
    let res = $1ea6901afdde618b$var$_1n;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) res = res * num % modulo;
        num = num * num % modulo;
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return res;
}
// Does x ^ (2 ^ power) mod p. pow2(30, 4) == 30 ^ (2 ^ 4)
function $1ea6901afdde618b$var$pow2(x, power, modulo) {
    let res = x;
    while(power-- > $1ea6901afdde618b$var$_0n){
        res *= res;
        res %= modulo;
    }
    return res;
}
// Inverses number over modulo
function $1ea6901afdde618b$var$invert(number, modulo) {
    if (number === $1ea6901afdde618b$var$_0n || modulo <= $1ea6901afdde618b$var$_0n) throw new Error(`invert: expected positive integers, got n=${number} mod=${modulo}`);
    // Euclidean GCD https://brilliant.org/wiki/extended-euclidean-algorithm/
    // Fermat's little theorem "CT-like" version inv(n) = n^(m-2) mod m is 30x slower.
    let a = $1ea6901afdde618b$var$mod(number, modulo);
    let b = modulo;
    // prettier-ignore
    let x = $1ea6901afdde618b$var$_0n, y = $1ea6901afdde618b$var$_1n, u = $1ea6901afdde618b$var$_1n, v = $1ea6901afdde618b$var$_0n;
    while(a !== $1ea6901afdde618b$var$_0n){
        // JIT applies optimization if those two lines follow each other
        const q = b / a;
        const r = b % a;
        const m = x - u * q;
        const n = y - v * q;
        // prettier-ignore
        b = a, a = r, x = u, y = v, u = m, v = n;
    }
    const gcd = b;
    if (gcd !== $1ea6901afdde618b$var$_1n) throw new Error("invert: does not exist");
    return $1ea6901afdde618b$var$mod(x, modulo);
}
/**
 * Tonelli-Shanks square root search algorithm.
 * 1. https://eprint.iacr.org/2012/685.pdf (page 12)
 * 2. Square Roots from 1; 24, 51, 10 to Dan Shanks
 * Will start an infinite loop if field order P is not prime.
 * @param P field order
 * @returns function that takes field Fp (created from P) and number n
 */ function $1ea6901afdde618b$var$tonelliShanks(P) {
    // Legendre constant: used to calculate Legendre symbol (a | p),
    // which denotes the value of a^((p-1)/2) (mod p).
    // (a | p) ≡ 1    if a is a square (mod p)
    // (a | p) ≡ -1   if a is not a square (mod p)
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreC = (P - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    let Q, S, Z;
    // Step 1: By factoring out powers of 2 from p - 1,
    // find q and s such that p - 1 = q*(2^s) with q odd
    for(Q = P - $1ea6901afdde618b$var$_1n, S = 0; Q % $1ea6901afdde618b$var$_2n === $1ea6901afdde618b$var$_0n; Q /= $1ea6901afdde618b$var$_2n, S++);
    // Step 2: Select a non-square z such that (z | p) ≡ -1 and set c ≡ zq
    for(Z = $1ea6901afdde618b$var$_2n; Z < P && $1ea6901afdde618b$var$pow(Z, legendreC, P) !== P - $1ea6901afdde618b$var$_1n; Z++);
    // Fast-path
    if (S === 1) {
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function tonelliFast(Fp, n) {
            const root = Fp.pow(n, p1div4);
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Slow-path
    const Q1div2 = (Q + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n;
    return function tonelliSlow(Fp, n) {
        // Step 0: Check that n is indeed a square: (n | p) should not be ≡ -1
        if (Fp.pow(n, legendreC) === Fp.neg(Fp.ONE)) throw new Error("Cannot find square root");
        let r = S;
        // TODO: will fail at Fp2/etc
        let g = Fp.pow(Fp.mul(Fp.ONE, Z), Q); // will update both x and b
        let x = Fp.pow(n, Q1div2); // first guess at the square root
        let b = Fp.pow(n, Q); // first guess at the fudge factor
        while(!Fp.eql(b, Fp.ONE)){
            if (Fp.eql(b, Fp.ZERO)) return Fp.ZERO; // https://en.wikipedia.org/wiki/Tonelli%E2%80%93Shanks_algorithm (4. If t = 0, return r = 0)
            // Find m such b^(2^m)==1
            let m = 1;
            for(let t2 = Fp.sqr(b); m < r; m++){
                if (Fp.eql(t2, Fp.ONE)) break;
                t2 = Fp.sqr(t2); // t2 *= t2
            }
            // NOTE: r-m-1 can be bigger than 32, need to convert to bigint before shift, otherwise there will be overflow
            const ge = Fp.pow(g, $1ea6901afdde618b$var$_1n << BigInt(r - m - 1)); // ge = 2^(r-m-1)
            g = Fp.sqr(ge); // g = ge * ge
            x = Fp.mul(x, ge); // x *= ge
            b = Fp.mul(b, g); // b *= g
            r = m;
        }
        return x;
    };
}
function $1ea6901afdde618b$var$FpSqrt(P) {
    // NOTE: different algorithms can give different roots, it is up to user to decide which one they want.
    // For example there is FpSqrtOdd/FpSqrtEven to choice root based on oddness (used for hash-to-curve).
    // P ≡ 3 (mod 4)
    // √n = n^((P+1)/4)
    if (P % $1ea6901afdde618b$var$_4n === $1ea6901afdde618b$var$_3n) {
        // Not all roots possible!
        // const ORDER =
        //   0x1a0111ea397fe69a4b1ba7b6434bacd764774b84f38512bf6730d2a0f6b0f6241eabfffeb153ffffb9feffffffffaaabn;
        // const NUM = 72057594037927816n;
        const p1div4 = (P + $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_4n;
        return function sqrt3mod4(Fp, n) {
            const root = Fp.pow(n, p1div4);
            // Throw if root**2 != n
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // Atkin algorithm for q ≡ 5 (mod 8), https://eprint.iacr.org/2012/685.pdf (page 10)
    if (P % $1ea6901afdde618b$var$_8n === $1ea6901afdde618b$var$_5n) {
        const c1 = (P - $1ea6901afdde618b$var$_5n) / $1ea6901afdde618b$var$_8n;
        return function sqrt5mod8(Fp, n) {
            const n2 = Fp.mul(n, $1ea6901afdde618b$var$_2n);
            const v = Fp.pow(n2, c1);
            const nv = Fp.mul(n, v);
            const i = Fp.mul(Fp.mul(nv, $1ea6901afdde618b$var$_2n), v);
            const root = Fp.mul(nv, Fp.sub(i, Fp.ONE));
            if (!Fp.eql(Fp.sqr(root), n)) throw new Error("Cannot find square root");
            return root;
        };
    }
    // P ≡ 9 (mod 16)
    $1ea6901afdde618b$var$_9n;
    // Other cases: Tonelli-Shanks algorithm
    return $1ea6901afdde618b$var$tonelliShanks(P);
}
// Little-endian check for first LE bit (last BE bit);
const $1ea6901afdde618b$var$isNegativeLE = (num, modulo)=>($1ea6901afdde618b$var$mod(num, modulo) & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n;
module.exports.isNegativeLE = $1ea6901afdde618b$var$isNegativeLE;
// prettier-ignore
const $1ea6901afdde618b$var$FIELD_FIELDS = [
    "create",
    "isValid",
    "is0",
    "neg",
    "inv",
    "sqrt",
    "sqr",
    "eql",
    "add",
    "sub",
    "mul",
    "pow",
    "div",
    "addN",
    "subN",
    "mulN",
    "sqrN"
];
function $1ea6901afdde618b$var$validateField(field) {
    const initial = {
        ORDER: "bigint",
        MASK: "bigint",
        BYTES: "isSafeInteger",
        BITS: "isSafeInteger"
    };
    const opts = $1ea6901afdde618b$var$FIELD_FIELDS.reduce((map, val)=>{
        map[val] = "function";
        return map;
    }, initial);
    return (0, $esaJO.validateObject)(field, opts);
}
// Generic field functions
/**
 * Same as `pow` but for Fp: non-constant-time.
 * Unsafe in some contexts: uses ladder, so can expose bigint bits.
 */ function $1ea6901afdde618b$var$FpPow(f, num, power) {
    // Should have same speed as pow for bigints
    // TODO: benchmark!
    if (power < $1ea6901afdde618b$var$_0n) throw new Error("Expected power > 0");
    if (power === $1ea6901afdde618b$var$_0n) return f.ONE;
    if (power === $1ea6901afdde618b$var$_1n) return num;
    let p = f.ONE;
    let d = num;
    while(power > $1ea6901afdde618b$var$_0n){
        if (power & $1ea6901afdde618b$var$_1n) p = f.mul(p, d);
        d = f.sqr(d);
        power >>= $1ea6901afdde618b$var$_1n;
    }
    return p;
}
/**
 * Efficiently invert an array of Field elements.
 * `inv(0)` will return `undefined` here: make sure to throw an error.
 */ function $1ea6901afdde618b$var$FpInvertBatch(f, nums) {
    const tmp = new Array(nums.length);
    // Walk from first to last, multiply them by each other MOD p
    const lastMultiplied = nums.reduce((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = acc;
        return f.mul(acc, num);
    }, f.ONE);
    // Invert last element
    const inverted = f.inv(lastMultiplied);
    // Walk from last to first, multiply them by inverted each other MOD p
    nums.reduceRight((acc, num, i)=>{
        if (f.is0(num)) return acc;
        tmp[i] = f.mul(acc, tmp[i]);
        return f.mul(acc, num);
    }, inverted);
    return tmp;
}
function $1ea6901afdde618b$var$FpDiv(f, lhs, rhs) {
    return f.mul(lhs, typeof rhs === "bigint" ? $1ea6901afdde618b$var$invert(rhs, f.ORDER) : f.inv(rhs));
}
function $1ea6901afdde618b$var$FpLegendre(order) {
    // (a | p) ≡ 1    if a is a square (mod p), quadratic residue
    // (a | p) ≡ -1   if a is not a square (mod p), quadratic non residue
    // (a | p) ≡ 0    if a ≡ 0 (mod p)
    const legendreConst = (order - $1ea6901afdde618b$var$_1n) / $1ea6901afdde618b$var$_2n; // Integer arithmetic
    return (f, x)=>f.pow(x, legendreConst);
}
// This function returns True whenever the value x is a square in the field F.
function $1ea6901afdde618b$var$FpIsSquare(f) {
    const legendre = $1ea6901afdde618b$var$FpLegendre(f.ORDER);
    return (x)=>{
        const p = legendre(f, x);
        return f.eql(p, f.ZERO) || f.eql(p, f.ONE);
    };
}
// CURVE.n lengths
function $1ea6901afdde618b$var$nLength(n, nBitLength) {
    // Bit size, byte size of CURVE.n
    const _nBitLength = nBitLength !== undefined ? nBitLength : n.toString(2).length;
    const nByteLength = Math.ceil(_nBitLength / 8);
    return {
        nBitLength: _nBitLength,
        nByteLength: nByteLength
    };
}
/**
 * Initializes a finite field over prime. **Non-primes are not supported.**
 * Do not init in loop: slow. Very fragile: always run a benchmark on a change.
 * Major performance optimizations:
 * * a) denormalized operations like mulN instead of mul
 * * b) same object shape: never add or remove keys
 * * c) Object.freeze
 * NOTE: operations don't check 'isValid' for all elements for performance reasons,
 * it is caller responsibility to check this.
 * This is low-level code, please make sure you know what you doing.
 * @param ORDER prime positive bigint
 * @param bitLen how many bits the field consumes
 * @param isLE (def: false) if encoding / decoding should be in little-endian
 * @param redef optional faster redefinitions of sqrt and other methods
 */ function $1ea6901afdde618b$var$Field(ORDER, bitLen, isLE = false, redef = {}) {
    if (ORDER <= $1ea6901afdde618b$var$_0n) throw new Error(`Expected Field ORDER > 0, got ${ORDER}`);
    const { nBitLength: BITS, nByteLength: BYTES } = $1ea6901afdde618b$var$nLength(ORDER, bitLen);
    if (BYTES > 2048) throw new Error("Field lengths over 2048 bytes are not supported");
    const sqrtP = $1ea6901afdde618b$var$FpSqrt(ORDER);
    const f = Object.freeze({
        ORDER: ORDER,
        BITS: BITS,
        BYTES: BYTES,
        MASK: (0, $esaJO.bitMask)(BITS),
        ZERO: $1ea6901afdde618b$var$_0n,
        ONE: $1ea6901afdde618b$var$_1n,
        create: (num)=>$1ea6901afdde618b$var$mod(num, ORDER),
        isValid: (num)=>{
            if (typeof num !== "bigint") throw new Error(`Invalid field element: expected bigint, got ${typeof num}`);
            return $1ea6901afdde618b$var$_0n <= num && num < ORDER; // 0 is valid element, but it's not invertible
        },
        is0: (num)=>num === $1ea6901afdde618b$var$_0n,
        isOdd: (num)=>(num & $1ea6901afdde618b$var$_1n) === $1ea6901afdde618b$var$_1n,
        neg: (num)=>$1ea6901afdde618b$var$mod(-num, ORDER),
        eql: (lhs, rhs)=>lhs === rhs,
        sqr: (num)=>$1ea6901afdde618b$var$mod(num * num, ORDER),
        add: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs + rhs, ORDER),
        sub: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs - rhs, ORDER),
        mul: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * rhs, ORDER),
        pow: (num, power)=>$1ea6901afdde618b$var$FpPow(f, num, power),
        div: (lhs, rhs)=>$1ea6901afdde618b$var$mod(lhs * $1ea6901afdde618b$var$invert(rhs, ORDER), ORDER),
        // Same as above, but doesn't normalize
        sqrN: (num)=>num * num,
        addN: (lhs, rhs)=>lhs + rhs,
        subN: (lhs, rhs)=>lhs - rhs,
        mulN: (lhs, rhs)=>lhs * rhs,
        inv: (num)=>$1ea6901afdde618b$var$invert(num, ORDER),
        sqrt: redef.sqrt || ((n)=>sqrtP(f, n)),
        invertBatch: (lst)=>$1ea6901afdde618b$var$FpInvertBatch(f, lst),
        // TODO: do we really need constant cmov?
        // We don't have const-time bigints anyway, so probably will be not very useful
        cmov: (a, b, c)=>c ? b : a,
        toBytes: (num)=>isLE ? (0, $esaJO.numberToBytesLE)(num, BYTES) : (0, $esaJO.numberToBytesBE)(num, BYTES),
        fromBytes: (bytes)=>{
            if (bytes.length !== BYTES) throw new Error(`Fp.fromBytes: expected ${BYTES}, got ${bytes.length}`);
            return isLE ? (0, $esaJO.bytesToNumberLE)(bytes) : (0, $esaJO.bytesToNumberBE)(bytes);
        }
    });
    return Object.freeze(f);
}
function $1ea6901afdde618b$var$FpSqrtOdd(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? root : Fp.neg(root);
}
function $1ea6901afdde618b$var$FpSqrtEven(Fp, elm) {
    if (!Fp.isOdd) throw new Error(`Field doesn't have isOdd`);
    const root = Fp.sqrt(elm);
    return Fp.isOdd(root) ? Fp.neg(root) : root;
}
/**
 * "Constant-time" private key generation utility.
 * Same as mapKeyToField, but accepts less bytes (40 instead of 48 for 32-byte field).
 * Which makes it slightly more biased, less secure.
 * @deprecated use mapKeyToField instead
 */ function $1ea6901afdde618b$var$hashToPrivateScalar(hash, groupOrder, isLE = false) {
    hash = (0, $esaJO.ensureBytes)("privateHash", hash);
    const hashLen = hash.length;
    const minLen = $1ea6901afdde618b$var$nLength(groupOrder).nByteLength + 8;
    if (minLen < 24 || hashLen < minLen || hashLen > 1024) throw new Error(`hashToPrivateScalar: expected ${minLen}-1024 bytes of input, got ${hashLen}`);
    const num = isLE ? (0, $esaJO.bytesToNumberLE)(hash) : (0, $esaJO.bytesToNumberBE)(hash);
    return $1ea6901afdde618b$var$mod(num, groupOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
}
/**
 * Returns total number of bytes consumed by the field element.
 * For example, 32 bytes for usual 256-bit weierstrass curve.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of field
 */ function $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder) {
    if (typeof fieldOrder !== "bigint") throw new Error("field order must be bigint");
    const bitLength = fieldOrder.toString(2).length;
    return Math.ceil(bitLength / 8);
}
/**
 * Returns minimal amount of bytes that can be safely reduced
 * by field order.
 * Should be 2^-128 for 128-bit curve such as P256.
 * @param fieldOrder number of field elements, usually CURVE.n
 * @returns byte length of target hash
 */ function $1ea6901afdde618b$var$getMinHashLength(fieldOrder) {
    const length = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    return length + Math.ceil(length / 2);
}
/**
 * "Constant-time" private key generation utility.
 * Can take (n + n/2) or more bytes of uniform input e.g. from CSPRNG or KDF
 * and convert them into private scalar, with the modulo bias being negligible.
 * Needs at least 48 bytes of input for 32-byte private key.
 * https://research.kudelskisecurity.com/2020/07/28/the-definitive-guide-to-modulo-bias-and-how-to-avoid-it/
 * FIPS 186-5, A.2 https://csrc.nist.gov/publications/detail/fips/186/5/final
 * RFC 9380, https://www.rfc-editor.org/rfc/rfc9380#section-5
 * @param hash hash output from SHA3 or a similar function
 * @param groupOrder size of subgroup - (e.g. secp256k1.CURVE.n)
 * @param isLE interpret hash bytes as LE num
 * @returns valid private scalar
 */ function $1ea6901afdde618b$var$mapHashToField(key, fieldOrder, isLE = false) {
    const len = key.length;
    const fieldLen = $1ea6901afdde618b$var$getFieldBytesLength(fieldOrder);
    const minLen = $1ea6901afdde618b$var$getMinHashLength(fieldOrder);
    // No small numbers: need to understand bias story. No huge numbers: easier to detect JS timings.
    if (len < 16 || len < minLen || len > 1024) throw new Error(`expected ${minLen}-1024 bytes of input, got ${len}`);
    const num = isLE ? (0, $esaJO.bytesToNumberBE)(key) : (0, $esaJO.bytesToNumberLE)(key);
    // `mod(x, 11)` can sometimes produce 0. `mod(x, 10) + 1` is the same, but no 0
    const reduced = $1ea6901afdde618b$var$mod(num, fieldOrder - $1ea6901afdde618b$var$_1n) + $1ea6901afdde618b$var$_1n;
    return isLE ? (0, $esaJO.numberToBytesLE)(reduced, fieldLen) : (0, $esaJO.numberToBytesBE)(reduced, fieldLen);
}

});
parcelRegister("esaJO", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.notImplemented = module.exports.bitMask = void 0;
module.exports.isBytes = $a85c028f110aa8ce$var$isBytes;
module.exports.abytes = $a85c028f110aa8ce$var$abytes;
module.exports.abool = $a85c028f110aa8ce$var$abool;
module.exports.bytesToHex = $a85c028f110aa8ce$var$bytesToHex;
module.exports.numberToHexUnpadded = $a85c028f110aa8ce$var$numberToHexUnpadded;
module.exports.hexToNumber = $a85c028f110aa8ce$var$hexToNumber;
module.exports.hexToBytes = $a85c028f110aa8ce$var$hexToBytes;
module.exports.bytesToNumberBE = $a85c028f110aa8ce$var$bytesToNumberBE;
module.exports.bytesToNumberLE = $a85c028f110aa8ce$var$bytesToNumberLE;
module.exports.numberToBytesBE = $a85c028f110aa8ce$var$numberToBytesBE;
module.exports.numberToBytesLE = $a85c028f110aa8ce$var$numberToBytesLE;
module.exports.numberToVarBytesBE = $a85c028f110aa8ce$var$numberToVarBytesBE;
module.exports.ensureBytes = $a85c028f110aa8ce$var$ensureBytes;
module.exports.concatBytes = $a85c028f110aa8ce$var$concatBytes;
module.exports.equalBytes = $a85c028f110aa8ce$var$equalBytes;
module.exports.utf8ToBytes = $a85c028f110aa8ce$var$utf8ToBytes;
module.exports.inRange = $a85c028f110aa8ce$var$inRange;
module.exports.aInRange = $a85c028f110aa8ce$var$aInRange;
module.exports.bitLen = $a85c028f110aa8ce$var$bitLen;
module.exports.bitGet = $a85c028f110aa8ce$var$bitGet;
module.exports.bitSet = $a85c028f110aa8ce$var$bitSet;
module.exports.createHmacDrbg = $a85c028f110aa8ce$var$createHmacDrbg;
module.exports.validateObject = $a85c028f110aa8ce$var$validateObject;
module.exports.memoized = $a85c028f110aa8ce$var$memoized;
/*! noble-curves - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // 100 lines of code in the file are duplicated from noble-hashes (utils).
// This is OK: `abstract` directory does not use noble-hashes.
// User may opt-in into using different hashing library. This way, noble-hashes
// won't be included into their bundle.
const $a85c028f110aa8ce$var$_0n = /* @__PURE__ */ BigInt(0);
const $a85c028f110aa8ce$var$_1n = /* @__PURE__ */ BigInt(1);
const $a85c028f110aa8ce$var$_2n = /* @__PURE__ */ BigInt(2);
function $a85c028f110aa8ce$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
function $a85c028f110aa8ce$var$abytes(item) {
    if (!$a85c028f110aa8ce$var$isBytes(item)) throw new Error("Uint8Array expected");
}
function $a85c028f110aa8ce$var$abool(title, value) {
    if (typeof value !== "boolean") throw new Error(`${title} must be valid boolean, got "${value}".`);
}
// Array where index 0xf0 (240) is mapped to string 'f0'
const $a85c028f110aa8ce$var$hexes = /* @__PURE__ */ Array.from({
    length: 256
}, (_, i)=>i.toString(16).padStart(2, "0"));
/**
 * @example bytesToHex(Uint8Array.from([0xca, 0xfe, 0x01, 0x23])) // 'cafe0123'
 */ function $a85c028f110aa8ce$var$bytesToHex(bytes) {
    $a85c028f110aa8ce$var$abytes(bytes);
    // pre-caching improves the speed 6x
    let hex = "";
    for(let i = 0; i < bytes.length; i++)hex += $a85c028f110aa8ce$var$hexes[bytes[i]];
    return hex;
}
function $a85c028f110aa8ce$var$numberToHexUnpadded(num) {
    const hex = num.toString(16);
    return hex.length & 1 ? `0${hex}` : hex;
}
function $a85c028f110aa8ce$var$hexToNumber(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    // Big Endian
    return BigInt(hex === "" ? "0" : `0x${hex}`);
}
// We use optimized technique to convert hex string to byte array
const $a85c028f110aa8ce$var$asciis = {
    _0: 48,
    _9: 57,
    _A: 65,
    _F: 70,
    _a: 97,
    _f: 102
};
function $a85c028f110aa8ce$var$asciiToBase16(char) {
    if (char >= $a85c028f110aa8ce$var$asciis._0 && char <= $a85c028f110aa8ce$var$asciis._9) return char - $a85c028f110aa8ce$var$asciis._0;
    if (char >= $a85c028f110aa8ce$var$asciis._A && char <= $a85c028f110aa8ce$var$asciis._F) return char - ($a85c028f110aa8ce$var$asciis._A - 10);
    if (char >= $a85c028f110aa8ce$var$asciis._a && char <= $a85c028f110aa8ce$var$asciis._f) return char - ($a85c028f110aa8ce$var$asciis._a - 10);
    return;
}
/**
 * @example hexToBytes('cafe0123') // Uint8Array.from([0xca, 0xfe, 0x01, 0x23])
 */ function $a85c028f110aa8ce$var$hexToBytes(hex) {
    if (typeof hex !== "string") throw new Error("hex string expected, got " + typeof hex);
    const hl = hex.length;
    const al = hl / 2;
    if (hl % 2) throw new Error("padded hex string expected, got unpadded hex of length " + hl);
    const array = new Uint8Array(al);
    for(let ai = 0, hi = 0; ai < al; ai++, hi += 2){
        const n1 = $a85c028f110aa8ce$var$asciiToBase16(hex.charCodeAt(hi));
        const n2 = $a85c028f110aa8ce$var$asciiToBase16(hex.charCodeAt(hi + 1));
        if (n1 === undefined || n2 === undefined) {
            const char = hex[hi] + hex[hi + 1];
            throw new Error('hex string expected, got non-hex character "' + char + '" at index ' + hi);
        }
        array[ai] = n1 * 16 + n2;
    }
    return array;
}
// BE: Big Endian, LE: Little Endian
function $a85c028f110aa8ce$var$bytesToNumberBE(bytes) {
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(bytes));
}
function $a85c028f110aa8ce$var$bytesToNumberLE(bytes) {
    $a85c028f110aa8ce$var$abytes(bytes);
    return $a85c028f110aa8ce$var$hexToNumber($a85c028f110aa8ce$var$bytesToHex(Uint8Array.from(bytes).reverse()));
}
function $a85c028f110aa8ce$var$numberToBytesBE(n, len) {
    return $a85c028f110aa8ce$var$hexToBytes(n.toString(16).padStart(len * 2, "0"));
}
function $a85c028f110aa8ce$var$numberToBytesLE(n, len) {
    return $a85c028f110aa8ce$var$numberToBytesBE(n, len).reverse();
}
// Unpadded, rarely used
function $a85c028f110aa8ce$var$numberToVarBytesBE(n) {
    return $a85c028f110aa8ce$var$hexToBytes($a85c028f110aa8ce$var$numberToHexUnpadded(n));
}
/**
 * Takes hex string or Uint8Array, converts to Uint8Array.
 * Validates output length.
 * Will throw error for other types.
 * @param title descriptive title for an error e.g. 'private key'
 * @param hex hex string or Uint8Array
 * @param expectedLength optional, will compare to result array's length
 * @returns
 */ function $a85c028f110aa8ce$var$ensureBytes(title, hex, expectedLength) {
    let res;
    if (typeof hex === "string") try {
        res = $a85c028f110aa8ce$var$hexToBytes(hex);
    } catch (e) {
        throw new Error(`${title} must be valid hex string, got "${hex}". Cause: ${e}`);
    }
    else if ($a85c028f110aa8ce$var$isBytes(hex)) // Uint8Array.from() instead of hash.slice() because node.js Buffer
    // is instance of Uint8Array, and its slice() creates **mutable** copy
    res = Uint8Array.from(hex);
    else throw new Error(`${title} must be hex string or Uint8Array`);
    const len = res.length;
    if (typeof expectedLength === "number" && len !== expectedLength) throw new Error(`${title} expected ${expectedLength} bytes, got ${len}`);
    return res;
}
/**
 * Copies several Uint8Arrays into one.
 */ function $a85c028f110aa8ce$var$concatBytes(...arrays) {
    let sum = 0;
    for(let i = 0; i < arrays.length; i++){
        const a = arrays[i];
        $a85c028f110aa8ce$var$abytes(a);
        sum += a.length;
    }
    const res = new Uint8Array(sum);
    for(let i = 0, pad = 0; i < arrays.length; i++){
        const a = arrays[i];
        res.set(a, pad);
        pad += a.length;
    }
    return res;
}
// Compares 2 u8a-s in kinda constant time
function $a85c028f110aa8ce$var$equalBytes(a, b) {
    if (a.length !== b.length) return false;
    let diff = 0;
    for(let i = 0; i < a.length; i++)diff |= a[i] ^ b[i];
    return diff === 0;
}
/**
 * @example utf8ToBytes('abc') // new Uint8Array([97, 98, 99])
 */ function $a85c028f110aa8ce$var$utf8ToBytes(str) {
    if (typeof str !== "string") throw new Error(`utf8ToBytes expected string, got ${typeof str}`);
    return new Uint8Array(new TextEncoder().encode(str)); // https://bugzil.la/1681809
}
// Is positive bigint
const $a85c028f110aa8ce$var$isPosBig = (n)=>typeof n === "bigint" && $a85c028f110aa8ce$var$_0n <= n;
function $a85c028f110aa8ce$var$inRange(n, min, max) {
    return $a85c028f110aa8ce$var$isPosBig(n) && $a85c028f110aa8ce$var$isPosBig(min) && $a85c028f110aa8ce$var$isPosBig(max) && min <= n && n < max;
}
/**
 * Asserts min <= n < max. NOTE: It's < max and not <= max.
 * @example
 * aInRange('x', x, 1n, 256n); // would assume x is in (1n..255n)
 */ function $a85c028f110aa8ce$var$aInRange(title, n, min, max) {
    // Why min <= n < max and not a (min < n < max) OR b (min <= n <= max)?
    // consider P=256n, min=0n, max=P
    // - a for min=0 would require -1:          `inRange('x', x, -1n, P)`
    // - b would commonly require subtraction:  `inRange('x', x, 0n, P - 1n)`
    // - our way is the cleanest:               `inRange('x', x, 0n, P)
    if (!$a85c028f110aa8ce$var$inRange(n, min, max)) throw new Error(`expected valid ${title}: ${min} <= n < ${max}, got ${typeof n} ${n}`);
}
// Bit operations
/**
 * Calculates amount of bits in a bigint.
 * Same as `n.toString(2).length`
 */ function $a85c028f110aa8ce$var$bitLen(n) {
    let len;
    for(len = 0; n > $a85c028f110aa8ce$var$_0n; n >>= $a85c028f110aa8ce$var$_1n, len += 1);
    return len;
}
/**
 * Gets single bit at position.
 * NOTE: first bit position is 0 (same as arrays)
 * Same as `!!+Array.from(n.toString(2)).reverse()[pos]`
 */ function $a85c028f110aa8ce$var$bitGet(n, pos) {
    return n >> BigInt(pos) & $a85c028f110aa8ce$var$_1n;
}
/**
 * Sets single bit at position.
 */ function $a85c028f110aa8ce$var$bitSet(n, pos, value) {
    return n | (value ? $a85c028f110aa8ce$var$_1n : $a85c028f110aa8ce$var$_0n) << BigInt(pos);
}
/**
 * Calculate mask for N bits. Not using ** operator with bigints because of old engines.
 * Same as BigInt(`0b${Array(i).fill('1').join('')}`)
 */ const $a85c028f110aa8ce$var$bitMask = (n)=>($a85c028f110aa8ce$var$_2n << BigInt(n - 1)) - $a85c028f110aa8ce$var$_1n;
module.exports.bitMask = $a85c028f110aa8ce$var$bitMask;
// DRBG
const $a85c028f110aa8ce$var$u8n = (data)=>new Uint8Array(data); // creates Uint8Array
const $a85c028f110aa8ce$var$u8fr = (arr)=>Uint8Array.from(arr); // another shortcut
/**
 * Minimal HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
 * @returns function that will call DRBG until 2nd arg returns something meaningful
 * @example
 *   const drbg = createHmacDRBG<Key>(32, 32, hmac);
 *   drbg(seed, bytesToKey); // bytesToKey must return Key or undefined
 */ function $a85c028f110aa8ce$var$createHmacDrbg(hashLen, qByteLen, hmacFn) {
    if (typeof hashLen !== "number" || hashLen < 2) throw new Error("hashLen must be a number");
    if (typeof qByteLen !== "number" || qByteLen < 2) throw new Error("qByteLen must be a number");
    if (typeof hmacFn !== "function") throw new Error("hmacFn must be a function");
    // Step B, Step C: set hashLen to 8*ceil(hlen/8)
    let v = $a85c028f110aa8ce$var$u8n(hashLen); // Minimal non-full-spec HMAC-DRBG from NIST 800-90 for RFC6979 sigs.
    let k = $a85c028f110aa8ce$var$u8n(hashLen); // Steps B and C of RFC6979 3.2: set hashLen, in our case always same
    let i = 0; // Iterations counter, will throw when over 1000
    const reset = ()=>{
        v.fill(1);
        k.fill(0);
        i = 0;
    };
    const h = (...b)=>hmacFn(k, v, ...b); // hmac(k)(v, ...values)
    const reseed = (seed = $a85c028f110aa8ce$var$u8n())=>{
        // HMAC-DRBG reseed() function. Steps D-G
        k = h($a85c028f110aa8ce$var$u8fr([
            0x00
        ]), seed); // k = hmac(k || v || 0x00 || seed)
        v = h(); // v = hmac(k || v)
        if (seed.length === 0) return;
        k = h($a85c028f110aa8ce$var$u8fr([
            0x01
        ]), seed); // k = hmac(k || v || 0x01 || seed)
        v = h(); // v = hmac(k || v)
    };
    const gen = ()=>{
        // HMAC-DRBG generate() function
        if (i++ >= 1000) throw new Error("drbg: tried 1000 values");
        let len = 0;
        const out = [];
        while(len < qByteLen){
            v = h();
            const sl = v.slice();
            out.push(sl);
            len += v.length;
        }
        return $a85c028f110aa8ce$var$concatBytes(...out);
    };
    const genUntil = (seed, pred)=>{
        reset();
        reseed(seed); // Steps D-G
        let res = undefined; // Step H: grind until k is in [1..n-1]
        while(!(res = pred(gen())))reseed();
        reset();
        return res;
    };
    return genUntil;
}
// Validating curves and fields
const $a85c028f110aa8ce$var$validatorFns = {
    bigint: (val)=>typeof val === "bigint",
    function: (val)=>typeof val === "function",
    boolean: (val)=>typeof val === "boolean",
    string: (val)=>typeof val === "string",
    stringOrUint8Array: (val)=>typeof val === "string" || $a85c028f110aa8ce$var$isBytes(val),
    isSafeInteger: (val)=>Number.isSafeInteger(val),
    array: (val)=>Array.isArray(val),
    field: (val, object)=>object.Fp.isValid(val),
    hash: (val)=>typeof val === "function" && Number.isSafeInteger(val.outputLen)
};
// type Record<K extends string | number | symbol, T> = { [P in K]: T; }
function $a85c028f110aa8ce$var$validateObject(object, validators, optValidators = {}) {
    const checkField = (fieldName, type, isOptional)=>{
        const checkVal = $a85c028f110aa8ce$var$validatorFns[type];
        if (typeof checkVal !== "function") throw new Error(`Invalid validator "${type}", expected function`);
        const val = object[fieldName];
        if (isOptional && val === undefined) return;
        if (!checkVal(val, object)) throw new Error(`Invalid param ${String(fieldName)}=${val} (${typeof val}), expected ${type}`);
    };
    for (const [fieldName, type] of Object.entries(validators))checkField(fieldName, type, false);
    for (const [fieldName, type] of Object.entries(optValidators))checkField(fieldName, type, true);
    return object;
}
// validate type tests
// const o: { a: number; b: number; c: number } = { a: 1, b: 5, c: 6 };
// const z0 = validateObject(o, { a: 'isSafeInteger' }, { c: 'bigint' }); // Ok!
// // Should fail type-check
// const z1 = validateObject(o, { a: 'tmp' }, { c: 'zz' });
// const z2 = validateObject(o, { a: 'isSafeInteger' }, { c: 'zz' });
// const z3 = validateObject(o, { test: 'boolean', z: 'bug' });
// const z4 = validateObject(o, { a: 'boolean', z: 'bug' });
/**
 * throws not implemented error
 */ const $a85c028f110aa8ce$var$notImplemented = ()=>{
    throw new Error("not implemented");
};
module.exports.notImplemented = $a85c028f110aa8ce$var$notImplemented;
/**
 * Memoizes (caches) computation result.
 * Uses WeakMap: the value is going auto-cleaned by GC after last reference is removed.
 */ function $a85c028f110aa8ce$var$memoized(fn) {
    const map = new WeakMap();
    return (arg, ...args)=>{
        const val = map.get(arg);
        if (val !== undefined) return val;
        const computed = fn(arg, ...args);
        map.set(arg, computed);
        return computed;
    };
}

});



/**
 * TODO: 
 * - [x] Ledger need WitnessScript in PSBT to sign P2WSH correctly and it must be removed in P2WPKH case to finalize it!!!
 * - [x] Large MultiSig Policy P2WSH unable to finalize and extract with bitcoinjs-lib but succesfully with bitcoin core finalizepsbt!!!
 * - [x] Coin Selection (UTXOs sorting) !!!
 * - [x] Batch Multi-Outputs !!!
 * - [x] Inputs / UTXOs type (p2sh + wrapped)
 * - [x] Tx Type mixed !!!
 * - [ ] Combine PSBTs
 * - [X] BASE64 encoding differences -> PSBT -> bip174.org -> Bitcoin Core * 
 * - [x] KeyChain & Bip32DerivationPath Input Matrix!!!
 * - [x] Transaction Fee Input!!!
 * - [ ] Set Input Sequence
 * - [x] Estimate Fees
 * - [x] Get Address info Create TX/PSBT without Ledger App Client (splitTransaction|serializeTransactionOutputs methods)
 * - [x] CoinJoin - PSBT Inputs/Bip32 mapping
 * - [X] BTC/Sats conversion
 * - [x] PubKey compressed Display
 * - [x] Signatures List
 * - [x] Bluetooth Transport Client
 * - [x] Bluetooth + testnet checkbox instantiate new HWI client with default testnet boolean
 * - [X] UTXOs and globalInfo reset (ex. !coinjoin)
 * - [X] Bitcoin Core state
 * - [ ] ETH App?
 */ //import { listen } from "@ledgerhq/logs";

var $3wrUl = parcelRequire("3wrUl");

var $7etJZ = parcelRequire("7etJZ");
/* eslint-disable no-continue */ /* eslint-disable no-unused-vars */ /* eslint-disable no-param-reassign */ /* eslint-disable no-prototype-builtins */ const $50105411ce29e10f$var$errorClasses = {};
const $50105411ce29e10f$var$deserializers = {};
const $50105411ce29e10f$export$ff6248acd0c27a3f = (name, deserializer)=>{
    $50105411ce29e10f$var$deserializers[name] = deserializer;
};
const $50105411ce29e10f$export$94baff7bf5134824 = (name)=>{
    class CustomErrorClass extends Error {
        constructor(message, fields, options){
            // eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            super(message || name, options);
            // Set the prototype explicitly. See https://github.com/Microsoft/TypeScript/wiki/Breaking-Changes#extending-built-ins-like-error-array-and-map-may-no-longer-work
            Object.setPrototypeOf(this, CustomErrorClass.prototype);
            this.name = name;
            if (fields) for(const k in fields)// eslint-disable-next-line @typescript-eslint/ban-ts-comment
            // @ts-ignore
            this[k] = fields[k];
            if (options && $50105411ce29e10f$var$isObject(options) && "cause" in options && !("cause" in this)) {
                // .cause was specified but the superconstructor
                // did not create an instance property.
                const cause = options.cause;
                this.cause = cause;
                if ("stack" in cause) this.stack = this.stack + "\nCAUSE: " + cause.stack;
            }
        }
    }
    $50105411ce29e10f$var$errorClasses[name] = CustomErrorClass;
    return CustomErrorClass;
};
function $50105411ce29e10f$var$isObject(value) {
    return typeof value === "object";
}
const $50105411ce29e10f$export$64cddc1e268e9046 = (object)=>{
    if (object && typeof object === "object") {
        try {
            if (typeof object.message === "string") {
                const msg = JSON.parse(object.message);
                if (msg.message && msg.name) object = msg;
            }
        } catch (e) {
        // nothing
        }
        let error;
        if (typeof object.name === "string") {
            const { name: name } = object;
            const des = $50105411ce29e10f$var$deserializers[name];
            if (des) error = des(object);
            else {
                let constructor = name === "Error" ? Error : $50105411ce29e10f$var$errorClasses[name];
                if (!constructor) {
                    console.warn("deserializing an unknown class '" + name + "'");
                    constructor = $50105411ce29e10f$export$94baff7bf5134824(name);
                }
                error = Object.create(constructor.prototype);
                try {
                    for(const prop in object)if (object.hasOwnProperty(prop)) error[prop] = object[prop];
                } catch (e) {
                // sometimes setting a property can fail (e.g. .name)
                }
            }
        } else if (typeof object.message === "string") error = new Error(object.message);
        if (error && !error.stack && Error.captureStackTrace) Error.captureStackTrace(error, $50105411ce29e10f$export$64cddc1e268e9046);
        return error;
    }
    return new Error(String(object));
};
const $50105411ce29e10f$export$46ff38bc6bdea8fb = (value)=>{
    if (!value) return value;
    if (typeof value === "object") return $50105411ce29e10f$var$destroyCircular(value, []);
    if (typeof value === "function") return `[Function: ${value.name || "anonymous"}]`;
    return value;
};
// https://www.npmjs.com/package/destroy-circular
function $50105411ce29e10f$var$destroyCircular(from, seen) {
    const to = {};
    seen.push(from);
    for (const key of Object.keys(from)){
        const value = from[key];
        if (typeof value === "function") continue;
        if (!value || typeof value !== "object") {
            to[key] = value;
            continue;
        }
        if (seen.indexOf(from[key]) === -1) {
            to[key] = $50105411ce29e10f$var$destroyCircular(from[key], seen.slice(0));
            continue;
        }
        to[key] = "[Circular]";
    }
    if (typeof from.name === "string") to.name = from.name;
    if (typeof from.message === "string") to.message = from.message;
    if (typeof from.stack === "string") to.stack = from.stack;
    return to;
}


const $9a194f74559621d2$export$d7dd32b41fc9c3a0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNameRequired");
const $9a194f74559621d2$export$fb9db505804530ec = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountNotSupported");
const $9a194f74559621d2$export$75c97521b0dae2d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AccountAwaitingSendPendingOperations");
const $9a194f74559621d2$export$c9d6bf2b06944665 = (0, $50105411ce29e10f$export$94baff7bf5134824)("AmountRequired");
const $9a194f74559621d2$export$2628fce2396c23c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BluetoothRequired");
const $9a194f74559621d2$export$75f8b0767ef406f1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("BtcUnmatchedApp");
const $9a194f74559621d2$export$f60aa84fd00bc3ee = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantOpenDevice");
const $9a194f74559621d2$export$fc0260506e4022ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("CashAddrNotSupported");
const $9a194f74559621d2$export$1e9e90415b859c28 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ClaimRewardsFeesWarning");
const $9a194f74559621d2$export$e0b1ec53ba36e221 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CurrencyNotSupported");
const $9a194f74559621d2$export$fa9aacd48d3a45c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceAppVerifyNotSupported");
const $9a194f74559621d2$export$f21ce806524ab8d4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceGenuineSocketEarlyClose");
const $9a194f74559621d2$export$9c30dc6872fcd74c = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNotGenuine");
const $9a194f74559621d2$export$1d5ae41b109edf1f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardExpected");
const $9a194f74559621d2$export$8eecf64ec9a8cfd7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnDashboardUnexpected");
const $9a194f74559621d2$export$a5e2071f1ac48fdd = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceInOSUExpected");
const $9a194f74559621d2$export$3be6e7231165f4ac = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceHalted");
const $9a194f74559621d2$export$fa7bfae6dce03474 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceNameInvalid");
const $9a194f74559621d2$export$bcce4e5aded80ca0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketFail");
const $9a194f74559621d2$export$944a0f9a7cc1e03a = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$612d1f6d08d4cfb = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceSocketNoBulkStatus");
const $9a194f74559621d2$export$5f6bf7cdd5818529 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnresponsiveDeviceError");
const $9a194f74559621d2$export$1e42f3936938e063 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDevice");
const $9a194f74559621d2$export$2a60f41a2ed2742 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisconnectedDeviceDuringOperation");
const $9a194f74559621d2$export$93e2040d8e24d646 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceExtractOnboardingStateError");
const $9a194f74559621d2$export$e6aaf90bcb4b2013 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceOnboardingStatePollingError");
const $9a194f74559621d2$export$cfbd0adf8f9fdaf9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EnpointConfig");
const $9a194f74559621d2$export$96d8d3c501f1625 = (0, $50105411ce29e10f$export$94baff7bf5134824)("EthAppPleaseEnableContractData");
const $9a194f74559621d2$export$37b49553b7172cb1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeEstimationFailed");
const $9a194f74559621d2$export$d00fd6c398a70fd9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareNotRecognized");
const $9a194f74559621d2$export$3dc3bbf8c134219c = (0, $50105411ce29e10f$export$94baff7bf5134824)("HardResetFail");
const $9a194f74559621d2$export$5e8f7ae1054a2777 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidXRPTag");
const $9a194f74559621d2$export$953b602d2269ceba = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddress");
const $9a194f74559621d2$export$61e75f453df94067 = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidNonce");
const $9a194f74559621d2$export$bbdaf7c77a7508eb = (0, $50105411ce29e10f$export$94baff7bf5134824)("InvalidAddressBecauseDestinationIsAlsoSource");
const $9a194f74559621d2$export$882967e2980534f9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LatestMCUInstalledError");
const $9a194f74559621d2$export$59772a13ac97df0e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnknownMCU");
const $9a194f74559621d2$export$26bf4f7c63d50901 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIError");
const $9a194f74559621d2$export$fdab6afd1b1820af = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPIErrorWithMessage");
const $9a194f74559621d2$export$c2996b38942cf758 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPINotAvailable");
const $9a194f74559621d2$export$3d81abcc61613a27 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppAlreadyInstalled");
const $9a194f74559621d2$export$87a9bff9fff141e2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppRelyOnBTC");
const $9a194f74559621d2$export$86581a722c4238c0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepInstallRequired");
const $9a194f74559621d2$export$267a8476044885dd = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerAppDepUninstallRequired");
const $9a194f74559621d2$export$bb771ca417eca344 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerDeviceLocked");
const $9a194f74559621d2$export$b634ce25e3ff5229 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerFirmwareNotEnoughSpace");
const $9a194f74559621d2$export$2d26f4eadfe37285 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerNotEnoughSpace");
const $9a194f74559621d2$export$ceb7f9bef5a1e481 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ManagerUninstallBTCDep");
const $9a194f74559621d2$export$baadb6886fde1621 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkDown");
const $9a194f74559621d2$export$bae979e68e4dc802 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NetworkError");
const $9a194f74559621d2$export$5cbfa0659f97216a = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAddressesFound");
const $9a194f74559621d2$export$9e00aead3515e5c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalance");
const $9a194f74559621d2$export$c7a9d36aa9527144 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceSwap");
const $9a194f74559621d2$export$5ed90e0e011f4857 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceToDelegate");
const $9a194f74559621d2$export$75178c95e66d9630 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceInParentAccount");
const $9a194f74559621d2$export$e3e2865b29f7e0b0 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughSpendableBalance");
const $9a194f74559621d2$export$a84b3634866707ea = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughBalanceBecauseDestinationNotCreated");
const $9a194f74559621d2$export$a282f858b69a7326 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoAccessToCamera");
const $9a194f74559621d2$export$5111c405c5cacc97 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGas");
const $9a194f74559621d2$export$1cb5c4489aaca4d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotEnoughGasSwap");
const $9a194f74559621d2$export$8e08d9056f116258 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TronEmptyAccount");
const $9a194f74559621d2$export$213047d20fb2fead = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaybeKeepTronAccountAlive");
const $9a194f74559621d2$export$626e1fd20d22139c = (0, $50105411ce29e10f$export$94baff7bf5134824)("NotSupportedLegacyAddress");
const $9a194f74559621d2$export$f919e2c9c746346b = (0, $50105411ce29e10f$export$94baff7bf5134824)("GasLessThanEstimate");
const $9a194f74559621d2$export$cc562f3706902d22 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooLow");
const $9a194f74559621d2$export$ee14d05cd43eb762 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeTooHigh");
const $9a194f74559621d2$export$931458f4b7d53154 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PriorityFeeHigherThanMaxFee");
const $9a194f74559621d2$export$c0ce9cadb94c6b86 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MaxFeeTooLow");
const $9a194f74559621d2$export$22c5aa8937c5b423 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordsDontMatch");
const $9a194f74559621d2$export$f57670cd1aaf386 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PasswordIncorrect");
const $9a194f74559621d2$export$3ba22bf10deb1448 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendSubAccountsToEmpty");
const $9a194f74559621d2$export$33f73085e1b7871b = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecommendUndelegation");
const $9a194f74559621d2$export$cd4d967a66d81060 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TimeoutTagged");
const $9a194f74559621d2$export$9375635756d6156e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnexpectedBootloader");
const $9a194f74559621d2$export$90478a5d08d6c2d7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("MCUNotGenuineToDashboard");
const $9a194f74559621d2$export$132f0197eaa65535 = (0, $50105411ce29e10f$export$94baff7bf5134824)("RecipientRequired");
const $9a194f74559621d2$export$7aee729193ab77ba = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountReceive");
const $9a194f74559621d2$export$4ec11dc947a3c9d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UnavailableTezosOriginatedAccountSend");
const $9a194f74559621d2$export$5e3ed85b946872a1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateFetchFileFail");
const $9a194f74559621d2$export$5db6383ad081f01e = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectHash");
const $9a194f74559621d2$export$92c199eb837d8df8 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateIncorrectSig");
const $9a194f74559621d2$export$85e0c017833c894c = (0, $50105411ce29e10f$export$94baff7bf5134824)("UpdateYourApp");
const $9a194f74559621d2$export$84115f1b54c874b3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedDeviceNameChange");
const $9a194f74559621d2$export$3f4864efb1638333 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAddress");
const $9a194f74559621d2$export$d777e0ef77faca34 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedFirmwareUpdate");
const $9a194f74559621d2$export$3d8a4f08cd3eb133 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedAllowManager");
const $9a194f74559621d2$export$db9b724c3524b5d6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("UserRefusedOnDevice"); // TODO rename because it's just for transaction refusal
const $9a194f74559621d2$export$220d77a66e32ad23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("PinNotSet");
const $9a194f74559621d2$export$65df6bdf4eb29653 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ExpertModeRequired");
const $9a194f74559621d2$export$9642f061c2494239 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportOpenUserCancelled");
const $9a194f74559621d2$export$fd71e3a51c4bf0ae = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportInterfaceNotAvailable");
const $9a194f74559621d2$export$d6cb63cda2c2b2a4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportRaceCondition");
const $9a194f74559621d2$export$c0ffbdd94649bd06 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportWebUSBGestureRequired");
const $9a194f74559621d2$export$28149f687a2e30c9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransactionHasBeenValidatedError");
const $9a194f74559621d2$export$448663d307bde953 = (0, $50105411ce29e10f$export$94baff7bf5134824)("TransportExchangeTimeoutError");
const $9a194f74559621d2$export$4800af3cc6204928 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DeviceShouldStayInApp");
const $9a194f74559621d2$export$101490ec073327e1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionError");
const $9a194f74559621d2$export$219228963d86b069 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WebsocketConnectionFailed");
const $9a194f74559621d2$export$25b49ca0efdfe5d1 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccount");
const $9a194f74559621d2$export$4de3709f8e2844ca = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountPayout");
const $9a194f74559621d2$export$b7651c38a977157 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongDeviceForAccountRefund");
const $9a194f74559621d2$export$63498b46122d8a23 = (0, $50105411ce29e10f$export$94baff7bf5134824)("WrongAppForCurrency");
const $9a194f74559621d2$export$707f317a4761c46d = (0, $50105411ce29e10f$export$94baff7bf5134824)("ETHAddressNonEIP");
const $9a194f74559621d2$export$a5d8da2f27618c16 = (0, $50105411ce29e10f$export$94baff7bf5134824)("CantScanQRCode");
const $9a194f74559621d2$export$3f2d8a7775aab6cc = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoaded");
const $9a194f74559621d2$export$3ae46f8c8f45dbe7 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeNotLoadedSwap");
const $9a194f74559621d2$export$ffbf6641e9ab88d3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeRequired");
const $9a194f74559621d2$export$53e797c2fa09aff3 = (0, $50105411ce29e10f$export$94baff7bf5134824)("FeeTooHigh");
const $9a194f74559621d2$export$cb0b645e3d7170ab = (0, $50105411ce29e10f$export$94baff7bf5134824)("PendingOperation");
const $9a194f74559621d2$export$2aca4567d80fd933 = (0, $50105411ce29e10f$export$94baff7bf5134824)("SyncError");
const $9a194f74559621d2$export$a2d6658d365c43df = (0, $50105411ce29e10f$export$94baff7bf5134824)("PairingFailed");
const $9a194f74559621d2$export$4400fa093e7d20ad = (0, $50105411ce29e10f$export$94baff7bf5134824)("PeerRemovedPairing");
const $9a194f74559621d2$export$3f7ba18f3c84cced = (0, $50105411ce29e10f$export$94baff7bf5134824)("GenuineCheckFailed");
const $9a194f74559621d2$export$437e6aac14cab3d9 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI4xx");
const $9a194f74559621d2$export$309835543e52bf92 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LedgerAPI5xx");
const $9a194f74559621d2$export$c282cdb2f7fdc27a = (0, $50105411ce29e10f$export$94baff7bf5134824)("FirmwareOrAppUpdateRequired");
const $9a194f74559621d2$export$aba9024c0d586a15 = (0, $50105411ce29e10f$export$94baff7bf5134824)("ReplacementTransactionUnderpriced");
const $9a194f74559621d2$export$51a1e1b4f21df9f4 = (0, $50105411ce29e10f$export$94baff7bf5134824)("OpReturnSizeLimit");
const $9a194f74559621d2$export$1d49177380419e3d = (0, $50105411ce29e10f$export$94baff7bf5134824)("DustLimit");
const $9a194f74559621d2$export$28f62a162580c9c2 = (0, $50105411ce29e10f$export$94baff7bf5134824)("LanguageNotFound");
const $9a194f74559621d2$export$d3cadb9f4e1fa40d = (0, $50105411ce29e10f$export$94baff7bf5134824)("NoDBPathGiven");
const $9a194f74559621d2$export$de46c919e379f03f = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBWrongPassword");
const $9a194f74559621d2$export$e1c94c135b0a553e = (0, $50105411ce29e10f$export$94baff7bf5134824)("DBNotReset");
const $9a194f74559621d2$export$35de8a1f557fb8bb = (0, $50105411ce29e10f$export$94baff7bf5134824)("SequenceNumberError");
const $9a194f74559621d2$export$df2168717eaf23c6 = (0, $50105411ce29e10f$export$94baff7bf5134824)("DisabledTransactionBroadcastError");
var $9a194f74559621d2$export$62e86095f76df800;
(function(HwTransportErrorType) {
    HwTransportErrorType["Unknown"] = "Unknown";
    HwTransportErrorType["LocationServicesDisabled"] = "LocationServicesDisabled";
    HwTransportErrorType["LocationServicesUnauthorized"] = "LocationServicesUnauthorized";
    HwTransportErrorType["BluetoothScanStartFailed"] = "BluetoothScanStartFailed";
})($9a194f74559621d2$export$62e86095f76df800 || ($9a194f74559621d2$export$62e86095f76df800 = {}));
class $9a194f74559621d2$export$ef5ffbe444ecd147 extends Error {
    constructor(type, message){
        super(message);
        this.name = "HwTransportError";
        this.type = type;
        // Needed as long as we target < ES6
        Object.setPrototypeOf(this, $9a194f74559621d2$export$ef5ffbe444ecd147.prototype);
    }
}
class $9a194f74559621d2$export$8e68de6fb26f2236 extends Error {
    constructor(message, id){
        const name = "TransportError";
        super(message || name);
        this.name = name;
        this.message = message;
        this.stack = new Error(message).stack;
        this.id = id;
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportError", (e)=>new $9a194f74559621d2$export$8e68de6fb26f2236(e.message, e.id));
const $9a194f74559621d2$export$efd5569f873811b1 = {
    ACCESS_CONDITION_NOT_FULFILLED: 0x9804,
    ALGORITHM_NOT_SUPPORTED: 0x9484,
    CLA_NOT_SUPPORTED: 0x6e00,
    CODE_BLOCKED: 0x9840,
    CODE_NOT_INITIALIZED: 0x9802,
    COMMAND_INCOMPATIBLE_FILE_STRUCTURE: 0x6981,
    CONDITIONS_OF_USE_NOT_SATISFIED: 0x6985,
    CONTRADICTION_INVALIDATION: 0x9810,
    CONTRADICTION_SECRET_CODE_STATUS: 0x9808,
    DEVICE_IN_RECOVERY_MODE: 0x662f,
    CUSTOM_IMAGE_EMPTY: 0x662e,
    FILE_ALREADY_EXISTS: 0x6a89,
    FILE_NOT_FOUND: 0x9404,
    GP_AUTH_FAILED: 0x6300,
    HALTED: 0x6faa,
    INCONSISTENT_FILE: 0x9408,
    INCORRECT_DATA: 0x6a80,
    INCORRECT_LENGTH: 0x6700,
    INCORRECT_P1_P2: 0x6b00,
    INS_NOT_SUPPORTED: 0x6d00,
    DEVICE_NOT_ONBOARDED: 0x6d07,
    DEVICE_NOT_ONBOARDED_2: 0x6611,
    INVALID_KCV: 0x9485,
    INVALID_OFFSET: 0x9402,
    LICENSING: 0x6f42,
    LOCKED_DEVICE: 0x5515,
    MAX_VALUE_REACHED: 0x9850,
    MEMORY_PROBLEM: 0x9240,
    MISSING_CRITICAL_PARAMETER: 0x6800,
    NO_EF_SELECTED: 0x9400,
    NOT_ENOUGH_MEMORY_SPACE: 0x6a84,
    OK: 0x9000,
    PIN_REMAINING_ATTEMPTS: 0x63c0,
    REFERENCED_DATA_NOT_FOUND: 0x6a88,
    SECURITY_STATUS_NOT_SATISFIED: 0x6982,
    TECHNICAL_PROBLEM: 0x6f00,
    UNKNOWN_APDU: 0x6d02,
    USER_REFUSED_ON_DEVICE: 0x5501,
    NOT_ENOUGH_SPACE: 0x5102,
    APP_NOT_FOUND_OR_INVALID_CONTEXT: 0x5123,
    INVALID_APP_NAME_LENGTH: 0x670a,
    GEN_AES_KEY_FAILED: 0x5419,
    INTERNAL_CRYPTO_OPERATION_FAILED: 0x541a,
    INTERNAL_COMPUTE_AES_CMAC_FAILED: 0x541b,
    ENCRYPT_APP_STORAGE_FAILED: 0x541c,
    INVALID_BACKUP_STATE: 0x6642,
    PIN_NOT_SET: 0x5502,
    INVALID_BACKUP_LENGTH: 0x6733,
    INVALID_RESTORE_STATE: 0x6643,
    INVALID_CHUNK_LENGTH: 0x6734,
    INVALID_BACKUP_HEADER: 0x684a,
    // Not documented:
    TRUSTCHAIN_WRONG_SEED: 0xb007
};
function $9a194f74559621d2$export$799566c03457ebd5(code) {
    switch(code){
        // improve text of most common errors
        case 0x6700:
            return "Incorrect length";
        case 0x6800:
            return "Missing critical parameter";
        case 0x6982:
            return "Security not satisfied (dongle locked or have invalid access rights)";
        case 0x6985:
            return "Condition of use not satisfied (denied by the user?)";
        case 0x6a80:
            return "Invalid data received";
        case 0x6b00:
            return "Invalid parameter received";
        case 0x5515:
            return "Locked device";
    }
    if (0x6f00 <= code && code <= 0x6fff) return "Internal error, please report";
}
class $9a194f74559621d2$export$78917f4716d96cfe extends Error {
    /**
     * @param statusCode The error status code coming from a Transport implementation
     * @param options containing:
     *  - canBeMappedToChildError: enable the mapping of TransportStatusError to an error extending/inheriting from it
     *  . Ex: LockedDeviceError. Default to true.
     */ constructor(statusCode, { canBeMappedToChildError: canBeMappedToChildError = true } = {}){
        const statusText = Object.keys($9a194f74559621d2$export$efd5569f873811b1).find((k)=>$9a194f74559621d2$export$efd5569f873811b1[k] === statusCode) || "UNKNOWN_ERROR";
        const smsg = $9a194f74559621d2$export$799566c03457ebd5(statusCode) || statusText;
        const statusCodeStr = statusCode.toString(16);
        const message = `Ledger device: ${smsg} (0x${statusCodeStr})`;
        super(message);
        this.name = "TransportStatusError";
        this.statusCode = statusCode;
        this.statusText = statusText;
        Object.setPrototypeOf(this, $9a194f74559621d2$export$78917f4716d96cfe.prototype);
        // Maps to a LockedDeviceError
        if (canBeMappedToChildError && statusCode === $9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE) return new $9a194f74559621d2$export$1fb6667702a70644(message);
    }
}
class $9a194f74559621d2$export$1fb6667702a70644 extends $9a194f74559621d2$export$78917f4716d96cfe {
    constructor(message){
        super($9a194f74559621d2$export$efd5569f873811b1.LOCKED_DEVICE, {
            canBeMappedToChildError: false
        });
        if (message) this.message = message;
        this.name = "LockedDeviceError";
        Object.setPrototypeOf(this, $9a194f74559621d2$export$1fb6667702a70644.prototype);
    }
}
(0, $50105411ce29e10f$export$ff6248acd0c27a3f)("TransportStatusError", (e)=>new $9a194f74559621d2$export$78917f4716d96cfe(e.statusCode));


let $fdd451dd43e0ce6f$var$id = 0;
const $fdd451dd43e0ce6f$var$subscribers = [];
const $fdd451dd43e0ce6f$export$bef1f36f5486a6a3 = (type, message, data)=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
const $fdd451dd43e0ce6f$export$357889f174732d38 = ({ type: type, message: message, data: data, context: context })=>{
    const obj = {
        type: type,
        id: String(++$fdd451dd43e0ce6f$var$id),
        date: new Date()
    };
    if (message) obj.message = message;
    if (data) obj.data = data;
    if (context) obj.context = context;
    $fdd451dd43e0ce6f$var$dispatch(obj);
};
class $fdd451dd43e0ce6f$export$c9a255a7b61db733 {
    constructor(type, context){
        this.type = type;
        this.context = context;
    }
    trace(message, data) {
        $fdd451dd43e0ce6f$export$357889f174732d38({
            type: this.type,
            message: message,
            data: data,
            context: this.context
        });
    }
    getContext() {
        return this.context;
    }
    setContext(context) {
        this.context = context;
    }
    updateContext(contextToAdd) {
        this.context = Object.assign(Object.assign({}, this.context), contextToAdd);
    }
    getType() {
        return this.type;
    }
    setType(type) {
        this.type = type;
    }
    /**
     * Create a new instance of the LocalTracer with an updated `type`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withType(type) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(type, this.context);
    }
    /**
     * Create a new instance of the LocalTracer with a new `context`
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ withContext(context) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, context);
    }
    /**
     * Create a new instance of the LocalTracer with an updated `context`,
     * on which an additional context is merged with the existing one.
     *
     * It does not mutate the calling instance, but returns a new LocalTracer,
     * following a simple builder pattern.
     */ withUpdatedContext(contextToAdd) {
        return new $fdd451dd43e0ce6f$export$c9a255a7b61db733(this.type, Object.assign(Object.assign({}, this.context), contextToAdd));
    }
}
const $fdd451dd43e0ce6f$export$63174c828edd6ff8 = (cb)=>{
    $fdd451dd43e0ce6f$var$subscribers.push(cb);
    return ()=>{
        const i = $fdd451dd43e0ce6f$var$subscribers.indexOf(cb);
        if (i !== -1) {
            // equivalent of subscribers.splice(i, 1) // https://twitter.com/Rich_Harris/status/1125850391155965952
            $fdd451dd43e0ce6f$var$subscribers[i] = $fdd451dd43e0ce6f$var$subscribers[$fdd451dd43e0ce6f$var$subscribers.length - 1];
            $fdd451dd43e0ce6f$var$subscribers.pop();
        }
    };
};
function $fdd451dd43e0ce6f$var$dispatch(log) {
    for(let i = 0; i < $fdd451dd43e0ce6f$var$subscribers.length; i++)try {
        $fdd451dd43e0ce6f$var$subscribers[i](log);
    } catch (e) {
        console.error(e);
    }
}
if (typeof window !== "undefined") window.__ledgerLogsListen = $fdd451dd43e0ce6f$export$63174c828edd6ff8;



var $6ZWSX = parcelRequire("6ZWSX");
var $375818ecee1623c3$require$Buffer = $6ZWSX.Buffer;
var $375818ecee1623c3$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $375818ecee1623c3$var$DEFAULT_LOG_TYPE = "transport";
/**
 * The Transport class defines a generic interface for communicating with a Ledger hardware wallet.
 * There are different kind of transports based on the technology (channels like U2F, HID, Bluetooth, Webusb) and environment (Node, Web,...).
 * It is an abstract class that needs to be implemented.
 */ class $375818ecee1623c3$var$Transport {
    constructor({ context: context, logType: logType } = {}){
        this.exchangeTimeout = 30000;
        this.unresponsiveTimeout = 15000;
        this.deviceModel = null;
        this._events = new (0, (/*@__PURE__*/$parcel$interopDefault($7etJZ)))();
        /**
         * Send data to the device using the higher level API.
         *
         * @param {number} cla - The instruction class for the command.
         * @param {number} ins - The instruction code for the command.
         * @param {number} p1 - The first parameter for the instruction.
         * @param {number} p2 - The second parameter for the instruction.
         * @param {Buffer} data - The data to be sent. Defaults to an empty buffer.
         * @param {Array<number>} statusList - A list of acceptable status codes for the response. Defaults to [StatusCodes.OK].
         * @param {Object} options - Contains optional options for the exchange function
         *  - abortTimeoutMs: stop the send after a given timeout. Another timeout exists
         *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
         * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
         */ this.send = (cla_1, ins_1, p1_1, p2_1, ...args_1)=>$375818ecee1623c3$var$__awaiter(this, [
                cla_1,
                ins_1,
                p1_1,
                p2_1,
                ...args_1
            ], void 0, function*(cla, ins, p1, p2, data = $375818ecee1623c3$require$Buffer.alloc(0), statusList = [
                (0, $9a194f74559621d2$export$efd5569f873811b1).OK
            ], { abortTimeoutMs: abortTimeoutMs } = {}) {
                const tracer = this.tracer.withUpdatedContext({
                    function: "send"
                });
                if (data.length >= 256) {
                    tracer.trace("data.length exceeded 256 bytes limit", {
                        dataLength: data.length
                    });
                    throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("data.length exceed 256 bytes limit. Got: " + data.length, "DataLengthTooBig");
                }
                tracer.trace("Starting an exchange", {
                    abortTimeoutMs: abortTimeoutMs
                });
                const response = yield this.exchange(// The size of the data is added in 1 byte just before `data`
                $375818ecee1623c3$require$Buffer.concat([
                    $375818ecee1623c3$require$Buffer.from([
                        cla,
                        ins,
                        p1,
                        p2
                    ]),
                    $375818ecee1623c3$require$Buffer.from([
                        data.length
                    ]),
                    data
                ]), {
                    abortTimeoutMs: abortTimeoutMs
                });
                tracer.trace("Received response from exchange");
                const sw = response.readUInt16BE(response.length - 2);
                if (!statusList.some((s)=>s === sw)) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(sw);
                return response;
            });
        this._appAPIlock = null;
        this.tracer = new (0, $fdd451dd43e0ce6f$export$c9a255a7b61db733)(logType !== null && logType !== void 0 ? logType : $375818ecee1623c3$var$DEFAULT_LOG_TYPE, context);
    }
    /**
     * Send data to the device using a low level API.
     * It's recommended to use the "send" method for a higher level API.
     * @param {Buffer} apdu - The data to send.
     * @param {Object} options - Contains optional options for the exchange function
     *  - abortTimeoutMs: stop the exchange after a given timeout. Another timeout exists
     *    to detect unresponsive device (see `unresponsiveTimeout`). This timeout aborts the exchange.
     * @returns {Promise<Buffer>} A promise that resolves with the response data from the device.
     */ exchange(_apdu, { abortTimeoutMs: _abortTimeoutMs } = {}) {
        throw new Error("exchange not implemented");
    }
    /**
     * Send apdus in batch to the device using a low level API.
     * The default implementation is to call exchange for each apdu.
     * @param {Array<Buffer>} apdus - array of apdus to send.
     * @param {Observer<Buffer>} observer - an observer that will receive the response of each apdu.
     * @returns {Subscription} A Subscription object on which you can call ".unsubscribe()" to stop sending apdus.
     */ exchangeBulk(apdus, observer) {
        let unsubscribed = false;
        const unsubscribe = ()=>{
            unsubscribed = true;
        };
        const main = ()=>$375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
                if (unsubscribed) return;
                for (const apdu of apdus){
                    const r = yield this.exchange(apdu);
                    if (unsubscribed) return;
                    const status = r.readUInt16BE(r.length - 2);
                    if (status !== (0, $9a194f74559621d2$export$efd5569f873811b1).OK) throw new (0, $9a194f74559621d2$export$78917f4716d96cfe)(status);
                    observer.next(r);
                }
            });
        main().then(()=>!unsubscribed && observer.complete(), (e)=>!unsubscribed && observer.error(e));
        return {
            unsubscribe: unsubscribe
        };
    }
    /**
     * Set the "scramble key" for the next data exchanges with the device.
     * Each app can have a different scramble key and it is set internally during instantiation.
     * @param {string} key - The scramble key to set.
     * deprecated This method is no longer needed for modern transports and should be migrated away from.
     * no @ before deprecated as it breaks documentationjs on version 14.0.2
     * https://github.com/documentationjs/documentation/issues/1596
     */ setScrambleKey(_key) {}
    /**
     * Close the connection with the device.
     *
     * Note: for certain transports (hw-transport-node-hid-singleton for ex), once the promise resolved,
     * the transport instance is actually still cached, and the device is disconnected only after a defined timeout.
     * But for the consumer of the Transport, this does not matter and it can consider the transport to be closed.
     *
     * @returns {Promise<void>} A promise that resolves when the transport is closed.
     */ close() {
        return Promise.resolve();
    }
    /**
     * Listen for an event on the transport instance.
     * Transport implementations may have specific events. Common events include:
     * "disconnect" : triggered when the transport is disconnected.
     * @param {string} eventName - The name of the event to listen for.
     * @param {(...args: Array<any>) => any} cb - The callback function to be invoked when the event occurs.
     */ on(eventName, cb) {
        this._events.on(eventName, cb);
    }
    /**
     * Stop listening to an event on an instance of transport.
     */ off(eventName, cb) {
        this._events.removeListener(eventName, cb);
    }
    emit(event, ...args) {
        this._events.emit(event, ...args);
    }
    /**
     * Enable or not logs of the binary exchange
     */ setDebugMode() {
        console.warn("setDebugMode is deprecated. use @ledgerhq/logs instead. No logs are emitted in this anymore.");
    }
    /**
     * Set a timeout (in milliseconds) for the exchange call. Only some transport might implement it. (e.g. U2F)
     */ setExchangeTimeout(exchangeTimeout) {
        this.exchangeTimeout = exchangeTimeout;
    }
    /**
     * Define the delay before emitting "unresponsive" on an exchange that does not respond
     */ setExchangeUnresponsiveTimeout(unresponsiveTimeout) {
        this.unresponsiveTimeout = unresponsiveTimeout;
    }
    /**
     * create() allows to open the first descriptor available or
     * throw if there is none or if timeout is reached.
     * This is a light helper, alternative to using listen() and open() (that you may need for any more advanced usecase)
     * @example
    TransportFoo.create().then(transport => ...)
     */ static create(openTimeout = 3000, listenTimeout) {
        return new Promise((resolve, reject)=>{
            let found = false;
            const sub = this.listen({
                next: (e)=>{
                    found = true;
                    if (sub) sub.unsubscribe();
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    this.open(e.descriptor, openTimeout).then(resolve, reject);
                },
                error: (e)=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    reject(e);
                },
                complete: ()=>{
                    if (listenTimeoutId) clearTimeout(listenTimeoutId);
                    if (!found) reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_NoDeviceFound, "NoDeviceFound"));
                }
            });
            const listenTimeoutId = listenTimeout ? setTimeout(()=>{
                sub.unsubscribe();
                reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(this.ErrorMessage_ListenTimeout, "ListenTimeout"));
            }, listenTimeout) : null;
        });
    }
    /**
     * Wrapper to make an exchange "atomic" (blocking any other exchange)
     *
     * It also handles "unresponsiveness" by emitting "unresponsive" and "responsive" events.
     *
     * @param f The exchange job, using the transport to run
     * @returns a Promise resolving with the output of the given job
     */ exchangeAtomicImpl(f) {
        return $375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
            const tracer = this.tracer.withUpdatedContext({
                function: "exchangeAtomicImpl",
                unresponsiveTimeout: this.unresponsiveTimeout
            });
            if (this.exchangeBusyPromise) {
                tracer.trace("Atomic exchange is already busy");
                throw new (0, $9a194f74559621d2$export$d6cb63cda2c2b2a4)("An action was already pending on the Ledger device. Please deny or reconnect.");
            }
            // Sets the atomic guard
            let resolveBusy;
            const busyPromise = new Promise((r)=>{
                resolveBusy = r;
            });
            this.exchangeBusyPromise = busyPromise;
            // The device unresponsiveness handler
            let unresponsiveReached = false;
            const timeout = setTimeout(()=>{
                tracer.trace(`Timeout reached, emitting Transport event "unresponsive"`, {
                    unresponsiveTimeout: this.unresponsiveTimeout
                });
                unresponsiveReached = true;
                this.emit("unresponsive");
            }, this.unresponsiveTimeout);
            try {
                const res = yield f();
                if (unresponsiveReached) {
                    tracer.trace("Device was unresponsive, emitting responsive");
                    this.emit("responsive");
                }
                return res;
            } finally{
                tracer.trace("Finalize, clearing busy guard");
                clearTimeout(timeout);
                if (resolveBusy) resolveBusy();
                this.exchangeBusyPromise = null;
            }
        });
    }
    decorateAppAPIMethods(self, methods, scrambleKey) {
        for (const methodName of methods)self[methodName] = this.decorateAppAPIMethod(methodName, self[methodName], self, scrambleKey);
    }
    decorateAppAPIMethod(methodName, f, ctx, scrambleKey) {
        return (...args)=>$375818ecee1623c3$var$__awaiter(this, void 0, void 0, function*() {
                const { _appAPIlock: _appAPIlock } = this;
                if (_appAPIlock) return Promise.reject(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Ledger Device is busy (lock " + _appAPIlock + ")", "TransportLocked"));
                try {
                    this._appAPIlock = methodName;
                    this.setScrambleKey(scrambleKey);
                    return yield f.apply(ctx, args);
                } finally{
                    this._appAPIlock = null;
                }
            });
    }
    /**
     * Sets the context used by the logging/tracing mechanism
     *
     * Useful when re-using (cached) the same Transport instance,
     * but with a new tracing context.
     *
     * @param context A TraceContext, that can undefined to reset the context
     */ setTraceContext(context) {
        this.tracer = this.tracer.withContext(context);
    }
    /**
     * Updates the context used by the logging/tracing mechanism
     *
     * The update only overrides the key-value that are already defined in the current context.
     *
     * @param contextToAdd A TraceContext that will be added to the current context
     */ updateTraceContext(contextToAdd) {
        this.tracer.updateContext(contextToAdd);
    }
    /**
     * Gets the tracing context of the transport instance
     */ getTraceContext() {
        return this.tracer.getContext();
    }
}
$375818ecee1623c3$var$Transport.ErrorMessage_ListenTimeout = "No Ledger device found (timeout)";
$375818ecee1623c3$var$Transport.ErrorMessage_NoDeviceFound = "No Ledger device found";
var $375818ecee1623c3$export$2e2bcd8739ae039 = $375818ecee1623c3$var$Transport;




var $6ZWSX = parcelRequire("6ZWSX");
var $f6e657627868bf3a$require$Buffer = $6ZWSX.Buffer;
const $f6e657627868bf3a$var$Tag = 0x05;
function $f6e657627868bf3a$var$asUInt16BE(value) {
    const b = $f6e657627868bf3a$require$Buffer.alloc(2);
    b.writeUInt16BE(value, 0);
    return b;
}
const $f6e657627868bf3a$var$initialAcc = {
    data: $f6e657627868bf3a$require$Buffer.alloc(0),
    dataLength: 0,
    sequence: 0
};
/**
 * Object to handle HID frames (encoding and decoding)
 *
 * @param channel
 * @param packetSize The HID protocol packet size in bytes (usually 64)
 */ const $f6e657627868bf3a$var$createHIDframing = (channel, packetSize)=>{
    return {
        /**
         * Frames/encodes an APDU message into HID USB packets/frames
         *
         * @param apdu The APDU message to send, in a Buffer containing [cla, ins, p1, p2, data length, data(if not empty)]
         * @returns an array of HID USB frames ready to be sent
         */ makeBlocks (apdu) {
            // Encodes the APDU length in 2 bytes before the APDU itself.
            // The length is measured as the number of bytes.
            // As the size of the APDU `data` should have been added in 1 byte just before `data`,
            // the minimum size of an APDU is 5 bytes.
            let data = $f6e657627868bf3a$require$Buffer.concat([
                $f6e657627868bf3a$var$asUInt16BE(apdu.length),
                apdu
            ]);
            const blockSize = packetSize - 5;
            const nbBlocks = Math.ceil(data.length / blockSize);
            // Fills data with 0-padding
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                $f6e657627868bf3a$require$Buffer.alloc(nbBlocks * blockSize - data.length + 1).fill(0)
            ]);
            const blocks = [];
            for(let i = 0; i < nbBlocks; i++){
                const head = $f6e657627868bf3a$require$Buffer.alloc(5);
                head.writeUInt16BE(channel, 0);
                head.writeUInt8($f6e657627868bf3a$var$Tag, 2);
                head.writeUInt16BE(i, 3);
                // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array
                const chunk = data.slice(i * blockSize, (i + 1) * blockSize);
                blocks.push($f6e657627868bf3a$require$Buffer.concat([
                    head,
                    chunk
                ]));
            }
            return blocks;
        },
        /**
         * Reduces HID USB packets/frames to one response.
         *
         * @param acc The value resulting from (accumulating) the previous call of reduceResponse.
         *   On first call initialized to `initialAcc`. The accumulator enables handling multi-frames messages.
         * @param chunk Current chunk to reduce into accumulator
         * @returns An accumulator value updated with the current chunk
         */ reduceResponse (acc, chunk) {
            let { data: data, dataLength: dataLength, sequence: sequence } = acc || $f6e657627868bf3a$var$initialAcc;
            if (chunk.readUInt16BE(0) !== channel) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid channel", "InvalidChannel");
            if (chunk.readUInt8(2) !== $f6e657627868bf3a$var$Tag) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid tag", "InvalidTag");
            if (chunk.readUInt16BE(3) !== sequence) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid sequence", "InvalidSequence");
            // Gets the total length of the response from the 1st frame
            if (!acc) dataLength = chunk.readUInt16BE(5);
            sequence++;
            // The total length on the 1st frame takes 2 more bytes
            const chunkData = chunk.slice(acc ? 5 : 7);
            data = $f6e657627868bf3a$require$Buffer.concat([
                data,
                chunkData
            ]);
            // Removes any 0 padding
            if (data.length > dataLength) data = data.slice(0, dataLength);
            return {
                data: data,
                dataLength: dataLength,
                sequence: sequence
            };
        },
        /**
         * Returns the response message that has been reduced from the HID USB frames
         *
         * @param acc The accumulator
         * @returns A Buffer containing the cleaned response message, or null if no response message, or undefined if the
         *   accumulator is incorrect (message length is not valid)
         */ getReducedResult (acc) {
            if (acc && acc.dataLength === acc.data.length) return acc.data;
        }
    };
};
var $f6e657627868bf3a$export$2e2bcd8739ae039 = $f6e657627868bf3a$var$createHIDframing;


var $dbb9fc904636819d$exports = {};
// just pre-load all the stuff that index.js lazily exports

var $kGRcS = parcelRequire("kGRcS");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$exports = {};

var $i9RZm = parcelRequire("i9RZm");

var $fJ45P = parcelRequire("fJ45P");
var $df90e8d1cf1cf055$require$MAX_LENGTH = $fJ45P.MAX_LENGTH;
var $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER = $fJ45P.MAX_SAFE_INTEGER;

var $kGRcS = parcelRequire("kGRcS");
var $df90e8d1cf1cf055$require$re = $kGRcS.safeRe;
var $df90e8d1cf1cf055$require$t = $kGRcS.t;
var $100fa442ed30ac34$exports = {};
// parse out just the options we care about
const $100fa442ed30ac34$var$looseOption = Object.freeze({
    loose: true
});
const $100fa442ed30ac34$var$emptyOpts = Object.freeze({});
const $100fa442ed30ac34$var$parseOptions = (options)=>{
    if (!options) return $100fa442ed30ac34$var$emptyOpts;
    if (typeof options !== "object") return $100fa442ed30ac34$var$looseOption;
    return options;
};
$100fa442ed30ac34$exports = $100fa442ed30ac34$var$parseOptions;


var $ed5e7d6476f836e9$exports = {};
const $ed5e7d6476f836e9$var$numeric = /^[0-9]+$/;
const $ed5e7d6476f836e9$var$compareIdentifiers = (a, b)=>{
    const anum = $ed5e7d6476f836e9$var$numeric.test(a);
    const bnum = $ed5e7d6476f836e9$var$numeric.test(b);
    if (anum && bnum) {
        a = +a;
        b = +b;
    }
    return a === b ? 0 : anum && !bnum ? -1 : bnum && !anum ? 1 : a < b ? -1 : 1;
};
const $ed5e7d6476f836e9$var$rcompareIdentifiers = (a, b)=>$ed5e7d6476f836e9$var$compareIdentifiers(b, a);
$ed5e7d6476f836e9$exports = {
    compareIdentifiers: $ed5e7d6476f836e9$var$compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$var$rcompareIdentifiers
};


var $df90e8d1cf1cf055$require$compareIdentifiers = $ed5e7d6476f836e9$exports.compareIdentifiers;
class $df90e8d1cf1cf055$var$SemVer {
    constructor(version, options){
        options = $100fa442ed30ac34$exports(options);
        if (version instanceof $df90e8d1cf1cf055$var$SemVer) {
            if (version.loose === !!options.loose && version.includePrerelease === !!options.includePrerelease) return version;
            else version = version.version;
        } else if (typeof version !== "string") throw new TypeError(`Invalid version. Must be a string. Got type "${typeof version}".`);
        if (version.length > $df90e8d1cf1cf055$require$MAX_LENGTH) throw new TypeError(`version is longer than ${$df90e8d1cf1cf055$require$MAX_LENGTH} characters`);
        $i9RZm("SemVer", version, options);
        this.options = options;
        this.loose = !!options.loose;
        // this isn't actually relevant for versions, but keep it so that we
        // don't run into trouble passing this.options around.
        this.includePrerelease = !!options.includePrerelease;
        const m = version.trim().match(options.loose ? $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.LOOSE] : $df90e8d1cf1cf055$require$re[$df90e8d1cf1cf055$require$t.FULL]);
        if (!m) throw new TypeError(`Invalid Version: ${version}`);
        this.raw = version;
        // these are actually numbers
        this.major = +m[1];
        this.minor = +m[2];
        this.patch = +m[3];
        if (this.major > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.major < 0) throw new TypeError("Invalid major version");
        if (this.minor > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.minor < 0) throw new TypeError("Invalid minor version");
        if (this.patch > $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER || this.patch < 0) throw new TypeError("Invalid patch version");
        // numberify any prerelease numeric ids
        if (!m[4]) this.prerelease = [];
        else this.prerelease = m[4].split(".").map((id)=>{
            if (/^[0-9]+$/.test(id)) {
                const num = +id;
                if (num >= 0 && num < $df90e8d1cf1cf055$require$MAX_SAFE_INTEGER) return num;
            }
            return id;
        });
        this.build = m[5] ? m[5].split(".") : [];
        this.format();
    }
    format() {
        this.version = `${this.major}.${this.minor}.${this.patch}`;
        if (this.prerelease.length) this.version += `-${this.prerelease.join(".")}`;
        return this.version;
    }
    toString() {
        return this.version;
    }
    compare(other) {
        $i9RZm("SemVer.compare", this.version, this.options, other);
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) {
            if (typeof other === "string" && other === this.version) return 0;
            other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        }
        if (other.version === this.version) return 0;
        return this.compareMain(other) || this.comparePre(other);
    }
    compareMain(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        return $df90e8d1cf1cf055$require$compareIdentifiers(this.major, other.major) || $df90e8d1cf1cf055$require$compareIdentifiers(this.minor, other.minor) || $df90e8d1cf1cf055$require$compareIdentifiers(this.patch, other.patch);
    }
    comparePre(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        // NOT having a prerelease is > having one
        if (this.prerelease.length && !other.prerelease.length) return -1;
        else if (!this.prerelease.length && other.prerelease.length) return 1;
        else if (!this.prerelease.length && !other.prerelease.length) return 0;
        let i = 0;
        do {
            const a = this.prerelease[i];
            const b = other.prerelease[i];
            $i9RZm("prerelease compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    compareBuild(other) {
        if (!(other instanceof $df90e8d1cf1cf055$var$SemVer)) other = new $df90e8d1cf1cf055$var$SemVer(other, this.options);
        let i = 0;
        do {
            const a = this.build[i];
            const b = other.build[i];
            $i9RZm("build compare", i, a, b);
            if (a === undefined && b === undefined) return 0;
            else if (b === undefined) return 1;
            else if (a === undefined) return -1;
            else if (a === b) continue;
            else return $df90e8d1cf1cf055$require$compareIdentifiers(a, b);
        }while (++i);
    }
    // preminor will bump the version up to the next minor release, and immediately
    // down to pre-release. premajor and prepatch work the same way.
    inc(release, identifier, identifierBase) {
        switch(release){
            case "premajor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor = 0;
                this.major++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "preminor":
                this.prerelease.length = 0;
                this.patch = 0;
                this.minor++;
                this.inc("pre", identifier, identifierBase);
                break;
            case "prepatch":
                // If this is already a prerelease, it will bump to the next version
                // drop any prereleases that might already exist, since they are not
                // relevant at this point.
                this.prerelease.length = 0;
                this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            // If the input is a non-prerelease version, this acts the same as
            // prepatch.
            case "prerelease":
                if (this.prerelease.length === 0) this.inc("patch", identifier, identifierBase);
                this.inc("pre", identifier, identifierBase);
                break;
            case "major":
                // If this is a pre-major version, bump up to the same major version.
                // Otherwise increment major.
                // 1.0.0-5 bumps to 1.0.0
                // 1.1.0 bumps to 2.0.0
                if (this.minor !== 0 || this.patch !== 0 || this.prerelease.length === 0) this.major++;
                this.minor = 0;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "minor":
                // If this is a pre-minor version, bump up to the same minor version.
                // Otherwise increment minor.
                // 1.2.0-5 bumps to 1.2.0
                // 1.2.1 bumps to 1.3.0
                if (this.patch !== 0 || this.prerelease.length === 0) this.minor++;
                this.patch = 0;
                this.prerelease = [];
                break;
            case "patch":
                // If this is not a pre-release version, it will increment the patch.
                // If it is a pre-release it will bump up to the same patch version.
                // 1.2.0-5 patches to 1.2.0
                // 1.2.0 patches to 1.2.1
                if (this.prerelease.length === 0) this.patch++;
                this.prerelease = [];
                break;
            // This probably shouldn't be used publicly.
            // 1.0.0 'pre' would become 1.0.0-0 which is the wrong direction.
            case "pre":
                {
                    const base = Number(identifierBase) ? 1 : 0;
                    if (!identifier && identifierBase === false) throw new Error("invalid increment argument: identifier is empty");
                    if (this.prerelease.length === 0) this.prerelease = [
                        base
                    ];
                    else {
                        let i = this.prerelease.length;
                        while(--i >= 0)if (typeof this.prerelease[i] === "number") {
                            this.prerelease[i]++;
                            i = -2;
                        }
                        if (i === -1) {
                            // didn't increment anything
                            if (identifier === this.prerelease.join(".") && identifierBase === false) throw new Error("invalid increment argument: identifier already exists");
                            this.prerelease.push(base);
                        }
                    }
                    if (identifier) {
                        // 1.2.0-beta.1 bumps to 1.2.0-beta.2,
                        // 1.2.0-beta.fooblz or 1.2.0-beta bumps to 1.2.0-beta.0
                        let prerelease = [
                            identifier,
                            base
                        ];
                        if (identifierBase === false) prerelease = [
                            identifier
                        ];
                        if ($df90e8d1cf1cf055$require$compareIdentifiers(this.prerelease[0], identifier) === 0) {
                            if (isNaN(this.prerelease[1])) this.prerelease = prerelease;
                        } else this.prerelease = prerelease;
                    }
                    break;
                }
            default:
                throw new Error(`invalid increment argument: ${release}`);
        }
        this.raw = this.format();
        if (this.build.length) this.raw += `+${this.build.join(".")}`;
        return this;
    }
}
$df90e8d1cf1cf055$exports = $df90e8d1cf1cf055$var$SemVer;



var $518bb137cbdf72c3$exports = {};

const $518bb137cbdf72c3$var$parse = (version, options, throwErrors = false)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    try {
        return new $df90e8d1cf1cf055$exports(version, options);
    } catch (er) {
        if (!throwErrors) return null;
        throw er;
    }
};
$518bb137cbdf72c3$exports = $518bb137cbdf72c3$var$parse;


var $c618592c32f826bd$exports = {};

const $c618592c32f826bd$var$valid = (version, options)=>{
    const v = $518bb137cbdf72c3$exports(version, options);
    return v ? v.version : null;
};
$c618592c32f826bd$exports = $c618592c32f826bd$var$valid;


var $889491f0ea5a6118$exports = {};

const $889491f0ea5a6118$var$clean = (version, options)=>{
    const s = $518bb137cbdf72c3$exports(version.trim().replace(/^[=v]+/, ""), options);
    return s ? s.version : null;
};
$889491f0ea5a6118$exports = $889491f0ea5a6118$var$clean;


var $d4783bb52460fa90$exports = {};

const $d4783bb52460fa90$var$inc = (version, release, options, identifier, identifierBase)=>{
    if (typeof options === "string") {
        identifierBase = identifier;
        identifier = options;
        options = undefined;
    }
    try {
        return new $df90e8d1cf1cf055$exports(version instanceof $df90e8d1cf1cf055$exports ? version.version : version, options).inc(release, identifier, identifierBase).version;
    } catch (er) {
        return null;
    }
};
$d4783bb52460fa90$exports = $d4783bb52460fa90$var$inc;


var $ab0877022a91d748$exports = {};

const $ab0877022a91d748$var$diff = (version1, version2)=>{
    const v1 = $518bb137cbdf72c3$exports(version1, null, true);
    const v2 = $518bb137cbdf72c3$exports(version2, null, true);
    const comparison = v1.compare(v2);
    if (comparison === 0) return null;
    const v1Higher = comparison > 0;
    const highVersion = v1Higher ? v1 : v2;
    const lowVersion = v1Higher ? v2 : v1;
    const highHasPre = !!highVersion.prerelease.length;
    const lowHasPre = !!lowVersion.prerelease.length;
    if (lowHasPre && !highHasPre) {
        // Going from prerelease -> no prerelease requires some special casing
        // If the low version has only a major, then it will always be a major
        // Some examples:
        // 1.0.0-1 -> 1.0.0
        // 1.0.0-1 -> 1.1.1
        // 1.0.0-1 -> 2.0.0
        if (!lowVersion.patch && !lowVersion.minor) return "major";
        // Otherwise it can be determined by checking the high version
        if (highVersion.patch) // anything higher than a patch bump would result in the wrong version
        return "patch";
        if (highVersion.minor) // anything higher than a minor bump would result in the wrong version
        return "minor";
        // bumping major/minor/patch all have same result
        return "major";
    }
    // add the `pre` prefix if we are going to a prerelease version
    const prefix = highHasPre ? "pre" : "";
    if (v1.major !== v2.major) return prefix + "major";
    if (v1.minor !== v2.minor) return prefix + "minor";
    if (v1.patch !== v2.patch) return prefix + "patch";
    // high and low are preleases
    return "prerelease";
};
$ab0877022a91d748$exports = $ab0877022a91d748$var$diff;


var $3c98d7b64d202a78$exports = {};

const $3c98d7b64d202a78$var$major = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).major;
$3c98d7b64d202a78$exports = $3c98d7b64d202a78$var$major;


var $6e90b5c2fe90feeb$exports = {};

const $6e90b5c2fe90feeb$var$minor = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).minor;
$6e90b5c2fe90feeb$exports = $6e90b5c2fe90feeb$var$minor;


var $4c2948a32081632b$exports = {};

const $4c2948a32081632b$var$patch = (a, loose)=>new $df90e8d1cf1cf055$exports(a, loose).patch;
$4c2948a32081632b$exports = $4c2948a32081632b$var$patch;


var $93a6413aa1f64654$exports = {};

const $93a6413aa1f64654$var$prerelease = (version, options)=>{
    const parsed = $518bb137cbdf72c3$exports(version, options);
    return parsed && parsed.prerelease.length ? parsed.prerelease : null;
};
$93a6413aa1f64654$exports = $93a6413aa1f64654$var$prerelease;


var $81994ac4c012d104$exports = {};

const $81994ac4c012d104$var$compare = (a, b, loose)=>new $df90e8d1cf1cf055$exports(a, loose).compare(new $df90e8d1cf1cf055$exports(b, loose));
$81994ac4c012d104$exports = $81994ac4c012d104$var$compare;


var $4d852d6325ac3f0a$exports = {};

const $4d852d6325ac3f0a$var$rcompare = (a, b, loose)=>$81994ac4c012d104$exports(b, a, loose);
$4d852d6325ac3f0a$exports = $4d852d6325ac3f0a$var$rcompare;


var $5341c4d7c3ddc057$exports = {};

const $5341c4d7c3ddc057$var$compareLoose = (a, b)=>$81994ac4c012d104$exports(a, b, true);
$5341c4d7c3ddc057$exports = $5341c4d7c3ddc057$var$compareLoose;


var $20d4c8016361ffad$exports = {};

const $20d4c8016361ffad$var$compareBuild = (a, b, loose)=>{
    const versionA = new $df90e8d1cf1cf055$exports(a, loose);
    const versionB = new $df90e8d1cf1cf055$exports(b, loose);
    return versionA.compare(versionB) || versionA.compareBuild(versionB);
};
$20d4c8016361ffad$exports = $20d4c8016361ffad$var$compareBuild;


var $49bbf04266a7f106$exports = {};

const $49bbf04266a7f106$var$sort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(a, b, loose));
$49bbf04266a7f106$exports = $49bbf04266a7f106$var$sort;


var $3c149acde0254244$exports = {};

const $3c149acde0254244$var$rsort = (list, loose)=>list.sort((a, b)=>$20d4c8016361ffad$exports(b, a, loose));
$3c149acde0254244$exports = $3c149acde0254244$var$rsort;


var $104422eefe356e5b$exports = {};

const $104422eefe356e5b$var$gt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) > 0;
$104422eefe356e5b$exports = $104422eefe356e5b$var$gt;


var $f6d98cb923c33015$exports = {};

const $f6d98cb923c33015$var$lt = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) < 0;
$f6d98cb923c33015$exports = $f6d98cb923c33015$var$lt;


var $5e5d028df14dc03a$exports = {};

const $5e5d028df14dc03a$var$eq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) === 0;
$5e5d028df14dc03a$exports = $5e5d028df14dc03a$var$eq;


var $3334214f1b360179$exports = {};

const $3334214f1b360179$var$neq = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) !== 0;
$3334214f1b360179$exports = $3334214f1b360179$var$neq;


var $c707a43d6c3b801a$exports = {};

const $c707a43d6c3b801a$var$gte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) >= 0;
$c707a43d6c3b801a$exports = $c707a43d6c3b801a$var$gte;


var $aaf185a79a690d76$exports = {};

const $aaf185a79a690d76$var$lte = (a, b, loose)=>$81994ac4c012d104$exports(a, b, loose) <= 0;
$aaf185a79a690d76$exports = $aaf185a79a690d76$var$lte;


var $2272a34159523aa5$exports = {};






const $2272a34159523aa5$var$cmp = (a, op, b, loose)=>{
    switch(op){
        case "===":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a === b;
        case "!==":
            if (typeof a === "object") a = a.version;
            if (typeof b === "object") b = b.version;
            return a !== b;
        case "":
        case "=":
        case "==":
            return $5e5d028df14dc03a$exports(a, b, loose);
        case "!=":
            return $3334214f1b360179$exports(a, b, loose);
        case ">":
            return $104422eefe356e5b$exports(a, b, loose);
        case ">=":
            return $c707a43d6c3b801a$exports(a, b, loose);
        case "<":
            return $f6d98cb923c33015$exports(a, b, loose);
        case "<=":
            return $aaf185a79a690d76$exports(a, b, loose);
        default:
            throw new TypeError(`Invalid operator: ${op}`);
    }
};
$2272a34159523aa5$exports = $2272a34159523aa5$var$cmp;


var $1fceaff8ff23f299$exports = {};



var $kGRcS = parcelRequire("kGRcS");
var $1fceaff8ff23f299$require$re = $kGRcS.safeRe;
var $1fceaff8ff23f299$require$t = $kGRcS.t;
const $1fceaff8ff23f299$var$coerce = (version, options)=>{
    if (version instanceof $df90e8d1cf1cf055$exports) return version;
    if (typeof version === "number") version = String(version);
    if (typeof version !== "string") return null;
    options = options || {};
    let match = null;
    if (!options.rtl) match = version.match(options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCEFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCE]);
    else {
        // Find the right-most coercible string that does not share
        // a terminus with a more left-ward coercible string.
        // Eg, '1.2.3.4' wants to coerce '2.3.4', not '3.4' or '4'
        // With includePrerelease option set, '1.2.3.4-rc' wants to coerce '2.3.4-rc', not '2.3.4'
        //
        // Walk through the string checking with a /g regexp
        // Manually set the index so as to pick up overlapping matches.
        // Stop when we get a match that ends at the string end, since no
        // coercible string can be more right-ward without the same terminus.
        const coerceRtlRegex = options.includePrerelease ? $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTLFULL] : $1fceaff8ff23f299$require$re[$1fceaff8ff23f299$require$t.COERCERTL];
        let next;
        while((next = coerceRtlRegex.exec(version)) && (!match || match.index + match[0].length !== version.length)){
            if (!match || next.index + next[0].length !== match.index + match[0].length) match = next;
            coerceRtlRegex.lastIndex = next.index + next[1].length + next[2].length;
        }
        // leave it in a clean state
        coerceRtlRegex.lastIndex = -1;
    }
    if (match === null) return null;
    const major = match[2];
    const minor = match[3] || "0";
    const patch = match[4] || "0";
    const prerelease = options.includePrerelease && match[5] ? `-${match[5]}` : "";
    const build = options.includePrerelease && match[6] ? `+${match[6]}` : "";
    return $518bb137cbdf72c3$exports(`${major}.${minor}.${patch}${prerelease}${build}`, options);
};
$1fceaff8ff23f299$exports = $1fceaff8ff23f299$var$coerce;


var $3d29c357640e9d06$exports = {};
const $3d29c357640e9d06$var$ANY = Symbol("SemVer ANY");
// hoisted class for cyclic dependency
class $3d29c357640e9d06$var$Comparator {
    static get ANY() {
        return $3d29c357640e9d06$var$ANY;
    }
    constructor(comp, options){
        options = $100fa442ed30ac34$exports(options);
        if (comp instanceof $3d29c357640e9d06$var$Comparator) {
            if (comp.loose === !!options.loose) return comp;
            else comp = comp.value;
        }
        comp = comp.trim().split(/\s+/).join(" ");
        $i9RZm("comparator", comp, options);
        this.options = options;
        this.loose = !!options.loose;
        this.parse(comp);
        if (this.semver === $3d29c357640e9d06$var$ANY) this.value = "";
        else this.value = this.operator + this.semver.version;
        $i9RZm("comp", this);
    }
    parse(comp) {
        const r = this.options.loose ? $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATORLOOSE] : $3d29c357640e9d06$require$re[$3d29c357640e9d06$require$t.COMPARATOR];
        const m = comp.match(r);
        if (!m) throw new TypeError(`Invalid comparator: ${comp}`);
        this.operator = m[1] !== undefined ? m[1] : "";
        if (this.operator === "=") this.operator = "";
        // if it literally is just '>' or '' then allow anything.
        if (!m[2]) this.semver = $3d29c357640e9d06$var$ANY;
        else this.semver = new $df90e8d1cf1cf055$exports(m[2], this.options.loose);
    }
    toString() {
        return this.value;
    }
    test(version) {
        $i9RZm("Comparator.test", version, this.options.loose);
        if (this.semver === $3d29c357640e9d06$var$ANY || version === $3d29c357640e9d06$var$ANY) return true;
        if (typeof version === "string") try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        return $2272a34159523aa5$exports(version, this.operator, this.semver, this.options);
    }
    intersects(comp, options) {
        if (!(comp instanceof $3d29c357640e9d06$var$Comparator)) throw new TypeError("a Comparator is required");
        if (this.operator === "") {
            if (this.value === "") return true;
            return new $36512a6be0346a51$exports(comp.value, options).test(this.value);
        } else if (comp.operator === "") {
            if (comp.value === "") return true;
            return new $36512a6be0346a51$exports(this.value, options).test(comp.semver);
        }
        options = $100fa442ed30ac34$exports(options);
        // Special cases where nothing can possibly be lower
        if (options.includePrerelease && (this.value === "<0.0.0-0" || comp.value === "<0.0.0-0")) return false;
        if (!options.includePrerelease && (this.value.startsWith("<0.0.0") || comp.value.startsWith("<0.0.0"))) return false;
        // Same direction increasing (> or >=)
        if (this.operator.startsWith(">") && comp.operator.startsWith(">")) return true;
        // Same direction decreasing (< or <=)
        if (this.operator.startsWith("<") && comp.operator.startsWith("<")) return true;
        // same SemVer and both sides are inclusive (<= or >=)
        if (this.semver.version === comp.semver.version && this.operator.includes("=") && comp.operator.includes("=")) return true;
        // opposite directions less than
        if ($2272a34159523aa5$exports(this.semver, "<", comp.semver, options) && this.operator.startsWith(">") && comp.operator.startsWith("<")) return true;
        // opposite directions greater than
        if ($2272a34159523aa5$exports(this.semver, ">", comp.semver, options) && this.operator.startsWith("<") && comp.operator.startsWith(">")) return true;
        return false;
    }
}
$3d29c357640e9d06$exports = $3d29c357640e9d06$var$Comparator;


var $kGRcS = parcelRequire("kGRcS");
var $3d29c357640e9d06$require$re = $kGRcS.safeRe;
var $3d29c357640e9d06$require$t = $kGRcS.t;


var $i9RZm = parcelRequire("i9RZm");

var $36512a6be0346a51$exports = {};
const $36512a6be0346a51$var$SPACE_CHARACTERS = /\s+/g;
// hoisted class for cyclic dependency
class $36512a6be0346a51$var$Range {
    constructor(range, options){
        options = $100fa442ed30ac34$exports(options);
        if (range instanceof $36512a6be0346a51$var$Range) {
            if (range.loose === !!options.loose && range.includePrerelease === !!options.includePrerelease) return range;
            else return new $36512a6be0346a51$var$Range(range.raw, options);
        }
        if (range instanceof $3d29c357640e9d06$exports) {
            // just put it in the set and return
            this.raw = range.value;
            this.set = [
                [
                    range
                ]
            ];
            this.formatted = undefined;
            return this;
        }
        this.options = options;
        this.loose = !!options.loose;
        this.includePrerelease = !!options.includePrerelease;
        // First reduce all whitespace as much as possible so we do not have to rely
        // on potentially slow regexes like \s*. This is then stored and used for
        // future error messages as well.
        this.raw = range.trim().replace($36512a6be0346a51$var$SPACE_CHARACTERS, " ");
        // First, split on ||
        this.set = this.raw.split("||")// map the range to a 2d array of comparators
        .map((r)=>this.parseRange(r.trim()))// throw out any comparator lists that are empty
        // this generally means that it was not a valid range, which is allowed
        // in loose mode, but will still throw if the WHOLE range is invalid.
        .filter((c)=>c.length);
        if (!this.set.length) throw new TypeError(`Invalid SemVer Range: ${this.raw}`);
        // if we have any that are not the null set, throw out null sets.
        if (this.set.length > 1) {
            // keep the first one, in case they're all null sets
            const first = this.set[0];
            this.set = this.set.filter((c)=>!$36512a6be0346a51$var$isNullSet(c[0]));
            if (this.set.length === 0) this.set = [
                first
            ];
            else if (this.set.length > 1) {
                // if we have any that are *, then the range is just *
                for (const c of this.set)if (c.length === 1 && $36512a6be0346a51$var$isAny(c[0])) {
                    this.set = [
                        c
                    ];
                    break;
                }
            }
        }
        this.formatted = undefined;
    }
    get range() {
        if (this.formatted === undefined) {
            this.formatted = "";
            for(let i = 0; i < this.set.length; i++){
                if (i > 0) this.formatted += "||";
                const comps = this.set[i];
                for(let k = 0; k < comps.length; k++){
                    if (k > 0) this.formatted += " ";
                    this.formatted += comps[k].toString().trim();
                }
            }
        }
        return this.formatted;
    }
    format() {
        return this.range;
    }
    toString() {
        return this.range;
    }
    parseRange(range) {
        // memoize range parsing for performance.
        // this is a very hot path, and fully deterministic.
        const memoOpts = (this.options.includePrerelease && $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE) | (this.options.loose && $36512a6be0346a51$require$FLAG_LOOSE);
        const memoKey = memoOpts + ":" + range;
        const cached = $36512a6be0346a51$var$cache.get(memoKey);
        if (cached) return cached;
        const loose = this.options.loose;
        // `1.2.3 - 1.2.4` => `>=1.2.3 <=1.2.4`
        const hr = loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.HYPHENRANGE];
        range = range.replace(hr, $36512a6be0346a51$var$hyphenReplace(this.options.includePrerelease));
        $i9RZm("hyphen replace", range);
        // `> 1.2.3 < 1.2.5` => `>1.2.3 <1.2.5`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORTRIM], $36512a6be0346a51$require$comparatorTrimReplace);
        $i9RZm("comparator trim", range);
        // `~ 1.2.3` => `~1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDETRIM], $36512a6be0346a51$require$tildeTrimReplace);
        $i9RZm("tilde trim", range);
        // `^ 1.2.3` => `^1.2.3`
        range = range.replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETTRIM], $36512a6be0346a51$require$caretTrimReplace);
        $i9RZm("caret trim", range);
        // At this point, the range is completely trimmed and
        // ready to be split into comparators.
        let rangeList = range.split(" ").map((comp)=>$36512a6be0346a51$var$parseComparator(comp, this.options)).join(" ").split(/\s+/)// >=0.0.0 is equivalent to *
        .map((comp)=>$36512a6be0346a51$var$replaceGTE0(comp, this.options));
        if (loose) // in loose mode, throw out any that are not valid comparators
        rangeList = rangeList.filter((comp)=>{
            $i9RZm("loose invalid filter", comp, this.options);
            return !!comp.match($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.COMPARATORLOOSE]);
        });
        $i9RZm("range list", rangeList);
        // if any comparators are the null set, then replace with JUST null set
        // if more than one comparator, remove any * comparators
        // also, don't include the same comparator more than once
        const rangeMap = new Map();
        const comparators = rangeList.map((comp)=>new $3d29c357640e9d06$exports(comp, this.options));
        for (const comp of comparators){
            if ($36512a6be0346a51$var$isNullSet(comp)) return [
                comp
            ];
            rangeMap.set(comp.value, comp);
        }
        if (rangeMap.size > 1 && rangeMap.has("")) rangeMap.delete("");
        const result = [
            ...rangeMap.values()
        ];
        $36512a6be0346a51$var$cache.set(memoKey, result);
        return result;
    }
    intersects(range, options) {
        if (!(range instanceof $36512a6be0346a51$var$Range)) throw new TypeError("a Range is required");
        return this.set.some((thisComparators)=>{
            return $36512a6be0346a51$var$isSatisfiable(thisComparators, options) && range.set.some((rangeComparators)=>{
                return $36512a6be0346a51$var$isSatisfiable(rangeComparators, options) && thisComparators.every((thisComparator)=>{
                    return rangeComparators.every((rangeComparator)=>{
                        return thisComparator.intersects(rangeComparator, options);
                    });
                });
            });
        });
    }
    // if ANY of the sets match ALL of its comparators, then pass
    test(version) {
        if (!version) return false;
        if (typeof version === "string") try {
            version = new $df90e8d1cf1cf055$exports(version, this.options);
        } catch (er) {
            return false;
        }
        for(let i = 0; i < this.set.length; i++){
            if ($36512a6be0346a51$var$testSet(this.set[i], version, this.options)) return true;
        }
        return false;
    }
}
$36512a6be0346a51$exports = $36512a6be0346a51$var$Range;
var $5fc8514051072a37$exports = {};
class $5fc8514051072a37$var$LRUCache {
    constructor(){
        this.max = 1000;
        this.map = new Map();
    }
    get(key) {
        const value = this.map.get(key);
        if (value === undefined) return undefined;
        else {
            // Remove the key from the map and add it to the end
            this.map.delete(key);
            this.map.set(key, value);
            return value;
        }
    }
    delete(key) {
        return this.map.delete(key);
    }
    set(key, value) {
        const deleted = this.delete(key);
        if (!deleted && value !== undefined) {
            // If cache is full, delete the least recently used item
            if (this.map.size >= this.max) {
                const firstKey = this.map.keys().next().value;
                this.delete(firstKey);
            }
            this.map.set(key, value);
        }
        return this;
    }
}
$5fc8514051072a37$exports = $5fc8514051072a37$var$LRUCache;


const $36512a6be0346a51$var$cache = new $5fc8514051072a37$exports();



var $i9RZm = parcelRequire("i9RZm");


var $kGRcS = parcelRequire("kGRcS");
var $36512a6be0346a51$require$re = $kGRcS.safeRe;
var $36512a6be0346a51$require$t = $kGRcS.t;
var $36512a6be0346a51$require$comparatorTrimReplace = $kGRcS.comparatorTrimReplace;
var $36512a6be0346a51$require$tildeTrimReplace = $kGRcS.tildeTrimReplace;
var $36512a6be0346a51$require$caretTrimReplace = $kGRcS.caretTrimReplace;

var $fJ45P = parcelRequire("fJ45P");
var $36512a6be0346a51$require$FLAG_INCLUDE_PRERELEASE = $fJ45P.FLAG_INCLUDE_PRERELEASE;
var $36512a6be0346a51$require$FLAG_LOOSE = $fJ45P.FLAG_LOOSE;
const $36512a6be0346a51$var$isNullSet = (c)=>c.value === "<0.0.0-0";
const $36512a6be0346a51$var$isAny = (c)=>c.value === "";
// take a set of comparators and determine whether there
// exists a version which can satisfy it
const $36512a6be0346a51$var$isSatisfiable = (comparators, options)=>{
    let result = true;
    const remainingComparators = comparators.slice();
    let testComparator = remainingComparators.pop();
    while(result && remainingComparators.length){
        result = remainingComparators.every((otherComparator)=>{
            return testComparator.intersects(otherComparator, options);
        });
        testComparator = remainingComparators.pop();
    }
    return result;
};
// comprised of xranges, tildes, stars, and gtlt's at this point.
// already replaced the hyphen ranges
// turn into a set of JUST comparators.
const $36512a6be0346a51$var$parseComparator = (comp, options)=>{
    $i9RZm("comp", comp, options);
    comp = $36512a6be0346a51$var$replaceCarets(comp, options);
    $i9RZm("caret", comp);
    comp = $36512a6be0346a51$var$replaceTildes(comp, options);
    $i9RZm("tildes", comp);
    comp = $36512a6be0346a51$var$replaceXRanges(comp, options);
    $i9RZm("xrange", comp);
    comp = $36512a6be0346a51$var$replaceStars(comp, options);
    $i9RZm("stars", comp);
    return comp;
};
const $36512a6be0346a51$var$isX = (id)=>!id || id.toLowerCase() === "x" || id === "*";
// ~, ~> --> * (any, kinda silly)
// ~2, ~2.x, ~2.x.x, ~>2, ~>2.x ~>2.x.x --> >=2.0.0 <3.0.0-0
// ~2.0, ~2.0.x, ~>2.0, ~>2.0.x --> >=2.0.0 <2.1.0-0
// ~1.2, ~1.2.x, ~>1.2, ~>1.2.x --> >=1.2.0 <1.3.0-0
// ~1.2.3, ~>1.2.3 --> >=1.2.3 <1.3.0-0
// ~1.2.0, ~>1.2.0 --> >=1.2.0 <1.3.0-0
// ~0.0.1 --> >=0.0.1 <0.1.0-0
const $36512a6be0346a51$var$replaceTildes = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceTilde(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceTilde = (comp, options)=>{
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.TILDE];
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("tilde", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0 <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) // ~1.2 == >=1.2.0 <1.3.0-0
        ret = `>=${M}.${m}.0 <${M}.${+m + 1}.0-0`;
        else if (pr) {
            $i9RZm("replaceTilde pr", pr);
            ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
        } else // ~1.2.3 == >=1.2.3 <1.3.0-0
        ret = `>=${M}.${m}.${p} <${M}.${+m + 1}.0-0`;
        $i9RZm("tilde return", ret);
        return ret;
    });
};
// ^ --> * (any, kinda silly)
// ^2, ^2.x, ^2.x.x --> >=2.0.0 <3.0.0-0
// ^2.0, ^2.0.x --> >=2.0.0 <3.0.0-0
// ^1.2, ^1.2.x --> >=1.2.0 <2.0.0-0
// ^1.2.3 --> >=1.2.3 <2.0.0-0
// ^1.2.0 --> >=1.2.0 <2.0.0-0
// ^0.0.1 --> >=0.0.1 <0.0.2-0
// ^0.1.0 --> >=0.1.0 <0.2.0-0
const $36512a6be0346a51$var$replaceCarets = (comp, options)=>{
    return comp.trim().split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceCaret(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceCaret = (comp, options)=>{
    $i9RZm("caret", comp, options);
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARETLOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.CARET];
    const z = options.includePrerelease ? "-0" : "";
    return comp.replace(r, (_, M, m, p, pr)=>{
        $i9RZm("caret", comp, _, M, m, p, pr);
        let ret;
        if ($36512a6be0346a51$var$isX(M)) ret = "";
        else if ($36512a6be0346a51$var$isX(m)) ret = `>=${M}.0.0${z} <${+M + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(p)) {
            if (M === "0") ret = `>=${M}.${m}.0${z} <${M}.${+m + 1}.0-0`;
            else ret = `>=${M}.${m}.0${z} <${+M + 1}.0.0-0`;
        } else if (pr) {
            $i9RZm("replaceCaret pr", pr);
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}-${pr} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}-${pr} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p}-${pr} <${+M + 1}.0.0-0`;
        } else {
            $i9RZm("no pr");
            if (M === "0") {
                if (m === "0") ret = `>=${M}.${m}.${p}${z} <${M}.${m}.${+p + 1}-0`;
                else ret = `>=${M}.${m}.${p}${z} <${M}.${+m + 1}.0-0`;
            } else ret = `>=${M}.${m}.${p} <${+M + 1}.0.0-0`;
        }
        $i9RZm("caret return", ret);
        return ret;
    });
};
const $36512a6be0346a51$var$replaceXRanges = (comp, options)=>{
    $i9RZm("replaceXRanges", comp, options);
    return comp.split(/\s+/).map((c)=>$36512a6be0346a51$var$replaceXRange(c, options)).join(" ");
};
const $36512a6be0346a51$var$replaceXRange = (comp, options)=>{
    comp = comp.trim();
    const r = options.loose ? $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGELOOSE] : $36512a6be0346a51$require$re[$36512a6be0346a51$require$t.XRANGE];
    return comp.replace(r, (ret, gtlt, M, m, p, pr)=>{
        $i9RZm("xRange", comp, ret, gtlt, M, m, p, pr);
        const xM = $36512a6be0346a51$var$isX(M);
        const xm = xM || $36512a6be0346a51$var$isX(m);
        const xp = xm || $36512a6be0346a51$var$isX(p);
        const anyX = xp;
        if (gtlt === "=" && anyX) gtlt = "";
        // if we're including prereleases in the match, then we need
        // to fix this to -0, the lowest possible prerelease value
        pr = options.includePrerelease ? "-0" : "";
        if (xM) {
            if (gtlt === ">" || gtlt === "<") // nothing is allowed
            ret = "<0.0.0-0";
            else // nothing is forbidden
            ret = "*";
        } else if (gtlt && anyX) {
            // we know patch is an x, because we have any x at all.
            // replace X with 0
            if (xm) m = 0;
            p = 0;
            if (gtlt === ">") {
                // >1 => >=2.0.0
                // >1.2 => >=1.3.0
                gtlt = ">=";
                if (xm) {
                    M = +M + 1;
                    m = 0;
                    p = 0;
                } else {
                    m = +m + 1;
                    p = 0;
                }
            } else if (gtlt === "<=") {
                // <=0.7.x is actually <0.8.0, since any 0.7.x should
                // pass.  Similarly, <=7.x is actually <8.0.0, etc.
                gtlt = "<";
                if (xm) M = +M + 1;
                else m = +m + 1;
            }
            if (gtlt === "<") pr = "-0";
            ret = `${gtlt + M}.${m}.${p}${pr}`;
        } else if (xm) ret = `>=${M}.0.0${pr} <${+M + 1}.0.0-0`;
        else if (xp) ret = `>=${M}.${m}.0${pr} <${M}.${+m + 1}.0-0`;
        $i9RZm("xRange return", ret);
        return ret;
    });
};
// Because * is AND-ed with everything else in the comparator,
// and '' means "any version", just remove the *s entirely.
const $36512a6be0346a51$var$replaceStars = (comp, options)=>{
    $i9RZm("replaceStars", comp, options);
    // Looseness is ignored here.  star is always as loose as it gets!
    return comp.trim().replace($36512a6be0346a51$require$re[$36512a6be0346a51$require$t.STAR], "");
};
const $36512a6be0346a51$var$replaceGTE0 = (comp, options)=>{
    $i9RZm("replaceGTE0", comp, options);
    return comp.trim().replace($36512a6be0346a51$require$re[options.includePrerelease ? $36512a6be0346a51$require$t.GTE0PRE : $36512a6be0346a51$require$t.GTE0], "");
};
// This function is passed to string.replace(re[t.HYPHENRANGE])
// M, m, patch, prerelease, build
// 1.2 - 3.4.5 => >=1.2.0 <=3.4.5
// 1.2.3 - 3.4 => >=1.2.0 <3.5.0-0 Any 3.4.x will do
// 1.2 - 3.4 => >=1.2.0 <3.5.0-0
// TODO build?
const $36512a6be0346a51$var$hyphenReplace = (incPr)=>($0, from, fM, fm, fp, fpr, fb, to, tM, tm, tp, tpr)=>{
        if ($36512a6be0346a51$var$isX(fM)) from = "";
        else if ($36512a6be0346a51$var$isX(fm)) from = `>=${fM}.0.0${incPr ? "-0" : ""}`;
        else if ($36512a6be0346a51$var$isX(fp)) from = `>=${fM}.${fm}.0${incPr ? "-0" : ""}`;
        else if (fpr) from = `>=${from}`;
        else from = `>=${from}${incPr ? "-0" : ""}`;
        if ($36512a6be0346a51$var$isX(tM)) to = "";
        else if ($36512a6be0346a51$var$isX(tm)) to = `<${+tM + 1}.0.0-0`;
        else if ($36512a6be0346a51$var$isX(tp)) to = `<${tM}.${+tm + 1}.0-0`;
        else if (tpr) to = `<=${tM}.${tm}.${tp}-${tpr}`;
        else if (incPr) to = `<${tM}.${tm}.${+tp + 1}-0`;
        else to = `<=${to}`;
        return `${from} ${to}`.trim();
    };
const $36512a6be0346a51$var$testSet = (set, version, options)=>{
    for(let i = 0; i < set.length; i++){
        if (!set[i].test(version)) return false;
    }
    if (version.prerelease.length && !options.includePrerelease) {
        // Find the set of versions that are allowed to have prereleases
        // For example, ^1.2.3-pr.1 desugars to >=1.2.3-pr.1 <2.0.0
        // That should allow `1.2.3-pr.2` to pass.
        // However, `1.2.4-alpha.notready` should NOT be allowed,
        // even though it's within the range set by the comparators.
        for(let i = 0; i < set.length; i++){
            $i9RZm(set[i].semver);
            if (set[i].semver === $3d29c357640e9d06$exports.ANY) continue;
            if (set[i].semver.prerelease.length > 0) {
                const allowed = set[i].semver;
                if (allowed.major === version.major && allowed.minor === version.minor && allowed.patch === version.patch) return true;
            }
        }
        // Version has a -pre, but it's not one of the ones we like.
        return false;
    }
    return true;
};





var $44370327d4e393bf$exports = {};

const $44370327d4e393bf$var$satisfies = (version, range, options)=>{
    try {
        range = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return false;
    }
    return range.test(version);
};
$44370327d4e393bf$exports = $44370327d4e393bf$var$satisfies;


var $6bf6930ad20f8979$exports = {};

// Mostly just for testing and legacy API reasons
const $6bf6930ad20f8979$var$toComparators = (range, options)=>new $36512a6be0346a51$exports(range, options).set.map((comp)=>comp.map((c)=>c.value).join(" ").trim().split(" "));
$6bf6930ad20f8979$exports = $6bf6930ad20f8979$var$toComparators;


var $2b2ac348dee0803e$exports = {};


const $2b2ac348dee0803e$var$maxSatisfying = (versions, range, options)=>{
    let max = null;
    let maxSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!max || maxSV.compare(v) === -1) {
                // compare(max, v, true)
                max = v;
                maxSV = new $df90e8d1cf1cf055$exports(max, options);
            }
        }
    });
    return max;
};
$2b2ac348dee0803e$exports = $2b2ac348dee0803e$var$maxSatisfying;


var $7a6650c8d62ec668$exports = {};


const $7a6650c8d62ec668$var$minSatisfying = (versions, range, options)=>{
    let min = null;
    let minSV = null;
    let rangeObj = null;
    try {
        rangeObj = new $36512a6be0346a51$exports(range, options);
    } catch (er) {
        return null;
    }
    versions.forEach((v)=>{
        if (rangeObj.test(v)) // satisfies(v, range, options)
        {
            if (!min || minSV.compare(v) === 1) {
                // compare(min, v, true)
                min = v;
                minSV = new $df90e8d1cf1cf055$exports(min, options);
            }
        }
    });
    return min;
};
$7a6650c8d62ec668$exports = $7a6650c8d62ec668$var$minSatisfying;


var $7389cc9c1db09b0d$exports = {};



const $7389cc9c1db09b0d$var$minVersion = (range, loose)=>{
    range = new $36512a6be0346a51$exports(range, loose);
    let minver = new $df90e8d1cf1cf055$exports("0.0.0");
    if (range.test(minver)) return minver;
    minver = new $df90e8d1cf1cf055$exports("0.0.0-0");
    if (range.test(minver)) return minver;
    minver = null;
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let setMin = null;
        comparators.forEach((comparator)=>{
            // Clone to avoid manipulating the comparator's semver object.
            const compver = new $df90e8d1cf1cf055$exports(comparator.semver.version);
            switch(comparator.operator){
                case ">":
                    if (compver.prerelease.length === 0) compver.patch++;
                    else compver.prerelease.push(0);
                    compver.raw = compver.format();
                /* fallthrough */ case "":
                case ">=":
                    if (!setMin || $104422eefe356e5b$exports(compver, setMin)) setMin = compver;
                    break;
                case "<":
                case "<=":
                    break;
                /* istanbul ignore next */ default:
                    throw new Error(`Unexpected operation: ${comparator.operator}`);
            }
        });
        if (setMin && (!minver || $104422eefe356e5b$exports(minver, setMin))) minver = setMin;
    }
    if (minver && range.test(minver)) return minver;
    return null;
};
$7389cc9c1db09b0d$exports = $7389cc9c1db09b0d$var$minVersion;


var $16299f7793385cf3$exports = {};

const $16299f7793385cf3$var$validRange = (range, options)=>{
    try {
        // Return '*' instead of '' so that truthiness works.
        // This will throw if it's invalid anyway
        return new $36512a6be0346a51$exports(range, options).range || "*";
    } catch (er) {
        return null;
    }
};
$16299f7793385cf3$exports = $16299f7793385cf3$var$validRange;


var $546520af951b9b5a$exports = {};


const { ANY: $546520af951b9b5a$var$ANY } = $3d29c357640e9d06$exports;






const $546520af951b9b5a$var$outside = (version, range, hilo, options)=>{
    version = new $df90e8d1cf1cf055$exports(version, options);
    range = new $36512a6be0346a51$exports(range, options);
    let gtfn, ltefn, ltfn, comp, ecomp;
    switch(hilo){
        case ">":
            gtfn = $104422eefe356e5b$exports;
            ltefn = $aaf185a79a690d76$exports;
            ltfn = $f6d98cb923c33015$exports;
            comp = ">";
            ecomp = ">=";
            break;
        case "<":
            gtfn = $f6d98cb923c33015$exports;
            ltefn = $c707a43d6c3b801a$exports;
            ltfn = $104422eefe356e5b$exports;
            comp = "<";
            ecomp = "<=";
            break;
        default:
            throw new TypeError('Must provide a hilo val of "<" or ">"');
    }
    // If it satisfies the range it is not outside
    if ($44370327d4e393bf$exports(version, range, options)) return false;
    // From now on, variable terms are as if we're in "gtr" mode.
    // but note that everything is flipped for the "ltr" function.
    for(let i = 0; i < range.set.length; ++i){
        const comparators = range.set[i];
        let high = null;
        let low = null;
        comparators.forEach((comparator)=>{
            if (comparator.semver === $546520af951b9b5a$var$ANY) comparator = new $3d29c357640e9d06$exports(">=0.0.0");
            high = high || comparator;
            low = low || comparator;
            if (gtfn(comparator.semver, high.semver, options)) high = comparator;
            else if (ltfn(comparator.semver, low.semver, options)) low = comparator;
        });
        // If the edge version comparator has a operator then our version
        // isn't outside it
        if (high.operator === comp || high.operator === ecomp) return false;
        // If the lowest version comparator has an operator and our version
        // is less than it then it isn't higher than the range
        if ((!low.operator || low.operator === comp) && ltefn(version, low.semver)) return false;
        else if (low.operator === ecomp && ltfn(version, low.semver)) return false;
    }
    return true;
};
$546520af951b9b5a$exports = $546520af951b9b5a$var$outside;


var $6e6f2ea8eb78962a$exports = {};
// Determine if version is greater than all the versions possible in the range.

const $6e6f2ea8eb78962a$var$gtr = (version, range, options)=>$546520af951b9b5a$exports(version, range, ">", options);
$6e6f2ea8eb78962a$exports = $6e6f2ea8eb78962a$var$gtr;


var $0d167156795b8123$exports = {};

// Determine if version is less than all the versions possible in the range
const $0d167156795b8123$var$ltr = (version, range, options)=>$546520af951b9b5a$exports(version, range, "<", options);
$0d167156795b8123$exports = $0d167156795b8123$var$ltr;


var $ff0b302dd979be82$exports = {};

const $ff0b302dd979be82$var$intersects = (r1, r2, options)=>{
    r1 = new $36512a6be0346a51$exports(r1, options);
    r2 = new $36512a6be0346a51$exports(r2, options);
    return r1.intersects(r2, options);
};
$ff0b302dd979be82$exports = $ff0b302dd979be82$var$intersects;


var $72b9b4c6a1649533$exports = {};
// given a set of versions and a range, create a "simplified" range
// that includes the same versions that the original range does
// If the original range is shorter than the simplified one, return that.


$72b9b4c6a1649533$exports = (versions, range, options)=>{
    const set = [];
    let first = null;
    let prev = null;
    const v = versions.sort((a, b)=>$81994ac4c012d104$exports(a, b, options));
    for (const version of v){
        const included = $44370327d4e393bf$exports(version, range, options);
        if (included) {
            prev = version;
            if (!first) first = version;
        } else {
            if (prev) set.push([
                first,
                prev
            ]);
            prev = null;
            first = null;
        }
    }
    if (first) set.push([
        first,
        null
    ]);
    const ranges = [];
    for (const [min, max] of set){
        if (min === max) ranges.push(min);
        else if (!max && min === v[0]) ranges.push("*");
        else if (!max) ranges.push(`>=${min}`);
        else if (min === v[0]) ranges.push(`<=${max}`);
        else ranges.push(`${min} - ${max}`);
    }
    const simplified = ranges.join(" || ");
    const original = typeof range.raw === "string" ? range.raw : String(range);
    return simplified.length < original.length ? simplified : range;
};


var $4a5bb988105271bd$exports = {};


const { ANY: $4a5bb988105271bd$var$ANY } = $3d29c357640e9d06$exports;


// Complex range `r1 || r2 || ...` is a subset of `R1 || R2 || ...` iff:
// - Every simple range `r1, r2, ...` is a null set, OR
// - Every simple range `r1, r2, ...` which is not a null set is a subset of
//   some `R1, R2, ...`
//
// Simple range `c1 c2 ...` is a subset of simple range `C1 C2 ...` iff:
// - If c is only the ANY comparator
//   - If C is only the ANY comparator, return true
//   - Else if in prerelease mode, return false
//   - else replace c with `[>=0.0.0]`
// - If C is only the ANY comparator
//   - if in prerelease mode, return true
//   - else replace C with `[>=0.0.0]`
// - Let EQ be the set of = comparators in c
// - If EQ is more than one, return true (null set)
// - Let GT be the highest > or >= comparator in c
// - Let LT be the lowest < or <= comparator in c
// - If GT and LT, and GT.semver > LT.semver, return true (null set)
// - If any C is a = range, and GT or LT are set, return false
// - If EQ
//   - If GT, and EQ does not satisfy GT, return true (null set)
//   - If LT, and EQ does not satisfy LT, return true (null set)
//   - If EQ satisfies every C, return true
//   - Else return false
// - If GT
//   - If GT.semver is lower than any > or >= comp in C, return false
//   - If GT is >=, and GT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the GT.semver tuple, return false
// - If LT
//   - If LT.semver is greater than any < or <= comp in C, return false
//   - If LT is <=, and LT.semver does not satisfy every C, return false
//   - If GT.semver has a prerelease, and not in prerelease mode
//     - If no C has a prerelease and the LT.semver tuple, return false
// - Else return true
const $4a5bb988105271bd$var$subset = (sub, dom, options = {})=>{
    if (sub === dom) return true;
    sub = new $36512a6be0346a51$exports(sub, options);
    dom = new $36512a6be0346a51$exports(dom, options);
    let sawNonNull = false;
    OUTER: for (const simpleSub of sub.set){
        for (const simpleDom of dom.set){
            const isSub = $4a5bb988105271bd$var$simpleSubset(simpleSub, simpleDom, options);
            sawNonNull = sawNonNull || isSub !== null;
            if (isSub) continue OUTER;
        }
        // the null set is a subset of everything, but null simple ranges in
        // a complex range should be ignored.  so if we saw a non-null range,
        // then we know this isn't a subset, but if EVERY simple range was null,
        // then it is a subset.
        if (sawNonNull) return false;
    }
    return true;
};
const $4a5bb988105271bd$var$minimumVersionWithPreRelease = [
    new $3d29c357640e9d06$exports(">=0.0.0-0")
];
const $4a5bb988105271bd$var$minimumVersion = [
    new $3d29c357640e9d06$exports(">=0.0.0")
];
const $4a5bb988105271bd$var$simpleSubset = (sub, dom, options)=>{
    if (sub === dom) return true;
    if (sub.length === 1 && sub[0].semver === $4a5bb988105271bd$var$ANY) {
        if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) return true;
        else if (options.includePrerelease) sub = $4a5bb988105271bd$var$minimumVersionWithPreRelease;
        else sub = $4a5bb988105271bd$var$minimumVersion;
    }
    if (dom.length === 1 && dom[0].semver === $4a5bb988105271bd$var$ANY) {
        if (options.includePrerelease) return true;
        else dom = $4a5bb988105271bd$var$minimumVersion;
    }
    const eqSet = new Set();
    let gt, lt;
    for (const c of sub){
        if (c.operator === ">" || c.operator === ">=") gt = $4a5bb988105271bd$var$higherGT(gt, c, options);
        else if (c.operator === "<" || c.operator === "<=") lt = $4a5bb988105271bd$var$lowerLT(lt, c, options);
        else eqSet.add(c.semver);
    }
    if (eqSet.size > 1) return null;
    let gtltComp;
    if (gt && lt) {
        gtltComp = $81994ac4c012d104$exports(gt.semver, lt.semver, options);
        if (gtltComp > 0) return null;
        else if (gtltComp === 0 && (gt.operator !== ">=" || lt.operator !== "<=")) return null;
    }
    // will iterate one or zero times
    for (const eq of eqSet){
        if (gt && !$44370327d4e393bf$exports(eq, String(gt), options)) return null;
        if (lt && !$44370327d4e393bf$exports(eq, String(lt), options)) return null;
        for (const c of dom){
            if (!$44370327d4e393bf$exports(eq, String(c), options)) return false;
        }
        return true;
    }
    let higher, lower;
    let hasDomLT, hasDomGT;
    // if the subset has a prerelease, we need a comparator in the superset
    // with the same tuple and a prerelease, or it's not a subset
    let needDomLTPre = lt && !options.includePrerelease && lt.semver.prerelease.length ? lt.semver : false;
    let needDomGTPre = gt && !options.includePrerelease && gt.semver.prerelease.length ? gt.semver : false;
    // exception: <1.2.3-0 is the same as <1.2.3
    if (needDomLTPre && needDomLTPre.prerelease.length === 1 && lt.operator === "<" && needDomLTPre.prerelease[0] === 0) needDomLTPre = false;
    for (const c of dom){
        hasDomGT = hasDomGT || c.operator === ">" || c.operator === ">=";
        hasDomLT = hasDomLT || c.operator === "<" || c.operator === "<=";
        if (gt) {
            if (needDomGTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomGTPre.major && c.semver.minor === needDomGTPre.minor && c.semver.patch === needDomGTPre.patch) needDomGTPre = false;
            }
            if (c.operator === ">" || c.operator === ">=") {
                higher = $4a5bb988105271bd$var$higherGT(gt, c, options);
                if (higher === c && higher !== gt) return false;
            } else if (gt.operator === ">=" && !$44370327d4e393bf$exports(gt.semver, String(c), options)) return false;
        }
        if (lt) {
            if (needDomLTPre) {
                if (c.semver.prerelease && c.semver.prerelease.length && c.semver.major === needDomLTPre.major && c.semver.minor === needDomLTPre.minor && c.semver.patch === needDomLTPre.patch) needDomLTPre = false;
            }
            if (c.operator === "<" || c.operator === "<=") {
                lower = $4a5bb988105271bd$var$lowerLT(lt, c, options);
                if (lower === c && lower !== lt) return false;
            } else if (lt.operator === "<=" && !$44370327d4e393bf$exports(lt.semver, String(c), options)) return false;
        }
        if (!c.operator && (lt || gt) && gtltComp !== 0) return false;
    }
    // if there was a < or >, and nothing in the dom, then must be false
    // UNLESS it was limited by another range in the other direction.
    // Eg, >1.0.0 <1.0.1 is still a subset of <2.0.0
    if (gt && hasDomLT && !lt && gtltComp !== 0) return false;
    if (lt && hasDomGT && !gt && gtltComp !== 0) return false;
    // we needed a prerelease range in a specific tuple, but didn't get one
    // then this isn't a subset.  eg >=1.2.3-pre is not a subset of >=1.0.0,
    // because it includes prereleases in the 1.2.3 tuple
    if (needDomGTPre || needDomLTPre) return false;
    return true;
};
// >=1.2.3 is lower than >1.2.3
const $4a5bb988105271bd$var$higherGT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp > 0 ? a : comp < 0 ? b : b.operator === ">" && a.operator === ">=" ? b : a;
};
// <=1.2.3 is higher than <1.2.3
const $4a5bb988105271bd$var$lowerLT = (a, b, options)=>{
    if (!a) return b;
    const comp = $81994ac4c012d104$exports(a.semver, b.semver, options);
    return comp < 0 ? a : comp > 0 ? b : b.operator === "<" && a.operator === "<=" ? b : a;
};
$4a5bb988105271bd$exports = $4a5bb988105271bd$var$subset;


$dbb9fc904636819d$exports = {
    parse: $518bb137cbdf72c3$exports,
    valid: $c618592c32f826bd$exports,
    clean: $889491f0ea5a6118$exports,
    inc: $d4783bb52460fa90$exports,
    diff: $ab0877022a91d748$exports,
    major: $3c98d7b64d202a78$exports,
    minor: $6e90b5c2fe90feeb$exports,
    patch: $4c2948a32081632b$exports,
    prerelease: $93a6413aa1f64654$exports,
    compare: $81994ac4c012d104$exports,
    rcompare: $4d852d6325ac3f0a$exports,
    compareLoose: $5341c4d7c3ddc057$exports,
    compareBuild: $20d4c8016361ffad$exports,
    sort: $49bbf04266a7f106$exports,
    rsort: $3c149acde0254244$exports,
    gt: $104422eefe356e5b$exports,
    lt: $f6d98cb923c33015$exports,
    eq: $5e5d028df14dc03a$exports,
    neq: $3334214f1b360179$exports,
    gte: $c707a43d6c3b801a$exports,
    lte: $aaf185a79a690d76$exports,
    cmp: $2272a34159523aa5$exports,
    coerce: $1fceaff8ff23f299$exports,
    Comparator: $3d29c357640e9d06$exports,
    Range: $36512a6be0346a51$exports,
    satisfies: $44370327d4e393bf$exports,
    toComparators: $6bf6930ad20f8979$exports,
    maxSatisfying: $2b2ac348dee0803e$exports,
    minSatisfying: $7a6650c8d62ec668$exports,
    minVersion: $7389cc9c1db09b0d$exports,
    validRange: $16299f7793385cf3$exports,
    outside: $546520af951b9b5a$exports,
    gtr: $6e6f2ea8eb78962a$exports,
    ltr: $0d167156795b8123$exports,
    intersects: $ff0b302dd979be82$exports,
    simplifyRange: $72b9b4c6a1649533$exports,
    subset: $4a5bb988105271bd$exports,
    SemVer: $df90e8d1cf1cf055$exports,
    re: $kGRcS.re,
    src: $kGRcS.src,
    tokens: $kGRcS.t,
    SEMVER_SPEC_VERSION: $fJ45P.SEMVER_SPEC_VERSION,
    RELEASE_TYPES: $fJ45P.RELEASE_TYPES,
    compareIdentifiers: $ed5e7d6476f836e9$exports.compareIdentifiers,
    rcompareIdentifiers: $ed5e7d6476f836e9$exports.rcompareIdentifiers
};


const $5dec73da4f32e22b$export$36f742de2ed7d90b = 0x01;
const $5dec73da4f32e22b$export$54bc2e040474338c = 0x02;
const $5dec73da4f32e22b$export$9368aec5a4b02506 = 0x04;
const $5dec73da4f32e22b$export$95f5e559ebc551b3 = 0x08;
const $5dec73da4f32e22b$export$18b064749618be01 = 0x10;
var $5dec73da4f32e22b$export$b8d24b2c0d9c5549;
(function(DeviceModelId) {
    /** Ledger Blue */ DeviceModelId["blue"] = "blue";
    /** Ledger Nano S */ DeviceModelId["nanoS"] = "nanoS";
    /** Ledger Nano S Plus */ DeviceModelId["nanoSP"] = "nanoSP";
    /** Ledger Nano X */ DeviceModelId["nanoX"] = "nanoX";
    /** Ledger Stax */ DeviceModelId["stax"] = "stax";
    /** Ledger Flex ("europa" is the internal name) */ DeviceModelId["europa"] = "europa";
})($5dec73da4f32e22b$export$b8d24b2c0d9c5549 || ($5dec73da4f32e22b$export$b8d24b2c0d9c5549 = {}));
const $5dec73da4f32e22b$var$devices = {
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
        productName: "Ledger\xa0Blue",
        productIdMM: 0x00,
        legacyUsbProductId: 0x0000,
        usbOnly: true,
        memorySize: 491520,
        masks: [
            0x31000000,
            0x31010000
        ],
        getBlockSize: (_firwareVersion)=>4096
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
        productName: "Ledger\xa0Nano\xa0S",
        productIdMM: 0x10,
        legacyUsbProductId: 0x0001,
        usbOnly: true,
        memorySize: 327680,
        masks: [
            0x31100000
        ],
        getBlockSize: (firmwareVersion)=>{
            var _a;
            return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt((_a = (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).coerce(firmwareVersion)) !== null && _a !== void 0 ? _a : "", "2.0.0") ? 4096 : 2048;
        }
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
        productName: "Ledger\xa0Nano\xa0X",
        productIdMM: 0x40,
        legacyUsbProductId: 0x0004,
        usbOnly: false,
        memorySize: 2097152,
        masks: [
            0x33000000
        ],
        getBlockSize: (_firwareVersion)=>4096,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-0004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-0004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-0004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-0004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
        productName: "Ledger Nano S Plus",
        productIdMM: 0x50,
        legacyUsbProductId: 0x0005,
        usbOnly: true,
        memorySize: 1569792,
        masks: [
            0x33100000
        ],
        getBlockSize: (_firmwareVersion)=>32
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
        productName: "Ledger\xa0Stax",
        productIdMM: 0x60,
        legacyUsbProductId: 0x0006,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33200000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-6004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-6004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-6004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-6004-0003-4c6564676572"
            }
        ]
    },
    [$5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa]: {
        id: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa,
        productName: "Ledger\xa0Flex",
        productIdMM: 0x70,
        legacyUsbProductId: 0x0007,
        usbOnly: false,
        memorySize: 1569792,
        masks: [
            0x33300000
        ],
        getBlockSize: (_firmwareVersion)=>32,
        bluetoothSpec: [
            {
                serviceUuid: "13d63400-2c97-3004-0000-4c6564676572",
                notifyUuid: "13d63400-2c97-3004-0001-4c6564676572",
                writeUuid: "13d63400-2c97-3004-0002-4c6564676572",
                writeCmdUuid: "13d63400-2c97-3004-0003-4c6564676572"
            }
        ]
    }
};
const $5dec73da4f32e22b$var$productMap = {
    Blue: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.blue,
    "Nano S": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoS,
    "Nano S Plus": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoSP,
    "Nano X": $5dec73da4f32e22b$export$b8d24b2c0d9c5549.nanoX,
    Stax: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.stax,
    Europa: $5dec73da4f32e22b$export$b8d24b2c0d9c5549.europa
};
const $5dec73da4f32e22b$var$devicesList = Object.values($5dec73da4f32e22b$var$devices);
const $5dec73da4f32e22b$export$268c42a4ddec87f3 = 0x2c97;
const $5dec73da4f32e22b$export$289d48518583cbd7 = (id)=>{
    const info = $5dec73da4f32e22b$var$devices[id];
    if (!info) throw new Error("device '" + id + "' does not exist");
    return info;
};
const $5dec73da4f32e22b$export$f656be11ec4fd95b = (targetId)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find(({ masks: masks })=>masks.find((mask)=>(targetId & 0xffff0000) === mask));
    return deviceModel;
};
const $5dec73da4f32e22b$export$df8f4444a7c73154 = (usbProductId)=>{
    const legacy = $5dec73da4f32e22b$var$devicesList.find((d)=>d.legacyUsbProductId === usbProductId);
    if (legacy) return legacy;
    const mm = usbProductId >> 8;
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.productIdMM === mm);
    return deviceModel;
};
const $5dec73da4f32e22b$export$dce0906e1912b553 = (productName)=>{
    const deviceModel = $5dec73da4f32e22b$var$devicesList.find((d)=>d.id === $5dec73da4f32e22b$var$productMap[productName]);
    return deviceModel;
};
const $5dec73da4f32e22b$var$bluetoothServices = [];
const $5dec73da4f32e22b$var$serviceUuidToInfos = {};
for(const id in $5dec73da4f32e22b$var$devices){
    const deviceModel = $5dec73da4f32e22b$var$devices[id];
    const { bluetoothSpec: bluetoothSpec } = deviceModel;
    if (bluetoothSpec) for(let i = 0; i < bluetoothSpec.length; i++){
        const spec = bluetoothSpec[i];
        $5dec73da4f32e22b$var$bluetoothServices.push(spec.serviceUuid);
        $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid] = $5dec73da4f32e22b$var$serviceUuidToInfos[spec.serviceUuid.replace(/-/g, "")] = Object.assign({
            deviceModel: deviceModel
        }, spec);
    }
}
const $5dec73da4f32e22b$export$1f1251c1c71d84cf = ()=>$5dec73da4f32e22b$var$bluetoothServices;
const $5dec73da4f32e22b$export$8c98567a3882f79e = (uuid)=>$5dec73da4f32e22b$var$serviceUuidToInfos[uuid.toLowerCase()];





var $6ZWSX = parcelRequire("6ZWSX");
var $b95dc6f85d7a5443$require$Buffer = $6ZWSX.Buffer;
var $b95dc6f85d7a5443$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $b95dc6f85d7a5443$var$ledgerDevices = [
    {
        vendorId: (0, $5dec73da4f32e22b$export$268c42a4ddec87f3)
    }
];
const $b95dc6f85d7a5443$var$isSupported = ()=>Promise.resolve(!!(window.navigator && window.navigator.hid));
const $b95dc6f85d7a5443$var$getHID = ()=>{
    // $FlowFixMe
    const { hid: hid } = navigator;
    if (!hid) throw new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("navigator.hid is not supported", "HIDNotSupported");
    return hid;
};
function $b95dc6f85d7a5443$var$requestLedgerDevices() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
        const device = yield $b95dc6f85d7a5443$var$getHID().requestDevice({
            filters: $b95dc6f85d7a5443$var$ledgerDevices
        });
        if (Array.isArray(device)) return device;
        return [
            device
        ];
    });
}
function $b95dc6f85d7a5443$var$getLedgerDevices() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
        const devices = yield $b95dc6f85d7a5443$var$getHID().getDevices();
        return devices.filter((d)=>d.vendorId === (0, $5dec73da4f32e22b$export$268c42a4ddec87f3));
    });
}
function $b95dc6f85d7a5443$var$getFirstLedgerDevice() {
    return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
        const existingDevices = yield $b95dc6f85d7a5443$var$getLedgerDevices();
        if (existingDevices.length > 0) return existingDevices[0];
        const devices = yield $b95dc6f85d7a5443$var$requestLedgerDevices();
        return devices[0];
    });
}
/**
 * WebHID Transport implementation
 * @example
 * import TransportWebHID from "@ledgerhq/hw-transport-webhid";
 * ...
 * TransportWebHID.create().then(transport => ...)
 */ class $b95dc6f85d7a5443$var$TransportWebHID extends (0, $375818ecee1623c3$export$2e2bcd8739ae039) {
    constructor(device){
        super();
        this.channel = Math.floor(Math.random() * 0xffff);
        this.packetSize = 64;
        this.inputs = [];
        this.read = ()=>{
            if (this.inputs.length) return Promise.resolve(this.inputs.shift());
            return new Promise((success)=>{
                this.inputCallback = success;
            });
        };
        this.onInputReport = (e)=>{
            const buffer = $b95dc6f85d7a5443$require$Buffer.from(e.data.buffer);
            if (this.inputCallback) {
                this.inputCallback(buffer);
                this.inputCallback = null;
            } else this.inputs.push(buffer);
        };
        this._disconnectEmitted = false;
        this._emitDisconnect = (e)=>{
            if (this._disconnectEmitted) return;
            this._disconnectEmitted = true;
            this.emit("disconnect", e);
        };
        /**
         * Exchange with the device using APDU protocol.
         * @param apdu
         * @returns a promise of apdu response
         */ this.exchange = (apdu)=>$b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
                const b = yield this.exchangeAtomicImpl(()=>$b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
                        const { channel: channel, packetSize: packetSize } = this;
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "=> " + apdu.toString("hex"));
                        const framing = (0, $f6e657627868bf3a$export$2e2bcd8739ae039)(channel, packetSize);
                        // Write...
                        const blocks = framing.makeBlocks(apdu);
                        for(let i = 0; i < blocks.length; i++)yield this.device.sendReport(0, blocks[i]);
                        // Read...
                        let result;
                        let acc;
                        while(!(result = framing.getReducedResult(acc))){
                            const buffer = yield this.read();
                            acc = framing.reduceResponse(acc, buffer);
                        }
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", "<= " + result.toString("hex"));
                        return result;
                    })).catch((e)=>{
                    if (e && e.message && e.message.includes("write")) {
                        this._emitDisconnect(e);
                        throw new (0, $9a194f74559621d2$export$2a60f41a2ed2742)(e.message);
                    }
                    throw e;
                });
                return b;
            });
        this.device = device;
        this.deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
        device.addEventListener("inputreport", this.onInputReport);
    }
    /**
     * Similar to create() except it will always display the device permission (even if some devices are already accepted).
     */ static request() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
            const [device] = yield $b95dc6f85d7a5443$var$requestLedgerDevices();
            return $b95dc6f85d7a5443$var$TransportWebHID.open(device);
        });
    }
    /**
     * Similar to create() except it will never display the device permission (it returns a Promise<?Transport>, null if it fails to find a device).
     */ static openConnected() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
            const devices = yield $b95dc6f85d7a5443$var$getLedgerDevices();
            if (devices.length === 0) return null;
            return $b95dc6f85d7a5443$var$TransportWebHID.open(devices[0]);
        });
    }
    /**
     * Create a Ledger transport with a HIDDevice
     */ static open(device) {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
            yield device.open();
            const transport = new $b95dc6f85d7a5443$var$TransportWebHID(device);
            const onDisconnect = (e)=>{
                if (device === e.device) {
                    $b95dc6f85d7a5443$var$getHID().removeEventListener("disconnect", onDisconnect);
                    transport._emitDisconnect(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
                }
            };
            $b95dc6f85d7a5443$var$getHID().addEventListener("disconnect", onDisconnect);
            return transport;
        });
    }
    /**
     * Release the transport device
     */ close() {
        return $b95dc6f85d7a5443$var$__awaiter(this, void 0, void 0, function*() {
            yield this.exchangeBusyPromise;
            this.device.removeEventListener("inputreport", this.onInputReport);
            yield this.device.close();
        });
    }
    setScrambleKey() {}
}
/**
 * Check if WebUSB transport is supported.
 */ $b95dc6f85d7a5443$var$TransportWebHID.isSupported = $b95dc6f85d7a5443$var$isSupported;
/**
 * List the WebUSB devices that was previously authorized by the user.
 */ $b95dc6f85d7a5443$var$TransportWebHID.list = $b95dc6f85d7a5443$var$getLedgerDevices;
/**
 * Actively listen to WebUSB devices and emit ONE device
 * that was either accepted before, if not it will trigger the native permission UI.
 *
 * Important: it must be called in the context of a UI click!
 */ $b95dc6f85d7a5443$var$TransportWebHID.listen = (observer)=>{
    let unsubscribed = false;
    $b95dc6f85d7a5443$var$getFirstLedgerDevice().then((device)=>{
        if (!device) observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)("Access denied to use Ledger device"));
        else if (!unsubscribed) {
            const deviceModel = typeof device.productId === "number" ? (0, $5dec73da4f32e22b$export$df8f4444a7c73154)(device.productId) : undefined;
            observer.next({
                type: "add",
                descriptor: device,
                deviceModel: deviceModel
            });
            observer.complete();
        }
    }, (error)=>{
        observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
    });
    function unsubscribe() {
        unsubscribed = true;
    }
    return {
        unsubscribe: unsubscribe
    };
};
var $b95dc6f85d7a5443$export$2e2bcd8739ae039 = $b95dc6f85d7a5443$var$TransportWebHID;





/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */ /* global Reflect, Promise, SuppressedError, Symbol, Iterator */ var $5c96a02c592fcff1$var$extendStatics = function(d, b) {
    $5c96a02c592fcff1$var$extendStatics = Object.setPrototypeOf || ({
        __proto__: []
    }) instanceof Array && function(d, b) {
        d.__proto__ = b;
    } || function(d, b) {
        for(var p in b)if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p];
    };
    return $5c96a02c592fcff1$var$extendStatics(d, b);
};
function $5c96a02c592fcff1$export$a8ba968b8961cb8a(d, b) {
    if (typeof b !== "function" && b !== null) throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
    $5c96a02c592fcff1$var$extendStatics(d, b);
    function __() {
        this.constructor = d;
    }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}
var $5c96a02c592fcff1$export$18ce0697a983be9b = function() {
    $5c96a02c592fcff1$export$18ce0697a983be9b = Object.assign || function __assign(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $5c96a02c592fcff1$export$18ce0697a983be9b.apply(this, arguments);
};
function $5c96a02c592fcff1$export$3c9a16f847548506(s, e) {
    var t = {};
    for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function") {
        for(var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++)if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
    }
    return t;
}
function $5c96a02c592fcff1$export$29e00dfd3077644b(decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for(var i = decorators.length - 1; i >= 0; i--)if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
}
function $5c96a02c592fcff1$export$d5ad3fd78186038f(paramIndex, decorator) {
    return function(target, key) {
        decorator(target, key, paramIndex);
    };
}
function $5c96a02c592fcff1$export$3a84e1ae4e97e9b0(ctor, descriptorIn, decorators, contextIn, initializers, extraInitializers) {
    function accept(f) {
        if (f !== void 0 && typeof f !== "function") throw new TypeError("Function expected");
        return f;
    }
    var kind = contextIn.kind, key = kind === "getter" ? "get" : kind === "setter" ? "set" : "value";
    var target = !descriptorIn && ctor ? contextIn["static"] ? ctor : ctor.prototype : null;
    var descriptor = descriptorIn || (target ? Object.getOwnPropertyDescriptor(target, contextIn.name) : {});
    var _, done = false;
    for(var i = decorators.length - 1; i >= 0; i--){
        var context = {};
        for(var p in contextIn)context[p] = p === "access" ? {} : contextIn[p];
        for(var p in contextIn.access)context.access[p] = contextIn.access[p];
        context.addInitializer = function(f) {
            if (done) throw new TypeError("Cannot add initializers after decoration has completed");
            extraInitializers.push(accept(f || null));
        };
        var result = (0, decorators[i])(kind === "accessor" ? {
            get: descriptor.get,
            set: descriptor.set
        } : descriptor[key], context);
        if (kind === "accessor") {
            if (result === void 0) continue;
            if (result === null || typeof result !== "object") throw new TypeError("Object expected");
            if (_ = accept(result.get)) descriptor.get = _;
            if (_ = accept(result.set)) descriptor.set = _;
            if (_ = accept(result.init)) initializers.unshift(_);
        } else if (_ = accept(result)) {
            if (kind === "field") initializers.unshift(_);
            else descriptor[key] = _;
        }
    }
    if (target) Object.defineProperty(target, contextIn.name, descriptor);
    done = true;
}
function $5c96a02c592fcff1$export$d831c04e792af3d(thisArg, initializers, value) {
    var useValue = arguments.length > 2;
    for(var i = 0; i < initializers.length; i++)value = useValue ? initializers[i].call(thisArg, value) : initializers[i].call(thisArg);
    return useValue ? value : void 0;
}
function $5c96a02c592fcff1$export$6a2a36740a146cb8(x) {
    return typeof x === "symbol" ? x : "".concat(x);
}
function $5c96a02c592fcff1$export$d1a06452d3489bc7(f, name, prefix) {
    if (typeof name === "symbol") name = name.description ? "[".concat(name.description, "]") : "";
    return Object.defineProperty(f, "name", {
        configurable: true,
        value: prefix ? "".concat(prefix, " ", name) : name
    });
}
function $5c96a02c592fcff1$export$f1db080c865becb9(metadataKey, metadataValue) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(metadataKey, metadataValue);
}
function $5c96a02c592fcff1$export$1050f835b63b671e(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function $5c96a02c592fcff1$export$67ebef60e6f28a6(thisArg, body) {
    var _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(g && (g = 0, op[0] && (_ = 0)), _)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
var $5c96a02c592fcff1$export$45d3717a4c69092e = Object.create ? function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) desc = {
        enumerable: true,
        get: function() {
            return m[k];
        }
    };
    Object.defineProperty(o, k2, desc);
} : function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
};
function $5c96a02c592fcff1$export$f33643c0debef087(m, o) {
    for(var p in m)if (p !== "default" && !Object.prototype.hasOwnProperty.call(o, p)) $5c96a02c592fcff1$export$45d3717a4c69092e(o, m, p);
}
function $5c96a02c592fcff1$export$19a8beecd37a4c45(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function $5c96a02c592fcff1$export$8d051b38c9118094(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
}
function $5c96a02c592fcff1$export$afc72e2116322959() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($5c96a02c592fcff1$export$8d051b38c9118094(arguments[i]));
    return ar;
}
function $5c96a02c592fcff1$export$6388937ca91ccae8() {
    for(var s = 0, i = 0, il = arguments.length; i < il; i++)s += arguments[i].length;
    for(var r = Array(s), k = 0, i = 0; i < il; i++)for(var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)r[k] = a[j];
    return r;
}
function $5c96a02c592fcff1$export$1216008129fb82ed(to, from, pack) {
    if (pack || arguments.length === 2) {
        for(var i = 0, l = from.length, ar; i < l; i++)if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
}
function $5c96a02c592fcff1$export$10c90e4f7922046c(v) {
    return this instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? (this.v = v, this) : new $5c96a02c592fcff1$export$10c90e4f7922046c(v);
}
function $5c96a02c592fcff1$export$e427f37a30a4de9b(thisArg, _arguments, generator) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var g = generator.apply(thisArg, _arguments || []), i, q = [];
    return i = Object.create((typeof AsyncIterator === "function" ? AsyncIterator : Object).prototype), verb("next"), verb("throw"), verb("return", awaitReturn), i[Symbol.asyncIterator] = function() {
        return this;
    }, i;
    function awaitReturn(f) {
        return function(v) {
            return Promise.resolve(v).then(f, reject);
        };
    }
    function verb(n, f) {
        if (g[n]) {
            i[n] = function(v) {
                return new Promise(function(a, b) {
                    q.push([
                        n,
                        v,
                        a,
                        b
                    ]) > 1 || resume(n, v);
                });
            };
            if (f) i[n] = f(i[n]);
        }
    }
    function resume(n, v) {
        try {
            step(g[n](v));
        } catch (e) {
            settle(q[0][3], e);
        }
    }
    function step(r) {
        r.value instanceof $5c96a02c592fcff1$export$10c90e4f7922046c ? Promise.resolve(r.value.v).then(fulfill, reject) : settle(q[0][2], r);
    }
    function fulfill(value) {
        resume("next", value);
    }
    function reject(value) {
        resume("throw", value);
    }
    function settle(f, v) {
        if (f(v), q.shift(), q.length) resume(q[0][0], q[0][1]);
    }
}
function $5c96a02c592fcff1$export$bbd80228419bb833(o) {
    var i, p;
    return i = {}, verb("next"), verb("throw", function(e) {
        throw e;
    }), verb("return"), i[Symbol.iterator] = function() {
        return this;
    }, i;
    function verb(n, f) {
        i[n] = o[n] ? function(v) {
            return (p = !p) ? {
                value: $5c96a02c592fcff1$export$10c90e4f7922046c(o[n](v)),
                done: false
            } : f ? f(v) : v;
        } : f;
    }
}
function $5c96a02c592fcff1$export$e3b29a3d6162315f(o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof $5c96a02c592fcff1$export$19a8beecd37a4c45 === "function" ? $5c96a02c592fcff1$export$19a8beecd37a4c45(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function() {
        return this;
    }, i);
    function verb(n) {
        i[n] = o[n] && function(v) {
            return new Promise(function(resolve, reject) {
                v = o[n](v), settle(resolve, reject, v.done, v.value);
            });
        };
    }
    function settle(resolve, reject, d, v) {
        Promise.resolve(v).then(function(v) {
            resolve({
                value: v,
                done: d
            });
        }, reject);
    }
}
function $5c96a02c592fcff1$export$4fb47efe1390b86f(cooked, raw) {
    if (Object.defineProperty) Object.defineProperty(cooked, "raw", {
        value: raw
    });
    else cooked.raw = raw;
    return cooked;
}
var $5c96a02c592fcff1$var$__setModuleDefault = Object.create ? function(o, v) {
    Object.defineProperty(o, "default", {
        enumerable: true,
        value: v
    });
} : function(o, v) {
    o["default"] = v;
};
function $5c96a02c592fcff1$export$c21735bcef00d192(mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) {
        for(var k in mod)if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) $5c96a02c592fcff1$export$45d3717a4c69092e(result, mod, k);
    }
    $5c96a02c592fcff1$var$__setModuleDefault(result, mod);
    return result;
}
function $5c96a02c592fcff1$export$da59b14a69baef04(mod) {
    return mod && mod.__esModule ? mod : {
        default: mod
    };
}
function $5c96a02c592fcff1$export$d5dcaf168c640c35(receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
}
function $5c96a02c592fcff1$export$d40a35129aaff81f(receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value), value;
}
function $5c96a02c592fcff1$export$81fdc39f203e4e04(state, receiver) {
    if (receiver === null || typeof receiver !== "object" && typeof receiver !== "function") throw new TypeError("Cannot use 'in' operator on non-object");
    return typeof state === "function" ? receiver === state : state.has(receiver);
}
function $5c96a02c592fcff1$export$88ac25d8e944e405(env, value, async) {
    if (value !== null && value !== void 0) {
        if (typeof value !== "object" && typeof value !== "function") throw new TypeError("Object expected.");
        var dispose, inner;
        if (async) {
            if (!Symbol.asyncDispose) throw new TypeError("Symbol.asyncDispose is not defined.");
            dispose = value[Symbol.asyncDispose];
        }
        if (dispose === void 0) {
            if (!Symbol.dispose) throw new TypeError("Symbol.dispose is not defined.");
            dispose = value[Symbol.dispose];
            if (async) inner = dispose;
        }
        if (typeof dispose !== "function") throw new TypeError("Object not disposable.");
        if (inner) dispose = function() {
            try {
                inner.call(this);
            } catch (e) {
                return Promise.reject(e);
            }
        };
        env.stack.push({
            value: value,
            dispose: dispose,
            async: async
        });
    } else if (async) env.stack.push({
        async: true
    });
    return value;
}
var $5c96a02c592fcff1$var$_SuppressedError = typeof SuppressedError === "function" ? SuppressedError : function(error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};
function $5c96a02c592fcff1$export$8f076105dc360e92(env) {
    function fail(e) {
        env.error = env.hasError ? new $5c96a02c592fcff1$var$_SuppressedError(e, env.error, "An error was suppressed during disposal.") : e;
        env.hasError = true;
    }
    var r, s = 0;
    function next() {
        while(r = env.stack.pop())try {
            if (!r.async && s === 1) return s = 0, env.stack.push(r), Promise.resolve().then(next);
            if (r.dispose) {
                var result = r.dispose.call(r.value);
                if (r.async) return s |= 2, Promise.resolve(result).then(next, function(e) {
                    fail(e);
                    return next();
                });
            } else s |= 1;
        } catch (e) {
            fail(e);
        }
        if (s === 1) return env.hasError ? Promise.reject(env.error) : Promise.resolve();
        if (env.hasError) throw env.error;
    }
    return next();
}
function $5c96a02c592fcff1$export$889dfb5d17574b0b(path, preserveJsx) {
    if (typeof path === "string" && /^\.\.?\//.test(path)) return path.replace(/\.(tsx)$|((?:\.d)?)((?:\.[^./]+?)?)\.([cm]?)ts$/i, function(m, tsx, d, ext, cm) {
        return tsx ? preserveJsx ? ".jsx" : ".js" : d && (!ext || !cm) ? m : d + ext + "." + cm.toLowerCase() + "js";
    });
    return path;
}
var $5c96a02c592fcff1$export$2e2bcd8739ae039 = {
    __extends: $5c96a02c592fcff1$export$a8ba968b8961cb8a,
    __assign: $5c96a02c592fcff1$export$18ce0697a983be9b,
    __rest: $5c96a02c592fcff1$export$3c9a16f847548506,
    __decorate: $5c96a02c592fcff1$export$29e00dfd3077644b,
    __param: $5c96a02c592fcff1$export$d5ad3fd78186038f,
    __esDecorate: $5c96a02c592fcff1$export$3a84e1ae4e97e9b0,
    __runInitializers: $5c96a02c592fcff1$export$d831c04e792af3d,
    __propKey: $5c96a02c592fcff1$export$6a2a36740a146cb8,
    __setFunctionName: $5c96a02c592fcff1$export$d1a06452d3489bc7,
    __metadata: $5c96a02c592fcff1$export$f1db080c865becb9,
    __awaiter: $5c96a02c592fcff1$export$1050f835b63b671e,
    __generator: $5c96a02c592fcff1$export$67ebef60e6f28a6,
    __createBinding: $5c96a02c592fcff1$export$45d3717a4c69092e,
    __exportStar: $5c96a02c592fcff1$export$f33643c0debef087,
    __values: $5c96a02c592fcff1$export$19a8beecd37a4c45,
    __read: $5c96a02c592fcff1$export$8d051b38c9118094,
    __spread: $5c96a02c592fcff1$export$afc72e2116322959,
    __spreadArrays: $5c96a02c592fcff1$export$6388937ca91ccae8,
    __spreadArray: $5c96a02c592fcff1$export$1216008129fb82ed,
    __await: $5c96a02c592fcff1$export$10c90e4f7922046c,
    __asyncGenerator: $5c96a02c592fcff1$export$e427f37a30a4de9b,
    __asyncDelegator: $5c96a02c592fcff1$export$bbd80228419bb833,
    __asyncValues: $5c96a02c592fcff1$export$e3b29a3d6162315f,
    __makeTemplateObject: $5c96a02c592fcff1$export$4fb47efe1390b86f,
    __importStar: $5c96a02c592fcff1$export$c21735bcef00d192,
    __importDefault: $5c96a02c592fcff1$export$da59b14a69baef04,
    __classPrivateFieldGet: $5c96a02c592fcff1$export$d5dcaf168c640c35,
    __classPrivateFieldSet: $5c96a02c592fcff1$export$d40a35129aaff81f,
    __classPrivateFieldIn: $5c96a02c592fcff1$export$81fdc39f203e4e04,
    __addDisposableResource: $5c96a02c592fcff1$export$88ac25d8e944e405,
    __disposeResources: $5c96a02c592fcff1$export$8f076105dc360e92,
    __rewriteRelativeImportExtension: $5c96a02c592fcff1$export$889dfb5d17574b0b
};


function $c1aa42b0603892d6$export$f6e2535fb5126e54(value) {
    return typeof value === "function";
}




function $ebe567a061bc80f6$export$128a15b65d1b6041(createImpl) {
    var _super = function(instance) {
        Error.call(instance);
        instance.stack = new Error().stack;
    };
    var ctorFunc = createImpl(_super);
    ctorFunc.prototype = Object.create(Error.prototype);
    ctorFunc.prototype.constructor = ctorFunc;
    return ctorFunc;
}


var $f587043ffd615a90$export$c9648b76fd580c34 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function UnsubscriptionErrorImpl(errors) {
        _super(this);
        this.message = errors ? errors.length + " errors occurred during unsubscription:\n" + errors.map(function(err, i) {
            return i + 1 + ") " + err.toString();
        }).join("\n  ") : "";
        this.name = "UnsubscriptionError";
        this.errors = errors;
    };
});


function $2b94c03d07e501cc$export$dae3f38077fc36c0(arr, item) {
    if (arr) {
        var index = arr.indexOf(item);
        0 <= index && arr.splice(index, 1);
    }
}


var $8343668acd7c4a9b$export$f55210826850c514 = function() {
    function Subscription(initialTeardown) {
        this.initialTeardown = initialTeardown;
        this.closed = false;
        this._parentage = null;
        this._finalizers = null;
    }
    Subscription.prototype.unsubscribe = function() {
        var e_1, _a, e_2, _b;
        var errors;
        if (!this.closed) {
            this.closed = true;
            var _parentage = this._parentage;
            if (_parentage) {
                this._parentage = null;
                if (Array.isArray(_parentage)) try {
                    for(var _parentage_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_parentage), _parentage_1_1 = _parentage_1.next(); !_parentage_1_1.done; _parentage_1_1 = _parentage_1.next()){
                        var parent_1 = _parentage_1_1.value;
                        parent_1.remove(this);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_parentage_1_1 && !_parentage_1_1.done && (_a = _parentage_1.return)) _a.call(_parentage_1);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
                else _parentage.remove(this);
            }
            var initialFinalizer = this.initialTeardown;
            if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(initialFinalizer)) try {
                initialFinalizer();
            } catch (e) {
                errors = e instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34) ? e.errors : [
                    e
                ];
            }
            var _finalizers = this._finalizers;
            if (_finalizers) {
                this._finalizers = null;
                try {
                    for(var _finalizers_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_finalizers), _finalizers_1_1 = _finalizers_1.next(); !_finalizers_1_1.done; _finalizers_1_1 = _finalizers_1.next()){
                        var finalizer = _finalizers_1_1.value;
                        try {
                            $8343668acd7c4a9b$var$execFinalizer(finalizer);
                        } catch (err) {
                            errors = errors !== null && errors !== void 0 ? errors : [];
                            if (err instanceof (0, $f587043ffd615a90$export$c9648b76fd580c34)) errors = (0, $5c96a02c592fcff1$export$1216008129fb82ed)((0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(errors)), (0, $5c96a02c592fcff1$export$8d051b38c9118094)(err.errors));
                            else errors.push(err);
                        }
                    }
                } catch (e_2_1) {
                    e_2 = {
                        error: e_2_1
                    };
                } finally{
                    try {
                        if (_finalizers_1_1 && !_finalizers_1_1.done && (_b = _finalizers_1.return)) _b.call(_finalizers_1);
                    } finally{
                        if (e_2) throw e_2.error;
                    }
                }
            }
            if (errors) throw new (0, $f587043ffd615a90$export$c9648b76fd580c34)(errors);
        }
    };
    Subscription.prototype.add = function(teardown) {
        var _a;
        if (teardown && teardown !== this) {
            if (this.closed) $8343668acd7c4a9b$var$execFinalizer(teardown);
            else {
                if (teardown instanceof Subscription) {
                    if (teardown.closed || teardown._hasParent(this)) return;
                    teardown._addParent(this);
                }
                (this._finalizers = (_a = this._finalizers) !== null && _a !== void 0 ? _a : []).push(teardown);
            }
        }
    };
    Subscription.prototype._hasParent = function(parent) {
        var _parentage = this._parentage;
        return _parentage === parent || Array.isArray(_parentage) && _parentage.includes(parent);
    };
    Subscription.prototype._addParent = function(parent) {
        var _parentage = this._parentage;
        this._parentage = Array.isArray(_parentage) ? (_parentage.push(parent), _parentage) : _parentage ? [
            _parentage,
            parent
        ] : parent;
    };
    Subscription.prototype._removeParent = function(parent) {
        var _parentage = this._parentage;
        if (_parentage === parent) this._parentage = null;
        else if (Array.isArray(_parentage)) (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_parentage, parent);
    };
    Subscription.prototype.remove = function(teardown) {
        var _finalizers = this._finalizers;
        _finalizers && (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(_finalizers, teardown);
        if (teardown instanceof Subscription) teardown._removeParent(this);
    };
    Subscription.EMPTY = function() {
        var empty = new Subscription();
        empty.closed = true;
        return empty;
    }();
    return Subscription;
}();
var $8343668acd7c4a9b$export$610f9c3ca1a38dd8 = $8343668acd7c4a9b$export$f55210826850c514.EMPTY;
function $8343668acd7c4a9b$export$4f9221cbada3c4fc(value) {
    return value instanceof $8343668acd7c4a9b$export$f55210826850c514 || value && "closed" in value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.remove) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.add) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.unsubscribe);
}
function $8343668acd7c4a9b$var$execFinalizer(finalizer) {
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(finalizer)) finalizer();
    else finalizer.unsubscribe();
}


var $ca336efb1b4fb564$export$e506a1d27d1eaa20 = {
    onUnhandledError: null,
    onStoppedNotification: null,
    Promise: undefined,
    useDeprecatedSynchronousErrorHandling: false,
    useDeprecatedNextContext: false
};




var $c07b5bfa3b9d4401$export$365aa6bd3c788e3d = {
    setTimeout: function(handler, timeout) {
        var args = [];
        for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        if (delegate === null || delegate === void 0 ? void 0 : delegate.setTimeout) return delegate.setTimeout.apply(delegate, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
        return setTimeout.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([
            handler,
            timeout
        ], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)));
    },
    clearTimeout: function(handle) {
        var delegate = $c07b5bfa3b9d4401$export$365aa6bd3c788e3d.delegate;
        return ((delegate === null || delegate === void 0 ? void 0 : delegate.clearTimeout) || clearTimeout)(handle);
    },
    delegate: undefined
};


function $18eb28ff53cc4943$export$ebf645db02d3e99f(err) {
    (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        var onUnhandledError = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onUnhandledError;
        if (onUnhandledError) onUnhandledError(err);
        else throw err;
    });
}


function $528e75db69787807$export$8793edee2d425525() {}


var $0ba077a4cdfd9739$export$b7f97edb34bc1f87 = function() {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("C", undefined, undefined);
}();
function $0ba077a4cdfd9739$export$dd472c3d8fe5a85a(error) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("E", undefined, error);
}
function $0ba077a4cdfd9739$export$ff9346b0d1d30313(value) {
    return $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3("N", value, undefined);
}
function $0ba077a4cdfd9739$export$9c8f6e8d39c60cf3(kind, value, error) {
    return {
        kind: kind,
        value: value,
        error: error
    };
}




var $92213d3dd6a83b5d$var$context = null;
function $92213d3dd6a83b5d$export$d974811edc77eafa(cb) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) {
        var isRoot = !$92213d3dd6a83b5d$var$context;
        if (isRoot) $92213d3dd6a83b5d$var$context = {
            errorThrown: false,
            error: null
        };
        cb();
        if (isRoot) {
            var _a = $92213d3dd6a83b5d$var$context, errorThrown = _a.errorThrown, error = _a.error;
            $92213d3dd6a83b5d$var$context = null;
            if (errorThrown) throw error;
        }
    } else cb();
}
function $92213d3dd6a83b5d$export$3e205fbb5df021e0(err) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling && $92213d3dd6a83b5d$var$context) {
        $92213d3dd6a83b5d$var$context.errorThrown = true;
        $92213d3dd6a83b5d$var$context.error = err;
    }
}


var $cf8ce74b80455e9f$export$60959659b2c22881 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subscriber, _super);
    function Subscriber(destination) {
        var _this = _super.call(this) || this;
        _this.isStopped = false;
        if (destination) {
            _this.destination = destination;
            if ((0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(destination)) destination.add(_this);
        } else _this.destination = $cf8ce74b80455e9f$export$88d395d20619a0af;
        return _this;
    }
    Subscriber.create = function(next, error, complete) {
        return new $cf8ce74b80455e9f$export$94eeb6a328cab6c7(next, error, complete);
    };
    Subscriber.prototype.next = function(value) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$ff9346b0d1d30313)(value), this);
        else this._next(value);
    };
    Subscriber.prototype.error = function(err) {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$dd472c3d8fe5a85a)(err), this);
        else {
            this.isStopped = true;
            this._error(err);
        }
    };
    Subscriber.prototype.complete = function() {
        if (this.isStopped) $cf8ce74b80455e9f$var$handleStoppedNotification((0, $0ba077a4cdfd9739$export$b7f97edb34bc1f87), this);
        else {
            this.isStopped = true;
            this._complete();
        }
    };
    Subscriber.prototype.unsubscribe = function() {
        if (!this.closed) {
            this.isStopped = true;
            _super.prototype.unsubscribe.call(this);
            this.destination = null;
        }
    };
    Subscriber.prototype._next = function(value) {
        this.destination.next(value);
    };
    Subscriber.prototype._error = function(err) {
        try {
            this.destination.error(err);
        } finally{
            this.unsubscribe();
        }
    };
    Subscriber.prototype._complete = function() {
        try {
            this.destination.complete();
        } finally{
            this.unsubscribe();
        }
    };
    return Subscriber;
}((0, $8343668acd7c4a9b$export$f55210826850c514));
var $cf8ce74b80455e9f$var$_bind = Function.prototype.bind;
function $cf8ce74b80455e9f$var$bind(fn, thisArg) {
    return $cf8ce74b80455e9f$var$_bind.call(fn, thisArg);
}
var $cf8ce74b80455e9f$var$ConsumerObserver = function() {
    function ConsumerObserver(partialObserver) {
        this.partialObserver = partialObserver;
    }
    ConsumerObserver.prototype.next = function(value) {
        var partialObserver = this.partialObserver;
        if (partialObserver.next) try {
            partialObserver.next(value);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    ConsumerObserver.prototype.error = function(err) {
        var partialObserver = this.partialObserver;
        if (partialObserver.error) try {
            partialObserver.error(err);
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
        else $cf8ce74b80455e9f$var$handleUnhandledError(err);
    };
    ConsumerObserver.prototype.complete = function() {
        var partialObserver = this.partialObserver;
        if (partialObserver.complete) try {
            partialObserver.complete();
        } catch (error) {
            $cf8ce74b80455e9f$var$handleUnhandledError(error);
        }
    };
    return ConsumerObserver;
}();
var $cf8ce74b80455e9f$export$94eeb6a328cab6c7 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(SafeSubscriber, _super);
    function SafeSubscriber(observerOrNext, error, complete) {
        var _this = _super.call(this) || this;
        var partialObserver;
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || !observerOrNext) partialObserver = {
            next: observerOrNext !== null && observerOrNext !== void 0 ? observerOrNext : undefined,
            error: error !== null && error !== void 0 ? error : undefined,
            complete: complete !== null && complete !== void 0 ? complete : undefined
        };
        else {
            var context_1;
            if (_this && (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedNextContext) {
                context_1 = Object.create(observerOrNext);
                context_1.unsubscribe = function() {
                    return _this.unsubscribe();
                };
                partialObserver = {
                    next: observerOrNext.next && $cf8ce74b80455e9f$var$bind(observerOrNext.next, context_1),
                    error: observerOrNext.error && $cf8ce74b80455e9f$var$bind(observerOrNext.error, context_1),
                    complete: observerOrNext.complete && $cf8ce74b80455e9f$var$bind(observerOrNext.complete, context_1)
                };
            } else partialObserver = observerOrNext;
        }
        _this.destination = new $cf8ce74b80455e9f$var$ConsumerObserver(partialObserver);
        return _this;
    }
    return SafeSubscriber;
}($cf8ce74b80455e9f$export$60959659b2c22881);
function $cf8ce74b80455e9f$var$handleUnhandledError(error) {
    if ((0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).useDeprecatedSynchronousErrorHandling) (0, $92213d3dd6a83b5d$export$3e205fbb5df021e0)(error);
    else (0, $18eb28ff53cc4943$export$ebf645db02d3e99f)(error);
}
function $cf8ce74b80455e9f$var$defaultErrorHandler(err) {
    throw err;
}
function $cf8ce74b80455e9f$var$handleStoppedNotification(notification, subscriber) {
    var onStoppedNotification = (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).onStoppedNotification;
    onStoppedNotification && (0, $c07b5bfa3b9d4401$export$365aa6bd3c788e3d).setTimeout(function() {
        return onStoppedNotification(notification, subscriber);
    });
}
var $cf8ce74b80455e9f$export$88d395d20619a0af = {
    closed: true,
    next: (0, $528e75db69787807$export$8793edee2d425525),
    error: $cf8ce74b80455e9f$var$defaultErrorHandler,
    complete: (0, $528e75db69787807$export$8793edee2d425525)
};



var $eaf29fccbded6ed3$export$5ab46cbf6120b33a = function() {
    return typeof Symbol === "function" && Symbol.observable || "@@observable";
}();


function $7569c528cdd9d182$export$f0954fd7d5368655(x) {
    return x;
}


function $0f1e8e2d1fe93adf$export$a4627e546088548d() {
    var fns = [];
    for(var _i = 0; _i < arguments.length; _i++)fns[_i] = arguments[_i];
    return $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns);
}
function $0f1e8e2d1fe93adf$export$71f88a61afaa14d7(fns) {
    if (fns.length === 0) return 0, $7569c528cdd9d182$export$f0954fd7d5368655;
    if (fns.length === 1) return fns[0];
    return function piped(input) {
        return fns.reduce(function(prev, fn) {
            return fn(prev);
        }, input);
    };
}





var $4f562137a990678a$export$77cea355fa80b5f4 = function() {
    function Observable(subscribe) {
        if (subscribe) this._subscribe = subscribe;
    }
    Observable.prototype.lift = function(operator) {
        var observable = new Observable();
        observable.source = this;
        observable.operator = operator;
        return observable;
    };
    Observable.prototype.subscribe = function(observerOrNext, error, complete) {
        var _this = this;
        var subscriber = $4f562137a990678a$var$isSubscriber(observerOrNext) ? observerOrNext : new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)(observerOrNext, error, complete);
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var _a = _this, operator = _a.operator, source = _a.source;
            subscriber.add(operator ? operator.call(subscriber, source) : source ? _this._subscribe(subscriber) : _this._trySubscribe(subscriber));
        });
        return subscriber;
    };
    Observable.prototype._trySubscribe = function(sink) {
        try {
            return this._subscribe(sink);
        } catch (err) {
            sink.error(err);
        }
    };
    Observable.prototype.forEach = function(next, promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                next: function(value) {
                    try {
                        next(value);
                    } catch (err) {
                        reject(err);
                        subscriber.unsubscribe();
                    }
                },
                error: reject,
                complete: resolve
            });
            _this.subscribe(subscriber);
        });
    };
    Observable.prototype._subscribe = function(subscriber) {
        var _a;
        return (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber);
    };
    Observable.prototype[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a] = function() {
        return this;
    };
    Observable.prototype.pipe = function() {
        var operations = [];
        for(var _i = 0; _i < arguments.length; _i++)operations[_i] = arguments[_i];
        return (0, $0f1e8e2d1fe93adf$export$71f88a61afaa14d7)(operations)(this);
    };
    Observable.prototype.toPromise = function(promiseCtor) {
        var _this = this;
        promiseCtor = $4f562137a990678a$var$getPromiseCtor(promiseCtor);
        return new promiseCtor(function(resolve, reject) {
            var value;
            _this.subscribe(function(x) {
                return value = x;
            }, function(err) {
                return reject(err);
            }, function() {
                return resolve(value);
            });
        });
    };
    Observable.create = function(subscribe) {
        return new Observable(subscribe);
    };
    return Observable;
}();
function $4f562137a990678a$var$getPromiseCtor(promiseCtor) {
    var _a;
    return (_a = promiseCtor !== null && promiseCtor !== void 0 ? promiseCtor : (0, $ca336efb1b4fb564$export$e506a1d27d1eaa20).Promise) !== null && _a !== void 0 ? _a : Promise;
}
function $4f562137a990678a$var$isObserver(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.next) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.error) && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.complete);
}
function $4f562137a990678a$var$isSubscriber(value) {
    return value && value instanceof (0, $cf8ce74b80455e9f$export$60959659b2c22881) || $4f562137a990678a$var$isObserver(value) && (0, $8343668acd7c4a9b$export$4f9221cbada3c4fc)(value);
}




var $6ZWSX = parcelRequire("6ZWSX");
var $0f9aba74d280b54b$require$Buffer = $6ZWSX.Buffer;
var $0f9aba74d280b54b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $0f9aba74d280b54b$var$TagId = 0x05;
/**
 * Creates a list of chunked buffer from one buffer
 *
 * If this is using a Node buffer: the chunked buffers reference to the same memory as the original buffer.
 * If this is using a Uint8Array: each part of the original buffer is copied into the chunked buffers
 *
 * @param buffer a Node Buffer, or a Uint8Array
 * @param sizeForIndex A function that takes an index (on the buffer) and returns the size of the chunk at that index
 * @returns a list of chunked buffers
 */ function $0f9aba74d280b54b$var$createChunkedBuffers(buffer, sizeForIndex) {
    const chunks = [];
    for(let i = 0, size = sizeForIndex(0); i < buffer.length; i += size, size = sizeForIndex(i))// If this is a Node buffer: this chunked buffer points to the same memory but with cropped starting and ending indices
    // `slice` and not `subarray`: this might not be a Node Buffer, but probably only a Uint8Array.
    chunks.push(buffer.slice(i, i + size));
    return chunks;
}
const $0f9aba74d280b54b$export$8f132f30db3d0b13 = (write, apdu, mtuSize, { context: context } = {})=>{
    // Prepares the data to be sent in chunks, by adding a header to chunked of the APDU
    // The first chunk will contain the total length of the APDU, which reduces the size of the data written in the first chunk.
    // The total length of the APDU is encoded in 2 bytes (so 5 bytes for the header with the tag id and the chunk index).
    const chunks = $0f9aba74d280b54b$var$createChunkedBuffers(apdu, (i)=>mtuSize - (i === 0 ? 5 : 3)).map((buffer, i)=>{
        const head = $0f9aba74d280b54b$require$Buffer.alloc(i === 0 ? 5 : 3);
        head.writeUInt8($0f9aba74d280b54b$var$TagId, 0);
        // Index of the chunk as the 2 next bytes
        head.writeUInt16BE(i, 1);
        // The total length of the APDU is written on the first chunk
        if (i === 0) head.writeUInt16BE(apdu.length, 3);
        // No 0-padding is needed
        return $0f9aba74d280b54b$require$Buffer.concat([
            head,
            buffer
        ]);
    });
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)((o)=>{
        let terminated = false;
        function main() {
            return $0f9aba74d280b54b$var$__awaiter(this, void 0, void 0, function*() {
                for (const chunk of chunks){
                    if (terminated) return;
                    yield write(chunk);
                }
            });
        }
        main().then(()=>{
            terminated = true;
            o.complete();
        }, (error)=>{
            terminated = true;
            (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                type: "ble-error",
                message: `sendAPDU failure: ${error}`,
                data: {
                    error: error
                },
                context: context
            });
            o.error(error);
        });
        const unsubscribe = ()=>{
            if (!terminated) {
                (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                    type: "ble-error",
                    message: "sendAPDU interruption",
                    context: context
                });
                terminated = true;
            }
        };
        return unsubscribe;
    });
};








var $43504509ae7aa03d$export$f708eee25634bc80 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function ObjectUnsubscribedErrorImpl() {
        _super(this);
        this.name = "ObjectUnsubscribedError";
        this.message = "object unsubscribed";
    };
});




var $2d63f5ffe6ca8602$export$b6bbab5a9b109038 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(Subject, _super);
    function Subject() {
        var _this = _super.call(this) || this;
        _this.closed = false;
        _this.currentObservers = null;
        _this.observers = [];
        _this.isStopped = false;
        _this.hasError = false;
        _this.thrownError = null;
        return _this;
    }
    Subject.prototype.lift = function(operator) {
        var subject = new $2d63f5ffe6ca8602$export$155189cde295587d(this, this);
        subject.operator = operator;
        return subject;
    };
    Subject.prototype._throwIfClosed = function() {
        if (this.closed) throw new (0, $43504509ae7aa03d$export$f708eee25634bc80)();
    };
    Subject.prototype.next = function(value) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            var e_1, _a;
            _this._throwIfClosed();
            if (!_this.isStopped) {
                if (!_this.currentObservers) _this.currentObservers = Array.from(_this.observers);
                try {
                    for(var _b = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(_this.currentObservers), _c = _b.next(); !_c.done; _c = _b.next()){
                        var observer = _c.value;
                        observer.next(value);
                    }
                } catch (e_1_1) {
                    e_1 = {
                        error: e_1_1
                    };
                } finally{
                    try {
                        if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                    } finally{
                        if (e_1) throw e_1.error;
                    }
                }
            }
        });
    };
    Subject.prototype.error = function(err) {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.hasError = _this.isStopped = true;
                _this.thrownError = err;
                var observers = _this.observers;
                while(observers.length)observers.shift().error(err);
            }
        });
    };
    Subject.prototype.complete = function() {
        var _this = this;
        (0, $92213d3dd6a83b5d$export$d974811edc77eafa)(function() {
            _this._throwIfClosed();
            if (!_this.isStopped) {
                _this.isStopped = true;
                var observers = _this.observers;
                while(observers.length)observers.shift().complete();
            }
        });
    };
    Subject.prototype.unsubscribe = function() {
        this.isStopped = this.closed = true;
        this.observers = this.currentObservers = null;
    };
    Object.defineProperty(Subject.prototype, "observed", {
        get: function() {
            var _a;
            return ((_a = this.observers) === null || _a === void 0 ? void 0 : _a.length) > 0;
        },
        enumerable: false,
        configurable: true
    });
    Subject.prototype._trySubscribe = function(subscriber) {
        this._throwIfClosed();
        return _super.prototype._trySubscribe.call(this, subscriber);
    };
    Subject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._checkFinalizedStatuses(subscriber);
        return this._innerSubscribe(subscriber);
    };
    Subject.prototype._innerSubscribe = function(subscriber) {
        var _this = this;
        var _a = this, hasError = _a.hasError, isStopped = _a.isStopped, observers = _a.observers;
        if (hasError || isStopped) return 0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8;
        this.currentObservers = null;
        observers.push(subscriber);
        return new (0, $8343668acd7c4a9b$export$f55210826850c514)(function() {
            _this.currentObservers = null;
            (0, $2b94c03d07e501cc$export$dae3f38077fc36c0)(observers, subscriber);
        });
    };
    Subject.prototype._checkFinalizedStatuses = function(subscriber) {
        var _a = this, hasError = _a.hasError, thrownError = _a.thrownError, isStopped = _a.isStopped;
        if (hasError) subscriber.error(thrownError);
        else if (isStopped) subscriber.complete();
    };
    Subject.prototype.asObservable = function() {
        var observable = new (0, $4f562137a990678a$export$77cea355fa80b5f4)();
        observable.source = this;
        return observable;
    };
    Subject.create = function(destination, source) {
        return new $2d63f5ffe6ca8602$export$155189cde295587d(destination, source);
    };
    return Subject;
}((0, $4f562137a990678a$export$77cea355fa80b5f4));
var $2d63f5ffe6ca8602$export$155189cde295587d = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(AnonymousSubject, _super);
    function AnonymousSubject(destination, source) {
        var _this = _super.call(this) || this;
        _this.destination = destination;
        _this.source = source;
        return _this;
    }
    AnonymousSubject.prototype.next = function(value) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.next) === null || _b === void 0 || _b.call(_a, value);
    };
    AnonymousSubject.prototype.error = function(err) {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.error) === null || _b === void 0 || _b.call(_a, err);
    };
    AnonymousSubject.prototype.complete = function() {
        var _a, _b;
        (_b = (_a = this.destination) === null || _a === void 0 ? void 0 : _a.complete) === null || _b === void 0 || _b.call(_a);
    };
    AnonymousSubject.prototype._subscribe = function(subscriber) {
        var _a, _b;
        return (_b = (_a = this.source) === null || _a === void 0 ? void 0 : _a.subscribe(subscriber)) !== null && _b !== void 0 ? _b : (0, $8343668acd7c4a9b$export$610f9c3ca1a38dd8);
    };
    return AnonymousSubject;
}($2d63f5ffe6ca8602$export$b6bbab5a9b109038);


var $94bcb2181a19339b$export$c1895ea2d519a677 = {
    now: function() {
        return ($94bcb2181a19339b$export$c1895ea2d519a677.delegate || Date).now();
    },
    delegate: undefined
};


var $4a1890c700519557$export$915d2682b0aa0991 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(ReplaySubject, _super);
    function ReplaySubject(_bufferSize, _windowTime, _timestampProvider) {
        if (_bufferSize === void 0) _bufferSize = Infinity;
        if (_windowTime === void 0) _windowTime = Infinity;
        if (_timestampProvider === void 0) _timestampProvider = (0, $94bcb2181a19339b$export$c1895ea2d519a677);
        var _this = _super.call(this) || this;
        _this._bufferSize = _bufferSize;
        _this._windowTime = _windowTime;
        _this._timestampProvider = _timestampProvider;
        _this._buffer = [];
        _this._infiniteTimeWindow = true;
        _this._infiniteTimeWindow = _windowTime === Infinity;
        _this._bufferSize = Math.max(1, _bufferSize);
        _this._windowTime = Math.max(1, _windowTime);
        return _this;
    }
    ReplaySubject.prototype.next = function(value) {
        var _a = this, isStopped = _a.isStopped, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow, _timestampProvider = _a._timestampProvider, _windowTime = _a._windowTime;
        if (!isStopped) {
            _buffer.push(value);
            !_infiniteTimeWindow && _buffer.push(_timestampProvider.now() + _windowTime);
        }
        this._trimBuffer();
        _super.prototype.next.call(this, value);
    };
    ReplaySubject.prototype._subscribe = function(subscriber) {
        this._throwIfClosed();
        this._trimBuffer();
        var subscription = this._innerSubscribe(subscriber);
        var _a = this, _infiniteTimeWindow = _a._infiniteTimeWindow, _buffer = _a._buffer;
        var copy = _buffer.slice();
        for(var i = 0; i < copy.length && !subscriber.closed; i += _infiniteTimeWindow ? 1 : 2)subscriber.next(copy[i]);
        this._checkFinalizedStatuses(subscriber);
        return subscription;
    };
    ReplaySubject.prototype._trimBuffer = function() {
        var _a = this, _bufferSize = _a._bufferSize, _timestampProvider = _a._timestampProvider, _buffer = _a._buffer, _infiniteTimeWindow = _a._infiniteTimeWindow;
        var adjustedBufferSize = (_infiniteTimeWindow ? 1 : 2) * _bufferSize;
        _bufferSize < Infinity && adjustedBufferSize < _buffer.length && _buffer.splice(0, _buffer.length - adjustedBufferSize);
        if (!_infiniteTimeWindow) {
            var now = _timestampProvider.now();
            var last = 0;
            for(var i = 1; i < _buffer.length && _buffer[i] <= now; i += 2)last = i;
            last && _buffer.splice(0, last + 1);
        }
    };
    return ReplaySubject;
}((0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038));


function $992c4a42843eb1d0$export$ebec8610810318c5(source) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(source === null || source === void 0 ? void 0 : source.lift);
}
function $992c4a42843eb1d0$export$871731df685d7753(init) {
    return function(source) {
        if ($992c4a42843eb1d0$export$ebec8610810318c5(source)) return source.lift(function(liftedSource) {
            try {
                return init(liftedSource, this);
            } catch (err) {
                this.error(err);
            }
        });
        throw new TypeError("Unable to lift unknown Observable type");
    };
}




function $3868f035248205c1$export$b9e075132cc6937f(destination, onNext, onComplete, onError, onFinalize) {
    return new $3868f035248205c1$export$8fbbf0c4d80268e5(destination, onNext, onComplete, onError, onFinalize);
}
var $3868f035248205c1$export$8fbbf0c4d80268e5 = function(_super) {
    (0, $5c96a02c592fcff1$export$a8ba968b8961cb8a)(OperatorSubscriber, _super);
    function OperatorSubscriber(destination, onNext, onComplete, onError, onFinalize, shouldUnsubscribe) {
        var _this = _super.call(this, destination) || this;
        _this.onFinalize = onFinalize;
        _this.shouldUnsubscribe = shouldUnsubscribe;
        _this._next = onNext ? function(value) {
            try {
                onNext(value);
            } catch (err) {
                destination.error(err);
            }
        } : _super.prototype._next;
        _this._error = onError ? function(err) {
            try {
                onError(err);
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._error;
        _this._complete = onComplete ? function() {
            try {
                onComplete();
            } catch (err) {
                destination.error(err);
            } finally{
                this.unsubscribe();
            }
        } : _super.prototype._complete;
        return _this;
    }
    OperatorSubscriber.prototype.unsubscribe = function() {
        var _a;
        if (!this.shouldUnsubscribe || this.shouldUnsubscribe()) {
            var closed_1 = this.closed;
            _super.prototype.unsubscribe.call(this);
            !closed_1 && ((_a = this.onFinalize) === null || _a === void 0 || _a.call(this));
        }
    };
    return OperatorSubscriber;
}((0, $cf8ce74b80455e9f$export$60959659b2c22881));



var $8821cb8787de9fb5$export$1e2f57719e155213 = function(x) {
    return x && typeof x.length === "number" && typeof x !== "function";
};



function $9dcf7896928e75dd$export$4369c812aac99591(value) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value === null || value === void 0 ? void 0 : value.then);
}





function $0539b51af1903d0a$export$48c0cddbc99c45c2(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]);
}



function $7c74d6a5e2273447$export$edb10ab8dd75a915(obj) {
    return Symbol.asyncIterator && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj[Symbol.asyncIterator]);
}


function $d63b3f5b704e6de4$export$7cbe71b9fa263484(input) {
    return new TypeError("You provided " + (input !== null && typeof input === "object" ? "an invalid object" : "'" + input + "'") + " where a stream was expected. You can provide an Observable, Promise, ReadableStream, Array, AsyncIterable, or Iterable.");
}


function $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8() {
    if (typeof Symbol !== "function" || !Symbol.iterator) return "@@iterator";
    return Symbol.iterator;
}
var $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d = $0b89b4d4fb8bd3fd$export$aa9956be4ae4fe8();



function $b8a13650b96f19ab$export$9652023d9040757(input) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(input === null || input === void 0 ? void 0 : input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]);
}




function $54b99b9095e84ce4$export$cf4785e597badab3(readableStream) {
    return (0, $5c96a02c592fcff1$export$e427f37a30a4de9b)(this, arguments, function readableStreamLikeToAsyncGenerator_1() {
        var reader, _a, value, done;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    reader = readableStream.getReader();
                    _b.label = 1;
                case 1:
                    _b.trys.push([
                        1,
                        ,
                        9,
                        10
                    ]);
                    _b.label = 2;
                case 2:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(reader.read())
                    ];
                case 3:
                    _a = _b.sent(), value = _a.value, done = _a.done;
                    if (!done) return [
                        3,
                        5
                    ];
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(void 0)
                    ];
                case 4:
                    return [
                        2,
                        _b.sent()
                    ];
                case 5:
                    return [
                        4,
                        (0, $5c96a02c592fcff1$export$10c90e4f7922046c)(value)
                    ];
                case 6:
                    return [
                        4,
                        _b.sent()
                    ];
                case 7:
                    _b.sent();
                    return [
                        3,
                        2
                    ];
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    reader.releaseLock();
                    return [
                        7
                    ];
                case 10:
                    return [
                        2
                    ];
            }
        });
    });
}
function $54b99b9095e84ce4$export$c088ffafdba7405f(obj) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obj === null || obj === void 0 ? void 0 : obj.getReader);
}





function $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910(input) {
    if (input instanceof (0, $4f562137a990678a$export$77cea355fa80b5f4)) return input;
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(input);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(input);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return $1dc2e2cd8f7c5351$export$60f45028237c39d1(input);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(input);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return $1dc2e2cd8f7c5351$export$dcccc29c315dd646(input);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(input);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}
function $1dc2e2cd8f7c5351$export$aa3d41784b3267fa(obj) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var obs = obj[0, $eaf29fccbded6ed3$export$5ab46cbf6120b33a]();
        if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(obs.subscribe)) return obs.subscribe(subscriber);
        throw new TypeError("Provided object does not correctly implement Symbol.observable");
    });
}
function $1dc2e2cd8f7c5351$export$4cb2acdbcda2c253(array) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        for(var i = 0; i < array.length && !subscriber.closed; i++)subscriber.next(array[i]);
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$60f45028237c39d1(promise) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        promise.then(function(value) {
            if (!subscriber.closed) {
                subscriber.next(value);
                subscriber.complete();
            }
        }, function(err) {
            return subscriber.error(err);
        }).then(null, (0, $18eb28ff53cc4943$export$ebf645db02d3e99f));
    });
}
function $1dc2e2cd8f7c5351$export$dcccc29c315dd646(iterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var e_1, _a;
        try {
            for(var iterable_1 = (0, $5c96a02c592fcff1$export$19a8beecd37a4c45)(iterable), iterable_1_1 = iterable_1.next(); !iterable_1_1.done; iterable_1_1 = iterable_1.next()){
                var value = iterable_1_1.value;
                subscriber.next(value);
                if (subscriber.closed) return;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (iterable_1_1 && !iterable_1_1.done && (_a = iterable_1.return)) _a.call(iterable_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        subscriber.complete();
    });
}
function $1dc2e2cd8f7c5351$export$e073fccf36d78cc1(asyncIterable) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber).catch(function(err) {
            return subscriber.error(err);
        });
    });
}
function $1dc2e2cd8f7c5351$export$b2dcb11d46e7a4ad(readableStream) {
    return $1dc2e2cd8f7c5351$export$e073fccf36d78cc1((0, $54b99b9095e84ce4$export$cf4785e597badab3)(readableStream));
}
function $1dc2e2cd8f7c5351$var$process(asyncIterable, subscriber) {
    var asyncIterable_1, asyncIterable_1_1;
    var e_2, _a;
    return (0, $5c96a02c592fcff1$export$1050f835b63b671e)(this, void 0, void 0, function() {
        var value, e_2_1;
        return (0, $5c96a02c592fcff1$export$67ebef60e6f28a6)(this, function(_b) {
            switch(_b.label){
                case 0:
                    _b.trys.push([
                        0,
                        5,
                        6,
                        11
                    ]);
                    asyncIterable_1 = (0, $5c96a02c592fcff1$export$e3b29a3d6162315f)(asyncIterable);
                    _b.label = 1;
                case 1:
                    return [
                        4,
                        asyncIterable_1.next()
                    ];
                case 2:
                    if (!(asyncIterable_1_1 = _b.sent(), !asyncIterable_1_1.done)) return [
                        3,
                        4
                    ];
                    value = asyncIterable_1_1.value;
                    subscriber.next(value);
                    if (subscriber.closed) return [
                        2
                    ];
                    _b.label = 3;
                case 3:
                    return [
                        3,
                        1
                    ];
                case 4:
                    return [
                        3,
                        11
                    ];
                case 5:
                    e_2_1 = _b.sent();
                    e_2 = {
                        error: e_2_1
                    };
                    return [
                        3,
                        11
                    ];
                case 6:
                    _b.trys.push([
                        6,
                        ,
                        9,
                        10
                    ]);
                    if (!(asyncIterable_1_1 && !asyncIterable_1_1.done && (_a = asyncIterable_1.return))) return [
                        3,
                        8
                    ];
                    return [
                        4,
                        _a.call(asyncIterable_1)
                    ];
                case 7:
                    _b.sent();
                    _b.label = 8;
                case 8:
                    return [
                        3,
                        10
                    ];
                case 9:
                    if (e_2) throw e_2.error;
                    return [
                        7
                    ];
                case 10:
                    return [
                        7
                    ];
                case 11:
                    subscriber.complete();
                    return [
                        2
                    ];
            }
        });
    });
}



function $e890d5c5b4491f33$export$ac8dfd3a7ad06e80(notifier) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(notifier).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function() {
            return subscriber.complete();
        }, (0, $528e75db69787807$export$8793edee2d425525)));
        !subscriber.closed && source.subscribe(subscriber);
    });
}




var $6ZWSX = parcelRequire("6ZWSX");
var $6ef0ce7423428135$require$Buffer = $6ZWSX.Buffer;
const $6ef0ce7423428135$var$TagId = 0x05;
const $6ef0ce7423428135$export$f86f8308901215ed = (rawStream, { context: context } = {})=>new (0, $4f562137a990678a$export$77cea355fa80b5f4)((o)=>{
        let notifiedIndex = 0;
        let notifiedDataLength = 0;
        let notifiedData = $6ef0ce7423428135$require$Buffer.alloc(0);
        const subscriptionCleaner = new (0, $4a1890c700519557$export$915d2682b0aa0991)();
        // The raw stream is listened/subscribed to until a full message (that can be made of several frames) is received
        rawStream.pipe((0, $e890d5c5b4491f33$export$ac8dfd3a7ad06e80)(subscriptionCleaner)).subscribe({
            complete: ()=>{
                o.error(new (0, $9a194f74559621d2$export$1e42f3936938e063)());
            },
            error: (error)=>{
                (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                    type: "ble-error",
                    message: `Error in receiveAPDU: ${error}`,
                    data: {
                        error: error
                    },
                    context: context
                });
                o.error(error);
            },
            next: (value)=>{
                // Silences emitted errors in next
                if (value instanceof Error) {
                    (0, $fdd451dd43e0ce6f$export$357889f174732d38)({
                        type: "ble-error",
                        message: `Error emitted to receiveAPDU next: ${value}`,
                        data: {
                            error: value
                        },
                        context: context
                    });
                    return;
                }
                const tag = value.readUInt8(0);
                const chunkIndex = value.readUInt16BE(1);
                // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                let chunkData = value.slice(3);
                if (tag !== $6ef0ce7423428135$var$TagId) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)("Invalid tag " + tag.toString(16), "InvalidTag"));
                    return;
                }
                // A chunk was probably missed
                if (notifiedIndex !== chunkIndex) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(`BLE: Invalid sequence number. discontinued chunk. Received ${chunkIndex} but expected ${notifiedIndex}`, "InvalidSequence"));
                    return;
                }
                // The total length of the response is located on the next 2 bytes on the 1st chunk
                if (chunkIndex === 0) {
                    notifiedDataLength = chunkData.readUInt16BE(0);
                    // `slice` and not `subarray`: this is not a Node Buffer, but probably only a Uint8Array.
                    chunkData = chunkData.slice(2);
                }
                notifiedIndex++;
                // The cost of creating a new buffer for each received chunk is low because the response is often contained in 1 chunk.
                // Allocating `notifiedData` buffer with the received total length and mutating it will probably not improve any performance.
                notifiedData = $6ef0ce7423428135$require$Buffer.concat([
                    notifiedData,
                    chunkData
                ]);
                if (notifiedData.length > notifiedDataLength) {
                    o.error(new (0, $9a194f74559621d2$export$8e68de6fb26f2236)(`BLE: received too much data. discontinued chunk. Received ${notifiedData.length} but expected ${notifiedDataLength}`, "BLETooMuchData"));
                    return;
                }
                if (notifiedData.length === notifiedDataLength) {
                    o.next(notifiedData);
                    o.complete();
                    // Tries to unsubscribe from the raw stream as soon as we complete the parent observer
                    subscriptionCleaner.next();
                }
            }
        });
        return ()=>{
            subscriptionCleaner.next();
        };
    });





function $8312939aeeb1a4f7$export$260e5c0943f31606(observableFactory) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(observableFactory()).subscribe(subscriber);
    });
}


var $6cabd83f99ce6113$export$78f6d1b1dbcda304 = (0, $ebe567a061bc80f6$export$128a15b65d1b6041)(function(_super) {
    return function EmptyErrorImpl() {
        _super(this);
        this.name = "EmptyError";
        this.message = "no elements in sequence";
    };
});



function $e61e581d31b1ea5f$export$400f9f949cef996c(source, config) {
    var hasConfig = typeof config === "object";
    return new Promise(function(resolve, reject) {
        var subscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
            next: function(value) {
                resolve(value);
                subscriber.unsubscribe();
            },
            error: reject,
            complete: function() {
                if (hasConfig) resolve(config.defaultValue);
                else reject(new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)());
            }
        });
        source.subscribe(subscriber);
    });
}


function $3525e15e439f8b93$export$a2b7447487315232(parentSubscription, scheduler, work, delay, repeat) {
    if (delay === void 0) delay = 0;
    if (repeat === void 0) repeat = false;
    var scheduleSubscription = scheduler.schedule(function() {
        work();
        if (repeat) parentSubscription.add(this.schedule(null, delay));
        else this.unsubscribe();
    }, delay);
    parentSubscription.add(scheduleSubscription);
    if (!repeat) return scheduleSubscription;
}




function $25136415cad576bc$export$9007f49c319d1ac7(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.next(value);
            }, delay);
        }, function() {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.complete();
            }, delay);
        }, function(err) {
            return (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                return subscriber.error(err);
            }, delay);
        }));
    });
}



function $daf4fd612cb884aa$export$1eb44d8f5f64733b(scheduler, delay) {
    if (delay === void 0) delay = 0;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        subscriber.add(scheduler.schedule(function() {
            return source.subscribe(subscriber);
        }, delay));
    });
}


function $e3a1d71c442b5de9$export$ed8bd553a12b6a30(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}





function $7ea29ae5d684fb04$export$fc9afd948577f0a8(input, scheduler) {
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input).pipe((0, $daf4fd612cb884aa$export$1eb44d8f5f64733b)(scheduler), (0, $25136415cad576bc$export$9007f49c319d1ac7)(scheduler));
}



function $0ce5b91768be0a6d$export$b34673931371729a(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var i = 0;
        return scheduler.schedule(function() {
            if (i === input.length) subscriber.complete();
            else {
                subscriber.next(input[i++]);
                if (!subscriber.closed) this.schedule();
            }
        });
    });
}






function $3a22bf76b9b6de63$export$2b75c58ab9b5b766(input, scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        var iterator;
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            iterator = input[0, $0b89b4d4fb8bd3fd$export$6f58e2338da23f4d]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                var _a;
                var value;
                var done;
                try {
                    _a = iterator.next(), value = _a.value, done = _a.done;
                } catch (err) {
                    subscriber.error(err);
                    return;
                }
                if (done) subscriber.complete();
                else subscriber.next(value);
            }, 0, true);
        });
        return function() {
            return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(iterator === null || iterator === void 0 ? void 0 : iterator.return) && iterator.return();
        };
    });
}




function $d2627b52a3f1ff1b$export$7c7f0979b56a32f3(input, scheduler) {
    if (!input) throw new Error("Iterable cannot be null");
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
            var iterator = input[Symbol.asyncIterator]();
            (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, scheduler, function() {
                iterator.next().then(function(result) {
                    if (result.done) subscriber.complete();
                    else subscriber.next(result.value);
                });
            }, 0, true);
        });
    });
}











function $7999ea1c5b71ad25$export$3385251aeecad28a(input, scheduler) {
    return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)((0, $54b99b9095e84ce4$export$cf4785e597badab3)(input), scheduler);
}


function $8f2bbfa9b5105688$export$49c44dfc2bb21d70(input, scheduler) {
    if (input != null) {
        if ((0, $0539b51af1903d0a$export$48c0cddbc99c45c2)(input)) return (0, $e3a1d71c442b5de9$export$ed8bd553a12b6a30)(input, scheduler);
        if ((0, $8821cb8787de9fb5$export$1e2f57719e155213)(input)) return (0, $0ce5b91768be0a6d$export$b34673931371729a)(input, scheduler);
        if ((0, $9dcf7896928e75dd$export$4369c812aac99591)(input)) return (0, $7ea29ae5d684fb04$export$fc9afd948577f0a8)(input, scheduler);
        if ((0, $7c74d6a5e2273447$export$edb10ab8dd75a915)(input)) return (0, $d2627b52a3f1ff1b$export$7c7f0979b56a32f3)(input, scheduler);
        if ((0, $b8a13650b96f19ab$export$9652023d9040757)(input)) return (0, $3a22bf76b9b6de63$export$2b75c58ab9b5b766)(input, scheduler);
        if ((0, $54b99b9095e84ce4$export$c088ffafdba7405f)(input)) return (0, $7999ea1c5b71ad25$export$3385251aeecad28a)(input, scheduler);
    }
    throw (0, $d63b3f5b704e6de4$export$7cbe71b9fa263484)(input);
}



function $2fe2b696577919a5$export$6788812c4e6611e6(input, scheduler) {
    return scheduler ? (0, $8f2bbfa9b5105688$export$49c44dfc2bb21d70)(input, scheduler) : (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(input);
}



function $9853a79d111e4e33$export$871de8747c9eaa88(project, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            subscriber.next(project.call(thisArg, value, index++));
        }));
    });
}







function $9cbbbba4f565a378$export$600918ebaa9e0a1b(source, subscriber, project, concurrent, onBeforeNext, expand, innerSubScheduler, additionalFinalizer) {
    var buffer = [];
    var active = 0;
    var index = 0;
    var isComplete = false;
    var checkComplete = function() {
        if (isComplete && !buffer.length && !active) subscriber.complete();
    };
    var outerNext = function(value) {
        return active < concurrent ? doInnerSub(value) : buffer.push(value);
    };
    var doInnerSub = function(value) {
        expand && subscriber.next(value);
        active++;
        var innerComplete = false;
        (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(value, index++)).subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(innerValue) {
            onBeforeNext === null || onBeforeNext === void 0 || onBeforeNext(innerValue);
            if (expand) outerNext(innerValue);
            else subscriber.next(innerValue);
        }, function() {
            innerComplete = true;
        }, undefined, function() {
            if (innerComplete) try {
                active--;
                var _loop_1 = function() {
                    var bufferedValue = buffer.shift();
                    if (innerSubScheduler) (0, $3525e15e439f8b93$export$a2b7447487315232)(subscriber, innerSubScheduler, function() {
                        return doInnerSub(bufferedValue);
                    });
                    else doInnerSub(bufferedValue);
                };
                while(buffer.length && active < concurrent)_loop_1();
                checkComplete();
            } catch (err) {
                subscriber.error(err);
            }
        }));
    };
    source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, outerNext, function() {
        isComplete = true;
        checkComplete();
    }));
    return function() {
        additionalFinalizer === null || additionalFinalizer === void 0 || additionalFinalizer();
    };
}



function $46964ba1b403cbfc$export$6b9f6c0d32c093f9(project, resultSelector, concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    if ((0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(resultSelector)) return $46964ba1b403cbfc$export$6b9f6c0d32c093f9(function(a, i) {
        return (0, $9853a79d111e4e33$export$871de8747c9eaa88)(function(b, ii) {
            return resultSelector(a, b, i, ii);
        })((0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(project(a, i)));
    }, concurrent);
    else if (typeof resultSelector === "number") concurrent = resultSelector;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        return (0, $9cbbbba4f565a378$export$600918ebaa9e0a1b)(source, subscriber, project, concurrent);
    });
}



function $4707859e785b3da6$export$18aef43295bbe906(concurrent) {
    if (concurrent === void 0) concurrent = Infinity;
    return (0, $46964ba1b403cbfc$export$6b9f6c0d32c093f9)((0, $7569c528cdd9d182$export$f0954fd7d5368655), concurrent);
}




var $8faf6f2806f38bc2$export$ccb33e29d92c9a58 = new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
    return subscriber.complete();
});
function $8faf6f2806f38bc2$export$6e22c362a0406a2c(scheduler) {
    return scheduler ? $8faf6f2806f38bc2$var$emptyScheduled(scheduler) : $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
}
function $8faf6f2806f38bc2$var$emptyScheduled(scheduler) {
    return new (0, $4f562137a990678a$export$77cea355fa80b5f4)(function(subscriber) {
        return scheduler.schedule(function() {
            return subscriber.complete();
        });
    });
}




function $cd8e5ea142a386bd$export$187e35932e88c15c(value) {
    return value && (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(value.schedule);
}


function $3b29c258456d9a89$var$last(arr) {
    return arr[arr.length - 1];
}
function $3b29c258456d9a89$export$9ae19b645239a61b(args) {
    return (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$29534b2f653ae592(args) {
    return (0, $cd8e5ea142a386bd$export$187e35932e88c15c)($3b29c258456d9a89$var$last(args)) ? args.pop() : undefined;
}
function $3b29c258456d9a89$export$3de14b735070dcd5(args, defaultValue) {
    return typeof $3b29c258456d9a89$var$last(args) === "number" ? args.pop() : defaultValue;
}



function $75c08a98094ca84a$export$4950aa0f605343fb() {
    var args = [];
    for(var _i = 0; _i < arguments.length; _i++)args[_i] = arguments[_i];
    var scheduler = (0, $3b29c258456d9a89$export$29534b2f653ae592)(args);
    var concurrent = (0, $3b29c258456d9a89$export$3de14b735070dcd5)(args, Infinity);
    var sources = args;
    return !sources.length ? (0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58) : sources.length === 1 ? (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(sources[0]) : (0, $4707859e785b3da6$export$18aef43295bbe906)(concurrent)((0, $2fe2b696577919a5$export$6788812c4e6611e6)(sources, scheduler));
}





function $98aaadcfa91e6727$export$3dea766d36a8935f(predicate, thisArg) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var index = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            return predicate.call(thisArg, value, index++) && subscriber.next(value);
        }));
    });
}





function $e53e80f9042754be$export$b7df5d561049483a(count) {
    return count <= 0 ? function() {
        return 0, $8faf6f2806f38bc2$export$ccb33e29d92c9a58;
    } : (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var seen = 0;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            if (++seen <= count) {
                subscriber.next(value);
                if (count <= seen) subscriber.complete();
            }
        }));
    });
}




function $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b(defaultValue) {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            if (!hasValue) subscriber.next(defaultValue);
            subscriber.complete();
        }));
    });
}





function $8c2c9c105ebfd25b$export$c8ea5e9f84346833(errorFactory) {
    if (errorFactory === void 0) errorFactory = $8c2c9c105ebfd25b$var$defaultErrorFactory;
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var hasValue = false;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            hasValue = true;
            subscriber.next(value);
        }, function() {
            return hasValue ? subscriber.complete() : subscriber.error(errorFactory());
        }));
    });
}
function $8c2c9c105ebfd25b$var$defaultErrorFactory() {
    return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
}



function $b9a90ca4d933af63$export$43128fadae87b74a(predicate, defaultValue) {
    var hasDefaultValue = arguments.length >= 2;
    return function(source) {
        return source.pipe(predicate ? (0, $98aaadcfa91e6727$export$3dea766d36a8935f)(function(v, i) {
            return predicate(v, i, source);
        }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655), (0, $e53e80f9042754be$export$b7df5d561049483a)(1), hasDefaultValue ? (0, $280fd838c1eb9e63$export$e4ca6d7b7a6dcf9b)(defaultValue) : (0, $8c2c9c105ebfd25b$export$c8ea5e9f84346833)(function() {
            return new (0, $6cabd83f99ce6113$export$78f6d1b1dbcda304)();
        }));
    };
}




function $55286ae00f8aa486$export$6953b97c7d866605() {
    return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, (0, $528e75db69787807$export$8793edee2d425525)));
    });
}






function $0cd9b6b86141760f$export$ed80d9de1d9df928(options) {
    if (options === void 0) options = {};
    var _a = options.connector, connector = _a === void 0 ? function() {
        return new (0, $2d63f5ffe6ca8602$export$b6bbab5a9b109038)();
    } : _a, _b = options.resetOnError, resetOnError = _b === void 0 ? true : _b, _c = options.resetOnComplete, resetOnComplete = _c === void 0 ? true : _c, _d = options.resetOnRefCountZero, resetOnRefCountZero = _d === void 0 ? true : _d;
    return function(wrapperSource) {
        var connection;
        var resetConnection;
        var subject;
        var refCount = 0;
        var hasCompleted = false;
        var hasErrored = false;
        var cancelReset = function() {
            resetConnection === null || resetConnection === void 0 || resetConnection.unsubscribe();
            resetConnection = undefined;
        };
        var reset = function() {
            cancelReset();
            connection = subject = undefined;
            hasCompleted = hasErrored = false;
        };
        var resetAndUnsubscribe = function() {
            var conn = connection;
            reset();
            conn === null || conn === void 0 || conn.unsubscribe();
        };
        return (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
            refCount++;
            if (!hasErrored && !hasCompleted) cancelReset();
            var dest = subject = subject !== null && subject !== void 0 ? subject : connector();
            subscriber.add(function() {
                refCount--;
                if (refCount === 0 && !hasErrored && !hasCompleted) resetConnection = $0cd9b6b86141760f$var$handleReset(resetAndUnsubscribe, resetOnRefCountZero);
            });
            dest.subscribe(subscriber);
            if (!connection && refCount > 0) {
                connection = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
                    next: function(value) {
                        return dest.next(value);
                    },
                    error: function(err) {
                        hasErrored = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnError, err);
                        dest.error(err);
                    },
                    complete: function() {
                        hasCompleted = true;
                        cancelReset();
                        resetConnection = $0cd9b6b86141760f$var$handleReset(reset, resetOnComplete);
                        dest.complete();
                    }
                });
                (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(source).subscribe(connection);
            }
        })(wrapperSource);
    };
}
function $0cd9b6b86141760f$var$handleReset(reset, on) {
    var args = [];
    for(var _i = 2; _i < arguments.length; _i++)args[_i - 2] = arguments[_i];
    if (on === true) {
        reset();
        return;
    }
    if (on === false) return;
    var onSubscriber = new (0, $cf8ce74b80455e9f$export$94eeb6a328cab6c7)({
        next: function() {
            onSubscriber.unsubscribe();
            reset();
        }
    });
    return (0, $1dc2e2cd8f7c5351$export$6a9cfa3ebc765910)(on.apply(void 0, (0, $5c96a02c592fcff1$export$1216008129fb82ed)([], (0, $5c96a02c592fcff1$export$8d051b38c9118094)(args)))).subscribe(onSubscriber);
}





function $3e7edc5b22925f26$export$3f23594af5f37336(observerOrNext, error, complete) {
    var tapObserver = (0, $c1aa42b0603892d6$export$f6e2535fb5126e54)(observerOrNext) || error || complete ? {
        next: observerOrNext,
        error: error,
        complete: complete
    } : observerOrNext;
    return tapObserver ? (0, $992c4a42843eb1d0$export$871731df685d7753)(function(source, subscriber) {
        var _a;
        (_a = tapObserver.subscribe) === null || _a === void 0 || _a.call(tapObserver);
        var isUnsub = true;
        source.subscribe((0, $3868f035248205c1$export$b9e075132cc6937f)(subscriber, function(value) {
            var _a;
            (_a = tapObserver.next) === null || _a === void 0 || _a.call(tapObserver, value);
            subscriber.next(value);
        }, function() {
            var _a;
            isUnsub = false;
            (_a = tapObserver.complete) === null || _a === void 0 || _a.call(tapObserver);
            subscriber.complete();
        }, function(err) {
            var _a;
            isUnsub = false;
            (_a = tapObserver.error) === null || _a === void 0 || _a.call(tapObserver, err);
            subscriber.error(err);
        }, function() {
            var _a, _b;
            if (isUnsub) (_a = tapObserver.unsubscribe) === null || _a === void 0 || _a.call(tapObserver);
            (_b = tapObserver.finalize) === null || _b === void 0 || _b.call(tapObserver);
        }));
    }) : (0, $7569c528cdd9d182$export$f0954fd7d5368655);
}





var $6ZWSX = parcelRequire("6ZWSX");
var $d4f073a8538219b0$require$Buffer = $6ZWSX.Buffer;
const $d4f073a8538219b0$export$419bb53c59622ce9 = (characteristic)=>(0, $4f562137a990678a$export$77cea355fa80b5f4).create((o)=>{
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "start monitor " + characteristic.uuid);
        function onCharacteristicValueChanged(event) {
            const characteristic = event.target;
            if (characteristic.value) o.next($d4f073a8538219b0$require$Buffer.from(characteristic.value.buffer));
        }
        characteristic.startNotifications().then(()=>{
            characteristic.addEventListener("characteristicvaluechanged", onCharacteristicValueChanged);
        });
        return ()=>{
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "end monitor " + characteristic.uuid);
            characteristic.stopNotifications();
        };
    });



var $6ZWSX = parcelRequire("6ZWSX");
var $9b04af14b7feeec2$require$Buffer = $6ZWSX.Buffer;
var $9b04af14b7feeec2$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var $9b04af14b7feeec2$var$_a;
const $9b04af14b7feeec2$var$requiresBluetooth = ()=>{
    // $FlowFixMe
    const { bluetooth: bluetooth } = navigator;
    if (typeof bluetooth === "undefined") throw new Error("web bluetooth not supported");
    return bluetooth;
};
const $9b04af14b7feeec2$var$availability = ()=>(0, $4f562137a990678a$export$77cea355fa80b5f4).create((observer)=>{
        const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
        const onAvailabilityChanged = (e)=>{
            observer.next(e.value);
        };
        bluetooth.addEventListener("availabilitychanged", onAvailabilityChanged);
        let unsubscribed = false;
        bluetooth.getAvailability().then((available)=>{
            if (!unsubscribed) observer.next(available);
        });
        return ()=>{
            unsubscribed = true;
            bluetooth.removeEventListener("availabilitychanged", onAvailabilityChanged);
        };
    });
const $9b04af14b7feeec2$var$transportsCache = {};
const $9b04af14b7feeec2$var$requestDeviceParam = ()=>({
        filters: (0, $5dec73da4f32e22b$export$1f1251c1c71d84cf)().map((uuid)=>({
                services: [
                    uuid
                ]
            }))
    });
const $9b04af14b7feeec2$var$retrieveService = (device)=>$9b04af14b7feeec2$var$__awaiter(void 0, void 0, void 0, function*() {
        if (!device.gatt) throw new Error("bluetooth gatt not found");
        const [service] = yield device.gatt.getPrimaryServices();
        if (!service) throw new Error("bluetooth service not found");
        const infos = (0, $5dec73da4f32e22b$export$8c98567a3882f79e)(service.uuid);
        if (!infos) throw new Error("bluetooth service infos not found");
        return [
            service,
            infos
        ];
    });
function $9b04af14b7feeec2$var$open(deviceOrId, needsReconnect) {
    return $9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
        let device;
        if (typeof deviceOrId === "string") {
            if ($9b04af14b7feeec2$var$transportsCache[deviceOrId]) {
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "Transport in cache, using that.");
                return $9b04af14b7feeec2$var$transportsCache[deviceOrId];
            }
            const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
            // TODO instead we should "query" the device by its ID
            device = yield bluetooth.requestDevice($9b04af14b7feeec2$var$requestDeviceParam());
        } else device = deviceOrId;
        if (!device.gatt.connected) {
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "not connected. connecting...");
            yield device.gatt.connect();
        }
        const [service, infos] = yield $9b04af14b7feeec2$var$retrieveService(device);
        const { deviceModel: deviceModel, writeUuid: writeUuid, notifyUuid: notifyUuid } = infos;
        const [writeC, notifyC] = yield Promise.all([
            service.getCharacteristic(writeUuid),
            service.getCharacteristic(notifyUuid)
        ]);
        const notifyObservable = (0, $d4f073a8538219b0$export$419bb53c59622ce9)(notifyC).pipe((0, $3e7edc5b22925f26$export$3f23594af5f37336)((value)=>{
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-frame", "<= " + value.toString("hex"));
        }), (0, $0cd9b6b86141760f$export$ed80d9de1d9df928)());
        const notif = notifyObservable.subscribe();
        const transport = new $9b04af14b7feeec2$var$BluetoothTransport(device, writeC, notifyObservable, deviceModel);
        if (!device.gatt.connected) throw new (0, $9a194f74559621d2$export$1e42f3936938e063)();
        // eslint-disable-next-line require-atomic-updates
        $9b04af14b7feeec2$var$transportsCache[transport.id] = transport;
        const onDisconnect = (e)=>{
            console.log("onDisconnect!", e);
            delete $9b04af14b7feeec2$var$transportsCache[transport.id];
            transport.notYetDisconnected = false;
            notif.unsubscribe();
            device.removeEventListener("gattserverdisconnected", onDisconnect);
            (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${transport.id}) disconnected`);
            transport.emit("disconnect", e);
        };
        device.addEventListener("gattserverdisconnected", onDisconnect);
        const beforeMTUTime = Date.now();
        try {
            yield transport.inferMTU();
        } finally{
            const afterMTUTime = Date.now();
            // workaround for #279: we need to open() again if we come the first time here,
            // to make sure we do a disconnect() after the first pairing time
            // because of a firmware bug
            if (afterMTUTime - beforeMTUTime < 1000) needsReconnect = false; // (optim) there is likely no new pairing done because mtu answer was fast.
            if (needsReconnect) {
                yield device.gatt.disconnect();
                // necessary time for the bonding workaround
                yield new Promise((s)=>setTimeout(s, 4000));
            }
        }
        if (needsReconnect) return $9b04af14b7feeec2$var$open(device, false);
        return transport;
    });
}
/**
 * react-native bluetooth BLE implementation
 * @example
 * import BluetoothTransport from "@ledgerhq/hw-transport-web-ble";
 */ class $9b04af14b7feeec2$var$BluetoothTransport extends (0, $375818ecee1623c3$export$2e2bcd8739ae039) {
    /**
     * Scan for Ledger Bluetooth devices.
     * On this web implementation, it only emits ONE device, the one that was selected in the UI (if any).
     */ static listen(observer) {
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", "listen...");
        let unsubscribed;
        const bluetooth = $9b04af14b7feeec2$var$requiresBluetooth();
        bluetooth.requestDevice($9b04af14b7feeec2$var$requestDeviceParam()).then((device)=>{
            if (!unsubscribed) {
                observer.next({
                    type: "add",
                    descriptor: device
                });
                observer.complete();
            }
        }, (error)=>{
            observer.error(new (0, $9a194f74559621d2$export$9642f061c2494239)(error.message));
        });
        function unsubscribe() {
            unsubscribed = true;
        }
        return {
            unsubscribe: unsubscribe
        };
    }
    /**
     * open a bluetooth device.
     */ static open(deviceOrId) {
        return $9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
            return $9b04af14b7feeec2$var$open(deviceOrId, true);
        });
    }
    constructor(device, writeCharacteristic, notifyObservable, deviceModel){
        super();
        this.mtuSize = 20;
        this.notYetDisconnected = true;
        this.write = (buffer)=>$9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-frame", "=> " + buffer.toString("hex"));
                yield this.writeCharacteristic.writeValue(buffer);
            });
        this.id = device.id;
        this.device = device;
        this.writeCharacteristic = writeCharacteristic;
        this.notifyObservable = notifyObservable;
        this.deviceModel = deviceModel;
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${String(this.id)}) new instance`);
    }
    inferMTU() {
        return $9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
            let mtu = 23;
            yield this.exchangeAtomicImpl(()=>$9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        mtu = (yield (0, $e61e581d31b1ea5f$export$400f9f949cef996c)((0, $75c08a98094ca84a$export$4950aa0f605343fb)(this.notifyObservable.pipe((0, $b9a90ca4d933af63$export$43128fadae87b74a)((buffer)=>buffer.readUInt8(0) === 0x08), (0, $9853a79d111e4e33$export$871de8747c9eaa88)((buffer)=>buffer.readUInt8(5))), (0, $8312939aeeb1a4f7$export$260e5c0943f31606)(()=>(0, $2fe2b696577919a5$export$6788812c4e6611e6)(this.write($9b04af14b7feeec2$require$Buffer.from([
                                0x08,
                                0,
                                0,
                                0,
                                0
                            ])))).pipe((0, $55286ae00f8aa486$export$6953b97c7d866605)())))) + 3;
                    } catch (e) {
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-error", "inferMTU got " + String(e));
                        this.device.gatt.disconnect();
                        throw e;
                    }
                }));
            if (mtu > 23) {
                const mtuSize = mtu - 3;
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `BleTransport(${String(this.id)}) mtu set to ${String(mtuSize)}`);
                this.mtuSize = mtuSize;
            }
            return this.mtuSize;
        });
    }
    /**
     * Exchange with the device using APDU protocol.
     * @param apdu
     * @returns a promise of apdu response
     */ exchange(apdu) {
        return $9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
            const b = yield this.exchangeAtomicImpl(()=>$9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
                    try {
                        const msgIn = apdu.toString("hex");
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", `=> ${msgIn}`);
                        const data = yield (0, $e61e581d31b1ea5f$export$400f9f949cef996c)((0, $75c08a98094ca84a$export$4950aa0f605343fb)(this.notifyObservable.pipe((0, $6ef0ce7423428135$export$f86f8308901215ed)), (0, $0f9aba74d280b54b$export$8f132f30db3d0b13)(this.write, apdu, this.mtuSize)));
                        const msgOut = data.toString("hex");
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("apdu", `<= ${msgOut}`);
                        return data;
                    } catch (e) {
                        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-error", "exchange got " + String(e));
                        if (this.notYetDisconnected) // in such case we will always disconnect because something is bad.
                        this.device.gatt.disconnect();
                        throw e;
                    }
                }));
            return b;
        });
    }
    setScrambleKey() {}
    close() {
        return $9b04af14b7feeec2$var$__awaiter(this, void 0, void 0, function*() {
            if (this.exchangeBusyPromise) yield this.exchangeBusyPromise;
        });
    }
}
$9b04af14b7feeec2$var$_a = $9b04af14b7feeec2$var$BluetoothTransport;
$9b04af14b7feeec2$var$BluetoothTransport.isSupported = ()=>Promise.resolve().then($9b04af14b7feeec2$var$requiresBluetooth).then(()=>true, ()=>false);
/**
 * observe event with { available: bool, type: string }
 * (available is generic, type is specific)
 * an event is emit once and then each time it changes
 */ $9b04af14b7feeec2$var$BluetoothTransport.observeAvailability = (observer)=>$9b04af14b7feeec2$var$availability().subscribe(observer);
$9b04af14b7feeec2$var$BluetoothTransport.list = ()=>Promise.resolve([]);
/**
 * globally disconnect a bluetooth device by its id.
 */ $9b04af14b7feeec2$var$BluetoothTransport.disconnect = (id)=>$9b04af14b7feeec2$var$__awaiter(void 0, void 0, void 0, function*() {
        (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("ble-verbose", `user disconnect(${id})`);
        const transport = $9b04af14b7feeec2$var$transportsCache[id];
        if (transport) transport.device.gatt.disconnect();
    });
var $9b04af14b7feeec2$export$2e2bcd8739ae039 = $9b04af14b7feeec2$var$BluetoothTransport;



var $3wrUl = parcelRequire("3wrUl");
var $7a6cef509ca65f26$exports = {};
"use strict";
var $7a6cef509ca65f26$var$__importDefault = $7a6cef509ca65f26$exports && $7a6cef509ca65f26$exports.__importDefault || function(mod) {
    return mod && mod.__esModule ? mod : {
        "default": mod
    };
};
Object.defineProperty($7a6cef509ca65f26$exports, "__esModule", {
    value: true
});
$7a6cef509ca65f26$exports.WalletPolicy = $7a6cef509ca65f26$exports.DefaultWalletPolicy = $7a6cef509ca65f26$exports.PsbtV2 = $7a6cef509ca65f26$exports.AppClient = void 0;

const $7a6cef509ca65f26$var$appClient_1 = $7a6cef509ca65f26$var$__importDefault((parcelRequire("pyUmM")));
$7a6cef509ca65f26$exports.AppClient = $7a6cef509ca65f26$var$appClient_1.default;
var $1a44f982b34497b4$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $1a44f982b34497b4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($1a44f982b34497b4$exports, "__esModule", {
    value: true
});
$1a44f982b34497b4$exports.DefaultWalletPolicy = $1a44f982b34497b4$exports.WalletPolicy = void 0;

var $3wrUl = parcelRequire("3wrUl");

var $8rRzQ = parcelRequire("8rRzQ");

var $goh0i = parcelRequire("goh0i");
const $1a44f982b34497b4$var$WALLET_POLICY_V2 = 2;
/**
 * The Bitcon hardware app uses a descriptors-like thing to describe
 * how to construct output scripts from keys. A "Wallet Policy" consists
 * of a "Descriptor Template" and a list of "keys". A key is basically
 * a serialized BIP32 extended public key with some added derivation path
 * information. This is documented at
 * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/wallet.md
 */ class $1a44f982b34497b4$var$WalletPolicy {
    /**
     * Creates and instance of a wallet policy.
     * @param name an ascii string, up to 16 bytes long; it must be an empty string for default wallet policies
     * @param descriptorTemplate the wallet policy template
     * @param keys and array of the keys, with the key derivation information
     */ constructor(name, descriptorTemplate, keys){
        this.name = name;
        this.descriptorTemplate = descriptorTemplate;
        this.keys = keys;
    }
    /**
     * Returns the unique 32-bytes id of this wallet policy.
     */ getId() {
        return $3wrUl.crypto.sha256(this.serialize());
    }
    /**
     * Serializes the wallet policy for transmission via the hardware wallet protocol.
     * @returns the serialized wallet policy
     */ serialize() {
        const keyBuffers = this.keys.map((k)=>{
            return $1a44f982b34497b4$require$Buffer.from(k, "ascii");
        });
        const m = new $goh0i.Merkle(keyBuffers.map((k)=>(0, $goh0i.hashLeaf)(k)));
        const buf = new $8rRzQ.BufferWriter();
        buf.writeUInt8($1a44f982b34497b4$var$WALLET_POLICY_V2); // wallet version
        // length of wallet name, and wallet name
        buf.writeVarSlice($1a44f982b34497b4$require$Buffer.from(this.name, "ascii"));
        // length of descriptor template
        buf.writeVarInt(this.descriptorTemplate.length);
        // sha256 hash of descriptor template
        buf.writeSlice($3wrUl.crypto.sha256($1a44f982b34497b4$require$Buffer.from(this.descriptorTemplate)));
        // number of keys
        buf.writeVarInt(this.keys.length);
        // root of Merkle tree of keys
        buf.writeSlice(m.getRoot());
        return buf.buffer();
    }
}
$1a44f982b34497b4$exports.WalletPolicy = $1a44f982b34497b4$var$WalletPolicy;
/**
 * Simplified class to handle default wallet policies that can be used without policy registration.
 */ class $1a44f982b34497b4$var$DefaultWalletPolicy extends $1a44f982b34497b4$var$WalletPolicy {
    constructor(descriptorTemplate, key){
        super("", descriptorTemplate, [
            key
        ]);
    }
}
$1a44f982b34497b4$exports.DefaultWalletPolicy = $1a44f982b34497b4$var$DefaultWalletPolicy;


Object.defineProperty($7a6cef509ca65f26$exports, "DefaultWalletPolicy", {
    enumerable: true,
    get: function() {
        return $1a44f982b34497b4$exports.DefaultWalletPolicy;
    }
});
Object.defineProperty($7a6cef509ca65f26$exports, "WalletPolicy", {
    enumerable: true,
    get: function() {
        return $1a44f982b34497b4$exports.WalletPolicy;
    }
});

var $fUsjC = parcelRequire("fUsjC");
Object.defineProperty($7a6cef509ca65f26$exports, "PsbtV2", {
    enumerable: true,
    get: function() {
        return $fUsjC.PsbtV2;
    }
});
$7a6cef509ca65f26$exports.default = $7a6cef509ca65f26$var$appClient_1.default;



var $58cf3bc07eb2f0ea$exports = {};
"use strict";
Object.defineProperty($58cf3bc07eb2f0ea$exports, "__esModule", {
    value: true
});
var $e7857d72cbf401cb$exports = {};
"use strict";
Object.defineProperty($e7857d72cbf401cb$exports, "__esModule", {
    value: true
});
var $36834601baa30f54$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $36834601baa30f54$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($36834601baa30f54$exports, "__esModule", {
    value: true
});
var $9769d1c09d3e8b0c$exports = {};
"use strict";
Object.defineProperty($9769d1c09d3e8b0c$exports, "__esModule", {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");

var $1iL1D = parcelRequire("1iL1D");
function $9769d1c09d3e8b0c$var$hash160(buffer) {
    const sha256Hash = $1R2J7("sha256").update(buffer).digest();
    try {
        return $1R2J7("rmd160").update(sha256Hash).digest();
    } catch (err) {
        return $1R2J7("ripemd160").update(sha256Hash).digest();
    }
}
$9769d1c09d3e8b0c$exports.hash160 = $9769d1c09d3e8b0c$var$hash160;
function $9769d1c09d3e8b0c$var$hmacSHA512(key, data) {
    return $1iL1D("sha512", key).update(data).digest();
}
$9769d1c09d3e8b0c$exports.hmacSHA512 = $9769d1c09d3e8b0c$var$hmacSHA512;



var $lpa1P = parcelRequire("lpa1P");
var $a810f27cf38f4a3f$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a810f27cf38f4a3f$require$Buffer = $6ZWSX.Buffer;

var $6noBd = parcelRequire("6noBd");

var $1zUcV = parcelRequire("1zUcV");
var $a810f27cf38f4a3f$require$EC = $1zUcV.ec;
const $a810f27cf38f4a3f$var$secp256k1 = new $a810f27cf38f4a3f$require$EC("secp256k1");
var $3a33a704f5d1184b$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $3a33a704f5d1184b$require$Buffer = $6ZWSX.Buffer;

var $1iL1D = parcelRequire("1iL1D");
const $3a33a704f5d1184b$var$ONE1 = $3a33a704f5d1184b$require$Buffer.alloc(1, 1);
const $3a33a704f5d1184b$var$ZERO1 = $3a33a704f5d1184b$require$Buffer.alloc(1, 0);
// https://tools.ietf.org/html/rfc6979#section-3.2
function $3a33a704f5d1184b$var$deterministicGenerateK(hash, x, checkSig, isPrivate, extraEntropy) {
    // Step A, ignored as hash already provided
    // Step B
    // Step C
    let k = $3a33a704f5d1184b$require$Buffer.alloc(32, 0);
    let v = $3a33a704f5d1184b$require$Buffer.alloc(32, 1);
    // Step D
    k = $1iL1D("sha256", k).update(v).update($3a33a704f5d1184b$var$ZERO1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step E
    v = $1iL1D("sha256", k).update(v).digest();
    // Step F
    k = $1iL1D("sha256", k).update(v).update($3a33a704f5d1184b$var$ONE1).update(x).update(hash).update(extraEntropy || "").digest();
    // Step G
    v = $1iL1D("sha256", k).update(v).digest();
    // Step H1/H2a, ignored as tlen === qlen (256 bit)
    // Step H2b
    v = $1iL1D("sha256", k).update(v).digest();
    let T = v;
    // Step H3, repeat until T is within the interval [1, n - 1] and is suitable for ECDSA
    while(!isPrivate(T) || !checkSig(T)){
        k = $1iL1D("sha256", k).update(v).update($3a33a704f5d1184b$var$ZERO1).digest();
        v = $1iL1D("sha256", k).update(v).digest();
        // Step H1/H2a, again, ignored as tlen === qlen (256 bit)
        // Step H2b again
        v = $1iL1D("sha256", k).update(v).digest();
        T = v;
    }
    return T;
}
$3a33a704f5d1184b$exports = $3a33a704f5d1184b$var$deterministicGenerateK;


const $a810f27cf38f4a3f$var$ZERO32 = $a810f27cf38f4a3f$require$Buffer.alloc(32, 0);
const $a810f27cf38f4a3f$var$EC_GROUP_ORDER = $a810f27cf38f4a3f$require$Buffer.from("fffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141", "hex");
const $a810f27cf38f4a3f$var$EC_P = $a810f27cf38f4a3f$require$Buffer.from("fffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f", "hex");
const $a810f27cf38f4a3f$var$n = $a810f27cf38f4a3f$var$secp256k1.curve.n;
const $a810f27cf38f4a3f$var$nDiv2 = $a810f27cf38f4a3f$var$n.shrn(1);
const $a810f27cf38f4a3f$var$G = $a810f27cf38f4a3f$var$secp256k1.curve.g;
const $a810f27cf38f4a3f$var$THROW_BAD_PRIVATE = "Expected Private";
const $a810f27cf38f4a3f$var$THROW_BAD_POINT = "Expected Point";
const $a810f27cf38f4a3f$var$THROW_BAD_TWEAK = "Expected Tweak";
const $a810f27cf38f4a3f$var$THROW_BAD_HASH = "Expected Hash";
const $a810f27cf38f4a3f$var$THROW_BAD_SIGNATURE = "Expected Signature";
const $a810f27cf38f4a3f$var$THROW_BAD_EXTRA_DATA = "Expected Extra Data (32 bytes)";
function $a810f27cf38f4a3f$var$isScalar(x) {
    return $a810f27cf38f4a3f$require$Buffer.isBuffer(x) && x.length === 32;
}
function $a810f27cf38f4a3f$var$isOrderScalar(x) {
    if (!$a810f27cf38f4a3f$var$isScalar(x)) return false;
    return x.compare($a810f27cf38f4a3f$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $a810f27cf38f4a3f$var$isPoint(p) {
    if (!$a810f27cf38f4a3f$require$Buffer.isBuffer(p)) return false;
    if (p.length < 33) return false;
    const t = p[0];
    const x = p.slice(1, 33);
    if (x.compare($a810f27cf38f4a3f$var$ZERO32) === 0) return false;
    if (x.compare($a810f27cf38f4a3f$var$EC_P) >= 0) return false;
    if ((t === 0x02 || t === 0x03) && p.length === 33) {
        try {
            $a810f27cf38f4a3f$var$decodeFrom(p);
        } catch (e) {
            return false;
        } // TODO: temporary
        return true;
    }
    const y = p.slice(33);
    if (y.compare($a810f27cf38f4a3f$var$ZERO32) === 0) return false;
    if (y.compare($a810f27cf38f4a3f$var$EC_P) >= 0) return false;
    if (t === 0x04 && p.length === 65) return true;
    return false;
}
function $a810f27cf38f4a3f$var$__isPointCompressed(p) {
    return p[0] !== 0x04;
}
function $a810f27cf38f4a3f$var$isPointCompressed(p) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) return false;
    return $a810f27cf38f4a3f$var$__isPointCompressed(p);
}
function $a810f27cf38f4a3f$var$isPrivate(x) {
    if (!$a810f27cf38f4a3f$var$isScalar(x)) return false;
    return x.compare($a810f27cf38f4a3f$var$ZERO32) > 0 && // > 0
    x.compare($a810f27cf38f4a3f$var$EC_GROUP_ORDER) < 0 // < G
    ;
}
function $a810f27cf38f4a3f$var$isSignature(value) {
    const r = value.slice(0, 32);
    const s = value.slice(32, 64);
    return $a810f27cf38f4a3f$require$Buffer.isBuffer(value) && value.length === 64 && r.compare($a810f27cf38f4a3f$var$EC_GROUP_ORDER) < 0 && s.compare($a810f27cf38f4a3f$var$EC_GROUP_ORDER) < 0;
}
function $a810f27cf38f4a3f$var$assumeCompression(value, pubkey) {
    if (value === undefined && pubkey !== undefined) return $a810f27cf38f4a3f$var$__isPointCompressed(pubkey);
    if (value === undefined) return true;
    return value;
}
function $a810f27cf38f4a3f$var$fromBuffer(d) {
    return new $6noBd(d);
}
function $a810f27cf38f4a3f$var$toBuffer(d) {
    return d.toArrayLike($a810f27cf38f4a3f$require$Buffer, "be", 32);
}
function $a810f27cf38f4a3f$var$decodeFrom(P) {
    return $a810f27cf38f4a3f$var$secp256k1.curve.decodePoint(P);
}
function $a810f27cf38f4a3f$var$getEncoded(P, compressed) {
    return $a810f27cf38f4a3f$require$Buffer.from(P._encode(compressed));
}
function $a810f27cf38f4a3f$var$pointAdd(pA, pB, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(pA)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isPoint(pB)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const a = $a810f27cf38f4a3f$var$decodeFrom(pA);
    const b = $a810f27cf38f4a3f$var$decodeFrom(pB);
    const pp = a.add(b);
    if (pp.isInfinity()) return null;
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, pA);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointAddScalar(p, tweak, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    if (tweak.compare($a810f27cf38f4a3f$var$ZERO32) === 0) return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const qq = $a810f27cf38f4a3f$var$G.mul(tt);
    const uu = pp.add(qq);
    if (uu.isInfinity()) return null;
    return $a810f27cf38f4a3f$var$getEncoded(uu, compressed);
}
function $a810f27cf38f4a3f$var$pointCompress(p, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    if (pp.isInfinity()) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointFromScalar(d, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const pp = $a810f27cf38f4a3f$var$G.mul(dd);
    if (pp.isInfinity()) return null;
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed);
    return $a810f27cf38f4a3f$var$getEncoded(pp, compressed);
}
function $a810f27cf38f4a3f$var$pointMultiply(p, tweak, __compressed) {
    if (!$a810f27cf38f4a3f$var$isPoint(p)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const compressed = $a810f27cf38f4a3f$var$assumeCompression(__compressed, p);
    const pp = $a810f27cf38f4a3f$var$decodeFrom(p);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const qq = pp.mul(tt);
    if (qq.isInfinity()) return null;
    return $a810f27cf38f4a3f$var$getEncoded(qq, compressed);
}
function $a810f27cf38f4a3f$var$privateAdd(d, tweak) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const dt = $a810f27cf38f4a3f$var$toBuffer(dd.add(tt).umod($a810f27cf38f4a3f$var$n));
    if (!$a810f27cf38f4a3f$var$isPrivate(dt)) return null;
    return dt;
}
function $a810f27cf38f4a3f$var$privateSub(d, tweak) {
    if (!$a810f27cf38f4a3f$var$isPrivate(d)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (!$a810f27cf38f4a3f$var$isOrderScalar(tweak)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_TWEAK);
    const dd = $a810f27cf38f4a3f$var$fromBuffer(d);
    const tt = $a810f27cf38f4a3f$var$fromBuffer(tweak);
    const dt = $a810f27cf38f4a3f$var$toBuffer(dd.sub(tt).umod($a810f27cf38f4a3f$var$n));
    if (!$a810f27cf38f4a3f$var$isPrivate(dt)) return null;
    return dt;
}
function $a810f27cf38f4a3f$var$sign(hash, x) {
    return $a810f27cf38f4a3f$var$__sign(hash, x);
}
function $a810f27cf38f4a3f$var$signWithEntropy(hash, x, addData) {
    return $a810f27cf38f4a3f$var$__sign(hash, x, addData);
}
function $a810f27cf38f4a3f$var$__sign(hash, x, addData) {
    if (!$a810f27cf38f4a3f$var$isScalar(hash)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_HASH);
    if (!$a810f27cf38f4a3f$var$isPrivate(x)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_PRIVATE);
    if (addData !== undefined && !$a810f27cf38f4a3f$var$isScalar(addData)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_EXTRA_DATA);
    const d = $a810f27cf38f4a3f$var$fromBuffer(x);
    const e = $a810f27cf38f4a3f$var$fromBuffer(hash);
    let r, s;
    const checkSig = function(k) {
        const kI = $a810f27cf38f4a3f$var$fromBuffer(k);
        const Q = $a810f27cf38f4a3f$var$G.mul(kI);
        if (Q.isInfinity()) return false;
        r = Q.x.umod($a810f27cf38f4a3f$var$n);
        if (r.isZero() === 0) return false;
        s = kI.invm($a810f27cf38f4a3f$var$n).mul(e.add(d.mul(r))).umod($a810f27cf38f4a3f$var$n);
        if (s.isZero() === 0) return false;
        return true;
    };
    $3a33a704f5d1184b$exports(hash, x, checkSig, $a810f27cf38f4a3f$var$isPrivate, addData);
    // enforce low S values, see bip62: 'low s values in signatures'
    if (s.cmp($a810f27cf38f4a3f$var$nDiv2) > 0) s = $a810f27cf38f4a3f$var$n.sub(s);
    const buffer = $a810f27cf38f4a3f$require$Buffer.allocUnsafe(64);
    $a810f27cf38f4a3f$var$toBuffer(r).copy(buffer, 0);
    $a810f27cf38f4a3f$var$toBuffer(s).copy(buffer, 32);
    return buffer;
}
function $a810f27cf38f4a3f$var$verify(hash, q, signature, strict) {
    if (!$a810f27cf38f4a3f$var$isScalar(hash)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_HASH);
    if (!$a810f27cf38f4a3f$var$isPoint(q)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_POINT);
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (1, isSignature enforces '< n - 1')
    if (!$a810f27cf38f4a3f$var$isSignature(signature)) throw new TypeError($a810f27cf38f4a3f$var$THROW_BAD_SIGNATURE);
    const Q = $a810f27cf38f4a3f$var$decodeFrom(q);
    const r = $a810f27cf38f4a3f$var$fromBuffer(signature.slice(0, 32));
    const s = $a810f27cf38f4a3f$var$fromBuffer(signature.slice(32, 64));
    if (strict && s.cmp($a810f27cf38f4a3f$var$nDiv2) > 0) return false;
    // 1.4.1 Enforce r and s are both integers in the interval [1, n − 1] (2, enforces '> 0')
    if (r.gtn(0) <= 0 /* || r.compareTo(n) >= 0 */ ) return false;
    if (s.gtn(0) <= 0 /* || s.compareTo(n) >= 0 */ ) return false;
    // 1.4.2 H = Hash(M), already done by the user
    // 1.4.3 e = H
    const e = $a810f27cf38f4a3f$var$fromBuffer(hash);
    // Compute s^-1
    const sInv = s.invm($a810f27cf38f4a3f$var$n);
    // 1.4.4 Compute u1 = es^−1 mod n
    //               u2 = rs^−1 mod n
    const u1 = e.mul(sInv).umod($a810f27cf38f4a3f$var$n);
    const u2 = r.mul(sInv).umod($a810f27cf38f4a3f$var$n);
    // 1.4.5 Compute R = (xR, yR)
    //               R = u1G + u2Q
    const R = $a810f27cf38f4a3f$var$G.mulAdd(u1, Q, u2);
    // 1.4.5 (cont.) Enforce R is not at infinity
    if (R.isInfinity()) return false;
    // 1.4.6 Convert the field element R.x to an integer
    const xR = R.x;
    // 1.4.7 Set v = xR mod n
    const v = xR.umod($a810f27cf38f4a3f$var$n);
    // 1.4.8 If v = r, output "valid", and if v != r, output "invalid"
    return v.eq(r);
}
$a810f27cf38f4a3f$exports = {
    isPoint: $a810f27cf38f4a3f$var$isPoint,
    isPointCompressed: $a810f27cf38f4a3f$var$isPointCompressed,
    isPrivate: $a810f27cf38f4a3f$var$isPrivate,
    pointAdd: $a810f27cf38f4a3f$var$pointAdd,
    pointAddScalar: $a810f27cf38f4a3f$var$pointAddScalar,
    pointCompress: $a810f27cf38f4a3f$var$pointCompress,
    pointFromScalar: $a810f27cf38f4a3f$var$pointFromScalar,
    pointMultiply: $a810f27cf38f4a3f$var$pointMultiply,
    privateAdd: $a810f27cf38f4a3f$var$privateAdd,
    privateSub: $a810f27cf38f4a3f$var$privateSub,
    sign: $a810f27cf38f4a3f$var$sign,
    signWithEntropy: $a810f27cf38f4a3f$var$signWithEntropy,
    verify: $a810f27cf38f4a3f$var$verify
};



var $lYlyf = parcelRequire("lYlyf");
var $ee5bf8de7b9f3154$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $ee5bf8de7b9f3154$require$Buffer = $6ZWSX.Buffer;

var $lpa1P = parcelRequire("lpa1P");
function $ee5bf8de7b9f3154$var$decodeRaw(buffer, version) {
    // check version only if defined
    if (version !== undefined && buffer[0] !== version) throw new Error("Invalid network version");
    // uncompressed
    if (buffer.length === 33) return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: false
    };
    // invalid length
    if (buffer.length !== 34) throw new Error("Invalid WIF length");
    // invalid compression flag
    if (buffer[33] !== 0x01) throw new Error("Invalid compression flag");
    return {
        version: buffer[0],
        privateKey: buffer.slice(1, 33),
        compressed: true
    };
}
function $ee5bf8de7b9f3154$var$encodeRaw(version, privateKey, compressed) {
    var result = new $ee5bf8de7b9f3154$require$Buffer(compressed ? 34 : 33);
    result.writeUInt8(version, 0);
    privateKey.copy(result, 1);
    if (compressed) result[33] = 0x01;
    return result;
}
function $ee5bf8de7b9f3154$var$decode(string, version) {
    return $ee5bf8de7b9f3154$var$decodeRaw($lpa1P.decode(string), version);
}
function $ee5bf8de7b9f3154$var$encode(version, privateKey, compressed) {
    if (typeof version === "number") return $lpa1P.encode($ee5bf8de7b9f3154$var$encodeRaw(version, privateKey, compressed));
    return $lpa1P.encode($ee5bf8de7b9f3154$var$encodeRaw(version.version, version.privateKey, version.compressed));
}
$ee5bf8de7b9f3154$exports = {
    decode: $ee5bf8de7b9f3154$var$decode,
    decodeRaw: $ee5bf8de7b9f3154$var$decodeRaw,
    encode: $ee5bf8de7b9f3154$var$encode,
    encodeRaw: $ee5bf8de7b9f3154$var$encodeRaw
};


const $36834601baa30f54$var$UINT256_TYPE = $lYlyf.BufferN(32);
const $36834601baa30f54$var$NETWORK_TYPE = $lYlyf.compile({
    wif: $lYlyf.UInt8,
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    }
});
const $36834601baa30f54$var$BITCOIN = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
const $36834601baa30f54$var$HIGHEST_BIT = 0x80000000;
const $36834601baa30f54$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $36834601baa30f54$var$BIP32Path(value) {
    return $lYlyf.String(value) && value.match(/^(m\/)?(\d+'?\/)*\d+'?$/) !== null;
}
function $36834601baa30f54$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $36834601baa30f54$var$UINT31_MAX;
}
class $36834601baa30f54$var$BIP32 {
    constructor(__D, __Q, chainCode, network, __DEPTH = 0, __INDEX = 0, __PARENT_FINGERPRINT = 0x00000000){
        this.__D = __D;
        this.__Q = __Q;
        this.chainCode = chainCode;
        this.network = network;
        this.__DEPTH = __DEPTH;
        this.__INDEX = __INDEX;
        this.__PARENT_FINGERPRINT = __PARENT_FINGERPRINT;
        $lYlyf($36834601baa30f54$var$NETWORK_TYPE, network);
        this.lowR = false;
    }
    get depth() {
        return this.__DEPTH;
    }
    get index() {
        return this.__INDEX;
    }
    get parentFingerprint() {
        return this.__PARENT_FINGERPRINT;
    }
    get publicKey() {
        if (this.__Q === undefined) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, true);
        return this.__Q;
    }
    get privateKey() {
        return this.__D;
    }
    get identifier() {
        return $9769d1c09d3e8b0c$exports.hash160(this.publicKey);
    }
    get fingerprint() {
        return this.identifier.slice(0, 4);
    }
    get compressed() {
        return true;
    }
    // Private === not neutered
    // Public === neutered
    isNeutered() {
        return this.__D === undefined;
    }
    neutered() {
        return $36834601baa30f54$var$fromPublicKeyLocal(this.publicKey, this.chainCode, this.network, this.depth, this.index, this.parentFingerprint);
    }
    toBase58() {
        const network = this.network;
        const version = !this.isNeutered() ? network.bip32.private : network.bip32.public;
        const buffer = $36834601baa30f54$require$Buffer.allocUnsafe(78);
        // 4 bytes: version bytes
        buffer.writeUInt32BE(version, 0);
        // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ....
        buffer.writeUInt8(this.depth, 4);
        // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
        buffer.writeUInt32BE(this.parentFingerprint, 5);
        // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
        // This is encoded in big endian. (0x00000000 if master key)
        buffer.writeUInt32BE(this.index, 9);
        // 32 bytes: the chain code
        this.chainCode.copy(buffer, 13);
        // 33 bytes: the public key or private key data
        if (!this.isNeutered()) {
            // 0x00 + k for private keys
            buffer.writeUInt8(0, 45);
            this.privateKey.copy(buffer, 46);
        // 33 bytes: the public key
        } else // X9.62 encoding for public keys
        this.publicKey.copy(buffer, 45);
        return $lpa1P.encode(buffer);
    }
    toWIF() {
        if (!this.privateKey) throw new TypeError("Missing private key");
        return $ee5bf8de7b9f3154$exports.encode(this.network.wif, this.privateKey, true);
    }
    // https://github.com/bitcoin/bips/blob/master/bip-0032.mediawiki#child-key-derivation-ckd-functions
    derive(index) {
        $lYlyf($lYlyf.UInt32, index);
        const isHardened = index >= $36834601baa30f54$var$HIGHEST_BIT;
        const data = $36834601baa30f54$require$Buffer.allocUnsafe(37);
        // Hardened child
        if (isHardened) {
            if (this.isNeutered()) throw new TypeError("Missing private key for hardened child key");
            // data = 0x00 || ser256(kpar) || ser32(index)
            data[0] = 0x00;
            this.privateKey.copy(data, 1);
            data.writeUInt32BE(index, 33);
        // Normal child
        } else {
            // data = serP(point(kpar)) || ser32(index)
            //      = serP(Kpar) || ser32(index)
            this.publicKey.copy(data, 0);
            data.writeUInt32BE(index, 33);
        }
        const I = $9769d1c09d3e8b0c$exports.hmacSHA512(this.chainCode, data);
        const IL = I.slice(0, 32);
        const IR = I.slice(32);
        // if parse256(IL) >= n, proceed with the next value for i
        if (!$a810f27cf38f4a3f$exports.isPrivate(IL)) return this.derive(index + 1);
        // Private parent key -> private child key
        let hd;
        if (!this.isNeutered()) {
            // ki = parse256(IL) + kpar (mod n)
            const ki = $a810f27cf38f4a3f$exports.privateAdd(this.privateKey, IL);
            // In case ki == 0, proceed with the next value for i
            if (ki == null) return this.derive(index + 1);
            hd = $36834601baa30f54$var$fromPrivateKeyLocal(ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        // Public parent key -> public child key
        } else {
            // Ki = point(parse256(IL)) + Kpar
            //    = G*IL + Kpar
            const Ki = $a810f27cf38f4a3f$exports.pointAddScalar(this.publicKey, IL, true);
            // In case Ki is the point at infinity, proceed with the next value for i
            if (Ki === null) return this.derive(index + 1);
            hd = $36834601baa30f54$var$fromPublicKeyLocal(Ki, IR, this.network, this.depth + 1, index, this.fingerprint.readUInt32BE(0));
        }
        return hd;
    }
    deriveHardened(index) {
        $lYlyf($36834601baa30f54$var$UInt31, index);
        // Only derives hardened private keys by default
        return this.derive(index + $36834601baa30f54$var$HIGHEST_BIT);
    }
    derivePath(path) {
        $lYlyf($36834601baa30f54$var$BIP32Path, path);
        let splitPath = path.split("/");
        if (splitPath[0] === "m") {
            if (this.parentFingerprint) throw new TypeError("Expected master, got child");
            splitPath = splitPath.slice(1);
        }
        return splitPath.reduce((prevHd, indexStr)=>{
            let index;
            if (indexStr.slice(-1) === `'`) {
                index = parseInt(indexStr.slice(0, -1), 10);
                return prevHd.deriveHardened(index);
            } else {
                index = parseInt(indexStr, 10);
                return prevHd.derive(index);
            }
        }, this);
    }
    sign(hash, lowR) {
        if (!this.privateKey) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.privateKey);
            const extraData = $36834601baa30f54$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.privateKey, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $36834601baa30f54$var$fromBase58(inString, network) {
    const buffer = $lpa1P.decode(inString);
    if (buffer.length !== 78) throw new TypeError("Invalid buffer length");
    network = network || $36834601baa30f54$var$BITCOIN;
    // 4 bytes: version bytes
    const version = buffer.readUInt32BE(0);
    if (version !== network.bip32.private && version !== network.bip32.public) throw new TypeError("Invalid network version");
    // 1 byte: depth: 0x00 for master nodes, 0x01 for level-1 descendants, ...
    const depth = buffer[4];
    // 4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
    const parentFingerprint = buffer.readUInt32BE(5);
    if (depth === 0) {
        if (parentFingerprint !== 0x00000000) throw new TypeError("Invalid parent fingerprint");
    }
    // 4 bytes: child number. This is the number i in xi = xpar/i, with xi the key being serialized.
    // This is encoded in MSB order. (0x00000000 if master key)
    const index = buffer.readUInt32BE(9);
    if (depth === 0 && index !== 0) throw new TypeError("Invalid index");
    // 32 bytes: the chain code
    const chainCode = buffer.slice(13, 45);
    let hd;
    // 33 bytes: private key data (0x00 + k)
    if (version === network.bip32.private) {
        if (buffer.readUInt8(45) !== 0x00) throw new TypeError("Invalid private key");
        const k = buffer.slice(46, 78);
        hd = $36834601baa30f54$var$fromPrivateKeyLocal(k, chainCode, network, depth, index, parentFingerprint);
    // 33 bytes: public key data (0x02 + X or 0x03 + X)
    } else {
        const X = buffer.slice(45, 78);
        hd = $36834601baa30f54$var$fromPublicKeyLocal(X, chainCode, network, depth, index, parentFingerprint);
    }
    return hd;
}
$36834601baa30f54$exports.fromBase58 = $36834601baa30f54$var$fromBase58;
function $36834601baa30f54$var$fromPrivateKey(privateKey, chainCode, network) {
    return $36834601baa30f54$var$fromPrivateKeyLocal(privateKey, chainCode, network);
}
$36834601baa30f54$exports.fromPrivateKey = $36834601baa30f54$var$fromPrivateKey;
function $36834601baa30f54$var$fromPrivateKeyLocal(privateKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        privateKey: $36834601baa30f54$var$UINT256_TYPE,
        chainCode: $36834601baa30f54$var$UINT256_TYPE
    }, {
        privateKey: privateKey,
        chainCode: chainCode
    });
    network = network || $36834601baa30f54$var$BITCOIN;
    if (!$a810f27cf38f4a3f$exports.isPrivate(privateKey)) throw new TypeError("Private key not in range [1, n)");
    return new $36834601baa30f54$var$BIP32(privateKey, undefined, chainCode, network, depth, index, parentFingerprint);
}
function $36834601baa30f54$var$fromPublicKey(publicKey, chainCode, network) {
    return $36834601baa30f54$var$fromPublicKeyLocal(publicKey, chainCode, network);
}
$36834601baa30f54$exports.fromPublicKey = $36834601baa30f54$var$fromPublicKey;
function $36834601baa30f54$var$fromPublicKeyLocal(publicKey, chainCode, network, depth, index, parentFingerprint) {
    $lYlyf({
        publicKey: $lYlyf.BufferN(33),
        chainCode: $36834601baa30f54$var$UINT256_TYPE
    }, {
        publicKey: publicKey,
        chainCode: chainCode
    });
    network = network || $36834601baa30f54$var$BITCOIN;
    // verify the X coordinate is a point on the curve
    if (!$a810f27cf38f4a3f$exports.isPoint(publicKey)) throw new TypeError("Point is not on the curve");
    return new $36834601baa30f54$var$BIP32(undefined, publicKey, chainCode, network, depth, index, parentFingerprint);
}
function $36834601baa30f54$var$fromSeed(seed, network) {
    $lYlyf($lYlyf.Buffer, seed);
    if (seed.length < 16) throw new TypeError("Seed should be at least 128 bits");
    if (seed.length > 64) throw new TypeError("Seed should be at most 512 bits");
    network = network || $36834601baa30f54$var$BITCOIN;
    const I = $9769d1c09d3e8b0c$exports.hmacSHA512($36834601baa30f54$require$Buffer.from("Bitcoin seed", "utf8"), seed);
    const IL = I.slice(0, 32);
    const IR = I.slice(32);
    return $36834601baa30f54$var$fromPrivateKey(IL, IR, network);
}
$36834601baa30f54$exports.fromSeed = $36834601baa30f54$var$fromSeed;


$e7857d72cbf401cb$exports.fromSeed = $36834601baa30f54$exports.fromSeed;
$e7857d72cbf401cb$exports.fromBase58 = $36834601baa30f54$exports.fromBase58;
$e7857d72cbf401cb$exports.fromPublicKey = $36834601baa30f54$exports.fromPublicKey;
$e7857d72cbf401cb$exports.fromPrivateKey = $36834601baa30f54$exports.fromPrivateKey;


$58cf3bc07eb2f0ea$exports.bip32 = $e7857d72cbf401cb$exports;
var $d26ee8edcbfb8f9e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $d26ee8edcbfb8f9e$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($d26ee8edcbfb8f9e$exports, "__esModule", {
    value: true
});
var $a2ef7e6d3e9bbe84$exports = {};
"use strict";
Object.defineProperty($a2ef7e6d3e9bbe84$exports, "__esModule", {
    value: true
});
$a2ef7e6d3e9bbe84$exports.bitcoin = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bc",
    bip32: {
        public: 0x0488b21e,
        private: 0x0488ade4
    },
    pubKeyHash: 0x00,
    scriptHash: 0x05,
    wif: 0x80
};
$a2ef7e6d3e9bbe84$exports.regtest = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "bcrt",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
$a2ef7e6d3e9bbe84$exports.testnet = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};


var $bed04000b8455fa3$exports = {};
"use strict";
Object.defineProperty($bed04000b8455fa3$exports, "__esModule", {
    value: true
});
var $3fad3c5a0cca36a9$exports = {};
"use strict";
Object.defineProperty($3fad3c5a0cca36a9$exports, "__esModule", {
    value: true
});

var $a6e22d0fc87b0ff4$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a6e22d0fc87b0ff4$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($a6e22d0fc87b0ff4$exports, "__esModule", {
    value: true
});
var $389c14a14ca9a542$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $389c14a14ca9a542$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($389c14a14ca9a542$exports, "__esModule", {
    value: true
});
function $389c14a14ca9a542$var$decode(buffer, maxLength, minimal) {
    maxLength = maxLength || 4;
    minimal = minimal === undefined ? true : minimal;
    const length = buffer.length;
    if (length === 0) return 0;
    if (length > maxLength) throw new TypeError("Script number overflow");
    if (minimal) {
        if ((buffer[length - 1] & 0x7f) === 0) {
            if (length <= 1 || (buffer[length - 2] & 0x80) === 0) throw new Error("Non-minimally encoded script number");
        }
    }
    // 40-bit
    if (length === 5) {
        const a = buffer.readUInt32LE(0);
        const b = buffer.readUInt8(4);
        if (b & 0x80) return -((b & -129) * 0x100000000 + a);
        return b * 0x100000000 + a;
    }
    // 32-bit / 24-bit / 16-bit / 8-bit
    let result = 0;
    for(let i = 0; i < length; ++i)result |= buffer[i] << 8 * i;
    if (buffer[length - 1] & 0x80) return -(result & ~(0x80 << 8 * (length - 1)));
    return result;
}
$389c14a14ca9a542$exports.decode = $389c14a14ca9a542$var$decode;
function $389c14a14ca9a542$var$scriptNumSize(i) {
    return i > 0x7fffffff ? 5 : i > 0x7fffff ? 4 : i > 0x7fff ? 3 : i > 0x7f ? 2 : i > 0x00 ? 1 : 0;
}
function $389c14a14ca9a542$var$encode(_number) {
    let value = Math.abs(_number);
    const size = $389c14a14ca9a542$var$scriptNumSize(value);
    const buffer = $389c14a14ca9a542$require$Buffer.allocUnsafe(size);
    const negative = _number < 0;
    for(let i = 0; i < size; ++i){
        buffer.writeUInt8(value & 0xff, i);
        value >>= 8;
    }
    if (buffer[size - 1] & 0x80) buffer.writeUInt8(negative ? 0x80 : 0x00, size - 1);
    else if (negative) buffer[size - 1] |= 0x80;
    return buffer;
}
$389c14a14ca9a542$exports.encode = $389c14a14ca9a542$var$encode;


var $ffb242255079930e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $ffb242255079930e$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($ffb242255079930e$exports, "__esModule", {
    value: true
});
var $e79ff6cff6024683$exports = {};
"use strict";
Object.defineProperty($e79ff6cff6024683$exports, "__esModule", {
    value: true
});

var $lYlyf = parcelRequire("lYlyf");
const $e79ff6cff6024683$var$UINT31_MAX = Math.pow(2, 31) - 1;
function $e79ff6cff6024683$var$UInt31(value) {
    return $lYlyf.UInt32(value) && value <= $e79ff6cff6024683$var$UINT31_MAX;
}
$e79ff6cff6024683$exports.UInt31 = $e79ff6cff6024683$var$UInt31;
function $e79ff6cff6024683$var$BIP32Path(value) {
    return $lYlyf.String(value) && !!value.match(/^(m\/)?(\d+'?\/)*\d+'?$/);
}
$e79ff6cff6024683$exports.BIP32Path = $e79ff6cff6024683$var$BIP32Path;
$e79ff6cff6024683$var$BIP32Path.toJSON = ()=>{
    return "BIP32 derivation path";
};
function $e79ff6cff6024683$var$Signer(obj) {
    return ($lYlyf.Buffer(obj.publicKey) || typeof obj.getPublicKey === "function") && typeof obj.sign === "function";
}
$e79ff6cff6024683$exports.Signer = $e79ff6cff6024683$var$Signer;
const $e79ff6cff6024683$var$SATOSHI_MAX = 21 * 1e14;
function $e79ff6cff6024683$var$Satoshi(value) {
    return $lYlyf.UInt53(value) && value <= $e79ff6cff6024683$var$SATOSHI_MAX;
}
$e79ff6cff6024683$exports.Satoshi = $e79ff6cff6024683$var$Satoshi;
// external dependent types
$e79ff6cff6024683$exports.ECPoint = $lYlyf.quacksLike("Point");
// exposed, external API
$e79ff6cff6024683$exports.Network = $lYlyf.compile({
    messagePrefix: $lYlyf.oneOf($lYlyf.Buffer, $lYlyf.String),
    bip32: {
        public: $lYlyf.UInt32,
        private: $lYlyf.UInt32
    },
    pubKeyHash: $lYlyf.UInt8,
    scriptHash: $lYlyf.UInt8,
    wif: $lYlyf.UInt8
});
$e79ff6cff6024683$exports.Buffer256bit = $lYlyf.BufferN(32);
$e79ff6cff6024683$exports.Hash160bit = $lYlyf.BufferN(20);
$e79ff6cff6024683$exports.Hash256bit = $lYlyf.BufferN(32);
$e79ff6cff6024683$exports.Number = $lYlyf.Number; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.Array = $lYlyf.Array;
$e79ff6cff6024683$exports.Boolean = $lYlyf.Boolean; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.String = $lYlyf.String; // tslint:disable-line variable-name
$e79ff6cff6024683$exports.Buffer = $lYlyf.Buffer;
$e79ff6cff6024683$exports.Hex = $lYlyf.Hex;
$e79ff6cff6024683$exports.maybe = $lYlyf.maybe;
$e79ff6cff6024683$exports.tuple = $lYlyf.tuple;
$e79ff6cff6024683$exports.UInt8 = $lYlyf.UInt8;
$e79ff6cff6024683$exports.UInt32 = $lYlyf.UInt32;
$e79ff6cff6024683$exports.Function = $lYlyf.Function;
$e79ff6cff6024683$exports.BufferN = $lYlyf.BufferN;
$e79ff6cff6024683$exports.Null = $lYlyf.Null;
$e79ff6cff6024683$exports.oneOf = $lYlyf.oneOf;


var $664727cfba118c74$exports = {};
// Reference https://github.com/bitcoin/bips/blob/master/bip-0066.mediawiki
// Format: 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
// NOTE: SIGHASH byte ignored AND restricted, truncate before use

var $1U9GM = parcelRequire("1U9GM");
var $664727cfba118c74$require$Buffer = $1U9GM.Buffer;
function $664727cfba118c74$var$check(buffer) {
    if (buffer.length < 8) return false;
    if (buffer.length > 72) return false;
    if (buffer[0] !== 0x30) return false;
    if (buffer[1] !== buffer.length - 2) return false;
    if (buffer[2] !== 0x02) return false;
    var lenR = buffer[3];
    if (lenR === 0) return false;
    if (5 + lenR >= buffer.length) return false;
    if (buffer[4 + lenR] !== 0x02) return false;
    var lenS = buffer[5 + lenR];
    if (lenS === 0) return false;
    if (6 + lenR + lenS !== buffer.length) return false;
    if (buffer[4] & 0x80) return false;
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) return false;
    if (buffer[lenR + 6] & 0x80) return false;
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) return false;
    return true;
}
function $664727cfba118c74$var$decode(buffer) {
    if (buffer.length < 8) throw new Error("DER sequence length is too short");
    if (buffer.length > 72) throw new Error("DER sequence length is too long");
    if (buffer[0] !== 0x30) throw new Error("Expected DER sequence");
    if (buffer[1] !== buffer.length - 2) throw new Error("DER sequence length is invalid");
    if (buffer[2] !== 0x02) throw new Error("Expected DER integer");
    var lenR = buffer[3];
    if (lenR === 0) throw new Error("R length is zero");
    if (5 + lenR >= buffer.length) throw new Error("R length is too long");
    if (buffer[4 + lenR] !== 0x02) throw new Error("Expected DER integer (2)");
    var lenS = buffer[5 + lenR];
    if (lenS === 0) throw new Error("S length is zero");
    if (6 + lenR + lenS !== buffer.length) throw new Error("S length is invalid");
    if (buffer[4] & 0x80) throw new Error("R value is negative");
    if (lenR > 1 && buffer[4] === 0x00 && !(buffer[5] & 0x80)) throw new Error("R value excessively padded");
    if (buffer[lenR + 6] & 0x80) throw new Error("S value is negative");
    if (lenS > 1 && buffer[lenR + 6] === 0x00 && !(buffer[lenR + 7] & 0x80)) throw new Error("S value excessively padded");
    // non-BIP66 - extract R, S values
    return {
        r: buffer.slice(4, 4 + lenR),
        s: buffer.slice(6 + lenR)
    };
}
/*
 * Expects r and s to be positive DER integers.
 *
 * The DER format uses the most significant bit as a sign bit (& 0x80).
 * If the significant bit is set AND the integer is positive, a 0x00 is prepended.
 *
 * Examples:
 *
 *      0 =>     0x00
 *      1 =>     0x01
 *     -1 =>     0xff
 *    127 =>     0x7f
 *   -127 =>     0x81
 *    128 =>   0x0080
 *   -128 =>     0x80
 *    255 =>   0x00ff
 *   -255 =>   0xff01
 *  16300 =>   0x3fac
 * -16300 =>   0xc054
 *  62300 => 0x00f35c
 * -62300 => 0xff0ca4
*/ function $664727cfba118c74$var$encode(r, s) {
    var lenR = r.length;
    var lenS = s.length;
    if (lenR === 0) throw new Error("R length is zero");
    if (lenS === 0) throw new Error("S length is zero");
    if (lenR > 33) throw new Error("R length is too long");
    if (lenS > 33) throw new Error("S length is too long");
    if (r[0] & 0x80) throw new Error("R value is negative");
    if (s[0] & 0x80) throw new Error("S value is negative");
    if (lenR > 1 && r[0] === 0x00 && !(r[1] & 0x80)) throw new Error("R value excessively padded");
    if (lenS > 1 && s[0] === 0x00 && !(s[1] & 0x80)) throw new Error("S value excessively padded");
    var signature = $664727cfba118c74$require$Buffer.allocUnsafe(6 + lenR + lenS);
    // 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S]
    signature[0] = 0x30;
    signature[1] = signature.length - 2;
    signature[2] = 0x02;
    signature[3] = r.length;
    r.copy(signature, 4);
    signature[4 + lenR] = 0x02;
    signature[5 + lenR] = s.length;
    s.copy(signature, 6 + lenR);
    return signature;
}
$664727cfba118c74$exports = {
    check: $664727cfba118c74$var$check,
    decode: $664727cfba118c74$var$decode,
    encode: $664727cfba118c74$var$encode
};



var $lYlyf = parcelRequire("lYlyf");
const $ffb242255079930e$var$ZERO = $ffb242255079930e$require$Buffer.alloc(1, 0);
function $ffb242255079930e$var$toDER(x) {
    let i = 0;
    while(x[i] === 0)++i;
    if (i === x.length) return $ffb242255079930e$var$ZERO;
    x = x.slice(i);
    if (x[0] & 0x80) return $ffb242255079930e$require$Buffer.concat([
        $ffb242255079930e$var$ZERO,
        x
    ], 1 + x.length);
    return x;
}
function $ffb242255079930e$var$fromDER(x) {
    if (x[0] === 0x00) x = x.slice(1);
    const buffer = $ffb242255079930e$require$Buffer.alloc(32, 0);
    const bstart = Math.max(0, 32 - x.length);
    x.copy(buffer, bstart);
    return buffer;
}
// BIP62: 1 byte hashType flag (only 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 are allowed)
function $ffb242255079930e$var$decode(buffer) {
    const hashType = buffer.readUInt8(buffer.length - 1);
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const decoded = $664727cfba118c74$exports.decode(buffer.slice(0, -1));
    const r = $ffb242255079930e$var$fromDER(decoded.r);
    const s = $ffb242255079930e$var$fromDER(decoded.s);
    const signature = $ffb242255079930e$require$Buffer.concat([
        r,
        s
    ], 64);
    return {
        signature: signature,
        hashType: hashType
    };
}
$ffb242255079930e$exports.decode = $ffb242255079930e$var$decode;
function $ffb242255079930e$var$encode(signature, hashType) {
    $lYlyf({
        signature: $e79ff6cff6024683$exports.BufferN(64),
        hashType: $e79ff6cff6024683$exports.UInt8
    }, {
        signature: signature,
        hashType: hashType
    });
    const hashTypeMod = hashType & -129;
    if (hashTypeMod <= 0 || hashTypeMod >= 4) throw new Error("Invalid hashType " + hashType);
    const hashTypeBuffer = $ffb242255079930e$require$Buffer.allocUnsafe(1);
    hashTypeBuffer.writeUInt8(hashType, 0);
    const r = $ffb242255079930e$var$toDER(signature.slice(0, 32));
    const s = $ffb242255079930e$var$toDER(signature.slice(32, 64));
    return $ffb242255079930e$require$Buffer.concat([
        $664727cfba118c74$exports.encode(r, s),
        hashTypeBuffer
    ]);
}
$ffb242255079930e$exports.encode = $ffb242255079930e$var$encode;





var $8ae9eecf784e7432$exports = {};

var $7dYL4 = parcelRequire("7dYL4");
function $8ae9eecf784e7432$var$encodingLength(i) {
    return i < $7dYL4.OP_PUSHDATA1 ? 1 : i <= 0xff ? 2 : i <= 0xffff ? 3 : 5;
}
function $8ae9eecf784e7432$var$encode(buffer, number, offset) {
    var size = $8ae9eecf784e7432$var$encodingLength(number);
    // ~6 bit
    if (size === 1) buffer.writeUInt8(number, offset);
    else if (size === 2) {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA1, offset);
        buffer.writeUInt8(number, offset + 1);
    // 16 bit
    } else if (size === 3) {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA2, offset);
        buffer.writeUInt16LE(number, offset + 1);
    // 32 bit
    } else {
        buffer.writeUInt8($7dYL4.OP_PUSHDATA4, offset);
        buffer.writeUInt32LE(number, offset + 1);
    }
    return size;
}
function $8ae9eecf784e7432$var$decode(buffer, offset) {
    var opcode = buffer.readUInt8(offset);
    var number, size;
    // ~6 bit
    if (opcode < $7dYL4.OP_PUSHDATA1) {
        number = opcode;
        size = 1;
    // 8 bit
    } else if (opcode === $7dYL4.OP_PUSHDATA1) {
        if (offset + 2 > buffer.length) return null;
        number = buffer.readUInt8(offset + 1);
        size = 2;
    // 16 bit
    } else if (opcode === $7dYL4.OP_PUSHDATA2) {
        if (offset + 3 > buffer.length) return null;
        number = buffer.readUInt16LE(offset + 1);
        size = 3;
    // 32 bit
    } else {
        if (offset + 5 > buffer.length) return null;
        if (opcode !== $7dYL4.OP_PUSHDATA4) throw new Error("Unexpected opcode");
        number = buffer.readUInt32LE(offset + 1);
        size = 5;
    }
    return {
        opcode: opcode,
        number: number,
        size: size
    };
}
$8ae9eecf784e7432$exports = {
    encodingLength: $8ae9eecf784e7432$var$encodingLength,
    encode: $8ae9eecf784e7432$var$encode,
    decode: $8ae9eecf784e7432$var$decode
};



var $lYlyf = parcelRequire("lYlyf");

$a6e22d0fc87b0ff4$exports.OPS = (parcelRequire("7dYL4"));
var $e70cbce69bba10e9$exports = {};

var $7dYL4 = parcelRequire("7dYL4");
var $e70cbce69bba10e9$var$map = {};
for(var $e70cbce69bba10e9$var$op in $7dYL4){
    var $e70cbce69bba10e9$var$code = $7dYL4[$e70cbce69bba10e9$var$op];
    $e70cbce69bba10e9$var$map[$e70cbce69bba10e9$var$code] = $e70cbce69bba10e9$var$op;
}
$e70cbce69bba10e9$exports = $e70cbce69bba10e9$var$map;


const $a6e22d0fc87b0ff4$var$OP_INT_BASE = $a6e22d0fc87b0ff4$exports.OPS.OP_RESERVED; // OP_1 - 1
function $a6e22d0fc87b0ff4$var$isOPInt(value) {
    return $e79ff6cff6024683$exports.Number(value) && (value === $a6e22d0fc87b0ff4$exports.OPS.OP_0 || value >= $a6e22d0fc87b0ff4$exports.OPS.OP_1 && value <= $a6e22d0fc87b0ff4$exports.OPS.OP_16 || value === $a6e22d0fc87b0ff4$exports.OPS.OP_1NEGATE);
}
function $a6e22d0fc87b0ff4$var$isPushOnlyChunk(value) {
    return $e79ff6cff6024683$exports.Buffer(value) || $a6e22d0fc87b0ff4$var$isOPInt(value);
}
function $a6e22d0fc87b0ff4$var$isPushOnly(value) {
    return $e79ff6cff6024683$exports.Array(value) && value.every($a6e22d0fc87b0ff4$var$isPushOnlyChunk);
}
$a6e22d0fc87b0ff4$exports.isPushOnly = $a6e22d0fc87b0ff4$var$isPushOnly;
function $a6e22d0fc87b0ff4$var$asMinimalOP(buffer) {
    if (buffer.length === 0) return $a6e22d0fc87b0ff4$exports.OPS.OP_0;
    if (buffer.length !== 1) return;
    if (buffer[0] >= 1 && buffer[0] <= 16) return $a6e22d0fc87b0ff4$var$OP_INT_BASE + buffer[0];
    if (buffer[0] === 0x81) return $a6e22d0fc87b0ff4$exports.OPS.OP_1NEGATE;
}
function $a6e22d0fc87b0ff4$var$chunksIsBuffer(buf) {
    return $a6e22d0fc87b0ff4$require$Buffer.isBuffer(buf);
}
function $a6e22d0fc87b0ff4$var$chunksIsArray(buf) {
    return $e79ff6cff6024683$exports.Array(buf);
}
function $a6e22d0fc87b0ff4$var$singleChunkIsBuffer(buf) {
    return $a6e22d0fc87b0ff4$require$Buffer.isBuffer(buf);
}
function $a6e22d0fc87b0ff4$var$compile(chunks) {
    // TODO: remove me
    if ($a6e22d0fc87b0ff4$var$chunksIsBuffer(chunks)) return chunks;
    $lYlyf($e79ff6cff6024683$exports.Array, chunks);
    const bufferSize = chunks.reduce((accum, chunk)=>{
        // data chunk
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            if (chunk.length === 1 && $a6e22d0fc87b0ff4$var$asMinimalOP(chunk) !== undefined) return accum + 1;
            return accum + $8ae9eecf784e7432$exports.encodingLength(chunk.length) + chunk.length;
        }
        // opcode
        return accum + 1;
    }, 0.0);
    const buffer = $a6e22d0fc87b0ff4$require$Buffer.allocUnsafe(bufferSize);
    let offset = 0;
    chunks.forEach((chunk)=>{
        // data chunk
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            // adhere to BIP62.3, minimal push policy
            const opcode = $a6e22d0fc87b0ff4$var$asMinimalOP(chunk);
            if (opcode !== undefined) {
                buffer.writeUInt8(opcode, offset);
                offset += 1;
                return;
            }
            offset += $8ae9eecf784e7432$exports.encode(buffer, chunk.length, offset);
            chunk.copy(buffer, offset);
            offset += chunk.length;
        // opcode
        } else {
            buffer.writeUInt8(chunk, offset);
            offset += 1;
        }
    });
    if (offset !== buffer.length) throw new Error("Could not decode chunks");
    return buffer;
}
$a6e22d0fc87b0ff4$exports.compile = $a6e22d0fc87b0ff4$var$compile;
function $a6e22d0fc87b0ff4$var$decompile(buffer) {
    // TODO: remove me
    if ($a6e22d0fc87b0ff4$var$chunksIsArray(buffer)) return buffer;
    $lYlyf($e79ff6cff6024683$exports.Buffer, buffer);
    const chunks = [];
    let i = 0;
    while(i < buffer.length){
        const opcode = buffer[i];
        // data chunk
        if (opcode > $a6e22d0fc87b0ff4$exports.OPS.OP_0 && opcode <= $a6e22d0fc87b0ff4$exports.OPS.OP_PUSHDATA4) {
            const d = $8ae9eecf784e7432$exports.decode(buffer, i);
            // did reading a pushDataInt fail?
            if (d === null) return null;
            i += d.size;
            // attempt to read too much data?
            if (i + d.number > buffer.length) return null;
            const data = buffer.slice(i, i + d.number);
            i += d.number;
            // decompile minimally
            const op = $a6e22d0fc87b0ff4$var$asMinimalOP(data);
            if (op !== undefined) chunks.push(op);
            else chunks.push(data);
        // opcode
        } else {
            chunks.push(opcode);
            i += 1;
        }
    }
    return chunks;
}
$a6e22d0fc87b0ff4$exports.decompile = $a6e22d0fc87b0ff4$var$decompile;
function $a6e22d0fc87b0ff4$var$toASM(chunks) {
    if ($a6e22d0fc87b0ff4$var$chunksIsBuffer(chunks)) chunks = $a6e22d0fc87b0ff4$var$decompile(chunks);
    return chunks.map((chunk)=>{
        // data?
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(chunk)) {
            const op = $a6e22d0fc87b0ff4$var$asMinimalOP(chunk);
            if (op === undefined) return chunk.toString("hex");
            chunk = op;
        }
        // opcode!
        return $e70cbce69bba10e9$exports[chunk];
    }).join(" ");
}
$a6e22d0fc87b0ff4$exports.toASM = $a6e22d0fc87b0ff4$var$toASM;
function $a6e22d0fc87b0ff4$var$fromASM(asm) {
    $lYlyf($e79ff6cff6024683$exports.String, asm);
    return $a6e22d0fc87b0ff4$var$compile(asm.split(" ").map((chunkStr)=>{
        // opcode?
        if ($a6e22d0fc87b0ff4$exports.OPS[chunkStr] !== undefined) return $a6e22d0fc87b0ff4$exports.OPS[chunkStr];
        $lYlyf($e79ff6cff6024683$exports.Hex, chunkStr);
        // data!
        return $a6e22d0fc87b0ff4$require$Buffer.from(chunkStr, "hex");
    }));
}
$a6e22d0fc87b0ff4$exports.fromASM = $a6e22d0fc87b0ff4$var$fromASM;
function $a6e22d0fc87b0ff4$var$toStack(chunks) {
    chunks = $a6e22d0fc87b0ff4$var$decompile(chunks);
    $lYlyf($a6e22d0fc87b0ff4$var$isPushOnly, chunks);
    return chunks.map((op)=>{
        if ($a6e22d0fc87b0ff4$var$singleChunkIsBuffer(op)) return op;
        if (op === $a6e22d0fc87b0ff4$exports.OPS.OP_0) return $a6e22d0fc87b0ff4$require$Buffer.allocUnsafe(0);
        return $389c14a14ca9a542$exports.encode(op - $a6e22d0fc87b0ff4$var$OP_INT_BASE);
    });
}
$a6e22d0fc87b0ff4$exports.toStack = $a6e22d0fc87b0ff4$var$toStack;
function $a6e22d0fc87b0ff4$var$isCanonicalPubKey(buffer) {
    return $a810f27cf38f4a3f$exports.isPoint(buffer);
}
$a6e22d0fc87b0ff4$exports.isCanonicalPubKey = $a6e22d0fc87b0ff4$var$isCanonicalPubKey;
function $a6e22d0fc87b0ff4$var$isDefinedHashType(hashType) {
    const hashTypeMod = hashType & -129;
    // return hashTypeMod > SIGHASH_ALL && hashTypeMod < SIGHASH_SINGLE
    return hashTypeMod > 0x00 && hashTypeMod < 0x04;
}
$a6e22d0fc87b0ff4$exports.isDefinedHashType = $a6e22d0fc87b0ff4$var$isDefinedHashType;
function $a6e22d0fc87b0ff4$var$isCanonicalScriptSignature(buffer) {
    if (!$a6e22d0fc87b0ff4$require$Buffer.isBuffer(buffer)) return false;
    if (!$a6e22d0fc87b0ff4$var$isDefinedHashType(buffer[buffer.length - 1])) return false;
    return $664727cfba118c74$exports.check(buffer.slice(0, -1));
}
$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature = $a6e22d0fc87b0ff4$var$isCanonicalScriptSignature;
// tslint:disable-next-line variable-name
$a6e22d0fc87b0ff4$exports.number = $389c14a14ca9a542$exports;
$a6e22d0fc87b0ff4$exports.signature = $ffb242255079930e$exports;


var $8e81aa4b8a918bf8$exports = {};
"use strict";
Object.defineProperty($8e81aa4b8a918bf8$exports, "__esModule", {
    value: true
});
function $8e81aa4b8a918bf8$var$prop(object, name, f) {
    Object.defineProperty(object, name, {
        configurable: true,
        enumerable: true,
        get () {
            const _value = f.call(this);
            this[name] = _value;
            return _value;
        },
        set (_value) {
            Object.defineProperty(this, name, {
                configurable: true,
                enumerable: true,
                value: _value,
                writable: true
            });
        }
    });
}
$8e81aa4b8a918bf8$exports.prop = $8e81aa4b8a918bf8$var$prop;
function $8e81aa4b8a918bf8$var$value(f) {
    let _value;
    return ()=>{
        if (_value !== undefined) return _value;
        _value = f();
        return _value;
    };
}
$8e81aa4b8a918bf8$exports.value = $8e81aa4b8a918bf8$var$value;



var $lYlyf = parcelRequire("lYlyf");
const $3fad3c5a0cca36a9$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;
function $3fad3c5a0cca36a9$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// output: OP_RETURN ...
function $3fad3c5a0cca36a9$var$p2data(a, opts) {
    if (!a.data && !a.output) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        data: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: "embed",
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!a.data) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $3fad3c5a0cca36a9$var$OPS.OP_RETURN
        ].concat(a.data));
    });
    $8e81aa4b8a918bf8$exports.prop(o, "data", ()=>{
        if (!a.output) return;
        return $a6e22d0fc87b0ff4$exports.decompile(a.output).slice(1);
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            const chunks = $a6e22d0fc87b0ff4$exports.decompile(a.output);
            if (chunks[0] !== $3fad3c5a0cca36a9$var$OPS.OP_RETURN) throw new TypeError("Output is invalid");
            if (!chunks.slice(1).every($lYlyf.Buffer)) throw new TypeError("Output is invalid");
            if (a.data && !$3fad3c5a0cca36a9$var$stacksEqual(a.data, o.data)) throw new TypeError("Data mismatch");
        }
    }
    return Object.assign(o, a);
}
$3fad3c5a0cca36a9$exports.p2data = $3fad3c5a0cca36a9$var$p2data;


$bed04000b8455fa3$exports.embed = $3fad3c5a0cca36a9$exports.p2data;
var $c5aef82e09ea7e36$exports = {};
"use strict";
Object.defineProperty($c5aef82e09ea7e36$exports, "__esModule", {
    value: true
});



const $c5aef82e09ea7e36$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $lYlyf = parcelRequire("lYlyf");

const $c5aef82e09ea7e36$var$OP_INT_BASE = $c5aef82e09ea7e36$var$OPS.OP_RESERVED; // OP_1 - 1
function $c5aef82e09ea7e36$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: OP_0 [signatures ...]
// output: m [pubKeys ...] n OP_CHECKMULTISIG
function $c5aef82e09ea7e36$var$p2ms(a, opts) {
    if (!a.input && !a.output && !(a.pubkeys && a.m !== undefined) && !a.signatures) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    function isAcceptableSignature(x) {
        return $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(x) || (opts.allowIncomplete && x === $c5aef82e09ea7e36$var$OPS.OP_0) !== undefined;
    }
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        m: $lYlyf.maybe($lYlyf.Number),
        n: $lYlyf.maybe($lYlyf.Number),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkeys: $lYlyf.maybe($lYlyf.arrayOf($a810f27cf38f4a3f$exports.isPoint)),
        signatures: $lYlyf.maybe($lYlyf.arrayOf(isAcceptableSignature)),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    let chunks = [];
    let decoded = false;
    function decode(output) {
        if (decoded) return;
        decoded = true;
        chunks = $a6e22d0fc87b0ff4$exports.decompile(output);
        o.m = chunks[0] - $c5aef82e09ea7e36$var$OP_INT_BASE;
        o.n = chunks[chunks.length - 2] - $c5aef82e09ea7e36$var$OP_INT_BASE;
        o.pubkeys = chunks.slice(1, -2);
    }
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!a.m) return;
        if (!o.n) return;
        if (!a.pubkeys) return;
        return $a6e22d0fc87b0ff4$exports.compile([].concat($c5aef82e09ea7e36$var$OP_INT_BASE + a.m, a.pubkeys, $c5aef82e09ea7e36$var$OP_INT_BASE + o.n, $c5aef82e09ea7e36$var$OPS.OP_CHECKMULTISIG));
    });
    $8e81aa4b8a918bf8$exports.prop(o, "m", ()=>{
        if (!o.output) return;
        decode(o.output);
        return o.m;
    });
    $8e81aa4b8a918bf8$exports.prop(o, "n", ()=>{
        if (!o.pubkeys) return;
        return o.pubkeys.length;
    });
    $8e81aa4b8a918bf8$exports.prop(o, "pubkeys", ()=>{
        if (!a.output) return;
        decode(a.output);
        return o.pubkeys;
    });
    $8e81aa4b8a918bf8$exports.prop(o, "signatures", ()=>{
        if (!a.input) return;
        return $a6e22d0fc87b0ff4$exports.decompile(a.input).slice(1);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!a.signatures) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $c5aef82e09ea7e36$var$OPS.OP_0
        ].concat(a.signatures));
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "name", ()=>{
        if (!o.m || !o.n) return;
        return `p2ms(${o.m} of ${o.n})`;
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            decode(a.output);
            if (!$lYlyf.Number(chunks[0])) throw new TypeError("Output is invalid");
            if (!$lYlyf.Number(chunks[chunks.length - 2])) throw new TypeError("Output is invalid");
            if (chunks[chunks.length - 1] !== $c5aef82e09ea7e36$var$OPS.OP_CHECKMULTISIG) throw new TypeError("Output is invalid");
            if (o.m <= 0 || o.n > 16 || o.m > o.n || o.n !== chunks.length - 3) throw new TypeError("Output is invalid");
            if (!o.pubkeys.every((x)=>$a810f27cf38f4a3f$exports.isPoint(x))) throw new TypeError("Output is invalid");
            if (a.m !== undefined && a.m !== o.m) throw new TypeError("m mismatch");
            if (a.n !== undefined && a.n !== o.n) throw new TypeError("n mismatch");
            if (a.pubkeys && !$c5aef82e09ea7e36$var$stacksEqual(a.pubkeys, o.pubkeys)) throw new TypeError("Pubkeys mismatch");
        }
        if (a.pubkeys) {
            if (a.n !== undefined && a.n !== a.pubkeys.length) throw new TypeError("Pubkey count mismatch");
            o.n = a.pubkeys.length;
            if (o.n < o.m) throw new TypeError("Pubkey count cannot be less than m");
        }
        if (a.signatures) {
            if (a.signatures.length < o.m) throw new TypeError("Not enough signatures provided");
            if (a.signatures.length > o.m) throw new TypeError("Too many signatures provided");
        }
        if (a.input) {
            if (a.input[0] !== $c5aef82e09ea7e36$var$OPS.OP_0) throw new TypeError("Input is invalid");
            if (o.signatures.length === 0 || !o.signatures.every(isAcceptableSignature)) throw new TypeError("Input has invalid signature(s)");
            if (a.signatures && !$c5aef82e09ea7e36$var$stacksEqual(a.signatures, o.signatures)) throw new TypeError("Signature mismatch");
            if (a.m !== undefined && a.m !== a.signatures.length) throw new TypeError("Signature count mismatch");
        }
    }
    return Object.assign(o, a);
}
$c5aef82e09ea7e36$exports.p2ms = $c5aef82e09ea7e36$var$p2ms;


$bed04000b8455fa3$exports.p2ms = $c5aef82e09ea7e36$exports.p2ms;
var $f96c9ec15be99b45$exports = {};
"use strict";
Object.defineProperty($f96c9ec15be99b45$exports, "__esModule", {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $f96c9ec15be99b45$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

// input: {signature}
// output: {pubKey} OP_CHECKSIG
function $f96c9ec15be99b45$var$p2pk(a, opts) {
    if (!a.input && !a.output && !a.pubkey && !a.input && !a.signature) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.Buffer),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: "p2pk",
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!a.pubkey) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.pubkey,
            $f96c9ec15be99b45$var$OPS.OP_CHECKSIG
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "pubkey", ()=>{
        if (!a.output) return;
        return a.output.slice(1, -1);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!a.signature) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.signature
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        if (a.output) {
            if (a.output[a.output.length - 1] !== $f96c9ec15be99b45$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            if (!$a810f27cf38f4a3f$exports.isPoint(o.pubkey)) throw new TypeError("Output pubkey is invalid");
            if (a.pubkey && !a.pubkey.equals(o.pubkey)) throw new TypeError("Pubkey mismatch");
        }
        if (a.signature) {
            if (a.input && !a.input.equals(o.input)) throw new TypeError("Signature mismatch");
        }
        if (a.input) {
            if (_chunks().length !== 1) throw new TypeError("Input is invalid");
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(o.signature)) throw new TypeError("Input has invalid signature");
        }
    }
    return Object.assign(o, a);
}
$f96c9ec15be99b45$exports.p2pk = $f96c9ec15be99b45$var$p2pk;


$bed04000b8455fa3$exports.p2pk = $f96c9ec15be99b45$exports.p2pk;
var $489bf4ac17a296db$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $489bf4ac17a296db$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($489bf4ac17a296db$exports, "__esModule", {
    value: true
});
var $1c834b456d93f732$exports = {};
"use strict";
Object.defineProperty($1c834b456d93f732$exports, "__esModule", {
    value: true
});

var $1R2J7 = parcelRequire("1R2J7");
function $1c834b456d93f732$var$ripemd160(buffer) {
    try {
        return $1R2J7("rmd160").update(buffer).digest();
    } catch (err) {
        return $1R2J7("ripemd160").update(buffer).digest();
    }
}
$1c834b456d93f732$exports.ripemd160 = $1c834b456d93f732$var$ripemd160;
function $1c834b456d93f732$var$sha1(buffer) {
    return $1R2J7("sha1").update(buffer).digest();
}
$1c834b456d93f732$exports.sha1 = $1c834b456d93f732$var$sha1;
function $1c834b456d93f732$var$sha256(buffer) {
    return $1R2J7("sha256").update(buffer).digest();
}
$1c834b456d93f732$exports.sha256 = $1c834b456d93f732$var$sha256;
function $1c834b456d93f732$var$hash160(buffer) {
    return $1c834b456d93f732$var$ripemd160($1c834b456d93f732$var$sha256(buffer));
}
$1c834b456d93f732$exports.hash160 = $1c834b456d93f732$var$hash160;
function $1c834b456d93f732$var$hash256(buffer) {
    return $1c834b456d93f732$var$sha256($1c834b456d93f732$var$sha256(buffer));
}
$1c834b456d93f732$exports.hash256 = $1c834b456d93f732$var$hash256;






var $lYlyf = parcelRequire("lYlyf");
const $489bf4ac17a296db$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;


var $lpa1P = parcelRequire("lpa1P");
// input: {signature} {pubkey}
// output: OP_DUP OP_HASH160 {hash160(pubkey)} OP_EQUALVERIFY OP_CHECKSIG
function $489bf4ac17a296db$var$p2pkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(25)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        input: $lYlyf.maybe($lYlyf.Buffer)
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: "p2pkh",
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $489bf4ac17a296db$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(network.pubKeyHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(3, 23);
        if (a.address) return _address().hash;
        if (a.pubkey || o.pubkey) return $1c834b456d93f732$exports.hash160(a.pubkey || o.pubkey);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $489bf4ac17a296db$var$OPS.OP_DUP,
            $489bf4ac17a296db$var$OPS.OP_HASH160,
            o.hash,
            $489bf4ac17a296db$var$OPS.OP_EQUALVERIFY,
            $489bf4ac17a296db$var$OPS.OP_CHECKSIG
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "pubkey", ()=>{
        if (!a.input) return;
        return _chunks()[1];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "signature", ()=>{
        if (!a.input) return;
        return _chunks()[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            a.signature,
            a.pubkey
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        if (!o.input) return;
        return [];
    });
    // extended validation
    if (opts.validate) {
        let hash = $489bf4ac17a296db$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.pubKeyHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 25 || a.output[0] !== $489bf4ac17a296db$var$OPS.OP_DUP || a.output[1] !== $489bf4ac17a296db$var$OPS.OP_HASH160 || a.output[2] !== 0x14 || a.output[23] !== $489bf4ac17a296db$var$OPS.OP_EQUALVERIFY || a.output[24] !== $489bf4ac17a296db$var$OPS.OP_CHECKSIG) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(3, 23);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.pubkey) {
            const pkh = $1c834b456d93f732$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
        }
        if (a.input) {
            const chunks = _chunks();
            if (chunks.length !== 2) throw new TypeError("Input is invalid");
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0])) throw new TypeError("Input has invalid signature");
            if (!$a810f27cf38f4a3f$exports.isPoint(chunks[1])) throw new TypeError("Input has invalid pubkey");
            if (a.signature && !a.signature.equals(chunks[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(chunks[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $1c834b456d93f732$exports.hash160(chunks[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$489bf4ac17a296db$exports.p2pkh = $489bf4ac17a296db$var$p2pkh;


$bed04000b8455fa3$exports.p2pkh = $489bf4ac17a296db$exports.p2pkh;
var $cdd255073c87f30c$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $cdd255073c87f30c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($cdd255073c87f30c$exports, "__esModule", {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $cdd255073c87f30c$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $lpa1P = parcelRequire("lpa1P");
function $cdd255073c87f30c$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
// input: [redeemScriptSig ...] {redeemScript}
// witness: <?>
// output: OP_HASH160 {hash160(redeemScript)} OP_EQUAL
function $cdd255073c87f30c$var$p2sh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.input) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        output: $lYlyf.maybe($lYlyf.BufferN(23)),
        redeem: $lYlyf.maybe({
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            input: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.Buffer),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const payload = $lpa1P.decode(a.address);
        const version = payload.readUInt8(0);
        const hash = payload.slice(1);
        return {
            version: version,
            hash: hash
        };
    });
    const _chunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.input);
    });
    const _redeem = $8e81aa4b8a918bf8$exports.value(()=>{
        const chunks = _chunks();
        return {
            network: network,
            output: chunks[chunks.length - 1],
            input: $a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1)),
            witness: a.witness || []
        };
    });
    // output dependents
    $8e81aa4b8a918bf8$exports.prop(o, "address", ()=>{
        if (!o.hash) return;
        const payload = $cdd255073c87f30c$require$Buffer.allocUnsafe(21);
        payload.writeUInt8(o.network.scriptHash, 0);
        o.hash.copy(payload, 1);
        return $lpa1P.encode(payload);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "hash", ()=>{
        // in order of least effort
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().hash;
        if (o.redeem && o.redeem.output) return $1c834b456d93f732$exports.hash160(o.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $cdd255073c87f30c$var$OPS.OP_HASH160,
            o.hash,
            $cdd255073c87f30c$var$OPS.OP_EQUAL
        ]);
    });
    // input dependents
    $8e81aa4b8a918bf8$exports.prop(o, "redeem", ()=>{
        if (!a.input) return;
        return _redeem();
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!a.redeem || !a.redeem.input || !a.redeem.output) return;
        return $a6e22d0fc87b0ff4$exports.compile([].concat($a6e22d0fc87b0ff4$exports.decompile(a.redeem.input), a.redeem.output));
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        if (o.redeem && o.redeem.witness) return o.redeem.witness;
        if (o.input) return [];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "name", ()=>{
        const nameParts = [
            "p2sh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    if (opts.validate) {
        let hash = $cdd255073c87f30c$require$Buffer.from([]);
        if (a.address) {
            if (_address().version !== network.scriptHash) throw new TypeError("Invalid version or Network mismatch");
            if (_address().hash.length !== 20) throw new TypeError("Invalid address");
            hash = _address().hash;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 23 || a.output[0] !== $cdd255073c87f30c$var$OPS.OP_HASH160 || a.output[1] !== 0x14 || a.output[22] !== $cdd255073c87f30c$var$OPS.OP_EQUAL) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2, 22);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        // inlined to prevent 'no-inner-declarations' failing
        const checkRedeem = (redeem)=>{
            // is the redeem output empty/invalid?
            if (redeem.output) {
                const decompile = $a6e22d0fc87b0ff4$exports.decompile(redeem.output);
                if (!decompile || decompile.length < 1) throw new TypeError("Redeem.output too short");
                // match hash against other sources
                const hash2 = $1c834b456d93f732$exports.hash160(redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (redeem.input) {
                const hasInput = redeem.input.length > 0;
                const hasWitness = redeem.witness && redeem.witness.length > 0;
                if (!hasInput && !hasWitness) throw new TypeError("Empty input");
                if (hasInput && hasWitness) throw new TypeError("Input and witness provided");
                if (hasInput) {
                    const richunks = $a6e22d0fc87b0ff4$exports.decompile(redeem.input);
                    if (!$a6e22d0fc87b0ff4$exports.isPushOnly(richunks)) throw new TypeError("Non push-only scriptSig");
                }
            }
        };
        if (a.input) {
            const chunks = _chunks();
            if (!chunks || chunks.length < 1) throw new TypeError("Input too short");
            if (!$cdd255073c87f30c$require$Buffer.isBuffer(_redeem().output)) throw new TypeError("Input is invalid");
            checkRedeem(_redeem());
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            if (a.input) {
                const redeem = _redeem();
                if (a.redeem.output && !a.redeem.output.equals(redeem.output)) throw new TypeError("Redeem.output mismatch");
                if (a.redeem.input && !a.redeem.input.equals(redeem.input)) throw new TypeError("Redeem.input mismatch");
            }
            checkRedeem(a.redeem);
        }
        if (a.witness) {
            if (a.redeem && a.redeem.witness && !$cdd255073c87f30c$var$stacksEqual(a.redeem.witness, a.witness)) throw new TypeError("Witness and redeem.witness mismatch");
        }
    }
    return Object.assign(o, a);
}
$cdd255073c87f30c$exports.p2sh = $cdd255073c87f30c$var$p2sh;


$bed04000b8455fa3$exports.p2sh = $cdd255073c87f30c$exports.p2sh;
var $3f1fc00c9e7a8919$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $3f1fc00c9e7a8919$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($3f1fc00c9e7a8919$exports, "__esModule", {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $3f1fc00c9e7a8919$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;

var $39e817052690ea98$exports = {};
"use strict";
var $39e817052690ea98$var$ALPHABET = "qpzry9x8gf2tvdw0s3jn54khce6mua7l";
// pre-compute lookup table
var $39e817052690ea98$var$ALPHABET_MAP = {};
for(var $39e817052690ea98$var$z = 0; $39e817052690ea98$var$z < $39e817052690ea98$var$ALPHABET.length; $39e817052690ea98$var$z++){
    var $39e817052690ea98$var$x = $39e817052690ea98$var$ALPHABET.charAt($39e817052690ea98$var$z);
    if ($39e817052690ea98$var$ALPHABET_MAP[$39e817052690ea98$var$x] !== undefined) throw new TypeError($39e817052690ea98$var$x + " is ambiguous");
    $39e817052690ea98$var$ALPHABET_MAP[$39e817052690ea98$var$x] = $39e817052690ea98$var$z;
}
function $39e817052690ea98$var$polymodStep(pre) {
    var b = pre >> 25;
    return (pre & 0x1FFFFFF) << 5 ^ -(b >> 0 & 1) & 0x3b6a57b2 ^ -(b >> 1 & 1) & 0x26508e6d ^ -(b >> 2 & 1) & 0x1ea119fa ^ -(b >> 3 & 1) & 0x3d4233dd ^ -(b >> 4 & 1) & 0x2a1462b3;
}
function $39e817052690ea98$var$prefixChk(prefix) {
    var chk = 1;
    for(var i = 0; i < prefix.length; ++i){
        var c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) return "Invalid prefix (" + prefix + ")";
        chk = $39e817052690ea98$var$polymodStep(chk) ^ c >> 5;
    }
    chk = $39e817052690ea98$var$polymodStep(chk);
    for(i = 0; i < prefix.length; ++i){
        var v = prefix.charCodeAt(i);
        chk = $39e817052690ea98$var$polymodStep(chk) ^ v & 0x1f;
    }
    return chk;
}
function $39e817052690ea98$var$encode(prefix, words, LIMIT) {
    LIMIT = LIMIT || 90;
    if (prefix.length + 7 + words.length > LIMIT) throw new TypeError("Exceeds length limit");
    prefix = prefix.toLowerCase();
    // determine chk mod
    var chk = $39e817052690ea98$var$prefixChk(prefix);
    if (typeof chk === "string") throw new Error(chk);
    var result = prefix + "1";
    for(var i = 0; i < words.length; ++i){
        var x = words[i];
        if (x >> 5 !== 0) throw new Error("Non 5-bit word");
        chk = $39e817052690ea98$var$polymodStep(chk) ^ x;
        result += $39e817052690ea98$var$ALPHABET.charAt(x);
    }
    for(i = 0; i < 6; ++i)chk = $39e817052690ea98$var$polymodStep(chk);
    chk ^= 1;
    for(i = 0; i < 6; ++i){
        var v = chk >> (5 - i) * 5 & 0x1f;
        result += $39e817052690ea98$var$ALPHABET.charAt(v);
    }
    return result;
}
function $39e817052690ea98$var$__decode(str, LIMIT) {
    LIMIT = LIMIT || 90;
    if (str.length < 8) return str + " too short";
    if (str.length > LIMIT) return "Exceeds length limit";
    // don't allow mixed case
    var lowered = str.toLowerCase();
    var uppered = str.toUpperCase();
    if (str !== lowered && str !== uppered) return "Mixed-case string " + str;
    str = lowered;
    var split = str.lastIndexOf("1");
    if (split === -1) return "No separator character for " + str;
    if (split === 0) return "Missing prefix for " + str;
    var prefix = str.slice(0, split);
    var wordChars = str.slice(split + 1);
    if (wordChars.length < 6) return "Data too short";
    var chk = $39e817052690ea98$var$prefixChk(prefix);
    if (typeof chk === "string") return chk;
    var words = [];
    for(var i = 0; i < wordChars.length; ++i){
        var c = wordChars.charAt(i);
        var v = $39e817052690ea98$var$ALPHABET_MAP[c];
        if (v === undefined) return "Unknown character " + c;
        chk = $39e817052690ea98$var$polymodStep(chk) ^ v;
        // not in the checksum?
        if (i + 6 >= wordChars.length) continue;
        words.push(v);
    }
    if (chk !== 1) return "Invalid checksum for " + str;
    return {
        prefix: prefix,
        words: words
    };
}
function $39e817052690ea98$var$decodeUnsafe() {
    var res = $39e817052690ea98$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
}
function $39e817052690ea98$var$decode(str) {
    var res = $39e817052690ea98$var$__decode.apply(null, arguments);
    if (typeof res === "object") return res;
    throw new Error(res);
}
function $39e817052690ea98$var$convert(data, inBits, outBits, pad) {
    var value = 0;
    var bits = 0;
    var maxV = (1 << outBits) - 1;
    var result = [];
    for(var i = 0; i < data.length; ++i){
        value = value << inBits | data[i];
        bits += inBits;
        while(bits >= outBits){
            bits -= outBits;
            result.push(value >> bits & maxV);
        }
    }
    if (pad) {
        if (bits > 0) result.push(value << outBits - bits & maxV);
    } else {
        if (bits >= inBits) return "Excess padding";
        if (value << outBits - bits & maxV) return "Non-zero padding";
    }
    return result;
}
function $39e817052690ea98$var$toWordsUnsafe(bytes) {
    var res = $39e817052690ea98$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
}
function $39e817052690ea98$var$toWords(bytes) {
    var res = $39e817052690ea98$var$convert(bytes, 8, 5, true);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
function $39e817052690ea98$var$fromWordsUnsafe(words) {
    var res = $39e817052690ea98$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
}
function $39e817052690ea98$var$fromWords(words) {
    var res = $39e817052690ea98$var$convert(words, 5, 8, false);
    if (Array.isArray(res)) return res;
    throw new Error(res);
}
$39e817052690ea98$exports = {
    decodeUnsafe: $39e817052690ea98$var$decodeUnsafe,
    decode: $39e817052690ea98$var$decode,
    encode: $39e817052690ea98$var$encode,
    toWordsUnsafe: $39e817052690ea98$var$toWordsUnsafe,
    toWords: $39e817052690ea98$var$toWords,
    fromWordsUnsafe: $39e817052690ea98$var$fromWordsUnsafe,
    fromWords: $39e817052690ea98$var$fromWords
};


const $3f1fc00c9e7a8919$var$EMPTY_BUFFER = $3f1fc00c9e7a8919$require$Buffer.alloc(0);
// witness: {signature} {pubKey}
// input: <>
// output: OP_0 {pubKeyHash}
function $3f1fc00c9e7a8919$var$p2wpkh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.pubkey && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(20)),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        network: $lYlyf.maybe($lYlyf.Object),
        output: $lYlyf.maybe($lYlyf.BufferN(22)),
        pubkey: $lYlyf.maybe($a810f27cf38f4a3f$exports.isPoint),
        signature: $lYlyf.maybe($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const result = $39e817052690ea98$exports.decode(a.address);
        const version = result.words.shift();
        const data = $39e817052690ea98$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $3f1fc00c9e7a8919$require$Buffer.from(data)
        };
    });
    const network = a.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        name: "p2wpkh",
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $39e817052690ea98$exports.toWords(o.hash);
        words.unshift(0x00);
        return $39e817052690ea98$exports.encode(network.bech32, words);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2, 22);
        if (a.address) return _address().data;
        if (a.pubkey || o.pubkey) return $1c834b456d93f732$exports.hash160(a.pubkey || o.pubkey);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $3f1fc00c9e7a8919$var$OPS.OP_0,
            o.hash
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "pubkey", ()=>{
        if (a.pubkey) return a.pubkey;
        if (!a.witness) return;
        return a.witness[1];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "signature", ()=>{
        if (!a.witness) return;
        return a.witness[0];
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $3f1fc00c9e7a8919$var$EMPTY_BUFFER;
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        if (!a.pubkey) return;
        if (!a.signature) return;
        return [
            a.signature,
            a.pubkey
        ];
    });
    // extended validation
    if (opts.validate) {
        let hash = $3f1fc00c9e7a8919$require$Buffer.from([]);
        if (a.address) {
            if (network && network.bech32 !== _address().prefix) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 20) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 22 || a.output[0] !== $3f1fc00c9e7a8919$var$OPS.OP_0 || a.output[1] !== 0x14) throw new TypeError("Output is invalid");
            if (hash.length > 0 && !hash.equals(a.output.slice(2))) throw new TypeError("Hash mismatch");
            else hash = a.output.slice(2);
        }
        if (a.pubkey) {
            const pkh = $1c834b456d93f732$exports.hash160(a.pubkey);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
            else hash = pkh;
            if (!$a810f27cf38f4a3f$exports.isPoint(a.pubkey) || a.pubkey.length !== 33) throw new TypeError("Invalid pubkey for p2wpkh");
        }
        if (a.witness) {
            if (a.witness.length !== 2) throw new TypeError("Witness is invalid");
            if (!$a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(a.witness[0])) throw new TypeError("Witness has invalid signature");
            if (!$a810f27cf38f4a3f$exports.isPoint(a.witness[1]) || a.witness[1].length !== 33) throw new TypeError("Witness has invalid pubkey");
            if (a.signature && !a.signature.equals(a.witness[0])) throw new TypeError("Signature mismatch");
            if (a.pubkey && !a.pubkey.equals(a.witness[1])) throw new TypeError("Pubkey mismatch");
            const pkh = $1c834b456d93f732$exports.hash160(a.witness[1]);
            if (hash.length > 0 && !hash.equals(pkh)) throw new TypeError("Hash mismatch");
        }
    }
    return Object.assign(o, a);
}
$3f1fc00c9e7a8919$exports.p2wpkh = $3f1fc00c9e7a8919$var$p2wpkh;


$bed04000b8455fa3$exports.p2wpkh = $3f1fc00c9e7a8919$exports.p2wpkh;
var $10f0972adafd621a$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $10f0972adafd621a$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($10f0972adafd621a$exports, "__esModule", {
    value: true
});





var $lYlyf = parcelRequire("lYlyf");
const $10f0972adafd621a$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;


const $10f0972adafd621a$var$EMPTY_BUFFER = $10f0972adafd621a$require$Buffer.alloc(0);
function $10f0972adafd621a$var$stacksEqual(a, b) {
    if (a.length !== b.length) return false;
    return a.every((x, i)=>{
        return x.equals(b[i]);
    });
}
function $10f0972adafd621a$var$chunkHasUncompressedPubkey(chunk) {
    if ($10f0972adafd621a$require$Buffer.isBuffer(chunk) && chunk.length === 65 && chunk[0] === 0x04 && $a810f27cf38f4a3f$exports.isPoint(chunk)) return true;
    else return false;
}
// input: <>
// witness: [redeemScriptSig ...] {redeemScript}
// output: OP_0 {sha256(redeemScript)}
function $10f0972adafd621a$var$p2wsh(a, opts) {
    if (!a.address && !a.hash && !a.output && !a.redeem && !a.witness) throw new TypeError("Not enough data");
    opts = Object.assign({
        validate: true
    }, opts || {});
    $lYlyf({
        network: $lYlyf.maybe($lYlyf.Object),
        address: $lYlyf.maybe($lYlyf.String),
        hash: $lYlyf.maybe($lYlyf.BufferN(32)),
        output: $lYlyf.maybe($lYlyf.BufferN(34)),
        redeem: $lYlyf.maybe({
            input: $lYlyf.maybe($lYlyf.Buffer),
            network: $lYlyf.maybe($lYlyf.Object),
            output: $lYlyf.maybe($lYlyf.Buffer),
            witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
        }),
        input: $lYlyf.maybe($lYlyf.BufferN(0)),
        witness: $lYlyf.maybe($lYlyf.arrayOf($lYlyf.Buffer))
    }, a);
    const _address = $8e81aa4b8a918bf8$exports.value(()=>{
        const result = $39e817052690ea98$exports.decode(a.address);
        const version = result.words.shift();
        const data = $39e817052690ea98$exports.fromWords(result.words);
        return {
            version: version,
            prefix: result.prefix,
            data: $10f0972adafd621a$require$Buffer.from(data)
        };
    });
    const _rchunks = $8e81aa4b8a918bf8$exports.value(()=>{
        return $a6e22d0fc87b0ff4$exports.decompile(a.redeem.input);
    });
    let network = a.network;
    if (!network) network = a.redeem && a.redeem.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    const o = {
        network: network
    };
    $8e81aa4b8a918bf8$exports.prop(o, "address", ()=>{
        if (!o.hash) return;
        const words = $39e817052690ea98$exports.toWords(o.hash);
        words.unshift(0x00);
        return $39e817052690ea98$exports.encode(network.bech32, words);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "hash", ()=>{
        if (a.output) return a.output.slice(2);
        if (a.address) return _address().data;
        if (o.redeem && o.redeem.output) return $1c834b456d93f732$exports.sha256(o.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "output", ()=>{
        if (!o.hash) return;
        return $a6e22d0fc87b0ff4$exports.compile([
            $10f0972adafd621a$var$OPS.OP_0,
            o.hash
        ]);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "redeem", ()=>{
        if (!a.witness) return;
        return {
            output: a.witness[a.witness.length - 1],
            input: $10f0972adafd621a$var$EMPTY_BUFFER,
            witness: a.witness.slice(0, -1)
        };
    });
    $8e81aa4b8a918bf8$exports.prop(o, "input", ()=>{
        if (!o.witness) return;
        return $10f0972adafd621a$var$EMPTY_BUFFER;
    });
    $8e81aa4b8a918bf8$exports.prop(o, "witness", ()=>{
        // transform redeem input to witness stack?
        if (a.redeem && a.redeem.input && a.redeem.input.length > 0 && a.redeem.output && a.redeem.output.length > 0) {
            const stack = $a6e22d0fc87b0ff4$exports.toStack(_rchunks());
            // assign, and blank the existing input
            o.redeem = Object.assign({
                witness: stack
            }, a.redeem);
            o.redeem.input = $10f0972adafd621a$var$EMPTY_BUFFER;
            return [].concat(stack, a.redeem.output);
        }
        if (!a.redeem) return;
        if (!a.redeem.output) return;
        if (!a.redeem.witness) return;
        return [].concat(a.redeem.witness, a.redeem.output);
    });
    $8e81aa4b8a918bf8$exports.prop(o, "name", ()=>{
        const nameParts = [
            "p2wsh"
        ];
        if (o.redeem !== undefined) nameParts.push(o.redeem.name);
        return nameParts.join("-");
    });
    // extended validation
    if (opts.validate) {
        let hash = $10f0972adafd621a$require$Buffer.from([]);
        if (a.address) {
            if (_address().prefix !== network.bech32) throw new TypeError("Invalid prefix or Network mismatch");
            if (_address().version !== 0x00) throw new TypeError("Invalid address version");
            if (_address().data.length !== 32) throw new TypeError("Invalid address data");
            hash = _address().data;
        }
        if (a.hash) {
            if (hash.length > 0 && !hash.equals(a.hash)) throw new TypeError("Hash mismatch");
            else hash = a.hash;
        }
        if (a.output) {
            if (a.output.length !== 34 || a.output[0] !== $10f0972adafd621a$var$OPS.OP_0 || a.output[1] !== 0x20) throw new TypeError("Output is invalid");
            const hash2 = a.output.slice(2);
            if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
            else hash = hash2;
        }
        if (a.redeem) {
            if (a.redeem.network && a.redeem.network !== network) throw new TypeError("Network mismatch");
            // is there two redeem sources?
            if (a.redeem.input && a.redeem.input.length > 0 && a.redeem.witness && a.redeem.witness.length > 0) throw new TypeError("Ambiguous witness source");
            // is the redeem output non-empty?
            if (a.redeem.output) {
                if ($a6e22d0fc87b0ff4$exports.decompile(a.redeem.output).length === 0) throw new TypeError("Redeem.output is invalid");
                // match hash against other sources
                const hash2 = $1c834b456d93f732$exports.sha256(a.redeem.output);
                if (hash.length > 0 && !hash.equals(hash2)) throw new TypeError("Hash mismatch");
                else hash = hash2;
            }
            if (a.redeem.input && !$a6e22d0fc87b0ff4$exports.isPushOnly(_rchunks())) throw new TypeError("Non push-only scriptSig");
            if (a.witness && a.redeem.witness && !$10f0972adafd621a$var$stacksEqual(a.witness, a.redeem.witness)) throw new TypeError("Witness and redeem.witness mismatch");
            if (a.redeem.input && _rchunks().some($10f0972adafd621a$var$chunkHasUncompressedPubkey) || a.redeem.output && ($a6e22d0fc87b0ff4$exports.decompile(a.redeem.output) || []).some($10f0972adafd621a$var$chunkHasUncompressedPubkey)) throw new TypeError("redeem.input or redeem.output contains uncompressed pubkey");
        }
        if (a.witness && a.witness.length > 0) {
            const wScript = a.witness[a.witness.length - 1];
            if (a.redeem && a.redeem.output && !a.redeem.output.equals(wScript)) throw new TypeError("Witness and redeem.output mismatch");
            if (a.witness.some($10f0972adafd621a$var$chunkHasUncompressedPubkey) || ($a6e22d0fc87b0ff4$exports.decompile(wScript) || []).some($10f0972adafd621a$var$chunkHasUncompressedPubkey)) throw new TypeError("Witness contains uncompressed pubkey");
        }
    }
    return Object.assign(o, a);
}
$10f0972adafd621a$exports.p2wsh = $10f0972adafd621a$var$p2wsh;


$bed04000b8455fa3$exports.p2wsh = $10f0972adafd621a$exports.p2wsh; // TODO
 // witness commitment






var $lpa1P = parcelRequire("lpa1P");

var $lYlyf = parcelRequire("lYlyf");
function $d26ee8edcbfb8f9e$var$fromBase58Check(address) {
    const payload = $lpa1P.decode(address);
    // TODO: 4.0.0, move to "toOutputScript"
    if (payload.length < 21) throw new TypeError(address + " is too short");
    if (payload.length > 21) throw new TypeError(address + " is too long");
    const version = payload.readUInt8(0);
    const hash = payload.slice(1);
    return {
        version: version,
        hash: hash
    };
}
$d26ee8edcbfb8f9e$exports.fromBase58Check = $d26ee8edcbfb8f9e$var$fromBase58Check;
function $d26ee8edcbfb8f9e$var$fromBech32(address) {
    const result = $39e817052690ea98$exports.decode(address);
    const data = $39e817052690ea98$exports.fromWords(result.words.slice(1));
    return {
        version: result.words[0],
        prefix: result.prefix,
        data: $d26ee8edcbfb8f9e$require$Buffer.from(data)
    };
}
$d26ee8edcbfb8f9e$exports.fromBech32 = $d26ee8edcbfb8f9e$var$fromBech32;
function $d26ee8edcbfb8f9e$var$toBase58Check(hash, version) {
    $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Hash160bit, $e79ff6cff6024683$exports.UInt8), arguments);
    const payload = $d26ee8edcbfb8f9e$require$Buffer.allocUnsafe(21);
    payload.writeUInt8(version, 0);
    hash.copy(payload, 1);
    return $lpa1P.encode(payload);
}
$d26ee8edcbfb8f9e$exports.toBase58Check = $d26ee8edcbfb8f9e$var$toBase58Check;
function $d26ee8edcbfb8f9e$var$toBech32(data, version, prefix) {
    const words = $39e817052690ea98$exports.toWords(data);
    words.unshift(version);
    return $39e817052690ea98$exports.encode(prefix, words);
}
$d26ee8edcbfb8f9e$exports.toBech32 = $d26ee8edcbfb8f9e$var$toBech32;
function $d26ee8edcbfb8f9e$var$fromOutputScript(output, network) {
    // TODO: Network
    network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    try {
        return $bed04000b8455fa3$exports.p2pkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2sh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2wpkh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    try {
        return $bed04000b8455fa3$exports.p2wsh({
            output: output,
            network: network
        }).address;
    } catch (e) {}
    throw new Error($a6e22d0fc87b0ff4$exports.toASM(output) + " has no matching Address");
}
$d26ee8edcbfb8f9e$exports.fromOutputScript = $d26ee8edcbfb8f9e$var$fromOutputScript;
function $d26ee8edcbfb8f9e$var$toOutputScript(address, network) {
    network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
    let decodeBase58;
    let decodeBech32;
    try {
        decodeBase58 = $d26ee8edcbfb8f9e$var$fromBase58Check(address);
    } catch (e) {}
    if (decodeBase58) {
        if (decodeBase58.version === network.pubKeyHash) return $bed04000b8455fa3$exports.p2pkh({
            hash: decodeBase58.hash
        }).output;
        if (decodeBase58.version === network.scriptHash) return $bed04000b8455fa3$exports.p2sh({
            hash: decodeBase58.hash
        }).output;
    } else {
        try {
            decodeBech32 = $d26ee8edcbfb8f9e$var$fromBech32(address);
        } catch (e) {}
        if (decodeBech32) {
            if (decodeBech32.prefix !== network.bech32) throw new Error(address + " has an invalid prefix");
            if (decodeBech32.version === 0) {
                if (decodeBech32.data.length === 20) return $bed04000b8455fa3$exports.p2wpkh({
                    hash: decodeBech32.data
                }).output;
                if (decodeBech32.data.length === 32) return $bed04000b8455fa3$exports.p2wsh({
                    hash: decodeBech32.data
                }).output;
            }
        }
    }
    throw new Error(address + " has no matching Script");
}
$d26ee8edcbfb8f9e$exports.toOutputScript = $d26ee8edcbfb8f9e$var$toOutputScript;


$58cf3bc07eb2f0ea$exports.address = $d26ee8edcbfb8f9e$exports;

$58cf3bc07eb2f0ea$exports.crypto = $1c834b456d93f732$exports;
var $c32869daae2b1652$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c32869daae2b1652$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($c32869daae2b1652$exports, "__esModule", {
    value: true
});




var $hkN9y = parcelRequire("hkN9y");

var $lYlyf = parcelRequire("lYlyf");

const $c32869daae2b1652$var$isOptions = $lYlyf.maybe($lYlyf.compile({
    compressed: $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Boolean),
    network: $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Network)
}));
class $c32869daae2b1652$var$ECPair {
    constructor(__D, __Q, options){
        this.__D = __D;
        this.__Q = __Q;
        this.lowR = false;
        if (options === undefined) options = {};
        this.compressed = options.compressed === undefined ? true : options.compressed;
        this.network = options.network || $a2ef7e6d3e9bbe84$exports.bitcoin;
        if (__Q !== undefined) this.__Q = $a810f27cf38f4a3f$exports.pointCompress(__Q, this.compressed);
    }
    get privateKey() {
        return this.__D;
    }
    get publicKey() {
        if (!this.__Q) this.__Q = $a810f27cf38f4a3f$exports.pointFromScalar(this.__D, this.compressed);
        return this.__Q;
    }
    toWIF() {
        if (!this.__D) throw new Error("Missing private key");
        return $ee5bf8de7b9f3154$exports.encode(this.network.wif, this.__D, this.compressed);
    }
    sign(hash, lowR) {
        if (!this.__D) throw new Error("Missing private key");
        if (lowR === undefined) lowR = this.lowR;
        if (lowR === false) return $a810f27cf38f4a3f$exports.sign(hash, this.__D);
        else {
            let sig = $a810f27cf38f4a3f$exports.sign(hash, this.__D);
            const extraData = $c32869daae2b1652$require$Buffer.alloc(32, 0);
            let counter = 0;
            // if first try is lowR, skip the loop
            // for second try and on, add extra entropy counting up
            while(sig[0] > 0x7f){
                counter++;
                extraData.writeUIntLE(counter, 0, 6);
                sig = $a810f27cf38f4a3f$exports.signWithEntropy(hash, this.__D, extraData);
            }
            return sig;
        }
    }
    verify(hash, signature) {
        return $a810f27cf38f4a3f$exports.verify(hash, this.publicKey, signature);
    }
}
function $c32869daae2b1652$var$fromPrivateKey(buffer, options) {
    $lYlyf($e79ff6cff6024683$exports.Buffer256bit, buffer);
    if (!$a810f27cf38f4a3f$exports.isPrivate(buffer)) throw new TypeError("Private key not in range [1, n)");
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    return new $c32869daae2b1652$var$ECPair(buffer, undefined, options);
}
$c32869daae2b1652$exports.fromPrivateKey = $c32869daae2b1652$var$fromPrivateKey;
function $c32869daae2b1652$var$fromPublicKey(buffer, options) {
    $lYlyf($a810f27cf38f4a3f$exports.isPoint, buffer);
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    return new $c32869daae2b1652$var$ECPair(undefined, buffer, options);
}
$c32869daae2b1652$exports.fromPublicKey = $c32869daae2b1652$var$fromPublicKey;
function $c32869daae2b1652$var$fromWIF(wifString, network) {
    const decoded = $ee5bf8de7b9f3154$exports.decode(wifString);
    const version = decoded.version;
    // list of networks?
    if ($e79ff6cff6024683$exports.Array(network)) {
        network = network.filter((x)=>{
            return version === x.wif;
        }).pop();
        if (!network) throw new Error("Unknown network version");
    // otherwise, assume a network object (or default to bitcoin)
    } else {
        network = network || $a2ef7e6d3e9bbe84$exports.bitcoin;
        if (version !== network.wif) throw new Error("Invalid network version");
    }
    return $c32869daae2b1652$var$fromPrivateKey(decoded.privateKey, {
        compressed: decoded.compressed,
        network: network
    });
}
$c32869daae2b1652$exports.fromWIF = $c32869daae2b1652$var$fromWIF;
function $c32869daae2b1652$var$makeRandom(options) {
    $lYlyf($c32869daae2b1652$var$isOptions, options);
    if (options === undefined) options = {};
    const rng = options.rng || $hkN9y;
    let d;
    do {
        d = rng(32);
        $lYlyf($e79ff6cff6024683$exports.Buffer256bit, d);
    }while (!$a810f27cf38f4a3f$exports.isPrivate(d));
    return $c32869daae2b1652$var$fromPrivateKey(d, options);
}
$c32869daae2b1652$exports.makeRandom = $c32869daae2b1652$var$makeRandom;


$58cf3bc07eb2f0ea$exports.ECPair = $c32869daae2b1652$exports;

$58cf3bc07eb2f0ea$exports.networks = $a2ef7e6d3e9bbe84$exports;

$58cf3bc07eb2f0ea$exports.payments = $bed04000b8455fa3$exports;

$58cf3bc07eb2f0ea$exports.script = $a6e22d0fc87b0ff4$exports;
var $c190b973b56bdb52$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c190b973b56bdb52$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($c190b973b56bdb52$exports, "__esModule", {
    value: true
});
var $9192ad2b59302b6c$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9192ad2b59302b6c$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($9192ad2b59302b6c$exports, "__esModule", {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
// https://github.com/feross/buffer/blob/master/index.js#L1127
function $9192ad2b59302b6c$var$verifuint(value, max) {
    if (typeof value !== "number") throw new Error("cannot write a non-number as a number");
    if (value < 0) throw new Error("specified a negative value for writing an unsigned value");
    if (value > max) throw new Error("RangeError: value out of range");
    if (Math.floor(value) !== value) throw new Error("value has a fractional component");
}
function $9192ad2b59302b6c$var$readUInt64LE(buffer, offset) {
    const a = buffer.readUInt32LE(offset);
    let b = buffer.readUInt32LE(offset + 4);
    b *= 0x100000000;
    $9192ad2b59302b6c$var$verifuint(b + a, 0x001fffffffffffff);
    return b + a;
}
$9192ad2b59302b6c$exports.readUInt64LE = $9192ad2b59302b6c$var$readUInt64LE;
function $9192ad2b59302b6c$var$writeUInt64LE(buffer, value, offset) {
    $9192ad2b59302b6c$var$verifuint(value, 0x001fffffffffffff);
    buffer.writeInt32LE(value & -1, offset);
    buffer.writeUInt32LE(Math.floor(value / 0x100000000), offset + 4);
    return offset + 8;
}
$9192ad2b59302b6c$exports.writeUInt64LE = $9192ad2b59302b6c$var$writeUInt64LE;
function $9192ad2b59302b6c$var$reverseBuffer(buffer) {
    if (buffer.length < 1) return buffer;
    let j = buffer.length - 1;
    let tmp = 0;
    for(let i = 0; i < buffer.length / 2; i++){
        tmp = buffer[i];
        buffer[i] = buffer[j];
        buffer[j] = tmp;
        j--;
    }
    return buffer;
}
$9192ad2b59302b6c$exports.reverseBuffer = $9192ad2b59302b6c$var$reverseBuffer;
function $9192ad2b59302b6c$var$cloneBuffer(buffer) {
    const clone = $9192ad2b59302b6c$require$Buffer.allocUnsafe(buffer.length);
    buffer.copy(clone);
    return clone;
}
$9192ad2b59302b6c$exports.cloneBuffer = $9192ad2b59302b6c$var$cloneBuffer;
/**
 * Helper class for serialization of bitcoin data types into a pre-allocated buffer.
 */ class $9192ad2b59302b6c$var$BufferWriter {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    writeUInt8(i) {
        this.offset = this.buffer.writeUInt8(i, this.offset);
    }
    writeInt32(i) {
        this.offset = this.buffer.writeInt32LE(i, this.offset);
    }
    writeUInt32(i) {
        this.offset = this.buffer.writeUInt32LE(i, this.offset);
    }
    writeUInt64(i) {
        this.offset = $9192ad2b59302b6c$var$writeUInt64LE(this.buffer, i, this.offset);
    }
    writeVarInt(i) {
        $JAEWR.encode(i, this.buffer, this.offset);
        this.offset += $JAEWR.encode.bytes;
    }
    writeSlice(slice) {
        if (this.buffer.length < this.offset + slice.length) throw new Error("Cannot write slice out of bounds");
        this.offset += slice.copy(this.buffer, this.offset);
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    writeVector(vector) {
        this.writeVarInt(vector.length);
        vector.forEach((buf)=>this.writeVarSlice(buf));
    }
}
$9192ad2b59302b6c$exports.BufferWriter = $9192ad2b59302b6c$var$BufferWriter;
/**
 * Helper class for reading of bitcoin data types from a buffer.
 */ class $9192ad2b59302b6c$var$BufferReader {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.UInt32), [
            buffer,
            offset
        ]);
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const result = $9192ad2b59302b6c$var$readUInt64LE(this.buffer, this.offset);
        this.offset += 8;
        return result;
    }
    readVarInt() {
        const vi = $JAEWR.decode(this.buffer, this.offset);
        this.offset += $JAEWR.decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}
$9192ad2b59302b6c$exports.BufferReader = $9192ad2b59302b6c$var$BufferReader;



var $fd7ffb7eadbf465f$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $fd7ffb7eadbf465f$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($fd7ffb7eadbf465f$exports, "__esModule", {
    value: true
});






var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
function $fd7ffb7eadbf465f$var$varSliceSize(someScript) {
    const length = someScript.length;
    return $JAEWR.encodingLength(length) + length;
}
function $fd7ffb7eadbf465f$var$vectorSize(someVector) {
    const length = someVector.length;
    return $JAEWR.encodingLength(length) + someVector.reduce((sum, witness)=>{
        return sum + $fd7ffb7eadbf465f$var$varSliceSize(witness);
    }, 0);
}
const $fd7ffb7eadbf465f$var$EMPTY_SCRIPT = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(0);
const $fd7ffb7eadbf465f$var$EMPTY_WITNESS = [];
const $fd7ffb7eadbf465f$var$ZERO = $fd7ffb7eadbf465f$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex");
const $fd7ffb7eadbf465f$var$ONE = $fd7ffb7eadbf465f$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000001", "hex");
const $fd7ffb7eadbf465f$var$VALUE_UINT64_MAX = $fd7ffb7eadbf465f$require$Buffer.from("ffffffffffffffff", "hex");
const $fd7ffb7eadbf465f$var$BLANK_OUTPUT = {
    script: $fd7ffb7eadbf465f$var$EMPTY_SCRIPT,
    valueBuffer: $fd7ffb7eadbf465f$var$VALUE_UINT64_MAX
};
function $fd7ffb7eadbf465f$var$isOutput(out) {
    return out.value !== undefined;
}
class $fd7ffb7eadbf465f$var$Transaction {
    constructor(){
        this.version = 1;
        this.locktime = 0;
        this.ins = [];
        this.outs = [];
    }
    static fromBuffer(buffer, _NO_STRICT) {
        const bufferReader = new $9192ad2b59302b6c$exports.BufferReader(buffer);
        const tx = new $fd7ffb7eadbf465f$var$Transaction();
        tx.version = bufferReader.readInt32();
        const marker = bufferReader.readUInt8();
        const flag = bufferReader.readUInt8();
        let hasWitnesses = false;
        if (marker === $fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER && flag === $fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG) hasWitnesses = true;
        else bufferReader.offset -= 2;
        const vinLen = bufferReader.readVarInt();
        for(let i = 0; i < vinLen; ++i)tx.ins.push({
            hash: bufferReader.readSlice(32),
            index: bufferReader.readUInt32(),
            script: bufferReader.readVarSlice(),
            sequence: bufferReader.readUInt32(),
            witness: $fd7ffb7eadbf465f$var$EMPTY_WITNESS
        });
        const voutLen = bufferReader.readVarInt();
        for(let i = 0; i < voutLen; ++i)tx.outs.push({
            value: bufferReader.readUInt64(),
            script: bufferReader.readVarSlice()
        });
        if (hasWitnesses) {
            for(let i = 0; i < vinLen; ++i)tx.ins[i].witness = bufferReader.readVector();
            // was this pointless?
            if (!tx.hasWitnesses()) throw new Error("Transaction has superfluous witness data");
        }
        tx.locktime = bufferReader.readUInt32();
        if (_NO_STRICT) return tx;
        if (bufferReader.offset !== buffer.length) throw new Error("Transaction has unexpected data");
        return tx;
    }
    static fromHex(hex) {
        return $fd7ffb7eadbf465f$var$Transaction.fromBuffer($fd7ffb7eadbf465f$require$Buffer.from(hex, "hex"), false);
    }
    static isCoinbaseHash(buffer) {
        $lYlyf($e79ff6cff6024683$exports.Hash256bit, buffer);
        for(let i = 0; i < 32; ++i){
            if (buffer[i] !== 0) return false;
        }
        return true;
    }
    isCoinbase() {
        return this.ins.length === 1 && $fd7ffb7eadbf465f$var$Transaction.isCoinbaseHash(this.ins[0].hash);
    }
    addInput(hash, index, sequence, scriptSig) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Hash256bit, $e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.UInt32), $e79ff6cff6024683$exports.maybe($e79ff6cff6024683$exports.Buffer)), arguments);
        if ($e79ff6cff6024683$exports.Null(sequence)) sequence = $fd7ffb7eadbf465f$var$Transaction.DEFAULT_SEQUENCE;
        // Add the input and return the input's index
        return this.ins.push({
            hash: hash,
            index: index,
            script: scriptSig || $fd7ffb7eadbf465f$var$EMPTY_SCRIPT,
            sequence: sequence,
            witness: $fd7ffb7eadbf465f$var$EMPTY_WITNESS
        }) - 1;
    }
    addOutput(scriptPubKey, value) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.Satoshi), arguments);
        // Add the output and return the output's index
        return this.outs.push({
            script: scriptPubKey,
            value: value
        }) - 1;
    }
    hasWitnesses() {
        return this.ins.some((x)=>{
            return x.witness.length !== 0;
        });
    }
    weight() {
        const base = this.byteLength(false);
        const total = this.byteLength(true);
        return base * 3 + total;
    }
    virtualSize() {
        return Math.ceil(this.weight() / 4);
    }
    byteLength(_ALLOW_WITNESS = true) {
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        return (hasWitnesses ? 10 : 8) + $JAEWR.encodingLength(this.ins.length) + $JAEWR.encodingLength(this.outs.length) + this.ins.reduce((sum, input)=>{
            return sum + 40 + $fd7ffb7eadbf465f$var$varSliceSize(input.script);
        }, 0) + this.outs.reduce((sum, output)=>{
            return sum + 8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script);
        }, 0) + (hasWitnesses ? this.ins.reduce((sum, input)=>{
            return sum + $fd7ffb7eadbf465f$var$vectorSize(input.witness);
        }, 0) : 0);
    }
    clone() {
        const newTx = new $fd7ffb7eadbf465f$var$Transaction();
        newTx.version = this.version;
        newTx.locktime = this.locktime;
        newTx.ins = this.ins.map((txIn)=>{
            return {
                hash: txIn.hash,
                index: txIn.index,
                script: txIn.script,
                sequence: txIn.sequence,
                witness: txIn.witness
            };
        });
        newTx.outs = this.outs.map((txOut)=>{
            return {
                script: txOut.script,
                value: txOut.value
            };
        });
        return newTx;
    }
    /**
   * Hash transaction for signing a specific input.
   *
   * Bitcoin uses a different hash for each signed transaction input.
   * This method copies the transaction, makes the necessary changes based on the
   * hashType, and then hashes the result.
   * This hash can then be used to sign the provided transaction input.
   */ hashForSignature(inIndex, prevOutScript, hashType) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.Buffer, /* types.UInt8 */ $e79ff6cff6024683$exports.Number), arguments);
        // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L29
        if (inIndex >= this.ins.length) return $fd7ffb7eadbf465f$var$ONE;
        // ignore OP_CODESEPARATOR
        const ourScript = $a6e22d0fc87b0ff4$exports.compile($a6e22d0fc87b0ff4$exports.decompile(prevOutScript).filter((x)=>{
            return x !== $a6e22d0fc87b0ff4$exports.OPS.OP_CODESEPARATOR;
        }));
        const txTmp = this.clone();
        // SIGHASH_NONE: ignore all outputs? (wildcard payee)
        if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            txTmp.outs = [];
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, i)=>{
                if (i === inIndex) return;
                input.sequence = 0;
            });
        // SIGHASH_SINGLE: ignore all outputs, except at the same index?
        } else if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE) {
            // https://github.com/bitcoin/bitcoin/blob/master/src/test/sighash_tests.cpp#L60
            if (inIndex >= this.outs.length) return $fd7ffb7eadbf465f$var$ONE;
            // truncate outputs after
            txTmp.outs.length = inIndex + 1;
            // "blank" outputs before
            for(let i = 0; i < inIndex; i++)txTmp.outs[i] = $fd7ffb7eadbf465f$var$BLANK_OUTPUT;
            // ignore sequence numbers (except at inIndex)
            txTmp.ins.forEach((input, y)=>{
                if (y === inIndex) return;
                input.sequence = 0;
            });
        }
        // SIGHASH_ANYONECANPAY: ignore inputs entirely?
        if (hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY) {
            txTmp.ins = [
                txTmp.ins[inIndex]
            ];
            txTmp.ins[0].script = ourScript;
        // SIGHASH_ALL: only ignore input scripts
        } else {
            // "blank" others input scripts
            txTmp.ins.forEach((input)=>{
                input.script = $fd7ffb7eadbf465f$var$EMPTY_SCRIPT;
            });
            txTmp.ins[inIndex].script = ourScript;
        }
        // serialize and hash
        const buffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(txTmp.byteLength(false) + 4);
        buffer.writeInt32LE(hashType, buffer.length - 4);
        txTmp.__toBuffer(buffer, 0, false);
        return $1c834b456d93f732$exports.hash256(buffer);
    }
    hashForWitnessV0(inIndex, prevOutScript, value, hashType) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.UInt32, $e79ff6cff6024683$exports.Buffer, $e79ff6cff6024683$exports.Satoshi, $e79ff6cff6024683$exports.UInt32), arguments);
        let tbuffer = $fd7ffb7eadbf465f$require$Buffer.from([]);
        let bufferWriter;
        let hashOutputs = $fd7ffb7eadbf465f$var$ZERO;
        let hashPrevouts = $fd7ffb7eadbf465f$var$ZERO;
        let hashSequence = $fd7ffb7eadbf465f$var$ZERO;
        if (!(hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY)) {
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(36 * this.ins.length);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeSlice(txIn.hash);
                bufferWriter.writeUInt32(txIn.index);
            });
            hashPrevouts = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        if (!(hashType & $fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY) && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(4 * this.ins.length);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.ins.forEach((txIn)=>{
                bufferWriter.writeUInt32(txIn.sequence);
            });
            hashSequence = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        if ((hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && (hashType & 0x1f) !== $fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE) {
            const txOutsSize = this.outs.reduce((sum, output)=>{
                return sum + 8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script);
            }, 0);
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(txOutsSize);
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            this.outs.forEach((out)=>{
                bufferWriter.writeUInt64(out.value);
                bufferWriter.writeVarSlice(out.script);
            });
            hashOutputs = $1c834b456d93f732$exports.hash256(tbuffer);
        } else if ((hashType & 0x1f) === $fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE && inIndex < this.outs.length) {
            const output = this.outs[inIndex];
            tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(8 + $fd7ffb7eadbf465f$var$varSliceSize(output.script));
            bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
            bufferWriter.writeUInt64(output.value);
            bufferWriter.writeVarSlice(output.script);
            hashOutputs = $1c834b456d93f732$exports.hash256(tbuffer);
        }
        tbuffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(156 + $fd7ffb7eadbf465f$var$varSliceSize(prevOutScript));
        bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(tbuffer, 0);
        const input = this.ins[inIndex];
        bufferWriter.writeUInt32(this.version);
        bufferWriter.writeSlice(hashPrevouts);
        bufferWriter.writeSlice(hashSequence);
        bufferWriter.writeSlice(input.hash);
        bufferWriter.writeUInt32(input.index);
        bufferWriter.writeVarSlice(prevOutScript);
        bufferWriter.writeUInt64(value);
        bufferWriter.writeUInt32(input.sequence);
        bufferWriter.writeSlice(hashOutputs);
        bufferWriter.writeUInt32(this.locktime);
        bufferWriter.writeUInt32(hashType);
        return $1c834b456d93f732$exports.hash256(tbuffer);
    }
    getHash(forWitness) {
        // wtxid for coinbase is always 32 bytes of 0x00
        if (forWitness && this.isCoinbase()) return $fd7ffb7eadbf465f$require$Buffer.alloc(32, 0);
        return $1c834b456d93f732$exports.hash256(this.__toBuffer(undefined, undefined, forWitness));
    }
    getId() {
        // transaction hash's are displayed in reverse order
        return $9192ad2b59302b6c$exports.reverseBuffer(this.getHash(false)).toString("hex");
    }
    toBuffer(buffer, initialOffset) {
        return this.__toBuffer(buffer, initialOffset, true);
    }
    toHex() {
        return this.toBuffer(undefined, undefined).toString("hex");
    }
    setInputScript(index, scriptSig) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Number, $e79ff6cff6024683$exports.Buffer), arguments);
        this.ins[index].script = scriptSig;
    }
    setWitness(index, witness) {
        $lYlyf($e79ff6cff6024683$exports.tuple($e79ff6cff6024683$exports.Number, [
            $e79ff6cff6024683$exports.Buffer
        ]), arguments);
        this.ins[index].witness = witness;
    }
    __toBuffer(buffer, initialOffset, _ALLOW_WITNESS = false) {
        if (!buffer) buffer = $fd7ffb7eadbf465f$require$Buffer.allocUnsafe(this.byteLength(_ALLOW_WITNESS));
        const bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(buffer, initialOffset || 0);
        bufferWriter.writeInt32(this.version);
        const hasWitnesses = _ALLOW_WITNESS && this.hasWitnesses();
        if (hasWitnesses) {
            bufferWriter.writeUInt8($fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER);
            bufferWriter.writeUInt8($fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG);
        }
        bufferWriter.writeVarInt(this.ins.length);
        this.ins.forEach((txIn)=>{
            bufferWriter.writeSlice(txIn.hash);
            bufferWriter.writeUInt32(txIn.index);
            bufferWriter.writeVarSlice(txIn.script);
            bufferWriter.writeUInt32(txIn.sequence);
        });
        bufferWriter.writeVarInt(this.outs.length);
        this.outs.forEach((txOut)=>{
            if ($fd7ffb7eadbf465f$var$isOutput(txOut)) bufferWriter.writeUInt64(txOut.value);
            else bufferWriter.writeSlice(txOut.valueBuffer);
            bufferWriter.writeVarSlice(txOut.script);
        });
        if (hasWitnesses) this.ins.forEach((input)=>{
            bufferWriter.writeVector(input.witness);
        });
        bufferWriter.writeUInt32(this.locktime);
        // avoid slicing unless necessary
        if (initialOffset !== undefined) return buffer.slice(initialOffset, bufferWriter.offset);
        return buffer;
    }
}
$fd7ffb7eadbf465f$var$Transaction.DEFAULT_SEQUENCE = 0xffffffff;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_ALL = 0x01;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_NONE = 0x02;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_SINGLE = 0x03;
$fd7ffb7eadbf465f$var$Transaction.SIGHASH_ANYONECANPAY = 0x80;
$fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_MARKER = 0x00;
$fd7ffb7eadbf465f$var$Transaction.ADVANCED_TRANSACTION_FLAG = 0x01;
$fd7ffb7eadbf465f$exports.Transaction = $fd7ffb7eadbf465f$var$Transaction;



var $332515b1e42ce389$exports = {};
// constant-space merkle root calculation algorithm

var $6ZWSX = parcelRequire("6ZWSX");
var $332515b1e42ce389$require$Buffer = $6ZWSX.Buffer;
$332515b1e42ce389$exports = function fastRoot(values, digestFn) {
    if (!Array.isArray(values)) throw TypeError("Expected values Array");
    if (typeof digestFn !== "function") throw TypeError("Expected digest Function");
    var length = values.length;
    var results = values.concat();
    while(length > 1){
        var j = 0;
        for(var i = 0; i < length; i += 2, ++j){
            var left = results[i];
            var right = i + 1 === length ? left : results[i + 1];
            var data = $332515b1e42ce389$require$Buffer.concat([
                left,
                right
            ]);
            results[j] = digestFn(data);
        }
        length = j;
    }
    return results[0];
};



var $lYlyf = parcelRequire("lYlyf");

var $JAEWR = parcelRequire("JAEWR");
const $c190b973b56bdb52$var$errorMerkleNoTxes = new TypeError("Cannot compute merkle root for zero transactions");
const $c190b973b56bdb52$var$errorWitnessNotSegwit = new TypeError("Cannot compute witness commit for non-segwit block");
class $c190b973b56bdb52$var$Block {
    constructor(){
        this.version = 1;
        this.prevHash = undefined;
        this.merkleRoot = undefined;
        this.timestamp = 0;
        this.witnessCommit = undefined;
        this.bits = 0;
        this.nonce = 0;
        this.transactions = undefined;
    }
    static fromBuffer(buffer) {
        if (buffer.length < 80) throw new Error("Buffer too small (< 80 bytes)");
        const bufferReader = new $9192ad2b59302b6c$exports.BufferReader(buffer);
        const block = new $c190b973b56bdb52$var$Block();
        block.version = bufferReader.readInt32();
        block.prevHash = bufferReader.readSlice(32);
        block.merkleRoot = bufferReader.readSlice(32);
        block.timestamp = bufferReader.readUInt32();
        block.bits = bufferReader.readUInt32();
        block.nonce = bufferReader.readUInt32();
        if (buffer.length === 80) return block;
        const readTransaction = ()=>{
            const tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(bufferReader.buffer.slice(bufferReader.offset), true);
            bufferReader.offset += tx.byteLength();
            return tx;
        };
        const nTransactions = bufferReader.readVarInt();
        block.transactions = [];
        for(let i = 0; i < nTransactions; ++i){
            const tx = readTransaction();
            block.transactions.push(tx);
        }
        const witnessCommit = block.getWitnessCommit();
        // This Block contains a witness commit
        if (witnessCommit) block.witnessCommit = witnessCommit;
        return block;
    }
    static fromHex(hex) {
        return $c190b973b56bdb52$var$Block.fromBuffer($c190b973b56bdb52$require$Buffer.from(hex, "hex"));
    }
    static calculateTarget(bits) {
        const exponent = ((bits & 0xff000000) >> 24) - 3;
        const mantissa = bits & 0x007fffff;
        const target = $c190b973b56bdb52$require$Buffer.alloc(32, 0);
        target.writeUIntBE(mantissa, 29 - exponent, 3);
        return target;
    }
    static calculateMerkleRoot(transactions, forWitness) {
        $lYlyf([
            {
                getHash: $e79ff6cff6024683$exports.Function
            }
        ], transactions);
        if (transactions.length === 0) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        if (forWitness && !$c190b973b56bdb52$var$txesHaveWitnessCommit(transactions)) throw $c190b973b56bdb52$var$errorWitnessNotSegwit;
        const hashes = transactions.map((transaction)=>transaction.getHash(forWitness));
        const rootHash = $332515b1e42ce389$exports(hashes, $1c834b456d93f732$exports.hash256);
        return forWitness ? $1c834b456d93f732$exports.hash256($c190b973b56bdb52$require$Buffer.concat([
            rootHash,
            transactions[0].ins[0].witness[0]
        ])) : rootHash;
    }
    getWitnessCommit() {
        if (!$c190b973b56bdb52$var$txesHaveWitnessCommit(this.transactions)) return null;
        // The merkle root for the witness data is in an OP_RETURN output.
        // There is no rule for the index of the output, so use filter to find it.
        // The root is prepended with 0xaa21a9ed so check for 0x6a24aa21a9ed
        // If multiple commits are found, the output with highest index is assumed.
        const witnessCommits = this.transactions[0].outs.filter((out)=>out.script.slice(0, 6).equals($c190b973b56bdb52$require$Buffer.from("6a24aa21a9ed", "hex"))).map((out)=>out.script.slice(6, 38));
        if (witnessCommits.length === 0) return null;
        // Use the commit with the highest output (should only be one though)
        const result = witnessCommits[witnessCommits.length - 1];
        if (!(result instanceof $c190b973b56bdb52$require$Buffer && result.length === 32)) return null;
        return result;
    }
    hasWitnessCommit() {
        if (this.witnessCommit instanceof $c190b973b56bdb52$require$Buffer && this.witnessCommit.length === 32) return true;
        if (this.getWitnessCommit() !== null) return true;
        return false;
    }
    hasWitness() {
        return $c190b973b56bdb52$var$anyTxHasWitness(this.transactions);
    }
    weight() {
        const base = this.byteLength(false, false);
        const total = this.byteLength(false, true);
        return base * 3 + total;
    }
    byteLength(headersOnly, allowWitness = true) {
        if (headersOnly || !this.transactions) return 80;
        return 80 + $JAEWR.encodingLength(this.transactions.length) + this.transactions.reduce((a, x)=>a + x.byteLength(allowWitness), 0);
    }
    getHash() {
        return $1c834b456d93f732$exports.hash256(this.toBuffer(true));
    }
    getId() {
        return $9192ad2b59302b6c$exports.reverseBuffer(this.getHash()).toString("hex");
    }
    getUTCDate() {
        const date = new Date(0); // epoch
        date.setUTCSeconds(this.timestamp);
        return date;
    }
    // TODO: buffer, offset compatibility
    toBuffer(headersOnly) {
        const buffer = $c190b973b56bdb52$require$Buffer.allocUnsafe(this.byteLength(headersOnly));
        const bufferWriter = new $9192ad2b59302b6c$exports.BufferWriter(buffer);
        bufferWriter.writeInt32(this.version);
        bufferWriter.writeSlice(this.prevHash);
        bufferWriter.writeSlice(this.merkleRoot);
        bufferWriter.writeUInt32(this.timestamp);
        bufferWriter.writeUInt32(this.bits);
        bufferWriter.writeUInt32(this.nonce);
        if (headersOnly || !this.transactions) return buffer;
        $JAEWR.encode(this.transactions.length, buffer, bufferWriter.offset);
        bufferWriter.offset += $JAEWR.encode.bytes;
        this.transactions.forEach((tx)=>{
            const txSize = tx.byteLength(); // TODO: extract from toBuffer?
            tx.toBuffer(buffer, bufferWriter.offset);
            bufferWriter.offset += txSize;
        });
        return buffer;
    }
    toHex(headersOnly) {
        return this.toBuffer(headersOnly).toString("hex");
    }
    checkTxRoots() {
        // If the Block has segwit transactions but no witness commit,
        // there's no way it can be valid, so fail the check.
        const hasWitnessCommit = this.hasWitnessCommit();
        if (!hasWitnessCommit && this.hasWitness()) return false;
        return this.__checkMerkleRoot() && (hasWitnessCommit ? this.__checkWitnessCommit() : true);
    }
    checkProofOfWork() {
        const hash = $9192ad2b59302b6c$exports.reverseBuffer(this.getHash());
        const target = $c190b973b56bdb52$var$Block.calculateTarget(this.bits);
        return hash.compare(target) <= 0;
    }
    __checkMerkleRoot() {
        if (!this.transactions) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        const actualMerkleRoot = $c190b973b56bdb52$var$Block.calculateMerkleRoot(this.transactions);
        return this.merkleRoot.compare(actualMerkleRoot) === 0;
    }
    __checkWitnessCommit() {
        if (!this.transactions) throw $c190b973b56bdb52$var$errorMerkleNoTxes;
        if (!this.hasWitnessCommit()) throw $c190b973b56bdb52$var$errorWitnessNotSegwit;
        const actualWitnessCommit = $c190b973b56bdb52$var$Block.calculateMerkleRoot(this.transactions, true);
        return this.witnessCommit.compare(actualWitnessCommit) === 0;
    }
}
$c190b973b56bdb52$exports.Block = $c190b973b56bdb52$var$Block;
function $c190b973b56bdb52$var$txesHaveWitnessCommit(transactions) {
    return transactions instanceof Array && transactions[0] && transactions[0].ins && transactions[0].ins instanceof Array && transactions[0].ins[0] && transactions[0].ins[0].witness && transactions[0].ins[0].witness instanceof Array && transactions[0].ins[0].witness.length > 0;
}
function $c190b973b56bdb52$var$anyTxHasWitness(transactions) {
    return transactions instanceof Array && transactions.some((tx)=>typeof tx === "object" && tx.ins instanceof Array && tx.ins.some((input)=>typeof input === "object" && input.witness instanceof Array && input.witness.length > 0));
}


$58cf3bc07eb2f0ea$exports.Block = $c190b973b56bdb52$exports.Block;
var $be6c7a369b481828$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $be6c7a369b481828$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($be6c7a369b481828$exports, "__esModule", {
    value: true
});

var $jbkDe = parcelRequire("jbkDe");

var $gjBY1 = parcelRequire("gjBY1");

var $geRUU = parcelRequire("geRUU");








/**
 * These are the default arguments for a Psbt instance.
 */ const $be6c7a369b481828$var$DEFAULT_OPTS = {
    /**
   * A bitcoinjs Network object. This is only used if you pass an `address`
   * parameter to addOutput. Otherwise it is not needed and can be left default.
   */ network: $a2ef7e6d3e9bbe84$exports.bitcoin,
    /**
   * When extractTransaction is called, the fee rate is checked.
   * THIS IS NOT TO BE RELIED ON.
   * It is only here as a last ditch effort to prevent sending a 500 BTC fee etc.
   */ maximumFeeRate: 5000
};
/**
 * Psbt class can parse and generate a PSBT binary based off of the BIP174.
 * There are 6 roles that this class fulfills. (Explained in BIP174)
 *
 * Creator: This can be done with `new Psbt()`
 * Updater: This can be done with `psbt.addInput(input)`, `psbt.addInputs(inputs)`,
 *   `psbt.addOutput(output)`, `psbt.addOutputs(outputs)` when you are looking to
 *   add new inputs and outputs to the PSBT, and `psbt.updateGlobal(itemObject)`,
 *   `psbt.updateInput(itemObject)`, `psbt.updateOutput(itemObject)`
 *   addInput requires hash: Buffer | string; and index: number; as attributes
 *   and can also include any attributes that are used in updateInput method.
 *   addOutput requires script: Buffer; and value: number; and likewise can include
 *   data for updateOutput.
 *   For a list of what attributes should be what types. Check the bip174 library.
 *   Also, check the integration tests for some examples of usage.
 * Signer: There are a few methods. signAllInputs and signAllInputsAsync, which will search all input
 *   information for your pubkey or pubkeyhash, and only sign inputs where it finds
 *   your info. Or you can explicitly sign a specific input with signInput and
 *   signInputAsync. For the async methods you can create a SignerAsync object
 *   and use something like a hardware wallet to sign with. (You must implement this)
 * Combiner: psbts can be combined easily with `psbt.combine(psbt2, psbt3, psbt4 ...)`
 *   the psbt calling combine will always have precedence when a conflict occurs.
 *   Combine checks if the internal bitcoin transaction is the same, so be sure that
 *   all sequences, version, locktime, etc. are the same before combining.
 * Input Finalizer: This role is fairly important. Not only does it need to construct
 *   the input scriptSigs and witnesses, but it SHOULD verify the signatures etc.
 *   Before running `psbt.finalizeAllInputs()` please run `psbt.validateSignaturesOfAllInputs()`
 *   Running any finalize method will delete any data in the input(s) that are no longer
 *   needed due to the finalized scripts containing the information.
 * Transaction Extractor: This role will perform some checks before returning a
 *   Transaction object. Such as fee rate not being larger than maximumFeeRate etc.
 */ class $be6c7a369b481828$var$Psbt {
    constructor(opts = {}, data = new $jbkDe.Psbt(new $be6c7a369b481828$var$PsbtTransaction())){
        this.data = data;
        // set defaults
        this.opts = Object.assign({}, $be6c7a369b481828$var$DEFAULT_OPTS, opts);
        this.__CACHE = {
            __NON_WITNESS_UTXO_TX_CACHE: [],
            __NON_WITNESS_UTXO_BUF_CACHE: [],
            __TX_IN_CACHE: {},
            __TX: this.data.globalMap.unsignedTx.tx,
            // Old TransactionBuilder behavior was to not confirm input values
            // before signing. Even though we highly encourage people to get
            // the full parent transaction to verify values, the ability to
            // sign non-segwit inputs without the full transaction was often
            // requested. So the only way to activate is to use @ts-ignore.
            // We will disable exporting the Psbt when unsafe sign is active.
            // because it is not BIP174 compliant.
            __UNSAFE_SIGN_NONSEGWIT: false
        };
        if (this.data.inputs.length === 0) this.setVersion(2);
        // Make data hidden when enumerating
        const dpew = (obj, attr, enumerable, writable)=>Object.defineProperty(obj, attr, {
                enumerable: enumerable,
                writable: writable
            });
        dpew(this, "__CACHE", false, true);
        dpew(this, "opts", false, true);
    }
    static fromBase64(data, opts = {}) {
        const buffer = $be6c7a369b481828$require$Buffer.from(data, "base64");
        return this.fromBuffer(buffer, opts);
    }
    static fromHex(data, opts = {}) {
        const buffer = $be6c7a369b481828$require$Buffer.from(data, "hex");
        return this.fromBuffer(buffer, opts);
    }
    static fromBuffer(buffer, opts = {}) {
        const psbtBase = $jbkDe.Psbt.fromBuffer(buffer, $be6c7a369b481828$var$transactionFromBuffer);
        const psbt = new $be6c7a369b481828$var$Psbt(opts, psbtBase);
        $be6c7a369b481828$var$checkTxForDupeIns(psbt.__CACHE.__TX, psbt.__CACHE);
        return psbt;
    }
    get inputCount() {
        return this.data.inputs.length;
    }
    get version() {
        return this.__CACHE.__TX.version;
    }
    set version(version) {
        this.setVersion(version);
    }
    get locktime() {
        return this.__CACHE.__TX.locktime;
    }
    set locktime(locktime) {
        this.setLocktime(locktime);
    }
    get txInputs() {
        return this.__CACHE.__TX.ins.map((input)=>({
                hash: $9192ad2b59302b6c$exports.cloneBuffer(input.hash),
                index: input.index,
                sequence: input.sequence
            }));
    }
    get txOutputs() {
        return this.__CACHE.__TX.outs.map((output)=>{
            let address;
            try {
                address = $d26ee8edcbfb8f9e$exports.fromOutputScript(output.script, this.opts.network);
            } catch (_) {}
            return {
                script: $9192ad2b59302b6c$exports.cloneBuffer(output.script),
                value: output.value,
                address: address
            };
        });
    }
    combine(...those) {
        this.data.combine(...those.map((o)=>o.data));
        return this;
    }
    clone() {
        // TODO: more efficient cloning
        const res = $be6c7a369b481828$var$Psbt.fromBuffer(this.data.toBuffer());
        res.opts = JSON.parse(JSON.stringify(this.opts));
        return res;
    }
    setMaximumFeeRate(satoshiPerByte) {
        $be6c7a369b481828$var$check32Bit(satoshiPerByte); // 42.9 BTC per byte IS excessive... so throw
        this.opts.maximumFeeRate = satoshiPerByte;
    }
    setVersion(version) {
        $be6c7a369b481828$var$check32Bit(version);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, "setVersion");
        const c = this.__CACHE;
        c.__TX.version = version;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setLocktime(locktime) {
        $be6c7a369b481828$var$check32Bit(locktime);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, "setLocktime");
        const c = this.__CACHE;
        c.__TX.locktime = locktime;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    setInputSequence(inputIndex, sequence) {
        $be6c7a369b481828$var$check32Bit(sequence);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, "setInputSequence");
        const c = this.__CACHE;
        if (c.__TX.ins.length <= inputIndex) throw new Error("Input index too high");
        c.__TX.ins[inputIndex].sequence = sequence;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addInputs(inputDatas) {
        inputDatas.forEach((inputData)=>this.addInput(inputData));
        return this;
    }
    addInput(inputData) {
        if (arguments.length > 1 || !inputData || inputData.hash === undefined || inputData.index === undefined) throw new Error(`Invalid arguments for Psbt.addInput. ` + `Requires single object with at least [hash] and [index]`);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, "addInput");
        if (inputData.witnessScript) $be6c7a369b481828$var$checkInvalidP2WSH(inputData.witnessScript);
        const c = this.__CACHE;
        this.data.addInput(inputData);
        const txIn = c.__TX.ins[c.__TX.ins.length - 1];
        $be6c7a369b481828$var$checkTxInputCache(c, txIn);
        const inputIndex = this.data.inputs.length - 1;
        const input = this.data.inputs[inputIndex];
        if (input.nonWitnessUtxo) $be6c7a369b481828$var$addNonWitnessTxCache(this.__CACHE, input, inputIndex);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    addOutputs(outputDatas) {
        outputDatas.forEach((outputData)=>this.addOutput(outputData));
        return this;
    }
    addOutput(outputData) {
        if (arguments.length > 1 || !outputData || outputData.value === undefined || outputData.address === undefined && outputData.script === undefined) throw new Error(`Invalid arguments for Psbt.addOutput. ` + `Requires single object with at least [script or address] and [value]`);
        $be6c7a369b481828$var$checkInputsForPartialSig(this.data.inputs, "addOutput");
        const { address: address } = outputData;
        if (typeof address === "string") {
            const { network: network } = this.opts;
            const script = $d26ee8edcbfb8f9e$exports.toOutputScript(address, network);
            outputData = Object.assign(outputData, {
                script: script
            });
        }
        const c = this.__CACHE;
        this.data.addOutput(outputData);
        c.__FEE = undefined;
        c.__FEE_RATE = undefined;
        c.__EXTRACTED_TX = undefined;
        return this;
    }
    extractTransaction(disableFeeCheck) {
        if (!this.data.inputs.every($be6c7a369b481828$var$isFinalized)) throw new Error("Not finalized");
        const c = this.__CACHE;
        if (!disableFeeCheck) $be6c7a369b481828$var$checkFees(this, c, this.opts);
        if (c.__EXTRACTED_TX) return c.__EXTRACTED_TX;
        const tx = c.__TX.clone();
        $be6c7a369b481828$var$inputFinalizeGetAmts(this.data.inputs, tx, c, true);
        return tx;
    }
    getFeeRate() {
        return $be6c7a369b481828$var$getTxCacheValue("__FEE_RATE", "fee rate", this.data.inputs, this.__CACHE);
    }
    getFee() {
        return $be6c7a369b481828$var$getTxCacheValue("__FEE", "fee", this.data.inputs, this.__CACHE);
    }
    finalizeAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        $be6c7a369b481828$var$range(this.data.inputs.length).forEach((idx)=>this.finalizeInput(idx));
        return this;
    }
    finalizeInput(inputIndex, finalScriptsFunc = $be6c7a369b481828$var$getFinalScripts) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const { script: script, isP2SH: isP2SH, isP2WSH: isP2WSH, isSegwit: isSegwit } = $be6c7a369b481828$var$getScriptFromInput(inputIndex, input, this.__CACHE);
        if (!script) throw new Error(`No script found for input #${inputIndex}`);
        $be6c7a369b481828$var$checkPartialSigSighashes(input);
        const { finalScriptSig: finalScriptSig, finalScriptWitness: finalScriptWitness } = finalScriptsFunc(inputIndex, input, script, isSegwit, isP2SH, isP2WSH);
        if (finalScriptSig) this.data.updateInput(inputIndex, {
            finalScriptSig: finalScriptSig
        });
        if (finalScriptWitness) this.data.updateInput(inputIndex, {
            finalScriptWitness: finalScriptWitness
        });
        if (!finalScriptSig && !finalScriptWitness) throw new Error(`Unknown error finalizing input #${inputIndex}`);
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
    getInputType(inputIndex) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const script = $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, this.__CACHE);
        const result = $be6c7a369b481828$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript || $be6c7a369b481828$var$redeemFromFinalScriptSig(input.finalScriptSig), input.witnessScript || $be6c7a369b481828$var$redeemFromFinalWitnessScript(input.finalScriptWitness));
        const type = result.type === "raw" ? "" : result.type + "-";
        const mainType = $be6c7a369b481828$var$classifyScript(result.meaningfulScript);
        return type + mainType;
    }
    inputHasPubkey(inputIndex, pubkey) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        return $be6c7a369b481828$var$pubkeyInInput(pubkey, input, inputIndex, this.__CACHE);
    }
    inputHasHDKey(inputIndex, root) {
        const input = $geRUU.checkForInput(this.data.inputs, inputIndex);
        const derivationIsMine = $be6c7a369b481828$var$bip32DerivationIsMine(root);
        return !!input.bip32Derivation && input.bip32Derivation.some(derivationIsMine);
    }
    outputHasPubkey(outputIndex, pubkey) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        return $be6c7a369b481828$var$pubkeyInOutput(pubkey, output, outputIndex, this.__CACHE);
    }
    outputHasHDKey(outputIndex, root) {
        const output = $geRUU.checkForOutput(this.data.outputs, outputIndex);
        const derivationIsMine = $be6c7a369b481828$var$bip32DerivationIsMine(root);
        return !!output.bip32Derivation && output.bip32Derivation.some(derivationIsMine);
    }
    validateSignaturesOfAllInputs() {
        $geRUU.checkForInput(this.data.inputs, 0); // making sure we have at least one
        const results = $be6c7a369b481828$var$range(this.data.inputs.length).map((idx)=>this.validateSignaturesOfInput(idx));
        return results.reduce((final, res)=>res === true && final, true);
    }
    validateSignaturesOfInput(inputIndex, pubkey) {
        const input = this.data.inputs[inputIndex];
        const partialSig = (input || {}).partialSig;
        if (!input || !partialSig || partialSig.length < 1) throw new Error("No signatures to validate");
        const mySigs = pubkey ? partialSig.filter((sig)=>sig.pubkey.equals(pubkey)) : partialSig;
        if (mySigs.length < 1) throw new Error("No signatures for this pubkey");
        const results = [];
        let hashCache;
        let scriptCache;
        let sighashCache;
        for (const pSig of mySigs){
            const sig = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
            const { hash: hash, script: script } = sighashCache !== sig.hashType ? $be6c7a369b481828$var$getHashForSig(inputIndex, Object.assign({}, input, {
                sighashType: sig.hashType
            }), this.__CACHE, true) : {
                hash: hashCache,
                script: scriptCache
            };
            sighashCache = sig.hashType;
            hashCache = hash;
            scriptCache = script;
            $be6c7a369b481828$var$checkScriptForPubkey(pSig.pubkey, script, "verify");
            const keypair = $c32869daae2b1652$exports.fromPublicKey(pSig.pubkey);
            results.push(keypair.verify(hash, sig.signature));
        }
        return results.every((res)=>res === true);
    }
    signAllInputsHD(hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const results = [];
        for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))try {
            this.signInputHD(i, hdKeyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsHDAsync(hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const results = [];
            const promises = [];
            for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))promises.push(this.signInputHDAsync(i, hdKeyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInputHD(inputIndex, hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) throw new Error("Need HDSigner to sign input");
        const signers = $be6c7a369b481828$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
        signers.forEach((signer)=>this.signInput(inputIndex, signer, sighashTypes));
        return this;
    }
    signInputHDAsync(inputIndex, hdKeyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!hdKeyPair || !hdKeyPair.publicKey || !hdKeyPair.fingerprint) return reject(new Error("Need HDSigner to sign input"));
            const signers = $be6c7a369b481828$var$getSignersFromHD(inputIndex, this.data.inputs, hdKeyPair);
            const promises = signers.map((signer)=>this.signInputAsync(inputIndex, signer, sighashTypes));
            return Promise.all(promises).then(()=>{
                resolve();
            }).catch(reject);
        });
    }
    signAllInputs(keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        // TODO: Add a pubkey/pubkeyhash cache to each input
        // as input information is added, then eventually
        // optimize this method.
        const results = [];
        for (const i of $be6c7a369b481828$var$range(this.data.inputs.length))try {
            this.signInput(i, keyPair, sighashTypes);
            results.push(true);
        } catch (err) {
            results.push(false);
        }
        if (results.every((v)=>v === false)) throw new Error("No inputs were signed");
        return this;
    }
    signAllInputsAsync(keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return new Promise((resolve, reject)=>{
            if (!keyPair || !keyPair.publicKey) return reject(new Error("Need Signer to sign input"));
            // TODO: Add a pubkey/pubkeyhash cache to each input
            // as input information is added, then eventually
            // optimize this method.
            const results = [];
            const promises = [];
            for (const [i] of this.data.inputs.entries())promises.push(this.signInputAsync(i, keyPair, sighashTypes).then(()=>{
                results.push(true);
            }, ()=>{
                results.push(false);
            }));
            return Promise.all(promises).then(()=>{
                if (results.every((v)=>v === false)) return reject(new Error("No inputs were signed"));
                resolve();
            });
        });
    }
    signInput(inputIndex, keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
        const { hash: hash, sighashType: sighashType } = $be6c7a369b481828$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
        const partialSig = [
            {
                pubkey: keyPair.publicKey,
                signature: $a6e22d0fc87b0ff4$exports.signature.encode(keyPair.sign(hash), sighashType)
            }
        ];
        this.data.updateInput(inputIndex, {
            partialSig: partialSig
        });
        return this;
    }
    signInputAsync(inputIndex, keyPair, sighashTypes = [
        $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL
    ]) {
        return Promise.resolve().then(()=>{
            if (!keyPair || !keyPair.publicKey) throw new Error("Need Signer to sign input");
            const { hash: hash, sighashType: sighashType } = $be6c7a369b481828$var$getHashAndSighashType(this.data.inputs, inputIndex, keyPair.publicKey, this.__CACHE, sighashTypes);
            return Promise.resolve(keyPair.sign(hash)).then((signature)=>{
                const partialSig = [
                    {
                        pubkey: keyPair.publicKey,
                        signature: $a6e22d0fc87b0ff4$exports.signature.encode(signature, sighashType)
                    }
                ];
                this.data.updateInput(inputIndex, {
                    partialSig: partialSig
                });
            });
        });
    }
    toBuffer() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toBuffer();
    }
    toHex() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toHex();
    }
    toBase64() {
        $be6c7a369b481828$var$checkCache(this.__CACHE);
        return this.data.toBase64();
    }
    updateGlobal(updateData) {
        this.data.updateGlobal(updateData);
        return this;
    }
    updateInput(inputIndex, updateData) {
        if (updateData.witnessScript) $be6c7a369b481828$var$checkInvalidP2WSH(updateData.witnessScript);
        this.data.updateInput(inputIndex, updateData);
        if (updateData.nonWitnessUtxo) $be6c7a369b481828$var$addNonWitnessTxCache(this.__CACHE, this.data.inputs[inputIndex], inputIndex);
        return this;
    }
    updateOutput(outputIndex, updateData) {
        this.data.updateOutput(outputIndex, updateData);
        return this;
    }
    addUnknownKeyValToGlobal(keyVal) {
        this.data.addUnknownKeyValToGlobal(keyVal);
        return this;
    }
    addUnknownKeyValToInput(inputIndex, keyVal) {
        this.data.addUnknownKeyValToInput(inputIndex, keyVal);
        return this;
    }
    addUnknownKeyValToOutput(outputIndex, keyVal) {
        this.data.addUnknownKeyValToOutput(outputIndex, keyVal);
        return this;
    }
    clearFinalizedInput(inputIndex) {
        this.data.clearFinalizedInput(inputIndex);
        return this;
    }
}
$be6c7a369b481828$exports.Psbt = $be6c7a369b481828$var$Psbt;
/**
 * This function is needed to pass to the bip174 base class's fromBuffer.
 * It takes the "transaction buffer" portion of the psbt buffer and returns a
 * Transaction (From the bip174 library) interface.
 */ const $be6c7a369b481828$var$transactionFromBuffer = (buffer)=>new $be6c7a369b481828$var$PsbtTransaction(buffer);
/**
 * This class implements the Transaction interface from bip174 library.
 * It contains a bitcoinjs-lib Transaction object.
 */ class $be6c7a369b481828$var$PsbtTransaction {
    constructor(buffer = $be6c7a369b481828$require$Buffer.from([
        2,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0,
        0
    ])){
        this.tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(buffer);
        $be6c7a369b481828$var$checkTxEmpty(this.tx);
        Object.defineProperty(this, "tx", {
            enumerable: false,
            writable: true
        });
    }
    getInputOutputCounts() {
        return {
            inputCount: this.tx.ins.length,
            outputCount: this.tx.outs.length
        };
    }
    addInput(input) {
        if (input.hash === undefined || input.index === undefined || !$be6c7a369b481828$require$Buffer.isBuffer(input.hash) && typeof input.hash !== "string" || typeof input.index !== "number") throw new Error("Error adding input.");
        const hash = typeof input.hash === "string" ? $9192ad2b59302b6c$exports.reverseBuffer($be6c7a369b481828$require$Buffer.from(input.hash, "hex")) : input.hash;
        this.tx.addInput(hash, input.index, input.sequence);
    }
    addOutput(output) {
        if (output.script === undefined || output.value === undefined || !$be6c7a369b481828$require$Buffer.isBuffer(output.script) || typeof output.value !== "number") throw new Error("Error adding output.");
        this.tx.addOutput(output.script, output.value);
    }
    toBuffer() {
        return this.tx.toBuffer();
    }
}
function $be6c7a369b481828$var$canFinalize(input, script, scriptType) {
    switch(scriptType){
        case "pubkey":
        case "pubkeyhash":
        case "witnesspubkeyhash":
            return $be6c7a369b481828$var$hasSigs(1, input.partialSig);
        case "multisig":
            const p2ms = $bed04000b8455fa3$exports.p2ms({
                output: script
            });
            return $be6c7a369b481828$var$hasSigs(p2ms.m, input.partialSig, p2ms.pubkeys);
        default:
            return false;
    }
}
function $be6c7a369b481828$var$checkCache(cache) {
    if (cache.__UNSAFE_SIGN_NONSEGWIT !== false) throw new Error("Not BIP174 compliant, can not export");
}
function $be6c7a369b481828$var$hasSigs(neededSigs, partialSig, pubkeys) {
    if (!partialSig) return false;
    let sigs;
    if (pubkeys) sigs = pubkeys.map((pkey)=>{
        const pubkey = $c32869daae2b1652$exports.fromPublicKey(pkey, {
            compressed: true
        }).publicKey;
        return partialSig.find((pSig)=>pSig.pubkey.equals(pubkey));
    }).filter((v)=>!!v);
    else sigs = partialSig;
    if (sigs.length > neededSigs) throw new Error("Too many signatures");
    return sigs.length === neededSigs;
}
function $be6c7a369b481828$var$isFinalized(input) {
    return !!input.finalScriptSig || !!input.finalScriptWitness;
}
function $be6c7a369b481828$var$isPaymentFactory(payment) {
    return (script)=>{
        try {
            payment({
                output: script
            });
            return true;
        } catch (err) {
            return false;
        }
    };
}
const $be6c7a369b481828$var$isP2MS = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2ms);
const $be6c7a369b481828$var$isP2PK = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2pk);
const $be6c7a369b481828$var$isP2PKH = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2pkh);
const $be6c7a369b481828$var$isP2WPKH = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2wpkh);
const $be6c7a369b481828$var$isP2WSHScript = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2wsh);
const $be6c7a369b481828$var$isP2SHScript = $be6c7a369b481828$var$isPaymentFactory($bed04000b8455fa3$exports.p2sh);
function $be6c7a369b481828$var$bip32DerivationIsMine(root) {
    return (d)=>{
        if (!d.masterFingerprint.equals(root.fingerprint)) return false;
        if (!root.derivePath(d.path).publicKey.equals(d.pubkey)) return false;
        return true;
    };
}
function $be6c7a369b481828$var$check32Bit(num) {
    if (typeof num !== "number" || num !== Math.floor(num) || num > 0xffffffff || num < 0) throw new Error("Invalid 32 bit integer");
}
function $be6c7a369b481828$var$checkFees(psbt, cache, opts) {
    const feeRate = cache.__FEE_RATE || psbt.getFeeRate();
    const vsize = cache.__EXTRACTED_TX.virtualSize();
    const satoshis = feeRate * vsize;
    if (feeRate >= opts.maximumFeeRate) throw new Error(`Warning: You are paying around ${(satoshis / 1e8).toFixed(8)} in ` + `fees, which is ${feeRate} satoshi per byte for a transaction ` + `with a VSize of ${vsize} bytes (segwit counted as 0.25 byte per ` + `byte). Use setMaximumFeeRate method to raise your threshold, or ` + `pass true to the first arg of extractTransaction.`);
}
function $be6c7a369b481828$var$checkInputsForPartialSig(inputs, action) {
    inputs.forEach((input)=>{
        let throws = false;
        let pSigs = [];
        if ((input.partialSig || []).length === 0) {
            if (!input.finalScriptSig && !input.finalScriptWitness) return;
            pSigs = $be6c7a369b481828$var$getPsigsFromInputFinalScripts(input);
        } else pSigs = input.partialSig;
        pSigs.forEach((pSig)=>{
            const { hashType: hashType } = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
            const whitelist = [];
            const isAnyoneCanPay = hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY;
            if (isAnyoneCanPay) whitelist.push("addInput");
            const hashMod = hashType & 0x1f;
            switch(hashMod){
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL:
                    break;
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE:
                case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE:
                    whitelist.push("addOutput");
                    whitelist.push("setInputSequence");
                    break;
            }
            if (whitelist.indexOf(action) === -1) throws = true;
        });
        if (throws) throw new Error("Can not modify transaction, signatures exist.");
    });
}
function $be6c7a369b481828$var$checkPartialSigSighashes(input) {
    if (!input.sighashType || !input.partialSig) return;
    const { partialSig: partialSig, sighashType: sighashType } = input;
    partialSig.forEach((pSig)=>{
        const { hashType: hashType } = $a6e22d0fc87b0ff4$exports.signature.decode(pSig.signature);
        if (sighashType !== hashType) throw new Error("Signature sighash does not match input sighash type");
    });
}
function $be6c7a369b481828$var$checkScriptForPubkey(pubkey, script, action) {
    if (!$be6c7a369b481828$var$pubkeyInScript(pubkey, script)) throw new Error(`Can not ${action} for this input with the key ${pubkey.toString("hex")}`);
}
function $be6c7a369b481828$var$checkTxEmpty(tx) {
    const isEmpty = tx.ins.every((input)=>input.script && input.script.length === 0 && input.witness && input.witness.length === 0);
    if (!isEmpty) throw new Error("Format Error: Transaction ScriptSigs are not empty");
}
function $be6c7a369b481828$var$checkTxForDupeIns(tx, cache) {
    tx.ins.forEach((input)=>{
        $be6c7a369b481828$var$checkTxInputCache(cache, input);
    });
}
function $be6c7a369b481828$var$checkTxInputCache(cache, input) {
    const key = $9192ad2b59302b6c$exports.reverseBuffer($be6c7a369b481828$require$Buffer.from(input.hash)).toString("hex") + ":" + input.index;
    if (cache.__TX_IN_CACHE[key]) throw new Error("Duplicate input detected.");
    cache.__TX_IN_CACHE[key] = 1;
}
function $be6c7a369b481828$var$scriptCheckerFactory(payment, paymentScriptName) {
    return (inputIndex, scriptPubKey, redeemScript, ioType)=>{
        const redeemScriptOutput = payment({
            redeem: {
                output: redeemScript
            }
        }).output;
        if (!scriptPubKey.equals(redeemScriptOutput)) throw new Error(`${paymentScriptName} for ${ioType} #${inputIndex} doesn't match the scriptPubKey in the prevout`);
    };
}
const $be6c7a369b481828$var$checkRedeemScript = $be6c7a369b481828$var$scriptCheckerFactory($bed04000b8455fa3$exports.p2sh, "Redeem script");
const $be6c7a369b481828$var$checkWitnessScript = $be6c7a369b481828$var$scriptCheckerFactory($bed04000b8455fa3$exports.p2wsh, "Witness script");
function $be6c7a369b481828$var$getTxCacheValue(key, name, inputs, c) {
    if (!inputs.every($be6c7a369b481828$var$isFinalized)) throw new Error(`PSBT must be finalized to calculate ${name}`);
    if (key === "__FEE_RATE" && c.__FEE_RATE) return c.__FEE_RATE;
    if (key === "__FEE" && c.__FEE) return c.__FEE;
    let tx;
    let mustFinalize = true;
    if (c.__EXTRACTED_TX) {
        tx = c.__EXTRACTED_TX;
        mustFinalize = false;
    } else tx = c.__TX.clone();
    $be6c7a369b481828$var$inputFinalizeGetAmts(inputs, tx, c, mustFinalize);
    if (key === "__FEE_RATE") return c.__FEE_RATE;
    else if (key === "__FEE") return c.__FEE;
}
function $be6c7a369b481828$var$getFinalScripts(inputIndex, input, script, isSegwit, isP2SH, isP2WSH) {
    const scriptType = $be6c7a369b481828$var$classifyScript(script);
    if (!$be6c7a369b481828$var$canFinalize(input, script, scriptType)) throw new Error(`Can not finalize input #${inputIndex}`);
    return $be6c7a369b481828$var$prepareFinalScripts(script, scriptType, input.partialSig, isSegwit, isP2SH, isP2WSH);
}
function $be6c7a369b481828$var$prepareFinalScripts(script, scriptType, partialSig, isSegwit, isP2SH, isP2WSH) {
    let finalScriptSig;
    let finalScriptWitness;
    // Wow, the payments API is very handy
    const payment = $be6c7a369b481828$var$getPayment(script, scriptType, partialSig);
    const p2wsh = !isP2WSH ? null : $bed04000b8455fa3$exports.p2wsh({
        redeem: payment
    });
    const p2sh = !isP2SH ? null : $bed04000b8455fa3$exports.p2sh({
        redeem: p2wsh || payment
    });
    if (isSegwit) {
        if (p2wsh) finalScriptWitness = $be6c7a369b481828$var$witnessStackToScriptWitness(p2wsh.witness);
        else finalScriptWitness = $be6c7a369b481828$var$witnessStackToScriptWitness(payment.witness);
        if (p2sh) finalScriptSig = p2sh.input;
    } else if (p2sh) finalScriptSig = p2sh.input;
    else finalScriptSig = payment.input;
    return {
        finalScriptSig: finalScriptSig,
        finalScriptWitness: finalScriptWitness
    };
}
function $be6c7a369b481828$var$getHashAndSighashType(inputs, inputIndex, pubkey, cache, sighashTypes) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    const { hash: hash, sighashType: sighashType, script: script } = $be6c7a369b481828$var$getHashForSig(inputIndex, input, cache, false, sighashTypes);
    $be6c7a369b481828$var$checkScriptForPubkey(pubkey, script, "sign");
    return {
        hash: hash,
        sighashType: sighashType
    };
}
function $be6c7a369b481828$var$getHashForSig(inputIndex, input, cache, forValidate, sighashTypes) {
    const unsignedTx = cache.__TX;
    const sighashType = input.sighashType || $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL;
    if (sighashTypes && sighashTypes.indexOf(sighashType) < 0) {
        const str = $be6c7a369b481828$var$sighashTypeToString(sighashType);
        throw new Error(`Sighash type is not allowed. Retry the sign method passing the ` + `sighashTypes array of whitelisted types. Sighash type: ${str}`);
    }
    let hash;
    let prevout;
    if (input.nonWitnessUtxo) {
        const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        const prevoutHash = unsignedTx.ins[inputIndex].hash;
        const utxoHash = nonWitnessUtxoTx.getHash();
        // If a non-witness UTXO is provided, its hash must match the hash specified in the prevout
        if (!prevoutHash.equals(utxoHash)) throw new Error(`Non-witness UTXO hash for input #${inputIndex} doesn't match the hash specified in the prevout`);
        const prevoutIndex = unsignedTx.ins[inputIndex].index;
        prevout = nonWitnessUtxoTx.outs[prevoutIndex];
    } else if (input.witnessUtxo) prevout = input.witnessUtxo;
    else throw new Error("Need a Utxo input item for signing");
    const { meaningfulScript: meaningfulScript, type: type } = $be6c7a369b481828$var$getMeaningfulScript(prevout.script, inputIndex, "input", input.redeemScript, input.witnessScript);
    if ([
        "p2sh-p2wsh",
        "p2wsh"
    ].indexOf(type) >= 0) hash = unsignedTx.hashForWitnessV0(inputIndex, meaningfulScript, prevout.value, sighashType);
    else if ($be6c7a369b481828$var$isP2WPKH(meaningfulScript)) {
        // P2WPKH uses the P2PKH template for prevoutScript when signing
        const signingScript = $bed04000b8455fa3$exports.p2pkh({
            hash: meaningfulScript.slice(2)
        }).output;
        hash = unsignedTx.hashForWitnessV0(inputIndex, signingScript, prevout.value, sighashType);
    } else {
        // non-segwit
        if (input.nonWitnessUtxo === undefined && cache.__UNSAFE_SIGN_NONSEGWIT === false) throw new Error(`Input #${inputIndex} has witnessUtxo but non-segwit script: ` + `${meaningfulScript.toString("hex")}`);
        if (!forValidate && cache.__UNSAFE_SIGN_NONSEGWIT !== false) console.warn("Warning: Signing non-segwit inputs without the full parent transaction means there is a chance that a miner could feed you incorrect information to trick you into paying large fees. This behavior is the same as the old TransactionBuilder class when signing non-segwit scripts. You are not able to export this Psbt with toBuffer|toBase64|toHex since it is not BIP174 compliant.\n*********************\nPROCEED WITH CAUTION!\n*********************");
        hash = unsignedTx.hashForSignature(inputIndex, meaningfulScript, sighashType);
    }
    return {
        script: meaningfulScript,
        sighashType: sighashType,
        hash: hash
    };
}
function $be6c7a369b481828$var$getPayment(script, scriptType, partialSig) {
    let payment;
    switch(scriptType){
        case "multisig":
            const sigs = $be6c7a369b481828$var$getSortedSigs(script, partialSig);
            payment = $bed04000b8455fa3$exports.p2ms({
                output: script,
                signatures: sigs
            });
            break;
        case "pubkey":
            payment = $bed04000b8455fa3$exports.p2pk({
                output: script,
                signature: partialSig[0].signature
            });
            break;
        case "pubkeyhash":
            payment = $bed04000b8455fa3$exports.p2pkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
        case "witnesspubkeyhash":
            payment = $bed04000b8455fa3$exports.p2wpkh({
                output: script,
                pubkey: partialSig[0].pubkey,
                signature: partialSig[0].signature
            });
            break;
    }
    return payment;
}
function $be6c7a369b481828$var$getPsigsFromInputFinalScripts(input) {
    const scriptItems = !input.finalScriptSig ? [] : $a6e22d0fc87b0ff4$exports.decompile(input.finalScriptSig) || [];
    const witnessItems = !input.finalScriptWitness ? [] : $a6e22d0fc87b0ff4$exports.decompile(input.finalScriptWitness) || [];
    return scriptItems.concat(witnessItems).filter((item)=>{
        return $be6c7a369b481828$require$Buffer.isBuffer(item) && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(item);
    }).map((sig)=>({
            signature: sig
        }));
}
function $be6c7a369b481828$var$getScriptFromInput(inputIndex, input, cache) {
    const unsignedTx = cache.__TX;
    const res = {
        script: null,
        isSegwit: false,
        isP2SH: false,
        isP2WSH: false
    };
    res.isP2SH = !!input.redeemScript;
    res.isP2WSH = !!input.witnessScript;
    if (input.witnessScript) res.script = input.witnessScript;
    else if (input.redeemScript) res.script = input.redeemScript;
    else {
        if (input.nonWitnessUtxo) {
            const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
            const prevoutIndex = unsignedTx.ins[inputIndex].index;
            res.script = nonWitnessUtxoTx.outs[prevoutIndex].script;
        } else if (input.witnessUtxo) res.script = input.witnessUtxo.script;
    }
    if (input.witnessScript || $be6c7a369b481828$var$isP2WPKH(res.script)) res.isSegwit = true;
    return res;
}
function $be6c7a369b481828$var$getSignersFromHD(inputIndex, inputs, hdKeyPair) {
    const input = $geRUU.checkForInput(inputs, inputIndex);
    if (!input.bip32Derivation || input.bip32Derivation.length === 0) throw new Error("Need bip32Derivation to sign with HD");
    const myDerivations = input.bip32Derivation.map((bipDv)=>{
        if (bipDv.masterFingerprint.equals(hdKeyPair.fingerprint)) return bipDv;
        else return;
    }).filter((v)=>!!v);
    if (myDerivations.length === 0) throw new Error("Need one bip32Derivation masterFingerprint to match the HDSigner fingerprint");
    const signers = myDerivations.map((bipDv)=>{
        const node = hdKeyPair.derivePath(bipDv.path);
        if (!bipDv.pubkey.equals(node.publicKey)) throw new Error("pubkey did not match bip32Derivation");
        return node;
    });
    return signers;
}
function $be6c7a369b481828$var$getSortedSigs(script, partialSig) {
    const p2ms = $bed04000b8455fa3$exports.p2ms({
        output: script
    });
    // for each pubkey in order of p2ms script
    return p2ms.pubkeys.map((pk)=>{
        // filter partialSig array by pubkey being equal
        return (partialSig.filter((ps)=>{
            return ps.pubkey.equals(pk);
        })[0] || {}).signature;
    // Any pubkey without a match will return undefined
    // this last filter removes all the undefined items in the array.
    }).filter((v)=>!!v);
}
function $be6c7a369b481828$var$scriptWitnessToWitnessStack(buffer) {
    let offset = 0;
    function readSlice(n) {
        offset += n;
        return buffer.slice(offset - n, offset);
    }
    function readVarInt() {
        const vi = $gjBY1.decode(buffer, offset);
        offset += $gjBY1.decode.bytes;
        return vi;
    }
    function readVarSlice() {
        return readSlice(readVarInt());
    }
    function readVector() {
        const count = readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(readVarSlice());
        return vector;
    }
    return readVector();
}
function $be6c7a369b481828$var$sighashTypeToString(sighashType) {
    let text = sighashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY ? "SIGHASH_ANYONECANPAY | " : "";
    const sigMod = sighashType & 0x1f;
    switch(sigMod){
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL:
            text += "SIGHASH_ALL";
            break;
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE:
            text += "SIGHASH_SINGLE";
            break;
        case $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE:
            text += "SIGHASH_NONE";
            break;
    }
    return text;
}
function $be6c7a369b481828$var$witnessStackToScriptWitness(witness) {
    let buffer = $be6c7a369b481828$require$Buffer.allocUnsafe(0);
    function writeSlice(slice) {
        buffer = $be6c7a369b481828$require$Buffer.concat([
            buffer,
            $be6c7a369b481828$require$Buffer.from(slice)
        ]);
    }
    function writeVarInt(i) {
        const currentLen = buffer.length;
        const varintLen = $gjBY1.encodingLength(i);
        buffer = $be6c7a369b481828$require$Buffer.concat([
            buffer,
            $be6c7a369b481828$require$Buffer.allocUnsafe(varintLen)
        ]);
        $gjBY1.encode(i, buffer, currentLen);
    }
    function writeVarSlice(slice) {
        writeVarInt(slice.length);
        writeSlice(slice);
    }
    function writeVector(vector) {
        writeVarInt(vector.length);
        vector.forEach(writeVarSlice);
    }
    writeVector(witness);
    return buffer;
}
function $be6c7a369b481828$var$addNonWitnessTxCache(cache, input, inputIndex) {
    cache.__NON_WITNESS_UTXO_BUF_CACHE[inputIndex] = input.nonWitnessUtxo;
    const tx = $fd7ffb7eadbf465f$exports.Transaction.fromBuffer(input.nonWitnessUtxo);
    cache.__NON_WITNESS_UTXO_TX_CACHE[inputIndex] = tx;
    const self = cache;
    const selfIndex = inputIndex;
    delete input.nonWitnessUtxo;
    Object.defineProperty(input, "nonWitnessUtxo", {
        enumerable: true,
        get () {
            const buf = self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex];
            const txCache = self.__NON_WITNESS_UTXO_TX_CACHE[selfIndex];
            if (buf !== undefined) return buf;
            else {
                const newBuf = txCache.toBuffer();
                self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = newBuf;
                return newBuf;
            }
        },
        set (data) {
            self.__NON_WITNESS_UTXO_BUF_CACHE[selfIndex] = data;
        }
    });
}
function $be6c7a369b481828$var$inputFinalizeGetAmts(inputs, tx, cache, mustFinalize) {
    let inputAmount = 0;
    inputs.forEach((input, idx)=>{
        if (mustFinalize && input.finalScriptSig) tx.ins[idx].script = input.finalScriptSig;
        if (mustFinalize && input.finalScriptWitness) tx.ins[idx].witness = $be6c7a369b481828$var$scriptWitnessToWitnessStack(input.finalScriptWitness);
        if (input.witnessUtxo) inputAmount += input.witnessUtxo.value;
        else if (input.nonWitnessUtxo) {
            const nwTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, idx);
            const vout = tx.ins[idx].index;
            const out = nwTx.outs[vout];
            inputAmount += out.value;
        }
    });
    const outputAmount = tx.outs.reduce((total, o)=>total + o.value, 0);
    const fee = inputAmount - outputAmount;
    if (fee < 0) throw new Error("Outputs are spending more than Inputs");
    const bytes = tx.virtualSize();
    cache.__FEE = fee;
    cache.__EXTRACTED_TX = tx;
    cache.__FEE_RATE = Math.floor(fee / bytes);
}
function $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex) {
    const c = cache.__NON_WITNESS_UTXO_TX_CACHE;
    if (!c[inputIndex]) $be6c7a369b481828$var$addNonWitnessTxCache(cache, input, inputIndex);
    return c[inputIndex];
}
function $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, cache) {
    if (input.witnessUtxo !== undefined) return input.witnessUtxo.script;
    else if (input.nonWitnessUtxo !== undefined) {
        const nonWitnessUtxoTx = $be6c7a369b481828$var$nonWitnessUtxoTxFromCache(cache, input, inputIndex);
        return nonWitnessUtxoTx.outs[cache.__TX.ins[inputIndex].index].script;
    } else throw new Error("Can't find pubkey in input without Utxo data");
}
function $be6c7a369b481828$var$pubkeyInInput(pubkey, input, inputIndex, cache) {
    const script = $be6c7a369b481828$var$getScriptFromUtxo(inputIndex, input, cache);
    const { meaningfulScript: meaningfulScript } = $be6c7a369b481828$var$getMeaningfulScript(script, inputIndex, "input", input.redeemScript, input.witnessScript);
    return $be6c7a369b481828$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $be6c7a369b481828$var$pubkeyInOutput(pubkey, output, outputIndex, cache) {
    const script = cache.__TX.outs[outputIndex].script;
    const { meaningfulScript: meaningfulScript } = $be6c7a369b481828$var$getMeaningfulScript(script, outputIndex, "output", output.redeemScript, output.witnessScript);
    return $be6c7a369b481828$var$pubkeyInScript(pubkey, meaningfulScript);
}
function $be6c7a369b481828$var$redeemFromFinalScriptSig(finalScript) {
    if (!finalScript) return;
    const decomp = $a6e22d0fc87b0ff4$exports.decompile(finalScript);
    if (!decomp) return;
    const lastItem = decomp[decomp.length - 1];
    if (!$be6c7a369b481828$require$Buffer.isBuffer(lastItem) || $be6c7a369b481828$var$isPubkeyLike(lastItem) || $be6c7a369b481828$var$isSigLike(lastItem)) return;
    const sDecomp = $a6e22d0fc87b0ff4$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $be6c7a369b481828$var$redeemFromFinalWitnessScript(finalScript) {
    if (!finalScript) return;
    const decomp = $be6c7a369b481828$var$scriptWitnessToWitnessStack(finalScript);
    const lastItem = decomp[decomp.length - 1];
    if ($be6c7a369b481828$var$isPubkeyLike(lastItem)) return;
    const sDecomp = $a6e22d0fc87b0ff4$exports.decompile(lastItem);
    if (!sDecomp) return;
    return lastItem;
}
function $be6c7a369b481828$var$isPubkeyLike(buf) {
    return buf.length === 33 && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(buf);
}
function $be6c7a369b481828$var$isSigLike(buf) {
    return $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(buf);
}
function $be6c7a369b481828$var$getMeaningfulScript(script, index, ioType, redeemScript, witnessScript) {
    const isP2SH = $be6c7a369b481828$var$isP2SHScript(script);
    const isP2SHP2WSH = isP2SH && redeemScript && $be6c7a369b481828$var$isP2WSHScript(redeemScript);
    const isP2WSH = $be6c7a369b481828$var$isP2WSHScript(script);
    if (isP2SH && redeemScript === undefined) throw new Error("scriptPubkey is P2SH but redeemScript missing");
    if ((isP2WSH || isP2SHP2WSH) && witnessScript === undefined) throw new Error("scriptPubkey or redeemScript is P2WSH but witnessScript missing");
    let meaningfulScript;
    if (isP2SHP2WSH) {
        meaningfulScript = witnessScript;
        $be6c7a369b481828$var$checkRedeemScript(index, script, redeemScript, ioType);
        $be6c7a369b481828$var$checkWitnessScript(index, redeemScript, witnessScript, ioType);
        $be6c7a369b481828$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2WSH) {
        meaningfulScript = witnessScript;
        $be6c7a369b481828$var$checkWitnessScript(index, script, witnessScript, ioType);
        $be6c7a369b481828$var$checkInvalidP2WSH(meaningfulScript);
    } else if (isP2SH) {
        meaningfulScript = redeemScript;
        $be6c7a369b481828$var$checkRedeemScript(index, script, redeemScript, ioType);
    } else meaningfulScript = script;
    return {
        meaningfulScript: meaningfulScript,
        type: isP2SHP2WSH ? "p2sh-p2wsh" : isP2SH ? "p2sh" : isP2WSH ? "p2wsh" : "raw"
    };
}
function $be6c7a369b481828$var$checkInvalidP2WSH(script) {
    if ($be6c7a369b481828$var$isP2WPKH(script) || $be6c7a369b481828$var$isP2SHScript(script)) throw new Error("P2WPKH or P2SH can not be contained within P2WSH");
}
function $be6c7a369b481828$var$pubkeyInScript(pubkey, script) {
    const pubkeyHash = $1c834b456d93f732$exports.hash160(pubkey);
    const decompiled = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (decompiled === null) throw new Error("Unknown script error");
    return decompiled.some((element)=>{
        if (typeof element === "number") return false;
        return element.equals(pubkey) || element.equals(pubkeyHash);
    });
}
function $be6c7a369b481828$var$classifyScript(script) {
    if ($be6c7a369b481828$var$isP2WPKH(script)) return "witnesspubkeyhash";
    if ($be6c7a369b481828$var$isP2PKH(script)) return "pubkeyhash";
    if ($be6c7a369b481828$var$isP2MS(script)) return "multisig";
    if ($be6c7a369b481828$var$isP2PK(script)) return "pubkey";
    return "nonstandard";
}
function $be6c7a369b481828$var$range(n) {
    return [
        ...Array(n).keys()
    ];
}


$58cf3bc07eb2f0ea$exports.Psbt = $be6c7a369b481828$exports.Psbt;

$58cf3bc07eb2f0ea$exports.opcodes = $a6e22d0fc87b0ff4$exports.OPS;

$58cf3bc07eb2f0ea$exports.Transaction = $fd7ffb7eadbf465f$exports.Transaction;
var $9bb4ae5172bb4a73$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $9bb4ae5172bb4a73$require$Buffer = $6ZWSX.Buffer;
"use strict";
Object.defineProperty($9bb4ae5172bb4a73$exports, "__esModule", {
    value: true
});


var $7ec8d6ec0e56f0c7$exports = {};
"use strict";
Object.defineProperty($7ec8d6ec0e56f0c7$exports, "__esModule", {
    value: true
});

var $ebabbd148d301963$exports = {};
"use strict";
Object.defineProperty($ebabbd148d301963$exports, "__esModule", {
    value: true
});
var $9bd35fa9a665aeef$exports = {};
"use strict";
// OP_0 [signatures ...]
Object.defineProperty($9bd35fa9a665aeef$exports, "__esModule", {
    value: true
});


function $9bd35fa9a665aeef$var$partialSignature(value) {
    return value === $a6e22d0fc87b0ff4$exports.OPS.OP_0 || $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(value);
}
function $9bd35fa9a665aeef$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 2) return false;
    if (chunks[0] !== $a6e22d0fc87b0ff4$exports.OPS.OP_0) return false;
    if (allowIncomplete) return chunks.slice(1).every($9bd35fa9a665aeef$var$partialSignature);
    return chunks.slice(1).every($a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature);
}
$9bd35fa9a665aeef$exports.check = $9bd35fa9a665aeef$var$check;
$9bd35fa9a665aeef$var$check.toJSON = ()=>{
    return "multisig input";
};


$ebabbd148d301963$exports.input = $9bd35fa9a665aeef$exports;
var $158e277f95d00e7a$exports = {};
"use strict";
// m [pubKeys ...] n OP_CHECKMULTISIG
Object.defineProperty($158e277f95d00e7a$exports, "__esModule", {
    value: true
});



const $158e277f95d00e7a$var$OP_INT_BASE = $a6e22d0fc87b0ff4$exports.OPS.OP_RESERVED; // OP_1 - 1
function $158e277f95d00e7a$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 4) return false;
    if (chunks[chunks.length - 1] !== $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKMULTISIG) return false;
    if (!$e79ff6cff6024683$exports.Number(chunks[0])) return false;
    if (!$e79ff6cff6024683$exports.Number(chunks[chunks.length - 2])) return false;
    const m = chunks[0] - $158e277f95d00e7a$var$OP_INT_BASE;
    const n = chunks[chunks.length - 2] - $158e277f95d00e7a$var$OP_INT_BASE;
    if (m <= 0) return false;
    if (n > 16) return false;
    if (m > n) return false;
    if (n !== chunks.length - 3) return false;
    if (allowIncomplete) return true;
    const keys = chunks.slice(1, -2);
    return keys.every($a6e22d0fc87b0ff4$exports.isCanonicalPubKey);
}
$158e277f95d00e7a$exports.check = $158e277f95d00e7a$var$check;
$158e277f95d00e7a$var$check.toJSON = ()=>{
    return "multi-sig output";
};


$ebabbd148d301963$exports.output = $158e277f95d00e7a$exports;


var $4319358ebd9a1bba$exports = {};
"use strict";
Object.defineProperty($4319358ebd9a1bba$exports, "__esModule", {
    value: true
});

const $4319358ebd9a1bba$var$OPS = $a6e22d0fc87b0ff4$exports.OPS;
function $4319358ebd9a1bba$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length > 1 && buffer[0] === $4319358ebd9a1bba$var$OPS.OP_RETURN;
}
$4319358ebd9a1bba$exports.check = $4319358ebd9a1bba$var$check;
$4319358ebd9a1bba$var$check.toJSON = ()=>{
    return "null data output";
};
const $4319358ebd9a1bba$var$output = {
    check: $4319358ebd9a1bba$var$check
};
$4319358ebd9a1bba$exports.output = $4319358ebd9a1bba$var$output;


var $a570fc1301f5ae9e$exports = {};
"use strict";
Object.defineProperty($a570fc1301f5ae9e$exports, "__esModule", {
    value: true
});
var $555ce1c4bec08396$exports = {};
"use strict";
// {signature}
Object.defineProperty($555ce1c4bec08396$exports, "__esModule", {
    value: true
});

function $555ce1c4bec08396$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 1 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]);
}
$555ce1c4bec08396$exports.check = $555ce1c4bec08396$var$check;
$555ce1c4bec08396$var$check.toJSON = ()=>{
    return "pubKey input";
};


$a570fc1301f5ae9e$exports.input = $555ce1c4bec08396$exports;
var $062e4dea667e945f$exports = {};
"use strict";
// {pubKey} OP_CHECKSIG
Object.defineProperty($062e4dea667e945f$exports, "__esModule", {
    value: true
});


function $062e4dea667e945f$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(chunks[0]) && chunks[1] === $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKSIG;
}
$062e4dea667e945f$exports.check = $062e4dea667e945f$var$check;
$062e4dea667e945f$var$check.toJSON = ()=>{
    return "pubKey output";
};


$a570fc1301f5ae9e$exports.output = $062e4dea667e945f$exports;


var $c192e5bc12ec5e98$exports = {};
"use strict";
Object.defineProperty($c192e5bc12ec5e98$exports, "__esModule", {
    value: true
});
var $ae3c87bd845a9ab1$exports = {};
"use strict";
// {signature} {pubKey}
Object.defineProperty($ae3c87bd845a9ab1$exports, "__esModule", {
    value: true
});

function $ae3c87bd845a9ab1$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]) && $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(chunks[1]);
}
$ae3c87bd845a9ab1$exports.check = $ae3c87bd845a9ab1$var$check;
$ae3c87bd845a9ab1$var$check.toJSON = ()=>{
    return "pubKeyHash input";
};


$c192e5bc12ec5e98$exports.input = $ae3c87bd845a9ab1$exports;
var $4a789aae5b7e419d$exports = {};
"use strict";
// OP_DUP OP_HASH160 {pubKeyHash} OP_EQUALVERIFY OP_CHECKSIG
Object.defineProperty($4a789aae5b7e419d$exports, "__esModule", {
    value: true
});


function $4a789aae5b7e419d$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 25 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_DUP && buffer[1] === $a6e22d0fc87b0ff4$exports.OPS.OP_HASH160 && buffer[2] === 0x14 && buffer[23] === $a6e22d0fc87b0ff4$exports.OPS.OP_EQUALVERIFY && buffer[24] === $a6e22d0fc87b0ff4$exports.OPS.OP_CHECKSIG;
}
$4a789aae5b7e419d$exports.check = $4a789aae5b7e419d$var$check;
$4a789aae5b7e419d$var$check.toJSON = ()=>{
    return "pubKeyHash output";
};


$c192e5bc12ec5e98$exports.output = $4a789aae5b7e419d$exports;


var $9097db3e4459603d$exports = {};
"use strict";
Object.defineProperty($9097db3e4459603d$exports, "__esModule", {
    value: true
});
var $a65e844a4e2fb569$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $a65e844a4e2fb569$require$Buffer = $6ZWSX.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($a65e844a4e2fb569$exports, "__esModule", {
    value: true
});




var $3e5ea6e5f16cc791$exports = {};
"use strict";
// OP_0 {pubKeyHash}
Object.defineProperty($3e5ea6e5f16cc791$exports, "__esModule", {
    value: true
});


function $3e5ea6e5f16cc791$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 22 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_0 && buffer[1] === 0x14;
}
$3e5ea6e5f16cc791$exports.check = $3e5ea6e5f16cc791$var$check;
$3e5ea6e5f16cc791$var$check.toJSON = ()=>{
    return "Witness pubKeyHash output";
};


var $98cbb92f9528d600$exports = {};
"use strict";
// OP_0 {scriptHash}
Object.defineProperty($98cbb92f9528d600$exports, "__esModule", {
    value: true
});


function $98cbb92f9528d600$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 34 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_0 && buffer[1] === 0x20;
}
$98cbb92f9528d600$exports.check = $98cbb92f9528d600$var$check;
$98cbb92f9528d600$var$check.toJSON = ()=>{
    return "Witness scriptHash output";
};


function $a65e844a4e2fb569$var$check(script, allowIncomplete) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (chunks.length < 1) return false;
    const lastChunk = chunks[chunks.length - 1];
    if (!$a65e844a4e2fb569$require$Buffer.isBuffer(lastChunk)) return false;
    const scriptSigChunks = $a6e22d0fc87b0ff4$exports.decompile($a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1)));
    const redeemScriptChunks = $a6e22d0fc87b0ff4$exports.decompile(lastChunk);
    // is redeemScript a valid script?
    if (!redeemScriptChunks) return false;
    // is redeemScriptSig push only?
    if (!$a6e22d0fc87b0ff4$exports.isPushOnly(scriptSigChunks)) return false;
    // is witness?
    if (chunks.length === 1) return $98cbb92f9528d600$exports.check(redeemScriptChunks) || $3e5ea6e5f16cc791$exports.check(redeemScriptChunks);
    // match types
    if ($c192e5bc12ec5e98$exports.input.check(scriptSigChunks) && $c192e5bc12ec5e98$exports.output.check(redeemScriptChunks)) return true;
    if ($ebabbd148d301963$exports.input.check(scriptSigChunks, allowIncomplete) && $ebabbd148d301963$exports.output.check(redeemScriptChunks)) return true;
    if ($a570fc1301f5ae9e$exports.input.check(scriptSigChunks) && $a570fc1301f5ae9e$exports.output.check(redeemScriptChunks)) return true;
    return false;
}
$a65e844a4e2fb569$exports.check = $a65e844a4e2fb569$var$check;
$a65e844a4e2fb569$var$check.toJSON = ()=>{
    return "scriptHash input";
};


$9097db3e4459603d$exports.input = $a65e844a4e2fb569$exports;
var $eda2fdbf168c359a$exports = {};
"use strict";
// OP_HASH160 {scriptHash} OP_EQUAL
Object.defineProperty($eda2fdbf168c359a$exports, "__esModule", {
    value: true
});


function $eda2fdbf168c359a$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length === 23 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_HASH160 && buffer[1] === 0x14 && buffer[22] === $a6e22d0fc87b0ff4$exports.OPS.OP_EQUAL;
}
$eda2fdbf168c359a$exports.check = $eda2fdbf168c359a$var$check;
$eda2fdbf168c359a$var$check.toJSON = ()=>{
    return "scriptHash output";
};


$9097db3e4459603d$exports.output = $eda2fdbf168c359a$exports;


var $779002cfa79af6a1$exports = {};
"use strict";
Object.defineProperty($779002cfa79af6a1$exports, "__esModule", {
    value: true
});
var $c4564f6a0592ee65$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $c4564f6a0592ee65$require$Buffer = $6ZWSX.Buffer;
"use strict";
// OP_RETURN {aa21a9ed} {commitment}
Object.defineProperty($c4564f6a0592ee65$exports, "__esModule", {
    value: true
});




var $lYlyf = parcelRequire("lYlyf");
const $c4564f6a0592ee65$var$HEADER = $c4564f6a0592ee65$require$Buffer.from("aa21a9ed", "hex");
function $c4564f6a0592ee65$var$check(script) {
    const buffer = $a6e22d0fc87b0ff4$exports.compile(script);
    return buffer.length > 37 && buffer[0] === $a6e22d0fc87b0ff4$exports.OPS.OP_RETURN && buffer[1] === 0x24 && buffer.slice(2, 6).equals($c4564f6a0592ee65$var$HEADER);
}
$c4564f6a0592ee65$exports.check = $c4564f6a0592ee65$var$check;
$c4564f6a0592ee65$var$check.toJSON = ()=>{
    return "Witness commitment output";
};
function $c4564f6a0592ee65$var$encode(commitment) {
    $lYlyf($e79ff6cff6024683$exports.Hash256bit, commitment);
    const buffer = $c4564f6a0592ee65$require$Buffer.allocUnsafe(36);
    $c4564f6a0592ee65$var$HEADER.copy(buffer, 0);
    commitment.copy(buffer, 4);
    return $a6e22d0fc87b0ff4$exports.compile([
        $a6e22d0fc87b0ff4$exports.OPS.OP_RETURN,
        buffer
    ]);
}
$c4564f6a0592ee65$exports.encode = $c4564f6a0592ee65$var$encode;
function $c4564f6a0592ee65$var$decode(buffer) {
    $lYlyf($c4564f6a0592ee65$var$check, buffer);
    return $a6e22d0fc87b0ff4$exports.decompile(buffer)[1].slice(4, 36);
}
$c4564f6a0592ee65$exports.decode = $c4564f6a0592ee65$var$decode;


$779002cfa79af6a1$exports.output = $c4564f6a0592ee65$exports;


var $959ee5238fe4dc72$exports = {};
"use strict";
Object.defineProperty($959ee5238fe4dc72$exports, "__esModule", {
    value: true
});
var $89c78ba228980643$exports = {};
"use strict";
// {signature} {pubKey}
Object.defineProperty($89c78ba228980643$exports, "__esModule", {
    value: true
});

function $89c78ba228980643$var$isCompressedCanonicalPubKey(pubKey) {
    return $a6e22d0fc87b0ff4$exports.isCanonicalPubKey(pubKey) && pubKey.length === 33;
}
function $89c78ba228980643$var$check(script) {
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    return chunks.length === 2 && $a6e22d0fc87b0ff4$exports.isCanonicalScriptSignature(chunks[0]) && $89c78ba228980643$var$isCompressedCanonicalPubKey(chunks[1]);
}
$89c78ba228980643$exports.check = $89c78ba228980643$var$check;
$89c78ba228980643$var$check.toJSON = ()=>{
    return "witnessPubKeyHash input";
};


$959ee5238fe4dc72$exports.input = $89c78ba228980643$exports;

$959ee5238fe4dc72$exports.output = $3e5ea6e5f16cc791$exports;


var $47d2e2cf7bd69d57$exports = {};
"use strict";
Object.defineProperty($47d2e2cf7bd69d57$exports, "__esModule", {
    value: true
});
var $e83f0d10cdeef2a8$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $e83f0d10cdeef2a8$require$Buffer = $6ZWSX.Buffer;
"use strict";
// <scriptSig> {serialized scriptPubKey script}
Object.defineProperty($e83f0d10cdeef2a8$exports, "__esModule", {
    value: true
});


var $lYlyf = parcelRequire("lYlyf");



function $e83f0d10cdeef2a8$var$check(chunks, allowIncomplete) {
    $lYlyf($lYlyf.Array, chunks);
    if (chunks.length < 1) return false;
    const witnessScript = chunks[chunks.length - 1];
    if (!$e83f0d10cdeef2a8$require$Buffer.isBuffer(witnessScript)) return false;
    const witnessScriptChunks = $a6e22d0fc87b0ff4$exports.decompile(witnessScript);
    // is witnessScript a valid script?
    if (!witnessScriptChunks || witnessScriptChunks.length === 0) return false;
    const witnessRawScriptSig = $a6e22d0fc87b0ff4$exports.compile(chunks.slice(0, -1));
    // match types
    if ($c192e5bc12ec5e98$exports.input.check(witnessRawScriptSig) && $c192e5bc12ec5e98$exports.output.check(witnessScriptChunks)) return true;
    if ($ebabbd148d301963$exports.input.check(witnessRawScriptSig, allowIncomplete) && $ebabbd148d301963$exports.output.check(witnessScriptChunks)) return true;
    if ($a570fc1301f5ae9e$exports.input.check(witnessRawScriptSig) && $a570fc1301f5ae9e$exports.output.check(witnessScriptChunks)) return true;
    return false;
}
$e83f0d10cdeef2a8$exports.check = $e83f0d10cdeef2a8$var$check;
$e83f0d10cdeef2a8$var$check.toJSON = ()=>{
    return "witnessScriptHash input";
};


$47d2e2cf7bd69d57$exports.input = $e83f0d10cdeef2a8$exports;

$47d2e2cf7bd69d57$exports.output = $98cbb92f9528d600$exports;


const $7ec8d6ec0e56f0c7$var$types = {
    P2MS: "multisig",
    NONSTANDARD: "nonstandard",
    NULLDATA: "nulldata",
    P2PK: "pubkey",
    P2PKH: "pubkeyhash",
    P2SH: "scripthash",
    P2WPKH: "witnesspubkeyhash",
    P2WSH: "witnessscripthash",
    WITNESS_COMMITMENT: "witnesscommitment"
};
$7ec8d6ec0e56f0c7$exports.types = $7ec8d6ec0e56f0c7$var$types;
function $7ec8d6ec0e56f0c7$var$classifyOutput(script) {
    if ($959ee5238fe4dc72$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2WPKH;
    if ($47d2e2cf7bd69d57$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2WSH;
    if ($c192e5bc12ec5e98$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2PKH;
    if ($9097db3e4459603d$exports.output.check(script)) return $7ec8d6ec0e56f0c7$var$types.P2SH;
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($ebabbd148d301963$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2MS;
    if ($a570fc1301f5ae9e$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PK;
    if ($779002cfa79af6a1$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.WITNESS_COMMITMENT;
    if ($4319358ebd9a1bba$exports.output.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.NULLDATA;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.output = $7ec8d6ec0e56f0c7$var$classifyOutput;
function $7ec8d6ec0e56f0c7$var$classifyInput(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($c192e5bc12ec5e98$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PKH;
    if ($9097db3e4459603d$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2SH;
    if ($ebabbd148d301963$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2MS;
    if ($a570fc1301f5ae9e$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2PK;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.input = $7ec8d6ec0e56f0c7$var$classifyInput;
function $7ec8d6ec0e56f0c7$var$classifyWitness(script, allowIncomplete) {
    // XXX: optimization, below functions .decompile before use
    const chunks = $a6e22d0fc87b0ff4$exports.decompile(script);
    if (!chunks) throw new TypeError("Invalid script");
    if ($959ee5238fe4dc72$exports.input.check(chunks)) return $7ec8d6ec0e56f0c7$var$types.P2WPKH;
    if ($47d2e2cf7bd69d57$exports.input.check(chunks, allowIncomplete)) return $7ec8d6ec0e56f0c7$var$types.P2WSH;
    return $7ec8d6ec0e56f0c7$var$types.NONSTANDARD;
}
$7ec8d6ec0e56f0c7$exports.witness = $7ec8d6ec0e56f0c7$var$classifyWitness;











var $lYlyf = parcelRequire("lYlyf");
const $9bb4ae5172bb4a73$var$SCRIPT_TYPES = $7ec8d6ec0e56f0c7$exports.types;
const $9bb4ae5172bb4a73$var$PREVOUT_TYPES = new Set([
    // Raw
    "p2pkh",
    "p2pk",
    "p2wpkh",
    "p2ms",
    // P2SH wrapped
    "p2sh-p2pkh",
    "p2sh-p2pk",
    "p2sh-p2wpkh",
    "p2sh-p2ms",
    // P2WSH wrapped
    "p2wsh-p2pkh",
    "p2wsh-p2pk",
    "p2wsh-p2ms",
    // P2SH-P2WSH wrapper
    "p2sh-p2wsh-p2pkh",
    "p2sh-p2wsh-p2pk",
    "p2sh-p2wsh-p2ms"
]);
function $9bb4ae5172bb4a73$var$tfMessage(type, value, message) {
    try {
        $lYlyf(type, value);
    } catch (err) {
        throw new Error(message);
    }
}
function $9bb4ae5172bb4a73$var$txIsString(tx) {
    return typeof tx === "string" || tx instanceof String;
}
function $9bb4ae5172bb4a73$var$txIsTransaction(tx) {
    return tx instanceof $fd7ffb7eadbf465f$exports.Transaction;
}
class $9bb4ae5172bb4a73$var$TransactionBuilder {
    // WARNING: maximumFeeRate is __NOT__ to be relied on,
    //          it's just another potential safety mechanism (safety in-depth)
    constructor(network = $a2ef7e6d3e9bbe84$exports.bitcoin, maximumFeeRate = 2500){
        this.network = network;
        this.maximumFeeRate = maximumFeeRate;
        this.__PREV_TX_SET = {};
        this.__INPUTS = [];
        this.__TX = new $fd7ffb7eadbf465f$exports.Transaction();
        this.__TX.version = 2;
        this.__USE_LOW_R = false;
        console.warn("Deprecation Warning: TransactionBuilder will be removed in the future. (v6.x.x or later) Please use the Psbt class instead. Examples of usage are available in the transactions-psbt.js integration test file on our Github. A high level explanation is available in the psbt.ts and psbt.js files as well.");
    }
    static fromTransaction(transaction, network) {
        const txb = new $9bb4ae5172bb4a73$var$TransactionBuilder(network);
        // Copy transaction fields
        txb.setVersion(transaction.version);
        txb.setLockTime(transaction.locktime);
        // Copy outputs (done first to avoid signature invalidation)
        transaction.outs.forEach((txOut)=>{
            txb.addOutput(txOut.script, txOut.value);
        });
        // Copy inputs
        transaction.ins.forEach((txIn)=>{
            txb.__addInputUnsafe(txIn.hash, txIn.index, {
                sequence: txIn.sequence,
                script: txIn.script,
                witness: txIn.witness
            });
        });
        // fix some things not possible through the public API
        txb.__INPUTS.forEach((input, i)=>{
            $9bb4ae5172bb4a73$var$fixMultisigOrder(input, transaction, i);
        });
        return txb;
    }
    setLowR(setting) {
        $lYlyf($lYlyf.maybe($lYlyf.Boolean), setting);
        if (setting === undefined) setting = true;
        this.__USE_LOW_R = setting;
        return setting;
    }
    setLockTime(locktime) {
        $lYlyf($e79ff6cff6024683$exports.UInt32, locktime);
        // if any signatures exist, throw
        if (this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((s)=>s !== undefined);
        })) throw new Error("No, this would invalidate signatures");
        this.__TX.locktime = locktime;
    }
    setVersion(version) {
        $lYlyf($e79ff6cff6024683$exports.UInt32, version);
        // XXX: this might eventually become more complex depending on what the versions represent
        this.__TX.version = version;
    }
    addInput(txHash, vout, sequence, prevOutScript) {
        if (!this.__canModifyInputs()) throw new Error("No, this would invalidate signatures");
        let value;
        // is it a hex string?
        if ($9bb4ae5172bb4a73$var$txIsString(txHash)) // transaction hashs's are displayed in reverse order, un-reverse it
        txHash = $9192ad2b59302b6c$exports.reverseBuffer($9bb4ae5172bb4a73$require$Buffer.from(txHash, "hex"));
        else if ($9bb4ae5172bb4a73$var$txIsTransaction(txHash)) {
            const txOut = txHash.outs[vout];
            prevOutScript = txOut.script;
            value = txOut.value;
            txHash = txHash.getHash(false);
        }
        return this.__addInputUnsafe(txHash, vout, {
            sequence: sequence,
            prevOutScript: prevOutScript,
            value: value
        });
    }
    addOutput(scriptPubKey, value) {
        if (!this.__canModifyOutputs()) throw new Error("No, this would invalidate signatures");
        // Attempt to get a script if it's a base58 or bech32 address string
        if (typeof scriptPubKey === "string") scriptPubKey = $d26ee8edcbfb8f9e$exports.toOutputScript(scriptPubKey, this.network);
        return this.__TX.addOutput(scriptPubKey, value);
    }
    build() {
        return this.__build(false);
    }
    buildIncomplete() {
        return this.__build(true);
    }
    sign(signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript) {
        $9bb4ae5172bb4a73$var$trySign($9bb4ae5172bb4a73$var$getSigningData(this.network, this.__INPUTS, this.__needsOutputs.bind(this), this.__TX, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, this.__USE_LOW_R));
    }
    __addInputUnsafe(txHash, vout, options) {
        if ($fd7ffb7eadbf465f$exports.Transaction.isCoinbaseHash(txHash)) throw new Error("coinbase inputs not supported");
        const prevTxOut = txHash.toString("hex") + ":" + vout;
        if (this.__PREV_TX_SET[prevTxOut] !== undefined) throw new Error("Duplicate TxOut: " + prevTxOut);
        let input = {};
        // derive what we can from the scriptSig
        if (options.script !== undefined) input = $9bb4ae5172bb4a73$var$expandInput(options.script, options.witness || []);
        // if an input value was given, retain it
        if (options.value !== undefined) input.value = options.value;
        // derive what we can from the previous transactions output script
        if (!input.prevOutScript && options.prevOutScript) {
            let prevOutType;
            if (!input.pubkeys && !input.signatures) {
                const expanded = $9bb4ae5172bb4a73$var$expandOutput(options.prevOutScript);
                if (expanded.pubkeys) {
                    input.pubkeys = expanded.pubkeys;
                    input.signatures = expanded.signatures;
                }
                prevOutType = expanded.type;
            }
            input.prevOutScript = options.prevOutScript;
            input.prevOutType = prevOutType || $7ec8d6ec0e56f0c7$exports.output(options.prevOutScript);
        }
        const vin = this.__TX.addInput(txHash, vout, options.sequence, options.scriptSig);
        this.__INPUTS[vin] = input;
        this.__PREV_TX_SET[prevTxOut] = true;
        return vin;
    }
    __build(allowIncomplete) {
        if (!allowIncomplete) {
            if (!this.__TX.ins.length) throw new Error("Transaction has no inputs");
            if (!this.__TX.outs.length) throw new Error("Transaction has no outputs");
        }
        const tx = this.__TX.clone();
        // create script signatures from inputs
        this.__INPUTS.forEach((input, i)=>{
            if (!input.prevOutType && !allowIncomplete) throw new Error("Transaction is not complete");
            const result = $9bb4ae5172bb4a73$var$build(input.prevOutType, input, allowIncomplete);
            if (!result) {
                if (!allowIncomplete && input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) throw new Error("Unknown input type");
                if (!allowIncomplete) throw new Error("Not enough information");
                return;
            }
            tx.setInputScript(i, result.input);
            tx.setWitness(i, result.witness);
        });
        if (!allowIncomplete) {
            // do not rely on this, its merely a last resort
            if (this.__overMaximumFees(tx.virtualSize())) throw new Error("Transaction has absurd fees");
        }
        return tx;
    }
    __canModifyInputs() {
        return this.__INPUTS.every((input)=>{
            if (!input.signatures) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                // if SIGHASH_ANYONECANPAY is set, signatures would not
                // be invalidated by more inputs
                return (hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ANYONECANPAY) !== 0;
            });
        });
    }
    __needsOutputs(signingHashType) {
        if (signingHashType === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL) return this.__TX.outs.length === 0;
        // if inputs are being signed with SIGHASH_NONE, we don't strictly need outputs
        // .build() will fail, but .buildIncomplete() is OK
        return this.__TX.outs.length === 0 && this.__INPUTS.some((input)=>{
            if (!input.signatures) return false;
            return input.signatures.some((signature)=>{
                if (!signature) return false; // no signature, no issue
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                if (hashType & $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE) return false; // SIGHASH_NONE doesn't care about outputs
                return true; // SIGHASH_* does care
            });
        });
    }
    __canModifyOutputs() {
        const nInputs = this.__TX.ins.length;
        const nOutputs = this.__TX.outs.length;
        return this.__INPUTS.every((input)=>{
            if (input.signatures === undefined) return true;
            return input.signatures.every((signature)=>{
                if (!signature) return true;
                const hashType = $9bb4ae5172bb4a73$var$signatureHashType(signature);
                const hashTypeMod = hashType & 0x1f;
                if (hashTypeMod === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_NONE) return true;
                if (hashTypeMod === $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_SINGLE) // if SIGHASH_SINGLE is set, and nInputs > nOutputs
                // some signatures would be invalidated by the addition
                // of more outputs
                return nInputs <= nOutputs;
                return false;
            });
        });
    }
    __overMaximumFees(bytes) {
        // not all inputs will have .value defined
        const incoming = this.__INPUTS.reduce((a, x)=>a + (x.value >>> 0), 0);
        // but all outputs do, and if we have any input value
        // we can immediately determine if the outputs are too small
        const outgoing = this.__TX.outs.reduce((a, x)=>a + x.value, 0);
        const fee = incoming - outgoing;
        const feeRate = fee / bytes;
        return feeRate > this.maximumFeeRate;
    }
}
$9bb4ae5172bb4a73$exports.TransactionBuilder = $9bb4ae5172bb4a73$var$TransactionBuilder;
function $9bb4ae5172bb4a73$var$expandInput(scriptSig, witnessStack, type, scriptPubKey) {
    if (scriptSig.length === 0 && witnessStack.length === 0) return {};
    if (!type) {
        let ssType = $7ec8d6ec0e56f0c7$exports.input(scriptSig, true);
        let wsType = $7ec8d6ec0e56f0c7$exports.witness(witnessStack, true);
        if (ssType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) ssType = undefined;
        if (wsType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD) wsType = undefined;
        type = ssType || wsType;
    }
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $bed04000b8455fa3$exports.p2wpkh({
                    witness: witnessStack
                });
                return {
                    prevOutScript: output,
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            {
                const { output: output, pubkey: pubkey, signature: signature } = $bed04000b8455fa3$exports.p2pkh({
                    input: scriptSig
                });
                return {
                    prevOutScript: output,
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
                    pubkeys: [
                        pubkey
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            {
                const { signature: signature } = $bed04000b8455fa3$exports.p2pk({
                    input: scriptSig
                });
                return {
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK,
                    pubkeys: [
                        undefined
                    ],
                    signatures: [
                        signature
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const { m: m, pubkeys: pubkeys, signatures: signatures } = $bed04000b8455fa3$exports.p2ms({
                    input: scriptSig,
                    output: scriptPubKey
                }, {
                    allowIncomplete: true
                });
                return {
                    prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS,
                    pubkeys: pubkeys,
                    signatures: signatures,
                    maxSignatures: m
                };
            }
    }
    if (type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH) {
        const { output: output, redeem: redeem } = $bed04000b8455fa3$exports.p2sh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $7ec8d6ec0e56f0c7$exports.output(redeem.output);
        const expanded = $9bb4ae5172bb4a73$var$expandInput(redeem.input, redeem.witness, outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            redeemScript: redeem.output,
            redeemScriptType: expanded.prevOutType,
            witnessScript: expanded.witnessScript,
            witnessScriptType: expanded.witnessScriptType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    if (type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH) {
        const { output: output, redeem: redeem } = $bed04000b8455fa3$exports.p2wsh({
            input: scriptSig,
            witness: witnessStack
        });
        const outputType = $7ec8d6ec0e56f0c7$exports.output(redeem.output);
        let expanded;
        if (outputType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) expanded = $9bb4ae5172bb4a73$var$expandInput(redeem.input, redeem.witness, outputType);
        else expanded = $9bb4ae5172bb4a73$var$expandInput($a6e22d0fc87b0ff4$exports.compile(redeem.witness), [], outputType, redeem.output);
        if (!expanded.prevOutType) return {};
        return {
            prevOutScript: output,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            witnessScript: redeem.output,
            witnessScriptType: expanded.prevOutType,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures
        };
    }
    return {
        prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.NONSTANDARD,
        prevOutScript: scriptSig
    };
}
// could be done in expandInput, but requires the original Transaction for hashForSignature
function $9bb4ae5172bb4a73$var$fixMultisigOrder(input, transaction, vin) {
    if (input.redeemScriptType !== $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS || !input.redeemScript) return;
    if (input.pubkeys.length === input.signatures.length) return;
    const unmatched = input.signatures.concat();
    input.signatures = input.pubkeys.map((pubKey)=>{
        const keyPair = $c32869daae2b1652$exports.fromPublicKey(pubKey);
        let match;
        // check for a signature
        unmatched.some((signature, i)=>{
            // skip if undefined || OP_0
            if (!signature) return false;
            // TODO: avoid O(n) hashForSignature
            const parsed = $a6e22d0fc87b0ff4$exports.signature.decode(signature);
            const hash = transaction.hashForSignature(vin, input.redeemScript, parsed.hashType);
            // skip if signature does not match pubKey
            if (!keyPair.verify(hash, parsed.signature)) return false;
            // remove matched signature from unmatched
            unmatched[i] = undefined;
            match = signature;
            return true;
        });
        return match;
    });
}
function $9bb4ae5172bb4a73$var$expandOutput(script, ourPubKey) {
    $lYlyf($e79ff6cff6024683$exports.Buffer, script);
    const type = $7ec8d6ec0e56f0c7$exports.output(script);
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const pkh1 = $bed04000b8455fa3$exports.p2pkh({
                    output: script
                }).hash;
                const pkh2 = $1c834b456d93f732$exports.hash160(ourPubKey);
                if (!pkh1.equals(pkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            {
                if (!ourPubKey) return {
                    type: type
                };
                // does our hash160(pubKey) match the output scripts?
                const wpkh1 = $bed04000b8455fa3$exports.p2wpkh({
                    output: script
                }).hash;
                const wpkh2 = $1c834b456d93f732$exports.hash160(ourPubKey);
                if (!wpkh1.equals(wpkh2)) return {
                    type: type
                };
                return {
                    type: type,
                    pubkeys: [
                        ourPubKey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            {
                const p2pk = $bed04000b8455fa3$exports.p2pk({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: [
                        p2pk.pubkey
                    ],
                    signatures: [
                        undefined
                    ]
                };
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const p2ms = $bed04000b8455fa3$exports.p2ms({
                    output: script
                });
                return {
                    type: type,
                    pubkeys: p2ms.pubkeys,
                    signatures: p2ms.pubkeys.map(()=>undefined),
                    maxSignatures: p2ms.m
                };
            }
    }
    return {
        type: type
    };
}
function $9bb4ae5172bb4a73$var$prepareInput(input, ourPubKey, redeemScript, witnessScript) {
    if (redeemScript && witnessScript) {
        const p2wsh = $bed04000b8455fa3$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        const p2wshAlt = $bed04000b8455fa3$exports.p2wsh({
            output: redeemScript
        });
        const p2sh = $bed04000b8455fa3$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        const p2shAlt = $bed04000b8455fa3$exports.p2sh({
            redeem: p2wsh
        });
        // enforces P2SH(P2WSH(...))
        if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as witnessScript (" + $a6e22d0fc87b0ff4$exports.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2SH(P2WSH(P2WPKH)) is a consensus failure");
        return {
            redeemScript: redeemScript,
            redeemScriptType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (redeemScript) {
        const p2sh = $bed04000b8455fa3$exports.p2sh({
            redeem: {
                output: redeemScript
            }
        });
        if (input.prevOutScript) {
            let p2shAlt;
            try {
                p2shAlt = $bed04000b8455fa3$exports.p2sh({
                    output: input.prevOutScript
                });
            } catch (e) {
                throw new Error("PrevOutScript must be P2SH");
            }
            if (!p2sh.hash.equals(p2shAlt.hash)) throw new Error("Redeem script inconsistent with prevOutScript");
        }
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2sh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as redeemScript (" + $a6e22d0fc87b0ff4$exports.toASM(redeemScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = redeemScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) signScript = $bed04000b8455fa3$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            redeemScript: redeemScript,
            redeemScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH,
            prevOutScript: p2sh.output,
            hasWitness: expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (witnessScript) {
        const p2wsh = $bed04000b8455fa3$exports.p2wsh({
            redeem: {
                output: witnessScript
            }
        });
        if (input.prevOutScript) {
            const p2wshAlt = $bed04000b8455fa3$exports.p2wsh({
                output: input.prevOutScript
            });
            if (!p2wsh.hash.equals(p2wshAlt.hash)) throw new Error("Witness script inconsistent with prevOutScript");
        }
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(p2wsh.redeem.output, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported as witnessScript (" + $a6e22d0fc87b0ff4$exports.toASM(witnessScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        const signScript = witnessScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) throw new Error("P2WSH(P2WPKH) is a consensus failure");
        return {
            witnessScript: witnessScript,
            witnessScriptType: expanded.type,
            prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH,
            prevOutScript: p2wsh.output,
            hasWitness: true,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    if (input.prevOutType && input.prevOutScript) {
        // embedded scripts are not possible without extra information
        if (input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires redeemScript");
        if (input.prevOutType === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH) throw new Error("PrevOutScript is " + input.prevOutType + ", requires witnessScript");
        if (!input.prevOutScript) throw new Error("PrevOutScript is missing");
        const expanded = $9bb4ae5172bb4a73$var$expandOutput(input.prevOutScript, ourPubKey);
        if (!expanded.pubkeys) throw new Error(expanded.type + " not supported (" + $a6e22d0fc87b0ff4$exports.toASM(input.prevOutScript) + ")");
        if (input.signatures && input.signatures.some((x)=>x !== undefined)) expanded.signatures = input.signatures;
        let signScript = input.prevOutScript;
        if (expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH) signScript = $bed04000b8455fa3$exports.p2pkh({
            pubkey: expanded.pubkeys[0]
        }).output;
        return {
            prevOutType: expanded.type,
            prevOutScript: input.prevOutScript,
            hasWitness: expanded.type === $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH,
            signScript: signScript,
            signType: expanded.type,
            pubkeys: expanded.pubkeys,
            signatures: expanded.signatures,
            maxSignatures: expanded.maxSignatures
        };
    }
    const prevOutScript = $bed04000b8455fa3$exports.p2pkh({
        pubkey: ourPubKey
    }).output;
    return {
        prevOutType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
        prevOutScript: prevOutScript,
        hasWitness: false,
        signScript: prevOutScript,
        signType: $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH,
        pubkeys: [
            ourPubKey
        ],
        signatures: [
            undefined
        ]
    };
}
function $9bb4ae5172bb4a73$var$build(type, input, allowIncomplete) {
    const pubkeys = input.pubkeys || [];
    let signatures = input.signatures || [];
    switch(type){
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2pkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WPKH:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2wpkh({
                pubkey: pubkeys[0],
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2PK:
            if (pubkeys.length === 0) break;
            if (signatures.length === 0) break;
            return $bed04000b8455fa3$exports.p2pk({
                signature: signatures[0]
            });
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2MS:
            {
                const m = input.maxSignatures;
                if (allowIncomplete) signatures = signatures.map((x)=>x || $a6e22d0fc87b0ff4$exports.OPS.OP_0);
                else signatures = signatures.filter((x)=>x);
                // if the transaction is not not complete (complete), or if signatures.length === m, validate
                // otherwise, the number of OP_0's may be >= m, so don't validate (boo)
                const validate = !allowIncomplete || m === signatures.length;
                return $bed04000b8455fa3$exports.p2ms({
                    m: m,
                    pubkeys: pubkeys,
                    signatures: signatures
                }, {
                    allowIncomplete: allowIncomplete,
                    validate: validate
                });
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2SH:
            {
                const redeem = $9bb4ae5172bb4a73$var$build(input.redeemScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $bed04000b8455fa3$exports.p2sh({
                    redeem: {
                        output: redeem.output || input.redeemScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
        case $9bb4ae5172bb4a73$var$SCRIPT_TYPES.P2WSH:
            {
                const redeem = $9bb4ae5172bb4a73$var$build(input.witnessScriptType, input, allowIncomplete);
                if (!redeem) return;
                return $bed04000b8455fa3$exports.p2wsh({
                    redeem: {
                        output: input.witnessScript,
                        input: redeem.input,
                        witness: redeem.witness
                    }
                });
            }
    }
}
function $9bb4ae5172bb4a73$var$canSign(input) {
    return input.signScript !== undefined && input.signType !== undefined && input.pubkeys !== undefined && input.signatures !== undefined && input.signatures.length === input.pubkeys.length && input.pubkeys.length > 0 && (input.hasWitness === false || input.value !== undefined);
}
function $9bb4ae5172bb4a73$var$signatureHashType(buffer) {
    return buffer.readUInt8(buffer.length - 1);
}
function $9bb4ae5172bb4a73$var$checkSignArgs(inputs, signParams) {
    if (!$9bb4ae5172bb4a73$var$PREVOUT_TYPES.has(signParams.prevOutScriptType)) throw new TypeError(`Unknown prevOutScriptType "${signParams.prevOutScriptType}"`);
    $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Number, signParams.vin, `sign must include vin parameter as Number (input index)`);
    $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Signer, signParams.keyPair, `sign must include keyPair parameter as Signer interface`);
    $9bb4ae5172bb4a73$var$tfMessage($lYlyf.maybe($lYlyf.Number), signParams.hashType, `sign hashType parameter must be a number`);
    const prevOutType = (inputs[signParams.vin] || []).prevOutType;
    const posType = signParams.prevOutScriptType;
    switch(posType){
        case "p2pkh":
            if (prevOutType && prevOutType !== "pubkeyhash") throw new TypeError(`input #${signParams.vin} is not of type p2pkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2pk":
            if (prevOutType && prevOutType !== "pubkey") throw new TypeError(`input #${signParams.vin} is not of type p2pk: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2wpkh":
            if (prevOutType && prevOutType !== "witnesspubkeyhash") throw new TypeError(`input #${signParams.vin} is not of type p2wpkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2ms":
            if (prevOutType && prevOutType !== "multisig") throw new TypeError(`input #${signParams.vin} is not of type p2ms: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2sh-p2wpkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type p2sh-p2wpkh: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2sh-p2ms":
        case "p2sh-p2pk":
        case "p2sh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessScript, `${posType} requires NO witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.witnessValue, `${posType} requires NO witnessValue`);
            break;
        case "p2wsh-p2ms":
        case "p2wsh-p2pk":
        case "p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "witnessscripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.value(undefined), signParams.redeemScript, `${posType} requires NO redeemScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessValue`);
            break;
        case "p2sh-p2wsh-p2ms":
        case "p2sh-p2wsh-p2pk":
        case "p2sh-p2wsh-p2pkh":
            if (prevOutType && prevOutType !== "scripthash") throw new TypeError(`input #${signParams.vin} is not of type ${posType}: ${prevOutType}`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.witnessScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($lYlyf.Buffer, signParams.redeemScript, `${posType} requires witnessScript`);
            $9bb4ae5172bb4a73$var$tfMessage($e79ff6cff6024683$exports.Satoshi, signParams.witnessValue, `${posType} requires witnessScript`);
            break;
    }
}
function $9bb4ae5172bb4a73$var$trySign({ input: input, ourPubKey: ourPubKey, keyPair: keyPair, signatureHash: signatureHash, hashType: hashType, useLowR: useLowR }) {
    // enforce in order signing of public keys
    let signed = false;
    for (const [i, pubKey] of input.pubkeys.entries()){
        if (!ourPubKey.equals(pubKey)) continue;
        if (input.signatures[i]) throw new Error("Signature already exists");
        // TODO: add tests
        if (ourPubKey.length !== 33 && input.hasWitness) throw new Error("BIP143 rejects uncompressed public keys in P2WPKH or P2WSH");
        const signature = keyPair.sign(signatureHash, useLowR);
        input.signatures[i] = $a6e22d0fc87b0ff4$exports.signature.encode(signature, hashType);
        signed = true;
    }
    if (!signed) throw new Error("Key pair cannot sign for this input");
}
function $9bb4ae5172bb4a73$var$getSigningData(network, inputs, needsOutputs, tx, signParams, keyPair, redeemScript, hashType, witnessValue, witnessScript, useLowR) {
    let vin;
    if (typeof signParams === "number") {
        console.warn("DEPRECATED: TransactionBuilder sign method arguments will change in v6, please use the TxbSignArg interface");
        vin = signParams;
    } else if (typeof signParams === "object") {
        $9bb4ae5172bb4a73$var$checkSignArgs(inputs, signParams);
        ({ vin: vin, keyPair: keyPair, redeemScript: redeemScript, hashType: hashType, witnessValue: witnessValue, witnessScript: witnessScript } = signParams);
    } else throw new TypeError("TransactionBuilder sign first arg must be TxbSignArg or number");
    if (keyPair === undefined) throw new Error("sign requires keypair");
    // TODO: remove keyPair.network matching in 4.0.0
    if (keyPair.network && keyPair.network !== network) throw new TypeError("Inconsistent network");
    if (!inputs[vin]) throw new Error("No input at index: " + vin);
    hashType = hashType || $fd7ffb7eadbf465f$exports.Transaction.SIGHASH_ALL;
    if (needsOutputs(hashType)) throw new Error("Transaction needs outputs");
    const input = inputs[vin];
    // if redeemScript was previously provided, enforce consistency
    if (input.redeemScript !== undefined && redeemScript && !input.redeemScript.equals(redeemScript)) throw new Error("Inconsistent redeemScript");
    const ourPubKey = keyPair.publicKey || keyPair.getPublicKey && keyPair.getPublicKey();
    if (!$9bb4ae5172bb4a73$var$canSign(input)) {
        if (witnessValue !== undefined) {
            if (input.value !== undefined && input.value !== witnessValue) throw new Error("Input did not match witnessValue");
            $lYlyf($e79ff6cff6024683$exports.Satoshi, witnessValue);
            input.value = witnessValue;
        }
        if (!$9bb4ae5172bb4a73$var$canSign(input)) {
            const prepared = $9bb4ae5172bb4a73$var$prepareInput(input, ourPubKey, redeemScript, witnessScript);
            // updates inline
            Object.assign(input, prepared);
        }
        if (!$9bb4ae5172bb4a73$var$canSign(input)) throw Error(input.prevOutType + " not supported");
    }
    // ready to sign
    let signatureHash;
    if (input.hasWitness) signatureHash = tx.hashForWitnessV0(vin, input.signScript, input.value, hashType);
    else signatureHash = tx.hashForSignature(vin, input.signScript, hashType);
    return {
        input: input,
        ourPubKey: ourPubKey,
        keyPair: keyPair,
        signatureHash: signatureHash,
        hashType: hashType,
        useLowR: !!useLowR
    };
}


$58cf3bc07eb2f0ea$exports.TransactionBuilder = $9bb4ae5172bb4a73$exports.TransactionBuilder;



/**
 * @file bip32.ts
 * @description BIP32 Path Handling for Bitcoin Wallets
 *
 * This file provides utility functions to handle BIP32 paths,
 * which are commonly used in hierarchical deterministic (HD) wallets.
 * It includes functions to convert BIP32 paths to and from different formats,
 * extract components from extended public keys (xpubs), and manipulate path elements.
 */ 
var $4c5Uh = parcelRequire("4c5Uh");

var $lpa1P = parcelRequire("lpa1P");

var $6ZWSX = parcelRequire("6ZWSX");
var $76d975e72423660e$require$Buffer = $6ZWSX.Buffer;
function $76d975e72423660e$export$91b509509e9f8b52(paths) {
    const buffer = $76d975e72423660e$require$Buffer.alloc(1 + paths.length * 4);
    buffer[0] = paths.length;
    paths.forEach((element, index)=>{
        buffer.writeUInt32BE(element, 1 + 4 * index);
    });
    return buffer;
}
function $76d975e72423660e$export$dae4da1c913eeebb(path) {
    const pathElements = !path ? [] : $76d975e72423660e$export$35caeff6b64c2b35(path);
    return $76d975e72423660e$export$91b509509e9f8b52(pathElements);
}
function $76d975e72423660e$export$6e27cd76987a4ce2(pathElements) {
    // Limitation: bippath can't handle and empty path. It shouldn't affect us
    // right now, but might in the future.
    // TODO: Fix support for empty path.
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromPathArray(pathElements).toString();
}
function $76d975e72423660e$export$35caeff6b64c2b35(path) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromString(path).toPathArray();
}
function $76d975e72423660e$export$133bb17506582e39(xpub) {
    const xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($lpa1P))).decode(xpub);
    return xpubBuf.slice(xpubBuf.length - 33);
}
function $76d975e72423660e$export$8bb2dc8ba35445c6(xpub) {
    const xpubBuf = (0, (/*@__PURE__*/$parcel$interopDefault($lpa1P))).decode(xpub);
    return {
        chaincode: xpubBuf.slice(13, 45),
        pubkey: xpubBuf.slice(xpubBuf.length - 33),
        version: xpubBuf.readUInt32BE(0)
    };
}
function $76d975e72423660e$export$cc16963b25268381(pathElements) {
    for(let i = pathElements.length - 1; i >= 0; i--){
        if (pathElements[i] >= 0x80000000) return pathElements.slice(0, i + 1);
    }
    return [];
}



var $JAEWR = parcelRequire("JAEWR");

var $6ZWSX = parcelRequire("6ZWSX");
var $036f9e277d3889a8$require$Buffer = $6ZWSX.Buffer;
function $036f9e277d3889a8$export$8ccb8fa75d191fb7(n) {
    // we want to represent the input as a 8-bytes array
    if (n > Number.MAX_SAFE_INTEGER) throw new Error("Can't convert numbers > MAX_SAFE_INT");
    const byteArray = $036f9e277d3889a8$require$Buffer.alloc(8, 0);
    for(let index = 0; index < byteArray.length; index++){
        const byte = n & 0xff;
        byteArray[index] = byte;
        n = (n - byte) / 256;
    }
    return byteArray;
}
function $036f9e277d3889a8$export$cbe6b25937ae0aed(byteArray) {
    let value = 0;
    if (byteArray.length != 8) throw new Error("Expected Bufffer of lenght 8");
    if (byteArray[7] != 0) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    if (byteArray[6] > 0x1f) throw new Error("Can't encode numbers > MAX_SAFE_INT");
    for(let i = byteArray.length - 1; i >= 0; i--)value = value * 256 + byteArray[i];
    return value;
}
class $036f9e277d3889a8$export$67649df22d9ca0ab {
    constructor(){
        this.bufs = [];
    }
    write(alloc, fn) {
        const b = $036f9e277d3889a8$require$Buffer.alloc(alloc);
        fn(b);
        this.bufs.push(b);
    }
    writeUInt8(i) {
        this.write(1, (b)=>b.writeUInt8(i, 0));
    }
    writeInt32(i) {
        this.write(4, (b)=>b.writeInt32LE(i, 0));
    }
    writeUInt32(i) {
        this.write(4, (b)=>b.writeUInt32LE(i, 0));
    }
    writeUInt64(i) {
        const bytes = $036f9e277d3889a8$export$8ccb8fa75d191fb7(i);
        this.writeSlice(bytes);
    }
    writeVarInt(i) {
        this.bufs.push((0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).encode(i));
    }
    writeSlice(slice) {
        this.bufs.push($036f9e277d3889a8$require$Buffer.from(slice));
    }
    writeVarSlice(slice) {
        this.writeVarInt(slice.length);
        this.writeSlice(slice);
    }
    buffer() {
        return $036f9e277d3889a8$require$Buffer.concat(this.bufs);
    }
}
class $036f9e277d3889a8$export$bd4917b7431e3e00 {
    constructor(buffer, offset = 0){
        this.buffer = buffer;
        this.offset = offset;
    }
    available() {
        return this.buffer.length - this.offset;
    }
    readUInt8() {
        const result = this.buffer.readUInt8(this.offset);
        this.offset++;
        return result;
    }
    readInt32() {
        const result = this.buffer.readInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt32() {
        const result = this.buffer.readUInt32LE(this.offset);
        this.offset += 4;
        return result;
    }
    readUInt64() {
        const buf = this.readSlice(8);
        const n = $036f9e277d3889a8$export$cbe6b25937ae0aed(buf);
        return n;
    }
    readVarInt() {
        const vi = (0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).decode(this.buffer, this.offset);
        this.offset += (0, (/*@__PURE__*/$parcel$interopDefault($JAEWR))).decode.bytes;
        return vi;
    }
    readSlice(n) {
        if (this.buffer.length < this.offset + n) throw new Error("Cannot read slice out of bounds");
        const result = this.buffer.slice(this.offset, this.offset + n);
        this.offset += n;
        return result;
    }
    readVarSlice() {
        return this.readSlice(this.readVarInt());
    }
    readVector() {
        const count = this.readVarInt();
        const vector = [];
        for(let i = 0; i < count; i++)vector.push(this.readVarSlice());
        return vector;
    }
}





// the maximum number of bytes allowed in a single chunk when processing bitcoin script data.
// if the Bitcoin script is too large, we will process it in several chunks.
const $543bb618117c682e$export$53184d0ac57d9130 = 50;
const $543bb618117c682e$export$363ebe89e6e7aeef = 1;
const $543bb618117c682e$export$7e0b52e7059ffec7 = 0;
const $543bb618117c682e$export$57fe8370989728bf = 0xffffffff;
const $543bb618117c682e$export$f53d15270899011f = 1;
const $543bb618117c682e$export$df6efc3aa949001c = 0x76;
const $543bb618117c682e$export$25244e17dfd6169b = 0xa9;
const $543bb618117c682e$export$259fba643ee77695 = 0x14;
const $543bb618117c682e$export$5459033a849d318 = 0x87;
const $543bb618117c682e$export$f8b5c605020bd49c = 0x88;
const $543bb618117c682e$export$dc70dbf3545af7b7 = 0xac;
const $543bb618117c682e$export$713f182313880dec = 0x6a;



var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");
function $ed0dd9fccba6448b$export$4f1687fa25e5df17(buffer) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($a8qBR)))().update((0, (/*@__PURE__*/$parcel$interopDefault($5Z1sR)))("sha256").update(buffer).digest()).digest();
}



var $6ZWSX = parcelRequire("6ZWSX");
var $2c7898c006d96858$require$Buffer = $6ZWSX.Buffer;
class $2c7898c006d96858$var$BaseAccount {
    constructor(psbt, masterFp){
        this.psbt = psbt;
        this.masterFp = masterFp;
    }
}
/**
 * Superclass for single signature accounts. This will make sure that the pubkey
 * arrays and path arrays in the method arguments contains exactly one element
 * and calls an abstract method to do the actual work.
 */ class $2c7898c006d96858$var$SingleKeyAccount extends $2c7898c006d96858$var$BaseAccount {
    spendingCondition(pubkeys) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        return this.singleKeyCondition(pubkeys[0]);
    }
    setInput(i, inputTx, spentOutput, pubkeys, pathElems) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        if (pathElems.length != 1) throw new Error("Expected single path, got " + pathElems.length);
        this.setSingleKeyInput(i, inputTx, spentOutput, pubkeys[0], pathElems[0]);
    }
    setOwnOutput(i, cond, pubkeys, paths) {
        if (pubkeys.length != 1) throw new Error("Expected single key, got " + pubkeys.length);
        if (paths.length != 1) throw new Error("Expected single path, got " + paths.length);
        this.setSingleKeyOutput(i, cond, pubkeys[0], paths[0]);
    }
}
class $2c7898c006d96858$export$864e513602cf2381 extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$df6efc3aa949001c),
            (0, $543bb618117c682e$export$25244e17dfd6169b),
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(pubkeyHash);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$f8b5c605020bd49c),
            (0, $543bb618117c682e$export$dc70dbf3545af7b7)
        ]));
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, inputTx, _spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "pkh(@0)";
    }
}
class $2c7898c006d96858$export$12d04d0fe56ae53 extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const xonlyPubkey = pubkey.slice(1); // x-only pubkey
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        const outputKey = this.getTaprootOutputKey(xonlyPubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            0x51,
            32
        ])); // push1, pubkeylen
        buf.writeSlice(outputKey);
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, _inputTx, spentOutput, pubkey, path) {
        const xonly = pubkey.slice(1);
        this.psbt.setInputTapBip32Derivation(i, xonly, [], this.masterFp, path);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        const xonly = pubkey.slice(1);
        this.psbt.setOutputTapBip32Derivation(i, xonly, [], this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "tr(@0)";
    }
    /*
    The following two functions are copied from wallet-btc and adapted.
    They should be moved to a library to avoid code reuse.
    */ hashTapTweak(x) {
        // hash_tag(x) = SHA256(SHA256(tag) || SHA256(tag) || x), see BIP340
        // See https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki#specification
        const h = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256($2c7898c006d96858$require$Buffer.from("TapTweak", "utf-8"));
        return (0, $58cf3bc07eb2f0ea$exports.crypto).sha256($2c7898c006d96858$require$Buffer.concat([
            h,
            h,
            x
        ]));
    }
    /**
     * Calculates a taproot output key from an internal key. This output key will be
     * used as witness program in a taproot output. The internal key is tweaked
     * according to recommendation in BIP341:
     * https://github.com/bitcoin/bips/blob/master/bip-0341.mediawiki#cite_ref-22-0
     *
     * @param internalPubkey A 32 byte x-only taproot internal key
     * @returns The output key
     */ getTaprootOutputKey(internalPubkey) {
        if (internalPubkey.length != 32) throw new Error("Expected 32 byte pubkey. Got " + internalPubkey.length);
        // A BIP32 derived key can be converted to a schnorr pubkey by dropping
        // the first byte, which represent the oddness/evenness. In schnorr all
        // pubkeys are even.
        // https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki#public-key-conversion
        const evenEcdsaPubkey = $2c7898c006d96858$require$Buffer.concat([
            $2c7898c006d96858$require$Buffer.from([
                0x02
            ]),
            internalPubkey
        ]);
        const tweak = this.hashTapTweak(internalPubkey);
        // Q = P + int(hash_TapTweak(bytes(P)))G
        const outputEcdsaKey = $2c7898c006d96858$require$Buffer.from((0, $a810f27cf38f4a3f$exports.pointAddScalar)(evenEcdsaPubkey, tweak));
        // Convert to schnorr.
        const outputSchnorrKey = outputEcdsaKey.slice(1);
        // Create address
        return outputSchnorrKey;
    }
}
class $2c7898c006d96858$export$efcc171358cfcc7d extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        const redeemScript = this.createRedeemScript(pubkey);
        const scriptHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(redeemScript);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            (0, $543bb618117c682e$export$25244e17dfd6169b),
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(scriptHash);
        buf.writeUInt8((0, $543bb618117c682e$export$5459033a849d318));
        return {
            scriptPubKey: buf.buffer(),
            redeemScript: redeemScript
        };
    }
    setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
        const userSuppliedRedeemScript = spentOutput.cond.redeemScript;
        const expectedRedeemScript = this.createRedeemScript(pubkey);
        if (userSuppliedRedeemScript && !expectedRedeemScript.equals(userSuppliedRedeemScript)) // At what point might a user set the redeemScript on its own?
        throw new Error(`User-supplied redeemScript ${userSuppliedRedeemScript.toString("hex")} doesn't
       match expected ${expectedRedeemScript.toString("hex")} for input ${i}`);
        this.psbt.setInputRedeemScript(i, expectedRedeemScript);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        this.psbt.setOutputRedeemScript(i, cond.redeemScript);
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "sh(wpkh(@0))";
    }
    createRedeemScript(pubkey) {
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        return $2c7898c006d96858$require$Buffer.concat([
            $2c7898c006d96858$require$Buffer.from("0014", "hex"),
            pubkeyHash
        ]);
    }
}
class $2c7898c006d96858$export$5126746498e32b4b extends $2c7898c006d96858$var$SingleKeyAccount {
    singleKeyCondition(pubkey) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        const pubkeyHash = (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(pubkey);
        buf.writeSlice($2c7898c006d96858$require$Buffer.from([
            0,
            (0, $543bb618117c682e$export$259fba643ee77695)
        ]));
        buf.writeSlice(pubkeyHash);
        return {
            scriptPubKey: buf.buffer()
        };
    }
    setSingleKeyInput(i, inputTx, spentOutput, pubkey, path) {
        if (!inputTx) throw new Error("Full input base transaction required");
        this.psbt.setInputNonWitnessUtxo(i, inputTx);
        this.psbt.setInputBip32Derivation(i, pubkey, this.masterFp, path);
        this.psbt.setInputWitnessUtxo(i, spentOutput.amount, spentOutput.cond.scriptPubKey);
    }
    setSingleKeyOutput(i, cond, pubkey, path) {
        this.psbt.setOutputBip32Derivation(i, pubkey, this.masterFp, path);
    }
    getDescriptorTemplate() {
        return "wpkh(@0)";
    }
}







var $6ZWSX = parcelRequire("6ZWSX");
var $2e3df0c7f02d7cff$require$Buffer = $6ZWSX.Buffer;
class $2e3df0c7f02d7cff$export$987d21b768c89d26 {
    constructor(leaves, hasher = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256){
        this.leaves = leaves;
        this.h = hasher;
        const nodes = this.calculateRoot(leaves);
        this.rootNode = nodes.root;
        this.leafNodes = nodes.leaves;
    }
    getRoot() {
        return this.rootNode.hash;
    }
    size() {
        return this.leaves.length;
    }
    getLeaves() {
        return this.leaves;
    }
    getLeafHash(index) {
        return this.leafNodes[index].hash;
    }
    getProof(index) {
        if (index >= this.leaves.length) throw Error("Index out of bounds");
        return $2e3df0c7f02d7cff$var$proveNode(this.leafNodes[index]);
    }
    calculateRoot(leaves) {
        const n = leaves.length;
        if (n == 0) return {
            root: new $2e3df0c7f02d7cff$var$Node(undefined, undefined, $2e3df0c7f02d7cff$require$Buffer.alloc(32, 0)),
            leaves: []
        };
        if (n == 1) {
            const newNode = new $2e3df0c7f02d7cff$var$Node(undefined, undefined, leaves[0]);
            return {
                root: newNode,
                leaves: [
                    newNode
                ]
            };
        }
        const leftCount = $2e3df0c7f02d7cff$var$highestPowerOf2LessThan(n);
        const leftBranch = this.calculateRoot(leaves.slice(0, leftCount));
        const rightBranch = this.calculateRoot(leaves.slice(leftCount));
        const leftChild = leftBranch.root;
        const rightChild = rightBranch.root;
        const hash = this.hashNode(leftChild.hash, rightChild.hash);
        const node = new $2e3df0c7f02d7cff$var$Node(leftChild, rightChild, hash);
        leftChild.parent = node;
        rightChild.parent = node;
        return {
            root: node,
            leaves: leftBranch.leaves.concat(rightBranch.leaves)
        };
    }
    hashNode(left, right) {
        return this.h($2e3df0c7f02d7cff$require$Buffer.concat([
            $2e3df0c7f02d7cff$require$Buffer.from([
                1
            ]),
            left,
            right
        ]));
    }
}
function $2e3df0c7f02d7cff$export$bc68c1df7778232a(buf, hashFunction = (0, $58cf3bc07eb2f0ea$exports.crypto).sha256) {
    return $2e3df0c7f02d7cff$var$hashConcat($2e3df0c7f02d7cff$require$Buffer.from([
        0
    ]), buf, hashFunction);
}
function $2e3df0c7f02d7cff$var$hashConcat(bufA, bufB, hashFunction) {
    return hashFunction($2e3df0c7f02d7cff$require$Buffer.concat([
        bufA,
        bufB
    ]));
}
class $2e3df0c7f02d7cff$var$Node {
    constructor(left, right, hash){
        this.leftChild = left;
        this.rightChild = right;
        this.hash = hash;
    }
    isLeaf() {
        return this.leftChild == undefined;
    }
}
function $2e3df0c7f02d7cff$var$proveNode(node) {
    if (!node.parent) return [];
    if (node.parent.leftChild == node) {
        if (!node.parent.rightChild) throw new Error("Expected right child to exist");
        return [
            node.parent.rightChild.hash,
            ...$2e3df0c7f02d7cff$var$proveNode(node.parent)
        ];
    } else {
        if (!node.parent.leftChild) throw new Error("Expected left child to exist");
        return [
            node.parent.leftChild.hash,
            ...$2e3df0c7f02d7cff$var$proveNode(node.parent)
        ];
    }
}
function $2e3df0c7f02d7cff$var$highestPowerOf2LessThan(n) {
    if (n < 2) throw Error("Expected n >= 2");
    if ($2e3df0c7f02d7cff$var$isPowerOf2(n)) return n / 2;
    return 1 << Math.floor(Math.log2(n));
}
function $2e3df0c7f02d7cff$var$isPowerOf2(n) {
    return (n & n - 1) == 0;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $e7bbfff3d6175ca3$require$Buffer = $6ZWSX.Buffer;
class $e7bbfff3d6175ca3$export$7dabddf99c50dec7 {
    /**
     * For now, we only support default descriptor templates.
     */ constructor(descriptorTemplate, key){
        this.descriptorTemplate = descriptorTemplate;
        this.keys = [
            key
        ];
    }
    getWalletId() {
        // wallet_id (sha256 of the wallet serialization),
        return (0, $58cf3bc07eb2f0ea$exports.crypto).sha256(this.serialize());
    }
    serialize() {
        const keyBuffers = this.keys.map((k)=>{
            return $e7bbfff3d6175ca3$require$Buffer.from(k, "ascii");
        });
        const m = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(keyBuffers.map((k)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(k)));
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        buf.writeUInt8(0x01); // wallet type (policy map)
        buf.writeUInt8(0); // length of wallet name (empty string for default wallets)
        buf.writeVarSlice($e7bbfff3d6175ca3$require$Buffer.from(this.descriptorTemplate, "ascii"));
        buf.writeVarInt(this.keys.length), buf.writeSlice(m.getRoot());
        return buf.buffer();
    }
}
function $e7bbfff3d6175ca3$export$e2280c1995141b13(masterFingerprint, path, xpub) {
    const accountPath = (0, $76d975e72423660e$export$6e27cd76987a4ce2)(path);
    return `[${masterFingerprint.toString("hex")}${accountPath.substring(1)}]${xpub}/**`;
}




var $6ZWSX = parcelRequire("6ZWSX");
var $eb97f90bde966f8e$require$Buffer = $6ZWSX.Buffer;
function $eb97f90bde966f8e$export$f9380c9a627682d3(psbt) {
    var _a, _b;
    const tx = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
    tx.writeUInt32(psbt.getGlobalTxVersion());
    const isSegwit = !!psbt.getInputWitnessUtxo(0);
    if (isSegwit) tx.writeSlice($eb97f90bde966f8e$require$Buffer.from([
        0,
        1
    ]));
    const inputCount = psbt.getGlobalInputCount();
    tx.writeVarInt(inputCount);
    const witnessWriter = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
    for(let i = 0; i < inputCount; i++){
        tx.writeSlice(psbt.getInputPreviousTxid(i));
        tx.writeUInt32(psbt.getInputOutputIndex(i));
        tx.writeVarSlice((_a = psbt.getInputFinalScriptsig(i)) !== null && _a !== void 0 ? _a : $eb97f90bde966f8e$require$Buffer.from([]));
        tx.writeUInt32(psbt.getInputSequence(i));
        if (isSegwit) witnessWriter.writeSlice(psbt.getInputFinalScriptwitness(i));
    }
    const outputCount = psbt.getGlobalOutputCount();
    tx.writeVarInt(outputCount);
    for(let i = 0; i < outputCount; i++){
        tx.writeUInt64(psbt.getOutputAmount(i));
        tx.writeVarSlice(psbt.getOutputScript(i));
    }
    tx.writeSlice(witnessWriter.buffer());
    tx.writeUInt32((_b = psbt.getGlobalFallbackLocktime()) !== null && _b !== void 0 ? _b : 0);
    return tx.buffer();
}



/* eslint-disable @typescript-eslint/no-non-null-assertion */ /* eslint-disable @typescript-eslint/explicit-module-boundary-types */ 

var $6ZWSX = parcelRequire("6ZWSX");
var $885e12fabfb71081$require$Buffer = $6ZWSX.Buffer;
var $885e12fabfb71081$export$51f4a0bcfde23fa;
(function(psbtGlobal) {
    psbtGlobal[psbtGlobal["TX_VERSION"] = 2] = "TX_VERSION";
    psbtGlobal[psbtGlobal["FALLBACK_LOCKTIME"] = 3] = "FALLBACK_LOCKTIME";
    psbtGlobal[psbtGlobal["INPUT_COUNT"] = 4] = "INPUT_COUNT";
    psbtGlobal[psbtGlobal["OUTPUT_COUNT"] = 5] = "OUTPUT_COUNT";
    psbtGlobal[psbtGlobal["TX_MODIFIABLE"] = 6] = "TX_MODIFIABLE";
    psbtGlobal[psbtGlobal["VERSION"] = 251] = "VERSION";
})($885e12fabfb71081$export$51f4a0bcfde23fa || ($885e12fabfb71081$export$51f4a0bcfde23fa = {}));
var $885e12fabfb71081$export$835161b70055ac87;
(function(psbtIn) {
    psbtIn[psbtIn["NON_WITNESS_UTXO"] = 0] = "NON_WITNESS_UTXO";
    psbtIn[psbtIn["WITNESS_UTXO"] = 1] = "WITNESS_UTXO";
    psbtIn[psbtIn["PARTIAL_SIG"] = 2] = "PARTIAL_SIG";
    psbtIn[psbtIn["SIGHASH_TYPE"] = 3] = "SIGHASH_TYPE";
    psbtIn[psbtIn["REDEEM_SCRIPT"] = 4] = "REDEEM_SCRIPT";
    psbtIn[psbtIn["BIP32_DERIVATION"] = 6] = "BIP32_DERIVATION";
    psbtIn[psbtIn["FINAL_SCRIPTSIG"] = 7] = "FINAL_SCRIPTSIG";
    psbtIn[psbtIn["FINAL_SCRIPTWITNESS"] = 8] = "FINAL_SCRIPTWITNESS";
    psbtIn[psbtIn["PREVIOUS_TXID"] = 14] = "PREVIOUS_TXID";
    psbtIn[psbtIn["OUTPUT_INDEX"] = 15] = "OUTPUT_INDEX";
    psbtIn[psbtIn["SEQUENCE"] = 16] = "SEQUENCE";
    psbtIn[psbtIn["TAP_KEY_SIG"] = 19] = "TAP_KEY_SIG";
    psbtIn[psbtIn["TAP_BIP32_DERIVATION"] = 22] = "TAP_BIP32_DERIVATION";
})($885e12fabfb71081$export$835161b70055ac87 || ($885e12fabfb71081$export$835161b70055ac87 = {}));
var $885e12fabfb71081$export$a0c38500664f371;
(function(psbtOut) {
    psbtOut[psbtOut["REDEEM_SCRIPT"] = 0] = "REDEEM_SCRIPT";
    psbtOut[psbtOut["BIP_32_DERIVATION"] = 2] = "BIP_32_DERIVATION";
    psbtOut[psbtOut["AMOUNT"] = 3] = "AMOUNT";
    psbtOut[psbtOut["SCRIPT"] = 4] = "SCRIPT";
    psbtOut[psbtOut["TAP_BIP32_DERIVATION"] = 7] = "TAP_BIP32_DERIVATION";
})($885e12fabfb71081$export$a0c38500664f371 || ($885e12fabfb71081$export$a0c38500664f371 = {}));
const $885e12fabfb71081$var$PSBT_MAGIC_BYTES = $885e12fabfb71081$require$Buffer.from([
    0x70,
    0x73,
    0x62,
    0x74,
    0xff
]);
class $885e12fabfb71081$export$9192c04a9e9ddc4d extends Error {
}
class $885e12fabfb71081$export$df421e92e1e77f5 {
    constructor(){
        this.globalMap = new Map();
        this.inputMaps = [];
        this.outputMaps = [];
    }
    setGlobalTxVersion(version) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.TX_VERSION, $885e12fabfb71081$var$uint32LE(version));
    }
    getGlobalTxVersion() {
        return this.getGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.TX_VERSION).readUInt32LE(0);
    }
    setGlobalFallbackLocktime(locktime) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME, $885e12fabfb71081$var$uint32LE(locktime));
    }
    getGlobalFallbackLocktime() {
        var _a;
        return (_a = this.getGlobalOptional($885e12fabfb71081$export$51f4a0bcfde23fa.FALLBACK_LOCKTIME)) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0);
    }
    setGlobalInputCount(inputCount) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.INPUT_COUNT, $885e12fabfb71081$var$varint(inputCount));
    }
    getGlobalInputCount() {
        return $885e12fabfb71081$var$fromVarint(this.getGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.INPUT_COUNT));
    }
    setGlobalOutputCount(outputCount) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.OUTPUT_COUNT, $885e12fabfb71081$var$varint(outputCount));
    }
    getGlobalOutputCount() {
        return $885e12fabfb71081$var$fromVarint(this.getGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.OUTPUT_COUNT));
    }
    setGlobalTxModifiable(byte) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.TX_MODIFIABLE, byte);
    }
    getGlobalTxModifiable() {
        return this.getGlobalOptional($885e12fabfb71081$export$51f4a0bcfde23fa.TX_MODIFIABLE);
    }
    setGlobalPsbtVersion(psbtVersion) {
        this.setGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.VERSION, $885e12fabfb71081$var$uint32LE(psbtVersion));
    }
    getGlobalPsbtVersion() {
        return this.getGlobal($885e12fabfb71081$export$51f4a0bcfde23fa.VERSION).readUInt32LE(0);
    }
    setInputNonWitnessUtxo(inputIndex, transaction) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.NON_WITNESS_UTXO, $885e12fabfb71081$var$b(), transaction);
    }
    getInputNonWitnessUtxo(inputIndex) {
        return this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.NON_WITNESS_UTXO, $885e12fabfb71081$var$b());
    }
    setInputWitnessUtxo(inputIndex, amount, scriptPubKey) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        buf.writeSlice(amount);
        buf.writeVarSlice(scriptPubKey);
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.WITNESS_UTXO, $885e12fabfb71081$var$b(), buf.buffer());
    }
    getInputWitnessUtxo(inputIndex) {
        const utxo = this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.WITNESS_UTXO, $885e12fabfb71081$var$b());
        if (!utxo) return undefined;
        const buf = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(utxo);
        return {
            amount: buf.readSlice(8),
            scriptPubKey: buf.readVarSlice()
        };
    }
    setInputPartialSig(inputIndex, pubkey, signature) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.PARTIAL_SIG, pubkey, signature);
    }
    getInputPartialSig(inputIndex, pubkey) {
        return this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.PARTIAL_SIG, pubkey);
    }
    setInputSighashType(inputIndex, sigHashtype) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.SIGHASH_TYPE, $885e12fabfb71081$var$b(), $885e12fabfb71081$var$uint32LE(sigHashtype));
    }
    getInputSighashType(inputIndex) {
        const result = this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.SIGHASH_TYPE, $885e12fabfb71081$var$b());
        if (!result) return undefined;
        return result.readUInt32LE(0);
    }
    setInputRedeemScript(inputIndex, redeemScript) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.REDEEM_SCRIPT, $885e12fabfb71081$var$b(), redeemScript);
    }
    getInputRedeemScript(inputIndex) {
        return this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.REDEEM_SCRIPT, $885e12fabfb71081$var$b());
    }
    setInputBip32Derivation(inputIndex, pubkey, masterFingerprint, path) {
        if (pubkey.length != 33) throw new Error("Invalid pubkey length: " + pubkey.length);
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.BIP32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getInputBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.BIP32_DERIVATION, pubkey);
        if (!buf) return undefined;
        return this.decodeBip32Derivation(buf);
    }
    setInputFinalScriptsig(inputIndex, scriptSig) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.FINAL_SCRIPTSIG, $885e12fabfb71081$var$b(), scriptSig);
    }
    getInputFinalScriptsig(inputIndex) {
        return this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.FINAL_SCRIPTSIG, $885e12fabfb71081$var$b());
    }
    setInputFinalScriptwitness(inputIndex, scriptWitness) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $885e12fabfb71081$var$b(), scriptWitness);
    }
    getInputFinalScriptwitness(inputIndex) {
        return this.getInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.FINAL_SCRIPTWITNESS, $885e12fabfb71081$var$b());
    }
    setInputPreviousTxId(inputIndex, txid) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.PREVIOUS_TXID, $885e12fabfb71081$var$b(), txid);
    }
    getInputPreviousTxid(inputIndex) {
        return this.getInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.PREVIOUS_TXID, $885e12fabfb71081$var$b());
    }
    setInputOutputIndex(inputIndex, outputIndex) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.OUTPUT_INDEX, $885e12fabfb71081$var$b(), $885e12fabfb71081$var$uint32LE(outputIndex));
    }
    getInputOutputIndex(inputIndex) {
        return this.getInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.OUTPUT_INDEX, $885e12fabfb71081$var$b()).readUInt32LE(0);
    }
    setInputSequence(inputIndex, sequence) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.SEQUENCE, $885e12fabfb71081$var$b(), $885e12fabfb71081$var$uint32LE(sequence));
    }
    getInputSequence(inputIndex) {
        var _a, _b;
        return (_b = (_a = this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.SEQUENCE, $885e12fabfb71081$var$b())) === null || _a === void 0 ? void 0 : _a.readUInt32LE(0)) !== null && _b !== void 0 ? _b : 0xffffffff;
    }
    setInputTapKeySig(inputIndex, sig) {
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.TAP_KEY_SIG, $885e12fabfb71081$var$b(), sig);
    }
    getInputTapKeySig(inputIndex) {
        return this.getInputOptional(inputIndex, $885e12fabfb71081$export$835161b70055ac87.TAP_KEY_SIG, $885e12fabfb71081$var$b());
    }
    setInputTapBip32Derivation(inputIndex, pubkey, hashes, masterFingerprint, path) {
        if (pubkey.length != 32) throw new Error("Invalid pubkey length: " + pubkey.length);
        const buf = this.encodeTapBip32Derivation(hashes, masterFingerprint, path);
        this.setInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getInputTapBip32Derivation(inputIndex, pubkey) {
        const buf = this.getInput(inputIndex, $885e12fabfb71081$export$835161b70055ac87.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    getInputKeyDatas(inputIndex, keyType) {
        return this.getKeyDatas(this.inputMaps[inputIndex], keyType);
    }
    setOutputRedeemScript(outputIndex, redeemScript) {
        this.setOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.REDEEM_SCRIPT, $885e12fabfb71081$var$b(), redeemScript);
    }
    getOutputRedeemScript(outputIndex) {
        return this.getOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.REDEEM_SCRIPT, $885e12fabfb71081$var$b());
    }
    setOutputBip32Derivation(outputIndex, pubkey, masterFingerprint, path) {
        this.setOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.BIP_32_DERIVATION, pubkey, this.encodeBip32Derivation(masterFingerprint, path));
    }
    getOutputBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.BIP_32_DERIVATION, pubkey);
        return this.decodeBip32Derivation(buf);
    }
    setOutputAmount(outputIndex, amount) {
        this.setOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.AMOUNT, $885e12fabfb71081$var$b(), $885e12fabfb71081$var$uint64LE(amount));
    }
    getOutputAmount(outputIndex) {
        const buf = this.getOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.AMOUNT, $885e12fabfb71081$var$b());
        return (0, $036f9e277d3889a8$export$cbe6b25937ae0aed)(buf);
    }
    setOutputScript(outputIndex, scriptPubKey) {
        this.setOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.SCRIPT, $885e12fabfb71081$var$b(), scriptPubKey);
    }
    getOutputScript(outputIndex) {
        return this.getOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.SCRIPT, $885e12fabfb71081$var$b());
    }
    setOutputTapBip32Derivation(outputIndex, pubkey, hashes, fingerprint, path) {
        const buf = this.encodeTapBip32Derivation(hashes, fingerprint, path);
        this.setOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey, buf);
    }
    getOutputTapBip32Derivation(outputIndex, pubkey) {
        const buf = this.getOutput(outputIndex, $885e12fabfb71081$export$a0c38500664f371.TAP_BIP32_DERIVATION, pubkey);
        return this.decodeTapBip32Derivation(buf);
    }
    deleteInputEntries(inputIndex, keyTypes) {
        const map = this.inputMaps[inputIndex];
        map.forEach((_v, k, m)=>{
            if (this.isKeyType(k, keyTypes)) m.delete(k);
        });
    }
    copy(to) {
        this.copyMap(this.globalMap, to.globalMap);
        this.copyMaps(this.inputMaps, to.inputMaps);
        this.copyMaps(this.outputMaps, to.outputMaps);
    }
    copyMaps(from, to) {
        from.forEach((m, index)=>{
            const to_index = new Map();
            this.copyMap(m, to_index);
            to[index] = to_index;
        });
    }
    copyMap(from, to) {
        from.forEach((v, k)=>to.set(k, $885e12fabfb71081$require$Buffer.from(v)));
    }
    serialize() {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        buf.writeSlice($885e12fabfb71081$require$Buffer.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xff
        ]));
        $885e12fabfb71081$var$serializeMap(buf, this.globalMap);
        this.inputMaps.forEach((map)=>{
            $885e12fabfb71081$var$serializeMap(buf, map);
        });
        this.outputMaps.forEach((map)=>{
            $885e12fabfb71081$var$serializeMap(buf, map);
        });
        return buf.buffer();
    }
    deserialize(psbt) {
        const buf = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(psbt);
        if (!buf.readSlice(5).equals($885e12fabfb71081$var$PSBT_MAGIC_BYTES)) throw new Error("Invalid magic bytes");
        while(this.readKeyPair(this.globalMap, buf));
        for(let i = 0; i < this.getGlobalInputCount(); i++){
            this.inputMaps[i] = new Map();
            while(this.readKeyPair(this.inputMaps[i], buf));
        }
        for(let i = 0; i < this.getGlobalOutputCount(); i++){
            this.outputMaps[i] = new Map();
            while(this.readKeyPair(this.outputMaps[i], buf));
        }
    }
    readKeyPair(map, buf) {
        const keyLen = buf.readVarInt();
        if (keyLen == 0) return false;
        const keyType = buf.readUInt8();
        const keyData = buf.readSlice(keyLen - 1);
        const value = buf.readVarSlice();
        $885e12fabfb71081$var$set(map, keyType, keyData, value);
        return true;
    }
    getKeyDatas(map, keyType) {
        const result = [];
        map.forEach((_v, k)=>{
            if (this.isKeyType(k, [
                keyType
            ])) result.push($885e12fabfb71081$require$Buffer.from(k.substring(2), "hex"));
        });
        return result;
    }
    isKeyType(hexKey, keyTypes) {
        const keyType = $885e12fabfb71081$require$Buffer.from(hexKey.substring(0, 2), "hex").readUInt8(0);
        return keyTypes.some((k)=>k == keyType);
    }
    setGlobal(keyType, value) {
        const key = new $885e12fabfb71081$var$Key(keyType, $885e12fabfb71081$require$Buffer.from([]));
        this.globalMap.set(key.toString(), value);
    }
    getGlobal(keyType) {
        return $885e12fabfb71081$var$get(this.globalMap, keyType, $885e12fabfb71081$var$b(), false);
    }
    getGlobalOptional(keyType) {
        return $885e12fabfb71081$var$get(this.globalMap, keyType, $885e12fabfb71081$var$b(), true);
    }
    setInput(index, keyType, keyData, value) {
        $885e12fabfb71081$var$set(this.getMap(index, this.inputMaps), keyType, keyData, value);
    }
    getInput(index, keyType, keyData) {
        return $885e12fabfb71081$var$get(this.inputMaps[index], keyType, keyData, false);
    }
    getInputOptional(index, keyType, keyData) {
        return $885e12fabfb71081$var$get(this.inputMaps[index], keyType, keyData, true);
    }
    setOutput(index, keyType, keyData, value) {
        $885e12fabfb71081$var$set(this.getMap(index, this.outputMaps), keyType, keyData, value);
    }
    getOutput(index, keyType, keyData) {
        return $885e12fabfb71081$var$get(this.outputMaps[index], keyType, keyData, false);
    }
    getMap(index, maps) {
        if (maps[index]) return maps[index];
        return maps[index] = new Map();
    }
    encodeBip32Derivation(masterFingerprint, path) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeBip32Derivation(buffer) {
        const buf = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(buffer);
        return this.readBip32Derivation(buf);
    }
    writeBip32Derivation(buf, masterFingerprint, path) {
        buf.writeSlice(masterFingerprint);
        path.forEach((element)=>{
            buf.writeUInt32(element);
        });
    }
    readBip32Derivation(buf) {
        const masterFingerprint = buf.readSlice(4);
        const path = [];
        while(buf.offset < buf.buffer.length)path.push(buf.readUInt32());
        return {
            masterFingerprint: masterFingerprint,
            path: path
        };
    }
    encodeTapBip32Derivation(hashes, masterFingerprint, path) {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        buf.writeVarInt(hashes.length);
        hashes.forEach((h)=>{
            buf.writeSlice(h);
        });
        this.writeBip32Derivation(buf, masterFingerprint, path);
        return buf.buffer();
    }
    decodeTapBip32Derivation(buffer) {
        const buf = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(buffer);
        const hashCount = buf.readVarInt();
        const hashes = [];
        for(let i = 0; i < hashCount; i++)hashes.push(buf.readSlice(32));
        const deriv = this.readBip32Derivation(buf);
        return Object.assign({
            hashes: hashes
        }, deriv);
    }
}
function $885e12fabfb71081$var$get(map, keyType, keyData, acceptUndefined) {
    if (!map) throw Error("No such map");
    const key = new $885e12fabfb71081$var$Key(keyType, keyData);
    const value = map.get(key.toString());
    if (!value) {
        if (acceptUndefined) return undefined;
        throw new $885e12fabfb71081$export$9192c04a9e9ddc4d(key.toString());
    }
    // Make sure to return a copy, to protect the underlying data.
    return $885e12fabfb71081$require$Buffer.from(value);
}
class $885e12fabfb71081$var$Key {
    constructor(keyType, keyData){
        this.keyType = keyType;
        this.keyData = keyData;
    }
    toString() {
        const buf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
        this.toBuffer(buf);
        return buf.buffer().toString("hex");
    }
    serialize(buf) {
        buf.writeVarInt(1 + this.keyData.length);
        this.toBuffer(buf);
    }
    toBuffer(buf) {
        buf.writeUInt8(this.keyType);
        buf.writeSlice(this.keyData);
    }
}
class $885e12fabfb71081$var$KeyPair {
    constructor(key, value){
        this.key = key;
        this.value = value;
    }
    serialize(buf) {
        this.key.serialize(buf);
        buf.writeVarSlice(this.value);
    }
}
function $885e12fabfb71081$var$createKey(buf) {
    return new $885e12fabfb71081$var$Key(buf.readUInt8(0), buf.slice(1));
}
function $885e12fabfb71081$var$serializeMap(buf, map) {
    for (const k of map.keys()){
        const value = map.get(k);
        const keyPair = new $885e12fabfb71081$var$KeyPair($885e12fabfb71081$var$createKey($885e12fabfb71081$require$Buffer.from(k, "hex")), value);
        keyPair.serialize(buf);
    }
    buf.writeUInt8(0);
}
function $885e12fabfb71081$var$b() {
    return $885e12fabfb71081$require$Buffer.from([]);
}
function $885e12fabfb71081$var$set(map, keyType, keyData, value) {
    const key = new $885e12fabfb71081$var$Key(keyType, keyData);
    map.set(key.toString(), value);
}
function $885e12fabfb71081$var$uint32LE(n) {
    const b = $885e12fabfb71081$require$Buffer.alloc(4);
    b.writeUInt32LE(n, 0);
    return b;
}
function $885e12fabfb71081$var$uint64LE(n) {
    return (0, $036f9e277d3889a8$export$8ccb8fa75d191fb7)(n);
}
function $885e12fabfb71081$var$varint(n) {
    const b = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
    b.writeVarInt(n);
    return b.buffer();
}
function $885e12fabfb71081$var$fromVarint(buf) {
    return new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(buf).readVarInt();
}



var $6ZWSX = parcelRequire("6ZWSX");
var $84fba0890f6d38c4$require$Buffer = $6ZWSX.Buffer;
function $84fba0890f6d38c4$export$578723aef62d92f5(psbt) {
    // First check that each input has a signature
    const inputCount = psbt.getGlobalInputCount();
    for(let i = 0; i < inputCount; i++){
        const legacyPubkeys = psbt.getInputKeyDatas(i, (0, $885e12fabfb71081$export$835161b70055ac87).PARTIAL_SIG);
        const taprootSig = psbt.getInputTapKeySig(i);
        if (legacyPubkeys.length == 0 && !taprootSig) throw Error(`No signature for input ${i} present`);
        if (legacyPubkeys.length > 0) {
            if (legacyPubkeys.length > 1) throw Error(`Expected exactly one signature, got ${legacyPubkeys.length}`);
            if (taprootSig) throw Error("Both taproot and non-taproot signatures present.");
            const isSegwitV0 = !!psbt.getInputWitnessUtxo(i);
            const redeemScript = psbt.getInputRedeemScript(i);
            const isWrappedSegwit = !!redeemScript;
            const signature = psbt.getInputPartialSig(i, legacyPubkeys[0]);
            if (!signature) throw new Error("Expected partial signature for input " + i);
            if (isSegwitV0) {
                const witnessBuf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
                witnessBuf.writeVarInt(2);
                witnessBuf.writeVarInt(signature.length);
                witnessBuf.writeSlice(signature);
                witnessBuf.writeVarInt(legacyPubkeys[0].length);
                witnessBuf.writeSlice(legacyPubkeys[0]);
                psbt.setInputFinalScriptwitness(i, witnessBuf.buffer());
                if (isWrappedSegwit) {
                    if (!redeemScript || redeemScript.length == 0) throw new Error("Expected non-empty redeemscript. Can't finalize intput " + i);
                    const scriptSigBuf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
                    // Push redeemScript length
                    scriptSigBuf.writeUInt8(redeemScript.length);
                    scriptSigBuf.writeSlice(redeemScript);
                    psbt.setInputFinalScriptsig(i, scriptSigBuf.buffer());
                }
            } else {
                // Legacy input
                const scriptSig = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
                $84fba0890f6d38c4$var$writePush(scriptSig, signature);
                $84fba0890f6d38c4$var$writePush(scriptSig, legacyPubkeys[0]);
                psbt.setInputFinalScriptsig(i, scriptSig.buffer());
            }
        } else {
            // Taproot input
            const signature = psbt.getInputTapKeySig(i);
            if (!signature) throw Error("No taproot signature found");
            if (signature.length != 64 && signature.length != 65) throw Error("Unexpected length of schnorr signature.");
            const witnessBuf = new (0, $036f9e277d3889a8$export$67649df22d9ca0ab)();
            witnessBuf.writeVarInt(1);
            witnessBuf.writeVarSlice(signature);
            psbt.setInputFinalScriptwitness(i, witnessBuf.buffer());
        }
        $84fba0890f6d38c4$var$clearFinalizedInput(psbt, i);
    }
}
/**
 * Deletes fields that are no longer neccesary from the psbt.
 *
 * Note, the spec doesn't say anything about removing ouput fields
 * like PSBT_OUT_BIP32_DERIVATION_PATH and others, so we keep them
 * without actually knowing why. I think we should remove them too.
 */ function $84fba0890f6d38c4$var$clearFinalizedInput(psbt, inputIndex) {
    const keyTypes = [
        (0, $885e12fabfb71081$export$835161b70055ac87).BIP32_DERIVATION,
        (0, $885e12fabfb71081$export$835161b70055ac87).PARTIAL_SIG,
        (0, $885e12fabfb71081$export$835161b70055ac87).TAP_BIP32_DERIVATION,
        (0, $885e12fabfb71081$export$835161b70055ac87).TAP_KEY_SIG
    ];
    const witnessUtxoAvailable = !!psbt.getInputWitnessUtxo(inputIndex);
    const nonWitnessUtxoAvailable = !!psbt.getInputNonWitnessUtxo(inputIndex);
    if (witnessUtxoAvailable && nonWitnessUtxoAvailable) // Remove NON_WITNESS_UTXO for segwit v0 as it's only needed while signing.
    // Segwit v1 doesn't have NON_WITNESS_UTXO set.
    // See https://github.com/bitcoin/bips/blob/master/bip-0174.mediawiki#cite_note-7
    keyTypes.push((0, $885e12fabfb71081$export$835161b70055ac87).NON_WITNESS_UTXO);
    psbt.deleteInputEntries(inputIndex, keyTypes);
}
/**
 * Writes a script push operation to buf, which looks different
 * depending on the size of the data. See
 * https://en.bitcoin.it/wiki/Script#Constants
 *
 * @param buf the BufferWriter to write to
 * @param data the Buffer to be pushed.
 */ function $84fba0890f6d38c4$var$writePush(buf, data) {
    if (data.length <= 75) buf.writeUInt8(data.length);
    else if (data.length <= 256) {
        buf.writeUInt8(76);
        buf.writeUInt8(data.length);
    } else if (data.length <= 65536) {
        buf.writeUInt8(77);
        const b = $84fba0890f6d38c4$require$Buffer.alloc(2);
        b.writeUInt16LE(data.length, 0);
        buf.writeSlice(b);
    }
    buf.writeSlice(data);
}




var $6ZWSX = parcelRequire("6ZWSX");
var $9c51203570a3cc05$require$Buffer = $6ZWSX.Buffer;
function $9c51203570a3cc05$export$aa1483be3b95dbf(data, offset) {
    if (data[offset] < 0xfd) return [
        data[offset],
        1
    ];
    if (data[offset] === 0xfd) return [
        (data[offset + 2] << 8) + data[offset + 1],
        3
    ];
    if (data[offset] === 0xfe) return [
        (data[offset + 4] << 24) + (data[offset + 3] << 16) + (data[offset + 2] << 8) + data[offset + 1],
        5
    ];
    throw new Error("getVarint called with unexpected parameters");
}
function $9c51203570a3cc05$export$6124fc6ccfda9c(value) {
    if (value < 0xfd) {
        const buffer = $9c51203570a3cc05$require$Buffer.alloc(1);
        buffer[0] = value;
        return buffer;
    }
    if (value <= 0xffff) {
        const buffer = $9c51203570a3cc05$require$Buffer.alloc(3);
        buffer[0] = 0xfd;
        buffer[1] = value & 0xff;
        buffer[2] = value >> 8 & 0xff;
        return buffer;
    }
    const buffer = $9c51203570a3cc05$require$Buffer.alloc(5);
    buffer[0] = 0xfe;
    buffer[1] = value & 0xff;
    buffer[2] = value >> 8 & 0xff;
    buffer[3] = value >> 16 & 0xff;
    buffer[4] = value >> 24 & 0xff;
    return buffer;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $6f5c2f66f4ecb3fe$require$Buffer = $6ZWSX.Buffer;
function $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8({ outputs: outputs }) {
    let outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.alloc(0);
    if (typeof outputs !== "undefined") {
        outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
            outputBuffer,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(outputs.length)
        ]);
        outputs.forEach((output)=>{
            outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
                outputBuffer,
                output.amount,
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(output.script.length),
                output.script
            ]);
        });
    }
    return outputBuffer;
}
function $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996(transaction, skipWitness, timestamp, additionals = []) {
    const isDecred = additionals.includes("decred");
    const isZcash = additionals.includes("zcash");
    const isBech32 = additionals.includes("bech32");
    let inputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.alloc(0);
    const useWitness = typeof transaction["witness"] != "undefined" && !skipWitness;
    transaction.inputs.forEach((input)=>{
        inputBuffer = isDecred || isBech32 ? $6f5c2f66f4ecb3fe$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            $6f5c2f66f4ecb3fe$require$Buffer.from([
                0x00
            ]),
            input.sequence
        ]) : $6f5c2f66f4ecb3fe$require$Buffer.concat([
            inputBuffer,
            input.prevout,
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length),
            input.script,
            input.sequence
        ]);
    });
    let outputBuffer = $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8(transaction);
    if (typeof transaction.outputs !== "undefined" && typeof transaction.locktime !== "undefined") outputBuffer = $6f5c2f66f4ecb3fe$require$Buffer.concat([
        outputBuffer,
        useWitness && transaction.witness || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.locktime,
        transaction.nExpiryHeight || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.extraData || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0)
    ]);
    // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
    if (isZcash) return $6f5c2f66f4ecb3fe$require$Buffer.concat([
        transaction.version,
        transaction.nVersionGroupId || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        $6f5c2f66f4ecb3fe$require$Buffer.from([
            0xb4,
            0xd0,
            0xd6,
            0xc2
        ]),
        transaction.locktime || $6f5c2f66f4ecb3fe$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        transaction.nExpiryHeight || $6f5c2f66f4ecb3fe$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        useWitness ? $6f5c2f66f4ecb3fe$require$Buffer.from("0001", "hex") : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
    return $6f5c2f66f4ecb3fe$require$Buffer.concat([
        transaction.version,
        timestamp ? timestamp : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        transaction.nVersionGroupId || $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        useWitness ? $6f5c2f66f4ecb3fe$require$Buffer.from("0001", "hex") : $6f5c2f66f4ecb3fe$require$Buffer.alloc(0),
        (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length),
        inputBuffer,
        outputBuffer
    ]);
}



var $6ZWSX = parcelRequire("6ZWSX");
var $9018257154446467$require$Buffer = $6ZWSX.Buffer;
var $9018257154446467$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $9018257154446467$export$2e2bcd8739ae039 {
    constructor(client){
        this.client = client;
    }
    /**
     * This is a new method that allow users to get an xpub at a standard path.
     * Standard paths are described at
     * https://github.com/LedgerHQ/app-bitcoin-new/blob/master/doc/bitcoin.md#description
     *
     * This boils down to paths (N=0 for Bitcoin, N=1 for Testnet):
     * M/44'/N'/x'/**
     * M/48'/N'/x'/y'/**
     * M/49'/N'/x'/**
     * M/84'/N'/x'/**
     * M/86'/N'/x'/**
     *
     * The method was added because of added security in the hardware app v2+. The
     * new hardware app will allow export of any xpub up to and including the
     * deepest hardened key of standard derivation paths, whereas the old app
     * would allow export of any key.
     *
     * This caused an issue for callers of this class, who only had
     * getWalletPublicKey() to call which means they have to constuct xpub
     * themselves:
     *
     * Suppose a user of this class wants to create an account xpub on a standard
     * path, M/44'/0'/Z'. The user must get the parent key fingerprint (see BIP32)
     * by requesting the parent key M/44'/0'. The new app won't allow that, because
     * it only allows exporting deepest level hardened path. So the options are to
     * allow requesting M/44'/0' from the app, or to add a new function
     * "getWalletXpub".
     *
     * We opted for adding a new function, which can greatly simplify client code.
     */ getWalletXpub(_a) {
        return $9018257154446467$var$__awaiter(this, arguments, void 0, function*({ path: path, xpubVersion: xpubVersion }) {
            const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
            const xpub = yield this.client.getExtendedPubkey(false, pathElements);
            const xpubComponents = (0, $76d975e72423660e$export$8bb2dc8ba35445c6)(xpub);
            if (xpubComponents.version != xpubVersion) throw new Error(`Expected xpub version ${xpubVersion} doesn't match the xpub version from the device ${xpubComponents.version}`);
            return xpub;
        });
    }
    /**
     * This method returns a public key, a bitcoin address, and and a chaincode
     * for a specific derivation path.
     *
     * Limitation: If the path is not a leaf node of a standard path, the address
     * will be the empty string "", see this.getWalletAddress() for details.
     */ getWalletPublicKey(path, opts) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            var _a, _b;
            if (!$9018257154446467$export$d0edaed3aa4f6f65(path)) throw Error(`non-standard path: ${path}`);
            const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
            const xpub = yield this.client.getExtendedPubkey(false, pathElements);
            const display = (_a = opts === null || opts === void 0 ? void 0 : opts.verify) !== null && _a !== void 0 ? _a : false;
            const address = yield this.getWalletAddress(pathElements, $9018257154446467$var$descrTemplFrom((_b = opts === null || opts === void 0 ? void 0 : opts.format) !== null && _b !== void 0 ? _b : "legacy"), display);
            const components = (0, $76d975e72423660e$export$8bb2dc8ba35445c6)(xpub);
            const uncompressedPubkey = $9018257154446467$require$Buffer.from((0, $a810f27cf38f4a3f$exports.pointCompress)(components.pubkey, false));
            return {
                publicKey: uncompressedPubkey.toString("hex"),
                bitcoinAddress: address,
                chainCode: components.chaincode.toString("hex")
            };
        });
    }
    /**
     * Get an address for the specified path.
     *
     * If display is true, we must get the address from the device, which would require
     * us to determine WalletPolicy. This requires two *extra* queries to the device, one
     * for the account xpub and one for master key fingerprint.
     *
     * If display is false we *could* generate the address ourselves, but chose to
     * get it from the device to save development time. However, it shouldn't take
     * too much time to implement local address generation.
     *
     * Moreover, if the path is not for a leaf, ie accountPath+/X/Y, there is no
     * way to get the address from the device. In this case we have to create it
     * ourselves, but we don't at this time, and instead return an empty ("") address.
     */ getWalletAddress(pathElements, descrTempl, display) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            const accountPath = (0, $76d975e72423660e$export$cc16963b25268381)(pathElements);
            if (accountPath.length + 2 != pathElements.length) return "";
            const accountXpub = yield this.client.getExtendedPubkey(false, accountPath);
            const masterFingerprint = yield this.client.getMasterFingerprint();
            const policy = new (0, $e7bbfff3d6175ca3$export$7dabddf99c50dec7)(descrTempl, (0, $e7bbfff3d6175ca3$export$e2280c1995141b13)(masterFingerprint, accountPath, accountXpub));
            const changeAndIndex = pathElements.slice(-2, pathElements.length);
            return this.client.getWalletAddress(policy, $9018257154446467$require$Buffer.alloc(32, 0), changeAndIndex[0], changeAndIndex[1], display);
        });
    }
    /**
     * Build and sign a transaction. See Btc.createPaymentTransaction for
     * details on how to use this method.
     *
     * This method will convert the legacy arguments, CreateTransactionArg, into
     * a psbt which is finally signed and finalized, and the extracted fully signed
     * transaction is returned.
     */ createPaymentTransaction(arg) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            const inputCount = arg.inputs.length;
            if (inputCount == 0) throw Error("No inputs");
            const psbt = new (0, $885e12fabfb71081$export$df421e92e1e77f5)();
            // The master fingerprint is needed when adding BIP32 derivation paths on
            // the psbt.
            const masterFp = yield this.client.getMasterFingerprint();
            const accountType = $9018257154446467$var$accountTypeFromArg(arg, psbt, masterFp);
            if (arg.lockTime != undefined) // The signer will assume locktime 0 if unset
            psbt.setGlobalFallbackLocktime(arg.lockTime);
            psbt.setGlobalInputCount(inputCount);
            psbt.setGlobalPsbtVersion(2);
            psbt.setGlobalTxVersion(2);
            let notifyCount = 0;
            const progress = ()=>{
                if (!arg.onDeviceStreaming) return;
                arg.onDeviceStreaming({
                    total: 2 * inputCount,
                    index: notifyCount,
                    progress: ++notifyCount / (2 * inputCount)
                });
            };
            let accountXpub = "";
            let accountPath = [];
            for(let i = 0; i < inputCount; i++){
                progress();
                const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(arg.associatedKeysets[i]);
                if (accountXpub == "") {
                    // We assume all inputs belong to the same account so we set
                    // the account xpub and path based on the first input.
                    accountPath = pathElems.slice(0, -2);
                    accountXpub = yield this.client.getExtendedPubkey(false, accountPath);
                }
                yield this.setInput(psbt, i, arg.inputs[i], pathElems, accountType, masterFp, arg.sigHashType);
            }
            const outputsConcat = $9018257154446467$require$Buffer.from(arg.outputScriptHex, "hex");
            const outputsBufferReader = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(outputsConcat);
            const outputCount = outputsBufferReader.readVarInt();
            psbt.setGlobalOutputCount(outputCount);
            const changeData = yield this.outputScriptAt(accountPath, accountType, arg.changePath);
            // If the caller supplied a changePath, we must make sure there actually is
            // a change output. If no change output found, we'll throw an error.
            let changeFound = !changeData;
            for(let i = 0; i < outputCount; i++){
                const amount = Number(outputsBufferReader.readUInt64());
                const outputScript = outputsBufferReader.readVarSlice();
                psbt.setOutputAmount(i, amount);
                psbt.setOutputScript(i, outputScript);
                // We won't know if we're paying to ourselves, because there's no
                // information in arg to support multiple "change paths". One exception is
                // if there are multiple outputs to the change address.
                const isChange = changeData && outputScript.equals(changeData === null || changeData === void 0 ? void 0 : changeData.cond.scriptPubKey);
                if (isChange) {
                    changeFound = true;
                    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                    const changePath = (0, $76d975e72423660e$export$35caeff6b64c2b35)(arg.changePath);
                    const pubkey = changeData.pubkey;
                    accountType.setOwnOutput(i, changeData.cond, [
                        pubkey
                    ], [
                        changePath
                    ]);
                }
            }
            if (!changeFound) throw new Error("Change script not found among outputs! " + (changeData === null || changeData === void 0 ? void 0 : changeData.cond.scriptPubKey.toString("hex")));
            const key = (0, $e7bbfff3d6175ca3$export$e2280c1995141b13)(masterFp, accountPath, accountXpub);
            const p = new (0, $e7bbfff3d6175ca3$export$7dabddf99c50dec7)(accountType.getDescriptorTemplate(), key);
            // This is cheating, because it's not actually requested on the
            // device yet, but it will be, soonish.
            if (arg.onDeviceSignatureRequested) arg.onDeviceSignatureRequested();
            let firstSigned = false;
            // This callback will be called once for each signature yielded.
            const progressCallback = ()=>{
                if (!firstSigned) {
                    firstSigned = true;
                    arg.onDeviceSignatureGranted && arg.onDeviceSignatureGranted();
                }
                progress();
            };
            yield this.signPsbt(psbt, p, progressCallback);
            (0, $84fba0890f6d38c4$export$578723aef62d92f5)(psbt);
            const serializedTx = (0, $eb97f90bde966f8e$export$f9380c9a627682d3)(psbt);
            return serializedTx.toString("hex");
        });
    }
    /**
     * Signs an arbitrary hex-formatted message with the private key at
     * the provided derivation path according to the Bitcoin Signature format
     * and returns v, r, s.
     */ signMessage(_a) {
        return $9018257154446467$var$__awaiter(this, arguments, void 0, function*({ path: path, messageHex: messageHex }) {
            const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
            const message = $9018257154446467$require$Buffer.from(messageHex, "hex");
            const sig = yield this.client.signMessage(message, pathElements);
            const buf = $9018257154446467$require$Buffer.from(sig, "base64");
            const v = buf.readUInt8() - 27 - 4;
            const r = buf.slice(1, 33).toString("hex");
            const s = buf.slice(33, 65).toString("hex");
            return {
                v: v,
                r: r,
                s: s
            };
        });
    }
    /**
     * Calculates an output script along with public key and possible redeemScript
     * from a path and accountType. The accountPath must be a prefix of path.
     *
     * @returns an object with output script (property "script"), redeemScript (if
     * wrapped p2wpkh), and pubkey at provided path. The values of these three
     * properties depend on the accountType used.
     */ outputScriptAt(accountPath, accountType, path) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            if (!path) return undefined;
            const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
            // Make sure path is in our account, otherwise something fishy is probably
            // going on.
            for(let i = 0; i < accountPath.length; i++){
                if (accountPath[i] != pathElems[i]) throw new Error(`Path ${path} not in account ${(0, $76d975e72423660e$export$6e27cd76987a4ce2)(accountPath)}`);
            }
            const xpub = yield this.client.getExtendedPubkey(false, pathElems);
            const pubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpub);
            const cond = accountType.spendingCondition([
                pubkey
            ]);
            return {
                cond: cond,
                pubkey: pubkey
            };
        });
    }
    /**
     * Adds relevant data about an input to the psbt. This includes sequence,
     * previous txid, output index, spent UTXO, redeem script for wrapped p2wpkh,
     * public key and its derivation path.
     */ setInput(psbt, i, input, pathElements, accountType, masterFP, sigHashType) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            const inputTx = input[0];
            const spentOutputIndex = input[1];
            // redeemScript will be null for wrapped p2wpkh, we need to create it
            // ourselves. But if set, it should be used.
            const redeemScript = input[2] ? $9018257154446467$require$Buffer.from(input[2], "hex") : undefined;
            const sequence = input[3];
            if (sequence != undefined) psbt.setInputSequence(i, sequence);
            if (sigHashType != undefined) psbt.setInputSighashType(i, sigHashType);
            const inputTxBuffer = (0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(inputTx, true);
            const inputTxid = (0, $58cf3bc07eb2f0ea$exports.crypto).hash256(inputTxBuffer);
            const xpubBase58 = yield this.client.getExtendedPubkey(false, pathElements);
            const pubkey = (0, $76d975e72423660e$export$133bb17506582e39)(xpubBase58);
            if (!inputTx.outputs) throw Error("Missing outputs array in transaction to sign");
            const spentTxOutput = inputTx.outputs[spentOutputIndex];
            const spendCondition = {
                scriptPubKey: spentTxOutput.script,
                redeemScript: redeemScript
            };
            const spentOutput = {
                cond: spendCondition,
                amount: spentTxOutput.amount
            };
            accountType.setInput(i, inputTxBuffer, spentOutput, [
                pubkey
            ], [
                pathElements
            ]);
            psbt.setInputPreviousTxId(i, inputTxid);
            psbt.setInputOutputIndex(i, spentOutputIndex);
        });
    }
    /**
     * This implements the "Signer" role of the BIP370 transaction signing
     * process.
     *
     * It ssks the hardware device to sign the a psbt using the specified wallet
     * policy. This method assumes BIP32 derived keys are used for all inputs, see
     * comment in-line. The signatures returned from the hardware device is added
     * to the appropriate input fields of the PSBT.
     */ signPsbt(psbt, walletPolicy, progressCallback) {
        return $9018257154446467$var$__awaiter(this, void 0, void 0, function*() {
            const sigs = yield this.client.signPsbt(psbt, walletPolicy, $9018257154446467$require$Buffer.alloc(32, 0), progressCallback);
            sigs.forEach((v, k)=>{
                // Note: Looking at BIP32 derivation does not work in the generic case,
                // since some inputs might not have a BIP32-derived pubkey.
                const pubkeys = psbt.getInputKeyDatas(k, (0, $885e12fabfb71081$export$835161b70055ac87).BIP32_DERIVATION);
                let pubkey;
                if (pubkeys.length != 1) {
                    // No legacy BIP32_DERIVATION, assume we're using taproot.
                    pubkey = psbt.getInputKeyDatas(k, (0, $885e12fabfb71081$export$835161b70055ac87).TAP_BIP32_DERIVATION);
                    if (pubkey.length == 0) throw Error(`Missing pubkey derivation for input ${k}`);
                    psbt.setInputTapKeySig(k, v);
                } else {
                    pubkey = pubkeys[0];
                    psbt.setInputPartialSig(k, pubkey, v);
                }
            });
        });
    }
}
/**
 * This function returns a descriptor template based on the address format.
 * See https://github.com/LedgerHQ/app-bitcoin-new/blob/develop/doc/wallet.md for details of
 * the bitcoin descriptor template.
 */ function $9018257154446467$var$descrTemplFrom(addressFormat) {
    if (addressFormat == "legacy") return "pkh(@0)";
    if (addressFormat == "p2sh") return "sh(wpkh(@0))";
    if (addressFormat == "bech32") return "wpkh(@0)";
    if (addressFormat == "bech32m") return "tr(@0)";
    throw new Error("Unsupported address format " + addressFormat);
}
function $9018257154446467$var$accountTypeFromArg(arg, psbt, masterFp) {
    if (arg.additionals.includes("bech32m")) return new (0, $2c7898c006d96858$export$12d04d0fe56ae53)(psbt, masterFp);
    if (arg.additionals.includes("bech32")) return new (0, $2c7898c006d96858$export$5126746498e32b4b)(psbt, masterFp);
    if (arg.segwit) return new (0, $2c7898c006d96858$export$efcc171358cfcc7d)(psbt, masterFp);
    return new (0, $2c7898c006d96858$export$864e513602cf2381)(psbt, masterFp);
}
/*
  The new protocol only allows standard path.
  Standard paths are (currently):
  M/44'/(1|0|88)'/X'
  M/49'/(1|0|88)'/X'
  M/84'/(1|0|88)'/X'
  M/86'/(1|0|88)'/X'
  M/48'/(1|0|88)'/X'/Y'
  followed by "", "(0|1)", or "(0|1)/b", where a and b are
  non-hardened. For example, the following paths are standard
  M/48'/1'/99'/7'
  M/86'/1'/99'/0
  M/48'/0'/99'/7'/1/17
  The following paths are non-standard
  M/48'/0'/99'           // Not deepest hardened path
  M/48'/0'/99'/7'/1/17/2 // Too many non-hardened derivation steps
  M/199'/0'/1'/0/88      // Not a known purpose 199
  M/86'/1'/99'/2         // Change path item must be 0 or 1

  Useful resource on derivation paths: https://learnmeabitcoin.com/technical/derivation-paths
*/ //path is not deepest hardened node of a standard path or deeper, use BtcOld
const $9018257154446467$var$H = 0x80000000; //HARDENED from bip32
const $9018257154446467$var$VALID_COIN_TYPES = [
    0,
    1,
    88
];
const $9018257154446467$var$VALID_SINGLE_SIG_PURPOSES = [
    44,
    49,
    84,
    86
];
const $9018257154446467$var$VALID_MULTISIG_PURPOSES = [
    48
];
const $9018257154446467$var$hard = (n)=>n >= $9018257154446467$var$H;
const $9018257154446467$var$soft = (n)=>n === undefined || n < $9018257154446467$var$H;
const $9018257154446467$var$change = (n)=>n === undefined || n === 0 || n === 1;
const $9018257154446467$var$validCoinPathPartsSet = new Set($9018257154446467$var$VALID_COIN_TYPES.map((t)=>t + $9018257154446467$var$H));
const $9018257154446467$var$validSingleSigPurposePathPartsSet = new Set($9018257154446467$var$VALID_SINGLE_SIG_PURPOSES.map((t)=>t + $9018257154446467$var$H));
const $9018257154446467$var$validMultiSigPurposePathPartsSet = new Set($9018257154446467$var$VALID_MULTISIG_PURPOSES.map((t)=>t + $9018257154446467$var$H));
function $9018257154446467$export$d0edaed3aa4f6f65(path) {
    const pathElems = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
    // Single sig
    if (pathElems.length >= 3 && pathElems.length <= 5 && $9018257154446467$var$validSingleSigPurposePathPartsSet.has(pathElems[0]) && $9018257154446467$var$validCoinPathPartsSet.has(pathElems[1]) && $9018257154446467$var$hard(pathElems[2]) && $9018257154446467$var$change(pathElems[3]) && $9018257154446467$var$soft(pathElems[4])) return true;
    // Multi sig
    if (pathElems.length >= 4 && pathElems.length <= 6 && $9018257154446467$var$validMultiSigPurposePathPartsSet.has(pathElems[0]) && $9018257154446467$var$validCoinPathPartsSet.has(pathElems[1]) && $9018257154446467$var$hard(pathElems[2]) && $9018257154446467$var$hard(pathElems[3]) && $9018257154446467$var$change(pathElems[4]) && $9018257154446467$var$soft(pathElems[5])) return true;
    return false;
}



var $bYkMz = parcelRequire("bYkMz");

var $a8qBR = parcelRequire("a8qBR");

var $5Z1sR = parcelRequire("5Z1sR");



var $3e4a006ddc6c022b$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $3e4a006ddc6c022b$var$addressFormatMap = {
    legacy: 0,
    p2sh: 1,
    bech32: 2,
    cashaddr: 3
};
function $3e4a006ddc6c022b$export$133040f4c0744766(transport, options) {
    return $3e4a006ddc6c022b$var$__awaiter(this, void 0, void 0, function*() {
        const { path: path, verify: verify, format: format } = Object.assign({
            verify: false,
            format: "legacy"
        }, options);
        if (!(format in $3e4a006ddc6c022b$var$addressFormatMap)) throw new Error("btc.getWalletPublicKey invalid format=" + format);
        const buffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
        const p1 = verify ? 1 : 0;
        const p2 = $3e4a006ddc6c022b$var$addressFormatMap[format];
        const response = yield transport.send(0xe0, 0x40, p1, p2, buffer);
        const publicKeyLength = response[0];
        const addressLength = response[1 + publicKeyLength];
        const publicKey = response.slice(1, 1 + publicKeyLength).toString("hex");
        const bitcoinAddress = response.slice(1 + publicKeyLength + 1, 1 + publicKeyLength + 1 + addressLength).toString("ascii");
        const chainCode = response.slice(1 + publicKeyLength + 1 + addressLength, 1 + publicKeyLength + 1 + addressLength + 32).toString("hex");
        return {
            publicKey: publicKey,
            bitcoinAddress: bitcoinAddress,
            chainCode: chainCode
        };
    });
}


var $768901fea8dbe440$exports = {};
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */ "use strict";
/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */ var $768901fea8dbe440$var$invariant = function(condition, format, a, b, c, d, e, f) {
    if (!condition) {
        var error;
        if (format === undefined) error = new Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");
        else {
            var args = [
                a,
                b,
                c,
                d,
                e,
                f
            ];
            var argIndex = 0;
            error = new Error(format.replace(/%s/g, function() {
                return args[argIndex++];
            }));
            error.name = "Invariant Violation";
        }
        error.framesToPop = 1; // we don't care about invariant's own frame
        throw error;
    }
};
$768901fea8dbe440$exports = $768901fea8dbe440$var$invariant;





var $6ZWSX = parcelRequire("6ZWSX");
var $4dc89f53f791a224$require$Buffer = $6ZWSX.Buffer;
var $4dc89f53f791a224$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, transactionData, indexLookup) {
    return $4dc89f53f791a224$var$__awaiter(this, void 0, void 0, function*() {
        let data;
        let firstRound = false;
        if (typeof indexLookup === "number") {
            firstRound = true;
            const prefix = $4dc89f53f791a224$require$Buffer.alloc(4);
            prefix.writeUInt32BE(indexLookup, 0);
            data = $4dc89f53f791a224$require$Buffer.concat([
                prefix,
                transactionData
            ], transactionData.length + 4);
        } else data = transactionData;
        const trustedInput = yield transport.send(0xe0, 0x42, firstRound ? 0x00 : 0x80, 0x00, data);
        const res = trustedInput.slice(0, trustedInput.length - 2).toString("hex");
        return res;
    });
}
function $4dc89f53f791a224$export$31ab969c8a87fc21(transport_1, indexLookup_1, transaction_1) {
    return $4dc89f53f791a224$var$__awaiter(this, arguments, void 0, function*(transport, indexLookup, transaction, additionals = []) {
        const { inputs: inputs, outputs: outputs, locktime: locktime, nExpiryHeight: nExpiryHeight, extraData: extraData } = transaction;
        if (!outputs || !locktime) throw new Error("getTrustedInput: locktime & outputs is expected");
        const isDecred = additionals.includes("decred");
        const processScriptBlocks = (script, sequence)=>$4dc89f53f791a224$var$__awaiter(this, void 0, void 0, function*() {
                const seq = sequence || $4dc89f53f791a224$require$Buffer.alloc(0);
                const scriptBlocks = [];
                let offset = 0;
                while(offset !== script.length){
                    const blockSize = script.length - offset > (0, $543bb618117c682e$export$53184d0ac57d9130) ? (0, $543bb618117c682e$export$53184d0ac57d9130) : script.length - offset;
                    if (offset + blockSize !== script.length) scriptBlocks.push(script.slice(offset, offset + blockSize));
                    else scriptBlocks.push($4dc89f53f791a224$require$Buffer.concat([
                        script.slice(offset, offset + blockSize),
                        seq
                    ]));
                    offset += blockSize;
                }
                // Handle case when no script length: we still want to pass the sequence
                // relatable: https://github.com/LedgerHQ/ledger-live-desktop/issues/1386
                if (script.length === 0) scriptBlocks.push(seq);
                let res;
                for (const scriptBlock of scriptBlocks)res = yield $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, scriptBlock);
                return res;
            });
        const processWholeScriptBlock = (block)=>$4dc89f53f791a224$export$c346d6c04a5f7a55(transport, block);
        yield $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, $4dc89f53f791a224$require$Buffer.concat([
            transaction.version,
            transaction.timestamp || $4dc89f53f791a224$require$Buffer.alloc(0),
            transaction.nVersionGroupId || $4dc89f53f791a224$require$Buffer.alloc(0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(inputs.length)
        ]), indexLookup);
        for (const input of inputs){
            const treeField = isDecred ? input.tree || $4dc89f53f791a224$require$Buffer.from([
                0x00
            ]) : $4dc89f53f791a224$require$Buffer.alloc(0);
            const data = $4dc89f53f791a224$require$Buffer.concat([
                input.prevout,
                treeField,
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length)
            ]);
            yield $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, data);
            // iteration (eachSeries) ended
            // TODO notify progress
            // deferred.notify("input");
            yield isDecred ? processWholeScriptBlock($4dc89f53f791a224$require$Buffer.concat([
                input.script,
                input.sequence
            ])) : processScriptBlocks(input.script, input.sequence);
        }
        yield $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(outputs.length));
        for (const output of outputs){
            const data = $4dc89f53f791a224$require$Buffer.concat([
                output.amount,
                isDecred ? $4dc89f53f791a224$require$Buffer.from([
                    0x00,
                    0x00
                ]) : $4dc89f53f791a224$require$Buffer.alloc(0),
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(output.script.length),
                output.script
            ]);
            yield $4dc89f53f791a224$export$c346d6c04a5f7a55(transport, data);
        }
        const endData = [];
        if (nExpiryHeight && nExpiryHeight.length > 0) endData.push(nExpiryHeight);
        if (extraData && extraData.length > 0) endData.push(extraData);
        let extraPart;
        if (endData.length) {
            const data = $4dc89f53f791a224$require$Buffer.concat(endData);
            extraPart = isDecred ? data : $4dc89f53f791a224$require$Buffer.concat([
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(data.length),
                data
            ]);
        }
        const res = yield processScriptBlocks($4dc89f53f791a224$require$Buffer.concat([
            locktime,
            extraPart || $4dc89f53f791a224$require$Buffer.alloc(0)
        ]));
        (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(res, "missing result in processScriptBlocks");
        return res;
    });
}





var $6ZWSX = parcelRequire("6ZWSX");
var $302fd648d7829cb7$require$Buffer = $6ZWSX.Buffer;
var $302fd648d7829cb7$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, firstRound, transactionData, bip143 = false, overwinter = false, additionals = []) {
    const p2 = additionals.includes("cashaddr") ? 0x03 : bip143 ? additionals.includes("sapling") ? 0x05 : overwinter ? 0x04 : 0x02 : 0x00;
    return transport.send(0xe0, 0x44, firstRound ? 0x00 : 0x80, newTransaction ? p2 : 0x80, transactionData);
}
function $302fd648d7829cb7$export$fe75eaa1344c36c1(transport_1, newTransaction_1, transaction_1, inputs_1) {
    return $302fd648d7829cb7$var$__awaiter(this, arguments, void 0, function*(transport, newTransaction, transaction, inputs, bip143 = false, overwinter = false, additionals = [], useTrustedInputForSegwit = false) {
        let data = $302fd648d7829cb7$require$Buffer.concat([
            transaction.version,
            transaction.timestamp || $302fd648d7829cb7$require$Buffer.alloc(0),
            transaction.nVersionGroupId || $302fd648d7829cb7$require$Buffer.alloc(0),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(transaction.inputs.length)
        ]);
        yield $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, true, data, bip143, overwinter, additionals);
        let i = 0;
        const isDecred = additionals.includes("decred");
        for (const input of transaction.inputs){
            let prefix;
            const inputValue = inputs[i].value;
            if (bip143) {
                if (useTrustedInputForSegwit && inputs[i].trustedInput) prefix = $302fd648d7829cb7$require$Buffer.from([
                    0x01,
                    inputValue.length
                ]);
                else prefix = $302fd648d7829cb7$require$Buffer.from([
                    0x02
                ]);
            } else if (inputs[i].trustedInput) prefix = $302fd648d7829cb7$require$Buffer.from([
                0x01,
                inputs[i].value.length
            ]);
            else prefix = $302fd648d7829cb7$require$Buffer.from([
                0x00
            ]);
            data = $302fd648d7829cb7$require$Buffer.concat([
                prefix,
                inputValue,
                isDecred ? $302fd648d7829cb7$require$Buffer.from([
                    0x00
                ]) : $302fd648d7829cb7$require$Buffer.alloc(0),
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(input.script.length)
            ]);
            yield $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, false, data, bip143, overwinter, additionals);
            const scriptBlocks = [];
            let offset = 0;
            if (input.script.length === 0) scriptBlocks.push(input.sequence);
            else while(offset !== input.script.length){
                const blockSize = input.script.length - offset > (0, $543bb618117c682e$export$53184d0ac57d9130) ? (0, $543bb618117c682e$export$53184d0ac57d9130) : input.script.length - offset;
                if (offset + blockSize !== input.script.length) scriptBlocks.push(input.script.slice(offset, offset + blockSize));
                else scriptBlocks.push($302fd648d7829cb7$require$Buffer.concat([
                    input.script.slice(offset, offset + blockSize),
                    input.sequence
                ]));
                offset += blockSize;
            }
            for (const scriptBlock of scriptBlocks)yield $302fd648d7829cb7$export$a3d2597c2fd4c463(transport, newTransaction, false, scriptBlock, bip143, overwinter, additionals);
            i++;
        }
    });
}




var $5Z1sR = parcelRequire("5Z1sR");


var $6ZWSX = parcelRequire("6ZWSX");
var $a0f3645f2f32a0c2$require$Buffer = $6ZWSX.Buffer;
function $a0f3645f2f32a0c2$export$33b7242117f697d5(transport, indexLookup, transaction, additionals = []) {
    if (!transaction) throw new Error("getTrustedInputBIP143: missing tx");
    const isDecred = additionals.includes("decred");
    if (isDecred) throw new Error("Decred does not implement BIP143");
    let hash = (0, (/*@__PURE__*/$parcel$interopDefault($5Z1sR)))("sha256").update((0, (/*@__PURE__*/$parcel$interopDefault($5Z1sR)))("sha256").update((0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(transaction, true)).digest()).digest();
    const data = $a0f3645f2f32a0c2$require$Buffer.alloc(4);
    data.writeUInt32LE(indexLookup, 0);
    const { outputs: outputs, locktime: locktime } = transaction;
    if (!outputs || !locktime) throw new Error("getTrustedInputBIP143: locktime & outputs is expected");
    if (!outputs[indexLookup]) throw new Error("getTrustedInputBIP143: wrong index");
    hash = $a0f3645f2f32a0c2$require$Buffer.concat([
        hash,
        data,
        outputs[indexLookup].amount
    ]);
    return hash.toString("hex");
}



var $6ZWSX = parcelRequire("6ZWSX");
var $7296dcc957b19d57$require$Buffer = $6ZWSX.Buffer;
function $7296dcc957b19d57$export$a490116043767aa7(publicKey) {
    const prefix = (publicKey[64] & 1) !== 0 ? 0x03 : 0x02;
    const prefixBuffer = $7296dcc957b19d57$require$Buffer.alloc(1);
    prefixBuffer[0] = prefix;
    return $7296dcc957b19d57$require$Buffer.concat([
        prefixBuffer,
        publicKey.slice(1, 33)
    ]);
}




var $6ZWSX = parcelRequire("6ZWSX");
var $945283aa22a61c46$require$Buffer = $6ZWSX.Buffer;
function $945283aa22a61c46$export$6ad02cc4966b42ab(transport, path, lockTime, sigHashType, expiryHeight, additionals = []) {
    const isDecred = additionals.includes("decred");
    const pathsBuffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
    const lockTimeBuffer = $945283aa22a61c46$require$Buffer.alloc(4);
    lockTimeBuffer.writeUInt32BE(lockTime, 0);
    let buffer = isDecred ? $945283aa22a61c46$require$Buffer.concat([
        pathsBuffer,
        lockTimeBuffer,
        expiryHeight || $945283aa22a61c46$require$Buffer.from([
            0x00,
            0x00,
            0x00,
            0x00
        ]),
        $945283aa22a61c46$require$Buffer.from([
            sigHashType
        ])
    ]) : $945283aa22a61c46$require$Buffer.concat([
        pathsBuffer,
        $945283aa22a61c46$require$Buffer.from([
            0x00
        ]),
        lockTimeBuffer,
        $945283aa22a61c46$require$Buffer.from([
            sigHashType
        ])
    ]);
    if (expiryHeight && !isDecred) buffer = $945283aa22a61c46$require$Buffer.concat([
        buffer,
        expiryHeight
    ]);
    return transport.send(0xe0, 0x48, 0x00, 0x00, buffer).then((result)=>{
        if (result.length > 0) {
            result[0] = 0x30;
            return result.slice(0, result.length - 2);
        }
        return result;
    });
}




var $dc30479c38246bb0$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $dc30479c38246bb0$export$8f0374b05305ecf2(transport, path) {
    const buffer = (0, $76d975e72423660e$export$dae4da1c913eeebb)(path);
    return transport.send(0xe0, 0x4a, 0xff, 0x00, buffer);
}
function $dc30479c38246bb0$export$34dd66230370b398(transport_1, outputScript_1) {
    return $dc30479c38246bb0$var$__awaiter(this, arguments, void 0, function*(transport, outputScript, additionals = []) {
        let offset = 0;
        const p1 = Number(0x80);
        const isDecred = additionals.includes("decred");
        ///WARNING: Decred works only with one call (without chunking)
        //TODO: test without this for Decred
        if (isDecred) return transport.send(0xe0, 0x4a, p1, 0x00, outputScript);
        while(offset < outputScript.length){
            const blockSize = offset + (0, $543bb618117c682e$export$53184d0ac57d9130) >= outputScript.length ? outputScript.length - offset : (0, $543bb618117c682e$export$53184d0ac57d9130);
            const p1 = offset + blockSize === outputScript.length ? 0x80 : 0x00;
            const data = outputScript.slice(offset, offset + blockSize);
            yield transport.send(0xe0, 0x4a, p1, 0x00, data);
            offset += blockSize;
        }
    });
}



var $300a11e70dc240cc$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $300a11e70dc240cc$export$bd21f07fb59bc20d = (transport)=>$300a11e70dc240cc$var$__awaiter(void 0, void 0, void 0, function*() {
        const r = yield transport.send(0xb0, 0x01, 0x00, 0x00);
        let i = 0;
        const format = r[i++];
        (0, (/*@__PURE__*/$parcel$interopDefault($768901fea8dbe440$exports)))(format === 1, "getAppAndVersion: format not supported");
        const nameLength = r[i++];
        const name = r.slice(i, i += nameLength).toString("ascii");
        const versionLength = r[i++];
        const version = r.slice(i, i += versionLength).toString("ascii");
        const flagLength = r[i++];
        const flags = r.slice(i, i += flagLength);
        return {
            name: name,
            version: version,
            flags: flags
        };
    });
const $300a11e70dc240cc$export$33e1ebd1430bed57 = (transport)=>$300a11e70dc240cc$var$__awaiter(void 0, void 0, void 0, function*() {
        try {
            // Call old btc API, it will throw an exception with new btc app. It is a workaround to differentiate new/old btc nano app
            yield transport.send(0xe0, 0xc4, 0, 0);
        } catch (e) {
            return false;
        }
        return true;
    });




function $fdf918935fee5100$export$f21853333aa2ecd1({ version: version, name: name }) {
    if (name === "Decred") return false;
    if (name === "Exchange") return true;
    return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).gte(version, "1.4.0");
}



var $6ZWSX = parcelRequire("6ZWSX");
var $416d57361974f34a$require$Buffer = $6ZWSX.Buffer;
var $416d57361974f34a$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $416d57361974f34a$var$defaultsSignTransaction = {
    lockTime: (0, $543bb618117c682e$export$7e0b52e7059ffec7),
    sigHashType: (0, $543bb618117c682e$export$f53d15270899011f),
    segwit: false,
    additionals: [],
    onDeviceStreaming: (_e)=>{},
    onDeviceSignatureGranted: ()=>{},
    onDeviceSignatureRequested: ()=>{}
};
function $416d57361974f34a$export$714aebfec8ead7f0(transport, arg) {
    return $416d57361974f34a$var$__awaiter(this, void 0, void 0, function*() {
        const signTx = Object.assign(Object.assign({}, $416d57361974f34a$var$defaultsSignTransaction), arg);
        const { inputs: inputs, associatedKeysets: associatedKeysets, changePath: changePath, outputScriptHex: outputScriptHex, lockTime: lockTime, sigHashType: sigHashType, segwit: segwit, additionals: additionals, expiryHeight: expiryHeight, onDeviceStreaming: onDeviceStreaming, onDeviceSignatureGranted: onDeviceSignatureGranted, onDeviceSignatureRequested: onDeviceSignatureRequested } = signTx;
        let useTrustedInputForSegwit = signTx.useTrustedInputForSegwit;
        if (useTrustedInputForSegwit === undefined) try {
            const a = yield (0, $300a11e70dc240cc$export$bd21f07fb59bc20d)(transport);
            useTrustedInputForSegwit = (0, $fdf918935fee5100$export$f21853333aa2ecd1)(a);
        } catch (e) {
            if (e.statusCode === 0x6d00) useTrustedInputForSegwit = false;
            else throw e;
        }
        // loop: 0 or 1 (before and after)
        // i: index of the input being streamed
        // i goes on 0...n, inluding n. in order for the progress value to go to 1
        // we normalize the 2 loops to make a global percentage
        const notify = (loop, i)=>{
            const { length: length } = inputs;
            if (length < 3) return; // there is not enough significant event to worth notifying (aka just use a spinner)
            const index = length * loop + i;
            const total = 2 * length;
            const progress = index / total;
            onDeviceStreaming({
                progress: progress,
                total: total,
                index: index
            });
        };
        const isDecred = additionals.includes("decred");
        const isZcash = additionals.includes("zcash");
        const sapling = additionals.includes("sapling");
        const bech32 = segwit && additionals.includes("bech32");
        const useBip143 = segwit || !!additionals && (additionals.includes("abc") || additionals.includes("gold") || additionals.includes("bip143")) || !!expiryHeight && !isDecred;
        // Inputs are provided as arrays of [transaction, output_index, optional redeem script, optional sequence]
        // associatedKeysets are provided as arrays of [path]
        const lockTimeBuffer = $416d57361974f34a$require$Buffer.alloc(4);
        lockTimeBuffer.writeUInt32LE(lockTime, 0);
        const nullScript = $416d57361974f34a$require$Buffer.alloc(0);
        const nullPrevout = $416d57361974f34a$require$Buffer.alloc(0);
        const defaultVersion = $416d57361974f34a$require$Buffer.alloc(4);
        !!expiryHeight && !isDecred ? defaultVersion.writeUInt32LE(isZcash ? 0x80000005 : sapling ? 0x80000004 : 0x80000003, 0) // v5 format for zcash refer to https://zips.z.cash/zip-0225
         : defaultVersion.writeUInt32LE(1, 0);
        // Default version to 2 for XST not to have timestamp
        const trustedInputs = [];
        const regularOutputs = [];
        const signatures = [];
        const publicKeys = [];
        let firstRun = true;
        const resuming = false;
        const targetTransaction = {
            inputs: [],
            version: defaultVersion,
            timestamp: $416d57361974f34a$require$Buffer.alloc(0)
        };
        const getTrustedInputCall = useBip143 && !useTrustedInputForSegwit ? (0, $a0f3645f2f32a0c2$export$33b7242117f697d5) : (0, $4dc89f53f791a224$export$31ab969c8a87fc21);
        const outputScript = $416d57361974f34a$require$Buffer.from(outputScriptHex, "hex");
        notify(0, 0);
        // first pass on inputs to get trusted inputs
        for (const input of inputs){
            if (!resuming) {
                const trustedInput = yield getTrustedInputCall(transport, input[1], input[0], additionals);
                (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("hw", "got trustedInput=" + trustedInput);
                const sequence = $416d57361974f34a$require$Buffer.alloc(4);
                sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
                trustedInputs.push({
                    trustedInput: true,
                    value: $416d57361974f34a$require$Buffer.from(trustedInput, "hex"),
                    sequence: sequence
                });
            }
            const { outputs: outputs } = input[0];
            const index = input[1];
            if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
            if (expiryHeight && !isDecred) {
                targetTransaction.nVersionGroupId = $416d57361974f34a$require$Buffer.from(// nVersionGroupId is 0x26A7270A for zcash NU5 upgrade
                // refer to https://github.com/zcash/zcash/blob/master/src/primitives/transaction.h
                isZcash ? [
                    0x0a,
                    0x27,
                    0xa7,
                    0x26
                ] : sapling ? [
                    0x85,
                    0x20,
                    0x2f,
                    0x89
                ] : [
                    0x70,
                    0x82,
                    0xc4,
                    0x03
                ]);
                targetTransaction.nExpiryHeight = expiryHeight;
                // For sapling : valueBalance (8), nShieldedSpend (1), nShieldedOutput (1), nJoinSplit (1)
                // Overwinter : use nJoinSplit (1)
                targetTransaction.extraData = $416d57361974f34a$require$Buffer.from(sapling ? [
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00,
                    0x00
                ] : [
                    0x00
                ]);
            } else if (isDecred) targetTransaction.nExpiryHeight = expiryHeight;
        }
        targetTransaction.inputs = inputs.map((input, idx)=>{
            const sequence = $416d57361974f34a$require$Buffer.alloc(4);
            sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
            return {
                script: isZcash ? regularOutputs[idx].script : nullScript,
                prevout: nullPrevout,
                sequence: sequence
            };
        });
        if (!resuming) {
            // Collect public keys
            const result = [];
            for(let i = 0; i < inputs.length; i++){
                const r = yield (0, $3e4a006ddc6c022b$export$133040f4c0744766)(transport, {
                    path: associatedKeysets[i]
                });
                notify(0, i + 1);
                result.push(r);
            }
            for(let i = 0; i < result.length; i++)publicKeys.push((0, $7296dcc957b19d57$export$a490116043767aa7)($416d57361974f34a$require$Buffer.from(result[i].publicKey, "hex")));
        }
        onDeviceSignatureRequested();
        if (useBip143) {
            // Do the first run with all inputs
            yield (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true, !!expiryHeight, additionals, useTrustedInputForSegwit);
            if (!resuming && changePath) yield (0, $dc30479c38246bb0$export$8f0374b05305ecf2)(transport, changePath);
            yield (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
        }
        if (!!expiryHeight && !isDecred) yield (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, "", lockTime, (0, $543bb618117c682e$export$f53d15270899011f), expiryHeight);
        // Do the second run with the individual transaction
        for(let i = 0; i < inputs.length; i++){
            const input = inputs[i];
            const script = inputs[i].length >= 3 && typeof input[2] === "string" ? $416d57361974f34a$require$Buffer.from(input[2], "hex") : !segwit ? regularOutputs[i].script : $416d57361974f34a$require$Buffer.concat([
                $416d57361974f34a$require$Buffer.from([
                    (0, $543bb618117c682e$export$df6efc3aa949001c),
                    (0, $543bb618117c682e$export$25244e17dfd6169b),
                    (0, $543bb618117c682e$export$259fba643ee77695)
                ]),
                (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(publicKeys[i]),
                $416d57361974f34a$require$Buffer.from([
                    (0, $543bb618117c682e$export$f8b5c605020bd49c),
                    (0, $543bb618117c682e$export$dc70dbf3545af7b7)
                ])
            ]);
            const pseudoTX = Object.assign({}, targetTransaction);
            const pseudoTrustedInputs = useBip143 ? [
                trustedInputs[i]
            ] : trustedInputs;
            if (useBip143) pseudoTX.inputs = [
                Object.assign(Object.assign({}, pseudoTX.inputs[i]), {
                    script: script
                })
            ];
            else pseudoTX.inputs[i].script = script;
            yield (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, !useBip143 && firstRun, pseudoTX, pseudoTrustedInputs, useBip143, !!expiryHeight && !isDecred, additionals, useTrustedInputForSegwit);
            if (!useBip143) {
                if (!resuming && changePath) yield (0, $dc30479c38246bb0$export$8f0374b05305ecf2)(transport, changePath);
                yield (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript, additionals);
            }
            if (firstRun) {
                onDeviceSignatureGranted();
                notify(1, 0);
            }
            const signature = yield (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, associatedKeysets[i], lockTime, sigHashType, expiryHeight, additionals);
            notify(1, i + 1);
            signatures.push(signature);
            targetTransaction.inputs[i].script = nullScript;
            if (firstRun) firstRun = false;
        }
        // Populate the final input scripts
        for(let i = 0; i < inputs.length; i++){
            if (segwit) {
                targetTransaction.witness = $416d57361974f34a$require$Buffer.alloc(0);
                if (!bech32) targetTransaction.inputs[i].script = $416d57361974f34a$require$Buffer.concat([
                    $416d57361974f34a$require$Buffer.from("160014", "hex"),
                    (0, $ed0dd9fccba6448b$export$4f1687fa25e5df17)(publicKeys[i])
                ]);
            } else {
                const signatureSize = $416d57361974f34a$require$Buffer.alloc(1);
                const keySize = $416d57361974f34a$require$Buffer.alloc(1);
                signatureSize[0] = signatures[i].length;
                keySize[0] = publicKeys[i].length;
                targetTransaction.inputs[i].script = $416d57361974f34a$require$Buffer.concat([
                    signatureSize,
                    signatures[i],
                    keySize,
                    publicKeys[i]
                ]);
            }
            const offset = useBip143 && !useTrustedInputForSegwit ? 0 : 4;
            targetTransaction.inputs[i].prevout = trustedInputs[i].value.slice(offset, offset + 0x24);
        }
        targetTransaction.locktime = lockTimeBuffer;
        let result = $416d57361974f34a$require$Buffer.concat([
            (0, $6f5c2f66f4ecb3fe$export$7cb44e9a321cd996)(targetTransaction, false, targetTransaction.timestamp, additionals),
            outputScript
        ]);
        if (segwit && !isDecred) {
            let witness = $416d57361974f34a$require$Buffer.alloc(0);
            for(let i = 0; i < inputs.length; i++){
                const tmpScriptData = $416d57361974f34a$require$Buffer.concat([
                    $416d57361974f34a$require$Buffer.from("02", "hex"),
                    $416d57361974f34a$require$Buffer.from([
                        signatures[i].length
                    ]),
                    signatures[i],
                    $416d57361974f34a$require$Buffer.from([
                        publicKeys[i].length
                    ]),
                    publicKeys[i]
                ]);
                witness = $416d57361974f34a$require$Buffer.concat([
                    witness,
                    tmpScriptData
                ]);
            }
            result = $416d57361974f34a$require$Buffer.concat([
                result,
                witness
            ]);
        }
        // from to https://zips.z.cash/zip-0225, zcash is different with other coins, the lock_time and nExpiryHeight fields are before the inputs and outputs
        if (!isZcash) {
            result = $416d57361974f34a$require$Buffer.concat([
                result,
                lockTimeBuffer
            ]);
            if (expiryHeight) result = $416d57361974f34a$require$Buffer.concat([
                result,
                targetTransaction.nExpiryHeight || $416d57361974f34a$require$Buffer.alloc(0),
                targetTransaction.extraData || $416d57361974f34a$require$Buffer.alloc(0)
            ]);
        }
        if (isDecred) {
            let decredWitness = $416d57361974f34a$require$Buffer.from([
                targetTransaction.inputs.length
            ]);
            inputs.forEach((input, inputIndex)=>{
                decredWitness = $416d57361974f34a$require$Buffer.concat([
                    decredWitness,
                    $416d57361974f34a$require$Buffer.from([
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00,
                        0x00
                    ]),
                    $416d57361974f34a$require$Buffer.from([
                        0x00,
                        0x00,
                        0x00,
                        0x00
                    ]),
                    $416d57361974f34a$require$Buffer.from([
                        0xff,
                        0xff,
                        0xff,
                        0xff
                    ]),
                    $416d57361974f34a$require$Buffer.from([
                        targetTransaction.inputs[inputIndex].script.length
                    ]),
                    targetTransaction.inputs[inputIndex].script
                ]);
            });
            result = $416d57361974f34a$require$Buffer.concat([
                result,
                decredWitness
            ]);
        }
        if (isZcash) result = $416d57361974f34a$require$Buffer.concat([
            result,
            $416d57361974f34a$require$Buffer.from([
                0x00,
                0x00,
                0x00
            ])
        ]);
        return result.toString("hex");
    });
}





var $4c5Uh = parcelRequire("4c5Uh");


var $6ZWSX = parcelRequire("6ZWSX");
var $300b1418bc632b61$require$Buffer = $6ZWSX.Buffer;
var $300b1418bc632b61$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
function $300b1418bc632b61$export$1d9a7a8a40780de(transport_1, _a) {
    return $300b1418bc632b61$var$__awaiter(this, arguments, void 0, function*(transport, { path: path, messageHex: messageHex }) {
        const paths = (0, (/*@__PURE__*/$parcel$interopDefault($4c5Uh))).fromString(path).toPathArray();
        const message = $300b1418bc632b61$require$Buffer.from(messageHex, "hex");
        let offset = 0;
        while(offset !== message.length){
            const maxChunkSize = offset === 0 ? (0, $543bb618117c682e$export$53184d0ac57d9130) - 1 - paths.length * 4 - 4 : (0, $543bb618117c682e$export$53184d0ac57d9130);
            const chunkSize = offset + maxChunkSize > message.length ? message.length - offset : maxChunkSize;
            const buffer = $300b1418bc632b61$require$Buffer.alloc(offset === 0 ? 1 + paths.length * 4 + 2 + chunkSize : chunkSize);
            if (offset === 0) {
                buffer[0] = paths.length;
                paths.forEach((element, index)=>{
                    buffer.writeUInt32BE(element, 1 + 4 * index);
                });
                buffer.writeUInt16BE(message.length, 1 + 4 * paths.length);
                message.copy(buffer, 1 + 4 * paths.length + 2, offset, offset + chunkSize);
            } else message.copy(buffer, 0, offset, offset + chunkSize);
            yield transport.send(0xe0, 0x4e, 0x00, offset === 0 ? 0x01 : 0x80, buffer);
            offset += chunkSize;
        }
        const res = yield transport.send(0xe0, 0x4e, 0x80, 0x00, $300b1418bc632b61$require$Buffer.from([
            0x00
        ]));
        const v = res[0] - 0x30;
        let r = res.slice(4, 4 + res[3]);
        if (r[0] === 0) r = r.slice(1);
        r = r.toString("hex");
        offset = 4 + res[3] + 2;
        let s = res.slice(offset, offset + res[offset - 1]);
        if (s[0] === 0) s = s.slice(1);
        s = s.toString("hex");
        return {
            v: v,
            r: r,
            s: s
        };
    });
}



var $6ZWSX = parcelRequire("6ZWSX");
var $86e871bb8fe485c6$require$Buffer = $6ZWSX.Buffer;
var $86e871bb8fe485c6$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $86e871bb8fe485c6$export$2e2bcd8739ae039 {
    constructor(transport){
        this.transport = transport;
        this.derivationsCache = {};
    }
    derivatePath(path) {
        return $86e871bb8fe485c6$var$__awaiter(this, void 0, void 0, function*() {
            if (this.derivationsCache[path]) return this.derivationsCache[path];
            const res = yield (0, $3e4a006ddc6c022b$export$133040f4c0744766)(this.transport, {
                path: path
            });
            this.derivationsCache[path] = res;
            return res;
        });
    }
    getWalletXpub(_a) {
        return $86e871bb8fe485c6$var$__awaiter(this, arguments, void 0, function*({ path: path, xpubVersion: xpubVersion }) {
            const pathElements = (0, $76d975e72423660e$export$35caeff6b64c2b35)(path);
            const parentPath = pathElements.slice(0, -1);
            const parentDerivation = yield this.derivatePath((0, $76d975e72423660e$export$6e27cd76987a4ce2)(parentPath));
            const accountDerivation = yield this.derivatePath(path);
            const fingerprint = $86e871bb8fe485c6$var$makeFingerprint($86e871bb8fe485c6$var$compressPublicKeySECP256($86e871bb8fe485c6$require$Buffer.from(parentDerivation.publicKey, "hex")));
            const xpub = $86e871bb8fe485c6$var$makeXpub(xpubVersion, pathElements.length, fingerprint, pathElements[pathElements.length - 1], $86e871bb8fe485c6$require$Buffer.from(accountDerivation.chainCode, "hex"), $86e871bb8fe485c6$var$compressPublicKeySECP256($86e871bb8fe485c6$require$Buffer.from(accountDerivation.publicKey, "hex")));
            return xpub;
        });
    }
    /**
     * @param path a BIP 32 path
     * @param options an object with optional these fields:
     *
     * - verify (boolean) will ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ getWalletPublicKey(path, opts) {
        if ((opts === null || opts === void 0 ? void 0 : opts.format) === "bech32m") throw new Error("Unsupported address format bech32m");
        return (0, $3e4a006ddc6c022b$export$133040f4c0744766)(this.transport, Object.assign(Object.assign({}, opts), {
            path: path
        }));
    }
    /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ createPaymentTransaction(arg) {
        if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
        return (0, $416d57361974f34a$export$714aebfec8ead7f0)(this.transport, arg);
    }
    signMessage(_a) {
        return $86e871bb8fe485c6$var$__awaiter(this, arguments, void 0, function*({ path: path, messageHex: messageHex }) {
            return (0, $300b1418bc632b61$export$1d9a7a8a40780de)(this.transport, {
                path: path,
                messageHex: messageHex
            });
        });
    }
}
function $86e871bb8fe485c6$var$makeFingerprint(compressedPubKey) {
    return $86e871bb8fe485c6$var$hash160(compressedPubKey).slice(0, 4);
}
function $86e871bb8fe485c6$var$asBufferUInt32BE(n) {
    const buf = $86e871bb8fe485c6$require$Buffer.allocUnsafe(4);
    buf.writeUInt32BE(n, 0);
    return buf;
}
const $86e871bb8fe485c6$var$compressPublicKeySECP256 = (publicKey)=>$86e871bb8fe485c6$require$Buffer.concat([
        $86e871bb8fe485c6$require$Buffer.from([
            0x02 + (publicKey[64] & 0x01)
        ]),
        publicKey.slice(1, 33)
    ]);
function $86e871bb8fe485c6$var$makeXpub(version, depth, parentFingerprint, index, chainCode, pubKey) {
    const indexBuffer = $86e871bb8fe485c6$var$asBufferUInt32BE(index);
    indexBuffer[0] |= 0x80;
    const extendedKeyBytes = $86e871bb8fe485c6$require$Buffer.concat([
        $86e871bb8fe485c6$var$asBufferUInt32BE(version),
        $86e871bb8fe485c6$require$Buffer.from([
            depth
        ]),
        parentFingerprint,
        indexBuffer,
        chainCode,
        pubKey
    ]);
    const checksum = $86e871bb8fe485c6$var$hash256(extendedKeyBytes).slice(0, 4);
    return (0, (/*@__PURE__*/$parcel$interopDefault($bYkMz))).encode($86e871bb8fe485c6$require$Buffer.concat([
        extendedKeyBytes,
        checksum
    ]));
}
function $86e871bb8fe485c6$var$sha256(buffer) {
    return (0, (/*@__PURE__*/$parcel$interopDefault($5Z1sR)))("sha256").update(buffer).digest();
}
function $86e871bb8fe485c6$var$hash256(buffer) {
    return $86e871bb8fe485c6$var$sha256($86e871bb8fe485c6$var$sha256(buffer));
}
function $86e871bb8fe485c6$var$ripemd160(buffer) {
    return new (0, (/*@__PURE__*/$parcel$interopDefault($a8qBR)))().update(buffer).digest();
}
function $86e871bb8fe485c6$var$hash160(buffer) {
    return $86e871bb8fe485c6$var$ripemd160($86e871bb8fe485c6$var$sha256(buffer));
}








var $6ZWSX = parcelRequire("6ZWSX");
var $c053b574be68d1d1$require$Buffer = $6ZWSX.Buffer;
class $c053b574be68d1d1$export$6333c118d63c57fc {
    /**
     * @param keys Sorted list of (unhashed) keys
     * @param values values, in corresponding order as the keys, and of equal length
     */ constructor(keys, values){
        if (keys.length != values.length) throw new Error("keys and values should have the same length");
        // Sanity check: verify that keys are actually sorted and with no duplicates
        for(let i = 0; i < keys.length - 1; i++){
            if (keys[i].toString("hex") >= keys[i + 1].toString("hex")) throw new Error("keys must be in strictly increasing order");
        }
        this.keys = keys;
        this.keysTree = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(keys.map((k)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(k)));
        this.values = values;
        this.valuesTree = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(values.map((v)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(v)));
    }
    commitment() {
        // returns a buffer between 65 and 73 (included) bytes long
        return $c053b574be68d1d1$require$Buffer.concat([
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(this.keys.length),
            this.keysTree.getRoot(),
            this.valuesTree.getRoot()
        ]);
    }
}




var $6ZWSX = parcelRequire("6ZWSX");
var $ffbadfabc2a8c4e6$require$Buffer = $6ZWSX.Buffer;
class $ffbadfabc2a8c4e6$export$6138aa48176e3ed2 extends (0, $885e12fabfb71081$export$df421e92e1e77f5) {
    constructor(psbt){
        super();
        this.inputMerkleMaps = [];
        this.outputMerkleMaps = [];
        psbt.copy(this);
        this.globalMerkleMap = $ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.globalMap);
        for(let i = 0; i < this.getGlobalInputCount(); i++)this.inputMerkleMaps.push($ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.inputMaps[i]));
        this.inputMapCommitments = [
            ...this.inputMerkleMaps.values()
        ].map((v)=>v.commitment());
        for(let i = 0; i < this.getGlobalOutputCount(); i++)this.outputMerkleMaps.push($ffbadfabc2a8c4e6$export$6138aa48176e3ed2.createMerkleMap(this.outputMaps[i]));
        this.outputMapCommitments = [
            ...this.outputMerkleMaps.values()
        ].map((v)=>v.commitment());
    }
    // These public functions are for MerkelizedPsbt.
    getGlobalSize() {
        return this.globalMap.size;
    }
    getGlobalKeysValuesRoot() {
        return this.globalMerkleMap.commitment();
    }
    static createMerkleMap(map) {
        const sortedKeysStrings = [
            ...map.keys()
        ].sort();
        const values = sortedKeysStrings.map((k)=>{
            const v = map.get(k);
            if (!v) throw new Error("No value for key " + k);
            return v;
        });
        const sortedKeys = sortedKeysStrings.map((k)=>$ffbadfabc2a8c4e6$require$Buffer.from(k, "hex"));
        const merkleMap = new (0, $c053b574be68d1d1$export$6333c118d63c57fc)(sortedKeys, values);
        return merkleMap;
    }
}







var $6ZWSX = parcelRequire("6ZWSX");
var $ef9a712c06b7320f$require$Buffer = $6ZWSX.Buffer;
var $ef9a712c06b7320f$var$ClientCommandCode;
(function(ClientCommandCode) {
    ClientCommandCode[ClientCommandCode["YIELD"] = 16] = "YIELD";
    ClientCommandCode[ClientCommandCode["GET_PREIMAGE"] = 64] = "GET_PREIMAGE";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_PROOF"] = 65] = "GET_MERKLE_LEAF_PROOF";
    ClientCommandCode[ClientCommandCode["GET_MERKLE_LEAF_INDEX"] = 66] = "GET_MERKLE_LEAF_INDEX";
    ClientCommandCode[ClientCommandCode["GET_MORE_ELEMENTS"] = 160] = "GET_MORE_ELEMENTS";
})($ef9a712c06b7320f$var$ClientCommandCode || ($ef9a712c06b7320f$var$ClientCommandCode = {}));
class $ef9a712c06b7320f$var$ClientCommand {
}
class $ef9a712c06b7320f$export$6cdc18cd411866ae extends $ef9a712c06b7320f$var$ClientCommand {
    constructor(results, progressCallback){
        super();
        this.progressCallback = progressCallback;
        this.code = $ef9a712c06b7320f$var$ClientCommandCode.YIELD;
        this.results = results;
    }
    execute(request) {
        this.results.push($ef9a712c06b7320f$require$Buffer.from(request.subarray(1)));
        this.progressCallback();
        return $ef9a712c06b7320f$require$Buffer.from("");
    }
}
class $ef9a712c06b7320f$export$be0d4b5d2e5a3c27 extends $ef9a712c06b7320f$var$ClientCommand {
    constructor(known_preimages, queue){
        super();
        this.code = $ef9a712c06b7320f$var$ClientCommandCode.GET_PREIMAGE;
        this.known_preimages = known_preimages;
        this.queue = queue;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        // we expect no more data to read
        if (req.length != 33) throw new Error("Invalid request, unexpected trailing data");
        if (req[0] != 0) throw new Error("Unsupported request, the first byte should be 0");
        // read the hash
        const hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)hash[i] = req[1 + i];
        const req_hash_hex = hash.toString("hex");
        const known_preimage = this.known_preimages.get(req_hash_hex);
        if (known_preimage != undefined) {
            const preimage_len_varint = (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(known_preimage.length);
            // We can send at most 255 - len(preimage_len_out) - 1 bytes in a single message;
            // the rest will be stored in the queue for GET_MORE_ELEMENTS
            const max_payload_size = 255 - preimage_len_varint.length - 1;
            const payload_size = Math.min(max_payload_size, known_preimage.length);
            if (payload_size < known_preimage.length) for(let i = payload_size; i < known_preimage.length; i++)this.queue.push($ef9a712c06b7320f$require$Buffer.from([
                known_preimage[i]
            ]));
            return $ef9a712c06b7320f$require$Buffer.concat([
                preimage_len_varint,
                $ef9a712c06b7320f$require$Buffer.from([
                    payload_size
                ]),
                $ef9a712c06b7320f$require$Buffer.from(known_preimage.subarray(0, payload_size))
            ]);
        }
        throw Error(`Requested unknown preimage for: ${req_hash_hex}`);
    }
}
class $ef9a712c06b7320f$export$a5a8e1b007cbff9d extends $ef9a712c06b7320f$var$ClientCommand {
    constructor(known_trees, queue){
        super();
        this.code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MERKLE_LEAF_PROOF;
        this.known_trees = known_trees;
        this.queue = queue;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        if (req.length < 34) throw new Error("Invalid request, expected at least 34 bytes");
        const reqBuf = new (0, $036f9e277d3889a8$export$bd4917b7431e3e00)(req);
        const hash = reqBuf.readSlice(32);
        const hash_hex = hash.toString("hex");
        let tree_size;
        let leaf_index;
        try {
            tree_size = reqBuf.readVarInt();
            leaf_index = reqBuf.readVarInt();
        } catch (e) {
            throw new Error("Invalid request, couldn't parse tree_size or leaf_index");
        }
        const mt = this.known_trees.get(hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf proof for unknown tree: ${hash_hex}`);
        if (leaf_index >= tree_size || mt.size() != tree_size) throw Error("Invalid index or tree size.");
        if (this.queue.length != 0) throw Error("This command should not execute when the queue is not empty.");
        const proof = mt.getProof(leaf_index);
        const n_response_elements = Math.min(Math.floor(6.90625), proof.length);
        const n_leftover_elements = proof.length - n_response_elements;
        // Add to the queue any proof elements that do not fit the response
        if (n_leftover_elements > 0) this.queue.push(...proof.slice(-n_leftover_elements));
        return $ef9a712c06b7320f$require$Buffer.concat([
            mt.getLeafHash(leaf_index),
            $ef9a712c06b7320f$require$Buffer.from([
                proof.length
            ]),
            $ef9a712c06b7320f$require$Buffer.from([
                n_response_elements
            ]),
            ...proof.slice(0, n_response_elements)
        ]);
    }
}
class $ef9a712c06b7320f$export$9e6812ae409a7928 extends $ef9a712c06b7320f$var$ClientCommand {
    constructor(known_trees){
        super();
        this.code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MERKLE_LEAF_INDEX;
        this.known_trees = known_trees;
    }
    execute(request) {
        const req = $ef9a712c06b7320f$require$Buffer.from(request.subarray(1));
        if (req.length != 64) throw new Error("Invalid request, unexpected trailing data");
        // read the root hash
        const root_hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)root_hash[i] = req.readUInt8(i);
        const root_hash_hex = root_hash.toString("hex");
        // read the leaf hash
        const leef_hash = $ef9a712c06b7320f$require$Buffer.alloc(32);
        for(let i = 0; i < 32; i++)leef_hash[i] = req.readUInt8(32 + i);
        const leef_hash_hex = leef_hash.toString("hex");
        const mt = this.known_trees.get(root_hash_hex);
        if (!mt) throw Error(`Requested Merkle leaf index for unknown root: ${root_hash_hex}`);
        let leaf_index = 0;
        let found = 0;
        for(let i = 0; i < mt.size(); i++)if (mt.getLeafHash(i).toString("hex") == leef_hash_hex) {
            found = 1;
            leaf_index = i;
            break;
        }
        return $ef9a712c06b7320f$require$Buffer.concat([
            $ef9a712c06b7320f$require$Buffer.from([
                found
            ]),
            (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(leaf_index)
        ]);
    }
}
class $ef9a712c06b7320f$export$947bca8282126547 extends $ef9a712c06b7320f$var$ClientCommand {
    constructor(queue){
        super();
        this.code = $ef9a712c06b7320f$var$ClientCommandCode.GET_MORE_ELEMENTS;
        this.queue = queue;
    }
    execute(request) {
        if (request.length != 1) throw new Error("Invalid request, unexpected trailing data");
        if (this.queue.length === 0) throw new Error("No elements to get");
        // all elements should have the same length
        const element_len = this.queue[0].length;
        if (this.queue.some((el)=>el.length != element_len)) throw new Error("The queue contains elements with different byte length, which is not expected");
        const max_elements = Math.floor(253 / element_len);
        const n_returned_elements = Math.min(max_elements, this.queue.length);
        const returned_elements = this.queue.splice(0, n_returned_elements);
        return $ef9a712c06b7320f$require$Buffer.concat([
            $ef9a712c06b7320f$require$Buffer.from([
                n_returned_elements
            ]),
            $ef9a712c06b7320f$require$Buffer.from([
                element_len
            ]),
            ...returned_elements
        ]);
    }
}
class $ef9a712c06b7320f$export$be0ded693afdcf85 {
    constructor(progressCallback){
        this.roots = new Map();
        this.preimages = new Map();
        this.yielded = [];
        this.queue = [];
        this.commands = new Map();
        const commands = [
            new $ef9a712c06b7320f$export$6cdc18cd411866ae(this.yielded, progressCallback),
            new $ef9a712c06b7320f$export$be0d4b5d2e5a3c27(this.preimages, this.queue),
            new $ef9a712c06b7320f$export$9e6812ae409a7928(this.roots),
            new $ef9a712c06b7320f$export$a5a8e1b007cbff9d(this.roots, this.queue),
            new $ef9a712c06b7320f$export$947bca8282126547(this.queue)
        ];
        for (const cmd of commands){
            if (this.commands.has(cmd.code)) throw new Error(`Multiple commands with code ${cmd.code}`);
            this.commands.set(cmd.code, cmd);
        }
    }
    getYielded() {
        return this.yielded;
    }
    addKnownPreimage(preimage) {
        this.preimages.set((0, $58cf3bc07eb2f0ea$exports.crypto).sha256(preimage).toString("hex"), preimage);
    }
    addKnownList(elements) {
        for (const el of elements){
            const preimage = $ef9a712c06b7320f$require$Buffer.concat([
                $ef9a712c06b7320f$require$Buffer.from([
                    0
                ]),
                el
            ]);
            this.addKnownPreimage(preimage);
        }
        const mt = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(elements.map((el)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(el)));
        this.roots.set(mt.getRoot().toString("hex"), mt);
    }
    addKnownMapping(mm) {
        this.addKnownList(mm.keys);
        this.addKnownList(mm.values);
    }
    execute(request) {
        if (request.length == 0) throw new Error("Unexpected empty command");
        const cmdCode = request[0];
        const cmd = this.commands.get(cmdCode);
        if (!cmd) throw new Error(`Unexpected command code ${cmdCode}`);
        return cmd.execute(request);
    }
}





var $6ZWSX = parcelRequire("6ZWSX");
var $e379a4228b1fbf23$require$Buffer = $6ZWSX.Buffer;
var $e379a4228b1fbf23$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $e379a4228b1fbf23$var$CLA_BTC = 0xe1;
const $e379a4228b1fbf23$var$CLA_FRAMEWORK = 0xf8;
var $e379a4228b1fbf23$var$BitcoinIns;
(function(BitcoinIns) {
    BitcoinIns[BitcoinIns["GET_PUBKEY"] = 0] = "GET_PUBKEY";
    // GET_ADDRESS = 0x01, // Removed from app
    BitcoinIns[BitcoinIns["REGISTER_WALLET"] = 2] = "REGISTER_WALLET";
    BitcoinIns[BitcoinIns["GET_WALLET_ADDRESS"] = 3] = "GET_WALLET_ADDRESS";
    BitcoinIns[BitcoinIns["SIGN_PSBT"] = 4] = "SIGN_PSBT";
    BitcoinIns[BitcoinIns["GET_MASTER_FINGERPRINT"] = 5] = "GET_MASTER_FINGERPRINT";
    BitcoinIns[BitcoinIns["SIGN_MESSAGE"] = 16] = "SIGN_MESSAGE";
})($e379a4228b1fbf23$var$BitcoinIns || ($e379a4228b1fbf23$var$BitcoinIns = {}));
var $e379a4228b1fbf23$var$FrameworkIns;
(function(FrameworkIns) {
    FrameworkIns[FrameworkIns["CONTINUE_INTERRUPTED"] = 1] = "CONTINUE_INTERRUPTED";
})($e379a4228b1fbf23$var$FrameworkIns || ($e379a4228b1fbf23$var$FrameworkIns = {}));
class $e379a4228b1fbf23$export$9bbedc1992a787b4 {
    constructor(transport){
        this.transport = transport;
    }
    makeRequest(ins, data, cci) {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            let response = yield this.transport.send($e379a4228b1fbf23$var$CLA_BTC, ins, 0, 0, data, [
                0x9000,
                0xe000
            ]);
            while(response.readUInt16BE(response.length - 2) === 0xe000){
                if (!cci) throw new Error("Unexpected SW_INTERRUPTED_EXECUTION");
                const hwRequest = response.slice(0, -2);
                const commandResponse = cci.execute(hwRequest);
                response = yield this.transport.send($e379a4228b1fbf23$var$CLA_FRAMEWORK, $e379a4228b1fbf23$var$FrameworkIns.CONTINUE_INTERRUPTED, 0, 0, commandResponse, [
                    0x9000,
                    0xe000
                ]);
            }
            return response.slice(0, -2); // drop the status word (can only be 0x9000 at this point)
        });
    }
    getExtendedPubkey(display, pathElements) {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
            const response = yield this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_PUBKEY, $e379a4228b1fbf23$require$Buffer.concat([
                $e379a4228b1fbf23$require$Buffer.from(display ? [
                    1
                ] : [
                    0
                ]),
                (0, $76d975e72423660e$export$91b509509e9f8b52)(pathElements)
            ]));
            return response.toString("ascii");
        });
    }
    getWalletAddress(walletPolicy, walletHMAC, change, addressIndex, display) {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            if (change !== 0 && change !== 1) throw new Error("Change can only be 0 or 1");
            if (addressIndex < 0 || !Number.isInteger(addressIndex)) throw new Error("Invalid address index");
            if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
            const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(()=>{});
            clientInterpreter.addKnownList(walletPolicy.keys.map((k)=>$e379a4228b1fbf23$require$Buffer.from(k, "ascii")));
            clientInterpreter.addKnownPreimage(walletPolicy.serialize());
            const addressIndexBuffer = $e379a4228b1fbf23$require$Buffer.alloc(4);
            addressIndexBuffer.writeUInt32BE(addressIndex, 0);
            const response = yield this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_WALLET_ADDRESS, $e379a4228b1fbf23$require$Buffer.concat([
                $e379a4228b1fbf23$require$Buffer.from(display ? [
                    1
                ] : [
                    0
                ]),
                walletPolicy.getWalletId(),
                walletHMAC || $e379a4228b1fbf23$require$Buffer.alloc(32, 0),
                $e379a4228b1fbf23$require$Buffer.from([
                    change
                ]),
                addressIndexBuffer
            ]), clientInterpreter);
            return response.toString("ascii");
        });
    }
    signPsbt(psbt, walletPolicy, walletHMAC, progressCallback) {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            const merkelizedPsbt = new (0, $ffbadfabc2a8c4e6$export$6138aa48176e3ed2)(psbt);
            if (walletHMAC != null && walletHMAC.length != 32) throw new Error("Invalid HMAC length");
            const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(progressCallback);
            // prepare ClientCommandInterpreter
            clientInterpreter.addKnownList(walletPolicy.keys.map((k)=>$e379a4228b1fbf23$require$Buffer.from(k, "ascii")));
            clientInterpreter.addKnownPreimage(walletPolicy.serialize());
            clientInterpreter.addKnownMapping(merkelizedPsbt.globalMerkleMap);
            for (const map of merkelizedPsbt.inputMerkleMaps)clientInterpreter.addKnownMapping(map);
            for (const map of merkelizedPsbt.outputMerkleMaps)clientInterpreter.addKnownMapping(map);
            clientInterpreter.addKnownList(merkelizedPsbt.inputMapCommitments);
            const inputMapsRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(merkelizedPsbt.inputMapCommitments.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
            clientInterpreter.addKnownList(merkelizedPsbt.outputMapCommitments);
            const outputMapsRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(merkelizedPsbt.outputMapCommitments.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
            yield this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.SIGN_PSBT, $e379a4228b1fbf23$require$Buffer.concat([
                merkelizedPsbt.getGlobalKeysValuesRoot(),
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalInputCount()),
                inputMapsRoot,
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(merkelizedPsbt.getGlobalOutputCount()),
                outputMapsRoot,
                walletPolicy.getWalletId(),
                walletHMAC || $e379a4228b1fbf23$require$Buffer.alloc(32, 0)
            ]), clientInterpreter);
            const yielded = clientInterpreter.getYielded();
            const ret = new Map();
            for (const inputAndSig of yielded)ret.set(inputAndSig[0], inputAndSig.slice(1));
            return ret;
        });
    }
    getMasterFingerprint() {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            return this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.GET_MASTER_FINGERPRINT, $e379a4228b1fbf23$require$Buffer.from([]));
        });
    }
    signMessage(message, pathElements) {
        return $e379a4228b1fbf23$var$__awaiter(this, void 0, void 0, function*() {
            if (pathElements.length > 6) throw new Error("Path too long. At most 6 levels allowed.");
            const clientInterpreter = new (0, $ef9a712c06b7320f$export$be0ded693afdcf85)(()=>{});
            // prepare ClientCommandInterpreter
            const nChunks = Math.ceil(message.length / 64);
            const chunks = [];
            for(let i = 0; i < nChunks; i++)chunks.push(message.subarray(64 * i, 64 * i + 64));
            clientInterpreter.addKnownList(chunks);
            const chunksRoot = new (0, $2e3df0c7f02d7cff$export$987d21b768c89d26)(chunks.map((m)=>(0, $2e3df0c7f02d7cff$export$bc68c1df7778232a)(m))).getRoot();
            const response = yield this.makeRequest($e379a4228b1fbf23$var$BitcoinIns.SIGN_MESSAGE, $e379a4228b1fbf23$require$Buffer.concat([
                (0, $76d975e72423660e$export$91b509509e9f8b52)(pathElements),
                (0, $9c51203570a3cc05$export$6124fc6ccfda9c)(message.length),
                chunksRoot
            ]), clientInterpreter);
            return response.toString("base64");
        });
    }
}





function $bc2f8f78c2c40909$export$83ccbb54a35801e8(transaction) {
    let str = "TX";
    str += " version " + transaction.version.toString("hex");
    if (transaction.locktime) str += " locktime " + transaction.locktime.toString("hex");
    if (transaction.witness) str += " witness " + transaction.witness.toString("hex");
    if (transaction.timestamp) str += " timestamp " + transaction.timestamp.toString("hex");
    if (transaction.nVersionGroupId) str += " nVersionGroupId " + transaction.nVersionGroupId.toString("hex");
    if (transaction.nExpiryHeight) str += " nExpiryHeight " + transaction.nExpiryHeight.toString("hex");
    if (transaction.extraData) str += " extraData " + transaction.extraData.toString("hex");
    transaction.inputs.forEach(({ prevout: prevout, script: script, sequence: sequence }, i)=>{
        str += `\ninput ${i}:`;
        str += ` prevout ${prevout.toString("hex")}`;
        str += ` script ${script.toString("hex")}`;
        str += ` sequence ${sequence.toString("hex")}`;
    });
    (transaction.outputs || []).forEach(({ amount: amount, script: script }, i)=>{
        str += `\noutput ${i}:`;
        str += ` amount ${amount.toString("hex")}`;
        str += ` script ${script.toString("hex")}`;
    });
    return str;
}
function $bc2f8f78c2c40909$export$ecf0056473e2fd14(transaction) {
    console.log($bc2f8f78c2c40909$export$83ccbb54a35801e8(transaction));
}



var $6ZWSX = parcelRequire("6ZWSX");
var $65ea30d1ca05f35d$require$Buffer = $6ZWSX.Buffer;
function $65ea30d1ca05f35d$export$58013ee1a5c7c230(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
    const inputs = [];
    const outputs = [];
    let witness = false;
    let offset = 0;
    const timestamp = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let nExpiryHeight = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let nVersionGroupId = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let extraData = $65ea30d1ca05f35d$require$Buffer.alloc(0);
    let witnessScript, locktime;
    const isDecred = additionals.includes("decred");
    const isZencash = additionals.includes("zencash");
    const isZcash = additionals.includes("zcash");
    const transaction = $65ea30d1ca05f35d$require$Buffer.from(transactionHex, "hex");
    const version = transaction.slice(offset, offset + 4);
    const overwinter = version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x03,
        0x00,
        0x00,
        0x80
    ])) || version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x04,
        0x00,
        0x00,
        0x80
    ])) || version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    const isZcashv5 = isZcash && version.equals($65ea30d1ca05f35d$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    offset += 4;
    if (isSegwitSupported && transaction[offset] === 0 && transaction[offset + 1] !== 0 && !isZencash) {
        offset += 2;
        witness = true;
    }
    if (overwinter) {
        nVersionGroupId = transaction.slice(offset, 4 + offset);
        offset += 4;
    }
    if (isZcashv5) {
        locktime = transaction.slice(offset + 4, offset + 8);
        nExpiryHeight = transaction.slice(offset + 8, offset + 12);
        offset += 12;
    }
    let varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const numberInputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberInputs; i++){
        const prevout = transaction.slice(offset, offset + 36);
        offset += 36;
        let script = $65ea30d1ca05f35d$require$Buffer.alloc(0);
        let tree = $65ea30d1ca05f35d$require$Buffer.alloc(0);
        //No script for decred, it has a witness
        if (!isDecred) {
            varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
        } else {
            //Tree field
            tree = transaction.slice(offset, offset + 1);
            offset += 1;
        }
        const sequence = transaction.slice(offset, offset + 4);
        offset += 4;
        inputs.push({
            prevout: prevout,
            script: script,
            sequence: sequence,
            tree: tree
        });
    }
    varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
    const numberOutputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberOutputs; i++){
        const amount = transaction.slice(offset, offset + 8);
        offset += 8;
        if (isDecred) //Script version
        offset += 2;
        varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        const script = transaction.slice(offset, offset + varint[0]);
        offset += varint[0];
        outputs.push({
            amount: amount,
            script: script
        });
    }
    if (witness) {
        witnessScript = transaction.slice(offset, -4);
        locktime = transaction.slice(transaction.length - 4);
    } else if (!isZcashv5) locktime = transaction.slice(offset, offset + 4);
    offset += 4;
    if ((overwinter || isDecred) && !isZcashv5) {
        nExpiryHeight = transaction.slice(offset, offset + 4);
        offset += 4;
    }
    if (hasExtraData) extraData = transaction.slice(offset);
    //Get witnesses for Decred
    if (isDecred) {
        varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
        offset += varint[1];
        if (varint[0] !== numberInputs) throw new Error("splitTransaction: incoherent number of witnesses");
        for(let i = 0; i < numberInputs; i++){
            //amount
            offset += 8;
            //block height
            offset += 4;
            //block index
            offset += 4;
            //Script size
            varint = (0, $9c51203570a3cc05$export$aa1483be3b95dbf)(transaction, offset);
            offset += varint[1];
            const script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
            inputs[i].script = script;
        }
    }
    const t = {
        version: version,
        inputs: inputs,
        outputs: outputs,
        locktime: locktime,
        witness: witnessScript,
        timestamp: timestamp,
        nVersionGroupId: nVersionGroupId,
        nExpiryHeight: nExpiryHeight,
        extraData: extraData
    };
    (0, $fdd451dd43e0ce6f$export$bef1f36f5486a6a3)("btc", `splitTransaction ${transactionHex}:\n${(0, $bc2f8f78c2c40909$export$83ccbb54a35801e8)(t)}`);
    return t;
}









var $6ZWSX = parcelRequire("6ZWSX");
var $a4198976a761baee$require$Buffer = $6ZWSX.Buffer;
var $a4198976a761baee$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
const $a4198976a761baee$var$defaultArg = {
    lockTime: (0, $543bb618117c682e$export$7e0b52e7059ffec7),
    sigHashType: (0, $543bb618117c682e$export$f53d15270899011f),
    segwit: false,
    transactionVersion: (0, $543bb618117c682e$export$363ebe89e6e7aeef)
};
function $a4198976a761baee$export$3cec8aff7aab66b(transport, arg) {
    return $a4198976a761baee$var$__awaiter(this, void 0, void 0, function*() {
        const { inputs: inputs, associatedKeysets: associatedKeysets, outputScriptHex: outputScriptHex, lockTime: lockTime, sigHashType: sigHashType, segwit: segwit, transactionVersion: transactionVersion } = Object.assign(Object.assign({}, $a4198976a761baee$var$defaultArg), arg);
        // Inputs are provided as arrays of [transaction, output_index, redeem script, optional sequence]
        // associatedKeysets are provided as arrays of [path]
        const nullScript = $a4198976a761baee$require$Buffer.alloc(0);
        const nullPrevout = $a4198976a761baee$require$Buffer.alloc(0);
        const defaultVersion = $a4198976a761baee$require$Buffer.alloc(4);
        defaultVersion.writeUInt32LE(transactionVersion, 0);
        const trustedInputs = [];
        const regularOutputs = [];
        const signatures = [];
        let firstRun = true;
        const resuming = false;
        const targetTransaction = {
            inputs: [],
            version: defaultVersion
        };
        const getTrustedInputCall = segwit ? (0, $a0f3645f2f32a0c2$export$33b7242117f697d5) : (0, $4dc89f53f791a224$export$31ab969c8a87fc21);
        const outputScript = $a4198976a761baee$require$Buffer.from(outputScriptHex, "hex");
        for (const input of inputs){
            if (!resuming) {
                const trustedInput = yield getTrustedInputCall(transport, input[1], input[0]);
                const sequence = $a4198976a761baee$require$Buffer.alloc(4);
                sequence.writeUInt32LE(input.length >= 4 && typeof input[3] === "number" ? input[3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
                trustedInputs.push({
                    trustedInput: false,
                    value: segwit ? $a4198976a761baee$require$Buffer.from(trustedInput, "hex") : $a4198976a761baee$require$Buffer.from(trustedInput, "hex").slice(4, 40),
                    sequence: sequence
                });
            }
            const { outputs: outputs } = input[0];
            const index = input[1];
            if (outputs && index <= outputs.length - 1) regularOutputs.push(outputs[index]);
        }
        // Pre-build the target transaction
        for(let i = 0; i < inputs.length; i++){
            const sequence = $a4198976a761baee$require$Buffer.alloc(4);
            sequence.writeUInt32LE(inputs[i].length >= 4 && typeof inputs[i][3] === "number" ? inputs[i][3] : (0, $543bb618117c682e$export$57fe8370989728bf), 0);
            targetTransaction.inputs.push({
                script: nullScript,
                prevout: nullPrevout,
                sequence: sequence
            });
        }
        if (segwit) {
            yield (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, true, targetTransaction, trustedInputs, true);
            yield (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
        }
        for(let i = 0; i < inputs.length; i++){
            const input = inputs[i];
            const script = inputs[i].length >= 3 && typeof input[2] === "string" ? $a4198976a761baee$require$Buffer.from(input[2], "hex") : regularOutputs[i].script;
            const pseudoTX = Object.assign({}, targetTransaction);
            const pseudoTrustedInputs = segwit ? [
                trustedInputs[i]
            ] : trustedInputs;
            if (segwit) pseudoTX.inputs = [
                Object.assign(Object.assign({}, pseudoTX.inputs[i]), {
                    script: script
                })
            ];
            else pseudoTX.inputs[i].script = script;
            yield (0, $302fd648d7829cb7$export$fe75eaa1344c36c1)(transport, !segwit && firstRun, pseudoTX, pseudoTrustedInputs, segwit);
            if (!segwit) yield (0, $dc30479c38246bb0$export$34dd66230370b398)(transport, outputScript);
            const signature = yield (0, $945283aa22a61c46$export$6ad02cc4966b42ab)(transport, associatedKeysets[i], lockTime, sigHashType);
            signatures.push(segwit ? signature.toString("hex") : signature.slice(0, signature.length - 1).toString("hex"));
            targetTransaction.inputs[i].script = nullScript;
            if (firstRun) firstRun = false;
        }
        return signatures;
    });
}



var $53ba752409530816$var$__awaiter = undefined && undefined.__awaiter || function(thisArg, _arguments, P, generator) {
    function adopt(value) {
        return value instanceof P ? value : new P(function(resolve) {
            resolve(value);
        });
    }
    return new (P || (P = Promise))(function(resolve, reject) {
        function fulfilled(value) {
            try {
                step(generator.next(value));
            } catch (e) {
                reject(e);
            }
        }
        function rejected(value) {
            try {
                step(generator["throw"](value));
            } catch (e) {
                reject(e);
            }
        }
        function step(result) {
            result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
        }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
class $53ba752409530816$export$2e2bcd8739ae039 {
    constructor({ transport: transport, scrambleKey: scrambleKey = "BTC", currency: currency = "bitcoin" }){
        this._transport = transport;
        this._transport.decorateAppAPIMethods(this, [
            "getWalletXpub",
            "getWalletPublicKey",
            "signP2SHTransaction",
            "signMessage",
            "createPaymentTransaction",
            "getTrustedInput",
            "getTrustedInputBIP143"
        ], scrambleKey);
        this._impl = (()=>{
            switch(currency){
                case "bitcoin":
                case "bitcoin_testnet":
                case "qtum":
                    // new APDU (nano app API) for currencies using app-bitcoin-new implementation
                    return new (0, $9018257154446467$export$2e2bcd8739ae039)(new (0, $e379a4228b1fbf23$export$9bbedc1992a787b4)(this._transport));
                default:
                    // old APDU (legacy API) for currencies using legacy bitcoin app implementation
                    return new (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)(this._transport);
            }
        })();
    }
    /**
     * Get an XPUB with a ledger device
     * @param arg derivation parameter
     * - path: a BIP 32 path of the account level. (e.g. The derivation path `84'/0'/0'`
     * follows the `purpose' / coin_type' / account'` standard, with purpose=84, coin_type=0, account=0)
     * - xpubVersion: the XPUBVersion of the coin used. (refer to ledgerjs/packages/cryptoassets/src/currencies.ts
     * for the XPUBVersion value if needed)
     * @returns XPUB of the account
     */ getWalletXpub(arg) {
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.getWalletXpub(arg);
        });
    }
    /**
     * @param path a BIP 32 path (i.e. the `purpose’ / coin_type’ / account’ / change / address_index` standard)
     * @param options an object with optional these fields:
     *
     * - verify (boolean) whether ask user to confirm the address on the device
     *
     * - format ("legacy" | "p2sh" | "bech32" | "bech32m" | "cashaddr") to use different bitcoin address formatter.
     *
     * NB The normal usage is to use:
     *
     * - legacy format with 44' paths
     *
     * - p2sh format with 49' paths
     *
     * - bech32 format with 84' paths
     *
     * - bech32m format with 86' paths
     *
     * - cashaddr in case of Bitcoin Cash
     *
     * @example
     * btc.getWalletPublicKey("44'/0'/0'/0/0").then(o => o.bitcoinAddress)
     * btc.getWalletPublicKey("49'/0'/0'/0/0", { format: "p2sh" }).then(o => o.bitcoinAddress)
     */ getWalletPublicKey(path, opts) {
        let options;
        if (arguments.length > 2 || typeof opts === "boolean") {
            console.warn("btc.getWalletPublicKey deprecated signature used. Please switch to getWalletPublicKey(path, { format, verify })");
            options = {
                verify: !!opts,
                // eslint-disable-next-line prefer-rest-params
                format: arguments[2] ? "p2sh" : "legacy"
            };
        } else options = opts || {};
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.getWalletPublicKey(path, options);
        });
    }
    /**
     * You can sign a message according to the Bitcoin Signature format and retrieve v, r, s given the message and the BIP 32 path of the account to sign.
     * @example
     btc.signMessage("44'/60'/0'/0'/0", Buffer.from("test").toString("hex")).then(function(result) {
       var v = result['v'] + 27 + 4;
       var signature = Buffer.from(v.toString(16) + result['r'] + result['s'], 'hex').toString('base64');
       console.log("Signature : " + signature);
     }).catch(function(ex) {console.log(ex);});
     */ signMessage(path, messageHex) {
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.signMessage({
                path: path,
                messageHex: messageHex
            });
        });
    }
    /**
     * To sign a transaction involving standard (P2PKH) inputs, call createTransaction with the following parameters
     * @param inputs is an array of [ transaction, output_index, optional redeem script, optional sequence ] where
     *
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the optional redeem script to use when consuming a Segregated Witness input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param changePath is an optional BIP 32 path pointing to the path to the public key used to compute the change address
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign, including leading vararg voutCount
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @param segwit is an optional boolean indicating wether to use segwit or not. This includes wrapped segwit.
     * @param additionals list of additionnal options
     *
     * - "bech32" for spending native segwit outputs
     * - "bech32m" for spending segwit v1+ outputs
     * - "abc" for bch
     * - "gold" for btg
     * - "decred" for decred
     * - "zcash" for zcash
     * - "bipxxx" for using BIPxxx
     * - "sapling" to indicate a zec transaction is supporting sapling (to be set over block 419200)
     * @param expiryHeight is an optional Buffer for zec overwinter / sapling Txs
     * @param useTrustedInputForSegwit trust inputs for segwit transactions. If app version >= 1.4.0 this should be true.
     * @return the signed transaction ready to be broadcast
     * @example
    btc.createTransaction({
     inputs: [ [tx1, 1] ],
     associatedKeysets: ["0'/0/0"],
     outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(res => ...);
     */ createPaymentTransaction(arg) {
        if (arguments.length > 1) throw new Error("@ledgerhq/hw-app-btc: createPaymentTransaction multi argument signature is deprecated. please switch to named parameters.");
        return this.changeImplIfNecessary().then((impl)=>{
            return impl.createPaymentTransaction(arg);
        });
    }
    /**
     * To obtain the signature of multisignature (P2SH) inputs, call signP2SHTransaction_async with the folowing parameters
     * @param inputs is an array of [ transaction, output_index, redeem script, optional sequence ] where
     * * transaction is the previously computed transaction object for this UTXO
     * * output_index is the output in the transaction used as input for this UTXO (counting from 0)
     * * redeem script is the mandatory redeem script associated to the current P2SH input
     * * sequence is the sequence number to use for this input (when using RBF), or non present
     * @param associatedKeysets is an array of BIP 32 paths pointing to the path to the private key used for each UTXO
     * @param outputScriptHex is the hexadecimal serialized outputs of the transaction to sign
     * @param lockTime is the optional lockTime of the transaction to sign, or default (0)
     * @param sigHashType is the hash type of the transaction to sign, or default (all)
     * @return the signed transaction ready to be broadcast
     * @example
    btc.signP2SHTransaction({
    inputs: [ [tx, 1, "52210289b4a3ad52a919abd2bdd6920d8a6879b1e788c38aa76f0440a6f32a9f1996d02103a3393b1439d1693b063482c04bd40142db97bdf139eedd1b51ffb7070a37eac321030b9a409a1e476b0d5d17b804fcdb81cf30f9b99c6f3ae1178206e08bc500639853ae"] ],
    associatedKeysets: ["0'/0/0"],
    outputScriptHex: "01905f0100000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88ac"
    }).then(result => ...);
     */ signP2SHTransaction(arg) {
        return (0, $a4198976a761baee$export$3cec8aff7aab66b)(this._transport, arg);
    }
    /**
     * For each UTXO included in your transaction, create a transaction object from the raw serialized version of the transaction used in this UTXO.
     * @param transactionHex a raw hexadecimal serialized transaction
     * @param isSegwitSupported is a boolean indicating if the segwit is supported
     * @param hasExtraData is a boolean (komodo, zencash and zcash include extraData in their transactions, others don't)
     * @param additionals list of additionnal options
     * @return the transaction object deserialized from the raw hexadecimal transaction
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
     */ splitTransaction(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
        return (0, $65ea30d1ca05f35d$export$58013ee1a5c7c230)(transactionHex, isSegwitSupported, hasExtraData, additionals);
    }
    /**
     * Serialize a transaction's outputs to hexadecimal
     * @example
    const tx1 = btc.splitTransaction("01000000014ea60aeac5252c14291d428915bd7ccd1bfc4af009f4d4dc57ae597ed0420b71010000008a47304402201f36a12c240dbf9e566bc04321050b1984cd6eaf6caee8f02bb0bfec08e3354b022012ee2aeadcbbfd1e92959f57c15c1c6debb757b798451b104665aa3010569b49014104090b15bde569386734abf2a2b99f9ca6a50656627e77de663ca7325702769986cf26cc9dd7fdea0af432c8e2becc867c932e1b9dd742f2a108997c2252e2bdebffffffff0281b72e00000000001976a91472a5d75c8d2d0565b656a5232703b167d50d5a2b88aca0860100000000001976a9144533f5fb9b4817f713c48f0bfe96b9f50c476c9b88ac00000000");
    const outputScript = btc.serializeTransactionOutputs(tx1).toString('hex');
    */ serializeTransactionOutputs(t) {
        return (0, $6f5c2f66f4ecb3fe$export$e6e9ad4770a214a8)(t);
    }
    /**
     * Trusted input is the hash of a UTXO that needs to be signed
     * For Legacy transactions, the app has some APDUs flows that do the amount check for an UTXO,
     * by parsing the transaction that created this UTXO
     */ getTrustedInput(indexLookup, transaction, additionals = []) {
        return (0, $4dc89f53f791a224$export$31ab969c8a87fc21)(this._transport, indexLookup, transaction, additionals);
    }
    /**
     * Trusted input is the hash of a UTXO that needs to be signed. BIP143 is used for Segwit inputs.
     */ getTrustedInputBIP143(indexLookup, transaction, additionals = []) {
        return (0, $a0f3645f2f32a0c2$export$33b7242117f697d5)(this._transport, indexLookup, transaction, additionals);
    }
    changeImplIfNecessary() {
        return $53ba752409530816$var$__awaiter(this, void 0, void 0, function*() {
            // if BtcOld was instantiated, stick with it
            if (this._impl instanceof (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)) return this._impl;
            const { name: name, version: version } = yield (0, $300a11e70dc240cc$export$bd21f07fb59bc20d)(this._transport);
            const isBtcLegacy = yield (()=>$53ba752409530816$var$__awaiter(this, void 0, void 0, function*() {
                    switch(name){
                        case "Bitcoin":
                        case "Bitcoin Test":
                            // we use the legacy protocol for versions below 2.1.0 of the Bitcoin app.
                            return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt(version, "2.1.0");
                        case "Bitcoin Legacy":
                        case "Bitcoin Test Legacy":
                            // the "Bitcoin Legacy" and "Bitcoin Testnet Legacy" app use the legacy protocol, regardless of the version
                            return true;
                        case "Exchange":
                            // We can't query the version of the Bitcoin app if we're coming from Exchange;
                            // therefore, we use a workaround to distinguish legacy and new versions.
                            // This can be removed once Ledger Live enforces minimum bitcoin version >= 2.1.0.
                            return yield (0, $300a11e70dc240cc$export$33e1ebd1430bed57)(this._transport);
                        case "Qtum":
                            // we use the legacy protocol for versions below 3.0.0 of the Qtum app.
                            return (0, (/*@__PURE__*/$parcel$interopDefault($dbb9fc904636819d$exports))).lt(version, "3.0.0");
                        default:
                            return true;
                    }
                }))();
            if (isBtcLegacy) this._impl = new (0, $86e871bb8fe485c6$export$2e2bcd8739ae039)(this._transport);
            return this._impl;
        });
    }
}



var $6ZWSX = parcelRequire("6ZWSX");
var $f93470cc11995b73$require$Buffer = $6ZWSX.Buffer;
function $f93470cc11995b73$export$58013ee1a5c7c230(transactionHex, isSegwitSupported = false, hasExtraData = false, additionals = []) {
    const inputs = [];
    const outputs = [];
    let witness = false;
    let offset = 0;
    const timestamp = $f93470cc11995b73$require$Buffer.alloc(0);
    let nExpiryHeight = $f93470cc11995b73$require$Buffer.alloc(0);
    let nVersionGroupId = $f93470cc11995b73$require$Buffer.alloc(0);
    let extraData = $f93470cc11995b73$require$Buffer.alloc(0);
    let witnessScript, locktime;
    const isDecred = additionals.includes("decred");
    const isZencash = additionals.includes("zencash");
    const isZcash = additionals.includes("zcash");
    const transaction = $f93470cc11995b73$require$Buffer.from(transactionHex, "hex");
    const version = transaction.slice(offset, offset + 4);
    const overwinter = version.equals($f93470cc11995b73$require$Buffer.from([
        0x03,
        0x00,
        0x00,
        0x80
    ])) || version.equals($f93470cc11995b73$require$Buffer.from([
        0x04,
        0x00,
        0x00,
        0x80
    ])) || version.equals($f93470cc11995b73$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    const isZcashv5 = isZcash && version.equals($f93470cc11995b73$require$Buffer.from([
        0x05,
        0x00,
        0x00,
        0x80
    ]));
    offset += 4;
    if (isSegwitSupported && transaction[offset] === 0 && transaction[offset + 1] !== 0 && !isZencash) {
        offset += 2;
        witness = true;
    }
    if (overwinter) {
        nVersionGroupId = transaction.slice(offset, 4 + offset);
        offset += 4;
    }
    if (isZcashv5) {
        locktime = transaction.slice(offset + 4, offset + 8);
        nExpiryHeight = transaction.slice(offset + 8, offset + 12);
        offset += 12;
    }
    let varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
    const numberInputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberInputs; i++){
        const prevout = transaction.slice(offset, offset + 36);
        offset += 36;
        let script = $f93470cc11995b73$require$Buffer.alloc(0);
        let tree = $f93470cc11995b73$require$Buffer.alloc(0);
        //No script for decred, it has a witness
        if (!isDecred) {
            varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
            offset += varint[1];
            script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
        } else {
            //Tree field
            tree = transaction.slice(offset, offset + 1);
            offset += 1;
        }
        const sequence = transaction.slice(offset, offset + 4);
        offset += 4;
        inputs.push({
            prevout: prevout,
            script: script,
            sequence: sequence,
            tree: tree
        });
    }
    varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
    const numberOutputs = varint[0];
    offset += varint[1];
    for(let i = 0; i < numberOutputs; i++){
        const amount = transaction.slice(offset, offset + 8);
        offset += 8;
        if (isDecred) //Script version
        offset += 2;
        varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
        offset += varint[1];
        const script = transaction.slice(offset, offset + varint[0]);
        offset += varint[0];
        outputs.push({
            amount: amount,
            script: script
        });
    }
    if (witness) {
        witnessScript = transaction.slice(offset, -4);
        locktime = transaction.slice(transaction.length - 4);
    } else if (!isZcashv5) locktime = transaction.slice(offset, offset + 4);
    offset += 4;
    if ((overwinter || isDecred) && !isZcashv5) {
        nExpiryHeight = transaction.slice(offset, offset + 4);
        offset += 4;
    }
    if (hasExtraData) extraData = transaction.slice(offset);
    //Get witnesses for Decred
    if (isDecred) {
        varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
        offset += varint[1];
        if (varint[0] !== numberInputs) throw new Error("splitTransaction: incoherent number of witnesses");
        for(let i = 0; i < numberInputs; i++){
            //amount
            offset += 8;
            //block height
            offset += 4;
            //block index
            offset += 4;
            //Script size
            varint = $f93470cc11995b73$export$aa1483be3b95dbf(transaction, offset);
            offset += varint[1];
            const script = transaction.slice(offset, offset + varint[0]);
            offset += varint[0];
            inputs[i].script = script;
        }
    }
    const t = {
        version: version,
        inputs: inputs,
        outputs: outputs,
        locktime: locktime,
        witness: witnessScript,
        timestamp: timestamp,
        nVersionGroupId: nVersionGroupId,
        nExpiryHeight: nExpiryHeight,
        extraData: extraData
    };
    //log("btc", `splitTransaction ${transactionHex}:\n${formatTransactionDebug(t)}`);
    return t;
}
function $f93470cc11995b73$export$e6e9ad4770a214a8({ outputs: outputs }) {
    let outputBuffer = $f93470cc11995b73$require$Buffer.alloc(0);
    if (typeof outputs !== "undefined") {
        outputBuffer = $f93470cc11995b73$require$Buffer.concat([
            outputBuffer,
            $f93470cc11995b73$export$6124fc6ccfda9c(outputs.length)
        ]);
        outputs.forEach((output)=>{
            outputBuffer = $f93470cc11995b73$require$Buffer.concat([
                outputBuffer,
                output.amount,
                $f93470cc11995b73$export$6124fc6ccfda9c(output.script.length),
                output.script
            ]);
        });
    }
    return outputBuffer;
}
function $f93470cc11995b73$export$aa1483be3b95dbf(data, offset) {
    if (data[offset] < 0xfd) return [
        data[offset],
        1
    ];
    if (data[offset] === 0xfd) return [
        (data[offset + 2] << 8) + data[offset + 1],
        3
    ];
    if (data[offset] === 0xfe) return [
        (data[offset + 4] << 24) + (data[offset + 3] << 16) + (data[offset + 2] << 8) + data[offset + 1],
        5
    ];
    throw new Error("getVarint called with unexpected parameters");
}
function $f93470cc11995b73$export$6124fc6ccfda9c(value) {
    if (value < 0xfd) {
        const buffer = $f93470cc11995b73$require$Buffer.alloc(1);
        buffer[0] = value;
        return buffer;
    }
    if (value <= 0xffff) {
        const buffer = $f93470cc11995b73$require$Buffer.alloc(3);
        buffer[0] = 0xfd;
        buffer[1] = value & 0xff;
        buffer[2] = value >> 8 & 0xff;
        return buffer;
    }
    const buffer = $f93470cc11995b73$require$Buffer.alloc(5);
    buffer[0] = 0xfe;
    buffer[1] = value & 0xff;
    buffer[2] = value >> 8 & 0xff;
    buffer[3] = value >> 16 & 0xff;
    buffer[4] = value >> 24 & 0xff;
    return buffer;
}



var $6ZWSX = parcelRequire("6ZWSX");
var $586cf8d59d7800a2$require$Buffer = $6ZWSX.Buffer;
//import { listen } from "@ledgerhq/logs";
const $586cf8d59d7800a2$var$MAINNET = {
    /**
     * The message prefix used for signing Bitcoin messages.
     */ messagePrefix: "\x18Bitcoin Signed Message:\n",
    /**
     * The Bech32 prefix used for Bitcoin addresses.
     */ bech32: "bc",
    /**
     * The BIP32 key prefixes for Bitcoin.
     */ bip32: {
        /**
       * The public key prefix for BIP32 extended public keys.
       */ public: 0x0488b21e,
        /**
       * The private key prefix for BIP32 extended private keys.
       */ private: 0x0488ade4
    },
    /**
     * The prefix for Bitcoin public key hashes.
     */ pubKeyHash: 0x00,
    /**
     * The prefix for Bitcoin script hashes.
     */ scriptHash: 0x05,
    /**
     * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
     */ wif: 0x80
};
const $586cf8d59d7800a2$var$TESTNET = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
class $586cf8d59d7800a2$var$HWI {
    /**
     * HWI is a class useful to instantiate the HWI client.
     * The client is able to open/close a transport connection to a Ledger hardware device.
     */ constructor(TransportWebHID){
        this.testnet = false;
        this.debugger = false;
        this.appversion = 0;
        this.b64 = "";
        this.hex = "";
        this.psbt = {};
        this.psbtLedger = {};
        this.TransportWebHID = TransportWebHID;
        this.transport = TransportWebHID;
        this.isOpen = false;
        this.appBtc = null;
        this.appBtcNew = null;
        this.policy = "";
        this.descriptorTemplate = "wsh(andor(multi(2,@0/**,@1/**,@2/**),multi(3,@3/**,@4/**,@5/**,@6/**,@7/**,@8/**),and_v(v:multi(2,@9/**,@10/**,@11/**),older(184))))";
        this.wallet = {
            address: "",
            policyHmac: "",
            walletPolicy: {}
        };
    }
    /**
     * Function used to create an empty PSBT object with bitcoin-lib
     */ createPsbt(type = "", network = "") {
        //p2wsh
        //this.psbt = bitcoin.payments.p2wsh({})
        //p2ms
        //const p2ms = bitcoin.payments.p2ms({ pubkeys: publicKeys, network: NETWORK, m: 1 });
        //p2sh
        //const p2shP2ms = bitcoin.payments.p2sh({ redeem: p2ms, network: NETWORK });
        //psbt
        //this.psbt = new bitcoin.Psbt({ network: NETWORK });
        switch(type){
            case "p2sh":
                this.psbt = new $3wrUl.Psbt();
                return;
            case "p2wsh":
                this.psbt = new $3wrUl.Psbt();
                return;
            default:
                this.psbt = new $3wrUl.Psbt();
        }
        console.log(this.psbt);
    }
    /**
     * Function used to import a PSBT from a base64 string
     */ importFromB64(data) {
        this.b64 = data;
        const hex = $586cf8d59d7800a2$var$base64ToHex(data);
        this.hex = hex;
        this.decode();
    }
    /**
     * Function used to import a PSBT from a raw hex string
     */ importFromHex(data) {
        this.psbt = $3wrUl.Psbt.fromHex(data, this.testnet ? $586cf8d59d7800a2$var$TESTNET : $586cf8d59d7800a2$var$MAINNET);
    }
    /**
     * Function used to decode a PSBT from raw hex after base64toHex conversion
     */ decode() {
        this.psbt = $3wrUl.Psbt.fromHex(this.hex, this.testnet ? $586cf8d59d7800a2$var$TESTNET : $586cf8d59d7800a2$var$MAINNET);
    }
    /**
     * Function used to extract useful informations from a PSBT
     */ getPsbtInfo() {
        const txInfo = {};
        /**
         * this.psbt.txOutputs[i].address !
         * this.psbt.txOutputs[i].value !
         * this.psbt.data.inputs[i].bip32Derivation.[j].masterFingerprint
         * this.psbt.data.inputs[i].bip32Derivation.[j].pubkey
         * this.psbt.data.inputs[i].bip32Derivation.[j].path
         * this.psbt.data.inputs[i].partialSig[i].pubkey
         * this.psbt.data.inputs[i].partialSig[i].signature
         */ try {
            txInfo.to = this.psbt.txOutputs?.length > 0 && this.psbt.txOutputs.map((item)=>{
                return {
                    address: item.address,
                    value: item.value
                };
            }) //[...this.psbt.txOutputs.map(item=>{return item.address})]
            ;
            txInfo.bip32 = [];
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map((item)=>{
                item.bip32Derivation?.length > 0 && item.bip32Derivation.map((el)=>{
                    txInfo.bip32.push({
                        fgpr: $586cf8d59d7800a2$require$Buffer.from(el.masterFingerprint).toString("hex"),
                        pubkey: $586cf8d59d7800a2$require$Buffer.from(el.pubkey).toString("hex"),
                        path: el.path
                    });
                });
            });
            txInfo.signatures = [];
            this.psbt.data.inputs?.length > 0 && this.psbt.data.inputs.map((item)=>{
                item.partialSig?.length > 0 && item.partialSig.map((el)=>{
                    txInfo.signatures.push({
                        pubkey: $586cf8d59d7800a2$require$Buffer.from(el.pubkey).toString("hex"),
                        signature: $586cf8d59d7800a2$require$Buffer.from(el.signature).toString("hex")
                    });
                });
            });
        } catch (error) {
            console.log("[PSBT-ERROR]: unable to get info", error);
        }
        return txInfo;
    }
    /**
     * Function used to open a transport client to Ledger device
     */ async getClient() {
        this.transport = await this.TransportWebHID.create();
        this.appBtc = new (0, $7a6cef509ca65f26$exports.AppClient)(this.transport);
        const transport1 = this.transport;
        this.appBtcNew = new (0, $53ba752409530816$export$2e2bcd8739ae039)({
            transport: transport1,
            currency: "bitcoin"
        });
        this.isOpen = true;
        this.appversion = await this.appBtc.getAppAndVersion();
        console.log("[APP version]: ", this.appversion);
    }
    async isBrowserSupported() {
        return await this.TransportWebHID.isSupported();
    }
    /**
     * Function used to close a transport client Ledger device
     */ async closeClient() {
        await this.transport.close();
        this.isOpen = false;
        console.log("Ledger transport closed...");
    }
    /**
     * Function used to decode a transaction with Ledger
     */ decodeTX(tx, segwit = true, additionals = [
        "bech32"
    ]) {
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,false,additionals) //
        this.psbtLedger = (0, $f93470cc11995b73$export$58013ee1a5c7c230)(tx, segwit, false, additionals);
        //this.psbtLedger = this.appBtcNew.splitTransaction(tx,segwit,null,[])
        //console.log("splitted transaction:", this.psbtLedger)
        //const serOut = this.appBtcNew.serializeTransactionOutputs(this.psbtLedger).toString('hex')
        const serOut = (0, $f93470cc11995b73$export$e6e9ad4770a214a8)(this.psbtLedger).toString("hex");
        //console.log("outputScriptHex: ", serOut)
        //const trustedInput = segwit? null : await this.appBtcNew.getTrustedInput(index,this.psbtLedger,["bech32"])
        //console.log("[TrustedInput]: ", trustedInput)
        //const trustedInput143 = segwit? await this.appBtcNew.getTrustedInputBIP143(index,this.psbtLedger,["bech32"]):null
        //console.log("[TrustedInputBIP143]: ", trustedInput143)
        //return {tx:this.psbtLedger,outputScript:serOut,trustedInput:segwit ? trustedInput143 : trustedInput}
        return {
            tx: this.psbtLedger,
            outputScript: serOut
        };
    }
    async getTrustedInputs(index, segwit, additionals = []) {
        const trustedInput = segwit ? null : await this.appBtcNew.getTrustedInput(index, this.psbtLedger, additionals);
        console.log("[TrustedInput]: ", trustedInput);
        const trustedInput143 = segwit ? await this.appBtcNew.getTrustedInputBIP143(index, this.psbtLedger, additionals) : null;
        console.log("[TrustedInputBIP143]: ", trustedInput143);
        return {
            trustedInput: segwit ? trustedInput143 : trustedInput
        };
    }
    /**
     * Function used to get the fingerprint of the connected Ledger
     */ async getFingerprint() {
        const fgpr = await this.appBtc.getMasterFingerprint();
        return fgpr;
    }
    /**
     * Function used to get the uncompressed public key from connected Ledger
     */ async getPub(path = "m/44'/0'/0'/0/0") {
        let format;
        switch(path.slice(2, 4)){
            case "44":
                format = "legacy";
                break;
            case "49":
                format = "p2sh";
                break;
            case "84":
                format = "bech32";
                break;
            case "86":
                format = "bech32m";
                break;
            default:
                format = "bech32";
        }
        //console.log("[POLICY type]",path.slice(2,4),format)
        const pub = await this.appBtcNew.getWalletPublicKey(path, {
            verify: false,
            format: format
        }) // TODO: fix format
        ;
        //console.log("[PUBext]: ", pub.publicKey.length , pub.publicKey)
        /*
        .then(o => {
            const buf = Buffer.from(o.publicKey,'hex').slice(1)

            //const final = buf.length === 64 ? Buffer.concat([0x02,buf.slice(0,32)]).toString('hex') : Buffer.concat([0x03,buf.slice(0,32)]).toString('hex')

            console.log("[PUB]: ", buf.length , o.publicKey)

            return o.publicKey
        })
        */ return pub.publicKey;
    }
    /**
     * Function used to get the extend public key from connected Ledger
     */ async getXpub(path = "m/44'/0'/0'/0/0") {
        const xpub = await this.appBtc.getExtendedPubkey(path, false);
        return xpub;
    }
    /**
     * Function used to get the corresponding derivation path address
     */ async getAddress(path = "m/44'/0'/0'/0/0", format = "bech32") {
        //console.log("getting address..")
        //console.log(this.appversion.name,this.appversion.version,parseFloat(this.appversion.version))
        if (parseFloat(this.appversion.version) < 2.1) return (await this.appBtcNew.getWalletPublicKey(path, {
            format: format
        })).bitcoinAddress // TODO: path.slice(2,4) === "44" || "49" || "84" || "86"
        ;
        const fpr = await this.getFingerprint();
        const decodedPath = path.split("/");
        let purpose = "" //decodedPath[0]
        ;
        let coinType = decodedPath[2] //path.slice(6,8)
        ;
        let account = decodedPath[3] //path.slice(9,11)
        ;
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //const accountPubkey = await this.getXpub(path.slice(0, path.length - 4)) // TODO:
        const accountPubkey = await this.getXpub(`${decodedPath[0]}/${decodedPath[1]}/${coinType}/${account}`);
        const formats = {
            pkh: "44'",
            sh: "49'",
            wpkh: "84'",
            tr: "86'"
        };
        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`);
        let addressType = "";
        Object.keys(formats).map((item)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item;
                purpose = formats[item];
            //return item
            }
        });
        const accountPolicy = new (0, $7a6cef509ca65f26$exports.DefaultWalletPolicy)(decodedPath[1] === "49'" ? `sh(wpkh(@0/**))` : `${addressType}(@0/**)`, `[${fpr}/${purpose}/${coinType}/${account}]${accountPubkey}`);
        console.log(fpr, accountPubkey, accountPolicy);
        const bitcoinAddress = await this.appBtc.getWalletAddress(accountPolicy, null, parseInt(change) || 0, parseInt(index) || 0, false // show address on the wallet's screen
        );
        console.log("[Address]:", bitcoinAddress);
        return bitcoinAddress;
    }
    /**
     * Function used to register a Wallet Policy with the Ledger
     */ async registerWallet(name = "WALLET", keychains) {
        const app = new (0, $7a6cef509ca65f26$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }

        //const paths = path.split("|")
        //const decodedPath = path.split("/")
        //console.log("[PATHS] ", paths)

        let purpose = ""
        let coinType = decodedPath[2] //path.slice(6,8)
        let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        let index = decodedPath[5] //path.slice(14,15)
        console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })
        
        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        */ const walletPolicy = new (0, $7a6cef509ca65f26$exports.WalletPolicy)(name, this.descriptorTemplate, //this.getKeys(path)
        this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        );
        //console.log("Wallet Policy:",  walletPolicy)
        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);
        //console.assert(policyId.compare(walletPolicy.getId()) == 0)
        //const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change)||0, parseInt(index)||0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);
        this.wallet.policyHmac = policyHmac;
        this.wallet.walletPolicy = walletPolicy;
        return this.wallet;
    }
    async getPolicyAddress(path, policy) {
        const app = new (0, $7a6cef509ca65f26$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        /*
        const formats = {
            pkh : "44'",
            sh : "49'",
            wpkh : "84'",
            tr : "86'",
        }
        */ //const paths = path.split("|")
        const decodedPath = path.split("/");
        //console.log("[PATHS] ", paths)
        //let purpose = ""
        //let coinType = decodedPath[2] //path.slice(6,8)
        //let account = decodedPath[3] //path.slice(9,11)
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        /*
        let addressType = ""

        Object.keys(formats).map((item,i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item
                purpose = formats[item]
            }
        })

        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?

        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        
       
        const multisigPolicy = new WalletPolicy(
            name,
            this.descriptorTemplate,        
            //this.getKeys(path)
            this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        )

        console.log("Wallet Policy:",  multisigPolicy)

        const [policyId, policyHmac] = await app.registerWallet(multisigPolicy);
        
        console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);

        //console.assert(policyId.compare(multisigPolicy.getId()) == 0)
        */ const walletAddress = await app.getWalletAddress(policy.walletPolicy, policy.policyHmac, parseInt(change) || 0, parseInt(index) || 0, true);
        console.log(`wallet address: ${walletAddress}`);
        this.wallet.address = walletAddress;
        return walletAddress;
    }
    async registerWalletPath(path, name = "RMS WALLET", keychains) {
        const app = new (0, $7a6cef509ca65f26$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        const formats = {
            pkh: "44'",
            sh: "49'",
            wpkh: "84'",
            tr: "86'"
        };
        const paths = path.split("|");
        const decodedPath = path.split("/");
        //console.log("[PATHS] ", paths)
        let purpose = "";
        let coinType = decodedPath[2] //path.slice(6,8)
        ;
        let account = decodedPath[3] //path.slice(9,11)
        ;
        let change = decodedPath[4] //path.slice(12,13)
        ;
        let index = decodedPath[5] //path.slice(14,15)
        ;
        //console.log(`[DECODED PATH]: ${coinType} | ${account} | ${change} | ${index}`)
        let addressType = "";
        Object.keys(formats).map((item, i)=>{
            if (formats[item] === decodedPath[1]) {
                addressType = item;
                purpose = formats[item];
            }
        });
        //const fpr = await app.getMasterFingerprint(); // this.getFingerprint()
        //const ourPubkey = await app.getExtendedPubkey(path); // TODO : ?
        //const ourKeyInfo = `[${fpr}/${purpose}/${coinType}/${account}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:", ourKeyInfo) // TODO: ??
        const walletPolicy = new (0, $7a6cef509ca65f26$exports.WalletPolicy)(name, this.descriptorTemplate, //this.getKeys(path)
        this.fetchXpubs(keychains) //this.getKeys(paths,keychains) // TODO: fix!!!
        );
        //console.log("Wallet Policy:",  walletPolicy)
        const [policyId, policyHmac] = await app.registerWallet(walletPolicy);
        //console.log(`[Policy ID]: ${policyId.toString("hex")} | [Policy HMAC]: ${policyHmac.toString("hex")}`);
        //console.assert(policyId.compare(walletPolicy.getId()) == 0)
        const walletAddress = await app.getWalletAddress(walletPolicy, policyHmac, parseInt(change) || 0, parseInt(index) || 0, true);
        //console.log(`Multisig wallet address: ${walletAddress}`);
        this.wallet.policyHmac = policyHmac;
        this.wallet.walletPolicy = walletPolicy;
        this.wallet.address = walletAddress;
        return this.wallet;
    }
    async signMessage(path, message, RandS = false) {
        const sig = await this.appBtcNew.signMessage(path, $586cf8d59d7800a2$require$Buffer.from(message, "hex"));
        //console.log("[SIG]: ", sig)
        if (RandS) {
            this.debugger && console.log(sig);
            return $586cf8d59d7800a2$require$Buffer.concat([
                $586cf8d59d7800a2$require$Buffer.from(sig.r, "hex"),
                $586cf8d59d7800a2$require$Buffer.from(sig.s, "hex")
            ]);
        } else return sig;
    }
    /**
     * Function used to partially sign a PSBT
     */ async signPsbt() {
        //path="m/44'/1'/0'"
        const app = new (0, $7a6cef509ca65f26$exports.AppClient)(this.transport);
        //listen(log => console.log(log))
        //const fpr = await this.getFingerprint()
        // ==> Register a multisig wallet named "FRZN Wallet"
        //const ourPubkey = await this.getXpub(path)
        //const ourKeyInfo = `[${fpr}${path.slice(1)}]${ourPubkey}`;
        //console.log("My Ledger XPubKey:",ourKeyInfo) // TODO: ??
        // ==> Sign a psbt
        const rawPsbtBase64 = this.b64; // a base64-encoded psbt file to sign
        const signingPolicy = this.wallet.walletPolicy //multisigPolicy; // an instance of WalletPolicy
        ;
        const signingPolicyHmac = this.wallet.policyHmac //policyHmac; // if not a default wallet policy, this must also be set
        ;
        if (!rawPsbtBase64 || !signingPolicy) {
            console.log("Nothing to sign");
            await transport.close();
            return;
        }
        const psbtBufToSign = $586cf8d59d7800a2$require$Buffer.from(this.b64, "base64");
        const psbtToSign = new (0, $7a6cef509ca65f26$exports.PsbtV2)();
        psbtToSign.deserialize(psbtBufToSign);
        const signatures = await app.signPsbt(psbtToSign, signingPolicy, signingPolicyHmac);
        //const result = await app.signPsbt(this.b64, signingPolicy, signingPolicyHmac);
        //console.log("Returned signatures:");
        //console.log(`${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`);
        //console.log("[SIGN RES]: ", signatures)
        this.addSignatures(signatures);
        // result.map((input,i)=>{
        //     //this.addSignature(result[i][1].pubkey,result[i][1].signature,result[i])
        //     console.log("[???]: ",input[0],input[1].pubkey,input[1].signature)
        //     this.addSignature(input[1].pubkey,input[1].signature,input[0])
        // })
        const psbt = new (0, $7a6cef509ca65f26$exports.PsbtV2)();
        const psbtBuf = $586cf8d59d7800a2$require$Buffer.from(this.b64, "base64");
        psbt.deserialize(psbtBuf);
        const serialized = psbt.serialize();
        //console.log("PSBT",this.psbt)
        //console.log("PSBTV2",psbt)
        //console.log("serialized",serialized.toString("hex"))
        return signatures;
    }
    /**
     * Function used to create a transaction with App Bitcoin < 2.1.0 P2PKH
     */ async createPaymentTX(ins = [], keyChain, outScript = "", segwit = true, additionals = [
        "bech32"
    ]) {
        const res = await this.appBtcNew.createPaymentTransaction({
            inputs: [
                ...ins
            ],
            associatedKeysets: [
                ...keyChain
            ],
            //changePath: [],
            outputScriptHex: outScript,
            //lockTime: 0,
            //sigHashType: 1,
            segwit: segwit,
            additionals: additionals
        });
        return res;
    }
    /**
     * Function used to sign a transaction with App Bitcoin < 2.1.0 P2SH
     */ async signP2SHTX(ins = [], keyChain, outScript = "", segwit = true, additionals = [
        "bech32"
    ]) {
        const res = await this.appBtcNew.signP2SHTransaction({
            inputs: [
                ...ins
            ],
            associatedKeysets: [
                ...keyChain
            ],
            changePath: [
                ...keyChain
            ],
            outputScriptHex: outScript,
            segwit: segwit,
            //transactionVersion: 2,
            //lockTime: 0,
            //sigHashType: 1,
            additionals: additionals
        });
        return res;
    }
    /**
     * Function used to add a signature to the PSBT
     */ async addSignatureToInput(pubkey, signature, index) {
        this.psbt.data.inputs.length > 0 && this.psbt.data.inputs.map((input, i)=>{
            console.log("INPUT", i, index);
            //console.log("!!!", input)
            if (input.partialSig?.length > 0) {
                console.log("adding a new signature", i);
                //input.partialSig.push({pubkey:pubkey,signature:signature})
                this.psbt.data.inputs[index].partialSig.push({
                    pubkey: pubkey,
                    signature: signature
                });
            } else {
                console.log("update a new signature", i);
                this.psbt.updateInput(index, {
                    partialSig: [
                        {
                            pubkey: pubkey,
                            signature: signature
                        }
                    ]
                });
            }
        });
    }
    async addSignatures(signatures) {
        //console.log(this.psbt.data.inputs)
        //console.log(signatures)
        signatures.map((el, i)=>{
            const index = el[0];
            const { pubkey: pubkey, signature: signature } = el[1];
            if (this.psbt.data.inputs[index]?.partialSig) this.psbt.data.inputs[index].partialSig.push({
                pubkey: pubkey,
                signature: signature
            });
            else this.psbt.updateInput(index, {
                partialSig: [
                    {
                        pubkey: pubkey,
                        signature: signature
                    }
                ]
            }); //TODO: input index
        //console.log('RESULT[i]', el, i, index);
        });
    }
    /**
     * Function used to validate PSBT's signatures
     */ async validateSignatures(callback) {
        //this.decode()
        //console.log(this.psbt)
        const validator = "";
        //const validate = await this.psbt.validateSignaturesOfAllInputs()
        //console.log("[VALIDATE]: ", validate)
        this.psbt.finalizeAllInputs();
        return this.psbt.extractTransaction(true) //.toHex()
        ;
    //console.log("Finalized",)
    //console.log("Extract Transaction",)
    }
    /**
     * Function used to edit PSBT data fields
     */ editPsbt(to = "", amount) {
        this.psbt.addInput({
            hash: $586cf8d59d7800a2$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000", "hex"),
            index: 0,
            //nonWitnessUtxo: Buffer.from(""), //utxo.toBuffer(),
            redeemScript: $586cf8d59d7800a2$require$Buffer.from("")
        });
        this.psbt.addOutput({
            address: to,
            value: amount
        });
    //this.psbt.setVersion(version);
    }
    /**
     * Function used to retrieve the corresponding Keychains involved in a PSBT
     */ /*
    getKeys(path="m/44'/0'/0'/0/0",keychains) {
        const xpubs = this.fetchXpubs(keychains)

        //const keyChains = this.psbt.data.inputs[0].bip32Derivation
        
        const keys = []

        xpubs.map((key,i)=>{
            keys.push(`[${key.fgpr}${path.slice(1)}]${key.xpub}`) //v2.1.3
        })
        
        return keys
    }
    */ /**
     * Function used to fetch the Extended pubkeys involved in a Keychains from an ENV file/Server
     */ /*
    fetchXpubs(keychains) {
        const xpubsList = keychains;
        const xpubs = xpubsList.split(",").map(key=>{
            const xpubsMap = key.split("|")
            return {fgpr: xpubsMap[0], xpub: xpubsMap[1]}
        })
        return xpubs
    }
    */ fetchXpubs(keychains) {
        const xpubs = keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const xpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            return {
                fgpr: derivation[0],
                path: xpub[0],
                xpub: xpub[1]
            };
        });
        const keys = [];
        xpubs.map((key, i)=>{
            keys.push(`[${key.fgpr}${key.path.slice(1)}]${key.xpub}`) //v2.1.3
            ;
        });
        //console.log(keys)
        return keys;
    }
    /**
     * Set the Descriptor Template
     */ setDescriptorTemplate(descriptor) {
        this.descriptorTemplate = descriptor;
    }
    /**
     * Function used to export a PSBT object to base64
     */ toBase64() {
        return this.psbt.toBase64();
    }
    compressPublicKey(pk) {
        const sliced = $586cf8d59d7800a2$require$Buffer.from(pk, "hex").slice(1);
        const len = sliced.length;
        const x = sliced.slice(0, 32);
        const y = sliced.slice(32, sliced.length);
        const prefix = BigInt(`0x${y.toString("hex")}`) % 2n === 0n ? "02" : "03";
        return (prefix + pk.slice(2, 66)).toString("hex");
    }
}
function $586cf8d59d7800a2$var$base64ToHex(str) {
    const raw = atob(str);
    let result = "";
    for(let i = 0; i < raw.length; i++){
        const hex = raw.charCodeAt(i).toString(16);
        result += hex.length === 2 ? hex : "0" + hex;
    }
    return result.toUpperCase();
}
var //module.exports = HWI
$586cf8d59d7800a2$export$2e2bcd8739ae039 = $586cf8d59d7800a2$var$HWI;


//#!/usr/bin/env node
/**
 * BTC Signer
 * - bip32 / Hierarchical Deterministic Wallets
 * - bip38 / Passphrase-protected private key
 * - bip39 / Mnemonic code for generating deterministic keys
 * - bip43 / Purpose field for deterministic Wallets
 * - bip44 / Multi-Account Hierarchy for Deterministic Wallets
 * - bip45-49 / P2SH Multi-sig Wallets / Multi-script hierarchy for multi-sig Walets
 * - bip63 / Stealth Addresses
 * - bip83-84-85-86-87-88
 * - bip93 / Codex32
 * - bip98 / Fast Merkle Trees
 * - bip173 / Base32 address format for native v0-16 witness outputs
 * - bip178 / WIF Private Key
 * - bip350 / Bech32m format for v1+ witness addresses * 
 * - bip388 / Wallet Policies for Descriptor Wallets
 */ var $44edd02a6be448cd$exports = {};

$parcel$export($44edd02a6be448cd$exports, "randomBytes", () => $44edd02a6be448cd$export$5f828d93ff035aa8, (v) => $44edd02a6be448cd$export$5f828d93ff035aa8 = v);
$parcel$export($44edd02a6be448cd$exports, "rng", () => $44edd02a6be448cd$export$cd94982b18c6332c, (v) => $44edd02a6be448cd$export$cd94982b18c6332c = v);
$parcel$export($44edd02a6be448cd$exports, "pseudoRandomBytes", () => $44edd02a6be448cd$export$1d518568e4f529b0, (v) => $44edd02a6be448cd$export$1d518568e4f529b0 = v);
$parcel$export($44edd02a6be448cd$exports, "prng", () => $44edd02a6be448cd$export$5285b6d41c912b41, (v) => $44edd02a6be448cd$export$5285b6d41c912b41 = v);
$parcel$export($44edd02a6be448cd$exports, "createHash", () => $44edd02a6be448cd$export$2fb37efbf6ae0c0e, (v) => $44edd02a6be448cd$export$2fb37efbf6ae0c0e = v);
$parcel$export($44edd02a6be448cd$exports, "Hash", () => $44edd02a6be448cd$export$ab85ecd77ce6a5cd, (v) => $44edd02a6be448cd$export$ab85ecd77ce6a5cd = v);
$parcel$export($44edd02a6be448cd$exports, "createHmac", () => $44edd02a6be448cd$export$da39cf97e1eb7c91, (v) => $44edd02a6be448cd$export$da39cf97e1eb7c91 = v);
$parcel$export($44edd02a6be448cd$exports, "Hmac", () => $44edd02a6be448cd$export$52a9039d7177394f, (v) => $44edd02a6be448cd$export$52a9039d7177394f = v);
$parcel$export($44edd02a6be448cd$exports, "getHashes", () => $44edd02a6be448cd$export$f7201db400317331, (v) => $44edd02a6be448cd$export$f7201db400317331 = v);
$parcel$export($44edd02a6be448cd$exports, "pbkdf2", () => $44edd02a6be448cd$export$448fa22aedc9dbca, (v) => $44edd02a6be448cd$export$448fa22aedc9dbca = v);
$parcel$export($44edd02a6be448cd$exports, "pbkdf2Sync", () => $44edd02a6be448cd$export$b80c7ba289c8fa56, (v) => $44edd02a6be448cd$export$b80c7ba289c8fa56 = v);
$parcel$export($44edd02a6be448cd$exports, "Cipher", () => $44edd02a6be448cd$export$26e5786e8ac8e530, (v) => $44edd02a6be448cd$export$26e5786e8ac8e530 = v);
$parcel$export($44edd02a6be448cd$exports, "createCipher", () => $44edd02a6be448cd$export$bdd223f16383713e, (v) => $44edd02a6be448cd$export$bdd223f16383713e = v);
$parcel$export($44edd02a6be448cd$exports, "Cipheriv", () => $44edd02a6be448cd$export$20533d26f07f1ee0, (v) => $44edd02a6be448cd$export$20533d26f07f1ee0 = v);
$parcel$export($44edd02a6be448cd$exports, "createCipheriv", () => $44edd02a6be448cd$export$2f64596b8cbf08b4, (v) => $44edd02a6be448cd$export$2f64596b8cbf08b4 = v);
$parcel$export($44edd02a6be448cd$exports, "Decipher", () => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a, (v) => $44edd02a6be448cd$export$2ce6d8d0e8b04e1a = v);
$parcel$export($44edd02a6be448cd$exports, "createDecipher", () => $44edd02a6be448cd$export$12ada9414fbc594c, (v) => $44edd02a6be448cd$export$12ada9414fbc594c = v);
$parcel$export($44edd02a6be448cd$exports, "Decipheriv", () => $44edd02a6be448cd$export$f5e7e39d57cd9700, (v) => $44edd02a6be448cd$export$f5e7e39d57cd9700 = v);
$parcel$export($44edd02a6be448cd$exports, "createDecipheriv", () => $44edd02a6be448cd$export$36b6d6ef312eab39, (v) => $44edd02a6be448cd$export$36b6d6ef312eab39 = v);
$parcel$export($44edd02a6be448cd$exports, "getCiphers", () => $44edd02a6be448cd$export$58a258485f1e49f6, (v) => $44edd02a6be448cd$export$58a258485f1e49f6 = v);
$parcel$export($44edd02a6be448cd$exports, "listCiphers", () => $44edd02a6be448cd$export$dedd8dc3dc62b370, (v) => $44edd02a6be448cd$export$dedd8dc3dc62b370 = v);
$parcel$export($44edd02a6be448cd$exports, "DiffieHellmanGroup", () => $44edd02a6be448cd$export$971862a2fcb1bb40, (v) => $44edd02a6be448cd$export$971862a2fcb1bb40 = v);
$parcel$export($44edd02a6be448cd$exports, "createDiffieHellmanGroup", () => $44edd02a6be448cd$export$c6ff6a88acbeaf40, (v) => $44edd02a6be448cd$export$c6ff6a88acbeaf40 = v);
$parcel$export($44edd02a6be448cd$exports, "getDiffieHellman", () => $44edd02a6be448cd$export$fdc27893e98845cc, (v) => $44edd02a6be448cd$export$fdc27893e98845cc = v);
$parcel$export($44edd02a6be448cd$exports, "createDiffieHellman", () => $44edd02a6be448cd$export$6671fb9a1323bed, (v) => $44edd02a6be448cd$export$6671fb9a1323bed = v);
$parcel$export($44edd02a6be448cd$exports, "DiffieHellman", () => $44edd02a6be448cd$export$d74daf141a551db, (v) => $44edd02a6be448cd$export$d74daf141a551db = v);
$parcel$export($44edd02a6be448cd$exports, "createSign", () => $44edd02a6be448cd$export$45df7cae684751af, (v) => $44edd02a6be448cd$export$45df7cae684751af = v);
$parcel$export($44edd02a6be448cd$exports, "Sign", () => $44edd02a6be448cd$export$1db683ad541682f6, (v) => $44edd02a6be448cd$export$1db683ad541682f6 = v);
$parcel$export($44edd02a6be448cd$exports, "createVerify", () => $44edd02a6be448cd$export$6f65485f87568e37, (v) => $44edd02a6be448cd$export$6f65485f87568e37 = v);
$parcel$export($44edd02a6be448cd$exports, "Verify", () => $44edd02a6be448cd$export$91a8e56769aeb334, (v) => $44edd02a6be448cd$export$91a8e56769aeb334 = v);
$parcel$export($44edd02a6be448cd$exports, "createECDH", () => $44edd02a6be448cd$export$2d4117e99c2179e4, (v) => $44edd02a6be448cd$export$2d4117e99c2179e4 = v);
$parcel$export($44edd02a6be448cd$exports, "publicEncrypt", () => $44edd02a6be448cd$export$512823e338ddb1b7, (v) => $44edd02a6be448cd$export$512823e338ddb1b7 = v);
$parcel$export($44edd02a6be448cd$exports, "privateEncrypt", () => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3, (v) => $44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = v);
$parcel$export($44edd02a6be448cd$exports, "publicDecrypt", () => $44edd02a6be448cd$export$b9d55ff329113abd, (v) => $44edd02a6be448cd$export$b9d55ff329113abd = v);
$parcel$export($44edd02a6be448cd$exports, "privateDecrypt", () => $44edd02a6be448cd$export$7efb24e2fddf99b9, (v) => $44edd02a6be448cd$export$7efb24e2fddf99b9 = v);
$parcel$export($44edd02a6be448cd$exports, "randomFill", () => $44edd02a6be448cd$export$bb1abf2ce84fc7e8, (v) => $44edd02a6be448cd$export$bb1abf2ce84fc7e8 = v);
$parcel$export($44edd02a6be448cd$exports, "randomFillSync", () => $44edd02a6be448cd$export$2f7171e78e524d5e, (v) => $44edd02a6be448cd$export$2f7171e78e524d5e = v);
$parcel$export($44edd02a6be448cd$exports, "createCredentials", () => $44edd02a6be448cd$export$e1d879b482f37d98, (v) => $44edd02a6be448cd$export$e1d879b482f37d98 = v);
$parcel$export($44edd02a6be448cd$exports, "constants", () => $44edd02a6be448cd$export$1a988e7317c65621, (v) => $44edd02a6be448cd$export$1a988e7317c65621 = v);
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$5f828d93ff035aa8;
var $44edd02a6be448cd$export$cd94982b18c6332c;
var $44edd02a6be448cd$export$1d518568e4f529b0;
var $44edd02a6be448cd$export$5285b6d41c912b41;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$2fb37efbf6ae0c0e;
var $44edd02a6be448cd$export$ab85ecd77ce6a5cd;
// eslint-disable-next-line no-multi-assign
var $44edd02a6be448cd$export$da39cf97e1eb7c91;
var $44edd02a6be448cd$export$52a9039d7177394f;
var $44edd02a6be448cd$export$f7201db400317331;
var $44edd02a6be448cd$export$448fa22aedc9dbca;
var $44edd02a6be448cd$export$b80c7ba289c8fa56;
var $44edd02a6be448cd$export$26e5786e8ac8e530;
var $44edd02a6be448cd$export$bdd223f16383713e;
var $44edd02a6be448cd$export$20533d26f07f1ee0;
var $44edd02a6be448cd$export$2f64596b8cbf08b4;
var $44edd02a6be448cd$export$2ce6d8d0e8b04e1a;
var $44edd02a6be448cd$export$12ada9414fbc594c;
var $44edd02a6be448cd$export$f5e7e39d57cd9700;
var $44edd02a6be448cd$export$36b6d6ef312eab39;
var $44edd02a6be448cd$export$58a258485f1e49f6;
var $44edd02a6be448cd$export$dedd8dc3dc62b370;
var $44edd02a6be448cd$export$971862a2fcb1bb40;
var $44edd02a6be448cd$export$c6ff6a88acbeaf40;
var $44edd02a6be448cd$export$fdc27893e98845cc;
var $44edd02a6be448cd$export$6671fb9a1323bed;
var $44edd02a6be448cd$export$d74daf141a551db;
var $44edd02a6be448cd$export$45df7cae684751af;
var $44edd02a6be448cd$export$1db683ad541682f6;
var $44edd02a6be448cd$export$6f65485f87568e37;
var $44edd02a6be448cd$export$91a8e56769aeb334;
var $44edd02a6be448cd$export$2d4117e99c2179e4;
var $44edd02a6be448cd$export$512823e338ddb1b7;
var $44edd02a6be448cd$export$9d0e0c0c4a8d30f3;
var $44edd02a6be448cd$export$b9d55ff329113abd;
var $44edd02a6be448cd$export$7efb24e2fddf99b9;
var $44edd02a6be448cd$export$bb1abf2ce84fc7e8;
var $44edd02a6be448cd$export$2f7171e78e524d5e;
var $44edd02a6be448cd$export$e1d879b482f37d98;
var $44edd02a6be448cd$export$1a988e7317c65621;
"use strict";

$44edd02a6be448cd$export$5f828d93ff035aa8 = $44edd02a6be448cd$export$cd94982b18c6332c = $44edd02a6be448cd$export$1d518568e4f529b0 = $44edd02a6be448cd$export$5285b6d41c912b41 = (parcelRequire("hkN9y"));

$44edd02a6be448cd$export$2fb37efbf6ae0c0e = $44edd02a6be448cd$export$ab85ecd77ce6a5cd = (parcelRequire("1R2J7"));

$44edd02a6be448cd$export$da39cf97e1eb7c91 = $44edd02a6be448cd$export$52a9039d7177394f = (parcelRequire("1iL1D"));
var $aaef572789dc684d$exports = {};
"use strict";

$aaef572789dc684d$exports = (parcelRequire("6swAi"));


var $44edd02a6be448cd$var$algoKeys = Object.keys($aaef572789dc684d$exports);
var $44edd02a6be448cd$var$hashes = [
    "sha1",
    "sha224",
    "sha256",
    "sha384",
    "sha512",
    "md5",
    "rmd160"
].concat($44edd02a6be448cd$var$algoKeys);
$44edd02a6be448cd$export$f7201db400317331 = function() {
    return $44edd02a6be448cd$var$hashes;
};

var $lORrZ = parcelRequire("lORrZ");
$44edd02a6be448cd$export$448fa22aedc9dbca = $lORrZ.pbkdf2;
$44edd02a6be448cd$export$b80c7ba289c8fa56 = $lORrZ.pbkdf2Sync;
var $a97f913e2ff95e3b$export$bdd223f16383713e;
var $a97f913e2ff95e3b$export$26e5786e8ac8e530;
var $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
var $a97f913e2ff95e3b$export$20533d26f07f1ee0;
var $a97f913e2ff95e3b$export$12ada9414fbc594c;
var $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
var $a97f913e2ff95e3b$export$36b6d6ef312eab39;
var $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
var $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $a97f913e2ff95e3b$export$58a258485f1e49f6;
var $f85287bc79724838$exports = {};

var $26nOC = parcelRequire("26nOC");
var $675eb908dbde2e68$export$eab97d15b1788b8d;
var $675eb908dbde2e68$export$26e5786e8ac8e530;
var $675eb908dbde2e68$export$cc8859615686b300;
var $675eb908dbde2e68$export$8ad3f227af08fcc5;
var $675eb908dbde2e68$export$947646e34766044f;
"use strict";

$675eb908dbde2e68$export$eab97d15b1788b8d = (parcelRequire("dyok1"));

$675eb908dbde2e68$export$26e5786e8ac8e530 = (parcelRequire("enfpo"));

$675eb908dbde2e68$export$cc8859615686b300 = (parcelRequire("dB8Kv"));

$675eb908dbde2e68$export$8ad3f227af08fcc5 = (parcelRequire("eiYbc"));

$675eb908dbde2e68$export$947646e34766044f = (parcelRequire("5ye6K"));



var $dlqwk = parcelRequire("dlqwk");

var $1U9GM = parcelRequire("1U9GM");
var $f85287bc79724838$require$Buffer = $1U9GM.Buffer;
var $f85287bc79724838$var$modes = {
    "des-ede3-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede3": $675eb908dbde2e68$export$947646e34766044f,
    "des-ede-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$947646e34766044f),
    "des-ede": $675eb908dbde2e68$export$947646e34766044f,
    "des-cbc": $675eb908dbde2e68$export$8ad3f227af08fcc5.instantiate($675eb908dbde2e68$export$cc8859615686b300),
    "des-ecb": $675eb908dbde2e68$export$cc8859615686b300
};
$f85287bc79724838$var$modes.des = $f85287bc79724838$var$modes["des-cbc"];
$f85287bc79724838$var$modes.des3 = $f85287bc79724838$var$modes["des-ede3-cbc"];
$f85287bc79724838$exports = $f85287bc79724838$var$DES;
$dlqwk($f85287bc79724838$var$DES, $26nOC);
function $f85287bc79724838$var$DES(opts) {
    $26nOC.call(this);
    var modeName = opts.mode.toLowerCase();
    var mode = $f85287bc79724838$var$modes[modeName];
    var type;
    if (opts.decrypt) type = "decrypt";
    else type = "encrypt";
    var key = opts.key;
    if (!$f85287bc79724838$require$Buffer.isBuffer(key)) key = $f85287bc79724838$require$Buffer.from(key);
    if (modeName === "des-ede" || modeName === "des-ede-cbc") key = $f85287bc79724838$require$Buffer.concat([
        key,
        key.slice(0, 8)
    ]);
    var iv = opts.iv;
    if (!$f85287bc79724838$require$Buffer.isBuffer(iv)) iv = $f85287bc79724838$require$Buffer.from(iv);
    this._des = mode.create({
        key: key,
        iv: iv,
        type: type
    });
}
$f85287bc79724838$var$DES.prototype._update = function(data) {
    return $f85287bc79724838$require$Buffer.from(this._des.update(data));
};
$f85287bc79724838$var$DES.prototype._final = function() {
    return $f85287bc79724838$require$Buffer.from(this._des.final());
};



var $7Zu82 = parcelRequire("7Zu82");

var $5Su5u = parcelRequire("5Su5u");
var $0649907c0434f982$exports = {};

$parcel$export($0649907c0434f982$exports, "des-ecb", () => $0649907c0434f982$export$116f8a5cee447347, (v) => $0649907c0434f982$export$116f8a5cee447347 = v);
$parcel$export($0649907c0434f982$exports, "des-cbc", () => $0649907c0434f982$export$7483c4066bfb7ae9, (v) => $0649907c0434f982$export$7483c4066bfb7ae9 = v);
$parcel$export($0649907c0434f982$exports, "des", () => $0649907c0434f982$export$e7a565d2e588bb06, (v) => $0649907c0434f982$export$e7a565d2e588bb06 = v);
$parcel$export($0649907c0434f982$exports, "des-ede3-cbc", () => $0649907c0434f982$export$aaa2f54a426f3eb8, (v) => $0649907c0434f982$export$aaa2f54a426f3eb8 = v);
$parcel$export($0649907c0434f982$exports, "des3", () => $0649907c0434f982$export$eba20568dde4ada, (v) => $0649907c0434f982$export$eba20568dde4ada = v);
$parcel$export($0649907c0434f982$exports, "des-ede3", () => $0649907c0434f982$export$d3b5e5996938f5ae, (v) => $0649907c0434f982$export$d3b5e5996938f5ae = v);
$parcel$export($0649907c0434f982$exports, "des-ede-cbc", () => $0649907c0434f982$export$57c08356130bc99b, (v) => $0649907c0434f982$export$57c08356130bc99b = v);
$parcel$export($0649907c0434f982$exports, "des-ede", () => $0649907c0434f982$export$c7169791d5c1e65d, (v) => $0649907c0434f982$export$c7169791d5c1e65d = v);
var $0649907c0434f982$export$116f8a5cee447347;
var $0649907c0434f982$export$7483c4066bfb7ae9;
var $0649907c0434f982$export$e7a565d2e588bb06;
var $0649907c0434f982$export$aaa2f54a426f3eb8;
var $0649907c0434f982$export$eba20568dde4ada;
var $0649907c0434f982$export$d3b5e5996938f5ae;
var $0649907c0434f982$export$57c08356130bc99b;
var $0649907c0434f982$export$c7169791d5c1e65d;
$0649907c0434f982$export$116f8a5cee447347 = {
    key: 8,
    iv: 0
};
$0649907c0434f982$export$7483c4066bfb7ae9 = $0649907c0434f982$export$e7a565d2e588bb06 = {
    key: 8,
    iv: 8
};
$0649907c0434f982$export$aaa2f54a426f3eb8 = $0649907c0434f982$export$eba20568dde4ada = {
    key: 24,
    iv: 8
};
$0649907c0434f982$export$d3b5e5996938f5ae = {
    key: 24,
    iv: 0
};
$0649907c0434f982$export$57c08356130bc99b = {
    key: 16,
    iv: 8
};
$0649907c0434f982$export$c7169791d5c1e65d = {
    key: 16,
    iv: 0
};



var $bSYjd = parcelRequire("bSYjd");
function $a97f913e2ff95e3b$var$createCipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createCipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createDecipher(suite, password) {
    suite = suite.toLowerCase();
    var keyLen, ivLen;
    if ($5Su5u[suite]) {
        keyLen = $5Su5u[suite].key;
        ivLen = $5Su5u[suite].iv;
    } else if ($0649907c0434f982$exports[suite]) {
        keyLen = $0649907c0434f982$exports[suite].key * 8;
        ivLen = $0649907c0434f982$exports[suite].iv;
    } else throw new TypeError("invalid suite type");
    var keys = $bSYjd(password, false, keyLen, ivLen);
    return $a97f913e2ff95e3b$var$createDecipheriv(suite, keys.key, keys.iv);
}
function $a97f913e2ff95e3b$var$createCipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createCipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$createDecipheriv(suite, key, iv) {
    suite = suite.toLowerCase();
    if ($5Su5u[suite]) return $7Zu82.createDecipheriv(suite, key, iv);
    if ($0649907c0434f982$exports[suite]) return new $f85287bc79724838$exports({
        key: key,
        iv: iv,
        mode: suite,
        decrypt: true
    });
    throw new TypeError("invalid suite type");
}
function $a97f913e2ff95e3b$var$getCiphers() {
    return Object.keys($0649907c0434f982$exports).concat($7Zu82.getCiphers());
}
$a97f913e2ff95e3b$export$bdd223f16383713e = $a97f913e2ff95e3b$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$var$createCipher;
$a97f913e2ff95e3b$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$var$createCipheriv;
$a97f913e2ff95e3b$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$var$createDecipher;
$a97f913e2ff95e3b$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$var$createDecipheriv;
$a97f913e2ff95e3b$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$58a258485f1e49f6 = $a97f913e2ff95e3b$var$getCiphers;


$44edd02a6be448cd$export$26e5786e8ac8e530 = $a97f913e2ff95e3b$export$26e5786e8ac8e530;
$44edd02a6be448cd$export$bdd223f16383713e = $a97f913e2ff95e3b$export$bdd223f16383713e;
$44edd02a6be448cd$export$20533d26f07f1ee0 = $a97f913e2ff95e3b$export$20533d26f07f1ee0;
$44edd02a6be448cd$export$2f64596b8cbf08b4 = $a97f913e2ff95e3b$export$2f64596b8cbf08b4;
$44edd02a6be448cd$export$2ce6d8d0e8b04e1a = $a97f913e2ff95e3b$export$2ce6d8d0e8b04e1a;
$44edd02a6be448cd$export$12ada9414fbc594c = $a97f913e2ff95e3b$export$12ada9414fbc594c;
$44edd02a6be448cd$export$f5e7e39d57cd9700 = $a97f913e2ff95e3b$export$f5e7e39d57cd9700;
$44edd02a6be448cd$export$36b6d6ef312eab39 = $a97f913e2ff95e3b$export$36b6d6ef312eab39;
$44edd02a6be448cd$export$58a258485f1e49f6 = $a97f913e2ff95e3b$export$58a258485f1e49f6;
$44edd02a6be448cd$export$dedd8dc3dc62b370 = $a97f913e2ff95e3b$export$dedd8dc3dc62b370;
var $4387b1fafb8a1868$export$971862a2fcb1bb40;
var $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
var $4387b1fafb8a1868$export$fdc27893e98845cc;
var $4387b1fafb8a1868$export$6671fb9a1323bed;
var $4387b1fafb8a1868$export$d74daf141a551db;

var $6ZWSX = parcelRequire("6ZWSX");
var $4387b1fafb8a1868$require$Buffer = $6ZWSX.Buffer;
var $7f34ba2fa9025258$exports = {};

var $hkN9y = parcelRequire("hkN9y");
$7f34ba2fa9025258$exports = $7f34ba2fa9025258$var$findPrime;
$7f34ba2fa9025258$var$findPrime.simpleSieve = $7f34ba2fa9025258$var$simpleSieve;
$7f34ba2fa9025258$var$findPrime.fermatTest = $7f34ba2fa9025258$var$fermatTest;

var $5vmVB = parcelRequire("5vmVB");
var $7f34ba2fa9025258$var$TWENTYFOUR = new $5vmVB(24);
var $bac5f004a90de4c6$exports = {};

var $7Zvov = parcelRequire("7Zvov");

var $7JHF0 = parcelRequire("7JHF0");
function $bac5f004a90de4c6$var$MillerRabin(rand) {
    this.rand = rand || new $7JHF0.Rand();
}
$bac5f004a90de4c6$exports = $bac5f004a90de4c6$var$MillerRabin;
$bac5f004a90de4c6$var$MillerRabin.create = function create(rand) {
    return new $bac5f004a90de4c6$var$MillerRabin(rand);
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randbelow = function _randbelow(n) {
    var len = n.bitLength();
    var min_bytes = Math.ceil(len / 8);
    // Generage random bytes until a number less than n is found.
    // This ensures that 0..n-1 have an equal probability of being selected.
    do var a = new $7Zvov(this.rand.generate(min_bytes));
    while (a.cmp(n) >= 0);
    return a;
};
$bac5f004a90de4c6$var$MillerRabin.prototype._randrange = function _randrange(start, stop) {
    // Generate a random number greater than or equal to start and less than stop.
    var size = stop.sub(start);
    return start.add(this._randbelow(size));
};
$bac5f004a90de4c6$var$MillerRabin.prototype.test = function test(n, k, cb) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    var prime = true;
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        if (cb) cb(a);
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return false;
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) return false;
    }
    return prime;
};
$bac5f004a90de4c6$var$MillerRabin.prototype.getDivisor = function getDivisor(n, k) {
    var len = n.bitLength();
    var red = $7Zvov.mont(n);
    var rone = new $7Zvov(1).toRed(red);
    if (!k) k = Math.max(1, len / 48 | 0);
    // Find d and s, (n - 1) = (2 ^ s) * d;
    var n1 = n.subn(1);
    for(var s = 0; !n1.testn(s); s++);
    var d = n.shrn(s);
    var rn1 = n1.toRed(red);
    for(; k > 0; k--){
        var a = this._randrange(new $7Zvov(2), n1);
        var g = n.gcd(a);
        if (g.cmpn(1) !== 0) return g;
        var x = a.toRed(red).redPow(d);
        if (x.cmp(rone) === 0 || x.cmp(rn1) === 0) continue;
        for(var i = 1; i < s; i++){
            x = x.redSqr();
            if (x.cmp(rone) === 0) return x.fromRed().subn(1).gcd(n);
            if (x.cmp(rn1) === 0) break;
        }
        if (i === s) {
            x = x.redSqr();
            return x.fromRed().subn(1).gcd(n);
        }
    }
    return false;
};


var $7f34ba2fa9025258$var$millerRabin = new $bac5f004a90de4c6$exports();
var $7f34ba2fa9025258$var$ONE = new $5vmVB(1);
var $7f34ba2fa9025258$var$TWO = new $5vmVB(2);
var $7f34ba2fa9025258$var$FIVE = new $5vmVB(5);
var $7f34ba2fa9025258$var$SIXTEEN = new $5vmVB(16);
var $7f34ba2fa9025258$var$EIGHT = new $5vmVB(8);
var $7f34ba2fa9025258$var$TEN = new $5vmVB(10);
var $7f34ba2fa9025258$var$THREE = new $5vmVB(3);
var $7f34ba2fa9025258$var$SEVEN = new $5vmVB(7);
var $7f34ba2fa9025258$var$ELEVEN = new $5vmVB(11);
var $7f34ba2fa9025258$var$FOUR = new $5vmVB(4);
var $7f34ba2fa9025258$var$TWELVE = new $5vmVB(12);
var $7f34ba2fa9025258$var$primes = null;
function $7f34ba2fa9025258$var$_getPrimes() {
    if ($7f34ba2fa9025258$var$primes !== null) return $7f34ba2fa9025258$var$primes;
    var limit = 0x100000;
    var res = [];
    res[0] = 2;
    for(var i = 1, k = 3; k < limit; k += 2){
        var sqrt = Math.ceil(Math.sqrt(k));
        for(var j = 0; j < i && res[j] <= sqrt; j++)if (k % res[j] === 0) break;
        if (i !== j && res[j] <= sqrt) continue;
        res[i++] = k;
    }
    $7f34ba2fa9025258$var$primes = res;
    return res;
}
function $7f34ba2fa9025258$var$simpleSieve(p) {
    var primes = $7f34ba2fa9025258$var$_getPrimes();
    for(var i = 0; i < primes.length; i++)if (p.modn(primes[i]) === 0) {
        if (p.cmpn(primes[i]) === 0) return true;
        else return false;
    }
    return true;
}
function $7f34ba2fa9025258$var$fermatTest(p) {
    var red = $5vmVB.mont(p);
    return $7f34ba2fa9025258$var$TWO.toRed(red).redPow(p.subn(1)).fromRed().cmpn(1) === 0;
}
function $7f34ba2fa9025258$var$findPrime(bits, gen) {
    if (bits < 16) {
        // this is what openssl does
        if (gen === 2 || gen === 5) return new $5vmVB([
            0x8c,
            0x7b
        ]);
        else return new $5vmVB([
            0x8c,
            0x27
        ]);
    }
    gen = new $5vmVB(gen);
    var num, n2;
    while(true){
        num = new $5vmVB($hkN9y(Math.ceil(bits / 8)));
        while(num.bitLength() > bits)num.ishrn(1);
        if (num.isEven()) num.iadd($7f34ba2fa9025258$var$ONE);
        if (!num.testn(1)) num.iadd($7f34ba2fa9025258$var$TWO);
        if (!gen.cmp($7f34ba2fa9025258$var$TWO)) while(num.mod($7f34ba2fa9025258$var$TWENTYFOUR).cmp($7f34ba2fa9025258$var$ELEVEN))num.iadd($7f34ba2fa9025258$var$FOUR);
        else if (!gen.cmp($7f34ba2fa9025258$var$FIVE)) while(num.mod($7f34ba2fa9025258$var$TEN).cmp($7f34ba2fa9025258$var$THREE))num.iadd($7f34ba2fa9025258$var$FOUR);
        n2 = num.shrn(1);
        if ($7f34ba2fa9025258$var$simpleSieve(n2) && $7f34ba2fa9025258$var$simpleSieve(num) && $7f34ba2fa9025258$var$fermatTest(n2) && $7f34ba2fa9025258$var$fermatTest(num) && $7f34ba2fa9025258$var$millerRabin.test(n2) && $7f34ba2fa9025258$var$millerRabin.test(num)) return num;
    }
}


var $f0f71b0d846b32d7$exports = {};
$f0f71b0d846b32d7$exports = JSON.parse('{"modp1":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a63a3620ffffffffffffffff"},"modp2":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece65381ffffffffffffffff"},"modp5":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca237327ffffffffffffffff"},"modp14":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aacaa68ffffffffffffffff"},"modp15":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a93ad2caffffffffffffffff"},"modp16":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c934063199ffffffffffffffff"},"modp17":{"gen":"02","prime":"ffffffffffffffffc90fdaa22168c234c4c6628b80dc1cd129024e088a67cc74020bbea63b139b22514a08798e3404ddef9519b3cd3a431b302b0a6df25f14374fe1356d6d51c245e485b576625e7ec6f44c42e9a637ed6b0bff5cb6f406b7edee386bfb5a899fa5ae9f24117c4b1fe649286651ece45b3dc2007cb8a163bf0598da48361c55d39a69163fa8fd24cf5f83655d23dca3ad961c62f356208552bb9ed529077096966d670c354e4abc9804f1746c08ca18217c32905e462e36ce3be39e772c180e86039b2783a2ec07a28fb5c55df06f4c52c9de2bcbf6955817183995497cea956ae515d2261898fa051015728e5a8aaac42dad33170d04507a33a85521abdf1cba64ecfb850458dbef0a8aea71575d060c7db3970f85a6e1e4c7abf5ae8cdb0933d71e8c94e04a25619dcee3d2261ad2ee6bf12ffa06d98a0864d87602733ec86a64521f2b18177b200cbbe117577a615d6c770988c0bad946e208e24fa074e5ab3143db5bfce0fd108e4b82d120a92108011a723c12a787e6d788719a10bdba5b2699c327186af4e23c1a946834b6150bda2583e9ca2ad44ce8dbbbc2db04de8ef92e8efc141fbecaa6287c59474e6bc05d99b2964fa090c3a2233ba186515be7ed1f612970cee2d7afb81bdd762170481cd0069127d5b05aa993b4ea988d8fddc186ffb7dc90a6c08f4df435c93402849236c3fab4d27c7026c1d4dcb2602646dec9751e763dba37bdf8ff9406ad9e530ee5db382f413001aeb06a53ed9027d831179727b0865a8918da3edbebcf9b14ed44ce6cbaced4bb1bdb7f1447e6cc254b332051512bd7af426fb8f401378cd2bf5983ca01c64b92ecf032ea15d1721d03f482d7ce6e74fef6d55e702f46980c82b5a84031900b1c9e59e7c97fbec7e8f323a97a7e36cc88be0f1d45b7ff585ac54bd407b22b4154aacc8f6d7ebf48e1d814cc5ed20f8037e0a79715eef29be32806a1d58bb7c5da76f550aa3d8a1fbff0eb19ccb1a313d55cda56c9ec2ef29632387fe8d76e3c0468043e8f663f4860ee12bf2d5b0b7474d6e694f91e6dcc4024ffffffffffffffff"},"modp18":{"gen":"02","prime":"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"}}');


var $8911d62d5514749e$exports = {};

var $6ZWSX = parcelRequire("6ZWSX");
var $8911d62d5514749e$require$Buffer = $6ZWSX.Buffer;

var $5vmVB = parcelRequire("5vmVB");

var $8911d62d5514749e$var$millerRabin = new $bac5f004a90de4c6$exports();
var $8911d62d5514749e$var$TWENTYFOUR = new $5vmVB(24);
var $8911d62d5514749e$var$ELEVEN = new $5vmVB(11);
var $8911d62d5514749e$var$TEN = new $5vmVB(10);
var $8911d62d5514749e$var$THREE = new $5vmVB(3);
var $8911d62d5514749e$var$SEVEN = new $5vmVB(7);


var $hkN9y = parcelRequire("hkN9y");
$8911d62d5514749e$exports = $8911d62d5514749e$var$DH;
function $8911d62d5514749e$var$setPublicKey(pub, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(pub)) pub = new $8911d62d5514749e$require$Buffer(pub, enc);
    this._pub = new $5vmVB(pub);
    return this;
}
function $8911d62d5514749e$var$setPrivateKey(priv, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(priv)) priv = new $8911d62d5514749e$require$Buffer(priv, enc);
    this._priv = new $5vmVB(priv);
    return this;
}
var $8911d62d5514749e$var$primeCache = {};
function $8911d62d5514749e$var$checkPrime(prime, generator) {
    var gen = generator.toString("hex");
    var hex = [
        gen,
        prime.toString(16)
    ].join("_");
    if (hex in $8911d62d5514749e$var$primeCache) return $8911d62d5514749e$var$primeCache[hex];
    var error = 0;
    if (prime.isEven() || !$7f34ba2fa9025258$exports.simpleSieve || !$7f34ba2fa9025258$exports.fermatTest(prime) || !$8911d62d5514749e$var$millerRabin.test(prime)) {
        //not a prime so +1
        error += 1;
        if (gen === "02" || gen === "05") // we'd be able to check the generator
        // it would fail so +8
        error += 8;
        else //we wouldn't be able to test the generator
        // so +4
        error += 4;
        $8911d62d5514749e$var$primeCache[hex] = error;
        return error;
    }
    if (!$8911d62d5514749e$var$millerRabin.test(prime.shrn(1))) //not a safe prime
    error += 2;
    var rem;
    switch(gen){
        case "02":
            if (prime.mod($8911d62d5514749e$var$TWENTYFOUR).cmp($8911d62d5514749e$var$ELEVEN)) // unsuidable generator
            error += 8;
            break;
        case "05":
            rem = prime.mod($8911d62d5514749e$var$TEN);
            if (rem.cmp($8911d62d5514749e$var$THREE) && rem.cmp($8911d62d5514749e$var$SEVEN)) // prime mod 10 needs to equal 3 or 7
            error += 8;
            break;
        default:
            error += 4;
    }
    $8911d62d5514749e$var$primeCache[hex] = error;
    return error;
}
function $8911d62d5514749e$var$DH(prime, generator, malleable) {
    this.setGenerator(generator);
    this.__prime = new $5vmVB(prime);
    this._prime = $5vmVB.mont(this.__prime);
    this._primeLen = prime.length;
    this._pub = undefined;
    this._priv = undefined;
    this._primeCode = undefined;
    if (malleable) {
        this.setPublicKey = $8911d62d5514749e$var$setPublicKey;
        this.setPrivateKey = $8911d62d5514749e$var$setPrivateKey;
    } else this._primeCode = 8;
}
Object.defineProperty($8911d62d5514749e$var$DH.prototype, "verifyError", {
    enumerable: true,
    get: function() {
        if (typeof this._primeCode !== "number") this._primeCode = $8911d62d5514749e$var$checkPrime(this.__prime, this.__gen);
        return this._primeCode;
    }
});
$8911d62d5514749e$var$DH.prototype.generateKeys = function() {
    if (!this._priv) this._priv = new $5vmVB($hkN9y(this._primeLen));
    this._pub = this._gen.toRed(this._prime).redPow(this._priv).fromRed();
    return this.getPublicKey();
};
$8911d62d5514749e$var$DH.prototype.computeSecret = function(other) {
    other = new $5vmVB(other);
    other = other.toRed(this._prime);
    var secret = other.redPow(this._priv).fromRed();
    var out = new $8911d62d5514749e$require$Buffer(secret.toArray());
    var prime = this.getPrime();
    if (out.length < prime.length) {
        var front = new $8911d62d5514749e$require$Buffer(prime.length - out.length);
        front.fill(0);
        out = $8911d62d5514749e$require$Buffer.concat([
            front,
            out
        ]);
    }
    return out;
};
$8911d62d5514749e$var$DH.prototype.getPublicKey = function getPublicKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._pub, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrivateKey = function getPrivateKey(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._priv, enc);
};
$8911d62d5514749e$var$DH.prototype.getPrime = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this.__prime, enc);
};
$8911d62d5514749e$var$DH.prototype.getGenerator = function(enc) {
    return $8911d62d5514749e$var$formatReturnValue(this._gen, enc);
};
$8911d62d5514749e$var$DH.prototype.setGenerator = function(gen, enc) {
    enc = enc || "utf8";
    if (!$8911d62d5514749e$require$Buffer.isBuffer(gen)) gen = new $8911d62d5514749e$require$Buffer(gen, enc);
    this.__gen = gen;
    this._gen = new $5vmVB(gen);
    return this;
};
function $8911d62d5514749e$var$formatReturnValue(bn, enc) {
    var buf = new $8911d62d5514749e$require$Buffer(bn.toArray());
    if (!enc) return buf;
    else return buf.toString(enc);
}


function $4387b1fafb8a1868$var$getDiffieHellman(mod) {
    var prime = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].prime, "hex");
    var gen = new $4387b1fafb8a1868$require$Buffer($f0f71b0d846b32d7$exports[mod].gen, "hex");
    return new $8911d62d5514749e$exports(prime, gen);
}
var $4387b1fafb8a1868$var$ENCODINGS = {
    "binary": true,
    "hex": true,
    "base64": true
};
function $4387b1fafb8a1868$var$createDiffieHellman(prime, enc, generator, genc) {
    if ($4387b1fafb8a1868$require$Buffer.isBuffer(enc) || $4387b1fafb8a1868$var$ENCODINGS[enc] === undefined) return $4387b1fafb8a1868$var$createDiffieHellman(prime, "binary", enc, generator);
    enc = enc || "binary";
    genc = genc || "binary";
    generator = generator || new $4387b1fafb8a1868$require$Buffer([
        2
    ]);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(generator)) generator = new $4387b1fafb8a1868$require$Buffer(generator, genc);
    if (typeof prime === "number") return new $8911d62d5514749e$exports($7f34ba2fa9025258$exports(prime, generator), generator, true);
    if (!$4387b1fafb8a1868$require$Buffer.isBuffer(prime)) prime = new $4387b1fafb8a1868$require$Buffer(prime, enc);
    return new $8911d62d5514749e$exports(prime, generator, true);
}
$4387b1fafb8a1868$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$fdc27893e98845cc = $4387b1fafb8a1868$var$getDiffieHellman;
$4387b1fafb8a1868$export$6671fb9a1323bed = $4387b1fafb8a1868$export$d74daf141a551db = $4387b1fafb8a1868$var$createDiffieHellman;


$44edd02a6be448cd$export$971862a2fcb1bb40 = $4387b1fafb8a1868$export$971862a2fcb1bb40;
$44edd02a6be448cd$export$c6ff6a88acbeaf40 = $4387b1fafb8a1868$export$c6ff6a88acbeaf40;
$44edd02a6be448cd$export$fdc27893e98845cc = $4387b1fafb8a1868$export$fdc27893e98845cc;
$44edd02a6be448cd$export$6671fb9a1323bed = $4387b1fafb8a1868$export$6671fb9a1323bed;
$44edd02a6be448cd$export$d74daf141a551db = $4387b1fafb8a1868$export$d74daf141a551db;
var $3550302076d9e62e$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $3550302076d9e62e$require$Buffer = $1U9GM.Buffer;

var $1R2J7 = parcelRequire("1R2J7");

var $b6RFW = parcelRequire("b6RFW");

var $dlqwk = parcelRequire("dlqwk");
var $4d6db7c28d99f640$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $4d6db7c28d99f640$require$Buffer = $1U9GM.Buffer;

var $1iL1D = parcelRequire("1iL1D");

var $3Sg1O = parcelRequire("3Sg1O");

var $1zUcV = parcelRequire("1zUcV");
var $4d6db7c28d99f640$require$EC = $1zUcV.ec;

var $dEXSZ = parcelRequire("dEXSZ");

var $aNeDF = parcelRequire("aNeDF");
var $7fcf61ce5a538063$exports = {};
$7fcf61ce5a538063$exports = JSON.parse('{"1.3.132.0.10":"secp256k1","1.3.132.0.33":"p224","1.2.840.10045.3.1.1":"p192","1.2.840.10045.3.1.7":"p256","1.3.132.0.34":"p384","1.3.132.0.35":"p521"}');


var $4d6db7c28d99f640$var$RSA_PKCS1_PADDING = 1;
function $4d6db7c28d99f640$var$sign(hash, key, hashType, signType, tag) {
    var priv = $aNeDF(key);
    if (priv.curve) {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$ecSign(hash, priv);
    } else if (priv.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong private key type");
        return $4d6db7c28d99f640$var$dsaSign(hash, priv, hashType);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong private key type");
    if (key.padding !== undefined && key.padding !== $4d6db7c28d99f640$var$RSA_PKCS1_PADDING) throw new Error("illegal or unsupported padding mode");
    hash = $4d6db7c28d99f640$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = priv.modulus.byteLength();
    var pad = [
        0,
        1
    ];
    while(hash.length + pad.length + 1 < len)pad.push(0xff);
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    var out = $3Sg1O(pad, priv);
    return out;
}
function $4d6db7c28d99f640$var$ecSign(hash, priv) {
    var curveId = $7fcf61ce5a538063$exports[priv.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + priv.curve.join("."));
    var curve = new $4d6db7c28d99f640$require$EC(curveId);
    var key = curve.keyFromPrivate(priv.privateKey);
    var out = key.sign(hash);
    return $4d6db7c28d99f640$require$Buffer.from(out.toDER());
}
function $4d6db7c28d99f640$var$dsaSign(hash, priv, algo) {
    var x = priv.params.priv_key;
    var p = priv.params.p;
    var q = priv.params.q;
    var g = priv.params.g;
    var r = new $dEXSZ(0);
    var k;
    var H = $4d6db7c28d99f640$var$bits2int(hash, q).mod(q);
    var s = false;
    var kv = $4d6db7c28d99f640$var$getKey(x, q, hash, algo);
    while(s === false){
        k = $4d6db7c28d99f640$var$makeKey(q, kv, algo);
        r = $4d6db7c28d99f640$var$makeR(g, k, p, q);
        s = k.invm(q).imul(H.add(x.mul(r))).mod(q);
        if (s.cmpn(0) === 0) {
            s = false;
            r = new $dEXSZ(0);
        }
    }
    return $4d6db7c28d99f640$var$toDER(r, s);
}
function $4d6db7c28d99f640$var$toDER(r, s) {
    r = r.toArray();
    s = s.toArray();
    // Pad values
    if (r[0] & 0x80) r = [
        0
    ].concat(r);
    if (s[0] & 0x80) s = [
        0
    ].concat(s);
    var total = r.length + s.length + 4;
    var res = [
        0x30,
        total,
        0x02,
        r.length
    ];
    res = res.concat(r, [
        0x02,
        s.length
    ], s);
    return $4d6db7c28d99f640$require$Buffer.from(res);
}
function $4d6db7c28d99f640$var$getKey(x, q, hash, algo) {
    x = $4d6db7c28d99f640$require$Buffer.from(x.toArray());
    if (x.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - x.length);
        x = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            x
        ]);
    }
    var hlen = hash.length;
    var hbits = $4d6db7c28d99f640$var$bits2octets(hash, q);
    var v = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    v.fill(1);
    var k = $4d6db7c28d99f640$require$Buffer.alloc(hlen);
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        0
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    k = $1iL1D(algo, k).update(v).update($4d6db7c28d99f640$require$Buffer.from([
        1
    ])).update(x).update(hbits).digest();
    v = $1iL1D(algo, k).update(v).digest();
    return {
        k: k,
        v: v
    };
}
function $4d6db7c28d99f640$var$bits2int(obits, q) {
    var bits = new $dEXSZ(obits);
    var shift = (obits.length << 3) - q.bitLength();
    if (shift > 0) bits.ishrn(shift);
    return bits;
}
function $4d6db7c28d99f640$var$bits2octets(bits, q) {
    bits = $4d6db7c28d99f640$var$bits2int(bits, q);
    bits = bits.mod(q);
    var out = $4d6db7c28d99f640$require$Buffer.from(bits.toArray());
    if (out.length < q.byteLength()) {
        var zeros = $4d6db7c28d99f640$require$Buffer.alloc(q.byteLength() - out.length);
        out = $4d6db7c28d99f640$require$Buffer.concat([
            zeros,
            out
        ]);
    }
    return out;
}
function $4d6db7c28d99f640$var$makeKey(q, kv, algo) {
    var t;
    var k;
    do {
        t = $4d6db7c28d99f640$require$Buffer.alloc(0);
        while(t.length * 8 < q.bitLength()){
            kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
            t = $4d6db7c28d99f640$require$Buffer.concat([
                t,
                kv.v
            ]);
        }
        k = $4d6db7c28d99f640$var$bits2int(t, q);
        kv.k = $1iL1D(algo, kv.k).update(kv.v).update($4d6db7c28d99f640$require$Buffer.from([
            0
        ])).digest();
        kv.v = $1iL1D(algo, kv.k).update(kv.v).digest();
    }while (k.cmp(q) !== -1);
    return k;
}
function $4d6db7c28d99f640$var$makeR(g, k, p, q) {
    return g.toRed($dEXSZ.mont(p)).redPow(k).fromRed().mod(q);
}
$4d6db7c28d99f640$exports = $4d6db7c28d99f640$var$sign;
$4d6db7c28d99f640$exports.getKey = $4d6db7c28d99f640$var$getKey;
$4d6db7c28d99f640$exports.makeKey = $4d6db7c28d99f640$var$makeKey;


var $b885ed4272d45f84$exports = {};
"use strict";

var $1U9GM = parcelRequire("1U9GM");
var $b885ed4272d45f84$require$Buffer = $1U9GM.Buffer;

var $dEXSZ = parcelRequire("dEXSZ");

var $1zUcV = parcelRequire("1zUcV");
var $b885ed4272d45f84$require$EC = $1zUcV.ec;

var $aNeDF = parcelRequire("aNeDF");

function $b885ed4272d45f84$var$verify(sig, hash, key, signType, tag) {
    var pub = $aNeDF(key);
    if (pub.type === "ec") {
        // rsa keys can be interpreted as ecdsa ones in openssl
        if (signType !== "ecdsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$ecVerify(sig, hash, pub);
    } else if (pub.type === "dsa") {
        if (signType !== "dsa") throw new Error("wrong public key type");
        return $b885ed4272d45f84$var$dsaVerify(sig, hash, pub);
    }
    if (signType !== "rsa" && signType !== "ecdsa/rsa") throw new Error("wrong public key type");
    hash = $b885ed4272d45f84$require$Buffer.concat([
        tag,
        hash
    ]);
    var len = pub.modulus.byteLength();
    var pad = [
        1
    ];
    var padNum = 0;
    while(hash.length + pad.length + 2 < len){
        pad.push(0xff);
        padNum += 1;
    }
    pad.push(0x00);
    var i = -1;
    while(++i < hash.length)pad.push(hash[i]);
    pad = $b885ed4272d45f84$require$Buffer.from(pad);
    var red = $dEXSZ.mont(pub.modulus);
    sig = new $dEXSZ(sig).toRed(red);
    sig = sig.redPow(new $dEXSZ(pub.publicExponent));
    sig = $b885ed4272d45f84$require$Buffer.from(sig.fromRed().toArray());
    var out = padNum < 8 ? 1 : 0;
    len = Math.min(sig.length, pad.length);
    if (sig.length !== pad.length) out = 1;
    i = -1;
    while(++i < len)out |= sig[i] ^ pad[i];
    return out === 0;
}
function $b885ed4272d45f84$var$ecVerify(sig, hash, pub) {
    var curveId = $7fcf61ce5a538063$exports[pub.data.algorithm.curve.join(".")];
    if (!curveId) throw new Error("unknown curve " + pub.data.algorithm.curve.join("."));
    var curve = new $b885ed4272d45f84$require$EC(curveId);
    var pubkey = pub.data.subjectPrivateKey.data;
    return curve.verify(hash, sig, pubkey);
}
function $b885ed4272d45f84$var$dsaVerify(sig, hash, pub) {
    var p = pub.data.p;
    var q = pub.data.q;
    var g = pub.data.g;
    var y = pub.data.pub_key;
    var unpacked = $aNeDF.signature.decode(sig, "der");
    var s = unpacked.s;
    var r = unpacked.r;
    $b885ed4272d45f84$var$checkValue(s, q);
    $b885ed4272d45f84$var$checkValue(r, q);
    var montp = $dEXSZ.mont(p);
    var w = s.invm(q);
    var v = g.toRed(montp).redPow(new $dEXSZ(hash).mul(w).mod(q)).fromRed().mul(y.toRed(montp).redPow(r.mul(w).mod(q)).fromRed()).mod(p).mod(q);
    return v.cmp(r) === 0;
}
function $b885ed4272d45f84$var$checkValue(b, q) {
    if (b.cmpn(0) <= 0) throw new Error("invalid sig");
    if (b.cmp(q) >= 0) throw new Error("invalid sig");
}
$b885ed4272d45f84$exports = $b885ed4272d45f84$var$verify;



var $6swAi = parcelRequire("6swAi");
Object.keys($6swAi).forEach(function(key) {
    $6swAi[key].id = $3550302076d9e62e$require$Buffer.from($6swAi[key].id, "hex");
    $6swAi[key.toLowerCase()] = $6swAi[key];
});
function $3550302076d9e62e$var$Sign(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hashType = data.hash;
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Sign, $b6RFW.Writable);
$3550302076d9e62e$var$Sign.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Sign.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Sign.prototype.sign = function signMethod(key, enc) {
    this.end();
    var hash = this._hash.digest();
    var sig = $4d6db7c28d99f640$exports(hash, key, this._hashType, this._signType, this._tag);
    return enc ? sig.toString(enc) : sig;
};
function $3550302076d9e62e$var$Verify(algorithm) {
    $b6RFW.Writable.call(this);
    var data = $6swAi[algorithm];
    if (!data) throw new Error("Unknown message digest");
    this._hash = $1R2J7(data.hash);
    this._tag = data.id;
    this._signType = data.sign;
}
$dlqwk($3550302076d9e62e$var$Verify, $b6RFW.Writable);
$3550302076d9e62e$var$Verify.prototype._write = function _write(data, _, done) {
    this._hash.update(data);
    done();
};
$3550302076d9e62e$var$Verify.prototype.update = function update(data, enc) {
    this._hash.update(typeof data === "string" ? $3550302076d9e62e$require$Buffer.from(data, enc) : data);
    return this;
};
$3550302076d9e62e$var$Verify.prototype.verify = function verifyMethod(key, sig, enc) {
    var sigBuffer = typeof sig === "string" ? $3550302076d9e62e$require$Buffer.from(sig, enc) : sig;
    this.end();
    var hash = this._hash.digest();
    return $b885ed4272d45f84$exports(sigBuffer, hash, key, this._signType, this._tag);
};
function $3550302076d9e62e$var$createSign(algorithm) {
    return new $3550302076d9e62e$var$Sign(algorithm);
}
function $3550302076d9e62e$var$createVerify(algorithm) {
    return new $3550302076d9e62e$var$Verify(algorithm);
}
$3550302076d9e62e$exports = {
    Sign: $3550302076d9e62e$var$createSign,
    Verify: $3550302076d9e62e$var$createVerify,
    createSign: $3550302076d9e62e$var$createSign,
    createVerify: $3550302076d9e62e$var$createVerify
};


$44edd02a6be448cd$export$45df7cae684751af = $3550302076d9e62e$exports.createSign;
$44edd02a6be448cd$export$1db683ad541682f6 = $3550302076d9e62e$exports.Sign;
$44edd02a6be448cd$export$6f65485f87568e37 = $3550302076d9e62e$exports.createVerify;
$44edd02a6be448cd$export$91a8e56769aeb334 = $3550302076d9e62e$exports.Verify;

$44edd02a6be448cd$export$2d4117e99c2179e4 = (parcelRequire("fd3gh"));
var $b7e0a6843ffae451$export$512823e338ddb1b7;
var $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
var $b7e0a6843ffae451$export$b9d55ff329113abd;

$b7e0a6843ffae451$export$512823e338ddb1b7 = (parcelRequire("98aLY"));

$b7e0a6843ffae451$export$7efb24e2fddf99b9 = (parcelRequire("jU8t7"));
$b7e0a6843ffae451$export$9d0e0c0c4a8d30f3 = function privateEncrypt(key, buf) {
    return $b7e0a6843ffae451$export$512823e338ddb1b7(key, buf, true);
};
$b7e0a6843ffae451$export$b9d55ff329113abd = function publicDecrypt(key, buf) {
    return $b7e0a6843ffae451$export$7efb24e2fddf99b9(key, buf, true);
};


$44edd02a6be448cd$export$512823e338ddb1b7 = $b7e0a6843ffae451$export$512823e338ddb1b7;
$44edd02a6be448cd$export$9d0e0c0c4a8d30f3 = $b7e0a6843ffae451$export$9d0e0c0c4a8d30f3;
$44edd02a6be448cd$export$b9d55ff329113abd = $b7e0a6843ffae451$export$b9d55ff329113abd;
$44edd02a6be448cd$export$7efb24e2fddf99b9 = $b7e0a6843ffae451$export$7efb24e2fddf99b9;
var $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
var $8c5943302864e9a5$export$2f7171e78e524d5e;

var $hPtJY = parcelRequire("hPtJY");
"use strict";
function $8c5943302864e9a5$var$oldBrowser() {
    throw new Error("secure random number generation not supported by this browser\nuse chrome, FireFox or Internet Explorer 11");
}

var $1U9GM = parcelRequire("1U9GM");

var $hkN9y = parcelRequire("hkN9y");
var $8c5943302864e9a5$var$Buffer = $1U9GM.Buffer;
var $8c5943302864e9a5$var$kBufferMaxLength = $1U9GM.kMaxLength;
var $8c5943302864e9a5$var$crypto = $parcel$global.crypto || $parcel$global.msCrypto;
var $8c5943302864e9a5$var$kMaxUint32 = Math.pow(2, 32) - 1;
function $8c5943302864e9a5$var$assertOffset(offset, length) {
    if (typeof offset !== "number" || offset !== offset) throw new TypeError("offset must be a number");
    if (offset > $8c5943302864e9a5$var$kMaxUint32 || offset < 0) throw new TypeError("offset must be a uint32");
    if (offset > $8c5943302864e9a5$var$kBufferMaxLength || offset > length) throw new RangeError("offset out of range");
}
function $8c5943302864e9a5$var$assertSize(size, offset, length) {
    if (typeof size !== "number" || size !== size) throw new TypeError("size must be a number");
    if (size > $8c5943302864e9a5$var$kMaxUint32 || size < 0) throw new TypeError("size must be a uint32");
    if (size + offset > length || size > $8c5943302864e9a5$var$kBufferMaxLength) throw new RangeError("buffer too small");
}
if ($8c5943302864e9a5$var$crypto && $8c5943302864e9a5$var$crypto.getRandomValues || false) {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$randomFill;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$randomFillSync;
} else {
    $8c5943302864e9a5$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$var$oldBrowser;
    $8c5943302864e9a5$export$2f7171e78e524d5e = $8c5943302864e9a5$var$oldBrowser;
}
function $8c5943302864e9a5$var$randomFill(buf, offset, size, cb) {
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    if (typeof offset === "function") {
        cb = offset;
        offset = 0;
        size = buf.length;
    } else if (typeof size === "function") {
        cb = size;
        size = buf.length - offset;
    } else if (typeof cb !== "function") throw new TypeError('"cb" argument must be a function');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size, cb);
}
function $8c5943302864e9a5$var$actualFill(buf, offset, size, cb) {
    var ourBuf = buf.buffer;
    var uint = new Uint8Array(ourBuf, offset, size);
    $8c5943302864e9a5$var$crypto.getRandomValues(uint);
    if (cb) {
        $hPtJY.nextTick(function() {
            cb(null, buf);
        });
        return;
    }
    return buf;
    if (cb) {
        $hkN9y(size, function(err, bytes) {
            if (err) return cb(err);
            bytes.copy(buf, offset);
            cb(null, buf);
        });
        return;
    }
    var bytes = $hkN9y(size);
    bytes.copy(buf, offset);
    return buf;
}
function $8c5943302864e9a5$var$randomFillSync(buf, offset, size) {
    if (typeof offset === "undefined") offset = 0;
    if (!$8c5943302864e9a5$var$Buffer.isBuffer(buf) && !(buf instanceof $parcel$global.Uint8Array)) throw new TypeError('"buf" argument must be a Buffer or Uint8Array');
    $8c5943302864e9a5$var$assertOffset(offset, buf.length);
    if (size === undefined) size = buf.length - offset;
    $8c5943302864e9a5$var$assertSize(size, offset, buf.length);
    return $8c5943302864e9a5$var$actualFill(buf, offset, size);
}


$44edd02a6be448cd$export$bb1abf2ce84fc7e8 = $8c5943302864e9a5$export$bb1abf2ce84fc7e8;
$44edd02a6be448cd$export$2f7171e78e524d5e = $8c5943302864e9a5$export$2f7171e78e524d5e;
$44edd02a6be448cd$export$e1d879b482f37d98 = function() {
    throw new Error("sorry, createCredentials is not implemented yet\nwe accept pull requests\nhttps://github.com/browserify/crypto-browserify");
};
$44edd02a6be448cd$export$1a988e7317c65621 = {
    DH_CHECK_P_NOT_SAFE_PRIME: 2,
    DH_CHECK_P_NOT_PRIME: 1,
    DH_UNABLE_TO_CHECK_GENERATOR: 4,
    DH_NOT_SUITABLE_GENERATOR: 8,
    NPN_ENABLED: 1,
    ALPN_ENABLED: 1,
    RSA_PKCS1_PADDING: 1,
    RSA_SSLV23_PADDING: 2,
    RSA_NO_PADDING: 3,
    RSA_PKCS1_OAEP_PADDING: 4,
    RSA_X931_PADDING: 5,
    RSA_PKCS1_PSS_PADDING: 6,
    POINT_CONVERSION_COMPRESSED: 2,
    POINT_CONVERSION_UNCOMPRESSED: 4,
    POINT_CONVERSION_HYBRID: 6
};


var $4a8af0cab3e1a9ea$exports = {};


$4a8af0cab3e1a9ea$exports = (parcelRequire("fr4Yq"))((parcelRequire("ejO33")));


var $51b6b372898f65c0$exports = {};
"use strict";
Object.defineProperty($51b6b372898f65c0$exports, "__esModule", {
    value: true
});
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$exports.HMAC = void 0;

var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
// HMAC (RFC 2104)
class $51b6b372898f65c0$var$HMAC extends $3Bcdj.Hash {
    constructor(hash, _key){
        super();
        this.finished = false;
        this.destroyed = false;
        (0, $dNiq9.hash)(hash);
        const key = (0, $3Bcdj.toBytes)(_key);
        this.iHash = hash.create();
        if (typeof this.iHash.update !== "function") throw new Error("Expected instance of class which extends utils.Hash");
        this.blockLen = this.iHash.blockLen;
        this.outputLen = this.iHash.outputLen;
        const blockLen = this.blockLen;
        const pad = new Uint8Array(blockLen);
        // blockLen can be bigger than outputLen
        pad.set(key.length > blockLen ? hash.create().update(key).digest() : key);
        for(let i = 0; i < pad.length; i++)pad[i] ^= 0x36;
        this.iHash.update(pad);
        // By doing update (processing of first block) of outer hash here we can re-use it between multiple calls via clone
        this.oHash = hash.create();
        // Undo internal XOR && apply outer XOR
        for(let i = 0; i < pad.length; i++)pad[i] ^= 106;
        this.oHash.update(pad);
        pad.fill(0);
    }
    update(buf) {
        (0, $dNiq9.exists)(this);
        this.iHash.update(buf);
        return this;
    }
    digestInto(out) {
        (0, $dNiq9.exists)(this);
        (0, $dNiq9.bytes)(out, this.outputLen);
        this.finished = true;
        this.iHash.digestInto(out);
        this.oHash.update(out);
        this.oHash.digestInto(out);
        this.destroy();
    }
    digest() {
        const out = new Uint8Array(this.oHash.outputLen);
        this.digestInto(out);
        return out;
    }
    _cloneInto(to) {
        // Create new instance without calling constructor since key already in state and we don't know it.
        to || (to = Object.create(Object.getPrototypeOf(this), {}));
        const { oHash: oHash, iHash: iHash, finished: finished, destroyed: destroyed, blockLen: blockLen, outputLen: outputLen } = this;
        to;
        to.finished = finished;
        to.destroyed = destroyed;
        to.blockLen = blockLen;
        to.outputLen = outputLen;
        to.oHash = oHash._cloneInto(to.oHash);
        to.iHash = iHash._cloneInto(to.iHash);
        return to;
    }
    destroy() {
        this.destroyed = true;
        this.oHash.destroy();
        this.iHash.destroy();
    }
}
$51b6b372898f65c0$exports.HMAC = $51b6b372898f65c0$var$HMAC;
/**
 * HMAC: RFC2104 message authentication code.
 * @param hash - function that would be used e.g. sha256
 * @param key - message key
 * @param message - message data
 * @example
 * import { hmac } from '@noble/hashes/hmac';
 * import { sha256 } from '@noble/hashes/sha2';
 * const mac1 = hmac(sha256, 'key', 'message');
 */ const $51b6b372898f65c0$var$hmac = (hash, key, message)=>new $51b6b372898f65c0$var$HMAC(hash, key).update(message).digest();
$51b6b372898f65c0$exports.hmac = $51b6b372898f65c0$var$hmac;
$51b6b372898f65c0$exports.hmac.create = (hash, key)=>new $51b6b372898f65c0$var$HMAC(hash, key);



var $6XnWx = parcelRequire("6XnWx");
var $2579977b4e52adba$exports = {};
"use strict";
Object.defineProperty($2579977b4e52adba$exports, "__esModule", {
    value: true
});
$2579977b4e52adba$exports.sha384 = $2579977b4e52adba$exports.sha512_256 = $2579977b4e52adba$exports.sha512_224 = $2579977b4e52adba$exports.sha512 = $2579977b4e52adba$exports.SHA384 = $2579977b4e52adba$exports.SHA512_256 = $2579977b4e52adba$exports.SHA512_224 = $2579977b4e52adba$exports.SHA512 = void 0;

var $iYRTw = parcelRequire("iYRTw");
var $aa71b30d36adb919$exports = {};
"use strict";
Object.defineProperty($aa71b30d36adb919$exports, "__esModule", {
    value: true
});
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$exports.toBig = void 0;
$aa71b30d36adb919$exports.fromBig = $aa71b30d36adb919$var$fromBig;
$aa71b30d36adb919$exports.split = $aa71b30d36adb919$var$split;
$aa71b30d36adb919$exports.add = $aa71b30d36adb919$var$add;
const $aa71b30d36adb919$var$U32_MASK64 = /* @__PURE__ */ BigInt(2 ** 32 - 1);
const $aa71b30d36adb919$var$_32n = /* @__PURE__ */ BigInt(32);
// We are not using BigUint64Array, because they are extremely slow as per 2022
function $aa71b30d36adb919$var$fromBig(n, le = false) {
    if (le) return {
        h: Number(n & $aa71b30d36adb919$var$U32_MASK64),
        l: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64)
    };
    return {
        h: Number(n >> $aa71b30d36adb919$var$_32n & $aa71b30d36adb919$var$U32_MASK64) | 0,
        l: Number(n & $aa71b30d36adb919$var$U32_MASK64) | 0
    };
}
function $aa71b30d36adb919$var$split(lst, le = false) {
    let Ah = new Uint32Array(lst.length);
    let Al = new Uint32Array(lst.length);
    for(let i = 0; i < lst.length; i++){
        const { h: h, l: l } = $aa71b30d36adb919$var$fromBig(lst[i], le);
        [Ah[i], Al[i]] = [
            h,
            l
        ];
    }
    return [
        Ah,
        Al
    ];
}
const $aa71b30d36adb919$var$toBig = (h, l)=>BigInt(h >>> 0) << $aa71b30d36adb919$var$_32n | BigInt(l >>> 0);
$aa71b30d36adb919$exports.toBig = $aa71b30d36adb919$var$toBig;
// for Shift in [0, 32)
const $aa71b30d36adb919$var$shrSH = (h, _l, s)=>h >>> s;
$aa71b30d36adb919$exports.shrSH = $aa71b30d36adb919$var$shrSH;
const $aa71b30d36adb919$var$shrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.shrSL = $aa71b30d36adb919$var$shrSL;
// Right rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotrSH = (h, l, s)=>h >>> s | l << 32 - s;
$aa71b30d36adb919$exports.rotrSH = $aa71b30d36adb919$var$rotrSH;
const $aa71b30d36adb919$var$rotrSL = (h, l, s)=>h << 32 - s | l >>> s;
$aa71b30d36adb919$exports.rotrSL = $aa71b30d36adb919$var$rotrSL;
// Right rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotrBH = (h, l, s)=>h << 64 - s | l >>> s - 32;
$aa71b30d36adb919$exports.rotrBH = $aa71b30d36adb919$var$rotrBH;
const $aa71b30d36adb919$var$rotrBL = (h, l, s)=>h >>> s - 32 | l << 64 - s;
$aa71b30d36adb919$exports.rotrBL = $aa71b30d36adb919$var$rotrBL;
// Right rotate for shift===32 (just swaps l&h)
const $aa71b30d36adb919$var$rotr32H = (_h, l)=>l;
$aa71b30d36adb919$exports.rotr32H = $aa71b30d36adb919$var$rotr32H;
const $aa71b30d36adb919$var$rotr32L = (h, _l)=>h;
$aa71b30d36adb919$exports.rotr32L = $aa71b30d36adb919$var$rotr32L;
// Left rotate for Shift in [1, 32)
const $aa71b30d36adb919$var$rotlSH = (h, l, s)=>h << s | l >>> 32 - s;
$aa71b30d36adb919$exports.rotlSH = $aa71b30d36adb919$var$rotlSH;
const $aa71b30d36adb919$var$rotlSL = (h, l, s)=>l << s | h >>> 32 - s;
$aa71b30d36adb919$exports.rotlSL = $aa71b30d36adb919$var$rotlSL;
// Left rotate for Shift in (32, 64), NOTE: 32 is special case.
const $aa71b30d36adb919$var$rotlBH = (h, l, s)=>l << s - 32 | h >>> 64 - s;
$aa71b30d36adb919$exports.rotlBH = $aa71b30d36adb919$var$rotlBH;
const $aa71b30d36adb919$var$rotlBL = (h, l, s)=>h << s - 32 | l >>> 64 - s;
$aa71b30d36adb919$exports.rotlBL = $aa71b30d36adb919$var$rotlBL;
// JS uses 32-bit signed integers for bitwise operations which means we cannot
// simple take carry out of low bit sum by shift, we need to use division.
function $aa71b30d36adb919$var$add(Ah, Al, Bh, Bl) {
    const l = (Al >>> 0) + (Bl >>> 0);
    return {
        h: Ah + Bh + (l / 2 ** 32 | 0) | 0,
        l: l | 0
    };
}
// Addition with more than 2 elements
const $aa71b30d36adb919$var$add3L = (Al, Bl, Cl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0);
$aa71b30d36adb919$exports.add3L = $aa71b30d36adb919$var$add3L;
const $aa71b30d36adb919$var$add3H = (low, Ah, Bh, Ch)=>Ah + Bh + Ch + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add3H = $aa71b30d36adb919$var$add3H;
const $aa71b30d36adb919$var$add4L = (Al, Bl, Cl, Dl)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0);
$aa71b30d36adb919$exports.add4L = $aa71b30d36adb919$var$add4L;
const $aa71b30d36adb919$var$add4H = (low, Ah, Bh, Ch, Dh)=>Ah + Bh + Ch + Dh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add4H = $aa71b30d36adb919$var$add4H;
const $aa71b30d36adb919$var$add5L = (Al, Bl, Cl, Dl, El)=>(Al >>> 0) + (Bl >>> 0) + (Cl >>> 0) + (Dl >>> 0) + (El >>> 0);
$aa71b30d36adb919$exports.add5L = $aa71b30d36adb919$var$add5L;
const $aa71b30d36adb919$var$add5H = (low, Ah, Bh, Ch, Dh, Eh)=>Ah + Bh + Ch + Dh + Eh + (low / 2 ** 32 | 0) | 0;
$aa71b30d36adb919$exports.add5H = $aa71b30d36adb919$var$add5H;
// prettier-ignore
const $aa71b30d36adb919$var$u64 = {
    fromBig: $aa71b30d36adb919$var$fromBig,
    split: $aa71b30d36adb919$var$split,
    toBig: $aa71b30d36adb919$var$toBig,
    shrSH: $aa71b30d36adb919$var$shrSH,
    shrSL: $aa71b30d36adb919$var$shrSL,
    rotrSH: $aa71b30d36adb919$var$rotrSH,
    rotrSL: $aa71b30d36adb919$var$rotrSL,
    rotrBH: $aa71b30d36adb919$var$rotrBH,
    rotrBL: $aa71b30d36adb919$var$rotrBL,
    rotr32H: $aa71b30d36adb919$var$rotr32H,
    rotr32L: $aa71b30d36adb919$var$rotr32L,
    rotlSH: $aa71b30d36adb919$var$rotlSH,
    rotlSL: $aa71b30d36adb919$var$rotlSL,
    rotlBH: $aa71b30d36adb919$var$rotlBH,
    rotlBL: $aa71b30d36adb919$var$rotlBL,
    add: $aa71b30d36adb919$var$add,
    add3L: $aa71b30d36adb919$var$add3L,
    add3H: $aa71b30d36adb919$var$add3H,
    add4L: $aa71b30d36adb919$var$add4L,
    add4H: $aa71b30d36adb919$var$add4H,
    add5H: $aa71b30d36adb919$var$add5H,
    add5L: $aa71b30d36adb919$var$add5L
};
$aa71b30d36adb919$exports.default = $aa71b30d36adb919$var$u64;



var $3Bcdj = parcelRequire("3Bcdj");
// Round contants (first 32 bits of the fractional parts of the cube roots of the first 80 primes 2..409):
// prettier-ignore
const [$2579977b4e52adba$var$SHA512_Kh, $2579977b4e52adba$var$SHA512_Kl] = /* @__PURE__ */ (()=>$aa71b30d36adb919$exports.default.split([
        "0x428a2f98d728ae22",
        "0x7137449123ef65cd",
        "0xb5c0fbcfec4d3b2f",
        "0xe9b5dba58189dbbc",
        "0x3956c25bf348b538",
        "0x59f111f1b605d019",
        "0x923f82a4af194f9b",
        "0xab1c5ed5da6d8118",
        "0xd807aa98a3030242",
        "0x12835b0145706fbe",
        "0x243185be4ee4b28c",
        "0x550c7dc3d5ffb4e2",
        "0x72be5d74f27b896f",
        "0x80deb1fe3b1696b1",
        "0x9bdc06a725c71235",
        "0xc19bf174cf692694",
        "0xe49b69c19ef14ad2",
        "0xefbe4786384f25e3",
        "0x0fc19dc68b8cd5b5",
        "0x240ca1cc77ac9c65",
        "0x2de92c6f592b0275",
        "0x4a7484aa6ea6e483",
        "0x5cb0a9dcbd41fbd4",
        "0x76f988da831153b5",
        "0x983e5152ee66dfab",
        "0xa831c66d2db43210",
        "0xb00327c898fb213f",
        "0xbf597fc7beef0ee4",
        "0xc6e00bf33da88fc2",
        "0xd5a79147930aa725",
        "0x06ca6351e003826f",
        "0x142929670a0e6e70",
        "0x27b70a8546d22ffc",
        "0x2e1b21385c26c926",
        "0x4d2c6dfc5ac42aed",
        "0x53380d139d95b3df",
        "0x650a73548baf63de",
        "0x766a0abb3c77b2a8",
        "0x81c2c92e47edaee6",
        "0x92722c851482353b",
        "0xa2bfe8a14cf10364",
        "0xa81a664bbc423001",
        "0xc24b8b70d0f89791",
        "0xc76c51a30654be30",
        "0xd192e819d6ef5218",
        "0xd69906245565a910",
        "0xf40e35855771202a",
        "0x106aa07032bbd1b8",
        "0x19a4c116b8d2d0c8",
        "0x1e376c085141ab53",
        "0x2748774cdf8eeb99",
        "0x34b0bcb5e19b48a8",
        "0x391c0cb3c5c95a63",
        "0x4ed8aa4ae3418acb",
        "0x5b9cca4f7763e373",
        "0x682e6ff3d6b2b8a3",
        "0x748f82ee5defb2fc",
        "0x78a5636f43172f60",
        "0x84c87814a1f0ab72",
        "0x8cc702081a6439ec",
        "0x90befffa23631e28",
        "0xa4506cebde82bde9",
        "0xbef9a3f7b2c67915",
        "0xc67178f2e372532b",
        "0xca273eceea26619c",
        "0xd186b8c721c0c207",
        "0xeada7dd6cde0eb1e",
        "0xf57d4f7fee6ed178",
        "0x06f067aa72176fba",
        "0x0a637dc5a2c898a6",
        "0x113f9804bef90dae",
        "0x1b710b35131c471b",
        "0x28db77f523047d84",
        "0x32caab7b40c72493",
        "0x3c9ebe0a15c9bebc",
        "0x431d67c49c100d4c",
        "0x4cc5d4becb3e42b6",
        "0x597f299cfc657e2a",
        "0x5fcb6fab3ad6faec",
        "0x6c44198c4a475817"
    ].map((n)=>BigInt(n))))();
// Temporary buffer, not used to store anything between runs
const $2579977b4e52adba$var$SHA512_W_H = /* @__PURE__ */ new Uint32Array(80);
const $2579977b4e52adba$var$SHA512_W_L = /* @__PURE__ */ new Uint32Array(80);
class $2579977b4e52adba$var$SHA512 extends $iYRTw.HashMD {
    constructor(){
        super(128, 64, 16, false);
        // We cannot use array here since array allows indexing by variable which means optimizer/compiler cannot use registers.
        // Also looks cleaner and easier to verify with spec.
        // Initial state (first 32 bits of the fractional parts of the square roots of the first 8 primes 2..19):
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 1779033703;
        this.Al = -205731576;
        this.Bh = -1150833019;
        this.Bl = -2067093701;
        this.Ch = 1013904242;
        this.Cl = -23791573;
        this.Dh = -1521486534;
        this.Dl = 1595750129;
        this.Eh = 1359893119;
        this.El = -1377402159;
        this.Fh = -1694144372;
        this.Fl = 725511199;
        this.Gh = 528734635;
        this.Gl = -79577749;
        this.Hh = 1541459225;
        this.Hl = 327033209;
    }
    // prettier-ignore
    get() {
        const { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        return [
            Ah,
            Al,
            Bh,
            Bl,
            Ch,
            Cl,
            Dh,
            Dl,
            Eh,
            El,
            Fh,
            Fl,
            Gh,
            Gl,
            Hh,
            Hl
        ];
    }
    // prettier-ignore
    set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl) {
        this.Ah = Ah | 0;
        this.Al = Al | 0;
        this.Bh = Bh | 0;
        this.Bl = Bl | 0;
        this.Ch = Ch | 0;
        this.Cl = Cl | 0;
        this.Dh = Dh | 0;
        this.Dl = Dl | 0;
        this.Eh = Eh | 0;
        this.El = El | 0;
        this.Fh = Fh | 0;
        this.Fl = Fl | 0;
        this.Gh = Gh | 0;
        this.Gl = Gl | 0;
        this.Hh = Hh | 0;
        this.Hl = Hl | 0;
    }
    process(view, offset) {
        // Extend the first 16 words into the remaining 64 words w[16..79] of the message schedule array
        for(let i = 0; i < 16; i++, offset += 4){
            $2579977b4e52adba$var$SHA512_W_H[i] = view.getUint32(offset);
            $2579977b4e52adba$var$SHA512_W_L[i] = view.getUint32(offset += 4);
        }
        for(let i = 16; i < 80; i++){
            // s0 := (w[i-15] rightrotate 1) xor (w[i-15] rightrotate 8) xor (w[i-15] rightshift 7)
            const W15h = $2579977b4e52adba$var$SHA512_W_H[i - 15] | 0;
            const W15l = $2579977b4e52adba$var$SHA512_W_L[i - 15] | 0;
            const s0h = $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSH(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSH(W15h, W15l, 7);
            const s0l = $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 1) ^ $aa71b30d36adb919$exports.default.rotrSL(W15h, W15l, 8) ^ $aa71b30d36adb919$exports.default.shrSL(W15h, W15l, 7);
            // s1 := (w[i-2] rightrotate 19) xor (w[i-2] rightrotate 61) xor (w[i-2] rightshift 6)
            const W2h = $2579977b4e52adba$var$SHA512_W_H[i - 2] | 0;
            const W2l = $2579977b4e52adba$var$SHA512_W_L[i - 2] | 0;
            const s1h = $aa71b30d36adb919$exports.default.rotrSH(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBH(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSH(W2h, W2l, 6);
            const s1l = $aa71b30d36adb919$exports.default.rotrSL(W2h, W2l, 19) ^ $aa71b30d36adb919$exports.default.rotrBL(W2h, W2l, 61) ^ $aa71b30d36adb919$exports.default.shrSL(W2h, W2l, 6);
            // SHA256_W[i] = s0 + s1 + SHA256_W[i - 7] + SHA256_W[i - 16];
            const SUMl = $aa71b30d36adb919$exports.default.add4L(s0l, s1l, $2579977b4e52adba$var$SHA512_W_L[i - 7], $2579977b4e52adba$var$SHA512_W_L[i - 16]);
            const SUMh = $aa71b30d36adb919$exports.default.add4H(SUMl, s0h, s1h, $2579977b4e52adba$var$SHA512_W_H[i - 7], $2579977b4e52adba$var$SHA512_W_H[i - 16]);
            $2579977b4e52adba$var$SHA512_W_H[i] = SUMh | 0;
            $2579977b4e52adba$var$SHA512_W_L[i] = SUMl | 0;
        }
        let { Ah: Ah, Al: Al, Bh: Bh, Bl: Bl, Ch: Ch, Cl: Cl, Dh: Dh, Dl: Dl, Eh: Eh, El: El, Fh: Fh, Fl: Fl, Gh: Gh, Gl: Gl, Hh: Hh, Hl: Hl } = this;
        // Compression function main loop, 80 rounds
        for(let i = 0; i < 80; i++){
            // S1 := (e rightrotate 14) xor (e rightrotate 18) xor (e rightrotate 41)
            const sigma1h = $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSH(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBH(Eh, El, 41);
            const sigma1l = $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 14) ^ $aa71b30d36adb919$exports.default.rotrSL(Eh, El, 18) ^ $aa71b30d36adb919$exports.default.rotrBL(Eh, El, 41);
            //const T1 = (H + sigma1 + Chi(E, F, G) + SHA256_K[i] + SHA256_W[i]) | 0;
            const CHIh = Eh & Fh ^ ~Eh & Gh;
            const CHIl = El & Fl ^ ~El & Gl;
            // T1 = H + sigma1 + Chi(E, F, G) + SHA512_K[i] + SHA512_W[i]
            // prettier-ignore
            const T1ll = $aa71b30d36adb919$exports.default.add5L(Hl, sigma1l, CHIl, $2579977b4e52adba$var$SHA512_Kl[i], $2579977b4e52adba$var$SHA512_W_L[i]);
            const T1h = $aa71b30d36adb919$exports.default.add5H(T1ll, Hh, sigma1h, CHIh, $2579977b4e52adba$var$SHA512_Kh[i], $2579977b4e52adba$var$SHA512_W_H[i]);
            const T1l = T1ll | 0;
            // S0 := (a rightrotate 28) xor (a rightrotate 34) xor (a rightrotate 39)
            const sigma0h = $aa71b30d36adb919$exports.default.rotrSH(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBH(Ah, Al, 39);
            const sigma0l = $aa71b30d36adb919$exports.default.rotrSL(Ah, Al, 28) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 34) ^ $aa71b30d36adb919$exports.default.rotrBL(Ah, Al, 39);
            const MAJh = Ah & Bh ^ Ah & Ch ^ Bh & Ch;
            const MAJl = Al & Bl ^ Al & Cl ^ Bl & Cl;
            Hh = Gh | 0;
            Hl = Gl | 0;
            Gh = Fh | 0;
            Gl = Fl | 0;
            Fh = Eh | 0;
            Fl = El | 0;
            ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(Dh | 0, Dl | 0, T1h | 0, T1l | 0));
            Dh = Ch | 0;
            Dl = Cl | 0;
            Ch = Bh | 0;
            Cl = Bl | 0;
            Bh = Ah | 0;
            Bl = Al | 0;
            const All = $aa71b30d36adb919$exports.default.add3L(T1l, sigma0l, MAJl);
            Ah = $aa71b30d36adb919$exports.default.add3H(All, T1h, sigma0h, MAJh);
            Al = All | 0;
        }
        // Add the compressed chunk to the current hash value
        ({ h: Ah, l: Al } = $aa71b30d36adb919$exports.default.add(this.Ah | 0, this.Al | 0, Ah | 0, Al | 0));
        ({ h: Bh, l: Bl } = $aa71b30d36adb919$exports.default.add(this.Bh | 0, this.Bl | 0, Bh | 0, Bl | 0));
        ({ h: Ch, l: Cl } = $aa71b30d36adb919$exports.default.add(this.Ch | 0, this.Cl | 0, Ch | 0, Cl | 0));
        ({ h: Dh, l: Dl } = $aa71b30d36adb919$exports.default.add(this.Dh | 0, this.Dl | 0, Dh | 0, Dl | 0));
        ({ h: Eh, l: El } = $aa71b30d36adb919$exports.default.add(this.Eh | 0, this.El | 0, Eh | 0, El | 0));
        ({ h: Fh, l: Fl } = $aa71b30d36adb919$exports.default.add(this.Fh | 0, this.Fl | 0, Fh | 0, Fl | 0));
        ({ h: Gh, l: Gl } = $aa71b30d36adb919$exports.default.add(this.Gh | 0, this.Gl | 0, Gh | 0, Gl | 0));
        ({ h: Hh, l: Hl } = $aa71b30d36adb919$exports.default.add(this.Hh | 0, this.Hl | 0, Hh | 0, Hl | 0));
        this.set(Ah, Al, Bh, Bl, Ch, Cl, Dh, Dl, Eh, El, Fh, Fl, Gh, Gl, Hh, Hl);
    }
    roundClean() {
        $2579977b4e52adba$var$SHA512_W_H.fill(0);
        $2579977b4e52adba$var$SHA512_W_L.fill(0);
    }
    destroy() {
        this.buffer.fill(0);
        this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
    }
}
$2579977b4e52adba$exports.SHA512 = $2579977b4e52adba$var$SHA512;
class $2579977b4e52adba$var$SHA512_224 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -1942145080;
        this.Al = 424955298;
        this.Bh = 1944164710;
        this.Bl = -1982016298;
        this.Ch = 502970286;
        this.Cl = 855612546;
        this.Dh = 1738396948;
        this.Dl = 1479516111;
        this.Eh = 258812777;
        this.El = 2077511080;
        this.Fh = 2011393907;
        this.Fl = 79989058;
        this.Gh = 1067287976;
        this.Gl = 1780299464;
        this.Hh = 286451373;
        this.Hl = -1848208735;
        this.outputLen = 28;
    }
}
$2579977b4e52adba$exports.SHA512_224 = $2579977b4e52adba$var$SHA512_224;
class $2579977b4e52adba$var$SHA512_256 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = 573645204;
        this.Al = -64227540;
        this.Bh = -1621794909;
        this.Bl = -934517566;
        this.Ch = 596883563;
        this.Cl = 1867755857;
        this.Dh = -1774684391;
        this.Dl = 1497426621;
        this.Eh = -1775747358;
        this.El = -1467023389;
        this.Fh = -1101128155;
        this.Fl = 1401305490;
        this.Gh = 721525244;
        this.Gl = 746961066;
        this.Hh = 246885852;
        this.Hl = -2117784414;
        this.outputLen = 32;
    }
}
$2579977b4e52adba$exports.SHA512_256 = $2579977b4e52adba$var$SHA512_256;
class $2579977b4e52adba$var$SHA384 extends $2579977b4e52adba$var$SHA512 {
    constructor(){
        super();
        // h -- high 32 bits, l -- low 32 bits
        this.Ah = -876896931;
        this.Al = -1056596264;
        this.Bh = 1654270250;
        this.Bl = 914150663;
        this.Ch = -1856437926;
        this.Cl = 812702999;
        this.Dh = 355462360;
        this.Dl = -150054599;
        this.Eh = 1731405415;
        this.El = -4191439;
        this.Fh = -1900787065;
        this.Fl = 1750603025;
        this.Gh = -619958771;
        this.Gl = 1694076839;
        this.Hh = 1203062813;
        this.Hl = -1090891868;
        this.outputLen = 48;
    }
}
$2579977b4e52adba$exports.SHA384 = $2579977b4e52adba$var$SHA384;
$2579977b4e52adba$exports.sha512 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512());
$2579977b4e52adba$exports.sha512_224 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_224());
$2579977b4e52adba$exports.sha512_256 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA512_256());
$2579977b4e52adba$exports.sha384 = (0, $3Bcdj.wrapConstructor)(()=>new $2579977b4e52adba$var$SHA384());



var $j5xzM = parcelRequire("j5xzM");
/*! scure-bip32 - MIT License (c) 2022 Patricio Palladino, Paul Miller (paulmillr.com) */ 

var $j5xzM = parcelRequire("j5xzM");

var $6XnWx = parcelRequire("6XnWx");


var $dNiq9 = parcelRequire("dNiq9");

var $3Bcdj = parcelRequire("3Bcdj");
var $3f551179096121b9$exports = {};
"use strict";
Object.defineProperty($3f551179096121b9$exports, "__esModule", {
    value: true
});
$3f551179096121b9$exports.encodeToCurve = $3f551179096121b9$exports.hashToCurve = $3f551179096121b9$exports.schnorr = $3f551179096121b9$exports.secp256k1 = void 0;

var $6XnWx = parcelRequire("6XnWx");

var $3Bcdj = parcelRequire("3Bcdj");
var $5af70d1c5fca3e4e$exports = {};
"use strict";
Object.defineProperty($5af70d1c5fca3e4e$exports, "__esModule", {
    value: true
});
$5af70d1c5fca3e4e$exports.getHash = $5af70d1c5fca3e4e$var$getHash;
$5af70d1c5fca3e4e$exports.createCurve = $5af70d1c5fca3e4e$var$createCurve;


var $3Bcdj = parcelRequire("3Bcdj");
var $c3b91d553ab14e64$exports = {};
"use strict";
Object.defineProperty($c3b91d553ab14e64$exports, "__esModule", {
    value: true
});
$c3b91d553ab14e64$exports.DER = void 0;
$c3b91d553ab14e64$exports.weierstrassPoints = $c3b91d553ab14e64$var$weierstrassPoints;
$c3b91d553ab14e64$exports.weierstrass = $c3b91d553ab14e64$var$weierstrass;
$c3b91d553ab14e64$exports.SWUFpSqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio;
$c3b91d553ab14e64$exports.mapToCurveSimpleSWU = $c3b91d553ab14e64$var$mapToCurveSimpleSWU;

var $lkFCe = parcelRequire("lkFCe");

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

var $esaJO = parcelRequire("esaJO");
function $c3b91d553ab14e64$var$validateSigVerOpts(opts) {
    if (opts.lowS !== undefined) (0, $esaJO.abool)("lowS", opts.lowS);
    if (opts.prehash !== undefined) (0, $esaJO.abool)("prehash", opts.prehash);
}
function $c3b91d553ab14e64$var$validatePointOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        a: "field",
        b: "field"
    }, {
        allowedPrivateKeyLengths: "array",
        wrapPrivateKey: "boolean",
        isTorsionFree: "function",
        clearCofactor: "function",
        allowInfinityPoint: "boolean",
        fromBytes: "function",
        toBytes: "function"
    });
    const { endo: endo, Fp: Fp, a: a } = opts;
    if (endo) {
        if (!Fp.eql(a, Fp.ZERO)) throw new Error("Endomorphism can only be defined for Koblitz curves that have a=0");
        if (typeof endo !== "object" || typeof endo.beta !== "bigint" || typeof endo.splitScalar !== "function") throw new Error("Expected endomorphism with beta: bigint and splitScalar: function");
    }
    return Object.freeze({
        ...opts
    });
}
const { bytesToNumberBE: $c3b91d553ab14e64$var$b2n, hexToBytes: $c3b91d553ab14e64$var$h2b } = $esaJO;
/**
 * ASN.1 DER encoding utilities. ASN is very complex & fragile. Format:
 *
 *     [0x30 (SEQUENCE), bytelength, 0x02 (INTEGER), intLength, R, 0x02 (INTEGER), intLength, S]
 *
 * Docs: https://letsencrypt.org/docs/a-warm-welcome-to-asn1-and-der/, https://luca.ntop.org/Teaching/Appunti/asn1.html
 */ $c3b91d553ab14e64$exports.DER = {
    // asn.1 DER encoding utils
    Err: class DERErr extends Error {
        constructor(m = ""){
            super(m);
        }
    },
    // Basic building block is TLV (Tag-Length-Value)
    _tlv: {
        encode: (tag, data)=>{
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length & 1) throw new E("tlv.encode: unpadded data");
            const dataLen = data.length / 2;
            const len = $esaJO.numberToHexUnpadded(dataLen);
            if (len.length / 2 & 128) throw new E("tlv.encode: long form length too big");
            // length of length with long form flag
            const lenLen = dataLen > 127 ? $esaJO.numberToHexUnpadded(len.length / 2 | 128) : "";
            return `${$esaJO.numberToHexUnpadded(tag)}${lenLen}${len}${data}`;
        },
        // v - value, l - left bytes (unparsed)
        decode (tag, data) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            let pos = 0;
            if (tag < 0 || tag > 256) throw new E("tlv.encode: wrong tag");
            if (data.length < 2 || data[pos++] !== tag) throw new E("tlv.decode: wrong tlv");
            const first = data[pos++];
            const isLong = !!(first & 128); // First bit of first length byte is flag for short/long form
            let length = 0;
            if (!isLong) length = first;
            else {
                // Long form: [longFlag(1bit), lengthLength(7bit), length (BE)]
                const lenLen = first & 127;
                if (!lenLen) throw new E("tlv.decode(long): indefinite length not supported");
                if (lenLen > 4) throw new E("tlv.decode(long): byte length is too big"); // this will overflow u32 in js
                const lengthBytes = data.subarray(pos, pos + lenLen);
                if (lengthBytes.length !== lenLen) throw new E("tlv.decode: length bytes not complete");
                if (lengthBytes[0] === 0) throw new E("tlv.decode(long): zero leftmost byte");
                for (const b of lengthBytes)length = length << 8 | b;
                pos += lenLen;
                if (length < 128) throw new E("tlv.decode(long): not minimal encoding");
            }
            const v = data.subarray(pos, pos + length);
            if (v.length !== length) throw new E("tlv.decode: wrong value length");
            return {
                v: v,
                l: data.subarray(pos + length)
            };
        }
    },
    // https://crypto.stackexchange.com/a/57734 Leftmost bit of first byte is 'negative' flag,
    // since we always use positive integers here. It must always be empty:
    // - add zero byte if exists
    // - if next byte doesn't have a flag, leading zero is not allowed (minimal encoding)
    _int: {
        encode (num) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (num < $c3b91d553ab14e64$var$_0n) throw new E("integer: negative integers are not allowed");
            let hex = $esaJO.numberToHexUnpadded(num);
            // Pad with zero byte if negative flag is present
            if (Number.parseInt(hex[0], 16) & 8) hex = "00" + hex;
            if (hex.length & 1) throw new E("unexpected assertion");
            return hex;
        },
        decode (data) {
            const { Err: E } = $c3b91d553ab14e64$exports.DER;
            if (data[0] & 128) throw new E("Invalid signature integer: negative");
            if (data[0] === 0x00 && !(data[1] & 128)) throw new E("Invalid signature integer: unnecessary leading zero");
            return $c3b91d553ab14e64$var$b2n(data);
        }
    },
    toSig (hex) {
        // parse DER signature
        const { Err: E, _int: int, _tlv: tlv } = $c3b91d553ab14e64$exports.DER;
        const data = typeof hex === "string" ? $c3b91d553ab14e64$var$h2b(hex) : hex;
        $esaJO.abytes(data);
        const { v: seqBytes, l: seqLeftBytes } = tlv.decode(0x30, data);
        if (seqLeftBytes.length) throw new E("Invalid signature: left bytes after parsing");
        const { v: rBytes, l: rLeftBytes } = tlv.decode(0x02, seqBytes);
        const { v: sBytes, l: sLeftBytes } = tlv.decode(0x02, rLeftBytes);
        if (sLeftBytes.length) throw new E("Invalid signature: left bytes after parsing");
        return {
            r: int.decode(rBytes),
            s: int.decode(sBytes)
        };
    },
    hexFromSig (sig) {
        const { _tlv: tlv, _int: int } = $c3b91d553ab14e64$exports.DER;
        const seq = `${tlv.encode(0x02, int.encode(sig.r))}${tlv.encode(0x02, int.encode(sig.s))}`;
        return tlv.encode(0x30, seq);
    }
};
// Be friendly to bad ECMAScript parsers by not using bigint literals
// prettier-ignore
const $c3b91d553ab14e64$var$_0n = BigInt(0), $c3b91d553ab14e64$var$_1n = BigInt(1), $c3b91d553ab14e64$var$_2n = BigInt(2), $c3b91d553ab14e64$var$_3n = BigInt(3), $c3b91d553ab14e64$var$_4n = BigInt(4);
function $c3b91d553ab14e64$var$weierstrassPoints(opts) {
    const CURVE = $c3b91d553ab14e64$var$validatePointOpts(opts);
    const { Fp: Fp } = CURVE; // All curves has same field / group length as for now, but they can differ
    const Fn = $2D9sF.Field(CURVE.n, CURVE.nBitLength);
    const toBytes = CURVE.toBytes || ((_c, point, _isCompressed)=>{
        const a = point.toAffine();
        return $esaJO.concatBytes(Uint8Array.from([
            0x04
        ]), Fp.toBytes(a.x), Fp.toBytes(a.y));
    });
    const fromBytes = CURVE.fromBytes || ((bytes)=>{
        // const head = bytes[0];
        const tail = bytes.subarray(1);
        // if (head !== 0x04) throw new Error('Only non-compressed encoding is supported');
        const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
        const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
        return {
            x: x,
            y: y
        };
    });
    /**
     * y² = x³ + ax + b: Short weierstrass curve formula
     * @returns y²
     */ function weierstrassEquation(x) {
        const { a: a, b: b } = CURVE;
        const x2 = Fp.sqr(x); // x * x
        const x3 = Fp.mul(x2, x); // x2 * x
        return Fp.add(Fp.add(x3, Fp.mul(x, a)), b); // x3 + a * x + b
    }
    // Validate whether the passed curve params are valid.
    // We check if curve equation works for generator point.
    // `assertValidity()` won't work: `isTorsionFree()` is not available at this point in bls12-381.
    // ProjectivePoint class has not been initialized yet.
    if (!Fp.eql(Fp.sqr(CURVE.Gy), weierstrassEquation(CURVE.Gx))) throw new Error("bad generator point: equation left != right");
    // Valid group elements reside in range 1..n-1
    function isWithinCurveOrder(num) {
        return $esaJO.inRange(num, $c3b91d553ab14e64$var$_1n, CURVE.n);
    }
    // Validates if priv key is valid and converts it to bigint.
    // Supports options allowedPrivateKeyLengths and wrapPrivateKey.
    function normPrivateKeyToScalar(key) {
        const { allowedPrivateKeyLengths: lengths, nByteLength: nByteLength, wrapPrivateKey: wrapPrivateKey, n: N } = CURVE;
        if (lengths && typeof key !== "bigint") {
            if ($esaJO.isBytes(key)) key = $esaJO.bytesToHex(key);
            // Normalize to hex string, pad. E.g. P521 would norm 130-132 char hex to 132-char bytes
            if (typeof key !== "string" || !lengths.includes(key.length)) throw new Error("Invalid key");
            key = key.padStart(nByteLength * 2, "0");
        }
        let num;
        try {
            num = typeof key === "bigint" ? key : $esaJO.bytesToNumberBE((0, $esaJO.ensureBytes)("private key", key, nByteLength));
        } catch (error) {
            throw new Error(`private key must be ${nByteLength} bytes, hex or bigint, not ${typeof key}`);
        }
        if (wrapPrivateKey) num = $2D9sF.mod(num, N); // disabled by default, enabled for BLS
        $esaJO.aInRange("private key", num, $c3b91d553ab14e64$var$_1n, N); // num in range [1..N-1]
        return num;
    }
    function assertPrjPoint(other) {
        if (!(other instanceof Point)) throw new Error("ProjectivePoint expected");
    }
    // Memoized toAffine / validity check. They are heavy. Points are immutable.
    // Converts Projective point to affine (x, y) coordinates.
    // Can accept precomputed Z^-1 - for example, from invertBatch.
    // (x, y, z) ∋ (x=x/z, y=y/z)
    const toAffineMemo = (0, $esaJO.memoized)((p, iz)=>{
        const { px: x, py: y, pz: z } = p;
        // Fast-path for normalized points
        if (Fp.eql(z, Fp.ONE)) return {
            x: x,
            y: y
        };
        const is0 = p.is0();
        // If invZ was 0, we return zero point. However we still want to execute
        // all operations, so we replace invZ with a random number, 1.
        if (iz == null) iz = is0 ? Fp.ONE : Fp.inv(z);
        const ax = Fp.mul(x, iz);
        const ay = Fp.mul(y, iz);
        const zz = Fp.mul(z, iz);
        if (is0) return {
            x: Fp.ZERO,
            y: Fp.ZERO
        };
        if (!Fp.eql(zz, Fp.ONE)) throw new Error("invZ was invalid");
        return {
            x: ax,
            y: ay
        };
    });
    // NOTE: on exception this will crash 'cached' and no value will be set.
    // Otherwise true will be return
    const assertValidMemo = (0, $esaJO.memoized)((p)=>{
        if (p.is0()) {
            // (0, 1, 0) aka ZERO is invalid in most contexts.
            // In BLS, ZERO can be serialized, so we allow it.
            // (0, 0, 0) is wrong representation of ZERO and is always invalid.
            if (CURVE.allowInfinityPoint && !Fp.is0(p.py)) return;
            throw new Error("bad point: ZERO");
        }
        // Some 3rd-party test vectors require different wording between here & `fromCompressedHex`
        const { x: x, y: y } = p.toAffine();
        // Check if x, y are valid field elements
        if (!Fp.isValid(x) || !Fp.isValid(y)) throw new Error("bad point: x or y not FE");
        const left = Fp.sqr(y); // y²
        const right = weierstrassEquation(x); // x³ + ax + b
        if (!Fp.eql(left, right)) throw new Error("bad point: equation left != right");
        if (!p.isTorsionFree()) throw new Error("bad point: not in prime-order subgroup");
        return true;
    });
    /**
     * Projective Point works in 3d / projective (homogeneous) coordinates: (x, y, z) ∋ (x=x/z, y=y/z)
     * Default Point works in 2d / affine coordinates: (x, y)
     * We're doing calculations in projective, because its operations don't require costly inversion.
     */ class Point {
        constructor(px, py, pz){
            this.px = px;
            this.py = py;
            this.pz = pz;
            if (px == null || !Fp.isValid(px)) throw new Error("x required");
            if (py == null || !Fp.isValid(py)) throw new Error("y required");
            if (pz == null || !Fp.isValid(pz)) throw new Error("z required");
            Object.freeze(this);
        }
        // Does not validate if the point is on-curve.
        // Use fromHex instead, or call assertValidity() later.
        static fromAffine(p) {
            const { x: x, y: y } = p || {};
            if (!p || !Fp.isValid(x) || !Fp.isValid(y)) throw new Error("invalid affine point");
            if (p instanceof Point) throw new Error("projective point not allowed");
            const is0 = (i)=>Fp.eql(i, Fp.ZERO);
            // fromAffine(x:0, y:0) would produce (x:0, y:0, z:1), but we need (x:0, y:1, z:0)
            if (is0(x) && is0(y)) return Point.ZERO;
            return new Point(x, y, Fp.ONE);
        }
        get x() {
            return this.toAffine().x;
        }
        get y() {
            return this.toAffine().y;
        }
        /**
         * Takes a bunch of Projective Points but executes only one
         * inversion on all of them. Inversion is very slow operation,
         * so this improves performance massively.
         * Optimization: converts a list of projective points to a list of identical points with Z=1.
         */ static normalizeZ(points) {
            const toInv = Fp.invertBatch(points.map((p)=>p.pz));
            return points.map((p, i)=>p.toAffine(toInv[i])).map(Point.fromAffine);
        }
        /**
         * Converts hash string or Uint8Array to Point.
         * @param hex short/long ECDSA hex
         */ static fromHex(hex) {
            const P = Point.fromAffine(fromBytes((0, $esaJO.ensureBytes)("pointHex", hex)));
            P.assertValidity();
            return P;
        }
        // Multiplies generator point by privateKey.
        static fromPrivateKey(privateKey) {
            return Point.BASE.multiply(normPrivateKeyToScalar(privateKey));
        }
        // Multiscalar Multiplication
        static msm(points, scalars) {
            return (0, $lkFCe.pippenger)(Point, Fn, points, scalars);
        }
        // "Private method", don't use it directly
        _setWindowSize(windowSize) {
            wnaf.setWindowSize(this, windowSize);
        }
        // A point on curve is valid if it conforms to equation.
        assertValidity() {
            assertValidMemo(this);
        }
        hasEvenY() {
            const { y: y } = this.toAffine();
            if (Fp.isOdd) return !Fp.isOdd(y);
            throw new Error("Field doesn't support isOdd");
        }
        /**
         * Compare one point to another.
         */ equals(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            const U1 = Fp.eql(Fp.mul(X1, Z2), Fp.mul(X2, Z1));
            const U2 = Fp.eql(Fp.mul(Y1, Z2), Fp.mul(Y2, Z1));
            return U1 && U2;
        }
        /**
         * Flips point to one corresponding to (x, -y) in Affine coordinates.
         */ negate() {
            return new Point(this.px, Fp.neg(this.py), this.pz);
        }
        // Renes-Costello-Batina exception-free doubling formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 3
        // Cost: 8M + 3S + 3*a + 2*b3 + 15add.
        double() {
            const { a: a, b: b } = CURVE;
            const b3 = Fp.mul(b, $c3b91d553ab14e64$var$_3n);
            const { px: X1, py: Y1, pz: Z1 } = this;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            let t0 = Fp.mul(X1, X1); // step 1
            let t1 = Fp.mul(Y1, Y1);
            let t2 = Fp.mul(Z1, Z1);
            let t3 = Fp.mul(X1, Y1);
            t3 = Fp.add(t3, t3); // step 5
            Z3 = Fp.mul(X1, Z1);
            Z3 = Fp.add(Z3, Z3);
            X3 = Fp.mul(a, Z3);
            Y3 = Fp.mul(b3, t2);
            Y3 = Fp.add(X3, Y3); // step 10
            X3 = Fp.sub(t1, Y3);
            Y3 = Fp.add(t1, Y3);
            Y3 = Fp.mul(X3, Y3);
            X3 = Fp.mul(t3, X3);
            Z3 = Fp.mul(b3, Z3); // step 15
            t2 = Fp.mul(a, t2);
            t3 = Fp.sub(t0, t2);
            t3 = Fp.mul(a, t3);
            t3 = Fp.add(t3, Z3);
            Z3 = Fp.add(t0, t0); // step 20
            t0 = Fp.add(Z3, t0);
            t0 = Fp.add(t0, t2);
            t0 = Fp.mul(t0, t3);
            Y3 = Fp.add(Y3, t0);
            t2 = Fp.mul(Y1, Z1); // step 25
            t2 = Fp.add(t2, t2);
            t0 = Fp.mul(t2, t3);
            X3 = Fp.sub(X3, t0);
            Z3 = Fp.mul(t2, t1);
            Z3 = Fp.add(Z3, Z3); // step 30
            Z3 = Fp.add(Z3, Z3);
            return new Point(X3, Y3, Z3);
        }
        // Renes-Costello-Batina exception-free addition formula.
        // There is 30% faster Jacobian formula, but it is not complete.
        // https://eprint.iacr.org/2015/1060, algorithm 1
        // Cost: 12M + 0S + 3*a + 3*b3 + 23add.
        add(other) {
            assertPrjPoint(other);
            const { px: X1, py: Y1, pz: Z1 } = this;
            const { px: X2, py: Y2, pz: Z2 } = other;
            let X3 = Fp.ZERO, Y3 = Fp.ZERO, Z3 = Fp.ZERO; // prettier-ignore
            const a = CURVE.a;
            const b3 = Fp.mul(CURVE.b, $c3b91d553ab14e64$var$_3n);
            let t0 = Fp.mul(X1, X2); // step 1
            let t1 = Fp.mul(Y1, Y2);
            let t2 = Fp.mul(Z1, Z2);
            let t3 = Fp.add(X1, Y1);
            let t4 = Fp.add(X2, Y2); // step 5
            t3 = Fp.mul(t3, t4);
            t4 = Fp.add(t0, t1);
            t3 = Fp.sub(t3, t4);
            t4 = Fp.add(X1, Z1);
            let t5 = Fp.add(X2, Z2); // step 10
            t4 = Fp.mul(t4, t5);
            t5 = Fp.add(t0, t2);
            t4 = Fp.sub(t4, t5);
            t5 = Fp.add(Y1, Z1);
            X3 = Fp.add(Y2, Z2); // step 15
            t5 = Fp.mul(t5, X3);
            X3 = Fp.add(t1, t2);
            t5 = Fp.sub(t5, X3);
            Z3 = Fp.mul(a, t4);
            X3 = Fp.mul(b3, t2); // step 20
            Z3 = Fp.add(X3, Z3);
            X3 = Fp.sub(t1, Z3);
            Z3 = Fp.add(t1, Z3);
            Y3 = Fp.mul(X3, Z3);
            t1 = Fp.add(t0, t0); // step 25
            t1 = Fp.add(t1, t0);
            t2 = Fp.mul(a, t2);
            t4 = Fp.mul(b3, t4);
            t1 = Fp.add(t1, t2);
            t2 = Fp.sub(t0, t2); // step 30
            t2 = Fp.mul(a, t2);
            t4 = Fp.add(t4, t2);
            t0 = Fp.mul(t1, t4);
            Y3 = Fp.add(Y3, t0);
            t0 = Fp.mul(t5, t4); // step 35
            X3 = Fp.mul(t3, X3);
            X3 = Fp.sub(X3, t0);
            t0 = Fp.mul(t3, t1);
            Z3 = Fp.mul(t5, Z3);
            Z3 = Fp.add(Z3, t0); // step 40
            return new Point(X3, Y3, Z3);
        }
        subtract(other) {
            return this.add(other.negate());
        }
        is0() {
            return this.equals(Point.ZERO);
        }
        wNAF(n) {
            return wnaf.wNAFCached(this, n, Point.normalizeZ);
        }
        /**
         * Non-constant-time multiplication. Uses double-and-add algorithm.
         * It's faster, but should only be used when you don't care about
         * an exposed private key e.g. sig verification, which works over *public* keys.
         */ multiplyUnsafe(sc) {
            $esaJO.aInRange("scalar", sc, $c3b91d553ab14e64$var$_0n, CURVE.n);
            const I = Point.ZERO;
            if (sc === $c3b91d553ab14e64$var$_0n) return I;
            if (sc === $c3b91d553ab14e64$var$_1n) return this;
            const { endo: endo } = CURVE;
            if (!endo) return wnaf.unsafeLadder(this, sc);
            // Apply endomorphism
            let { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(sc);
            let k1p = I;
            let k2p = I;
            let d = this;
            while(k1 > $c3b91d553ab14e64$var$_0n || k2 > $c3b91d553ab14e64$var$_0n){
                if (k1 & $c3b91d553ab14e64$var$_1n) k1p = k1p.add(d);
                if (k2 & $c3b91d553ab14e64$var$_1n) k2p = k2p.add(d);
                d = d.double();
                k1 >>= $c3b91d553ab14e64$var$_1n;
                k2 >>= $c3b91d553ab14e64$var$_1n;
            }
            if (k1neg) k1p = k1p.negate();
            if (k2neg) k2p = k2p.negate();
            k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
            return k1p.add(k2p);
        }
        /**
         * Constant time multiplication.
         * Uses wNAF method. Windowed method may be 10% faster,
         * but takes 2x longer to generate and consumes 2x memory.
         * Uses precomputes when available.
         * Uses endomorphism for Koblitz curves.
         * @param scalar by which the point would be multiplied
         * @returns New point
         */ multiply(scalar) {
            const { endo: endo, n: N } = CURVE;
            $esaJO.aInRange("scalar", scalar, $c3b91d553ab14e64$var$_1n, N);
            let point, fake; // Fake point is used to const-time mult
            if (endo) {
                const { k1neg: k1neg, k1: k1, k2neg: k2neg, k2: k2 } = endo.splitScalar(scalar);
                let { p: k1p, f: f1p } = this.wNAF(k1);
                let { p: k2p, f: f2p } = this.wNAF(k2);
                k1p = wnaf.constTimeNegate(k1neg, k1p);
                k2p = wnaf.constTimeNegate(k2neg, k2p);
                k2p = new Point(Fp.mul(k2p.px, endo.beta), k2p.py, k2p.pz);
                point = k1p.add(k2p);
                fake = f1p.add(f2p);
            } else {
                const { p: p, f: f } = this.wNAF(scalar);
                point = p;
                fake = f;
            }
            // Normalize `z` for both points, but return only real one
            return Point.normalizeZ([
                point,
                fake
            ])[0];
        }
        /**
         * Efficiently calculate `aP + bQ`. Unsafe, can expose private key, if used incorrectly.
         * Not using Strauss-Shamir trick: precomputation tables are faster.
         * The trick could be useful if both P and Q are not G (not in our case).
         * @returns non-zero affine point
         */ multiplyAndAddUnsafe(Q, a, b) {
            const G = Point.BASE; // No Strauss-Shamir trick: we have 10% faster G precomputes
            const mul = (P, a // Select faster multiply() method
            )=>a === $c3b91d553ab14e64$var$_0n || a === $c3b91d553ab14e64$var$_1n || !P.equals(G) ? P.multiplyUnsafe(a) : P.multiply(a);
            const sum = mul(this, a).add(mul(Q, b));
            return sum.is0() ? undefined : sum;
        }
        // Converts Projective point to affine (x, y) coordinates.
        // Can accept precomputed Z^-1 - for example, from invertBatch.
        // (x, y, z) ∋ (x=x/z, y=y/z)
        toAffine(iz) {
            return toAffineMemo(this, iz);
        }
        isTorsionFree() {
            const { h: cofactor, isTorsionFree: isTorsionFree } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return true; // No subgroups, always torsion-free
            if (isTorsionFree) return isTorsionFree(Point, this);
            throw new Error("isTorsionFree() has not been declared for the elliptic curve");
        }
        clearCofactor() {
            const { h: cofactor, clearCofactor: clearCofactor } = CURVE;
            if (cofactor === $c3b91d553ab14e64$var$_1n) return this; // Fast-path
            if (clearCofactor) return clearCofactor(Point, this);
            return this.multiplyUnsafe(CURVE.h);
        }
        toRawBytes(isCompressed = true) {
            (0, $esaJO.abool)("isCompressed", isCompressed);
            this.assertValidity();
            return toBytes(Point, this, isCompressed);
        }
        toHex(isCompressed = true) {
            (0, $esaJO.abool)("isCompressed", isCompressed);
            return $esaJO.bytesToHex(this.toRawBytes(isCompressed));
        }
    }
    Point.BASE = new Point(CURVE.Gx, CURVE.Gy, Fp.ONE);
    Point.ZERO = new Point(Fp.ZERO, Fp.ONE, Fp.ZERO);
    const _bits = CURVE.nBitLength;
    const wnaf = (0, $lkFCe.wNAF)(Point, CURVE.endo ? Math.ceil(_bits / 2) : _bits);
    // Validate if generator point is on curve
    return {
        CURVE: CURVE,
        ProjectivePoint: Point,
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        weierstrassEquation: weierstrassEquation,
        isWithinCurveOrder: isWithinCurveOrder
    };
}
function $c3b91d553ab14e64$var$validateOpts(curve) {
    const opts = (0, $lkFCe.validateBasic)(curve);
    $esaJO.validateObject(opts, {
        hash: "hash",
        hmac: "function",
        randomBytes: "function"
    }, {
        bits2int: "function",
        bits2int_modN: "function",
        lowS: "boolean"
    });
    return Object.freeze({
        lowS: true,
        ...opts
    });
}
/**
 * Creates short weierstrass curve and ECDSA signature methods for it.
 * @example
 * import { Field } from '@noble/curves/abstract/modular';
 * // Before that, define BigInt-s: a, b, p, n, Gx, Gy
 * const curve = weierstrass({ a, b, Fp: Field(p), n, Gx, Gy, h: 1n })
 */ function $c3b91d553ab14e64$var$weierstrass(curveDef) {
    const CURVE = $c3b91d553ab14e64$var$validateOpts(curveDef);
    const { Fp: Fp, n: CURVE_ORDER } = CURVE;
    const compressedLen = Fp.BYTES + 1; // e.g. 33 for 32
    const uncompressedLen = 2 * Fp.BYTES + 1; // e.g. 65 for 32
    function modN(a) {
        return $2D9sF.mod(a, CURVE_ORDER);
    }
    function invN(a) {
        return $2D9sF.invert(a, CURVE_ORDER);
    }
    const { ProjectivePoint: Point, normPrivateKeyToScalar: normPrivateKeyToScalar, weierstrassEquation: weierstrassEquation, isWithinCurveOrder: isWithinCurveOrder } = $c3b91d553ab14e64$var$weierstrassPoints({
        ...CURVE,
        toBytes (_c, point, isCompressed) {
            const a = point.toAffine();
            const x = Fp.toBytes(a.x);
            const cat = $esaJO.concatBytes;
            (0, $esaJO.abool)("isCompressed", isCompressed);
            if (isCompressed) return cat(Uint8Array.from([
                point.hasEvenY() ? 0x02 : 0x03
            ]), x);
            else return cat(Uint8Array.from([
                0x04
            ]), x, Fp.toBytes(a.y));
        },
        fromBytes (bytes) {
            const len = bytes.length;
            const head = bytes[0];
            const tail = bytes.subarray(1);
            // this.assertValidity() is done inside of fromHex
            if (len === compressedLen && (head === 0x02 || head === 0x03)) {
                const x = $esaJO.bytesToNumberBE(tail);
                if (!$esaJO.inRange(x, $c3b91d553ab14e64$var$_1n, Fp.ORDER)) throw new Error("Point is not on curve");
                const y2 = weierstrassEquation(x); // y² = x³ + ax + b
                let y;
                try {
                    y = Fp.sqrt(y2); // y = y² ^ (p+1)/4
                } catch (sqrtError) {
                    const suffix = sqrtError instanceof Error ? ": " + sqrtError.message : "";
                    throw new Error("Point is not on curve" + suffix);
                }
                const isYOdd = (y & $c3b91d553ab14e64$var$_1n) === $c3b91d553ab14e64$var$_1n;
                // ECDSA
                const isHeadOdd = (head & 1) === 1;
                if (isHeadOdd !== isYOdd) y = Fp.neg(y);
                return {
                    x: x,
                    y: y
                };
            } else if (len === uncompressedLen && head === 0x04) {
                const x = Fp.fromBytes(tail.subarray(0, Fp.BYTES));
                const y = Fp.fromBytes(tail.subarray(Fp.BYTES, 2 * Fp.BYTES));
                return {
                    x: x,
                    y: y
                };
            } else throw new Error(`Point of length ${len} was invalid. Expected ${compressedLen} compressed bytes or ${uncompressedLen} uncompressed bytes`);
        }
    });
    const numToNByteStr = (num)=>$esaJO.bytesToHex($esaJO.numberToBytesBE(num, CURVE.nByteLength));
    function isBiggerThanHalfOrder(number) {
        const HALF = CURVE_ORDER >> $c3b91d553ab14e64$var$_1n;
        return number > HALF;
    }
    function normalizeS(s) {
        return isBiggerThanHalfOrder(s) ? modN(-s) : s;
    }
    // slice bytes num
    const slcNum = (b, from, to)=>$esaJO.bytesToNumberBE(b.slice(from, to));
    /**
     * ECDSA signature with its (r, s) properties. Supports DER & compact representations.
     */ class Signature {
        constructor(r, s, recovery){
            this.r = r;
            this.s = s;
            this.recovery = recovery;
            this.assertValidity();
        }
        // pair (bytes of r, bytes of s)
        static fromCompact(hex) {
            const l = CURVE.nByteLength;
            hex = (0, $esaJO.ensureBytes)("compactSignature", hex, l * 2);
            return new Signature(slcNum(hex, 0, l), slcNum(hex, l, 2 * l));
        }
        // DER encoded ECDSA signature
        // https://bitcoin.stackexchange.com/questions/57644/what-are-the-parts-of-a-bitcoin-transaction-input-script
        static fromDER(hex) {
            const { r: r, s: s } = $c3b91d553ab14e64$exports.DER.toSig((0, $esaJO.ensureBytes)("DER", hex));
            return new Signature(r, s);
        }
        assertValidity() {
            $esaJO.aInRange("r", this.r, $c3b91d553ab14e64$var$_1n, CURVE_ORDER); // r in [1..N]
            $esaJO.aInRange("s", this.s, $c3b91d553ab14e64$var$_1n, CURVE_ORDER); // s in [1..N]
        }
        addRecoveryBit(recovery) {
            return new Signature(this.r, this.s, recovery);
        }
        recoverPublicKey(msgHash) {
            const { r: r, s: s, recovery: rec } = this;
            const h = bits2int_modN((0, $esaJO.ensureBytes)("msgHash", msgHash)); // Truncate hash
            if (rec == null || ![
                0,
                1,
                2,
                3
            ].includes(rec)) throw new Error("recovery id invalid");
            const radj = rec === 2 || rec === 3 ? r + CURVE.n : r;
            if (radj >= Fp.ORDER) throw new Error("recovery id 2 or 3 invalid");
            const prefix = (rec & 1) === 0 ? "02" : "03";
            const R = Point.fromHex(prefix + numToNByteStr(radj));
            const ir = invN(radj); // r^-1
            const u1 = modN(-h * ir); // -hr^-1
            const u2 = modN(s * ir); // sr^-1
            const Q = Point.BASE.multiplyAndAddUnsafe(R, u1, u2); // (sr^-1)R-(hr^-1)G = -(hr^-1)G + (sr^-1)
            if (!Q) throw new Error("point at infinify"); // unsafe is fine: no priv data leaked
            Q.assertValidity();
            return Q;
        }
        // Signatures should be low-s, to prevent malleability.
        hasHighS() {
            return isBiggerThanHalfOrder(this.s);
        }
        normalizeS() {
            return this.hasHighS() ? new Signature(this.r, modN(-this.s), this.recovery) : this;
        }
        // DER-encoded
        toDERRawBytes() {
            return $esaJO.hexToBytes(this.toDERHex());
        }
        toDERHex() {
            return $c3b91d553ab14e64$exports.DER.hexFromSig({
                r: this.r,
                s: this.s
            });
        }
        // padded bytes of r, then padded bytes of s
        toCompactRawBytes() {
            return $esaJO.hexToBytes(this.toCompactHex());
        }
        toCompactHex() {
            return numToNByteStr(this.r) + numToNByteStr(this.s);
        }
    }
    const utils = {
        isValidPrivateKey (privateKey) {
            try {
                normPrivateKeyToScalar(privateKey);
                return true;
            } catch (error) {
                return false;
            }
        },
        normPrivateKeyToScalar: normPrivateKeyToScalar,
        /**
         * Produces cryptographically secure private key from random of size
         * (groupLen + ceil(groupLen / 2)) with modulo bias being negligible.
         */ randomPrivateKey: ()=>{
            const length = $2D9sF.getMinHashLength(CURVE.n);
            return $2D9sF.mapHashToField(CURVE.randomBytes(length), CURVE.n);
        },
        /**
         * Creates precompute table for an arbitrary EC point. Makes point "cached".
         * Allows to massively speed-up `point.multiply(scalar)`.
         * @returns cached point
         * @example
         * const fast = utils.precompute(8, ProjectivePoint.fromHex(someonesPubKey));
         * fast.multiply(privKey); // much faster ECDH now
         */ precompute (windowSize = 8, point = Point.BASE) {
            point._setWindowSize(windowSize);
            point.multiply(BigInt(3)); // 3 is arbitrary, just need any number here
            return point;
        }
    };
    /**
     * Computes public key for a private key. Checks for validity of the private key.
     * @param privateKey private key
     * @param isCompressed whether to return compact (default), or full key
     * @returns Public key, full when isCompressed=false; short when isCompressed=true
     */ function getPublicKey(privateKey, isCompressed = true) {
        return Point.fromPrivateKey(privateKey).toRawBytes(isCompressed);
    }
    /**
     * Quick and dirty check for item being public key. Does not validate hex, or being on-curve.
     */ function isProbPub(item) {
        const arr = $esaJO.isBytes(item);
        const str = typeof item === "string";
        const len = (arr || str) && item.length;
        if (arr) return len === compressedLen || len === uncompressedLen;
        if (str) return len === 2 * compressedLen || len === 2 * uncompressedLen;
        if (item instanceof Point) return true;
        return false;
    }
    /**
     * ECDH (Elliptic Curve Diffie Hellman).
     * Computes shared public key from private key and public key.
     * Checks: 1) private key validity 2) shared key is on-curve.
     * Does NOT hash the result.
     * @param privateA private key
     * @param publicB different public key
     * @param isCompressed whether to return compact (default), or full key
     * @returns shared public key
     */ function getSharedSecret(privateA, publicB, isCompressed = true) {
        if (isProbPub(privateA)) throw new Error("first arg must be private key");
        if (!isProbPub(publicB)) throw new Error("second arg must be public key");
        const b = Point.fromHex(publicB); // check for being on-curve
        return b.multiply(normPrivateKeyToScalar(privateA)).toRawBytes(isCompressed);
    }
    // RFC6979: ensure ECDSA msg is X bytes and < N. RFC suggests optional truncating via bits2octets.
    // FIPS 186-4 4.6 suggests the leftmost min(nBitLen, outLen) bits, which matches bits2int.
    // bits2int can produce res>N, we can do mod(res, N) since the bitLen is the same.
    // int2octets can't be used; pads small msgs with 0: unacceptatble for trunc as per RFC vectors
    const bits2int = CURVE.bits2int || function(bytes) {
        // For curves with nBitLength % 8 !== 0: bits2octets(bits2octets(m)) !== bits2octets(m)
        // for some cases, since bytes.length * 8 is not actual bitLength.
        const num = $esaJO.bytesToNumberBE(bytes); // check for == u8 done here
        const delta = bytes.length * 8 - CURVE.nBitLength; // truncate to nBitLength leftmost bits
        return delta > 0 ? num >> BigInt(delta) : num;
    };
    const bits2int_modN = CURVE.bits2int_modN || function(bytes) {
        return modN(bits2int(bytes)); // can't use bytesToNumberBE here
    };
    // NOTE: pads output with zero as per spec
    const ORDER_MASK = $esaJO.bitMask(CURVE.nBitLength);
    /**
     * Converts to bytes. Checks if num in `[0..ORDER_MASK-1]` e.g.: `[0..2^256-1]`.
     */ function int2octets(num) {
        $esaJO.aInRange(`num < 2^${CURVE.nBitLength}`, num, $c3b91d553ab14e64$var$_0n, ORDER_MASK);
        // works with order, can have different size than numToField!
        return $esaJO.numberToBytesBE(num, CURVE.nByteLength);
    }
    // Steps A, D of RFC6979 3.2
    // Creates RFC6979 seed; converts msg/privKey to numbers.
    // Used only in sign, not in verify.
    // NOTE: we cannot assume here that msgHash has same amount of bytes as curve order, this will be wrong at least for P521.
    // Also it can be bigger for P224 + SHA256
    function prepSig(msgHash, privateKey, opts = defaultSigOpts) {
        if ([
            "recovered",
            "canonical"
        ].some((k)=>k in opts)) throw new Error("sign() legacy options not supported");
        const { hash: hash, randomBytes: randomBytes } = CURVE;
        let { lowS: lowS, prehash: prehash, extraEntropy: ent } = opts; // generates low-s sigs by default
        if (lowS == null) lowS = true; // RFC6979 3.2: we skip step A, because we already provide hash
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        $c3b91d553ab14e64$var$validateSigVerOpts(opts);
        if (prehash) msgHash = (0, $esaJO.ensureBytes)("prehashed msgHash", hash(msgHash));
        // We can't later call bits2octets, since nested bits2int is broken for curves
        // with nBitLength % 8 !== 0. Because of that, we unwrap it here as int2octets call.
        // const bits2octets = (bits) => int2octets(bits2int_modN(bits))
        const h1int = bits2int_modN(msgHash);
        const d = normPrivateKeyToScalar(privateKey); // validate private key, convert to bigint
        const seedArgs = [
            int2octets(d),
            int2octets(h1int)
        ];
        // extraEntropy. RFC6979 3.6: additional k' (optional).
        if (ent != null && ent !== false) {
            // K = HMAC_K(V || 0x00 || int2octets(x) || bits2octets(h1) || k')
            const e = ent === true ? randomBytes(Fp.BYTES) : ent; // generate random bytes OR pass as-is
            seedArgs.push((0, $esaJO.ensureBytes)("extraEntropy", e)); // check for being bytes
        }
        const seed = $esaJO.concatBytes(...seedArgs); // Step D of RFC6979 3.2
        const m = h1int; // NOTE: no need to call bits2int second time here, it is inside truncateHash!
        // Converts signature params into point w r/s, checks result for validity.
        function k2sig(kBytes) {
            // RFC 6979 Section 3.2, step 3: k = bits2int(T)
            const k = bits2int(kBytes); // Cannot use fields methods, since it is group element
            if (!isWithinCurveOrder(k)) return; // Important: all mod() calls here must be done over N
            const ik = invN(k); // k^-1 mod n
            const q = Point.BASE.multiply(k).toAffine(); // q = Gk
            const r = modN(q.x); // r = q.x mod n
            if (r === $c3b91d553ab14e64$var$_0n) return;
            // Can use scalar blinding b^-1(bm + bdr) where b ∈ [1,q−1] according to
            // https://tches.iacr.org/index.php/TCHES/article/view/7337/6509. We've decided against it:
            // a) dependency on CSPRNG b) 15% slowdown c) doesn't really help since bigints are not CT
            const s = modN(ik * modN(m + r * d)); // Not using blinding here
            if (s === $c3b91d553ab14e64$var$_0n) return;
            let recovery = (q.x === r ? 0 : 2) | Number(q.y & $c3b91d553ab14e64$var$_1n); // recovery bit (2 or 3, when q.x > n)
            let normS = s;
            if (lowS && isBiggerThanHalfOrder(s)) {
                normS = normalizeS(s); // if lowS was passed, ensure s is always
                recovery ^= 1; // // in the bottom half of N
            }
            return new Signature(r, normS, recovery); // use normS, not s
        }
        return {
            seed: seed,
            k2sig: k2sig
        };
    }
    const defaultSigOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    const defaultVerOpts = {
        lowS: CURVE.lowS,
        prehash: false
    };
    /**
     * Signs message hash with a private key.
     * ```
     * sign(m, d, k) where
     *   (x, y) = G × k
     *   r = x mod n
     *   s = (m + dr)/k mod n
     * ```
     * @param msgHash NOT message. msg needs to be hashed to `msgHash`, or use `prehash`.
     * @param privKey private key
     * @param opts lowS for non-malleable sigs. extraEntropy for mixing randomness into k. prehash will hash first arg.
     * @returns signature with recovery param
     */ function sign(msgHash, privKey, opts = defaultSigOpts) {
        const { seed: seed, k2sig: k2sig } = prepSig(msgHash, privKey, opts); // Steps A, D of RFC6979 3.2.
        const C = CURVE;
        const drbg = $esaJO.createHmacDrbg(C.hash.outputLen, C.nByteLength, C.hmac);
        return drbg(seed, k2sig); // Steps B, C, D, E, F, G
    }
    // Enable precomputes. Slows down first publicKey computation by 20ms.
    Point.BASE._setWindowSize(8);
    // utils.precompute(8, ProjectivePoint.BASE)
    /**
     * Verifies a signature against message hash and public key.
     * Rejects lowS signatures by default: to override,
     * specify option `{lowS: false}`. Implements section 4.1.4 from https://www.secg.org/sec1-v2.pdf:
     *
     * ```
     * verify(r, s, h, P) where
     *   U1 = hs^-1 mod n
     *   U2 = rs^-1 mod n
     *   R = U1⋅G - U2⋅P
     *   mod(R.x, n) == r
     * ```
     */ function verify(signature, msgHash, publicKey, opts = defaultVerOpts) {
        const sg = signature;
        msgHash = (0, $esaJO.ensureBytes)("msgHash", msgHash);
        publicKey = (0, $esaJO.ensureBytes)("publicKey", publicKey);
        if ("strict" in opts) throw new Error("options.strict was renamed to lowS");
        $c3b91d553ab14e64$var$validateSigVerOpts(opts);
        const { lowS: lowS, prehash: prehash } = opts;
        let _sig = undefined;
        let P;
        try {
            if (typeof sg === "string" || $esaJO.isBytes(sg)) // Signature can be represented in 2 ways: compact (2*nByteLength) & DER (variable-length).
            // Since DER can also be 2*nByteLength bytes, we check for it first.
            try {
                _sig = Signature.fromDER(sg);
            } catch (derError) {
                if (!(derError instanceof $c3b91d553ab14e64$exports.DER.Err)) throw derError;
                _sig = Signature.fromCompact(sg);
            }
            else if (typeof sg === "object" && typeof sg.r === "bigint" && typeof sg.s === "bigint") {
                const { r: r, s: s } = sg;
                _sig = new Signature(r, s);
            } else throw new Error("PARSE");
            P = Point.fromHex(publicKey);
        } catch (error) {
            if (error.message === "PARSE") throw new Error(`signature must be Signature instance, Uint8Array or hex string`);
            return false;
        }
        if (lowS && _sig.hasHighS()) return false;
        if (prehash) msgHash = CURVE.hash(msgHash);
        const { r: r, s: s } = _sig;
        const h = bits2int_modN(msgHash); // Cannot use fields methods, since it is group element
        const is = invN(s); // s^-1
        const u1 = modN(h * is); // u1 = hs^-1 mod n
        const u2 = modN(r * is); // u2 = rs^-1 mod n
        const R = Point.BASE.multiplyAndAddUnsafe(P, u1, u2)?.toAffine(); // R = u1⋅G + u2⋅P
        if (!R) return false;
        const v = modN(R.x);
        return v === r;
    }
    return {
        CURVE: CURVE,
        getPublicKey: getPublicKey,
        getSharedSecret: getSharedSecret,
        sign: sign,
        verify: verify,
        ProjectivePoint: Point,
        Signature: Signature,
        utils: utils
    };
}
/**
 * Implementation of the Shallue and van de Woestijne method for any weierstrass curve.
 * TODO: check if there is a way to merge this with uvRatio in Edwards; move to modular.
 * b = True and y = sqrt(u / v) if (u / v) is square in F, and
 * b = False and y = sqrt(Z * (u / v)) otherwise.
 * @param Fp
 * @param Z
 * @returns
 */ function $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, Z) {
    // Generic implementation
    const q = Fp.ORDER;
    let l = $c3b91d553ab14e64$var$_0n;
    for(let o = q - $c3b91d553ab14e64$var$_1n; o % $c3b91d553ab14e64$var$_2n === $c3b91d553ab14e64$var$_0n; o /= $c3b91d553ab14e64$var$_2n)l += $c3b91d553ab14e64$var$_1n;
    const c1 = l; // 1. c1, the largest integer such that 2^c1 divides q - 1.
    // We need 2n ** c1 and 2n ** (c1-1). We can't use **; but we can use <<.
    // 2n ** c1 == 2n << (c1-1)
    const _2n_pow_c1_1 = $c3b91d553ab14e64$var$_2n << c1 - $c3b91d553ab14e64$var$_1n - $c3b91d553ab14e64$var$_1n;
    const _2n_pow_c1 = _2n_pow_c1_1 * $c3b91d553ab14e64$var$_2n;
    const c2 = (q - $c3b91d553ab14e64$var$_1n) / _2n_pow_c1; // 2. c2 = (q - 1) / (2^c1)  # Integer arithmetic
    const c3 = (c2 - $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n; // 3. c3 = (c2 - 1) / 2            # Integer arithmetic
    const c4 = _2n_pow_c1 - $c3b91d553ab14e64$var$_1n; // 4. c4 = 2^c1 - 1                # Integer arithmetic
    const c5 = _2n_pow_c1_1; // 5. c5 = 2^(c1 - 1)                  # Integer arithmetic
    const c6 = Fp.pow(Z, c2); // 6. c6 = Z^c2
    const c7 = Fp.pow(Z, (c2 + $c3b91d553ab14e64$var$_1n) / $c3b91d553ab14e64$var$_2n); // 7. c7 = Z^((c2 + 1) / 2)
    let sqrtRatio = (u, v)=>{
        let tv1 = c6; // 1. tv1 = c6
        let tv2 = Fp.pow(v, c4); // 2. tv2 = v^c4
        let tv3 = Fp.sqr(tv2); // 3. tv3 = tv2^2
        tv3 = Fp.mul(tv3, v); // 4. tv3 = tv3 * v
        let tv5 = Fp.mul(u, tv3); // 5. tv5 = u * tv3
        tv5 = Fp.pow(tv5, c3); // 6. tv5 = tv5^c3
        tv5 = Fp.mul(tv5, tv2); // 7. tv5 = tv5 * tv2
        tv2 = Fp.mul(tv5, v); // 8. tv2 = tv5 * v
        tv3 = Fp.mul(tv5, u); // 9. tv3 = tv5 * u
        let tv4 = Fp.mul(tv3, tv2); // 10. tv4 = tv3 * tv2
        tv5 = Fp.pow(tv4, c5); // 11. tv5 = tv4^c5
        let isQR = Fp.eql(tv5, Fp.ONE); // 12. isQR = tv5 == 1
        tv2 = Fp.mul(tv3, c7); // 13. tv2 = tv3 * c7
        tv5 = Fp.mul(tv4, tv1); // 14. tv5 = tv4 * tv1
        tv3 = Fp.cmov(tv2, tv3, isQR); // 15. tv3 = CMOV(tv2, tv3, isQR)
        tv4 = Fp.cmov(tv5, tv4, isQR); // 16. tv4 = CMOV(tv5, tv4, isQR)
        // 17. for i in (c1, c1 - 1, ..., 2):
        for(let i = c1; i > $c3b91d553ab14e64$var$_1n; i--){
            let tv5 = i - $c3b91d553ab14e64$var$_2n; // 18.    tv5 = i - 2
            tv5 = $c3b91d553ab14e64$var$_2n << tv5 - $c3b91d553ab14e64$var$_1n; // 19.    tv5 = 2^tv5
            let tvv5 = Fp.pow(tv4, tv5); // 20.    tv5 = tv4^tv5
            const e1 = Fp.eql(tvv5, Fp.ONE); // 21.    e1 = tv5 == 1
            tv2 = Fp.mul(tv3, tv1); // 22.    tv2 = tv3 * tv1
            tv1 = Fp.mul(tv1, tv1); // 23.    tv1 = tv1 * tv1
            tvv5 = Fp.mul(tv4, tv1); // 24.    tv5 = tv4 * tv1
            tv3 = Fp.cmov(tv2, tv3, e1); // 25.    tv3 = CMOV(tv2, tv3, e1)
            tv4 = Fp.cmov(tvv5, tv4, e1); // 26.    tv4 = CMOV(tv5, tv4, e1)
        }
        return {
            isValid: isQR,
            value: tv3
        };
    };
    if (Fp.ORDER % $c3b91d553ab14e64$var$_4n === $c3b91d553ab14e64$var$_3n) {
        // sqrt_ratio_3mod4(u, v)
        const c1 = (Fp.ORDER - $c3b91d553ab14e64$var$_3n) / $c3b91d553ab14e64$var$_4n; // 1. c1 = (q - 3) / 4     # Integer arithmetic
        const c2 = Fp.sqrt(Fp.neg(Z)); // 2. c2 = sqrt(-Z)
        sqrtRatio = (u, v)=>{
            let tv1 = Fp.sqr(v); // 1. tv1 = v^2
            const tv2 = Fp.mul(u, v); // 2. tv2 = u * v
            tv1 = Fp.mul(tv1, tv2); // 3. tv1 = tv1 * tv2
            let y1 = Fp.pow(tv1, c1); // 4. y1 = tv1^c1
            y1 = Fp.mul(y1, tv2); // 5. y1 = y1 * tv2
            const y2 = Fp.mul(y1, c2); // 6. y2 = y1 * c2
            const tv3 = Fp.mul(Fp.sqr(y1), v); // 7. tv3 = y1^2; 8. tv3 = tv3 * v
            const isQR = Fp.eql(tv3, u); // 9. isQR = tv3 == u
            let y = Fp.cmov(y2, y1, isQR); // 10. y = CMOV(y2, y1, isQR)
            return {
                isValid: isQR,
                value: y
            }; // 11. return (isQR, y) isQR ? y : y*c2
        };
    }
    // No curves uses that
    // if (Fp.ORDER % _8n === _5n) // sqrt_ratio_5mod8
    return sqrtRatio;
}
/**
 * Simplified Shallue-van de Woestijne-Ulas Method
 * https://www.rfc-editor.org/rfc/rfc9380#section-6.6.2
 */ function $c3b91d553ab14e64$var$mapToCurveSimpleSWU(Fp, opts) {
    $2D9sF.validateField(Fp);
    if (!Fp.isValid(opts.A) || !Fp.isValid(opts.B) || !Fp.isValid(opts.Z)) throw new Error("mapToCurveSimpleSWU: invalid opts");
    const sqrtRatio = $c3b91d553ab14e64$var$SWUFpSqrtRatio(Fp, opts.Z);
    if (!Fp.isOdd) throw new Error("Fp.isOdd is not implemented!");
    // Input: u, an element of F.
    // Output: (x, y), a point on E.
    return (u)=>{
        // prettier-ignore
        let tv1, tv2, tv3, tv4, tv5, tv6, x, y;
        tv1 = Fp.sqr(u); // 1.  tv1 = u^2
        tv1 = Fp.mul(tv1, opts.Z); // 2.  tv1 = Z * tv1
        tv2 = Fp.sqr(tv1); // 3.  tv2 = tv1^2
        tv2 = Fp.add(tv2, tv1); // 4.  tv2 = tv2 + tv1
        tv3 = Fp.add(tv2, Fp.ONE); // 5.  tv3 = tv2 + 1
        tv3 = Fp.mul(tv3, opts.B); // 6.  tv3 = B * tv3
        tv4 = Fp.cmov(opts.Z, Fp.neg(tv2), !Fp.eql(tv2, Fp.ZERO)); // 7.  tv4 = CMOV(Z, -tv2, tv2 != 0)
        tv4 = Fp.mul(tv4, opts.A); // 8.  tv4 = A * tv4
        tv2 = Fp.sqr(tv3); // 9.  tv2 = tv3^2
        tv6 = Fp.sqr(tv4); // 10. tv6 = tv4^2
        tv5 = Fp.mul(tv6, opts.A); // 11. tv5 = A * tv6
        tv2 = Fp.add(tv2, tv5); // 12. tv2 = tv2 + tv5
        tv2 = Fp.mul(tv2, tv3); // 13. tv2 = tv2 * tv3
        tv6 = Fp.mul(tv6, tv4); // 14. tv6 = tv6 * tv4
        tv5 = Fp.mul(tv6, opts.B); // 15. tv5 = B * tv6
        tv2 = Fp.add(tv2, tv5); // 16. tv2 = tv2 + tv5
        x = Fp.mul(tv1, tv3); // 17.   x = tv1 * tv3
        const { isValid: isValid, value: value } = sqrtRatio(tv2, tv6); // 18. (is_gx1_square, y1) = sqrt_ratio(tv2, tv6)
        y = Fp.mul(tv1, u); // 19.   y = tv1 * u  -> Z * u^3 * y1
        y = Fp.mul(y, value); // 20.   y = y * y1
        x = Fp.cmov(x, tv3, isValid); // 21.   x = CMOV(x, tv3, is_gx1_square)
        y = Fp.cmov(y, value, isValid); // 22.   y = CMOV(y, y1, is_gx1_square)
        const e1 = Fp.isOdd(u) === Fp.isOdd(y); // 23.  e1 = sgn0(u) == sgn0(y)
        y = Fp.cmov(Fp.neg(y), y, e1); // 24.   y = CMOV(-y, y, e1)
        x = Fp.div(x, tv4); // 25.   x = x / tv4
        return {
            x: x,
            y: y
        };
    };
}


// connects noble-curves to noble-hashes
function $5af70d1c5fca3e4e$var$getHash(hash) {
    return {
        hash: hash,
        hmac: (key, ...msgs)=>(0, $51b6b372898f65c0$exports.hmac)(hash, key, (0, $3Bcdj.concatBytes)(...msgs)),
        randomBytes: $3Bcdj.randomBytes
    };
}
function $5af70d1c5fca3e4e$var$createCurve(curveDef, defHash) {
    const create = (hash)=>(0, $c3b91d553ab14e64$exports.weierstrass)({
            ...curveDef,
            ...$5af70d1c5fca3e4e$var$getHash(hash)
        });
    return Object.freeze({
        ...create(defHash),
        create: create
    });
}


var $0522aeca5769187c$exports = {};
"use strict";
Object.defineProperty($0522aeca5769187c$exports, "__esModule", {
    value: true
});
$0522aeca5769187c$exports.expand_message_xmd = $0522aeca5769187c$var$expand_message_xmd;
$0522aeca5769187c$exports.expand_message_xof = $0522aeca5769187c$var$expand_message_xof;
$0522aeca5769187c$exports.hash_to_field = $0522aeca5769187c$var$hash_to_field;
$0522aeca5769187c$exports.isogenyMap = $0522aeca5769187c$var$isogenyMap;
$0522aeca5769187c$exports.createHasher = $0522aeca5769187c$var$createHasher;

var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");
// Octet Stream to Integer. "spec" implementation of os2ip is 2.5x slower vs bytesToNumberBE.
const $0522aeca5769187c$var$os2ip = $esaJO.bytesToNumberBE;
// Integer to Octet Stream (numberToBytesBE)
function $0522aeca5769187c$var$i2osp(value, length) {
    $0522aeca5769187c$var$anum(value);
    $0522aeca5769187c$var$anum(length);
    if (value < 0 || value >= 1 << 8 * length) throw new Error(`bad I2OSP call: value=${value} length=${length}`);
    const res = Array.from({
        length: length
    }).fill(0);
    for(let i = length - 1; i >= 0; i--){
        res[i] = value & 0xff;
        value >>>= 8;
    }
    return new Uint8Array(res);
}
function $0522aeca5769187c$var$strxor(a, b) {
    const arr = new Uint8Array(a.length);
    for(let i = 0; i < a.length; i++)arr[i] = a[i] ^ b[i];
    return arr;
}
function $0522aeca5769187c$var$anum(item) {
    if (!Number.isSafeInteger(item)) throw new Error("number expected");
}
// Produces a uniformly random byte string using a cryptographic hash function H that outputs b bits
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.1
function $0522aeca5769187c$var$expand_message_xmd(msg, DST, lenInBytes, H) {
    (0, $esaJO.abytes)(msg);
    (0, $esaJO.abytes)(DST);
    $0522aeca5769187c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    if (DST.length > 255) DST = H((0, $esaJO.concatBytes)((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-"), DST));
    const { outputLen: b_in_bytes, blockLen: r_in_bytes } = H;
    const ell = Math.ceil(lenInBytes / b_in_bytes);
    if (lenInBytes > 65535 || ell > 255) throw new Error("expand_message_xmd: invalid lenInBytes");
    const DST_prime = (0, $esaJO.concatBytes)(DST, $0522aeca5769187c$var$i2osp(DST.length, 1));
    const Z_pad = $0522aeca5769187c$var$i2osp(0, r_in_bytes);
    const l_i_b_str = $0522aeca5769187c$var$i2osp(lenInBytes, 2); // len_in_bytes_str
    const b = new Array(ell);
    const b_0 = H((0, $esaJO.concatBytes)(Z_pad, msg, l_i_b_str, $0522aeca5769187c$var$i2osp(0, 1), DST_prime));
    b[0] = H((0, $esaJO.concatBytes)(b_0, $0522aeca5769187c$var$i2osp(1, 1), DST_prime));
    for(let i = 1; i <= ell; i++){
        const args = [
            $0522aeca5769187c$var$strxor(b_0, b[i - 1]),
            $0522aeca5769187c$var$i2osp(i + 1, 1),
            DST_prime
        ];
        b[i] = H((0, $esaJO.concatBytes)(...args));
    }
    const pseudo_random_bytes = (0, $esaJO.concatBytes)(...b);
    return pseudo_random_bytes.slice(0, lenInBytes);
}
// Produces a uniformly random byte string using an extendable-output function (XOF) H.
// 1. The collision resistance of H MUST be at least k bits.
// 2. H MUST be an XOF that has been proved indifferentiable from
//    a random oracle under a reasonable cryptographic assumption.
// https://www.rfc-editor.org/rfc/rfc9380#section-5.3.2
function $0522aeca5769187c$var$expand_message_xof(msg, DST, lenInBytes, k, H) {
    (0, $esaJO.abytes)(msg);
    (0, $esaJO.abytes)(DST);
    $0522aeca5769187c$var$anum(lenInBytes);
    // https://www.rfc-editor.org/rfc/rfc9380#section-5.3.3
    // DST = H('H2C-OVERSIZE-DST-' || a_very_long_DST, Math.ceil((lenInBytes * k) / 8));
    if (DST.length > 255) {
        const dkLen = Math.ceil(2 * k / 8);
        DST = H.create({
            dkLen: dkLen
        }).update((0, $esaJO.utf8ToBytes)("H2C-OVERSIZE-DST-")).update(DST).digest();
    }
    if (lenInBytes > 65535 || DST.length > 255) throw new Error("expand_message_xof: invalid lenInBytes");
    return H.create({
        dkLen: lenInBytes
    }).update(msg).update($0522aeca5769187c$var$i2osp(lenInBytes, 2))// 2. DST_prime = DST || I2OSP(len(DST), 1)
    .update(DST).update($0522aeca5769187c$var$i2osp(DST.length, 1)).digest();
}
/**
 * Hashes arbitrary-length byte strings to a list of one or more elements of a finite field F
 * https://www.rfc-editor.org/rfc/rfc9380#section-5.2
 * @param msg a byte string containing the message to hash
 * @param count the number of elements of F to output
 * @param options `{DST: string, p: bigint, m: number, k: number, expand: 'xmd' | 'xof', hash: H}`, see above
 * @returns [u_0, ..., u_(count - 1)], a list of field elements.
 */ function $0522aeca5769187c$var$hash_to_field(msg, count, options) {
    (0, $esaJO.validateObject)(options, {
        DST: "stringOrUint8Array",
        p: "bigint",
        m: "isSafeInteger",
        k: "isSafeInteger",
        hash: "hash"
    });
    const { p: p, k: k, m: m, hash: hash, expand: expand, DST: _DST } = options;
    (0, $esaJO.abytes)(msg);
    $0522aeca5769187c$var$anum(count);
    const DST = typeof _DST === "string" ? (0, $esaJO.utf8ToBytes)(_DST) : _DST;
    const log2p = p.toString(2).length;
    const L = Math.ceil((log2p + k) / 8); // section 5.1 of ietf draft link above
    const len_in_bytes = count * m * L;
    let prb; // pseudo_random_bytes
    if (expand === "xmd") prb = $0522aeca5769187c$var$expand_message_xmd(msg, DST, len_in_bytes, hash);
    else if (expand === "xof") prb = $0522aeca5769187c$var$expand_message_xof(msg, DST, len_in_bytes, k, hash);
    else if (expand === "_internal_pass") // for internal tests only
    prb = msg;
    else throw new Error('expand must be "xmd" or "xof"');
    const u = new Array(count);
    for(let i = 0; i < count; i++){
        const e = new Array(m);
        for(let j = 0; j < m; j++){
            const elm_offset = L * (j + i * m);
            const tv = prb.subarray(elm_offset, elm_offset + L);
            e[j] = (0, $2D9sF.mod)($0522aeca5769187c$var$os2ip(tv), p);
        }
        u[i] = e;
    }
    return u;
}
function $0522aeca5769187c$var$isogenyMap(field, map) {
    // Make same order as in spec
    const COEFF = map.map((i)=>Array.from(i).reverse());
    return (x, y)=>{
        const [xNum, xDen, yNum, yDen] = COEFF.map((val)=>val.reduce((acc, i)=>field.add(field.mul(acc, x), i)));
        x = field.div(xNum, xDen); // xNum / xDen
        y = field.mul(y, field.div(yNum, yDen)); // y * (yNum / yDev)
        return {
            x: x,
            y: y
        };
    };
}
function $0522aeca5769187c$var$createHasher(Point, mapToCurve, def) {
    if (typeof mapToCurve !== "function") throw new Error("mapToCurve() must be defined");
    return {
        // Encodes byte string to elliptic curve.
        // hash_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        hashToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 2, {
                ...def,
                DST: def.DST,
                ...options
            });
            const u0 = Point.fromAffine(mapToCurve(u[0]));
            const u1 = Point.fromAffine(mapToCurve(u[1]));
            const P = u0.add(u1).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Encodes byte string to elliptic curve.
        // encode_to_curve from https://www.rfc-editor.org/rfc/rfc9380#section-3
        encodeToCurve (msg, options) {
            const u = $0522aeca5769187c$var$hash_to_field(msg, 1, {
                ...def,
                DST: def.encodeDST,
                ...options
            });
            const P = Point.fromAffine(mapToCurve(u[0])).clearCofactor();
            P.assertValidity();
            return P;
        },
        // Same as encodeToCurve, but without hash
        mapToCurve (scalars) {
            if (!Array.isArray(scalars)) throw new Error("mapToCurve: expected array of bigints");
            for (const i of scalars)if (typeof i !== "bigint") throw new Error(`mapToCurve: expected array of bigints, got ${i} in array`);
            const P = Point.fromAffine(mapToCurve(scalars)).clearCofactor();
            P.assertValidity();
            return P;
        }
    };
}



var $2D9sF = parcelRequire("2D9sF");

var $esaJO = parcelRequire("esaJO");

const $3f551179096121b9$var$secp256k1P = BigInt("0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffffc2f");
const $3f551179096121b9$var$secp256k1N = BigInt("0xfffffffffffffffffffffffffffffffebaaedce6af48a03bbfd25e8cd0364141");
const $3f551179096121b9$var$_1n = BigInt(1);
const $3f551179096121b9$var$_2n = BigInt(2);
const $3f551179096121b9$var$divNearest = (a, b)=>(a + b / $3f551179096121b9$var$_2n) / b;
/**
 * √n = n^((p+1)/4) for fields p = 3 mod 4. We unwrap the loop and multiply bit-by-bit.
 * (P+1n/4n).toString(2) would produce bits [223x 1, 0, 22x 1, 4x 0, 11, 00]
 */ function $3f551179096121b9$var$sqrtMod(y) {
    const P = $3f551179096121b9$var$secp256k1P;
    // prettier-ignore
    const _3n = BigInt(3), _6n = BigInt(6), _11n = BigInt(11), _22n = BigInt(22);
    // prettier-ignore
    const _23n = BigInt(23), _44n = BigInt(44), _88n = BigInt(88);
    const b2 = y * y * y % P; // x^3, 11
    const b3 = b2 * b2 * y % P; // x^7
    const b6 = (0, $2D9sF.pow2)(b3, _3n, P) * b3 % P;
    const b9 = (0, $2D9sF.pow2)(b6, _3n, P) * b3 % P;
    const b11 = (0, $2D9sF.pow2)(b9, $3f551179096121b9$var$_2n, P) * b2 % P;
    const b22 = (0, $2D9sF.pow2)(b11, _11n, P) * b11 % P;
    const b44 = (0, $2D9sF.pow2)(b22, _22n, P) * b22 % P;
    const b88 = (0, $2D9sF.pow2)(b44, _44n, P) * b44 % P;
    const b176 = (0, $2D9sF.pow2)(b88, _88n, P) * b88 % P;
    const b220 = (0, $2D9sF.pow2)(b176, _44n, P) * b44 % P;
    const b223 = (0, $2D9sF.pow2)(b220, _3n, P) * b3 % P;
    const t1 = (0, $2D9sF.pow2)(b223, _23n, P) * b22 % P;
    const t2 = (0, $2D9sF.pow2)(t1, _6n, P) * b2 % P;
    const root = (0, $2D9sF.pow2)(t2, $3f551179096121b9$var$_2n, P);
    if (!$3f551179096121b9$var$Fp.eql($3f551179096121b9$var$Fp.sqr(root), y)) throw new Error("Cannot find square root");
    return root;
}
const $3f551179096121b9$var$Fp = (0, $2D9sF.Field)($3f551179096121b9$var$secp256k1P, undefined, undefined, {
    sqrt: $3f551179096121b9$var$sqrtMod
});
/**
 * secp256k1 short weierstrass curve and ECDSA signatures over it.
 */ $3f551179096121b9$exports.secp256k1 = (0, $5af70d1c5fca3e4e$exports.createCurve)({
    a: BigInt(0),
    b: BigInt(7),
    Fp: $3f551179096121b9$var$Fp,
    n: $3f551179096121b9$var$secp256k1N,
    // Base point (x, y) aka generator point
    Gx: BigInt("55066263022277343669578718895168534326250603453777594175500187360389116729240"),
    Gy: BigInt("32670510020758816978083085130507043184471273380659243275938904335757337482424"),
    h: BigInt(1),
    lowS: true,
    /**
     * secp256k1 belongs to Koblitz curves: it has efficiently computable endomorphism.
     * Endomorphism uses 2x less RAM, speeds up precomputation by 2x and ECDH / key recovery by 20%.
     * For precomputed wNAF it trades off 1/2 init time & 1/3 ram for 20% perf hit.
     * Explanation: https://gist.github.com/paulmillr/eb670806793e84df628a7c434a873066
     */ endo: {
        beta: BigInt("0x7ae96a2b657c07106e64479eac3434e99cf0497512f58995c1396c28719501ee"),
        splitScalar: (k)=>{
            const n = $3f551179096121b9$var$secp256k1N;
            const a1 = BigInt("0x3086d221a7d46bcde86c90e49284eb15");
            const b1 = -$3f551179096121b9$var$_1n * BigInt("0xe4437ed6010e88286f547fa90abfe4c3");
            const a2 = BigInt("0x114ca50f7a8e2f3f657c1108d9d44cfd8");
            const b2 = a1;
            const POW_2_128 = BigInt("0x100000000000000000000000000000000"); // (2n**128n).toString(16)
            const c1 = $3f551179096121b9$var$divNearest(b2 * k, n);
            const c2 = $3f551179096121b9$var$divNearest(-b1 * k, n);
            let k1 = (0, $2D9sF.mod)(k - c1 * a1 - c2 * a2, n);
            let k2 = (0, $2D9sF.mod)(-c1 * b1 - c2 * b2, n);
            const k1neg = k1 > POW_2_128;
            const k2neg = k2 > POW_2_128;
            if (k1neg) k1 = n - k1;
            if (k2neg) k2 = n - k2;
            if (k1 > POW_2_128 || k2 > POW_2_128) throw new Error("splitScalar: Endomorphism failed, k=" + k);
            return {
                k1neg: k1neg,
                k1: k1,
                k2neg: k2neg,
                k2: k2
            };
        }
    }
}, $6XnWx.sha256);
// Schnorr signatures are superior to ECDSA from above. Below is Schnorr-specific BIP0340 code.
// https://github.com/bitcoin/bips/blob/master/bip-0340.mediawiki
const $3f551179096121b9$var$_0n = BigInt(0);
/** An object mapping tags to their tagged hash prefix of [SHA256(tag) | SHA256(tag)] */ const $3f551179096121b9$var$TAGGED_HASH_PREFIXES = {};
function $3f551179096121b9$var$taggedHash(tag, ...messages) {
    let tagP = $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag];
    if (tagP === undefined) {
        const tagH = (0, $6XnWx.sha256)(Uint8Array.from(tag, (c)=>c.charCodeAt(0)));
        tagP = (0, $esaJO.concatBytes)(tagH, tagH);
        $3f551179096121b9$var$TAGGED_HASH_PREFIXES[tag] = tagP;
    }
    return (0, $6XnWx.sha256)((0, $esaJO.concatBytes)(tagP, ...messages));
}
// ECDSA compact points are 33-byte. Schnorr is 32: we strip first byte 0x02 or 0x03
const $3f551179096121b9$var$pointToBytes = (point)=>point.toRawBytes(true).slice(1);
const $3f551179096121b9$var$numTo32b = (n)=>(0, $esaJO.numberToBytesBE)(n, 32);
const $3f551179096121b9$var$modP = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1P);
const $3f551179096121b9$var$modN = (x)=>(0, $2D9sF.mod)(x, $3f551179096121b9$var$secp256k1N);
const $3f551179096121b9$var$Point = $3f551179096121b9$exports.secp256k1.ProjectivePoint;
const $3f551179096121b9$var$GmulAdd = (Q, a, b)=>$3f551179096121b9$var$Point.BASE.multiplyAndAddUnsafe(Q, a, b);
// Calculate point, scalar and bytes
function $3f551179096121b9$var$schnorrGetExtPubKey(priv) {
    let d_ = $3f551179096121b9$exports.secp256k1.utils.normPrivateKeyToScalar(priv); // same method executed in fromPrivateKey
    let p = $3f551179096121b9$var$Point.fromPrivateKey(d_); // P = d'⋅G; 0 < d' < n check is done inside
    const scalar = p.hasEvenY() ? d_ : $3f551179096121b9$var$modN(-d_);
    return {
        scalar: scalar,
        bytes: $3f551179096121b9$var$pointToBytes(p)
    };
}
/**
 * lift_x from BIP340. Convert 32-byte x coordinate to elliptic curve point.
 * @returns valid point checked for being on-curve
 */ function $3f551179096121b9$var$lift_x(x) {
    (0, $esaJO.aInRange)("x", x, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1P); // Fail if x ≥ p.
    const xx = $3f551179096121b9$var$modP(x * x);
    const c = $3f551179096121b9$var$modP(xx * x + BigInt(7)); // Let c = x³ + 7 mod p.
    let y = $3f551179096121b9$var$sqrtMod(c); // Let y = c^(p+1)/4 mod p.
    if (y % $3f551179096121b9$var$_2n !== $3f551179096121b9$var$_0n) y = $3f551179096121b9$var$modP(-y); // Return the unique point P such that x(P) = x and
    const p = new $3f551179096121b9$var$Point(x, y, $3f551179096121b9$var$_1n); // y(P) = y if y mod 2 = 0 or y(P) = p-y otherwise.
    p.assertValidity();
    return p;
}
const $3f551179096121b9$var$num = $esaJO.bytesToNumberBE;
/**
 * Create tagged hash, convert it to bigint, reduce modulo-n.
 */ function $3f551179096121b9$var$challenge(...args) {
    return $3f551179096121b9$var$modN($3f551179096121b9$var$num($3f551179096121b9$var$taggedHash("BIP0340/challenge", ...args)));
}
/**
 * Schnorr public key is just `x` coordinate of Point as per BIP340.
 */ function $3f551179096121b9$var$schnorrGetPublicKey(privateKey) {
    return $3f551179096121b9$var$schnorrGetExtPubKey(privateKey).bytes; // d'=int(sk). Fail if d'=0 or d'≥n. Ret bytes(d'⋅G)
}
/**
 * Creates Schnorr signature as per BIP340. Verifies itself before returning anything.
 * auxRand is optional and is not the sole source of k generation: bad CSPRNG won't be dangerous.
 */ function $3f551179096121b9$var$schnorrSign(message, privateKey, auxRand = (0, $3Bcdj.randomBytes)(32)) {
    const m = (0, $esaJO.ensureBytes)("message", message);
    const { bytes: px, scalar: d } = $3f551179096121b9$var$schnorrGetExtPubKey(privateKey); // checks for isWithinCurveOrder
    const a = (0, $esaJO.ensureBytes)("auxRand", auxRand, 32); // Auxiliary random data a: a 32-byte array
    const t = $3f551179096121b9$var$numTo32b(d ^ $3f551179096121b9$var$num($3f551179096121b9$var$taggedHash("BIP0340/aux", a))); // Let t be the byte-wise xor of bytes(d) and hash/aux(a)
    const rand = $3f551179096121b9$var$taggedHash("BIP0340/nonce", t, px, m); // Let rand = hash/nonce(t || bytes(P) || m)
    const k_ = $3f551179096121b9$var$modN($3f551179096121b9$var$num(rand)); // Let k' = int(rand) mod n
    if (k_ === $3f551179096121b9$var$_0n) throw new Error("sign failed: k is zero"); // Fail if k' = 0.
    const { bytes: rx, scalar: k } = $3f551179096121b9$var$schnorrGetExtPubKey(k_); // Let R = k'⋅G.
    const e = $3f551179096121b9$var$challenge(rx, px, m); // Let e = int(hash/challenge(bytes(R) || bytes(P) || m)) mod n.
    const sig = new Uint8Array(64); // Let sig = bytes(R) || bytes((k + ed) mod n).
    sig.set(rx, 0);
    sig.set($3f551179096121b9$var$numTo32b($3f551179096121b9$var$modN(k + e * d)), 32);
    // If Verify(bytes(P), m, sig) (see below) returns failure, abort
    if (!$3f551179096121b9$var$schnorrVerify(sig, m, px)) throw new Error("sign: Invalid signature produced");
    return sig;
}
/**
 * Verifies Schnorr signature.
 * Will swallow errors & return false except for initial type validation of arguments.
 */ function $3f551179096121b9$var$schnorrVerify(signature, message, publicKey) {
    const sig = (0, $esaJO.ensureBytes)("signature", signature, 64);
    const m = (0, $esaJO.ensureBytes)("message", message);
    const pub = (0, $esaJO.ensureBytes)("publicKey", publicKey, 32);
    try {
        const P = $3f551179096121b9$var$lift_x($3f551179096121b9$var$num(pub)); // P = lift_x(int(pk)); fail if that fails
        const r = $3f551179096121b9$var$num(sig.subarray(0, 32)); // Let r = int(sig[0:32]); fail if r ≥ p.
        if (!(0, $esaJO.inRange)(r, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1P)) return false;
        const s = $3f551179096121b9$var$num(sig.subarray(32, 64)); // Let s = int(sig[32:64]); fail if s ≥ n.
        if (!(0, $esaJO.inRange)(s, $3f551179096121b9$var$_1n, $3f551179096121b9$var$secp256k1N)) return false;
        const e = $3f551179096121b9$var$challenge($3f551179096121b9$var$numTo32b(r), $3f551179096121b9$var$pointToBytes(P), m); // int(challenge(bytes(r)||bytes(P)||m))%n
        const R = $3f551179096121b9$var$GmulAdd(P, s, $3f551179096121b9$var$modN(-e)); // R = s⋅G - e⋅P
        if (!R || !R.hasEvenY() || R.toAffine().x !== r) return false; // -eP == (n-e)P
        return true; // Fail if is_infinite(R) / not has_even_y(R) / x(R) ≠ r.
    } catch (error) {
        return false;
    }
}
/**
 * Schnorr signatures over secp256k1.
 */ $3f551179096121b9$exports.schnorr = (()=>({
        getPublicKey: $3f551179096121b9$var$schnorrGetPublicKey,
        sign: $3f551179096121b9$var$schnorrSign,
        verify: $3f551179096121b9$var$schnorrVerify,
        utils: {
            randomPrivateKey: $3f551179096121b9$exports.secp256k1.utils.randomPrivateKey,
            lift_x: $3f551179096121b9$var$lift_x,
            pointToBytes: $3f551179096121b9$var$pointToBytes,
            numberToBytesBE: $esaJO.numberToBytesBE,
            bytesToNumberBE: $esaJO.bytesToNumberBE,
            taggedHash: $3f551179096121b9$var$taggedHash,
            mod: $2D9sF.mod
        }
    }))();
const $3f551179096121b9$var$isoMap = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.isogenyMap)($3f551179096121b9$var$Fp, [
        // xNum
        [
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa8c7",
            "0x7d3d4c80bc321d5b9f315cea7fd44c5d595d2fc0bf63b92dfff1044f17c6581",
            "0x534c328d23f234e6e2a413deca25caece4506144037c40314ecbd0b53d9dd262",
            "0x8e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38e38daaaaa88c"
        ],
        // xDen
        [
            "0xd35771193d94918a9ca34ccbb7b640dd86cd409542f8487d9fe6b745781eb49b",
            "0xedadc6f64383dc1df7c4b2d51b54225406d36b641f5e41bbc52a56612a8c6d14",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ],
        // yNum
        [
            "0x4bda12f684bda12f684bda12f684bda12f684bda12f684bda12f684b8e38e23c",
            "0xc75e0c32d5cb7c0fa9d0a54b12a0a6d5647ab046d686da6fdffc90fc201d71a3",
            "0x29a6194691f91a73715209ef6512e576722830a201be2018a765e85a9ecee931",
            "0x2f684bda12f684bda12f684bda12f684bda12f684bda12f684bda12f38e38d84"
        ],
        // yDen
        [
            "0xfffffffffffffffffffffffffffffffffffffffffffffffffffffffefffff93b",
            "0x7a06534bb8bdb49fd5e9e6632722c2989467c1bfc8e8d978dfb425d2685c2573",
            "0x6484aa716545ca2cf3a70c3fa8fe337e0a3d21162f0d6299a7bf8192bfd2a76f",
            "0x0000000000000000000000000000000000000000000000000000000000000001"
        ]
    ].map((i)=>i.map((j)=>BigInt(j)))))();
const $3f551179096121b9$var$mapSWU = /* @__PURE__ */ (()=>(0, $c3b91d553ab14e64$exports.mapToCurveSimpleSWU)($3f551179096121b9$var$Fp, {
        A: BigInt("0x3f8731abdd661adca08a5558f0f5d272e953d363cb6f0e5d405447c01a444533"),
        B: BigInt("1771"),
        Z: $3f551179096121b9$var$Fp.create(BigInt("-11"))
    }))();
const $3f551179096121b9$var$htf = /* @__PURE__ */ (()=>(0, $0522aeca5769187c$exports.createHasher)($3f551179096121b9$exports.secp256k1.ProjectivePoint, (scalars)=>{
        const { x: x, y: y } = $3f551179096121b9$var$mapSWU($3f551179096121b9$var$Fp.create(scalars[0]));
        return $3f551179096121b9$var$isoMap(x, y);
    }, {
        DST: "secp256k1_XMD:SHA-256_SSWU_RO_",
        encodeDST: "secp256k1_XMD:SHA-256_SSWU_NU_",
        p: $3f551179096121b9$var$Fp.ORDER,
        m: 1,
        k: 128,
        expand: "xmd",
        hash: $6XnWx.sha256
    }))();
$3f551179096121b9$exports.hashToCurve = (()=>$3f551179096121b9$var$htf.hashToCurve)();
$3f551179096121b9$exports.encodeToCurve = (()=>$3f551179096121b9$var$htf.encodeToCurve)();



var $2D9sF = parcelRequire("2D9sF");
/*! scure-base - MIT License (c) 2022 Paul Miller (paulmillr.com) */ // Utilities
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$export$dfbcecb440255e4a(n) {
    if (!Number.isSafeInteger(n)) throw new Error(`Wrong integer: ${n}`);
}
function $3600b4829dff8fa9$var$isBytes(a) {
    return a instanceof Uint8Array || a != null && typeof a === "object" && a.constructor.name === "Uint8Array";
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$chain(...args) {
    const id = (a)=>a;
    // Wrap call in closure so JIT can inline calls
    const wrap = (a, b)=>(c)=>a(b(c));
    // Construct chain of args[-1].encode(args[-2].encode([...]))
    const encode = args.map((x)=>x.encode).reduceRight(wrap, id);
    // Construct chain of args[0].decode(args[1].decode(...))
    const decode = args.map((x)=>x.decode).reduce(wrap, id);
    return {
        encode: encode,
        decode: decode
    };
}
/**
 * Encodes integer radix representation to array of strings using alphabet and back
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$alphabet(alphabet) {
    return {
        encode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("alphabet.encode input should be an array of numbers");
            return digits.map((i)=>{
                $3600b4829dff8fa9$export$dfbcecb440255e4a(i);
                if (i < 0 || i >= alphabet.length) throw new Error(`Digit index outside alphabet: ${i} (alphabet: ${alphabet.length})`);
                return alphabet[i];
            });
        },
        decode: (input)=>{
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("alphabet.decode input should be array of strings");
            return input.map((letter)=>{
                if (typeof letter !== "string") throw new Error(`alphabet.decode: not string element=${letter}`);
                const index = alphabet.indexOf(letter);
                if (index === -1) throw new Error(`Unknown letter: "${letter}". Allowed: ${alphabet}`);
                return index;
            });
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$join(separator = "") {
    if (typeof separator !== "string") throw new Error("join separator should be string");
    return {
        encode: (from)=>{
            if (!Array.isArray(from) || from.length && typeof from[0] !== "string") throw new Error("join.encode input should be array of strings");
            for (let i of from)if (typeof i !== "string") throw new Error(`join.encode: non-string input=${i}`);
            return from.join(separator);
        },
        decode: (to)=>{
            if (typeof to !== "string") throw new Error("join.decode input should be string");
            return to.split(separator);
        }
    };
}
/**
 * Pad strings array so it has integer number of bits
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$padding(bits, chr = "=") {
    $3600b4829dff8fa9$export$dfbcecb440255e4a(bits);
    if (typeof chr !== "string") throw new Error("padding chr should be string");
    return {
        encode (data) {
            if (!Array.isArray(data) || data.length && typeof data[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of data)if (typeof i !== "string") throw new Error(`padding.encode: non-string input=${i}`);
            while(data.length * bits % 8)data.push(chr);
            return data;
        },
        decode (input) {
            if (!Array.isArray(input) || input.length && typeof input[0] !== "string") throw new Error("padding.encode input should be array of strings");
            for (let i of input)if (typeof i !== "string") throw new Error(`padding.decode: non-string input=${i}`);
            let end = input.length;
            if (end * bits % 8) throw new Error("Invalid padding: string should have whole number of bytes");
            for(; end > 0 && input[end - 1] === chr; end--){
                if (!((end - 1) * bits % 8)) throw new Error("Invalid padding: string has too much padding");
            }
            return input.slice(0, end);
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$normalize(fn) {
    if (typeof fn !== "function") throw new Error("normalize fn should be function");
    return {
        encode: (from)=>from,
        decode: (to)=>fn(to)
    };
}
/**
 * Slow: O(n^2) time complexity
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$convertRadix(data, from, to) {
    // base 1 is impossible
    if (from < 2) throw new Error(`convertRadix: wrong from=${from}, base cannot be less than 2`);
    if (to < 2) throw new Error(`convertRadix: wrong to=${to}, base cannot be less than 2`);
    if (!Array.isArray(data)) throw new Error("convertRadix: data should be array");
    if (!data.length) return [];
    let pos = 0;
    const res = [];
    const digits = Array.from(data);
    digits.forEach((d)=>{
        $3600b4829dff8fa9$export$dfbcecb440255e4a(d);
        if (d < 0 || d >= from) throw new Error(`Wrong integer: ${d}`);
    });
    while(true){
        let carry = 0;
        let done = true;
        for(let i = pos; i < digits.length; i++){
            const digit = digits[i];
            const digitBase = from * carry + digit;
            if (!Number.isSafeInteger(digitBase) || from * carry / from !== carry || digitBase - digit !== from * carry) throw new Error("convertRadix: carry overflow");
            carry = digitBase % to;
            const rounded = Math.floor(digitBase / to);
            digits[i] = rounded;
            if (!Number.isSafeInteger(rounded) || rounded * to + carry !== digitBase) throw new Error("convertRadix: carry overflow");
            if (!done) continue;
            else if (!rounded) pos = i;
            else done = false;
        }
        res.push(carry);
        if (done) break;
    }
    for(let i = 0; i < data.length - 1 && data[i] === 0; i++)res.push(0);
    return res.reverse();
}
const $3600b4829dff8fa9$var$gcd = /* @__NO_SIDE_EFFECTS__ */ (a, b)=>!b ? a : $3600b4829dff8fa9$var$gcd(b, a % b);
const $3600b4829dff8fa9$var$radix2carry = /*@__NO_SIDE_EFFECTS__ */ (from, to)=>from + (to - $3600b4829dff8fa9$var$gcd(from, to));
/**
 * Implemented with numbers, because BigInt is 5x slower
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$convertRadix2(data, from, to, padding) {
    if (!Array.isArray(data)) throw new Error("convertRadix2: data should be array");
    if (from <= 0 || from > 32) throw new Error(`convertRadix2: wrong from=${from}`);
    if (to <= 0 || to > 32) throw new Error(`convertRadix2: wrong to=${to}`);
    if ($3600b4829dff8fa9$var$radix2carry(from, to) > 32) throw new Error(`convertRadix2: carry overflow from=${from} to=${to} carryBits=${$3600b4829dff8fa9$var$radix2carry(from, to)}`);
    let carry = 0;
    let pos = 0; // bitwise position in current element
    const mask = 2 ** to - 1;
    const res = [];
    for (const n of data){
        $3600b4829dff8fa9$export$dfbcecb440255e4a(n);
        if (n >= 2 ** from) throw new Error(`convertRadix2: invalid data word=${n} from=${from}`);
        carry = carry << from | n;
        if (pos + from > 32) throw new Error(`convertRadix2: carry overflow pos=${pos} from=${from}`);
        pos += from;
        for(; pos >= to; pos -= to)res.push((carry >> pos - to & mask) >>> 0);
        carry &= 2 ** pos - 1; // clean carry, otherwise it will cause overflow
    }
    carry = carry << to - pos & mask;
    if (!padding && pos >= from) throw new Error("Excess padding");
    if (!padding && carry) throw new Error(`Non-zero padding: ${carry}`);
    if (padding && pos > 0) res.push(carry >>> 0);
    return res;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix(num) {
    $3600b4829dff8fa9$export$dfbcecb440255e4a(num);
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error("radix.encode input should be Uint8Array");
            return $3600b4829dff8fa9$var$convertRadix(Array.from(bytes), 256, num);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix.decode input should be array of numbers");
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix(digits, num, 256));
        }
    };
}
/**
 * If both bases are power of same number (like `2**8 <-> 2**64`),
 * there is a linear algorithm. For now we have implementation for power-of-two bases only.
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$radix2(bits, revPadding = false) {
    $3600b4829dff8fa9$export$dfbcecb440255e4a(bits);
    if (bits <= 0 || bits > 32) throw new Error("radix2: bits should be in (0..32]");
    if ($3600b4829dff8fa9$var$radix2carry(8, bits) > 32 || $3600b4829dff8fa9$var$radix2carry(bits, 8) > 32) throw new Error("radix2: carry overflow");
    return {
        encode: (bytes)=>{
            if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new Error("radix2.encode input should be Uint8Array");
            return $3600b4829dff8fa9$var$convertRadix2(Array.from(bytes), 8, bits, !revPadding);
        },
        decode: (digits)=>{
            if (!Array.isArray(digits) || digits.length && typeof digits[0] !== "number") throw new Error("radix2.decode input should be array of numbers");
            return Uint8Array.from($3600b4829dff8fa9$var$convertRadix2(digits, bits, 8, revPadding));
        }
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$unsafeWrapper(fn) {
    if (typeof fn !== "function") throw new Error("unsafeWrapper fn should be function");
    return function(...args) {
        try {
            return fn.apply(null, args);
        } catch (e) {}
    };
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$checksum(len, fn) {
    $3600b4829dff8fa9$export$dfbcecb440255e4a(len);
    if (typeof fn !== "function") throw new Error("checksum fn should be function");
    return {
        encode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error("checksum.encode: input should be Uint8Array");
            const checksum = fn(data).slice(0, len);
            const res = new Uint8Array(data.length + len);
            res.set(data);
            res.set(checksum, data.length);
            return res;
        },
        decode (data) {
            if (!$3600b4829dff8fa9$var$isBytes(data)) throw new Error("checksum.decode: input should be Uint8Array");
            const payload = data.slice(0, -len);
            const newChecksum = fn(payload).slice(0, len);
            const oldChecksum = data.slice(-len);
            for(let i = 0; i < len; i++)if (newChecksum[i] !== oldChecksum[i]) throw new Error("Invalid checksum");
            return payload;
        }
    };
}
const $3600b4829dff8fa9$export$eab97d15b1788b8d = {
    alphabet: $3600b4829dff8fa9$var$alphabet,
    chain: $3600b4829dff8fa9$var$chain,
    checksum: $3600b4829dff8fa9$var$checksum,
    convertRadix: $3600b4829dff8fa9$var$convertRadix,
    convertRadix2: $3600b4829dff8fa9$var$convertRadix2,
    radix: $3600b4829dff8fa9$var$radix,
    radix2: $3600b4829dff8fa9$var$radix2,
    join: $3600b4829dff8fa9$var$join,
    padding: $3600b4829dff8fa9$var$padding
};
const $3600b4829dff8fa9$export$586f61c71cb02fe4 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEF"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$4a4d5965e2738b2a = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$e077e39445e9b6db = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZ234567"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$c57d6760d519c8ac = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $3600b4829dff8fa9$var$padding(5), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$e37c85831a779eb9 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHIJKLMNOPQRSTUV"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$5fbcb08925249358 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(5), $3600b4829dff8fa9$var$alphabet("0123456789ABCDEFGHJKMNPQRSTVWXYZ"), $3600b4829dff8fa9$var$join(""), $3600b4829dff8fa9$var$normalize((s)=>s.toUpperCase().replace(/O/g, "0").replace(/[IL]/g, "1")));
const $3600b4829dff8fa9$export$b3b2de96497acc47 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$c907e660b9401ec7 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$7d21597c7bc64465 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $3600b4829dff8fa9$var$padding(6), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$963cd24a38dd2f90 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(6), $3600b4829dff8fa9$var$alphabet("ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789-_"), $3600b4829dff8fa9$var$join(""));
// base58 code
// -----------
const $3600b4829dff8fa9$var$genBase58 = (abc)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix(58), $3600b4829dff8fa9$var$alphabet(abc), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$export$61f53211c069eefb = /* @__PURE__ */ $3600b4829dff8fa9$var$genBase58("123456789ABCDEFGHJKLMNPQRSTUVWXYZabcdefghijkmnopqrstuvwxyz");
const $3600b4829dff8fa9$export$c6a7baed2941aad2 = /* @__PURE__ */ $3600b4829dff8fa9$var$genBase58("123456789abcdefghijkmnopqrstuvwxyzABCDEFGHJKLMNPQRSTUVWXYZ");
const $3600b4829dff8fa9$export$cbd4c72942a9201d = /* @__PURE__ */ $3600b4829dff8fa9$var$genBase58("rpshnaf39wBUDNEGHJKLM4PQRST7VWXYZ2bcdeCg65jkm8oFqi1tuvAxyz");
// xmr ver is done in 8-byte blocks (which equals 11 chars in decoding). Last (non-full) block padded with '1' to size in XMR_BLOCK_LEN.
// Block encoding significantly reduces quadratic complexity of base58.
// Data len (index) -> encoded block len
const $3600b4829dff8fa9$var$XMR_BLOCK_LEN = [
    0,
    2,
    3,
    5,
    6,
    7,
    9,
    10,
    11
];
const $3600b4829dff8fa9$export$e86cd8e7f8cff4a6 = {
    encode (data) {
        let res = "";
        for(let i = 0; i < data.length; i += 8){
            const block = data.subarray(i, i + 8);
            res += $3600b4829dff8fa9$export$61f53211c069eefb.encode(block).padStart($3600b4829dff8fa9$var$XMR_BLOCK_LEN[block.length], "1");
        }
        return res;
    },
    decode (str) {
        let res = [];
        for(let i = 0; i < str.length; i += 11){
            const slice = str.slice(i, i + 11);
            const blockLen = $3600b4829dff8fa9$var$XMR_BLOCK_LEN.indexOf(slice.length);
            const block = $3600b4829dff8fa9$export$61f53211c069eefb.decode(slice);
            for(let j = 0; j < block.length - blockLen; j++){
                if (block[j] !== 0) throw new Error("base58xmr: wrong padding");
            }
            res = res.concat(Array.from(block.slice(block.length - blockLen)));
        }
        return Uint8Array.from(res);
    }
};
const $3600b4829dff8fa9$export$2217e0412f7b06b6 = (sha256)=>$3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$checksum(4, (data)=>sha256(sha256(data))), $3600b4829dff8fa9$export$61f53211c069eefb);
const $3600b4829dff8fa9$export$fff625c574161df6 = $3600b4829dff8fa9$export$2217e0412f7b06b6;
const $3600b4829dff8fa9$var$BECH_ALPHABET = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$alphabet("qpzry9x8gf2tvdw0s3jn54khce6mua7l"), $3600b4829dff8fa9$var$join(""));
const $3600b4829dff8fa9$var$POLYMOD_GENERATORS = [
    0x3b6a57b2,
    0x26508e6d,
    0x1ea119fa,
    0x3d4233dd,
    0x2a1462b3
];
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$bech32Polymod(pre) {
    const b = pre >> 25;
    let chk = (pre & 0x1ffffff) << 5;
    for(let i = 0; i < $3600b4829dff8fa9$var$POLYMOD_GENERATORS.length; i++)if ((b >> i & 1) === 1) chk ^= $3600b4829dff8fa9$var$POLYMOD_GENERATORS[i];
    return chk;
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$bechChecksum(prefix, words, encodingConst = 1) {
    const len = prefix.length;
    let chk = 1;
    for(let i = 0; i < len; i++){
        const c = prefix.charCodeAt(i);
        if (c < 33 || c > 126) throw new Error(`Invalid prefix (${prefix})`);
        chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ c >> 5;
    }
    chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    for(let i = 0; i < len; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ prefix.charCodeAt(i) & 0x1f;
    for (let v of words)chk = $3600b4829dff8fa9$var$bech32Polymod(chk) ^ v;
    for(let i = 0; i < 6; i++)chk = $3600b4829dff8fa9$var$bech32Polymod(chk);
    chk ^= encodingConst;
    return $3600b4829dff8fa9$var$BECH_ALPHABET.encode($3600b4829dff8fa9$var$convertRadix2([
        chk % 2 ** 30
    ], 30, 5, false));
}
/**
 * @__NO_SIDE_EFFECTS__
 */ function $3600b4829dff8fa9$var$genBech32(encoding) {
    const ENCODING_CONST = encoding === "bech32" ? 1 : 0x2bc830a3;
    const _words = $3600b4829dff8fa9$var$radix2(5);
    const fromWords = _words.decode;
    const toWords = _words.encode;
    const fromWordsUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(fromWords);
    function encode(prefix, words, limit = 90) {
        if (typeof prefix !== "string") throw new Error(`bech32.encode prefix should be string, not ${typeof prefix}`);
        if (words instanceof Uint8Array) words = Array.from(words);
        if (!Array.isArray(words) || words.length && typeof words[0] !== "number") throw new Error(`bech32.encode words should be array of numbers, not ${typeof words}`);
        if (prefix.length === 0) throw new TypeError(`Invalid prefix length ${prefix.length}`);
        const actualLength = prefix.length + 7 + words.length;
        if (limit !== false && actualLength > limit) throw new TypeError(`Length ${actualLength} exceeds limit ${limit}`);
        const lowered = prefix.toLowerCase();
        const sum = $3600b4829dff8fa9$var$bechChecksum(lowered, words, ENCODING_CONST);
        return `${lowered}1${$3600b4829dff8fa9$var$BECH_ALPHABET.encode(words)}${sum}`;
    }
    function decode(str, limit = 90) {
        if (typeof str !== "string") throw new Error(`bech32.decode input should be string, not ${typeof str}`);
        if (str.length < 8 || limit !== false && str.length > limit) throw new TypeError(`Wrong string length: ${str.length} (${str}). Expected (8..${limit})`);
        // don't allow mixed case
        const lowered = str.toLowerCase();
        if (str !== lowered && str !== str.toUpperCase()) throw new Error(`String must be lowercase or uppercase`);
        const sepIndex = lowered.lastIndexOf("1");
        if (sepIndex === 0 || sepIndex === -1) throw new Error(`Letter "1" must be present between prefix and data only`);
        const prefix = lowered.slice(0, sepIndex);
        const data = lowered.slice(sepIndex + 1);
        if (data.length < 6) throw new Error("Data must be at least 6 characters long");
        const words = $3600b4829dff8fa9$var$BECH_ALPHABET.decode(data).slice(0, -6);
        const sum = $3600b4829dff8fa9$var$bechChecksum(prefix, words, ENCODING_CONST);
        if (!data.endsWith(sum)) throw new Error(`Invalid checksum in ${str}: expected "${sum}"`);
        return {
            prefix: prefix,
            words: words
        };
    }
    const decodeUnsafe = $3600b4829dff8fa9$var$unsafeWrapper(decode);
    function decodeToBytes(str) {
        const { prefix: prefix, words: words } = decode(str, false);
        return {
            prefix: prefix,
            words: words,
            bytes: fromWords(words)
        };
    }
    function encodeFromBytes(prefix, bytes) {
        return encode(prefix, toWords(bytes));
    }
    return {
        encode: encode,
        decode: decode,
        encodeFromBytes: encodeFromBytes,
        decodeToBytes: decodeToBytes,
        decodeUnsafe: decodeUnsafe,
        fromWords: fromWords,
        fromWordsUnsafe: fromWordsUnsafe,
        toWords: toWords
    };
}
const $3600b4829dff8fa9$export$27c42482533637da = /* @__PURE__ */ $3600b4829dff8fa9$var$genBech32("bech32");
const $3600b4829dff8fa9$export$4963f7e473ccf819 = /* @__PURE__ */ $3600b4829dff8fa9$var$genBech32("bech32m");
const $3600b4829dff8fa9$export$74329b762b589566 = {
    encode: (data)=>new TextDecoder().decode(data),
    decode: (str)=>new TextEncoder().encode(str)
};
const $3600b4829dff8fa9$export$834dfc94dde4b3d8 = /* @__PURE__ */ $3600b4829dff8fa9$var$chain($3600b4829dff8fa9$var$radix2(4), $3600b4829dff8fa9$var$alphabet("0123456789abcdef"), $3600b4829dff8fa9$var$join(""), $3600b4829dff8fa9$var$normalize((s)=>{
    if (typeof s !== "string" || s.length % 2) throw new TypeError(`hex.decode: expected string, got ${typeof s} with length ${s.length}`);
    return s.toLowerCase();
}));
// prettier-ignore
const $3600b4829dff8fa9$var$CODERS = {
    utf8: $3600b4829dff8fa9$export$74329b762b589566,
    hex: $3600b4829dff8fa9$export$834dfc94dde4b3d8,
    base16: $3600b4829dff8fa9$export$586f61c71cb02fe4,
    base32: $3600b4829dff8fa9$export$4a4d5965e2738b2a,
    base64: $3600b4829dff8fa9$export$b3b2de96497acc47,
    base64url: $3600b4829dff8fa9$export$7d21597c7bc64465,
    base58: $3600b4829dff8fa9$export$61f53211c069eefb,
    base58xmr: $3600b4829dff8fa9$export$e86cd8e7f8cff4a6
};
const $3600b4829dff8fa9$var$coderTypeError = "Invalid encoding type. Available types: utf8, hex, base16, base32, base64, base64url, base58, base58xmr";
const $3600b4829dff8fa9$export$7c746b75f47c9c7d = (type, bytes)=>{
    if (typeof type !== "string" || !$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (!$3600b4829dff8fa9$var$isBytes(bytes)) throw new TypeError("bytesToString() expects Uint8Array");
    return $3600b4829dff8fa9$var$CODERS[type].encode(bytes);
};
const $3600b4829dff8fa9$export$42d51816ce590c93 = $3600b4829dff8fa9$export$7c746b75f47c9c7d; // as in python, but for bytes only
const $3600b4829dff8fa9$export$c8dd6bc66a63753c = (type, str)=>{
    if (!$3600b4829dff8fa9$var$CODERS.hasOwnProperty(type)) throw new TypeError($3600b4829dff8fa9$var$coderTypeError);
    if (typeof str !== "string") throw new TypeError("stringToBytes() expects string");
    return $3600b4829dff8fa9$var$CODERS[type].decode(str);
};
const $3600b4829dff8fa9$export$b3317979f9250576 = $3600b4829dff8fa9$export$c8dd6bc66a63753c;


const $c1c39050bd418416$var$Point = (0, $3f551179096121b9$exports.secp256k1).ProjectivePoint;
const $c1c39050bd418416$var$base58check = (0, $3600b4829dff8fa9$export$2217e0412f7b06b6)((0, $6XnWx.sha256));
function $c1c39050bd418416$var$bytesToNumber(bytes) {
    return BigInt(`0x${(0, $3Bcdj.bytesToHex)(bytes)}`);
}
function $c1c39050bd418416$var$numberToBytes(num) {
    return (0, $3Bcdj.hexToBytes)(num.toString(16).padStart(64, "0"));
}
const $c1c39050bd418416$var$MASTER_SECRET = (0, $3Bcdj.utf8ToBytes)("Bitcoin seed");
// Bitcoin hardcoded by default
const $c1c39050bd418416$var$BITCOIN_VERSIONS = {
    private: 0x0488ade4,
    public: 0x0488b21e
};
const $c1c39050bd418416$export$c16360648dc994f8 = 0x80000000;
const $c1c39050bd418416$var$hash160 = (data)=>(0, $j5xzM.ripemd160)((0, $6XnWx.sha256)(data));
const $c1c39050bd418416$var$fromU32 = (data)=>(0, $3Bcdj.createView)(data).getUint32(0, false);
const $c1c39050bd418416$var$toU32 = (n)=>{
    if (!Number.isSafeInteger(n) || n < 0 || n > 2 ** 32 - 1) throw new Error(`Invalid number=${n}. Should be from 0 to 2 ** 32 - 1`);
    const buf = new Uint8Array(4);
    (0, $3Bcdj.createView)(buf).setUint32(0, n, false);
    return buf;
};
class $c1c39050bd418416$export$bb670963070b393a {
    get fingerprint() {
        if (!this.pubHash) throw new Error("No publicKey set!");
        return $c1c39050bd418416$var$fromU32(this.pubHash);
    }
    get identifier() {
        return this.pubHash;
    }
    get pubKeyHash() {
        return this.pubHash;
    }
    get privateKey() {
        return this.privKeyBytes || null;
    }
    get publicKey() {
        return this.pubKey || null;
    }
    get privateExtendedKey() {
        const priv = this.privateKey;
        if (!priv) throw new Error("No private key");
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.private, (0, $3Bcdj.concatBytes)(new Uint8Array([
            0
        ]), priv)));
    }
    get publicExtendedKey() {
        if (!this.pubKey) throw new Error("No public key");
        return $c1c39050bd418416$var$base58check.encode(this.serialize(this.versions.public, this.pubKey));
    }
    static fromMasterSeed(seed, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        (0, $dNiq9.bytes)(seed);
        if (8 * seed.length < 128 || 8 * seed.length > 512) throw new Error(`HDKey: wrong seed length=${seed.length}. Should be between 128 and 512 bits; 256 bits is advised)`);
        const I = (0, $51b6b372898f65c0$exports.hmac)((0, $2579977b4e52adba$exports.sha512), $c1c39050bd418416$var$MASTER_SECRET, seed);
        return new $c1c39050bd418416$export$bb670963070b393a({
            versions: versions,
            chainCode: I.slice(32),
            privateKey: I.slice(0, 32)
        });
    }
    static fromExtendedKey(base58key, versions = $c1c39050bd418416$var$BITCOIN_VERSIONS) {
        // => version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        const keyBuffer = $c1c39050bd418416$var$base58check.decode(base58key);
        const keyView = (0, $3Bcdj.createView)(keyBuffer);
        const version = keyView.getUint32(0, false);
        const opt = {
            versions: versions,
            depth: keyBuffer[4],
            parentFingerprint: keyView.getUint32(5, false),
            index: keyView.getUint32(9, false),
            chainCode: keyBuffer.slice(13, 45)
        };
        const key = keyBuffer.slice(45);
        const isPriv = key[0] === 0;
        if (version !== versions[isPriv ? "private" : "public"]) throw new Error("Version mismatch");
        if (isPriv) return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            privateKey: key.slice(1)
        });
        else return new $c1c39050bd418416$export$bb670963070b393a({
            ...opt,
            publicKey: key
        });
    }
    static fromJSON(json) {
        return $c1c39050bd418416$export$bb670963070b393a.fromExtendedKey(json.xpriv);
    }
    constructor(opt){
        this.depth = 0;
        this.index = 0;
        this.chainCode = null;
        this.parentFingerprint = 0;
        if (!opt || typeof opt !== "object") throw new Error("HDKey.constructor must not be called directly");
        this.versions = opt.versions || $c1c39050bd418416$var$BITCOIN_VERSIONS;
        this.depth = opt.depth || 0;
        this.chainCode = opt.chainCode || null;
        this.index = opt.index || 0;
        this.parentFingerprint = opt.parentFingerprint || 0;
        if (!this.depth) {
            if (this.parentFingerprint || this.index) throw new Error("HDKey: zero depth with non-zero index/parent fingerprint");
        }
        if (opt.publicKey && opt.privateKey) throw new Error("HDKey: publicKey and privateKey at same time.");
        if (opt.privateKey) {
            if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(opt.privateKey)) throw new Error("Invalid private key");
            this.privKey = typeof opt.privateKey === "bigint" ? opt.privateKey : $c1c39050bd418416$var$bytesToNumber(opt.privateKey);
            this.privKeyBytes = $c1c39050bd418416$var$numberToBytes(this.privKey);
            this.pubKey = (0, $3f551179096121b9$exports.secp256k1).getPublicKey(opt.privateKey, true);
        } else if (opt.publicKey) this.pubKey = $c1c39050bd418416$var$Point.fromHex(opt.publicKey).toRawBytes(true); // force compressed point
        else throw new Error("HDKey: no public or private key provided");
        this.pubHash = $c1c39050bd418416$var$hash160(this.pubKey);
    }
    derive(path) {
        if (!/^[mM]'?/.test(path)) throw new Error('Path must start with "m" or "M"');
        if (/^[mM]'?$/.test(path)) return this;
        const parts = path.replace(/^[mM]'?\//, "").split("/");
        // tslint:disable-next-line
        let child = this;
        for (const c of parts){
            const m = /^(\d+)('?)$/.exec(c);
            const m1 = m && m[1];
            if (!m || m.length !== 3 || typeof m1 !== "string") throw new Error(`Invalid child index: ${c}`);
            let idx = +m1;
            if (!Number.isSafeInteger(idx) || idx >= $c1c39050bd418416$export$c16360648dc994f8) throw new Error("Invalid index");
            // hardened key
            if (m[2] === "'") idx += $c1c39050bd418416$export$c16360648dc994f8;
            child = child.deriveChild(idx);
        }
        return child;
    }
    deriveChild(index) {
        if (!this.pubKey || !this.chainCode) throw new Error("No publicKey or chainCode set");
        let data = $c1c39050bd418416$var$toU32(index);
        if (index >= $c1c39050bd418416$export$c16360648dc994f8) {
            // Hardened
            const priv = this.privateKey;
            if (!priv) throw new Error("Could not derive hardened child key");
            // Hardened child: 0x00 || ser256(kpar) || ser32(index)
            data = (0, $3Bcdj.concatBytes)(new Uint8Array([
                0
            ]), priv, data);
        } else // Normal child: serP(point(kpar)) || ser32(index)
        data = (0, $3Bcdj.concatBytes)(this.pubKey, data);
        const I = (0, $51b6b372898f65c0$exports.hmac)((0, $2579977b4e52adba$exports.sha512), this.chainCode, data);
        const childTweak = $c1c39050bd418416$var$bytesToNumber(I.slice(0, 32));
        const chainCode = I.slice(32);
        if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(childTweak)) throw new Error("Tweak bigger than curve order");
        const opt = {
            versions: this.versions,
            chainCode: chainCode,
            depth: this.depth + 1,
            parentFingerprint: this.fingerprint,
            index: index
        };
        try {
            // Private parent key -> private child key
            if (this.privateKey) {
                const added = (0, $2D9sF.mod)(this.privKey + childTweak, (0, $3f551179096121b9$exports.secp256k1).CURVE.n);
                if (!(0, $3f551179096121b9$exports.secp256k1).utils.isValidPrivateKey(added)) throw new Error("The tweak was out of range or the resulted private key is invalid");
                opt.privateKey = added;
            } else {
                const added = $c1c39050bd418416$var$Point.fromHex(this.pubKey).add($c1c39050bd418416$var$Point.fromPrivateKey(childTweak));
                // Cryptographically impossible: hmac-sha512 preimage would need to be found
                if (added.equals($c1c39050bd418416$var$Point.ZERO)) throw new Error("The tweak was equal to negative P, which made the result key invalid");
                opt.publicKey = added.toRawBytes(true);
            }
            return new $c1c39050bd418416$export$bb670963070b393a(opt);
        } catch (err) {
            return this.deriveChild(index + 1);
        }
    }
    sign(hash) {
        if (!this.privateKey) throw new Error("No privateKey set!");
        (0, $dNiq9.bytes)(hash, 32);
        return (0, $3f551179096121b9$exports.secp256k1).sign(hash, this.privKey).toCompactRawBytes();
    }
    verify(hash, signature) {
        (0, $dNiq9.bytes)(hash, 32);
        (0, $dNiq9.bytes)(signature, 64);
        if (!this.publicKey) throw new Error("No publicKey set!");
        let sig;
        try {
            sig = (0, $3f551179096121b9$exports.secp256k1).Signature.fromCompact(signature);
        } catch (error) {
            return false;
        }
        return (0, $3f551179096121b9$exports.secp256k1).verify(sig, hash, this.publicKey);
    }
    wipePrivateData() {
        this.privKey = undefined;
        if (this.privKeyBytes) {
            this.privKeyBytes.fill(0);
            this.privKeyBytes = undefined;
        }
        return this;
    }
    toJSON() {
        return {
            xpriv: this.privateExtendedKey,
            xpub: this.publicExtendedKey
        };
    }
    serialize(version, key) {
        if (!this.chainCode) throw new Error("No chainCode set");
        (0, $dNiq9.bytes)(key, 33);
        // version(4) || depth(1) || fingerprint(4) || index(4) || chain(32) || key(33)
        return (0, $3Bcdj.concatBytes)($c1c39050bd418416$var$toU32(version), new Uint8Array([
            this.depth
        ]), $c1c39050bd418416$var$toU32(this.parentFingerprint), $c1c39050bd418416$var$toU32(this.index), this.chainCode, key);
    }
}


var $836cf4f0e2c80e2c$exports = {};
"use strict";
Object.defineProperty($836cf4f0e2c80e2c$exports, "__esModule", {
    value: true
});
$836cf4f0e2c80e2c$exports.generateMnemonic = $836cf4f0e2c80e2c$var$generateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToEntropy = $836cf4f0e2c80e2c$var$mnemonicToEntropy;
$836cf4f0e2c80e2c$exports.entropyToMnemonic = $836cf4f0e2c80e2c$var$entropyToMnemonic;
$836cf4f0e2c80e2c$exports.validateMnemonic = $836cf4f0e2c80e2c$var$validateMnemonic;
$836cf4f0e2c80e2c$exports.mnemonicToSeed = $836cf4f0e2c80e2c$var$mnemonicToSeed;
$836cf4f0e2c80e2c$exports.mnemonicToSeedSync = $836cf4f0e2c80e2c$var$mnemonicToSeedSync;

var $dNiq9 = parcelRequire("dNiq9");
var $8c2f54a153cf1baf$exports = {};
"use strict";
Object.defineProperty($8c2f54a153cf1baf$exports, "__esModule", {
    value: true
});
$8c2f54a153cf1baf$exports.pbkdf2 = $8c2f54a153cf1baf$var$pbkdf2;
$8c2f54a153cf1baf$exports.pbkdf2Async = $8c2f54a153cf1baf$var$pbkdf2Async;

var $dNiq9 = parcelRequire("dNiq9");


var $3Bcdj = parcelRequire("3Bcdj");
// Common prologue and epilogue for sync/async functions
function $8c2f54a153cf1baf$var$pbkdf2Init(hash, _password, _salt, _opts) {
    (0, $dNiq9.hash)(hash);
    const opts = (0, $3Bcdj.checkOpts)({
        dkLen: 32,
        asyncTick: 10
    }, _opts);
    const { c: c, dkLen: dkLen, asyncTick: asyncTick } = opts;
    (0, $dNiq9.number)(c);
    (0, $dNiq9.number)(dkLen);
    (0, $dNiq9.number)(asyncTick);
    if (c < 1) throw new Error("PBKDF2: iterations (c) should be >= 1");
    const password = (0, $3Bcdj.toBytes)(_password);
    const salt = (0, $3Bcdj.toBytes)(_salt);
    // DK = PBKDF2(PRF, Password, Salt, c, dkLen);
    const DK = new Uint8Array(dkLen);
    // U1 = PRF(Password, Salt + INT_32_BE(i))
    const PRF = $51b6b372898f65c0$exports.hmac.create(hash, password);
    const PRFSalt = PRF._cloneInto().update(salt);
    return {
        c: c,
        dkLen: dkLen,
        asyncTick: asyncTick,
        DK: DK,
        PRF: PRF,
        PRFSalt: PRFSalt
    };
}
function $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u) {
    PRF.destroy();
    PRFSalt.destroy();
    if (prfW) prfW.destroy();
    u.fill(0);
    return DK;
}
/**
 * PBKDF2-HMAC: RFC 2898 key derivation function
 * @param hash - hash function that would be used e.g. sha256
 * @param password - password from which a derived key is generated
 * @param salt - cryptographic salt
 * @param opts - {c, dkLen} where c is work factor and dkLen is output message size
 */ function $8c2f54a153cf1baf$var$pbkdf2(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        for(let ui = 1; ui < c; ui++){
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        }
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}
async function $8c2f54a153cf1baf$var$pbkdf2Async(hash, password, salt, opts) {
    const { c: c, dkLen: dkLen, asyncTick: asyncTick, DK: DK, PRF: PRF, PRFSalt: PRFSalt } = $8c2f54a153cf1baf$var$pbkdf2Init(hash, password, salt, opts);
    let prfW; // Working copy
    const arr = new Uint8Array(4);
    const view = (0, $3Bcdj.createView)(arr);
    const u = new Uint8Array(PRF.outputLen);
    // DK = T1 + T2 + ⋯ + Tdklen/hlen
    for(let ti = 1, pos = 0; pos < dkLen; ti++, pos += PRF.outputLen){
        // Ti = F(Password, Salt, c, i)
        const Ti = DK.subarray(pos, pos + PRF.outputLen);
        view.setInt32(0, ti, false);
        // F(Password, Salt, c, i) = U1 ^ U2 ^ ⋯ ^ Uc
        // U1 = PRF(Password, Salt + INT_32_BE(i))
        (prfW = PRFSalt._cloneInto(prfW)).update(arr).digestInto(u);
        Ti.set(u.subarray(0, Ti.length));
        await (0, $3Bcdj.asyncLoop)(c - 1, asyncTick, ()=>{
            // Uc = PRF(Password, Uc−1)
            PRF._cloneInto(prfW).update(u).digestInto(u);
            for(let i = 0; i < Ti.length; i++)Ti[i] ^= u[i];
        });
    }
    return $8c2f54a153cf1baf$var$pbkdf2Output(PRF, PRFSalt, DK, prfW, u);
}



var $6XnWx = parcelRequire("6XnWx");


var $3Bcdj = parcelRequire("3Bcdj");

// Japanese wordlist
const $836cf4f0e2c80e2c$var$isJapanese = (wordlist)=>wordlist[0] === "\u3042\u3044\u3053\u304F\u3057\u3093";
// Normalization replaces equivalent sequences of characters
// so that any two texts that are equivalent will be reduced
// to the same sequence of code points, called the normal form of the original text.
// https://tonsky.me/blog/unicode/#why-is-a----
function $836cf4f0e2c80e2c$var$nfkd(str) {
    if (typeof str !== "string") throw new TypeError(`Invalid mnemonic type: ${typeof str}`);
    return str.normalize("NFKD");
}
function $836cf4f0e2c80e2c$var$normalize(str) {
    const norm = $836cf4f0e2c80e2c$var$nfkd(str);
    const words = norm.split(" ");
    if (![
        12,
        15,
        18,
        21,
        24
    ].includes(words.length)) throw new Error("Invalid mnemonic");
    return {
        nfkd: norm,
        words: words
    };
}
function $836cf4f0e2c80e2c$var$assertEntropy(entropy) {
    (0, $dNiq9.bytes)(entropy, 16, 20, 24, 28, 32);
}
/**
 * Generate x random words. Uses Cryptographically-Secure Random Number Generator.
 * @param wordlist imported wordlist for specific language
 * @param strength mnemonic strength 128-256 bits
 * @example
 * generateMnemonic(wordlist, 128)
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$generateMnemonic(wordlist, strength = 128) {
    (0, $dNiq9.number)(strength);
    if (strength % 32 !== 0 || strength > 256) throw new TypeError("Invalid entropy");
    return $836cf4f0e2c80e2c$var$entropyToMnemonic((0, $3Bcdj.randomBytes)(strength / 8), wordlist);
}
const $836cf4f0e2c80e2c$var$calcChecksum = (entropy)=>{
    // Checksum is ent.length/4 bits long
    const bitsLeft = 8 - entropy.length / 4;
    // Zero rightmost "bitsLeft" bits in byte
    // For example: bitsLeft=4 val=10111101 -> 10110000
    return new Uint8Array([
        (0, $6XnWx.sha256)(entropy)[0] >> bitsLeft << bitsLeft
    ]);
};
function $836cf4f0e2c80e2c$var$getCoder(wordlist) {
    if (!Array.isArray(wordlist) || wordlist.length !== 2048 || typeof wordlist[0] !== "string") throw new Error("Wordlist: expected array of 2048 strings");
    wordlist.forEach((i)=>{
        if (typeof i !== "string") throw new Error(`Wordlist: non-string element: ${i}`);
    });
    return $3600b4829dff8fa9$export$eab97d15b1788b8d.chain($3600b4829dff8fa9$export$eab97d15b1788b8d.checksum(1, $836cf4f0e2c80e2c$var$calcChecksum), $3600b4829dff8fa9$export$eab97d15b1788b8d.radix2(11, true), $3600b4829dff8fa9$export$eab97d15b1788b8d.alphabet(wordlist));
}
/**
 * Reversible: Converts mnemonic string to raw entropy in form of byte array.
 * @param mnemonic 12-24 words
 * @param wordlist imported wordlist for specific language
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToEntropy(mnem, wordlist)
 * // Produces
 * new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ])
 */ function $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist) {
    const { words: words } = $836cf4f0e2c80e2c$var$normalize(mnemonic);
    const entropy = $836cf4f0e2c80e2c$var$getCoder(wordlist).decode(words);
    $836cf4f0e2c80e2c$var$assertEntropy(entropy);
    return entropy;
}
/**
 * Reversible: Converts raw entropy in form of byte array to mnemonic string.
 * @param entropy byte array
 * @param wordlist imported wordlist for specific language
 * @returns 12-24 words
 * @example
 * const ent = new Uint8Array([
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f,
 *   0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f, 0x7f
 * ]);
 * entropyToMnemonic(ent, wordlist);
 * // 'legal winner thank year wave sausage worth useful legal winner thank yellow'
 */ function $836cf4f0e2c80e2c$var$entropyToMnemonic(entropy, wordlist) {
    $836cf4f0e2c80e2c$var$assertEntropy(entropy);
    const words = $836cf4f0e2c80e2c$var$getCoder(wordlist).encode(entropy);
    return words.join($836cf4f0e2c80e2c$var$isJapanese(wordlist) ? "\u3000" : " ");
}
/**
 * Validates mnemonic for being 12-24 words contained in `wordlist`.
 */ function $836cf4f0e2c80e2c$var$validateMnemonic(mnemonic, wordlist) {
    try {
        $836cf4f0e2c80e2c$var$mnemonicToEntropy(mnemonic, wordlist);
    } catch (e) {
        return false;
    }
    return true;
}
const $836cf4f0e2c80e2c$var$salt = (passphrase)=>$836cf4f0e2c80e2c$var$nfkd(`mnemonic${passphrase}`);
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * await mnemonicToSeed(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeed(mnemonic, passphrase = "") {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2Async)($2579977b4e52adba$exports.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$salt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}
/**
 * Irreversible: Uses KDF to derive 64 bytes of key data from mnemonic + optional password.
 * @param mnemonic 12-24 words
 * @param passphrase string that will additionally protect the key
 * @returns 64 bytes of key data
 * @example
 * const mnem = 'legal winner thank year wave sausage worth useful legal winner thank yellow';
 * mnemonicToSeedSync(mnem, 'password');
 * // new Uint8Array([...64 bytes])
 */ function $836cf4f0e2c80e2c$var$mnemonicToSeedSync(mnemonic, passphrase = "") {
    return (0, $8c2f54a153cf1baf$exports.pbkdf2)($2579977b4e52adba$exports.sha512, $836cf4f0e2c80e2c$var$normalize(mnemonic).nfkd, $836cf4f0e2c80e2c$var$salt(passphrase), {
        c: 2048,
        dkLen: 64
    });
}


var $d248fb36c996c0d4$exports = {};
"use strict";
Object.defineProperty($d248fb36c996c0d4$exports, "__esModule", {
    value: true
});
$d248fb36c996c0d4$exports.wordlist = void 0;
$d248fb36c996c0d4$exports.wordlist = `abandon
ability
able
about
above
absent
absorb
abstract
absurd
abuse
access
accident
account
accuse
achieve
acid
acoustic
acquire
across
act
action
actor
actress
actual
adapt
add
addict
address
adjust
admit
adult
advance
advice
aerobic
affair
afford
afraid
again
age
agent
agree
ahead
aim
air
airport
aisle
alarm
album
alcohol
alert
alien
all
alley
allow
almost
alone
alpha
already
also
alter
always
amateur
amazing
among
amount
amused
analyst
anchor
ancient
anger
angle
angry
animal
ankle
announce
annual
another
answer
antenna
antique
anxiety
any
apart
apology
appear
apple
approve
april
arch
arctic
area
arena
argue
arm
armed
armor
army
around
arrange
arrest
arrive
arrow
art
artefact
artist
artwork
ask
aspect
assault
asset
assist
assume
asthma
athlete
atom
attack
attend
attitude
attract
auction
audit
august
aunt
author
auto
autumn
average
avocado
avoid
awake
aware
away
awesome
awful
awkward
axis
baby
bachelor
bacon
badge
bag
balance
balcony
ball
bamboo
banana
banner
bar
barely
bargain
barrel
base
basic
basket
battle
beach
bean
beauty
because
become
beef
before
begin
behave
behind
believe
below
belt
bench
benefit
best
betray
better
between
beyond
bicycle
bid
bike
bind
biology
bird
birth
bitter
black
blade
blame
blanket
blast
bleak
bless
blind
blood
blossom
blouse
blue
blur
blush
board
boat
body
boil
bomb
bone
bonus
book
boost
border
boring
borrow
boss
bottom
bounce
box
boy
bracket
brain
brand
brass
brave
bread
breeze
brick
bridge
brief
bright
bring
brisk
broccoli
broken
bronze
broom
brother
brown
brush
bubble
buddy
budget
buffalo
build
bulb
bulk
bullet
bundle
bunker
burden
burger
burst
bus
business
busy
butter
buyer
buzz
cabbage
cabin
cable
cactus
cage
cake
call
calm
camera
camp
can
canal
cancel
candy
cannon
canoe
canvas
canyon
capable
capital
captain
car
carbon
card
cargo
carpet
carry
cart
case
cash
casino
castle
casual
cat
catalog
catch
category
cattle
caught
cause
caution
cave
ceiling
celery
cement
census
century
cereal
certain
chair
chalk
champion
change
chaos
chapter
charge
chase
chat
cheap
check
cheese
chef
cherry
chest
chicken
chief
child
chimney
choice
choose
chronic
chuckle
chunk
churn
cigar
cinnamon
circle
citizen
city
civil
claim
clap
clarify
claw
clay
clean
clerk
clever
click
client
cliff
climb
clinic
clip
clock
clog
close
cloth
cloud
clown
club
clump
cluster
clutch
coach
coast
coconut
code
coffee
coil
coin
collect
color
column
combine
come
comfort
comic
common
company
concert
conduct
confirm
congress
connect
consider
control
convince
cook
cool
copper
copy
coral
core
corn
correct
cost
cotton
couch
country
couple
course
cousin
cover
coyote
crack
cradle
craft
cram
crane
crash
crater
crawl
crazy
cream
credit
creek
crew
cricket
crime
crisp
critic
crop
cross
crouch
crowd
crucial
cruel
cruise
crumble
crunch
crush
cry
crystal
cube
culture
cup
cupboard
curious
current
curtain
curve
cushion
custom
cute
cycle
dad
damage
damp
dance
danger
daring
dash
daughter
dawn
day
deal
debate
debris
decade
december
decide
decline
decorate
decrease
deer
defense
define
defy
degree
delay
deliver
demand
demise
denial
dentist
deny
depart
depend
deposit
depth
deputy
derive
describe
desert
design
desk
despair
destroy
detail
detect
develop
device
devote
diagram
dial
diamond
diary
dice
diesel
diet
differ
digital
dignity
dilemma
dinner
dinosaur
direct
dirt
disagree
discover
disease
dish
dismiss
disorder
display
distance
divert
divide
divorce
dizzy
doctor
document
dog
doll
dolphin
domain
donate
donkey
donor
door
dose
double
dove
draft
dragon
drama
drastic
draw
dream
dress
drift
drill
drink
drip
drive
drop
drum
dry
duck
dumb
dune
during
dust
dutch
duty
dwarf
dynamic
eager
eagle
early
earn
earth
easily
east
easy
echo
ecology
economy
edge
edit
educate
effort
egg
eight
either
elbow
elder
electric
elegant
element
elephant
elevator
elite
else
embark
embody
embrace
emerge
emotion
employ
empower
empty
enable
enact
end
endless
endorse
enemy
energy
enforce
engage
engine
enhance
enjoy
enlist
enough
enrich
enroll
ensure
enter
entire
entry
envelope
episode
equal
equip
era
erase
erode
erosion
error
erupt
escape
essay
essence
estate
eternal
ethics
evidence
evil
evoke
evolve
exact
example
excess
exchange
excite
exclude
excuse
execute
exercise
exhaust
exhibit
exile
exist
exit
exotic
expand
expect
expire
explain
expose
express
extend
extra
eye
eyebrow
fabric
face
faculty
fade
faint
faith
fall
false
fame
family
famous
fan
fancy
fantasy
farm
fashion
fat
fatal
father
fatigue
fault
favorite
feature
february
federal
fee
feed
feel
female
fence
festival
fetch
fever
few
fiber
fiction
field
figure
file
film
filter
final
find
fine
finger
finish
fire
firm
first
fiscal
fish
fit
fitness
fix
flag
flame
flash
flat
flavor
flee
flight
flip
float
flock
floor
flower
fluid
flush
fly
foam
focus
fog
foil
fold
follow
food
foot
force
forest
forget
fork
fortune
forum
forward
fossil
foster
found
fox
fragile
frame
frequent
fresh
friend
fringe
frog
front
frost
frown
frozen
fruit
fuel
fun
funny
furnace
fury
future
gadget
gain
galaxy
gallery
game
gap
garage
garbage
garden
garlic
garment
gas
gasp
gate
gather
gauge
gaze
general
genius
genre
gentle
genuine
gesture
ghost
giant
gift
giggle
ginger
giraffe
girl
give
glad
glance
glare
glass
glide
glimpse
globe
gloom
glory
glove
glow
glue
goat
goddess
gold
good
goose
gorilla
gospel
gossip
govern
gown
grab
grace
grain
grant
grape
grass
gravity
great
green
grid
grief
grit
grocery
group
grow
grunt
guard
guess
guide
guilt
guitar
gun
gym
habit
hair
half
hammer
hamster
hand
happy
harbor
hard
harsh
harvest
hat
have
hawk
hazard
head
health
heart
heavy
hedgehog
height
hello
helmet
help
hen
hero
hidden
high
hill
hint
hip
hire
history
hobby
hockey
hold
hole
holiday
hollow
home
honey
hood
hope
horn
horror
horse
hospital
host
hotel
hour
hover
hub
huge
human
humble
humor
hundred
hungry
hunt
hurdle
hurry
hurt
husband
hybrid
ice
icon
idea
identify
idle
ignore
ill
illegal
illness
image
imitate
immense
immune
impact
impose
improve
impulse
inch
include
income
increase
index
indicate
indoor
industry
infant
inflict
inform
inhale
inherit
initial
inject
injury
inmate
inner
innocent
input
inquiry
insane
insect
inside
inspire
install
intact
interest
into
invest
invite
involve
iron
island
isolate
issue
item
ivory
jacket
jaguar
jar
jazz
jealous
jeans
jelly
jewel
job
join
joke
journey
joy
judge
juice
jump
jungle
junior
junk
just
kangaroo
keen
keep
ketchup
key
kick
kid
kidney
kind
kingdom
kiss
kit
kitchen
kite
kitten
kiwi
knee
knife
knock
know
lab
label
labor
ladder
lady
lake
lamp
language
laptop
large
later
latin
laugh
laundry
lava
law
lawn
lawsuit
layer
lazy
leader
leaf
learn
leave
lecture
left
leg
legal
legend
leisure
lemon
lend
length
lens
leopard
lesson
letter
level
liar
liberty
library
license
life
lift
light
like
limb
limit
link
lion
liquid
list
little
live
lizard
load
loan
lobster
local
lock
logic
lonely
long
loop
lottery
loud
lounge
love
loyal
lucky
luggage
lumber
lunar
lunch
luxury
lyrics
machine
mad
magic
magnet
maid
mail
main
major
make
mammal
man
manage
mandate
mango
mansion
manual
maple
marble
march
margin
marine
market
marriage
mask
mass
master
match
material
math
matrix
matter
maximum
maze
meadow
mean
measure
meat
mechanic
medal
media
melody
melt
member
memory
mention
menu
mercy
merge
merit
merry
mesh
message
metal
method
middle
midnight
milk
million
mimic
mind
minimum
minor
minute
miracle
mirror
misery
miss
mistake
mix
mixed
mixture
mobile
model
modify
mom
moment
monitor
monkey
monster
month
moon
moral
more
morning
mosquito
mother
motion
motor
mountain
mouse
move
movie
much
muffin
mule
multiply
muscle
museum
mushroom
music
must
mutual
myself
mystery
myth
naive
name
napkin
narrow
nasty
nation
nature
near
neck
need
negative
neglect
neither
nephew
nerve
nest
net
network
neutral
never
news
next
nice
night
noble
noise
nominee
noodle
normal
north
nose
notable
note
nothing
notice
novel
now
nuclear
number
nurse
nut
oak
obey
object
oblige
obscure
observe
obtain
obvious
occur
ocean
october
odor
off
offer
office
often
oil
okay
old
olive
olympic
omit
once
one
onion
online
only
open
opera
opinion
oppose
option
orange
orbit
orchard
order
ordinary
organ
orient
original
orphan
ostrich
other
outdoor
outer
output
outside
oval
oven
over
own
owner
oxygen
oyster
ozone
pact
paddle
page
pair
palace
palm
panda
panel
panic
panther
paper
parade
parent
park
parrot
party
pass
patch
path
patient
patrol
pattern
pause
pave
payment
peace
peanut
pear
peasant
pelican
pen
penalty
pencil
people
pepper
perfect
permit
person
pet
phone
photo
phrase
physical
piano
picnic
picture
piece
pig
pigeon
pill
pilot
pink
pioneer
pipe
pistol
pitch
pizza
place
planet
plastic
plate
play
please
pledge
pluck
plug
plunge
poem
poet
point
polar
pole
police
pond
pony
pool
popular
portion
position
possible
post
potato
pottery
poverty
powder
power
practice
praise
predict
prefer
prepare
present
pretty
prevent
price
pride
primary
print
priority
prison
private
prize
problem
process
produce
profit
program
project
promote
proof
property
prosper
protect
proud
provide
public
pudding
pull
pulp
pulse
pumpkin
punch
pupil
puppy
purchase
purity
purpose
purse
push
put
puzzle
pyramid
quality
quantum
quarter
question
quick
quit
quiz
quote
rabbit
raccoon
race
rack
radar
radio
rail
rain
raise
rally
ramp
ranch
random
range
rapid
rare
rate
rather
raven
raw
razor
ready
real
reason
rebel
rebuild
recall
receive
recipe
record
recycle
reduce
reflect
reform
refuse
region
regret
regular
reject
relax
release
relief
rely
remain
remember
remind
remove
render
renew
rent
reopen
repair
repeat
replace
report
require
rescue
resemble
resist
resource
response
result
retire
retreat
return
reunion
reveal
review
reward
rhythm
rib
ribbon
rice
rich
ride
ridge
rifle
right
rigid
ring
riot
ripple
risk
ritual
rival
river
road
roast
robot
robust
rocket
romance
roof
rookie
room
rose
rotate
rough
round
route
royal
rubber
rude
rug
rule
run
runway
rural
sad
saddle
sadness
safe
sail
salad
salmon
salon
salt
salute
same
sample
sand
satisfy
satoshi
sauce
sausage
save
say
scale
scan
scare
scatter
scene
scheme
school
science
scissors
scorpion
scout
scrap
screen
script
scrub
sea
search
season
seat
second
secret
section
security
seed
seek
segment
select
sell
seminar
senior
sense
sentence
series
service
session
settle
setup
seven
shadow
shaft
shallow
share
shed
shell
sheriff
shield
shift
shine
ship
shiver
shock
shoe
shoot
shop
short
shoulder
shove
shrimp
shrug
shuffle
shy
sibling
sick
side
siege
sight
sign
silent
silk
silly
silver
similar
simple
since
sing
siren
sister
situate
six
size
skate
sketch
ski
skill
skin
skirt
skull
slab
slam
sleep
slender
slice
slide
slight
slim
slogan
slot
slow
slush
small
smart
smile
smoke
smooth
snack
snake
snap
sniff
snow
soap
soccer
social
sock
soda
soft
solar
soldier
solid
solution
solve
someone
song
soon
sorry
sort
soul
sound
soup
source
south
space
spare
spatial
spawn
speak
special
speed
spell
spend
sphere
spice
spider
spike
spin
spirit
split
spoil
sponsor
spoon
sport
spot
spray
spread
spring
spy
square
squeeze
squirrel
stable
stadium
staff
stage
stairs
stamp
stand
start
state
stay
steak
steel
stem
step
stereo
stick
still
sting
stock
stomach
stone
stool
story
stove
strategy
street
strike
strong
struggle
student
stuff
stumble
style
subject
submit
subway
success
such
sudden
suffer
sugar
suggest
suit
summer
sun
sunny
sunset
super
supply
supreme
sure
surface
surge
surprise
surround
survey
suspect
sustain
swallow
swamp
swap
swarm
swear
sweet
swift
swim
swing
switch
sword
symbol
symptom
syrup
system
table
tackle
tag
tail
talent
talk
tank
tape
target
task
taste
tattoo
taxi
teach
team
tell
ten
tenant
tennis
tent
term
test
text
thank
that
theme
then
theory
there
they
thing
this
thought
three
thrive
throw
thumb
thunder
ticket
tide
tiger
tilt
timber
time
tiny
tip
tired
tissue
title
toast
tobacco
today
toddler
toe
together
toilet
token
tomato
tomorrow
tone
tongue
tonight
tool
tooth
top
topic
topple
torch
tornado
tortoise
toss
total
tourist
toward
tower
town
toy
track
trade
traffic
tragic
train
transfer
trap
trash
travel
tray
treat
tree
trend
trial
tribe
trick
trigger
trim
trip
trophy
trouble
truck
true
truly
trumpet
trust
truth
try
tube
tuition
tumble
tuna
tunnel
turkey
turn
turtle
twelve
twenty
twice
twin
twist
two
type
typical
ugly
umbrella
unable
unaware
uncle
uncover
under
undo
unfair
unfold
unhappy
uniform
unique
unit
universe
unknown
unlock
until
unusual
unveil
update
upgrade
uphold
upon
upper
upset
urban
urge
usage
use
used
useful
useless
usual
utility
vacant
vacuum
vague
valid
valley
valve
van
vanish
vapor
various
vast
vault
vehicle
velvet
vendor
venture
venue
verb
verify
version
very
vessel
veteran
viable
vibrant
vicious
victory
video
view
village
vintage
violin
virtual
virus
visa
visit
visual
vital
vivid
vocal
voice
void
volcano
volume
vote
voyage
wage
wagon
wait
walk
wall
walnut
want
warfare
warm
warrior
wash
wasp
waste
water
wave
way
wealth
weapon
wear
weasel
weather
web
wedding
weekend
weird
welcome
west
wet
whale
what
wheat
wheel
when
where
whip
whisper
wide
width
wife
wild
will
win
window
wine
wing
wink
winner
winter
wire
wisdom
wise
wish
witness
wolf
woman
wonder
wood
wool
word
work
world
worry
worth
wrap
wreck
wrestle
wrist
write
wrong
yard
year
yellow
you
young
youth
zebra
zero
zone
zoo`.split("\n");





var $db6J2 = parcelRequire("db6J2");
var $092c7e998bebe629$exports = {};

$parcel$export($092c7e998bebe629$exports, "create", () => $092c7e998bebe629$export$185802fd694ee1f5, (v) => $092c7e998bebe629$export$185802fd694ee1f5 = v);
$parcel$export($092c7e998bebe629$exports, "toCanvas", () => $092c7e998bebe629$export$f87f6982d1fd4f81, (v) => $092c7e998bebe629$export$f87f6982d1fd4f81 = v);
$parcel$export($092c7e998bebe629$exports, "toDataURL", () => $092c7e998bebe629$export$723e4939e5a27c8, (v) => $092c7e998bebe629$export$723e4939e5a27c8 = v);
$parcel$export($092c7e998bebe629$exports, "toString", () => $092c7e998bebe629$export$f84e8e69fd4488a5, (v) => $092c7e998bebe629$export$f84e8e69fd4488a5 = v);
var $092c7e998bebe629$export$185802fd694ee1f5;
var $092c7e998bebe629$export$f87f6982d1fd4f81;
var $092c7e998bebe629$export$723e4939e5a27c8;
// only svg for now.
var $092c7e998bebe629$export$f84e8e69fd4488a5;
var $e6419622b12b5572$exports = {};
// can-promise has a crash in some versions of react native that dont have
// standard global objects
// https://github.com/soldair/node-qrcode/issues/157
$e6419622b12b5572$exports = function() {
    return typeof Promise === "function" && Promise.prototype && Promise.prototype.then;
};


/**
 * QR Code
 *
 * @param {String | Array} data                 Input data
 * @param {Object} options                      Optional configurations
 * @param {Number} options.version              QR Code version
 * @param {String} options.errorCorrectionLevel Error correction level
 * @param {Function} options.toSJISFunc         Helper func to convert utf8 to sjis
 */ var $5f2127839fe01a16$export$185802fd694ee1f5;
/**
 * Returns the QR Code size for the specified version
 *
 * @param  {Number} version QR Code version
 * @return {Number}         size of QR code
 */ var $c1483b5b1305278f$export$8d4a06d3facd414b;
/**
 * Returns the total number of codewords used to store data and EC information.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Data length in bits
 */ var $c1483b5b1305278f$export$b05dac13c7a35c32;
/**
 * Encode data with Bose-Chaudhuri-Hocquenghem
 *
 * @param  {Number} data Value to encode
 * @return {Number}      Encoded value
 */ var $c1483b5b1305278f$export$ed1d66da50968976;
var $c1483b5b1305278f$export$6733b14783f975c2;
var $c1483b5b1305278f$export$ce5b1274f8597fa0;
var $c1483b5b1305278f$export$43dd553ecded716d;
let $c1483b5b1305278f$var$toSJISFunction;
const $c1483b5b1305278f$var$CODEWORDS_COUNT = [
    0,
    26,
    44,
    70,
    100,
    134,
    172,
    196,
    242,
    292,
    346,
    404,
    466,
    532,
    581,
    655,
    733,
    815,
    901,
    991,
    1085,
    1156,
    1258,
    1364,
    1474,
    1588,
    1706,
    1828,
    1921,
    2051,
    2185,
    2323,
    2465,
    2611,
    2761,
    2876,
    3034,
    3196,
    3362,
    3532,
    3706
];
$c1483b5b1305278f$export$8d4a06d3facd414b = function getSymbolSize(version) {
    if (!version) throw new Error('"version" cannot be null or undefined');
    if (version < 1 || version > 40) throw new Error('"version" should be in range from 1 to 40');
    return version * 4 + 17;
};
$c1483b5b1305278f$export$b05dac13c7a35c32 = function getSymbolTotalCodewords(version) {
    return $c1483b5b1305278f$var$CODEWORDS_COUNT[version];
};
$c1483b5b1305278f$export$ed1d66da50968976 = function(data) {
    let digit = 0;
    while(data !== 0){
        digit++;
        data >>>= 1;
    }
    return digit;
};
$c1483b5b1305278f$export$6733b14783f975c2 = function setToSJISFunction(f) {
    if (typeof f !== "function") throw new Error('"toSJISFunc" is not a valid function.');
    $c1483b5b1305278f$var$toSJISFunction = f;
};
$c1483b5b1305278f$export$ce5b1274f8597fa0 = function() {
    return typeof $c1483b5b1305278f$var$toSJISFunction !== "undefined";
};
$c1483b5b1305278f$export$43dd553ecded716d = function toSJIS(kanji) {
    return $c1483b5b1305278f$var$toSJISFunction(kanji);
};


var $d22956012916b666$export$61196ced6d74a310;
var $d22956012916b666$export$3a1a48c8f6ef640e;
var $d22956012916b666$export$3722cfe417b6ed86;
var $d22956012916b666$export$7f8ddf7c7c20b3cd;
var $d22956012916b666$export$1ea939691cdc45b8;
var $d22956012916b666$export$6788812c4e6611e6;
$d22956012916b666$export$61196ced6d74a310 = {
    bit: 1
};
$d22956012916b666$export$3a1a48c8f6ef640e = {
    bit: 0
};
$d22956012916b666$export$3722cfe417b6ed86 = {
    bit: 3
};
$d22956012916b666$export$7f8ddf7c7c20b3cd = {
    bit: 2
};
function $d22956012916b666$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "l":
        case "low":
            return $d22956012916b666$export$61196ced6d74a310;
        case "m":
        case "medium":
            return $d22956012916b666$export$3a1a48c8f6ef640e;
        case "q":
        case "quartile":
            return $d22956012916b666$export$3722cfe417b6ed86;
        case "h":
        case "high":
            return $d22956012916b666$export$7f8ddf7c7c20b3cd;
        default:
            throw new Error("Unknown EC Level: " + string);
    }
}
$d22956012916b666$export$1ea939691cdc45b8 = function isValid(level) {
    return level && typeof level.bit !== "undefined" && level.bit >= 0 && level.bit < 4;
};
$d22956012916b666$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($d22956012916b666$export$1ea939691cdc45b8(value)) return value;
    try {
        return $d22956012916b666$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};


var $22a6389bcfc83921$exports = {};
function $22a6389bcfc83921$var$BitBuffer() {
    this.buffer = [];
    this.length = 0;
}
$22a6389bcfc83921$var$BitBuffer.prototype = {
    get: function(index) {
        const bufIndex = Math.floor(index / 8);
        return (this.buffer[bufIndex] >>> 7 - index % 8 & 1) === 1;
    },
    put: function(num, length) {
        for(let i = 0; i < length; i++)this.putBit((num >>> length - i - 1 & 1) === 1);
    },
    getLengthInBits: function() {
        return this.length;
    },
    putBit: function(bit) {
        const bufIndex = Math.floor(this.length / 8);
        if (this.buffer.length <= bufIndex) this.buffer.push(0);
        if (bit) this.buffer[bufIndex] |= 0x80 >>> this.length % 8;
        this.length++;
    }
};
$22a6389bcfc83921$exports = $22a6389bcfc83921$var$BitBuffer;


var $3c0264e2c9c64d36$exports = {};
/**
 * Helper class to handle QR Code symbol modules
 *
 * @param {Number} size Symbol size
 */ function $3c0264e2c9c64d36$var$BitMatrix(size) {
    if (!size || size < 1) throw new Error("BitMatrix size must be defined and greater than 0");
    this.size = size;
    this.data = new Uint8Array(size * size);
    this.reservedBit = new Uint8Array(size * size);
}
/**
 * Set bit value at specified location
 * If reserved flag is set, this bit will be ignored during masking process
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 * @param {Boolean} reserved
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.set = function(row, col, value, reserved) {
    const index = row * this.size + col;
    this.data[index] = value;
    if (reserved) this.reservedBit[index] = true;
};
/**
 * Returns bit value at specified location
 *
 * @param  {Number}  row
 * @param  {Number}  col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.get = function(row, col) {
    return this.data[row * this.size + col];
};
/**
 * Applies xor operator at specified location
 * (used during masking process)
 *
 * @param {Number}  row
 * @param {Number}  col
 * @param {Boolean} value
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.xor = function(row, col, value) {
    this.data[row * this.size + col] ^= value;
};
/**
 * Check if bit at specified location is reserved
 *
 * @param {Number}   row
 * @param {Number}   col
 * @return {Boolean}
 */ $3c0264e2c9c64d36$var$BitMatrix.prototype.isReserved = function(row, col) {
    return this.reservedBit[row * this.size + col];
};
$3c0264e2c9c64d36$exports = $3c0264e2c9c64d36$var$BitMatrix;


/**
 * Alignment pattern are fixed reference pattern in defined positions
 * in a matrix symbology, which enables the decode software to re-synchronise
 * the coordinate mapping of the image modules in the event of moderate amounts
 * of distortion of the image.
 *
 * Alignment patterns are present only in QR Code symbols of version 2 or larger
 * and their number depends on the symbol version.
 */ /**
 * Calculate the row/column coordinates of the center module of each alignment pattern
 * for the specified QR Code version.
 *
 * The alignment patterns are positioned symmetrically on either side of the diagonal
 * running from the top left corner of the symbol to the bottom right corner.
 *
 * Since positions are simmetrical only half of the coordinates are returned.
 * Each item of the array will represent in turn the x and y coordinate.
 * @see {@link getPositions}
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinate
 */ var $c20e4b3185223698$export$cb05537eb8e57a83;
/**
 * Returns an array containing the positions of each alignment pattern.
 * Each array's element represent the center point of the pattern as (x, y) coordinates
 *
 * Coordinates are calculated expanding the row/column coordinates returned by {@link getRowColCoords}
 * and filtering out the items that overlaps with finder pattern
 *
 * @example
 * For a Version 7 symbol {@link getRowColCoords} returns values 6, 22 and 38.
 * The alignment patterns, therefore, are to be centered on (row, column)
 * positions (6,22), (22,6), (22,22), (22,38), (38,22), (38,38).
 * Note that the coordinates (6,6), (6,38), (38,6) are occupied by finder patterns
 * and are not therefore used for alignment patterns.
 *
 * let pos = getPositions(7)
 * // [[6,22], [22,6], [22,22], [22,38], [38,22], [38,38]]
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $c20e4b3185223698$export$c39457c570f2b189;

var $c20e4b3185223698$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
$c20e4b3185223698$export$cb05537eb8e57a83 = function getRowColCoords(version) {
    if (version === 1) return [];
    const posCount = Math.floor(version / 7) + 2;
    const size = $c20e4b3185223698$require$getSymbolSize(version);
    const intervals = size === 145 ? 26 : Math.ceil((size - 13) / (2 * posCount - 2)) * 2;
    const positions = [
        size - 7
    ] // Last coord is always (size - 7)
    ;
    for(let i = 1; i < posCount - 1; i++)positions[i] = positions[i - 1] - intervals;
    positions.push(6) // First coord is always 6
    ;
    return positions.reverse();
};
$c20e4b3185223698$export$c39457c570f2b189 = function getPositions(version) {
    const coords = [];
    const pos = $c20e4b3185223698$export$cb05537eb8e57a83(version);
    const posLength = pos.length;
    for(let i = 0; i < posLength; i++)for(let j = 0; j < posLength; j++){
        // Skip if position is occupied by finder patterns
        if (i === 0 && j === 0 || // top-left
        i === 0 && j === posLength - 1 || // bottom-left
        i === posLength - 1 && j === 0) continue;
        coords.push([
            pos[i],
            pos[j]
        ]);
    }
    return coords;
};


/**
 * Returns an array containing the positions of each finder pattern.
 * Each array's element represent the top-left point of the pattern as (x, y) coordinates
 *
 * @param  {Number} version QR Code version
 * @return {Array}          Array of coordinates
 */ var $b4836838cc492349$export$c39457c570f2b189;

var $b4836838cc492349$require$getSymbolSize = $c1483b5b1305278f$export$8d4a06d3facd414b;
const $b4836838cc492349$var$FINDER_PATTERN_SIZE = 7;
$b4836838cc492349$export$c39457c570f2b189 = function getPositions(version) {
    const size = $b4836838cc492349$require$getSymbolSize(version);
    return [
        // top-left
        [
            0,
            0
        ],
        // top-right
        [
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE,
            0
        ],
        // bottom-left
        [
            0,
            size - $b4836838cc492349$var$FINDER_PATTERN_SIZE
        ]
    ];
};


/**
 * Data mask pattern reference
 * @type {Object}
 */ var $1edc2624fba191d0$export$7ed115685df827af;
/**
 * Check if mask pattern value is valid
 *
 * @param  {Number}  mask    Mask pattern
 * @return {Boolean}         true if valid, false otherwise
 */ var $1edc2624fba191d0$export$1ea939691cdc45b8;
/**
 * Returns mask pattern from a value.
 * If value is not valid, returns undefined
 *
 * @param  {Number|String} value        Mask pattern value
 * @return {Number}                     Valid mask pattern or undefined
 */ var $1edc2624fba191d0$export$6788812c4e6611e6;
/**
* Find adjacent modules in row/column with the same color
* and assign a penalty value.
*
* Points: N1 + i
* i is the amount by which the number of adjacent modules of the same color exceeds 5
*/ var $1edc2624fba191d0$export$a5fd3a02c14d0b3e;
/**
 * Find 2x2 blocks with the same color and assign a penalty value
 *
 * Points: N2 * (m - 1) * (n - 1)
 */ var $1edc2624fba191d0$export$9a9385107a518e46;
/**
 * Find 1:1:3:1:1 ratio (dark:light:dark:light:dark) pattern in row/column,
 * preceded or followed by light area 4 modules wide
 *
 * Points: N3 * number of pattern found
 */ var $1edc2624fba191d0$export$ade754353f0dc75e;
/**
 * Calculate proportion of dark modules in entire symbol
 *
 * Points: N4 * k
 *
 * k is the rating of the deviation of the proportion of dark modules
 * in the symbol from 50% in steps of 5%
 */ var $1edc2624fba191d0$export$3ff6f04d40d9962b;
/**
 * Apply a mask pattern to a BitMatrix
 *
 * @param  {Number}    pattern Pattern reference number
 * @param  {BitMatrix} data    BitMatrix data
 */ var $1edc2624fba191d0$export$a1c9aa9c0e8ba394;
/**
 * Returns the best mask pattern for data
 *
 * @param  {BitMatrix} data
 * @return {Number} Mask pattern reference number
 */ var $1edc2624fba191d0$export$fe9625aaceb0e563;
$1edc2624fba191d0$export$7ed115685df827af = {
    PATTERN000: 0,
    PATTERN001: 1,
    PATTERN010: 2,
    PATTERN011: 3,
    PATTERN100: 4,
    PATTERN101: 5,
    PATTERN110: 6,
    PATTERN111: 7
};
/**
 * Weighted penalty scores for the undesirable features
 * @type {Object}
 */ const $1edc2624fba191d0$var$PenaltyScores = {
    N1: 3,
    N2: 3,
    N3: 40,
    N4: 10
};
$1edc2624fba191d0$export$1ea939691cdc45b8 = function isValid(mask) {
    return mask != null && mask !== "" && !isNaN(mask) && mask >= 0 && mask <= 7;
};
$1edc2624fba191d0$export$6788812c4e6611e6 = function from(value) {
    return $1edc2624fba191d0$export$1ea939691cdc45b8(value) ? parseInt(value, 10) : undefined;
};
$1edc2624fba191d0$export$a5fd3a02c14d0b3e = function getPenaltyN1(data) {
    const size = data.size;
    let points = 0;
    let sameCountCol = 0;
    let sameCountRow = 0;
    let lastCol = null;
    let lastRow = null;
    for(let row = 0; row < size; row++){
        sameCountCol = sameCountRow = 0;
        lastCol = lastRow = null;
        for(let col = 0; col < size; col++){
            let module = data.get(row, col);
            if (module === lastCol) sameCountCol++;
            else {
                if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
                lastCol = module;
                sameCountCol = 1;
            }
            module = data.get(col, row);
            if (module === lastRow) sameCountRow++;
            else {
                if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
                lastRow = module;
                sameCountRow = 1;
            }
        }
        if (sameCountCol >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountCol - 5);
        if (sameCountRow >= 5) points += $1edc2624fba191d0$var$PenaltyScores.N1 + (sameCountRow - 5);
    }
    return points;
};
$1edc2624fba191d0$export$9a9385107a518e46 = function getPenaltyN2(data) {
    const size = data.size;
    let points = 0;
    for(let row = 0; row < size - 1; row++)for(let col = 0; col < size - 1; col++){
        const last = data.get(row, col) + data.get(row, col + 1) + data.get(row + 1, col) + data.get(row + 1, col + 1);
        if (last === 4 || last === 0) points++;
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N2;
};
$1edc2624fba191d0$export$ade754353f0dc75e = function getPenaltyN3(data) {
    const size = data.size;
    let points = 0;
    let bitsCol = 0;
    let bitsRow = 0;
    for(let row = 0; row < size; row++){
        bitsCol = bitsRow = 0;
        for(let col = 0; col < size; col++){
            bitsCol = bitsCol << 1 & 0x7FF | data.get(row, col);
            if (col >= 10 && (bitsCol === 0x5D0 || bitsCol === 0x05D)) points++;
            bitsRow = bitsRow << 1 & 0x7FF | data.get(col, row);
            if (col >= 10 && (bitsRow === 0x5D0 || bitsRow === 0x05D)) points++;
        }
    }
    return points * $1edc2624fba191d0$var$PenaltyScores.N3;
};
$1edc2624fba191d0$export$3ff6f04d40d9962b = function getPenaltyN4(data) {
    let darkCount = 0;
    const modulesCount = data.data.length;
    for(let i = 0; i < modulesCount; i++)darkCount += data.data[i];
    const k = Math.abs(Math.ceil(darkCount * 100 / modulesCount / 5) - 10);
    return k * $1edc2624fba191d0$var$PenaltyScores.N4;
};
/**
 * Return mask value at given position
 *
 * @param  {Number} maskPattern Pattern reference value
 * @param  {Number} i           Row
 * @param  {Number} j           Column
 * @return {Boolean}            Mask value
 */ function $1edc2624fba191d0$var$getMaskAt(maskPattern, i, j) {
    switch(maskPattern){
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN000:
            return (i + j) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN001:
            return i % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN010:
            return j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN011:
            return (i + j) % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN100:
            return (Math.floor(i / 2) + Math.floor(j / 3)) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN101:
            return i * j % 2 + i * j % 3 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN110:
            return (i * j % 2 + i * j % 3) % 2 === 0;
        case $1edc2624fba191d0$export$7ed115685df827af.PATTERN111:
            return (i * j % 3 + (i + j) % 2) % 2 === 0;
        default:
            throw new Error("bad maskPattern:" + maskPattern);
    }
}
$1edc2624fba191d0$export$a1c9aa9c0e8ba394 = function applyMask(pattern, data) {
    const size = data.size;
    for(let col = 0; col < size; col++)for(let row = 0; row < size; row++){
        if (data.isReserved(row, col)) continue;
        data.xor(row, col, $1edc2624fba191d0$var$getMaskAt(pattern, row, col));
    }
};
$1edc2624fba191d0$export$fe9625aaceb0e563 = function getBestMask(data, setupFormatFunc) {
    const numPatterns = Object.keys($1edc2624fba191d0$export$7ed115685df827af).length;
    let bestPattern = 0;
    let lowerPenalty = Infinity;
    for(let p = 0; p < numPatterns; p++){
        setupFormatFunc(p);
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        // Calculate penalty
        const penalty = $1edc2624fba191d0$export$a5fd3a02c14d0b3e(data) + $1edc2624fba191d0$export$9a9385107a518e46(data) + $1edc2624fba191d0$export$ade754353f0dc75e(data) + $1edc2624fba191d0$export$3ff6f04d40d9962b(data);
        // Undo previously applied mask
        $1edc2624fba191d0$export$a1c9aa9c0e8ba394(p, data);
        if (penalty < lowerPenalty) {
            lowerPenalty = penalty;
            bestPattern = p;
        }
    }
    return bestPattern;
};


/**
 * Returns the number of error correction block that the QR Code should contain
 * for the specified version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction blocks
 */ var $7f809b8d8966b945$export$41a1fc627aca72b9;
/**
 * Returns the number of error correction codewords to use for the specified
 * version and error correction level.
 *
 * @param  {Number} version              QR Code version
 * @param  {Number} errorCorrectionLevel Error correction level
 * @return {Number}                      Number of error correction codewords
 */ var $7f809b8d8966b945$export$683d1b3e8a1a8438;

const $7f809b8d8966b945$var$EC_BLOCKS_TABLE = [
    // L  M  Q  H
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    1,
    2,
    2,
    1,
    2,
    2,
    4,
    1,
    2,
    4,
    4,
    2,
    4,
    4,
    4,
    2,
    4,
    6,
    5,
    2,
    4,
    6,
    6,
    2,
    5,
    8,
    8,
    4,
    5,
    8,
    8,
    4,
    5,
    8,
    11,
    4,
    8,
    10,
    11,
    4,
    9,
    12,
    16,
    4,
    9,
    16,
    16,
    6,
    10,
    12,
    18,
    6,
    10,
    17,
    16,
    6,
    11,
    16,
    19,
    6,
    13,
    18,
    21,
    7,
    14,
    21,
    25,
    8,
    16,
    20,
    25,
    8,
    17,
    23,
    25,
    9,
    17,
    23,
    34,
    9,
    18,
    25,
    30,
    10,
    20,
    27,
    32,
    12,
    21,
    29,
    35,
    12,
    23,
    34,
    37,
    12,
    25,
    34,
    40,
    13,
    26,
    35,
    42,
    14,
    28,
    38,
    45,
    15,
    29,
    40,
    48,
    16,
    31,
    43,
    51,
    17,
    33,
    45,
    54,
    18,
    35,
    48,
    57,
    19,
    37,
    51,
    60,
    19,
    38,
    53,
    63,
    20,
    40,
    56,
    66,
    21,
    43,
    59,
    70,
    22,
    45,
    62,
    74,
    24,
    47,
    65,
    77,
    25,
    49,
    68,
    81
];
const $7f809b8d8966b945$var$EC_CODEWORDS_TABLE = [
    // L  M  Q  H
    7,
    10,
    13,
    17,
    10,
    16,
    22,
    28,
    15,
    26,
    36,
    44,
    20,
    36,
    52,
    64,
    26,
    48,
    72,
    88,
    36,
    64,
    96,
    112,
    40,
    72,
    108,
    130,
    48,
    88,
    132,
    156,
    60,
    110,
    160,
    192,
    72,
    130,
    192,
    224,
    80,
    150,
    224,
    264,
    96,
    176,
    260,
    308,
    104,
    198,
    288,
    352,
    120,
    216,
    320,
    384,
    132,
    240,
    360,
    432,
    144,
    280,
    408,
    480,
    168,
    308,
    448,
    532,
    180,
    338,
    504,
    588,
    196,
    364,
    546,
    650,
    224,
    416,
    600,
    700,
    224,
    442,
    644,
    750,
    252,
    476,
    690,
    816,
    270,
    504,
    750,
    900,
    300,
    560,
    810,
    960,
    312,
    588,
    870,
    1050,
    336,
    644,
    952,
    1110,
    360,
    700,
    1020,
    1200,
    390,
    728,
    1050,
    1260,
    420,
    784,
    1140,
    1350,
    450,
    812,
    1200,
    1440,
    480,
    868,
    1290,
    1530,
    510,
    924,
    1350,
    1620,
    540,
    980,
    1440,
    1710,
    570,
    1036,
    1530,
    1800,
    570,
    1064,
    1590,
    1890,
    600,
    1120,
    1680,
    1980,
    630,
    1204,
    1770,
    2100,
    660,
    1260,
    1860,
    2220,
    720,
    1316,
    1950,
    2310,
    750,
    1372,
    2040,
    2430
];
$7f809b8d8966b945$export$41a1fc627aca72b9 = function getBlocksCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_BLOCKS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};
$7f809b8d8966b945$export$683d1b3e8a1a8438 = function getTotalCodewordsCount(version, errorCorrectionLevel) {
    switch(errorCorrectionLevel){
        case $d22956012916b666$export$61196ced6d74a310:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 0];
        case $d22956012916b666$export$3a1a48c8f6ef640e:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 1];
        case $d22956012916b666$export$3722cfe417b6ed86:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 2];
        case $d22956012916b666$export$7f8ddf7c7c20b3cd:
            return $7f809b8d8966b945$var$EC_CODEWORDS_TABLE[(version - 1) * 4 + 3];
        default:
            return undefined;
    }
};


var $06a1abce65162dc0$exports = {};
/**
 * Multiplies two polynomials inside Galois Field
 *
 * @param  {Uint8Array} p1 Polynomial
 * @param  {Uint8Array} p2 Polynomial
 * @return {Uint8Array}    Product of p1 and p2
 */ var $9563d144998a4c78$export$6e3a27864ab166fe;
/**
 * Calculate the remainder of polynomials division
 *
 * @param  {Uint8Array} divident Polynomial
 * @param  {Uint8Array} divisor  Polynomial
 * @return {Uint8Array}          Remainder
 */ var $9563d144998a4c78$export$842a2cf37af977e1;
/**
 * Generate an irreducible generator polynomial of specified degree
 * (used by Reed-Solomon encoder)
 *
 * @param  {Number} degree Degree of the generator polynomial
 * @return {Uint8Array}    Buffer containing polynomial coefficients
 */ var $9563d144998a4c78$export$7b8be06a973a9d05;
/**
 * Returns log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$bef1f36f5486a6a3;
/**
 * Returns anti-log value of n inside Galois Field
 *
 * @param  {Number} n
 * @return {Number}
 */ var $758ebb328fd03b3c$export$b310ec824aaee37f;
/**
 * Multiplies two number inside Galois Field
 *
 * @param  {Number} x
 * @param  {Number} y
 * @return {Number}
 */ var $758ebb328fd03b3c$export$6e3a27864ab166fe;
const $758ebb328fd03b3c$var$EXP_TABLE = new Uint8Array(512);
const $758ebb328fd03b3c$var$LOG_TABLE = new Uint8Array(256) /**
 * Precompute the log and anti-log tables for faster computation later
 *
 * For each possible value in the galois field 2^8, we will pre-compute
 * the logarithm and anti-logarithm (exponential) of this value
 *
 * ref {@link https://en.wikiversity.org/wiki/Reed%E2%80%93Solomon_codes_for_coders#Introduction_to_mathematical_fields}
 */ ;
(function initTables() {
    let x = 1;
    for(let i = 0; i < 255; i++){
        $758ebb328fd03b3c$var$EXP_TABLE[i] = x;
        $758ebb328fd03b3c$var$LOG_TABLE[x] = i;
        x <<= 1 // multiply by 2
        ;
        // The QR code specification says to use byte-wise modulo 100011101 arithmetic.
        // This means that when a number is 256 or larger, it should be XORed with 0x11D.
        if (x & 0x100) x ^= 0x11D;
    }
    // Optimization: double the size of the anti-log table so that we don't need to mod 255 to
    // stay inside the bounds (because we will mainly use this table for the multiplication of
    // two GF numbers, no more).
    // @see {@link mul}
    for(let i = 255; i < 512; i++)$758ebb328fd03b3c$var$EXP_TABLE[i] = $758ebb328fd03b3c$var$EXP_TABLE[i - 255];
})();
$758ebb328fd03b3c$export$bef1f36f5486a6a3 = function log(n) {
    if (n < 1) throw new Error("log(" + n + ")");
    return $758ebb328fd03b3c$var$LOG_TABLE[n];
};
$758ebb328fd03b3c$export$b310ec824aaee37f = function exp(n) {
    return $758ebb328fd03b3c$var$EXP_TABLE[n];
};
$758ebb328fd03b3c$export$6e3a27864ab166fe = function mul(x, y) {
    if (x === 0 || y === 0) return 0;
    // should be EXP_TABLE[(LOG_TABLE[x] + LOG_TABLE[y]) % 255] if EXP_TABLE wasn't oversized
    // @see {@link initTables}
    return $758ebb328fd03b3c$var$EXP_TABLE[$758ebb328fd03b3c$var$LOG_TABLE[x] + $758ebb328fd03b3c$var$LOG_TABLE[y]];
};


$9563d144998a4c78$export$6e3a27864ab166fe = function mul(p1, p2) {
    const coeff = new Uint8Array(p1.length + p2.length - 1);
    for(let i = 0; i < p1.length; i++)for(let j = 0; j < p2.length; j++)coeff[i + j] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(p1[i], p2[j]);
    return coeff;
};
$9563d144998a4c78$export$842a2cf37af977e1 = function mod(divident, divisor) {
    let result = new Uint8Array(divident);
    while(result.length - divisor.length >= 0){
        const coeff = result[0];
        for(let i = 0; i < divisor.length; i++)result[i] ^= $758ebb328fd03b3c$export$6e3a27864ab166fe(divisor[i], coeff);
        // remove all zeros from buffer head
        let offset = 0;
        while(offset < result.length && result[offset] === 0)offset++;
        result = result.slice(offset);
    }
    return result;
};
$9563d144998a4c78$export$7b8be06a973a9d05 = function generateECPolynomial(degree) {
    let poly = new Uint8Array([
        1
    ]);
    for(let i = 0; i < degree; i++)poly = $9563d144998a4c78$export$6e3a27864ab166fe(poly, new Uint8Array([
        1,
        $758ebb328fd03b3c$export$b310ec824aaee37f(i)
    ]));
    return poly;
};


function $06a1abce65162dc0$var$ReedSolomonEncoder(degree) {
    this.genPoly = undefined;
    this.degree = degree;
    if (this.degree) this.initialize(this.degree);
}
/**
 * Initialize the encoder.
 * The input param should correspond to the number of error correction codewords.
 *
 * @param  {Number} degree
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.initialize = function initialize(degree) {
    // create an irreducible generator polynomial
    this.degree = degree;
    this.genPoly = $9563d144998a4c78$export$7b8be06a973a9d05(this.degree);
};
/**
 * Encodes a chunk of data
 *
 * @param  {Uint8Array} data Buffer containing input data
 * @return {Uint8Array}      Buffer containing encoded data
 */ $06a1abce65162dc0$var$ReedSolomonEncoder.prototype.encode = function encode(data) {
    if (!this.genPoly) throw new Error("Encoder not initialized");
    // Calculate EC for this data block
    // extends data size to data+genPoly size
    const paddedData = new Uint8Array(data.length + this.degree);
    paddedData.set(data);
    // The error correction codewords are the remainder after dividing the data codewords
    // by a generator polynomial
    const remainder = $9563d144998a4c78$export$842a2cf37af977e1(paddedData, this.genPoly);
    // return EC data blocks (last n byte, where n is the degree of genPoly)
    // If coefficients number in remainder are less than genPoly degree,
    // pad with 0s to the left to reach the needed number of coefficients
    const start = this.degree - remainder.length;
    if (start > 0) {
        const buff = new Uint8Array(this.degree);
        buff.set(remainder, start);
        return buff;
    }
    return remainder;
};
$06a1abce65162dc0$exports = $06a1abce65162dc0$var$ReedSolomonEncoder;


/**
 * Returns version number from a value.
 * If value is not a valid version, returns defaultValue
 *
 * @param  {Number|String} value        QR Code version
 * @param  {Number}        defaultValue Fallback value
 * @return {Number}                     QR Code version number
 */ var $140eee110ea3b5f9$export$6788812c4e6611e6;
/**
 * Returns how much data can be stored with the specified QR code version
 * and error correction level
 *
 * @param  {Number} version              QR Code version (1-40)
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Mode}   mode                 Data mode
 * @return {Number}                      Quantity of storable data
 */ var $140eee110ea3b5f9$export$55b283886ec2d3fb;
/**
 * Returns the minimum version needed to contain the amount of data
 *
 * @param  {Segment} data                    Segment of data
 * @param  {Number} [errorCorrectionLevel=H] Error correction level
 * @param  {Mode} mode                       Data mode
 * @return {Number}                          QR Code version
 */ var $140eee110ea3b5f9$export$264e969aa7a8ff7e;
/**
 * Returns version information with relative error correction bits
 *
 * The version information is included in QR Code symbols of version 7 or larger.
 * It consists of an 18-bit sequence containing 6 data bits,
 * with 12 error correction bits calculated using the (18, 6) Golay code.
 *
 * @param  {Number} version QR Code version
 * @return {Number}         Encoded version info bits
 */ var $140eee110ea3b5f9$export$eee5438974ef6f0e;



/**
 * Numeric mode encodes data from the decimal digit set (0 - 9)
 * (byte values 30HEX to 39HEX).
 * Normally, 3 data characters are represented by 10 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$4d318981b5a83836;
/**
 * Alphanumeric mode encodes data from a set of 45 characters,
 * i.e. 10 numeric digits (0 - 9),
 *      26 alphabetic characters (A - Z),
 *   and 9 symbols (SP, $, %, *, +, -, ., /, :).
 * Normally, two input characters are represented by 11 bits.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$376a9ed239d6c1c8;
/**
 * In byte mode, data is encoded at 8 bits per character.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$8f4bf8f7eb581284;
/**
 * The Kanji mode efficiently encodes Kanji characters in accordance with
 * the Shift JIS system based on JIS X 0208.
 * The Shift JIS values are shifted from the JIS X 0208 values.
 * JIS X 0208 gives details of the shift coded representation.
 * Each two-byte character value is compacted to a 13-bit binary codeword.
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$a4d452c2363c8e12;
/**
 * Mixed mode will contain a sequences of data in a combination of any of
 * the modes described above
 *
 * @type {Object}
 */ var $21e4e023abb588c2$export$bb410559a65d3418;
/**
 * Returns the number of bits needed to store the data length
 * according to QR Code specifications.
 *
 * @param  {Mode}   mode    Data mode
 * @param  {Number} version QR Code version
 * @return {Number}         Number of bits
 */ var $21e4e023abb588c2$export$e79764af6ffaeb8d;
/**
 * Returns the most efficient mode to store the specified data
 *
 * @param  {String} dataStr Input data string
 * @return {Mode}           Best mode
 */ var $21e4e023abb588c2$export$1bd4c93ffb42e55e;
/**
 * Return mode name as string
 *
 * @param {Mode} mode Mode object
 * @returns {String}  Mode name
 */ var $21e4e023abb588c2$export$f84e8e69fd4488a5;
/**
 * Check if input param is a valid mode object
 *
 * @param   {Mode}    mode Mode object
 * @returns {Boolean} True if valid mode, false otherwise
 */ var $21e4e023abb588c2$export$1ea939691cdc45b8;
/**
 * Returns mode from a value.
 * If value is not a valid mode, returns defaultValue
 *
 * @param  {Mode|String} value        Encoding mode
 * @param  {Mode}        defaultValue Fallback value
 * @return {Mode}                     Encoding mode
 */ var $21e4e023abb588c2$export$6788812c4e6611e6;
/**
 * Check if QR Code version is valid
 *
 * @param  {Number}  version QR Code version
 * @return {Boolean}         true if valid version, false otherwise
 */ var $7f0bebb05133540b$export$1ea939691cdc45b8;
$7f0bebb05133540b$export$1ea939691cdc45b8 = function isValid(version) {
    return !isNaN(version) && version >= 1 && version <= 40;
};


var $d479c387334094fb$export$a4d452c2363c8e12;
var $d479c387334094fb$export$9df7c29d562bab83;
var $d479c387334094fb$export$8f4bf8f7eb581284;
var $d479c387334094fb$export$4d318981b5a83836;
var $d479c387334094fb$export$376a9ed239d6c1c8;
var $d479c387334094fb$export$175f16aef75a4569;
var $d479c387334094fb$export$50b7f9bf92c74274;
var $d479c387334094fb$export$4ba5f52893b4ac97;
const $d479c387334094fb$var$numeric = "[0-9]+";
const $d479c387334094fb$var$alphanumeric = "[A-Z $%*+\\-./:]+";
let $d479c387334094fb$var$kanji = "(?:[u3000-u303F]|[u3040-u309F]|[u30A0-u30FF]|[uFF00-uFFEF]|[u4E00-u9FAF]|[u2605-u2606]|[u2190-u2195]|u203B|[u2010u2015u2018u2019u2025u2026u201Cu201Du2225u2260]|[u0391-u0451]|[u00A7u00A8u00B1u00B4u00D7u00F7])+";
$d479c387334094fb$var$kanji = $d479c387334094fb$var$kanji.replace(/u/g, "\\u");
const $d479c387334094fb$var$byte = "(?:(?![A-Z0-9 $%*+\\-./:]|" + $d479c387334094fb$var$kanji + ")(?:.|[\r\n]))+";
$d479c387334094fb$export$a4d452c2363c8e12 = new RegExp($d479c387334094fb$var$kanji, "g");
$d479c387334094fb$export$9df7c29d562bab83 = new RegExp("[^A-Z0-9 $%*+\\-./:]+", "g");
$d479c387334094fb$export$8f4bf8f7eb581284 = new RegExp($d479c387334094fb$var$byte, "g");
$d479c387334094fb$export$4d318981b5a83836 = new RegExp($d479c387334094fb$var$numeric, "g");
$d479c387334094fb$export$376a9ed239d6c1c8 = new RegExp($d479c387334094fb$var$alphanumeric, "g");
const $d479c387334094fb$var$TEST_KANJI = new RegExp("^" + $d479c387334094fb$var$kanji + "$");
const $d479c387334094fb$var$TEST_NUMERIC = new RegExp("^" + $d479c387334094fb$var$numeric + "$");
const $d479c387334094fb$var$TEST_ALPHANUMERIC = new RegExp("^[A-Z0-9 $%*+\\-./:]+$");
$d479c387334094fb$export$175f16aef75a4569 = function testKanji(str) {
    return $d479c387334094fb$var$TEST_KANJI.test(str);
};
$d479c387334094fb$export$50b7f9bf92c74274 = function testNumeric(str) {
    return $d479c387334094fb$var$TEST_NUMERIC.test(str);
};
$d479c387334094fb$export$4ba5f52893b4ac97 = function testAlphanumeric(str) {
    return $d479c387334094fb$var$TEST_ALPHANUMERIC.test(str);
};


$21e4e023abb588c2$export$4d318981b5a83836 = {
    id: "Numeric",
    bit: 1,
    ccBits: [
        10,
        12,
        14
    ]
};
$21e4e023abb588c2$export$376a9ed239d6c1c8 = {
    id: "Alphanumeric",
    bit: 2,
    ccBits: [
        9,
        11,
        13
    ]
};
$21e4e023abb588c2$export$8f4bf8f7eb581284 = {
    id: "Byte",
    bit: 4,
    ccBits: [
        8,
        16,
        16
    ]
};
$21e4e023abb588c2$export$a4d452c2363c8e12 = {
    id: "Kanji",
    bit: 8,
    ccBits: [
        8,
        10,
        12
    ]
};
$21e4e023abb588c2$export$bb410559a65d3418 = {
    bit: -1
};
$21e4e023abb588c2$export$e79764af6ffaeb8d = function getCharCountIndicator(mode, version) {
    if (!mode.ccBits) throw new Error("Invalid mode: " + mode);
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid version: " + version);
    if (version >= 1 && version < 10) return mode.ccBits[0];
    else if (version < 27) return mode.ccBits[1];
    return mode.ccBits[2];
};
$21e4e023abb588c2$export$1bd4c93ffb42e55e = function getBestModeForData(dataStr) {
    if ($d479c387334094fb$export$50b7f9bf92c74274(dataStr)) return $21e4e023abb588c2$export$4d318981b5a83836;
    else if ($d479c387334094fb$export$4ba5f52893b4ac97(dataStr)) return $21e4e023abb588c2$export$376a9ed239d6c1c8;
    else if ($d479c387334094fb$export$175f16aef75a4569(dataStr)) return $21e4e023abb588c2$export$a4d452c2363c8e12;
    else return $21e4e023abb588c2$export$8f4bf8f7eb581284;
};
$21e4e023abb588c2$export$f84e8e69fd4488a5 = function toString(mode) {
    if (mode && mode.id) return mode.id;
    throw new Error("Invalid mode");
};
$21e4e023abb588c2$export$1ea939691cdc45b8 = function isValid(mode) {
    return mode && mode.bit && mode.ccBits;
};
/**
 * Get mode object from its name
 *
 * @param   {String} string Mode name
 * @returns {Mode}          Mode object
 */ function $21e4e023abb588c2$var$fromString(string) {
    if (typeof string !== "string") throw new Error("Param is not a string");
    const lcStr = string.toLowerCase();
    switch(lcStr){
        case "numeric":
            return $21e4e023abb588c2$export$4d318981b5a83836;
        case "alphanumeric":
            return $21e4e023abb588c2$export$376a9ed239d6c1c8;
        case "kanji":
            return $21e4e023abb588c2$export$a4d452c2363c8e12;
        case "byte":
            return $21e4e023abb588c2$export$8f4bf8f7eb581284;
        default:
            throw new Error("Unknown mode: " + string);
    }
}
$21e4e023abb588c2$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($21e4e023abb588c2$export$1ea939691cdc45b8(value)) return value;
    try {
        return $21e4e023abb588c2$var$fromString(value);
    } catch (e) {
        return defaultValue;
    }
};



// Generator polynomial used to encode version information
const $140eee110ea3b5f9$var$G18 = 7973;
const $140eee110ea3b5f9$var$G18_BCH = $c1483b5b1305278f$export$ed1d66da50968976($140eee110ea3b5f9$var$G18);
function $140eee110ea3b5f9$var$getBestVersionForDataLength(mode, length, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, mode)) return currentVersion;
    }
    return undefined;
}
function $140eee110ea3b5f9$var$getReservedBitsCount(mode, version) {
    // Character count indicator + mode indicator bits
    return $21e4e023abb588c2$export$e79764af6ffaeb8d(mode, version) + 4;
}
function $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, version) {
    let totalBits = 0;
    segments.forEach(function(data) {
        const reservedBits = $140eee110ea3b5f9$var$getReservedBitsCount(data.mode, version);
        totalBits += reservedBits + data.getBitsLength();
    });
    return totalBits;
}
function $140eee110ea3b5f9$var$getBestVersionForMixedData(segments, errorCorrectionLevel) {
    for(let currentVersion = 1; currentVersion <= 40; currentVersion++){
        const length = $140eee110ea3b5f9$var$getTotalBitsFromDataArray(segments, currentVersion);
        if (length <= $140eee110ea3b5f9$export$55b283886ec2d3fb(currentVersion, errorCorrectionLevel, $21e4e023abb588c2$export$bb410559a65d3418)) return currentVersion;
    }
    return undefined;
}
$140eee110ea3b5f9$export$6788812c4e6611e6 = function from(value, defaultValue) {
    if ($7f0bebb05133540b$export$1ea939691cdc45b8(value)) return parseInt(value, 10);
    return defaultValue;
};
$140eee110ea3b5f9$export$55b283886ec2d3fb = function getCapacity(version, errorCorrectionLevel, mode) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version)) throw new Error("Invalid QR Code version");
    // Use Byte mode as default
    if (typeof mode === "undefined") mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    if (mode === $21e4e023abb588c2$export$bb410559a65d3418) return dataTotalCodewordsBits;
    const usableBits = dataTotalCodewordsBits - $140eee110ea3b5f9$var$getReservedBitsCount(mode, version);
    // Return max number of storable codewords
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return Math.floor(usableBits / 10 * 3);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return Math.floor(usableBits / 11 * 2);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return Math.floor(usableBits / 13);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
        default:
            return Math.floor(usableBits / 8);
    }
};
$140eee110ea3b5f9$export$264e969aa7a8ff7e = function getBestVersionForData(data, errorCorrectionLevel) {
    let seg;
    const ecl = $d22956012916b666$export$6788812c4e6611e6(errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
    if (Array.isArray(data)) {
        if (data.length > 1) return $140eee110ea3b5f9$var$getBestVersionForMixedData(data, ecl);
        if (data.length === 0) return 1;
        seg = data[0];
    } else seg = data;
    return $140eee110ea3b5f9$var$getBestVersionForDataLength(seg.mode, seg.getLength(), ecl);
};
$140eee110ea3b5f9$export$eee5438974ef6f0e = function getEncodedBits(version) {
    if (!$7f0bebb05133540b$export$1ea939691cdc45b8(version) || version < 7) throw new Error("Invalid QR Code version");
    let d = version << 12;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH >= 0)d ^= $140eee110ea3b5f9$var$G18 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $140eee110ea3b5f9$var$G18_BCH;
    return version << 12 | d;
};


/**
 * Returns format information with relative error correction bits
 *
 * The format information is a 15-bit sequence containing 5 data bits,
 * with 10 error correction bits calculated using the (15, 5) BCH code.
 *
 * @param  {Number} errorCorrectionLevel Error correction level
 * @param  {Number} mask                 Mask pattern
 * @return {Number}                      Encoded format information bits
 */ var $1f894980312e7d2a$export$eee5438974ef6f0e;

const $1f894980312e7d2a$var$G15 = 1335;
const $1f894980312e7d2a$var$G15_MASK = 21522;
const $1f894980312e7d2a$var$G15_BCH = $c1483b5b1305278f$export$ed1d66da50968976($1f894980312e7d2a$var$G15);
$1f894980312e7d2a$export$eee5438974ef6f0e = function getEncodedBits(errorCorrectionLevel, mask) {
    const data = errorCorrectionLevel.bit << 3 | mask;
    let d = data << 10;
    while($c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH >= 0)d ^= $1f894980312e7d2a$var$G15 << $c1483b5b1305278f$export$ed1d66da50968976(d) - $1f894980312e7d2a$var$G15_BCH;
    // xor final data with mask pattern in order to ensure that
    // no combination of Error Correction Level and data mask pattern
    // will result in an all-zero data string
    return (data << 10 | d) ^ $1f894980312e7d2a$var$G15_MASK;
};



/**
 * Builds a list of segments from an array.
 * Array can contain Strings or Objects with segment's info.
 *
 * For each item which is a string, will be generated a segment with the given
 * string and the more appropriate encoding mode.
 *
 * For each item which is an object, will be generated a segment with the given
 * data and mode.
 * Objects must contain at least the property "data".
 * If property "mode" is not present, the more suitable mode will be used.
 *
 * @param  {Array} array Array of objects with segments data
 * @return {Array}       Array of Segments
 */ var $06b6d7424b9df2df$export$571d59b505e6bb4e;
/**
 * Builds an optimized sequence of segments from a string,
 * which will produce the shortest possible bitstream.
 *
 * @param  {String} data    Input string
 * @param  {Number} version QR Code version
 * @return {Array}          Array of segments
 */ var $06b6d7424b9df2df$export$3004f64547af360e;
/**
 * Splits a string in various segments with the modes which
 * best represent their content.
 * The produced segments are far from being optimized.
 * The output of this function is only used to estimate a QR Code version
 * which may contain the data.
 *
 * @param  {string} data Input string
 * @return {Array}       Array of segments
 */ var $06b6d7424b9df2df$export$89ab1afb9839589b;

var $7a5bacf4a539441d$exports = {};

function $7a5bacf4a539441d$var$NumericData(data) {
    this.mode = $21e4e023abb588c2$export$4d318981b5a83836;
    this.data = data.toString();
}
$7a5bacf4a539441d$var$NumericData.getBitsLength = function getBitsLength(length) {
    return 10 * Math.floor(length / 3) + (length % 3 ? length % 3 * 3 + 1 : 0);
};
$7a5bacf4a539441d$var$NumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$7a5bacf4a539441d$var$NumericData.prototype.getBitsLength = function getBitsLength() {
    return $7a5bacf4a539441d$var$NumericData.getBitsLength(this.data.length);
};
$7a5bacf4a539441d$var$NumericData.prototype.write = function write(bitBuffer) {
    let i, group, value;
    // The input data string is divided into groups of three digits,
    // and each group is converted to its 10-bit binary equivalent.
    for(i = 0; i + 3 <= this.data.length; i += 3){
        group = this.data.substr(i, 3);
        value = parseInt(group, 10);
        bitBuffer.put(value, 10);
    }
    // If the number of input digits is not an exact multiple of three,
    // the final one or two digits are converted to 4 or 7 bits respectively.
    const remainingNum = this.data.length - i;
    if (remainingNum > 0) {
        group = this.data.substr(i);
        value = parseInt(group, 10);
        bitBuffer.put(value, remainingNum * 3 + 1);
    }
};
$7a5bacf4a539441d$exports = $7a5bacf4a539441d$var$NumericData;


var $f6549c884fd9ace3$exports = {};

/**
 * Array of characters available in alphanumeric mode
 *
 * As per QR Code specification, to each character
 * is assigned a value from 0 to 44 which in this case coincides
 * with the array index
 *
 * @type {Array}
 */ const $f6549c884fd9ace3$var$ALPHA_NUM_CHARS = [
    "0",
    "1",
    "2",
    "3",
    "4",
    "5",
    "6",
    "7",
    "8",
    "9",
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    " ",
    "$",
    "%",
    "*",
    "+",
    "-",
    ".",
    "/",
    ":"
];
function $f6549c884fd9ace3$var$AlphanumericData(data) {
    this.mode = $21e4e023abb588c2$export$376a9ed239d6c1c8;
    this.data = data;
}
$f6549c884fd9ace3$var$AlphanumericData.getBitsLength = function getBitsLength(length) {
    return 11 * Math.floor(length / 2) + 6 * (length % 2);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getLength = function getLength() {
    return this.data.length;
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.getBitsLength = function getBitsLength() {
    return $f6549c884fd9ace3$var$AlphanumericData.getBitsLength(this.data.length);
};
$f6549c884fd9ace3$var$AlphanumericData.prototype.write = function write(bitBuffer) {
    let i;
    // Input data characters are divided into groups of two characters
    // and encoded as 11-bit binary codes.
    for(i = 0; i + 2 <= this.data.length; i += 2){
        // The character value of the first character is multiplied by 45
        let value = $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]) * 45;
        // The character value of the second digit is added to the product
        value += $f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i + 1]);
        // The sum is then stored as 11-bit binary number
        bitBuffer.put(value, 11);
    }
    // If the number of input data characters is not a multiple of two,
    // the character value of the final character is encoded as a 6-bit binary number.
    if (this.data.length % 2) bitBuffer.put($f6549c884fd9ace3$var$ALPHA_NUM_CHARS.indexOf(this.data[i]), 6);
};
$f6549c884fd9ace3$exports = $f6549c884fd9ace3$var$AlphanumericData;


var $47f01312d66828cb$exports = {};

function $47f01312d66828cb$var$ByteData(data) {
    this.mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    if (typeof data === "string") this.data = new TextEncoder().encode(data);
    else this.data = new Uint8Array(data);
}
$47f01312d66828cb$var$ByteData.getBitsLength = function getBitsLength(length) {
    return length * 8;
};
$47f01312d66828cb$var$ByteData.prototype.getLength = function getLength() {
    return this.data.length;
};
$47f01312d66828cb$var$ByteData.prototype.getBitsLength = function getBitsLength() {
    return $47f01312d66828cb$var$ByteData.getBitsLength(this.data.length);
};
$47f01312d66828cb$var$ByteData.prototype.write = function(bitBuffer) {
    for(let i = 0, l = this.data.length; i < l; i++)bitBuffer.put(this.data[i], 8);
};
$47f01312d66828cb$exports = $47f01312d66828cb$var$ByteData;


var $668803520f2d7445$exports = {};


function $668803520f2d7445$var$KanjiData(data) {
    this.mode = $21e4e023abb588c2$export$a4d452c2363c8e12;
    this.data = data;
}
$668803520f2d7445$var$KanjiData.getBitsLength = function getBitsLength(length) {
    return length * 13;
};
$668803520f2d7445$var$KanjiData.prototype.getLength = function getLength() {
    return this.data.length;
};
$668803520f2d7445$var$KanjiData.prototype.getBitsLength = function getBitsLength() {
    return $668803520f2d7445$var$KanjiData.getBitsLength(this.data.length);
};
$668803520f2d7445$var$KanjiData.prototype.write = function(bitBuffer) {
    let i;
    // In the Shift JIS system, Kanji characters are represented by a two byte combination.
    // These byte values are shifted from the JIS X 0208 values.
    // JIS X 0208 gives details of the shift coded representation.
    for(i = 0; i < this.data.length; i++){
        let value = $c1483b5b1305278f$export$43dd553ecded716d(this.data[i]);
        // For characters with Shift JIS values from 0x8140 to 0x9FFC:
        if (value >= 0x8140 && value <= 0x9FFC) // Subtract 0x8140 from Shift JIS value
        value -= 0x8140;
        else if (value >= 0xE040 && value <= 0xEBBF) // Subtract 0xC140 from Shift JIS value
        value -= 0xC140;
        else throw new Error("Invalid SJIS character: " + this.data[i] + "\n" + "Make sure your charset is UTF-8");
        // Multiply most significant byte of result by 0xC0
        // and add least significant byte to product
        value = (value >>> 8 & 0xff) * 0xC0 + (value & 0xff);
        // Convert result to a 13-bit binary string
        bitBuffer.put(value, 13);
    }
};
$668803520f2d7445$exports = $668803520f2d7445$var$KanjiData;




var $6c1abb425b529163$exports = {};
"use strict";
/******************************************************************************
 * Created 2008-08-19.
 *
 * Dijkstra path-finding functions. Adapted from the Dijkstar Python project.
 *
 * Copyright (C) 2008
 *   Wyatt Baldwin <self@wyattbaldwin.com>
 *   All rights reserved
 *
 * Licensed under the MIT license.
 *
 *   http://www.opensource.org/licenses/mit-license.php
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 *****************************************************************************/ var $6c1abb425b529163$var$dijkstra = {
    single_source_shortest_paths: function(graph, s, d) {
        // Predecessor map for each node that has been encountered.
        // node ID => predecessor node ID
        var predecessors = {};
        // Costs of shortest paths from s to all nodes encountered.
        // node ID => cost
        var costs = {};
        costs[s] = 0;
        // Costs of shortest paths from s to all nodes encountered; differs from
        // `costs` in that it provides easy access to the node that currently has
        // the known shortest path from s.
        // XXX: Do we actually need both `costs` and `open`?
        var open = $6c1abb425b529163$var$dijkstra.PriorityQueue.make();
        open.push(s, 0);
        var closest, u, v, cost_of_s_to_u, adjacent_nodes, cost_of_e, cost_of_s_to_u_plus_cost_of_e, cost_of_s_to_v, first_visit;
        while(!open.empty()){
            // In the nodes remaining in graph that have a known cost from s,
            // find the node, u, that currently has the shortest path from s.
            closest = open.pop();
            u = closest.value;
            cost_of_s_to_u = closest.cost;
            // Get nodes adjacent to u...
            adjacent_nodes = graph[u] || {};
            // ...and explore the edges that connect u to those nodes, updating
            // the cost of the shortest paths to any or all of those nodes as
            // necessary. v is the node across the current edge from u.
            for(v in adjacent_nodes)if (adjacent_nodes.hasOwnProperty(v)) {
                // Get the cost of the edge running from u to v.
                cost_of_e = adjacent_nodes[v];
                // Cost of s to u plus the cost of u to v across e--this is *a*
                // cost from s to v that may or may not be less than the current
                // known cost to v.
                cost_of_s_to_u_plus_cost_of_e = cost_of_s_to_u + cost_of_e;
                // If we haven't visited v yet OR if the current known cost from s to
                // v is greater than the new cost we just found (cost of s to u plus
                // cost of u to v across e), update v's cost in the cost list and
                // update v's predecessor in the predecessor list (it's now u).
                cost_of_s_to_v = costs[v];
                first_visit = typeof costs[v] === "undefined";
                if (first_visit || cost_of_s_to_v > cost_of_s_to_u_plus_cost_of_e) {
                    costs[v] = cost_of_s_to_u_plus_cost_of_e;
                    open.push(v, cost_of_s_to_u_plus_cost_of_e);
                    predecessors[v] = u;
                }
            }
        }
        if (typeof d !== "undefined" && typeof costs[d] === "undefined") {
            var msg = [
                "Could not find a path from ",
                s,
                " to ",
                d,
                "."
            ].join("");
            throw new Error(msg);
        }
        return predecessors;
    },
    extract_shortest_path_from_predecessor_list: function(predecessors, d) {
        var nodes = [];
        var u = d;
        var predecessor;
        while(u){
            nodes.push(u);
            predecessor = predecessors[u];
            u = predecessors[u];
        }
        nodes.reverse();
        return nodes;
    },
    find_path: function(graph, s, d) {
        var predecessors = $6c1abb425b529163$var$dijkstra.single_source_shortest_paths(graph, s, d);
        return $6c1abb425b529163$var$dijkstra.extract_shortest_path_from_predecessor_list(predecessors, d);
    },
    /**
   * A very naive priority queue implementation.
   */ PriorityQueue: {
        make: function(opts) {
            var T = $6c1abb425b529163$var$dijkstra.PriorityQueue, t = {}, key;
            opts = opts || {};
            for(key in T)if (T.hasOwnProperty(key)) t[key] = T[key];
            t.queue = [];
            t.sorter = opts.sorter || T.default_sorter;
            return t;
        },
        default_sorter: function(a, b) {
            return a.cost - b.cost;
        },
        /**
     * Add a new item to the queue and ensure the highest priority element
     * is at the front of the queue.
     */ push: function(value, cost) {
            var item = {
                value: value,
                cost: cost
            };
            this.queue.push(item);
            this.queue.sort(this.sorter);
        },
        /**
     * Return the highest priority element in the queue.
     */ pop: function() {
            return this.queue.shift();
        },
        empty: function() {
            return this.queue.length === 0;
        }
    }
};
$6c1abb425b529163$exports = $6c1abb425b529163$var$dijkstra;


/**
 * Returns UTF8 byte length
 *
 * @param  {String} str Input string
 * @return {Number}     Number of byte
 */ function $06b6d7424b9df2df$var$getStringByteLength(str) {
    return unescape(encodeURIComponent(str)).length;
}
/**
 * Get a list of segments of the specified mode
 * from a string
 *
 * @param  {Mode}   mode Segment mode
 * @param  {String} str  String to process
 * @return {Array}       Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegments(regex, mode, str) {
    const segments = [];
    let result;
    while((result = regex.exec(str)) !== null)segments.push({
        data: result[0],
        index: result.index,
        mode: mode,
        length: result[0].length
    });
    return segments;
}
/**
 * Extracts a series of segments with the appropriate
 * modes from a string
 *
 * @param  {String} dataStr Input string
 * @return {Array}          Array of object with segments data
 */ function $06b6d7424b9df2df$var$getSegmentsFromString(dataStr) {
    const numSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$4d318981b5a83836, $21e4e023abb588c2$export$4d318981b5a83836, dataStr);
    const alphaNumSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$376a9ed239d6c1c8, $21e4e023abb588c2$export$376a9ed239d6c1c8, dataStr);
    let byteSegs;
    let kanjiSegs;
    if ($c1483b5b1305278f$export$ce5b1274f8597fa0()) {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$8f4bf8f7eb581284, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$a4d452c2363c8e12, $21e4e023abb588c2$export$a4d452c2363c8e12, dataStr);
    } else {
        byteSegs = $06b6d7424b9df2df$var$getSegments($d479c387334094fb$export$9df7c29d562bab83, $21e4e023abb588c2$export$8f4bf8f7eb581284, dataStr);
        kanjiSegs = [];
    }
    const segs = numSegs.concat(alphaNumSegs, byteSegs, kanjiSegs);
    return segs.sort(function(s1, s2) {
        return s1.index - s2.index;
    }).map(function(obj) {
        return {
            data: obj.data,
            mode: obj.mode,
            length: obj.length
        };
    });
}
/**
 * Returns how many bits are needed to encode a string of
 * specified length with the specified mode
 *
 * @param  {Number} length String length
 * @param  {Mode} mode     Segment mode
 * @return {Number}        Bit length
 */ function $06b6d7424b9df2df$var$getSegmentBitsLength(length, mode) {
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return $7a5bacf4a539441d$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return $f6549c884fd9ace3$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return $668803520f2d7445$exports.getBitsLength(length);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return $47f01312d66828cb$exports.getBitsLength(length);
    }
}
/**
 * Merges adjacent segments which have the same mode
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$mergeSegments(segs) {
    return segs.reduce(function(acc, curr) {
        const prevSeg = acc.length - 1 >= 0 ? acc[acc.length - 1] : null;
        if (prevSeg && prevSeg.mode === curr.mode) {
            acc[acc.length - 1].data += curr.data;
            return acc;
        }
        acc.push(curr);
        return acc;
    }, []);
}
/**
 * Generates a list of all possible nodes combination which
 * will be used to build a segments graph.
 *
 * Nodes are divided by groups. Each group will contain a list of all the modes
 * in which is possible to encode the given text.
 *
 * For example the text '12345' can be encoded as Numeric, Alphanumeric or Byte.
 * The group for '12345' will contain then 3 objects, one for each
 * possible encoding mode.
 *
 * Each node represents a possible segment.
 *
 * @param  {Array} segs Array of object with segments data
 * @return {Array}      Array of object with segments data
 */ function $06b6d7424b9df2df$var$buildNodes(segs) {
    const nodes = [];
    for(let i = 0; i < segs.length; i++){
        const seg = segs[i];
        switch(seg.mode){
            case $21e4e023abb588c2$export$4d318981b5a83836:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$376a9ed239d6c1c8,
                        length: seg.length
                    },
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$376a9ed239d6c1c8:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: seg.length
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$a4d452c2363c8e12:
                nodes.push([
                    seg,
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
                break;
            case $21e4e023abb588c2$export$8f4bf8f7eb581284:
                nodes.push([
                    {
                        data: seg.data,
                        mode: $21e4e023abb588c2$export$8f4bf8f7eb581284,
                        length: $06b6d7424b9df2df$var$getStringByteLength(seg.data)
                    }
                ]);
        }
    }
    return nodes;
}
/**
 * Builds a graph from a list of nodes.
 * All segments in each node group will be connected with all the segments of
 * the next group and so on.
 *
 * At each connection will be assigned a weight depending on the
 * segment's byte length.
 *
 * @param  {Array} nodes    Array of object with segments data
 * @param  {Number} version QR Code version
 * @return {Object}         Graph of all possible segments
 */ function $06b6d7424b9df2df$var$buildGraph(nodes, version) {
    const table = {};
    const graph = {
        start: {}
    };
    let prevNodeIds = [
        "start"
    ];
    for(let i = 0; i < nodes.length; i++){
        const nodeGroup = nodes[i];
        const currentNodeIds = [];
        for(let j = 0; j < nodeGroup.length; j++){
            const node = nodeGroup[j];
            const key = "" + i + j;
            currentNodeIds.push(key);
            table[key] = {
                node: node,
                lastCount: 0
            };
            graph[key] = {};
            for(let n = 0; n < prevNodeIds.length; n++){
                const prevNodeId = prevNodeIds[n];
                if (table[prevNodeId] && table[prevNodeId].node.mode === node.mode) {
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount + node.length, node.mode) - $06b6d7424b9df2df$var$getSegmentBitsLength(table[prevNodeId].lastCount, node.mode);
                    table[prevNodeId].lastCount += node.length;
                } else {
                    if (table[prevNodeId]) table[prevNodeId].lastCount = node.length;
                    graph[prevNodeId][key] = $06b6d7424b9df2df$var$getSegmentBitsLength(node.length, node.mode) + 4 + $21e4e023abb588c2$export$e79764af6ffaeb8d(node.mode, version) // switch cost
                    ;
                }
            }
        }
        prevNodeIds = currentNodeIds;
    }
    for(let n = 0; n < prevNodeIds.length; n++)graph[prevNodeIds[n]].end = 0;
    return {
        map: graph,
        table: table
    };
}
/**
 * Builds a segment from a specified data and mode.
 * If a mode is not specified, the more suitable will be used.
 *
 * @param  {String} data             Input data
 * @param  {Mode | String} modesHint Data mode
 * @return {Segment}                 Segment
 */ function $06b6d7424b9df2df$var$buildSingleSegment(data, modesHint) {
    let mode;
    const bestMode = $21e4e023abb588c2$export$1bd4c93ffb42e55e(data);
    mode = $21e4e023abb588c2$export$6788812c4e6611e6(modesHint, bestMode);
    // Make sure data can be encoded
    if (mode !== $21e4e023abb588c2$export$8f4bf8f7eb581284 && mode.bit < bestMode.bit) throw new Error('"' + data + '"' + " cannot be encoded with mode " + $21e4e023abb588c2$export$f84e8e69fd4488a5(mode) + ".\n Suggested mode is: " + $21e4e023abb588c2$export$f84e8e69fd4488a5(bestMode));
    // Use Mode.BYTE if Kanji support is disabled
    if (mode === $21e4e023abb588c2$export$a4d452c2363c8e12 && !$c1483b5b1305278f$export$ce5b1274f8597fa0()) mode = $21e4e023abb588c2$export$8f4bf8f7eb581284;
    switch(mode){
        case $21e4e023abb588c2$export$4d318981b5a83836:
            return new $7a5bacf4a539441d$exports(data);
        case $21e4e023abb588c2$export$376a9ed239d6c1c8:
            return new $f6549c884fd9ace3$exports(data);
        case $21e4e023abb588c2$export$a4d452c2363c8e12:
            return new $668803520f2d7445$exports(data);
        case $21e4e023abb588c2$export$8f4bf8f7eb581284:
            return new $47f01312d66828cb$exports(data);
    }
}
$06b6d7424b9df2df$export$571d59b505e6bb4e = function fromArray(array) {
    return array.reduce(function(acc, seg) {
        if (typeof seg === "string") acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg, null));
        else if (seg.data) acc.push($06b6d7424b9df2df$var$buildSingleSegment(seg.data, seg.mode));
        return acc;
    }, []);
};
$06b6d7424b9df2df$export$3004f64547af360e = function fromString(data, version) {
    const segs = $06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0());
    const nodes = $06b6d7424b9df2df$var$buildNodes(segs);
    const graph = $06b6d7424b9df2df$var$buildGraph(nodes, version);
    const path = $6c1abb425b529163$exports.find_path(graph.map, "start", "end");
    const optimizedSegs = [];
    for(let i = 1; i < path.length - 1; i++)optimizedSegs.push(graph.table[path[i]].node);
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$mergeSegments(optimizedSegs));
};
$06b6d7424b9df2df$export$89ab1afb9839589b = function rawSplit(data) {
    return $06b6d7424b9df2df$export$571d59b505e6bb4e($06b6d7424b9df2df$var$getSegmentsFromString(data, $c1483b5b1305278f$export$ce5b1274f8597fa0()));
};


/**
 * QRCode for JavaScript
 *
 * modified by Ryan Day for nodejs support
 * Copyright (c) 2011 Ryan Day
 *
 * Licensed under the MIT license:
 *   http://www.opensource.org/licenses/mit-license.php
 *
//---------------------------------------------------------------------
// QRCode for JavaScript
//
// Copyright (c) 2009 Kazuhiko Arase
//
// URL: http://www.d-project.com/
//
// Licensed under the MIT license:
//   http://www.opensource.org/licenses/mit-license.php
//
// The word "QR Code" is registered trademark of
// DENSO WAVE INCORPORATED
//   http://www.denso-wave.com/qrcode/faqpatent-e.html
//
//---------------------------------------------------------------------
*/ /**
 * Add finder patterns bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupFinderPattern(matrix, version) {
    const size = matrix.size;
    const pos = $b4836838cc492349$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -1; r <= 7; r++){
            if (row + r <= -1 || size <= row + r) continue;
            for(let c = -1; c <= 7; c++){
                if (col + c <= -1 || size <= col + c) continue;
                if (r >= 0 && r <= 6 && (c === 0 || c === 6) || c >= 0 && c <= 6 && (r === 0 || r === 6) || r >= 2 && r <= 4 && c >= 2 && c <= 4) matrix.set(row + r, col + c, true, true);
                else matrix.set(row + r, col + c, false, true);
            }
        }
    }
}
/**
 * Add timing pattern bits to matrix
 *
 * Note: this function must be called before {@link setupAlignmentPattern}
 *
 * @param  {BitMatrix} matrix Modules matrix
 */ function $5f2127839fe01a16$var$setupTimingPattern(matrix) {
    const size = matrix.size;
    for(let r = 8; r < size - 8; r++){
        const value = r % 2 === 0;
        matrix.set(r, 6, value, true);
        matrix.set(6, r, value, true);
    }
}
/**
 * Add alignment patterns bits to matrix
 *
 * Note: this function must be called after {@link setupTimingPattern}
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupAlignmentPattern(matrix, version) {
    const pos = $c20e4b3185223698$export$c39457c570f2b189(version);
    for(let i = 0; i < pos.length; i++){
        const row = pos[i][0];
        const col = pos[i][1];
        for(let r = -2; r <= 2; r++){
            for(let c = -2; c <= 2; c++)if (r === -2 || r === 2 || c === -2 || c === 2 || r === 0 && c === 0) matrix.set(row + r, col + c, true, true);
            else matrix.set(row + r, col + c, false, true);
        }
    }
}
/**
 * Add version info bits to matrix
 *
 * @param  {BitMatrix} matrix  Modules matrix
 * @param  {Number}    version QR Code version
 */ function $5f2127839fe01a16$var$setupVersionInfo(matrix, version) {
    const size = matrix.size;
    const bits = $140eee110ea3b5f9$export$eee5438974ef6f0e(version);
    let row, col, mod;
    for(let i = 0; i < 18; i++){
        row = Math.floor(i / 3);
        col = i % 3 + size - 8 - 3;
        mod = (bits >> i & 1) === 1;
        matrix.set(row, col, mod, true);
        matrix.set(col, row, mod, true);
    }
}
/**
 * Add format info bits to matrix
 *
 * @param  {BitMatrix} matrix               Modules matrix
 * @param  {ErrorCorrectionLevel}    errorCorrectionLevel Error correction level
 * @param  {Number}    maskPattern          Mask pattern reference value
 */ function $5f2127839fe01a16$var$setupFormatInfo(matrix, errorCorrectionLevel, maskPattern) {
    const size = matrix.size;
    const bits = $1f894980312e7d2a$export$eee5438974ef6f0e(errorCorrectionLevel, maskPattern);
    let i, mod;
    for(i = 0; i < 15; i++){
        mod = (bits >> i & 1) === 1;
        // vertical
        if (i < 6) matrix.set(i, 8, mod, true);
        else if (i < 8) matrix.set(i + 1, 8, mod, true);
        else matrix.set(size - 15 + i, 8, mod, true);
        // horizontal
        if (i < 8) matrix.set(8, size - i - 1, mod, true);
        else if (i < 9) matrix.set(8, 15 - i - 1 + 1, mod, true);
        else matrix.set(8, 15 - i - 1, mod, true);
    }
    // fixed module
    matrix.set(size - 8, 8, 1, true);
}
/**
 * Add encoded data bits to matrix
 *
 * @param  {BitMatrix}  matrix Modules matrix
 * @param  {Uint8Array} data   Data codewords
 */ function $5f2127839fe01a16$var$setupData(matrix, data) {
    const size = matrix.size;
    let inc = -1;
    let row = size - 1;
    let bitIndex = 7;
    let byteIndex = 0;
    for(let col = size - 1; col > 0; col -= 2){
        if (col === 6) col--;
        while(true){
            for(let c = 0; c < 2; c++)if (!matrix.isReserved(row, col - c)) {
                let dark = false;
                if (byteIndex < data.length) dark = (data[byteIndex] >>> bitIndex & 1) === 1;
                matrix.set(row, col - c, dark);
                bitIndex--;
                if (bitIndex === -1) {
                    byteIndex++;
                    bitIndex = 7;
                }
            }
            row += inc;
            if (row < 0 || size <= row) {
                row -= inc;
                inc = -inc;
                break;
            }
        }
    }
}
/**
 * Create encoded codewords from data input
 *
 * @param  {Number}   version              QR Code version
 * @param  {ErrorCorrectionLevel}   errorCorrectionLevel Error correction level
 * @param  {ByteData} data                 Data input
 * @return {Uint8Array}                    Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments) {
    // Prepare data buffer
    const buffer = new $22a6389bcfc83921$exports();
    segments.forEach(function(data) {
        // prefix data with mode indicator (4 bits)
        buffer.put(data.mode.bit, 4);
        // Prefix data with character count indicator.
        // The character count indicator is a string of bits that represents the
        // number of characters that are being encoded.
        // The character count indicator must be placed after the mode indicator
        // and must be a certain number of bits long, depending on the QR version
        // and data mode
        // @see {@link Mode.getCharCountIndicator}.
        buffer.put(data.getLength(), $21e4e023abb588c2$export$e79764af6ffaeb8d(data.mode, version));
        // add binary data sequence to buffer
        data.write(buffer);
    });
    // Calculate required number of bits
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    const dataTotalCodewordsBits = (totalCodewords - ecTotalCodewords) * 8;
    // Add a terminator.
    // If the bit string is shorter than the total number of required bits,
    // a terminator of up to four 0s must be added to the right side of the string.
    // If the bit string is more than four bits shorter than the required number of bits,
    // add four 0s to the end.
    if (buffer.getLengthInBits() + 4 <= dataTotalCodewordsBits) buffer.put(0, 4);
    // If the bit string is fewer than four bits shorter, add only the number of 0s that
    // are needed to reach the required number of bits.
    // After adding the terminator, if the number of bits in the string is not a multiple of 8,
    // pad the string on the right with 0s to make the string's length a multiple of 8.
    while(buffer.getLengthInBits() % 8 !== 0)buffer.putBit(0);
    // Add pad bytes if the string is still shorter than the total number of required bits.
    // Extend the buffer to fill the data capacity of the symbol corresponding to
    // the Version and Error Correction Level by adding the Pad Codewords 11101100 (0xEC)
    // and 00010001 (0x11) alternately.
    const remainingByte = (dataTotalCodewordsBits - buffer.getLengthInBits()) / 8;
    for(let i = 0; i < remainingByte; i++)buffer.put(i % 2 ? 0x11 : 0xEC, 8);
    return $5f2127839fe01a16$var$createCodewords(buffer, version, errorCorrectionLevel);
}
/**
 * Encode input data with Reed-Solomon and return codewords with
 * relative error correction bits
 *
 * @param  {BitBuffer} bitBuffer            Data to encode
 * @param  {Number}    version              QR Code version
 * @param  {ErrorCorrectionLevel} errorCorrectionLevel Error correction level
 * @return {Uint8Array}                     Buffer containing encoded codewords
 */ function $5f2127839fe01a16$var$createCodewords(bitBuffer, version, errorCorrectionLevel) {
    // Total codewords for this QR code version (Data + Error correction)
    const totalCodewords = $c1483b5b1305278f$export$b05dac13c7a35c32(version);
    // Total number of error correction codewords
    const ecTotalCodewords = $7f809b8d8966b945$export$683d1b3e8a1a8438(version, errorCorrectionLevel);
    // Total number of data codewords
    const dataTotalCodewords = totalCodewords - ecTotalCodewords;
    // Total number of blocks
    const ecTotalBlocks = $7f809b8d8966b945$export$41a1fc627aca72b9(version, errorCorrectionLevel);
    // Calculate how many blocks each group should contain
    const blocksInGroup2 = totalCodewords % ecTotalBlocks;
    const blocksInGroup1 = ecTotalBlocks - blocksInGroup2;
    const totalCodewordsInGroup1 = Math.floor(totalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup1 = Math.floor(dataTotalCodewords / ecTotalBlocks);
    const dataCodewordsInGroup2 = dataCodewordsInGroup1 + 1;
    // Number of EC codewords is the same for both groups
    const ecCount = totalCodewordsInGroup1 - dataCodewordsInGroup1;
    // Initialize a Reed-Solomon encoder with a generator polynomial of degree ecCount
    const rs = new $06a1abce65162dc0$exports(ecCount);
    let offset = 0;
    const dcData = new Array(ecTotalBlocks);
    const ecData = new Array(ecTotalBlocks);
    let maxDataSize = 0;
    const buffer = new Uint8Array(bitBuffer.buffer);
    // Divide the buffer into the required number of blocks
    for(let b = 0; b < ecTotalBlocks; b++){
        const dataSize = b < blocksInGroup1 ? dataCodewordsInGroup1 : dataCodewordsInGroup2;
        // extract a block of data from buffer
        dcData[b] = buffer.slice(offset, offset + dataSize);
        // Calculate EC codewords for this data block
        ecData[b] = rs.encode(dcData[b]);
        offset += dataSize;
        maxDataSize = Math.max(maxDataSize, dataSize);
    }
    // Create final data
    // Interleave the data and error correction codewords from each block
    const data = new Uint8Array(totalCodewords);
    let index = 0;
    let i, r;
    // Add data codewords
    for(i = 0; i < maxDataSize; i++){
        for(r = 0; r < ecTotalBlocks; r++)if (i < dcData[r].length) data[index++] = dcData[r][i];
    }
    // Apped EC codewords
    for(i = 0; i < ecCount; i++)for(r = 0; r < ecTotalBlocks; r++)data[index++] = ecData[r][i];
    return data;
}
/**
 * Build QR Code symbol
 *
 * @param  {String} data                 Input string
 * @param  {Number} version              QR Code version
 * @param  {ErrorCorretionLevel} errorCorrectionLevel Error level
 * @param  {MaskPattern} maskPattern     Mask pattern
 * @return {Object}                      Object containing symbol data
 */ function $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, maskPattern) {
    let segments;
    if (Array.isArray(data)) segments = $06b6d7424b9df2df$export$571d59b505e6bb4e(data);
    else if (typeof data === "string") {
        let estimatedVersion = version;
        if (!estimatedVersion) {
            const rawSegments = $06b6d7424b9df2df$export$89ab1afb9839589b(data);
            // Estimate best version that can contain raw splitted segments
            estimatedVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(rawSegments, errorCorrectionLevel);
        }
        // Build optimized segments
        // If estimated version is undefined, try with the highest version
        segments = $06b6d7424b9df2df$export$3004f64547af360e(data, estimatedVersion || 40);
    } else throw new Error("Invalid data");
    // Get the min version that can contain data
    const bestVersion = $140eee110ea3b5f9$export$264e969aa7a8ff7e(segments, errorCorrectionLevel);
    // If no version is found, data cannot be stored
    if (!bestVersion) throw new Error("The amount of data is too big to be stored in a QR Code");
    // If not specified, use min version as default
    if (!version) version = bestVersion;
    else if (version < bestVersion) throw new Error("\nThe chosen QR Code version cannot contain this amount of data.\nMinimum version required to store current data is: " + bestVersion + ".\n");
    const dataBits = $5f2127839fe01a16$var$createData(version, errorCorrectionLevel, segments);
    // Allocate matrix buffer
    const moduleCount = $c1483b5b1305278f$export$8d4a06d3facd414b(version);
    const modules = new $3c0264e2c9c64d36$exports(moduleCount);
    // Add function modules
    $5f2127839fe01a16$var$setupFinderPattern(modules, version);
    $5f2127839fe01a16$var$setupTimingPattern(modules);
    $5f2127839fe01a16$var$setupAlignmentPattern(modules, version);
    // Add temporary dummy bits for format info just to set them as reserved.
    // This is needed to prevent these bits from being masked by {@link MaskPattern.applyMask}
    // since the masking operation must be performed only on the encoding region.
    // These blocks will be replaced with correct values later in code.
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, 0);
    if (version >= 7) $5f2127839fe01a16$var$setupVersionInfo(modules, version);
    // Add data codewords
    $5f2127839fe01a16$var$setupData(modules, dataBits);
    if (isNaN(maskPattern)) // Find best mask pattern
    maskPattern = $1edc2624fba191d0$export$fe9625aaceb0e563(modules, $5f2127839fe01a16$var$setupFormatInfo.bind(null, modules, errorCorrectionLevel));
    // Apply mask pattern
    $1edc2624fba191d0$export$a1c9aa9c0e8ba394(maskPattern, modules);
    // Replace format info bits with correct values
    $5f2127839fe01a16$var$setupFormatInfo(modules, errorCorrectionLevel, maskPattern);
    return {
        modules: modules,
        version: version,
        errorCorrectionLevel: errorCorrectionLevel,
        maskPattern: maskPattern,
        segments: segments
    };
}
$5f2127839fe01a16$export$185802fd694ee1f5 = function create(data, options) {
    if (typeof data === "undefined" || data === "") throw new Error("No input text");
    let errorCorrectionLevel = $d22956012916b666$export$3a1a48c8f6ef640e;
    let version;
    let mask;
    if (typeof options !== "undefined") {
        // Use higher error correction level as default
        errorCorrectionLevel = $d22956012916b666$export$6788812c4e6611e6(options.errorCorrectionLevel, $d22956012916b666$export$3a1a48c8f6ef640e);
        version = $140eee110ea3b5f9$export$6788812c4e6611e6(options.version);
        mask = $1edc2624fba191d0$export$6788812c4e6611e6(options.maskPattern);
        if (options.toSJISFunc) $c1483b5b1305278f$export$6733b14783f975c2(options.toSJISFunc);
    }
    return $5f2127839fe01a16$var$createSymbol(data, version, errorCorrectionLevel, mask);
};


var $53c344a5283c422c$export$b3890eb0ae9dca99;
var $53c344a5283c422c$export$c3e5526bbaf70a25;
var $c890d85f31194258$export$d2312e68e1f5ad00;
var $c890d85f31194258$export$5cdac61cf538712e;
var $c890d85f31194258$export$c3a1a1f268a8142b;
var $c890d85f31194258$export$83136f57c739c5f3;
function $c890d85f31194258$var$hex2rgba(hex) {
    if (typeof hex === "number") hex = hex.toString();
    if (typeof hex !== "string") throw new Error("Color should be defined as hex string");
    let hexCode = hex.slice().replace("#", "").split("");
    if (hexCode.length < 3 || hexCode.length === 5 || hexCode.length > 8) throw new Error("Invalid hex color: " + hex);
    // Convert from short to long form (fff -> ffffff)
    if (hexCode.length === 3 || hexCode.length === 4) hexCode = Array.prototype.concat.apply([], hexCode.map(function(c) {
        return [
            c,
            c
        ];
    }));
    // Add default alpha value
    if (hexCode.length === 6) hexCode.push("F", "F");
    const hexValue = parseInt(hexCode.join(""), 16);
    return {
        r: hexValue >> 24 & 255,
        g: hexValue >> 16 & 255,
        b: hexValue >> 8 & 255,
        a: hexValue & 255,
        hex: "#" + hexCode.slice(0, 6).join("")
    };
}
$c890d85f31194258$export$d2312e68e1f5ad00 = function getOptions(options) {
    if (!options) options = {};
    if (!options.color) options.color = {};
    const margin = typeof options.margin === "undefined" || options.margin === null || options.margin < 0 ? 4 : options.margin;
    const width = options.width && options.width >= 21 ? options.width : undefined;
    const scale = options.scale || 4;
    return {
        width: width,
        scale: width ? 4 : scale,
        margin: margin,
        color: {
            dark: $c890d85f31194258$var$hex2rgba(options.color.dark || "#000000ff"),
            light: $c890d85f31194258$var$hex2rgba(options.color.light || "#ffffffff")
        },
        type: options.type,
        rendererOpts: options.rendererOpts || {}
    };
};
$c890d85f31194258$export$5cdac61cf538712e = function getScale(qrSize, opts) {
    return opts.width && opts.width >= qrSize + opts.margin * 2 ? opts.width / (qrSize + opts.margin * 2) : opts.scale;
};
$c890d85f31194258$export$c3a1a1f268a8142b = function getImageWidth(qrSize, opts) {
    const scale = $c890d85f31194258$export$5cdac61cf538712e(qrSize, opts);
    return Math.floor((qrSize + opts.margin * 2) * scale);
};
$c890d85f31194258$export$83136f57c739c5f3 = function qrToImageData(imgData, qr, opts) {
    const size = qr.modules.size;
    const data = qr.modules.data;
    const scale = $c890d85f31194258$export$5cdac61cf538712e(size, opts);
    const symbolSize = Math.floor((size + opts.margin * 2) * scale);
    const scaledMargin = opts.margin * scale;
    const palette = [
        opts.color.light,
        opts.color.dark
    ];
    for(let i = 0; i < symbolSize; i++)for(let j = 0; j < symbolSize; j++){
        let posDst = (i * symbolSize + j) * 4;
        let pxColor = opts.color.light;
        if (i >= scaledMargin && j >= scaledMargin && i < symbolSize - scaledMargin && j < symbolSize - scaledMargin) {
            const iSrc = Math.floor((i - scaledMargin) / scale);
            const jSrc = Math.floor((j - scaledMargin) / scale);
            pxColor = palette[data[iSrc * size + jSrc] ? 1 : 0];
        }
        imgData[posDst++] = pxColor.r;
        imgData[posDst++] = pxColor.g;
        imgData[posDst++] = pxColor.b;
        imgData[posDst] = pxColor.a;
    }
};


function $53c344a5283c422c$var$clearCanvas(ctx, canvas, size) {
    ctx.clearRect(0, 0, canvas.width, canvas.height);
    if (!canvas.style) canvas.style = {};
    canvas.height = size;
    canvas.width = size;
    canvas.style.height = size + "px";
    canvas.style.width = size + "px";
}
function $53c344a5283c422c$var$getCanvasElement() {
    try {
        return document.createElement("canvas");
    } catch (e) {
        throw new Error("You need to specify a canvas element");
    }
}
$53c344a5283c422c$export$b3890eb0ae9dca99 = function render(qrData, canvas, options) {
    let opts = options;
    let canvasEl = canvas;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!canvas) canvasEl = $53c344a5283c422c$var$getCanvasElement();
    opts = $c890d85f31194258$export$d2312e68e1f5ad00(opts);
    const size = $c890d85f31194258$export$c3a1a1f268a8142b(qrData.modules.size, opts);
    const ctx = canvasEl.getContext("2d");
    const image = ctx.createImageData(size, size);
    $c890d85f31194258$export$83136f57c739c5f3(image.data, qrData, opts);
    $53c344a5283c422c$var$clearCanvas(ctx, canvasEl, size);
    ctx.putImageData(image, 0, 0);
    return canvasEl;
};
$53c344a5283c422c$export$c3e5526bbaf70a25 = function renderToDataURL(qrData, canvas, options) {
    let opts = options;
    if (typeof opts === "undefined" && (!canvas || !canvas.getContext)) {
        opts = canvas;
        canvas = undefined;
    }
    if (!opts) opts = {};
    const canvasEl = $53c344a5283c422c$export$b3890eb0ae9dca99(qrData, canvas, opts);
    const type = opts.type || "image/png";
    const rendererOpts = opts.rendererOpts || {};
    return canvasEl.toDataURL(type, rendererOpts.quality);
};


var $3112213e4acbe245$export$b3890eb0ae9dca99;

function $3112213e4acbe245$var$getColorAttrib(color, attrib) {
    const alpha = color.a / 255;
    const str = attrib + '="' + color.hex + '"';
    return alpha < 1 ? str + " " + attrib + '-opacity="' + alpha.toFixed(2).slice(1) + '"' : str;
}
function $3112213e4acbe245$var$svgCmd(cmd, x, y) {
    let str = cmd + x;
    if (typeof y !== "undefined") str += " " + y;
    return str;
}
function $3112213e4acbe245$var$qrToPath(data, size, margin) {
    let path = "";
    let moveBy = 0;
    let newRow = false;
    let lineLength = 0;
    for(let i = 0; i < data.length; i++){
        const col = Math.floor(i % size);
        const row = Math.floor(i / size);
        if (!col && !newRow) newRow = true;
        if (data[i]) {
            lineLength++;
            if (!(i > 0 && col > 0 && data[i - 1])) {
                path += newRow ? $3112213e4acbe245$var$svgCmd("M", col + margin, 0.5 + row + margin) : $3112213e4acbe245$var$svgCmd("m", moveBy, 0);
                moveBy = 0;
                newRow = false;
            }
            if (!(col + 1 < size && data[i + 1])) {
                path += $3112213e4acbe245$var$svgCmd("h", lineLength);
                lineLength = 0;
            }
        } else moveBy++;
    }
    return path;
}
$3112213e4acbe245$export$b3890eb0ae9dca99 = function render(qrData, options, cb) {
    const opts = $c890d85f31194258$export$d2312e68e1f5ad00(options);
    const size = qrData.modules.size;
    const data = qrData.modules.data;
    const qrcodesize = size + opts.margin * 2;
    const bg = !opts.color.light.a ? "" : "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.light, "fill") + ' d="M0 0h' + qrcodesize + "v" + qrcodesize + 'H0z"/>';
    const path = "<path " + $3112213e4acbe245$var$getColorAttrib(opts.color.dark, "stroke") + ' d="' + $3112213e4acbe245$var$qrToPath(data, size, opts.margin) + '"/>';
    const viewBox = 'viewBox="0 0 ' + qrcodesize + " " + qrcodesize + '"';
    const width = !opts.width ? "" : 'width="' + opts.width + '" height="' + opts.width + '" ';
    const svgTag = '<svg xmlns="http://www.w3.org/2000/svg" ' + width + viewBox + ' shape-rendering="crispEdges">' + bg + path + "</svg>\n";
    if (typeof cb === "function") cb(null, svgTag);
    return svgTag;
};


function $092c7e998bebe629$var$renderCanvas(renderFunc, canvas, text, opts, cb) {
    const args = [].slice.call(arguments, 1);
    const argsNum = args.length;
    const isLastArgCb = typeof args[argsNum - 1] === "function";
    if (!isLastArgCb && !$e6419622b12b5572$exports()) throw new Error("Callback required as last argument");
    if (isLastArgCb) {
        if (argsNum < 2) throw new Error("Too few arguments provided");
        if (argsNum === 2) {
            cb = text;
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 3) {
            if (canvas.getContext && typeof cb === "undefined") {
                cb = opts;
                opts = undefined;
            } else {
                cb = opts;
                opts = text;
                text = canvas;
                canvas = undefined;
            }
        }
    } else {
        if (argsNum < 1) throw new Error("Too few arguments provided");
        if (argsNum === 1) {
            text = canvas;
            canvas = opts = undefined;
        } else if (argsNum === 2 && !canvas.getContext) {
            opts = text;
            text = canvas;
            canvas = undefined;
        }
        return new Promise(function(resolve, reject) {
            try {
                const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
                resolve(renderFunc(data, canvas, opts));
            } catch (e) {
                reject(e);
            }
        });
    }
    try {
        const data = $5f2127839fe01a16$export$185802fd694ee1f5(text, opts);
        cb(null, renderFunc(data, canvas, opts));
    } catch (e) {
        cb(e);
    }
}
$092c7e998bebe629$export$185802fd694ee1f5 = $5f2127839fe01a16$export$185802fd694ee1f5;
$092c7e998bebe629$export$f87f6982d1fd4f81 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$b3890eb0ae9dca99);
$092c7e998bebe629$export$723e4939e5a27c8 = $092c7e998bebe629$var$renderCanvas.bind(null, $53c344a5283c422c$export$c3e5526bbaf70a25);
$092c7e998bebe629$export$f84e8e69fd4488a5 = $092c7e998bebe629$var$renderCanvas.bind(null, function(data, _, opts) {
    return $3112213e4acbe245$export$b3890eb0ae9dca99(data, opts);
});


/*
* API Class
*/ class $5fa469543a026a34$export$2e2bcd8739ae039 {
    constructor(id, url){
        this.id = id;
        this.url = url;
        this.json = {};
    }
    get = async ()=>{
        const resApi = await fetch(this.url);
        const json = await resApi.json();
        this.json = json;
        return json;
    };
    post = async (data)=>{
        const resApi = await fetch(this.url, {
            method: "POST",
            body: data
        });
        const json = await resApi.json();
        this.json = json;
        return json;
    };
}



var $6ZWSX = parcelRequire("6ZWSX");
var $ee63ffa40e34f8fc$require$Buffer = $6ZWSX.Buffer;
function $ee63ffa40e34f8fc$var$dec2hex(str) {
    var dec = str.toString().split(""), sum = [], hex = [], i, s;
    while(dec.length){
        s = 1 * dec.shift();
        for(i = 0; s || i < sum.length; i++){
            s += (sum[i] || 0) * 10;
            sum[i] = s % 16;
            s = (s - sum[i]) / 16;
        }
    }
    while(sum.length)hex.push(sum.pop().toString(16));
    return hex.join("");
}
class $ee63ffa40e34f8fc$export$2e2bcd8739ae039 {
    constructor(){
        /**
         * - HD KeyPair
         * - BIP32-39-44-84
         * - P2PKH
         * - P2SH
         * - P2WKH
         * - P2WSH
         * - P2TR
         */ this.entropy = null;
        this.mnemonic = null;
        this.privateKey = null;
        this.publicKey = null;
        this.address = null;
        this.hd = null;
    }
    async randomBytes(browser = true) {
        // 
        const P = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFC2F"));
        const A = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000000"));
        const B = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("0000000000000000000000000000000000000000000000000000000000000007"));
        const Gcomp = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("0279BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798"));
        const Gext = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("0479BE667EF9DCBBAC55A06295CE870B07029BFCDB2DCE28D959F2815B16F81798483ADA7726A3C4655DA4FBFC0E1108A8FD17B448A68554199C47D08FFB10D4B8"));
        const H = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("01"));
        //const secp256k1 = Uint8Array.from(Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141"))
        // NODEJS / BROWSER
        //secp256k1.contextRandomize(new Uint8Array(32))
        let rndBytes = browser ? window.crypto.getRandomValues(new Uint8Array(32)) : (0, (/*@__PURE__*/$parcel$interopDefault($44edd02a6be448cd$exports))).getRandomValues(new Uint8Array(32));
        const curve = BigInt(`0x${$ee63ffa40e34f8fc$require$Buffer.from(rndBytes).toString("hex")}`) //Uint8Array.from(Buffer.from(rndBytes))
        ;
        const order = BigInt(`0x${$ee63ffa40e34f8fc$require$Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141")}`);
        const ok = curve < order //rndBytes < secp256k1
        ;
        while(!ok)rndBytes = browser ? window.crypto.getRandomValues(new Uint8Array(32)) : (0, (/*@__PURE__*/$parcel$interopDefault($44edd02a6be448cd$exports))).getRandomValues(new Uint8Array(32));
        //console.log("[order]: ", order)
        //console.log("[curve]: ", curve)
        console.log("[RND BigInt]: ", curve) //.toString(16)
        ;
        console.log(`[RND Bytes]: (secp256k1-${ok})`, $ee63ffa40e34f8fc$require$Buffer.from(rndBytes).toString("hex"));
        //console.log(dec2hex(""))
        return rndBytes;
    }
    async importFromMnemonic(sentence) {
        this.mnemonic = sentence;
        this.entropy = $836cf4f0e2c80e2c$exports.mnemonicToEntropy(sentence, (0, $d248fb36c996c0d4$exports.wordlist));
        //console.log("[ENTROPY]: ", Buffer.from(this.entropy).toString('hex'))
        this.privateKey = $ee63ffa40e34f8fc$require$Buffer.from(this.entropy);
        this.publicKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(this.privateKey) ? $ee63ffa40e34f8fc$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(this.privateKey)) : 0;
        this.bip32();
    }
    async exportToMnemonic() {
        this.mnemonic = $836cf4f0e2c80e2c$exports.entropyToMnemonic(this.privateKey, (0, $d248fb36c996c0d4$exports.wordlist));
        //console.log("[MNEMONIC]: ", this.mnemonic)
        this.importFromMnemonic(this.mnemonic);
    }
    async importPrivateKey(key) {
        const pre = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("302e0201010420", "hex")) //302e0201010420
        ;
        const mid = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from(key));
        const post = Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("a00706052b8104000a", "hex")) //secp256k1 //a00706052b8104000a
        ;
        //console.log(`[PRIVKEY]: ${Buffer.from(mid).toString('hex')}`)
        //console.log("[DER]: ",Buffer.from([...pre,...mid,...post]).toString('hex'))
        this.privateKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(key) ? $ee63ffa40e34f8fc$require$Buffer.from(key) : 0;
        this.publicKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(key) ? $ee63ffa40e34f8fc$require$Buffer.from((0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(key)) : 0;
    //this.exportToMnemonic()
    //this.bip32()
    }
    bip32(path = "m/44'/0'/0'/0", i = 0) {
        // NETWORKS
        const pubMainnet = new Uint8Array([
            0x04,
            0x88,
            0xB2,
            0x1E
        ]);
        const privMainnet = new Uint8Array([
            0x04,
            0x88,
            0xAD,
            0xE4
        ]);
        const pubTestnet = new Uint8Array([
            0x04,
            0x35,
            0x87,
            0xCF
        ]);
        const privTestnet = new Uint8Array([
            0x04,
            0x35,
            0x83,
            0x94
        ]);
        //console.log("\n====================== BIP32 =======================\n")
        /**
         *  Generate a seed byte sequence S of a chosen length (between 128 and 512 bits; 256 bits is advised) from a (P)RNG.
            Calculate I = HMAC-SHA512(Key = "Bitcoin seed", Data = S)
            Split I into two 32-byte sequences, IL and IR.
            Use parse256(IL) as master secret key, and IR as master chain code.
            In case parse256(IL) is 0 or parse256(IL) ≥ n, the master key is invalid.

            4 byte: version bytes (mainnet: 0x0488B21E public, 0x0488ADE4 private; testnet: 0x043587CF public, 0x04358394 private)
            1 byte: depth: 0x00 for master nodes, 0x01 for level-1 derived keys, ....
            4 bytes: the fingerprint of the parent's key (0x00000000 if master key)
            4 bytes: child number. This is ser32(i) for i in xi = xpar/i, with xi the key being serialized. (0x00000000 if master key)
            32 bytes: the chain code
            33 bytes: the public key or private key data (serP(K) for public keys, 0x00 || ser256(k) for private keys)
            
            This 78 byte structure can be encoded like other Bitcoin data in Base58, by first adding 32 checksum bits (derived from the double SHA-256 checksum), and then converting to the Base58 representation. 
            This results in a Base58-encoded string of up to 112 characters. Because of the choice of the version bytes, the Base58 representation will start with "xprv" or "xpub" on mainnet, "tprv" or "tpub" on testnet.
            Note that the fingerprint of the parent only serves as a fast way to detect parent and child nodes in software, and software must be willing to deal with collisions. Internally, the full 160-bit identifier could be used.

            When importing a serialized extended public key, implementations must verify whether the X coordinate in the public key data corresponds to a point on the curve. If not, the extended public key is invalid.
        */ const key = this.bip39("");
        const depth = new Uint8Array([
            0x00
        ]) // Master Node
        ;
        // Master Key Generation
        const S = key //Buffer.concat([this.privateKey, pass]) // 
        ;
        //const S = Buffer.concat([this.privateKey, Buffer.from("")]) // bip39 (S + mnemonic) + passphrase?
        const curve = $ee63ffa40e34f8fc$require$Buffer.from("Bitcoin seed") // 'Nist256p1 seed' | 'ed25519 seed'
        ;
        const I = (0, $51b6b372898f65c0$exports.hmac)((0, $2579977b4e52adba$exports.sha512), curve, S) // Bitcoin seed | Curve Point + SEED
        ;
        const il = I.slice(0, 32) // parent Master Secret Private Key m/ 256bits 32byte
        ;
        const ir = I.slice(32, 64) // parent Master Chain Code c
        ;
        const ok = il < Uint8Array.from($ee63ffa40e34f8fc$require$Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141"));
        //console.log("[secp256k1]: ",ok)
        //console.log("[iL]: ",Buffer.from(il).toString('hex'))
        //console.log("[iR]: ",Buffer.from(ir).toString('hex'))
        // [priv,chain]
        const parentPrivKey = il // m/
        ;
        const parentChainCode = ir // c
        ;
        // Parent Pub Key
        //const parentPubKeyExt = secp256k1.privateKeyVerify(parentPrivKey)?secp256k1.publicKeyCreate(parentPrivKey,false):0
        const parentPubKey = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).privateKeyVerify(parentPrivKey) ? (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).publicKeyCreate(parentPrivKey, true) : 0;
        //console.log("[Master Parent PrivKey]: ",Buffer.from(I).toString('hex'))
        //console.log("[Master Parent PubKey compressed]: ", Buffer.from(parentPubKey).toString('hex'))
        // <prefix> <depth> <parent fgpr> <chaincode> <key>
        const rawPrivKey = $ee63ffa40e34f8fc$require$Buffer.concat([
            //Buffer.from([0x00]),
            $ee63ffa40e34f8fc$require$Buffer.from(privMainnet),
            $ee63ffa40e34f8fc$require$Buffer.from(depth),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentChainCode),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentPrivKey) // or parentPubKeyc
        ]);
        const rawPubKey = $ee63ffa40e34f8fc$require$Buffer.concat([
            //Buffer.from([0x00]),
            $ee63ffa40e34f8fc$require$Buffer.from(pubMainnet),
            $ee63ffa40e34f8fc$require$Buffer.from(depth),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from([
                0x00,
                0x00,
                0x00,
                0x00
            ]),
            $ee63ffa40e34f8fc$require$Buffer.from(parentChainCode),
            $ee63ffa40e34f8fc$require$Buffer.from(parentPubKey) // or parentPubKeyc
        ]);
        //console.log("[RAWKEY]: ", rawPrivKey.length, Buffer.from(rawPrivKey).toString('hex'))
        const cksmPriv = $ee63ffa40e34f8fc$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)(rawPrivKey)).slice(0, 4));
        const cksmPub = $ee63ffa40e34f8fc$require$Buffer.from((0, $6XnWx.sha256)((0, $6XnWx.sha256)(rawPubKey)).slice(0, 4));
        //console.log("[CKSM-priv]: ", Buffer.from(cksmPriv).toString('hex'))
        //console.log("[CKSM-pub]: ", Buffer.from(cksmPub).toString('hex'))
        const extPrivRaw = $ee63ffa40e34f8fc$require$Buffer.concat([
            rawPrivKey,
            cksmPriv
        ]);
        const extPubRaw = $ee63ffa40e34f8fc$require$Buffer.concat([
            rawPubKey,
            cksmPub
        ]);
        //base58
        /**
         * This 78 byte structure can be encoded like other Bitcoin data in Base58,
         * by first adding 32 checksum bits (derived from the double SHA-256 checksum), 
         * and then converting to the Base58 representation.
         * This results in a Base58-encoded string of up to 112 characters.
         */ //console.log("[ * XPRIV-base58 root * ]: ", base58.encode(extPrivRaw)) // <--- BIP 32 Root Extendend Private Key
        //console.log("[ * XPUB-base58 root * ]: ", base58.encode(extPubRaw)) // <--- BIP 32 Root Extendend Public Key
        this.hd = (0, $c1c39050bd418416$export$bb670963070b393a).fromExtendedKey((0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(extPrivRaw));
        this.hd = this.hd.derive(path);
        //console.log("[CKD-XPRIV]", path, this.hd.privateExtendedKey)
        //console.log("[CKD-XPUB]", path, this.hd.publicExtendedKey)
        this.hd = this.hd.deriveChild(i);
        this.privateKey = this.hd.privateKey;
        this.publicKey = this.hd.publicKey;
    }
    bip38() {
        /**
         * - base58check 6P...
         * - 0x0142 (non-EC-multiplied) + C0 = 6PR uncompressed | + E0 = 6PY compressed
         * - 0x0143 (EC-multiplied) + 00 = 6Pf uncompressed | + 20 = 6Pn compressed
         * - 37 bytes <flag 1 byte + 2xsha256(addr) + 16bytes +16bytes>
         * 
         * - Scrypt ( passphrase , salt=addresshash ) = 64bytes / 2
         * 
         *  NO FLAG
         *  Do AES256Encrypt(block = bitcoinprivkey[0...15] xor derivedhalf1[0...15], key = derivedhalf2), call the 16-byte result encryptedhalf1
         *  Do AES256Encrypt(block = bitcoinprivkey[16...31] xor derivedhalf1[16...31], key = derivedhalf2), call the 16-byte result encryptedhalf2
         *  The encrypted private key is the Base58Check-encoded concatenation of the following, which totals 39 bytes without Base58 checksum:
         *  0x01 0x42 + flagbyte + salt + encryptedhalf1 + encryptedhalf2
         */ console.log("\n====================== BIP38 =======================\n");
        console.log("\n==================================================\n");
    }
    bip39(pass = "") {
        /**
         * To create a binary seed from the mnemonic, 
         * we use the PBKDF2 function with a mnemonic sentence (in UTF-8 NFKD) used as the password 
         * and the string "mnemonic" + passphrase (again in UTF-8 NFKD) used as the salt. 
         * The iteration count is set to 2048 and HMAC-SHA512 is used as the pseudo-random function. 
         * The length of the derived key is 512 bits (= 64 bytes).
        */ //console.log("\n====================== BIP39 =======================\n")
        const passphrase = pass;
        const password = this.mnemonic;
        const salt = "mnemonic" + passphrase;
        const pbkey = (0, $8c2f54a153cf1baf$exports.pbkdf2)((0, $2579977b4e52adba$exports.sha512), password, salt, {
            c: 2048,
            dkLen: 64
        });
        //console.log("[BIP39-root seed]: ", Buffer.from(pbkey).toString('hex'))
        return pbkey;
    }
    async getPublicKey() {
        //console.log("[PUBKEY]: ", this.publicKey.toString('hex'))
        return this.publicKey;
    }
    async getAddress(type = "p2sh", createQr = false, custom = "") {
        /**
         * p2pkh
         * p2sh
         * p2wpkh
         * p2wsh
         * p2tr
         */ //console.log("\n====================== ADDRESSES =======================\n")
        //console.log("[ADDRESS]: ")
        //console.log(sha256(this.publicKey))
        //console.log(Buffer.from(ripemd160.create().update(sha256(this.publicKey)).digest()).toString('hex'))
        // 00 p2pkh 05 p2sh 6f p2pkh testnet c4 p2sh testnet
        const p2pkh = 0x00 //Buffer.from([0x00])
        ;
        const p2sh = 0x05 //Buffer.from([0x05])
        ;
        const p2pkhtestnet = 0x6f //Buffer.from([0x6F])
        ;
        const p2shtestnet = 0xc4 //Buffer.from([0xC4])
        ;
        const pkh = (0, $6XnWx.sha256)(this.publicKey);
        //console.log("[PKH]: ",Buffer.from(pkh).toString('hex'))
        const hash160 = (0, $j5xzM.ripemd160).create().update(pkh).digest();
        //console.log("[HASH160]",Buffer.from(hash160,'hex').toString('hex'))
        //***P2PKH***
        let sha = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkh
            ]),
            hash160
        ]));
        //console.log("[SHA*1]: ",Buffer.from(sha).toString('hex'))
        sha = (0, $6XnWx.sha256)(sha);
        //console.log("[SHA*2]: ",Buffer.from(sha).toString('hex'))
        const cksm = sha.slice(0, 4);
        //console.log("[cksm-p2pkh]: ",Buffer.from(cksm,'hex').toString('hex'))
        const address = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkh
            ]),
            hash160,
            cksm
        ]);
        //console.log("[P2PKH]: ",base58.encode(address))
        //***P2SH***
        const psh = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                0x00,
                0x14
            ]),
            hash160
        ]));
        //console.log("[PSH]: ",Buffer.from(psh).toString('hex'))
        const pshash160 = (0, $j5xzM.ripemd160).create().update(psh).digest();
        //console.log("[PSHASH160]",Buffer.from(pshash160,'hex').toString('hex'))
        sha = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2sh
            ]),
            pshash160
        ]));
        //console.log("[SHA*1]: ",Buffer.from(sha).toString('hex'))
        sha = (0, $6XnWx.sha256)(sha);
        //console.log("[SHA*2]: ",Buffer.from(sha).toString('hex'))
        const p2shcksm = sha.slice(0, 4);
        //console.log("[cksm-p2sh]: ",Buffer.from(p2shcksm,'hex').toString('hex'))
        const p2shaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2sh
            ]),
            pshash160,
            p2shcksm
        ]);
        //console.log("[P2SH]: ",base58.encode(p2shaddress))
        //***Testnet p2pkh***
        sha = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkhtestnet
            ]),
            hash160
        ]));
        //console.log("[SHA*1]: ",Buffer.from(sha).toString('hex'))
        sha = (0, $6XnWx.sha256)(sha);
        //console.log("[SHA*2]: ",Buffer.from(sha).toString('hex'))
        const p2pkhtestcksm = sha.slice(0, 4);
        //console.log("[cksm-test-p2pkh]: ",Buffer.from(p2pkhtestcksm,'hex').toString('hex'))
        const p2pkhtestaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2pkhtestnet
            ]),
            hash160,
            p2pkhtestcksm
        ]);
        //console.log("[P2PKHtestnet]",base58.encode(p2pkhtestaddress))
        //***Testnet p2sh***
        const pshtest = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                0x00,
                0x14
            ]),
            hash160
        ]));
        const pshtesthash160 = (0, $j5xzM.ripemd160).create().update(pshtest).digest();
        //console.log(Buffer.from(pshtesthash160).toString('hex'))
        sha = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2shtestnet
            ]),
            pshtesthash160
        ]));
        //console.log("[SHA*1]: ",Buffer.from(sha).toString('hex'))
        sha = (0, $6XnWx.sha256)(sha);
        //console.log("[SHA*2]: ",Buffer.from(sha).toString('hex'))
        const p2shtestcksm = sha.slice(0, 4);
        //console.log("[cksm-test-p2sh]: ",Buffer.from(p2shtestcksm,'hex').toString('hex'))
        const p2shtestaddress = $ee63ffa40e34f8fc$require$Buffer.concat([
            new Uint8Array([
                p2shtestnet
            ]),
            pshtesthash160,
            p2shtestcksm
        ]);
        //console.log("[P2SHtestnet]",base58.encode(p2shtestaddress))
        //***P2WPKH bech32 ***/ OP_DUP OP_HASH160 <pubKeyHash> OP_EQUALVERIFY OP_CHECKSIG
        //***P2WSH bech32 ***/ sha256 0 <scriptHash>
        //***P2TR bech32m***/ schnorr
        switch(type){
            case "p2pkh":
                if (createQr) this.createQR("P2PKH Address", (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(address));
                return (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(address);
            case "p2sh":
                if (createQr) this.createQR("P2SH Address", (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2shaddress));
                return (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2shaddress);
            case "p2wpkh":
                const pkhash = (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)(this.publicKey)).digest();
                const pkwords = (0, $db6J2.bech32).toWords(pkhash);
                pkwords.unshift(0x00);
                if (createQr) this.createQR("P2WPKH Address", (0, $db6J2.bech32).encode("bc", pkwords));
                return (0, $db6J2.bech32).encode("bc", pkwords);
            case "p2wsh":
                //const shhash = sha256(this.publicKey)
                //const shhash = sha256(Buffer.concat([Uint8Array.from([0x21]),this.publicKey,Uint8Array.from([0xac])]))
                const shhash = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0x51,
                        0x21
                    ]),
                    this.publicKey,
                    Uint8Array.from([
                        0x51,
                        0xae
                    ])
                ]));
                const shwords = (0, $db6J2.bech32).toWords(shhash);
                shwords.unshift(0x00);
                if (createQr) this.createQR("P2WSH Address", (0, $db6J2.bech32).encode("bc", shwords));
                return (0, $db6J2.bech32).encode("bc", shwords);
            case "p2tr":
                const trhash = (0, $6XnWx.sha256)(this.publicKey);
                const trwords = (0, $db6J2.bech32m).toWords(trhash);
                trwords.unshift(0x01);
                if (createQr) this.createQR("P2TR Address", (0, $db6J2.bech32m).encode("bc", trwords));
                return (0, $db6J2.bech32m).encode("bc", trwords);
            case "p2pkh-test":
                if (createQr) this.createQR("P2PKH-test Address", (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2pkhtestaddress));
                return (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2pkhtestaddress);
            case "p2sh-test":
                if (createQr) this.createQR("P2SH-test Address", (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2shtestaddress));
                return (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(p2shtestaddress);
            case "p2wpkh-test":
                const pkhashtest = (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)(this.publicKey)).digest();
                const pkwordstest = (0, $db6J2.bech32).toWords(pkhashtest);
                pkwordstest.unshift(0x00);
                if (createQr) this.createQR("P2WPKH Test Address", (0, $db6J2.bech32).encode("tb", pkwordstest));
                return (0, $db6J2.bech32).encode("tb", pkwordstest);
            case "p2wsh-test":
                //const shhashtest = sha256(this.publicKey)
                //const shhashtest = sha256(Buffer.concat([Uint8Array.from([0x21]),this.publicKey,Uint8Array.from([0xac])]))
                const shhashtest = (0, $6XnWx.sha256)($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0x51,
                        0x21
                    ]),
                    this.publicKey,
                    Uint8Array.from([
                        0x51,
                        0xae
                    ])
                ]));
                const shwordstest = (0, $db6J2.bech32).toWords(shhashtest);
                shwordstest.unshift(0x00);
                if (createQr) this.createQR("P2WSH Test Address", (0, $db6J2.bech32).encode("tb", shwordstest));
                return (0, $db6J2.bech32).encode("tb", shwordstest);
            case "custom":
                const hash = this.sha256(custom);
                const words = (0, $db6J2.bech32).toWords(hash);
                words.unshift(0x00);
                const p2sh1 = (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0x05
                    ]),
                    this.hash160($ee63ffa40e34f8fc$require$Buffer.concat([
                        Uint8Array.from([
                            0x00,
                            0x20
                        ]),
                        custom
                    ])),
                    this.hash256(this.hash160($ee63ffa40e34f8fc$require$Buffer.concat([
                        Uint8Array.from([
                            0x00,
                            0x20
                        ]),
                        custom
                    ]))).slice(0, 4)
                ]));
                return (0, $db6J2.bech32).encode("bc", words);
            case "custom-test":
                const hashtest = this.sha256(custom);
                const wordstest = (0, $db6J2.bech32).toWords(hashtest);
                wordstest.unshift(0x00);
                const p2shtest = (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode($ee63ffa40e34f8fc$require$Buffer.concat([
                    Uint8Array.from([
                        0xc4
                    ]),
                    this.hash160($ee63ffa40e34f8fc$require$Buffer.concat([
                        Uint8Array.from([
                            0x00,
                            0x20
                        ]),
                        custom
                    ])),
                    this.hash256(this.hash160($ee63ffa40e34f8fc$require$Buffer.concat([
                        Uint8Array.from([
                            0x00,
                            0x20
                        ]),
                        custom
                    ]))).slice(0, 4)
                ]));
                return (0, $db6J2.bech32).encode("tb", wordstest);
            default:
                console.log("no type address selected");
        }
    }
    async sign(data) {
        // sign the message
        const sigObj = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaSign(data, this.privateKey);
        // verify the signature
        const isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaVerify(sigObj.signature, data, this.publicKey);
        //console.log("[SIGNATURE]: ", Buffer.from(sigObj.signature).toString('hex'), isValid)
        if (this.hd !== null) {
            //const hash = sha256(data)
            //console.log("[hash]: ", Buffer.from(hash).toString('hex'))
            const sig = this.hd.sign(data);
            //console.log("[bip32-sig]: ", Buffer.from(sig).toString('hex'))
            const valid = this.hd.verify(data, sig);
            //console.log("[Bip32-sig-valid]: ", valid)
            return sig;
        }
        return $ee63ffa40e34f8fc$require$Buffer.from(sigObj.signature);
    }
    async verify(sig, data, pubkey) {
        const isValid = (0, (/*@__PURE__*/$parcel$interopDefault($4a8af0cab3e1a9ea$exports))).ecdsaVerify(sig, data, pubkey);
        return isValid;
    }
    sha256(data) {
        return (0, $6XnWx.sha256)(data);
    }
    hash256(data) {
        return (0, $6XnWx.sha256)((0, $6XnWx.sha256)(data));
    }
    hash160(data) {
        return (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)(data)).digest();
    }
    base58(data) {
        return (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(data);
    }
    fromBase58(data) {
        return $ee63ffa40e34f8fc$require$Buffer.from((0, $3600b4829dff8fa9$export$61f53211c069eefb).decode(data));
    }
    bech32(data, prefix, m = false) {
        return m ? (0, $db6J2.bech32m).encode(prefix, (0, $db6J2.bech32m).toWords(data)) : (0, $db6J2.bech32).encode(prefix, (0, $db6J2.bech32).toWords(data));
    }
    fromBech32(data) {
        const el = (0, $db6J2.bech32).decode(data, data.len).words //bech32.decode(address,62).words
        ;
        const decoded = $ee63ffa40e34f8fc$require$Buffer.from(this.convertbits(el.slice(1), 5, 8, false));
        return $ee63ffa40e34f8fc$require$Buffer.concat([
            Uint8Array.from([
                0x00
            ]),
            Uint8Array.from([
                decoded.length
            ]),
            decoded
        ]) //m ? bech32m.decode(prefix,bech32m.toWords(data)) : bech32.decode(prefix,bech32.toWords(data))
        ;
    }
    convertbits(data, frombits, tobits, pad) {
        var acc = 0;
        var bits = 0;
        var ret = [];
        var maxv = (1 << tobits) - 1;
        for(var p = 0; p < data.length; ++p){
            var value = data[p];
            if (value < 0 || value >> frombits !== 0) return null;
            acc = acc << frombits | value;
            bits += frombits;
            while(bits >= tobits){
                bits -= tobits;
                ret.push(acc >> bits & maxv);
            }
        }
        if (pad) {
            if (bits > 0) ret.push(acc << tobits - bits & maxv);
        } else if (bits >= frombits || acc << tobits - bits & maxv) return null;
        return ret;
    }
    createQR(name, data, file = false) {
        console.log(`\n************************ ${name} ************************\n`);
        (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toString(data, {
            type: "terminal"
        }, function(err, url) {
            console.log(url);
        });
        console.log("\n**************************************************************\n");
        if (file) (0, (/*@__PURE__*/$parcel$interopDefault($092c7e998bebe629$exports))).toFile(`${name}.png`, [
            {
                data: $ee63ffa40e34f8fc$require$Buffer.from([
                    253,
                    254,
                    255
                ]),
                mode: "byte"
            }
        ], //...options...,
        //...callback...
        ()=>{
            console.log("qr filke created...");
        });
    }
    wif(data, format = "p2pkh", network = "mainnet") {
        /**
         * No suffix	P2PKH_UNCOMPRESSED	No	Uncompressed legacy public key. Unknown public key format
         * 0x01	P2PKH_COMPRESSED	Yes	Compressed legacy public key. Unknown public key format
         * 0x10	P2PKH	Yes	Compressed legacy public key. Legacy public key format (1...)
         * 0x11	P2WPKH	Yes	Bech32 format (native Segwit)
         * 0x12	P2WPKH_P2SH	Yes	Segwit nested in BIP16 P2SH (3...)
         */ let suffix;
        let version;
        switch(format){
            case "p2pkh":
                suffix = 0x10;
                break;
            case "p2wpkh":
                suffix = 0x11;
                break;
            case "p2wpkh-p2sh":
                suffix = 0x12;
                break;
            default:
                suffix = 0x01;
        }
        switch(network){
            case "mainnet":
                version = 0x80;
                break;
            case "testnet":
                version = 0xef;
                break;
        }
        //cksm = hash256(key)[0:4]
        const key = $ee63ffa40e34f8fc$require$Buffer.concat([
            Uint8Array.from([
                version
            ]),
            data
        ]);
        const cksm = this.hash256(key).slice(0, 4);
        //console.log("[CKSM]: ",Buffer.from(cksm).toString('hex'))
        //key = key + cksm
        const uncompressed = $ee63ffa40e34f8fc$require$Buffer.concat([
            key,
            cksm
        ]);
        const compressed = $ee63ffa40e34f8fc$require$Buffer.concat([
            key,
            cksm,
            Uint8Array.from([
                suffix
            ])
        ]);
        //WIFext = base58(key)
        const wifExt = (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(uncompressed);
        //WIFcomp = base58(key + 0x01) 
        const wifComp = (0, $3600b4829dff8fa9$export$61f53211c069eefb).encode(compressed);
        //console.log("[WIF uncompressed]: ", wifExt)
        //console.log("[WIF compressed]: ", wifComp)
        return wifComp //compressed
        ;
    }
    fromWif(data) {
        //decode from string
        let buf = (0, $3600b4829dff8fa9$export$61f53211c069eefb).decode(data);
        buf = buf.slice(1, -5);
        this.importPrivateKey(buf);
    //console.log("[FROM-WIF]", Buffer.from(buf).toString('hex'))
    }
    async getApi(id, url) {
        const api = await new (0, $5fa469543a026a34$export$2e2bcd8739ae039)(id, url).get();
        return api;
    }
    async postApi(id, url, data) {
        const api = await new (0, $5fa469543a026a34$export$2e2bcd8739ae039)(id, url).post(data);
        return api;
    }
}
const $ee63ffa40e34f8fc$var$main = async (type = "p2sh", online = false, test = false)=>{
    console.log("* * * BTC Signer * * *");
    const wallet = new $ee63ffa40e34f8fc$export$2e2bcd8739ae039();
    const rnd = await wallet.randomBytes();
    //console.log(rnd.buffer)
    try {
        await wallet.importPrivateKey($ee63ffa40e34f8fc$require$Buffer.from("F000000000000000000000000000000000000000000000000000000000000001", "hex")) //Buffer.from("",'hex')
        ;
    } catch (error) {
        console.log(error);
    }
    const pubKey = await wallet.getPublicKey();
    const address = await wallet.getAddress(type) // true for QRcode export
    ;
    console.log(`[ADDRESS-${type}]: `, address);
    await wallet.sign("pubKey");
    if (online) {
        const testnet = test ? "testnet/" : "";
        try {
            //balance
            const status = await wallet.getApi("status", `https://mempool.space/${testnet}api/address/${address}`);
            //txs
            const txs = await wallet.getApi("utxo", `https://mempool.space/${testnet}api/address/${address}/txs`);
            //utxo
            const utxo = await wallet.getApi("txs", `https://mempool.space/${testnet}api/address/${address}/utxo`);
            //block
            const block = await wallet.getApi("block", `https://mempool.space/${testnet}api/blocks/tip/height`);
            //price
            const price = await wallet.getApi("price", `https://mempool.space/api/v1/prices`);
        //
        //const broadcast = https://mempool.space/testnet/api/tx //POST
        /*
            console.log("[STATUS]: ", status)
            console.log("[UTXO]: ", utxo)
            console.log("[TXS]: ", txs)
            console.log("[BLOCK]: ", block)
            console.log("[PRICE]: ", price)
            */ } catch (error) {
            console.log("[API] error: ", error);
        }
    }
//console.log(wallet)
} /*
(async()=>{await main("p2sh-test",true,true) // address type, online, testnet
.then(()=>process.exit(0))
.catch((error)=>{
    console.error(error)
    process.exit(1)
})})()
*/ ;


//#!/usr/bin/env node
/**
 * BTC TX Builder
 * - bip66 / Strict DER signing
 * - bip112 / Checksequenceverify
 * - bip125 / RBF
 * - bip136 / Bech32 TX
 * - bip141-143-147 / Segregated Witness
 * - bip174 / PSBTV v0
 * - bip197-199 / Hashed Time-Locked Contract / Transactions
 * - bip327 / MuSig2
 * - bip340 / Schnorr Signatures
 * - bip341-342 / Taproot SegWit v1 spending rules / Validation
 * - bip350 / Bech32m format for v1+ witness addresses
 * - bip370 / PSBTV v2
 * - bip371 / PSBT Taproot fields
 * - bip373 MuSig2 PSBT
 * - bip380-381-382-383-385-386-387 / Output/Non-SegWit/Segwit/Multisig script Descriptors
 */ 
var $6XnWx = parcelRequire("6XnWx");

var $j5xzM = parcelRequire("j5xzM");


var $db6J2 = parcelRequire("db6J2");

/*
* API Class
*/ class $c2ab48eaa2792f66$export$2e2bcd8739ae039 {
    constructor(id, url){
        this.id = id;
        this.url = url;
        this.json = {};
    }
    get = async ()=>{
        const resApi = await fetch(this.url);
        const json = await resApi.json();
        this.json = json;
        return json;
    };
    post = async (data)=>{
        const resApi = await fetch(this.url, {
            method: "POST",
            body: data
        });
        const json = resApi //.json();
        ;
        this.json = json;
        return json;
    };
}



var $6ZWSX = parcelRequire("6ZWSX");
var $ebab65f303698dab$require$Buffer = $6ZWSX.Buffer;
const $ebab65f303698dab$var$OP_0 = 0x00;
const $ebab65f303698dab$var$OP_1 = 0x51;
const $ebab65f303698dab$var$OP_PUSHDATA1 = 0x4c;
const $ebab65f303698dab$var$OP_PUSHDATA2 = 0x4d;
const $ebab65f303698dab$var$OP_IF = 0x63;
const $ebab65f303698dab$var$OP_NOTIF = 0x64;
const $ebab65f303698dab$var$OP_ELSE = 0x67;
const $ebab65f303698dab$var$OP_ENDIF = 0x68;
const $ebab65f303698dab$var$OP_VERIFY = 0x69;
const $ebab65f303698dab$var$OP_RETURN = 0x6a;
const $ebab65f303698dab$var$OP_DROP = 0x75;
const $ebab65f303698dab$var$OP_DUP = 0x76;
const $ebab65f303698dab$var$OP_AND = 0x84;
const $ebab65f303698dab$var$OP_OR = 0x85;
const $ebab65f303698dab$var$OP_XOR = 0x86;
const $ebab65f303698dab$var$OP_EQUAL = 0x87;
const $ebab65f303698dab$var$OP_EQUALVERIFY = 0x88;
const $ebab65f303698dab$var$OP_RIPEMD160 = 0xa6;
const $ebab65f303698dab$var$OP_SHA256 = 0xa8;
const $ebab65f303698dab$var$OP_HASH160 = 0xa9;
const $ebab65f303698dab$var$OP_HASH256 = 0xaa;
const $ebab65f303698dab$var$OP_CODESEPARATOR = 0xab;
const $ebab65f303698dab$var$OP_CHECKSIG = 0xac;
const $ebab65f303698dab$var$OP_CHECKSIGVERIFY = 0xad;
const $ebab65f303698dab$var$OP_CHECKMULTISIG = 0xae;
const $ebab65f303698dab$var$OP_CHECKMULTISIGVERIFY = 0xaf;
const $ebab65f303698dab$var$OP_CHECKSIGADD = 0xba;
const $ebab65f303698dab$var$OP_CHECKLOCKTIMEVERIFY = 0xb1;
const $ebab65f303698dab$var$OP_CHECKSEQUENCEVERIFY = 0xb2;
class $ebab65f303698dab$export$fce14c253806ce6d {
    /**
     * Bitcoin transaction instance
     * @param {*} version Specify 1 or 2
     * @param {*} segwit  true or false for segwit
     */ constructor(network = "bitcoin", version = 2, segwit = false, type = "p2pkh"){
        /**
         * - Version 4byte
         * - VINS [inputCount 1+byte + inputs 32byte + vout 4byte + scriptSig(unlockScript) ?byte + sequence 4byte ...]
         * - VOUTS [outputCount 1+byte + value 8byte + scriptPubKey(len 1byte + pubkey) ...]
         * - LOCKTIME 4byte
         */ this.debugger = false;
        this.type = type // p2pkh | p2sh | p2wpkh | p2wsh
        ;
        this.txid = [];
        this.wtxid = [];
        this.version = new Uint8Array([
            version,
            0x00,
            0x00,
            0x00
        ]);
        this.flag = segwit ? new Uint8Array([
            0x01
        ]) : new Uint8Array([
            0x00
        ]);
        this.inputs = [] // ScriptSig
        ;
        this.vins = [] // ScriptSig
        ;
        this.vouts = [] // ScriptPubKey
        ;
        this.sequence = new Uint8Array([
            0xFF,
            0xFF,
            0xFF,
            0xFD
        ]) // locktime 0xFFFFFFFD | rbf 0xFFFFFFFE | rel locktime 0x80000000
        ;
        this.locktime = new Uint8Array([
            0x00,
            0x00,
            0x00,
            0x00
        ]);
        this.sighash = new Uint8Array([
            0x01
        ]) // 0x01, 0x02, 0x03, 0x81, 0x82 and 0x83 
        ;
        this.inputCount = 0;
        this.outputCount = 0;
        this.signature = [];
        this.signatures = [];
        this.scriptSig = [];
        this.wtxid = [] //[nVersion][marker][flag][txins][txouts][witness][nLockTime]
        ;
        this.witnessCount = 0;
        this.witness = [];
        this.redeem = [];
        //
        this.segwit = segwit;
        this.network = network;
        this.fee = 1000;
        this.size = 0;
        this.vsize = 0;
        this.weight = 0;
        this.amount = [];
        this.output = [];
        this.outputScript = [];
        this.unsignedtx = {
            // version + inputcount + vins + outputcount + vouts + locktime
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ 00 + <>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: [],
            vins: [],
            outputcount: [],
            vouts: [],
            locktime: this.locktime
        };
        this.txtosign = {
            // version + inputcount + vins + vouts + locktime + sighash
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ ?? + <prevout scriptpubkey>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: new Uint8Array([
                this.inputCount
            ]),
            vins: [],
            outputcount: new Uint8Array([
                this.outputCount
            ]),
            vouts: [],
            locktime: this.locktime,
            sighash: new Uint8Array([
                this.sighash,
                0x00,
                0x00,
                0x00
            ])
        };
        this.signedtx = {
            // version + inputcount + vins + vouts + locktime
            // vin = [txid + vout + scriptsig + sequence] // scriptsig = [ ?? + <script ...sig ...pub>]
            // vouts = [ amount + scriptpubkey]
            version: this.version,
            inputcount: new Uint8Array([
                this.inputCount
            ]),
            vins: [],
            outputcount: new Uint8Array([
                this.outputCount
            ]),
            vouts: [],
            locktime: this.locktime
        };
    }
    /**
     * Create an input given the hash of an unspent transaction output and the script pubkey (locking script)
     * @param {*} utxo txid
     * @param {*} script script or pubkey 
     * @param {*} type p2pkh|p2sh
     * @param {*} n index to spend
     * @returns this
     */ createInput(utxo = "", script = "", type = "p2pkh", n = 0) {
        /**
         * Inputs Count
         * Inputs[tx_id, vout, script_sig, sequence]
         */ const redeem = this.scripter(type, script);
        const txId = new Uint8Array(32);
        txId.set($ebab65f303698dab$require$Buffer.from(utxo, "hex").reverse());
        this.txid = txId;
        //console.log("[TX_ID]:",Buffer.from(txId).toString('hex'))
        // Which previous output index from txid hash has to be spent
        const vout = new Uint8Array(new ArrayBuffer(4));
        vout.set([
            n,
            0x00,
            0x00,
            0x00
        ]);
        //console.log("[VOUT]: ",Buffer.from(vout).toString('hex'))
        const scriptSig2 = new Uint8Array(redeem.length + 1);
        scriptSig2[0] = redeem.length;
        scriptSig2.set(redeem, 1);
        if (this.debugger) console.log("[SCRIPT_SIG]: ", $ebab65f303698dab$require$Buffer.from(scriptSig2).toString("hex"));
        const sequence = new Uint8Array(new ArrayBuffer(4));
        sequence.set([
            0xFF,
            0xFF,
            0xFF,
            0xFD
        ]);
        //console.log("[SEQUENCE]: ",Buffer.from(sequence).toString('hex'))
        const input = {
            hash: utxo,
            vout: $ebab65f303698dab$require$Buffer.from(vout).toString("hex"),
            script_size: this.segwit ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString("hex") : this.type === "p2sh" || this.type === "p2wsh" ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString("hex") : scriptSig2.length,
            unlock_scriptsig: this.segwit ? this.type === "p2sh" || this.type === "p2wsh" ? $ebab65f303698dab$require$Buffer.from("").toString("hex") : $ebab65f303698dab$require$Buffer.from([
                0x00
            ]).toString("hex") : $ebab65f303698dab$require$Buffer.from(scriptSig2).toString("hex"),
            pubkey: script,
            sequence: $ebab65f303698dab$require$Buffer.from(this.sequence).toString("hex"),
            witness: ""
        };
        this.debugger && console.log("[INPUT]: ", input);
        const inputRaw = $ebab65f303698dab$require$Buffer.concat([
            //Buffer.from(inputCount),
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            this.segwit ? $ebab65f303698dab$require$Buffer.from([
                0x00
            ]) : scriptSig2,
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]);
        //console.log(`[${inputRaw.length}]`,inputRaw.toString('hex'))
        this.vins.push(inputRaw);
        this.unsignedtx.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            $ebab65f303698dab$require$Buffer.from([
                0x00
            ]),
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]));
        this.txtosign.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout),
            scriptSig2,
            $ebab65f303698dab$require$Buffer.from(this.sequence)
        ]));
        this.signedtx.vins.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(txId),
            $ebab65f303698dab$require$Buffer.from(vout)
        ]));
        this.inputCount = this.inputCount + 1;
        this.unsignedtx.inputcount = new Uint8Array([
            this.inputCount,
            0x00,
            0x00,
            0x00
        ]);
        this.txtosign.inputcount = new Uint8Array([
            this.inputCount,
            0x00,
            0x00,
            0x00
        ]);
        return this;
    }
    /**
     * Create an output given an amount in satoshi and address receiver
     * @param {*} valueIn 
     * @param {*} address 
     * @returns this
     */ createOutput(valueIn = 0, address = "") {
        /**
         * Outputs Count
         * [value, script_pubkey]
         */ let addressDecoded;
        let outputScript;
        let scriptDetected = "";
        if (address.startsWith("1") || address.startsWith("m")) {
            this.debugger && console.log("***P2PKH OUTPUT***");
            addressDecoded = (0, $3600b4829dff8fa9$export$61f53211c069eefb).decode(address);
        }
        if (address.startsWith("3") || address.startsWith("2")) {
            this.debugger && console.log("***P2SH OUTPUT***");
            addressDecoded = (0, $3600b4829dff8fa9$export$61f53211c069eefb).decode(address);
        }
        if (address.startsWith("bc") && address.length === 42 || address.startsWith("tb") && address.length === 42) {
            this.debugger && console.log("***P2WPKH OUTPUT***", address.length);
            scriptDetected = "p2wpkh";
            addressDecoded = (0, $db6J2.bech32).decode(address, 42).words;
        }
        if (address.startsWith("bc") && address.length > 42 || address.startsWith("tb") && address.length > 42) {
            this.debugger && console.log("***P2WSH OUTPUT***", address.length);
            scriptDetected = "p2wsh";
            addressDecoded = (0, $db6J2.bech32).decode(address, 62).words;
        }
        const decodedHash = new Uint8Array($ebab65f303698dab$require$Buffer.from(addressDecoded, "hex")).slice(1, addressDecoded.length - 4);
        switch(addressDecoded[0]){
            case 0x00:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x00", "P2PKH", "MAINNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_DUP,
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUALVERIFY,
                        $ebab65f303698dab$var$OP_CHECKSIG
                    ])
                ]);
                if (scriptDetected === "p2wpkh") {
                    const decoded = $ebab65f303698dab$require$Buffer.from(this.convertbits(addressDecoded.slice(1), 5, 8, false));
                    outputScript = $ebab65f303698dab$require$Buffer.concat([
                        Uint8Array.from([
                            $ebab65f303698dab$var$OP_0
                        ]),
                        Uint8Array.from([
                            0x14
                        ]),
                        decoded
                    ]);
                }
                if (scriptDetected === "p2wsh") {
                    const decoded = $ebab65f303698dab$require$Buffer.from(this.convertbits(addressDecoded.slice(1), 5, 8, false));
                    outputScript = $ebab65f303698dab$require$Buffer.concat([
                        Uint8Array.from([
                            $ebab65f303698dab$var$OP_0
                        ]),
                        Uint8Array.from([
                            0x20
                        ]),
                        decoded
                    ]);
                }
                break;
            case 0x05:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x05", "P2SH", "MAINNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUAL
                    ])
                ]);
                break;
            case 0x6f:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0x6f", "P2PKH", "TESTNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_DUP,
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUALVERIFY,
                        $ebab65f303698dab$var$OP_CHECKSIG
                    ])
                ]);
                break;
            case 0xc4:
                if (this.debugger) console.log("[SCRIPT-DETECTION]: ", "0xc4", "P2SH", "TESTNET");
                outputScript = $ebab65f303698dab$require$Buffer.concat([
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_HASH160,
                        0x14
                    ]),
                    decodedHash,
                    new Uint8Array([
                        $ebab65f303698dab$var$OP_EQUAL
                    ])
                ]);
                break;
            default:
                console.log("[SCRIPT DETECTION] error");
        }
        this.debugger && console.log("[OUTPUT_SCRIPT]: ", $ebab65f303698dab$require$Buffer.from(outputScript).toString("hex"));
        const output = {
            script_size: outputScript.length,
            lock_scriptpubkey: $ebab65f303698dab$require$Buffer.from(outputScript).toString("hex"),
            value: valueIn,
            address: address
        };
        this.debugger && console.log("[OUTPUT]: ", output);
        const outputRaw = $ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]);
        //console.log(`[${outputRaw.length}]`,outputRaw.toString('hex'))
        this.vouts.push(outputRaw);
        this.amount = this.longToByteArray(valueIn);
        this.outputScript = Uint8Array.from([
            ...this.amount,
            outputScript.length,
            ...outputScript
        ]);
        this.unsignedtx.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.txtosign.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.signedtx.vouts.push($ebab65f303698dab$require$Buffer.concat([
            $ebab65f303698dab$require$Buffer.from(this.longToByteArray(valueIn)),
            $ebab65f303698dab$require$Buffer.from(new Uint8Array([
                outputScript.length
            ])),
            outputScript
        ]));
        this.outputCount = this.outputCount + 1;
        this.unsignedtx.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        this.txtosign.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        this.signedtx.outputcount = new Uint8Array([
            this.outputCount,
            0x00,
            0x00,
            0x00
        ]);
        return this;
    }
    /**
     * Add witness program
     * @param {*} data 
     * @returns 
     */ addWitness(data) {
        let witness;
        // if data < 75 |--> 0x??
        if ($ebab65f303698dab$require$Buffer.from(data, "hex").length <= 75) {
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    data.length
                ]),
                $ebab65f303698dab$require$Buffer.from(data, "hex")
            ]);
            this.debugger && console.log("[WIT < 75]", data.length, $ebab65f303698dab$require$Buffer.from(data, "hex").length);
        }
        // if data > 75 < 253 |--> 0x4c
        if ($ebab65f303698dab$require$Buffer.from(data, "hex").length > 75 && $ebab65f303698dab$require$Buffer.from(data, "hex").length <= 253) {
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    $ebab65f303698dab$require$Buffer.from(data, "hex").length
                ]),
                $ebab65f303698dab$require$Buffer.from(data, "hex")
            ]);
            this.debugger && console.log("[75 < WIT < 253]", data.length, $ebab65f303698dab$require$Buffer.from(data, "hex").length.toString(16));
        }
        // if data > 253 |--> 0xfd 0xff 0x01
        if ($ebab65f303698dab$require$Buffer.from(data, "hex").length >= 253) {
            //...Buffer.from(Buffer.from(array,'hex').length.toString(16).padStart(4, '0'),'hex').reverse()
            witness = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(data, "hex").length.toString(16).padStart(4, "0"), "hex").reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(data, "hex")
            ]);
            this.debugger && console.log("[WIT > 253]", data.length, $ebab65f303698dab$require$Buffer.from(data, "hex").length.toString(16));
        }
        //const witness = Buffer.concat([Uint8Array.from([data.length]),Buffer.from(data,'hex')])
        //const witness = Buffer.concat([data.length > 75 ? Uint8Array.from([0x4c,Buffer.from(data,'hex').length.toString(16)]):Uint8Array.from([data.length]),Buffer.from(data,'hex')])
        this.debugger && console.log("[WITNESS]: ", $ebab65f303698dab$require$Buffer.from(witness).toString("hex"));
        this.witnessCount = this.witnessCount + 1;
        this.witness.push(...witness);
        //console.log("[FINAL]",Buffer.concat([new Uint8Array([this.witnessCount]), new Uint8Array([witness.length]),witness]))
        return this;
    }
    /**
     * Function used to add and DER encode various signatures with relative public keys
     * @param {*} sig Signature
     * @param {*} pubkey Pubkey
     */ addSignatures(sig, pubkey) {
        this.signatures.push({
            sig: sig,
            pubkey: pubkey
        });
    }
    /**
     * Function used to DER encode a signature
     * @param {*} sig Signature to be DER encoded
     */ encodeSignature(sig) {
        // 0x47 0x30 [total-length] 0x02 [R-length] [R] 0x02 [S-length] [S] [sighash-type] 0x21 [pubkey]
        // Extract R and S -> Check Low S -> Check First Byte if > 0x80
        const order = BigInt("0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141") //Uint8Array.from(Buffer.from("7FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFF5D576E7357A4501DDFE92F46681B20A0",'hex'))
        ;
        const sub = BigInt("0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141") //Uint8Array.from(Buffer.from("FFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141",'hex')) // - S
        ;
        const R = Uint8Array.from($ebab65f303698dab$require$Buffer.from(sig.slice(0, 32)));
        const S = Uint8Array.from($ebab65f303698dab$require$Buffer.from(sig.slice(32, 64)));
        const sToCheck = BigInt(`0x${$ebab65f303698dab$require$Buffer.from(S).toString("hex")}`);
        const Rbyte = R[0];
        const Sbyte = S[0];
        // High or Low S
        const check = sToCheck >= order / BigInt(2) //S >= order/2
        ;
        const sTweaked = check ? $ebab65f303698dab$require$Buffer.from((order - sToCheck).toString(16), "hex") : 0x00;
        //console.log("[S-Tweaked]", sTweaked)
        const STweakedbyte = sTweaked[0];
        //const x = BigInt("115792089237316195423570985008687907852837564279074904382605163141518161494337")
        //const y = BigInt("0xFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFFEBAAEDCE6AF48A03BBFD25E8CD0364141")
        //const test = Buffer.from(S).toString('hex')
        //const z = BigInt("0x3f6a96f81cfad1c97bec2a5921a08e964f85cf5f1207450bd7956c72aadbf448")
        //console.log("??? ", Buffer.from(sig.slice(0,32)))
        //console.log(". . . ", sub)
        //console.log("= = = ", BigInt(`0x${test}`))
        //console.log("* * * ", Buffer.from((sub - sToCheck).toString(16),'hex')) //Buffer.from((sub - sToCheck).toString(16))
        const checkR = Rbyte > 0x7f;
        const checkS = check ? STweakedbyte > 0x7f : Sbyte > 0x7f;
        //const checkSTweaked = STweakedbyte > 0x80
        //const lowS = checkSTweaked ? new Uint8Array([0x00,...sTweaked]) : sTweaked
        //const len = new Uint8Array([0x47])
        const der = new Uint8Array([
            0x30
        ]);
        const a = new Uint8Array([
            0x02
        ]);
        const rlen = checkR ? new Uint8Array([
            R.length + 1
        ]) : new Uint8Array([
            R.length
        ]);
        const r = checkR ? new Uint8Array([
            0x00,
            ...R
        ]) : R;
        const b = new Uint8Array([
            0x02
        ]);
        const slen = check ? checkS ? new Uint8Array([
            sTweaked.length + 1
        ]) : new Uint8Array([
            sTweaked.length
        ]) : checkS ? new Uint8Array([
            S.length + 1
        ]) : new Uint8Array([
            S.length
        ]) //checkS ? new Uint8Array([S.length + 1]) : new Uint8Array([S.length])
        ;
        const s = check ? checkS ? new Uint8Array([
            0x00,
            ...sTweaked
        ]) : sTweaked : checkS ? new Uint8Array([
            0x00,
            ...S
        ]) : S //checkS ? new Uint8Array([0x00,...S]) : S // lowS ???
        ;
        const sighash = this.sighash //new Uint8Array([0x01])
        ;
        const lentot = new Uint8Array([
            a.length + rlen.length + r.length + b.length + slen.length + s.length
        ]);
        const encoded = $ebab65f303698dab$require$Buffer.concat([
            der,
            lentot,
            a,
            rlen,
            r,
            b,
            slen,
            s,
            sighash
        ]);
        if (this.debugger) {
            console.log("{R}", Rbyte, "{S}", Sbyte, 0x7f);
            console.log("[Signature Check]: ", "[S > N/2]:", check, "[R > 0x80]:", checkR, "[S > 0x80]", checkS, $ebab65f303698dab$require$Buffer.from(R).toString("hex"), $ebab65f303698dab$require$Buffer.from(S).toString("hex"), sTweaked, sighash);
            console.log("[DER Canonical]: ", $ebab65f303698dab$require$Buffer.from(encoded).toString("hex"));
        }
        return encoded;
    }
    /**
     * Internal function used to create scripts
     * @param {*} type Script format `p2pk|p2pkh|p2sh`
     * @param {*} data
     * @returns 
     */ scripter(type = "p2sh", data) {
        let dataIn;
        let dataIn2;
        let script;
        let len;
        const op0 = new Uint8Array([
            0x00
        ]);
        const op1 = new Uint8Array([
            0x01
        ]);
        const opDup = new Uint8Array([
            $ebab65f303698dab$var$OP_DUP
        ]);
        const opChecksig = new Uint8Array([
            $ebab65f303698dab$var$OP_CHECKSIG
        ]);
        const opHash160 = new Uint8Array([
            $ebab65f303698dab$var$OP_HASH160
        ]);
        const opEqual = new Uint8Array([
            $ebab65f303698dab$var$OP_EQUAL
        ]);
        const opEqualVerify = new Uint8Array([
            $ebab65f303698dab$var$OP_EQUALVERIFY
        ]);
        switch(type){
            case "p2pk":
                // P2PK | <33 or 65 bytes pubkey> OP_CHECKSIG
                dataIn = $ebab65f303698dab$require$Buffer.from(data, "hex");
                dataIn2 = new Uint8Array($ebab65f303698dab$require$Buffer.from(data, "hex").length);
                dataIn2.set($ebab65f303698dab$require$Buffer.from(data, "hex"));
                script = $ebab65f303698dab$require$Buffer.concat([
                    dataIn2,
                    opChecksig
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2pk]: ", $ebab65f303698dab$require$Buffer.from(script).toString("hex"), "\n");
                return script;
            case "p2ms":
                // P2MS | <M <pubkey1> <pubkey2> N> OP_CHECKMULTISIG
                return;
            case "p2pkh":
                // P2PKH | OP_DUP OP_HASH160 <20 bytes pubkey hash> OP_EQUALVERIFY OP_CHECKSIG
                dataIn = (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(data, "hex"))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    opDup,
                    opHash160,
                    len,
                    dataIn,
                    opEqualVerify,
                    opChecksig
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2pkh]: ", $ebab65f303698dab$require$Buffer.from(script).toString("hex"), "\n");
                return script;
            case "p2sh":
                // P2SH | OP_HASH160 <20 bytes pubkey hash> OP_EQUAL
                dataIn = (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(data, "hex"))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    opHash160,
                    len,
                    dataIn,
                    opEqual
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2sh]: ", $ebab65f303698dab$require$Buffer.from(script).toString("hex"), "\n");
                return script;
            case "p2wpkh":
                // P2WPKH | 0 <20 bytes pubkey hash>
                dataIn = (0, $j5xzM.ripemd160).create().update((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(data, "hex"))).digest();
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op0,
                    len,
                    dataIn
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2wpkh]: ", $ebab65f303698dab$require$Buffer.from(script).toString("hex"), "\n");
                return script;
            case "p2wsh":
                // P2WSH | 0 <32 bytes script hash>
                dataIn = (0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(data, "hex"));
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op0,
                    len,
                    dataIn
                ]);
                this.debugger && console.log("\n[SCRIPTER:p2wsh]: ", $ebab65f303698dab$require$Buffer.from(script).toString("hex"), "\n");
                return script;
            case "p2tr":
                // P2TR | 1 <32 bytes script hash>
                dataIn = (0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(data, "hex"));
                len = new Uint8Array([
                    dataIn.length
                ]);
                script = $ebab65f303698dab$require$Buffer.concat([
                    op1,
                    len,
                    dataIn
                ]);
                return;
            default:
                console.log("No script selected");
        }
    //return Buffer.from(script)
    }
    /**
     * Serialized Unsigned TX
     */ serializeUnsigned() {
        const tmp = [];
        tmp.push(...this.unsignedtx.version);
        //if (this.segwit) {tmp.push(...new Uint8Array([0x00,this.flag]))}
        tmp.push(this.inputCount) //new Uint8Array([0x00])
        ;
        this.unsignedtx.vins.map((buf)=>tmp.push(...buf));
        tmp.push(this.outputCount);
        this.unsignedtx.vouts.map((buf)=>tmp.push(...buf));
        //if (this.segwit) {tmp.push(this.witnessCount)}
        tmp.push(...this.unsignedtx.locktime);
        this.debugger && console.log("[TX Unsigned]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
        return tmp;
    }
    /**
     * Serialize to Sign - include ScriptPubKey from previous utxo for each input ScriptSig's
     * Pass N = Input to Sign , IF SegWit UTXO amount & ScriptCode
     */ serializeToSign(index = 0, utxoAmount = 0, scriptCode = "") {
        const tmp = [];
        tmp.push(...this.txtosign.version);
        tmp.push(this.inputCount);
        this.txtosign.vins.map((buf, i)=>{
            if (index === i) tmp.push(...buf);
        });
        tmp.push(this.outputCount);
        this.txtosign.vouts.map((buf)=>tmp.push(...buf));
        tmp.push(...this.txtosign.locktime);
        tmp.push(...new Uint8Array([
            this.sighash,
            0x00,
            0x00,
            0x00
        ]));
        // SEGWIT
        if (this.segwit) {
            // preimage = version + hash256(inputs) + hash256(sequences) + input + scriptcode + amount + sequence + hash256(outputs) + locktime
            // wtxid = hash256 [nVersion][marker][flag][txins][txouts][witness][nLockTime]
            let ram = [];
            let seq = [];
            let out = [];
            let outs = [];
            const seg = [];
            // versions
            seg.push(...this.txtosign.version);
            // inputs
            this.txtosign.vins.map((buf)=>{
                ram.push(...buf.slice(0, 32));
                ram.push(...buf.slice(32, 36));
                seq.push(...buf.slice(buf.length - 4, buf.length));
            });
            const inputs = (0, $6XnWx.sha256)((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(ram)));
            seg.push(...inputs);
            // sequences
            const sequences = (0, $6XnWx.sha256)((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(seq)));
            seg.push(...sequences);
            // inputs outpoint txid + vout + scriptcode + utxo amount + sequence
            this.txtosign.vins.map((buf, i)=>{
                if (index === i) {
                    out.push(...buf.slice(0, 32));
                    out.push(...buf.slice(32, 36));
                    out.push(...$ebab65f303698dab$require$Buffer.from(scriptCode, "hex"));
                    out.push(...this.longToByteArray(utxoAmount));
                    out.push(...buf.slice(buf.length - 4, buf.length));
                }
            });
            seg.push(...out);
            // outputs
            this.txtosign.vouts.map((buf)=>{
                outs.push(...buf);
            });
            const outputs = (0, $6XnWx.sha256)((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(outs)));
            seg.push(...outputs);
            // locktime
            seg.push(...this.txtosign.locktime);
            // sighash
            seg.push(...new Uint8Array([
                this.sighash,
                0x00,
                0x00,
                0x00
            ]));
            this.debugger && console.log("[TX SEGWIT to SIGN]: ", $ebab65f303698dab$require$Buffer.from(seg).toString("hex"));
            return seg;
        }
        this.debugger && console.log("[TX To SIGN]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
        return tmp;
    }
    /**
     * Serialize to Broadcast - include ScriptSig for each input
     * Pass Redeem Script
     */ serializeSigned(redeemScript = "") {
        const tmp = [];
        tmp.push(...this.signedtx.version);
        tmp.push(this.inputCount);
        this.signedtx.vins.map((buf, i)=>{
            const script = [
                ...this.encodeHex(this.encodeSignature(this.signatures[i].sig)),
                ...this.encodeHex(this.signatures[i].pubkey)
            ];
            tmp.push(...buf, ...this.encodeHex(script), ...this.sequence);
        });
        tmp.push(this.outputCount);
        this.signedtx.vouts.map((buf)=>tmp.push(...buf));
        tmp.push(...this.signedtx.locktime);
        // SEGWIT
        if (this.segwit) {
            const seg = [];
            let ram = [];
            // versions
            seg.push(...this.signedtx.version);
            // FLAG
            seg.push(...new Uint8Array([
                0x00,
                this.flag
            ]));
            // INPUT COUNT
            seg.push(this.inputCount);
            // INPUTS
            this.signedtx.vins.map((buf, i)=>{
                // P2SH-P2WPKH | P2SH-P2WSH | P2WPKH | P2WSH
                const redeemcode = $ebab65f303698dab$require$Buffer.from(redeemScript, "hex");
                seg.push(...buf, ...this.encodeHex(redeemcode), ...this.sequence);
                ram.push(...buf, ...this.encodeHex(redeemcode), ...this.sequence);
            });
            // OUTPUT COUNT 
            seg.push(this.outputCount);
            // OUTPUTS
            this.signedtx.vouts.map((buf)=>seg.push(...buf));
            // WITNESS
            seg.push(this.witnessCount);
            seg.push(...this.witness);
            // LOCKTIME
            seg.push(...this.signedtx.locktime);
            this.debugger && console.log("[TX SEGWIT SIGNED]: ", $ebab65f303698dab$require$Buffer.from(seg).toString("hex"));
            const noseg = Uint8Array.from([
                ...this.version,
                this.inputCount,
                ...ram,
                this.outputCount,
                ...$ebab65f303698dab$require$Buffer.from(...this.signedtx.vouts),
                ...this.locktime
            ]);
            this.txid = (0, $6XnWx.sha256)((0, $6XnWx.sha256)(noseg)).reverse();
            this.wtxid = (0, $6XnWx.sha256)((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(seg))).reverse();
            //console.log("[WTXID]: ", Buffer.from(this.wtxid).toString('hex'))
            //console.log("[SegWit-TXID]: ", Buffer.from(sha256(sha256(this.wtxid)).reverse()).toString('hex'))
            this.size = seg.length;
            this.weight = noseg.length * 4 + (2 + this.witness.length);
            this.vsize = noseg.length + (2 + this.witness.length) / 4;
            this.debugger && console.log("[Size]: ", this.size);
            this.debugger && console.log("[vSize]: ", this.vsize);
            this.debugger && console.log("[Sats/Byte]: ", (this.fee / this.size).toFixed(2));
            this.debugger && console.log("[Sats/vByte]: ", (this.fee / this.vsize).toFixed(2));
            return seg;
        }
        this.debugger && console.log("[TX Signed]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
        this.txid = (0, $6XnWx.sha256)((0, $6XnWx.sha256)($ebab65f303698dab$require$Buffer.from(tmp)));
        this.size = tmp.length;
        this.weight = tmp.length * 4 + (2 + this.witness.length);
        this.vsize = tmp.length + (2 + this.witness.length) / 4;
        this.debugger && console.log("[Size]: ", this.size);
        this.debugger && console.log("[vSize]: ", this.vsize);
        this.debugger && console.log("[Sats/Byte]: ", (this.fee / this.size).toFixed(2));
        this.debugger && console.log("[Sats/vByte]: ", (this.fee / this.vsize).toFixed(2));
        return tmp;
    }
    encodeHex(array) {
        const hex = [
            array.length,
            ...array
        ];
        // toString(16).padStart(4, '0')
        let hex2;
        // if data < 75 bytes |--> data.len
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length <= 75) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    array.length
                ]),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            if (this.debugger) console.log("[DATA < 75]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(2, "0"));
        }
        // if data > 75 < 253 |--> 0xfc
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length > 75 && $ebab65f303698dab$require$Buffer.from(array, "hex").length < 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                //Uint8Array.from([ 0xfc, Buffer.from(array,'hex').length.toString(16)]),
                $ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16), "hex"),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            if (this.debugger) console.log("[75 < DATA < 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16));
        }
        // if data > 253 |--> 0xfd 0x0100 (256bytes) || 0x0802 (520bytes)
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length >= 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(4, "0"), "hex").reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            if (this.debugger) console.log("[DATA > 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(4, "0"));
        }
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length > 520) {
            this.debugger && console.log("[***MAX_LENGTH***]");
            hex2 = [];
        }
        //this.log("encodeHEX", Buffer.from(hex).toString('hex'))
        return hex2;
    }
    decodeHex(array) {
        const length = array.length;
        let ptr = 0;
        let buf = [];
        while(ptr < length){
            const op = array[ptr];
            if (ptr > length) //this.log("PTR","END")
            return;
            if (op === 0x00) //this.log("PTR","0x00")
            return;
            if (op > 0 || op < 0x4c) {
                const tmp = array.slice(ptr + 1, op + 1);
                //this.log("TMP",tmp)
                buf.push(...tmp);
                ptr += op + 1;
            }
        }
        //this.log("decodeHEX", Buffer.from(buf).toString('hex'))
        return buf;
    }
    setFee(fee = 1000) {
        this.fee = fee;
    }
    longToByteArray(/*long*/ long) {
        // we want to represent the input as a 8-bytes array
        var byteArray = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var index = 0; index < byteArray.length; index++){
            var byte = long & 0xff;
            byteArray[index] = byte;
            long = (long - byte) / 256;
        }
        return byteArray;
    }
    convertbits(data, frombits, tobits, pad) {
        var acc = 0;
        var bits = 0;
        var ret = [];
        var maxv = (1 << tobits) - 1;
        for(var p = 0; p < data.length; ++p){
            var value = data[p];
            if (value < 0 || value >> frombits !== 0) return null;
            acc = acc << frombits | value;
            bits += frombits;
            while(bits >= tobits){
                bits -= tobits;
                ret.push(acc >> bits & maxv);
            }
        }
        if (pad) {
            if (bits > 0) ret.push(acc << tobits - bits & maxv);
        } else if (bits >= frombits || acc << tobits - bits & maxv) return null;
        return ret;
    }
    debug() {
        const tx = this;
        console.log("[hash]:", $ebab65f303698dab$require$Buffer.from(this.txid).toString("hex"));
        console.log("[version]:", $ebab65f303698dab$require$Buffer.from(tx.version).toString("hex"));
        console.log("[segwit]:", $ebab65f303698dab$require$Buffer.from(tx.flag).toString("hex"));
        console.log("[vins]:", tx.vins.map((item)=>{
            return $ebab65f303698dab$require$Buffer.from(item).toString("hex");
        }));
        console.log("[inputs]:", tx.inputs.map((item)=>{
            return $ebab65f303698dab$require$Buffer.from(item).toString("hex");
        })) // SegWit
        ;
        console.log("[vouts]:", tx.vouts.map((item)=>$ebab65f303698dab$require$Buffer.from(item).toString("hex")));
        console.log("[locktime]:", $ebab65f303698dab$require$Buffer.from(tx.locktime).toString("hex"));
        console.log("[signature]:", $ebab65f303698dab$require$Buffer.from(this.signature).toString("hex"));
        console.log("[sighash]:", $ebab65f303698dab$require$Buffer.from(this.sighash).toString("hex"));
        console.log("[scriptsig]:", $ebab65f303698dab$require$Buffer.from(this.scriptSig).toString("hex"));
        console.log("[size]:", this.size);
        console.log("[weight]:", this.weight);
        console.log("[vsize]:", this.vsize);
    }
    log(name, data) {
        console.log(`[${name}]: `, data);
    }
}
class $ebab65f303698dab$export$6bc7a366cf543c74 {
    /**
     * <psbt> := <magic> <global-map> <input-map>* <output-map>*
     * <magic> := 0x70 0x73 0x62 0x74 0xFF
     * <global-map> := <keypair>* 0x00
     * <input-map> := <keypair>* 0x00
     * <output-map> := <keypair>* 0x00
     * <keypair> := <key> <value>
     * <key> := <keylen> <keytype> <keydata>
     * <value> := <valuelen> <valuedata>
     * @param {*} version 
     */ constructor(version = 2){
        this.debugger = false;
        // MAGIC BYTES
        this.magic = Uint8Array.from([
            0x70,
            0x73,
            0x62,
            0x74,
            0xFF
        ]);
        // Unsigned Transaction 0x00 (req_v0)
        this.unsignedtx = [
            0x01,
            0x00
        ];
        // Extended Public Keys 0x01
        this.xpub = [
            0x01
        ];
        // Version Unsigned TX
        this.txversion = [
            0x01,
            0x02,
            0x04
        ] //0x02 (req_v2) (no_v0)
        ;
        // Fallback Locktime 0x03 (req_v2) (no_v0)
        this.locktime = [
            0x01,
            0x03,
            0x04
        ];
        // Input Count 0x04 (req_v2) (no_v0)
        this.inCount = [
            0x01,
            0x04,
            0x01
        ];
        //this.inputCount = [0x01,0x04]
        this.icount = 0;
        // Output Count 0x05 (req_v2) (no_v0)
        this.outCount = [
            0x01,
            0x05,
            0x01
        ];
        //this.outputCount = [0x05]
        this.ocount = 0;
        // Transaction Modifiable flag 0x06 (no_v0)
        this.modFlag = [
            0x01,
            0x06,
            0x01
        ];
        // PSBT Version Number 0xfb
        this.version = version;
        this.psbtversion = [
            0x01,
            0xfb,
            0x04,
            ...Uint8Array.from([
                version,
                0x00,
                0x00,
                0x00
            ])
        ] //0xfb
        ;
        // Proprietary Use Type 0xfc
        this.witnessCount = 0;
        this.witnesses = [];
        this.unsignedpsbt = {
            magic: [
                ...this.magic
            ],
            globalMap: [],
            inputMap: [],
            outputMap: []
        };
        this.hex = "";
        this.base64 = "";
    }
    importFromHex(hex) {
        this.hex = hex;
        const buffer = $ebab65f303698dab$require$Buffer.from(hex);
    //console.log("[ImportFromHex]: ", Buffer.from(buffer).toString('hex'))
    }
    importFromBase64(base64) {
        this.base64 = base64;
        const hex = $ebab65f303698dab$require$Buffer.from(base64, "base64");
        this.importFromHex(hex);
    //console.log("[ImportBase64]: ", this.base64)
    }
    addGlobalMap(unsignedTx, version, keyChain) {
        /**
         * <keypair> := <key> <value>
         * <key> := <keylen> <keytype> <keydata>
         * <value> := <valuelen> <valuedata>
         */ const tmp = [];
        const ext = [];
        const end = 0x00;
        // Unsigned Tx <0x00><bytes tx>
        //this.unsignedtx.push(...Uint8Array.from([unsignedTx.length]),...unsignedTx)
        this.unsignedtx.push(...this.encodeHex(unsignedTx));
        tmp.push(...this.unsignedtx);
        //console.info("[Global-UnsignedTX]: ",Buffer.from(this.unsignedtx).toString('hex'))
        // Extended Public Keys <0x01><4byte fgpr><4byte le path>*
        keyChain.length > 0 && keyChain.map((el)=>{
            ext.push(...this.addXpub(el.xpub, el.path, el.fgpr));
        });
        keyChain.length > 0 && tmp.push(...ext);
        // TX Version <0x02><4byte le version>
        if (this.version !== 0) {
            this.txversion.push(...new Uint8Array([
                version,
                0x00,
                0x00,
                0x00
            ]));
            tmp.push(...this.txversion);
        //console.info("[Global-TX-version]: ",Buffer.from(this.txversion).toString('hex'))
        }
        // Fallback Locktime <0x03><4byte le locktime>
        if (this.version !== 0) {
            this.locktime.push(...new Uint8Array([
                0xff,
                0xff,
                0xff,
                0xfd
            ]));
            tmp.push(...this.locktime);
        //console.info("[Global-locktime]: ",Buffer.from(this.locktime).toString('hex'))
        }
        // Input Count <0x04><uint>
        if (this.version !== 0) {
            this.inCount.push(...new Uint8Array([
                this.icount
            ]));
            tmp.push(...this.inCount);
        //console.info("[Global-Input-Count]: ",Buffer.from(this.inCount).toString('hex'))
        }
        // Output Count <0x05><uint>
        if (this.version !== 0) {
            this.outCount.push(...Uint8Array.from([
                this.ocount
            ]));
            tmp.push(...this.outCount);
        //console.info("[Global-Output-Count]: ",Buffer.from(this.outCount).toString('hex'))
        }
        // Transaction Modifiable Flag <0x06><1byte>
        if (this.version !== 0) {
            this.modFlag.push(0x01);
            tmp.push(...this.modFlag);
        //console.info("[Global-Mod-Flag]: ",Buffer.from(this.modFlag).toString('hex'))
        }
        // PSBT Version number <0xfb><4byte le version>
        if (this.version !== 0) tmp.push(...this.psbtversion) // TODO
        ;
        // Separator
        tmp.push(end);
        this.unsignedpsbt.globalMap.push(...tmp);
    //console.log("[GLOBAL-MAP]: ", Buffer.from(tmp).toString('hex'))
    }
    addInput(segwit = false, utxo = "", txid = "", vout = 0, bip32Chain = [], partialSigs = [], redeemScript = "", witnessScript = "", extra = "") {
        /**
         * If Segwit add WITNESS-UTXO amount+out else NON WITNESS-UTXO tx
         */ const tmp = [];
        const end = 0x00;
        // Non WitnessUtxo 0x00
        // WitnessUtxo 0x01
        if (!segwit) {
            const nonWitUtxo = [
                0x01,
                0x00
            ];
            //nonWitUtxo.push(...Uint8Array.from([Buffer.from(utxo,'hex').length]),...Buffer.from(utxo,'hex'))
            nonWitUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(utxo, "hex")));
            tmp.push(...nonWitUtxo);
        } else {
            if (extra.length > 0) {
                const nonWitUtxo = [
                    0x01,
                    0x00
                ];
                //nonWitUtxo.push(...Uint8Array.from([Buffer.from(utxo,'hex').length]),...Buffer.from(utxo,'hex'))
                nonWitUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(extra, "hex")));
                tmp.push(...nonWitUtxo);
            }
            const witUtxo = [
                0x01,
                0x01
            ];
            //witUtxo.push(...Uint8Array.from([Buffer.from(utxo,'hex').length]),...Buffer.from(utxo,'hex'))
            witUtxo.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(utxo, "hex")));
            tmp.push(...witUtxo);
        }
        // Partial Signature 0x02
        if (partialSigs.length > 0) partialSigs.map((el)=>{
            tmp.push(...this.addPartialSig(el.pub, el.sig));
        });
        // Sighash Type 0x03
        // Redeem Script 0x04
        if (redeemScript.length > 0) //this.addRedeemScript("input",redeemScript)
        tmp.push(...this.addRedeemScript("input", redeemScript));
        // Witness Script 0x05
        if (witnessScript.length > 0) {
            //this.addWitnessScript("input",witnessScript)
            tmp.push(...this.addWitnessScript("input", witnessScript));
            //const keytype = Uint8Array.from([0x01,0x05])
            //tmp.push(...keytype)
            //tmp.push(...this.encodeHex(Buffer.from(witnessScript,'hex')))
            this.witnessCount++;
        }
        // Bip32 Derivation Path 0x06
        if (bip32Chain.length > 0) bip32Chain.map((el)=>{
            tmp.push(...this.addBip32("input", el.pub, el.fgpr, el.path));
        });
        // Finalized ScriptSig 0x07
        // Finalized ScriptWitness 0x08
        // POR Commit 0x09
        // Ripemd160 PreImage 0x0a
        // Sha256 PreImage 0x0b
        // Hash160 PreImage 0x0c
        // Hash256 PreImage 0x0d
        // Previous TXID 0x0e (req_v2) (no_v0)
        if (this.version !== 0) {
            const prevTxid = $ebab65f303698dab$require$Buffer.from(txid, "hex");
            const prevtxid = Uint8Array.from([
                0x01,
                0x0e,
                prevTxid.length,
                ...prevTxid
            ]);
            tmp.push(...prevtxid);
        //console.log("[INPUT-PREV-TXID]: ", Buffer.from(prevtxid).toString('hex'))
        }
        // Spent Output Index 0x0f (req_v2) (no_v0)
        if (this.version !== 0) {
            const prevOut = Uint8Array.from([
                0x01,
                0x0f,
                0x04,
                ...Uint8Array.from([
                    vout,
                    0x00,
                    0x00,
                    0x00
                ])
            ]);
            tmp.push(...prevOut);
        //console.log("[INPUT-PREV-VOUT]: ", Buffer.from(prevOut).toString('hex'))
        }
        // Sequence Number 0x10 (no_v0)
        // Locktime TimeBased 0x11 (no_v0)
        // Locktime HeightBased 0x12 (no_v0)
        // Taproot Key Spend Signature 0x13
        // Taproot Script Spend Signature 0x14
        // Taproot Leaf Script 0x15
        // Taproot Key Bip32 Derivation Path 0x16
        // Taproot Internal Key 0x17
        // Taproot Merkle Root 0x18
        // MuSig2 Public Keys 0x1a
        // MuSig2 Public Nonce 0x1b
        // MuSig2 Partial Signature 0x1c
        // Proprietary Use Type 0xfc
        // Separator
        tmp.push(end);
        this.unsignedpsbt.inputMap.push(...tmp);
        //console.log("[INPUT-MAP]: ", Buffer.from(tmp).toString('hex'))
        this.icount++;
    }
    addOutput(amount = 0, outscript = "", bip32Chain = []) {
        const tmp = [];
        const end = 0x00;
        // Redeem Script 0x00
        // Witness Script 0x01
        // Bip32 Derivation Path 0x02
        if (bip32Chain.length > 0) bip32Chain.map((el)=>{
            tmp.push(...this.addBip32("output", el.pub, el.fgpr, el.path));
        });
        // Output Amount 0x03 (req_v2) (no_v0)
        if (this.version !== 0) {
            const outAmount = Uint8Array.from([
                0x01,
                0x03,
                0x08,
                ...this.longToByteArray(amount)
            ]);
            tmp.push(...outAmount);
        //console.log("[OUTPUT-AMOUNT]: ", Buffer.from(outAmount).toString('hex'))
        }
        // Output Script 0x04 (req_v2) (no_v0)
        if (this.version !== 0) {
            const outScript = Uint8Array.from([
                0x01,
                0x04,
                outscript.length,
                ...outscript
            ]);
            tmp.push(...outScript);
        //console.log("[OUTPUT-SCRIPT]: ", Buffer.from(outScript).toString('hex'))
        }
        // Taproot Internal Key 0x05
        // Taproot Tree 0x06
        // Taproot Key Bip32 Derivation Path 0x07
        // MuSig2 Public Keys 0x08
        // Proprietary Use Type 0xfc
        // Separator
        tmp.push(end);
        this.unsignedpsbt.outputMap.push(...tmp);
        //console.log("[OUTPUT-MAP]: ", Buffer.from(tmp).toString('hex'))
        this.ocount++;
    }
    addXpub(data, dpath, mstFgpr) {
        const tmp = [];
        const rawxpub = (0, $3600b4829dff8fa9$export$61f53211c069eefb).decode(data).slice(0, -4);
        //console.log("RAW-XPUB:: ", rawxpub.length, Buffer.from(rawxpub,'hex').toString('hex'))
        const ver = rawxpub.slice(0, 4);
        const depth = rawxpub.slice(4, 5);
        const fgpr = $ebab65f303698dab$require$Buffer.from(mstFgpr, "hex") //rawxpub.slice(5,9)
        ;
        const path = rawxpub.slice(9, 13);
        const code = rawxpub.slice(13, 45);
        const pub = rawxpub.slice(45, 78);
        //console.log("[Decode Xpub]", Buffer.from(ver).toString('hex'),Buffer.from(depth).toString('hex'),Buffer.from(fgpr).toString('hex'),Buffer.from(path).toString('hex'),Buffer.from(code).toString('hex'),Buffer.from(pub).toString('hex'))
        tmp.push(...this.xpub);
        tmp.unshift(rawxpub.length + 1);
        tmp.push(...rawxpub);
        tmp.push(...Uint8Array.from([
            4 * dpath.split("/").length
        ]));
        tmp.push(...fgpr);
        dpath.split("/").map((el, i)=>{
            if (el === "m") return;
            if (el.includes("h")) {
                const x = el.split("h").join();
                const hex = Uint8Array.from([
                    parseInt(x),
                    0x00,
                    0x00,
                    0x80
                ]) //.reverse()
                ;
                //console.log(i,Buffer.from(hex).toString('hex'))
                tmp.push(...hex);
            } else {
                const hex = Uint8Array.from([
                    parseInt(el),
                    0x00,
                    0x00,
                    0x00
                ]) //.reverse()
                ;
                //console.log(i,Buffer.from(hex).toString('hex'))
                tmp.push(...hex);
            }
        });
        //console.log("[GLOBAL-XPUB]:: ", parseInt(depth), Buffer.from(this.xpub,'hex').toString('hex'))
        //console.log("[TMP-XPUB]: ",Buffer.from(tmp).toString('hex'))
        //this.unsignedpsbt.globalMap.push(...tmp)
        return tmp;
    }
    addBip32(mode = "input", pub, fgpr, path) {
        const tmp = [];
        // 0x06
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x22,
                0x06
            ]);
            tmp.push(...keytype);
        }
        // 0x02
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x22,
                0x02
            ]);
            tmp.push(...keytype);
        }
        tmp.push(...$ebab65f303698dab$require$Buffer.from(pub, "hex"));
        tmp.push(...Uint8Array.from([
            4 * path.split("/").length
        ]));
        tmp.push(...$ebab65f303698dab$require$Buffer.from(fgpr, "hex"));
        path.split("/").map((item, i)=>{
            if (item === "m") return;
            if (item.includes("h")) {
                const x = item.split("h").join();
                const hex = Uint8Array.from([
                    parseInt(x),
                    0x00,
                    0x00,
                    0x80
                ]) //.reverse()
                ;
                //console.log(i,Buffer.from(hex).toString('hex'))
                tmp.push(...hex);
            } else {
                const hex = Uint8Array.from([
                    parseInt(item),
                    0x00,
                    0x00,
                    0x00
                ]) //.reverse()
                ;
                //console.log(i,Buffer.from(hex).toString('hex'))
                tmp.push(...hex);
            }
        });
        //console.info("[Bip32]: ", mode,Buffer.from(tmp).toString('hex'))
        return tmp;
    }
    addPartialSig(pub, sig) {
        // 0x02
        const tmp = [];
        tmp.push(...Uint8Array.from([
            0x22,
            0x02,
            ...$ebab65f303698dab$require$Buffer.from(pub, "hex"),
            $ebab65f303698dab$require$Buffer.from(sig, "hex").length,
            ...$ebab65f303698dab$require$Buffer.from(sig, "hex")
        ]));
        //console.info("[PartialSig]: ",Buffer.from(tmp).toString('hex'))
        //this.unsignedpsbt.inputMap.push(...tmp)
        return tmp;
    }
    addRedeemScript(mode = "input", script) {
        const tmp = [];
        // 0x04
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x01,
                0x04
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, "hex")));
            //this.unsignedpsbt.inputMap.push(...tmp)
            return tmp;
        }
        // 0x00
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x01,
                0x00
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, "hex")));
            //this.unsignedpsbt.outputMap.push(...tmp)
            return tmp;
        }
        this.debugger && console.info("[Redeem-Script]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
    }
    addWitnessScript(mode = "input", script) {
        const tmp = [];
        // 0x05
        if (mode === "input") {
            const keytype = Uint8Array.from([
                0x01,
                0x05
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, "hex")));
            //this.unsignedpsbt.inputMap.push(...tmp)
            this.witnessCount++;
            return tmp;
        }
        // 0x01
        if (mode === "output") {
            const keytype = Uint8Array.from([
                0x01,
                0x01
            ]);
            tmp.push(...keytype);
            tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, "hex")));
            //this.unsignedpsbt.outputMap.push(...tmp)
            return tmp;
        }
        this.debugger && console.info("[Witness-Script]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
    }
    addFinalScriptSig(script) {
        const tmp = [];
        // 0x07        
        const keytype = Uint8Array.from([
            0x01,
            0x07
        ]);
        tmp.push(...keytype);
        tmp.push(...this.encodeHex($ebab65f303698dab$require$Buffer.from(script, "hex")));
        this.unsignedpsbt.inputMap.push(...tmp);
        this.debugger && console.info("[Final-ScriptSig]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
    }
    addFinalScriptWitness() {
        const tmp = [];
        const ram = [];
        // 0x08        
        const keytype = Uint8Array.from([
            0x01,
            0x08
        ]);
        tmp.push(...keytype);
        const witCount = Uint8Array.from([
            this.witnessCount
        ]);
        // WITNESS COUNT
        ram.push(...witCount);
        this.witnesses.map((item)=>{
            ram.push(...this.encodeHex(item));
        });
        tmp.push(...this.encodeHex(ram));
        this.unsignedpsbt.inputMap.push(...tmp);
        this.debugger && console.info("[Final-ScriptWitness]: ", $ebab65f303698dab$require$Buffer.from(tmp).toString("hex"));
    }
    serialize() {
        const tmp = [];
        const end = 0x00;
        // Magic Bytes
        tmp.push(...this.unsignedpsbt.magic);
        // Global Map + 0x00
        tmp.push(...this.unsignedpsbt.globalMap);
        //this.unsignedpsbt.globalMap.length > 0 ? tmp.push(...this.unsignedpsbt.globalMap) : tmp.push(end)
        // Input Map + 0x00
        //tmp.push(...this.unsignedpsbt.inputMap)
        this.unsignedpsbt.inputMap.length > 0 ? tmp.push(...this.unsignedpsbt.inputMap) : tmp.push(...this.unsignedpsbt.inputMap, end);
        // Output Map + 0x00
        //tmp.push(...this.unsignedpsbt.outputMap)
        this.unsignedpsbt.outputMap.length > 0 ? tmp.push(...this.unsignedpsbt.outputMap) : tmp.push(...this.unsignedpsbt.outputMap, end);
        this.hex = $ebab65f303698dab$require$Buffer.from(tmp, "hex").toString("hex");
        this.base64 = $ebab65f303698dab$require$Buffer.from(tmp).toString("base64");
        //console.log("[PSBT Unsigned]: ",Buffer.from(tmp).toString('hex'))
        return tmp;
    }
    decode(buf) {
        /**
         * WIP
         * <keyLen> <keyType> <keyData?> <valueLen> <value>
         */ let ptr = 0;
        const bufLen = $ebab65f303698dab$require$Buffer.from(buf, "hex").length;
        console.log("[DECODE]: ", bufLen, $ebab65f303698dab$require$Buffer.from(buf.slice(0, 4)).toString("hex"));
        buf.slice(0, 4).toString("hex");
        if (buf.slice(0, 4).toString("hex") === "70736274") ptr += 5;
        while(ptr < bufLen){
            //ptr += 1
            const read = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                buf[ptr]
            ]), "hex");
            //console.log("[READ]: ",ptr, Buffer.from(read,'hex').toString('hex'))
            try {
                const keyLen = Number(read.toString("hex")) //parseInt(read.toString('hex'),16)
                ;
                ptr += 1;
                const keyType = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    buf[ptr]
                ]), "hex");
                if (keyType > 0x1c) continue;
                const keyData = keyLen > 1 ? $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    ...buf.slice(ptr, ptr + keyLen)
                ]), "hex") : null;
                ptr += keyLen;
                const valueLen = buf[ptr] //parseInt(Buffer.from(Uint8Array.from([buf[ptr]]),'hex').toString('hex'),16)
                ;
                ptr += 1;
                const value = $ebab65f303698dab$require$Buffer.from(Uint8Array.from([
                    ...buf.slice(ptr, ptr + valueLen)
                ]), "hex");
                ptr += valueLen;
                console.log("\n[KeyLen]: ", keyLen);
                console.log("[KeyType]: ", keyType.toString("hex"));
                console.log("[KeyData]: ", keyData);
                console.log("[ValueLen]: ", valueLen);
                console.log("[Value]: ", value.toString("hex"));
            } catch (error) {
                console.log("[ERROR]: psbt decode");
            }
            ptr += 1;
        }
    }
    toHex() {
        return this.hex;
    }
    toBase64() {
        return this.base64;
    }
    encodeHex(array) {
        const hex = [
            array.length,
            ...array
        ];
        // toString(16).padStart(4, '0')
        let hex2;
        // if data < 75 bytes |--> data.len
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length <= 75) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    array.length
                ]),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            this.debugger && console.log("[DATA < 75]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(2, "0"));
        }
        // if data > 75 < 253 |--> 0xfc
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length > 75 && $ebab65f303698dab$require$Buffer.from(array, "hex").length < 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                //Uint8Array.from([ 0xfc, Buffer.from(array,'hex').length.toString(16)]),
                $ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16), "hex"),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            this.debugger && console.log("[75 < DATA < 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16));
        }
        // if data > 253 |--> 0xfd 0x0100 (256bytes) || 0x0802 (520bytes)
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length >= 253) {
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(4, "0"), "hex").reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
            this.debugger && console.log("[DATA > 253]", array.length, $ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(4, "0"));
        }
        if ($ebab65f303698dab$require$Buffer.from(array, "hex").length > 520) {
            this.debugger && console.log("[***MAX_LENGTH***]");
            hex2 = $ebab65f303698dab$require$Buffer.concat([
                Uint8Array.from([
                    0xfd,
                    ...$ebab65f303698dab$require$Buffer.from($ebab65f303698dab$require$Buffer.from(array, "hex").length.toString(16).padStart(4, "0"), "hex").reverse()
                ]),
                $ebab65f303698dab$require$Buffer.from(array, "hex")
            ]);
        //hex2 = []
        }
        //this.log("encodeHEX", Buffer.from(hex2).toString('hex'))
        return hex2;
    }
    decodeHex(array) {
        const length = array.length;
        let ptr = 0;
        let buf = [];
        while(ptr < length){
            const op = array[ptr];
            if (ptr > length) //this.log("PTR","END")
            return;
            if (op === 0x00) //this.log("PTR","0x00")
            return;
            if (op > 0 || op < 0x4c) {
                const tmp = array.slice(ptr + 1, op + 1);
                //this.log("TMP",tmp)
                buf.push(...tmp);
                ptr += op + 1;
            }
        }
        //this.log("decodeHEX", Buffer.from(buf).toString('hex'))
        return buf;
    }
    longToByteArray(long) {
        // we want to represent the input as a 8-bytes array
        var byteArray = [
            0,
            0,
            0,
            0,
            0,
            0,
            0,
            0
        ];
        for(var index = 0; index < byteArray.length; index++){
            var byte = long & 0xff;
            byteArray[index] = byte;
            long = (long - byte) / 256;
        }
        return byteArray;
    }
    debug() {
        console.log("[GlobalMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.globalMap).toString("hex"));
        console.log("[InputMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.inputMap).toString("hex"));
        console.log("[OutputMap]: ", $ebab65f303698dab$require$Buffer.from(this.unsignedpsbt.outputMap).toString("hex"));
        console.log("[HEX]: ", $ebab65f303698dab$require$Buffer.from(this.hex, "hex").toString("hex"));
        console.log("[Base64]: ", this.base64);
    }
}
async function $ebab65f303698dab$var$getInfo(id, url) {
    const api = await new (0, $c2ab48eaa2792f66$export$2e2bcd8739ae039)(id, url).get();
    return api;
}
const $ebab65f303698dab$var$main = async (type = "p2sh", online = false, test = false)=>{
    console.log("* * * BTC TX Builder * * *");
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    await wallet.importPrivateKey($ebab65f303698dab$require$Buffer.from("F000000000000000000000000000000000000000000000000000000000000001", "hex")) // privateKey rawhex
    ;
    const address = await wallet.getAddress(type) // true for QRcode export
    ;
    const pubKey = await wallet.getPublicKey();
    //console.log(`[ADDRESS-${type}]: `,address)
    await wallet.sign(pubKey);
    let _txid = "";
    let _pubkey = $ebab65f303698dab$require$Buffer.from(pubKey).toString("hex");
    let _amount = 5001;
    let _to = address;
    let _wit = "00";
    if (online) {
        const testnet = test ? "testnet/" : "";
        try {
            //balance
            const status = await wallet.getApi("status", `https://mempool.space/${testnet}api/address/${address}`);
            //txs
            const txs = await wallet.getApi("utxo", `https://mempool.space/${testnet}api/address/${address}/txs`);
            //utxo
            const utxo = await wallet.getApi("txs", `https://mempool.space/${testnet}api/address/${address}/utxo`);
            //block
            const block = await wallet.getApi("block", `https://mempool.space/${testnet}api/blocks/tip/height`);
            //price
            const price = await wallet.getApi("price", `https://mempool.space/api/v1/prices`);
            //
            //const broadcast = https://mempool.space/testnet/api/tx //POST
            /*
            console.log("[STATUS]: ", status)
            console.log("[UTXO]: ", utxo)
            console.log("[TXS]: ", txs)
            console.log("[BLOCK]: ", block)
            console.log("[PRICE]: ", price)
            */ _txid = txs[0].txid;
        } catch (error) {
            console.log("[API] error: ", error);
        }
    }
    const tx = new $ebab65f303698dab$export$fce14c253806ce6d("testnet", 1, false);
    /**
     * -in txid + script pubkey hash
     * -out amount + address
     */ const serializedTx = tx.createInput(_txid, _pubkey).createOutput(_amount, _to)//.addWitness(_wit)
    .serialize();
    //tx.debug()
    //console.log(tx)
    console.log("==================");
    console.log(serializedTx);
    console.log("==================");
    const signature = await wallet.sign(serializedTx);
//console.log("[SIGNATURE]: ", signature)
//console.log(wallet)
} /*
await main("p2sh-test",true,true) // address type, online, testnet
.then(()=>process.exit(0))
.catch((error)=>{
    console.error(error)
    process.exit(1)
})
*/ ;


"use strict";
function $e5cb5cefd6507f7e$export$2e2bcd8739ae039(fn, thisArg) {
    return function wrap() {
        return fn.apply(thisArg, arguments);
    };
}



var $hPtJY = parcelRequire("hPtJY");
"use strict";
// utils is a library of generic helper functions non-specific to axios
const { toString: $c319b2c832c2914a$var$toString } = Object.prototype;
const { getPrototypeOf: $c319b2c832c2914a$var$getPrototypeOf } = Object;
const $c319b2c832c2914a$var$kindOf = ((cache)=>(thing)=>{
        const str = $c319b2c832c2914a$var$toString.call(thing);
        return cache[str] || (cache[str] = str.slice(8, -1).toLowerCase());
    })(Object.create(null));
const $c319b2c832c2914a$var$kindOfTest = (type)=>{
    type = type.toLowerCase();
    return (thing)=>$c319b2c832c2914a$var$kindOf(thing) === type;
};
const $c319b2c832c2914a$var$typeOfTest = (type)=>(thing)=>typeof thing === type;
/**
 * Determine if a value is an Array
 *
 * @param {Object} val The value to test
 *
 * @returns {boolean} True if value is an Array, otherwise false
 */ const { isArray: $c319b2c832c2914a$var$isArray } = Array;
/**
 * Determine if a value is undefined
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if the value is undefined, otherwise false
 */ const $c319b2c832c2914a$var$isUndefined = $c319b2c832c2914a$var$typeOfTest("undefined");
/**
 * Determine if a value is a Buffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Buffer, otherwise false
 */ function $c319b2c832c2914a$var$isBuffer(val) {
    return val !== null && !$c319b2c832c2914a$var$isUndefined(val) && val.constructor !== null && !$c319b2c832c2914a$var$isUndefined(val.constructor) && $c319b2c832c2914a$var$isFunction(val.constructor.isBuffer) && val.constructor.isBuffer(val);
}
/**
 * Determine if a value is an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is an ArrayBuffer, otherwise false
 */ const $c319b2c832c2914a$var$isArrayBuffer = $c319b2c832c2914a$var$kindOfTest("ArrayBuffer");
/**
 * Determine if a value is a view on an ArrayBuffer
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a view on an ArrayBuffer, otherwise false
 */ function $c319b2c832c2914a$var$isArrayBufferView(val) {
    let result;
    if (typeof ArrayBuffer !== "undefined" && ArrayBuffer.isView) result = ArrayBuffer.isView(val);
    else result = val && val.buffer && $c319b2c832c2914a$var$isArrayBuffer(val.buffer);
    return result;
}
/**
 * Determine if a value is a String
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a String, otherwise false
 */ const $c319b2c832c2914a$var$isString = $c319b2c832c2914a$var$typeOfTest("string");
/**
 * Determine if a value is a Function
 *
 * @param {*} val The value to test
 * @returns {boolean} True if value is a Function, otherwise false
 */ const $c319b2c832c2914a$var$isFunction = $c319b2c832c2914a$var$typeOfTest("function");
/**
 * Determine if a value is a Number
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Number, otherwise false
 */ const $c319b2c832c2914a$var$isNumber = $c319b2c832c2914a$var$typeOfTest("number");
/**
 * Determine if a value is an Object
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an Object, otherwise false
 */ const $c319b2c832c2914a$var$isObject = (thing)=>thing !== null && typeof thing === "object";
/**
 * Determine if a value is a Boolean
 *
 * @param {*} thing The value to test
 * @returns {boolean} True if value is a Boolean, otherwise false
 */ const $c319b2c832c2914a$var$isBoolean = (thing)=>thing === true || thing === false;
/**
 * Determine if a value is a plain Object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a plain Object, otherwise false
 */ const $c319b2c832c2914a$var$isPlainObject = (val)=>{
    if ($c319b2c832c2914a$var$kindOf(val) !== "object") return false;
    const prototype = $c319b2c832c2914a$var$getPrototypeOf(val);
    return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in val) && !(Symbol.iterator in val);
};
/**
 * Determine if a value is a Date
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Date, otherwise false
 */ const $c319b2c832c2914a$var$isDate = $c319b2c832c2914a$var$kindOfTest("Date");
/**
 * Determine if a value is a File
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFile = $c319b2c832c2914a$var$kindOfTest("File");
/**
 * Determine if a value is a Blob
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Blob, otherwise false
 */ const $c319b2c832c2914a$var$isBlob = $c319b2c832c2914a$var$kindOfTest("Blob");
/**
 * Determine if a value is a FileList
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a File, otherwise false
 */ const $c319b2c832c2914a$var$isFileList = $c319b2c832c2914a$var$kindOfTest("FileList");
/**
 * Determine if a value is a Stream
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a Stream, otherwise false
 */ const $c319b2c832c2914a$var$isStream = (val)=>$c319b2c832c2914a$var$isObject(val) && $c319b2c832c2914a$var$isFunction(val.pipe);
/**
 * Determine if a value is a FormData
 *
 * @param {*} thing The value to test
 *
 * @returns {boolean} True if value is an FormData, otherwise false
 */ const $c319b2c832c2914a$var$isFormData = (thing)=>{
    let kind;
    return thing && (typeof FormData === "function" && thing instanceof FormData || $c319b2c832c2914a$var$isFunction(thing.append) && ((kind = $c319b2c832c2914a$var$kindOf(thing)) === "formdata" || // detect form-data instance
    kind === "object" && $c319b2c832c2914a$var$isFunction(thing.toString) && thing.toString() === "[object FormData]"));
};
/**
 * Determine if a value is a URLSearchParams object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a URLSearchParams object, otherwise false
 */ const $c319b2c832c2914a$var$isURLSearchParams = $c319b2c832c2914a$var$kindOfTest("URLSearchParams");
const [$c319b2c832c2914a$var$isReadableStream, $c319b2c832c2914a$var$isRequest, $c319b2c832c2914a$var$isResponse, $c319b2c832c2914a$var$isHeaders] = [
    "ReadableStream",
    "Request",
    "Response",
    "Headers"
].map($c319b2c832c2914a$var$kindOfTest);
/**
 * Trim excess whitespace off the beginning and end of a string
 *
 * @param {String} str The String to trim
 *
 * @returns {String} The String freed of excess whitespace
 */ const $c319b2c832c2914a$var$trim = (str)=>str.trim ? str.trim() : str.replace(/^[\s\uFEFF\xA0]+|[\s\uFEFF\xA0]+$/g, "");
/**
 * Iterate over an Array or an Object invoking a function for each item.
 *
 * If `obj` is an Array callback will be called passing
 * the value, index, and complete array for each item.
 *
 * If 'obj' is an Object callback will be called passing
 * the value, key, and complete object for each property.
 *
 * @param {Object|Array} obj The object to iterate
 * @param {Function} fn The callback to invoke for each item
 *
 * @param {Boolean} [allOwnKeys = false]
 * @returns {any}
 */ function $c319b2c832c2914a$var$forEach(obj, fn, { allOwnKeys: allOwnKeys = false } = {}) {
    // Don't bother if no value provided
    if (obj === null || typeof obj === "undefined") return;
    let i;
    let l;
    // Force an array if not already something iterable
    if (typeof obj !== "object") /*eslint no-param-reassign:0*/ obj = [
        obj
    ];
    if ($c319b2c832c2914a$var$isArray(obj)) // Iterate over array values
    for(i = 0, l = obj.length; i < l; i++)fn.call(null, obj[i], i, obj);
    else {
        // Iterate over object keys
        const keys = allOwnKeys ? Object.getOwnPropertyNames(obj) : Object.keys(obj);
        const len = keys.length;
        let key;
        for(i = 0; i < len; i++){
            key = keys[i];
            fn.call(null, obj[key], key, obj);
        }
    }
}
function $c319b2c832c2914a$var$findKey(obj, key) {
    key = key.toLowerCase();
    const keys = Object.keys(obj);
    let i = keys.length;
    let _key;
    while(i-- > 0){
        _key = keys[i];
        if (key === _key.toLowerCase()) return _key;
    }
    return null;
}
const $c319b2c832c2914a$var$_global = (()=>{
    /*eslint no-undef:0*/ if (typeof globalThis !== "undefined") return globalThis;
    return typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : $parcel$global;
})();
const $c319b2c832c2914a$var$isContextDefined = (context)=>!$c319b2c832c2914a$var$isUndefined(context) && context !== $c319b2c832c2914a$var$_global;
/**
 * Accepts varargs expecting each argument to be an object, then
 * immutably merges the properties of each object and returns result.
 *
 * When multiple objects contain the same key the later object in
 * the arguments list will take precedence.
 *
 * Example:
 *
 * ```js
 * var result = merge({foo: 123}, {foo: 456});
 * console.log(result.foo); // outputs 456
 * ```
 *
 * @param {Object} obj1 Object to merge
 *
 * @returns {Object} Result of all merge properties
 */ function $c319b2c832c2914a$var$merge() {
    const { caseless: caseless } = $c319b2c832c2914a$var$isContextDefined(this) && this || {};
    const result = {};
    const assignValue = (val, key)=>{
        const targetKey = caseless && $c319b2c832c2914a$var$findKey(result, key) || key;
        if ($c319b2c832c2914a$var$isPlainObject(result[targetKey]) && $c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge(result[targetKey], val);
        else if ($c319b2c832c2914a$var$isPlainObject(val)) result[targetKey] = $c319b2c832c2914a$var$merge({}, val);
        else if ($c319b2c832c2914a$var$isArray(val)) result[targetKey] = val.slice();
        else result[targetKey] = val;
    };
    for(let i = 0, l = arguments.length; i < l; i++)arguments[i] && $c319b2c832c2914a$var$forEach(arguments[i], assignValue);
    return result;
}
/**
 * Extends object a by mutably adding to it the properties of object b.
 *
 * @param {Object} a The object to be extended
 * @param {Object} b The object to copy properties from
 * @param {Object} thisArg The object to bind function to
 *
 * @param {Boolean} [allOwnKeys]
 * @returns {Object} The resulting value of object a
 */ const $c319b2c832c2914a$var$extend = (a, b, thisArg, { allOwnKeys: allOwnKeys } = {})=>{
    $c319b2c832c2914a$var$forEach(b, (val, key)=>{
        if (thisArg && $c319b2c832c2914a$var$isFunction(val)) a[key] = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)(val, thisArg);
        else a[key] = val;
    }, {
        allOwnKeys: allOwnKeys
    });
    return a;
};
/**
 * Remove byte order marker. This catches EF BB BF (the UTF-8 BOM)
 *
 * @param {string} content with BOM
 *
 * @returns {string} content value without BOM
 */ const $c319b2c832c2914a$var$stripBOM = (content)=>{
    if (content.charCodeAt(0) === 0xFEFF) content = content.slice(1);
    return content;
};
/**
 * Inherit the prototype methods from one constructor into another
 * @param {function} constructor
 * @param {function} superConstructor
 * @param {object} [props]
 * @param {object} [descriptors]
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$inherits = (constructor, superConstructor, props, descriptors)=>{
    constructor.prototype = Object.create(superConstructor.prototype, descriptors);
    constructor.prototype.constructor = constructor;
    Object.defineProperty(constructor, "super", {
        value: superConstructor.prototype
    });
    props && Object.assign(constructor.prototype, props);
};
/**
 * Resolve object with deep prototype chain to a flat object
 * @param {Object} sourceObj source object
 * @param {Object} [destObj]
 * @param {Function|Boolean} [filter]
 * @param {Function} [propFilter]
 *
 * @returns {Object}
 */ const $c319b2c832c2914a$var$toFlatObject = (sourceObj, destObj, filter, propFilter)=>{
    let props;
    let i;
    let prop;
    const merged = {};
    destObj = destObj || {};
    // eslint-disable-next-line no-eq-null,eqeqeq
    if (sourceObj == null) return destObj;
    do {
        props = Object.getOwnPropertyNames(sourceObj);
        i = props.length;
        while(i-- > 0){
            prop = props[i];
            if ((!propFilter || propFilter(prop, sourceObj, destObj)) && !merged[prop]) {
                destObj[prop] = sourceObj[prop];
                merged[prop] = true;
            }
        }
        sourceObj = filter !== false && $c319b2c832c2914a$var$getPrototypeOf(sourceObj);
    }while (sourceObj && (!filter || filter(sourceObj, destObj)) && sourceObj !== Object.prototype);
    return destObj;
};
/**
 * Determines whether a string ends with the characters of a specified string
 *
 * @param {String} str
 * @param {String} searchString
 * @param {Number} [position= 0]
 *
 * @returns {boolean}
 */ const $c319b2c832c2914a$var$endsWith = (str, searchString, position)=>{
    str = String(str);
    if (position === undefined || position > str.length) position = str.length;
    position -= searchString.length;
    const lastIndex = str.indexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
/**
 * Returns new array from array like object or null if failed
 *
 * @param {*} [thing]
 *
 * @returns {?Array}
 */ const $c319b2c832c2914a$var$toArray = (thing)=>{
    if (!thing) return null;
    if ($c319b2c832c2914a$var$isArray(thing)) return thing;
    let i = thing.length;
    if (!$c319b2c832c2914a$var$isNumber(i)) return null;
    const arr = new Array(i);
    while(i-- > 0)arr[i] = thing[i];
    return arr;
};
/**
 * Checking if the Uint8Array exists and if it does, it returns a function that checks if the
 * thing passed in is an instance of Uint8Array
 *
 * @param {TypedArray}
 *
 * @returns {Array}
 */ // eslint-disable-next-line func-names
const $c319b2c832c2914a$var$isTypedArray = ((TypedArray)=>{
    // eslint-disable-next-line func-names
    return (thing)=>{
        return TypedArray && thing instanceof TypedArray;
    };
})(typeof Uint8Array !== "undefined" && $c319b2c832c2914a$var$getPrototypeOf(Uint8Array));
/**
 * For each entry in the object, call the function with the key and value.
 *
 * @param {Object<any, any>} obj - The object to iterate over.
 * @param {Function} fn - The function to call for each entry.
 *
 * @returns {void}
 */ const $c319b2c832c2914a$var$forEachEntry = (obj, fn)=>{
    const generator = obj && obj[Symbol.iterator];
    const iterator = generator.call(obj);
    let result;
    while((result = iterator.next()) && !result.done){
        const pair = result.value;
        fn.call(obj, pair[0], pair[1]);
    }
};
/**
 * It takes a regular expression and a string, and returns an array of all the matches
 *
 * @param {string} regExp - The regular expression to match against.
 * @param {string} str - The string to search.
 *
 * @returns {Array<boolean>}
 */ const $c319b2c832c2914a$var$matchAll = (regExp, str)=>{
    let matches;
    const arr = [];
    while((matches = regExp.exec(str)) !== null)arr.push(matches);
    return arr;
};
/* Checking if the kindOfTest function returns true when passed an HTMLFormElement. */ const $c319b2c832c2914a$var$isHTMLForm = $c319b2c832c2914a$var$kindOfTest("HTMLFormElement");
const $c319b2c832c2914a$var$toCamelCase = (str)=>{
    return str.toLowerCase().replace(/[-_\s]([a-z\d])(\w*)/g, function replacer(m, p1, p2) {
        return p1.toUpperCase() + p2;
    });
};
/* Creating a function that will check if an object has a property. */ const $c319b2c832c2914a$var$hasOwnProperty = (({ hasOwnProperty: hasOwnProperty })=>(obj, prop)=>hasOwnProperty.call(obj, prop))(Object.prototype);
/**
 * Determine if a value is a RegExp object
 *
 * @param {*} val The value to test
 *
 * @returns {boolean} True if value is a RegExp object, otherwise false
 */ const $c319b2c832c2914a$var$isRegExp = $c319b2c832c2914a$var$kindOfTest("RegExp");
const $c319b2c832c2914a$var$reduceDescriptors = (obj, reducer)=>{
    const descriptors = Object.getOwnPropertyDescriptors(obj);
    const reducedDescriptors = {};
    $c319b2c832c2914a$var$forEach(descriptors, (descriptor, name)=>{
        let ret;
        if ((ret = reducer(descriptor, name, obj)) !== false) reducedDescriptors[name] = ret || descriptor;
    });
    Object.defineProperties(obj, reducedDescriptors);
};
/**
 * Makes all methods read-only
 * @param {Object} obj
 */ const $c319b2c832c2914a$var$freezeMethods = (obj)=>{
    $c319b2c832c2914a$var$reduceDescriptors(obj, (descriptor, name)=>{
        // skip restricted props in strict mode
        if ($c319b2c832c2914a$var$isFunction(obj) && [
            "arguments",
            "caller",
            "callee"
        ].indexOf(name) !== -1) return false;
        const value = obj[name];
        if (!$c319b2c832c2914a$var$isFunction(value)) return;
        descriptor.enumerable = false;
        if ("writable" in descriptor) {
            descriptor.writable = false;
            return;
        }
        if (!descriptor.set) descriptor.set = ()=>{
            throw Error("Can not rewrite read-only method '" + name + "'");
        };
    });
};
const $c319b2c832c2914a$var$toObjectSet = (arrayOrString, delimiter)=>{
    const obj = {};
    const define = (arr)=>{
        arr.forEach((value)=>{
            obj[value] = true;
        });
    };
    $c319b2c832c2914a$var$isArray(arrayOrString) ? define(arrayOrString) : define(String(arrayOrString).split(delimiter));
    return obj;
};
const $c319b2c832c2914a$var$noop = ()=>{};
const $c319b2c832c2914a$var$toFiniteNumber = (value, defaultValue)=>{
    return value != null && Number.isFinite(value = +value) ? value : defaultValue;
};
/**
 * If the thing is a FormData object, return true, otherwise return false.
 *
 * @param {unknown} thing - The thing to check.
 *
 * @returns {boolean}
 */ function $c319b2c832c2914a$var$isSpecCompliantForm(thing) {
    return !!(thing && $c319b2c832c2914a$var$isFunction(thing.append) && thing[Symbol.toStringTag] === "FormData" && thing[Symbol.iterator]);
}
const $c319b2c832c2914a$var$toJSONObject = (obj)=>{
    const stack = new Array(10);
    const visit = (source, i)=>{
        if ($c319b2c832c2914a$var$isObject(source)) {
            if (stack.indexOf(source) >= 0) return;
            if (!("toJSON" in source)) {
                stack[i] = source;
                const target = $c319b2c832c2914a$var$isArray(source) ? [] : {};
                $c319b2c832c2914a$var$forEach(source, (value, key)=>{
                    const reducedValue = visit(value, i + 1);
                    !$c319b2c832c2914a$var$isUndefined(reducedValue) && (target[key] = reducedValue);
                });
                stack[i] = undefined;
                return target;
            }
        }
        return source;
    };
    return visit(obj, 0);
};
const $c319b2c832c2914a$var$isAsyncFn = $c319b2c832c2914a$var$kindOfTest("AsyncFunction");
const $c319b2c832c2914a$var$isThenable = (thing)=>thing && ($c319b2c832c2914a$var$isObject(thing) || $c319b2c832c2914a$var$isFunction(thing)) && $c319b2c832c2914a$var$isFunction(thing.then) && $c319b2c832c2914a$var$isFunction(thing.catch);
// original code
// https://github.com/DigitalBrainJS/AxiosPromise/blob/16deab13710ec09779922131f3fa5954320f83ab/lib/utils.js#L11-L34
const $c319b2c832c2914a$var$_setImmediate = ((setImmediateSupported, postMessageSupported)=>{
    if (setImmediateSupported) return setImmediate;
    return postMessageSupported ? ((token, callbacks)=>{
        $c319b2c832c2914a$var$_global.addEventListener("message", ({ source: source, data: data })=>{
            if (source === $c319b2c832c2914a$var$_global && data === token) callbacks.length && callbacks.shift()();
        }, false);
        return (cb)=>{
            callbacks.push(cb);
            $c319b2c832c2914a$var$_global.postMessage(token, "*");
        };
    })(`axios@${Math.random()}`, []) : (cb)=>setTimeout(cb);
})(typeof setImmediate === "function", $c319b2c832c2914a$var$isFunction($c319b2c832c2914a$var$_global.postMessage));
const $c319b2c832c2914a$var$asap = typeof queueMicrotask !== "undefined" ? queueMicrotask.bind($c319b2c832c2914a$var$_global) : typeof $hPtJY !== "undefined" && $hPtJY.nextTick || $c319b2c832c2914a$var$_setImmediate;
var // *********************
$c319b2c832c2914a$export$2e2bcd8739ae039 = {
    isArray: $c319b2c832c2914a$var$isArray,
    isArrayBuffer: $c319b2c832c2914a$var$isArrayBuffer,
    isBuffer: $c319b2c832c2914a$var$isBuffer,
    isFormData: $c319b2c832c2914a$var$isFormData,
    isArrayBufferView: $c319b2c832c2914a$var$isArrayBufferView,
    isString: $c319b2c832c2914a$var$isString,
    isNumber: $c319b2c832c2914a$var$isNumber,
    isBoolean: $c319b2c832c2914a$var$isBoolean,
    isObject: $c319b2c832c2914a$var$isObject,
    isPlainObject: $c319b2c832c2914a$var$isPlainObject,
    isReadableStream: $c319b2c832c2914a$var$isReadableStream,
    isRequest: $c319b2c832c2914a$var$isRequest,
    isResponse: $c319b2c832c2914a$var$isResponse,
    isHeaders: $c319b2c832c2914a$var$isHeaders,
    isUndefined: $c319b2c832c2914a$var$isUndefined,
    isDate: $c319b2c832c2914a$var$isDate,
    isFile: $c319b2c832c2914a$var$isFile,
    isBlob: $c319b2c832c2914a$var$isBlob,
    isRegExp: $c319b2c832c2914a$var$isRegExp,
    isFunction: $c319b2c832c2914a$var$isFunction,
    isStream: $c319b2c832c2914a$var$isStream,
    isURLSearchParams: $c319b2c832c2914a$var$isURLSearchParams,
    isTypedArray: $c319b2c832c2914a$var$isTypedArray,
    isFileList: $c319b2c832c2914a$var$isFileList,
    forEach: $c319b2c832c2914a$var$forEach,
    merge: $c319b2c832c2914a$var$merge,
    extend: $c319b2c832c2914a$var$extend,
    trim: $c319b2c832c2914a$var$trim,
    stripBOM: $c319b2c832c2914a$var$stripBOM,
    inherits: $c319b2c832c2914a$var$inherits,
    toFlatObject: $c319b2c832c2914a$var$toFlatObject,
    kindOf: $c319b2c832c2914a$var$kindOf,
    kindOfTest: $c319b2c832c2914a$var$kindOfTest,
    endsWith: $c319b2c832c2914a$var$endsWith,
    toArray: $c319b2c832c2914a$var$toArray,
    forEachEntry: $c319b2c832c2914a$var$forEachEntry,
    matchAll: $c319b2c832c2914a$var$matchAll,
    isHTMLForm: $c319b2c832c2914a$var$isHTMLForm,
    hasOwnProperty: $c319b2c832c2914a$var$hasOwnProperty,
    hasOwnProp: $c319b2c832c2914a$var$hasOwnProperty,
    reduceDescriptors: $c319b2c832c2914a$var$reduceDescriptors,
    freezeMethods: $c319b2c832c2914a$var$freezeMethods,
    toObjectSet: $c319b2c832c2914a$var$toObjectSet,
    toCamelCase: $c319b2c832c2914a$var$toCamelCase,
    noop: $c319b2c832c2914a$var$noop,
    toFiniteNumber: $c319b2c832c2914a$var$toFiniteNumber,
    findKey: $c319b2c832c2914a$var$findKey,
    global: $c319b2c832c2914a$var$_global,
    isContextDefined: $c319b2c832c2914a$var$isContextDefined,
    isSpecCompliantForm: $c319b2c832c2914a$var$isSpecCompliantForm,
    toJSONObject: $c319b2c832c2914a$var$toJSONObject,
    isAsyncFn: $c319b2c832c2914a$var$isAsyncFn,
    isThenable: $c319b2c832c2914a$var$isThenable,
    setImmediate: $c319b2c832c2914a$var$_setImmediate,
    asap: $c319b2c832c2914a$var$asap
};







"use strict";
/**
 * Create an Error with the specified message, config, error code, request and response.
 *
 * @param {string} message The error message.
 * @param {string} [code] The error code (for example, 'ECONNABORTED').
 * @param {Object} [config] The config.
 * @param {Object} [request] The request.
 * @param {Object} [response] The response.
 *
 * @returns {Error} The created error.
 */ function $4e2395edb77acf3a$var$AxiosError(message, code, config, request, response) {
    Error.call(this);
    if (Error.captureStackTrace) Error.captureStackTrace(this, this.constructor);
    else this.stack = new Error().stack;
    this.message = message;
    this.name = "AxiosError";
    code && (this.code = code);
    config && (this.config = config);
    request && (this.request = request);
    if (response) {
        this.response = response;
        this.status = response.status ? response.status : null;
    }
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($4e2395edb77acf3a$var$AxiosError, Error, {
    toJSON: function toJSON() {
        return {
            // Standard
            message: this.message,
            name: this.name,
            // Microsoft
            description: this.description,
            number: this.number,
            // Mozilla
            fileName: this.fileName,
            lineNumber: this.lineNumber,
            columnNumber: this.columnNumber,
            stack: this.stack,
            // Axios
            config: (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toJSONObject(this.config),
            code: this.code,
            status: this.status
        };
    }
});
const $4e2395edb77acf3a$var$prototype = $4e2395edb77acf3a$var$AxiosError.prototype;
const $4e2395edb77acf3a$var$descriptors = {};
[
    "ERR_BAD_OPTION_VALUE",
    "ERR_BAD_OPTION",
    "ECONNABORTED",
    "ETIMEDOUT",
    "ERR_NETWORK",
    "ERR_FR_TOO_MANY_REDIRECTS",
    "ERR_DEPRECATED",
    "ERR_BAD_RESPONSE",
    "ERR_BAD_REQUEST",
    "ERR_CANCELED",
    "ERR_NOT_SUPPORT",
    "ERR_INVALID_URL"
].forEach((code)=>{
    $4e2395edb77acf3a$var$descriptors[code] = {
        value: code
    };
});
Object.defineProperties($4e2395edb77acf3a$var$AxiosError, $4e2395edb77acf3a$var$descriptors);
Object.defineProperty($4e2395edb77acf3a$var$prototype, "isAxiosError", {
    value: true
});
// eslint-disable-next-line func-names
$4e2395edb77acf3a$var$AxiosError.from = (error, code, config, request, response, customProps)=>{
    const axiosError = Object.create($4e2395edb77acf3a$var$prototype);
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(error, axiosError, function filter(obj) {
        return obj !== Error.prototype;
    }, (prop)=>{
        return prop !== "isAxiosError";
    });
    $4e2395edb77acf3a$var$AxiosError.call(axiosError, error.message, code, config, request, response);
    axiosError.cause = error;
    axiosError.name = error.name;
    customProps && Object.assign(axiosError, customProps);
    return axiosError;
};
var $4e2395edb77acf3a$export$2e2bcd8739ae039 = $4e2395edb77acf3a$var$AxiosError;


// eslint-disable-next-line strict
var $4023ac50ad132196$export$2e2bcd8739ae039 = null;



var $6ZWSX = parcelRequire("6ZWSX");
var $e6cbd383b18c9625$require$Buffer = $6ZWSX.Buffer;
"use strict";
/**
 * Determines if the given thing is a array or js object.
 *
 * @param {string} thing - The object or array to be visited.
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isVisitable(thing) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(thing) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(thing);
}
/**
 * It removes the brackets from the end of a string
 *
 * @param {string} key - The key of the parameter.
 *
 * @returns {string} the key without the brackets.
 */ function $e6cbd383b18c9625$var$removeBrackets(key) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]") ? key.slice(0, -2) : key;
}
/**
 * It takes a path, a key, and a boolean, and returns a string
 *
 * @param {string} path - The path to the current key.
 * @param {string} key - The key of the current object being iterated over.
 * @param {string} dots - If true, the key will be rendered with dots instead of brackets.
 *
 * @returns {string} The path to the current key.
 */ function $e6cbd383b18c9625$var$renderKey(path, key, dots) {
    if (!path) return key;
    return path.concat(key).map(function each(token, i) {
        // eslint-disable-next-line no-param-reassign
        token = $e6cbd383b18c9625$var$removeBrackets(token);
        return !dots && i ? "[" + token + "]" : token;
    }).join(dots ? "." : "");
}
/**
 * If the array is an array and none of its elements are visitable, then it's a flat array.
 *
 * @param {Array<any>} arr - The array to check
 *
 * @returns {boolean}
 */ function $e6cbd383b18c9625$var$isFlatArray(arr) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(arr) && !arr.some($e6cbd383b18c9625$var$isVisitable);
}
const $e6cbd383b18c9625$var$predicates = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject((0, $c319b2c832c2914a$export$2e2bcd8739ae039), {}, null, function filter(prop) {
    return /^is[A-Z]/.test(prop);
});
/**
 * Convert a data object to FormData
 *
 * @param {Object} obj
 * @param {?Object} [formData]
 * @param {?Object} [options]
 * @param {Function} [options.visitor]
 * @param {Boolean} [options.metaTokens = true]
 * @param {Boolean} [options.dots = false]
 * @param {?Boolean} [options.indexes = false]
 *
 * @returns {Object}
 **/ /**
 * It converts an object into a FormData object
 *
 * @param {Object<any, any>} obj - The object to convert to form data.
 * @param {string} formData - The FormData object to append to.
 * @param {Object<string, any>} options
 *
 * @returns
 */ function $e6cbd383b18c9625$var$toFormData(obj, formData, options) {
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("target must be an object");
    // eslint-disable-next-line no-param-reassign
    formData = formData || new ((0, $4023ac50ad132196$export$2e2bcd8739ae039) || FormData)();
    // eslint-disable-next-line no-param-reassign
    options = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFlatObject(options, {
        metaTokens: true,
        dots: false,
        indexes: false
    }, false, function defined(option, source) {
        // eslint-disable-next-line no-eq-null,eqeqeq
        return !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(source[option]);
    });
    const metaTokens = options.metaTokens;
    // eslint-disable-next-line no-use-before-define
    const visitor = options.visitor || defaultVisitor;
    const dots = options.dots;
    const indexes = options.indexes;
    const _Blob = options.Blob || typeof Blob !== "undefined" && Blob;
    const useBlob = _Blob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(formData);
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(visitor)) throw new TypeError("visitor must be a function");
    function convertValue(value) {
        if (value === null) return "";
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isDate(value)) return value.toISOString();
        if (!useBlob && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(value)) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Blob is not supported. Use a Buffer instead.");
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isTypedArray(value)) return useBlob && typeof Blob === "function" ? new Blob([
            value
        ]) : $e6cbd383b18c9625$require$Buffer.from(value);
        return value;
    }
    /**
   * Default visitor.
   *
   * @param {*} value
   * @param {String|Number} key
   * @param {Array<String|Number>} path
   * @this {FormData}
   *
   * @returns {boolean} return true to visit the each prop of the value recursively
   */ function defaultVisitor(value, key, path) {
        let arr = value;
        if (value && !path && typeof value === "object") {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "{}")) {
                // eslint-disable-next-line no-param-reassign
                key = metaTokens ? key : key.slice(0, -2);
                // eslint-disable-next-line no-param-reassign
                value = JSON.stringify(value);
            } else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) && $e6cbd383b18c9625$var$isFlatArray(value) || ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(value) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).endsWith(key, "[]")) && (arr = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toArray(value))) {
                // eslint-disable-next-line no-param-reassign
                key = $e6cbd383b18c9625$var$removeBrackets(key);
                arr.forEach(function each(el, index) {
                    !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && formData.append(// eslint-disable-next-line no-nested-ternary
                    indexes === true ? $e6cbd383b18c9625$var$renderKey([
                        key
                    ], index, dots) : indexes === null ? key : key + "[]", convertValue(el));
                });
                return false;
            }
        }
        if ($e6cbd383b18c9625$var$isVisitable(value)) return true;
        formData.append($e6cbd383b18c9625$var$renderKey(path, key, dots), convertValue(value));
        return false;
    }
    const stack = [];
    const exposedHelpers = Object.assign($e6cbd383b18c9625$var$predicates, {
        defaultVisitor: defaultVisitor,
        convertValue: convertValue,
        isVisitable: $e6cbd383b18c9625$var$isVisitable
    });
    function build(value, path) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(value)) return;
        if (stack.indexOf(value) !== -1) throw Error("Circular reference detected in " + path.join("."));
        stack.push(value);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(value, function each(el, key) {
            const result = !((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(el) || el === null) && visitor.call(formData, el, (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(key) ? key.trim() : key, path, exposedHelpers);
            if (result === true) build(el, path ? path.concat(key) : [
                key
            ]);
        });
        stack.pop();
    }
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(obj)) throw new TypeError("data must be an object");
    build(obj);
    return formData;
}
var $e6cbd383b18c9625$export$2e2bcd8739ae039 = $e6cbd383b18c9625$var$toFormData;


"use strict";
/**
 * It encodes a string by replacing all characters that are not in the unreserved set with
 * their percent-encoded equivalents
 *
 * @param {string} str - The string to encode.
 *
 * @returns {string} The encoded string.
 */ function $f66f8c7b4f247caf$var$encode(str) {
    const charMap = {
        "!": "%21",
        "'": "%27",
        "(": "%28",
        ")": "%29",
        "~": "%7E",
        "%20": "+",
        "%00": "\0"
    };
    return encodeURIComponent(str).replace(/[!'()~]|%20|%00/g, function replacer(match) {
        return charMap[match];
    });
}
/**
 * It takes a params object and converts it to a FormData object
 *
 * @param {Object<string, any>} params - The parameters to be converted to a FormData object.
 * @param {Object<string, any>} options - The options object passed to the Axios constructor.
 *
 * @returns {void}
 */ function $f66f8c7b4f247caf$var$AxiosURLSearchParams(params, options) {
    this._pairs = [];
    params && (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(params, this, options);
}
const $f66f8c7b4f247caf$var$prototype = $f66f8c7b4f247caf$var$AxiosURLSearchParams.prototype;
$f66f8c7b4f247caf$var$prototype.append = function append(name, value) {
    this._pairs.push([
        name,
        value
    ]);
};
$f66f8c7b4f247caf$var$prototype.toString = function toString(encoder) {
    const _encode = encoder ? function(value) {
        return encoder.call(this, value, $f66f8c7b4f247caf$var$encode);
    } : $f66f8c7b4f247caf$var$encode;
    return this._pairs.map(function each(pair) {
        return _encode(pair[0]) + "=" + _encode(pair[1]);
    }, "").join("&");
};
var $f66f8c7b4f247caf$export$2e2bcd8739ae039 = $f66f8c7b4f247caf$var$AxiosURLSearchParams;


"use strict";
/**
 * It replaces all instances of the characters `:`, `$`, `,`, `+`, `[`, and `]` with their
 * URI encoded counterparts
 *
 * @param {string} val The value to be encoded.
 *
 * @returns {string} The encoded value.
 */ function $8df8fedf1c1e4428$var$encode(val) {
    return encodeURIComponent(val).replace(/%3A/gi, ":").replace(/%24/g, "$").replace(/%2C/gi, ",").replace(/%20/g, "+").replace(/%5B/gi, "[").replace(/%5D/gi, "]");
}
function $8df8fedf1c1e4428$export$2e2bcd8739ae039(url, params, options) {
    /*eslint no-param-reassign:0*/ if (!params) return url;
    const _encode = options && options.encode || $8df8fedf1c1e4428$var$encode;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(options)) options = {
        serialize: options
    };
    const serializeFn = options && options.serialize;
    let serializedParams;
    if (serializeFn) serializedParams = serializeFn(params, options);
    else serializedParams = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(params) ? params.toString() : new (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039)(params, options).toString(_encode);
    if (serializedParams) {
        const hashmarkIndex = url.indexOf("#");
        if (hashmarkIndex !== -1) url = url.slice(0, hashmarkIndex);
        url += (url.indexOf("?") === -1 ? "?" : "&") + serializedParams;
    }
    return url;
}



"use strict";
class $5de878cd737ef277$var$InterceptorManager {
    constructor(){
        this.handlers = [];
    }
    /**
   * Add a new interceptor to the stack
   *
   * @param {Function} fulfilled The function to handle `then` for a `Promise`
   * @param {Function} rejected The function to handle `reject` for a `Promise`
   *
   * @return {Number} An ID used to remove interceptor later
   */ use(fulfilled, rejected, options) {
        this.handlers.push({
            fulfilled: fulfilled,
            rejected: rejected,
            synchronous: options ? options.synchronous : false,
            runWhen: options ? options.runWhen : null
        });
        return this.handlers.length - 1;
    }
    /**
   * Remove an interceptor from the stack
   *
   * @param {Number} id The ID that was returned by `use`
   *
   * @returns {Boolean} `true` if the interceptor was removed, `false` otherwise
   */ eject(id) {
        if (this.handlers[id]) this.handlers[id] = null;
    }
    /**
   * Clear all interceptors from the stack
   *
   * @returns {void}
   */ clear() {
        if (this.handlers) this.handlers = [];
    }
    /**
   * Iterate over all the registered interceptors
   *
   * This method is particularly useful for skipping over any
   * interceptors that may have become `null` calling `eject`.
   *
   * @param {Function} fn The function to call for each interceptor
   *
   * @returns {void}
   */ forEach(fn) {
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this.handlers, function forEachHandler(h) {
            if (h !== null) fn(h);
        });
    }
}
var $5de878cd737ef277$export$2e2bcd8739ae039 = $5de878cd737ef277$var$InterceptorManager;





"use strict";
var $51466d41a76e5b4b$export$2e2bcd8739ae039 = {
    silentJSONParsing: true,
    forcedJSONParsing: true,
    clarifyTimeoutError: false
};






"use strict";
var $6eeff4490c995137$export$2e2bcd8739ae039 = typeof URLSearchParams !== "undefined" ? URLSearchParams : (0, $f66f8c7b4f247caf$export$2e2bcd8739ae039);


"use strict";
var $86d275a264afb13f$export$2e2bcd8739ae039 = typeof FormData !== "undefined" ? FormData : null;


"use strict";
var $59c79e94740631e4$export$2e2bcd8739ae039 = typeof Blob !== "undefined" ? Blob : null;


var $2f71637df772b183$export$2e2bcd8739ae039 = {
    isBrowser: true,
    classes: {
        URLSearchParams: $6eeff4490c995137$export$2e2bcd8739ae039,
        FormData: $86d275a264afb13f$export$2e2bcd8739ae039,
        Blob: $59c79e94740631e4$export$2e2bcd8739ae039
    },
    protocols: [
        "http",
        "https",
        "file",
        "blob",
        "url",
        "data"
    ]
};


var $565e85ead8bde60a$exports = {};

$parcel$export($565e85ead8bde60a$exports, "hasBrowserEnv", () => $565e85ead8bde60a$export$c4996c4b7b93b0bf);
$parcel$export($565e85ead8bde60a$exports, "navigator", () => $565e85ead8bde60a$export$ec7c8efa7f5790ae);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserEnv", () => $565e85ead8bde60a$export$c0bcc9250309d66);
$parcel$export($565e85ead8bde60a$exports, "hasStandardBrowserWebWorkerEnv", () => $565e85ead8bde60a$export$c81692cf5af97dac);
$parcel$export($565e85ead8bde60a$exports, "origin", () => $565e85ead8bde60a$export$f710a83a91838a36);
const $565e85ead8bde60a$export$c4996c4b7b93b0bf = typeof window !== "undefined" && typeof document !== "undefined";
const $565e85ead8bde60a$export$ec7c8efa7f5790ae = typeof navigator === "object" && navigator || undefined;
/**
 * Determine if we're running in a standard browser environment
 *
 * This allows axios to run in a web worker, and react-native.
 * Both environments support XMLHttpRequest, but not fully standard globals.
 *
 * web workers:
 *  typeof window -> undefined
 *  typeof document -> undefined
 *
 * react-native:
 *  navigator.product -> 'ReactNative'
 * nativescript
 *  navigator.product -> 'NativeScript' or 'NS'
 *
 * @returns {boolean}
 */ const $565e85ead8bde60a$export$c0bcc9250309d66 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && (!$565e85ead8bde60a$export$ec7c8efa7f5790ae || [
    "ReactNative",
    "NativeScript",
    "NS"
].indexOf($565e85ead8bde60a$export$ec7c8efa7f5790ae.product) < 0);
/**
 * Determine if we're running in a standard browser webWorker environment
 *
 * Although the `isStandardBrowserEnv` method indicates that
 * `allows axios to run in a web worker`, the WebWorker will still be
 * filtered out due to its judgment standard
 * `typeof window !== 'undefined' && typeof document !== 'undefined'`.
 * This leads to a problem when axios post `FormData` in webWorker
 */ const $565e85ead8bde60a$export$c81692cf5af97dac = (()=>{
    return typeof WorkerGlobalScope !== "undefined" && // eslint-disable-next-line no-undef
    self instanceof WorkerGlobalScope && typeof self.importScripts === "function";
})();
const $565e85ead8bde60a$export$f710a83a91838a36 = $565e85ead8bde60a$export$c4996c4b7b93b0bf && window.location.href || "http://localhost";


var $bb8180acb278e187$export$2e2bcd8739ae039 = {
    ...$565e85ead8bde60a$exports,
    ...(0, $2f71637df772b183$export$2e2bcd8739ae039)
};


"use strict";
function $f6f250f62cadb740$export$2e2bcd8739ae039(data, options) {
    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(data, new (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.URLSearchParams(), Object.assign({
        visitor: function(value, key, path, helpers) {
            if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).isNode && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(value)) {
                this.append(key, value.toString("base64"));
                return false;
            }
            return helpers.defaultVisitor.apply(this, arguments);
        }
    }, options));
}




"use strict";
/**
 * It takes a string like `foo[x][y][z]` and returns an array like `['foo', 'x', 'y', 'z']
 *
 * @param {string} name - The name of the property to get.
 *
 * @returns An array of strings.
 */ function $5f8142930b3b943f$var$parsePropPath(name) {
    // foo[x][y][z]
    // foo.x.y.z
    // foo-x-y-z
    // foo x y z
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).matchAll(/\w+|\[(\w*)]/g, name).map((match)=>{
        return match[0] === "[]" ? "" : match[1] || match[0];
    });
}
/**
 * Convert an array to an object.
 *
 * @param {Array<any>} arr - The array to convert to an object.
 *
 * @returns An object with the same keys and values as the array.
 */ function $5f8142930b3b943f$var$arrayToObject(arr) {
    const obj = {};
    const keys = Object.keys(arr);
    let i;
    const len = keys.length;
    let key;
    for(i = 0; i < len; i++){
        key = keys[i];
        obj[key] = arr[key];
    }
    return obj;
}
/**
 * It takes a FormData object and returns a JavaScript object
 *
 * @param {string} formData The FormData object to convert to JSON.
 *
 * @returns {Object<string, any> | null} The converted object.
 */ function $5f8142930b3b943f$var$formDataToJSON(formData) {
    function buildPath(path, value, target, index) {
        let name = path[index++];
        if (name === "__proto__") return true;
        const isNumericKey = Number.isFinite(+name);
        const isLast = index >= path.length;
        name = !name && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target) ? target.length : name;
        if (isLast) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).hasOwnProp(target, name)) target[name] = [
                target[name],
                value
            ];
            else target[name] = value;
            return !isNumericKey;
        }
        if (!target[name] || !(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(target[name])) target[name] = [];
        const result = buildPath(path, value, target[name], index);
        if (result && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(target[name])) target[name] = $5f8142930b3b943f$var$arrayToObject(target[name]);
        return !isNumericKey;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(formData) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(formData.entries)) {
        const obj = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEachEntry(formData, (name, value)=>{
            buildPath($5f8142930b3b943f$var$parsePropPath(name), value, obj, 0);
        });
        return obj;
    }
    return null;
}
var $5f8142930b3b943f$export$2e2bcd8739ae039 = $5f8142930b3b943f$var$formDataToJSON;


"use strict";
/**
 * It takes a string, tries to parse it, and if it fails, it returns the stringified version
 * of the input
 *
 * @param {any} rawValue - The value to be stringified.
 * @param {Function} parser - A function that parses a string into a JavaScript object.
 * @param {Function} encoder - A function that takes a value and returns a string.
 *
 * @returns {string} A stringified version of the rawValue.
 */ function $843bf0209bc94df8$var$stringifySafely(rawValue, parser, encoder) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(rawValue)) try {
        (parser || JSON.parse)(rawValue);
        return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).trim(rawValue);
    } catch (e) {
        if (e.name !== "SyntaxError") throw e;
    }
    return (encoder || JSON.stringify)(rawValue);
}
const $843bf0209bc94df8$var$defaults = {
    transitional: (0, $51466d41a76e5b4b$export$2e2bcd8739ae039),
    adapter: [
        "xhr",
        "http",
        "fetch"
    ],
    transformRequest: [
        function transformRequest(data, headers) {
            const contentType = headers.getContentType() || "";
            const hasJSONContentType = contentType.indexOf("application/json") > -1;
            const isObjectPayload = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(data);
            if (isObjectPayload && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(data)) data = new FormData(data);
            const isFormData = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data);
            if (isFormData) return hasJSONContentType ? JSON.stringify((0, $5f8142930b3b943f$export$2e2bcd8739ae039)(data)) : data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBuffer(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isStream(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFile(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(data)) return data.buffer;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(data)) {
                headers.setContentType("application/x-www-form-urlencoded;charset=utf-8", false);
                return data.toString();
            }
            let isFileList;
            if (isObjectPayload) {
                if (contentType.indexOf("application/x-www-form-urlencoded") > -1) return (0, $f6f250f62cadb740$export$2e2bcd8739ae039)(data, this.formSerializer).toString();
                if ((isFileList = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFileList(data)) || contentType.indexOf("multipart/form-data") > -1) {
                    const _FormData = this.env && this.env.FormData;
                    return (0, $e6cbd383b18c9625$export$2e2bcd8739ae039)(isFileList ? {
                        "files[]": data
                    } : data, _FormData && new _FormData(), this.formSerializer);
                }
            }
            if (isObjectPayload || hasJSONContentType) {
                headers.setContentType("application/json", false);
                return $843bf0209bc94df8$var$stringifySafely(data);
            }
            return data;
        }
    ],
    transformResponse: [
        function transformResponse(data) {
            const transitional = this.transitional || $843bf0209bc94df8$var$defaults.transitional;
            const forcedJSONParsing = transitional && transitional.forcedJSONParsing;
            const JSONRequested = this.responseType === "json";
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isResponse(data) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(data)) return data;
            if (data && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(data) && (forcedJSONParsing && !this.responseType || JSONRequested)) {
                const silentJSONParsing = transitional && transitional.silentJSONParsing;
                const strictJSONParsing = !silentJSONParsing && JSONRequested;
                try {
                    return JSON.parse(data);
                } catch (e) {
                    if (strictJSONParsing) {
                        if (e.name === "SyntaxError") throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(e, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE, this, null, this.response);
                        throw e;
                    }
                }
            }
            return data;
        }
    ],
    /**
   * A timeout in milliseconds to abort a request. If set to 0 (default) a
   * timeout is not created.
   */ timeout: 0,
    xsrfCookieName: "XSRF-TOKEN",
    xsrfHeaderName: "X-XSRF-TOKEN",
    maxContentLength: -1,
    maxBodyLength: -1,
    env: {
        FormData: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.FormData,
        Blob: (0, $bb8180acb278e187$export$2e2bcd8739ae039).classes.Blob
    },
    validateStatus: function validateStatus(status) {
        return status >= 200 && status < 300;
    },
    headers: {
        common: {
            "Accept": "application/json, text/plain, */*",
            "Content-Type": undefined
        }
    }
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "post",
    "put",
    "patch"
], (method)=>{
    $843bf0209bc94df8$var$defaults.headers[method] = {};
});
var $843bf0209bc94df8$export$2e2bcd8739ae039 = $843bf0209bc94df8$var$defaults;




"use strict";
// RawAxiosHeaders whose duplicates are ignored by node
// c.f. https://nodejs.org/api/http.html#http_message_headers
const $fc026bbf9ee156f1$var$ignoreDuplicateOf = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toObjectSet([
    "age",
    "authorization",
    "content-length",
    "content-type",
    "etag",
    "expires",
    "from",
    "host",
    "if-modified-since",
    "if-unmodified-since",
    "last-modified",
    "location",
    "max-forwards",
    "proxy-authorization",
    "referer",
    "retry-after",
    "user-agent"
]);
var /**
 * Parse headers into an object
 *
 * ```
 * Date: Wed, 27 Aug 2014 08:58:49 GMT
 * Content-Type: application/json
 * Connection: keep-alive
 * Transfer-Encoding: chunked
 * ```
 *
 * @param {String} rawHeaders Headers needing to be parsed
 *
 * @returns {Object} Headers parsed into an object
 */ $fc026bbf9ee156f1$export$2e2bcd8739ae039 = (rawHeaders)=>{
    const parsed = {};
    let key;
    let val;
    let i;
    rawHeaders && rawHeaders.split("\n").forEach(function parser(line) {
        i = line.indexOf(":");
        key = line.substring(0, i).trim().toLowerCase();
        val = line.substring(i + 1).trim();
        if (!key || parsed[key] && $fc026bbf9ee156f1$var$ignoreDuplicateOf[key]) return;
        if (key === "set-cookie") {
            if (parsed[key]) parsed[key].push(val);
            else parsed[key] = [
                val
            ];
        } else parsed[key] = parsed[key] ? parsed[key] + ", " + val : val;
    });
    return parsed;
};


"use strict";
const $866cce54f6bdfb0c$var$$internals = Symbol("internals");
function $866cce54f6bdfb0c$var$normalizeHeader(header) {
    return header && String(header).trim().toLowerCase();
}
function $866cce54f6bdfb0c$var$normalizeValue(value) {
    if (value === false || value == null) return value;
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.map($866cce54f6bdfb0c$var$normalizeValue) : String(value);
}
function $866cce54f6bdfb0c$var$parseTokens(str) {
    const tokens = Object.create(null);
    const tokensRE = /([^\s,;=]+)\s*(?:=\s*([^,;]+))?/g;
    let match;
    while(match = tokensRE.exec(str))tokens[match[1]] = match[2];
    return tokens;
}
const $866cce54f6bdfb0c$var$isValidHeaderName = (str)=>/^[-_a-zA-Z0-9^`|~,!#$%&'*+.]+$/.test(str.trim());
function $866cce54f6bdfb0c$var$matchHeaderValue(context, value, header, filter, isHeaderNameFilter) {
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(filter)) return filter.call(this, value, header);
    if (isHeaderNameFilter) value = header;
    if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(value)) return;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(filter)) return value.indexOf(filter) !== -1;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(filter)) return filter.test(value);
}
function $866cce54f6bdfb0c$var$formatHeader(header) {
    return header.trim().toLowerCase().replace(/([a-z\d])(\w*)/g, (w, char, str)=>{
        return char.toUpperCase() + str;
    });
}
function $866cce54f6bdfb0c$var$buildAccessors(obj, header) {
    const accessorName = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toCamelCase(" " + header);
    [
        "get",
        "set",
        "has"
    ].forEach((methodName)=>{
        Object.defineProperty(obj, methodName + accessorName, {
            value: function(arg1, arg2, arg3) {
                return this[methodName].call(this, header, arg1, arg2, arg3);
            },
            configurable: true
        });
    });
}
class $866cce54f6bdfb0c$var$AxiosHeaders {
    constructor(headers){
        headers && this.set(headers);
    }
    set(header, valueOrRewrite, rewrite) {
        const self = this;
        function setHeader(_value, _header, _rewrite) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!lHeader) throw new Error("header name must be a non-empty string");
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, lHeader);
            if (!key || self[key] === undefined || _rewrite === true || _rewrite === undefined && self[key] !== false) self[key || _header] = $866cce54f6bdfb0c$var$normalizeValue(_value);
        }
        const setHeaders = (headers, _rewrite)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(headers, (_value, _header)=>setHeader(_value, _header, _rewrite));
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(header) || header instanceof this.constructor) setHeaders(header, valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(header) && (header = header.trim()) && !$866cce54f6bdfb0c$var$isValidHeaderName(header)) setHeaders((0, $fc026bbf9ee156f1$export$2e2bcd8739ae039)(header), valueOrRewrite);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHeaders(header)) for (const [key, value] of header.entries())setHeader(value, key, rewrite);
        else header != null && setHeader(valueOrRewrite, header, rewrite);
        return this;
    }
    get(header, parser) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            if (key) {
                const value = this[key];
                if (!parser) return value;
                if (parser === true) return $866cce54f6bdfb0c$var$parseTokens(value);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(parser)) return parser.call(this, value, key);
                if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isRegExp(parser)) return parser.exec(value);
                throw new TypeError("parser must be boolean|regexp|function");
            }
        }
    }
    has(header, matcher) {
        header = $866cce54f6bdfb0c$var$normalizeHeader(header);
        if (header) {
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(this, header);
            return !!(key && this[key] !== undefined && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher)));
        }
        return false;
    }
    delete(header, matcher) {
        const self = this;
        let deleted = false;
        function deleteHeader(_header) {
            _header = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (_header) {
                const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(self, _header);
                if (key && (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(self, self[key], key, matcher))) {
                    delete self[key];
                    deleted = true;
                }
            }
        }
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header)) header.forEach(deleteHeader);
        else deleteHeader(header);
        return deleted;
    }
    clear(matcher) {
        const keys = Object.keys(this);
        let i = keys.length;
        let deleted = false;
        while(i--){
            const key = keys[i];
            if (!matcher || $866cce54f6bdfb0c$var$matchHeaderValue(this, this[key], key, matcher, true)) {
                delete this[key];
                deleted = true;
            }
        }
        return deleted;
    }
    normalize(format) {
        const self = this;
        const headers = {};
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            const key = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey(headers, header);
            if (key) {
                self[key] = $866cce54f6bdfb0c$var$normalizeValue(value);
                delete self[header];
                return;
            }
            const normalized = format ? $866cce54f6bdfb0c$var$formatHeader(header) : String(header).trim();
            if (normalized !== header) delete self[header];
            self[normalized] = $866cce54f6bdfb0c$var$normalizeValue(value);
            headers[normalized] = true;
        });
        return this;
    }
    concat(...targets) {
        return this.constructor.concat(this, ...targets);
    }
    toJSON(asStrings) {
        const obj = Object.create(null);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(this, (value, header)=>{
            value != null && value !== false && (obj[header] = asStrings && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(value) ? value.join(", ") : value);
        });
        return obj;
    }
    [Symbol.iterator]() {
        return Object.entries(this.toJSON())[Symbol.iterator]();
    }
    toString() {
        return Object.entries(this.toJSON()).map(([header, value])=>header + ": " + value).join("\n");
    }
    get [Symbol.toStringTag]() {
        return "AxiosHeaders";
    }
    static from(thing) {
        return thing instanceof this ? thing : new this(thing);
    }
    static concat(first, ...targets) {
        const computed = new this(first);
        targets.forEach((target)=>computed.set(target));
        return computed;
    }
    static accessor(header) {
        const internals = this[$866cce54f6bdfb0c$var$$internals] = this[$866cce54f6bdfb0c$var$$internals] = {
            accessors: {}
        };
        const accessors = internals.accessors;
        const prototype = this.prototype;
        function defineAccessor(_header) {
            const lHeader = $866cce54f6bdfb0c$var$normalizeHeader(_header);
            if (!accessors[lHeader]) {
                $866cce54f6bdfb0c$var$buildAccessors(prototype, _header);
                accessors[lHeader] = true;
            }
        }
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(header) ? header.forEach(defineAccessor) : defineAccessor(header);
        return this;
    }
}
$866cce54f6bdfb0c$var$AxiosHeaders.accessor([
    "Content-Type",
    "Content-Length",
    "Accept",
    "Accept-Encoding",
    "User-Agent",
    "Authorization"
]);
// reserved names hotfix
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).reduceDescriptors($866cce54f6bdfb0c$var$AxiosHeaders.prototype, ({ value: value }, key)=>{
    let mapped = key[0].toUpperCase() + key.slice(1); // map `set` => `Set`
    return {
        get: ()=>value,
        set (headerValue) {
            this[mapped] = headerValue;
        }
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).freezeMethods($866cce54f6bdfb0c$var$AxiosHeaders);
var $866cce54f6bdfb0c$export$2e2bcd8739ae039 = $866cce54f6bdfb0c$var$AxiosHeaders;


"use strict";
function $5cf10c777cce5f4f$export$2e2bcd8739ae039(fns, response) {
    const config = this || (0, $843bf0209bc94df8$export$2e2bcd8739ae039);
    const context = response || config;
    const headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(context.headers);
    let data = context.data;
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(fns, function transform(fn) {
        data = fn.call(config, data, headers.normalize(), response ? response.status : undefined);
    });
    headers.normalize();
    return data;
}


"use strict";
function $5a60afef8b0dd173$export$2e2bcd8739ae039(value) {
    return !!(value && value.__CANCEL__);
}





"use strict";
/**
 * A `CanceledError` is an object that is thrown when an operation is canceled.
 *
 * @param {string=} message The message.
 * @param {Object=} config The config.
 * @param {Object=} request The request.
 *
 * @returns {CanceledError} The created error.
 */ function $9fd0919e266b4fda$var$CanceledError(message, config, request) {
    // eslint-disable-next-line no-eq-null,eqeqeq
    (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).call(this, message == null ? "canceled" : message, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_CANCELED, config, request);
    this.name = "CanceledError";
}
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).inherits($9fd0919e266b4fda$var$CanceledError, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039), {
    __CANCEL__: true
});
var $9fd0919e266b4fda$export$2e2bcd8739ae039 = $9fd0919e266b4fda$var$CanceledError;







"use strict";
function $ecb62d5372993dcf$export$2e2bcd8739ae039(resolve, reject, response) {
    const validateStatus = response.config.validateStatus;
    if (!response.status || !validateStatus || validateStatus(response.status)) resolve(response);
    else reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request failed with status code " + response.status, [
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST,
        (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_RESPONSE
    ][Math.floor(response.status / 100) - 4], response.config, response.request, response));
}





"use strict";
function $23607f53e4fda918$export$2e2bcd8739ae039(url) {
    const match = /^([-+\w]{1,25})(:?\/\/|:)/.exec(url);
    return match && match[1] || "";
}




"use strict";
/**
 * Calculate data maxRate
 * @param {Number} [samplesCount= 10]
 * @param {Number} [min= 1000]
 * @returns {Function}
 */ function $4a9d49cd0e6b8acc$var$speedometer(samplesCount, min) {
    samplesCount = samplesCount || 10;
    const bytes = new Array(samplesCount);
    const timestamps = new Array(samplesCount);
    let head = 0;
    let tail = 0;
    let firstSampleTS;
    min = min !== undefined ? min : 1000;
    return function push(chunkLength) {
        const now = Date.now();
        const startedAt = timestamps[tail];
        if (!firstSampleTS) firstSampleTS = now;
        bytes[head] = chunkLength;
        timestamps[head] = now;
        let i = tail;
        let bytesCount = 0;
        while(i !== head){
            bytesCount += bytes[i++];
            i = i % samplesCount;
        }
        head = (head + 1) % samplesCount;
        if (head === tail) tail = (tail + 1) % samplesCount;
        if (now - firstSampleTS < min) return;
        const passed = startedAt && now - startedAt;
        return passed ? Math.round(bytesCount * 1000 / passed) : undefined;
    };
}
var $4a9d49cd0e6b8acc$export$2e2bcd8739ae039 = $4a9d49cd0e6b8acc$var$speedometer;


/**
 * Throttle decorator
 * @param {Function} fn
 * @param {Number} freq
 * @return {Function}
 */ function $9b3ced92bc7bdc99$var$throttle(fn, freq) {
    let timestamp = 0;
    let threshold = 1000 / freq;
    let lastArgs;
    let timer;
    const invoke = (args, now = Date.now())=>{
        timestamp = now;
        lastArgs = null;
        if (timer) {
            clearTimeout(timer);
            timer = null;
        }
        fn.apply(null, args);
    };
    const throttled = (...args)=>{
        const now = Date.now();
        const passed = now - timestamp;
        if (passed >= threshold) invoke(args, now);
        else {
            lastArgs = args;
            if (!timer) timer = setTimeout(()=>{
                timer = null;
                invoke(lastArgs);
            }, threshold - passed);
        }
    };
    const flush = ()=>lastArgs && invoke(lastArgs);
    return [
        throttled,
        flush
    ];
}
var $9b3ced92bc7bdc99$export$2e2bcd8739ae039 = $9b3ced92bc7bdc99$var$throttle;



const $1a6c80b567b74091$export$c1b28109d46c3592 = (listener, isDownloadStream, freq = 3)=>{
    let bytesNotified = 0;
    const _speedometer = (0, $4a9d49cd0e6b8acc$export$2e2bcd8739ae039)(50, 250);
    return (0, $9b3ced92bc7bdc99$export$2e2bcd8739ae039)((e)=>{
        const loaded = e.loaded;
        const total = e.lengthComputable ? e.total : undefined;
        const progressBytes = loaded - bytesNotified;
        const rate = _speedometer(progressBytes);
        const inRange = loaded <= total;
        bytesNotified = loaded;
        const data = {
            loaded: loaded,
            total: total,
            progress: total ? loaded / total : undefined,
            bytes: progressBytes,
            rate: rate ? rate : undefined,
            estimated: rate && total && inRange ? (total - loaded) / rate : undefined,
            event: e,
            lengthComputable: total != null,
            [isDownloadStream ? "download" : "upload"]: true
        };
        listener(data);
    }, freq);
};
const $1a6c80b567b74091$export$d9fadd12586c18d6 = (total, throttled)=>{
    const lengthComputable = total != null;
    return [
        (loaded)=>throttled[0]({
                lengthComputable: lengthComputable,
                total: total,
                loaded: loaded
            }),
        throttled[1]
    ];
};
const $1a6c80b567b74091$export$5d35863c355a22a9 = (fn)=>(...args)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(()=>fn(...args));





var $5eb63b558e1fb85a$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? ((origin, isMSIE)=>(url)=>{
        url = new URL(url, (0, $bb8180acb278e187$export$2e2bcd8739ae039).origin);
        return origin.protocol === url.protocol && origin.host === url.host && (isMSIE || origin.port === url.port);
    })(new URL((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin), (0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator && /(msie|trident)/i.test((0, $bb8180acb278e187$export$2e2bcd8739ae039).navigator.userAgent)) : ()=>true;




var $65cc14c0704b5541$export$2e2bcd8739ae039 = (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv ? // Standard browser envs support document.cookie
{
    write (name, value, expires, path, domain, secure) {
        const cookie = [
            name + "=" + encodeURIComponent(value)
        ];
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isNumber(expires) && cookie.push("expires=" + new Date(expires).toGMTString());
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(path) && cookie.push("path=" + path);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(domain) && cookie.push("domain=" + domain);
        secure === true && cookie.push("secure");
        document.cookie = cookie.join("; ");
    },
    read (name) {
        const match = document.cookie.match(new RegExp("(^|;\\s*)(" + name + ")=([^;]*)"));
        return match ? decodeURIComponent(match[3]) : null;
    },
    remove (name) {
        this.write(name, "", Date.now() - 86400000);
    }
} : // Non-standard browser env (web workers, react-native) lack needed support.
{
    write () {},
    read () {
        return null;
    },
    remove () {}
};


"use strict";
function $8fa91c1a59edb5d9$export$2e2bcd8739ae039(url) {
    // A URL is considered absolute if it begins with "<scheme>://" or "//" (protocol-relative URL).
    // RFC 3986 defines scheme name as a sequence of characters beginning with a letter and followed
    // by any combination of letters, digits, plus, period, or hyphen.
    return /^([a-z][a-z\d+\-.]*:)?\/\//i.test(url);
}


"use strict";
function $b63e12c1e0b9e0be$export$2e2bcd8739ae039(baseURL, relativeURL) {
    return relativeURL ? baseURL.replace(/\/?\/$/, "") + "/" + relativeURL.replace(/^\/+/, "") : baseURL;
}


"use strict";
function $598acbfafd2c63c5$export$2e2bcd8739ae039(baseURL, requestedURL, allowAbsoluteUrls) {
    let isRelativeUrl = !(0, $8fa91c1a59edb5d9$export$2e2bcd8739ae039)(requestedURL);
    if (baseURL && (isRelativeUrl || allowAbsoluteUrls == false)) return (0, $b63e12c1e0b9e0be$export$2e2bcd8739ae039)(baseURL, requestedURL);
    return requestedURL;
}




"use strict";
const $f85fda54cd977b19$var$headersToObject = (thing)=>thing instanceof (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039) ? {
        ...thing
    } : thing;
function $f85fda54cd977b19$export$2e2bcd8739ae039(config1, config2) {
    // eslint-disable-next-line no-param-reassign
    config2 = config2 || {};
    const config = {};
    function getMergedValue(target, source, prop, caseless) {
        if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(target) && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge.call({
            caseless: caseless
        }, target, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isPlainObject(source)) return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge({}, source);
        else if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(source)) return source.slice();
        return source;
    }
    // eslint-disable-next-line consistent-return
    function mergeDeepProperties(a, b, prop, caseless) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(a, b, prop, caseless);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a, prop, caseless);
    }
    // eslint-disable-next-line consistent-return
    function valueFromConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
    }
    // eslint-disable-next-line consistent-return
    function defaultToConfig2(a, b) {
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(b)) return getMergedValue(undefined, b);
        else if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(a)) return getMergedValue(undefined, a);
    }
    // eslint-disable-next-line consistent-return
    function mergeDirectKeys(a, b, prop) {
        if (prop in config2) return getMergedValue(a, b);
        else if (prop in config1) return getMergedValue(undefined, a);
    }
    const mergeMap = {
        url: valueFromConfig2,
        method: valueFromConfig2,
        data: valueFromConfig2,
        baseURL: defaultToConfig2,
        transformRequest: defaultToConfig2,
        transformResponse: defaultToConfig2,
        paramsSerializer: defaultToConfig2,
        timeout: defaultToConfig2,
        timeoutMessage: defaultToConfig2,
        withCredentials: defaultToConfig2,
        withXSRFToken: defaultToConfig2,
        adapter: defaultToConfig2,
        responseType: defaultToConfig2,
        xsrfCookieName: defaultToConfig2,
        xsrfHeaderName: defaultToConfig2,
        onUploadProgress: defaultToConfig2,
        onDownloadProgress: defaultToConfig2,
        decompress: defaultToConfig2,
        maxContentLength: defaultToConfig2,
        maxBodyLength: defaultToConfig2,
        beforeRedirect: defaultToConfig2,
        transport: defaultToConfig2,
        httpAgent: defaultToConfig2,
        httpsAgent: defaultToConfig2,
        cancelToken: defaultToConfig2,
        socketPath: defaultToConfig2,
        responseEncoding: defaultToConfig2,
        validateStatus: mergeDirectKeys,
        headers: (a, b, prop)=>mergeDeepProperties($f85fda54cd977b19$var$headersToObject(a), $f85fda54cd977b19$var$headersToObject(b), prop, true)
    };
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(Object.keys(Object.assign({}, config1, config2)), function computeConfigValue(prop) {
        const merge = mergeMap[prop] || mergeDeepProperties;
        const configValue = merge(config1[prop], config2[prop], prop);
        (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(configValue) && merge !== mergeDirectKeys || (config[prop] = configValue);
    });
    return config;
}




var $ab4625fac3104691$export$2e2bcd8739ae039 = (config)=>{
    const newConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)({}, config);
    let { data: data, withXSRFToken: withXSRFToken, xsrfHeaderName: xsrfHeaderName, xsrfCookieName: xsrfCookieName, headers: headers, auth: auth } = newConfig;
    newConfig.headers = headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(headers);
    newConfig.url = (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)((0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(newConfig.baseURL, newConfig.url, newConfig.allowAbsoluteUrls), config.params, config.paramsSerializer);
    // HTTP basic authentication
    if (auth) headers.set("Authorization", "Basic " + btoa((auth.username || "") + ":" + (auth.password ? unescape(encodeURIComponent(auth.password)) : "")));
    let contentType;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data)) {
        if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv || (0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserWebWorkerEnv) headers.setContentType(undefined); // Let the browser set it
        else if ((contentType = headers.getContentType()) !== false) {
            // fix semicolon duplication issue for ReactNative FormData implementation
            const [type, ...tokens] = contentType ? contentType.split(";").map((token)=>token.trim()).filter(Boolean) : [];
            headers.setContentType([
                type || "multipart/form-data",
                ...tokens
            ].join("; "));
        }
    }
    // Add xsrf header
    // This is only done if running in a standard browser environment.
    // Specifically not if we're in a web worker, or react-native.
    if ((0, $bb8180acb278e187$export$2e2bcd8739ae039).hasStandardBrowserEnv) {
        withXSRFToken && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(withXSRFToken) && (withXSRFToken = withXSRFToken(newConfig));
        if (withXSRFToken || withXSRFToken !== false && (0, $5eb63b558e1fb85a$export$2e2bcd8739ae039)(newConfig.url)) {
            // Add xsrf header
            const xsrfValue = xsrfHeaderName && xsrfCookieName && (0, $65cc14c0704b5541$export$2e2bcd8739ae039).read(xsrfCookieName);
            if (xsrfValue) headers.set(xsrfHeaderName, xsrfValue);
        }
    }
    return newConfig;
};


const $79f0a48d5eb7919b$var$isXHRAdapterSupported = typeof XMLHttpRequest !== "undefined";
var $79f0a48d5eb7919b$export$2e2bcd8739ae039 = $79f0a48d5eb7919b$var$isXHRAdapterSupported && function(config) {
    return new Promise(function dispatchXhrRequest(resolve, reject) {
        const _config = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
        let requestData = _config.data;
        const requestHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(_config.headers).normalize();
        let { responseType: responseType, onUploadProgress: onUploadProgress, onDownloadProgress: onDownloadProgress } = _config;
        let onCanceled;
        let uploadThrottled, downloadThrottled;
        let flushUpload, flushDownload;
        function done() {
            flushUpload && flushUpload(); // flush events
            flushDownload && flushDownload(); // flush events
            _config.cancelToken && _config.cancelToken.unsubscribe(onCanceled);
            _config.signal && _config.signal.removeEventListener("abort", onCanceled);
        }
        let request = new XMLHttpRequest();
        request.open(_config.method.toUpperCase(), _config.url, true);
        // Set the request timeout in MS
        request.timeout = _config.timeout;
        function onloadend() {
            if (!request) return;
            // Prepare the response
            const responseHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from("getAllResponseHeaders" in request && request.getAllResponseHeaders());
            const responseData = !responseType || responseType === "text" || responseType === "json" ? request.responseText : request.response;
            const response = {
                data: responseData,
                status: request.status,
                statusText: request.statusText,
                headers: responseHeaders,
                config: config,
                request: request
            };
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(function _resolve(value) {
                resolve(value);
                done();
            }, function _reject(err) {
                reject(err);
                done();
            }, response);
            // Clean up request
            request = null;
        }
        if ("onloadend" in request) // Use onloadend if available
        request.onloadend = onloadend;
        else // Listen for ready state to emulate onloadend
        request.onreadystatechange = function handleLoad() {
            if (!request || request.readyState !== 4) return;
            // The request errored out and we didn't get a response, this will be
            // handled by onerror instead
            // With one exception: request that using file: protocol, most browsers
            // will return status as 0 even though it's a successful request
            if (request.status === 0 && !(request.responseURL && request.responseURL.indexOf("file:") === 0)) return;
            // readystate handler is calling before onerror or ontimeout handlers,
            // so we should call onloadend on the next 'tick'
            setTimeout(onloadend);
        };
        // Handle browser request cancellation (as opposed to a manual cancellation)
        request.onabort = function handleAbort() {
            if (!request) return;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Request aborted", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Handle low level network errors
        request.onerror = function handleError() {
            // Real errors are hidden from us by the browser
            // onerror should only fire if it's a network error
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request));
            // Clean up request
            request = null;
        };
        // Handle timeout
        request.ontimeout = function handleTimeout() {
            let timeoutErrorMessage = _config.timeout ? "timeout of " + _config.timeout + "ms exceeded" : "timeout exceeded";
            const transitional = _config.transitional || (0, $51466d41a76e5b4b$export$2e2bcd8739ae039);
            if (_config.timeoutErrorMessage) timeoutErrorMessage = _config.timeoutErrorMessage;
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(timeoutErrorMessage, transitional.clarifyTimeoutError ? (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT : (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ECONNABORTED, config, request));
            // Clean up request
            request = null;
        };
        // Remove Content-Type if data is undefined
        requestData === undefined && requestHeaders.setContentType(null);
        // Add headers to the request
        if ("setRequestHeader" in request) (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach(requestHeaders.toJSON(), function setRequestHeader(val, key) {
            request.setRequestHeader(key, val);
        });
        // Add withCredentials to request if needed
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isUndefined(_config.withCredentials)) request.withCredentials = !!_config.withCredentials;
        // Add responseType to request if needed
        if (responseType && responseType !== "json") request.responseType = _config.responseType;
        // Handle progress if needed
        if (onDownloadProgress) {
            [downloadThrottled, flushDownload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onDownloadProgress, true);
            request.addEventListener("progress", downloadThrottled);
        }
        // Not all browsers support upload events
        if (onUploadProgress && request.upload) {
            [uploadThrottled, flushUpload] = (0, $1a6c80b567b74091$export$c1b28109d46c3592)(onUploadProgress);
            request.upload.addEventListener("progress", uploadThrottled);
            request.upload.addEventListener("loadend", flushUpload);
        }
        if (_config.cancelToken || _config.signal) {
            // Handle cancellation
            // eslint-disable-next-line func-names
            onCanceled = (cancel)=>{
                if (!request) return;
                reject(!cancel || cancel.type ? new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config, request) : cancel);
                request.abort();
                request = null;
            };
            _config.cancelToken && _config.cancelToken.subscribe(onCanceled);
            if (_config.signal) _config.signal.aborted ? onCanceled() : _config.signal.addEventListener("abort", onCanceled);
        }
        const protocol = (0, $23607f53e4fda918$export$2e2bcd8739ae039)(_config.url);
        if (protocol && (0, $bb8180acb278e187$export$2e2bcd8739ae039).protocols.indexOf(protocol) === -1) {
            reject(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unsupported protocol " + protocol + ":", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_REQUEST, config));
            return;
        }
        // Send the request
        request.send(requestData || null);
    });
};








const $a052b9a6636aacdc$var$composeSignals = (signals, timeout)=>{
    const { length: length } = signals = signals ? signals.filter(Boolean) : [];
    if (timeout || length) {
        let controller = new AbortController();
        let aborted;
        const onabort = function(reason) {
            if (!aborted) {
                aborted = true;
                unsubscribe();
                const err = reason instanceof Error ? reason : this.reason;
                controller.abort(err instanceof (0, $4e2395edb77acf3a$export$2e2bcd8739ae039) ? err : new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(err instanceof Error ? err.message : err));
            }
        };
        let timer = timeout && setTimeout(()=>{
            timer = null;
            onabort(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`timeout ${timeout} of ms exceeded`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ETIMEDOUT));
        }, timeout);
        const unsubscribe = ()=>{
            if (signals) {
                timer && clearTimeout(timer);
                timer = null;
                signals.forEach((signal)=>{
                    signal.unsubscribe ? signal.unsubscribe(onabort) : signal.removeEventListener("abort", onabort);
                });
                signals = null;
            }
        };
        signals.forEach((signal)=>signal.addEventListener("abort", onabort));
        const { signal: signal } = controller;
        signal.unsubscribe = ()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).asap(unsubscribe);
        return signal;
    }
};
var $a052b9a6636aacdc$export$2e2bcd8739ae039 = $a052b9a6636aacdc$var$composeSignals;


const $c9465135abb26626$export$71b051935044bd5d = function*(chunk, chunkSize) {
    let len = chunk.byteLength;
    if (!chunkSize || len < chunkSize) {
        yield chunk;
        return;
    }
    let pos = 0;
    let end;
    while(pos < len){
        end = pos + chunkSize;
        yield chunk.slice(pos, end);
        pos = end;
    }
};
const $c9465135abb26626$export$f9f241124ee3198e = async function*(iterable, chunkSize) {
    for await (const chunk of $c9465135abb26626$var$readStream(iterable))yield* $c9465135abb26626$export$71b051935044bd5d(chunk, chunkSize);
};
const $c9465135abb26626$var$readStream = async function*(stream) {
    if (stream[Symbol.asyncIterator]) {
        yield* stream;
        return;
    }
    const reader = stream.getReader();
    try {
        for(;;){
            const { done: done, value: value } = await reader.read();
            if (done) break;
            yield value;
        }
    } finally{
        await reader.cancel();
    }
};
const $c9465135abb26626$export$b0119225647bd83 = (stream, chunkSize, onProgress, onFinish)=>{
    const iterator = $c9465135abb26626$export$f9f241124ee3198e(stream, chunkSize);
    let bytes = 0;
    let done;
    let _onFinish = (e)=>{
        if (!done) {
            done = true;
            onFinish && onFinish(e);
        }
    };
    return new ReadableStream({
        async pull (controller) {
            try {
                const { done: done, value: value } = await iterator.next();
                if (done) {
                    _onFinish();
                    controller.close();
                    return;
                }
                let len = value.byteLength;
                if (onProgress) {
                    let loadedBytes = bytes += len;
                    onProgress(loadedBytes);
                }
                controller.enqueue(new Uint8Array(value));
            } catch (err) {
                _onFinish(err);
                throw err;
            }
        },
        cancel (reason) {
            _onFinish(reason);
            return iterator.return();
        }
    }, {
        highWaterMark: 2
    });
};






const $e52be20a9fc15e96$var$isFetchSupported = typeof fetch === "function" && typeof Request === "function" && typeof Response === "function";
const $e52be20a9fc15e96$var$isReadableStreamSupported = $e52be20a9fc15e96$var$isFetchSupported && typeof ReadableStream === "function";
// used only inside the fetch adapter
const $e52be20a9fc15e96$var$encodeText = $e52be20a9fc15e96$var$isFetchSupported && (typeof TextEncoder === "function" ? ((encoder)=>(str)=>encoder.encode(str))(new TextEncoder()) : async (str)=>new Uint8Array(await new Response(str).arrayBuffer()));
const $e52be20a9fc15e96$var$test = (fn, ...args)=>{
    try {
        return !!fn(...args);
    } catch (e) {
        return false;
    }
};
const $e52be20a9fc15e96$var$supportsRequestStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>{
    let duplexAccessed = false;
    const hasContentType = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
        body: new ReadableStream(),
        method: "POST",
        get duplex () {
            duplexAccessed = true;
            return "half";
        }
    }).headers.has("Content-Type");
    return duplexAccessed && !hasContentType;
});
const $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE = 65536;
const $e52be20a9fc15e96$var$supportsResponseStream = $e52be20a9fc15e96$var$isReadableStreamSupported && $e52be20a9fc15e96$var$test(()=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isReadableStream(new Response("").body));
const $e52be20a9fc15e96$var$resolvers = {
    stream: $e52be20a9fc15e96$var$supportsResponseStream && ((res)=>res.body)
};
$e52be20a9fc15e96$var$isFetchSupported && ((res)=>{
    [
        "text",
        "arrayBuffer",
        "blob",
        "formData",
        "stream"
    ].forEach((type)=>{
        !$e52be20a9fc15e96$var$resolvers[type] && ($e52be20a9fc15e96$var$resolvers[type] = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(res[type]) ? (res)=>res[type]() : (_, config)=>{
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Response type '${type}' is not supported`, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NOT_SUPPORT, config);
        });
    });
})(new Response);
const $e52be20a9fc15e96$var$getBodyLength = async (body)=>{
    if (body == null) return 0;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isBlob(body)) return body.size;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isSpecCompliantForm(body)) {
        const _request = new Request((0, $bb8180acb278e187$export$2e2bcd8739ae039).origin, {
            method: "POST",
            body: body
        });
        return (await _request.arrayBuffer()).byteLength;
    }
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBufferView(body) || (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArrayBuffer(body)) return body.byteLength;
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isURLSearchParams(body)) body = body + "";
    if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(body)) return (await $e52be20a9fc15e96$var$encodeText(body)).byteLength;
};
const $e52be20a9fc15e96$var$resolveBodyLength = async (headers, body)=>{
    const length = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(headers.getContentLength());
    return length == null ? $e52be20a9fc15e96$var$getBodyLength(body) : length;
};
var $e52be20a9fc15e96$export$2e2bcd8739ae039 = $e52be20a9fc15e96$var$isFetchSupported && (async (config)=>{
    let { url: url, method: method, data: data, signal: signal, cancelToken: cancelToken, timeout: timeout, onDownloadProgress: onDownloadProgress, onUploadProgress: onUploadProgress, responseType: responseType, headers: headers, withCredentials: withCredentials = "same-origin", fetchOptions: fetchOptions } = (0, $ab4625fac3104691$export$2e2bcd8739ae039)(config);
    responseType = responseType ? (responseType + "").toLowerCase() : "text";
    let composedSignal = (0, $a052b9a6636aacdc$export$2e2bcd8739ae039)([
        signal,
        cancelToken && cancelToken.toAbortSignal()
    ], timeout);
    let request;
    const unsubscribe = composedSignal && composedSignal.unsubscribe && (()=>{
        composedSignal.unsubscribe();
    });
    let requestContentLength;
    try {
        if (onUploadProgress && $e52be20a9fc15e96$var$supportsRequestStream && method !== "get" && method !== "head" && (requestContentLength = await $e52be20a9fc15e96$var$resolveBodyLength(headers, data)) !== 0) {
            let _request = new Request(url, {
                method: "POST",
                body: data,
                duplex: "half"
            });
            let contentTypeHeader;
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFormData(data) && (contentTypeHeader = _request.headers.get("content-type"))) headers.setContentType(contentTypeHeader);
            if (_request.body) {
                const [onProgress, flush] = (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(requestContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onUploadProgress)));
                data = (0, $c9465135abb26626$export$b0119225647bd83)(_request.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, flush);
            }
        }
        if (!(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isString(withCredentials)) withCredentials = withCredentials ? "include" : "omit";
        // Cloudflare Workers throws when credentials are defined
        // see https://github.com/cloudflare/workerd/issues/902
        const isCredentialsSupported = "credentials" in Request.prototype;
        request = new Request(url, {
            ...fetchOptions,
            signal: composedSignal,
            method: method.toUpperCase(),
            headers: headers.normalize().toJSON(),
            body: data,
            duplex: "half",
            credentials: isCredentialsSupported ? withCredentials : undefined
        });
        let response = await fetch(request);
        const isStreamResponse = $e52be20a9fc15e96$var$supportsResponseStream && (responseType === "stream" || responseType === "response");
        if ($e52be20a9fc15e96$var$supportsResponseStream && (onDownloadProgress || isStreamResponse && unsubscribe)) {
            const options = {};
            [
                "status",
                "statusText",
                "headers"
            ].forEach((prop)=>{
                options[prop] = response[prop];
            });
            const responseContentLength = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).toFiniteNumber(response.headers.get("content-length"));
            const [onProgress, flush] = onDownloadProgress && (0, $1a6c80b567b74091$export$d9fadd12586c18d6)(responseContentLength, (0, $1a6c80b567b74091$export$c1b28109d46c3592)((0, $1a6c80b567b74091$export$5d35863c355a22a9)(onDownloadProgress), true)) || [];
            response = new Response((0, $c9465135abb26626$export$b0119225647bd83)(response.body, $e52be20a9fc15e96$var$DEFAULT_CHUNK_SIZE, onProgress, ()=>{
                flush && flush();
                unsubscribe && unsubscribe();
            }), options);
        }
        responseType = responseType || "text";
        let responseData = await $e52be20a9fc15e96$var$resolvers[(0, $c319b2c832c2914a$export$2e2bcd8739ae039).findKey($e52be20a9fc15e96$var$resolvers, responseType) || "text"](response, config);
        !isStreamResponse && unsubscribe && unsubscribe();
        return await new Promise((resolve, reject)=>{
            (0, $ecb62d5372993dcf$export$2e2bcd8739ae039)(resolve, reject, {
                data: responseData,
                headers: (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers),
                status: response.status,
                statusText: response.statusText,
                config: config,
                request: request
            });
        });
    } catch (err) {
        unsubscribe && unsubscribe();
        if (err && err.name === "TypeError" && /fetch/i.test(err.message)) throw Object.assign(new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Network Error", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_NETWORK, config, request), {
            cause: err.cause || err
        });
        throw (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).from(err, err && err.code, config, request);
    }
});



const $e8c8c7960873e9ee$var$knownAdapters = {
    http: (0, $4023ac50ad132196$export$2e2bcd8739ae039),
    xhr: (0, $79f0a48d5eb7919b$export$2e2bcd8739ae039),
    fetch: (0, $e52be20a9fc15e96$export$2e2bcd8739ae039)
};
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach($e8c8c7960873e9ee$var$knownAdapters, (fn, value)=>{
    if (fn) {
        try {
            Object.defineProperty(fn, "name", {
                value: value
            });
        } catch (e) {
        // eslint-disable-next-line no-empty
        }
        Object.defineProperty(fn, "adapterName", {
            value: value
        });
    }
});
const $e8c8c7960873e9ee$var$renderReason = (reason)=>`- ${reason}`;
const $e8c8c7960873e9ee$var$isResolvedHandle = (adapter)=>(0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(adapter) || adapter === null || adapter === false;
var $e8c8c7960873e9ee$export$2e2bcd8739ae039 = {
    getAdapter: (adapters)=>{
        adapters = (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isArray(adapters) ? adapters : [
            adapters
        ];
        const { length: length } = adapters;
        let nameOrAdapter;
        let adapter;
        const rejectedReasons = {};
        for(let i = 0; i < length; i++){
            nameOrAdapter = adapters[i];
            let id;
            adapter = nameOrAdapter;
            if (!$e8c8c7960873e9ee$var$isResolvedHandle(nameOrAdapter)) {
                adapter = $e8c8c7960873e9ee$var$knownAdapters[(id = String(nameOrAdapter)).toLowerCase()];
                if (adapter === undefined) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`Unknown adapter '${id}'`);
            }
            if (adapter) break;
            rejectedReasons[id || "#" + i] = adapter;
        }
        if (!adapter) {
            const reasons = Object.entries(rejectedReasons).map(([id, state])=>`adapter ${id} ` + (state === false ? "is not supported by the environment" : "is not available in the build"));
            let s = length ? reasons.length > 1 ? "since :\n" + reasons.map($e8c8c7960873e9ee$var$renderReason).join("\n") : " " + $e8c8c7960873e9ee$var$renderReason(reasons[0]) : "as no adapter specified";
            throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(`There is no suitable adapter to dispatch the request ` + s, "ERR_NOT_SUPPORT");
        }
        return adapter;
    },
    adapters: $e8c8c7960873e9ee$var$knownAdapters
};


"use strict";
/**
 * Throws a `CanceledError` if cancellation has been requested.
 *
 * @param {Object} config The config that is to be used for the request
 *
 * @returns {void}
 */ function $9b8d10189805ccc0$var$throwIfCancellationRequested(config) {
    if (config.cancelToken) config.cancelToken.throwIfRequested();
    if (config.signal && config.signal.aborted) throw new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(null, config);
}
function $9b8d10189805ccc0$export$2e2bcd8739ae039(config) {
    $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
    config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(config.headers);
    // Transform request data
    config.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformRequest);
    if ([
        "post",
        "put",
        "patch"
    ].indexOf(config.method) !== -1) config.headers.setContentType("application/x-www-form-urlencoded", false);
    const adapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter(config.adapter || (0, $843bf0209bc94df8$export$2e2bcd8739ae039).adapter);
    return adapter(config).then(function onAdapterResolution(response) {
        $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
        // Transform response data
        response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, response);
        response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(response.headers);
        return response;
    }, function onAdapterRejection(reason) {
        if (!(0, $5a60afef8b0dd173$export$2e2bcd8739ae039)(reason)) {
            $9b8d10189805ccc0$var$throwIfCancellationRequested(config);
            // Transform response data
            if (reason && reason.response) {
                reason.response.data = (0, $5cf10c777cce5f4f$export$2e2bcd8739ae039).call(config, config.transformResponse, reason.response);
                reason.response.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).from(reason.response.headers);
            }
        }
        return Promise.reject(reason);
    });
}




const $23ff3f1a5c7912d5$export$a4ad2735b021c132 = "1.8.4";



"use strict";
const $85f59389941e7907$var$validators = {};
// eslint-disable-next-line func-names
[
    "object",
    "boolean",
    "number",
    "function",
    "string",
    "symbol"
].forEach((type, i)=>{
    $85f59389941e7907$var$validators[type] = function validator(thing) {
        return typeof thing === type || "a" + (i < 1 ? "n " : " ") + type;
    };
});
const $85f59389941e7907$var$deprecatedWarnings = {};
/**
 * Transitional option validator
 *
 * @param {function|boolean?} validator - set to false if the transitional option has been removed
 * @param {string?} version - deprecated version / removed since version
 * @param {string?} message - some message with additional info
 *
 * @returns {function}
 */ $85f59389941e7907$var$validators.transitional = function transitional(validator, version, message) {
    function formatMessage(opt, desc) {
        return "[Axios v" + (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132) + "] Transitional option '" + opt + "'" + desc + (message ? ". " + message : "");
    }
    // eslint-disable-next-line func-names
    return (value, opt, opts)=>{
        if (validator === false) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)(formatMessage(opt, " has been removed" + (version ? " in " + version : "")), (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_DEPRECATED);
        if (version && !$85f59389941e7907$var$deprecatedWarnings[opt]) {
            $85f59389941e7907$var$deprecatedWarnings[opt] = true;
            // eslint-disable-next-line no-console
            console.warn(formatMessage(opt, " has been deprecated since v" + version + " and will be removed in the near future"));
        }
        return validator ? validator(value, opt, opts) : true;
    };
};
$85f59389941e7907$var$validators.spelling = function spelling(correctSpelling) {
    return (value, opt)=>{
        // eslint-disable-next-line no-console
        console.warn(`${opt} is likely a misspelling of ${correctSpelling}`);
        return true;
    };
};
/**
 * Assert object's properties type
 *
 * @param {object} options
 * @param {object} schema
 * @param {boolean?} allowUnknown
 *
 * @returns {object}
 */ function $85f59389941e7907$var$assertOptions(options, schema, allowUnknown) {
    if (typeof options !== "object") throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("options must be an object", (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
    const keys = Object.keys(options);
    let i = keys.length;
    while(i-- > 0){
        const opt = keys[i];
        const validator = schema[opt];
        if (validator) {
            const value = options[opt];
            const result = value === undefined || validator(value, opt, options);
            if (result !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("option " + opt + " must be " + result, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION_VALUE);
            continue;
        }
        if (allowUnknown !== true) throw new (0, $4e2395edb77acf3a$export$2e2bcd8739ae039)("Unknown option " + opt, (0, $4e2395edb77acf3a$export$2e2bcd8739ae039).ERR_BAD_OPTION);
    }
}
var $85f59389941e7907$export$2e2bcd8739ae039 = {
    assertOptions: $85f59389941e7907$var$assertOptions,
    validators: $85f59389941e7907$var$validators
};



"use strict";
const $a93486d2307f31c3$var$validators = (0, $85f59389941e7907$export$2e2bcd8739ae039).validators;
/**
 * Create a new instance of Axios
 *
 * @param {Object} instanceConfig The default config for the instance
 *
 * @return {Axios} A new instance of Axios
 */ class $a93486d2307f31c3$var$Axios {
    constructor(instanceConfig){
        this.defaults = instanceConfig;
        this.interceptors = {
            request: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)(),
            response: new (0, $5de878cd737ef277$export$2e2bcd8739ae039)()
        };
    }
    /**
   * Dispatch a request
   *
   * @param {String|Object} configOrUrl The config specific for this request (merged with this.defaults)
   * @param {?Object} config
   *
   * @returns {Promise} The Promise to be fulfilled
   */ async request(configOrUrl, config) {
        try {
            return await this._request(configOrUrl, config);
        } catch (err) {
            if (err instanceof Error) {
                let dummy = {};
                Error.captureStackTrace ? Error.captureStackTrace(dummy) : dummy = new Error();
                // slice off the Error: ... line
                const stack = dummy.stack ? dummy.stack.replace(/^.+\n/, "") : "";
                try {
                    if (!err.stack) err.stack = stack;
                    else if (stack && !String(err.stack).endsWith(stack.replace(/^.+\n.+\n/, ""))) err.stack += "\n" + stack;
                } catch (e) {
                // ignore the case where "stack" is an un-writable property
                }
            }
            throw err;
        }
    }
    _request(configOrUrl, config) {
        /*eslint no-param-reassign:0*/ // Allow for axios('example/url'[, config]) a la fetch API
        if (typeof configOrUrl === "string") {
            config = config || {};
            config.url = configOrUrl;
        } else config = configOrUrl || {};
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const { transitional: transitional, paramsSerializer: paramsSerializer, headers: headers } = config;
        if (transitional !== undefined) (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(transitional, {
            silentJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            forcedJSONParsing: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean),
            clarifyTimeoutError: $a93486d2307f31c3$var$validators.transitional($a93486d2307f31c3$var$validators.boolean)
        }, false);
        if (paramsSerializer != null) {
            if ((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isFunction(paramsSerializer)) config.paramsSerializer = {
                serialize: paramsSerializer
            };
            else (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(paramsSerializer, {
                encode: $a93486d2307f31c3$var$validators.function,
                serialize: $a93486d2307f31c3$var$validators.function
            }, true);
        }
        // Set config.allowAbsoluteUrls
        if (config.allowAbsoluteUrls !== undefined) ;
        else if (this.defaults.allowAbsoluteUrls !== undefined) config.allowAbsoluteUrls = this.defaults.allowAbsoluteUrls;
        else config.allowAbsoluteUrls = true;
        (0, $85f59389941e7907$export$2e2bcd8739ae039).assertOptions(config, {
            baseUrl: $a93486d2307f31c3$var$validators.spelling("baseURL"),
            withXsrfToken: $a93486d2307f31c3$var$validators.spelling("withXSRFToken")
        }, true);
        // Set config.method
        config.method = (config.method || this.defaults.method || "get").toLowerCase();
        // Flatten headers
        let contextHeaders = headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).merge(headers.common, headers[config.method]);
        headers && (0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
            "delete",
            "get",
            "head",
            "post",
            "put",
            "patch",
            "common"
        ], (method)=>{
            delete headers[method];
        });
        config.headers = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039).concat(contextHeaders, headers);
        // filter out skipped interceptors
        const requestInterceptorChain = [];
        let synchronousRequestInterceptors = true;
        this.interceptors.request.forEach(function unshiftRequestInterceptors(interceptor) {
            if (typeof interceptor.runWhen === "function" && interceptor.runWhen(config) === false) return;
            synchronousRequestInterceptors = synchronousRequestInterceptors && interceptor.synchronous;
            requestInterceptorChain.unshift(interceptor.fulfilled, interceptor.rejected);
        });
        const responseInterceptorChain = [];
        this.interceptors.response.forEach(function pushResponseInterceptors(interceptor) {
            responseInterceptorChain.push(interceptor.fulfilled, interceptor.rejected);
        });
        let promise;
        let i = 0;
        let len;
        if (!synchronousRequestInterceptors) {
            const chain = [
                (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).bind(this),
                undefined
            ];
            chain.unshift.apply(chain, requestInterceptorChain);
            chain.push.apply(chain, responseInterceptorChain);
            len = chain.length;
            promise = Promise.resolve(config);
            while(i < len)promise = promise.then(chain[i++], chain[i++]);
            return promise;
        }
        len = requestInterceptorChain.length;
        let newConfig = config;
        i = 0;
        while(i < len){
            const onFulfilled = requestInterceptorChain[i++];
            const onRejected = requestInterceptorChain[i++];
            try {
                newConfig = onFulfilled(newConfig);
            } catch (error) {
                onRejected.call(this, error);
                break;
            }
        }
        try {
            promise = (0, $9b8d10189805ccc0$export$2e2bcd8739ae039).call(this, newConfig);
        } catch (error) {
            return Promise.reject(error);
        }
        i = 0;
        len = responseInterceptorChain.length;
        while(i < len)promise = promise.then(responseInterceptorChain[i++], responseInterceptorChain[i++]);
        return promise;
    }
    getUri(config) {
        config = (0, $f85fda54cd977b19$export$2e2bcd8739ae039)(this.defaults, config);
        const fullPath = (0, $598acbfafd2c63c5$export$2e2bcd8739ae039)(config.baseURL, config.url, config.allowAbsoluteUrls);
        return (0, $8df8fedf1c1e4428$export$2e2bcd8739ae039)(fullPath, config.params, config.paramsSerializer);
    }
}
// Provide aliases for supported request methods
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "delete",
    "get",
    "head",
    "options"
], function forEachMethodNoData(method) {
    /*eslint func-names:0*/ $a93486d2307f31c3$var$Axios.prototype[method] = function(url, config) {
        return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
            method: method,
            url: url,
            data: (config || {}).data
        }));
    };
});
(0, $c319b2c832c2914a$export$2e2bcd8739ae039).forEach([
    "post",
    "put",
    "patch"
], function forEachMethodWithData(method) {
    /*eslint func-names:0*/ function generateHTTPMethod(isForm) {
        return function httpMethod(url, data, config) {
            return this.request((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(config || {}, {
                method: method,
                headers: isForm ? {
                    "Content-Type": "multipart/form-data"
                } : {},
                url: url,
                data: data
            }));
        };
    }
    $a93486d2307f31c3$var$Axios.prototype[method] = generateHTTPMethod();
    $a93486d2307f31c3$var$Axios.prototype[method + "Form"] = generateHTTPMethod(true);
});
var $a93486d2307f31c3$export$2e2bcd8739ae039 = $a93486d2307f31c3$var$Axios;







"use strict";
/**
 * A `CancelToken` is an object that can be used to request cancellation of an operation.
 *
 * @param {Function} executor The executor function.
 *
 * @returns {CancelToken}
 */ class $fb81495929d8a282$var$CancelToken {
    constructor(executor){
        if (typeof executor !== "function") throw new TypeError("executor must be a function.");
        let resolvePromise;
        this.promise = new Promise(function promiseExecutor(resolve) {
            resolvePromise = resolve;
        });
        const token = this;
        // eslint-disable-next-line func-names
        this.promise.then((cancel)=>{
            if (!token._listeners) return;
            let i = token._listeners.length;
            while(i-- > 0)token._listeners[i](cancel);
            token._listeners = null;
        });
        // eslint-disable-next-line func-names
        this.promise.then = (onfulfilled)=>{
            let _resolve;
            // eslint-disable-next-line func-names
            const promise = new Promise((resolve)=>{
                token.subscribe(resolve);
                _resolve = resolve;
            }).then(onfulfilled);
            promise.cancel = function reject() {
                token.unsubscribe(_resolve);
            };
            return promise;
        };
        executor(function cancel(message, config, request) {
            if (token.reason) // Cancellation has already been requested
            return;
            token.reason = new (0, $9fd0919e266b4fda$export$2e2bcd8739ae039)(message, config, request);
            resolvePromise(token.reason);
        });
    }
    /**
   * Throws a `CanceledError` if cancellation has been requested.
   */ throwIfRequested() {
        if (this.reason) throw this.reason;
    }
    /**
   * Subscribe to the cancel signal
   */ subscribe(listener) {
        if (this.reason) {
            listener(this.reason);
            return;
        }
        if (this._listeners) this._listeners.push(listener);
        else this._listeners = [
            listener
        ];
    }
    /**
   * Unsubscribe from the cancel signal
   */ unsubscribe(listener) {
        if (!this._listeners) return;
        const index = this._listeners.indexOf(listener);
        if (index !== -1) this._listeners.splice(index, 1);
    }
    toAbortSignal() {
        const controller = new AbortController();
        const abort = (err)=>{
            controller.abort(err);
        };
        this.subscribe(abort);
        controller.signal.unsubscribe = ()=>this.unsubscribe(abort);
        return controller.signal;
    }
    /**
   * Returns an object that contains a new `CancelToken` and a function that, when called,
   * cancels the `CancelToken`.
   */ static source() {
        let cancel;
        const token = new $fb81495929d8a282$var$CancelToken(function executor(c) {
            cancel = c;
        });
        return {
            token: token,
            cancel: cancel
        };
    }
}
var $fb81495929d8a282$export$2e2bcd8739ae039 = $fb81495929d8a282$var$CancelToken;






"use strict";
function $089369673aa7c1c3$export$2e2bcd8739ae039(callback) {
    return function wrap(arr) {
        return callback.apply(null, arr);
    };
}



"use strict";
function $9db8da59db12cd94$export$2e2bcd8739ae039(payload) {
    return (0, $c319b2c832c2914a$export$2e2bcd8739ae039).isObject(payload) && payload.isAxiosError === true;
}




const $f919374d785e9fb8$var$HttpStatusCode = {
    Continue: 100,
    SwitchingProtocols: 101,
    Processing: 102,
    EarlyHints: 103,
    Ok: 200,
    Created: 201,
    Accepted: 202,
    NonAuthoritativeInformation: 203,
    NoContent: 204,
    ResetContent: 205,
    PartialContent: 206,
    MultiStatus: 207,
    AlreadyReported: 208,
    ImUsed: 226,
    MultipleChoices: 300,
    MovedPermanently: 301,
    Found: 302,
    SeeOther: 303,
    NotModified: 304,
    UseProxy: 305,
    Unused: 306,
    TemporaryRedirect: 307,
    PermanentRedirect: 308,
    BadRequest: 400,
    Unauthorized: 401,
    PaymentRequired: 402,
    Forbidden: 403,
    NotFound: 404,
    MethodNotAllowed: 405,
    NotAcceptable: 406,
    ProxyAuthenticationRequired: 407,
    RequestTimeout: 408,
    Conflict: 409,
    Gone: 410,
    LengthRequired: 411,
    PreconditionFailed: 412,
    PayloadTooLarge: 413,
    UriTooLong: 414,
    UnsupportedMediaType: 415,
    RangeNotSatisfiable: 416,
    ExpectationFailed: 417,
    ImATeapot: 418,
    MisdirectedRequest: 421,
    UnprocessableEntity: 422,
    Locked: 423,
    FailedDependency: 424,
    TooEarly: 425,
    UpgradeRequired: 426,
    PreconditionRequired: 428,
    TooManyRequests: 429,
    RequestHeaderFieldsTooLarge: 431,
    UnavailableForLegalReasons: 451,
    InternalServerError: 500,
    NotImplemented: 501,
    BadGateway: 502,
    ServiceUnavailable: 503,
    GatewayTimeout: 504,
    HttpVersionNotSupported: 505,
    VariantAlsoNegotiates: 506,
    InsufficientStorage: 507,
    LoopDetected: 508,
    NotExtended: 510,
    NetworkAuthenticationRequired: 511
};
Object.entries($f919374d785e9fb8$var$HttpStatusCode).forEach(([key, value])=>{
    $f919374d785e9fb8$var$HttpStatusCode[value] = key;
});
var $f919374d785e9fb8$export$2e2bcd8739ae039 = $f919374d785e9fb8$var$HttpStatusCode;


"use strict";
/**
 * Create an instance of Axios
 *
 * @param {Object} defaultConfig The default config for the instance
 *
 * @returns {Axios} A new instance of Axios
 */ function $57966c7e0affc4cb$var$createInstance(defaultConfig) {
    const context = new (0, $a93486d2307f31c3$export$2e2bcd8739ae039)(defaultConfig);
    const instance = (0, $e5cb5cefd6507f7e$export$2e2bcd8739ae039)((0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype.request, context);
    // Copy axios.prototype to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, (0, $a93486d2307f31c3$export$2e2bcd8739ae039).prototype, context, {
        allOwnKeys: true
    });
    // Copy context to instance
    (0, $c319b2c832c2914a$export$2e2bcd8739ae039).extend(instance, context, null, {
        allOwnKeys: true
    });
    // Factory for creating new instances
    instance.create = function create(instanceConfig) {
        return $57966c7e0affc4cb$var$createInstance((0, $f85fda54cd977b19$export$2e2bcd8739ae039)(defaultConfig, instanceConfig));
    };
    return instance;
}
// Create the default instance to be exported
const $57966c7e0affc4cb$var$axios = $57966c7e0affc4cb$var$createInstance((0, $843bf0209bc94df8$export$2e2bcd8739ae039));
// Expose Axios class to allow class inheritance
$57966c7e0affc4cb$var$axios.Axios = (0, $a93486d2307f31c3$export$2e2bcd8739ae039);
// Expose Cancel & CancelToken
$57966c7e0affc4cb$var$axios.CanceledError = (0, $9fd0919e266b4fda$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.CancelToken = (0, $fb81495929d8a282$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.isCancel = (0, $5a60afef8b0dd173$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.VERSION = (0, $23ff3f1a5c7912d5$export$a4ad2735b021c132);
$57966c7e0affc4cb$var$axios.toFormData = (0, $e6cbd383b18c9625$export$2e2bcd8739ae039);
// Expose AxiosError class
$57966c7e0affc4cb$var$axios.AxiosError = (0, $4e2395edb77acf3a$export$2e2bcd8739ae039);
// alias for CanceledError for backward compatibility
$57966c7e0affc4cb$var$axios.Cancel = $57966c7e0affc4cb$var$axios.CanceledError;
// Expose all/spread
$57966c7e0affc4cb$var$axios.all = function all(promises) {
    return Promise.all(promises);
};
$57966c7e0affc4cb$var$axios.spread = (0, $089369673aa7c1c3$export$2e2bcd8739ae039);
// Expose isAxiosError
$57966c7e0affc4cb$var$axios.isAxiosError = (0, $9db8da59db12cd94$export$2e2bcd8739ae039);
// Expose mergeConfig
$57966c7e0affc4cb$var$axios.mergeConfig = (0, $f85fda54cd977b19$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.AxiosHeaders = (0, $866cce54f6bdfb0c$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.formToJSON = (thing)=>(0, $5f8142930b3b943f$export$2e2bcd8739ae039)((0, $c319b2c832c2914a$export$2e2bcd8739ae039).isHTMLForm(thing) ? new FormData(thing) : thing);
$57966c7e0affc4cb$var$axios.getAdapter = (0, $e8c8c7960873e9ee$export$2e2bcd8739ae039).getAdapter;
$57966c7e0affc4cb$var$axios.HttpStatusCode = (0, $f919374d785e9fb8$export$2e2bcd8739ae039);
$57966c7e0affc4cb$var$axios.default = $57966c7e0affc4cb$var$axios;
var // this module should only have a default export
$57966c7e0affc4cb$export$2e2bcd8739ae039 = $57966c7e0affc4cb$var$axios;


// This module is intended to unwrap Axios default export as named.
// Keep top-level export same with static properties
// so that it can keep same with es module or cjs
const { Axios: $b302555736d21bd7$export$1c00760e9e5a4e95, AxiosError: $b302555736d21bd7$export$c1fbed17c2f6a328, CanceledError: $b302555736d21bd7$export$1ab0c6b20d94fa14, isCancel: $b302555736d21bd7$export$3b22524397b493c6, CancelToken: $b302555736d21bd7$export$fd08e3cb425f0d61, VERSION: $b302555736d21bd7$export$a4ad2735b021c132, all: $b302555736d21bd7$export$84bf76cd7afc7469, Cancel: $b302555736d21bd7$export$848c9b7ead0df967, isAxiosError: $b302555736d21bd7$export$fbafdbe06a5b5a9a, spread: $b302555736d21bd7$export$3ae0fd4797ed47c8, toFormData: $b302555736d21bd7$export$10ae0d317ea97f8b, AxiosHeaders: $b302555736d21bd7$export$4e7d6ff0f3e6520, HttpStatusCode: $b302555736d21bd7$export$a972f69c851492b3, formToJSON: $b302555736d21bd7$export$86d7c59254d6a2c9, getAdapter: $b302555736d21bd7$export$17ddc20a97d669e2, mergeConfig: $b302555736d21bd7$export$7ec1ebcfa9d8bd6a } = (0, $57966c7e0affc4cb$export$2e2bcd8739ae039);



var $6ZWSX = parcelRequire("6ZWSX");
var $2b6e161c9edcf319$require$Buffer = $6ZWSX.Buffer;
let $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $b95dc6f85d7a5443$export$2e2bcd8739ae039)) // new HWI(TransportWebBLE)
;
$2b6e161c9edcf319$var$hwi.testnet = false;
const $2b6e161c9edcf319$var$satoshi = 10 ** 8;
let $2b6e161c9edcf319$var$debug;
const $2b6e161c9edcf319$var$StandardPurpose = {
    p2tr: "86'",
    p2wpkh: "84'",
    p2wpkhInP2sh: "49'",
    p2pkh: "44'"
};
const $2b6e161c9edcf319$var$MAINNET = {
    /**
   * The message prefix used for signing Bitcoin messages.
   */ messagePrefix: "\x18Bitcoin Signed Message:\n",
    /**
   * The Bech32 prefix used for Bitcoin addresses.
   */ bech32: "bc",
    /**
   * The BIP32 key prefixes for Bitcoin.
   */ bip32: {
        /**
     * The public key prefix for BIP32 extended public keys.
     */ public: 0x0488b21e,
        /**
     * The private key prefix for BIP32 extended private keys.
     */ private: 0x0488ade4
    },
    /**
   * The prefix for Bitcoin public key hashes.
   */ pubKeyHash: 0x00,
    /**
   * The prefix for Bitcoin script hashes.
   */ scriptHash: 0x05,
    /**
   * The prefix for Bitcoin Wallet Import Format (WIF) private keys.
   */ wif: 0x80
};
const $2b6e161c9edcf319$var$TESTNET = {
    messagePrefix: "\x18Bitcoin Signed Message:\n",
    bech32: "tb",
    bip32: {
        public: 0x043587cf,
        private: 0x04358394
    },
    pubKeyHash: 0x6f,
    scriptHash: 0xc4,
    wif: 0xef
};
//Display the header in the div which has the ID "main"
const $2b6e161c9edcf319$var$initial = "<h3>Connect a Ledger hardware wallet and open Bitcoin or Bitcoin Testnet app.</h3>";
const $2b6e161c9edcf319$var$$main = document.getElementById("debug");
const $2b6e161c9edcf319$var$addr = document.getElementById("addr");
const $2b6e161c9edcf319$var$create = document.getElementById("create");
const $2b6e161c9edcf319$var$decode = document.getElementById("decode");
const $2b6e161c9edcf319$var$psbtInfo = document.getElementById("psbt-info");
const $2b6e161c9edcf319$var$signPsbt = document.getElementById("sign-psbt");
const $2b6e161c9edcf319$var$sign = document.getElementById("sign");
const $2b6e161c9edcf319$var$signMessage = document.getElementById("sign-message");
const $2b6e161c9edcf319$var$fgpr = document.getElementById("fgpr");
const $2b6e161c9edcf319$var$xpub = document.getElementById("xpub");
const $2b6e161c9edcf319$var$register = document.getElementById("register");
const $2b6e161c9edcf319$var$theme = document.getElementById("theme");
let $2b6e161c9edcf319$var$selectedTheme = "light";
$2b6e161c9edcf319$var$$main.innerHTML = $2b6e161c9edcf319$var$initial;
let $2b6e161c9edcf319$var$prevTx = {};
let $2b6e161c9edcf319$var$psbtFormatted = {};
let $2b6e161c9edcf319$var$globalPSBT;
let $2b6e161c9edcf319$var$hexed = undefined;
let $2b6e161c9edcf319$var$globalInfo;
let $2b6e161c9edcf319$var$coinjoin = [];
let $2b6e161c9edcf319$var$signMode = false;
let $2b6e161c9edcf319$var$balance = 0;
let $2b6e161c9edcf319$var$targetFee = 100;
let $2b6e161c9edcf319$var$satsIncrease = 10;
let $2b6e161c9edcf319$var$selectedAmount = 0;
let $2b6e161c9edcf319$var$price = 0;
let $2b6e161c9edcf319$var$block = 0;
/**
 * MENU
 */ document.getElementById("btn-manager").addEventListener("click", ()=>{
    document.getElementById("ledger-manager").classList.toggle("hidden");
    document.getElementById("btn-manager").classList.toggle("btn-active");
});
document.getElementById("btn-register").addEventListener("click", ()=>{
    document.getElementById("register-policy").classList.toggle("hidden");
    document.getElementById("btn-register").classList.toggle("btn-active");
});
document.getElementById("btn-create").addEventListener("click", ()=>{
    document.getElementById("create-div").classList.toggle("hidden");
    document.getElementById("btn-create").classList.toggle("btn-active");
});
document.getElementById("btn-decode").addEventListener("click", ()=>{
    document.getElementById("decode-psbt").classList.toggle("hidden");
    document.getElementById("btn-decode").classList.toggle("btn-active");
});
document.getElementById("btn-finalize").addEventListener("click", ()=>{
    document.getElementById("finalize-broadcast").classList.toggle("hidden");
    document.getElementById("btn-finalize").classList.toggle("btn-active");
});
document.getElementById("btn-message").addEventListener("click", ()=>{
    document.getElementById("message-sign").classList.toggle("hidden");
    document.getElementById("btn-message").classList.toggle("btn-active");
});
/**
 * STATE LISTENERS
 */ document.getElementById("ble").addEventListener("click", ()=>$2b6e161c9edcf319$var$bleClient());
document.getElementById("network").addEventListener("change", ()=>{
    $2b6e161c9edcf319$var$hwi.testnet = !$2b6e161c9edcf319$var$hwi.testnet;
    console.log("[TESTNET]: ", $2b6e161c9edcf319$var$hwi.testnet);
});
document.getElementById("debug-mode").addEventListener("change", ()=>{
    $2b6e161c9edcf319$var$debug = document.getElementById("debug-mode").checked;
    console.log("[DEBUG]: ", $2b6e161c9edcf319$var$debug);
});
document.getElementById("sign-mode").addEventListener("change", ()=>{
    $2b6e161c9edcf319$var$signMode = !$2b6e161c9edcf319$var$signMode;
    console.log("[sign-mode]: ", $2b6e161c9edcf319$var$signMode);
});
document.getElementById("core").addEventListener("change", ()=>{
    console.log("[CORE]: ", document.getElementById("core").checked);
});
document.getElementById("test-broadcast").addEventListener("change", ()=>{
    console.log("[TEST-BROADCAST]: ", document.getElementById("test-broadcast").checked);
});
window.addEventListener("load", async ()=>{
    $2b6e161c9edcf319$var$theme.click();
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //block
    $2b6e161c9edcf319$var$block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`);
    //price
    $2b6e161c9edcf319$var$price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD;
    //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
    document.getElementById("btc-info").innerHTML = `PRICE: ${$2b6e161c9edcf319$var$price} $ | BLOCK: ${$2b6e161c9edcf319$var$block}`;
    setInterval(async ()=>await $2b6e161c9edcf319$var$btcInfo(), 60000);
//hwi.createPsbt()
//hwi.editPsbt("3LQYLTyh9amMshr8JJXbuDTJjyuKBB26d1",1000)
//console.log(hwi.toBase64())
});
$2b6e161c9edcf319$var$theme.addEventListener("click", ()=>{
    if ($2b6e161c9edcf319$var$selectedTheme === "light") {
        $2b6e161c9edcf319$var$selectedTheme = "dark";
        document.getElementById("theme").innerHTML = `theme [${$2b6e161c9edcf319$var$selectedTheme}]`;
        document.getElementById("main").style.background = "black";
        document.getElementById("main").style.color = "white";
        document.querySelectorAll("div").forEach((div)=>{
            div.style.boxShadow = "0px 0px 5px 1px inset rgba(255, 255, 255, 0.5)";
        });
    } else {
        $2b6e161c9edcf319$var$selectedTheme = "light";
        document.getElementById("theme").innerHTML = `theme [${$2b6e161c9edcf319$var$selectedTheme}]`;
        document.getElementById("main").style.background = "white";
        document.getElementById("main").style.color = "black";
        document.querySelectorAll("div").forEach((div)=>{
            div.style.boxShadow = "5px 5px 10px 1px black";
        });
    }
});
/**
 * Wallet Client
 */ $2b6e161c9edcf319$var$addr.addEventListener("click", async ()=>{
    const get_info = document.getElementById("get-info").checked;
    try {
        !get_info && await $2b6e161c9edcf319$var$hwi.getClient();
        const path = document.getElementById("path").value;
        const bitcoinAddress = get_info ? path : await $2b6e161c9edcf319$var$hwi.getAddress(path);
        //const addrTo = document.getElementById('addr-to').value
        //const amount = document.getElementById('amount').value
        //const txType = document.getElementById('tx-type').value
        $2b6e161c9edcf319$var$displayData(bitcoinAddress);
        $2b6e161c9edcf319$var$createQR(bitcoinAddress);
        const pubkey = get_info ? "" : $2b6e161c9edcf319$var$compressPublicKey(await $2b6e161c9edcf319$var$hwi.getPub(path));
        //console.log("[PUB]:", pubkey)
        $2b6e161c9edcf319$var$push(`[Address]: ${bitcoinAddress}`);
        document.getElementById("pub-view").innerHTML = `[PubKey]: ${pubkey}`;
        try {
            await $2b6e161c9edcf319$var$getAddressInfo(bitcoinAddress).then(async (infos)=>{
                $2b6e161c9edcf319$var$debug && console.log("[infos]: ", infos);
            });
        } catch (error) {
            console.log("[ADDR INFOS] error", error);
            !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
        }
        !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (e1) {
        console.log(e1.message || e1);
        $2b6e161c9edcf319$var$push(e1.message);
        //!get_info && 
        !get_info && await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$create.addEventListener("click", async ()=>{
    try {
        //await hwi.getClient()
        const path = document.getElementById("path").value;
        //const bitcoinAddress = await hwi.getAddress(path)
        //const pubkey = compressPublicKey(await hwi.getPub(path))
        //console.log("[PUB]:", pubkey)
        const scriptFrom = document.getElementById("script-from").value;
        const addrFrom = document.getElementById("addr-from").value;
        const addrTo = document.getElementById("addr-to").value;
        const amount = document.getElementById("amount").value;
        const txType = document.getElementById("tx-type").value;
        const getxpubs = [
            ...$2b6e161c9edcf319$var$fetchXpubs(document.getElementById("global-map-xpub").value)
        ];
        //console.log("[KEYCHAIN]: ",getxpubs)
        const getbip32 = document.getElementById("coinjoin").checked ? document.getElementById("input-map-bip32").value : [
            ...$2b6e161c9edcf319$var$fetchPubs(document.getElementById("input-map-bip32").value)
        ];
        //console.log("[BIP32]: ",getbip32)
        //addAmount()
        let start = 0;
        let target = document.getElementById("est-fees").value;
        $2b6e161c9edcf319$var$targetFee = document.getElementById("fees").value;
        $2b6e161c9edcf319$var$selectedAmount = 0;
        while(start <= target){
            $2b6e161c9edcf319$var$addAmount();
            const max = document.getElementById("max").checked;
            if (max) {
                document.getElementById("amount").value = 0;
                document.getElementById("amount").value = $2b6e161c9edcf319$var$selectedAmount - $2b6e161c9edcf319$var$targetFee // satoshi
                ;
            }
            try {
                await $2b6e161c9edcf319$var$createUnsignedTx(addrTo, scriptFrom, $2b6e161c9edcf319$var$globalInfo.ids, max ? ($2b6e161c9edcf319$var$selectedAmount - $2b6e161c9edcf319$var$targetFee).toString() : amount, $2b6e161c9edcf319$var$globalInfo.balance, txType).then(async (unsigned)=>{
                    try {
                        if (target / start > 1) $2b6e161c9edcf319$var$satsIncrease += 1;
                        await $2b6e161c9edcf319$var$createPsbt(scriptFrom, $2b6e161c9edcf319$var$globalInfo.ids, $2b6e161c9edcf319$var$globalInfo.prevTxs, unsigned, getxpubs, getbip32, txType).then(async (res)=>{
                            //console.log("TX/PSBT CREATED ✅")
                            $2b6e161c9edcf319$var$push(`\u{2705} \u{20BF} TX/PSBT created: Selected Amount ${($2b6e161c9edcf319$var$selectedAmount / $2b6e161c9edcf319$var$satoshi).toFixed(8)} Fees ${($2b6e161c9edcf319$var$targetFee / $2b6e161c9edcf319$var$satoshi).toFixed(8)}`);
                            //console.log("[START]:", start)
                            //console.log("[TARGET]:", target)
                            //console.log("[TARGET_FEE]:",targetFee)
                            start = res;
                            //if (target / start > 1) {satsIncrease+=1}
                            //targetFee++
                            $2b6e161c9edcf319$var$targetFee = parseInt($2b6e161c9edcf319$var$targetFee) + $2b6e161c9edcf319$var$satsIncrease;
                        //await hwi.closeClient()
                        });
                    //await hwi.closeClient()
                    } catch (error) {
                        console.log("[createPsbt] error", error);
                        $2b6e161c9edcf319$var$push(`\u{274C} [ERROR] creating PSBT`);
                        throw "\u274C [createPsbt] error";
                    //await hwi.closeClient()
                    }
                });
            } catch (error) {
                console.log("[createUnsignedTx] error", error);
                $2b6e161c9edcf319$var$push(`\u{274C} [ERROR] creating TX/PSBT`);
                break;
            //await hwi.closeClient()
            }
        }
        if (document.getElementById("coinjoin").checked) document.getElementById("coinjoin").checked = false;
    } catch (error) {
        console.log("[ADDR INFOS] error", error);
        $2b6e161c9edcf319$var$push(error);
    //await hwi.closeClient()
    }
});
$2b6e161c9edcf319$var$fgpr.addEventListener("click", async ()=>{
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const fingerprint = await $2b6e161c9edcf319$var$hwi.getFingerprint();
        //console.log("[FGPR]:", fingerprint)
        document.getElementById("fgpr-view").innerHTML = `[FGPR]: ${fingerprint}`;
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$xpub.addEventListener("click", async ()=>{
    //const hwi = new HWI()
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const path = document.getElementById("path").value;
        const xpubkey = await $2b6e161c9edcf319$var$hwi.getXpub(path, 70617039) ////76067358 - 70617039
        ;
        document.getElementById("xpub-view").innerHTML = `[XPUB]: ${xpubkey}`;
        //await hwi.closeClient()
        //console.log("[DECODED]: ", Buffer.from(base58.decode(xpubkey)).toString('hex'))
        const extPub = await $2b6e161c9edcf319$var$hwi.getPub(path);
        //await hwi.getClient()
        const pubkey = $2b6e161c9edcf319$var$compressPublicKey(extPub);
        document.getElementById("pub-view").innerHTML = `[PubKey]: ${pubkey}`;
        //console.log("[PUB]:", pubkey)
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$register.addEventListener("click", async ()=>{
    //const hwi = new HWI()
    try {
        await $2b6e161c9edcf319$var$hwi.getClient();
        const b64 = document.getElementById("base64").value;
        //hwi.importFromB64(b64)
        const path = document.getElementById("path").value;
        const miniscript = document.getElementById("policy").value;
        const keychains = document.getElementById("keychains").value;
        const addrTo = document.getElementById("addr-to").value;
        const amount = document.getElementById("amount").value;
        const txType = document.getElementById("tx-type").value;
        //console.log(miniscript)
        $2b6e161c9edcf319$var$hwi.setDescriptorTemplate(miniscript);
        const walletName = document.getElementById("wallet-name").value;
        if (document.getElementById("policy-address").checked) {
            const wallet = await $2b6e161c9edcf319$var$hwi.registerWalletPath(path, walletName, keychains);
            //const wallet = await hwi.registerWallet("FRZN",keychains)
            //const walletAddress = await hwi.getPolicyAddress(path, wallet.walletPolicy)
            const walletAddress = wallet.address;
            //const walletAddress = await hwi.getPolicyAddress(path, policy)
            //console.log("MultiSigWallet ", hwi.wallet)
            $2b6e161c9edcf319$var$displayData(walletAddress);
            $2b6e161c9edcf319$var$createQR(walletAddress);
            await $2b6e161c9edcf319$var$getAddressInfo(walletAddress).then(async (infos)=>{
                $2b6e161c9edcf319$var$debug && console.log("[infos]: ", infos);
                $2b6e161c9edcf319$var$push(`\u{2705} [SUCCESS] Wallet Policy registered with Address: ${walletAddress}`);
            });
        } else {
            const wallet = await $2b6e161c9edcf319$var$hwi.registerWallet(walletName, keychains);
        //console.log("Wallet ", hwi.wallet)
        }
        await $2b6e161c9edcf319$var$hwi.closeClient();
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$decode.addEventListener("click", ()=>{
    try {
        let decodedPsbt = {};
        const b64 = document.getElementById("base64").value;
        const hex = $2b6e161c9edcf319$var$base64ToHex(b64);
        $2b6e161c9edcf319$var$hexed = hex;
        const psbt = $3wrUl.Psbt.fromHex(hex, $2b6e161c9edcf319$var$hwi.testnet ? $2b6e161c9edcf319$var$TESTNET : $2b6e161c9edcf319$var$MAINNET) //.Psbt.fromHex(hex)
        ;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        const txInfo = $2b6e161c9edcf319$var$hwi.getPsbtInfo();
        $2b6e161c9edcf319$var$debug && console.log(txInfo);
        $2b6e161c9edcf319$var$psbtInfo.innerHTML = `${JSON.stringify(txInfo.to)} | ${JSON.stringify(txInfo.signatures)}`;
        //console.log(psbt)
        $2b6e161c9edcf319$var$globalPSBT = psbt;
        $2b6e161c9edcf319$var$prevTx = psbt.data.globalMap.unsignedTx.tx;
        decodedPsbt.inputs = {};
        for(let i = 0; i < psbt.data.inputs.length; i++){
            decodedPsbt.inputs[i] = {};
            decodedPsbt.inputs[i].bip32 = {};
            if (psbt.data.inputs[i]?.bip32Derivation) for(let j = 0; j < psbt.data.inputs[i].bip32Derivation.length; j++)decodedPsbt.inputs[i].bip32[j] = {
                masterFingerprint: psbt.data.inputs[i].bip32Derivation[j].masterFingerprint.toString("hex"),
                pubkey: psbt.data.inputs[i].bip32Derivation[j].pubkey.toString("hex"),
                path: psbt.data.inputs[i].bip32Derivation[j].path
            };
            decodedPsbt.inputs[i].partialSig = [];
            if (psbt.data.inputs[i]?.partialSig) for(let k = 0; k < psbt.data.inputs[i].partialSig.length; k++)decodedPsbt.inputs[i].partialSig.push({
                pubKey: psbt.data.inputs[i].partialSig[k].pubkey.toString("hex"),
                partialSig: psbt.data.inputs[i].partialSig[k].signature.toString("hex")
            });
            decodedPsbt.inputs[i].witnessScript = psbt.data.inputs[i].witnessScript?.toString("hex");
            decodedPsbt.inputs[i].witnessUtxo = psbt.data.inputs[i]?.witnessUtxo?.script?.toString("hex");
            decodedPsbt.inputs[i].value = psbt.data.inputs[i]?.witnessUtxo?.value;
        }
        decodedPsbt.outputs = {};
        for(let i = 0; i < psbt.data.outputs.length; i++){
            decodedPsbt.outputs[i] = {};
            decodedPsbt.outputs[i].bip32 = {};
            if (psbt.data.outputs[i]?.bip32Derivation) for(let j = 0; j < psbt.data.outputs[i].bip32Derivation.length; j++)decodedPsbt.outputs[i].bip32[j] = {
                masterFingerprint: psbt.data.outputs[i].bip32Derivation[j].masterFingerprint.toString("hex"),
                pubkey: psbt.data.outputs[i].bip32Derivation[j].pubkey.toString("hex"),
                path: psbt.data.outputs[i].bip32Derivation[j].path
            };
        //decodedPsbt.outputs[i] = psbt.data.outputs[i]
        }
        decodedPsbt.options = {};
        decodedPsbt.options.maximumFeeRate = psbt.opts.maximumFeeRate;
        decodedPsbt.options.network = psbt.opts.network.messagePrefix;
        decodedPsbt.options.bech32 = psbt.opts.network.bech32;
        decodedPsbt.options.bip32 = psbt.opts.network.bip32;
        decodedPsbt.options.pubKeyHash = psbt.opts.network.pubKeyHash;
        decodedPsbt.options.scriptHash = psbt.opts.network.scriptHash;
        decodedPsbt.options.wif = psbt.opts.network.wif // ???
        ;
        //document.getElementById("decoded").innerHTML = JSON.stringify(decodedPsbt,null,4)
        $2b6e161c9edcf319$var$psbtFormatted.utxo = {};
        $2b6e161c9edcf319$var$psbtFormatted.utxo.ins = [];
        $2b6e161c9edcf319$var$prevTx.ins.forEach((element)=>{
            $2b6e161c9edcf319$var$psbtFormatted.utxo.ins.push({
                hash: element.hash.toString("hex"),
                index: element.index,
                script: $2b6e161c9edcf319$require$Buffer.from(element.script.buffer).toString("hex"),
                sequence: element.sequence,
                witness: element.witness.toString("hex")
            });
        });
        $2b6e161c9edcf319$var$psbtFormatted.utxo.locktime = $2b6e161c9edcf319$var$prevTx.locktime;
        $2b6e161c9edcf319$var$psbtFormatted.utxo.outs = [];
        $2b6e161c9edcf319$var$prevTx.outs.forEach((element)=>{
            $2b6e161c9edcf319$var$psbtFormatted.utxo.outs.push({
                value: element.value,
                script: $2b6e161c9edcf319$require$Buffer.from(element.script.buffer).toString("hex")
            });
        });
        $2b6e161c9edcf319$var$psbtFormatted.utxo.version = $2b6e161c9edcf319$var$prevTx.version;
        $2b6e161c9edcf319$var$psbtFormatted.data = decodedPsbt;
    } catch (e1) {
        $2b6e161c9edcf319$var$push(e1);
        console.log(e1);
    }
});
$2b6e161c9edcf319$var$signPsbt.addEventListener("click", async ()=>{
    console.log("signPsbt...");
    //const hwi = new HWI()
    try {
        const b64 = document.getElementById("base64").value;
        const path = document.getElementById("path").value;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        await $2b6e161c9edcf319$var$hwi.getClient();
        //await hwi.getXpub("m/44'/1'/0'/0/0")
        //await hwi.getAddress("m/44'/1'/0'/0/0")
        const result = await $2b6e161c9edcf319$var$hwi.signPsbt(path);
        //hwi.decodeTX()
        await $2b6e161c9edcf319$var$hwi.closeClient();
        //console.log("HWI Client: ",hwi)
        //console.log("b64: ",hwi.toBase64())
        document.getElementById("exported-b64").innerHTML = $2b6e161c9edcf319$var$hwi.toBase64();
        //const wallet = new Wallet()
        //await hwi.validateSignatures(await wallet.verify(,,))
        /*
    const finalized = await hwi.validateSignatures() //callback()
    console.log("[FINALIZED]: ", finalized.toHex())
    document.getElementById("broadcast").innerHTML = finalized.toHex()
    */ document.getElementById("signature-result").innerHTML = "";
        const resList = document.createElement("ul");
        result.forEach((el)=>{
            const newSig = document.createElement("li");
            //console.log("EL: ",el)
            const txt = document.createTextNode(`${el[0]} : ${el[1].pubkey.toString("hex")} : ${el[1].signature.toString("hex")}`);
            newSig.appendChild(txt);
            resList.appendChild(newSig);
        });
        //document.getElementById("exported-b64").innerHTML = hwi.toBase64()
        //document.getElementById("signature-result").innerHTML = `${result[0][0]} : ${result[0][1].pubkey.toString("hex")} : ${result[0][1].signature.toString("hex")}`//JSON.stringify(result)
        //document.getElementById("signature-result").innerHTML = `${JSON.stringify(result)}`
        document.getElementById("signature-result").appendChild(resList);
        $2b6e161c9edcf319$var$push(`\u{2705} [SUCCESS] PSBT signed`);
    } catch (error) {
        console.log(error);
        $2b6e161c9edcf319$var$push(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$sign.addEventListener("click", async ()=>{
    console.log("sign...");
    //const hwi = new HWI()
    try {
        const b64 = document.getElementById("base64").value;
        const path = document.getElementById("path").value;
        $2b6e161c9edcf319$var$hwi.importFromB64(b64);
        await $2b6e161c9edcf319$var$hwi.getClient();
        const signImported = document.getElementById("sign-imported").checked;
        //console.log(signImported)
        const analyzedPsbt = signImported ? await $2b6e161c9edcf319$var$analyzeDecodedPsbt($2b6e161c9edcf319$var$hwi.psbt) : {};
        // Previous Mined TX
        // 02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000
        // 020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000
        // Serialized Output Script
        // 019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938
        const radios = document.getElementsByName("utxo");
        const ins = [];
        !signImported && $2b6e161c9edcf319$var$globalInfo.prevTxs.map((item, n)=>{
            radios.forEach((radio)=>{
                //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
                if (radio.checked) {
                    if (parseInt(radio.value) === n) ins.push([
                        item[2].tx,
                        item[3],
                        undefined,
                        undefined
                    ]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
                    ;
                }
            });
        });
        const paths = [];
        for(let i = 0; i < ins.length; i++)signImported ? paths.push(...analyzedPsbt.paths) : paths.push(path);
        //const oldTx = hwi.decodeTX("02000000000101f75d0beedf98acda3379d7a42a1243e4c3c2d56bfe1be08b7e12dc1f0c1d1a5701000000000000000002d007000000000000220020e898e861510a655ccdfafef352553c7b8b5e7d85b75bae4f3b0fffa889d6bdfc8b32010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d6938024730440220068d2796c03404e4b3af244d781ba6f06079a2de587e17f83ed1a3cbbcf1fb4c02207992636edd68ea23170ac21deb550adab5b4b5a7ef44afac849ed14a1b9c1b4301210209ed5c211206be21054582fa122681ce85a21418a057c4f6d04bf3084257be9700000000",true,["bech32"])
        //const newTx = hwi.decodeTX("020000000120f204014c20c733041fc9ae6f525427a809eb73196991fe02fb27ec2c4f13a20100000000fffffffd019031010000000000160014951c2a3f00ee81873fbb5dec6c05b49cca5d693800000000")
        // segwit, additionals
        const segwit = document.getElementById("tx-type").value === "p2sh" || document.getElementById("tx-type").value === "p2wpkh" || document.getElementById("tx-type").value === "p2wsh" ? true : false;
        const additionals = segwit ? [
            "bech32"
        ] : [];
        const newTx = signImported ? null : $2b6e161c9edcf319$var$hwi.decodeTX($2b6e161c9edcf319$var$globalInfo.unsignedTx.serializeUnsigned(), segwit, additionals);
        //const newTx = hwi.decodeTX(globalInfo.unsignedTx.serializeUnsigned())
        //console.log("[PATHs]: ", paths)
        //console.log("[INPUTS]: ", newTx.outputScript, ins)
        //console.log("[INS]",...ins)
        let result;
        if ($2b6e161c9edcf319$var$signMode) result = await $2b6e161c9edcf319$var$hwi.signP2SHTX(//[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [
            ...ins
        ], signImported ? [
            ...analyzedPsbt.paths
        ] : [
            ...paths
        ], //[path], // change Path
        signImported ? analyzedPsbt.newTx.outputScript : newTx.outputScript, segwit, additionals // Additionals
        );
        else result = await $2b6e161c9edcf319$var$hwi.createPaymentTX(//[[oldTx.tx, 1, "", 0]], // inputs // TODO: ???
        signImported ? analyzedPsbt.ins : [
            ...ins
        ], signImported ? [
            ...analyzedPsbt.paths
        ] : [
            ...paths
        ], //[], // change Path
        signImported ? analyzedPsbt.newTx.outputScript : newTx.outputScript, segwit, additionals // Additionals
        );
        //console.log("[RESULT]: ", result)
        await $2b6e161c9edcf319$var$hwi.closeClient();
        document.getElementById("broadcast").innerHTML = result;
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
        await $2b6e161c9edcf319$var$hwi.closeClient();
    }
});
$2b6e161c9edcf319$var$signMessage.addEventListener("click", async ()=>{
    //// https://www.verifybitcoinmessage.com/
    try {
        const path = document.getElementById("path").value;
        const message = document.getElementById("message").value;
        await $2b6e161c9edcf319$var$hwi.getClient();
        const RandS = document.getElementById("sign-message-mode").checked;
        const msg = $2b6e161c9edcf319$require$Buffer.from(message).toString("hex");
        await $2b6e161c9edcf319$var$hwi.signMessage(path, msg, RandS).then(async function(result) {
            let signature;
            if (RandS) signature = $2b6e161c9edcf319$require$Buffer.from(result, "hex").toString("hex") //.toString('base64')
            ;
            else {
                let v = result["v"] + 27 + 4;
                signature = $2b6e161c9edcf319$require$Buffer.from(v.toString(16) + result["r"] + result["s"], "hex").toString("base64");
            }
            //console.log("Signature : " + signature);
            document.getElementById("signature").innerHTML = "Signature : " + signature;
            await $2b6e161c9edcf319$var$hwi.closeClient();
        }).catch(function(ex) {
            console.log(ex);
        });
    } catch (err) {
        $2b6e161c9edcf319$var$push(err);
        console.log(err);
        await transport.close().then(()=>{
            console.log(`[LEDGER]: Connection closed`);
        });
    }
});
document.getElementById("finalize").addEventListener("click", async ()=>{
    console.log("finalizePsbt...");
    try {
        if (document.getElementById("core").checked) {
            const finalized = await $2b6e161c9edcf319$var$makeRpcRequest("finalizepsbt", [
                document.getElementById("exported-b64").value
            ]);
            //console.log("[FINALIZED]: ", finalized.result)
            if (finalized.result.complete) document.getElementById("broadcast").innerHTML = finalized.result.hex;
        } else {
            //await hwi.getClient()
            const finalized = await $2b6e161c9edcf319$var$hwi.validateSignatures() // callback()
            ;
            //console.log("[FINALIZED]: ", finalized.toHex())
            document.getElementById("broadcast").innerHTML = finalized.toHex();
        //await hwi.closeClient()
        }
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
    //await hwi.closeClient()
    }
});
document.getElementById("broadcast-tx").addEventListener("click", async ()=>{
    try {
        if (document.getElementById("core").checked) {
            if (document.getElementById("test-broadcast").checked) {
                console.log("Core test broadcasting...");
                const test = await $2b6e161c9edcf319$var$makeRpcRequest("testmempoolaccept", [
                    [
                        `${document.getElementById("broadcast").value}`
                    ]
                ]);
                //console.log("[TEST]: ", test.result)
                document.getElementById("broadcast-result").innerHTML = JSON.stringify(test.result);
            } else {
                console.log("Core broadcasting...");
                const hash = await $2b6e161c9edcf319$var$makeRpcRequest("sendrawtransaction", [
                    document.getElementById("broadcast").value
                ]);
                //console.log("[HASH]: ", hash)
                if (hash.result) document.getElementById("broadcast-result").innerHTML = hash.result;
                hash.result && $2b6e161c9edcf319$var$push(`[SUCCESS]: transaction broadcasted with hash ${hash.result}`);
            }
        } else {
            console.log("Mempool broadcasting...");
            const test = $2b6e161c9edcf319$var$hwi.testnet;
            const testnet = test ? "testnet/" : "";
            const resApi = await fetch(`https://mempool.space/${testnet}api/tx`, {
                method: "POST",
                body: document.getElementById("broadcast").value
            });
            const json = await resApi.text();
            console.log("\n[BROADCAST RESULT]: ", json);
            // `https://mempool.space/${testnet}tx/${json}`
            document.getElementById("broadcast-result").innerHTML = json;
        }
    } catch (error) {
        $2b6e161c9edcf319$var$push(error);
        console.log(error);
    //await hwi.closeClient()
    }
});
async function $2b6e161c9edcf319$var$makeRpcRequest(method, params) {
    //console.log("JSON-RPC")
    const url = document.getElementById("node").value // adjust to your node's RPC URL
    ;
    const headers = {
        "Content-Type": "application/json"
    };
    const data = {
        jsonrpc: "2.0",
        method: method,
        params: params,
        id: 1
    };
    try {
        const response = await (0, $57966c7e0affc4cb$export$2e2bcd8739ae039).post(url, data, {
            headers: headers
        });
        //console.log("JSON-RESP:",response.data);
        return response.data;
    } catch (error) {
        console.error(error);
    }
}
// Bluetooth Low Energy client
function $2b6e161c9edcf319$var$bleClient() {
    const ble = document.getElementById("ble").checked;
    if (ble) {
        const networkState = $2b6e161c9edcf319$var$hwi.testnet;
        $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $9b04af14b7feeec2$export$2e2bcd8739ae039));
        $2b6e161c9edcf319$var$hwi.testnet = networkState;
    } else {
        const networkState = $2b6e161c9edcf319$var$hwi.testnet;
        $2b6e161c9edcf319$var$hwi = new (0, $586cf8d59d7800a2$export$2e2bcd8739ae039)((0, $b95dc6f85d7a5443$export$2e2bcd8739ae039));
        $2b6e161c9edcf319$var$hwi.testnet = networkState;
    }
    console.log("[BLE]", ble);
}
async function $2b6e161c9edcf319$var$analyzeDecodedPsbt(psbt) {
    console.log(psbt);
    /*
  console.log(psbt.data.globalMap.unknownKeyVals)
  const proprietaryFieldKey = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].key,'hex').toString('hex')
  const proprietaryFieldValue = Buffer.from(psbt.data.globalMap.unknownKeyVals[0].value,'hex').toString('hex')
  console.log(proprietaryFieldKey)
  console.log(proprietaryFieldValue)
  */ const unsignedTX = $2b6e161c9edcf319$require$Buffer.from(psbt.data.getTransaction(), "hex").toString("hex");
    //console.log(unsignedTX)
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTX, true, [
        "bech32"
    ]);
    const ins = [];
    const prevTxs = [];
    const paths = [];
    for(txid in psbt.txInputs){
        const input = psbt.txInputs[txid];
        const hash = $2b6e161c9edcf319$require$Buffer.from(input.hash.reverse(), "hex").toString("hex");
        const vout = input.index;
        //console.log(hash)
        //console.log(vout)
        paths.push(psbt.data.inputs[txid].bip32Derivation[0].path);
        await fetch(`https://blockstream.info/${$2b6e161c9edcf319$var$hwi.testnet ? "testnet/" : ""}api/tx/${hash}/hex`).then(async (prevTx)=>{
            await prevTx.text().then((tx)=>{
                //console.log(tx)
                const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(tx, true, [
                    "bech32"
                ]);
                //console.log(oldTx)
                const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                    oldTx.tx.outputs[vout].amount,
                    Uint8Array.from([
                        oldTx.tx.outputs[vout].script.length
                    ]),
                    oldTx.tx.outputs[vout].script
                ]).toString("hex");
                prevTxs.push([
                    tx,
                    outputScript,
                    oldTx,
                    vout
                ]);
                ins.push([
                    oldTx.tx,
                    vout,
                    undefined,
                    undefined
                ]);
            });
        });
    }
    // input txid + vout -> tx, outputScript, newTx
    //console.log(ins)
    //console.log(paths)
    //console.log(newTx.outputScript)
    return {
        ins: ins,
        paths: paths,
        newTx: newTx
    };
}
function $2b6e161c9edcf319$var$compressPublicKey(pk) {
    const sliced = $2b6e161c9edcf319$require$Buffer.from(pk, "hex").slice(1);
    const len = sliced.length;
    const x = sliced.slice(0, 32);
    const y = sliced.slice(32, sliced.length);
    const prefix = BigInt(`0x${y.toString("hex")}`) % 2n === 0n ? "02" : "03";
    return (prefix + pk.slice(2, 66)).toString("hex");
}
function $2b6e161c9edcf319$var$base64ToHex(str) {
    const raw = atob(str);
    let result = "";
    for(let i = 0; i < raw.length; i++){
        const hex = raw.charCodeAt(i).toString(16);
        result += hex.length === 2 ? hex : "0" + hex;
    }
    return result.toUpperCase();
}
const $2b6e161c9edcf319$var$displayData = (data)=>{
    try {
        //Display your bitcoin address on the screen
        const h2 = document.createElement("h2");
        h2.id = "address";
        h2.textContent = data;
        $2b6e161c9edcf319$var$$main.innerHTML = "<h1>Bitcoin address: </h1>";
        $2b6e161c9edcf319$var$$main.appendChild(h2);
    } catch (error) {
        const $err = document.createElement("code");
        $err.style.color = "#f66";
        $err.textContent = String(e.message || e);
        $2b6e161c9edcf319$var$$main.appendChild($err);
    }
};
function $2b6e161c9edcf319$var$createQR(data) {
    const div = document.createElement("div");
    div.id = "qrcode";
    $2b6e161c9edcf319$var$$main.appendChild(div);
    // $main
    const qrcode = new QRCode(div, {
        text: data,
        width: 150,
        height: 150,
        colorDark: "#000",
        colorLight: "#fff"
    });
}
async function $2b6e161c9edcf319$var$btcInfo() {
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //block
    $2b6e161c9edcf319$var$block = await wallet.getApi("block", `https://mempool.space/api/blocks/tip/height`);
    //price
    $2b6e161c9edcf319$var$price = (await wallet.getApi("price", `https://mempool.space/api/v1/prices`)).USD;
    //console.log(`PRICE: ${price} $ | BLOCK: ${block}`)
    document.getElementById("btc-info").innerHTML = `PRICE: ${$2b6e161c9edcf319$var$price} $ | BLOCK: ${$2b6e161c9edcf319$var$block}`;
}
function $2b6e161c9edcf319$var$fetchXpubs(keychains) {
    const keys = [];
    if (keychains.length > 0) {
        if (keychains.includes(",")) keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const getxpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getxpub[0],
                xpub: getxpub[1]
            });
        });
        else {
            const derivation = keychains.split(":");
            const getxpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getxpub[0],
                xpub: getxpub[1]
            });
        }
    }
    //console.log(keys)
    return keys;
}
function $2b6e161c9edcf319$var$fetchPubs(keychains) {
    const keys = [];
    if (keychains.length > 0) {
        if (keychains.includes(",")) keychains.split(",").map((key)=>{
            const derivation = key.split(":");
            const getpub = derivation[1].split("|");
            //console.log("???: ", derivation,xpub)
            keys.push({
                fgpr: derivation[0],
                path: getpub[0],
                pub: getpub[1]
            });
        });
        else {
            const derivation = keychains.split(":");
            const getpub = derivation[1].split("|");
            //console.log("???: ", derivation,getpub)
            keys.push({
                fgpr: derivation[0],
                path: getpub[0],
                pub: getpub[1]
            });
        }
    }
    //console.log(keys)
    return keys;
}
function $2b6e161c9edcf319$var$decodeXpub(xpub) {
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    const decoded = wallet.fromBase58(xpub);
    const step0 = decoded.subarray(0, 4);
    const step1 = decoded.subarray(4, 5);
    const step2 = decoded.subarray(5, 9);
    const step3 = decoded.subarray(9, 13);
    const step4 = decoded.subarray(13, 45);
    const step5 = decoded.subarray(45, 78);
    return {
        depth: $2b6e161c9edcf319$require$Buffer.from(step1).toString("hex"),
        path: $2b6e161c9edcf319$require$Buffer.from(step3).toString("hex"),
        pubkey: $2b6e161c9edcf319$require$Buffer.from(step5).toString("hex")
    };
}
function $2b6e161c9edcf319$var$sortDataBy(data, byKey) {
    let sortedData;
    if (byKey == "id") sortedData = data.sort(function(a, b) {
        let x = a.txid.toLowerCase();
        let y = b.txid.toLowerCase();
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
    });
    else if (byKey == "value") sortedData = data.sort(function(a, b) {
        let x = a.value;
        let y = b.value;
        if (x > y) return 1;
        if (x < y) return -1;
        return 0;
    });
    else {
        byKey = "txid";
        sortedData = data.sort(function(a, b) {
            return a.txid.localeCompare(b.txid);
        });
    }
    return sortedData;
}
function $2b6e161c9edcf319$var$push(msg) {
    const div = document.getElementById("push");
    div.innerHTML = msg;
    div.style.height = "50px";
    div.style.padding = "10px";
    setTimeout(()=>{
        div.innerHTML = "";
        div.style.height = "auto";
        div.style.padding = "";
    }, 5000);
}
function $2b6e161c9edcf319$var$addAmount() {
    const radios = document.getElementsByName("utxo");
    $2b6e161c9edcf319$var$selectedAmount = 0;
    $2b6e161c9edcf319$var$globalInfo.ids.map((i, n)=>{
        radios.forEach((radio)=>{
            if (radio.checked) {
                if (parseInt(radio.value) === n) // i.txid | i.vout | i.value
                $2b6e161c9edcf319$var$selectedAmount += i.value // satoshi
                ;
            }
        });
    });
//selectedAmount -= targetFee
//console.log("[UTXO SELECTED AMOUNT]", selectedAmount)
//push(`[UTXO SELECTED AMOUNT]: ${selectedAmount/satoshi} ₿`)
}
function $2b6e161c9edcf319$var$estimateFees(fee, size, wit, totInputs = 1, segwit = true) {
    // ( witnessLen + ((signatureLen + pubkeyLen) * N) + flagLen ) / 4 + txSizeLen
    const flagLen = 2;
    const witLen = segwit ? wit / 4 : 0 //(Buffer.from(wit,'hex').length * totInputs) / 4 : 0
    ;
    const scriptSigLen = segwit ? 0 : 22;
    //const mulLen = 1 * totInputs
    const pubLen = 34;
    //const sigLen = segwit ? ((73 + pubLen) * mul) / 4 : ((73 + pubLen) * mul)
    const sigLen = segwit ? 73 / 4 * totInputs : (73 + pubLen) * totInputs;
    let est = (parseInt(fee) / parseInt(flagLen + size + sigLen + witLen)).toFixed(2);
    //document.getElementById('est-fees').value = est
    //estFees = est
    //console.log(`[Fee]: ${fee}, [Bytes]:${size + sigLen + witLen}, [*]: ${mul}`)
    console.log("[sats/vbyte]: ", est);
    return est;
}
async function $2b6e161c9edcf319$var$getAddressInfo(address, display = true) {
    //const path = document.getElementById('path').value
    //const fgpr = await hwi.getFingerprint()
    //const xpub = await hwi.getXpub(path)
    const balanceView = document.getElementById("balance");
    const panel = document.getElementById("utxos");
    const txType = document.getElementById("tx-type").value;
    let addrType = "";
    if (address.startsWith("1") || address.startsWith("m")) addrType = "p2pkh";
    if (address.startsWith("3") || address.startsWith("2")) addrType = "p2sh";
    if (address.startsWith("bc") && address.length === 42 || address.startsWith("tb") && address.length === 42) addrType = "p2wpkh";
    if (address.startsWith("bc") && address.length > 42 || address.startsWith("tb") && address.length > 42) addrType = "p2wsh";
    // RESET UTXO LIST
    if (display) panel.innerHTML = "";
    if (!document.getElementById("coinjoin").checked) $2b6e161c9edcf319$var$coinjoin = [];
    const addresses = address.split(",");
    //console.log(">>> ",addresses)
    // PARAMETERS
    const test = $2b6e161c9edcf319$var$hwi.testnet;
    const testnet = test ? "testnet/" : "";
    //const from = address
    //let balance = 0
    let ids = [];
    let prevTxs = [];
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    //addresses.map(async(addr)=> {
    const from = address;
    // ONLINE
    try {
        //balance
        const status = await wallet.getApi("status", `https://mempool.space/${testnet}api/address/${from}`);
        //txs
        const txs = await wallet.getApi("utxo", `https://mempool.space/${testnet}api/address/${from}/txs`);
        //utxo
        const utxo = await wallet.getApi("txs", `https://mempool.space/${testnet}api/address/${from}/utxo`);
        //block
        //const block = await wallet.getApi("block", `https://mempool.space/${testnet}api/blocks/tip/height`)
        //price
        //const price = await wallet.getApi("price", `https://mempool.space/api/v1/prices`)
        //const broadcast = https://mempool.space/testnet/api/tx //POST
        //console.log("[STATUS]: ", status)
        //console.log("[UTXO]: ", utxo)
        //console.log("[TXS]: ", txs)
        //console.log("[vout]: ", txs[0].vout)
        /*
      console.log("[BLOCK]: ", block)
      console.log("[PRICE]: ", price)
      */ $2b6e161c9edcf319$var$balance += status.chain_stats.funded_txo_sum - status.chain_stats.spent_txo_sum;
        utxo.map((id)=>{
            ids.push({
                address: from,
                type: addrType,
                txid: id.txid,
                vout: id.vout,
                value: id.value
            });
        //coinjoin.push({txid:id.txid,vout:id.vout,value:id.value})
        });
    //ids = sortDataBy(ids,"txid")
    //ids = sortDataBy(ids,"id")
    //ids = sortDataBy(ids,"value")
    //ids = sortDataBy(ids)
    //ids.sort((a,b)=> a.value < b.value)
    // ids.sort((a,b)=> {
    //   console.log("??? ",a,b)
    //   return a.txid < b.txid
    // })
    } catch (error) {
        console.log("[API] error: unable to get utxos");
        $2b6e161c9edcf319$var$push(`\u{26A0}\u{FE0F} [API] error: unable to get utxos`);
    //console.log(error)
    }
    //})  
    ids = $2b6e161c9edcf319$var$sortDataBy(ids, "txid");
    $2b6e161c9edcf319$var$coinjoin.push(...ids);
    //console.log("[BALANCE]: ", balance)
    balanceView.innerHTML = `\u{20BF} ${$2b6e161c9edcf319$var$balance / $2b6e161c9edcf319$var$satoshi} | (${$2b6e161c9edcf319$var$balance}) sats | $ ${($2b6e161c9edcf319$var$balance / $2b6e161c9edcf319$var$satoshi * $2b6e161c9edcf319$var$price).toFixed(2)}`;
    // Return if no Balance
    if ($2b6e161c9edcf319$var$balance === 0) console.log("[NO BALANCE AVAILABLE]");
    // Display UTXOs
    display && $2b6e161c9edcf319$var$coinjoin.length > 0 && $2b6e161c9edcf319$var$coinjoin.map((item, i)=>{
        const newUtxo = document.createElement("li");
        const radio = document.createElement("input");
        radio.type = "checkbox";
        radio.name = "utxo";
        radio.value = `${i}`; // Set the value attribute
        newUtxo.appendChild(radio);
        //const x = document.createTextNode(`#${i} : ${JSON.stringify(item)} [${item.value/satoshi}] $ ${((item.value/satoshi)* price).toFixed(2)}`)
        const x = document.createTextNode(` #${i} : \u{20BF} ${item.value / $2b6e161c9edcf319$var$satoshi} | ${item.address} $ ${(item.value / $2b6e161c9edcf319$var$satoshi * $2b6e161c9edcf319$var$price).toFixed(2)}`);
        newUtxo.appendChild(x);
        panel.appendChild(newUtxo);
    //console.log(i,item)
    });
    for(let i = 0; i < $2b6e161c9edcf319$var$coinjoin.length; i++)await fetch(`https://mempool.space/${testnet}api/tx/${$2b6e161c9edcf319$var$coinjoin[i].txid}/hex`).then(async (prevTx)=>{
        await prevTx.text().then((tx)=>{
            //console.log("[PREVTX]: ", tx)
            //const oldTx = hwi.decodeTX(tx, true, ["bech32"]) // TODO: ???
            //const oldTx = hwi.decodeTX(tx, false, []) // TODO: ???
            const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(tx, txType === "p2sh" || txType === "p2wpkh" || txType === "p2wsh" ? true : false, txType === "p2wpkh" || txType === "p2wsh" ? [
                "bech32"
            ] : []) // TODO: ???
            ;
            //console.log("[OLDTX]: ", oldTx)
            const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                //Uint8Array.from([0x01]), // ???
                oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].amount,
                Uint8Array.from([
                    oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].script.length
                ]),
                oldTx.tx.outputs[$2b6e161c9edcf319$var$coinjoin[i].vout].script
            ]).toString("hex");
            //console.log("[>>>] ", outputScript)
            prevTxs.push([
                tx,
                outputScript,
                oldTx,
                $2b6e161c9edcf319$var$coinjoin[i].vout
            ]);
        //return [tx,outputScript,oldTx]
        });
    });
    //console.log("[COINJOIN]: ", coinjoin)
    $2b6e161c9edcf319$var$globalInfo = {
        address: address,
        prevTxs: prevTxs,
        ids: $2b6e161c9edcf319$var$coinjoin,
        balance: $2b6e161c9edcf319$var$balance
    };
    return {
        prevTxs: prevTxs,
        ids: $2b6e161c9edcf319$var$coinjoin,
        balance: $2b6e161c9edcf319$var$balance
    };
}
async function $2b6e161c9edcf319$var$createUnsignedTx(address, pubkey, ids, values, balance, type = "p2wpkh") {
    const network = "testnet";
    const version = 2;
    const segwit = true;
    //const type = "p2wpkh" // TODO: ???
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    // FROM SPENDER
    const pkh = $2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(pubkey, "hex"))).toString("hex");
    //console.log("[from]: ", from)
    //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
    //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
    //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
    // CREATE TX
    const tx = new (0, $ebab65f303698dab$export$fce14c253806ce6d)(network, version, segwit, type);
    tx.debugger = document.getElementById("debug-mode").checked;
    const fees = $2b6e161c9edcf319$var$targetFee //document.getElementById('fees').value
    ;
    tx.setFee(parseInt(fees));
    let _pubkey = $2b6e161c9edcf319$require$Buffer.from(pubkey, "hex").toString("hex");
    // CREATE TX INPUTS  
    const radios = document.getElementsByName("utxo");
    let toSpend = 0;
    //<input type="radio" name="utxo" id="0">  
    ids.map((i, n)=>{
        radios.forEach((radio)=>{
            //console.log("[Selecting utxo]: ", parseInt(radio.value), n, i, radio.value)
            if (radio.checked) {
                if (parseInt(radio.value) === n) {
                    //console.log("[*SELECTED UTXO*]: ", radio.value)
                    toSpend += i.value;
                    tx.createInput(i.txid, _pubkey, i.type, i.vout);
                }
            }
        });
    //tx.createInput(i.txid, _pubkey, type, i.vout)
    });
    // CREATE TX OUTPUTS
    const addresses = address.split(",");
    const amounts = values.split(",");
    //amounts[0] = amounts[0] - parseInt(fees)
    //console.log("TX-ADRESSES+AMOUNT", addresses, amounts)
    let sum = 0;
    addresses.map((addr, i)=>{
        const amount = parseInt(parseFloat(amounts[i]) * $2b6e161c9edcf319$var$satoshi);
        sum += parseInt(amounts[i]);
        //if ((sum - fees) >= balance) { return }
        amounts[i] > 0 && tx.createOutput(amounts[i], addr);
    //console.log("[*OUT*]: ", sum, amounts[i], addr)
    });
    let changeAddress = document.getElementById("addr-from").value;
    let rest = toSpend - sum - parseInt(fees) //(sum - parseInt(fees))
    ;
    //console.log("[toSpend]: ",toSpend)
    //console.log("[FEES]:",rest, "[REST to CHANGE:]", rest - parseInt(fees))
    if (rest < 0) {
        //console.log("[ERROR]: Fees are wrong!")
        $2b6e161c9edcf319$var$push(`\u{26A0}\u{FE0F} [ERROR]: Fees are wrong! ${rest}`);
        throw "[ERROR]: Fees are wrong!";
    //return // ATTENTION!!!!! This cause a loop
    }
    if (rest > 0) {
        let changeAmount = rest - parseInt(fees) //balance - (sum - parseInt(fees))
        ;
        if (changeAmount < 0) {
            $2b6e161c9edcf319$var$push(`\u{26D4}\u{FE0F} [ERROR]: Change amount negative: try to reduce fees ${changeAmount}`);
            throw "\u26D4\uFE0F [ERROR]: Change amount negative: try to reduce fees!";
        }
        console.log("[CHANGE]: ", rest / 10 ** 8, changeAddress);
        tx.createOutput(rest, changeAddress);
    }
    //const size = globalInfo.unsignedTx.serializeUnsigned().length
    //estimateFees(fees,size,globalInfo.pubkey)
    //tx.createOutput((balance - tx.fee).toString(), address)
    // SERIALIZE UNSIGNED TX
    const unsignedTx = tx //.serializeUnsigned()
    ;
    $2b6e161c9edcf319$var$globalInfo.pubkey = pubkey;
    $2b6e161c9edcf319$var$globalInfo.unsignedTx = unsignedTx;
    return unsignedTx;
}
async function $2b6e161c9edcf319$var$createPsbt(pubkey, ids, prevTxs, unsignedTx, globalXpubs, bip32Derivations, type = "p2wpkh") {
    const path = document.getElementById("path").value;
    //const fgpr = await hwi.getFingerprint()
    //const xpub = await hwi.getXpub(path)
    const wallet = new (0, $ee63ffa40e34f8fc$export$2e2bcd8739ae039)();
    // TODO: Tx type is needed to set the script hash
    // FROM SPENDER
    const pkh = $2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(pubkey, "hex"))).toString("hex") // P2WPKH
    ;
    //const pkh = Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex') // P2WSH
    //console.log("[pubkey/redeem|witness]: ", Buffer.from(pubkey,'hex').toString('hex'))
    //console.log("[pkh/sh ripemd160] ", Buffer.from(wallet.hash160(Buffer.from(pubkey,'hex'))).toString('hex'))
    //console.log("[pkh/sh sha256] ", Buffer.from(wallet.sha256(Buffer.from(pubkey,'hex'))).toString('hex'))
    let keyChains = [
        ...globalXpubs
    ];
    let bip32Chain = [
        ...bip32Derivations
    ];
    let partialSig = [];
    //const scriptCode = `1976a914${pkh}88ac`
    const scriptCode = "" // P2WPKH | P2WSH 1976a914  88ac
    ;
    const redeemScript = type === "p2sh" ? `0014${pkh}` : "" // P2WPKH | P2WSH 0014
    ;
    const witnessScript = type === "p2sh" || type === "p2pkh" ? "" : pubkey //"" //`1976a914${pkh}88ac`
    ;
    // CREATE PSBT
    const psbtVersion = 0;
    const unsignedTxVersion = 2;
    const psbt = new (0, $ebab65f303698dab$export$6bc7a366cf543c74)(psbtVersion);
    psbt.testnet = $2b6e161c9edcf319$var$hwi.testnet;
    psbt.debugger = document.getElementById("debug-mode").checked;
    const tx = unsignedTx;
    const bip32Ins = bip32Derivations.length > 0 && document.getElementById("coinjoin").checked ? bip32Derivations.split(";") : [];
    const witnesses = pubkey.length > 0 && document.getElementById("coinjoin").checked ? pubkey.split(",") : [];
    //console.log("bip32Ins",bip32Ins)
    //console.log("witnesses",witnesses)
    let nInput = 0;
    let nMul = 0;
    let toSpend = 0;
    let lenWitnesses = 0;
    // ADD INPUTS to PSBT
    const radios = document.getElementsByName("utxo");
    ids.map((i, n)=>{
        radios.forEach((radio)=>{
            if (radio.checked) {
                if (parseInt(radio.value) === n) {
                    toSpend += i.value;
                    //console.log("[VALUE]: ",i.value)
                    const oldTx = $2b6e161c9edcf319$var$hwi.decodeTX(prevTxs[n][0], i.type === "p2sh" || i.type === "p2wpkh" || i.type === "p2wsh" ? true : false, i.type === "p2wpkh" || i.type === "p2wsh" ? [
                        "bech32"
                    ] : []);
                    const outputScript = $2b6e161c9edcf319$require$Buffer.concat([
                        oldTx.tx.outputs[i.vout].amount,
                        Uint8Array.from([
                            oldTx.tx.outputs[i.vout].script.length
                        ]),
                        oldTx.tx.outputs[i.vout].script
                    ]).toString("hex");
                    //console.log("[OUTPUT SCRIPT>>>]: ", outputScript)
                    //console.log("[input-type]",i.type)
                    //console.log("[ID]: ",n,i,outputScript)
                    //console.log("[PREVTX]",prevTxs[n][0].length/2,Buffer.from(prevTxs[n][0],'hex').toString('hex'))
                    if (!document.getElementById("coinjoin").checked) {
                        // Previous Entire Transaction must be included eventually with previous unspent transaction Output Script
                        if (i.type === "p2pkh") psbt.addInput(false, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], "hex").toString("hex"), i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript);
                        if (i.type === "p2sh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], "hex").toString("hex"));
                            lenWitnesses += redeemScript.length + witnessScript.length;
                        }
                        if (i.type === "p2wpkh" || i.type === "p2wsh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chain, partialSig, redeemScript, witnessScript);
                            lenWitnesses += witnessScript.length;
                        }
                    }
                    if (document.getElementById("coinjoin").checked) {
                        //console.log(">>>",n,bip32Ins[nInput],witnesses[nInput])
                        const bip32Chainx = bip32Ins.length > 0 ? [
                            ...$2b6e161c9edcf319$var$fetchPubs(bip32Ins[nInput])
                        ] : [];
                        const redeem = `0014${$2b6e161c9edcf319$require$Buffer.from(wallet.hash160($2b6e161c9edcf319$require$Buffer.from(witnesses[nInput], "hex"))).toString("hex")}`;
                        nMul += bip32Ins.length;
                        //console.log("bip32Chainx",bip32Chainx)
                        if (i.type === "p2pkh") psbt.addInput(false, $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], "hex").toString("hex"), i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput]);
                        if (i.type === "p2sh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeem, "", $2b6e161c9edcf319$require$Buffer.from(prevTxs[n][0], "hex").toString("hex"));
                            lenWitnesses += redeemScript.length + witnesses[nInput].length;
                        }
                        if (i.type === "p2wpkh" || i.type === "p2wsh") {
                            psbt.addInput(true, outputScript, i.txid, i.vout, bip32Chainx, partialSig, redeemScript, witnesses[nInput]);
                            lenWitnesses += witnesses[nInput].length;
                        }
                    }
                    nInput++;
                }
            }
        });
    });
    // ADD OUTPUTS to PSBT
    const addrTo = document.getElementById("addr-to").value;
    const amount = document.getElementById("amount").value;
    const addresses = addrTo.split(",");
    const amounts = amount.split(",");
    //console.log("PSBT-ADRESSES+AMOUNT", addresses, amounts)
    let totSpend = 0;
    addresses.map((addr, i)=>{
        const amount = parseInt(parseFloat(amounts[i]) * $2b6e161c9edcf319$var$satoshi);
        const len = addr.length;
        const isBase = len <= 35 //
        ;
        const outScript = isBase ? wallet.fromBase58(addr).slice(2) : wallet.fromBech32(addr).slice(2);
        //const outScript = type === "p2sh" || type === "p2pkh" ? (wallet.fromBase58(addr)).slice(2) : (wallet.fromBech32(addr)).slice(2)
        //console.log("[*******] ", i, amounts[i] , Buffer.from(outScript.slice(2)).toString('hex'))
        psbt.addOutput(amounts[i].toString(), $2b6e161c9edcf319$require$Buffer.from(outScript, "hex"), []);
        //psbt.addOutput("0", "", [])
        totSpend += parseInt(amounts[i]);
    });
    let rest = parseInt(toSpend) - parseInt(totSpend) - parseInt($2b6e161c9edcf319$var$targetFee);
    //console.log("PSBT-REST", rest)
    if (rest > 0) psbt.addOutput(rest.toString(), "", []);
    //psbt.addOutput()
    //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pubkey,'hex'), []) // bip32Chain
    //psbt.addOutput((balance - tx.fee).toString(), Buffer.from(pkh,'hex'), [])
    // ADD GLOBAL MAP to PSBT
    psbt.addGlobalMap(unsignedTx.serializeUnsigned(), unsignedTxVersion, keyChains) // keyChains
    ;
    const serializedPsbt = psbt.serialize();
    document.getElementById("base64").value = psbt.base64;
    //psbt.debug()
    document.getElementById("fees").value = $2b6e161c9edcf319$var$targetFee;
    const fees = $2b6e161c9edcf319$var$targetFee //document.getElementById('fees').value
    ;
    const size = $2b6e161c9edcf319$var$globalInfo.unsignedTx.serializeUnsigned().length;
    const segwit = type === "p2wpkh" || type === "p2wsh" || type === "p2sh" ? true : false;
    const target = $2b6e161c9edcf319$var$estimateFees(fees, size, lenWitnesses /*globalInfo.pubkey*/ , document.getElementById("coinjoin").checked ? nInput : bip32Chain.length, segwit) // TODO: 1?
    ;
    return target;
//console.log("[PSBT-BASE64]: ", psbt.toBase64()) // Buffer.from(serializedPsbt).toString('base64')
//console.log("[CHECK]: ",psbt.testnet, balance.value, bip32Chain,keyChains)
}
async function $2b6e161c9edcf319$var$createPaymentTx(unsignedTx, prevTxs) {
    // TODO: allow signing for different paths
    const path = document.getElementById("path").value;
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTx);
    //console.log("[prevTxs]: ",prevTxs)
    // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
    const ins = [];
    prevTxs.map((item)=>{
        ins.push([
            item[2].tx,
            item[3],
            undefined,
            undefined
        ]) // [tx, outIndex, redeem, sequence] // TODO: if p2sh or locktime change "undefined"
        ;
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
    });
    console.log("[INPUTS]: ", newTx.outputScript, ins);
    console.log("[INS]", ...ins);
    const paths = [];
    for(let i = 0; i < ins.length; i++)paths.push(path);
    console.log("[PATHs]: ", paths);
    await $2b6e161c9edcf319$var$hwi.createPaymentTX([
        ...ins
    ], //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [
        ...paths
    ], //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, true, [
        "bech32"
    ] // Additionals // TODO: make a switch from path to determine additionals
    ).then((result)=>{
        console.log("[RESULT]: ", result);
        document.getElementById("broadcast").innerHTML = result;
    });
}
async function $2b6e161c9edcf319$var$signP2SHTx(unsignedTx, prevTxs) {
    const path = document.getElementById("path").value;
    const newTx = $2b6e161c9edcf319$var$hwi.decodeTX(unsignedTx);
    //console.log("[prevTxs]: ",prevTxs)
    // [inTx,outIndex,redeem,sequence] [oldTx,1,"",0]
    const ins = [];
    prevTxs.map((item)=>{
        ins.push([
            item[2].tx,
            item[3],
            ""
        ]);
    //ins.push([item[2].tx, item[3]])
    //console.log("[ITEM]: ", [item[2], item[3], "", 0])
    });
    console.log("[INPUTS]: ", newTx.outputScript, ins);
    console.log("[INS]", ...ins);
    const paths = [];
    for(let i = 0; i < ins.length; i++)paths.push(path);
    console.log("[PATHs]: ", paths);
    await $2b6e161c9edcf319$var$hwi.signP2SHTX([
        ...ins
    ], //[[oldTx,1,"",0]], // inputs
    //[prevTxs.map(item=>{return [item[2], item[3], "", 0]})],
    [
        ...paths
    ], //["m/84'/0'/0'/1/0","change"], // change Path
    newTx.outputScript, true, [
        "bech32"
    ] // Additionals
    ).then((result)=>{
        console.log("[RESULT]: ", result);
        document.getElementById("broadcast").innerHTML = result;
    });
}


//# sourceMappingURL=index.d4d84ead.js.map
